webpackJsonp([47],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(808);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(66);

var assertThisInitialized = __webpack_require__(11);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(795);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(802)();
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var core = __webpack_require__(61);
var hide = __webpack_require__(54);
var redefine = __webpack_require__(55);
var ctx = __webpack_require__(67);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _prefixer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bpfrpt_proptype_StylesObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
 // Flow doesn't actually use this; it's just here to make eslint-plugin-import
// shut up. The real StylesObject type is in prefixStyles.js.flow.

var bpfrpt_proptype_StylesObject = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object;
var prefixer = new __WEBPACK_IMPORTED_MODULE_0_inline_style_prefixer___default.a();
/* harmony default export */ __webpack_exports__["b"] = (function (style) {
  return prefixer.prefix(style);
});
var _prefixer = prefixer;



/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(799)();
}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setColorSetName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ColorsProvider; });
/* harmony export (immutable) */ __webpack_exports__["c"] = withColorsProvider;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bpfrpt_proptype_ColorSet; });
/* unused harmony export bpfrpt_proptype_ColorSetName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_MuiThemeProvider__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_MuiThemeProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_MuiThemeProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ColorSets__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var bpfrpt_proptype_ColorSet = __WEBPACK_IMPORTED_MODULE_11__ColorSets__["a" /* bpfrpt_proptype_ColorSet */] === __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.any ? {} : __WEBPACK_IMPORTED_MODULE_11__ColorSets__["a" /* bpfrpt_proptype_ColorSet */];
var bpfrpt_proptype_ColorSetName = __WEBPACK_IMPORTED_MODULE_11__ColorSets__["b" /* bpfrpt_proptype_ColorSetName */] === __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.any ? {} : __WEBPACK_IMPORTED_MODULE_11__ColorSets__["b" /* bpfrpt_proptype_ColorSetName */];
// eslint-disable-next-line no-process-env
var isCommercial = "commercial" === "commercial";
var currentColorSetName = isCommercial ? "pivot" : "nexia";

var changeColorSetListener = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Events);

changeColorSetListener.on("change", function (newSetName) {
  currentColorSetName = newSetName;
});
function setColorSetName(colorSetName) {
  changeColorSetListener.trigger("change", colorSetName);
}

var ColorsProvider =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ColorsProvider, _React$Component);

  function ColorsProvider() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ColorsProvider);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ColorsProvider).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ColorsProvider, [{
    key: "_getMuiTheme",
    value: function _getMuiTheme(colorSetName) {
      if (this.constructor._muiThemes[colorSetName]) {
        return this.constructor._muiThemes[colorSetName];
      }

      var colorSet = __WEBPACK_IMPORTED_MODULE_11__ColorSets__["c" /* default */][colorSetName];
      this.constructor._muiThemes[colorSetName] = Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["createMuiTheme"])({
        fontFamily: "",
        palette: {
          primary: {
            main: colorSet.PRIMARY,
            pivot: colorSet.PRIMARY
          },
          secondary: {
            main: colorSet.PRIMARY,
            pivot: colorSet.PRIMARY
          },
          text: {
            main: colorSet.TEXT,
            pivot: colorSet.TEXT
          }
        },
        overrides: {
          MuiRadio: {
            colorPrimary: {
              color: colorSet.PRIMARY
            },
            colorSecondary: {
              color: colorSet.PRIMARY
            }
          }
        },
        typography: {
          useNextVariants: true
        }
      });
      return this.constructor._muiThemes[colorSetName];
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      changeColorSetListener.on("change", function () {
        _this.forceUpdate();
      }, this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      changeColorSetListener.off(null, null, this);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var colorSet = __WEBPACK_IMPORTED_MODULE_11__ColorSets__["c" /* default */][currentColorSetName];
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_MuiThemeProvider___default.a, {
        theme: this._getMuiTheme(currentColorSetName)
      }, children(colorSet));
    }
  }]);

  return ColorsProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ColorsProvider, "_muiThemes", {});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ColorsProvider, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired
});


function withColorsProvider(Component) {
  var displayName = Component.displayName || Component.name || "<anonymous component>";

  function ColoredComponent(props) {
    return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](ColorsProvider, null, function (colors) {
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](Component, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
        colors: colors
      }));
    });
  }

  ColoredComponent.displayName = "withColorsProvider(".concat(displayName, ")");
  return ColoredComponent;
}






/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);

 // Use dispatch to run actions.
// Dispatch(actionType, args...)
// Use Dispatch.on to add an action type handler:
// Dispatch.on(actionType, (args...) => { /* ... */ });

function Dispatch(actionType) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (Dispatch.debug) {
    // eslint-disable-next-line no-console
    console.log("Dispatch:", actionType, args);
  }

  __WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.captureBreadcrumb({
    category: "Dispatch",
    level: "info",
    message: actionType
  });
  Dispatch.trigger.apply(Dispatch, [actionType].concat(args));
}

_.extend(Dispatch, __WEBPACK_IMPORTED_MODULE_0_backbone___default.a.Events); // It's useful to have Dispatch be a global so that you can set Dispatch.debug
// to true and manually Dispatch stuff from the browser console.


global.Dispatch = Dispatch;
/* harmony default export */ __webpack_exports__["a"] = (Dispatch);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 14 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Backbone.js 1.3.3

//     (c) 2010-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(factory) {

  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
  // We use `self` instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self === self && self) ||
            (typeof global == 'object' && global.global === global && global);

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(317), __webpack_require__(194), exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = require('underscore'), $;
    try { $ = require('jquery'); } catch (e) {}
    factory(root, exports, _, $);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  }

})(function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create a local reference to a common array method we'll want to use later.
  var slice = Array.prototype.slice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.3.3';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... this will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Proxy Backbone class methods to Underscore functions, wrapping the model's
  // `attributes` object or collection's `models` array behind the scenes.
  //
  // collection.filter(function(model) { return model.get('age') > 10 });
  // collection.each(this.addView);
  //
  // `Function#apply` can be slow so we use the method's arg count, if we know it.
  var addMethod = function(length, method, attribute) {
    switch (length) {
      case 1: return function() {
        return _[method](this[attribute]);
      };
      case 2: return function(value) {
        return _[method](this[attribute], value);
      };
      case 3: return function(iteratee, context) {
        return _[method](this[attribute], cb(iteratee, this), context);
      };
      case 4: return function(iteratee, defaultVal, context) {
        return _[method](this[attribute], cb(iteratee, this), defaultVal, context);
      };
      default: return function() {
        var args = slice.call(arguments);
        args.unshift(this[attribute]);
        return _[method].apply(_, args);
      };
    }
  };
  var addUnderscoreMethods = function(Class, methods, attribute) {
    _.each(methods, function(length, method) {
      if (_[method]) Class.prototype[method] = addMethod(length, method, attribute);
    });
  };

  // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
  var cb = function(iteratee, instance) {
    if (_.isFunction(iteratee)) return iteratee;
    if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
    if (_.isString(iteratee)) return function(model) { return model.get(iteratee); };
    return iteratee;
  };
  var modelMatcher = function(attrs) {
    var matcher = _.matches(attrs);
    return function(model) {
      return matcher(model.attributes);
    };
  };

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // a custom event channel. You may bind a callback to an event with `on` or
  // remove with `off`; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {};

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Iterates over the standard `event, callback` (as well as the fancy multiple
  // space-separated events `"change blur", callback` and jQuery-style event
  // maps `{event: callback}`).
  var eventsApi = function(iteratee, events, name, callback, opts) {
    var i = 0, names;
    if (name && typeof name === 'object') {
      // Handle event maps.
      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
      for (names = _.keys(name); i < names.length ; i++) {
        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
      }
    } else if (name && eventSplitter.test(name)) {
      // Handle space-separated event names by delegating them individually.
      for (names = name.split(eventSplitter); i < names.length; i++) {
        events = iteratee(events, names[i], callback, opts);
      }
    } else {
      // Finally, standard events.
      events = iteratee(events, name, callback, opts);
    }
    return events;
  };

  // Bind an event to a `callback` function. Passing `"all"` will bind
  // the callback to all events fired.
  Events.on = function(name, callback, context) {
    return internalOn(this, name, callback, context);
  };

  // Guard the `listening` argument from the public API.
  var internalOn = function(obj, name, callback, context, listening) {
    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
      context: context,
      ctx: obj,
      listening: listening
    });

    if (listening) {
      var listeners = obj._listeners || (obj._listeners = {});
      listeners[listening.id] = listening;
    }

    return obj;
  };

  // Inversion-of-control versions of `on`. Tell *this* object to listen to
  // an event in another object... keeping track of what it's listening to
  // for easier unbinding later.
  Events.listenTo = function(obj, name, callback) {
    if (!obj) return this;
    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
    var listeningTo = this._listeningTo || (this._listeningTo = {});
    var listening = listeningTo[id];

    // This object is not listening to any other events on `obj` yet.
    // Setup the necessary references to track the listening callbacks.
    if (!listening) {
      var thisId = this._listenId || (this._listenId = _.uniqueId('l'));
      listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
    }

    // Bind callbacks on obj, and keep track of them on listening.
    internalOn(obj, name, callback, this, listening);
    return this;
  };

  // The reducing API that adds a callback to the `events` object.
  var onApi = function(events, name, callback, options) {
    if (callback) {
      var handlers = events[name] || (events[name] = []);
      var context = options.context, ctx = options.ctx, listening = options.listening;
      if (listening) listening.count++;

      handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
    }
    return events;
  };

  // Remove one or many callbacks. If `context` is null, removes all
  // callbacks with that function. If `callback` is null, removes all
  // callbacks for the event. If `name` is null, removes all bound
  // callbacks for all events.
  Events.off = function(name, callback, context) {
    if (!this._events) return this;
    this._events = eventsApi(offApi, this._events, name, callback, {
      context: context,
      listeners: this._listeners
    });
    return this;
  };

  // Tell this object to stop listening to either specific events ... or
  // to every object it's currently listening to.
  Events.stopListening = function(obj, name, callback) {
    var listeningTo = this._listeningTo;
    if (!listeningTo) return this;

    var ids = obj ? [obj._listenId] : _.keys(listeningTo);

    for (var i = 0; i < ids.length; i++) {
      var listening = listeningTo[ids[i]];

      // If listening doesn't exist, this object is not currently
      // listening to obj. Break out early.
      if (!listening) break;

      listening.obj.off(name, callback, this);
    }

    return this;
  };

  // The reducing API that removes a callback from the `events` object.
  var offApi = function(events, name, callback, options) {
    if (!events) return;

    var i = 0, listening;
    var context = options.context, listeners = options.listeners;

    // Delete all events listeners and "drop" events.
    if (!name && !callback && !context) {
      var ids = _.keys(listeners);
      for (; i < ids.length; i++) {
        listening = listeners[ids[i]];
        delete listeners[listening.id];
        delete listening.listeningTo[listening.objId];
      }
      return;
    }

    var names = name ? [name] : _.keys(events);
    for (; i < names.length; i++) {
      name = names[i];
      var handlers = events[name];

      // Bail out if there are no events stored.
      if (!handlers) break;

      // Replace events if there are any remaining.  Otherwise, clean up.
      var remaining = [];
      for (var j = 0; j < handlers.length; j++) {
        var handler = handlers[j];
        if (
          callback && callback !== handler.callback &&
            callback !== handler.callback._callback ||
              context && context !== handler.context
        ) {
          remaining.push(handler);
        } else {
          listening = handler.listening;
          if (listening && --listening.count === 0) {
            delete listeners[listening.id];
            delete listening.listeningTo[listening.objId];
          }
        }
      }

      // Update tail event if the list has any events.  Otherwise, clean up.
      if (remaining.length) {
        events[name] = remaining;
      } else {
        delete events[name];
      }
    }
    return events;
  };

  // Bind an event to only be triggered a single time. After the first time
  // the callback is invoked, its listener will be removed. If multiple events
  // are passed in using the space-separated syntax, the handler will fire
  // once for each event, not once for a combination of all events.
  Events.once = function(name, callback, context) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.off, this));
    if (typeof name === 'string' && context == null) callback = void 0;
    return this.on(events, callback, context);
  };

  // Inversion-of-control versions of `once`.
  Events.listenToOnce = function(obj, name, callback) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.stopListening, this, obj));
    return this.listenTo(obj, events);
  };

  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
  // `offer` unbinds the `onceWrapper` after it has been called.
  var onceMap = function(map, name, callback, offer) {
    if (callback) {
      var once = map[name] = _.once(function() {
        offer(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
    }
    return map;
  };

  // Trigger one or many events, firing all bound callbacks. Callbacks are
  // passed the same arguments as `trigger` is, apart from the event name
  // (unless you're listening on `"all"`, which will cause your callback to
  // receive the true name of the event as the first argument).
  Events.trigger = function(name) {
    if (!this._events) return this;

    var length = Math.max(0, arguments.length - 1);
    var args = Array(length);
    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

    eventsApi(triggerApi, this._events, name, void 0, args);
    return this;
  };

  // Handles triggering the appropriate event callbacks.
  var triggerApi = function(objEvents, name, callback, args) {
    if (objEvents) {
      var events = objEvents[name];
      var allEvents = objEvents.all;
      if (events && allEvents) allEvents = allEvents.slice();
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId(this.cidPrefix);
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    var defaults = _.result(this, 'defaults');
    attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // The prefix is used to create the client id which is used to identify models locally.
    // You may want to override this if you're experiencing name clashes with model ids.
    cidPrefix: 'c',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Special-cased proxy to underscore's `_.matches` method.
    matches: function(attrs) {
      return !!_.iteratee(attrs, this)(this.attributes);
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      var unset      = options.unset;
      var silent     = options.silent;
      var changes    = [];
      var changing   = this._changing;
      this._changing = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }

      var current = this.attributes;
      var changed = this.changed;
      var prev    = this._previousAttributes;

      // For each `set` attribute, update or delete the current value.
      for (var attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          changed[attr] = val;
        } else {
          delete changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Update the `id`.
      if (this.idAttribute in attrs) this.id = this.get(this.idAttribute);

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0; i < changes.length; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      var changed = {};
      for (var attr in diff) {
        var val = diff[attr];
        if (_.isEqual(old[attr], val)) continue;
        changed[attr] = val;
      }
      return _.size(changed) ? changed : false;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server, merging the response with the model's
    // local attributes. Any changed attributes will trigger a "change" event.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (!model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true, parse: true}, options);
      var wait = options.wait;

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !wait) {
        if (!this.set(attrs, options)) return false;
      } else if (!this._validate(attrs, options)) {
        return false;
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      var model = this;
      var success = options.success;
      var attributes = this.attributes;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
        if (serverAttrs && !model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      // Set temporary attributes if `{wait: true}` to properly find new ids.
      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);

      var method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch' && !options.attrs) options.attrs = attrs;
      var xhr = this.sync(method, this, options);

      // Restore attributes.
      this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;
      var wait = options.wait;

      var destroy = function() {
        model.stopListening();
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (wait) destroy();
        if (success) success.call(options.context, model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      var xhr = false;
      if (this.isNew()) {
        _.defer(options.success);
      } else {
        wrapError(this, options);
        xhr = this.sync('delete', this, options);
      }
      if (!wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      var id = this.get(this.idAttribute);
      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend({}, options, {validate: true}));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model, mapped to the
  // number of arguments they take.
  var modelMethods = {keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
      omit: 0, chain: 1, isEmpty: 1};

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  addUnderscoreMethods(Model, modelMethods, 'attributes');

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analogous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Splices `insert` into `array` at index `at`.
  var splice = function(array, insert, at) {
    at = Math.min(Math.max(at, 0), array.length);
    var tail = Array(array.length - at);
    var length = insert.length;
    var i;
    for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
    for (i = 0; i < length; i++) array[i + at] = insert[i];
    for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
  };

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model) { return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set. `models` may be Backbone
    // Models or raw JavaScript objects to be converted to Models, or any
    // combination of the two.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      options = _.extend({}, options);
      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();
      var removed = this._removeModels(models, options);
      if (!options.silent && removed.length) {
        options.changes = {added: [], merged: [], removed: removed};
        this.trigger('update', this, options);
      }
      return singular ? removed[0] : removed;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      if (models == null) return;

      options = _.extend({}, setOptions, options);
      if (options.parse && !this._isModel(models)) {
        models = this.parse(models, options) || [];
      }

      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();

      var at = options.at;
      if (at != null) at = +at;
      if (at > this.length) at = this.length;
      if (at < 0) at += this.length + 1;

      var set = [];
      var toAdd = [];
      var toMerge = [];
      var toRemove = [];
      var modelMap = {};

      var add = options.add;
      var merge = options.merge;
      var remove = options.remove;

      var sort = false;
      var sortable = this.comparator && at == null && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      var model, i;
      for (i = 0; i < models.length; i++) {
        model = models[i];

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        var existing = this.get(model);
        if (existing) {
          if (merge && model !== existing) {
            var attrs = this._isModel(model) ? model.attributes : model;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            toMerge.push(existing);
            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
          }
          if (!modelMap[existing.cid]) {
            modelMap[existing.cid] = true;
            set.push(existing);
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(model, options);
          if (model) {
            toAdd.push(model);
            this._addReference(model, options);
            modelMap[model.cid] = true;
            set.push(model);
          }
        }
      }

      // Remove stale models.
      if (remove) {
        for (i = 0; i < this.length; i++) {
          model = this.models[i];
          if (!modelMap[model.cid]) toRemove.push(model);
        }
        if (toRemove.length) this._removeModels(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      var orderChanged = false;
      var replace = !sortable && add && remove;
      if (set.length && replace) {
        orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
          return m !== set[index];
        });
        this.models.length = 0;
        splice(this.models, set, 0);
        this.length = this.models.length;
      } else if (toAdd.length) {
        if (sortable) sort = true;
        splice(this.models, toAdd, at == null ? this.length : at);
        this.length = this.models.length;
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort/update events.
      if (!options.silent) {
        for (i = 0; i < toAdd.length; i++) {
          if (at != null) options.index = at + i;
          model = toAdd[i];
          model.trigger('add', model, this, options);
        }
        if (sort || orderChanged) this.trigger('sort', this, options);
        if (toAdd.length || toRemove.length || toMerge.length) {
          options.changes = {
            added: toAdd,
            removed: toRemove,
            merged: toMerge
          };
          this.trigger('update', this, options);
        }
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options = options ? _.clone(options) : {};
      for (var i = 0; i < this.models.length; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      return this.remove(model, options);
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      return this.remove(model, options);
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id, cid, model object with id or cid
    // properties, or an attributes object that is transformed through modelId.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj] ||
        this._byId[this.modelId(obj.attributes || obj)] ||
        obj.cid && this._byId[obj.cid];
    },

    // Returns `true` if the model is in the collection.
    has: function(obj) {
      return this.get(obj) != null;
    },

    // Get the model at the given index.
    at: function(index) {
      if (index < 0) index += this.length;
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      return this[first ? 'find' : 'filter'](attrs);
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      var comparator = this.comparator;
      if (!comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      var length = comparator.length;
      if (_.isFunction(comparator)) comparator = _.bind(comparator, this);

      // Run sort based on type of `comparator`.
      if (length === 1 || _.isString(comparator)) {
        this.models = this.sortBy(comparator);
      } else {
        this.models.sort(comparator);
      }
      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return this.map(attr + '');
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success.call(options.context, collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      var wait = options.wait;
      model = this._prepareModel(model, options);
      if (!model) return false;
      if (!wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(m, resp, callbackOpts) {
        if (wait) collection.add(m, callbackOpts);
        if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models, {
        model: this.model,
        comparator: this.comparator
      });
    },

    // Define how to uniquely identify models in the collection.
    modelId: function(attrs) {
      return attrs[this.model.prototype.idAttribute || 'id'];
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (this._isModel(attrs)) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method called by both remove and set.
    _removeModels: function(models, options) {
      var removed = [];
      for (var i = 0; i < models.length; i++) {
        var model = this.get(models[i]);
        if (!model) continue;

        var index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;

        // Remove references before triggering 'remove' event to prevent an
        // infinite loop. #3693
        delete this._byId[model.cid];
        var id = this.modelId(model.attributes);
        if (id != null) delete this._byId[id];

        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }

        removed.push(model);
        this._removeReference(model, options);
      }
      return removed;
    },

    // Method for checking whether an object should be considered a model for
    // the purposes of adding to the collection.
    _isModel: function(model) {
      return model instanceof Model;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      var id = this.modelId(model.attributes);
      if (id != null) this._byId[id] = model;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      delete this._byId[model.cid];
      var id = this.modelId(model.attributes);
      if (id != null) delete this._byId[id];
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if (model) {
        if ((event === 'add' || event === 'remove') && collection !== this) return;
        if (event === 'destroy') this.remove(model, options);
        if (event === 'change') {
          var prevId = this.modelId(model.previousAttributes());
          var id = this.modelId(model.attributes);
          if (prevId !== id) {
            if (prevId != null) delete this._byId[prevId];
            if (id != null) this._byId[id] = model;
          }
        }
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var collectionMethods = {forEach: 3, each: 3, map: 3, collect: 3, reduce: 0,
      foldl: 0, inject: 0, reduceRight: 0, foldr: 0, find: 3, detect: 3, filter: 3,
      select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
      contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
      head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
      without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
      isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
      sortBy: 3, indexBy: 3, findIndex: 3, findLastIndex: 3};

  // Mix in each Underscore method as a proxy to `Collection#models`.
  addUnderscoreMethods(Collection, collectionMethods, 'models');

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be set as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this._removeElement();
      this.stopListening();
      return this;
    },

    // Remove this view's element from the document and all event listeners
    // attached to it. Exposed for subclasses using an alternative DOM
    // manipulation API.
    _removeElement: function() {
      this.$el.remove();
    },

    // Change the view's element (`this.el` property) and re-delegate the
    // view's events on the new element.
    setElement: function(element) {
      this.undelegateEvents();
      this._setElement(element);
      this.delegateEvents();
      return this;
    },

    // Creates the `this.el` and `this.$el` references for this view using the
    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
    // context or an element. Subclasses can override this to utilize an
    // alternative DOM manipulation API and are only required to set the
    // `this.el` property.
    _setElement: function(el) {
      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
      this.el = this.$el[0];
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    delegateEvents: function(events) {
      events || (events = _.result(this, 'events'));
      if (!events) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[method];
        if (!method) continue;
        var match = key.match(delegateEventSplitter);
        this.delegate(match[1], match[2], _.bind(method, this));
      }
      return this;
    },

    // Add a single event listener to the view's element (or a child element
    // using `selector`). This only works for delegate-able events: not `focus`,
    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
    delegate: function(eventName, selector, listener) {
      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Clears all callbacks previously bound to the view by `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // A finer-grained `undelegateEvents` for removing a single delegated event.
    // `selector` and `listener` are both optional.
    undelegate: function(eventName, selector, listener) {
      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Produces a DOM element to be assigned to your view. Exposed for
    // subclasses using an alternative DOM manipulation API.
    _createElement: function(tagName) {
      return document.createElement(tagName);
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        this.setElement(this._createElement(_.result(this, 'tagName')));
        this._setAttributes(attrs);
      } else {
        this.setElement(_.result(this, 'el'));
      }
    },

    // Set attributes from a hash on this view's element.  Exposed for
    // subclasses using an alternative DOM manipulation API.
    _setAttributes: function(attributes) {
      this.$el.attr(attributes);
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // Pass along `textStatus` and `errorThrown` from jQuery.
    var error = options.error;
    options.error = function(xhr, textStatus, errorThrown) {
      options.textStatus = textStatus;
      options.errorThrown = errorThrown;
      if (error) error.call(options.context, xhr, textStatus, errorThrown);
    };

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch': 'PATCH',
    'delete': 'DELETE',
    'read': 'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        if (router.execute(callback, args, name) !== false) {
          router.trigger.apply(router, ['route:' + name].concat(args));
          router.trigger('route', name, args);
          Backbone.history.trigger('route', router, name, args);
        }
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args, name) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    this.checkUrl = _.bind(this.checkUrl, this);

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
      return path === this.root && !this.getSearch();
    },

    // Does the pathname match the root?
    matchRoot: function() {
      var path = this.decodeFragment(this.location.pathname);
      var rootPath = path.slice(0, this.root.length - 1) + '/';
      return rootPath === this.root;
    },

    // Unicode characters in `location.pathname` are percent encoded so they're
    // decoded for comparison. `%25` should not be decoded since it may be part
    // of an encoded parameter.
    decodeFragment: function(fragment) {
      return decodeURI(fragment.replace(/%25/g, '%2525'));
    },

    // In IE6, the hash fragment and search params are incorrect if the
    // fragment contains `?`.
    getSearch: function() {
      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
      return match ? match[0] : '';
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the pathname and search params, without the root.
    getPath: function() {
      var path = this.decodeFragment(
        this.location.pathname + this.getSearch()
      ).slice(this.root.length - 1);
      return path.charAt(0) === '/' ? path.slice(1) : path;
    },

    // Get the cross-browser normalized URL fragment from the path or hash.
    getFragment: function(fragment) {
      if (fragment == null) {
        if (this._usePushState || !this._wantsHashChange) {
          fragment = this.getPath();
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error('Backbone.history has already been started');
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._hasHashChange   = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.history && this.history.pushState);
      this._usePushState    = this._wantsPushState && this._hasPushState;
      this.fragment         = this.getFragment();

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          var rootPath = this.root.slice(0, -1) || '/';
          this.location.replace(rootPath + '#' + this.getPath());
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot()) {
          this.navigate(this.getHash(), {replace: true});
        }

      }

      // Proxy an iframe to handle location events if the browser doesn't
      // support the `hashchange` event, HTML5 history, or the user wants
      // `hashChange` but not `pushState`.
      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
        this.iframe = document.createElement('iframe');
        this.iframe.src = 'javascript:0';
        this.iframe.style.display = 'none';
        this.iframe.tabIndex = -1;
        var body = document.body;
        // Using `appendChild` will throw on IE < 9 if the document is not ready.
        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
        iWindow.document.open();
        iWindow.document.close();
        iWindow.location.hash = '#' + this.fragment;
      }

      // Add a cross-platform `addEventListener` shim for older browsers.
      var addEventListener = window.addEventListener || function(eventName, listener) {
        return attachEvent('on' + eventName, listener);
      };

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._usePushState) {
        addEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        addEventListener('hashchange', this.checkUrl, false);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      // Add a cross-platform `removeEventListener` shim for older browsers.
      var removeEventListener = window.removeEventListener || function(eventName, listener) {
        return detachEvent('on' + eventName, listener);
      };

      // Remove window listeners.
      if (this._usePushState) {
        removeEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        removeEventListener('hashchange', this.checkUrl, false);
      }

      // Clean up the iframe if necessary.
      if (this.iframe) {
        document.body.removeChild(this.iframe);
        this.iframe = null;
      }

      // Some environments will throw when clearing an undefined interval.
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();

      // If the user pressed the back button, the iframe's hash will have
      // changed and we should use that for comparison.
      if (current === this.fragment && this.iframe) {
        current = this.getHash(this.iframe.contentWindow);
      }

      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      // If the root doesn't match, no routes can match either.
      if (!this.matchRoot()) return false;
      fragment = this.fragment = this.getFragment(fragment);
      return _.some(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      // Normalize the fragment.
      fragment = this.getFragment(fragment || '');

      // Don't include a trailing slash on the root.
      var rootPath = this.root;
      if (fragment === '' || fragment.charAt(0) === '?') {
        rootPath = rootPath.slice(0, -1) || '/';
      }
      var url = rootPath + fragment;

      // Strip the hash and decode for matching.
      fragment = this.decodeFragment(fragment.replace(pathStripper, ''));

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._usePushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
          var iWindow = this.iframe.contentWindow;

          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if (!options.replace) {
            iWindow.document.open();
            iWindow.document.close();
          }

          this._updateHash(iWindow.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function and add the prototype properties.
    child.prototype = _.create(parent.prototype, protoProps);
    child.prototype.constructor = child;

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error.call(options.context, model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 16 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_AccessCodeFeature */
/* unused harmony export bpfrpt_proptype_ActionButtonsFeature */
/* unused harmony export bpfrpt_proptype_AdvancedInfoItem */
/* unused harmony export bpfrpt_proptype_AdvancedInfoFeature */
/* unused harmony export bpfrpt_proptype_AlarmFeature */
/* unused harmony export bpfrpt_proptype_BarrierFeature */
/* unused harmony export bpfrpt_proptype_BatteryFeature */
/* unused harmony export bpfrpt_proptype_ButtonPadFeature */
/* unused harmony export bpfrpt_proptype_CameraFeature */
/* unused harmony export bpfrpt_proptype_ColoredFeature */
/* unused harmony export bpfrpt_proptype_ConnectionFeature */
/* unused harmony export bpfrpt_proptype_DimmerFeature */
/* unused harmony export bpfrpt_proptype_DragonflyWifiConfigurationFeature */
/* unused harmony export bpfrpt_proptype_FanFeature */
/* unused harmony export bpfrpt_proptype_GroupFeature */
/* unused harmony export bpfrpt_proptype_LockLockFeature */
/* unused harmony export bpfrpt_proptype_UnlockLockFeature */
/* unused harmony export bpfrpt_proptype_ActivateLockFeature */
/* unused harmony export bpfrpt_proptype_OccupancyFeature */
/* unused harmony export bpfrpt_proptype_PivotFeature */
/* unused harmony export bpfrpt_proptype_PanTiltFeature */
/* unused harmony export bpfrpt_proptype_RuntimeHistoryFeature */
/* unused harmony export bpfrpt_proptype_RoomIqFeature */
/* unused harmony export bpfrpt_proptype_ScheduleFeature */
/* unused harmony export bpfrpt_proptype_SensorFeature */
/* unused harmony export bpfrpt_proptype_SolarPanelFeature */
/* unused harmony export bpfrpt_proptype_SpeakerFeature */
/* unused harmony export bpfrpt_proptype_SprinklerFeature */
/* unused harmony export bpfrpt_proptype_StreamableFeature */
/* unused harmony export bpfrpt_proptype_SwitchFeature */
/* unused harmony export bpfrpt_proptype_ThermostatFeature */
/* unused harmony export bpfrpt_proptype_ThermostatCompressorSpeedFeature */
/* unused harmony export bpfrpt_proptype_ThermostatFanModeFeature */
/* unused harmony export bpfrpt_proptype_ThermostatModeFeature */
/* unused harmony export bpfrpt_proptype_ThermostatRunModeFeature */
/* unused harmony export bpfrpt_proptype_PivotOccupancyModeFeature */
/* unused harmony export bpfrpt_proptype_UnenrollFeature */
/* unused harmony export bpfrpt_proptype_ValveFeature */
/* unused harmony export bpfrpt_proptype_WindowShadeOpenCloseStopFeature */
/* unused harmony export bpfrpt_proptype_WindowShadeSetPercentOpenFeature */
/* unused harmony export bpfrpt_proptype_XR724WifiConfigurationFeature */
/* unused harmony export bpfrpt_proptype_Feature */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);

var bpfrpt_proptype_AccessCodeFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["access_code"]).isRequired,
  has_temporary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  code_length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_temporary: function set_temporary() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    remove_temporary: function remove_temporary() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired,
  resource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })
};
var bpfrpt_proptype_ActionButtonsFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["action_buttons"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    button_text: function button_text() {
      return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    icon: function icon() {
      return (typeof IconList === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(IconList) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }
  }).isRequired).isRequired
};
var bpfrpt_proptype_AdvancedInfoItem = {
  label: function label() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  },
  value: function value() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  },
  load_link_label: function load_link_label() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  },
  timeout_message: function timeout_message() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  },
  warning_message: function warning_message() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  },
  alert_result: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  load_link: function load_link() {
    return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  }
};
var bpfrpt_proptype_AdvancedInfoFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["advanced_info"]).isRequired,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: function label() {
      return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    value: function value() {
      return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    load_link_label: function load_link_label() {
      return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    timeout_message: function timeout_message() {
      return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    warning_message: function warning_message() {
      return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    alert_result: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    load_link: function load_link() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }
  }).isRequired).isRequired
};
var bpfrpt_proptype_AlarmFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["alarm"]).isRequired,
  status: function status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    toggle: function toggle() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }
  })
};
var bpfrpt_proptype_BarrierFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["barrier"]).isRequired,
  status: function status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    operate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      title: function title() {
        return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
      }
    })
  }).isRequired
};
var bpfrpt_proptype_BatteryFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["battery"]).isRequired,
  label: function label() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  },
  // the battery status
  // * If `label` ends in "remaining", some mobile clients trim that part off
  updated_at: function updated_at() {
    return (typeof DateString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(DateString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  icon: function icon() {
    return (typeof IconList === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(IconList) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  }
};
var bpfrpt_proptype_ButtonPadFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["button_pad"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    assign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      data: function data() {
        return (typeof Schema === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Schema) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
      },
      // If data is not present, you can fetch the Link to get it.
      type: function type(props, propName, componentName) {
        if (!Object.prototype.hasOwnProperty.call(props, propName)) {
          throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
        }
      }
    }).isRequired
  }).isRequired
};
var bpfrpt_proptype_CameraFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["camera"]).isRequired,
  connected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  aspect_ratio: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // eg 16 / 9

  /* deprecated */
  quality: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["low", "high", "hd", "unknown"]).isRequired
};
var bpfrpt_proptype_ColoredFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["colored"]).isRequired,
  colors: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    red: function red() {
      return (typeof ZeroTo255 === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(ZeroTo255).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    blue: function blue() {
      return (typeof ZeroTo255 === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(ZeroTo255).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    green: function green() {
      return (typeof ZeroTo255 === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(ZeroTo255).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    warm: function warm() {
      return (typeof ZeroTo255 === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(ZeroTo255).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    // "warm light"
    cool: function cool() {
      return (typeof ZeroTo255 === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(ZeroTo255).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_color: function set_color() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_ConnectionFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["connection"]).isRequired,
  protocol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["wifi"]),
  // not currently used
  signal_strength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([function () {
    return (typeof PercentInteger === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(PercentInteger) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  }, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["unknown"])]).isRequired,
  is_connected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
var bpfrpt_proptype_DimmerFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["dimmer"]).isRequired,
  level: function level() {
    return (typeof PercentInteger === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(PercentInteger).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_level: function set_level() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_DragonflyWifiConfigurationFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["dragonfly_wifi_configuration"]).isRequired,
  // This "get_last_update_time" Link may be used by the wizard to discover
  // when the Dragonfly has reconnected (using the new WiFi configuration). If
  // the device was last updated at a time after when the wizard knew it was
  // offline, then the device must have reconnected.
  get_last_update_time: function get_last_update_time() {
    return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
};
var bpfrpt_proptype_FanFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["fan"]).isRequired,
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["off", "low", "medium", "high", "unknown"]).isRequired,
  speed: function speed() {
    return (typeof PercentInteger === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(PercentInteger).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  // 0 means stopped, 100 means very fast
  speed_increment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  // increment by which the fan can change speed, eg 33
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_speed: function set_speed() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_GroupFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["group"]).isRequired,
  members: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(function () {
    return (typeof Device === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Device).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  }).isRequired
};
var bpfrpt_proptype_LockLockFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["lock_lock"]).isRequired,
  is_locked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    lock: function lock() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_UnlockLockFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["unlock_lock"]).isRequired,
  is_unlocked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    unlock: function unlock() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_ActivateLockFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["activate_lock"]).isRequired,
  is_activatable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    activate: function activate() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_OccupancyFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["occupancy"]).isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["home", "away", "auto-away", "unknown"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_value: function set_value() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_PivotFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["pivot"]).isRequired,
  device_identifier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  occupancy_setpoints: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    preset_heat1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    preset_cool1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    preset_heat2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    preset_cool2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    setpoint_limit_enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    setpoint_limit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  }).isRequired,
  occupancy_mode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["none", "occupied", "unoccupied"]).isRequired,
  max_period_name_length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  max_periods_per_day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  high_low_temp_alert: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    high_low_enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    high_limit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    low_limit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  }).isRequired,
  sensor_fault_enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  pin_access: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pin_enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    pin_passcode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    technican_pin_enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    technican_passcode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  access_level: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_occupancy_mode: function set_occupancy_mode() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_occupancy_setpoints: function set_occupancy_setpoints() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_group_occupancy_setpoints: function set_group_occupancy_setpoints() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_group_schedule: function set_group_schedule() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    get_schedules_with_default: function get_schedules_with_default() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_high_low_temp_alert: function set_high_low_temp_alert() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_group_high_low_temp_alert: function set_group_high_low_temp_alert() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_sensor_fault_enabled: function set_sensor_fault_enabled() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_group_sensor_fault_enabled: function set_group_sensor_fault_enabled() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_pin_access: function set_pin_access() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_group_pin_access: function set_group_pin_access() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_access_level: function set_access_level() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_group_access_level: function set_group_access_level() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_PanTiltFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["pan_tilt"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    up: function up() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    down: function down() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    left: function left() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    right: function right() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_RuntimeHistoryFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["runtime_history"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    get_runtime_history: function get_runtime_history() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    get_monthly_runtime_history: function get_monthly_runtime_history() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_RoomIqFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["room_iq"]).isRequired,
  href: function href() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
};
var bpfrpt_proptype_ScheduleFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["schedule"]).isRequired,
  enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  max_period_name_length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  collection_url: function collection_url() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  can_add_remove_periods: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  max_periods_per_day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    get_active_schedule: function get_active_schedule() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    get_default_schedule: function get_default_schedule() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    set_active_schedule: function set_active_schedule() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    enable_scheduling: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
  }).isRequired
};
var bpfrpt_proptype_SensorFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["sensor"]).isRequired,
  sensor_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([function () {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  }, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired,
  // eg 72
  unit: function unit() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  // eg "°"
  status: function status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  }
};
var bpfrpt_proptype_SolarPanelFeature = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["solar_panel"]).isRequired,
  is_setup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([false]).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["solar_panel"]).isRequired,
  is_setup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([true]).isRequired,
  history_chart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  // Any valid highcharts config
  energy_production_current: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  energy_production_today: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  energy_production_month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  energy_production_lifetime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  dollars_saved_today: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  dollars_saved_month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  dollars_saved_lifetime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
})]);
var bpfrpt_proptype_SpeakerFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["speaker"]).isRequired,
  status: function status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  volume: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  is_playing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  favorites: function favorites(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  },
  // TODO
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    play: function play() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    pause: function pause() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_volume: function set_volume() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    play_url: function play_url() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    play_favorite: function play_favorite() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    // The below two actions don't appear to have ever been implemented
    // serverside, but the clientside code supports them:
    seek_previous: function seek_previous() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    seek_next: function seek_next() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_SprinklerFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["sprinkler"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    standby_mode: function standby_mode() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    water_zones: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      data: function data() {
        return (typeof Schema === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Schema) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
      },
      type: function type(props, propName, componentName) {
        if (!Object.prototype.hasOwnProperty.call(props, propName)) {
          throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
        }
      }
    }).isRequired,
    stop_water: function stop_water() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_StreamableFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["streamable"]).isRequired,
  stream_app_url: function stream_app_url() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  // eg nestmobile://something
  stream_web_url: function stream_web_url() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  // eg http://nest.com/somewhere
  connected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  // Whether the device has streaming enabled
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    // Enable/disable streaming
    set_value: function set_value() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_SwitchFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["switch"]).isRequired,
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["on", "off"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    toggle: function toggle() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    on: function on() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    off: function off() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_ThermostatFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["thermostat"]).isRequired,
  temperature: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  // Current indoor temperature
  status: function status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  // Heating, Cooling, Idle, Not Connected, etc
  status_icon: function status_icon() {
    return (typeof Icon === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Icon) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  },
  setpoint_delta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  // Distance the heat and cool setpoint need to be from
  // each other, in degrees. (Eg 3)
  setpoint_increment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([1, 0.5]).isRequired,
  // Amount the thermostat changes setpoints by
  setpoint_heat_min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  // Minimum value the heat setpoint can be
  setpoint_heat_max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  // Maximum value the heat setpoint can be
  setpoint_cool_min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  // Minimum value the cool setpoint can be
  setpoint_cool_max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  // Maximum value the cool setpoint can be
  setpoint_heat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // Current heat setpoint value
  setpoint_cool: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // Current cool setpoint value
  alert_temperature_low: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // Current lower-bound temp to send alerts at
  alert_temperature_high: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // Current upper-bound temp to send alerts at
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_heat_setpoint: function set_heat_setpoint() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    set_cool_setpoint: function set_cool_setpoint() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    set_setpoints: function set_setpoints() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }
  }).isRequired,
  system_status: function system_status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  }
};
var bpfrpt_proptype_ThermostatCompressorSpeedFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["thermostat_compressor_speed"]).isRequired,
  compressor_speed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
var bpfrpt_proptype_ThermostatFanModeFeature = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    __exact__: function __exact__(values, prop, displayName) {
      var props = {
        id: true,
        label: true,
        value: true,
        header: true
      };
      var extra = [];

      for (var k in values) {
        if (values.hasOwnProperty(k) && !props.hasOwnProperty(k)) {
          extra.push(k);
        }
      }

      if (extra.length > 0) {
        return new Error('Invalid additional prop(s) ' + JSON.stringify(extra));
      }
    }
  }).isRequired).isRequired,
  display_value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["thermostat_fan_mode"]).isRequired,
  status_icon: function status_icon() {
    return (typeof Icon === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Icon) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    update_thermostat_fan_mode: function update_thermostat_fan_mode() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_ThermostatModeFeature = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    __exact__: function __exact__(values, prop, displayName) {
      var props = {
        id: true,
        label: true,
        value: true,
        header: true
      };
      var extra = [];

      for (var k in values) {
        if (values.hasOwnProperty(k) && !props.hasOwnProperty(k)) {
          extra.push(k);
        }
      }

      if (extra.length > 0) {
        return new Error('Invalid additional prop(s) ' + JSON.stringify(extra));
      }
    }
  }).isRequired).isRequired,
  display_value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["thermostat_system_mode", "thermostat_zone_mode"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    update_thermostat_mode: function update_thermostat_mode() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_ThermostatRunModeFeature = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    __exact__: function __exact__(values, prop, displayName) {
      var props = {
        id: true,
        label: true,
        value: true,
        header: true
      };
      var extra = [];

      for (var k in values) {
        if (values.hasOwnProperty(k) && !props.hasOwnProperty(k)) {
          extra.push(k);
        }
      }

      if (extra.length > 0) {
        return new Error('Invalid additional prop(s) ' + JSON.stringify(extra));
      }
    }
  }).isRequired).isRequired,
  display_value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["thermostat_run_mode"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    update_thermostat_run_mode: function update_thermostat_run_mode() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_PivotOccupancyModeFeature = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    __exact__: function __exact__(values, prop, displayName) {
      var props = {
        id: true,
        label: true,
        value: true,
        header: true
      };
      var extra = [];

      for (var k in values) {
        if (values.hasOwnProperty(k) && !props.hasOwnProperty(k)) {
          extra.push(k);
        }
      }

      if (extra.length > 0) {
        return new Error('Invalid additional prop(s) ' + JSON.stringify(extra));
      }
    }
  }).isRequired).isRequired,
  display_value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["pivot_occupancy_mode"]).isRequired,
  setpoints_override: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    occupancy_override_mode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  }).isRequired,
  occupancy_override: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    current_time: function current_time() {
      return (typeof DateString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(DateString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    occupancy_override_enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    occupancy_override_start_time: function occupancy_override_start_time() {
      return (typeof DateString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(DateString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    occupancy_override_time: function occupancy_override_time() {
      return (typeof DateString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(DateString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_occupancy_override: function set_occupancy_override() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_UnenrollFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["unenroll"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    // If `unenroll` is a SchemaActionLink, then the device has guided unenrollment.
    // That idea doesn't seem to be fully fleshed out, though, because all we do
    // if a device has guided unenrollment is we don't show a simple "unenroll"
    // button in the details view (because presumably the guided enrollment
    // happens somewhere else).
    unenroll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      data: function data() {
        return (typeof Schema === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Schema) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
      },
      type: function type(props, propName, componentName) {
        if (!Object.prototype.hasOwnProperty.call(props, propName)) {
          throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
        }
      }
    }), function () {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }]).isRequired
  }).isRequired
};
var bpfrpt_proptype_ValveFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["valve"]).isRequired,
  status: function status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    operate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      title: function title() {
        return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
      }
    })
  }).isRequired
};
var bpfrpt_proptype_WindowShadeOpenCloseStopFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["window_shade_open_close_stop"]).isRequired,
  percent_open: function percent_open() {
    return (typeof PercentInteger === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(PercentInteger).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    open: function open() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    close: function close() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    stop: function stop() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_WindowShadeSetPercentOpenFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["window_shade_set_percent_open"]).isRequired,
  percent_open: function percent_open() {
    return (typeof PercentInteger === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(PercentInteger).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_percent_open: function set_percent_open() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
};
var bpfrpt_proptype_XR724WifiConfigurationFeature = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["xr724_wifi_configuration"]).isRequired,
  // This "get_last_update_time" Link may be used by the wizard to discover
  // when the XR724 has reconnected (using the new WiFi configuration). If the
  // device was last updated at a time after when the wizard knew it was
  // offline, then the device must have reconnected.
  get_last_update_time: function get_last_update_time() {
    return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  // We don't use these wizard images anymore; instead we use the mp4s found in
  // src/cdn.
  wizard_images: function wizard_images() {
    return (typeof XR724WizardImages === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(XR724WizardImages).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
};
var bpfrpt_proptype_Feature = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["access_code"]).isRequired,
  has_temporary: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  code_length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_temporary: function set_temporary() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    remove_temporary: function remove_temporary() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired,
  resource: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  })
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["action_buttons"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    button_text: function button_text() {
      return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    icon: function icon() {
      return (typeof IconList === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(IconList) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }
  }).isRequired).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["activate_lock"]).isRequired,
  is_activatable: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    activate: function activate() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["advanced_info"]).isRequired,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    label: function label() {
      return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    value: function value() {
      return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    load_link_label: function load_link_label() {
      return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    timeout_message: function timeout_message() {
      return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    warning_message: function warning_message() {
      return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    alert_result: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    load_link: function load_link() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }
  }).isRequired).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["alarm"]).isRequired,
  status: function status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    toggle: function toggle() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }
  })
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["barrier"]).isRequired,
  status: function status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    operate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      title: function title() {
        return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
      }
    })
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["battery"]).isRequired,
  label: function label() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  },
  updated_at: function updated_at() {
    return (typeof DateString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(DateString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  icon: function icon() {
    return (typeof IconList === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(IconList) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  }
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["button_pad"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    assign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      data: function data() {
        return (typeof Schema === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Schema) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
      },
      type: function type(props, propName, componentName) {
        if (!Object.prototype.hasOwnProperty.call(props, propName)) {
          throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
        }
      }
    }).isRequired
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["camera"]).isRequired,
  connected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  aspect_ratio: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  quality: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["low", "high", "hd", "unknown"]).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["colored"]).isRequired,
  colors: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    red: function red() {
      return (typeof ZeroTo255 === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(ZeroTo255).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    blue: function blue() {
      return (typeof ZeroTo255 === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(ZeroTo255).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    green: function green() {
      return (typeof ZeroTo255 === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(ZeroTo255).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    warm: function warm() {
      return (typeof ZeroTo255 === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(ZeroTo255).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    cool: function cool() {
      return (typeof ZeroTo255 === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(ZeroTo255).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_color: function set_color() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["connection"]).isRequired,
  protocol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["wifi"]),
  signal_strength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([function () {
    return (typeof PercentInteger === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(PercentInteger) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  }, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["unknown"])]).isRequired,
  is_connected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["dimmer"]).isRequired,
  level: function level() {
    return (typeof PercentInteger === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(PercentInteger).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_level: function set_level() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["dragonfly_wifi_configuration"]).isRequired,
  get_last_update_time: function get_last_update_time() {
    return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["fan"]).isRequired,
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["off", "low", "medium", "high", "unknown"]).isRequired,
  speed: function speed() {
    return (typeof PercentInteger === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(PercentInteger).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  speed_increment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_speed: function set_speed() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["group"]).isRequired,
  members: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(function () {
    return (typeof Device === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Device).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["lock_lock"]).isRequired,
  is_locked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    lock: function lock() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["occupancy"]).isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["home", "away", "auto-away", "unknown"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_value: function set_value() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["pan_tilt"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    up: function up() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    down: function down() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    left: function left() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    right: function right() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["pivot"]).isRequired,
  device_identifier: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  occupancy_setpoints: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    preset_heat1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    preset_cool1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    preset_heat2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    preset_cool2: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    setpoint_limit_enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    setpoint_limit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  }).isRequired,
  occupancy_mode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["none", "occupied", "unoccupied"]).isRequired,
  max_period_name_length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  max_periods_per_day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  high_low_temp_alert: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    high_low_enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    high_limit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    low_limit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  }).isRequired,
  sensor_fault_enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  pin_access: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    pin_enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    pin_passcode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    technican_pin_enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    technican_passcode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  access_level: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_occupancy_mode: function set_occupancy_mode() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_occupancy_setpoints: function set_occupancy_setpoints() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_group_occupancy_setpoints: function set_group_occupancy_setpoints() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_group_schedule: function set_group_schedule() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    get_schedules_with_default: function get_schedules_with_default() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_high_low_temp_alert: function set_high_low_temp_alert() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_group_high_low_temp_alert: function set_group_high_low_temp_alert() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_sensor_fault_enabled: function set_sensor_fault_enabled() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_group_sensor_fault_enabled: function set_group_sensor_fault_enabled() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_pin_access: function set_pin_access() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_group_pin_access: function set_group_pin_access() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_access_level: function set_access_level() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_group_access_level: function set_group_access_level() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["room_iq"]).isRequired,
  href: function href() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["runtime_history"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    get_runtime_history: function get_runtime_history() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    get_monthly_runtime_history: function get_monthly_runtime_history() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["schedule"]).isRequired,
  enabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  max_period_name_length: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  collection_url: function collection_url() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  can_add_remove_periods: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  max_periods_per_day: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    get_active_schedule: function get_active_schedule() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    get_default_schedule: function get_default_schedule() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    set_active_schedule: function set_active_schedule() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    enable_scheduling: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["sensor"]).isRequired,
  sensor_type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([function () {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  }, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired,
  unit: function unit() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  status: function status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  }
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["solar_panel"]).isRequired,
  is_setup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([false]).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["solar_panel"]).isRequired,
  is_setup: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([true]).isRequired,
  history_chart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  energy_production_current: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  energy_production_today: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  energy_production_month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  energy_production_lifetime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  dollars_saved_today: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  dollars_saved_month: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  dollars_saved_lifetime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
})]), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["speaker"]).isRequired,
  status: function status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  volume: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  is_playing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  favorites: function favorites(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    play: function play() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    pause: function pause() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    set_volume: function set_volume() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    play_url: function play_url() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    play_favorite: function play_favorite() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    seek_previous: function seek_previous() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    seek_next: function seek_next() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["sprinkler"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    standby_mode: function standby_mode() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    water_zones: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      data: function data() {
        return (typeof Schema === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Schema) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
      },
      type: function type(props, propName, componentName) {
        if (!Object.prototype.hasOwnProperty.call(props, propName)) {
          throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
        }
      }
    }).isRequired,
    stop_water: function stop_water() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["streamable"]).isRequired,
  stream_app_url: function stream_app_url() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  stream_web_url: function stream_web_url() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  connected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_value: function set_value() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["switch"]).isRequired,
  status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["on", "off"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    toggle: function toggle() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    on: function on() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    off: function off() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["thermostat"]).isRequired,
  temperature: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  status: function status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  status_icon: function status_icon() {
    return (typeof Icon === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Icon) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  },
  setpoint_delta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  setpoint_increment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([1, 0.5]).isRequired,
  setpoint_heat_min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  setpoint_heat_max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  setpoint_cool_min: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  setpoint_cool_max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  setpoint_heat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  setpoint_cool: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  alert_temperature_low: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  alert_temperature_high: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_heat_setpoint: function set_heat_setpoint() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    set_cool_setpoint: function set_cool_setpoint() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    },
    set_setpoints: function set_setpoints() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }
  }).isRequired,
  system_status: function system_status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
  }
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["unenroll"]).isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    unenroll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      data: function data() {
        return (typeof Schema === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Schema) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
      },
      type: function type(props, propName, componentName) {
        if (!Object.prototype.hasOwnProperty.call(props, propName)) {
          throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
        }
      }
    }), function () {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link) : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).apply(this, arguments);
    }]).isRequired
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["unlock_lock"]).isRequired,
  is_unlocked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    unlock: function unlock() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["valve"]).isRequired,
  status: function status() {
    return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    operate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      title: function title() {
        return (typeof HumanReadableString === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(HumanReadableString).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
      }
    })
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["window_covering"]).isRequired,
  percent_closed: function percent_closed() {
    return (typeof PercentInteger === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(PercentInteger).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_percent_closed: function set_percent_closed() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["window_shade_open_close_stop"]).isRequired,
  percent_open: function percent_open() {
    return (typeof PercentInteger === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(PercentInteger).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    open: function open() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    close: function close() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    stop: function stop() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["window_shade_set_percent_open"]).isRequired,
  percent_open: function percent_open() {
    return (typeof PercentInteger === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(PercentInteger).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    set_percent_open: function set_percent_open() {
      return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["xr724_wifi_configuration"]).isRequired,
  get_last_update_time: function get_last_update_time() {
    return (typeof Link === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Link).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  wizard_images: function wizard_images() {
    return (typeof XR724WizardImages === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(XR724WizardImages).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
})]);












































/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_prefixStyles__ = __webpack_require__(9);

var breakpoint = {
  THERMOSTAT_DETAILS_HEADER: 490,
  IPAD_WIDTH: 768
};
var button = {
  RADIUS: "4px"
};
var font = {
  WEIGHT_BOLD: 700
}; // The notch for iPhone X added safe-area-inset-top CSS properties. Unfortunately,
// iOS 11 uses constant(safe-area-inset-top), iOS 11.2 uses env(safe-are-inset-top)

var safeAreaFunction = null; // $FlowIgnore CSS can be defined globally, which is why the typeof check is here

if (typeof CSS !== "undefined" && typeof CSS.supports === "function") {
  if (CSS.supports("padding-top", "constant(safe-area-inset-top)")) {
    safeAreaFunction = "constant";
  } else if (CSS.supports("padding-top", "env(safe-area-inset-top)")) {
    safeAreaFunction = "env";
  }
}

var padding = {
  CONTENT: 14.25,
  APP_BAR_BUTTON: 4,
  SAFE_AREA_TOP: safeAreaFunction ? "".concat(safeAreaFunction, "(safe-area-inset-top)") : "0px",
  SAFE_AREA_RIGHT: safeAreaFunction ? "".concat(safeAreaFunction, "(safe-area-inset-right)") : "0px",
  SAFE_AREA_BOTTOM: safeAreaFunction ? "".concat(safeAreaFunction, "(safe-area-inset-bottom)") : "0px",
  SAFE_AREA_LEFT: safeAreaFunction ? "".concat(safeAreaFunction, "(safe-area-inset-left)") : "0px"
};
var styles = Object(__WEBPACK_IMPORTED_MODULE_0__utils_prefixStyles__["b" /* default */])({
  flexLayout: {
    display: "flex",
    alignItems: "center"
  },
  flexStretch: {
    flex: "1 1 auto"
  },
  flexStretchEqual: {
    flex: "1 1 100%"
  },
  flexShrink: {
    flex: "0 1 auto",
    minWidth: 0 // fixes a bizarre bug with text-overflow

  },
  flexFixed: {
    flex: "0 0 auto"
  },
  textEllipsis: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  }
});
var zIndexLayers = {
  BASE: 0,
  CONTENTS: 1000,
  MODAL: 2000,
  POPUP: 3000
};
/* harmony default export */ __webpack_exports__["a"] = ({
  Breakpoint: breakpoint,
  Button: button,
  Font: font,
  Padding: padding,
  RESPONSIVE_REFRESH_RATE: 250,
  Styles: styles,
  zIndexLayers: zIndexLayers
});

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(865);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 22 */
/***/ (function(module, exports) {

/**
 * Ensure some object is a coerced to a string
 **/
module.exports = function makeString(object) {
  if (object == null) return '';
  return '' + object;
};


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return IconClearAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return IconHelp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return IconIpad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return IconRotateArrow; });
/* unused harmony export IconEnergyMeter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return IconRuntimeHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return IconScheduling; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return IconSettingsGear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return IconCircledCheckmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return IconCircledArrowDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return IconCircledArrowUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return IconThermostat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return IconThermostatMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return IconWifi; });
/* unused harmony export IconRadioAntenna */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return IconDisclosureArrowRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return IconDropDownArrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return IconThinChevronLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return IconThinChevronRight; });
/* unused harmony export IconThinChevronDown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return IconThinnerChevronDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return IconThinnerChevronUp; });
/* unused harmony export IconThinArrowUp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return IconThinArrowDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return IconPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return IconPause; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return IconStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return IconRewind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return IconFastForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconBatteryEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconBatteryLow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IconBatteryMostlyFull; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IconBatteryFull; });
/* unused harmony export IconBell */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IconBlindsClosed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IconBlindsHalfOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IconBlindsMostlyClosed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return IconBlindsMostlyOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return IconBlindsOpen; });
/* unused harmony export IconCalendarEmpty */
/* unused harmony export IconCalendar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return IconCameraDisconnected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return IconCamera; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return IconSnapshot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return IconCaretDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return IconCaretUp; });
/* unused harmony export IconCasementWindowClosedLocked */
/* unused harmony export IconCasementWindowClosedUnlocked */
/* unused harmony export IconCasementWindowClosed */
/* unused harmony export IconCasementWindowOpen */
/* unused harmony export IconCasementWindowUnknown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return IconChat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return IconCheckSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return IconCheckmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return IconChevronDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return IconChevronLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return IconChevronRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return IconChevronUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return IconCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return IconCircleGradient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return IconClimate; });
/* unused harmony export IconClock */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return IconClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return IconCloudOff; });
/* unused harmony export IconCreateGroup */
/* unused harmony export IconDoorOpen */
/* unused harmony export IconDoor */
/* unused harmony export IconDoorbellTriggered */
/* unused harmony export IconDoorbellWaiting */
/* unused harmony export IconDoubleHungWindowClosedLocked */
/* unused harmony export IconDoubleHungWindowClosedUnlocked */
/* unused harmony export IconDoubleHungWindowClosed */
/* unused harmony export IconDoubleHungWindowOpen */
/* unused harmony export IconDoubleHungWindowUnknown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return IconDroplets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return IconEnvelope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return IconEqualizer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return IconExit; });
/* unused harmony export IconFanMoving */
/* unused harmony export IconFanOff */
/* unused harmony export IconFanOn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return IconFilter; });
/* unused harmony export IconGarageClosed */
/* unused harmony export IconGarageOpen */
/* unused harmony export IconGaragePartial */
/* unused harmony export IconGears */
/* unused harmony export IconGlobe */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return IconGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return IconSad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return IconHD; });
/* unused harmony export IconHeart */
/* unused harmony export IconHingedDoorClosedLocked */
/* unused harmony export IconHingedDoorClosedUnlocked */
/* unused harmony export IconHingedDoorClosed */
/* unused harmony export IconHingedDoorOpen */
/* unused harmony export IconHingedDoorUnknown */
/* unused harmony export IconHistory */
/* unused harmony export IconHomeController */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return IconHomeMode; });
/* unused harmony export IconHouse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return IconInfo; });
/* unused harmony export IconInsynctive */
/* unused harmony export IconIrrigationOff */
/* unused harmony export IconIrrigationOn */
/* unused harmony export IconKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return IconLightSwitchOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return IconLightSwitchOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return IconLightbulb0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return IconLightbulb100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return IconLightning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return IconListUl; });
/* unused harmony export IconLocation */
/* unused harmony export IconLockUnknown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return IconLocked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return IconUnlocked; });
/* unused harmony export IconMicrophone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return IconMinusSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return IconMinus; });
/* unused harmony export IconMoon */
/* unused harmony export IconMouseTrapArmed */
/* unused harmony export IconMouseTrapDisarmed */
/* unused harmony export IconMouseTrapTripped */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return IconMovie; });
/* unused harmony export IconMusic */
/* unused harmony export IconNestAwayIcon */
/* unused harmony export IconNestHomeIcon */
/* unused harmony export IconNestUnknownIcon */
/* unused harmony export IconNewspaper */
/* unused harmony export IconNexiaLogo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return IconPencil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return IconPhone; });
/* unused harmony export IconPlane */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return IconPlusSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return IconPlus; });
/* unused harmony export IconQuestion */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return IconQuestionCommercial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return IconRefresh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return IconPivotRefresh; });
/* unused harmony export IconRemote */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return IconRemoveSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return IconRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return IconPivotRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return IconHamburgerMenu; });
/* unused harmony export IconSamsungDryer */
/* unused harmony export IconSamsungDryerOffline */
/* unused harmony export IconSamsungVacuum */
/* unused harmony export IconSamsungVacuumCharging */
/* unused harmony export IconSamsungVacuumOffline */
/* unused harmony export IconSamsungWasher */
/* unused harmony export IconSamsungWasherOffline */
/* unused harmony export IconSensorActivated */
/* unused harmony export IconSensorGenericActive */
/* unused harmony export IconSensorGeneric */
/* unused harmony export IconSensorMotionIdle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return IconSettings; });
/* unused harmony export IconShadesBottomHalfOpen */
/* unused harmony export IconShadesBottomMostlyClosed */
/* unused harmony export IconShadesBottomMostlyOpen */
/* unused harmony export IconShadesClosed */
/* unused harmony export IconShadesHalfOpen */
/* unused harmony export IconShadesMostlyClosed */
/* unused harmony export IconShadesMostlyOpen */
/* unused harmony export IconShadesOpen */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return IconShield; });
/* unused harmony export IconSirenOn */
/* unused harmony export IconSiren */
/* unused harmony export IconSlidingDoorClosedLocked */
/* unused harmony export IconSlidingDoorClosedUnlocked */
/* unused harmony export IconSlidingDoorClosed */
/* unused harmony export IconSlidingDoorOpen */
/* unused harmony export IconSlidingDoorUnknown */
/* unused harmony export IconSmile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return IconSmokeDetectorTriggered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return IconSmokeDetector; });
/* unused harmony export IconStar */
/* unused harmony export IconSunny */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return IconSupport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return IconUndo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return IconUser; });
/* unused harmony export IconUserAndroid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return IconUserBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return IconUserMobile; });
/* unused harmony export IconUserWindows */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return IconVolumeHigh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return IconVolumeMedium; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return IconVolumeLow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return IconVolumeMute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return IconWand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return IconWarning; });
/* unused harmony export IconWaterSensor */
/* unused harmony export IconWaterValveClosed */
/* unused harmony export IconWaterValve */
/* unused harmony export IconWindowNotOk */
/* unused harmony export IconWindowOk */
/* unused harmony export IconWindowOpen */
/* unused harmony export IconWindowClosed */
/* unused harmony export IconZWave */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return IconDeletePinpad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return IconDigit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return IconEmptyDigit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return IconForgotPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return IconPasswordNotVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return IconPasswordVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return IconWaterDrop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return IconWaterDropOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return IconCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return IconRachioLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return IconFire; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return IconSnowflake; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return IconPivotOccupied; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return IconPivotUnoccupied; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return IconBuilding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return IconTransferAccount; });
/* harmony export (immutable) */ __webpack_exports__["_62"] = iconFromAPIName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconBase__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GlobalStyleSheet__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var IconClearAll = function IconClearAll(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconClearAll"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M6.8,29.9h40.4v-5.8H6.8V29.9z M1,41.4h40.4v-5.8H1V41.4z M12.6,12.6v5.8H53v-5.8H12.6z"
  }));
};
IconClearAll.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconHelp = function IconHelp(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconHelp"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M27,4.5c12.4,0,22.5,10.1,22.5,22.5S39.4,49.5,27,49.5S4.5,39.4,4.5,27S14.6,4.5,27,4.5z M26.7,35.3l0-3.5 c0.3-1.4,1.3-2.5,2.8-3c3.3-1,5.7-4,5.9-7.5c0.4-3.9-2.2-7.6-5.9-8.8c-0.3-0.1-0.6-0.2-0.9-0.2c-2.1-0.4-4.2,0-6,1.1 c-2,1.2-3.5,3.3-3.9,5.7 M26.9,41.9v-1.4"
  }));
};
IconHelp.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconIpad = function IconIpad(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 50 50"
  }, props, {
    "data-component-name": "IconIpad"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M 6 6 C 4.136719 6 2.609375 6.921875 1.59375 8.09375 C 0.578125 9.265625 0 10.679688 0 12 L 0 38.375 C 0 41.464844 2.535156 44 5.625 44 L 44.375 44 C 47.464844 44 50 41.464844 50 38.375 L 50 11.84375 C 50 8.65625 47.148438 6 44 6 Z M 6 8 L 44 8 C 45.949219 8 48 9.9375 48 11.84375 L 48 38.375 C 48 40.382813 46.382813 42 44.375 42 L 5.625 42 C 3.613281 42 2 40.386719 2 38.375 L 2 12 C 2 11.320313 2.378906 10.234375 3.09375 9.40625 C 3.808594 8.578125 4.785156 8 6 8 Z M 6.8125 10 C 6.335938 10.089844 5.992188 10.511719 6 11 L 6 39 C 6 39.550781 6.449219 40 7 40 L 44 40 C 44.550781 40 45 39.550781 45 39 L 45 11 C 45 10.449219 44.550781 10 44 10 L 7 10 C 6.96875 10 6.9375 10 6.90625 10 C 6.875 10 6.84375 10 6.8125 10 Z M 8 12 L 43 12 L 43 38 L 8 38 Z M 4 23.5 C 3.171875 23.5 2.5 24.171875 2.5 25 C 2.5 25.828125 3.171875 26.5 4 26.5 C 4.828125 26.5 5.5 25.828125 5.5 25 C 5.5 24.171875 4.828125 23.5 4 23.5 Z ",
    fill: "currentColor"
  }));
};
IconIpad.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconRotateArrow = function IconRotateArrow(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 50 50"
  }, props, {
    "data-component-name": "IconRotateArrow"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M 15 3.171875 L 2.5859375 15.585938 A 2.0002 2.0002 0 1 0 5.4140625 18.414062 L 13 10.828125 L 13 38 C 13 42.394668 16.605332 46 21 46 L 46 46 A 2.0002 2.0002 0 1 0 46 42 L 21 42 C 18.766668 42 17 40.233332 17 38 L 17 10.828125 L 24.585938 18.414062 A 2.0002 2.0002 0 1 0 27.414062 15.585938 L 15 3.171875 z",
    fill: "currentColor"
  }));
};
IconRotateArrow.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconEnergyMeter = function IconEnergyMeter(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconEnergyMeter"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M14,7A15,15,0,0,0,6.8,8.4C5.2,9.3,4,10.5,4,12V44a3.08,3.08,0,0,0,3,3H47a3.08,3.08,0,0,0,3-3V12c0-1.5-1.1-2.8-2.8-3.6A16.64,16.64,0,0,0,40,7Zm-1.2,7a1,1,0,0,0-.8,1v7a.94.94,0,0,0,1,1H30a.94.94,0,0,0,1-1V15a.94.94,0,0,0-1-1H12.8Zm26.7,4A5.5,5.5,0,1,0,45,23.5,5.55,5.55,0,0,0,39.5,18Zm-14,10a.52.52,0,1,0,.52.52A.53.53,0,0,0,25.5,28ZM8.8,47V40.8c0-1.1,2.2-4.6,5.4-4.6h26c3.2,1,4.8,3.5,4.8,4.7V47M39.5,23a.52.52,0,1,0,.52.52A.53.53,0,0,0,39.5,23ZM14.62,42a4,4,0,0,1,.61,0c2.63.41,2,5.06,2,5.06H12.08S11.29,42,14.62,42Zm8,0a4,4,0,0,1,.61,0c2.63.41,2,5.06,2,5.06H20.08S19.29,42,22.62,42Zm8,0a4,4,0,0,1,.61,0c2.63.41,2,5.06,2,5.06H28.08S27.29,42,30.62,42ZM36.08,47S35.29,42,38.62,42a4,4,0,0,1,.61,0c2.63.41,2,5.06,2,5.06Z"
  }));
};
IconEnergyMeter.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconRuntimeHistory = function IconRuntimeHistory(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconRuntimeHistory"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("rect", {
    x: "5",
    y: "18",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    width: "12",
    height: "31"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("rect", {
    x: "21",
    y: "29",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    width: "12",
    height: "20"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("rect", {
    x: "37",
    y: "5",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    width: "12",
    height: "44"
  }));
};
IconRuntimeHistory.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconScheduling = function IconScheduling(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconScheduling"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("rect", {
    x: "3",
    y: "7",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: "48",
    height: "40"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: "11",
    y1: "7",
    x2: "11",
    y2: "47"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: "51",
    y1: "23",
    x2: "3",
    y2: "23"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: "51",
    y1: "15",
    x2: "3",
    y2: "15"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: "51",
    y1: "31",
    x2: "3",
    y2: "31"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: "51",
    y1: "39",
    x2: "3",
    y2: "39"
  }));
};
IconScheduling.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSettingsGear = function IconSettingsGear(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSettingsGear"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M51,30v-6l-7.1-1.2c-0.4-1.7-1.1-3.3-2-4.7l4.2-5.9l-4.2-4.2L36,12.1c-1.5-0.9-3.1-1.6-4.8-2L30,3h-6l-1.2,7.1c-1.7,0.4-3.3,1.1-4.8,2l-5.8-4.2l-4.2,4.2L12,18c-0.9,1.5-1.6,3.1-2,4.8L3,24v6l7,1.2c0.4,1.7,1.1,3.3,2,4.8l-4.2,5.8l4.2,4.2l5.9-4.1c1.5,0.9,3.1,1.6,4.8,2L24,51h6l1.3-7.1c1.7-0.4,3.3-1.1,4.8-2l5.9,4.2l4.2-4.2l-4.2-5.9c0.9-1.5,1.5-3,2-4.7L51,30z M27,35c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S31.4,35,27,35z"
  }));
};
IconSettingsGear.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCircledCheckmark = function IconCircledCheckmark(_ref) {
  var checked = _ref.checked,
      children = _ref.children,
      props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["checked", "children"]);

  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 32 32"
  }, props, {
    "data-component-name": "IconCircledCheckmark"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: "16",
    cy: "16",
    r: "12"
  }), checked ? __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "23,12 15,20 10,15 "
  }) : null, children ? __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("text", {
    x: "16",
    y: "16",
    fontSize: "0.65em",
    dy: "0.35em",
    textAnchor: "middle",
    fill: "currentColor"
  }, children) : null);
};
IconCircledCheckmark.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  checked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
};
IconCircledCheckmark.defaultProps = {
  checked: false
};
var IconCircledArrowDown = function IconCircledArrowDown(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 40 40"
  }, props, {
    "data-component-name": "IconCircledArrowDown"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", {
    transform: "matrix(0.5,0,0,-0.5,10,30)"
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M6.6 20 20 6.6 33.4 20 30.9 22.3 21.6 13l0 20.4-3.2 0 0-20.4-9.4 9.3z"
  })), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("ellipse", {
    cx: "20",
    cy: "20",
    rx: "17",
    ry: "17",
    fill: "none",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "currentColor"
  }));
};
IconCircledArrowDown.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCircledArrowUp = function IconCircledArrowUp(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 40 40"
  }, props, {
    "data-component-name": "IconCircledArrowUp"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", {
    transform: "matrix(0.5,0,0,0.5,10,10)"
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M6.6 20 20 6.6 33.4 20 30.9 22.3 21.6 13l0 20.4-3.2 0 0-20.4-9.4 9.3z"
  })), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("ellipse", {
    cx: "20",
    cy: "20",
    rx: "17",
    ry: "17",
    fill: "none",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "currentColor"
  }));
};
IconCircledArrowUp.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconThermostat = function IconThermostat(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconThermostat"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M31,29.82V5H23v24.8A10,10,0,1,0,37,39,10.15,10.15,0,0,0,31,29.82ZM27,16V34m0,0a5,5,0,1,1-5,5A5,5,0,0,1,27,34ZM31,9h4m-4,4h3m-3,4h4m-4,4h3m-3,4h4"
  }));
};
IconThermostat.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconThermostatMode = function IconThermostatMode(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconThermostatMode"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M50.62,22.21h0l-3-2.33-20-15.67A1,1,0,0,0,27,4a1,1,0,0,0-.58.21l-20,15.63-3,2.37m2.62-2V49a1,1,0,0,0,1,1H47a1,1,0,0,0,1-1V20.17M18.78,22.62h0a4.9,4.9,0,0,1,2-1.37c1.29-.46,3.05-.56,5.54,1.51,2.91,2.43,5.65,2.53,7.51,1.86a7,7,0,0,0,2.92-2A1,1,0,0,0,37,22M17.78,31.62h0a4.9,4.9,0,0,1,2-1.37c1.29-.46,3.05-.56,5.54,1.51,2.91,2.43,5.65,2.53,7.51,1.86a7,7,0,0,0,2.92-2A1,1,0,0,0,36,31M17.78,40.62h0a4.9,4.9,0,0,1,2-1.37c1.29-.46,3.05-.56,5.54,1.51,2.91,2.43,5.65,2.53,7.51,1.86a7,7,0,0,0,2.92-2A1,1,0,0,0,36,40"
  }));
};
IconThermostatMode.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconWifi = function IconWifi(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 24 24"
  }, props, {
    "data-component-name": "IconWifi"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M10.6,18.5L12,20l1.4-1.5C13,18.2,12.5,18,12,18S11,18.2,10.6,18.5z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M16.1,15.6C15,14.6,13.6,14,12,14s-3,0.6-4.1,1.6"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M19.5,12c-2-1.8-4.6-3-7.5-3s-5.5,1.1-7.5,3"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M22.9,8.3C20,5.6,16.2,4,12,4S3.9,5.6,1.1,8.3"
  }));
};
IconWifi.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconRadioAntenna = function IconRadioAntenna(_ref2) {
  var radioWavesLeftShown = _ref2.radioWavesLeftShown,
      radioWavesRightShown = _ref2.radioWavesRightShown,
      props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ["radioWavesLeftShown", "radioWavesRightShown"]);

  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 387.1 431.9"
  }, props, {
    "data-component-name": "IconRadioAntenna"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", {
    id: "antenna"
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M189.3,184.5l-14.9,247.3h32l-6.9-247.3c-1.6,0.3-3.4,0.4-5.1,0.4C192.7,184.9,190.9,184.8,189.3,184.5z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M194.4,146c-13.8,0-25,9-25,20c0,9.6,8.5,17.7,19.9,19.6v-0.1h10.2v0.1c11.4-1.9,19.9-10,19.9-19.6   C219.4,154.9,208.2,146,194.4,146z"
  })), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", {
    id: "radio-waves-left",
    style: {
      visibility: radioWavesLeftShown ? "visible" : "hidden"
    }
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M159.9,115.4l4.5-5.4l-10.8-8.9l-4.5,5.4c-0.5,0.6-12,14.6-17.8,34.5c-8,27.1-1.6,52,18.3,71.9l4.9,4.9l9.8-9.9l-4.9-4.9   c-16.2-16.2-21.2-35.6-14.8-57.7C149.6,128.1,159.8,115.5,159.9,115.4z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M118.8,73.3l4.5-5.4l-10.7-9l-4.5,5.4c-0.9,1.1-22.8,27.6-34,65.4c-10.5,35.5-13,87.7,34.4,135.1l4.9,4.9l9.9-9.8l-4.9-5   c-34-34-44.4-74.7-31-120.8C97.6,99.1,118.4,73.8,118.8,73.3z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M14.1,159.9C15.9,76.3,81.2,15.6,81.9,15l3.1-3.1L75.1,2l-2.8,2.8C70.5,6.4,54,22,37,48C20.7,72.9,1.1,112.5,0,159.4   c-1.2,56,23.4,109.6,73.2,159.4l10-9.9C36.2,261.9,12.9,211.8,14.1,159.9z"
  })), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", {
    id: "radio-waves-right",
    style: {
      visibility: radioWavesRightShown ? "visible" : "hidden"
    }
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M387,157.4c-1.1-46.9-20.7-86.5-36.9-111.4c-17-26-33.6-41.6-35.3-43.2L312,0l-9.9,9.9l2.9,2.9l0.2,0.2   c0.7,0.6,66,61.3,67.8,144.9c1.2,51.9-22.1,102-69.1,149l9.9,9.9C363.7,267,388.3,213.4,387,157.4z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M304,128.8c-11.2-37.8-33-64.3-34-65.4l-10.7,9c0.2,0.2,20.9,25.3,31.3,60.4c13.7,46.3,3.3,87.1-30.9,121.2l9.9,9.9   C317,216.4,314.5,164.2,304,128.8z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M257.9,142.9C252,123,240.5,109,240,108.4l-4.5-5.4l-10.8,8.9l4.4,5.4c0.1,0.1,10.3,12.7,15.3,29.9   c6.3,22.1,1.3,41.5-14.8,57.7l-4.9,4.9l9.9,9.9l5-4.9C259.5,194.9,265.8,170,257.9,142.9z"
  })));
};
IconRadioAntenna.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  radioWavesLeftShown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  radioWavesRightShown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
IconRadioAntenna.defaultProps = {
  radioWavesLeftShown: true,
  radioWavesRightShown: true
};
var IconDisclosureArrowRight = function IconDisclosureArrowRight(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 364 1024"
  }, props, {
    "data-component-name": "IconDisclosureArrowRight"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M339.144 548.572q0 7.428-5.714 13.142l-266.286 266.286q-5.714 5.714-13.142 5.714t-13.142-5.714l-28.572-28.572q-5.714-5.714-5.714-13.142t5.714-13.142l224.572-224.572-224.572-224.572q-5.714-5.714-5.714-13.142t5.714-13.142l28.572-28.572q5.714-5.714 13.142-5.714t13.142 5.714l266.286 266.286q5.714 5.714 5.714 13.142z"
  }));
};
IconDisclosureArrowRight.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconDropDownArrow = function IconDropDownArrow(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconDropDownArrow"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M792.73 438.426c-20.838 21.402-240.384 230.554-240.384 230.554-11.162 11.416-25.754 17.1-40.346 17.1-14.644 0-29.236-5.684-40.346-17.1 0 0-219.546-209.152-240.436-230.554-20.838-21.402-22.272-59.852 0-82.74 22.324-22.836 53.402-24.628 80.692 0l200.09 191.898 200.038-191.846c27.34-24.628 58.47-22.836 80.692 0 22.322 22.834 20.94 61.338 0 82.688z"
  }));
};
IconDropDownArrow.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconThinChevronLeft = function IconThinChevronLeft(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconThinChevronLeft"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M737.228 891.802c13.722 13.876 13.722 36.25 0 50.124s-35.892 13.876-49.612 0l-400.896-404.838c-13.722-13.876-13.722-36.3 0-50.124l400.896-404.89c13.722-13.876 35.892-13.876 49.612 0s13.722 36.25 0 50.124l-365.568 379.802 365.568 379.802z"
  }));
};
IconThinChevronLeft.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconThinChevronRight = function IconThinChevronRight(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconUniE04D"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M286.704 891.802c-13.722 13.876-13.722 36.25 0 50.124s35.892 13.876 49.612 0l400.896-404.838c13.722-13.876 13.722-36.3 0-50.124l-400.896-404.89c-13.722-13.876-35.892-13.876-49.612 0s-13.722 36.25 0 50.124l365.568 379.802-365.568 379.802z"
  }));
};
IconThinChevronRight.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconThinChevronDown = function IconThinChevronDown(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconThinChevronDown"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M132.198 286.772c-13.876-13.722-36.3-13.722-50.124 0-13.824 13.67-13.824 35.892 0 49.612l404.89 400.896c13.876 13.722 36.25 13.722 50.124 0l404.89-400.896c13.824-13.722 13.876-35.892 0-49.612s-36.352-13.722-50.126-.052l-379.852 365.62-379.802-365.568z"
  }));
};
IconThinChevronDown.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconThinnerChevronDown = function IconThinnerChevronDown(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconThinnerChevronDown"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M49.2,16l-21,21c-0.2,0.2-0.5,0.3-0.7,0.3S27,37.2,26.8,37l-22-22"
  }));
};
IconThinnerChevronDown.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconThinnerChevronUp = function IconThinnerChevronUp(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconThinnerChevronUp"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M4.8,36.3l21-21c0.2-0.2,0.5-0.3,0.7-0.3s0.5,0.1,0.7,0.3l22,22"
  }));
};
IconThinnerChevronUp.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconThinArrowUp = function IconThinArrowUp(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconThinArrowUp"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    d: "M27,42V12.42M38.59,23.64,27.72,12.73,27,12.05l-.72.68L15.41,23.64"
  }));
};
IconThinArrowUp.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconThinArrowDown = function IconThinArrowDown(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconDropDownArrow"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    d: "M27,41.58V12.05M15.41,30.36,26.28,41.27,27,42l.72-.68L38.59,30.36"
  }));
};
IconThinArrowDown.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconPlay = function IconPlay(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 804 1024"
  }, props, {
    "data-component-name": "IconPlay"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M790.858 529.714l-758.858 421.714q-13.142 7.428-22.572 1.714t-9.428-20.572v-841.142q0-14.858 9.428-20.572t22.572 1.714l758.858 421.714q13.142 7.428 13.142 17.714t-13.142 17.714z"
  }));
};
IconPlay.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconPause = function IconPause(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 876 1024"
  }, props, {
    "data-component-name": "IconPause"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M877.714 109.714v804.572q0 14.858-10.858 25.714t-25.714 10.858h-292.572q-14.858 0-25.714-10.858t-10.858-25.714v-804.572q0-14.858 10.858-25.714t25.714-10.858h292.572q14.858 0 25.714 10.858t10.858 25.714zm-512 0v804.572q0 14.858-10.858 25.714t-25.714 10.858h-292.572q-14.858 0-25.714-10.858t-10.858-25.714v-804.572q0-14.858 10.858-25.714t25.714-10.858h292.572q14.858 0 25.714 10.858t10.858 25.714z"
  }));
};
IconPause.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconStop = function IconStop(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 876 1024"
  }, props, {
    "data-component-name": "IconStop"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M877.714 109.714v804.572q0 14.858-10.858 25.714t-25.714 10.858h-804.572q-14.858 0-25.714-10.858t-10.858-25.714v-804.572q0-14.858 10.858-25.714t25.714-10.858h804.572q14.858 0 25.714 10.858t10.858 25.714z"
  }));
};
IconStop.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconRewind = function IconRewind(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 950 1024"
  }, props, {
    "data-component-name": "IconRewind"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M925.142 80.572q10.858-10.858 18.286-7.428t7.428 18.286v841.142q0 14.858-7.428 18.286t-18.286-7.428l-405.714-405.714q-4.572-5.142-7.428-10.858v405.714q0 14.858-7.428 18.286t-18.286-7.428l-405.714-405.714q-10.858-10.858-10.858-25.714t10.858-25.714l405.714-405.714q10.858-10.858 18.286-7.428t7.428 18.286v405.714q2.858-6.286 7.428-10.858z"
  }));
};
IconRewind.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconFastForward = function IconFastForward(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 950 1024"
  }, props, {
    "data-component-name": "IconFastForward"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M25.714 943.428q-10.858 10.858-18.286 7.428t-7.428-18.286v-841.142q0-14.858 7.428-18.286t18.286 7.428l405.714 405.714q4.572 4.572 7.428 10.858v-405.714q0-14.858 7.428-18.286t18.286 7.428l405.714 405.714q10.858 10.858 10.858 25.714t-10.858 25.714l-405.714 405.714q-10.858 10.858-18.286 7.428t-7.428-18.286v-405.714q-2.858 5.714-7.428 10.858z"
  }));
};
IconFastForward.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconBatteryEmpty = function IconBatteryEmpty(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconBatteryEmpty"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M35,50.5H19a6,6,0,0,1-6-6v-32a6,6,0,0,1,6-6h2v-1a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v1h2a6,6,0,0,1,6,6v32A6,6,0,0,1,35,50.5Z"
  }));
};
IconBatteryEmpty.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconBatteryLow = function IconBatteryLow(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconBatteryLow"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M35,51.5H19a7,7,0,0,1-7-7v-32a7,7,0,0,1,7-7h1a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3h1a7,7,0,0,1,7,7v32A7,7,0,0,1,35,51.5ZM19,7.5a5,5,0,0,0-5,5v32a5,5,0,0,0,5,5H35a5,5,0,0,0,5-5v-32a5,5,0,0,0-5-5H33a1,1,0,0,1-1-1v-1a1,1,0,0,0-1-1H23a1,1,0,0,0-1,1v1a1,1,0,0,1-1,1ZM37.5,46.7H16.7a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1H37.5a1,1,0,0,1,1,1v9A1,1,0,0,1,37.5,46.7Z"
  }));
};
IconBatteryLow.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconBatteryMostlyFull = function IconBatteryMostlyFull(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconBatteryMostlyFull"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M35,51.5H19a7,7,0,0,1-7-7v-32a7,7,0,0,1,7-7h1a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3h1a7,7,0,0,1,7,7v32A7,7,0,0,1,35,51.5ZM19,7.5a5,5,0,0,0-5,5v32a5,5,0,0,0,5,5H35a5,5,0,0,0,5-5v-32a5,5,0,0,0-5-5H33a1,1,0,0,1-1-1v-1a1,1,0,0,0-1-1H23a1,1,0,0,0-1,1v1a1,1,0,0,1-1,1ZM37.5,46.7H16.7a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1H37.5a1,1,0,0,1,1,1v9A1,1,0,0,1,37.5,46.7Zm0-13H16.7a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1H37.5a1,1,0,0,1,1,1v9A1,1,0,0,1,37.5,33.7Z"
  }));
};
IconBatteryMostlyFull.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconBatteryFull = function IconBatteryFull(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconBatteryFull"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M35,51.5H19a7,7,0,0,1-7-7v-32a7,7,0,0,1,7-7h1a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3h1a7,7,0,0,1,7,7v32A7,7,0,0,1,35,51.5ZM19,7.5a5,5,0,0,0-5,5v32a5,5,0,0,0,5,5H35a5,5,0,0,0,5-5v-32a5,5,0,0,0-5-5H33a1,1,0,0,1-1-1v-1a1,1,0,0,0-1-1H23a1,1,0,0,0-1,1v1a1,1,0,0,1-1,1ZM37.5,46.7H16.7a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1H37.5a1,1,0,0,1,1,1v9A1,1,0,0,1,37.5,46.7Zm0-13H16.7a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1H37.5a1,1,0,0,1,1,1v9A1,1,0,0,1,37.5,33.7Zm0-13H16.7a1,1,0,0,1-1-1v-9a1,1,0,0,1,1-1H37.5a1,1,0,0,1,1,1v9A1,1,0,0,1,37.5,20.7Z"
  }));
};
IconBatteryFull.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconBell = function IconBell(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconBell"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M19,49a6,6,0,0,1-3.78-10.63l-.81-.78A34.28,34.28,0,0,1,7.2,27.65c-1.48-3.36-1.59-6.08-.34-8.08a1.69,1.69,0,0,1,.44-.7l.08-.09,0,0,.09-.1a5.85,5.85,0,0,1,3.29-1.46c2.59-.48,4.67-.94,6.34-1.41a13.87,13.87,0,0,0,4.15-1.71l0,0,4.6-4.59A11.78,11.78,0,0,1,39,7a5,5,0,0,1,9,3,4.94,4.94,0,0,1-2.52,4.31,11.75,11.75,0,0,1-2.93,11.77L38,30.65l0,0a13.62,13.62,0,0,0-1.74,4.17c-.46,1.67-.92,3.74-1.4,6.34a5.83,5.83,0,0,1-1.46,3.3l-.1.09-.09.1a1.84,1.84,0,0,1-.63.41c-1.94,1.27-4.58,1.22-7.85-.15A6,6,0,0,1,19,49ZM8.75,20.25a1.28,1.28,0,0,1-.13.29c-1.18,1.75-.43,4.4.41,6.31a32.39,32.39,0,0,0,6.8,9.32c.56.56,1.12,1.09,1.69,1.6a1,1,0,0,1,.32.88,1,1,0,0,1-.56.76,4,4,0,1,0,5.7,4,1,1,0,0,1,.51-.77,1,1,0,0,1,.93,0c.29.14.51.25.73.34,1.94.86,4.62,1.62,6.37.4a.75.75,0,0,1,.25-.13,1.37,1.37,0,0,1,.17-.17,4,4,0,0,0,.91-2.23c.48-2.66.95-4.79,1.44-6.52s1.37-4.12,2.21-5l0,0,4.6-4.6A9.77,9.77,0,0,0,43.3,14.15a1,1,0,0,1,0-.8,1,1,0,0,1,.59-.52A3,3,0,1,0,40.3,8.75a1,1,0,0,1-.59.52,1,1,0,0,1-.79-.07A9.83,9.83,0,0,0,34.24,8a9.71,9.71,0,0,0-6.91,2.85L23,15.2a1,1,0,0,1-.21.26.8.8,0,0,1-.21.15,16.12,16.12,0,0,1-4.89,2.1c-1.73.49-3.87,1-6.52,1.44A4,4,0,0,0,9,20,1.34,1.34,0,0,1,8.75,20.25ZM37.24,30h0ZM9,19.88A.54.54,0,0,1,9,20a.85.85,0,0,0,.1-.19ZM15.77,23a1,1,0,0,1-.23-2l.77-.17c1.08-.25,2.55-.59,3.91-1a13.38,13.38,0,0,0,3.43-1.37c.87-.8,3.28-3.26,4.58-4.58l.34-.35A7.74,7.74,0,0,1,34,11a1,1,0,0,1,1,1,1,1,0,0,1-1,1h0a5.73,5.73,0,0,0-4,2l-.35.35C28.25,16.78,25.91,19.16,25,20a13.73,13.73,0,0,1-4.22,1.82c-1.42.41-2.93.75-4,1L16,23A.91.91,0,0,1,15.77,23Zm28.46-8.25a1,1,0,0,1-.75-.34L38.65,9a1,1,0,0,1,1.49-1.33L45,13.11a1,1,0,0,1-.09,1.42A1,1,0,0,1,44.23,14.78ZM24,44.51a1,1,0,0,1-.57-.18l-7.13-5a1,1,0,0,1,1.15-1.64l7.13,5A1,1,0,0,1,24,44.51Z"
  }));
};
IconBell.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconBlindsClosed = function IconBlindsClosed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconBlindsClosed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M43.8,44.92H41.32V14.66h1.32V9H12.36v5.66h1.31V44.89H11.2V48H43.8v-3ZM15.25,44l1.45-3.16H38.27L39.67,44Zm0-5.19,1.48-3.21H38.3l1.47,3.21Zm0-5.19,1.48-3.16H38.3l1.47,3.16Zm0-5.21,1.48-3.16H38.3l1.47,3.16Zm0-5.16L16.73,20H38.3l1.47,3.22Zm0-4.8,1.74-4H38l1.73,4Z"
  }));
};
IconBlindsClosed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconBlindsHalfOpen = function IconBlindsHalfOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconBlindsHalfOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M43.3,43.4h-2.5V13.2h1.3V7.5H11.9v5.7h1.3v30.2h-2.5v3.1h32.6V43.4z M38.1,42.4H36l0,0H21.4l0,0h-5.5V29h22.2 V42.4z M14.8,26.9l1.5-3.2h21.6l1.5,3.2H14.8z M14.8,21.8l1.5-3.2h21.6l1.5,3.2L14.8,21.8z M14.8,17l1.7-4h21l1.7,4H14.8z"
  }));
};
IconBlindsHalfOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconBlindsMostlyClosed = function IconBlindsMostlyClosed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconBlindsMostlyClosed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M43.3,43.4h-2.5V13.2h1.3V7.5H11.9v5.7h1.3v30.2h-2.5v3.1h32.6V43.4z M38.1,42.4h-2.9l0,0H17.4l0,0h-1.5v-8.3 h22.2L38.1,42.4L38.1,42.4z M14.8,32.1l1.5-3.1h21.6l1.5,3.2L14.8,32.1z M14.8,26.9l1.5-3.2h21.6l1.5,3.2H14.8z M14.8,21.8l1.5-3.2 h21.6l1.5,3.2L14.8,21.8z M14.8,17l1.7-4h21l1.7,4H14.8z"
  }));
};
IconBlindsMostlyClosed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconBlindsMostlyOpen = function IconBlindsMostlyOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconBlindsMostlyOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M43.3,43.43H40.83V13.17h1.31V7.51H11.86v5.66h1.31V43.41H10.7v3.08H43.3V43.43Zm-5.19-1H32.66l0,0H18.84l0,0H15.89V23.76H38.11ZM14.75,21.76l1.48-3.21H37.8l1.47,3.21Zm0-4.79,1.74-4h21l1.74,4Z"
  }));
};
IconBlindsMostlyOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconBlindsOpen = function IconBlindsOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconBlindsOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M43.3,43.43H40.83V13.17h1.31V7.51H11.86v5.66h1.31V43.41H10.7v3.08H43.3V43.43Zm-5.19-1H35.3l0,0H18.49l0,0H15.89V12.91H38.11Z"
  }));
};
IconBlindsOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCalendarEmpty = function IconCalendarEmpty(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconCalendarEmpty"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M43.17,6H50a1.93,1.93,0,0,1,2,2V50a1.93,1.93,0,0,1-2,2H4a1.93,1.93,0,0,1-2-2V8A1.93,1.93,0,0,1,4,6h7M36.81,6H17.5M43,10V4a1.93,1.93,0,0,0-2-2H39a1.93,1.93,0,0,0-2,2v6a1.93,1.93,0,0,0,2,2h2A1.93,1.93,0,0,0,43,10ZM17,10V4a1.93,1.93,0,0,0-2-2H13a1.93,1.93,0,0,0-2,2v6a1.93,1.93,0,0,0,2,2h2A1.93,1.93,0,0,0,17,10ZM2,17a1,1,0,0,0,1,1H51a1,1,0,0,0,1-1"
  }));
};
IconCalendarEmpty.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCalendar = function IconCalendar(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconCalendar"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M43.17,6H50a1.93,1.93,0,0,1,2,2V50a1.93,1.93,0,0,1-2,2H4a1.93,1.93,0,0,1-2-2V8A1.93,1.93,0,0,1,4,6h7M36.81,6H17.5M43,10V4a1.93,1.93,0,0,0-2-2H39a1.93,1.93,0,0,0-2,2v6a1.93,1.93,0,0,0,2,2h2A1.93,1.93,0,0,0,43,10ZM17,10V4a1.93,1.93,0,0,0-2-2H13a1.93,1.93,0,0,0-2,2v6a1.93,1.93,0,0,0,2,2h2A1.93,1.93,0,0,0,17,10ZM2,17a1,1,0,0,0,1,1H51a1,1,0,0,0,1-1M46,45V24a1,1,0,0,0-1-1H9a1,1,0,0,0-1,1V45a1,1,0,0,0,1,1H45A1,1,0,0,0,46,45ZM8.25,31H45.83m-37,7.67,36.59.16M28,45.67V23M18,45.9V23.25M37,45.92V23.13"
  }));
};
IconCalendar.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCameraDisconnected = function IconCameraDisconnected(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconCameraDisconnected"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    d: "M37.2,13.1l6.7-2.9c0.7-0.3,1.6,0,2,0.7l5.4,11.4c0.3,0.7,0,1.6-0.7,2L19,39.3c-0.7,0.3-1.6,0-2-0.7l-5.4-11.4 c-0.3-0.7,0-1.6,0.7-2l6.6-3.2 M12.9,29.9l-8.6-0.3c-0.5,0-0.9,0.5-0.7,0.9l6.1,12.8c0.2,0.3,0.6,0.4,0.9,0.2 c0.1-0.1,0.1-0.1,0.2-0.2l5-7.3 M52.5,44h-12c-1.1,0-2-0.9-2-2v-8 M40.9,29.1c0.4,0.5,0.6,1.2,0.6,1.9c0,1.7-1.4,3-3.1,2.9 c-1.3,0-2.5-0.9-2.8-2.2 M19.8,21.7c-2.5-4.5-0.9-10.3,3.6-12.8S33.7,8,36.2,12.6s0.9,10.3-3.6,12.8c-1.4,0.8-3,1.2-4.5,1.2 C24.6,26.5,21.4,24.7,19.8,21.7 M27.6,10.1V20 M27.7,22c-0.3,0-0.6,0.2-0.7,0.5c0,0.3,0.2,0.6,0.5,0.7c0.1,0,0.1,0,0.2,0 c0.3,0,0.5-0.3,0.5-0.7C28.2,22.2,28,22,27.7,22z"
  }));
};
IconCameraDisconnected.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCamera = function IconCamera(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconCamera"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M16,38.6,10.6,27.2a1.63,1.63,0,0,1,.7-2l31.6-15a1.63,1.63,0,0,1,2,.7l5.4,11.4a1.63,1.63,0,0,1-.7,2L18,39.3A1.55,1.55,0,0,1,16,38.6Zm-4.1-8.7-8.6-.3c-.5,0-.9.5-.7.9L8.7,43.3a.65.65,0,0,0,1.1,0l5-7.3m36.7,8h-12a2,2,0,0,1-2-2V34m2.4-4.9a3.08,3.08,0,0,1,.6,1.9,3,3,0,0,1-3,3,3,3,0,0,1-2.9-2.3"
  }));
};
IconCamera.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSnapshot = function IconSnapshot(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1096 1024"
  }, props, {
    "data-component-name": "IconSnapshot"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M548 384.132q67.93 0 116.164 48.236t48.236 116.164-48.236 116.164-116.164 48.236-116.164-48.236-48.236-116.164 48.236-116.164 116.164-48.236zm401.868-237.466q60.508 0 103.32 42.814t42.814 103.32v511.468q0 60.508-42.814 103.32t-103.32 42.814h-803.734q-60.508 0-103.32-42.814t-42.814-103.32v-511.468q0-60.508 42.814-103.32t103.32-42.814h127.866l29.112-77.634q10.846-27.97 39.672-48.236t59.08-20.264h292.268q30.254 0 59.08 20.264t39.672 48.236l29.112 77.634h127.866zm-401.868 657.6q105.604 0 180.67-75.064t75.064-180.67-75.064-180.67-180.67-75.064-180.67 75.064-75.064 180.67 75.064 180.67 180.67 75.064z"
  }));
};
IconSnapshot.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCaretDown = function IconCaretDown(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 584 1024"
  }, props, {
    "data-component-name": "IconCaretDown"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M584.572 402.286q0 14.858-10.858 25.714l-256 256q-10.858 10.858-25.714 10.858t-25.714-10.858l-256-256q-10.858-10.858-10.858-25.714t10.858-25.714 25.714-10.858h512q14.858 0 25.714 10.858t10.858 25.714z"
  }));
};
IconCaretDown.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCaretUp = function IconCaretUp(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 584 1024"
  }, props, {
    "data-component-name": "IconCaretUp"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M584.572 694.858q0 14.858-10.858 25.714t-25.714 10.858h-512q-14.858 0-25.714-10.858t-10.858-25.714 10.858-25.714l256-256q10.858-10.858 25.714-10.858t25.714 10.858l256 256q10.858 10.858 10.858 25.714z"
  }));
};
IconCaretUp.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCasementWindowClosedLocked = function IconCasementWindowClosedLocked(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 809 1024"
  }, props, {
    "data-component-name": "IconCasementWindowClosedLocked"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M552.449 737.663c0 4.258-3.193 8.516-6.387 9.58v18.096c0 2.129-1.064 3.193-3.193 3.193s-3.193-1.064-3.193-3.193v-18.096h-2.129c-4.258-1.064-6.387-5.322-6.387-9.58 0-5.322 4.258-10.644 10.644-10.644 5.322 0 10.644 4.258 10.644 10.644zm-11.709-98.994c-17.031 0-30.869 13.838-30.869 30.869v23.418h61.738v-23.418c0-17.031-13.838-30.869-30.869-30.869zm131.992 84.092c0 72.383-59.609 131.992-131.992 131.992-45.771 0-86.22-23.418-109.638-59.609h-255.468c-7.451 0-12.773-5.322-12.773-12.773v-630.154c0-7.451 5.322-12.773 12.773-12.773h383.202c7.451 0 12.773 5.322 12.773 12.773v442.811c57.48 13.838 101.123 65.996 101.123 127.734zm-255.468 46.836c-4.258-10.644-7.451-22.353-8.516-34.062h-203.31v-535.418h323.593v391.717l11.709-1.064h5.322v-425.78h-357.655v604.607h228.857zm86.22-173.506v-370.428h-272.499v484.324h178.827c5.322-54.287 43.642-98.994 93.672-113.896zm108.574 117.09c0-11.709-9.58-20.225-20.225-20.225v-24.482c0-28.74-23.418-51.094-51.094-51.094-28.74 0-51.094 23.418-51.094 51.094v24.482c-11.709 0-20.225 9.58-20.225 20.225v68.125c0 11.709 9.58 20.225 20.225 20.225h102.187c11.709 0 20.225-9.58 20.225-20.225v-68.125z"
  }));
};
IconCasementWindowClosedLocked.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCasementWindowClosedUnlocked = function IconCasementWindowClosedUnlocked(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 809 1024"
  }, props, {
    "data-component-name": "IconCasementWindowClosedUnlocked"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M205.439 200.116h323.593v391.717c-8.516 1.064-17.031 2.129-25.547 5.322v-371.493h-272.499v484.324h178.827l-1.064 12.773s0 8.516 1.064 12.773h-204.374v-535.418zm211.825 569.481h-228.857v-604.607h357.655v425.78c8.516 0 17.031 1.064 25.547 3.193v-454.52h-408.748v655.701h268.241c-5.322-7.451-9.58-17.031-13.838-25.547zm151.152-15.967c0 3.193-2.129 6.387-5.322 7.451v13.838c0 1.064-1.064 2.129-2.129 2.129s-2.129-1.064-2.129-2.129v-13.838c-3.193-1.064-5.322-4.258-5.322-7.451 0-4.258 3.193-7.451 7.451-7.451s7.451 3.193 7.451 7.451zm102.187-26.611c0 70.254-56.416 126.669-126.669 126.669s-126.669-56.416-126.669-126.669c0-70.254 56.416-126.669 126.669-126.669s126.669 56.416 126.669 126.669zm-55.351 8.515c0-8.516-7.451-15.967-15.967-15.967h-61.738v-38.32c0-21.289-17.031-38.32-38.32-38.32s-38.32 17.031-38.32 38.32v20.225c0 4.258 3.193 7.451 7.451 7.451s7.451-3.193 7.451-7.451v-20.225c0-12.773 10.644-23.418 23.418-23.418s23.418 10.644 23.418 23.418c0 0 0 39.385-1.064 38.32-8.516 0-14.902 7.451-14.902 15.967v51.094c0 8.516 7.451 15.967 15.967 15.967h76.64c8.516 0 15.967-7.451 15.967-15.967v-51.094z"
  }));
};
IconCasementWindowClosedUnlocked.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCasementWindowClosed = function IconCasementWindowClosed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 638 1024"
  }, props, {
    "data-component-name": "IconCasementWindowClosed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M571.844 930.909h-505.351v-836.156h505.351zm-465.454-39.896h425.558v-756.364h-425.558zm512 132.987h-598.442l-.677.012c-10.65 0-19.283-8.633-19.283-19.283l.013-.711-.001-984.07-.012-.677c0-10.65 8.633-19.283 19.283-19.283l.711.013 598.407-.001.677-.012c10.65 0 19.283 8.633 19.283 19.283l-.013.711.001 984.07.012.677c0 10.65-8.633 19.283-19.283 19.283l-.711-.013zm-578.494-39.896h558.545v-944.208h-558.545z"
  }));
};
IconCasementWindowClosed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCasementWindowOpen = function IconCasementWindowOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 548 1024"
  }, props, {
    "data-component-name": "IconCasementWindowOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M531.28 952.591h-514.142c-9.997 0-17.138-7.141-17.138-17.138v-845.478c0-9.997 7.141-17.138 17.138-17.138h514.142c9.997 0 17.138 7.141 17.138 17.138v845.478c0 9.997-8.569 17.138-17.138 17.138zm-497.004-34.276h479.866v-811.202h-479.866v811.202zm378.466 105.685l-355.615-157.099v-705.517l355.615-161.384v1024zm-321.339-178.522l287.063 125.679v-918.315l-287.063 129.964v662.672z"
  }));
};
IconCasementWindowOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCasementWindowUnknown = function IconCasementWindowUnknown(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 730 1024"
  }, props, {
    "data-component-name": "IconCasementWindowUnknown"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M353.524 815.238l-1.524 19.81s0 10.667 1.524 16.762h-274.286c-10.667 0-18.286-7.619-18.286-18.286v-729.905c0-10.667 7.619-18.286 18.286-18.286h426.667c10.667 0 18.286 7.619 18.286 18.286v544c-12.19 1.524-24.381 3.048-36.571 7.619v-533.333h-390.095v693.333h256zm10.666 86.857h-327.619v-865.524h512v609.524c12.19 0 24.381 1.524 36.571 4.571v-632.381c0-10.667-7.619-18.286-18.286-18.286h-548.571c-10.667 0-18.286 7.619-18.286 18.286v902.095c0 10.667 7.619 18.286 18.286 18.286h364.19c-7.619-12.19-13.714-24.381-18.286-36.571zm176.762-248.381c-100.571 0-181.333 80.762-181.333 181.333s80.762 181.333 181.333 181.333 181.333-80.762 181.333-181.333-80.762-181.333-181.333-181.333zm18.286 274.286h-30.476v-121.905h30.476v121.905zm0-152.381h-30.476v-30.476h30.476v30.476z"
  }));
};
IconCasementWindowUnknown.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var rotateAnimationId = "nx-components_Icons_rotate";
__WEBPACK_IMPORTED_MODULE_5__GlobalStyleSheet__["a" /* default */].preload(rotateAnimationId, "\n    @keyframes ".concat(rotateAnimationId, " {\n      0% { transform: rotate(360deg); }\n      50% { transform: rotate(180deg); }\n      100% { transform: rotate(0deg); }\n    }\n  "));
var IconChat = function IconChat(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconChat"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M9,6a5,5,0,0,0-5,5V35a5,5,0,0,0,5,5h4.09a7.84,7.84,0,0,1-.18,3.25,5.18,5.18,0,0,1-2.41,2.91A1,1,0,0,0,11,48a12.39,12.39,0,0,0,11.56-8H45a5,5,0,0,0,5-5V11a5,5,0,0,0-5-5Zm8,14a3,3,0,1,0,3,3A3,3,0,0,0,17,20Zm10,0a3,3,0,1,0,3,3A3,3,0,0,0,27,20Zm10,0a3,3,0,1,0,3,3A3,3,0,0,0,37,20Z"
  }));
};
IconChat.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCheckSign = function IconCheckSign(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 878 1024"
  }, props, {
    "data-component-name": "IconCheckSign"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M391.429 742.286l350.857-350.857q10.857-10.857 10.857-25.714t-10.857-25.714l-58.286-58.286q-10.857-10.857-25.714-10.857t-25.714 10.857l-266.857 266.857-120.571-120.571q-10.857-10.857-25.714-10.857t-25.714 10.857l-58.286 58.286q-10.857 10.857-10.857 25.714t10.857 25.714l204.571 204.571q10.857 10.857 25.714 10.857t25.714-10.857zm486.285-504.572v548.571q0 68-48.286 116.286t-116.286 48.286h-548.571q-68 0-116.286-48.286t-48.286-116.286v-548.571q0-68 48.286-116.286t116.286-48.286h548.571q68 0 116.286 48.286t48.286 116.286z"
  }));
};
IconCheckSign.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCheckmark = function IconCheckmark(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconCheckmark"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M864 128l-480 480-224-224-160 160 384 384 640-640z"
  }));
};
IconCheckmark.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconChevronDown = function IconChevronDown(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 950 1024"
  }, props, {
    "data-component-name": "IconChevronDown"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M920.144 402.286q0 30.286-21.142 51.428l-372 372q-21.714 21.714-52 21.714-30.858 0-51.428-21.714l-372-372q-21.714-20.572-21.714-51.428 0-30.286 21.714-52l42.286-42.858q22.286-21.142 52-21.142 30.286 0 51.428 21.142l277.714 277.714 277.714-277.714q21.142-21.142 51.428-21.142 29.714 0 52 21.142l42.858 42.858q21.142 22.286 21.142 52z"
  }));
};
IconChevronDown.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconChevronLeft = function IconChevronLeft(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 658 1024"
  }, props, {
    "data-component-name": "IconChevronLeft"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M423.858 898.858l-372.572-372q-21.142-21.142-21.142-51.714t21.142-51.714l372.572-372q21.142-21.142 51.714-21.142t51.714 21.142l42.858 42.858q21.142 21.142 21.142 51.714t-21.142 51.714l-277.714 277.714 277.714 277.142q21.142 21.714 21.142 52t-21.142 51.428l-42.858 42.858q-21.142 21.142-51.714 21.142t-51.714-21.142z"
  }));
};
IconChevronLeft.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconChevronRight = function IconChevronRight(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 658 1024"
  }, props, {
    "data-component-name": "IconChevronRight"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M627.856 475.428q0 29.714-21.142 52l-372.572 372q-21.142 21.142-51.428 21.142t-51.428-21.142l-43.428-42.858q-21.142-22.286-21.142-52 0-30.286 21.142-51.428l277.714-277.714-277.714-277.142q-21.142-22.286-21.142-52 0-30.286 21.142-51.428l43.428-42.858q20.572-21.714 51.428-21.714t51.428 21.714l372.572 372q21.142 21.142 21.142 51.428z"
  }));
};
IconChevronRight.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconChevronUp = function IconChevronUp(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 950 1024"
  }, props, {
    "data-component-name": "IconChevronUp"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M920.144 694.858q0 30.286-21.142 51.428l-42.858 42.858q-21.714 21.714-52 21.714-30.858 0-51.428-21.714l-277.714-277.142-277.714 277.142q-20.572 21.714-51.428 21.714t-51.428-21.714l-42.858-42.858q-21.714-20.572-21.714-51.428 0-30.286 21.714-52l372-372q21.142-21.142 51.428-21.142 29.714 0 52 21.142l371.428 372q21.714 21.714 21.714 52z"
  }));
};
IconChevronUp.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCircle = function IconCircle(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 878 1024"
  }, props, {
    "data-component-name": "IconCircle"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M877.714 512q0 119.429-58.857 220.286t-159.714 159.714-220.286 58.857-220.286-58.857-159.714-159.714-58.857-220.286 58.857-220.286 159.714-159.714 220.286-58.857 220.286 58.857 159.714 159.714 58.857 220.286z"
  }));
};
IconCircle.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};

var gradientHash = function gradientHash(colorTop, colorBottom) {
  return "".concat(colorTop).concat(colorBottom).replace(/[^a-z0-9]/gi, "");
};

var IconCircleGradient = function IconCircleGradient(_ref3) {
  var colorTop = _ref3.colorTop,
      colorBottom = _ref3.colorBottom,
      props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ["colorTop", "colorBottom"]);

  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 100 100"
  }, props, {
    "data-component-name": "IconCircleGradient"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("defs", null, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("linearGradient", {
    id: "gradient-".concat(gradientHash(colorTop, colorBottom)),
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("stop", {
    offset: "0%",
    stopColor: colorTop
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("stop", {
    offset: "100%",
    stopColor: colorBottom
  }))), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("circle", {
    cx: "50",
    cy: "50",
    r: "47",
    stroke: "url(#gradient-".concat(gradientHash(colorTop, colorBottom), ")"),
    strokeWidth: "3",
    fill: "none"
  }));
};
IconCircleGradient.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  colorTop: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  colorBottom: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired
};
var IconClimate = function IconClimate(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconClimate"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    d: "M18,29.84V5H10v24.8A10,10,0,1,0,24,39,10.15,10.15,0,0,0,18,29.84ZM14,16V34m0,0a5,5,0,1,1-5,5A5,5,0,0,1,14,34ZM18,9h4m-4,4h3m-3,4h4m-4,4h3m-3,4h4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    d: "M43.12,29.84V5h-8v24.8a10,10,0,1,0,14,9.2A10.13,10.13,0,0,0,43.12,29.84ZM39.12,16V34m0,0a5,5,0,1,1-5,5A5,5,0,0,1,39.12,34Zm4-25h4m-4,4h3m-3,4h4m-4,4h3m-3,4h4"
  }));
};
IconClimate.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconClock = function IconClock(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconClock"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    d: "M27,4C14.3,4,4,14.3,4,27s10.3,23,23,23s23-10.3,23-23S39.7,4,27,4z M27,9c-0.6,0-1,0.4-1,1v14.2 c-1.6,0.6-2.4,2.3-1.8,3.8c0,0.1,0.1,0.2,0.1,0.3l-6,6c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l0,0l6-6c1.5,0.6,3.3-0.1,3.9-1.6 s-0.1-3.3-1.6-3.9V10C28,9.4,27.6,9,27,9z"
  }));
};
IconClock.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconClose = function IconClose(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconClose"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M1014.662 822.66l-.012-.01-310.644-310.65 310.644-310.65.012-.01c3.344-3.346 5.762-7.254 7.312-11.416 4.246-11.376 1.824-24.682-7.324-33.83l-146.746-146.746c-9.148-9.146-22.45-11.566-33.828-7.32-4.16 1.55-8.07 3.968-11.418 7.31l-.008.01-310.648 310.652-310.648-310.65-.01-.01c-3.346-3.342-7.254-5.76-11.414-7.31-11.38-4.248-24.682-1.826-33.83 7.32l-146.748 146.748c-9.148 9.148-11.568 22.452-7.322 33.828 1.552 4.16 3.97 8.072 7.312 11.416l.01.01 310.65 310.648-310.65 310.652-.008.01c-3.342 3.346-5.76 7.254-7.314 11.414-4.248 11.376-1.826 24.682 7.322 33.83l146.748 146.746c9.15 9.148 22.452 11.568 33.83 7.322 4.16-1.552 8.07-3.97 11.416-7.312l.01-.01 310.648-310.65 310.648 310.65.012.008c3.348 3.344 7.254 5.762 11.414 7.314 11.378 4.246 24.684 1.826 33.828-7.322l146.746-146.748c9.148-9.148 11.57-22.454 7.324-33.83-1.552-4.16-3.97-8.068-7.314-11.414z"
  }));
};
IconClose.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCloudOff = function IconCloudOff(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconCloudOff"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M43.2,41.29a8.48,8.48,0,0,0,.3-16.88c0-.18,0-.36,0-.53A12.52,12.52,0,0,0,19.92,18M6,6.79,16.48,17.26h-.06l4.15,4.15v0L38.63,39.42h-.05l1.91,1.91h0L47.2,48M14,17.56A6.68,6.68,0,0,0,9.4,23.45a9.22,9.22,0,0,0,3.15,17.88H37.79"
  }));
};
IconCloudOff.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCreateGroup = function IconCreateGroup(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconCreateGroup"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M910.288 900.407h-677.12c-43.993 0-79.658-35.664-79.658-79.658v-736.909c0-43.994 35.665-79.658 79.658-79.658h677.12c43.994 0 79.658 35.664 79.658 79.658v736.909c0 43.994-35.664 79.658-79.658 79.658zm-154.025-471.099c0-6.841-2.494-12.909-7.468-18.203-4.982-4.668-11.049-7.154-18.204-7.468l-110.618.467v-111.552c0-6.841-2.494-12.908-7.468-18.203-4.982-4.667-11.049-7.154-18.204-7.468l-51.341.467c-7.162-.307-13.229 2.181-18.203 7.468-4.982 4.667-7.469 10.735-7.469 18.203v110.619l-110.618.467c-7.162-.307-13.229 2.181-18.203 7.468-4.982 4.667-7.469 10.735-7.469 18.203v50.408c0 7.468 2.487 13.536 7.469 18.203 4.974 5.295 11.041 7.782 18.203 7.468l110.618.467v110.618c0 7.468 2.487 13.535 7.469 18.203 4.974 5.294 11.041 7.782 18.203 7.468l51.341.467c7.154-.307 13.222-2.801 18.204-7.468 4.974-5.287 7.468-11.355 7.468-18.204v-111.552l110.618.467c7.154-.307 13.222-2.801 18.204-7.468 4.974-5.287 7.468-11.355 7.468-18.203v-51.342zm-590.786 538.676h677.12c8.418 0 16.521-1.325 24.138-3.746-10.209 32.221-40.336 55.579-75.934 55.579h-677.09c-43.994 0-79.658-35.664-79.658-79.658v-736.833c0-35.585 23.343-65.701 55.544-75.921-2.439 7.643-3.779 15.775-3.779 24.226v736.695c.002 43.995 35.665 79.658 79.659 79.658z"
  }));
};
IconCreateGroup.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconDoorOpen = function IconDoorOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconDoorOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M28.78,1.5l-.09,0-16,5a1,1,0,0,0-.69,1v40a1,1,0,0,0,.75,1l16,4a1,1,0,0,0,1.25-1V2.5a1,1,0,0,0-.34-.75,1,1,0,0,0-.78-.25ZM32,48.5h9a1,1,0,0,0,1-1V6.5a1,1,0,0,0-1-1H32m-6,20c-.55,0-1,.68-1,1.5s.45,1.5,1,1.5,1-.67,1-1.5S26.55,25.5,26,25.5Z"
  }));
};
IconDoorOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconDoor = function IconDoor(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconDoor"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M12.91,4A1,1,0,0,0,12,5V49a1,1,0,0,0,1,1H41a1,1,0,0,0,1-1V4.91A1,1,0,0,0,41,4H12.91ZM36.5,26A1.5,1.5,0,1,0,38,27.5,1.5,1.5,0,0,0,36.5,26Z"
  }));
};
IconDoor.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconDoorbellTriggered = function IconDoorbellTriggered(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconDoorbellTriggered"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M35.05,29.29a2.11,2.11,0,1,0-2.11-2.1A2.11,2.11,0,0,0,35.05,29.29Zm0-2.52a.42.42,0,1,1-.42.42A.42.42,0,0,1,35.05,26.77Zm5.48,9V8.08a1.66,1.66,0,0,0-1.67-1.53H15.1a1.67,1.67,0,0,0-1.53,1.68V45.3A1.69,1.69,0,0,0,15.25,47H33.13a7,7,0,0,0,5.54,2.69v0a7.07,7.07,0,0,0,1.86-13.9ZM38.67,48a5.4,5.4,0,0,1-5.39-5.39H31.6a7.09,7.09,0,0,0,.53,2.69H15.25V8.23H38.84v27.3h-.17a7.08,7.08,0,0,0-7.07,7.07h1.68a5.4,5.4,0,0,1,5.39-5.39h.27A5.39,5.39,0,0,1,38.67,48Zm3.7-4.72A1.81,1.81,0,0,0,42,43a1.56,1.56,0,0,1-.21-.18,2.18,2.18,0,0,1-.34-1.43,2.57,2.57,0,0,0-1.34-2.32,1.34,1.34,0,0,0-2.62,0,2.57,2.57,0,0,0-1.34,2.32,2.18,2.18,0,0,1-.34,1.43,1.48,1.48,0,0,1-.26.21,1.88,1.88,0,0,0-.29.26A1.11,1.11,0,0,0,35,44a1.35,1.35,0,0,0,.64,1.12,2.62,2.62,0,0,0,.93.35,5.1,5.1,0,0,0,.65.09,1.63,1.63,0,0,0,1.58,1.23,1.65,1.65,0,0,0,1.59-1.23,5.19,5.19,0,0,0,.64-.09,2.44,2.44,0,0,0,.93-.35A1.34,1.34,0,0,0,42.65,44,1.09,1.09,0,0,0,42.37,43.28Zm-1.57.85a6.38,6.38,0,0,1-1.07.12l-.82.1.2.81a.27.27,0,1,1-.53-.07l.2-.8-.83,0a6.11,6.11,0,0,1-1.06-.12L36.52,44a2.33,2.33,0,0,0,.34-.31,3.34,3.34,0,0,0,.7-2.34,1.21,1.21,0,0,1,.84-1.22l.43-.14.45.14a1.22,1.22,0,0,1,.85,1.22,3.29,3.29,0,0,0,.7,2.34,2.16,2.16,0,0,0,.32.3A1.68,1.68,0,0,1,40.8,44.13ZM43,17.77a1,1,0,0,1-.7-.28,1,1,0,0,1,0-1.42l5.2-5.3a1,1,0,1,1,1.42,1.41l-5.2,5.3A1,1,0,0,1,43,17.77Zm9.9,8.61H45.5a1,1,0,0,1,0-2h7.4a1,1,0,0,1,0,2Zm-3.7,12.5a1,1,0,0,1-.71-.3l-5.3-5.3a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0l5.3,5.3a1,1,0,0,1-.71,1.71Zm-38.3-21a1,1,0,0,1-.71-.3L5,12.3a1,1,0,0,1,1.42-1.4l5.2,5.3a1,1,0,0,1-.71,1.7ZM8.4,26.5H1a1,1,0,0,1,0-2H8.4a1,1,0,0,1,0,2ZM4.7,39A1,1,0,0,1,4,38.71a1,1,0,0,1,0-1.42L9.29,32a1,1,0,1,1,1.42,1.42l-5.3,5.3A1,1,0,0,1,4.7,39Z"
  }));
};
IconDoorbellTriggered.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconDoorbellWaiting = function IconDoorbellWaiting(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconDoorbellWaiting"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M33.4,28.4a2.5,2.5,0,1,0-2.5-2.5A2.5,2.5,0,0,0,33.4,28.4Zm0-3a.5.5,0,1,1-.5.5A.5.5,0,0,1,33.4,25.4Zm6.5,10.7V3.22a2,2,0,0,0-2-1.82H9.72a2,2,0,0,0-1.82,2v44a2,2,0,0,0,2,2H31.12a8.36,8.36,0,0,0,6.58,3.2v0a8.4,8.4,0,0,0,2.2-16.5ZM37.7,50.6a6.41,6.41,0,0,1-6.4-6.4h-2a8.34,8.34,0,0,0,.64,3.2H9.9V3.4h28V35.8h-.2v0a8.41,8.41,0,0,0-8.4,8.4h2a6.41,6.41,0,0,1,6.4-6.4v0H38A6.4,6.4,0,0,1,37.7,50.6ZM42.09,45a2.16,2.16,0,0,0-.39-.34c-.07-.06-.16-.12-.25-.21A2.6,2.6,0,0,1,41,42.76,3.07,3.07,0,0,0,39.46,40a1.6,1.6,0,0,0-3.12,0,3.06,3.06,0,0,0-1.58,2.76,2.58,2.58,0,0,1-.41,1.69,1.89,1.89,0,0,1-.3.25,2.08,2.08,0,0,0-.35.31,1.28,1.28,0,0,0-.32.84,1.6,1.6,0,0,0,.76,1.33,3.18,3.18,0,0,0,1.11.42c.22,0,.48.08.77.11a1.94,1.94,0,0,0,3.76,0c.29,0,.54-.07.77-.11a3.25,3.25,0,0,0,1.1-.41,1.61,1.61,0,0,0,.77-1.34A1.29,1.29,0,0,0,42.09,45Zm-1.87,1a8.24,8.24,0,0,1-1.26.14l-1,.12.24,1a.32.32,0,1,1-.63-.08l.23-.95-1-.05A8.24,8.24,0,0,1,35.58,46a2.4,2.4,0,0,1-.43-.11,3.24,3.24,0,0,0,1.23-3.14,1.45,1.45,0,0,1,1-1.45l.51-.17.55.17a1.45,1.45,0,0,1,1,1.45,3.16,3.16,0,0,0,1.23,3.13A1.73,1.73,0,0,1,40.22,46Z"
  }));
};
IconDoorbellWaiting.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconDoubleHungWindowClosedLocked = function IconDoubleHungWindowClosedLocked(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 629 1024"
  }, props, {
    "data-component-name": "IconDoubleHungWindowClosedLocked"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M263.022 817.157v-137.895h145.556v40.858c10.214-5.107 21.706-7.661 33.197-10.214v-624.359h-390.703v764.808h263.022c1.277-11.491 3.83-22.983 6.384-33.197h-57.456zm0-698.414h145.556v157.047h-145.556v-157.047zm0 190.245h145.556v148.11h-145.556v-148.11zm0 196.628h145.556v140.449h-145.556v-140.449zm-33.197 311.541h-145.556v-137.895h145.556v137.895zm0-171.092h-145.556v-140.449h145.556v140.449zm0-188.968h-145.556v-148.11h145.556v148.11zm0-181.306h-145.556v-157.047h145.556v157.047zm99.591 661.386h-312.818c-8.938 0-16.599-7.661-16.599-16.599v-903.98c0-8.938 7.661-16.599 16.599-16.599h459.651c8.938 0 16.599 7.661 16.599 16.599v692.03c-7.661-1.277-14.045-1.277-21.706-1.277h-11.491v-674.155h-426.454v870.783h284.728c2.554 11.491 6.384 22.983 11.491 33.197zm141.726-223.441c84.269 0 151.94 67.671 151.94 151.94s-67.671 151.94-151.94 151.94-151.94-67.671-151.94-151.94 67.671-151.94 151.94-151.94zm-8.938 177.476c-3.83-1.277-7.661-5.107-7.661-10.214 0-6.384 5.107-11.491 11.491-11.491s11.491 5.107 11.491 11.491c0 5.107-2.554 8.938-7.661 10.214v19.152c0 2.554-1.277 3.83-3.83 3.83s-3.83-1.277-3.83-3.83v-19.152zm-52.349-60.01c-12.768 0-22.983 10.214-22.983 22.983v75.332c0 12.768 10.214 22.983 22.983 22.983h113.636c12.768 0 22.983-10.214 22.983-22.983v-75.332c0-12.768-10.214-22.983-22.983-22.983v-26.813c0-30.643-25.536-56.18-56.18-56.18s-56.18 25.536-56.18 56.18c-1.277 8.938-1.277 17.875-1.277 26.813zm22.983 0v-26.813c0-19.152 15.322-34.474 34.474-34.474s34.474 15.322 34.474 34.474v26.813h-68.948z"
  }));
};
IconDoubleHungWindowClosedLocked.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconDoubleHungWindowClosedUnlocked = function IconDoubleHungWindowClosedUnlocked(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 629 1024"
  }, props, {
    "data-component-name": "IconDoubleHungWindowClosedUnlocked"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M263.022 817.157v-137.895h145.556v40.858c10.214-5.107 21.706-7.661 33.197-10.214v-624.359h-390.703v764.808h263.022c1.277-11.491 3.83-22.983 6.384-33.197h-57.456zm0-698.414h145.556v157.047h-145.556v-157.047zm0 190.245h145.556v148.11h-145.556v-148.11zm0 196.628h145.556v140.449h-145.556v-140.449zm-33.197 311.541h-145.556v-137.895h145.556v137.895zm0-171.092h-145.556v-140.449h145.556v140.449zm0-188.968h-145.556v-148.11h145.556v148.11zm0-181.306h-145.556v-157.047h145.556v157.047zm100.868 661.386h-314.095c-8.938 0-16.599-7.661-16.599-16.599v-903.98c0-8.938 7.661-16.599 16.599-16.599h459.651c8.938 0 16.599 7.661 16.599 16.599v692.03c-7.661-1.277-14.045-1.277-21.706-1.277h-11.491v-674.155h-426.454v870.783h284.728c2.554 11.491 6.384 22.983 12.768 33.197zm177.477-43.411c0 3.83-2.554 7.661-6.384 8.938v16.599c0 1.277-1.277 2.554-2.554 2.554s-2.554-1.277-2.554-2.554v-16.599c-3.83-2.554-6.384-5.107-8.938-8.938 0-5.107 5.107-10.214 10.214-10.214s10.214 5.107 10.214 10.214zm114.912-28.09c0 84.269-67.671 151.94-151.94 151.94s-151.94-67.671-151.94-151.94c0-84.269 67.671-151.94 151.94-151.94s151.94 67.671 151.94 151.94zm-54.902 5.107c0-10.214-8.938-19.152-19.152-19.152h-76.608v-48.519c0-26.813-21.706-47.242-48.519-47.242h-1.277c-25.536 0-47.242 21.706-47.242 47.242v25.536c0 5.107 5.107 10.214 10.214 10.214s10.214-5.107 10.214-10.214v-25.536c0-15.322 12.768-28.09 28.09-28.09s28.09 12.768 28.09 28.09c0 0 0 48.519 1.277 48.519-10.214 0-19.152 8.938-19.152 19.152v63.84c0 10.214 8.938 19.152 19.152 19.152h95.761c10.214 0 19.152-8.938 19.152-19.152v-63.84z"
  }));
};
IconDoubleHungWindowClosedUnlocked.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconDoubleHungWindowClosed = function IconDoubleHungWindowClosed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 539 1024"
  }, props, {
    "data-component-name": "IconDoubleHungWindowClosed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M520.371 1024h-502.234c-10.016 0-18.136-8.12-18.136-18.136v-987.728c0-10.016 8.12-18.136 18.136-18.136h502.234c10.016 0 18.136 8.12 18.136 18.136v987.728c0 10.016-8.12 18.136-18.136 18.136zm-484.099-36.272h465.962v-951.455h-465.962zm446.431-58.594h-426.899v-835.662h426.899zm-390.627-36.273h354.354v-763.117h-354.354zm195.314 18.136h-36.272v-799.39h36.272zm177.177-573.384h-390.627v-36.272h390.627zm0 404.578h-390.627v-36.272h390.627zm0-190.152h-390.627v-52.037h390.627z"
  }));
};
IconDoubleHungWindowClosed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconDoubleHungWindowOpen = function IconDoubleHungWindowOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 738 1024"
  }, props, {
    "data-component-name": "IconDoubleHungWindowOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M564.148 856.889h-362.667v-709.926h362.667v709.926zm-331.852-30.815h301.037v-648.296h-301.037v648.296zm363.852 111.407h-426.667c-8.296 0-15.407-7.111-15.407-15.407v-839.111c0-8.296 7.111-15.407 15.407-15.407h426.667c8.296 0 15.407 7.111 15.407 15.407v839.111c0 8.296-7.111 15.407-15.407 15.407zm-411.259-30.814h395.852v-808.296h-395.852v808.296zm209.778-303.408h-24.889v-440.889h24.889v440.889zm154.074-248.889h-331.852v-30.815h331.852v30.815zm0 106.667h-331.852v-30.815h331.852v30.815zm0 165.926h-331.852v-30.815h331.852v30.815z"
  }));
};
IconDoubleHungWindowOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconDoubleHungWindowUnknown = function IconDoubleHungWindowUnknown(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 629 1024"
  }, props, {
    "data-component-name": "IconDoubleHungWindowUnknown"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M331.97 937.177h-315.372c-8.938 0-16.599-7.661-16.599-16.599v-903.98c0-8.938 7.661-16.599 16.599-16.599h459.651c8.938 0 16.599 7.661 16.599 16.599v693.307c-7.661-1.277-16.599-2.554-24.259-2.554h-8.938v-674.155h-426.454v870.783h286.005c2.554 11.491 7.661 22.983 12.768 33.197zm-12.768-120.02c-3.83 10.214-5.107 21.706-6.384 33.197h-261.746v-764.808h390.703v624.359c-11.491 2.554-22.983 5.107-33.197 8.938v-39.581h-145.556v137.895h56.18zm89.377-171.092v-140.449h-145.556v140.449h145.556zm-178.754-337.077h-145.556v148.11h145.556v-148.11zm33.197 148.109h145.556v-148.11h-145.556v148.11zm-178.753 48.519v140.449h145.556v-140.449h-145.556zm324.31-386.873h-145.556v157.047h145.556v-157.047zm-324.31 0v157.047h145.556v-157.047h-145.556zm0 698.414h145.556v-137.895h-145.556v137.895zm386.873-97.037c-80.439 0-145.556 65.117-145.556 145.556s65.117 145.556 145.556 145.556c80.439 0 145.556-65.117 145.556-145.556s-65.117-145.556-145.556-145.556zm14.045 228.548h-25.536v-102.145h25.536v102.145zm0-127.68h-25.536v-25.536h25.536v25.536z"
  }));
};
IconDoubleHungWindowUnknown.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconDroplets = function IconDroplets(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconDroplets"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M10,1.84,9.19,2.91A61.84,61.84,0,0,0,5.62,8.28C3.84,11.31,2,15,2,18a8,8,0,0,0,16,0c0-3.05-1.84-6.69-3.62-9.72a61.84,61.84,0,0,0-3.57-5.37Zm34,9.1L43.22,12a59.94,59.94,0,0,0-3.6,5.34C37.84,20.35,36,24,36,27a8,8,0,0,0,16,0c0-3.05-1.84-6.65-3.62-9.66A59.94,59.94,0,0,0,44.78,12ZM24,27.84l-.81,1.07a61.84,61.84,0,0,0-3.57,5.37C17.84,37.31,16,41,16,44a8,8,0,0,0,16,0c0-3-1.84-6.69-3.62-9.72a61.84,61.84,0,0,0-3.57-5.37Z"
  }));
};
IconDroplets.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconEnvelope = function IconEnvelope(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconEnvelope"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M51,45H3a1,1,0,0,1-1-1V10A1,1,0,0,1,3,9H51a1,1,0,0,1,1,1V44A1,1,0,0,1,51,45ZM4,43H50V11H4ZM27.23,31.35,50,20.92V18.7L26.82,29.33,4,18.5v2.29L26.39,31.34a.91.91,0,0,0,.43.1A1,1,0,0,0,27.23,31.35Z"
  }));
};
IconEnvelope.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconEqualizer = function IconEqualizer(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconEqualizer"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M44,51a2.07,2.07,0,0,1-1-.26A2,2,0,0,1,42,49V31.06a1.31,1.31,0,0,1,0-.28V24H41a4,4,0,0,1-4-4V18a4,4,0,0,1,4-4h1V5a2,2,0,0,1,1.56-2l.17,0h.08a2,2,0,0,1,1.56.53A2,2,0,0,1,46,5.05v9h1a4,4,0,0,1,4,4v2a4,4,0,0,1-4,4H46v6.77a1.31,1.31,0,0,1,0,.28V49a2,2,0,0,1-1,1.74A2,2,0,0,1,44,51ZM27,51a2.07,2.07,0,0,1-1-.26A2,2,0,0,1,25,49V44.06a1.31,1.31,0,0,1,0-.28V42H24a4,4,0,0,1-4-4V36a4,4,0,0,1,4-4h1V5a2,2,0,0,1,1.56-2l.17,0h.08a2,2,0,0,1,1.56.53A2,2,0,0,1,29,5.05V32h1a4,4,0,0,1,4,4v2a4,4,0,0,1-4,4H29v1.77a1.31,1.31,0,0,1,0,.28V49a2,2,0,0,1-1,1.74A2,2,0,0,1,27,51ZM10,51a2.07,2.07,0,0,1-1-.26A2,2,0,0,1,8,49V28.06a1.31,1.31,0,0,1,0-.28V21H7a4,4,0,0,1-4-4V15a4,4,0,0,1,4-4H8V5A2,2,0,0,1,9.56,3l.17,0h.08a2,2,0,0,1,1.56.53A2,2,0,0,1,12,5.05v6h1a4,4,0,0,1,4,4v2a4,4,0,0,1-4,4H12v6.77a1.31,1.31,0,0,1,0,.28V49a2,2,0,0,1-1,1.74A2,2,0,0,1,10,51ZM8,11h4M8,21h4M25,32h4M25,42h4M42,14h4M42,24h4.42"
  }));
};
IconEqualizer.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconExit = function IconExit(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconExit"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M34.3,13V3c0-0.6-0.4-1-1-1h-30C3.3,2,3.2,2,3.1,2C2.6,2.1,2.3,2.5,2.3,3v48c0,0.6,0.4,1,1,1h30 c0.6,0,1-0.4,1-1V41 M42.1,36.6l8.9-8.9l0.7-0.7L51,26.3l-8.9-8.9 M21.3,27h29.6"
  }));
};
IconExit.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconFanMoving = function IconFanMoving(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconFanMoving",
    style: _objectSpread({
      overflow: "visible"
    }, props.style)
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", {
    style: {
      animation: "".concat(rotateAnimationId, " 3s linear 0ms infinite "),
      transformOrigin: "center"
    }
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
    d: "M41.2,26.8c-1.7-1.7-3.8-2.9-6.2-3.4l7.1-7.1c1.5-1.5,2.3-3.4-0.5-5.4c-5.8-3.4-13.3-1.4-16.8,4.4 c-0.7,1.1-1.1,2.4-1.4,3.7l-7.2-7.1c-1.5-1.5-3.4-2.3-5.4,0.5c-3.4,5.9-1.5,13.4,4.4,16.8c1.1,0.7,2.4,1.1,3.7,1.4l-7.1,7.1 c-1.5,1.5-2.4,3.5,0.5,5.4c5.8,3.4,13.4,1.5,16.8-4.4c0.7-1.1,1.2-2.4,1.4-3.7l7.1,7.1c1.5,1.5,3.4,2.3,5.4-0.5 C45.9,36.8,45.1,30.8,41.2,26.8z M27,31.5c-2.5,0-4.5-2-4.5-4.5l0,0l0,0c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5S29.4,31.5,27,31.5 C27,31.5,27,31.5,27,31.5z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "0.5px",
    d: "M16.2,38.3l-0.3,0.4l-0.3,0.4l0,0c-3.5-3-5.6-7.3-5.9-11.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5 C10.9,31.4,12.9,35.4,16.2,38.3z M38.5,13L38.5,13c-0.3-0.2-0.6-0.1-0.7,0.1c-0.2,0.2-0.2,0.5,0.1,0.7c3.3,2.8,5.3,6.8,5.6,11.2 c0,0.3,0.2,0.5,0.5,0.5l0,0c0.3,0,0.5-0.3,0.5-0.5c0,0,0,0,0,0C44,20.3,41.9,16,38.5,13z M39.3,36.8c-2.9,3.3-6.9,5.2-11.2,5.5 c-0.3,0-0.5,0.3-0.5,0.5c0,0,0,0,0,0c0,0.3,0.2,0.5,0.5,0.5l0,0c4.6-0.3,8.9-2.4,11.9-5.9l-0.4-0.3l0.4,0.3c0.2-0.2,0.2-0.5,0-0.7 C39.8,36.6,39.5,36.6,39.3,36.8L39.3,36.8z M14.4,15.4c0.1,0,0.3-0.1,0.4-0.2c2.9-3.3,6.9-5.2,11.2-5.5c0.3,0,0.5-0.3,0.5-0.5 c0,0,0,0,0,0c0-0.3-0.3-0.5-0.5-0.5c0,0,0,0,0,0C21.3,9,17,11.1,14,14.5l0,0c-0.2,0.2-0.2,0.5,0,0.7 C14.1,15.3,14.2,15.4,14.4,15.4L14.4,15.4z M28.2,39.8L28.2,39.8c3.6-0.2,7-1.9,9.5-4.7l-0.3-0.4L37,34.5 c-2.2,2.6-5.4,4.1-8.8,4.3c-0.3,0-0.5,0.2-0.5,0.5S27.9,39.8,28.2,39.8z M36.5,15.7L36.5,15.7c-0.3-0.2-0.6-0.2-0.8,0 c-0.2,0.2-0.2,0.5,0,0.7c2.6,2.2,4.1,5.4,4.3,8.8c0,0.3,0.2,0.5,0.5,0.5l0,0c0.3,0,0.5-0.2,0.5-0.5c0,0,0,0,0,0 C40.8,21.5,39.2,18.1,36.5,15.7z M18.6,36.1l-0.3,0.3l-0.1,0.1L18.6,36.1z M26.4,12.2c-3.7,0.2-7.1,1.9-9.5,4.7l0,0 c-0.2,0.2-0.2,0.5,0,0.7c0.2,0.2,0.5,0.2,0.7,0c0,0,0.1-0.1,0.1-0.1c2.2-2.6,5.4-4.1,8.8-4.3c0.3,0,0.5-0.3,0.5-0.5c0,0,0,0,0,0 C26.9,12.4,26.7,12.2,26.4,12.2z M14.5,26.9c0-0.3-0.3-0.5-0.5-0.5c-0.3,0-0.5,0.3-0.5,0.5c0,0,0,0,0,0c0.2,3.7,1.9,7.1,4.7,9.5 l0.1-0.1l0.6-0.7C16.3,33.4,14.7,30.2,14.5,26.9z"
  })));
};
IconFanMoving.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconFanOff = function IconFanOff(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconFanOff"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M37,17.6c-2.4,0-4.7,0.7-6.8,2V9.5c0-2.1-0.8-4.1-4.2-3.5c-6.5,1.7-10.4,8.4-8.8,15c0.3,1.3,0.9,2.5,1.6,3.6 l-10.1,0c-2.1,0-4.1,0.8-3.5,4.2c1.7,6.6,8.4,10.5,15,8.8c1.3-0.3,2.5-0.9,3.6-1.6l0,10c0,2.1,0.8,4.1,4.2,3.5 c6.6-1.7,10.5-8.4,8.8-15c-0.3-1.3-0.9-2.5-1.6-3.6h10.1c2.1,0,4.1-0.8,3.5-4.2C47.4,21.3,42.6,17.6,37,17.6z M30.2,31 c-1.7,1.7-4.6,1.7-6.3,0l0,0l0,0c-1.7-1.7-1.7-4.6,0-6.3c1.7-1.7,4.6-1.7,6.3,0C32,26.4,32,29.2,30.2,31C30.2,31,30.2,31,30.2,31z"
  }));
};
IconFanOff.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconFanOn = function IconFanOn(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconFanOn",
    style: _objectSpread({
      overflow: "visible"
    }, props.style)
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", null, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
    d: "M41.2,26.8c-1.7-1.7-3.8-2.9-6.2-3.4l7.1-7.1c1.5-1.5,2.3-3.4-0.5-5.4c-5.8-3.4-13.3-1.4-16.8,4.4 c-0.7,1.1-1.1,2.4-1.4,3.7l-7.2-7.1c-1.5-1.5-3.4-2.3-5.4,0.5c-3.4,5.9-1.5,13.4,4.4,16.8c1.1,0.7,2.4,1.1,3.7,1.4l-7.1,7.1 c-1.5,1.5-2.4,3.5,0.5,5.4c5.8,3.4,13.4,1.5,16.8-4.4c0.7-1.1,1.2-2.4,1.4-3.7l7.1,7.1c1.5,1.5,3.4,2.3,5.4-0.5 C45.9,36.8,45.1,30.8,41.2,26.8z M27,31.5c-2.5,0-4.5-2-4.5-4.5l0,0l0,0c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5S29.4,31.5,27,31.5 C27,31.5,27,31.5,27,31.5z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "0.5px",
    d: "M16.2,38.3l-0.3,0.4l-0.3,0.4l0,0c-3.5-3-5.6-7.3-5.9-11.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5 C10.9,31.4,12.9,35.4,16.2,38.3z M38.5,13L38.5,13c-0.3-0.2-0.6-0.1-0.7,0.1c-0.2,0.2-0.2,0.5,0.1,0.7c3.3,2.8,5.3,6.8,5.6,11.2 c0,0.3,0.2,0.5,0.5,0.5l0,0c0.3,0,0.5-0.3,0.5-0.5c0,0,0,0,0,0C44,20.3,41.9,16,38.5,13z M39.3,36.8c-2.9,3.3-6.9,5.2-11.2,5.5 c-0.3,0-0.5,0.3-0.5,0.5c0,0,0,0,0,0c0,0.3,0.2,0.5,0.5,0.5l0,0c4.6-0.3,8.9-2.4,11.9-5.9l-0.4-0.3l0.4,0.3c0.2-0.2,0.2-0.5,0-0.7 C39.8,36.6,39.5,36.6,39.3,36.8L39.3,36.8z M14.4,15.4c0.1,0,0.3-0.1,0.4-0.2c2.9-3.3,6.9-5.2,11.2-5.5c0.3,0,0.5-0.3,0.5-0.5 c0,0,0,0,0,0c0-0.3-0.3-0.5-0.5-0.5c0,0,0,0,0,0C21.3,9,17,11.1,14,14.5l0,0c-0.2,0.2-0.2,0.5,0,0.7 C14.1,15.3,14.2,15.4,14.4,15.4L14.4,15.4z M28.2,39.8L28.2,39.8c3.6-0.2,7-1.9,9.5-4.7l-0.3-0.4L37,34.5 c-2.2,2.6-5.4,4.1-8.8,4.3c-0.3,0-0.5,0.2-0.5,0.5S27.9,39.8,28.2,39.8z M36.5,15.7L36.5,15.7c-0.3-0.2-0.6-0.2-0.8,0 c-0.2,0.2-0.2,0.5,0,0.7c2.6,2.2,4.1,5.4,4.3,8.8c0,0.3,0.2,0.5,0.5,0.5l0,0c0.3,0,0.5-0.2,0.5-0.5c0,0,0,0,0,0 C40.8,21.5,39.2,18.1,36.5,15.7z M18.6,36.1l-0.3,0.3l-0.1,0.1L18.6,36.1z M26.4,12.2c-3.7,0.2-7.1,1.9-9.5,4.7l0,0 c-0.2,0.2-0.2,0.5,0,0.7c0.2,0.2,0.5,0.2,0.7,0c0,0,0.1-0.1,0.1-0.1c2.2-2.6,5.4-4.1,8.8-4.3c0.3,0,0.5-0.3,0.5-0.5c0,0,0,0,0,0 C26.9,12.4,26.7,12.2,26.4,12.2z M14.5,26.9c0-0.3-0.3-0.5-0.5-0.5c-0.3,0-0.5,0.3-0.5,0.5c0,0,0,0,0,0c0.2,3.7,1.9,7.1,4.7,9.5 l0.1-0.1l0.6-0.7C16.3,33.4,14.7,30.2,14.5,26.9z"
  })));
};
IconFanOn.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconFilter = function IconFilter(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconFilter"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    d: "M32,50.49a1.53,1.53,0,0,1-.75-.2l-10-6A1.51,1.51,0,0,1,20.5,43V25.58L4.92,9A1.45,1.45,0,0,1,4.5,8V5A1.5,1.5,0,0,1,5.72,3.52H48A1.5,1.5,0,0,1,49.5,5v3a1.59,1.59,0,0,1-.14.64l-.13.18a1.37,1.37,0,0,1-.16.18L49,9.18,33.5,25.58V49a1.48,1.48,0,0,1-.76,1.28A1.52,1.52,0,0,1,32,50.49ZM20.5,25.58h13"
  }));
};
IconFilter.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconGarageClosed = function IconGarageClosed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconGarageClosed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M25,4.13,45,14.61V44H40V19a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1V44H5V14.61ZM10,44H40M35,28.08v7.84"
  }));
};
IconGarageClosed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconGarageOpen = function IconGarageOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconGarageOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M27,6.1,47,16.6V46H42V21a.94.94,0,0,0-1-1H13a.94.94,0,0,0-1,1V46H7V16.6Z"
  }));
};
IconGarageOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconGaragePartial = function IconGaragePartial(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconGaragePartial"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M27,6.14,47,16.61V46H42V20.9a1,1,0,0,0-.72-.86H12.52a1.08,1.08,0,0,0-.24.18.61.61,0,0,0-.12.16.41.41,0,0,0-.05.09.67.67,0,0,0-.07.18A.82.82,0,0,0,12,21V46H7V16.61ZM30,20V46H12M26,30.08v7.84"
  }));
};
IconGaragePartial.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconGears = function IconGears(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconGears"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M42.09,2a1,1,0,0,0-.71.47L39.75,5.16a8.69,8.69,0,0,0-1.53,0L36.56,2.5a1,1,0,0,0-1.25-.38L32.5,3.31a1,1,0,0,0-.59,1.16l.68,3a9.93,9.93,0,0,0-1.06,1.09l-3.06-.68a1,1,0,0,0-1.13.62l-1.15,2.81a1,1,0,0,0,.37,1.25l2.66,1.66a9.77,9.77,0,0,0,0,1.53l-2.63,1.66a1,1,0,0,0-.37,1.25l1.19,2.81a1,1,0,0,0,1.12.59l3.06-.68a10,10,0,0,0,1.1,1.06L32,25.53a1,1,0,0,0,.59,1.13l2.85,1.15a1,1,0,0,0,1.22-.37l1.68-2.66a9.13,9.13,0,0,0,1.57,0l1.68,2.66a1,1,0,0,0,1.22.37l2.85-1.19a1,1,0,0,0,.56-1.15l-.75-3.06a9.74,9.74,0,0,0,1.06-1.07l3.09.66a1,1,0,0,0,1.16-.63l1.16-2.81a1,1,0,0,0-.41-1.25l-2.69-1.66a8.88,8.88,0,0,0,0-1.46l2.66-1.75a1,1,0,0,0,.41-1.22L50.66,8.38a1,1,0,0,0-1.16-.6l-3,.75a10.2,10.2,0,0,0-1.09-1.09L46,4.38a1,1,0,0,0-.59-1.16L42.59,2.06A1.06,1.06,0,0,0,42.09,2ZM39,9.88a5.07,5.07,0,1,0,2,.37A5,5,0,0,0,39,9.88ZM16.34,19a1,1,0,0,0-.81.84l-.62,4a11.66,11.66,0,0,0-2.07.84L9.5,22.34a1,1,0,0,0-1.28.1L5.47,25.19a1,1,0,0,0-.09,1.28l2.34,3.34a12.12,12.12,0,0,0-.84,2.07l-4,.68a1,1,0,0,0-.84,1v3.88a1,1,0,0,0,.81,1l4,.68a11.79,11.79,0,0,0,.88,2.1L5.34,44.5a1,1,0,0,0,.1,1.28l2.75,2.75a1,1,0,0,0,1.28.09l3.34-2.34a12.12,12.12,0,0,0,2.07.84l.65,4a1,1,0,0,0,1,.84h3.88a1,1,0,0,0,1-.81l.71-4.1a12.15,12.15,0,0,0,2-.84l3.37,2.37a1,1,0,0,0,1.28-.09l2.75-2.75a1,1,0,0,0,.1-1.28l-2.41-3.38a11,11,0,0,0,.84-2l4.1-.68a1,1,0,0,0,.81-1V33.53a1,1,0,0,0-.84-1l-4.1-.68a11.31,11.31,0,0,0-.81-2l2.37-3.41a1,1,0,0,0-.09-1.28l-2.75-2.75a1,1,0,0,0-1.28-.1l-3.34,2.41a12.46,12.46,0,0,0-2.07-.84l-.68-4.07a1,1,0,0,0-1-.84H16.34ZM18.5,29.34a6.16,6.16,0,1,0,6.16,6.16A6.18,6.18,0,0,0,18.5,29.34Z"
  }));
};
IconGears.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconGlobe = function IconGlobe(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconGlobe"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M27.09,51l-1,0A24,24,0,0,1,4.31,19.21,24,24,0,0,1,24.75,3.12,20.63,20.63,0,0,1,26.82,3h0a21.37,21.37,0,0,1,2.79.16h.32a19.62,19.62,0,0,1,4.28.88l.34.09a2.31,2.31,0,0,1,.68.35,23.3,23.3,0,0,1,5.12,2.62,2.06,2.06,0,0,1,.69.47A23.66,23.66,0,0,1,51,25.66a1.94,1.94,0,0,1,0,.68v.13c0,.17,0,.33,0,.5a24.91,24.91,0,0,1-4.57,14.26l0,0A24.06,24.06,0,0,1,27.09,51ZM26.84,5c-.63,0-1.27,0-1.9.09A22,22,0,0,0,6.2,19.86,22.05,22.05,0,0,0,44.8,40.07l0,0A22.82,22.82,0,0,0,49,27c0-.14,0-.28,0-.41V26.3a.85.85,0,0,1,0-.23,1.7,1.7,0,0,1,0-.22A21.63,21.63,0,0,0,39.8,9.16,1,1,0,0,1,39.59,9a.84.84,0,0,1-.27-.13,21.65,21.65,0,0,0-4.94-2.51A.88.88,0,0,1,34,6.07L33.66,6a17.41,17.41,0,0,0-3.86-.8,1,1,0,0,1-.3,0A19.59,19.59,0,0,0,26.84,5ZM29.73,46.2a1,1,0,0,1-.59-.19,1,1,0,0,1-.35-1.16L31,39l-.69-1-1.89-.83a1,1,0,0,1-.55-.6l-.81-2.42A.86.86,0,0,1,27,33.8V32.38a1,1,0,0,1,.29-.71L28,31V29.58a1,1,0,0,1,.55-.89l1.25-.62a.88.88,0,0,1,.42-.11l3.32-.08a.93.93,0,0,1,.76.32L35,29l1.85.92a1.24,1.24,0,0,1,.26.19L38,31l2.94.84a1,1,0,0,1,.7.72l.27,1.08a1,1,0,0,1-.08.69L41,36l-.87,2.6a1,1,0,0,1-.51.58L38,40l-7.66,6A1,1,0,0,1,29.73,46.2Zm-.12-10.71,1.48.64a2.12,2.12,0,0,1,.85.69l.69,1a2,2,0,0,1,.24,1.85l-.95,2.53,4.84-3.8a1.79,1.79,0,0,1,.34-.22l1.26-.63.74-2.22c0-.09.07-.18.11-.27l.67-1.33,0-.16-2.39-.68a2.07,2.07,0,0,1-.87-.51l-.77-.77-1.71-.85a2.37,2.37,0,0,1-.59-.45l-.38-.42L30.49,30,30,30.2V31a2,2,0,0,1-.59,1.41l-.41.41v.85ZM31,27a2,2,0,0,1-.64-.11l-3-1a2,2,0,0,1,.7-3.9,2.37,2.37,0,0,1,.58.11l3,1a2,2,0,0,1,1.16,1,2,2,0,0,1,.1,1.53,2,2,0,0,1-1,1.16A2,2,0,0,1,31,27Zm-3-3,3,1-3-1Zm-8,1.89a1,1,0,0,1-.45-.11l-1.18-.59a1,1,0,0,1-.5-.58l-1.82-5.45A.86.86,0,0,1,16,18.8V15.2a1,1,0,0,1,.1-.44L17,13V10l-.77-.38a1,1,0,0,1-.55-.88,1,1,0,0,1,.51-.89q.91-.51,1.86-.93A1,1,0,0,1,19,7l2,1.11L24,8a.94.94,0,0,1,.72.29A1,1,0,0,1,25,9v2.08l2,.9,1.29-1.3a1,1,0,0,1,1.41,0l2.43,2.43a1,1,0,0,1,.29.81,1,1,0,0,1-.44.73L30,16l-3.71,3.7a1,1,0,0,1-.71.3H24l-3,1v3.88a1,1,0,0,1-1,1Zm-2-7.21,1,3V21a2,2,0,0,1,1.36-1.9l3-1A2,2,0,0,1,24,18h1.17l3.41-3.42.3-.25,1-.64L29,12.79l-.59.59a2,2,0,0,1-2.23.41l-2-.9A2,2,0,0,1,23,11.07V10l-1.95.05a2,2,0,0,1-1-.25l-1.2-.66A2,2,0,0,1,19,10v3a2,2,0,0,1-.22.89L18,15.44ZM47.83,25.4a1,1,0,0,1-.89-.55l-.88-1.76a1.07,1.07,0,0,1-.09-.27l-.73-4a1,1,0,0,1,1.91-.57,22.39,22.39,0,0,1,1.67,6.06,1,1,0,0,1-.7,1.09A1,1,0,0,1,47.83,25.4ZM32.46,9a1,1,0,0,1-.7-.29L31,8l-1.47-.49a1,1,0,0,1-.66-.72,1,1,0,0,1,.27-.94l.26-.26a1,1,0,0,1,.86-.28,22,22,0,0,1,2.78.6,1,1,0,0,1,.69,1.21l-.3,1.18a1,1,0,0,1-.7.71A.84.84,0,0,1,32.46,9Z"
  }));
};
IconGlobe.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconGrid = function IconGrid(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconGrid"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M16,22.12H8.72A1.22,1.22,0,0,0,7.5,23.34v7.32a1.22,1.22,0,0,0,1.22,1.22H16a1.22,1.22,0,0,0,1.22-1.22V23.34A1.22,1.22,0,0,0,16,22.12ZM16,7.5H8.72A1.21,1.21,0,0,0,7.5,8.72V16a1.21,1.21,0,0,0,1.22,1.22H16c.68,0,1.22-1.76,1.22-2.44V8.72A1.21,1.21,0,0,0,16,7.5Zm0,29.25H8.72A1.21,1.21,0,0,0,7.5,38v7.31A1.21,1.21,0,0,0,8.72,46.5H16a1.21,1.21,0,0,0,1.22-1.22V38A1.21,1.21,0,0,0,16,36.75ZM30.66,22.12H23.34a1.22,1.22,0,0,0-1.22,1.22v7.32a1.22,1.22,0,0,0,1.22,1.22h7.32a1.22,1.22,0,0,0,1.22-1.22V23.34A1.22,1.22,0,0,0,30.66,22.12Zm0,14.63H23.34A1.22,1.22,0,0,0,22.12,38v7.31a1.22,1.22,0,0,0,1.22,1.22h7.32a1.22,1.22,0,0,0,1.22-1.22V38A1.22,1.22,0,0,0,30.66,36.75ZM45.28,22.12H38a1.22,1.22,0,0,0-1.22,1.22v7.32A1.22,1.22,0,0,0,38,31.88h7.31a1.22,1.22,0,0,0,1.22-1.22V23.34A1.22,1.22,0,0,0,45.28,22.12Zm0-14.62H38a1.21,1.21,0,0,0-1.22,1.22V16A1.21,1.21,0,0,0,38,17.25h7.31c.68,0,1.22-1.76,1.22-2.44V8.72A1.21,1.21,0,0,0,45.28,7.5Zm-14.62,0H23.34a1.22,1.22,0,0,0-1.22,1.22V16a1.22,1.22,0,0,0,1.22,1.22h7.32c.67,0,1.22-1.76,1.22-2.44V8.72A1.22,1.22,0,0,0,30.66,7.5ZM45.28,36.75H38A1.21,1.21,0,0,0,36.75,38v7.31A1.21,1.21,0,0,0,38,46.5h7.31a1.21,1.21,0,0,0,1.22-1.22V38A1.21,1.21,0,0,0,45.28,36.75Z"
  }));
};
IconGrid.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSad = function IconSad(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 50 50"
  }, props, {
    "data-component-name": "IconSad"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M15,35c0,0,4-4,10-4s10,4,10,4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", {
    fill: "currentColor"
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M25,2C12.297,2,2,12.297,2,25c0,12.703,10.297,23,23,23c12.703,0,23-10.297,23-23C48,12.297,37.703,2,25,2L25,2z"
  })), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("circle", {
    cx: "33",
    cy: "22",
    r: "3",
    fill: "currentColor"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("circle", {
    cx: "17",
    cy: "22",
    r: "3",
    fill: "currentColor"
  }));
};
IconSad.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconHD = function IconHD(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1365 1024"
  }, props, {
    "data-component-name": "IconHD"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M941.22 387.99h-35.924v254.655h35.282c30.102 0 51.516-3.343 64.227-10.022 12.713-6.675 22.67-18.331 29.887-34.966 7.194-16.647 10.803-43.605 10.803-80.913 0-49.382-8.061-83.186-24.154-101.412-16.121-18.227-42.817-27.343-80.121-27.343zm-579.562 57.544h157.361v-163.094h144.66v466.065h-144.66v-188.518h-157.361v188.517h-144.019v-466.065h144.019v163.096zm399.619 302.969v-466.065h213.955c42.185 0 76.247 5.722 102.212 17.171 25.967 11.441 47.428 27.87 64.379 49.277 16.961 21.405 29.247 46.309 36.878 74.706 7.634 28.404 11.441 58.498 11.441 90.291 0 49.801-5.67 88.426-17 115.886-11.341 27.435-27.083 50.447-47.215 68.98-20.142 18.546-41.755 30.894-64.853 37.041-31.587 8.475-60.192 12.711-85.842 12.711h-213.955zm477.048-611.712h-1111.306c-69.168 0-125.21 59.511-125.21 132.919v486.627c0 73.407 56.042 132.919 125.21 132.919h1111.306c69.144 0 125.196-59.511 125.196-132.919v-486.627c0-73.407-56.052-132.919-125.196-132.919z"
  }));
};
IconHD.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconHeart = function IconHeart(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconHeart"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M37,8c-4.2,0-7.9,2.1-10,5.4C24.9,10.1,21.2,8,17,8C10.4,8,5,13.4,5,20c0,14,16,21,22,26c6-5,22-12,22-26 C49,13.4,43.6,8,37,8z"
  }));
};
IconHeart.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconHingedDoorClosedLocked = function IconHingedDoorClosedLocked(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1121 1024"
  }, props, {
    "data-component-name": "IconHingedDoorClosedLocked"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M810.331 940.682c-6.719-10.751-10.751-21.501-14.782-33.596h-225.764v-798.236h344.021v587.255c10.751-2.688 21.501-4.031 32.252-4.031v-599.349c0-9.407-6.719-16.126-16.126-16.126h-376.273c-9.407 0-16.126 6.719-16.126 16.126v814.362h-21.501v-874.835h451.528v659.822c10.751 1.344 21.501 2.688 32.252 5.375v-681.323c0-9.407-6.719-16.126-16.126-16.126h-967.559c-9.407 0-16.126 6.719-16.126 16.126v907.087c0 9.407 6.719 16.126 16.126 16.126h47.034c1.344 0 4.031 1.344 6.719 1.344h376.273l6.719-1.344h94.068c2.688 1.344 4.031 1.344 6.719 1.344h256.672zm-778.079-908.43h451.528v874.835h-21.501v-814.362c0-9.407-6.719-16.126-16.126-16.126h-376.273c-9.407 0-16.126 6.719-16.126 16.126v814.362h-21.501v-874.835zm53.753 874.835v-798.236h344.021v798.236h-344.021zm501.25-381.649v-134.383h13.438v134.383h-13.438zm-174.699-134.383v134.383h-13.438v-134.383h13.438zm556.347 491.843c0 5.375-2.688 9.407-8.063 12.094v22.845c0 2.688-1.344 4.031-4.031 4.031s-4.031-1.344-4.031-4.031v-22.845h-2.688c-5.375-1.344-8.063-6.719-8.063-12.094 0-8.063 5.375-13.438 13.438-13.438 6.719 0 13.438 5.375 13.438 13.438zm-14.782-124.977c-21.501 0-38.971 17.47-38.971 38.971v29.564h77.942v-29.564c0-21.501-17.47-38.971-38.971-38.971zm159.916 99.444c0 88.693-71.223 159.916-159.916 159.916s-159.916-71.223-159.916-159.916 71.223-159.916 159.916-159.916 159.916 71.223 159.916 159.916zm-69.88-5.375c0-13.438-12.094-25.533-25.533-25.533v-30.908c0-36.283-29.564-64.504-64.504-64.504s-64.504 28.22-64.504 64.504v30.908c-13.438 0-25.533 12.094-25.533 25.533v86.005c0 13.438 12.094 25.533 25.533 25.533h129.008c13.438 0 25.533-12.094 25.533-25.533v-86.005z"
  }));
};
IconHingedDoorClosedLocked.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconHingedDoorClosedUnlocked = function IconHingedDoorClosedUnlocked(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1121 1024"
  }, props, {
    "data-component-name": "IconHingedDoorClosedUnlocked"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M412.556 525.438h-13.438v-134.383h13.438v134.383zm382.993 381.649c4.031 12.094 9.407 22.845 14.782 33.596h-256.672c-2.688 0-5.375-1.344-6.719-1.344h-94.068c-2.688 1.344-4.031 1.344-6.719 1.344h-376.273c-2.688 0-5.375-1.344-6.719-1.344h-47.034c-9.407 0-16.126-6.719-16.126-16.126v-907.087c0-9.407 6.719-16.126 16.126-16.126h967.559c9.407 0 16.126 6.719 16.126 16.126v681.323c-10.751-2.688-21.501-5.375-32.252-5.375v-659.822h-451.528v874.835h21.501v-814.362c0-9.407 6.719-16.126 16.126-16.126h376.273c9.407 0 16.126 6.719 16.126 16.126v598.005c-10.751 0-21.501 2.688-32.252 4.031v-585.911h-344.021v798.236h225.764zm-365.523-798.237h-344.021v798.236h344.021v-798.236zm53.754-76.598h-451.528v874.835h21.501v-814.362c0-9.407 6.719-16.126 16.126-16.126h376.273c9.407 0 16.126 6.719 16.126 16.126v814.362h21.501v-874.835zm116.913 493.186v-134.383h-13.438v134.383h13.438zm353.428 172.011c-88.693 0-159.916 71.223-159.916 159.916s71.223 159.916 159.916 159.916 159.916-71.223 159.916-159.916-71.223-159.916-159.916-159.916zm90.036 235.17c0 10.751-9.407 20.157-20.157 20.157h-96.756c-10.751 0-20.157-9.407-20.157-20.157v-64.504c0-10.751 8.063-20.157 18.814-20.157 1.344 1.344 1.344-48.378 1.344-48.378 0-16.126-13.438-29.564-29.564-29.564s-29.564 13.438-29.564 29.564v25.533c0 5.375-4.031 9.407-9.407 9.407s-9.407-4.031-9.407-9.407v-25.533c0-26.877 21.501-48.378 48.378-48.378s48.378 21.501 48.378 48.378v48.378h77.942c10.751 0 20.157 9.407 20.157 20.157v64.504zm-59.128-41.658c0 4.031-2.688 8.063-6.719 9.407v17.47c0 1.344-1.344 2.688-2.688 2.688s-2.688-1.344-2.688-2.688v-17.47c-4.031-1.344-6.719-5.375-6.719-9.407 0-5.375 4.031-9.407 9.407-9.407s9.407 4.031 9.407 9.407z"
  }));
};
IconHingedDoorClosedUnlocked.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconHingedDoorClosed = function IconHingedDoorClosed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1088 1024"
  }, props, {
    "data-component-name": "IconHingedDoorClosed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M449.143 572.076h-14.635v-146.348h14.635zm204.888-146.348h-14.635v146.348h14.635zm358.554 598.418h-409.874c-2.507 0-4.889-.539-7.035-1.507l-102.336.044c-2.038.925-4.42 1.464-6.927 1.464h-410.557c-2.507 0-4.889-.539-7.035-1.507l-51.407.044c-9.618 0-17.415-7.797-17.415-17.415v-987.852c0-9.618 7.797-17.415 17.415-17.415h1053.709c9.618 0 17.415 7.797 17.415 17.415v987.852l.002.293c0 9.537-7.732 17.269-17.269 17.269l-.157-.001h-51.507c-1.949.836-4.217 1.322-6.598 1.322l-.448-.006zm17.415-36.148h23.855v-953.167h-492.17v953.021h23.855v-887.019c0-9.567 7.714-17.332 17.261-17.415h409.783c9.618 0 17.415 7.797 17.415 17.415zm-409.775 0h374.945v-869.749h-374.945zm-117.079 0h23.855v-953.167h-492.17v953.021h23.855v-887.019c0-9.567 7.714-17.332 17.261-17.415h409.783c9.618 0 17.415 7.797 17.415 17.415zm-409.776 0h374.945v-869.749h-374.945z"
  }));
};
IconHingedDoorClosed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconHingedDoorOpen = function IconHingedDoorOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 936 1024"
  }, props, {
    "data-component-name": "IconHingedDoorOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M913.723 975.426h-892.718c-11.815 0-21.005-9.19-21.005-21.005v-887.467c0-11.815 9.19-21.005 21.005-21.005h892.718c11.815 0 21.005 9.19 21.005 21.005v886.154c1.313 11.815-9.19 22.318-21.005 22.318zm-870.4-43.323h849.395v-842.831h-849.395v842.831zm347.898 91.897h-2.626l-317.703-52.513c-7.877-1.313-13.128-7.877-13.128-15.754v-813.949c0-6.564 3.938-13.128 10.503-14.441l317.703-126.031c7.877-2.626 18.379 1.313 21.005 9.19l1.313 5.251v991.179c0 9.19-7.877 17.067-17.067 17.067zm-301.949-82.708l286.195 47.262v-947.856l-284.882 112.903-1.313 787.692zm266.502-376.779h-13.128v-131.282h13.128v131.282zm199.549 458.174c-9.19 0-15.754-6.564-15.754-15.754v-991.179c0-9.19 6.564-15.754 15.754-15.754 2.626 0 3.938 0 5.251 1.313l307.2 126.031c5.251 2.626 9.19 7.877 9.19 14.441v812.636c0 7.877-5.251 14.441-13.128 15.754l-308.513 52.513zm15.754-983.302v949.169l275.692-47.262v-789.005l-275.692-112.903zm31.508 530.379h-13.128v-131.282h13.128v131.282z"
  }));
};
IconHingedDoorOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconHingedDoorUnknown = function IconHingedDoorUnknown(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1121 1024"
  }, props, {
    "data-component-name": "IconHingedDoorUnknown"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M412.556 525.438h-13.438v-134.383h13.438v134.383zm382.993 381.649c4.031 12.094 9.407 22.845 14.782 33.596h-256.672c-2.688 0-5.375-1.344-6.719-1.344h-94.068c-2.688 1.344-4.031 1.344-6.719 1.344h-376.273c-2.688 0-5.375-1.344-6.719-1.344h-47.034c-9.407 0-16.126-6.719-16.126-16.126v-907.087c0-9.407 6.719-16.126 16.126-16.126h967.559c9.407 0 16.126 6.719 16.126 16.126v681.323c-10.751-2.688-21.501-5.375-32.252-5.375v-659.822h-451.528v874.835h21.501v-814.362c0-9.407 6.719-16.126 16.126-16.126h376.273c9.407 0 16.126 6.719 16.126 16.126v598.005c-10.751 0-21.501 2.688-32.252 4.031v-585.911h-344.021v798.236h225.764zm-365.523-798.237h-344.021v798.236h344.021v-798.236zm53.754-76.598h-451.528v874.835h21.501v-814.362c0-9.407 6.719-16.126 16.126-16.126h376.273c9.407 0 16.126 6.719 16.126 16.126v814.362h21.501v-874.835zm116.913 493.186v-134.383h-13.438v134.383h13.438zm353.428 172.011c-88.693 0-159.916 71.223-159.916 159.916s71.223 159.916 159.916 159.916 159.916-71.223 159.916-159.916-71.223-159.916-159.916-159.916zm16.126 228.451h-26.877v-107.507h26.877v107.507zm0-134.383h-26.877v-26.877h26.877v26.877z"
  }));
};
IconHingedDoorUnknown.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconHistory = function IconHistory(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconHistory"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M19,13.5H10v-9m.3,8.7A22,22,0,1,1,5,27.5,22.77,22.77,0,0,1,7.4,17.4M27,11.5v16l-8,8m8-10a2,2,0,1,1-2,2A2,2,0,0,1,27,25.5Z"
  }));
};
IconHistory.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconHomeController = function IconHomeController(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconHomeController"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M42.9,3.6H11.1A1.37,1.37,0,0,0,9.7,5V49a1.37,1.37,0,0,0,1.4,1.4H43A1.37,1.37,0,0,0,44.4,49V5A1.6,1.6,0,0,0,42.9,3.6ZM30.8,39.4a1.37,1.37,0,0,1-1.4,1.4H17.6a1.37,1.37,0,0,1-1.4-1.4V14.3a1.37,1.37,0,0,1,1.4-1.4H29.5a1.37,1.37,0,0,1,1.4,1.4l-.1,25.1Zm8.5-1.3a1.37,1.37,0,0,1-1.4,1.4h-2a1.37,1.37,0,0,1-1.4-1.4v-.8a1.37,1.37,0,0,1,1.4-1.4h2a1.37,1.37,0,0,1,1.4,1.4v.8Zm0-5.3a1.37,1.37,0,0,1-1.4,1.4h-2a1.37,1.37,0,0,1-1.4-1.4V32a1.37,1.37,0,0,1,1.4-1.4h2A1.37,1.37,0,0,1,39.3,32v.8Zm0-5.3a1.37,1.37,0,0,1-1.4,1.4h-2a1.37,1.37,0,0,1-1.4-1.4v-.8a1.37,1.37,0,0,1,1.4-1.4h2a1.37,1.37,0,0,1,1.4,1.4Zm0-5.3a1.37,1.37,0,0,1-1.4,1.4h-2a1.37,1.37,0,0,1-1.4-1.4v-.8A1.37,1.37,0,0,1,35.9,20h2a1.37,1.37,0,0,1,1.4,1.4Zm0-5.4a1.37,1.37,0,0,1-1.4,1.4h-2a1.37,1.37,0,0,1-1.4-1.4V16a1.37,1.37,0,0,1,1.4-1.4h2A1.37,1.37,0,0,1,39.3,16Z"
  }));
};
IconHomeController.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconHomeMode = function IconHomeMode(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconHomeMode"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M6,20.17V49a1,1,0,0,0,1,1H47a1,1,0,0,0,1-1V20.17m2.62,2-3-2.33L27.6,4.17A1,1,0,0,0,27,4a1,1,0,0,0-.58.21L6.4,19.84l-3,2.37"
  }));
};
IconHomeMode.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconHouse = function IconHouse(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconHouse"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    strokeMiterlimit: "10",
    d: "M43.94,29h2.62V7H7.44V29h2.67M26.94,18.86,33.39,29H43.94V47h-12V38a5,5,0,0,0-10,0v9h-12V29H20.49ZM13.94,35h4v5h-4Zm22,0h4v5h-4Z"
  }));
};
IconHouse.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconInfo = function IconInfo(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconInfo"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M27,51A24,24,0,1,1,51,27,24,24,0,0,1,27,51Zm2.84-35.85a2.5,2.5,0,0,1-.23,1.08,2.75,2.75,0,0,1-.62.88,3,3,0,0,1-.91.6,2.64,2.64,0,0,1-1.12.23,2.57,2.57,0,0,1-1.09-.23,3,3,0,0,1-.89-.6,2.86,2.86,0,0,1-.6-.88,2.64,2.64,0,0,1-.22-1.08A2.8,2.8,0,0,1,24.38,14a3.08,3.08,0,0,1,.6-.9,3,3,0,0,1,.89-.6A2.72,2.72,0,0,1,27,12.31a2.8,2.8,0,0,1,1.12.22,3,3,0,0,1,.91.6,3,3,0,0,1,.62.9A2.64,2.64,0,0,1,29.84,15.15Zm-.61,7.38V41H24.77V22.53Z"
  }));
};
IconInfo.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconInsynctive = function IconInsynctive(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconInsynctive"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M22.89,30.79,21.07,30a7.55,7.55,0,0,1,13.72-.11L33,30.71a5.56,5.56,0,0,0-10.09.08Zm-5.1-1.19L16,28.73a13.38,13.38,0,0,1,12-7.56,13.18,13.18,0,0,1,11.89,7.39l-1.79.88A11.23,11.23,0,0,0,28,23.17,11.36,11.36,0,0,0,17.79,29.6Zm-6.07-1.37-1.74-1A20.63,20.63,0,0,1,45.78,27l-1.72,1a18.64,18.64,0,0,0-32.34.24Zm38.9,22.89H4.88a1,1,0,0,1-1-1V4.38a1,1,0,0,1,1-1H50.62a1,1,0,0,1,1,1V50.12A1,1,0,0,1,50.62,51.12Zm-44.74-2H49.62V5.38H5.88Z"
  }));
};
IconInsynctive.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconIrrigationOff = function IconIrrigationOff(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconIrrigationOff"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M34.61,45.21H19.83V37.7h1.92V18.55h1.31v-2H19.22V13.28c0-2,2.09-4.44,8-4.44,5.5,0,8,2.23,8,4.44v3.27H31.38v2h1.31V37.7h1.92Zm-12.78-2H32.61V39.7H30.69V20.55H29.38v-6h3.79V13.28c0-1.18-2.09-2.44-6-2.44s-6,1.23-6,2.44v1.27h3.84v6H23.75V39.7H21.83ZM19.62,38.8m-2.37-3.09-3,8.41a1,1,0,0,0,.49-1.33.93.93,0,0,0-.28-.37,9,9,0,0,1,3.41-7.92,1,1,0,1,0-1.22-1.58C12,36.5,12,42.27,12.78,43.61a1.14,1.14,0,0,0,1,.61A1.11,1.11,0,0,0,14.24,44.12Zm-4-3.59A15.69,15.69,0,0,1,15.35,30a1,1,0,0,0,.15-1.41,1,1,0,0,0-1.4-.15,17.47,17.47,0,0,0-5.36,8.67,10,10,0,0,0-3.12-3.76,1,1,0,1,0-1,1.74c1.28.72,2.92,3.89,3.65,5.72L10,45ZM6,44.18A1,1,0,0,0,6.71,43a13.56,13.56,0,0,0-4.18-6.34,1,1,0,0,0-1.41.14,1,1,0,0,0,.15,1.41,11.51,11.51,0,0,1,3.5,5.28,1,1,0,0,0,1,.76Zm43.25-.06a1,1,0,0,0,.49-1.33.93.93,0,0,0-.28-.37,9,9,0,0,1,3.42-7.92A1,1,0,0,0,53,33.09a1,1,0,0,0-1.4-.17C47,36.5,47,42.27,47.78,43.61a1.14,1.14,0,0,0,1,.61A1.11,1.11,0,0,0,49.24,44.12Zm-4-3.59A15.66,15.66,0,0,1,50.35,30a1,1,0,0,0,.15-1.41,1,1,0,0,0-1.4-.15,17.47,17.47,0,0,0-5.36,8.67,10,10,0,0,0-3.12-3.76,1,1,0,0,0-1,1.74c1.29.72,2.93,3.89,3.66,5.72L45,45ZM41,44.18A1,1,0,0,0,41.71,43a13.56,13.56,0,0,0-4.18-6.34,1,1,0,1,0-1.26,1.55,11.51,11.51,0,0,1,3.5,5.28,1,1,0,0,0,1,.76Z"
  }));
};
IconIrrigationOff.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconIrrigationOn = function IconIrrigationOn(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconIrrigationOn"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M34.61,45.21H19.83V37.7h1.92V18.55h1.31v-2H19.22V13.28c0-2,2.09-4.44,8-4.44,5.5,0,8,2.23,8,4.44v3.27H31.38v2h1.31V37.7h1.92Zm-12.78-2H32.61V39.7H30.69V20.55H29.38v-6h3.79V13.28c0-1.18-2.09-2.44-6-2.44s-6,1.23-6,2.44v1.27h3.84v6H23.75V39.7H21.83ZM39.19,18.43A1.21,1.21,0,1,1,38,17.22,1.23,1.23,0,0,1,39.19,18.43Zm6,0a1.21,1.21,0,1,1-1.21-1.21A1.23,1.23,0,0,1,45.15,18.43ZM42.07,16a1.21,1.21,0,1,1-1.21-1.21A1.19,1.19,0,0,1,42.07,16Zm0,5a1.21,1.21,0,1,1-1.21-1.21A1.22,1.22,0,0,1,42.07,21Zm3.08,2.28A1.21,1.21,0,1,1,43.94,22,1.23,1.23,0,0,1,45.15,23.24Zm0-9.71a1.21,1.21,0,1,1-1.21-1.21,1.26,1.26,0,0,1,1.21,1.21ZM48.74,21a1.21,1.21,0,1,1-1.21-1.21A1.22,1.22,0,0,1,48.74,21Zm-1.21,3.49a1.21,1.21,0,1,1-1.21,1.21A1.22,1.22,0,0,1,47.53,24.45Zm0-9.7A1.21,1.21,0,1,1,46.32,16,1.26,1.26,0,0,1,47.53,14.75Zm0-5A1.22,1.22,0,1,1,46.32,11,1.26,1.26,0,0,1,47.53,9.79ZM16.36,17a1.21,1.21,0,1,1-1.21,1.21A1.23,1.23,0,0,1,16.36,17ZM9.19,18.18a1.21,1.21,0,1,1,1.21,1.21,1.22,1.22,0,0,1-1.21-1.21Zm4.24,1.32a1.21,1.21,0,1,1-1.21,1.21A1.23,1.23,0,0,1,13.43,19.5Zm-1.16-3.84a1.22,1.22,0,1,1,1.21,1.21A1.24,1.24,0,0,1,12.27,15.66ZM9.19,13.38a1.21,1.21,0,1,1,1.21,1.21,1.22,1.22,0,0,1-1.21-1.21Zm0,9.7A1.21,1.21,0,1,1,10.4,24.3a1.26,1.26,0,0,1-1.21-1.22ZM5.6,15.66a1.22,1.22,0,1,1,1.21,1.21A1.24,1.24,0,0,1,5.6,15.66ZM6.76,9.79A1.22,1.22,0,1,1,5.55,11,1.23,1.23,0,0,1,6.76,9.79Zm0,9.71a1.21,1.21,0,1,1-1.21,1.21A1.22,1.22,0,0,1,6.76,19.5ZM5.55,25.66a1.22,1.22,0,0,1,1.21-1.21h0a1.21,1.21,0,1,1-1.21,1.21M19.62,38.8m-2.37-3.09-3,8.41a1,1,0,0,0,.49-1.33.93.93,0,0,0-.28-.37,9,9,0,0,1,3.41-7.92,1,1,0,1,0-1.22-1.58C12,36.5,12,42.27,12.78,43.61a1.14,1.14,0,0,0,1,.61A1.11,1.11,0,0,0,14.24,44.12Zm-4-3.59A15.69,15.69,0,0,1,15.35,30a1,1,0,0,0,.15-1.41,1,1,0,0,0-1.4-.15,17.47,17.47,0,0,0-5.36,8.67,10,10,0,0,0-3.12-3.76,1,1,0,1,0-1,1.74c1.28.72,2.92,3.89,3.65,5.72L10,45ZM6,44.18A1,1,0,0,0,6.71,43a13.56,13.56,0,0,0-4.18-6.34,1,1,0,0,0-1.41.14,1,1,0,0,0,.15,1.41,11.51,11.51,0,0,1,3.5,5.28,1,1,0,0,0,1,.76Zm43.25-.06a1,1,0,0,0,.49-1.33.93.93,0,0,0-.28-.37,9,9,0,0,1,3.42-7.92A1,1,0,0,0,53,33.09a1,1,0,0,0-1.4-.17C47,36.5,47,42.27,47.78,43.61a1.14,1.14,0,0,0,1,.61A1.11,1.11,0,0,0,49.24,44.12Zm-4-3.59A15.66,15.66,0,0,1,50.35,30a1,1,0,0,0,.15-1.41,1,1,0,0,0-1.4-.15,17.47,17.47,0,0,0-5.36,8.67,10,10,0,0,0-3.12-3.76,1,1,0,0,0-1,1.74c1.29.72,2.93,3.89,3.66,5.72L45,45ZM41,44.18A1,1,0,0,0,41.71,43a13.56,13.56,0,0,0-4.18-6.34,1,1,0,1,0-1.26,1.55,11.51,11.51,0,0,1,3.5,5.28,1,1,0,0,0,1,.76Z"
  }));
};
IconIrrigationOn.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconKey = function IconKey(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconKey"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    d: "M3.63,49.66,5,51l6.07,0L14,48V45l3.05,0L20,42V40l2.05,0L24,38V36l2.05,0,4.43-3.78m-8.26-7.89L3,43l0,6.07,1,1L19.51,34.51M31,32.11a15.1,15.1,0,1,0-9.1-9.1Zm11.64-6.18-1.2-1.25L28.07,11.37l1.24-1.24A10.3,10.3,0,0,1,43.87,24.69Z"
  }));
};
IconKey.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconLightSwitchOff = function IconLightSwitchOff(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconLightSwitchOff"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    d: "M33.68,32.86l-.77,3.21c-.06.39-.39.49-.77.49,0,0-6.25.06-6.36,0h-.06a.79.79,0,0,1-.39-.66l-.1-.17H23.79a.67.67,0,0,1-.67-.66V20.42a.68.68,0,0,1,.67-.67H30a.66.66,0,0,1,.44.17.6.6,0,0,1,.16.44v7l3,4.81c0,.11.12.17.12.28A.44.44,0,0,1,33.68,32.86ZM35.29,45.8h.06A4.62,4.62,0,0,0,40,41.2V12.8a4.61,4.61,0,0,0-4.6-4.61H18a4.61,4.61,0,0,0-4.6,4.61V41.2A4.6,4.6,0,0,0,18,45.8H35.29Zm-1.52-13a.59.59,0,0,0-.06-.45c-.06-.11-.06-.22-.11-.27l-3-4.81v-7a.6.6,0,0,0-.16-.44A.66.66,0,0,0,30,19.7h-6.2a.67.67,0,0,0-.66.66V35.07a.66.66,0,0,0,.66.66h1.45l.12.17a.58.58,0,0,0,.38.66h.06c.11.06,6.36,0,6.36,0a.75.75,0,0,0,.77-.49ZM27,32.25l-2.78-4.88h6.47m-7.56,4.88,2.61,3.14L27,32.25h6.76"
  }));
};
IconLightSwitchOff.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconLightSwitchOn = function IconLightSwitchOn(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconLightSwitchOn"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    d: "M33.75,21.58c0,.11-.07.17-.12.28l-3,4.81v7a.6.6,0,0,1-.16.44.66.66,0,0,1-.44.17H23.79a.68.68,0,0,1-.67-.67V18.93a.67.67,0,0,1,.67-.66h1.44l.1-.17a.79.79,0,0,1,.39-.66h.06c.11-.06,6.36,0,6.36,0,.38,0,.71.1.77.49l.77,3.21A.44.44,0,0,1,33.75,21.58ZM35.28,8.2H18a4.6,4.6,0,0,0-4.6,4.6V41.2A4.61,4.61,0,0,0,18,45.81H35.35A4.61,4.61,0,0,0,40,41.2V12.8a4.62,4.62,0,0,0-4.6-4.61h-.07ZM33,17.93a.75.75,0,0,0-.77-.49s-6.25-.06-6.36,0h-.06a.58.58,0,0,0-.38.66l-.12.17H23.84a.66.66,0,0,0-.66.66V33.64a.67.67,0,0,0,.66.66H30a.66.66,0,0,0,.44-.17.6.6,0,0,0,.16-.44v-7l3-4.81c0-.05,0-.16.11-.27a.59.59,0,0,0,.06-.45Zm-2.3,8.7H24.21L27,21.75m6.76,0H27l-1.26-3.14-2.61,3.14m24.57-4.67-4,4.06m7.58,6.59H45.62m2.84,9.58L44.4,33.25M10.29,21.14l-4-4.06M8.38,27.73H2.71M9.6,33.25,5.54,37.31"
  }));
};
IconLightSwitchOn.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconLightbulb0 = function IconLightbulb0(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconLightbulb0"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    d: "M20,40v4c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2v-4H20z M34,40c0-1,0-4,0-6c0-5.4,7-5.6,7-15c0-7.7-6.3-14-14-14 s-14,6.3-14,14c0,9.6,7,10.7,7,15c0,1.3,0,6,0,6 M30,46c0,1.7-1.3,3-3,3s-3-1.3-3-3 M27,24v13 M23,20l4,4l4-4"
  }));
};
IconLightbulb0.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconLightbulb100 = function IconLightbulb100(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconLightbulb100"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    d: "M20,40v4c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2v-4H20z M34,40c0-1,0-4,0-6c0-5.4,7-5.6,7-15c0-7.7-6.3-14-14-14 s-14,6.3-14,14c0,9.6,7,10.7,7,15c0,1.3,0,6,0,6 M30,46c0,1.7-1.3,3-3,3s-3-1.3-3-3 M27,24v13 M23,20l4,4l4-4 M6.8,4.2l5.3,5.2 M2.2,18h7.4 M5.9,30.5l5.2-5.3 M47.2,4.6L42,9.9 M51.9,18.5h-7.4 M48.2,31l-5.3-5.3"
  }));
};
IconLightbulb100.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconLightning = function IconLightning(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconLightning"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M26.81,2a1,1,0,0,0-.75.62l-10,24a1,1,0,0,0,.1.94A1,1,0,0,0,17,28h7.62L17.15,50.42l-.09.25a1,1,0,0,0,1.78.88l19-29a1,1,0,0,0,0-1A1,1,0,0,0,37,21H29.53L37.4,3.39A1,1,0,0,0,36.5,2H26.81Z"
  }));
};
IconLightning.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconListUl = function IconListUl(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconListUl"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M13,22H49M5,20H9v4H5Zm8-8H49M5,10H9v4H5Zm8,22H49M5,30H9v4H5Zm8,12H49M5,40H9v4H5Z"
  }));
};
IconListUl.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconLocation = function IconLocation(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconLocation"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M27,2.8a14,14,0,0,0-13.9,14c0,6.4,3.3,13.7,6.6,19.5a98.11,98.11,0,0,0,6.6,10.1,1,1,0,0,0,1.3.2l.2-.2a107.6,107.6,0,0,0,6.6-10.2C37.7,30.4,41,23.1,41,16.8A14.11,14.11,0,0,0,27,2.8Zm0,9.9a5,5,0,1,1-5,5A5,5,0,0,1,27,12.7ZM17.2,36.9a41,41,0,0,0-9.9,2.4,9.55,9.55,0,0,0-3,1.8A4.07,4.07,0,0,0,3,43.7,4.25,4.25,0,0,0,5.2,47a18.06,18.06,0,0,0,5.2,2.2,63.81,63.81,0,0,0,16.6,2,59.77,59.77,0,0,0,16.6-2A16.92,16.92,0,0,0,48.8,47,4.25,4.25,0,0,0,51,43.7a3.7,3.7,0,0,0-1.2-2.5,10.86,10.86,0,0,0-3-1.8A36.77,36.77,0,0,0,36.9,37"
  }));
};
IconLocation.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconLockUnknown = function IconLockUnknown(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconLockUnknown"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M10.6,26.39a8.74,8.74,0,1,1,11.93,3.45A8.67,8.67,0,0,1,18.33,31a8.94,8.94,0,0,1-7.73-4.57m7.32-9.31v7.15M18,25.68a.55.55,0,0,0-.51.36.54.54,0,0,0,.36.5H18c.22,0,.36-.21.36-.5A.34.34,0,0,0,18,25.68Zm9-2.43H41.06a1.45,1.45,0,0,1,1.44,1.44V42a1.44,1.44,0,0,1-1.44,1.44H17.94A1.44,1.44,0,0,1,16.5,42V30.73m20.94-7.48V18.92a7.85,7.85,0,0,0-7.94-8c-3.12.11-4.09.74-6.37,3.07m8.54,17.88a2.17,2.17,0,0,0-4.34,0,2.08,2.08,0,0,0,.73,1.59v2a1.44,1.44,0,1,0,2.88,0v-2A2.08,2.08,0,0,0,31.67,31.92Z"
  }));
};
IconLockUnknown.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconLocked = function IconLocked(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconLocked"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M11,50.5a2,2,0,0,1-2-2v-24a2,2,0,0,1,2-2H43a2,2,0,0,1,2,2v24a2,2,0,0,1-2,2Zm27-28v-6a11,11,0,0,0-22,0v6m14,12a3,3,0,0,0-6,0,2.87,2.87,0,0,0,1,2.2v2.8a2,2,0,0,0,4,0V36.7A2.87,2.87,0,0,0,30,34.5Z"
  }));
};
IconLocked.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconUnlocked = function IconUnlocked(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconUnlocked"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M10,52a2,2,0,0,1-2-2V26a2,2,0,0,1,2-2H42a2,2,0,0,1,2,2V50a2,2,0,0,1-2,2ZM35.6,16.1s-1.1-3.6-1.3-4.3a11,11,0,0,0-21.1,6.5C13.6,19.4,15,24,15,24M29,36a3,3,0,0,0-6,0,2.87,2.87,0,0,0,1,2.2V41a2,2,0,0,0,4,0V38.2A2.87,2.87,0,0,0,29,36Z"
  }));
};
IconUnlocked.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconMicrophone = function IconMicrophone(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 658 1024"
  }, props, {
    "data-component-name": "IconMicrophone"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M658.286 402.286v73.142q0 126.286-84.286 219.714t-208.286 107.142v75.428h146.286q14.858 0 25.714 10.858t10.858 25.714-10.858 25.714-25.714 10.858h-365.714q-14.858 0-25.714-10.858t-10.858-25.714 10.858-25.714 25.714-10.858h146.286v-75.428q-124-13.714-208.286-107.142t-84.286-219.714v-73.142q0-14.858 10.858-25.714t25.714-10.858 25.714 10.858 10.858 25.714v73.142q0 105.714 75.142 180.858t180.858 75.142 180.858-75.142 75.142-180.858v-73.142q0-14.858 10.858-25.714t25.714-10.858 25.714 10.858 10.858 25.714zm-146.286-219.428v292.572q0 75.428-53.714 129.142t-129.142 53.714-129.142-53.714-53.714-129.142v-292.572q0-75.428 53.714-129.142t129.142-53.714 129.142 53.714 53.714 129.142z"
  }));
};
IconMicrophone.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconMinusSign = function IconMinusSign(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 876 1024"
  }, props, {
    "data-component-name": "IconMinusSign"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M694 548.572v-73.142q0-14.858-10.858-25.714t-25.714-10.858h-438.858q-14.858 0-25.714 10.858t-10.858 25.714v73.142q0 14.858 10.858 25.714t25.714 10.858h438.858q14.858 0 25.714-10.858t10.858-25.714zm182.856-36.572q0 119.428-58.858 220.286t-159.714 159.714-220.286 58.858-220.286-58.858-159.714-159.714-58.858-220.286 58.858-220.286 159.714-159.714 220.286-58.858 220.286 58.858 159.714 159.714 58.858 220.286z"
  }));
};
IconMinusSign.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconMinus = function IconMinus(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconMinus"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M778.188 460.8h-532.428c-28.314 0-30.72 22.938-30.72 51.2s2.406 51.2 30.72 51.2h532.428c28.314 0 30.772-22.938 30.772-51.2s-2.458-51.2-30.772-51.2z"
  }));
};
IconMinus.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconMoon = function IconMoon(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconMoon"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M42.88,34a16.76,16.76,0,0,1-15.17,9.7,16.33,16.33,0,0,1-6.48-1.32,17.13,17.13,0,0,1-5.34-3.57,16.88,16.88,0,0,1-3.56-5.33A16.21,16.21,0,0,1,11,27a16.48,16.48,0,0,1,1.25-6.37,16.21,16.21,0,0,1,8.52-8.83,16.44,16.44,0,0,1,6.31-1.49,1.26,1.26,0,0,1,1.33.85,1.27,1.27,0,0,1-.33,1.56,11.82,11.82,0,0,0-2.26,14.65,11.8,11.8,0,0,0,4.31,4.31,11.78,11.78,0,0,0,10.9.48,1.3,1.3,0,0,1,1.57.28,1.35,1.35,0,0,1,.38.74,1.38,1.38,0,0,1-.1.83Z"
  }));
};
IconMoon.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconMouseTrapArmed = function IconMouseTrapArmed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconMouseTrapArmed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", null, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "27",
    y1: "11.7",
    x2: "27",
    y2: "9"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", null, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M12.6,28.2V10c0-0.9,0.7-1.6,1.7-1.6h16.9"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M31.1,8.4h8.6c0.9,0,1.6,0.7,1.6,1.6v18.2"
  })), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M10.6,48.6h32.7c0.9,0,1.7-0.7,1.7-1.6V7c0-0.9-0.7-1.6-1.6-1.6H10.6C9.7,5.4,9,6.1,9,7v40 C9,47.9,9.7,48.6,10.6,48.6z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "15.3",
    y1: "27.9",
    x2: "17.1",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "18.9",
    y1: "27.9",
    x2: "20.7",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "22.5",
    y1: "27.9",
    x2: "24.3",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "26.1",
    y1: "27.9",
    x2: "27.9",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "29.7",
    y1: "27.9",
    x2: "31.5",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "33.3",
    y1: "27.9",
    x2: "35.1",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "36.9",
    y1: "27.9",
    x2: "38.7",
    y2: "23.4"
  })));
};
IconMouseTrapArmed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconMouseTrapDisarmed = function IconMouseTrapDisarmed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconMouseTrapDisarmed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", null, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "27",
    y1: "11.7",
    x2: "27",
    y2: "9"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", null, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M12.6,28.2V10c0-0.9,0.7-1.6,1.7-1.6h16.9"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M31.1,8.4h8.6c0.9,0,1.6,0.7,1.6,1.6v18.2"
  })), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M10.6,48.6h32.7c0.9,0,1.7-0.7,1.7-1.6V7c0-0.9-0.7-1.6-1.6-1.6H10.6C9.7,5.4,9,6.1,9,7V47 C9,47.9,9.7,48.6,10.6,48.6z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "15.3",
    y1: "27.9",
    x2: "17.1",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "18.9",
    y1: "27.9",
    x2: "20.7",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "22.5",
    y1: "27.9",
    x2: "24.3",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "26.1",
    y1: "27.9",
    x2: "27.9",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "29.7",
    y1: "27.9",
    x2: "31.5",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "33.3",
    y1: "27.9",
    x2: "35.1",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "36.9",
    y1: "27.9",
    x2: "38.7",
    y2: "23.4"
  })), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "3.5",
    y1: "2.5",
    x2: "51.2",
    y2: "50.2"
  }));
};
IconMouseTrapDisarmed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconMouseTrapTripped = function IconMouseTrapTripped(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconMouseTrapTripped"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", null, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "27",
    y1: "11.7",
    x2: "27",
    y2: "9"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M22.9,43.2h-8.6c-0.9,0-1.7-0.7-1.7-1.6V23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M41.4,23.4v18.2c0,0.9-0.7,1.6-1.6,1.6h-8.6"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M10.6,48.6h32.7c0.9,0,1.7-0.7,1.7-1.6V7c0-0.9-0.7-1.6-1.6-1.6H10.6C9.7,5.4,9,6.1,9,7v40 C9,47.9,9.7,48.6,10.6,48.6z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "15.3",
    y1: "27.9",
    x2: "17.1",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "18.9",
    y1: "27.9",
    x2: "20.7",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "22.5",
    y1: "27.9",
    x2: "24.3",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "26.1",
    y1: "27.9",
    x2: "27.9",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "29.7",
    y1: "27.9",
    x2: "31.5",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "33.3",
    y1: "27.9",
    x2: "35.1",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    x1: "36.9",
    y1: "27.9",
    x2: "38.7",
    y2: "23.4"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M32,33.3c-1.7,0-3.2,1.4-3.2,3.2c0,0.3,0.1,0.6,0.2,0.9c-0.6-0.3-1.2-0.5-2-0.5s-1.4,0.2-2,0.5 c0.1-0.3,0.2-0.6,0.2-0.9c0-1.7-1.4-3.2-3.2-3.2s-3.1,1.4-3.1,3.2c0,1.7,1.4,3.1,3.1,3.1c0.3,0,0.6-0.1,0.9-0.2 c-0.3,0.6-0.5,1.2-0.5,2c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5c0-0.7-0.2-1.4-0.5-2c0.3,0.1,0.6,0.2,0.9,0.2c1.7,0,3.1-1.4,3.1-3.1 C35.1,34.7,33.7,33.3,32,33.3z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("circle", {
    cx: "27",
    cy: "43.2",
    r: "0.9"
  })));
};
IconMouseTrapTripped.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconMovie = function IconMovie(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconMovie"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M52.39,51.35c-.63-3.2-.19-7.45-.07-12.29.16-7.28-.66-16-7.66-24.52A44.09,44.09,0,0,0,38,8a21.31,21.31,0,0,0-2.12-1.67h-.07a22,22,0,1,0,9.74,18.21M23.71,22.72a1.77,1.77,0,1,0,1.77,1.77A1.77,1.77,0,0,0,23.71,22.72ZM23.65,10.8a5.72,5.72,0,0,0-3.14.68,3.14,3.14,0,0,0-1.25,2.72,4.49,4.49,0,0,0,1.79,3.24,7.46,7.46,0,0,0,1.33.91,2.16,2.16,0,0,0,2.56,0,7.46,7.46,0,0,0,1.33-.91,4.49,4.49,0,0,0,1.79-3.24,3.14,3.14,0,0,0-1.25-2.69A5.62,5.62,0,0,0,23.65,10.8Zm-9.57,6.26a2.44,2.44,0,0,0-1.35.54,5.68,5.68,0,0,0-1.65,2.81,5.54,5.54,0,0,0-.28,3.22,3.12,3.12,0,0,0,2.17,2,4.44,4.44,0,0,0,3.62-.74,7.62,7.62,0,0,0,1.28-1,2.3,2.3,0,0,0,.79-2.45,7.37,7.37,0,0,0-.49-1.55,4.36,4.36,0,0,0-2.5-2.71A3.9,3.9,0,0,0,14,17.06Zm18.37,0a2.94,2.94,0,0,0-.78.17h0a4.39,4.39,0,0,0-2.5,2.68,7.78,7.78,0,0,0-.5,1.55,2.46,2.46,0,0,0,0,1.37,2.36,2.36,0,0,0,.77,1.05,7.64,7.64,0,0,0,1.29,1,4.4,4.4,0,0,0,3.62.73,3.11,3.11,0,0,0,2.17-2,5.5,5.5,0,0,0-.29-3.13,5.61,5.61,0,0,0-1.6-2.8,2.63,2.63,0,0,0-1.39-.54,3.93,3.93,0,0,0-.84,0ZM29,28.23a5.08,5.08,0,0,0-.78,0,2.48,2.48,0,0,0-1.29.4,2.59,2.59,0,0,0-.81,1.09,8,8,0,0,0-.54,1.51A4.47,4.47,0,0,0,26,35a3.14,3.14,0,0,0,2.61,1.47,5.44,5.44,0,0,0,3-1.29,5.47,5.47,0,0,0,2.21-2.38,3.13,3.13,0,0,0-.58-2.91h0a4.42,4.42,0,0,0-3.38-1.61,7.42,7.42,0,0,0-.82,0Zm-10.76.14a8.52,8.52,0,0,0-.87.08,4.38,4.38,0,0,0-3.26,1.73,3.18,3.18,0,0,0-.45,3A5.65,5.65,0,0,0,16,35.44a5.55,5.55,0,0,0,3,1.16A3.18,3.18,0,0,0,21.49,35a4.34,4.34,0,0,0,.26-3.67,7.75,7.75,0,0,0-.61-1.53,2.45,2.45,0,0,0-.86-1A2.33,2.33,0,0,0,19,28.45a4.13,4.13,0,0,0-.78-.08ZM45.55,25a21.1,21.1,0,0,0-7.3-16.89"
  }));
};
IconMovie.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconMusic = function IconMusic(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconMusic"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M47,5V40s-.12,6-7,6c-7.51,0-8-4.87-8-6,0-2.41.94-5,8-5,3.25,0,4-.84,4-3V15.21c0-1.32-.08-1.79-1.54-1.46-2.52.57-19,4.13-19.62,4.29s-.84.55-.84,1.7V45c0,2.26-1.74,6-8,6s-7-4-7-6c0-3,2.25-4.89,7-4.89,4.43,0,5-1.25,5-3.11V10a1.63,1.63,0,0,1,1.37-1.82C22,7.81,45.14,3,45.14,3S47,2.61,47,5Z"
  }));
};
IconMusic.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconNestAwayIcon = function IconNestAwayIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1067 1024"
  }, props, {
    "data-component-name": "IconNestAwayIcon"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M535.467 230.4l-448 354.133v418.133c0 12.8 8.533 21.333 21.333 21.333h853.333c12.8 0 21.333-8.533 21.333-21.333v-416l-448-356.267zm238.933 221.867c29.867 0 53.333 23.467 53.333 53.333s-23.467 53.333-53.333 53.333c-29.867 0-53.333-23.467-53.333-53.333s25.6-53.333 53.333-53.333zm-78.933 443.733c-2.133 6.4-6.4 12.8-12.8 21.333-10.667 12.8-44.8 59.733-53.333 70.4s-23.467 27.733-40.533 14.933c-14.933-12.8-8.533-27.733 0-42.667 12.8-17.067 57.6-81.067 57.6-81.067l21.333-74.667 40.533 57.6c-4.267 10.667-10.667 27.733-12.8 34.133zm215.466-134.4c-6.4 10.667-21.333 8.533-34.133 4.267-14.933-6.4-61.867-27.733-70.4-32s-10.667-6.4-14.933-10.667c-6.4-10.667-19.2-27.733-19.2-27.733l-17.067 76.8s104.533 170.667 113.067 185.6 10.667 36.267-4.267 44.8c-19.2 10.667-32 2.133-44.8-17.067-12.8-17.067-117.333-181.333-125.867-194.133s-19.2-29.867-14.933-53.333c2.133-12.8 10.667-51.2 17.067-87.467l-46.933 36.267s-14.933 83.2-17.067 91.733c-2.133 10.667-14.933 14.933-21.333 12.8-10.667-2.133-19.2-8.533-17.067-25.6l14.933-102.4c2.133-8.533 6.4-12.8 12.8-17.067l70.4-59.733c8.533-4.267 12.8-10.667 27.733-10.667h25.6c17.067 0 25.6 6.4 36.267 34.133 12.8 27.733 36.267 81.067 36.267 81.067s68.267 34.133 78.933 38.4c12.8 8.533 21.333 21.333 14.933 32zm147.2-352l-512-405.333c-6.4-6.4-17.067-6.4-25.6 0l-512 405.333c-6.4 4.267-8.533 10.667-8.533 17.067v128c0 8.533 6.4 14.933 12.8 19.2 8.533 4.267 17.067 2.133 23.467-2.133l499.2-394.667 499.2 394.667c4.267 2.133 8.533 4.267 12.8 4.267 2.133 0 6.4 0 6.4-2.133 8.533-4.267 12.8-10.667 12.8-19.2v-128c0-6.4-4.267-12.8-8.533-17.067z"
  }));
};
IconNestAwayIcon.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconNestHomeIcon = function IconNestHomeIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1067 1024"
  }, props, {
    "data-component-name": "IconNestHomeIcon"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M1047.467 576c-4.267 0-8.533-2.133-12.8-4.267l-499.2-394.667-499.2 394.667c-6.4 4.267-14.933 6.4-23.467 2.133-6.4-4.267-12.8-10.667-12.8-19.2v-128c0-6.4 2.133-12.8 8.533-17.067l512-405.333c8.533-6.4 19.2-6.4 25.6 0l512 405.333c4.267 4.267 8.533 10.667 8.533 17.067v128c0 8.533-4.267 14.933-12.8 19.2 0 2.133-4.267 2.133-6.4 2.133zm-512-345.6l-448 354.133v418.133c0 12.8 8.533 21.333 21.333 21.333h256c12.8 0 21.333-8.533 21.333-21.333v-249.6c0-81.067 61.867-149.333 140.8-155.733 87.467-6.4 157.867 64 157.867 149.333v256c0 12.8 8.533 21.333 21.333 21.333h256c12.8 0 21.333-8.533 21.333-21.333v-416l-448-356.267z"
  }));
};
IconNestHomeIcon.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconNestUnknownIcon = function IconNestUnknownIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1067 1024"
  }, props, {
    "data-component-name": "IconNestUnknownIcon"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M535.467 230.4l-448 354.133v418.133c0 12.8 8.533 21.333 21.333 21.333h853.333c12.8 0 21.333-8.533 21.333-21.333v-416l-448-356.267zm44.8 759.467c-2.133 6.4-6.4 12.8-12.8 12.8h-51.2c-6.4 0-12.8-6.4-12.8-12.8v-51.2c0-6.4 6.4-12.8 12.8-12.8h51.2c6.4 0 12.8 6.4 12.8 12.8v51.2zm42.666-285.867c-27.733 14.933-44.8 42.667-44.8 72.533v74.667c0 14.933-10.667 25.6-25.6 25.6h-25.6c-14.933 0-25.6-10.667-25.6-25.6v-74.667c0-59.733 34.133-113.067 87.467-140.8 36.267-21.333 57.6-59.733 53.333-102.4-6.4-46.933-42.667-85.333-89.6-89.6-2.133-2.133-6.4-2.133-10.667-2.133-25.6 0-49.067 8.533-68.267 25.6-21.333 21.333-34.133 46.933-34.133 76.8 0 14.933-10.667 25.6-25.6 25.6h-25.6c-14.933 0-25.6-10.667-25.6-25.6 0-51.2 21.333-98.133 59.733-132.267 32-27.733 74.667-44.8 119.467-44.8 6.4 0 12.8 0 19.2 2.133 81.067 8.533 147.2 74.667 155.733 157.867 8.533 72.533-29.867 142.933-93.867 177.067zm443.734-277.333v128c0 8.533-4.267 14.933-12.8 19.2 0 2.133-4.267 2.133-6.4 2.133-4.267 0-8.533-2.133-12.8-4.267l-499.2-394.667-499.2 394.667c-6.4 4.267-14.933 6.4-23.467 2.133-6.4-4.267-12.8-10.667-12.8-19.2v-128c0-6.4 2.133-12.8 8.533-17.067l512-405.333c8.533-6.4 19.2-6.4 25.6 0l512 405.333c4.267 4.267 8.533 10.667 8.533 17.067z"
  }));
};
IconNestUnknownIcon.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconNewspaper = function IconNewspaper(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconNewspaper"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M49,37.5l-12,12H7a2,2,0,0,1-2-2V6.5l3,3,3-3,4,3,4-3,4,3,4-3,4,3,4-3,4,3,4.1-3,3,3,2.9-3Zm-38-22H43v4H11Zm18,10H44m-15,4H44m-15,4H44m-34,8H25m4-4h6m-6,4h6m-24-16H24v12H11Zm26,24v-12H49"
  }));
};
IconNewspaper.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconNexiaLogo = function IconNexiaLogo(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconNexiaLogo"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    d: "M26,22.06h9.36l-1.21,2.45.58.39,7,0L33.05,7.49l-4,9.82m.8,4.74-1.35-8-7.82,4.45L26,22.06m8.73,2.85-.58-.39-.19.39-2.11,4.28L31,30.8l.4,5.94,11.23-6.47ZM26,22.06H11.34l12,24.46L31,30.8"
  }));
};
IconNexiaLogo.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconPencil = function IconPencil(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconPencil"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    strokeWidth: "2px",
    d: "M6,49a1,1,0,0,1-.71-.3,1,1,0,0,1-.23-1.05l3.3-8.8a1,1,0,0,1,.23-.36L40,7.19a1,1,0,0,1,1.42,0l5.5,5.5a1,1,0,0,1,0,1.42l-31.4,31.4a1.1,1.1,0,0,1-.37.23l-8.8,3.2A1,1,0,0,1,6,49Zm4.16-9.25L7.7,46.32l6.55-2.38L44.79,13.4,40.7,9.31ZM46.31,13.51l-1.42-1.42,1.5-1.5a2.12,2.12,0,0,0,0-3,2.17,2.17,0,0,0-3,0l-1.5,1.5L40.49,7.69,42,6.19A4.12,4.12,0,0,1,47.81,12ZM42,18.4a1,1,0,0,1-.7-.29l-5.4-5.3a1,1,0,0,1,1.4-1.42l5.4,5.3a1,1,0,0,1,0,1.41A1,1,0,0,1,42,18.4ZM14.6,45.6a1,1,0,0,1-.71-.29l-1.6-1.6A1,1,0,0,1,12,43V42H11a1,1,0,0,1-.68-.27l-1.6-1.5a1,1,0,0,1,1.36-1.46L11.4,40H13a1,1,0,0,1,1,1v1.59l1.31,1.3a1,1,0,0,1,0,1.42A1,1,0,0,1,14.6,45.6ZM7.3,44,10,46.8l-3.5.7Z"
  }));
};
IconPencil.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconPhone = function IconPhone(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconPhone"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M14.81,4A1,1,0,0,0,14,5V44a5.84,5.84,0,0,0,2.09,4.41A6.18,6.18,0,0,0,20,50H35a5,5,0,0,0,5-5V14a5,5,0,0,0-5-5H19V5a1,1,0,0,0-1-1H14.81ZM21,14a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3H33a3,3,0,0,0,3-3V17a3,3,0,0,0-3-3Zm0,17a2,2,0,1,0,2,2A2,2,0,0,0,21,31Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,27,31Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,33,31ZM21,37a2,2,0,1,0,2,2A2,2,0,0,0,21,37Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,27,37Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,33,37ZM21,43a2,2,0,1,0,2,2A2,2,0,0,0,21,43Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,27,43Zm6,0a2,2,0,1,0,2,2A2,2,0,0,0,33,43Z"
  }));
};
IconPhone.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconPlane = function IconPlane(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconPlane"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M48.51,2.1a8.13,8.13,0,0,0-1,.15,16.89,16.89,0,0,0-4,1.57A26.13,26.13,0,0,0,37.42,8h0l-6.75,6.71-24-3.25a1,1,0,0,0-.85.32l-3.4,3.5a1,1,0,0,0,.34,1.62l18.5,7.25L11.7,33.91H7.1a1,1,0,0,0-.65.25l-4,3.38a1,1,0,0,0-.35,1,1,1,0,0,0,.75.75l9.54,2.34,2.34,9.53a1,1,0,0,0,.67.7,1,1,0,0,0,1-.2l3.41-3a1,1,0,0,0,.34-.75V42.32l9.82-9.53,7.15,18.5a1,1,0,0,0,.73.6,1,1,0,0,0,.9-.26l3.5-3.41a1,1,0,0,0,.31-.84l-3.25-24L46,16.63a29.26,29.26,0,0,0,4.19-6.19,16.33,16.33,0,0,0,1.56-4,3.83,3.83,0,0,0-.62-3.56l0,0a2.85,2.85,0,0,0-1.65-.75A4.21,4.21,0,0,0,48.51,2.1Z"
  }));
};
IconPlane.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconPlusSign = function IconPlusSign(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 876 1024"
  }, props, {
    "data-component-name": "IconPlusSign"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M694 548.572v-73.142q0-14.858-10.858-25.714t-25.714-10.858h-146.286v-146.286q0-14.858-10.858-25.714t-25.714-10.858h-73.142q-14.858 0-25.714 10.858t-10.858 25.714v146.286h-146.286q-14.858 0-25.714 10.858t-10.858 25.714v73.142q0 14.858 10.858 25.714t25.714 10.858h146.286v146.286q0 14.858 10.858 25.714t25.714 10.858h73.142q14.858 0 25.714-10.858t10.858-25.714v-146.286h146.286q14.858 0 25.714-10.858t10.858-25.714zm182.856-36.572q0 119.428-58.858 220.286t-159.714 159.714-220.286 58.858-220.286-58.858-159.714-159.714-58.858-220.286 58.858-220.286 159.714-159.714 220.286-58.858 220.286 58.858 159.714 159.714 58.858 220.286z"
  }));
};
IconPlusSign.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconPlus = function IconPlus(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconPlus"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M778.188 460.8h-215.04v-215.04c0-28.262-22.886-30.72-51.2-30.72-28.262 0-51.2 2.406-51.2 30.72v215.04h-214.988c-28.314 0-30.72 22.938-30.72 51.2s2.406 51.2 30.72 51.2h214.988v215.04c0 28.262 22.938 30.72 51.2 30.72 28.314 0 51.2-2.458 51.2-30.72v-215.04h215.04c28.314 0 30.772-22.938 30.772-51.2s-2.458-51.2-30.772-51.2z"
  }));
};
IconPlus.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconQuestion = function IconQuestion(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconQuestion"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M721.408 114.38c-58.42-42.136-131.686-63.18-219.956-63.18-67.174 0-123.8 14.848-169.83 44.442-73.062 46.386-111.872 125.132-116.582 236.236h169.268c0-32.358 9.42-63.54 28.314-93.542s50.944-45.004 96.154-45.004c45.926 0 77.62 12.186 94.924 36.506 17.356 24.422 26.01 51.404 26.01 80.998 0 25.754-12.902 49.306-28.468 70.758-8.55 12.492-19.866 23.962-33.844 34.508 0 0-91.802 58.88-132.148 106.188-23.398 27.444-25.498 68.506-27.546 127.436-.154 4.198 1.434 12.852 16.128 12.852h131.686s15.77-9.676 15.974-13.926c.922-21.452 3.328-32.41 7.27-44.8 7.424-23.398 27.494-43.828 50.124-61.388l46.592-32.154c42.036-32.768 75.622-59.648 90.42-80.742 25.296-34.714 43.062-77.414 43.062-128.052 0-82.688-29.236-145.048-87.552-187.136zm-222.668 649.728c-58.368-1.74-106.496 38.604-108.34 101.888-1.844 63.232 43.93 105.012 102.298 106.752 60.928 1.792 107.776-37.274 109.62-100.506 1.79-63.282-42.65-106.342-103.578-108.134z"
  }));
};
IconQuestion.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconQuestionCommercial = function IconQuestionCommercial(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 64 64"
  }, props, {
    "data-component-name": "IconQuestionCommercial"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", {
    id: "IconQuestionCommercial"
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M32,63.5a31.5,31.5,0,0,1,0-63,31.5,31.5,0,0,1,0,63ZM32,3.31a28.69,28.69,0,0,0,0,57.38A28.69,28.69,0,0,0,32,3.31Z"
  })), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M43.62,16.93a9.5,9.5,0,0,0-2.77-3.61A14.58,14.58,0,0,0,37,11.24a14.44,14.44,0,0,0-4.61-.8,14.74,14.74,0,0,0-5.55,1,12.74,12.74,0,0,0-4.22,2.79A11.8,11.8,0,0,0,20,18.67a12.23,12.23,0,0,0-.66,5.52l.12,1.63h6.8l-.22-1.95a7,7,0,0,1,.33-2.55l.05-.23a5.93,5.93,0,0,1,1.19-2.27,4.52,4.52,0,0,1,1.94-1.46,7.63,7.63,0,0,1,3-.58,7.29,7.29,0,0,1,2.24.47,3,3,0,0,1,1.55.84A11.9,11.9,0,0,1,37.69,20a4.67,4.67,0,0,1,.37,2.05,5.17,5.17,0,0,1-.75,2.8l0,.09a7.82,7.82,0,0,1-2,2.42c-1.17,1-2,1.91-2.89,2.78l-.11.12a15.92,15.92,0,0,0-2,2.89l-.2.45a10.92,10.92,0,0,0-.91,2.91,12.57,12.57,0,0,0-.32,3.62v1.76h6.72V40.17a14.87,14.87,0,0,1,.12-2.68l0-.17V37.2a3,3,0,0,1,.38-1.34,3.63,3.63,0,0,1,1-1.3l2.6-2.62a22.68,22.68,0,0,0,3.47-4.3,10.91,10.91,0,0,0,1.5-5.84A11,11,0,0,0,43.62,16.93Zm-2,9.82a20.53,20.53,0,0,1-3.21,3.95c-1.11,1.14-2,2-2.51,2.55a5.33,5.33,0,0,0-1.4,1.83A4.76,4.76,0,0,0,34,37.2a17.83,17.83,0,0,0-.13,3H30.6a10.75,10.75,0,0,1,.28-3.25,10.58,10.58,0,0,1,1-3,14.69,14.69,0,0,1,1.82-2.54c.83-.85,1.67-1.69,2.79-2.68a9.66,9.66,0,0,0,2.37-3,6.88,6.88,0,0,0,1-3.67,6.4,6.4,0,0,0-.56-2.83A12.85,12.85,0,0,0,37.72,17a4.4,4.4,0,0,0-2.37-1.41A8.71,8.71,0,0,0,32.56,15a9.13,9.13,0,0,0-3.63.71,6.17,6.17,0,0,0-2.65,2,7.42,7.42,0,0,0-1.54,3,9,9,0,0,0-.42,3.39H21.11a10.58,10.58,0,0,1,.56-4.8,10.21,10.21,0,0,1,2.23-3.82A11.21,11.21,0,0,1,27.53,13a13.26,13.26,0,0,1,4.89-.84,12.94,12.94,0,0,1,4,.7,13,13,0,0,1,3.35,1.84,7.85,7.85,0,0,1,2.23,3,9.27,9.27,0,0,1,.84,4.09A9.27,9.27,0,0,1,41.63,26.75Z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M32,44.74a4.41,4.41,0,1,0,4.4,4.41A4.42,4.42,0,0,0,32,44.74Zm0,7.07a2.66,2.66,0,1,1,2.66-2.66A2.66,2.66,0,0,1,32,51.81Z"
  }));
};
IconQuestionCommercial.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconRefresh = function IconRefresh(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconRefresh"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M42.38,10,38,15l9,1L45,7,42.42,10A23,23,0,1,0,50,27"
  }));
};
IconRefresh.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconPivotRefresh = function IconPivotRefresh(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 64 64"
  }, props, {
    "data-component-name": "IconPivotRefresh"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M.5,32A31.46,31.46,0,0,1,53.6,9.12V5.24a2.69,2.69,0,0,1,.64-1.83A2.17,2.17,0,0,1,56,2.64a2.49,2.49,0,0,1,1.83.74,2.51,2.51,0,0,1,.78,1.81L58.5,16.41A2.53,2.53,0,0,1,56,18.94L44.76,19a2.51,2.51,0,0,1-1.82-.78,2.42,2.42,0,0,1-.75-1.82A2.17,2.17,0,0,1,43,14.68,2.84,2.84,0,0,1,44.8,14h3.35a24.16,24.16,0,1,0,8,18,3.66,3.66,0,1,1,7.32,0,31.5,31.5,0,0,1-63,0Z"
  }));
};
IconPivotRefresh.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconRemote = function IconRemote(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 19 44"
  }, props, {
    "data-component-name": "IconRemote"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M16.5,44h-14C1.1,44,0,42.9,0,41.5v-30C0,10.1,1.1,9,2.5,9h14c1.4,0,2.5,1.1,2.5,2.5v30C19,42.9,17.9,44,16.5,44z M2.5,10 C1.7,10,1,10.7,1,11.5v30C1,42.3,1.7,43,2.5,43h14c0.8,0,1.5-0.7,1.5-1.5v-30c0-0.8-0.7-1.5-1.5-1.5H2.5z M15.1,41.2h-11v-6.6 l5.5-3.3l5.5,3.3V41.2z M5.1,40.2h9v-5l-4.5-2.7l-4.5,2.7V40.2z M9.6,29.7l-5.5-5.3l0.7-0.7l4.7,4.7l4.6-4.6l0.7,0.7L9.6,29.7z M4.9,19l-0.7-0.7l5.5-5.3l5.3,5.4L14.2,19l-4.6-4.6L4.9,19z M13.6,6.7C12.6,5.6,11,5,9.5,5C7.9,5,6.6,5.6,5.6,6.6L4.8,6 C6,4.7,7.6,4,9.5,4c1.8,0,3.6,0.7,4.9,1.9L13.6,6.7z M2.6,4L1.8,3.4C3.9,1.2,6.6,0,9.5,0c2.9,0,5.6,1.2,7.6,3.4L16.3,4 c-1.8-2-4.2-3-6.8-3C6.9,1,4.4,2.1,2.6,4z"
  }));
};
IconRemote.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconRemoveSign = function IconRemoveSign(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 876 1024"
  }, props, {
    "data-component-name": "IconRemoveSign"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M655.714 641.142q0-14.858-10.858-25.714l-103.428-103.428 103.428-103.428q10.858-10.858 10.858-25.714 0-15.428-10.858-26.286l-51.428-51.428q-10.858-10.858-26.286-10.858-14.858 0-25.714 10.858l-103.428 103.428-103.428-103.428q-10.858-10.858-25.714-10.858-15.428 0-26.286 10.858l-51.428 51.428q-10.858 10.858-10.858 26.286 0 14.858 10.858 25.714l103.428 103.428-103.428 103.428q-10.858 10.858-10.858 25.714 0 15.428 10.858 26.286l51.428 51.428q10.858 10.858 26.286 10.858 14.858 0 25.714-10.858l103.428-103.428 103.428 103.428q10.858 10.858 25.714 10.858 15.428 0 26.286-10.858l51.428-51.428q10.858-10.858 10.858-26.286zm221.142-129.142q0 119.428-58.858 220.286t-159.714 159.714-220.286 58.858-220.286-58.858-159.714-159.714-58.858-220.286 58.858-220.286 159.714-159.714 220.286-58.858 220.286 58.858 159.714 159.714 58.858 220.286z"
  }));
};
IconRemoveSign.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconRemove = function IconRemove(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 804 1024"
  }, props, {
    "data-component-name": "IconRemove"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M741.428 755.428q0 22.858-16 38.858l-77.714 77.714q-16 16-38.858 16t-38.858-16l-168-168-168 168q-16 16-38.858 16t-38.858-16l-77.714-77.714q-16-16-16-38.858t16-38.858l168-168-168-168q-16-16-16-38.858t16-38.858l77.714-77.714q16-16 38.858-16t38.858 16l168 168 168-168q16-16 38.858-16t38.858 16l77.714 77.714q16 16 16 38.858t-16 38.858l-168 168 168 168q16 16 16 38.858z"
  }));
};
IconRemove.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconPivotRemove = function IconPivotRemove(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 64 64"
  }, props, {
    "data-component-name": "IconPivotRemove"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M6,63.5a5.45,5.45,0,0,1-3.88-9.28L24.29,32,2.14,9.85a5.45,5.45,0,0,1-.07-7.72,5.44,5.44,0,0,1,7.71-.06L32,24.29,54.15,2.14a5.45,5.45,0,1,1,7.78,7.64L39.71,32,61.86,54.15A5.46,5.46,0,0,1,58,63.5h0a5.4,5.4,0,0,1-3.82-1.57L32,39.71,9.85,61.86A5.43,5.43,0,0,1,6,63.5Z"
  }));
};
IconPivotRemove.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconHamburgerMenu = function IconHamburgerMenu(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconHamburgerMenu"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    x1: "5",
    x2: "49",
    y1: "13.5",
    y2: "13.5"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    x1: "5",
    x2: "49",
    y1: "27.0",
    y2: "27.0"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    x1: "5",
    x2: "49",
    y1: "40.5",
    y2: "40.5"
  }));
};
IconHamburgerMenu.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSamsungDryer = function IconSamsungDryer(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSamsungDryer"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M9.6,4.6H44.4V45.8H9.6ZM22.4,8.7h9.4m4.9,23.1a10.85,10.85,0,1,1-.5-11.5m-7.5,4.3s3-4.5,7.6,0c0,0,3.3,2.6,5.1-1.6M28.7,29.1s3-4.5,7.6,0c0,0,3.3,2.6,5.1-1.6"
  }));
};
IconSamsungDryer.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSamsungDryerOffline = function IconSamsungDryerOffline(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSamsungDryerOffline"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M9.6,4.6H44.4V45.8H9.6ZM22.4,8.7h9.4m4.9,23.1a10.85,10.85,0,1,1-.5-11.5m-7.5,4.3s3-4.5,7.6,0c0,0,3.3,2.6,5.1-1.6M28.7,29.1s3-4.5,7.6,0c0,0,3.3,2.6,5.1-1.6M3.5,2.5l49,49"
  }));
};
IconSamsungDryerOffline.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSamsungVacuum = function IconSamsungVacuum(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSamsungVacuum"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M27,6.4A20.6,20.6,0,1,1,6.4,27,20.6,20.6,0,0,1,27,6.4ZM17.2,8.9l2,6.9a.66.66,0,0,0,.5.4H34.1a.82.82,0,0,0,.6-.4l2.9-6.4M31.7,43.2H23c-.4,0-.3-.5-.3-.9l-.4-8a.68.68,0,0,1,.7-.7h8.7a.68.68,0,0,1,.7.7l-.3,8C32.1,42.8,32.1,43.2,31.7,43.2Zm-17.1.3s-3,4.6-4.6,5.1m30-5.3s3,4.6,4.6,5.1"
  }));
};
IconSamsungVacuum.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSamsungVacuumCharging = function IconSamsungVacuumCharging(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSamsungVacuumCharging"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M27,6.2A20.4,20.4,0,1,1,6.6,26.6,20.4,20.4,0,0,1,27,6.2ZM17.4,8.6l2,6.8a.66.66,0,0,0,.5.4H34.1a.62.62,0,0,0,.6-.4L37.5,9M31.7,42.6H23.1c-.4,0-.3-.5-.3-.9l-.4-7.9a.68.68,0,0,1,.7-.7h8.6a.68.68,0,0,1,.7.7l-.4,8C32,42.2,32,42.6,31.7,42.6Zm-17,.2s-2.9,4.5-4.6,5m29.8-5.1s2.9,4.5,4.6,5M27.18,18.1h1.46l-1.58,3.53a.19.19,0,0,0,0,.19.2.2,0,0,0,.17.09h1.43l-2.76,4.21L27,22.78a.23.23,0,0,0,0-.18.26.26,0,0,0-.16-.09H25.33Z"
  }));
};
IconSamsungVacuumCharging.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSamsungVacuumOffline = function IconSamsungVacuumOffline(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSamsungVacuumOffline"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M27,6.2A20.4,20.4,0,1,1,6.6,26.6,20.4,20.4,0,0,1,27,6.2ZM17.4,8.6l2,6.8a.66.66,0,0,0,.5.4H34.1a.62.62,0,0,0,.6-.4L37.5,9M31.7,42.6H23.1c-.4,0-.3-.5-.3-.9l-.4-7.9a.68.68,0,0,1,.7-.7h8.6a.68.68,0,0,1,.7.7l-.4,8C32,42.2,32,42.6,31.7,42.6Zm-17,.2s-2.9,4.5-4.6,5m29.8-5.1s2.9,4.5,4.6,5M7.8,5.7l41,41.4"
  }));
};
IconSamsungVacuumOffline.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSamsungWasher = function IconSamsungWasher(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSamsungWasher"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M9.6,6.45H44.4v41.1H9.6Zm12.8,4.1h9.4m-4.6,6.8a10.9,10.9,0,1,1-10.9,10.9A10.9,10.9,0,0,1,27.2,17.35Z"
  }));
};
IconSamsungWasher.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSamsungWasherOffline = function IconSamsungWasherOffline(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSamsungWasherOffline"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M9.6,6.45H44.4v41.1H9.6Zm12.8,4.1h9.4m-4.6,6.8a10.9,10.9,0,1,1-10.9,10.9A10.9,10.9,0,0,1,27.2,17.35ZM5.72,3.62l41,41.4"
  }));
};
IconSamsungWasherOffline.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSensorActivated = function IconSensorActivated(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSensorActivated"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M37.87,8.55H16.6a3.21,3.21,0,0,0-3.24,3.24V42.21a3.21,3.21,0,0,0,3.24,3.24H37.87a3.21,3.21,0,0,0,3.24-3.24V11.79a3.21,3.21,0,0,0-3.24-3.24Zm-.67,3.72c0,2.38-5.05,4.38-10,4.38s-10-2-10-4.38Zm.95,26a.82.82,0,0,1-.76.76H17.08a.82.82,0,0,1-.76-.76V23a.82.82,0,0,1,.76-.76H37.49a.82.82,0,0,1,.76.76l-.1,15.26ZM34.82,26.46v8M10,19.64,5.72,15.29m2.21,11.4H1.86M9.25,32.6,4.9,37M49.13,16.29l-4.27,4.35m2,7.05H53M50,38,45.6,33.6"
  }));
};
IconSensorActivated.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSensorGenericActive = function IconSensorGenericActive(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSensorGenericActive"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    d: "M42.47,29.38H11.53a4,4,0,0,0-4,4v9.06a4,4,0,0,0,4,4H42.47a4,4,0,0,0,4-4V33.41A4,4,0,0,0,42.47,29.38Zm-5,11.73a3.18,3.18,0,1,1,3.18-3.17A3.17,3.17,0,0,1,37.46,41.11Zm0-19c-8.2-8-17-3.62-20.81,0l2.7,2.71c1.41-1.31,8.27-6.89,15.39,0l2.72-2.71ZM43,14.42C28-.27,13,12.72,11.11,14.42l2.71,2.7c1.66-1.56,13.94-12.22,26.42,0Z"
  }));
};
IconSensorGenericActive.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSensorGeneric = function IconSensorGeneric(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSensorGeneric"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M42,27.88H11a4,4,0,0,0-4,4V41a4,4,0,0,0,4,4H42a4,4,0,0,0,4-4V31.91A4,4,0,0,0,42,27.88ZM37,39.61a3.17,3.17,0,1,1,3.17-3.17A3.17,3.17,0,0,1,37,39.61ZM33.32,11a.85.85,0,0,0-.23-.61L31.88,9.21A.79.79,0,0,0,31.29,9a.82.82,0,0,0-.6.25L25.3,14.59l-3-3a.83.83,0,0,0-1.19,0l-1.2,1.19a.88.88,0,0,0,0,1.21l4.78,4.78a.82.82,0,0,0,.6.25.84.84,0,0,0,.61-.25l7.18-7.18A.81.81,0,0,0,33.32,11Zm3.33,2.14a9.94,9.94,0,0,1-1.36,5.1,10.2,10.2,0,0,1-3.69,3.69,10.24,10.24,0,0,1-10.2,0,10.2,10.2,0,0,1-3.69-3.69,9.94,9.94,0,0,1-1.36-5.1,9.94,9.94,0,0,1,1.36-5.1A10.2,10.2,0,0,1,21.4,4.36a10.24,10.24,0,0,1,10.2,0,10.2,10.2,0,0,1,3.69,3.69A9.94,9.94,0,0,1,36.65,13.15Z"
  }));
};
IconSensorGeneric.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSensorMotionIdle = function IconSensorMotionIdle(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSensorMotionIdle"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M37.87,8.55H16.6a3.21,3.21,0,0,0-3.24,3.24V42.21a3.21,3.21,0,0,0,3.24,3.24H37.87a3.21,3.21,0,0,0,3.24-3.24V11.79a3.21,3.21,0,0,0-3.24-3.24Zm-.67,3.72c0,2.38-5.05,4.38-10,4.38s-10-2-10-4.38Zm.95,26a.82.82,0,0,1-.76.76H17.08a.82.82,0,0,1-.76-.76V23a.82.82,0,0,1,.76-.76H37.49a.82.82,0,0,1,.76.76l-.1,15.26ZM34.82,26.46v8"
  }));
};
IconSensorMotionIdle.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSettings = function IconSettings(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSettings"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M30,52H24a1,1,0,0,1-1-.82l-1.19-6.47A17.92,17.92,0,0,1,18,43.08l-5.38,3.74a1,1,0,0,1-1.28-.11l-4.2-4.2a1,1,0,0,1-.1-1.3l3.82-5.27a18.46,18.46,0,0,1-1.62-3.86L2.83,31A1,1,0,0,1,2,30V24a1,1,0,0,1,.83-1l6.36-1.09A17.92,17.92,0,0,1,10.82,18L7.17,12.66a1,1,0,0,1,.12-1.27l4.2-4.2a1,1,0,0,1,1.3-.1l5.27,3.82a18.46,18.46,0,0,1,3.86-1.62L23,2.83A1,1,0,0,1,24,2h6a1,1,0,0,1,1,.83l1.09,6.46A18.06,18.06,0,0,1,36,10.92l5.38-3.74a1,1,0,0,1,1.28.11l4.2,4.2a1,1,0,0,1,.1,1.29L43.1,18.14a16.54,16.54,0,0,1,1.61,3.78L51.17,23A1,1,0,0,1,52,24v6a1,1,0,0,1-.82,1l-6.4,1.19a20.06,20.06,0,0,1-1.59,3.77L47,41.32a1,1,0,0,1-.1,1.29l-4.2,4.2a1,1,0,0,1-1.29.1L36,43.09a18.53,18.53,0,0,1-3.87,1.62L31,51.18A1,1,0,0,1,30,52ZM51,30h0ZM27,36a9,9,0,1,1,9-9A9,9,0,0,1,27,36Z"
  }));
};
IconSettings.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconShadesBottomHalfOpen = function IconShadesBottomHalfOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconShadesBottomHalfOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41ZM17.68,41.62H36.3V27.87H17.68Zm-.79-15.75h20.2V14.17H16.89Zm-.21,1H37.3V42.62H16.68ZM37.3,43.62H16.68a1,1,0,0,1-1-1V26.87a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V42.62A1,1,0,0,1,37.3,43.62Zm-19.62-2H36.3V27.87H17.68Z"
  }));
};
IconShadesBottomHalfOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconShadesBottomMostlyClosed = function IconShadesBottomMostlyClosed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconShadesBottomMostlyClosed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41ZM17.68,41.59H36.3V22.71H17.68Zm-.79-20.88h20.2V14.17H16.89Zm-.21,1H37.3V42.59H16.68ZM37.3,43.59H16.68a1,1,0,0,1-1-1V21.71a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V42.59A1,1,0,0,1,37.3,43.59Zm-19.62-2H36.3V22.71H17.68Z"
  }));
};
IconShadesBottomMostlyClosed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconShadesBottomMostlyOpen = function IconShadesBottomMostlyOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconShadesBottomMostlyOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41ZM17.68,41.62H36.3V32.9H17.68ZM16.89,30.9h20.2V14.17H16.89Zm-.21,1H37.3V42.62H16.68ZM37.3,43.62H16.68a1,1,0,0,1-1-1V31.9a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V42.62A1,1,0,0,1,37.3,43.62Zm-19.62-2H36.3V32.9H17.68Z"
  }));
};
IconShadesBottomMostlyOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconShadesClosed = function IconShadesClosed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconShadesClosed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41ZM17.68,41.62H36.3V15H17.68ZM16.68,14H37.3V42.62H16.68ZM37.3,43.62H16.68a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V42.62A1,1,0,0,1,37.3,43.62Zm-19.62-2H36.3V15H17.68Z"
  }));
};
IconShadesClosed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconShadesHalfOpen = function IconShadesHalfOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconShadesHalfOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41Zm-21.22-2h20.2V30.9H16.89Zm.79-13.51H36.3V15H17.68ZM16.68,14H37.3V29.9H16.68ZM37.3,30.9H16.68a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V29.9A1,1,0,0,1,37.3,30.9Zm-19.62-2H36.3V15H17.68Z"
  }));
};
IconShadesHalfOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconShadesMostlyClosed = function IconShadesMostlyClosed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconShadesMostlyClosed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41Zm-21.22-2h20.2V36H16.89ZM17.68,34H36.3V15H17.68ZM16.68,14H37.3V35H16.68ZM37.3,36H16.68a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V35A1,1,0,0,1,37.3,36ZM17.68,34H36.3V15H17.68Z"
  }));
};
IconShadesMostlyClosed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconShadesMostlyOpen = function IconShadesMostlyOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconShadesMostlyOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41Zm-21.22-2h20.2V25.68H16.89Zm.79-18.73H36.3V15H17.68Zm-1-9.72H37.3V24.68H16.68ZM37.3,25.68H16.68a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1H37.3a1,1,0,0,1,1,1V24.68A1,1,0,0,1,37.3,25.68Zm-19.62-2H36.3V15H17.68Z"
  }));
};
IconShadesMostlyOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconShadesOpen = function IconShadesOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconShadesOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M43.3,47.49H10.7a1,1,0,0,1-1-1V43.41a1,1,0,0,1,1-1h1.48V14.17h-.32a1,1,0,0,1-1-1V7.51a1,1,0,0,1,1-1H42.14a1,1,0,0,1,1,1v5.66a1,1,0,0,1-1,1h-.31V42.41H43.3a1,1,0,0,1,1,1v3.08A1,1,0,0,1,43.3,47.49Zm-31.6-2H42.3V44.41H41.06a1,1,0,0,1-1.23-1V13.17a1,1,0,0,1,1-1h.31V8.51H12.86v3.66h.32a1,1,0,0,1,1,1V43.41a1,1,0,0,1-1,1H11.7Zm26.41-1.08H15.89a1,1,0,0,1-1-1V13.17a1,1,0,0,1,1-1h22.2a1,1,0,0,1,1,1v30a1.64,1.64,0,0,1,0,.23A1,1,0,0,1,38.11,44.41Zm-21.22-2h20.2V14.17H16.89Z"
  }));
};
IconShadesOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconShield = function IconShield(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconShield"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M27,51.85a1,1,0,0,1-.42-.09C26.36,51.66,5,41.44,5,11a1,1,0,0,1,.78-1,54.81,54.81,0,0,0,15-5.59C23.23,3.09,25,2.15,27,2.15s3.74.94,6.19,2.23a52.54,52.54,0,0,0,15,5.59A1,1,0,0,1,49,11c0,15.43-5.84,25.69-10.73,31.58a37.74,37.74,0,0,1-10.82,9.21A1,1,0,0,1,27,51.85ZM7,11.75c.34,26.21,17,36.38,20,38,2.93-1.71,19.67-12.56,20-38a54.51,54.51,0,0,1-14.74-5.6c-2.19-1.16-3.78-2-5.25-2s-3.1.84-5.32,2A57,57,0,0,1,7,11.75Z"
  }));
};
IconShield.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSirenOn = function IconSirenOn(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54 "
  }, props, {
    "data-component-name": "IconSirenOn"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M9,44H45v7H9ZM37.7,20l3.2,24h-28l3.2-24A7,7,0,0,1,23,13.9h7.6A7.21,7.21,0,0,1,37.7,20ZM35.6,7.4,37.8,3m8.8,13.2L51,14M46.6,29.4,51,31.6M18.4,7.4,16.2,3M7.4,16.2,3,14M7.4,29.4,3,31.6"
  }));
};
IconSirenOn.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSiren = function IconSiren(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSiren"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M9,44H45v7H9ZM37.7,20l3.2,24h-28l3.2-24A7,7,0,0,1,23,13.9h7.6A7.21,7.21,0,0,1,37.7,20Z"
  }));
};
IconSiren.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSlidingDoorClosedLocked = function IconSlidingDoorClosedLocked(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1278 1024"
  }, props, {
    "data-component-name": "IconSlidingDoorClosedLocked"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M609.524 56.381h464.762v591.238c-13.714 1.524-25.905 3.048-38.095 7.619v-562.286h-390.095v755.81h254.476c1.524 13.714 3.048 25.905 6.095 38.095h-297.143v-830.476zm321.524 882.286h-912.762c-10.667 0-18.286-9.143-18.286-18.286v-902.095c0-10.667 7.619-18.286 18.286-18.286h1097.143c10.667 0 18.286 7.619 18.286 18.286v633.905c-12.19-3.048-24.381-4.571-36.571-4.571v-609.524h-512v865.524h327.619c4.571 10.667 10.667 22.857 18.286 35.048zm-894.477-36.572h512v-865.524h-512v865.524zm24.381-845.714h464.762v832h-464.762v-832zm36.572 793.905h390.095v-757.333h-390.095v757.333zm992-196.572c-100.571 0-181.333 80.762-181.333 181.333s80.762 181.333 181.333 181.333 181.333-80.762 181.333-181.333-80.762-181.333-181.333-181.333zm102.095 272.762c0 15.238-13.714 28.952-28.952 28.952h-146.286c-15.238 0-28.952-13.714-28.952-28.952v-97.524c0-15.238 13.714-28.952 28.952-28.952v-35.048c0-39.619 32-73.143 73.143-73.143s73.143 32 73.143 73.143v35.048c15.238 0 28.952 13.714 28.952 28.952v97.524zm-57.905-160v33.524h-88.381v-33.524c0-24.381 19.81-44.19 44.19-44.19s44.19 19.81 44.19 44.19zm-27.428 97.524c0 6.095-3.048 10.667-9.143 13.714v25.905c0 3.048-1.524 4.571-4.571 4.571s-4.571-1.524-4.571-4.571v-25.905h-3.048c-6.095-1.524-9.143-7.619-9.143-13.714 0-9.143 6.095-15.238 15.238-15.238 7.619 0 15.238 6.095 15.238 15.238z"
  }));
};
IconSlidingDoorClosedLocked.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSlidingDoorClosedUnlocked = function IconSlidingDoorClosedUnlocked(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1278 1024"
  }, props, {
    "data-component-name": "IconSlidingDoorClosedUnlocked"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M609.524 56.381h464.762v591.238c-13.714 1.524-25.905 3.048-38.095 7.619v-562.286h-390.095v755.81h254.476c1.524 13.714 3.048 25.905 6.095 38.095h-297.143v-830.476zm-548.572 0h464.762v832h-464.762v-832zm36.572 793.905h390.095v-757.333h-390.095v757.333zm833.524 88.381h-912.762c-10.667 0-18.286-9.143-18.286-18.286v-902.095c0-10.667 7.619-18.286 18.286-18.286h1097.143c10.667 0 18.286 7.619 18.286 18.286v633.905c-12.19-3.048-24.381-4.571-36.571-4.571v-609.524h-512v865.524h327.619c4.571 10.667 10.667 22.857 18.286 35.048zm-894.477-36.572h512v-865.524h-512v865.524zm1052.953-248.381c-100.571 0-181.333 80.762-181.333 181.333s80.762 181.333 181.333 181.333 181.333-80.762 181.333-181.333-80.762-181.333-181.333-181.333zm106.666 257.524c0 12.19-10.667 22.857-22.857 22.857h-114.286c-12.19 0-22.857-10.667-22.857-22.857v-76.19c0-12.19 10.667-22.857 22.857-22.857-1.524 0-1.524-57.905-1.524-57.905 0-18.286-15.238-33.524-33.524-33.524s-33.524 15.238-33.524 33.524v30.476c0 6.095-6.095 12.19-12.19 12.19s-12.19-6.095-12.19-12.19v-30.476c0-30.476 25.905-56.381 56.381-56.381h1.524c32 0 57.905 24.381 57.905 56.381v57.905h91.429c12.19 0 22.857 10.667 22.857 22.857v76.19zm-71.619-48.762c0 4.571-3.048 9.143-7.619 10.667v19.81c0 1.524-1.524 3.048-3.048 3.048s-3.048-1.524-3.048-3.048v-19.81c-4.571-3.048-7.619-6.095-10.667-10.667 0-6.095 6.095-12.19 12.19-12.19s12.19 4.571 12.19 12.19z"
  }));
};
IconSlidingDoorClosedUnlocked.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSlidingDoorClosed = function IconSlidingDoorClosed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1237 1024"
  }, props, {
    "data-component-name": "IconSlidingDoorClosed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M1171.355 968.285h-506.927v-907.58h506.927zm-465.681-41.08h424.435v-825.42h-424.435zm511.584 96.795h-598.733c-10.931 0-19.791-8.861-19.791-19.791v-984.583c.094-10.859 8.919-19.625 19.791-19.625h598.7339999999999c10.931 0 19.791 8.861 19.791 19.791v984.583c-.094 10.859-8.919 19.625-19.791 19.625h-.001zm-578.942-39.417h559.15v-945.167h-559.15zm-65.694-16.631h-506.927v-907.247h506.927zm-465.682-41.08h424.435v-825.088h-424.435zm511.585 97.128h-598.733c-10.931 0-19.791-8.861-19.791-19.791v-984.583c.094-10.859 8.919-19.625 19.791-19.625h598.7339999999999c10.931 0 19.791 8.861 19.791 19.791v984.583c-.094 10.859-8.919 19.625-19.791 19.625h-.001zm-578.942-39.417h559.15v-945.167h-559.15z"
  }));
};
IconSlidingDoorClosed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSlidingDoorOpen = function IconSlidingDoorOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1237 1024"
  }, props, {
    "data-component-name": "IconSlidingDoorOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M871.065 967.481h-505.351v-905.974h507.013l-1.662 905.974zm-465.455-39.897h425.558v-826.182h-425.558v826.182zm811.221 96.416h-598.442v-39.896h578.494v-944.208h-578.494v-39.896h598.442c11.636 0 19.948 8.312 19.948 19.948v984.104c0 9.974-9.974 19.948-19.948 19.948zm-644.987-56.519h-505.351v-905.974h505.351v905.974zm-465.454-39.897h425.558v-826.182h-425.558v826.182zm512 96.416h-598.442c-11.636 0-19.948-8.312-19.948-19.948v-984.104c0-11.636 8.312-19.948 19.948-19.948h598.442v39.896h-578.494v944.208h578.494v39.896z"
  }));
};
IconSlidingDoorOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSlidingDoorUnknown = function IconSlidingDoorUnknown(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1278 1024"
  }, props, {
    "data-component-name": "IconSlidingDoorUnknown"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M609.524 56.381h464.762v591.238c-13.714 1.524-25.905 3.048-38.095 7.619v-562.286h-390.095v755.81h254.476c1.524 13.714 3.048 25.905 6.095 38.095h-297.143v-830.476zm321.524 882.286h-912.762c-10.667 0-18.286-7.619-18.286-18.286v-902.095c0-10.667 7.619-18.286 18.286-18.286h1097.143c10.667 0 18.286 7.619 18.286 18.286v632.381c-12.19-3.048-24.381-4.571-36.571-4.571v-609.524h-512v865.524h327.619c4.571 12.19 10.667 24.381 18.286 36.571zm-894.477-36.572h512v-865.524h-512v865.524zm24.381-845.714h463.238v832h-463.238v-832zm36.572 793.905h390.095v-757.333h-390.095v757.333zm992-196.572c-100.571 0-181.333 80.762-181.333 181.333s80.762 181.333 181.333 181.333 181.333-80.762 181.333-181.333-80.762-181.333-181.333-181.333zm22.857 259.048h-30.476v-121.905h30.476v121.905zm0-152.381h-30.476v-30.476h30.476v30.476z"
  }));
};
IconSlidingDoorUnknown.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSmile = function IconSmile(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSmile"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M27,51a24,24,0,0,1-.23-48L27,3h0l.22,0A24,24,0,0,1,27,51ZM27,5l-.15,0a22,22,0,1,0,.3,0Zm0,36c-9,0-14.41-7.52-14.63-7.84A1,1,0,0,1,14,32c.05.07,5.06,7,13,7s13-6.92,13-7a1,1,0,1,1,1.63,1.15C41.41,33.48,36,41,27,41Zm8-14a4,4,0,1,1,4-4A4,4,0,0,1,35,27Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,35,21ZM19,27a4,4,0,1,1,4-4A4,4,0,0,1,19,27Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,19,21Z"
  }));
};
IconSmile.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSmokeDetectorTriggered = function IconSmokeDetectorTriggered(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSmokeDetectorTriggered"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M27,41.61a14.61,14.61,0,0,1,0-29.22A14.54,14.54,0,0,1,41.54,27,14.59,14.59,0,0,1,27,41.61Zm0-4.15a2.09,2.09,0,1,1,2.08-2.09A2.1,2.1,0,0,1,27,37.46ZM22.85,18.21h8.33m-8.33,3.44h8.33m-8.33,3.79h8.33M43.1,19.85l4.76-4.67m-2.51,12.4H52m-8,6.48,4.67,4.76M6.24,15.18,11,19.85M2.1,27.58H8.75M5.43,38.82l4.67-4.76"
  }));
};
IconSmokeDetectorTriggered.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSmokeDetector = function IconSmokeDetector(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSmokeDetector"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M27,41.61a14.61,14.61,0,0,1,0-29.22A14.54,14.54,0,0,1,41.54,27,14.59,14.59,0,0,1,27,41.61Zm0-4.15a2.09,2.09,0,1,1,2.08-2.09A2.1,2.1,0,0,1,27,37.46ZM22.85,18.21h8.33m-8.33,3.44h8.33m-8.33,3.79h8.33"
  }));
};
IconSmokeDetector.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconStar = function IconStar(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconStar"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M12.2,51.8a1.75,1.75,0,0,1-.51-.07,2,2,0,0,1-1.42-2.44l4.17-15.76L1.73,23.15A2,2,0,0,1,1,21.7a2,2,0,0,1,1.9-2.1l16.3-.83L25.14,3.48A2,2,0,0,1,27,2.2h0a2,2,0,0,1,1.86,1.28L34.8,18.77l16.3.83a2,2,0,0,1,1.45.73,2,2,0,0,1-.28,2.82L39.56,33.53l4.17,15.76a1.94,1.94,0,0,1-.25,1.59,2,2,0,0,1-2.76.6L27,42.68l-13.72,8.8A2,2,0,0,1,12.2,51.8ZM27,40.3l14.8,9.5-4.5-17L51,21.6l-17.6-.9L27,4.2,20.6,20.7,3,21.6,16.7,32.8l-4.5,17Z"
  }));
};
IconStar.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSunny = function IconSunny(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSunny"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M27,2a1,1,0,0,0-.81.45l-5.5,8.24h0a1.43,1.43,0,0,1-.73.3L10.23,9.05a1,1,0,0,0-1.18,1.18L11,19.94a1.52,1.52,0,0,1-.3.73l-8.24,5.5a1,1,0,0,0,0,1.66l8.24,5.5h0a1.43,1.43,0,0,1,.3.73L9.05,43.78a1,1,0,0,0,.27.9,1,1,0,0,0,.91.27L19.94,43a1.48,1.48,0,0,1,.73.3l5.5,8.24a1,1,0,0,0,1.66,0l5.5-8.24h0a1.43,1.43,0,0,1,.73-.3L43.78,45a1,1,0,0,0,.9-.27,1,1,0,0,0,.27-.91L43,34.06a1.39,1.39,0,0,1,.3-.73h0l8.24-5.5a1,1,0,0,0,0-1.66l-8.24-5.5h0a1.43,1.43,0,0,1-.3-.73L45,10.23a1,1,0,0,0-1.18-1.18L34.06,11a1.48,1.48,0,0,1-.73-.3l-5.5-8.24A1,1,0,0,0,27,2Zm0,12A13,13,0,1,0,40,27,13,13,0,0,0,27,14Z"
  }));
};
IconSunny.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSupport = function IconSupport(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSupport"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    d: "M43.5,25h-2v8h2a2,2,0,0,0,2-2V27A2,2,0,0,0,43.5,25Zm-13,17h5a7,7,0,0,0,7-7V33m-14,11h-2a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2h0A2,2,0,0,1,28.5,44Zm-18-16.9,4,1.9V21s11.5-.6,16-6c2.7,4.4,8,6,8,6v8l2-1m2.67-3.17c.6,0,.33-.33.33-.83V20c-.4-8.8-5.3-13.8-13.6-14l-2-2h-.4C14.8,4,9.9,12.2,9.5,20v6.7a4.45,4.45,0,0,0-1,3.1,4.73,4.73,0,0,0,3.7,4.7C14.8,41.3,19.1,50,26.5,50c4,0,7.1-2.6,9.5-6"
  }));
};
IconSupport.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconUndo = function IconUndo(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 876 1024"
  }, props, {
    "data-component-name": "IconUndo"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M876.856 512q0 89.142-34.858 170.286t-93.714 140-140 93.714-170.286 34.858q-98.286 0-186.858-41.428t-150.858-116.858q-4-5.714-3.714-12.858t4.858-11.714l78.286-78.858q5.714-5.142 14.286-5.142 9.142 1.142 13.142 6.858 41.714 54.286 102.286 84t128.572 29.714q59.428 0 113.428-23.142t93.428-62.572 62.572-93.428 23.142-113.428-23.142-113.428-62.572-93.428-93.428-62.572-113.428-23.142q-56 0-107.428 20.286t-91.428 58l78.286 78.858q17.714 17.142 8 39.428-9.714 22.858-33.714 22.858h-256q-14.858 0-25.714-10.858t-10.858-25.714v-256q0-24 22.858-33.714 22.286-9.714 39.428 8l74.286 73.714q61.142-57.714 139.714-89.428t162.572-31.714q89.142 0 170.286 34.858t140 93.714 93.714 140 34.858 170.286z"
  }));
};
IconUndo.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconUser = function IconUser(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconUser"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M27,51A24,24,0,1,1,51,27,24,24,0,0,1,27,51ZM11.87,43a22,22,0,0,0,30.34-.08A43.16,43.16,0,0,0,35.67,40a18.05,18.05,0,0,1-2.93-1.2,3.73,3.73,0,0,1-1.6-1.65l-.59-1.24,1.37-.18A21.59,21.59,0,0,0,36,35a5.45,5.45,0,0,0,1.48-.75c.48-.36.54-.62.54-.81a3.21,3.21,0,0,1-.74-1.7A17.43,17.43,0,0,1,37,28.88c0-.83,0-1.74,0-2.7,0-1.5,0-3.05,0-4.61a16,16,0,0,0-1.42-6.73,5.27,5.27,0,0,0-4.88-2.78h-.31l-.25-.18A5.32,5.32,0,0,0,27.09,11a9.38,9.38,0,0,0-7.2,3.53,14.16,14.16,0,0,0-2.4,7c-.22,1.86-.27,3.76-.32,5.43,0,.67,0,1.32-.06,1.92a16.78,16.78,0,0,1-.29,2.83A3.48,3.48,0,0,1,16,33.48a1.31,1.31,0,0,0,.55.94,4.9,4.9,0,0,0,1.51.67,28.27,28.27,0,0,0,3.9.69l1.33.17-.48,1.23a3.58,3.58,0,0,1-1.63,1.69,16.71,16.71,0,0,1-2.9,1.19A38.86,38.86,0,0,0,11.87,43ZM27,5A22,22,0,0,0,10.45,41.48a38.72,38.72,0,0,1,7.2-3.31c.63-.22,1.31-.46,1.9-.71A18.3,18.3,0,0,1,17.49,37a6.56,6.56,0,0,1-2.13-1A3.22,3.22,0,0,1,14,33.48,2,2,0,0,1,14.66,32a4.09,4.09,0,0,0,.21-.67,16.34,16.34,0,0,0,.25-2.49q0-.9.06-1.89c0-1.72.09-3.66.32-5.62a16.1,16.1,0,0,1,2.79-8A11.37,11.37,0,0,1,27,9h.14a7.36,7.36,0,0,1,3.95,1,7.25,7.25,0,0,1,6.33,3.83A17.7,17.7,0,0,1,39,21.49c.07,1.61,0,3.26,0,4.72,0,.93,0,1.83,0,2.64a15.79,15.79,0,0,0,.19,2.48,2.6,2.6,0,0,0,.2.66,2,2,0,0,1,.57,1.4,3,3,0,0,1-1.33,2.4,7.37,7.37,0,0,1-2,1,13.63,13.63,0,0,1-2.29.59c.58.26,1.27.5,1.94.73a43.2,43.2,0,0,1,7.32,3.25A22,22,0,0,0,27,5Z"
  }));
};
IconUser.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconUserAndroid = function IconUserAndroid(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconUserAndroid"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M17.2,42.2C8.8,42.2,2,35.4,2,27s6.8-15.2,15.2-15.2S32.5,18.6,32.5,27S25.7,42.2,17.2,42.2z M7.6,37.2 c5.4,5.1,13.9,5.1,19.3-0.1c-1.3-0.7-2.7-1.4-4.2-1.9c-0.6-0.2-1.3-0.5-1.9-0.8c-0.4-0.2-0.8-0.6-1-1l-0.4-0.8l0.9-0.1 c0.9-0.1,1.7-0.2,2.6-0.5c0.3-0.1,0.7-0.3,0.9-0.5c0.3-0.2,0.3-0.4,0.3-0.5c-0.3-0.3-0.4-0.7-0.5-1.1c-0.1-0.6-0.2-1.2-0.2-1.8 c0-0.5,0-1.1,0-1.7c0-1,0-1.9,0-2.9c0-1.5-0.3-2.9-0.9-4.3c-0.6-1.1-1.8-1.8-3.1-1.8h-0.2L19,17.3c-0.6-0.4-1.3-0.6-1.9-0.6 c-1.8,0-3.5,0.8-4.6,2.2c-0.9,1.3-1.4,2.9-1.5,4.4c0.1,1.4,0,2.6,0,3.7c0,0.4,0,0.8,0,1.2c0,0.6-0.1,1.2-0.2,1.8 c-0.1,0.4-0.2,0.8-0.5,1.1c0,0.2,0.2,0.5,0.3,0.6c0.3,0.2,0.6,0.3,1,0.4c0.8,0.2,1.6,0.4,2.5,0.4l0.8,0.1l-0.3,0.8 c-0.2,0.5-0.6,0.8-1,1.1c-0.6,0.3-1.2,0.6-1.8,0.8C10.3,35.8,8.9,36.4,7.6,37.2z M17.2,13c-7.7,0-14,6.3-14,14 c0,3.4,1.2,6.6,3.5,9.2c1.4-0.9,3-1.6,4.6-2.1c0.4-0.1,0.8-0.3,1.2-0.5c-0.4-0.1-0.9-0.2-1.3-0.3c-0.5-0.1-0.9-0.3-1.4-0.6 c-0.5-0.4-0.8-1-0.9-1.6c0-0.4,0.2-0.7,0.4-0.9c0.1-0.1,0.1-0.3,0.1-0.4c0.1-0.5,0.1-1.1,0.2-1.6c0-0.4,0-0.8,0-1.2 c0-1.1,0.1-2.3,0.2-3.6c0.1-1.8,0.7-3.6,1.8-5.1c1.3-1.7,3.4-2.7,5.5-2.8h0.1c0.9,0,1.7,0.2,2.5,0.6c1.7,0,3.2,0.9,4,2.4 c0.7,1.5,1,3.2,1,4.9c0,1,0,2.1,0,3c0,0.6,0,1.2,0,1.7s0,1.1,0.1,1.6c0,0.1,0.1,0.3,0.1,0.4c0.2,0.2,0.4,0.6,0.4,0.9 c0,0.6-0.3,1.2-0.8,1.5c-0.4,0.3-0.8,0.5-1.3,0.6c-0.5,0.2-1,0.3-1.5,0.4c0.4,0.2,0.8,0.3,1.2,0.5c1.6,0.5,3.2,1.2,4.7,2.1 c5-5.8,4.4-14.7-1.5-19.7C23.8,14.2,20.6,13,17.2,13z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    strokeWidth: "0.25",
    strokeMiterlimit: "10",
    stroke: "currentColor",
    d: "M40,20.4C40,20.4,39.9,20.4,40,20.4c-0.2,0-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.3l0.7,1.1 c-1.2,0.6-2.1,1.7-2.3,3.1c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1v0.5c-0.2-0.1-0.4-0.2-0.7-0.2 c-0.7,0-1.4,0.6-1.4,1.4v4.1c0,0.7,0.6,1.4,1.4,1.4c0.2,0,0.5-0.1,0.7-0.2v0.9c0,0.6,0.5,1,1,1h0.3v2c0,0.7,0.6,1.4,1.4,1.4 s1.4-0.6,1.4-1.4v-2h1.4v2c0,0.7,0.6,1.4,1.4,1.4c0.7,0,1.4-0.6,1.4-1.4v-2h0.3c0.6,0,1-0.5,1-1v-0.9c0.2,0.1,0.4,0.2,0.7,0.2 c0.7,0,1.4-0.6,1.4-1.4v-4.1c0-0.7-0.6-1.4-1.4-1.4c-0.2,0-0.5,0.1-0.7,0.2v-0.5c0,0,0-0.1,0-0.1c0,0,0,0,0,0s0,0,0,0 c-0.2-1.3-1.1-2.4-2.3-3.1l0.7-1.1c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.2-0.2-0.4-0.1c-0.1,0-0.2,0.1-0.2,0.1l-0.8,1.2 c-0.6-0.2-1.2-0.3-1.8-0.3c-0.6,0-1.3,0.1-1.8,0.3l-0.8-1.2C40.2,20.4,40.1,20.4,40,20.4z M42.9,22.1c0.6,0,1.2,0.1,1.8,0.3 c0,0,0,0,0,0c1.1,0.5,1.8,1.3,2.1,2.4H39c0.3-1,1-1.9,2.1-2.3c0,0,0,0,0.1,0C41.6,22.2,42.3,22.1,42.9,22.1z M41,23.1 c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5C41.5,23.3,41.3,23.1,41,23.1z M44.8,23.1 c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5C45.3,23.3,45,23.1,44.8,23.1z M38.8,25.5H47v7.5 c0,0.2-0.1,0.3-0.3,0.3H44c0,0-0.1,0-0.1,0h-3.9c0,0-0.1,0-0.1,0h-0.6c-0.2,0-0.3-0.1-0.3-0.3V25.5z M37.5,26.1 c0.4,0,0.7,0.3,0.7,0.7v4.1c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7v-4.1C36.8,26.4,37.1,26.1,37.5,26.1z M48.3,26.1 c0.4,0,0.7,0.3,0.7,0.7v4.1c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7v-4.1C47.6,26.4,47.9,26.1,48.3,26.1z M40.2,34h1.4v2 c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7V34z M44.2,34h1.4v2c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7V34z"
  }));
};
IconUserAndroid.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconUserBrowser = function IconUserBrowser(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconUserBrowser"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M17.2,42.2C8.8,42.2,2,35.4,2,27s6.8-15.2,15.2-15.2S32.5,18.6,32.5,27S25.7,42.2,17.2,42.2z M7.6,37.2 c5.4,5.1,13.9,5.1,19.3-0.1c-1.3-0.7-2.7-1.4-4.2-1.9c-0.6-0.2-1.3-0.5-1.9-0.8c-0.4-0.2-0.8-0.6-1-1l-0.4-0.8l0.9-0.1 c0.9-0.1,1.7-0.2,2.6-0.5c0.3-0.1,0.7-0.3,0.9-0.5c0.3-0.2,0.3-0.4,0.3-0.5c-0.3-0.3-0.4-0.7-0.5-1.1c-0.1-0.6-0.2-1.2-0.2-1.8 c0-0.5,0-1.1,0-1.7c0-1,0-1.9,0-2.9c0-1.5-0.3-2.9-0.9-4.3c-0.6-1.1-1.8-1.8-3.1-1.8h-0.2l-0.2-0.1c-0.6-0.4-1.3-0.6-1.9-0.6 c-1.8,0-3.5,0.8-4.6,2.2c-0.9,1.3-1.4,2.9-1.5,4.4C11.1,24.7,11,25.9,11,27c0,0.4,0,0.8,0,1.2c0,0.6-0.1,1.2-0.2,1.8 c-0.1,0.4-0.2,0.8-0.5,1.1c0,0.2,0.2,0.5,0.3,0.6c0.3,0.2,0.6,0.3,1,0.4c0.8,0.2,1.6,0.4,2.5,0.4l0.8,0.1l-0.3,0.8 c-0.2,0.5-0.6,0.8-1,1.1c-0.6,0.3-1.2,0.6-1.8,0.8C10.3,35.8,8.9,36.4,7.6,37.2z M17.2,13c-7.7,0-14,6.3-14,14 c0,3.4,1.2,6.6,3.5,9.2c1.4-0.9,3-1.6,4.6-2.1c0.4-0.1,0.8-0.3,1.2-0.5c-0.4-0.1-0.9-0.2-1.3-0.3c-0.5-0.1-0.9-0.3-1.4-0.6 c-0.5-0.4-0.8-1-0.9-1.6c0-0.4,0.2-0.7,0.4-0.9c0.1-0.1,0.1-0.3,0.1-0.4c0.1-0.5,0.1-1.1,0.2-1.6c0-0.4,0-0.8,0-1.2 c0-1.1,0.1-2.3,0.2-3.6c0.1-1.8,0.7-3.6,1.8-5.1c1.3-1.7,3.4-2.7,5.5-2.8h0.1c0.9,0,1.7,0.2,2.5,0.6c1.7,0,3.2,0.9,4,2.4 c0.7,1.5,1,3.2,1,4.9c0,1,0,2.1,0,3c0,0.6,0,1.2,0,1.7c0,0.5,0,1.1,0.1,1.6c0,0.1,0.1,0.3,0.1,0.4c0.2,0.2,0.4,0.6,0.4,0.9 c0,0.6-0.3,1.2-0.8,1.5c-0.4,0.3-0.8,0.5-1.3,0.6c-0.5,0.2-1,0.3-1.5,0.4c0.4,0.2,0.8,0.3,1.2,0.5c1.6,0.5,3.2,1.2,4.7,2.1 c5-5.8,4.4-14.7-1.5-19.7C23.8,14.2,20.6,13,17.2,13z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    strokeMiterlimit: "10",
    fill: "none",
    stroke: "currentColor",
    d: "M35.9,20.8c-0.5,0-0.9,0.4-0.9,0.9v11.2c0,0.2,0.1,0.3,0.2,0.3h14.4c0.3,0,0.5-0.1,0.5-0.3V21.7 c0-0.5-0.4-0.9-0.9-0.9H35.9z M40.6,22.1v0.3V24h7.9v-2H40.6z M37,22.4c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7C37.6,22.7,37.3,22.4,37,22.4z M38.9,22.4c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7 c0.4,0,0.7-0.3,0.7-0.7C39.6,22.7,39.3,22.4,38.9,22.4z M35,25.4h15.1"
  }));
};
IconUserBrowser.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconUserMobile = function IconUserMobile(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconUserMobile"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M17.2,42.2A15.2,15.2,0,1,1,32.5,27,15.19,15.19,0,0,1,17.2,42.2Zm-9.6-5a14,14,0,0,0,19.3-.1,26.81,26.81,0,0,0-4.2-1.9,15.39,15.39,0,0,1-1.9-.8,2.41,2.41,0,0,1-1-1l-.4-.8.9-.1a11.93,11.93,0,0,0,2.6-.5,2.62,2.62,0,0,0,.9-.5.54.54,0,0,0,.3-.5,2.22,2.22,0,0,1-.5-1.1,11,11,0,0,1-.2-1.8V23.5a10.7,10.7,0,0,0-.9-4.3,3.53,3.53,0,0,0-3.1-1.8h-.2l-.2-.1a3.53,3.53,0,0,0-1.9-.6,5.83,5.83,0,0,0-4.6,2.2A8.92,8.92,0,0,0,11,23.3c.1,1.4,0,2.6,0,3.7v1.2a11,11,0,0,1-.2,1.8,2.22,2.22,0,0,1-.5,1.1,1.14,1.14,0,0,0,.3.6,3,3,0,0,0,1,.4,10.05,10.05,0,0,0,2.5.4l.8.1-.3.8a2.66,2.66,0,0,1-1,1.1,14.17,14.17,0,0,1-1.8.8A20,20,0,0,0,7.6,37.2ZM17.2,13a14,14,0,0,0-14,14,13.72,13.72,0,0,0,3.5,9.2,19.15,19.15,0,0,1,4.6-2.1,6.12,6.12,0,0,0,1.2-.5l-1.3-.3a4.24,4.24,0,0,1-1.4-.6,2.6,2.6,0,0,1-.9-1.6,1.27,1.27,0,0,1,.4-.9.6.6,0,0,0,.1-.4c.1-.5.1-1.1.2-1.6V27c0-1.1.1-2.3.2-3.6a9.54,9.54,0,0,1,1.8-5.1,7.43,7.43,0,0,1,5.5-2.8h.1a5.42,5.42,0,0,1,2.5.6,4.47,4.47,0,0,1,4,2.4,11.62,11.62,0,0,1,1,4.9v4.7a8.6,8.6,0,0,0,.1,1.6c0,.1.1.3.1.4a1.49,1.49,0,0,1,.4.9,1.76,1.76,0,0,1-.8,1.5,3.1,3.1,0,0,1-1.3.6,8.33,8.33,0,0,1-1.5.4c.4.2.8.3,1.2.5a21.83,21.83,0,0,1,4.7,2.1,14,14,0,0,0-1.5-19.7A12.82,12.82,0,0,0,17.2,13Z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", {
    id: "surface1"
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M37,22.26a1.12,1.12,0,0,0-1.12,1.13v10.7A1.13,1.13,0,0,0,37,35.22H43V33H37.33V23.67h7.32v2.25h1.41V23.39a1.13,1.13,0,0,0-1.13-1.13Zm7,3.94a.85.85,0,0,0-.84.85v8.17a.85.85,0,0,0,.84.84h5.08a.85.85,0,0,0,.84-.84V27.05a.85.85,0,0,0-.84-.85Zm.57,1.41h3.94v6.2H44.65ZM41,33.52a.43.43,0,1,1-.43.43A.42.42,0,0,1,41,33.52Zm5.63.85a.43.43,0,1,1-.42.42A.42.42,0,0,1,46.62,34.37Z"
  })));
};
IconUserMobile.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconUserWindows = function IconUserWindows(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconUserWindows"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M17.2,42.2C8.8,42.2,2,35.4,2,27s6.8-15.2,15.2-15.2S32.5,18.6,32.5,27S25.7,42.2,17.2,42.2z M7.6,37.2 c5.4,5.1,13.9,5.1,19.3-0.1c-1.3-0.7-2.7-1.4-4.2-1.9c-0.6-0.2-1.3-0.5-1.9-0.8c-0.4-0.2-0.8-0.6-1-1l-0.4-0.8l0.9-0.1 c0.9-0.1,1.7-0.2,2.6-0.5c0.3-0.1,0.7-0.3,0.9-0.5c0.3-0.2,0.3-0.4,0.3-0.5c-0.3-0.3-0.4-0.7-0.5-1.1c-0.1-0.6-0.2-1.2-0.2-1.8 c0-0.5,0-1.1,0-1.7c0-1,0-1.9,0-2.9c0-1.5-0.3-2.9-0.9-4.3c-0.6-1.1-1.8-1.8-3.1-1.8h-0.2l-0.2-0.1c-0.6-0.4-1.3-0.6-1.9-0.6 c-1.8,0-3.5,0.8-4.6,2.2c-0.9,1.3-1.4,2.9-1.5,4.4C11.1,24.7,11,25.9,11,27c0,0.4,0,0.8,0,1.2c0,0.6-0.1,1.2-0.2,1.8 c-0.1,0.4-0.2,0.8-0.5,1.1c0,0.2,0.2,0.5,0.3,0.6c0.3,0.2,0.6,0.3,1,0.4c0.8,0.2,1.6,0.4,2.5,0.4l0.8,0.1l-0.3,0.8 c-0.2,0.5-0.6,0.8-1,1.1c-0.6,0.3-1.2,0.6-1.8,0.8C10.3,35.8,8.9,36.4,7.6,37.2z M17.2,13c-7.7,0-14,6.3-14,14 c0,3.4,1.2,6.6,3.5,9.2c1.4-0.9,3-1.6,4.6-2.1c0.4-0.1,0.8-0.3,1.2-0.5c-0.4-0.1-0.9-0.2-1.3-0.3c-0.5-0.1-0.9-0.3-1.4-0.6 c-0.5-0.4-0.8-1-0.9-1.6c0-0.4,0.2-0.7,0.4-0.9c0.1-0.1,0.1-0.3,0.1-0.4c0.1-0.5,0.1-1.1,0.2-1.6c0-0.4,0-0.8,0-1.2 c0-1.1,0.1-2.3,0.2-3.6c0.1-1.8,0.7-3.6,1.8-5.1c1.3-1.7,3.4-2.7,5.5-2.8h0.1c0.9,0,1.7,0.2,2.5,0.6c1.7,0,3.2,0.9,4,2.4 c0.7,1.5,1,3.2,1,4.9c0,1,0,2.1,0,3c0,0.6,0,1.2,0,1.7c0,0.5,0,1.1,0.1,1.6c0,0.1,0.1,0.3,0.1,0.4c0.2,0.2,0.4,0.6,0.4,0.9 c0,0.6-0.3,1.2-0.8,1.5c-0.4,0.3-0.8,0.5-1.3,0.6c-0.5,0.2-1,0.3-1.5,0.4c0.4,0.2,0.8,0.3,1.2,0.5c1.6,0.5,3.2,1.2,4.7,2.1 c5-5.8,4.4-14.7-1.5-19.7C23.8,14.2,20.6,13,17.2,13z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M50.8,18.6l-16.5,2.1v11.7l16.5,2.1V18.6z M50,19.5v6.6h-7.5v-5.7L50,19.5z M41.8,20.5v5.6h-6.7v-4.8L41.8,20.5z M35.1,26.9h6.7v5.6l-6.7-0.8V26.9z M42.6,26.9H50v6.6l-7.5-0.9V26.9z"
  }));
};
IconUserWindows.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconVolumeHigh = function IconVolumeHigh(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1088 1024"
  }, props, {
    "data-component-name": "IconVolumeHigh"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M890.04 922.04c-12.286 0-24.566-4.686-33.942-14.056-18.744-18.746-18.744-49.136 0-67.882 87.638-87.642 135.904-204.16 135.904-328.1 0-123.938-48.266-240.458-135.904-328.098-18.744-18.746-18.744-49.138 0-67.882s49.138-18.744 67.882 0c105.77 105.772 164.022 246.4 164.022 395.98s-58.252 290.208-164.022 395.98c-9.372 9.372-21.656 14.058-33.94 14.058zm-170.51-90.51c-12.286 0-24.566-4.686-33.942-14.056-18.744-18.744-18.744-49.136 0-67.882 131.006-131.006 131.006-344.17 0-475.176-18.744-18.746-18.744-49.138 0-67.882 18.744-18.742 49.138-18.744 67.882 0 81.594 81.59 126.53 190.074 126.53 305.466 0 115.39-44.936 223.876-126.53 305.47-9.372 9.374-21.656 14.06-33.94 14.06zm-170.51-90.51c-12.286 0-24.568-4.686-33.942-14.058-18.746-18.746-18.746-49.134 0-67.88 81.1-81.1 81.1-213.058 0-294.156-18.746-18.746-18.746-49.138 0-67.882s49.136-18.744 67.882 0c118.53 118.53 118.53 311.392 0 429.922-9.372 9.368-21.656 14.054-33.94 14.054zm-133.014 218.98c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
  }));
};
IconVolumeHigh.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconVolumeMedium = function IconVolumeMedium(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconVolumeMedium"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M719.53 831.53c-12.286 0-24.566-4.686-33.942-14.056-18.744-18.744-18.744-49.136 0-67.882 131.006-131.006 131.006-344.17 0-475.176-18.744-18.746-18.744-49.138 0-67.882 18.744-18.742 49.138-18.744 67.882 0 81.594 81.59 126.53 190.074 126.53 305.466 0 115.39-44.936 223.876-126.53 305.47-9.372 9.374-21.656 14.06-33.94 14.06zm-170.51-90.51c-12.286 0-24.566-4.686-33.942-14.058-18.746-18.746-18.746-49.134 0-67.88 81.1-81.1 81.1-213.058 0-294.156-18.746-18.746-18.746-49.138 0-67.882s49.136-18.744 67.882 0c118.53 118.53 118.53 311.392 0 429.922-9.372 9.368-21.656 14.054-33.94 14.054zm-133.014 218.98c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
  }));
};
IconVolumeMedium.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconVolumeLow = function IconVolumeLow(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconVolumeLow"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M549.02 741.02c-12.286 0-24.566-4.686-33.942-14.058-18.746-18.746-18.746-49.134 0-67.88 81.1-81.1 81.1-213.058 0-294.156-18.746-18.746-18.746-49.138 0-67.882s49.136-18.744 67.882 0c118.53 118.53 118.53 311.392 0 429.922-9.372 9.368-21.656 14.054-33.94 14.054zm-133.014 218.98c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
  }));
};
IconVolumeLow.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconVolumeMute = function IconVolumeMute(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconVolumeMute"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M960 619.148v84.852h-84.852l-107.148-107.148-107.148 107.148h-84.852v-84.852l107.148-107.148-107.148-107.148v-84.852h84.852l107.148 107.148 107.148-107.148h84.852v84.852l-107.148 107.148 107.148 107.148zm-543.994 340.852c-8.328 0-16.512-3.25-22.634-9.374l-246.626-246.626h-114.746c-17.672 0-32-14.326-32-32v-320c0-17.672 14.328-32 32-32h114.746l246.626-246.628c9.154-9.154 22.916-11.89 34.874-6.936 11.958 4.952 19.754 16.622 19.754 29.564v832c0 12.944-7.796 24.612-19.754 29.564-3.958 1.64-8.118 2.436-12.24 2.436z"
  }));
};
IconVolumeMute.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconWand = function IconWand(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconWand"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M35.06,2.53l-1,2.63L31.65,11.5,25.56,8.41,23,7.13l1.18,2.59L27,15.91,20.5,18.07l-2.69.87,2.62,1,5.5,2.13-6.65,6.71a1.1,1.1,0,0,0-.19.25L3.5,44.6l0,0a3.47,3.47,0,0,0,0,4.78l1.12,1.12a3.47,3.47,0,0,0,4.78,0L25.22,34.72l1.59-1.62,4.78-4.78,1.75,5.21.88,2.6,1-2.56,2.5-6.38,6,3,2.5,1.25-3.88-8.72,6.44-2.06,2.66-.88-2.6-1-6.37-2.5,3.09-6,1.28-2.53L44.28,8.88l-6.19,2.78L35.93,5.19Zm1.58,11M31.59,28.32,36.4,23.5a3.47,3.47,0,0,0,0-4.78l-.06-.06L35.22,17.6l0,0a3.39,3.39,0,0,0-2.37-1,3.43,3.43,0,0,0-2.41,1h0l-4.44,4.47M42.5,35.75l-.94,2.38-1.25,3.19-3.19,1.25-2.37.93,2.37.94,3.19,1.25,1.25,3.19.94,2.37.93-2.37,1.25-3.19,3.19-1.25,2.38-.94-2.38-.93-3.19-1.25-1.25-3.19Zm-12.82.75-1,2.5-2.5,1,2.5,1,1,2.5,1-2.5,2.5-1-2.5-1ZM22.08,26,28,31.89"
  }));
};
IconWand.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconWarning = function IconWarning(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconWarning3"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M26.84,5.44a1,1,0,0,0-.72.5L2.12,47.5a1,1,0,0,0,0,1A1,1,0,0,0,3,49H51a1,1,0,0,0,.87-.5,1,1,0,0,0,0-1l-24-41.56A1,1,0,0,0,26.84,5.44Zm.08,12.68V36.31M27.07,40a1.07,1.07,0,1,0-.28,2.12h.28a1.07,1.07,0,0,0,0-2.12Z"
  }));
};
IconWarning.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconWaterSensor = function IconWaterSensor(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconWaterSensor"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px",
    d: "M27,3.1S10.4,23.2,10.4,34.3a16.6,16.6,0,0,0,33.2,0C43.6,23.2,27,3.1,27,3.1ZM25.8,45.4a11,11,0,0,1-9.1-11.3c0-7.6,9.7-20.1,9.7-20.1"
  }));
};
IconWaterSensor.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconWaterValveClosed = function IconWaterValveClosed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconWaterValveClosed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M1.81,2A1,1,0,1,0,2,4v7.81A13.22,13.22,0,0,0,15.19,25H25a1,1,0,0,0,2,0h9.81A1.21,1.21,0,0,1,38,26.19V34h-.09a1,1,0,0,0,0,2H50a1,1,0,0,0,0-2V26.19A13.22,13.22,0,0,0,36.81,13H27a1,1,0,0,0-2,0H15.19A1.21,1.21,0,0,1,14,11.81V4a1,1,0,0,0,0-2ZM25,13V25m2-12V25"
  }));
};
IconWaterValveClosed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconWaterValve = function IconWaterValve(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconWaterValve"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M1.81,2A1,1,0,1,0,2,4v7.81A13.22,13.22,0,0,0,15.19,25H25a1,1,0,0,0,2,0h9.81A1.21,1.21,0,0,1,38,26.19V34h-.09a1,1,0,0,0,0,2H50a1,1,0,0,0,0-2V26.19A13.22,13.22,0,0,0,36.81,13H27a1,1,0,0,0-2,0H15.19A1.21,1.21,0,0,1,14,11.81V4a1,1,0,0,0,0-2ZM44,36l-.88,1.47s-1,1.71-2,3.72c-.5,1-1,2.1-1.4,3.09A7.37,7.37,0,0,0,39,47a5,5,0,0,0,10,0,7.38,7.38,0,0,0-.69-2.69c-.39-1-.9-2.09-1.4-3.09-1-2-2-3.72-2-3.72Z "
  }));
};
IconWaterValve.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconWindowNotOk = function IconWindowNotOk(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconWindowNotOk"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M36.39,48.8H6.8a2,2,0,0,1-2-2V4.8a2,2,0,0,1,1.63-2l.37,0h36a2,2,0,0,1,2,2V37.39h-2V4.8H6.8v42H36.39Zm-1.25-4H8.8V6.8h32V37.55h-2V27.3H25.14V42.8h10Zm-24.34-2H23.14V27.3H10.8ZM25.14,25.3H38.8V8.8H25.14Zm-14.34,0H23.14V8.8H10.8Zm31,25.9a7.4,7.4,0,1,1,7.4-7.4A7.41,7.41,0,0,1,41.8,51.2Zm0-12.79a5.4,5.4,0,1,0,5.4,5.39A5.4,5.4,0,0,0,41.8,38.41Zm1,6.47V40.62a1,1,0,0,0-2,0v4.26a1,1,0,0,0,2,0Zm-1,3.38a.95.95,0,1,1,.94-.94A.95.95,0,0,1,41.75,48.26Zm0-1a.07.07,0,0,0-.08.08c0,.09.16.09.16,0A.08.08,0,0,0,41.75,47.24Z"
  }));
};
IconWindowNotOk.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconWindowOk = function IconWindowOk(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconWindowOk"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M42.88,44.26v-36h-32v38h32v-2Zm-15.66-34H40.88v16.5H27.22Zm-2,34H12.88V28.76H25.22Zm0-17.5H12.88V10.26H25.22Zm2,2H40.88v15.5H27.22ZM46.75,51H7.25a1,1,0,0,1-1-1V4a1,1,0,0,1,1-1h39.5a1,1,0,0,1,1,1V50A1,1,0,0,1,46.75,51ZM8.25,49h37.5V5H8.25Z"
  }));
};
IconWindowOk.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconWindowOpen = function IconWindowOpen(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconWindowOpen"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M40.37,42.81V8.21H13.63v34.6h-2.4v3H42.77v-3Zm-24-31.94h9.87v5.94H16.39Zm0,7.39h9.87V24.2H16.39ZM37.84,33.4v7.39H16.39V27.45H37.84Zm0-9.2H27.74V18.26h10.1Zm0-7.39H27.74V10.87h10.1Z"
  }));
};
IconWindowOpen.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconWindowClosed = function IconWindowClosed(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconWindowClosed"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2px",
    d: "M40.37,42.8V8.2H13.63V42.8h-2.4v3H42.77v-3ZM27.74,10.86h10.1V16.8H27.74Zm0,7.39h10.1v5.94H27.74Zm0,9.2h10.1v5.94H27.74Zm0,7.39h10.1v5.94H27.74Zm-11.35-24h9.87V16.8H16.39Zm0,7.39h9.87v5.94H16.39Zm0,9.2h9.87v5.94H16.39Zm0,7.39h9.87v5.94H16.39Z"
  }));
};
IconWindowClosed.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconZWave = function IconZWave(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconZWave"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    d: "M37.16,24.83a14,14,0,1,0,14,14A14,14,0,0,0,37.16,24.83Zm4.18,20.76H29.49l6.42-10.06H29.76l2.67-4.27H44.1l-6.23,9.92H44.1ZM37.16,3.82a35,35,0,0,0-35,35m35-25.65A25.67,25.67,0,0,0,11.52,38.78"
  }));
};
IconZWave.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconDeletePinpad = function IconDeletePinpad(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconDeletePinpad"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M48,41H12c-0.7,0-1.3-0.3-1.6-0.9L2,28l8.4-12.1c0.4-0.5,1-0.8,1.6-0.9h36c1.1,0,2,0.9,2,2v22 C50,40.1,49.1,41,48,41z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3.6069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    x1: "22.4",
    y1: "34.2",
    x2: "34.9",
    y2: "21.8"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("line", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3.6069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    x1: "22.4",
    y1: "21.8",
    x2: "34.9",
    y2: "34.2"
  }));
};
IconDeletePinpad.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconDigit = function IconDigit(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconDigit"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("circle", {
    stroke: "currentColor",
    strokeMiterlimit: 30,
    cx: "28.62",
    cy: "28",
    r: "14"
  }));
};
IconDigit.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconEmptyDigit = function IconEmptyDigit(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconEmptyDigit"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 30,
    cx: "28.62",
    cy: "28",
    r: "14"
  }));
};
IconEmptyDigit.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconForgotPassword = function IconForgotPassword(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 50 50"
  }, props, {
    "data-component-name": "IconForgotPassword",
    version: "1.1",
    x: "0px",
    y: "0px"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M38,27c-6.1,0-11,4.9-11,11s4.9,11,11,11s11-4.9,11-11S44.1,27,38,27z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M26.3,31.3c-0.7-0.4-1.1-1.1-1.4-1.8c-0.1-1.6-0.1-2.7-0.1-4.2c0.7-0.4,2-2.8,2.3-4.9c0.6,0,1.5-0.6,1.7-2.8 c0.1-1.2-0.4-1.9-0.8-2.1C29,12.7,30.9,4,24.5,3.1c-0.7-1.2-2.4-1.8-4.6-1.8c-8.9,0.2-9.9,6.7-8,14.2c-0.3,0.2-0.9,0.9-0.8,2.1 c0.3,2.2,1.2,2.8,1.7,2.8c0.2,2.1,1.6,4.5,2.3,4.9c0,1.5,0.1,2.6-0.1,4.2C13.4,34.2,1.5,32.9,1,42h21"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("polygon", {
    fill: "currentColor",
    stroke: "none",
    points: "22,41 22,43 25,43 24.4,41"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("text", {
    stroke: "currentColor",
    fill: "currentColor",
    fontSize: "18px",
    transform: "matrix(1 0 0 1 34 44)"
  }, "?"));
};
IconForgotPassword.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconPasswordNotVisible = function IconPasswordNotVisible(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconPasswordNotVisible"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
    d: "M27,15C13.67,15,3.25,27.34,3.25,27.34a1,1,0,0,0,0,1.32s11,10.22,24.29,10.22S50.75,28.66,50.75,28.66a1,1,0,0,0,0-1.32S40.33,15,27,15ZM16.19,17.84a12,12,0,1,0,21.65,0M27,19a5,5,0,1,0,5,5A5,5,0,0,0,27,19ZM11.73,10.36l33,32.48"
  }));
};
IconPasswordNotVisible.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconPasswordVisible = function IconPasswordVisible(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconPasswordVisible"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
    d: "M27,15C13.67,15,3.25,27.34,3.25,27.34a1,1,0,0,0,0,1.32s11,10.22,24.29,10.22S50.75,28.66,50.75,28.66a1,1,0,0,0,0-1.32S40.33,15,27,15Zm0,24M16.19,17.84A12,12,0,1,0,39,23a12.08,12.08,0,0,0-1.16-5.16M27,18a5,5,0,1,0,5,5A5,5,0,0,0,27,18Z"
  }));
};
IconPasswordVisible.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconWaterDrop = function IconWaterDrop(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 50 50"
  }, props, {
    "data-component-name": "IconWaterDrop"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "  M25,1.173c0,0-16.615,20.135-16.615,31.211C8.385,41.562,15.822,49,25,49s16.615-7.438,16.615-16.615  C41.615,21.308,25,1.173,25,1.173z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "  M23.843,43.491c0,0-9.1-1.308-9.1-11.297c0-7.588,9.666-20.064,9.666-20.064"
  }));
};
IconWaterDrop.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconWaterDropOff = function IconWaterDropOff(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconWaterDropOff"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2px",
    strokeMiterlimit: "10",
    d: "M13,15.09l28.6,28.57M26.93,8.35S14,24.05,14,32.69a13,13,0,0,0,25.92,0C39.89,24.05,26.93,8.35,26.93,8.35Zm-.91,33a8.54,8.54,0,0,1-7.09-8.82c0-5.91,7.53-15.65,7.53-15.65"
  }));
};
IconWaterDropOff.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconCheck = function IconCheck(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconCheck"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M41,6H13a7,7,0,0,0-7,7V41a7,7,0,0,0,7,7H41a7,7,0,0,0,7-7V17M16.41,26.44l8.9,8.28.78.72.66-.78L46.75,11m1.37,5.63V41A7,7,0,0,1,41,48.12H13A7,7,0,0,1,5.88,41V13A7,7,0,0,1,13,5.88H41.26M46.93,11l-.08.09L26.11,35.62l-.88-.81-9-8.37m29-16.87"
  }));
};
IconCheck.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconRachioLogo = function IconRachioLogo(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 1024 1024"
  }, props, {
    "data-component-name": "IconRachioLogo"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M762.89 489.517c0 133.365-103.218 242.715-234.028 252.423v-185.996c0-9.198 7.665-15.84 18.395-18.395 17.884-4.088 45.988-9.198 72.559-9.198h5.621v-53.142s-39.345-3.577-108.838 15.329v-101.685c0-8.687 7.154-15.329 17.373-17.884 10.731-2.044 24.527-4.088 37.301-4.088h3.577v-33.725s-61.317 2.555-92.487 17.373v58.762c-55.697-15.329-87.377-12.263-87.377-12.263v42.411h4.599c19.417 0 39.345 3.577 54.164 6.643h-.511c10.731 2.044 18.395 4.599 18.395 13.796v279.505c-121.102-18.906-214.1-123.657-214.1-249.868 0-139.497 113.437-252.934 252.934-252.934 138.986 0 252.423 112.926 252.423 252.934zm261.11 468.056v-891.657c0-36.279-29.637-65.916-65.916-65.916h-892.168c-36.279 0-65.916 29.637-65.916 65.916v891.657c0 36.279 29.637 65.916 65.916 65.916h891.657c36.79.511 66.427-29.126 66.427-65.916zm-66.427-926.914c19.417 0 35.257 15.84 35.257 35.257v891.657c0 19.417-15.84 35.257-35.257 35.257h-891.657c-19.417 0-35.257-15.84-35.257-35.257v-891.657c0-19.417 15.84-35.257 35.257-35.257h891.657z"
  }));
};
IconRachioLogo.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconFire = function IconFire(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconFire"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M27.75,53.27a28.21,28.21,0,0,1-6.95-.9l0,.06a1.75,1.75,0,0,1-.39-.19C12.53,49.41,8,43.51,8,36.08c0-6.36,2.83-11.35,5.57-16.18l.34-.61c2.79-4.91,5.67-10,7.14-16.95A2,2,0,0,1,22.69.75h.15a2.11,2.11,0,0,1,1.53.55c8.18,7.56,13.06,12.89,16.31,17.83A29.67,29.67,0,0,1,46,36c0,8.25-5.76,15.35-13.48,16.7v.05A20.9,20.9,0,0,1,27.75,53.27Zm-6.63-2.89a24.45,24.45,0,0,0,10.72.47v-.07c7-1,12.2-7.37,12.2-14.79a27.73,27.73,0,0,0-5-15.77c-3.16-4.79-7.94-10-16-17.47h0C21.44,10,18.35,15.48,15.62,20.28l-.34.61C12.67,25.49,10,30.25,10,36.08,10,45,16.94,48.87,21.12,50.38ZM27.91,49a16.32,16.32,0,0,1-6.26-1.35l-.2-.11C19.67,46.12,17,42.69,17,39.71a16.25,16.25,0,0,1,1.42-6.79l.21-.51c.57-1.4,1.23-3,1.82-4.88l.57-1.79,1.17,1.47A13.53,13.53,0,0,1,25,33.73h0a34.89,34.89,0,0,0,3.1-15.27L28,15.81l1.83,1.93C36.6,24.93,38,31.14,38,35.09c0,6.18-1.59,10.37-4.81,12.45A9.57,9.57,0,0,1,27.91,49Zm-5.33-3.12c.78.33,5.91,2.34,9.5,0C34.69,44.17,36,40.55,36,35.08c0-3.23-1-8.17-5.92-14a38.84,38.84,0,0,1-3.24,13.63,2,2,0,0,1-3.84-.8h0a12,12,0,0,0-1.25-3.78c-.41,1.14-.83,2.15-1.21,3.08l-.21.51a14.38,14.38,0,0,0-1.27,6C19,41.85,21.1,44.64,22.58,45.84Z"
  }));
};
IconFire.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconSnowflake = function IconSnowflake(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 54 54"
  }, props, {
    "data-component-name": "IconSnowflake"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M48.67,39.5a1,1,0,0,1-1.37.37l-6.62-3.82,1.59,5.89a1,1,0,0,1-.71,1.23l-.26,0a1,1,0,0,1-1-.74l-2.1-7.82L28,28.73V40.59l5.71,5.7a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0L28,43.41V51a1,1,0,0,1-2,0V43.41l-4.29,4.3a1,1,0,0,1-1.42-1.42L26,40.59V28.73L15.76,34.64l-2.09,7.82a1,1,0,0,1-1,.74l-.26,0a1,1,0,0,1-.71-1.23l1.58-5.89L6.7,39.87a1,1,0,1,1-1-1.74l6.59-3.8L6.44,32.77A1,1,0,1,1,7,30.83l7.78,2.09L25,27,14.74,21.08,7,23.17l-.26,0a1,1,0,0,1-1-.74,1,1,0,0,1,.71-1.23l5.85-1.56L5.7,15.87a1,1,0,0,1,1-1.74L13.31,18l-1.58-5.89a1,1,0,0,1,1.94-.52l2.09,7.82L26,25.27V13.41l-5.71-5.7a1,1,0,0,1,1.42-1.42L26,10.59V3a1,1,0,0,1,2,0v7.59l4.29-4.3a1,1,0,1,1,1.42,1.42L28,13.41V25.27l10.23-5.91,2.1-7.82a1,1,0,1,1,1.94.52L40.68,18l6.62-3.82a1,1,0,1,1,1,1.74l-6.59,3.8,5.85,1.56a1,1,0,0,1,.71,1.23,1,1,0,0,1-1,.74,1.15,1.15,0,0,1-.26,0l-7.78-2.09L29,27l10.26,5.92L47,30.83a1,1,0,1,1,.52,1.94l-5.85,1.56,6.59,3.8A1,1,0,0,1,48.67,39.5Z"
  }));
};
IconSnowflake.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconPivotOccupied = function IconPivotOccupied(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 64 64"
  }, props, {
    "data-component-name": "IconPivotOccupied"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M41.84,30.4V40.59l-.09.2a1.16,1.16,0,0,1-2.22-.21,2.81,2.81,0,0,1-.06-.65V31.66c0-.14,0-.27,0-.42H37.13v.48q0,11.72,0,23.44a4,4,0,0,1,0,.68,1.68,1.68,0,0,1-1.72,1.36,1.66,1.66,0,0,1-1.61-1.44,4.74,4.74,0,0,1-.05-.65V41.93c0-.15,0-.3,0-.48a30.81,30.81,0,0,0-3.33,0V55.59a1.71,1.71,0,0,1-1.72,1.61A1.67,1.67,0,0,1,27,55.58c0-.17,0-.34,0-.5V31.71c0-.15,0-.3,0-.46H24.55v4.92c0,1.32,0,2.64,0,3.95a1.61,1.61,0,0,1-.19.81,1.13,1.13,0,0,1-1,.59,1.09,1.09,0,0,1-1-.58,1.65,1.65,0,0,1-.19-.84c0-3.06,0-6.11,0-9.17,0-2.16,2.67-3.87,4.82-3.89,2.64,0,7.29,0,9.93,0,1.72,0,4,.85,4.64,2.43A7,7,0,0,1,41.84,30.4Z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M32.65,18.33c.34.14.69.24,1,.41A3.57,3.57,0,1,1,31,18.46l.38-.13Z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("rect", {
    x: "43.06",
    y: "10.34",
    width: "9.84",
    fill: "none"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("polygon", {
    points: "51.9 30.01 51.9 29.67 51.9 11.34 44.06 11.34 44.06 17.21 44.06 20.09 42.27 17.82 32 4.81 4.6 39.53 11.11 39.53 12.11 39.53 12.11 40.53 12.11 59.47 51.9 59.47 51.9 40.53 51.9 39.53 52.9 39.53 59.4 39.53 52.11 30.29 51.9 30.01",
    fill: "none"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M63,39.41,54.77,29V8.47H41.19v3.35l-7.3-9.25a2.41,2.41,0,0,0-3.78,0L1,39.41a1.93,1.93,0,0,0-.38,2,1.9,1.9,0,0,0,1.82,1H9.24V59.54a2.8,2.8,0,0,0,2.8,2.8H52a2.8,2.8,0,0,0,2.81-2.8V42.4h6.76a1.74,1.74,0,0,0,1.44-3Zm-10.07.12h-1V59.47H12.11V39.53H4.6L32,4.81l10.28,13,1.78,2.26V11.34H51.9V30l.21.28,7.29,9.24Z"
  }));
};
IconPivotOccupied.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconPivotUnoccupied = function IconPivotUnoccupied(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 64 64"
  }, props, {
    "data-component-name": "IconPivotUnoccupied"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("polygon", {
    points: "51.9 30.01 51.9 29.67 51.9 11.34 44.06 11.34 44.06 17.21 44.06 20.09 42.27 17.82 32 4.81 4.6 39.53 11.1 39.53 12.1 39.53 12.1 40.53 12.1 59.47 51.9 59.47 51.9 40.53 51.9 39.53 52.9 39.53 59.4 39.53 52.11 30.29 51.9 30.01",
    fill: "none"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M63,39.41,54.77,29V8.47H41.19v3.35l-7.3-9.25a2.41,2.41,0,0,0-3.78,0L1,39.41a1.91,1.91,0,0,0-.38,2,1.9,1.9,0,0,0,1.82,1H9.23V59.54A2.8,2.8,0,0,0,12,62.34H52a2.8,2.8,0,0,0,2.81-2.8V42.4h6.76a1.74,1.74,0,0,0,1.44-3Zm-10.07.12h-1V59.47H12.1V39.53H4.6L32,4.81l10.28,13,1.78,2.26V11.34H51.9V30l.21.28,7.29,9.24Z"
  }));
};
IconPivotUnoccupied.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconBuilding = function IconBuilding(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 64 64"
  }, props, {
    "data-component-name": "IconBuilding"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M7.62,28.52V5.93c0-2.38.54-2.95,3-2.95H53.35c2.47,0,3,.59,3,3.11q0,22.59,0,45.18a6.93,6.93,0,0,1-.2,1.7,1.47,1.47,0,0,1-1.55,1.14A1.44,1.44,0,0,1,53.06,53a10.32,10.32,0,0,1-.22-2.22q0-20.94,0-41.88c0-2.69.23-2.4-2.45-2.4H13c-2.1,0-2.1,0-2.1,2q0,20.43,0,40.84c0,1,0,2.09,0,3.12a1.6,1.6,0,0,1-3.2.17,11.21,11.21,0,0,1-.08-1.74V28.52Z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M32.12,57.47h29a6.14,6.14,0,0,1,.86,0,1.75,1.75,0,0,1,1.77,1.58A1.9,1.9,0,0,1,62.08,61a7,7,0,0,1-1.21.05H3.57a9.94,9.94,0,0,1-1.73-.08,1.72,1.72,0,0,1,.07-3.43,13.54,13.54,0,0,1,1.56,0H32.12Z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M46.3,34.47A1.6,1.6,0,0,1,44.73,36a1.52,1.52,0,0,1-1.59-1.32,29.71,29.71,0,0,1,0-4.81,1.42,1.42,0,0,1,1.62-1.24A1.48,1.48,0,0,1,46.27,30,29.13,29.13,0,0,1,46.3,34.47Z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M33.59,34.47A1.6,1.6,0,0,1,32,36a1.51,1.51,0,0,1-1.58-1.32,28.61,28.61,0,0,1,0-4.81,1.42,1.42,0,0,1,1.62-1.24A1.5,1.5,0,0,1,33.57,30,30.4,30.4,0,0,1,33.59,34.47Z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M20.88,34.47A1.59,1.59,0,0,1,19.31,36a1.51,1.51,0,0,1-1.58-1.32,29.71,29.71,0,0,1,0-4.81,1.41,1.41,0,0,1,1.61-1.24A1.49,1.49,0,0,1,20.86,30,27.86,27.86,0,0,1,20.88,34.47Z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M46.3,20.44A1.6,1.6,0,0,1,44.73,22a1.52,1.52,0,0,1-1.59-1.32,29.71,29.71,0,0,1,0-4.81,1.42,1.42,0,0,1,1.62-1.24A1.48,1.48,0,0,1,46.27,16,29.13,29.13,0,0,1,46.3,20.44Z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M33.59,20.44A1.6,1.6,0,0,1,32,22a1.51,1.51,0,0,1-1.58-1.32,28.61,28.61,0,0,1,0-4.81,1.42,1.42,0,0,1,1.62-1.24A1.5,1.5,0,0,1,33.57,16,30.4,30.4,0,0,1,33.59,20.44Z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M20.88,20.44A1.59,1.59,0,0,1,19.31,22a1.51,1.51,0,0,1-1.58-1.32,29.71,29.71,0,0,1,0-4.81,1.41,1.41,0,0,1,1.61-1.24A1.49,1.49,0,0,1,20.86,16,27.86,27.86,0,0,1,20.88,20.44Z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M38.78,44c0-1.91-.62-2.44-2.54-2.47-1.41,0-2.83,0-4.24,0s-2.83,0-4.24,0c-1.92,0-2.5.56-2.54,2.47,0,2.55,0,5.09,0,7.64,0,1.67.67,2.52,1.78,2.51s1.73-.88,1.75-2.53c0-1.85,0-3.7,0-5.55,0-.5.08-.93.72-1s.85.42.85,1v5.38a7,7,0,0,0,.09,1.38,1.62,1.62,0,0,0,3.16,0,7,7,0,0,0,.09-1.38V46.06c0-.58.12-1,.85-1s.72.47.72,1c0,1.85,0,3.7,0,5.55,0,1.65.63,2.51,1.75,2.53s1.76-.84,1.78-2.51C38.82,49.05,38.83,46.51,38.78,44Z"
  }));
};
IconBuilding.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var IconTransferAccount = function IconTransferAccount(props) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconBase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_extends___default()({
    viewBox: "0 0 48 48"
  }, props, {
    "data-component-name": "IconTransferAccount"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("g", {
    opacity: "1",
    fillOpacity: "0",
    stroke: "#959DA4",
    strokeWidth: "2",
    strokeOpacity: "1"
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M37.5 24L48 13.5L37.5 3L37.5 10.5L0 10.5L0 16.5L37.5 16.5L37.5 24Z"
  }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("path", {
    d: "M10.5 45L0 34.5L10.5 24L10.5 31.5L48 31.5L48 37.5L10.5 37.5L10.5 45Z"
  })));
};
/* eslint-disable camelcase */

IconTransferAccount.propTypes = {
  modifiers: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
var apiNameMap = {
  // These are organized in roughly the same order as in mobile/icons.rb in the
  // serverside code.
  settings: IconSettings,
  "plus-sign": IconPlusSign,
  calendar: IconCalendar,
  calendar_empty: IconCalendarEmpty,
  clock: IconClock,
  sun: IconSunny,
  moon: IconMoon,
  new_device: IconLightning,
  create_group: IconCreateGroup,
  zwave: IconZWave,
  bridge: IconNexiaLogo,
  automation: IconWand,
  mode: IconRefresh,
  remove: IconRemove,
  music: IconMusic,
  question: IconQuestion,
  window_blind_open: IconBlindsOpen,
  window_blind_mostly_open: IconBlindsMostlyOpen,
  window_blind_half_open: IconBlindsHalfOpen,
  window_blind_mostly_closed: IconBlindsMostlyClosed,
  window_blind_closed: IconBlindsClosed,
  window_shade_open: IconShadesOpen,
  window_shade_mostly_open: IconShadesMostlyOpen,
  window_shade_half_open: IconShadesHalfOpen,
  window_shade_mostly_closed: IconShadesMostlyClosed,
  window_shade_closed: IconShadesClosed,
  window_shade_bottomup_open: IconShadesOpen,
  window_shade_bottomup_mostly_open: IconShadesBottomMostlyOpen,
  window_shade_bottomup_half_open: IconShadesBottomHalfOpen,
  window_shade_bottomup_mostly_closed: IconShadesBottomMostlyClosed,
  window_shade_bottomup_closed: IconShadesClosed,
  speaker: IconMusic,
  speaker_play: IconPlay,
  speaker_pause: IconPause,
  speaker_volume: IconVolumeHigh,
  speaker_play_favorite: IconPlay,
  speaker_play_url: IconPlay,
  speaker_next: IconFastForward,
  speaker_previous: IconRewind,
  lock_locked: IconLocked,
  lock_unknown: IconLockUnknown,
  lock_unlocked: IconUnlocked,
  caution: IconWarning,
  mouse_trap_armed: IconMouseTrapArmed,
  mouse_trap_disarmed: IconMouseTrapDisarmed,
  mouse_trap_tripped: IconMouseTrapTripped,
  sensor_generic_tripped: IconSensorGenericActive,
  sensor_generic_idle: IconSensorGeneric,
  sensor_glass_tripped: IconWindowNotOk,
  sensor_glass_idle: IconWindowOk,
  sensor_door_tripped: IconDoorOpen,
  sensor_door_idle: IconDoor,
  sensor_window_tripped: IconWindowOpen,
  sensor_window_idle: IconWindowClosed,
  sensor_water_tripped: IconWaterSensor,
  sensor_water_idle: IconWaterSensor,
  sensor_motion_tripped: IconSensorActivated,
  sensor_motion_idle: IconSensorMotionIdle,
  "sliding-door-unknown": IconSlidingDoorUnknown,
  "sliding-door-open": IconSlidingDoorOpen,
  "sliding-door-closed": IconSlidingDoorClosed,
  "sliding-door-closed-locked": IconSlidingDoorClosedLocked,
  "sliding-door-closed-unlocked": IconSlidingDoorClosedUnlocked,
  "hinged-door-unknown": IconHingedDoorUnknown,
  "hinged-door-open": IconHingedDoorOpen,
  "hinged-door-closed": IconHingedDoorClosed,
  "hinged-door-closed-locked": IconHingedDoorClosedLocked,
  "hinged-door-closed-unlocked": IconHingedDoorClosedUnlocked,
  "double-hung-window-unknown": IconDoubleHungWindowUnknown,
  "double-hung-window-open": IconDoubleHungWindowOpen,
  "double-hung-window-closed": IconDoubleHungWindowClosed,
  "double-hung-window-closed-locked": IconDoubleHungWindowClosedLocked,
  "double-hung-window-closed-unlocked": IconDoubleHungWindowClosedUnlocked,
  "casement-window-unknown": IconCasementWindowUnknown,
  "casement-window-open": IconCasementWindowOpen,
  "casement-window-closed": IconCasementWindowClosed,
  "casement-window-closed-locked": IconCasementWindowClosedLocked,
  "casement-window-closed-unlocked": IconCasementWindowClosedUnlocked,
  smoke_detector_tripped: IconSmokeDetectorTriggered,
  smoke_detector_idle: IconSmokeDetector,
  thermostat: IconThermostat,
  climate: IconClimate,
  heating: IconFire,
  cooling: IconSnowflake,
  humidity: IconDroplets,
  temperature: IconThermostat,
  above_value: IconThinArrowUp,
  below_value: IconThinArrowDown,
  dimmer_0: IconLightbulb0,
  dimmer_30: IconLightbulb100,
  dimmer_70: IconLightbulb100,
  dimmer_100: IconLightbulb100,
  remote: IconRemote,
  switch_on: IconLightSwitchOn,
  switch_off: IconLightSwitchOff,
  siren_on: IconSirenOn,
  siren_off: IconSiren,
  doorbell_triggered: IconDoorbellTriggered,
  doorbell_waiting: IconDoorbellWaiting,
  valve_open: IconWaterValve,
  valve_closed: IconWaterValveClosed,
  barrier_open: IconGarageOpen,
  barrier_closed: IconGarageClosed,
  barrier_partially_open: IconGaragePartial,
  nest_structure_home: IconNestHomeIcon,
  nest_structure_away: IconNestAwayIcon,
  nest_structure_unknown: IconNestUnknownIcon,
  camera: IconCamera,
  camera_disconnected: IconCameraDisconnected,
  zid_connected: IconSensorGeneric,
  zid_disconnected: IconSensorGenericActive,
  message: IconChat,
  insynctive: IconInsynctive,
  battery_full: IconBatteryFull,
  battery_mostly_full: IconBatteryMostlyFull,
  battery_mostly_empty: IconBatteryLow,
  battery_empty: IconBatteryEmpty,
  ceiling_fan_on: IconFanMoving,
  ceiling_fan_off: IconFanOff,
  thermostat_fan_on: IconFanOn,
  thermostat_fan_off: IconFanOff,
  home_controller: IconHomeController,
  energy_meter: IconEnergyMeter,
  sprinkler_on: IconIrrigationOn,
  sprinkler_off: IconIrrigationOff,
  samsung_vacuum: IconSamsungVacuum,
  samsung_vacuum_charging: IconSamsungVacuumCharging,
  samsung_vacuum_offline: IconSamsungVacuumOffline,
  samsung_washer: IconSamsungWasher,
  samsung_washer_offline: IconSamsungWasherOffline,
  samsung_dryer: IconSamsungDryer,
  samsung_dryer_offline: IconSamsungDryerOffline,
  at_home: IconHomeMode,
  shield: IconShield,
  heart: IconHeart,
  star: IconStar,
  key: IconKey,
  smile: IconSmile,
  user: IconUser,
  globe: IconGlobe,
  plane: IconPlane,
  dials: IconEqualizer,
  rewind: IconHistory,
  bell: IconBell,
  gears: IconGears,
  // Currently, serverside uses mode.icon instead of Mobile::Icons.mode_icon.
  // So we need to support these names, too. Duplicate entries are commented
  // out, but kept in here because they're mode icons.
  home: IconHomeMode,
  away: IconShield,
  sleep: IconMoon,
  "alarm-clock": IconClock,
  // heart: IconHeart,
  // star: IconStar,
  // key: IconKey,
  smiley: IconSmile,
  // user: IconUser,
  network: IconGlobe,
  picture: IconPlane // dials: IconDials,
  // rewind: IconRewind,
  // bell: IconBell,
  // calendar: IconCalendar,
  // shield: IconShield,

};
/* eslint-enable camelcase */

function iconFromAPIName(name) {
  return apiNameMap[name];
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_LOCKOUT_MINUTES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_framework_model__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_url__ = __webpack_require__(73);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var KEYS = {
  AUTH_TYPE: "auth_type",
  PIN_NUMBER: "pin_number",
  AUTH_ATTEMPTS: "auth_attempts",
  AUTH_ATTEMPT_AT: "auth_attempt_at",
  MOBILE_ID: "mobile_id",
  API_KEY: "api_key",
  HOST: "host",
  DEFAULT_LOCATION_ID: "default_location_id",
  HIGH_RES_VIDEO: "high_res_video",
  PUSH_NOTIFICATION_TOKEN: "push_notification_token",
  NOTIFICATION_SOUND_ENABLED: "notification_sound_enabled",
  DEVICE_SORT_ORDER: "device_sort_order",
  SHOW_NEWS: "show_news",
  VOGNITION: "vognition",
  VOGNITION_ON_STARTUP: "vognition_on_startup",
  DEBUG: "debug",
  DEBUG_VIDEO: "debug_video",
  DEBUG_STREAMING: "debug_streaming",
  SHOW_POLLING: "show_polling",
  FAST_POLLING: "fast_polling",
  DASHBOARD_AUTOMATIONS: "dashboard_automations",
  THERMOSTAT_SCHEDULING_ENABLED: "thermostat_scheduling_enabled",
  EVENT_STREAMING_ENABLED: "event_streaming_enabled",
  MULTI_VIDEO_ENABLED: "multi_video_enabled",
  PHONE_AUTH_PIN_ENABLED: "phone_auth_pin_enabled",
  DRAW_UPDATES: "draw_updates",
  DARK_MODE: "dark_mode",
  HAS_SEEN_THERMOSTAT_SCHEDULING_INSTRUCTIONS: "has_seen_thermostat_scheduling_instructions",
  HANDEDNESS: "handedness",
  LOCALE: "locale"
};
var AUTH_TYPES = {
  PIN: "pin",
  FINGERPRINT: "fingerprint",
  NONE: "none",
  UNINITIALIZED: "undefined"
};
var AUTH_LOCKOUT_ATTEMPTS = 5;
var AUTH_LOCKOUT_MINUTES = 5;
var isCommercial = __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_environment__["a" /* default */].isCommercial();

var LocalSettings =
/*#__PURE__*/
function (_Model) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(LocalSettings, _Model);

  function LocalSettings() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, LocalSettings);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(LocalSettings).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(LocalSettings, [{
    key: "initialize",
    value: function initialize() {
      var _this = this;

      this.listenTo(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].Event.NOTIFICATION_TOKEN, function (event) {
        $.ajax({
          type: "POST",
          url: "".concat(_this.getHost(), "/mobile/register_for_push_notifications"),
          data: {
            /* eslint-disable camelcase */
            push_notification_token: event.token
            /* eslint-enable camelcase */

          }
        });
      });
    } // This is called when the script interface is ready to update platform data with new patterns

  }, {
    key: "ensureBackwardsCompatibility",
    value: function ensureBackwardsCompatibility() {
      var _this2 = this;

      {
        // 4.11 -> 4.12 changed "PIN" to "PIN_NUMBER"
        var pin = this.getValue("pin");

        if (pin != null) {
          this.setValue(KEYS.PIN_NUMBER, pin);
          this.clearValue("pin");
        }
      }
      {
        // 4.11 -> 4.12 changed authorization patterns to support fingerprints
        //   - pin_required now maps to an auth_type
        var pinRequired = this.getBooleanValue("pin_required", "default value");

        switch (pinRequired) {
          case true:
            {
              // An upgrading user who chose to require PIN is migrated to the PIN auth type
              this.setAuthToPin();
              break;
            }

          case false:
            {
              // An upgrading user who chose to disable PIN will continue to have to authorization
              this.setAuthToNone();
              break;
            }

          default:
            {
              if (this.getValue(KEYS.AUTH_TYPE)) {// A fully migrated user doesn't need further work
              } else if (this.hasPin()) {
                // An upgrading user who never changed the settings is migrated to PIN auth as well
                this.setAuthToPin();
              } else if (!this.getValue(KEYS.AUTH_TYPE)) {
                // A user who has a fresh install is defaulted to PIN or fingerprint if available
                this.setAuthToPin();
                __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].isFingerprintAuthAvailable().then(function (available) {
                  if (available) {
                    _this2.setAuthToFingerprint();
                  }
                })["catch"](function () {// ignore platform bridge error
                });
              }
            }
        }

        this.clearValue("pin_required");
      }
    }
  }, {
    key: "authenticate",
    value: function authenticate(username, password, params) {
      var auth = new __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_framework_model__["a" /* default */](_objectSpread({
        /* eslint-disable camelcase */
        login: username,
        password: password,
        device_uuid: __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].deviceUUID,
        is_commercial: isCommercial
      }, params));
      var host = this.getHost();
      auth.url = "".concat(host, "/mobile/authenticate");
      return auth.save()["catch"](function (xhr) {
        var message = xhr.responseJSON.error.message;
        throw message || "An unknown error occured.";
      });
    }
  }, {
    key: "setMobileIdAndApiKey",
    value: function setMobileIdAndApiKey(mobileId, apiKey) {
      this.setValue(KEYS.MOBILE_ID, mobileId);
      return this.setValue(KEYS.API_KEY, apiKey);
    }
  }, {
    key: "setLocale",
    value: function setLocale(locale) {
      return this.setValue(KEYS.LOCALE, locale || "en_us");
    }
  }, {
    key: "getLocale",
    value: function getLocale() {
      return this.getValue(KEYS.LOCALE);
    }
  }, {
    key: "getMobileId",
    value: function getMobileId() {
      return this.getValue(KEYS.MOBILE_ID);
    }
  }, {
    key: "getApiKey",
    value: function getApiKey() {
      return this.getValue(KEYS.API_KEY);
    }
  }, {
    key: "getHost",
    value: function getHost() {
      var host = this.getValue(KEYS.HOST);
      return host == null ? __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_environment__["a" /* default */].defaultHostForEnvironment() : host;
    }
  }, {
    key: "setHost",
    value: function setHost(url) {
      return this.setValue(KEYS.HOST, __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_url__["a" /* default */].getHostAddress(url));
    }
  }, {
    key: "isPointedToProductionHost",
    value: function isPointedToProductionHost() {
      return this.getHost() === __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_environment__["a" /* default */].PRODUCTION_HOST;
    }
  }, {
    key: "canSkipLogin",
    value: function canSkipLogin() {
      return this.isActivated() && !this.needsAuthentication();
    }
  }, {
    key: "isActivated",
    value: function isActivated() {
      return this.getValue(KEYS.MOBILE_ID) != null && this.getValue(KEYS.API_KEY) != null;
    }
  }, {
    key: "getCurrentAuth",
    value: function getCurrentAuth() {
      if (!__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].isMobilePlatform()) {
        return AUTH_TYPES.NONE;
      }

      return this.getValue(KEYS.AUTH_TYPE) || AUTH_TYPES.UNINITIALIZED;
    }
  }, {
    key: "setAuthToPin",
    value: function setAuthToPin() {
      this.setValue(KEYS.AUTH_TYPE, AUTH_TYPES.PIN);
    }
  }, {
    key: "setAuthToFingerprint",
    value: function setAuthToFingerprint() {
      this.setValue(KEYS.AUTH_TYPE, AUTH_TYPES.FINGERPRINT);
    }
  }, {
    key: "setAuthToNone",
    value: function setAuthToNone() {
      this.setValue(KEYS.AUTH_TYPE, AUTH_TYPES.NONE);
    }
  }, {
    key: "needsAuthentication",
    value: function needsAuthentication() {
      var currentAuth = this.getCurrentAuth();
      return !(currentAuth === AUTH_TYPES.NONE || currentAuth === AUTH_TYPES.UNINITIALIZED);
    }
  }, {
    key: "hasPin",
    value: function hasPin() {
      return this.getValue(KEYS.PIN_NUMBER) != null;
    }
  }, {
    key: "pinLength",
    value: function pinLength() {
      return (this.getValue(KEYS.PIN_NUMBER) || "").length;
    }
  }, {
    key: "needsPin",
    value: function needsPin() {
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].isMobilePlatform() && !this.hasPin();
    }
  }, {
    key: "isPinValid",
    value: function isPinValid(value) {
      return value === this.getValue(KEYS.PIN_NUMBER);
    }
  }, {
    key: "setEnabledByAuthPin",
    value: function setEnabledByAuthPin(bool) {
      return this.setValue(KEYS.PHONE_AUTH_PIN_ENABLED, bool);
    }
  }, {
    key: "isEnabledByAuthPin",
    value: function isEnabledByAuthPin() {
      return this.getValue(KEYS.PHONE_AUTH_PIN_ENABLED);
    }
  }, {
    key: "saveNewPin",
    value: function saveNewPin(value) {
      this.setValue(KEYS.PIN_NUMBER, value);
    }
  }, {
    key: "clearPin",
    value: function clearPin() {
      this.clearValue(KEYS.PIN_NUMBER);
      this.clearValue(KEYS.AUTH_ATTEMPTS);
    }
  }, {
    key: "recordFailedAuthAttempt",
    value: function recordFailedAuthAttempt() {
      var attempts = parseInt(this.getValue(KEYS.AUTH_ATTEMPTS)) || 0;
      attempts++;
      this.setValue(KEYS.AUTH_ATTEMPTS, attempts);
      this.setValue(KEYS.AUTH_ATTEMPT_AT, Date.now().toString());
    }
  }, {
    key: "isAuthAttemptLockedOut",
    value: function isAuthAttemptLockedOut() {
      var lastAttempt = parseInt(this.getValue(KEYS.AUTH_ATTEMPT_AT)) || 0;
      var timeSinceLastAttempt = Date.now() - lastAttempt;

      if (timeSinceLastAttempt < AUTH_LOCKOUT_MINUTES * 60 * 1000) {
        var numberOfAttempts = parseInt(this.getValue(KEYS.AUTH_ATTEMPTS)) || 0;

        if (numberOfAttempts >= AUTH_LOCKOUT_ATTEMPTS) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "clearFailedAuthAttempts",
    value: function clearFailedAuthAttempts() {
      this.setValue(KEYS.AUTH_ATTEMPTS, 0);
      this.setValue(KEYS.AUTH_ATTEMPT_AT, 0);
    }
  }, {
    key: "publish",
    value: function publish() {
      $.ajax({
        type: "PUT",
        url: "".concat(this.getHost(), "/mobile/settings"),
        data: {
          geofencing_enabled: false // eslint-disable-line camelcase

        }
      });
    }
  }, {
    key: "setShowNews",
    value: function setShowNews(yesno) {
      return this.setValue(KEYS.SHOW_NEWS, yesno);
    }
  }, {
    key: "getShowNews",
    value: function getShowNews() {
      return this.getBooleanValue(KEYS.SHOW_NEWS, true);
    }
  }, {
    key: "setNotificationSoundEnabled",
    value: function setNotificationSoundEnabled(yesno) {
      return this.setValue(KEYS.NOTIFICATION_SOUND_ENABLED, yesno);
    }
  }, {
    key: "getNotificationSoundEnabled",
    value: function getNotificationSoundEnabled() {
      return this.getBooleanValue(KEYS.NOTIFICATION_SOUND_ENABLED, true);
    }
  }, {
    key: "setDefaultLocationId",
    value: function setDefaultLocationId(id) {
      return this.setValue(KEYS.DEFAULT_LOCATION_ID, id);
    }
  }, {
    key: "getDefaultLocationId",
    value: function getDefaultLocationId() {
      return this.getValue(KEYS.DEFAULT_LOCATION_ID);
    }
  }, {
    key: "setShowVognition",
    value: function setShowVognition(yesno) {
      return this.setValue(KEYS.VOGNITION, yesno);
    }
  }, {
    key: "getShowVognition",
    value: function getShowVognition() {
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].isVognitionSupported() && this.getBooleanValue(KEYS.VOGNITION, true) && this.isPointedToProductionHost() && !isCommercial;
    }
  }, {
    key: "setShowVognitionOnStartup",
    value: function setShowVognitionOnStartup(yesno) {
      return this.setValue(KEYS.VOGNITION_ON_STARTUP, yesno);
    }
  }, {
    key: "getShowVognitionOnStartup",
    value: function getShowVognitionOnStartup() {
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].isVognitionSupported() && this.getBooleanValue(KEYS.VOGNITION_ON_STARTUP, false) && this.isPointedToProductionHost() && !isCommercial;
    }
  }, {
    key: "setDebug",
    value: function setDebug(yesno) {
      return this.setValue(KEYS.DEBUG, yesno);
    }
  }, {
    key: "getDebug",
    value: function getDebug() {
      return this.getBooleanValue(KEYS.DEBUG);
    }
  }, {
    key: "setShowPolling",
    value: function setShowPolling(bool) {
      return this.setValue(KEYS.SHOW_POLLING, bool);
    }
  }, {
    key: "getShowPolling",
    value: function getShowPolling() {
      return this.getBooleanValue(KEYS.SHOW_POLLING);
    }
  }, {
    key: "setFastPolling",
    value: function setFastPolling(bool) {
      return this.setValue(KEYS.FAST_POLLING, bool);
    }
  }, {
    key: "getFastPolling",
    value: function getFastPolling() {
      return this.getBooleanValue(KEYS.FAST_POLLING);
    }
  }, {
    key: "setDebugVideo",
    value: function setDebugVideo(bool) {
      return this.setValue(KEYS.DEBUG_VIDEO, bool);
    }
  }, {
    key: "getDebugVideo",
    value: function getDebugVideo() {
      return this.getBooleanValue(KEYS.DEBUG_VIDEO);
    }
  }, {
    key: "getDeviceSortOrder",
    value: function getDeviceSortOrder() {
      var order = this.getValue(KEYS.DEVICE_SORT_ORDER);
      return order || "default";
    }
  }, {
    key: "setDeviceSortOrder",
    value: function setDeviceSortOrder(newOrder) {
      return this.setValue(KEYS.DEVICE_SORT_ORDER, newOrder);
    }
  }, {
    key: "setThermostatSchedulingEnabled",
    value: function setThermostatSchedulingEnabled(bool) {
      this.setValue(KEYS.THERMOSTAT_SCHEDULING_ENABLED, bool);
    }
  }, {
    key: "getThermostatSchedulingEnabled",
    value: function getThermostatSchedulingEnabled() {
      return isCommercial ? true : this.getBooleanValue(KEYS.THERMOSTAT_SCHEDULING_ENABLED, false);
    }
  }, {
    key: "setEventStreamingEnabled",
    value: function setEventStreamingEnabled(bool) {
      this.setValue(KEYS.EVENT_STREAMING_ENABLED, bool);
    }
  }, {
    key: "getEventStreamingEnabled",
    value: function getEventStreamingEnabled() {
      return this.getBooleanValue(KEYS.EVENT_STREAMING_ENABLED, false);
    }
  }, {
    key: "setMultiVideoEnabled",
    value: function setMultiVideoEnabled(bool) {
      this.setValue(KEYS.MULTI_VIDEO_ENABLED, bool);
    }
  }, {
    key: "getMultiVideoEnabled",
    value: function getMultiVideoEnabled() {
      return this.getBooleanValue(KEYS.MULTI_VIDEO_ENABLED, false);
    }
  }, {
    key: "setDrawUpdates",
    value: function setDrawUpdates(bool) {
      this.setValue(KEYS.DRAW_UPDATES, bool);
    }
  }, {
    key: "getDrawUpdates",
    value: function getDrawUpdates() {
      return this.getBooleanValue(KEYS.DRAW_UPDATES, false);
    }
  }, {
    key: "setDarkMode",
    value: function setDarkMode(bool) {
      this.setValue(KEYS.DARK_MODE, bool);
    }
  }, {
    key: "getDarkMode",
    value: function getDarkMode() {
      return this.getBooleanValue(KEYS.DARK_MODE, false);
    }
  }, {
    key: "setHasSeenThermostatSchedulingInstructions",
    value: function setHasSeenThermostatSchedulingInstructions(bool) {
      this.setValue(KEYS.HAS_SEEN_THERMOSTAT_SCHEDULING_INSTRUCTIONS, bool);
    }
  }, {
    key: "getHasSeenThermostatSchedulingInstructions",
    value: function getHasSeenThermostatSchedulingInstructions() {
      return this.getBooleanValue(KEYS.HAS_SEEN_THERMOSTAT_SCHEDULING_INSTRUCTIONS, false);
    }
  }, {
    key: "getHandedness",
    value: function getHandedness() {
      return this.getValue(KEYS.HANDEDNESS) || "right";
    }
  }, {
    key: "setHandedness",
    value: function setHandedness(newValue) {
      return this.setValue(KEYS.HANDEDNESS, newValue);
    }
  }, {
    key: "setDebugStreaming",
    value: function setDebugStreaming(bool) {
      return this.setValue(KEYS.DEBUG_STREAMING, bool);
    }
  }, {
    key: "getDebugStreaming",
    value: function getDebugStreaming() {
      return this.getBooleanValue(KEYS.DEBUG_STREAMING);
    }
  }, {
    key: "getDeviceName",
    value: function getDeviceName() {
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].deviceName;
    }
  }, {
    key: "obtainPushNotificationToken",
    value: function obtainPushNotificationToken() {
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].obtainPushNotificationToken();
    }
  }, {
    key: "setAutomationShownOnDashboard",
    value: function setAutomationShownOnDashboard(automationId, bool) {
      this.setValue("".concat(KEYS.DASHBOARD_AUTOMATIONS, "_").concat(automationId), bool);
    }
  }, {
    key: "getAutomationShownOnDashboard",
    value: function getAutomationShownOnDashboard(automationId) {
      return this.getBooleanValue("".concat(KEYS.DASHBOARD_AUTOMATIONS, "_").concat(automationId), false);
    }
  }, {
    key: "getTrackedSettings",
    value: function getTrackedSettings() {
      return {
        /* eslint-disable camelcase */
        dark_mode: this.getDarkMode(),
        multi_video_enabled: this.getMultiVideoEnabled()
        /* eslint-disable camelcase */

      };
    }
  }, {
    key: "getValue",
    value: function getValue(key) {
      var val = __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].getStoredValue(key);

      if (val === "undefined") {
        val = undefined;
      }

      if (val === "null") {
        val = null;
      }

      return val;
    }
  }, {
    key: "getBooleanValue",
    value: function getBooleanValue(key, defaultValue) {
      var result = __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].getStoredValue(key);

      if (_.isBoolean(result)) {
        return result;
      }

      if (_.isString(result)) {
        return result.toLowerCase() === "true";
      } else {
        return defaultValue;
      }
    }
  }, {
    key: "setValue",
    value: function setValue(key, value) {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].setStoredValue(key, value.toString());
      this.trigger("settings_changed");
    }
  }, {
    key: "clearValue",
    value: function clearValue(key) {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].clearStoredValue(key);
    }
  }, {
    key: "clear",
    value: function clear() {
      var host = this.getValue(KEYS.HOST);
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].clearSessionCache();
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platform__["a" /* default */].clearStoredValues();

      if (host) {
        this.setValue(KEYS.HOST, host);
      }
    }
  }]);

  return LocalSettings;
}(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_framework_model__["a" /* default */]);

if (LocalSettings.singleton == null) {
  LocalSettings.singleton = new LocalSettings();
}

/* harmony default export */ __webpack_exports__["c"] = (LocalSettings.singleton);

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = listenToPath;
/* harmony export (immutable) */ __webpack_exports__["e"] = stopListeningToPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = setValueAtPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = resetStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_set__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store_initial_state__ = __webpack_require__(862);



var Store = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store_initial_state__["a" /* default */]));
var allListeners = new Map(); // Map<string, Set<(any) => void>>

function listenToPath(pathString, callback) {
  var listenersForPath;

  if (allListeners.has(pathString)) {
    listenersForPath = allListeners.get(pathString);
  } else {
    listenersForPath = new Set();
    allListeners.set(pathString, listenersForPath);
  }

  if (typeof callback !== "function") {
    throw new Error("Attempted to add a listener for ".concat(pathString, " but the callback was not a function"));
  }

  listenersForPath.add(callback);
}
function stopListeningToPath(pathString, callback) {
  if (!allListeners.has(pathString)) {
    throw new Error("Attempted to stop listening to a path for which no listeners were registered: ".concat(pathString));
  }

  var listenersForPath = allListeners.get(pathString);

  if (!listenersForPath.has(callback)) {
    throw new Error("Attempted to remove a listener callback for path ".concat(pathString, ", but the provided callback was not registered"));
  }

  listenersForPath["delete"](callback);
}
function setValueAtPath(pathString, newValue) {
  // lodash.set can set both string and array paths, but since this
  // implementation uses paths as a lookup key, only strings are supported
  // (since ["some", "path"] !== ["some", "path"])
  if (typeof pathString !== "string") {
    throw new Error("Attempted to call setValueAtPath with a non-string path");
  }

  var oldValue = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(Store, pathString);

  if (oldValue === newValue) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_0_lodash_set___default()(Store, pathString, newValue);

  if (allListeners.has(pathString)) {
    var listenersForPath = allListeners.get(pathString);
    listenersForPath.forEach(function (callback) {
      callback(newValue, oldValue);
    });
  }
}
function resetStore() {
  Object.keys(Store).forEach(function (path) {
    if (!(path in __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store_initial_state__["a" /* default */])) {
      console.warn("Unknown key ".concat(path, " encountered in Store. Please add this key so it can be reset properly"));
      delete Store[path];
      return;
    }

    if (__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store_initial_state__["a" /* default */][path] instanceof Object && !Array.isArray(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store_initial_state__["a" /* default */][path])) {
      // We only support one layer of nesting here so far. setValueAtPath the
      // subpaths to catch any listeners on deep paths
      Object.keys(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store_initial_state__["a" /* default */][path]).forEach(function (subPath) {
        setValueAtPath("".concat(path, ".").concat(subPath), __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store_initial_state__["a" /* default */][path][subPath]);
      });
    }

    setValueAtPath(path, __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store_initial_state__["a" /* default */][path]);
  });
}
/* harmony default export */ __webpack_exports__["a"] = (Store);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Tappable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVE_DARKEN_AMOUNT; });
/* harmony export (immutable) */ __webpack_exports__["c"] = simpleActiveBackgroundColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_debounce__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_enqueueIn__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);













function distance(_ref, _ref2) {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_slicedToArray___default()(_ref, 2),
      x1 = _ref3[0],
      y1 = _ref3[1];

  var _ref4 = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
      x2 = _ref4[0],
      y2 = _ref4[1];

  return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
}

var Tappable =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Tappable, _React$Component);

  function Tappable() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Tappable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Tappable)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      active: false
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isTouchDevice", "ontouchstart" in window);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_listeningForUp", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isMounted", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_target", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_startingPositionAndTarget", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_targetRefHandler", function (el) {
      var target = _this._target;

      if (target != null && el !== target) {
        if (_this._isTouchDevice) {
          target.removeEventListener("touchstart", _this._handleTouchStart);
        } else {
          target.removeEventListener("mousedown", _this._handleMouseDown);
        }

        target.removeEventListener("keyup", _this._handleKeyUp);
      }

      if (target !== el && el != null) {
        if (_this._isTouchDevice) {
          el.addEventListener("touchstart", _this._handleTouchStart);
        } else {
          el.addEventListener("mousedown", _this._handleMouseDown);
        }

        el.addEventListener("keyup", _this._handleKeyUp);
      }

      _this._target = el;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_listenForUp", function () {
      if (_this._listeningForUp) {
        return;
      }

      if (_this._isTouchDevice) {
        window.addEventListener("touchend", _this._handleTouchEnd);
      } else {
        window.addEventListener("mouseup", _this._handleMouseUp);
      }

      window.addEventListener("touchcancel", _this._activeOff);
      window.addEventListener("scroll", _this._activeOff, true);
      _this._listeningForUp = true;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_stopListeningForUp", function () {
      if (!_this._listeningForUp) {
        return;
      }

      if (_this._isTouchDevice) {
        window.removeEventListener("touchend", _this._handleTouchEnd);
      } else {
        window.removeEventListener("mouseup", _this._handleMouseUp);
      }

      window.removeEventListener("touchcancel", _this._activeOff);
      window.removeEventListener("scroll", _this._activeOff, true);

      _this._debouncedSetStateIfMounted.cancel();

      _this._listeningForUp = false;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleMouseDown", function (event) {
      _this._startingPositionAndTarget = event;

      _this._activeOn();
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTouchStart", function (event) {
      var touch = event.changedTouches[0];
      _this._startingPositionAndTarget = touch;

      _this._activeOn();
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_activeOn", function () {
      _this._listenForUp();

      if (_this.props.noDelay || _this.props.needsTrustedTap) {
        _this._setStateIfMounted({
          active: true
        });
      } else {
        _this._debouncedSetStateIfMounted({
          active: true
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_debouncedSetStateIfMounted", __WEBPACK_IMPORTED_MODULE_10_lodash_debounce___default()(_this._setStateIfMounted.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this)), 20));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleMouseUp", function (event) {
      _this._handleTap(event);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTouchEnd", function (event) {
      var touch = event.changedTouches[0];
      var target = document.elementFromPoint(touch.clientX, touch.clientY);

      _this._handleTap({
        clientX: touch.clientX,
        clientY: touch.clientY,
        target: target
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTap", function (end) {
      if (!_this._listeningForUp) {
        // Some event handlers might be fired asynchronously. We don't want to
        // process an event that would cause an up if we're not listening
        // for up anymore.
        return;
      }

      var start = _this._startingPositionAndTarget;
      _this._startingPositionAndTarget = null;
      var target = _this._target;

      if (target != null && start != null && start.target instanceof Node && target.contains(start.target) && end.target instanceof Node && target.contains(end.target) && distance([start.clientX, start.clientY], [end.clientX, end.clientY]) < 16) {
        _this._executeDelayedTap();
      } else {
        _this._activeOff();
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_activeOff", function () {
      if (!_this._listeningForUp) {
        // Some event handlers might be fired asynchronously. We don't want to
        // process an event that would cause an up if we're not listening
        // for up anymore.
        return;
      }

      _this._stopListeningForUp();

      _this._setStateIfMounted({
        active: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleKeyUp", function (event) {
      var enterKeycode = 13;
      var spaceKeycode = 32;

      if (event.keyCode === enterKeycode || event.keyCode === spaceKeycode) {
        _this.setState({
          active: true
        });

        _this._afterTapDelay();
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Tappable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;

      this._stopListeningForUp();

      Object(__WEBPACK_IMPORTED_MODULE_11__utils_enqueueIn__["a" /* cancelEnqueued */])(this._handleTapEnqueueRef);
    }
  }, {
    key: "_setStateIfMounted",
    value: function _setStateIfMounted(state, callback) {
      if (!this._isMounted) {
        return;
      }

      if (callback == null) {
        this.setState(state);
      } else {
        this.setState(state, callback);
      }
    }
  }, {
    key: "_executeDelayedTap",
    value: function _executeDelayedTap() {
      var _this2 = this;

      this._stopListeningForUp();

      if (this.props.needsTrustedTap) {
        this._afterTapDelay();

        return;
      }

      if (this._handleTapEnqueueRef != null) {
        // A click is already pending for this target.
        return;
      }

      this._handleTapEnqueueRef = Object(__WEBPACK_IMPORTED_MODULE_11__utils_enqueueIn__["b" /* default */])(function () {
        _this2._handleTapEnqueueRef = null;
        __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.unstable_batchedUpdates(function () {
          if (!_this2._isMounted) {
            return;
          }

          _this2._afterTapDelay();
        });
      }, // Our goal here is to try to make sure the change in active gets
      // reflected before the action that occurs when the button is pressed
      // occurs, eg. page transition, menu drawer opening, etc. The change
      // in active will get rendered in between 0 and 20ms, so I'm picking a
      // number bigger than 20 with some wiggle room so that it's not likely
      // that it'll get batched into the same task loop as the task that
      // sets active to true. Also, we don't want this number to be too big
      // or it will feel like the app takes forever to respond to button
      // presses.
      40);
    } // For screen reader support

  }, {
    key: "_afterTapDelay",
    value: function _afterTapDelay() {
      var _this3 = this;

      var _this$props = this.props,
          holdActiveUntil = _this$props.holdActiveUntil,
          onTap = _this$props.onTap;

      if (onTap != null) {
        onTap();
      }

      if (holdActiveUntil != null) {
        holdActiveUntil().then(function () {
          _this3._setStateIfMounted({
            active: false
          });
        });
      } else {
        this._setStateIfMounted({
          active: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var active = this.state.active;
      return children({
        active: active,
        tapTargetRefHandler: this._targetRefHandler
      });
    }
  }]);

  return Tappable;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Tappable, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  // If this is true, then the active state will appear immediately on
  // touchstart/mousedown, instead of after 20ms. If your button/etc is showing
  // up in a scrollable area, then you probably want the 20ms buffer so that
  // stuff doesn't flash active when you scroll around (so leave this false).
  noDelay: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  // Infrequently, we need to have an event which is "trusted" by the browser,
  // for instance when we open a new app. Don't delay the tap event at all.
  // This doesn't do active styling very well.
  needsTrustedTap: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  // If you pass this, then it will get called when the target has been tapped,
  // and active will remain true until the Promise you return resolves. This
  // way, you can keep the active state true until the next page loads.
  holdActiveUntil: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
  // What to do when the element is tapped. We can't use real click events
  // because the timing and details around when and how the browser dispatches
  // click and touch events vary and have some difficult-to-work-around
  // constraints.
  onTap: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func
});


var ACTIVE_DARKEN_AMOUNT = 0.15;
function simpleActiveBackgroundColor(active) {
  if (active) {
    return "rgba(0, 0, 0, ".concat(ACTIVE_DARKEN_AMOUNT, ")");
  } else {
    return "transparent";
  }
}



/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(153)('wks');
var uid = __webpack_require__(112);
var Symbol = __webpack_require__(21).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(69);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return history; });
/* harmony export (immutable) */ __webpack_exports__["e"] = setHistory;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearHistoryAndPush;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearHistoryAndVirtualPopTo;
/* harmony export (immutable) */ __webpack_exports__["c"] = goBackTo;
/* unused harmony export bpfrpt_proptype_LocationStateForRoute */
/* unused harmony export bpfrpt_proptype_NexiaHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nx_components_utils_enqueueIn__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_batchReactUpdates__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Scrollable_TrackedScrollableArea__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/





var bpfrpt_proptype_LocationStateForRoute = function bpfrpt_proptype_LocationStateForRoute() {
  return (typeof $ElementType === "function" ? __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf($ElementType) : __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any).apply(this, arguments);
};

var bpfrpt_proptype_NexiaHistory = {
  // TODO: Once we're on babel 7.x then we'll be able to parse object type spread.
  // Flow can still parse it using the comment syntax (/* :: bla */) though.

  /* :: ...MemoryHistoryWithoutPushAndReplace, */
  // These are compatible with the push/replace from MemoryHistory but
  // restricted so that you have to use the string form (instead of
  // { pathname, state }), so that we can typecheck the route you're navigating
  // to (using RouteToLocationStateMappings).

  /* eslint-disable no-undef */
  push: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,

  /* eslint-enable no-undef */
  // The location that just got replaced. We need to keep it around so that we
  // can animate it off the page.
  replacedLocation: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    location: function location() {
      return (typeof MemoryLocation === "function" ? __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(MemoryLocation).isRequired : __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any.isRequired).apply(this, arguments);
    },
    previousIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired
  }),
  // When doing a clearHistoryAndPush, this is true.
  _isDoingClearHistoryAndPush: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  // When doing a clearHistoryAndVirtualPopTo, this is true.
  _isDoingVirtualPop: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
  computeEffectiveAction: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};
// This has to be a named export because our babel setup doesn't handle
// mutable default exports properly.
// This is technically a ?NexiaHistory, but once React is mounted, it's a
// NexiaHistory, and React is mounted 99.9% of the time the app is running, so
// treat it like a NexiaHistory instead of making other people treat it as
// a maybe for no real benefit.
// $FlowIgnore
var history = null; // eslint-disable-line import/no-mutable-exports

function patchHistory(hist) {
  var originalHistoryReplace = hist.replace;

  hist.replace = function (path, state) {
    hist.replacedLocation = {
      location: hist.entries[hist.index],
      previousIndex: hist.index
    };
    return originalHistoryReplace.call(hist, path, state);
  };

  var originalHistoryPush = hist.push;

  hist.push = function (path, state) {
    hist.replacedLocation = null;
    return originalHistoryPush.call(hist, path, state);
  };

  var originalGoBack = hist.goBack;

  hist.goBack = function () {
    hist.replacedLocation = null;
    return originalGoBack.call(hist);
  };

  var originalGoForward = hist.goForward;

  hist.goForward = function () {
    hist.replacedLocation = null;
    return originalGoForward.call(hist);
  };

  var originalGo = hist.go;

  hist.go = function (amount) {
    hist.replacedLocation = null;
    return originalGo.call(hist, amount);
  };

  hist.computeEffectiveAction = function () {
    // React router only has three action types: PUSH, POP, and REPLACE.
    // We can handle transitions for those all pretty well.
    // However, there are three places in our app that need to be
    // transitioned differently: the initial REPLACE that occurs when we
    // navigate to /app, the POP and REPLACE that occur when we use
    // clearHistoryAndPush, and the POP and REPLACE that occur when we use
    // clearHistoryAndVirtualPopTo. To differentiate those three, we're going to
    // fake INITIAL_REPLACE, CLEAR_HISTORY_AND_PUSH, and VIRTUAL_POP action
    // types.
    var action = hist.action;

    if (hist._isDoingClearHistoryAndPush) {
      if (action === "POP") {
        // A clearHistoryAndPush consists of two parts: a POP and a REPLACE.
        // We want to treat it as one atomic CLEAR_HISTORY_AND_PUSH, so
        // ignore the POP phase.
        action = "IGNORE";
      } else if (hist._isDoingVirtualPop) {
        action = "VIRTUAL_POP";
      } else {
        action = "CLEAR_HISTORY_AND_PUSH";
      }
    } // We don't want to transition the first REPLACE from /app to /app/home in,
    // we just want to teleport /app/home in. So treat it special.


    if (hist.action === "REPLACE" && hist.replacedLocation && (hist.replacedLocation.location.pathname === "/app" || hist.replacedLocation.location.pathname != null && !hist.replacedLocation.location.pathname.startsWith("/app")) // pin entry screen, etc
    ) {
        action = "INITIAL_REPLACE";
      }

    return action;
  };
}

function setHistory(newHistory) {
  if (history === newHistory) {
    return;
  }

  patchHistory(newHistory);
  history = newHistory;
}
function clearHistoryAndPush(pathname, locationState) {
  if (history == null) {
    throw new Error("Attempted to use history before it was ready");
  }

  history._isDoingClearHistoryAndPush = true;
  __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Scrollable_TrackedScrollableArea__["a" /* default */].forgetAll();
  Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_batchReactUpdates__["a" /* default */])(function () {
    history.go(1 - history.length);
    history.replace(pathname, locationState);
  }); // Don't clear the _isDoingClearHistoryAndPush until a tick from now so that
  // componentDidMount in HistoryPageTransitionController can use
  // computeEffectiveAction in componentDidUpdate to check if this was a
  // CLEAR_HISTORY_AND_PUSH.

  Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_utils_enqueueIn__["b" /* default */])(function () {
    history._isDoingClearHistoryAndPush = false;
  }, 0);
}
function clearHistoryAndVirtualPopTo(pathname, locationState) {
  if (history == null) {
    throw new Error("Attempted to use history before it was ready");
  }

  history._isDoingVirtualPop = true;
  clearHistoryAndPush(pathname, locationState); // Don't clear the _isDoingVirtualPop until a tick from now so that
  // componentDidMount in HistoryPageTransitionController can use
  // computeEffectiveAction in componentDidUpdate to check if this was a
  // VIRTUAL_POP.

  Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_utils_enqueueIn__["b" /* default */])(function () {
    history._isDoingVirtualPop = false;
  }, 0);
}
function goBackTo(pathname) {
  var index = history.entries.findIndex(function (entry) {
    return entry.pathname === pathname;
  });

  if (index === -1) {
    throw new Error("Attempted to go back to ".concat(pathname, ", but it wasn't in history.\nThe following entries were in history:\n").concat(history.entries.map(function (entry) {
      return "  ".concat(entry.pathname || "(no pathname)");
    }).join("\n")));
  }

  history.go(1 + index - history.length);
}




/***/ }),
/* 32 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(25)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UserLanguageContextWrapper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Locales__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contextHelper__ = __webpack_require__(446);




var UserLanguageContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext();
/* harmony default export */ __webpack_exports__["b"] = (UserLanguageContext);
function UserLanguageContextWrapper(props) {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(Object(__WEBPACK_IMPORTED_MODULE_2__Locales__["b" /* getLanguageSet */])()),
      _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      localeSet = _useState2[0],
      setLocaleSet = _useState2[1];

  var setUserLocaleContext = function setUserLocaleContext(value) {
    var newLocalSet = Object(__WEBPACK_IMPORTED_MODULE_2__Locales__["b" /* getLanguageSet */])(value);
    setLocaleSet(newLocalSet);
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(UserLanguageContext.Provider, {
    value: {
      localeSet: localeSet,
      setUserLocaleContext: setUserLocaleContext,
      casing: __WEBPACK_IMPORTED_MODULE_3__contextHelper__["a" /* casing */],
      template: __WEBPACK_IMPORTED_MODULE_2__Locales__["e" /* template */]
    }
  }, props.children);
}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_polished__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var Button =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Button, _React$Component);

  function Button() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Button)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      active: false
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_darken", function (amount, color) {
      if (color === "transparent") {
        return "rgba(0, 0, 0, ".concat(amount, ")");
      }

      return Object(__WEBPACK_IMPORTED_MODULE_10_polished__["a" /* darken */])(amount, color);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_lighten", function (amount, color) {
      if (color === "transparent") {
        return "rgba(255, 255, 255, ".concat(amount, ")");
      }

      return Object(__WEBPACK_IMPORTED_MODULE_10_polished__["b" /* lighten */])(amount, color);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Button, [{
    key: "_calculateStyles",
    value: function _calculateStyles(active) {
      var _this2 = this;

      var _this$props = this.props,
          onTap = _this$props.onTap,
          onClickCapture = _this$props.onClickCapture,
          full = _this$props.full,
          disabled = _this$props.disabled,
          style = _this$props.style,
          theme = _this$props.theme,
          forceActiveStyling = _this$props.forceActiveStyling,
          colors = _this$props.colors;

      var darkenIfActive = function darkenIfActive(undarkenedColor) {
        if (active || forceActiveStyling) {
          return _this2._darken(__WEBPACK_IMPORTED_MODULE_15__Tappable__["a" /* ACTIVE_DARKEN_AMOUNT */], undarkenedColor);
        } else {
          return undarkenedColor;
        }
      };

      var lightenIfActive = function lightenIfActive(unlightenedColor) {
        if (active || forceActiveStyling) {
          return _this2._lighten(__WEBPACK_IMPORTED_MODULE_15__Tappable__["a" /* ACTIVE_DARKEN_AMOUNT */], unlightenedColor);
        } else {
          return unlightenedColor;
        }
      };

      var _ref = style || {},
          userBackgroundColor = _ref.backgroundColor,
          userStyle = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["backgroundColor"]);

      var styles = Object(__WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["b" /* default */])({
        button: _objectSpread({
          WebkitTapHighlightColor: "rgba(0,0,0,0)",
          userSelect: "none",
          position: "relative",
          display: "inline-block",
          textAlign: "center",
          borderRadius: __WEBPACK_IMPORTED_MODULE_13__Theme__["a" /* default */].Button.RADIUS,
          color: colors.PRIMARY_TEXT,
          backgroundColor: darkenIfActive(colors.PRIMARY),
          outline: "none",
          cursor: onTap || onClickCapture ? "pointer" : "",
          lineHeight: "1em",
          padding: "0.5em",
          // this is only used for the Footer
          pointerEvents: "auto"
        }, __WEBPACK_IMPORTED_MODULE_13__Theme__["a" /* default */].Styles.textEllipsis, {}, full ? {
          display: "block",
          width: "100%",
          marginBottom: "0.2em"
        } : null, {}, disabled ? {
          pointerEvents: "none",
          opacity: 0.25
        } : null, {}, typeof userBackgroundColor === "string" ? {
          backgroundColor: darkenIfActive(userBackgroundColor)
        } : null, {}, userStyle),
        content: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }
      });

      if (theme) {
        var themes;

        if (typeof theme === "string") {
          themes = [theme];
        } else {
          themes = theme;
        }

        themes.forEach(function (themePart) {
          switch (themePart) {
            case "alert":
              {
                Object.assign(styles.button, {
                  backgroundColor: darkenIfActive(colors.RED)
                });
                break;
              }

            case "heat":
              {
                Object.assign(styles.button, {
                  backgroundColor: darkenIfActive(colors.HEAT)
                });
                break;
              }

            case "cool":
              {
                Object.assign(styles.button, {
                  backgroundColor: darkenIfActive(colors.COOL)
                });
                break;
              }

            case "overlay":
              {
                Object.assign(styles.button, {
                  backgroundColor: "transparent",
                  fontSize: ".8em",
                  padding: "1.2em",
                  color: darkenIfActive("white")
                });
                break;
              }

            case "accept":
              {
                Object.assign(styles.button, {
                  backgroundColor: darkenIfActive(colors.ACCEPT)
                });
                break;
              }

            case "reject":
              {
                Object.assign(styles.button, {
                  backgroundColor: darkenIfActive(colors.REJECT)
                });
                break;
              }

            case "important":
              {
                Object.assign(styles.button, {
                  backgroundColor: darkenIfActive(colors.IMPORTANT)
                });
                break;
              }

            case "flat":
              {
                Object.assign(styles.button, {
                  backgroundColor: darkenIfActive("transparent"),
                  color: darkenIfActive(colors.PRIMARY)
                });
                break;
              }

            case "toolbar":
              {
                Object.assign(styles.button, {
                  backgroundColor: darkenIfActive("transparent"),
                  color: darkenIfActive(colors.SECONDARY)
                });
                break;
              }

            case "floating":
              {
                Object.assign(styles.button, {
                  boxShadow: "0 16px 24px 2px rgba(0,0,0,0.14), " + "0 6px 30px 5px rgba(0,0,0,0.12), " + "0 8px 10px -5px rgba(0,0,0,0.4)"
                });
                break;
              }

            case "round":
              {
                Object.assign(styles.button, {
                  width: "2em",
                  height: "2em",
                  borderRadius: "50%",
                  padding: 0
                });
                Object.assign(styles.content, {
                  fontSize: "2em",
                  height: "100%"
                });
                break;
              }

            case "minimal":
              {
                Object.assign(styles.button, {
                  backgroundColor: darkenIfActive("transparent"),
                  color: darkenIfActive(colors.IMPORTANT)
                });
                break;
              }

            case "link":
              {
                Object.assign(styles.button, {
                  backgroundColor: "transparent",
                  color: colors.ANCHOR,
                  textDecoration: "underline"
                });
                break;
              }

            case "ghost":
              {
                Object.assign(styles.button, {
                  backgroundColor: darkenIfActive("transparent"),
                  color: darkenIfActive(colors.PRIMARY),
                  // Hard inset box shadow is acting as an inner border. If you
                  // change it to an actual inner border, a button with text inside
                  // is eg. 34px tall instead of 32px (even with box-sizing:
                  // border-box). Ghost buttons are often displayed next to normal
                  // or important buttons (Ok/Cancel), so them being different
                  // heights looks bad.
                  boxShadow: "".concat(colors.PRIMARY, " 0px 0px 0px 1px inset")
                });
                break;
              }

            case "outline":
              {
                Object.assign(styles.button, {
                  backgroundColor: darkenIfActive("transparent"),
                  color: darkenIfActive(colors.TEXT),
                  boxShadow: "".concat(colors.TEXT, " 0px 0px 0px 1px inset")
                });
                break;
              }

            case "light":
              {
                Object.assign(styles.button, {
                  backgroundColor: lightenIfActive("transparent"),
                  boxShadow: "white 0px 0px 0px 1px inset"
                });
                break;
              }

            case "reverse":
              {
                Object.assign(styles.button, {
                  backgroundColor: darkenIfActive(colors.PRIMARY_TEXT),
                  color: colors.PRIMARY
                });
                break;
              }
          }
        });
      }

      return styles;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          buttonContentStyle = _this$props2.buttonContentStyle,
          children = _this$props2.children,
          disabled = _this$props2.disabled,
          full = _this$props2.full,
          style = _this$props2.style,
          theme = _this$props2.theme,
          type = _this$props2.type,
          needsTrustedTap = _this$props2.needsTrustedTap,
          onTap = _this$props2.onTap,
          onClickCapture = _this$props2.onClickCapture,
          onMouseDown = _this$props2.onMouseDown,
          onMouseUp = _this$props2.onMouseUp,
          onTouchStart = _this$props2.onTouchStart,
          onTouchMove = _this$props2.onTouchMove,
          onTouchEnd = _this$props2.onTouchEnd,
          forceActiveStyling = _this$props2.forceActiveStyling,
          attrs = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props2, ["buttonContentStyle", "children", "disabled", "full", "style", "theme", "type", "needsTrustedTap", "onTap", "onClickCapture", "onMouseDown", "onMouseUp", "onTouchStart", "onTouchMove", "onTouchEnd", "forceActiveStyling"]);

      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Tappable__["b" /* default */], {
        onTap: onTap,
        needsTrustedTap: needsTrustedTap,
        noDelay: true
      }, function (_ref2) {
        var active = _ref2.active,
            tapTargetRefHandler = _ref2.tapTargetRefHandler;

        var styles = _this3._calculateStyles(active);

        var ElementType = "div";
        var additionalProps = {};

        if (onTap != null) {
          ElementType = __WEBPACK_IMPORTED_MODULE_14__NoStyleButton__["a" /* default */];
          additionalProps = {
            innerRef: tapTargetRefHandler,
            disabled: disabled
          };
        }

        return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          "data-component-name": "Button"
        }, additionalProps, {
          onMouseDown: onMouseDown,
          onMouseUp: onMouseUp,
          onClickCapture: onClickCapture,
          onTouchStart: onTouchStart,
          onTouchMove: onTouchMove,
          onTouchEnd: onTouchEnd,
          type: type
        }, attrs, {
          style: styles.button
        }), __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("span", {
          style: _objectSpread({}, styles.content, {}, buttonContentStyle)
        }, children));
      });
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Button, "defaultProps", {
  full: false,
  disabled: false
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Button, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.node,
  disabled: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool,
  full: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool,
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  buttonContentStyle: function buttonContentStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  theme: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.oneOf(["alert", "heat", "cool", "overlay", "accept", "reject", "important", "flat", "toolbar", "floating", "round", "minimal", "ghost", "reverse", "link", "outline", "light"]), __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.oneOf(["alert", "heat", "cool", "overlay", "accept", "reject", "important", "flat", "toolbar", "floating", "round", "minimal", "ghost", "reverse", "link", "outline", "light"]).isRequired)]),
  type: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.string,
  needsTrustedTap: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool,
  onTap: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func,
  onClickCapture: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func,
  onTouchMove: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func,
  onTouchEnd: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func,
  forceActiveStyling: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_11__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_11__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_11__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_11__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_11__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__ColorsProvider__["c" /* withColorsProvider */])(Button));




/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_framework_model__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_framework_resource__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_url__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_followLink__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_formatServerErrors__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nx_components_Locales__ = __webpack_require__(44);
















var BaseModel =
/*#__PURE__*/
function (_Model) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(BaseModel, _Model);

  function BaseModel() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, BaseModel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BaseModel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.listenTo(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this), "error", _this._handleServerError);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(BaseModel, [{
    key: "onParse",
    value: function onParse(rawAttrs) {
      var attrs = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BaseModel.prototype), "onParse", this).call(this, rawAttrs);

      if (attrs.result) {
        attrs = attrs.result;
      }

      return _.extend(attrs, this.parseLinks(attrs));
    }
  }, {
    key: "onParseError",
    value: function onParseError(rawAttrs) {
      var localeSet = Object(__WEBPACK_IMPORTED_MODULE_14_nx_components_Locales__["b" /* getLanguageSet */])();
      var language = localeSet.nexia_mobile.utils.ajax_hooks;
      var attrs = rawAttrs || {}; // support the mishmash of error formats our server returns

      if (attrs.error) {
        attrs = attrs.error;
      }

      if (attrs.options) {
        attrs = attrs.options;
      } // backstage errors


      if (attrs.errors) {
        return Object(__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_formatServerErrors__["a" /* default */])(attrs.errors, attrs);
      }

      if (attrs.message) {
        return [{
          errorMessage: attrs.message
        }];
      }

      return [{
        errorMessage: language.unkownError
      }];
    }
  }, {
    key: "validateAttribute",
    value: function validateAttribute(attribute) {
      return this.validate(this.attributes, {
        validate: true,
        validateOnly: attribute
      });
    }
  }, {
    key: "trigger",
    value: function trigger() {
      var _get2;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      (_get2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BaseModel.prototype), "trigger", this)).call.apply(_get2, [this].concat(args)); // only broadcast the event if we were the originator.
      // otherwise events bubbled up from nested models/collections will get repeated


      if (args[1] === this) {
        var _BaseModel$Events;

        (_BaseModel$Events = BaseModel.Events).trigger.apply(_BaseModel$Events, args);
      }
    }
  }, {
    key: "postCommand",
    value: function postCommand(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var link = {
        href: __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_url__["a" /* default */].withAdditionalPath(this.url(), name),
        method: options.method || "POST"
      };
      return Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_followLink__["a" /* default */])(this, link, options);
    }
  }, {
    key: "_translateArrayOfErrors",
    value: function _translateArrayOfErrors(errors) {
      var result = [];
      errors.forEach(function (error) {
        var translatedError = {
          errorMessage: error.errorMessage
        };

        if (error.attribute) {
          translatedError.attribute = error.attribute;
        }

        result.push(translatedError);
      });
      return result;
    }
  }, {
    key: "_handleServerError",
    value: function _handleServerError(model, xhr) {
      if (!xhr || !_.isFunction(xhr.getResponseHeader)) {
        console.warn("We expect backbone error events to have" + " the jqXHR as their second parameter.", new Error().stack);
      }

      if (xhr.statusText === "abort") {
        // an aborted request still calls the error handlers, but we shouldn't handle it and show a toast
        return;
      }

      var response;

      try {
        response = JSON.parse(xhr.responseText);
      } catch (error) {
        response = {};
      } //HACK: Nexia api will always return a 500 error after account creation. Cannot be resolved. Ignore the error.


      if (model.id.match(/signup_validation/)) {
        return;
      } // derived models specify how the error is parsed


      var errors = this.onParseError(response);

      if (!_.isEmpty(errors)) {
        Object(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_flux_like_dispatch__["a" /* default */])("SERVERSIDE_ERROR_OCCURRED", this._translateArrayOfErrors(errors));
      }
    }
  }]);

  return BaseModel;
}(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_framework_model__["a" /* default */]);

BaseModel.Events = _.extend({}, __WEBPACK_IMPORTED_MODULE_7_backbone___default.a.Events);

_.extend(BaseModel.prototype, __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_framework_resource__["b" /* default */], {
  url: function url() {
    return this.getUrl() || (this.collection ? this.collection.url() : undefined);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (BaseModel);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-process-env */
var webAppHostMap = {
  "m.mynexia.com": "https://www.mynexia.com",
  "m-qa.nexiadev.com": "https://qa.nexiadev.com",
  "m-qa2.nexiadev.com": "https://qa2.nexiadev.com",
  "m-demo.mynexia.com": "https://demo.mynexia.com",
  "m-lab.nexiadev.com": "https://lab.nexiadev.com",
  "m-pivot.mynexia.com": "https://www.mynexia.com",
  "m-pivot-qa.nexiadev.com": "https://qa.nexiadev.com",
  "qa-pivot.trane.com": "https://qa.nexiadev.com"
};
var Environment = {
  PRODUCTION_HOST: "https://www.mynexia.com",
  isProductionDeployTarget: function isProductionDeployTarget() {
    return "production" === "production";
  },
  isTestRunner: function isTestRunner() {
    return "production" === "test" || this.isJest();
  },
  isJest: function isJest() {
    return typeof jest !== "undefined";
  },
  isCommercial: function isCommercial() {
    return "commercial" === "commercial";
  },
  isTraneCommercial: function isTraneCommercial() {
    return "commercial" === "commercial" && undefined !== "american_standard";
  },
  isAmStdCommercial: function isAmStdCommercial() {
    return "commercial" === "commercial" && undefined === "american_standard";
  },
  defaultHostForEnvironment: function defaultHostForEnvironment() {
    return webAppHostMap[window.location.hostname] || this.PRODUCTION_HOST;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Environment);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var IE8_DOM_DEFINE = __webpack_require__(329);
var toPrimitive = __webpack_require__(75);
var dP = Object.defineProperty;

exports.f = __webpack_require__(33) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(76);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(809)();
}


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var superPropBase = __webpack_require__(798);

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

module.exports = _get;

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Controls_wrappers_DetailsControlWrapper__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_TileControlWrapper__ = __webpack_require__(458);





var CommonControlWrapper = function CommonControlWrapper(_ref) {
  var isDetailed = _ref.isDetailed,
      children = _ref.children;
  return isDetailed ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Controls_wrappers_DetailsControlWrapper__["a" /* default */], null, children) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_TileControlWrapper__["a" /* default */], null, children);
};

CommonControlWrapper.propTypes = {
  isDetailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};
/* harmony default export */ __webpack_exports__["a"] = (CommonControlWrapper);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nx_components_UserAgent__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_platforms_base__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platforms_android__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platforms_ios__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_platforms_win10__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_QueryParams__ = __webpack_require__(173);







var singleton = function () {
  if (__WEBPACK_IMPORTED_MODULE_0_nx_components_UserAgent__["a" /* default */].isWindows10WebView()) {
    return new __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_platforms_win10__["a" /* default */]();
  }

  var platform = __WEBPACK_IMPORTED_MODULE_5_nx_components_QueryParams__["a" /* default */].platform();

  if (platform === "ios-wkwebview" || platform === "ios-uiwebview") {
    return new __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platforms_ios__["a" /* default */]();
  }

  if (platform === "android") {
    return new __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platforms_android__["a" /* default */]();
  }

  return new __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_platforms_base__["a" /* default */]();
}(); // So that native code can do eg. `PlatformInterface.triggerAppPause()`.
// It has to be global because native code just executes a string.


window.PlatformInterface = singleton;
/* harmony default export */ __webpack_exports__["a"] = (singleton);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return localeValues; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getLanguageSet;
/* harmony export (immutable) */ __webpack_exports__["a"] = getLanguageLocale;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return template; });
/* harmony export (immutable) */ __webpack_exports__["d"] = occupiedHelper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en_us_core__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fr_ca_core__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__es_mx_core__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stringsProvider__ = __webpack_require__(806);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






 // Used when showing and setting the value in languageDialog

var localeValues = [_objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__en_us_core__["b" /* en_us_values */]), _objectSpread({}, __WEBPACK_IMPORTED_MODULE_4__fr_ca_core__["b" /* fr_ca_values */]), _objectSpread({}, __WEBPACK_IMPORTED_MODULE_5__es_mx_core__["b" /* es_mx_values */])]; // Returns the current set of language strings
// demandedLocale is usually after a language selection by the user

function getLanguageSet() {
  var demandedLocaleString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var referenceLocale = getLanguageLocale(demandedLocaleString);
  return Object(__WEBPACK_IMPORTED_MODULE_6__stringsProvider__["a" /* default */])(referenceLocale);
} // Returns the current locale of language
// demandedLocale is usually after a language selection by the user

function getLanguageLocale() {
  var demandedLocaleString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var referenceLocaleString = demandedLocaleString || __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_local_settings__["c" /* default */].getLocale() || "en_us";
  var phoneLocale = __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platform__["a" /* default */].getAppInfo().currentLocale;
  phoneLocale = phoneLocale ? phoneLocale.toLowerCase().replace("-", "_") : "en_us"; // Auto is part of the locale string. Normal: en_us, Auto: auto|en_us
  // This is to avoid needing a separate database column just for auto.

  var localeVars = referenceLocaleString.split("|");
  var storedLocale = localeVars.length > 1 ? localeVars[1] : localeVars[0];
  var isAuto = localeVars.length > 1;
  return isAuto ? phoneLocale : storedLocale;
}
var template = function template(string, templates) {
  var newString = string;
  var keys = Object.keys(templates);
  keys.forEach(function (key) {
    var regex = new RegExp("#{".concat(key.toUpperCase(), "}#"), "g");
    newString = newString.replace(regex, templates[key]);
  });
  return newString;
};
function occupiedHelper(string) {
  var occupancyLanguages = [__WEBPACK_IMPORTED_MODULE_3__en_us_core__["a" /* en_us */][201].toLowerCase(), __WEBPACK_IMPORTED_MODULE_4__fr_ca_core__["a" /* fr_ca */][201].toLowerCase(), __WEBPACK_IMPORTED_MODULE_5__es_mx_core__["a" /* es_mx */][201].toLowerCase(), "occupied" // For testing while strings are prefixed with E_ or FR_
  ];
  return occupancyLanguages.indexOf(string.toLowerCase());
}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_store__ = __webpack_require__(27);










 // Create a higher-order component that passes values from the store
// into the wrapped component as props, and updates those values when
// the values in the store change.
//
// Usage:
//   const ConnectedComponentClass = connect(pathDef, ComponentClass);
// Where:
//   * `pathDef` is an object of shape {[string]: string} that defines mappings
//     between props and values in the store; the keys are the prop names and the
//     values are the store value paths strings.
//   * `ComponentClass` is the "dumb" component. The props it receives should match
//     the prop names in `pathDef`.
// Example:
//
//   const MyComponent = ({ name }) => <div>Hello, {name}</div>;
//   console.log(Store.user.name); // "Bob"
//   const ConnectedMyComponent = connect({ name: "user.name" }, MyComponent);
//   // ConnectedMyComponent will render <div>Hello, Bob</div>

function connect(pathDef, ComponentClass) {
  var _class, _temp;

  var displayName = ComponentClass.displayName || ComponentClass.name || "<anonymous component>";
  var pathDefs = [];
  Object.entries(pathDef).forEach(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        propName = _ref2[0],
        storePath = _ref2[1];

    pathDefs.push({
      propName: propName,
      storePath: storePath
    });
  });
  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ConnectedComponent, _React$Component);

    function ConnectedComponent(props) {
      var _this;

      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ConnectedComponent);

      _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ConnectedComponent).call(this, props));
      var initialState = {};
      _this._listeners = {};
      pathDefs.forEach(function (_ref3) {
        var propName = _ref3.propName,
            storePath = _ref3.storePath;
        initialState[propName] = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_store__["a" /* default */], storePath);

        _this._listeners[propName] = function (newValue) {
          _this.setState(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({}, propName, newValue));
        };
      });
      _this.state = initialState;
      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ConnectedComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        pathDefs.forEach(function (_ref4) {
          var propName = _ref4.propName,
              storePath = _ref4.storePath;
          Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_store__["b" /* listenToPath */])(storePath, _this2._listeners[propName]);
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this3 = this;

        pathDefs.forEach(function (_ref5) {
          var propName = _ref5.propName,
              storePath = _ref5.storePath;
          Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_store__["e" /* stopListeningToPath */])(storePath, _this3._listeners[propName]);
        });
      }
    }, {
      key: "render",
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](ComponentClass, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.state, this.props));
      }
    }]);

    return ConnectedComponent;
  }(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]), __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_class, "displayName", "Connected(".concat(displayName, ")")), _temp;
}

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BackboneListener; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_debounce__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_debounce__);












var BackboneListener =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(BackboneListener, _React$Component);

  function BackboneListener() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, BackboneListener);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(BackboneListener)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_forceUpdateIfMounted", function () {
      if (!_this._isMounted) {
        return;
      }

      _this.forceUpdate();
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(BackboneListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;

      this._listenTo(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;

      this._stopListeningTo(this.props);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.listenTo === nextProps.listenTo && this.props.events === nextProps.events && this.props.debounceRender === nextProps.debounceRender) {
        return;
      }

      this._stopListeningTo(this.props);

      this._listenTo(nextProps);
    }
  }, {
    key: "_listenTo",
    value: function _listenTo(_ref) {
      var listenTo = _ref.listenTo,
          events = _ref.events,
          debounceRender = _ref.debounceRender;

      if (listenTo == null) {
        return;
      }

      var shouldDebounce = debounceRender === true || typeof debounceRender === "number";
      var debounceAmount = debounceRender;

      if (debounceRender === true) {
        debounceAmount = 0;
      }

      var listener = shouldDebounce ? __WEBPACK_IMPORTED_MODULE_10_lodash_debounce___default()(this._forceUpdateIfMounted, debounceAmount) : this._forceUpdateIfMounted;
      listenTo.on(events.join(" "), listener, this);
    }
  }, {
    key: "_stopListeningTo",
    value: function _stopListeningTo(_ref2) {
      var listenTo = _ref2.listenTo;

      if (listenTo == null) {
        return;
      }

      listenTo.off(null, null, this);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children();
    }
  }]);

  return BackboneListener;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(BackboneListener, "propTypes", {
  listenTo: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_backbone___default.a.Model), __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_backbone___default.a.Collection)]),
  events: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  // () => Element
  debounceRender: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number])
});



/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GlobalStyleSheet__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tappable__ = __webpack_require__(28);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var buttonResetStyleSheet = "\n  button.nx-components_NoStyleButton {\n      -webkit-box-sizing: border-box;\n      -moz-box-sizing: border-box;\n      box-sizing: border-box;\n      background: none;\n      border: 0;\n      color: inherit;\n      font: inherit;\n      line-height: normal;\n      overflow: visible;\n      padding: 0;\n      margin: 0;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n  }\n  button.nx-components_NoStyleButton::-moz-focus-inner {\n      border: 0;\n      padding: 0;\n  }\n"; // A button that has all styles reset.

var NoStyleButton = function NoStyleButton(_ref) {
  var onTap = _ref.onTap,
      children = _ref.children,
      style = _ref.style,
      innerRef = _ref.innerRef,
      type = _ref.type,
      props = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["onTap", "children", "style", "innerRef", "type"]);

  if (style.display === "flex") {
    throw new Error("A button cannot be a flex container in Safari. Consider putting a div inside the NoStyleButton.");
  }

  var makeButton = function makeButton(ref, additionalStyle) {
    return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("button", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
      type: type,
      className: props.className ? "".concat(props.className, " nx-components_NoStyleButton") : "nx-components_NoStyleButton",
      style: _objectSpread({}, style, {
        cursor: props.onTap ? "pointer" : style.cursor
      }, additionalStyle),
      ref: ref
    }), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__GlobalStyleSheet__["a" /* default */], {
      id: "nx-components_NoStyleButton",
      sheet: buttonResetStyleSheet
    }), children);
  };

  if (onTap != null) {
    return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Tappable__["b" /* default */], {
      onTap: onTap
    }, function (_ref2) {
      var tapTargetRefHandler = _ref2.tapTargetRefHandler,
          active = _ref2.active;
      return makeButton(function (el) {
        if (innerRef != null) {
          innerRef(el);
        }

        tapTargetRefHandler(el);
      }, {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__Tappable__["c" /* simpleActiveBackgroundColor */])(active)
      });
    });
  } else {
    return makeButton(innerRef, {});
  }
};

NoStyleButton.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  innerRef: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTap: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};
NoStyleButton.defaultProps = {
  style: {},
  // Browsers implicitly make all buttons "submit" if they are children of a form.
  // We want them to be "normal", but be sure to override actual submit buttons.
  type: "button"
};
/* harmony default export */ __webpack_exports__["a"] = (NoStyleButton);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(393);

var iterableToArrayLimit = __webpack_require__(801);

var nonIterableRest = __webpack_require__(394);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_utils_sleep__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_framework_collection__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_framework_resource__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_mixins_editable__ = __webpack_require__(90);














var BaseCollection =
/*#__PURE__*/
function (_Collection) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(BaseCollection, _Collection);

  function BaseCollection() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, BaseCollection);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BaseCollection).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(BaseCollection, [{
    key: "parse",
    value: function parse(rawAttrs) {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var attrs = (_get2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BaseCollection.prototype), "parse", this)).call.apply(_get2, [this, rawAttrs].concat(args));

      var items = this._performParseSideEffects(attrs);

      if (!items) {
        // If the server hasn't given us any items, we can't
        // assume there are NO items, just that we haven't been given them.
        // (Server gives an empty array of items if there were none).
        // In this case, instead of returning an empty array (which
        // would remove all items in the collection), return the same
        // models that we currently have- this effectively no-ops the set
        // operation, but ensures the parse still goes through (because our
        // models all depend on parse running).
        return this.models;
      }

      var ModelClass = this.model || __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_base_model__["a" /* default */];
      return items.map(function (item) {
        if (item instanceof __WEBPACK_IMPORTED_MODULE_7_backbone___default.a.Model) {
          return item;
        } else {
          return new ModelClass(item, {
            parse: true
          });
        }
      });
    }
  }, {
    key: "_parseModelsAsync",
    value: function _parseModelsAsync(rawAttrs, options) {
      var _get3;

      var _len2,
          args,
          _key2,
          attrs,
          items,
          ModelClass,
          models,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          item,
          model,
          _args = arguments;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.async(function _parseModelsAsync$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              for (_len2 = _args.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                args[_key2 - 2] = _args[_key2];
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap((_get3 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BaseCollection.prototype), "_parseModelsAsync", this)).call.apply(_get3, [this, rawAttrs, options].concat(args)));

            case 3:
              attrs = _context.sent;
              items = this._performParseSideEffects(attrs);

              if (items) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", this.models);

            case 7:
              ModelClass = this.model || __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_base_model__["a" /* default */];
              models = [];
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 12;
              _iterator = items[Symbol.iterator]();

            case 14:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 27;
                break;
              }

              item = _step.value;

              if (!(item instanceof __WEBPACK_IMPORTED_MODULE_7_backbone___default.a.Model)) {
                _context.next = 20;
                break;
              }

              models.push(item);
              _context.next = 24;
              break;

            case 20:
              _context.next = 22;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_utils_sleep__["a" /* default */])(options.asyncParseDelay));

            case 22:
              model = new ModelClass(item, {
                parse: true
              });
              models.push(model);

            case 24:
              _iteratorNormalCompletion = true;
              _context.next = 14;
              break;

            case 27:
              _context.next = 33;
              break;

            case 29:
              _context.prev = 29;
              _context.t0 = _context["catch"](12);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 33:
              _context.prev = 33;
              _context.prev = 34;

              if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
              }

            case 36:
              _context.prev = 36;

              if (!_didIteratorError) {
                _context.next = 39;
                break;
              }

              throw _iteratorError;

            case 39:
              return _context.finish(36);

            case 40:
              return _context.finish(33);

            case 41:
              return _context.abrupt("return", models);

            case 42:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[12, 29, 33, 41], [34,, 36, 40]]);
    }
  }, {
    key: "_performParseSideEffects",
    value: function _performParseSideEffects(attributes) {
      var attrs = attributes;

      if (attrs.result) {
        attrs = attrs.result;
      }

      _.extend(attrs, this.parseLinks(attrs));

      if (attrs.template) {
        this._createSchemaFromAttrs(attrs.template);
      }

      var items;

      if (_.isArray(attrs)) {
        items = attrs;
      } else if (_.isArray(attrs.items)) {
        items = attrs.items;
      }

      return items;
    }
  }, {
    key: "trigger",
    value: function trigger() {
      var _get4;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      (_get4 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BaseCollection.prototype), "trigger", this)).call.apply(_get4, [this].concat(args)); // only broadcast the event if we were the originator.
      // otherwise events bubbled up from models within this collection will get repeated


      if (args[1] === this) {
        var _BaseModel$Events;

        (_BaseModel$Events = __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_base_model__["a" /* default */].Events).trigger.apply(_BaseModel$Events, args);
      }
    }
  }]);

  return BaseCollection;
}(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_framework_collection__["a" /* default */]);

_.extend(BaseCollection.prototype, __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_mixins_editable__["a" /* default */]);

_.extend(BaseCollection.prototype, __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_framework_resource__["b" /* default */]);

BaseCollection.prototype.model = __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_base_model__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (BaseCollection);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Schema; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_formatter__ = __webpack_require__(517);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var Schema =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Schema, _BaseModel);

  function Schema() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Schema);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Schema).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Schema, [{
    key: "nestedCollections",
    value: function nestedCollections() {
      return {
        children: {
          model: Schema
        },
        childSchemas: {
          model: Schema
        }
      };
    }
  }, {
    key: "onParse",
    value: function onParse(rawAttrs) {
      var _this = this;

      this.get("children").reset();
      this.get("childSchemas").reset();

      var attrs = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Schema.prototype), "onParse", this).call(this, rawAttrs));

      this.validations = {};

      _.each(attrs.fields, function (field) {
        _this.validations[field.name] = field;

        var clampedField = _this._clampField(field);

        attrs[clampedField.name] = clampedField.value;
      });

      this.schemaFields = attrs.fields;
      delete attrs.fields;
      this._serverErrors = attrs.serverErrors;
      delete attrs.serverErrors;
      return attrs;
    }
  }, {
    key: "parseLinksNext",
    value: function parseLinksNext(links) {
      var link = _.first(links);

      return {
        nextHref: link ? link.href : null
      };
    }
  }, {
    key: "hasNextStep",
    value: function hasNextStep() {
      return Boolean(this.get("nextHref"));
    }
  }, {
    key: "getNextStep",
    value: function getNextStep() {
      var fetchOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.hasNextStep()) {
        return Promise.reject(new Error("Attempted to go to the next step with a Schema that had no next step"));
      }

      var nextSchema = new Schema();
      nextSchema.setUrl(this.get("nextHref"));
      nextSchema.setUrlParams(this.getUrlParams()); // at times fetch may return a response

      return nextSchema.fetch(fetchOpts).then(function (response) {
        return {
          nextSchema: nextSchema,
          response: response
        };
      });
    }
  }, {
    key: "prepare",
    value: function prepare()
    /* returns Promise<Schema> */
    {
      var _this2 = this;

      if (this.hasUrl()) {
        if (this._storedOnServer) {
          var newSchema = new Schema();
          newSchema.setUrl(this.url());
          return newSchema.save({}, {
            method: "POST",
            validate: false
          }).then(function () {
            return newSchema;
          });
        } else {
          return this.fetch().then(function () {
            return _this2;
          });
        }
      } else {
        return Promise.resolve(this);
      }
    }
  }, {
    key: "setStoredOnServer",
    value: function setStoredOnServer(yesno) {
      this._storedOnServer = yesno;
    }
  }, {
    key: "setForExistingResource",
    value: function setForExistingResource(yesno) {
      this._forExistingResource = yesno;
    }
  }, {
    key: "isNew",
    value: function isNew() {
      return !this._forExistingResource;
    }
  }, {
    key: "parseLinksChild",
    value: function parseLinksChild(links) {
      var _this3 = this;

      return _.each(links, function (link) {
        if (link.hasData()) {
          _this3.get("children").add(new Schema(link.getData(), {
            parse: true
          }));
        }
      });
    }
  }, {
    key: "parseLinksChildSchema",
    value: function parseLinksChildSchema(links) {
      var _this4 = this;

      return _.each(links, function (link) {
        if (link.hasData()) {
          _this4.get("childSchemas").add(new Schema(link.getData(), {
            parse: true
          }));
        }
      });
    }
  }, {
    key: "triggerValidationErrors",
    value: function triggerValidationErrors(errors) {
      this.trigger("validated", this, errors);
    }
  }, {
    key: "getUrlParams",
    value: function getUrlParams() {
      var _this5 = this;

      var params = {};

      _.each(this.schemaFields, function (field) {
        var value = _this5.get(field.name);

        if (value != null) {
          if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(value) === "object" && !Array.isArray(value)) {
            value = JSON.stringify(value); // url encoding doesn't work on objects
          }

          params[field.name] = value;
        }
      });

      return params;
    }
  }, {
    key: "hasSchemaFields",
    value: function hasSchemaFields() {
      return _.any(this.schemaFields);
    }
  }, {
    key: "getSchemaFields",
    value: function getSchemaFields() {
      return this.schemaFields || [];
    }
  }, {
    key: "getServerErrors",
    value: function getServerErrors() {
      return this._serverErrors || {};
    }
  }, {
    key: "clearServerErrors",
    value: function clearServerErrors() {
      this._serverErrors = {};
    }
  }, {
    key: "hasChildren",
    value: function hasChildren() {
      return this.get("children").any();
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      return this.get("children");
    }
  }, {
    key: "hasChildSchemas",
    value: function hasChildSchemas() {
      return this.get("childSchemas").any();
    }
  }, {
    key: "getChildSchemas",
    value: function getChildSchemas() {
      return this.get("childSchemas");
    }
  }, {
    key: "parseLinksCommit",
    value: function parseLinksCommit(links) {
      var commitModel = this.get("commitModel");

      if (commitModel) {
        this.stopListening(commitModel);
      }

      var link = _.first(links);

      if (link) {
        commitModel = new Schema(link.getData(), {
          parse: true
        });
        commitModel.setForExistingResource(link.isPutLink());
      } else {
        commitModel = null;
      }

      return {
        commitModel: commitModel
      };
    }
  }, {
    key: "canCommit",
    value: function canCommit() {
      return Boolean(this.get("commitModel"));
    }
  }, {
    key: "commit",
    value: function commit(options) {
      var _this6 = this;

      if (!this.isValid()) {
        return Promise.reject(new Error("Cannot commit an invalid schema"));
      }

      if (!this.canCommit()) {
        return Promise.reject(new Error("Cannot commit a schema that doesn't have a commit link"));
      }

      var commitModel = this.get("commitModel");
      commitModel.setUrlParams(this.getUrlParams());

      var fieldKeys = _.pluck(this.schemaFields, "name");

      commitModel.set(_.pick(this.attributes, fieldKeys));
      return commitModel.save(null
      /* attrs */
      , options).then(function (passedData) {
        var data = passedData;

        if (data.result) {
          data = data.result;
        }

        if (data.polling_path) {
          _this6.set("statusUrl", data.polling_path);
        }

        return data;
      });
    }
  }, {
    key: "canDestroy",
    value: function canDestroy() {
      return Boolean(this.parentModel && this.parentModel.destroy);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      options.wait = true;

      if (this.parentModel) {
        return this.parentModel.destroy(options);
      } else {
        return undefined;
      }
    }
  }, {
    key: "_clampField",
    value: function _clampField(field) {
      var value;
      var min;
      var max;
      var newValue;
      var sorted;

      if (field != null && _.isNumber(field.value)) {
        value = field.value;
        min = field.min == null ? value : field.min;
        max = field.max == null ? value : field.max;

        newValue = function newValue() {
          return sorted[1];
        };
      } else if (field != null && __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_formatter__["a" /* default */].isISODate(field.value)) {
        value = __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_formatter__["a" /* default */].getDateObjectFromISODate(field.value);
        min = field.min ? __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_formatter__["a" /* default */].getDateObjectFromISODate(field.min) : value;
        max = field.max ? __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_formatter__["a" /* default */].getDateObjectFromISODate(field.max) : value;

        newValue = function newValue() {
          return __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_formatter__["a" /* default */].getISODateString(sorted[1]);
        };
      } else {
        return field;
      }

      sorted = _.sortBy([min, value, max], function (val) {
        return val;
      });
      field.value = newValue();
      return field;
    }
  }]);

  return Schema;
}(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_base_model__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Schema, "isEphemeral", true);



/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(825);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(38);
var createDesc = __webpack_require__(111);
module.exports = __webpack_require__(33) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var hide = __webpack_require__(54);
var has = __webpack_require__(60);
var SRC = __webpack_require__(112)('src');
var $toString = __webpack_require__(545);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(61).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var fails = __webpack_require__(25);
var defined = __webpack_require__(76);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Page; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StaticSizedArea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_ErrorHandler__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Pages_ErrorPage__ = __webpack_require__(286);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var pageStyles = Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_utils_prefixStyles__["b" /* default */])({
  wrapper: {
    position: "absolute",
    bottom: 0,
    left: __WEBPACK_IMPORTED_MODULE_9_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_LEFT,
    right: __WEBPACK_IMPORTED_MODULE_9_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_RIGHT,
    top: 0,
    display: "flex",
    flexDirection: "column"
  }
});

var Page =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Page, _React$Component);

  function Page() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Page);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Page).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Page, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      if (this.props.arbitraryHeight) {
        document.documentElement.style.position = "relative";
        document.body.style.position = "relative";
      } else {
        document.documentElement.style.position = "fixed";
        document.body.style.position = "fixed";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          children = _this$props.children,
          backgroundColor = _this$props.backgroundColor,
          arbitraryHeight = _this$props.arbitraryHeight,
          backgroundImageStyles = _this$props.backgroundImageStyles,
          ignoreSafeArea = _this$props.ignoreSafeArea,
          fullyLoaded = _this$props.fullyLoaded;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_ErrorHandler__["a" /* default */], {
        fallback: __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Pages_ErrorPage__["a" /* default */], null)
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("main", {
        "data-component-name": "Page",
        "data-component-prop-name": name,
        "data-page-fully-loaded": fullyLoaded,
        style: _objectSpread({}, pageStyles.wrapper, {}, this.context && this.context.isLargeAppLayout ? {
          left: 0
        } : null, {}, backgroundColor ? {
          backgroundColor: backgroundColor
        } : null, {}, backgroundImageStyles || null, {}, ignoreSafeArea ? {
          left: 0,
          right: 0
        } : null, {
          bottom: arbitraryHeight ? "" : 0
        })
      }, children));
    }
  }]);

  return Page;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]); // Page renders a vertical flex layout, which means any immediate
// children are subject to vertical growing and shrinking unless wrapped
// with a flex: "none" element. Use StaticSizedArea as an easy shortcut
// like the following:
//
// <Page>
//   <StaticSizedArea>
//     {/* Your fixed-height stuff goes here */}
//   </StaticSizedArea>
// </Page>


__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Page, "contextTypes", {
  // This is just undefined if Page is not mounted inside an AppContainerBreakpointProvider.
  // NOTE: React 16.3 added a new context API which might be less forgiving than this.
  isLargeAppLayout: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Page, "propTypes", {
  name: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  backgroundImageStyles: function backgroundImageStyles() {
    return (typeof StylesObject === "function" ? __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(StylesObject) : __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any).apply(this, arguments);
  },
  arbitraryHeight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  // arbitraryHeight works around an iOS bug where two nested containers can
  // scroll. When the keyboard is visible, iOS does NOT shrink the viewport,
  // but instead allows the body to scroll. If a child is also scrollable, the
  // user's scroll attempts will choose seemingly at random between scrolling
  // body and the child.
  // To improve UX during account creation, we remove scrolling from the child
  // by allowing Page to have arbitrary height. The scrolling will now ALWAYS
  // target the body, which causes the header to scroll out of view. For sign
  // up views, this isn't a problem and since it can be easily scrolled back.
  ignoreSafeArea: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  fullyLoaded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
});


var staticSizedAreaStyles = Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_utils_prefixStyles__["b" /* default */])({
  container: {
    flex: "none" // keep Page from shrinking us vertically

  }
});
var StaticSizedArea = function StaticSizedArea(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
    style: staticSizedAreaStyles.container
  }, children);
};
StaticSizedArea.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/

var RavenConstructor = __webpack_require__(790);

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function() {
  _window.Raven = _Raven;
  return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/**
 * DISCLAIMER:
 *
 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
 *
 * It's called `Client' to be in-line with Raven Node implementation.
 *
 * HOWTO:
 *
 * import Raven from 'raven-js';
 *
 * const someAppReporter = new Raven.Client();
 * const someOtherAppReporter = new Raven.Client();
 *
 * someAppReporter.config('__DSN__', {
 *   ...config goes here
 * });
 *
 * someOtherAppReporter.config('__OTHER_DSN__', {
 *   ...config goes here
 * });
 *
 * someAppReporter.captureMessage(...);
 * someAppReporter.captureException(...);
 * someAppReporter.captureBreadcrumb(...);
 *
 * someOtherAppReporter.captureMessage(...);
 * someOtherAppReporter.captureException(...);
 * someOtherAppReporter.captureBreadcrumb(...);
 *
 * It should "just work".
 */
module.exports.Client = RavenConstructor;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = enqueueIn;
/* harmony export (immutable) */ __webpack_exports__["a"] = cancelEnqueued;
/* harmony export (immutable) */ __webpack_exports__["c"] = setImplementation;
/* unused harmony export bpfrpt_proptype_EnqueueRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_EnqueueRef = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any;
var implementation = {
  enqueue: function enqueue(func) {
    var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return setTimeout(func, ms);
  },
  cancel: function cancel(ref) {
    return clearTimeout(ref);
  }
};
function enqueueIn(func, ms) {
  return implementation.enqueue(func, ms);
}
function cancelEnqueued(ref) {
  implementation.cancel(ref);
}
function setImplementation(newImplementation) {
  implementation = newImplementation;
}



/***/ }),
/* 60 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(154);
var defined = __webpack_require__(76);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(155);
var createDesc = __webpack_require__(111);
var toIObject = __webpack_require__(62);
var toPrimitive = __webpack_require__(75);
var has = __webpack_require__(60);
var IE8_DOM_DEFINE = __webpack_require__(329);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(33) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(60);
var toObject = __webpack_require__(39);
var IE_PROTO = __webpack_require__(231)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Item__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ItemList__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Divider__ = __webpack_require__(444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Item__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Divider__["a"]; });



/* harmony default export */ __webpack_exports__["c"] = (__WEBPACK_IMPORTED_MODULE_1__ItemList__["a" /* default */]);


/***/ }),
/* 66 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(50);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(25);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(405);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_MediaType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_MediaType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(["application/vnd.nexia.collection+json", "application/vnd.nexia.device+json", "application/vnd.nexia.schema+json", "application/vnd.nexia.automation+json", "application/vnd.nexia.event+json", "application/vnd.nexia.mode+json", "application/vnd.nexia.video+json", "application/vnd.nexia.location+json", "application/vnd.nexia.user-code+json", "application/vnd.nexia.alert+json", "application/vnd.nexia.news+json", "application/vnd.nexia.account+json", "application/vnd.nexia.geofence+json", "application/vnd.nexia.choice+json", "application/vnd.nexia.phone+json"]);
/* harmony default export */ __webpack_exports__["a"] = ({
  COLLECTION: "application/vnd.nexia.collection+json",
  DEVICE: "application/vnd.nexia.device+json",
  SCHEMA: "application/vnd.nexia.schema+json",
  AUTOMATION: "application/vnd.nexia.automation+json",
  EVENT: "application/vnd.nexia.event+json",
  MODE: "application/vnd.nexia.mode+json",
  VIDEO: "application/vnd.nexia.video+json",
  LOCATION: "application/vnd.nexia.location+json",
  USER_CODE: "application/vnd.nexia.user-code+json",
  ALERT: "application/vnd.nexia.alert+json",
  NEWS: "application/vnd.nexia.news+json",
  ACCOUNT: "application/vnd.nexia.account+json",
  GEOFENCE: "application/vnd.nexia.geofence+json",
  CHOICE: "application/vnd.nexia.choice+json",
  STREAM: "text/event-stream",
  PHONE: "application/vnd.nexia.phone+json"
});



/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse_uri__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse_uri___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parse_uri__);


function assembleParsedUri(parser) {
  var result = "".concat(parser.authority).concat(parser.directory).concat(parser.file);

  if (_.isString(parser.protocol) && parser.protocol.length > 0) {
    result = "".concat(parser.protocol, "://").concat(result);
  }

  var query = _(parser.queryKey ? parser.queryKey : {}).map(function (value, key) {
    return "".concat(key, "=").concat(value);
  }).join("&");

  if (_.isString(query) && query.length > 0) {
    result = "".concat(result, "?").concat(query);
  }

  if (_.isString(parser.anchor) && parser.anchor.length > 0) {
    result = "".concat(result, "#").concat(parser.anchor);
  }

  return result;
}

var Url = {
  getHostAddress: function getHostAddress(url) {
    var parser = __WEBPACK_IMPORTED_MODULE_0_parse_uri___default()(url);
    var result = parser.authority;

    if (_.isString(parser.protocol) && parser.protocol.length > 0) {
      result = "".concat(parser.protocol, "://").concat(result);
    }

    return result;
  },
  getFilename: function getFilename(url) {
    var parser = __WEBPACK_IMPORTED_MODULE_0_parse_uri___default()(url);

    if (_.isString(parser.file) && parser.file.length === 0) {
      return parser.source;
    }

    return parser.file;
  },
  withAdditionalPath: function withAdditionalPath(url, path) {
    var parser = __WEBPACK_IMPORTED_MODULE_0_parse_uri___default()(url);

    if (!_.str.endsWith(parser.directory, "/")) {
      parser.directory += "/";
    }

    var sanitizedPath;

    if (path.startsWith("/")) {
      sanitizedPath = path.slice(1);
    } else {
      sanitizedPath = path;
    }

    parser.directory += sanitizedPath;
    return assembleParsedUri(parser);
  },
  withAdditionalParams: function withAdditionalParams(url, params) {
    var parser = __WEBPACK_IMPORTED_MODULE_0_parse_uri___default()(url);

    _.extend(parser.queryKey, params);

    return assembleParsedUri(parser);
  },
  withoutParams: function withoutParams(url) {
    var parser = __WEBPACK_IMPORTED_MODULE_0_parse_uri___default()(url);
    parser.queryKey = {};
    return assembleParsedUri(parser);
  },
  expandTemplate: function expandTemplate(urlTemplate, params) {
    var href = urlTemplate.toString();

    _.each(params, function (value, key) {
      return href = href.replace("{".concat(key, "}"), encodeURIComponent(value));
    });

    return href.replace(/{.*?}/g, "");
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Url);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_utils_prefixStyles__ = __webpack_require__(9);




var buttonStyle = Object(__WEBPACK_IMPORTED_MODULE_3_nx_components_utils_prefixStyles__["b" /* default */])({
  flex: "1 1 auto",
  fontSize: "0.8em",
  marginBottom: ""
});

function DeviceControlButton(_ref) {
  var alert = _ref.alert,
      buttonLabel = _ref.buttonLabel,
      disabled = _ref.disabled,
      needsTrustedTap = _ref.needsTrustedTap,
      onTap = _ref.onTap;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_nx_components_Button__["a" /* default */], {
    full: true,
    disabled: disabled,
    needsTrustedTap: needsTrustedTap,
    onTap: onTap,
    theme: alert ? "alert" : undefined,
    style: buttonStyle
  }, buttonLabel);
}

DeviceControlButton.propTypes = {
  alert: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  buttonLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  needsTrustedTap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onTap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (DeviceControlButton);

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(26);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(8);
var core = __webpack_require__(61);
var fails = __webpack_require__(25);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(67);
var IObject = __webpack_require__(154);
var toObject = __webpack_require__(39);
var toLength = __webpack_require__(30);
var asc = __webpack_require__(247);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Location; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_automation_collection__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_device_collection__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_mixins_editable__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_mixins_detailsable__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mode_collection__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_event_collection__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_recorded_video_collection__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_framework_media_type__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);

















var Location =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Location, _BaseModel);

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Location, [{
    key: "nestedCollections",
    value: function nestedCollections() {
      return {
        automations: {
          collection: __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_automation_collection__["a" /* default */]
        },
        devices: {
          collection: __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_device_collection__["a" /* default */]
        },
        modes: {
          collection: __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mode_collection__["a" /* default */]
        },
        events: {
          collection: __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_event_collection__["a" /* default */]
        },
        recordedVideos: {
          collection: __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_recorded_video_collection__["a" /* default */]
        },
        operations: {
          collection: __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_collection__["a" /* default */],
          model: __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__["a" /* default */]
        }
      };
    }
  }]);

  function Location() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Location);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default()(Location)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.listenTo(_this.get("modes"), "reload_automations", function () {
      return _this.get("automations").fetch();
    });

    _this.listenTo(_this.get("devices"), "name:edited", function () {
      return _this.fetch();
    });

    _this.get("events").automationFilters = _this.get("automations");
    _this.get("events").deviceFilters = _this.get("devices");
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Location, [{
    key: "getChildSchema",
    value: function getChildSchema(schemaType, callback) {
      return this.get("devices").createEditSchema().then(function (schema) {
        var addDeviceSchema = schema.getChildSchemas().models.find(function (childSchema) {
          return childSchema.get("label").match(new RegExp(schemaType, "i"));
        });
        return addDeviceSchema.getNextStep().then(function (_ref) {
          var nextSchema = _ref.nextSchema;
          return callback(nextSchema);
        }, function () {// Ignore failure to get next step
        });
      });
    }
  }, {
    key: "unregisterThirdParty",
    value: function unregisterThirdParty(href) {
      var dummyModel = new __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__["a" /* default */]();
      dummyModel.setUrl(href);
      dummyModel.setAsEphemeral();
      return dummyModel.destroy();
    }
  }, {
    key: "parseLinksChild",
    value: function parseLinksChild(links) {
      var _this2 = this;

      if (links.length === 0) {
        return null;
      }

      var linkPromises = [];
      links.forEach(function (link) {
        switch (link.getCollectionItemType()) {
          case __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_framework_media_type__["a" /* default */].AUTOMATION:
            linkPromises.push(_this2.get("automations").set(link.getData(), {
              parse: true,
              asyncParseDelay: 1
            }));
            break;

          case __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_framework_media_type__["a" /* default */].DEVICE:
            linkPromises.push(_this2.get("devices").set(link.getData(), {
              parse: true,
              asyncParseDelay: 1
            }));
            break;

          case __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_framework_media_type__["a" /* default */].EVENT:
            _this2.maybeParseChildLinkForCollection(_this2.get("events"), link);

            break;

          case __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_framework_media_type__["a" /* default */].MODE:
            _this2.get("modes").set(link.getData(), {
              parse: true
            });

            break;

          case __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_framework_media_type__["a" /* default */].VIDEO:
            _this2.maybeParseChildLinkForCollection(_this2.get("recordedVideos"), link);

            break;
        }
      });
      this._asyncParsePromise = Promise.all(linkPromises).then(function () {
        _this2.set("hasParsedChildCollections", true);
      }); // Only prevent this if we were explicitly told to

      if (this._allowHomeProfileUpdate !== false) {
        this._asyncParsePromise.then(function () {
          return Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_flux_like_dispatch__["a" /* default */])("UPDATE_VOGNITION_HOME_PROFILE", _this2);
        });
      }

      return null;
    }
  }, {
    key: "parseLinksOperation",
    value: function parseLinksOperation(links) {
      var link = _.first(links);

      if (link == null) {
        return;
      }

      this.get("operations").add(new __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__["a" /* default */](_.extend({}, link, link.getData()), {
        parse: true
      }));
    }
  }, {
    key: "ensureParsed",
    value: function ensureParsed() {
      return this._asyncParsePromise;
    }
  }, {
    key: "allowHomeProfileUpdate",
    value: function allowHomeProfileUpdate() {
      this._allowHomeProfileUpdate = true;
    }
  }, {
    key: "preventHomeProfileUpdate",
    value: function preventHomeProfileUpdate() {
      this._allowHomeProfileUpdate = false;
    }
  }, {
    key: "getDeviceListingView",
    value: function getDeviceListingView() {
      return this._allowDeviceListingView;
    }
  }, {
    key: "preventDeviceListingView",
    value: function preventDeviceListingView() {
      this._allowDeviceListingView = false;
    }
  }, {
    key: "allowDeviceListingView",
    value: function allowDeviceListingView() {
      this._allowDeviceListingView = true;
    }
  }]);

  return Location;
}(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__["a" /* default */]);



_.extend(Location.prototype, __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_mixins_editable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_mixins_detailsable__["a" /* default */]);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentPropType__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentPropType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__componentPropType__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "componentPropType", function() { return __WEBPACK_IMPORTED_MODULE_0__componentPropType___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "chainPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_1__chainPropTypes___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exactProp__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exactProp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__exactProp__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "exactProp", function() { return __WEBPACK_IMPORTED_MODULE_2__exactProp___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getDisplayName__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getDisplayName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__getDisplayName__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return __WEBPACK_IMPORTED_MODULE_3__getDisplayName___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ponyfillGlobal", function() { return __WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal___default.a; });
/** @license Material-UI v3.0.0-alpha.3
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */







/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserRouter */
/* unused harmony export HashRouter */
/* unused harmony export Link */
/* unused harmony export NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(399);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(264);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["d" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["d" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a", props);
});

if (false) {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["component", "replace", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["f" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var method = replace ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props);
  });
});

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["f" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["g" /* matchPath */])(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, {}, activeStyle) : styleProp;

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link, props);
  });
});

if (false) {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}


//# sourceMappingURL=react-router-dom.js.map


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_framework_media_type__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_followLink__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_setting__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_mixins_editable__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mixins_automatable__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_mixins_has_icon__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_mixins_device_features__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_url__ = __webpack_require__(73);







/* eslint-disable no-case-declarations */










var Device =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Device, _BaseModel);

  function Device() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Device);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Device).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Device, [{
    key: "validations",
    value: function validations() {
      return {
        name: {
          required: true,
          label: "Name"
        }
      };
    }
  }, {
    key: "nestedCollections",
    value: function nestedCollections() {
      return {
        settings: {
          model: __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_setting__["a" /* default */]
        }
      };
    }
  }, {
    key: "onParse",
    value: function onParse(rawAttrs) {
      var _this = this;

      var attrs = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Device.prototype), "onParse", this).call(this, rawAttrs);

      if (attrs.features == null) {
        attrs.features = [];
      }

      this._adaptAttributesToFeatures(attrs);

      this._deviceFeatures = new Set();
      var featureAttrs = {};

      _.each(attrs.features, function (feature, name) {
        var className = _.str.classify(feature.name || name).replace(/Xr724/, "XR724"); // eslint-disable-next-line import/namespace


        var featureMixin = __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_mixins_device_features__[className];

        if (featureMixin == null) {
          return;
        } // mixins should return any attributes that represent the state of the device,
        // so that appropriate change events are triggered by the model as the state changes.


        var result = _this.addFeature(featureMixin, feature);

        if (_.isObject(result) && !_.isFunction(result)) {
          _.extend(featureAttrs, result);
        }
      });

      return _.extend(featureAttrs, attrs);
    }
  }, {
    key: "addFeature",
    value: function addFeature(featureMixin) {
      var featureAttrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this._deviceFeatures == null) {
        this._deviceFeatures = new Set();
      }

      this._deviceFeatures.add(featureMixin);

      if (featureAttrs.actions == null) {
        featureAttrs.actions = {};
      } // mixins are defined as methods. call the mixin using this device as
      // the value for "this", so the mixin can add instance methods if it wants to.


      return featureMixin.call(this, featureAttrs);
    }
  }, {
    key: "hasFeature",
    value: function hasFeature(featureMixin) {
      if (this._deviceFeatures == null) {
        this._deviceFeatures = new Set();
      }

      return Boolean(this._deviceFeatures.has(featureMixin));
    }
  }, {
    key: "isNameEditable",
    value: function isNameEditable() {
      var editable = this.get("name_editable");
      return editable == null ? true : editable;
    }
  }, {
    key: "parseLinksFilterEvents",
    value: function parseLinksFilterEvents(links) {
      var link = _.first(links);

      if (link) {
        this.set("filterEventsUrl", link.getHref());
      }
    }
  }, {
    key: "parseLinksFilterVideos",
    value: function parseLinksFilterVideos(links) {
      var link = _.first(links);

      if (link) {
        this.set("filterVideosUrl", link.getHref());
      }
    }
  }, {
    key: "parseLinksImage",
    value: function parseLinksImage(links) {
      var link = _.first(links);

      if (link) {
        return {
          imageSrc: link.href
        };
      } else {
        return {
          imageSrc: null
        };
      }
    }
  }, {
    key: "hasSettings",
    value: function hasSettings() {
      return this.get("settings").length > 0;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        name: this.get("name")
      };
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.get("name");
    }
  }, {
    key: "getDeviceTypeString",
    value: function getDeviceTypeString() {
      return this.get("type") || "Device";
    }
  }, {
    key: "executeDeviceAction",
    value: function executeDeviceAction(link, data) {
      var passedOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var options = Object.assign({
        method: "POST",
        data: data,
        fetchModelWhenDone: false,
        updateModelWithResponse: !passedOptions.fetchModelWhenDone
      }, passedOptions);
      return Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_followLink__["a" /* default */])(this, link, options);
    }
  }, {
    key: "executeDeviceActionThenFetch",
    value: function executeDeviceActionThenFetch(link, data) {
      var passedOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var options = Object.assign({
        fetchModelWhenDone: true
      }, passedOptions);
      return this.executeDeviceAction(link, data, options);
    } // ---- TODO: change server responses so this isn't necessary.
    // Rearrange the device JSON so it looks like the server is listing all
    // device capabilities in the 'features' array (only some of them are
    // at the moment)

    /* eslint-disable camelcase */

  }, {
    key: "_adaptAttributesToFeatures",
    value: function _adaptAttributesToFeatures(attrs) {
      switch (attrs.type) {
        case "barrier":
          {
            var feature = {
              name: "barrier",
              status: attrs.current_state_text,
              actions: {}
            };

            if (attrs.operable) {
              feature.actions.operate = {
                href: __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_url__["a" /* default */].withAdditionalPath(this.url(), "operate"),
                title: attrs.current_action
              };
            }

            attrs.features.push(feature);
            break;
          }

        case "camera":
          {
            attrs.features.push({
              name: "camera",
              connected: attrs.connected,
              quality: attrs.quality
            });
            break;
          }

        case "dimmer":
          {
            attrs.features.push({
              name: "dimmer",
              level: attrs.value,
              actions: {
                set_level: {
                  href: __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_url__["a" /* default */].withAdditionalPath(this.url(), "set")
                }
              }
            });
            break;
          }

        case "group":
          {
            var members;

            if (attrs._links != null) {
              members = attrs._links.child;
            }

            if (members != null && !_.isArray(members)) {
              members = [members];
            }

            attrs.features.push({
              name: "group",
              members: members.map(function (member) {
                return member.data;
              })
            });
            break;
          }

        case "lock":
          {
            if (attrs.supports_user_codes) {
              var userCodeFeature = {
                name: "access_code",
                has_temporary: attrs.has_temporary_code,
                code_length: attrs.user_code_length,
                resource: {},
                actions: {
                  set_temporary: {
                    href: __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_url__["a" /* default */].withAdditionalPath(this.url(), "set_temporary_code")
                  },
                  remove_temporary: {
                    href: __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_url__["a" /* default */].withAdditionalPath(this.url(), "remove_temporary_code")
                  }
                }
              };
              var collection;

              if (attrs._links != null) {
                collection = attrs._links.child;
              }

              if (collection.type === __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_framework_media_type__["a" /* default */].COLLECTION && collection.data && collection.data.item_type === __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_framework_media_type__["a" /* default */].USER_CODE) {
                userCodeFeature.resource.href = collection.href;
              }

              attrs.features.push(userCodeFeature);
            }

            break;
          }

        case "sensor":
          {
            var _feature = {
              name: "sensor",
              sensor_type: attrs.sensor_type
            };

            if (attrs.value != null) {
              _feature.triggered = attrs.value !== 0;
            }

            if (attrs.current_state_text != null) {
              _feature.status = attrs.current_state_text;
            }

            attrs.features.push(_feature);

            if (attrs.temperature != null) {
              attrs.features.push({
                name: "sensor",
                sensor_type: __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_mixins_device_features__["Sensor"].Type.TEMPERATURE,
                value: attrs.temperature,
                unit: "°"
              });
            }

            break;
          }

        case "smoke_detector":
          {
            var _feature2 = {
              name: "sensor",
              sensor_type: __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_mixins_device_features__["Sensor"].Type.SMOKE
            };

            if (attrs.current_state_text != null) {
              _feature2.status = attrs.current_state_text;
            }

            attrs.features.push(_feature2);
            break;
          }

        case "solar_panel":
          {
            var _feature3 = {
              name: "solar_panel"
            };

            _.extend(_feature3, _.omit(attrs, "features"));

            attrs.features.push(_feature3);
            break;
          }

        case "siren":
        case "switch":
          {
            var status;
            var toggleHref;

            if (attrs.value === 0) {
              status = "off";
              toggleHref = __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_url__["a" /* default */].withAdditionalPath(this.url(), "on");
            } else {
              status = "on";
              toggleHref = __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_url__["a" /* default */].withAdditionalPath(this.url(), "off");
            }

            var featureName = attrs.type === "siren" ? "alarm" : "switch";
            attrs.features.push({
              name: featureName,
              status: status,
              actions: {
                toggle: {
                  href: toggleHref
                },
                on: {
                  href: __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_url__["a" /* default */].withAdditionalPath(this.url(), "on")
                },
                off: {
                  href: __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_url__["a" /* default */].withAdditionalPath(this.url(), "off")
                }
              }
            });
            break;
          }

        case "valve":
          {
            var _feature4 = {
              name: "valve",
              status: attrs.current_state_text,
              actions: {}
            };

            if (attrs.operable) {
              _feature4.actions.operate = {
                href: __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_url__["a" /* default */].withAdditionalPath(this.url(), "operate"),
                title: attrs.current_action
              };
            }

            attrs.features.push(_feature4);
            break;
          }
      }

      if (attrs.has_indoor_humidity) {
        attrs.features.push({
          name: "sensor",
          sensor_type: __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_mixins_device_features__["Sensor"].Type.RELATIVE_HUMIDITY,
          value: attrs.indoor_humidity,
          unit: "%"
        });
      }

      if (attrs.has_outdoor_temperature) {
        attrs.features.push({
          name: "sensor",
          sensor_type: __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_mixins_device_features__["Sensor"].Type.OUTDOOR_TEMPERATURE,
          value: attrs.outdoor_temperature,
          unit: "°"
        });
      }
    }
    /* eslint-enable camelcase */

  }]);

  return Device;
}(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__["a" /* default */]);

_.extend(Device.prototype, __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_mixins_editable__["a" /* default */]);

_.extend(Device.prototype, __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mixins_automatable__["a" /* default */]);

_.extend(Device.prototype, __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_mixins_has_icon__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Device);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseIconsFromServer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_DeviceThermostatIcon__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function parseValues(icons) {
  // $FlowFixMe the type for _.flatten is wrong in the library we're using.
  var values = _.flatten([icons]); // convert all icons to a common pattern {name, class, modifiers, key}


  return values.map(function (value) {
    var icon = {};

    if (value != null && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(value) == "object") {
      icon.name = value.name;
      icon["class"] = Object(__WEBPACK_IMPORTED_MODULE_3_nx_components_Icons__["_62" /* iconFromAPIName */])(icon.name);
      icon.modifiers = value.modifiers || [];
      icon.key = "".concat(icon.name, " ").concat(icon.modifiers.join(" "));
    } else {
      icon.name = value;
      icon["class"] = Object(__WEBPACK_IMPORTED_MODULE_3_nx_components_Icons__["_62" /* iconFromAPIName */])(value);
      icon.modifiers = [];
      icon.key = value;
    }

    return icon;
  });
}

function createElementsFromValues(values, options) {
  return values.map(function (icon) {
    var element;

    if (icon.name === "thermostat") {
      element = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_DeviceThermostatIcon__["a" /* default */], {
        value: icon,
        includeTemperature: options.showThermostatTemperatureModifier
      });
    } else {
      var IconClass = icon["class"];
      element = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](IconClass, options.ignoreModifiers ? null : {
        modifiers: icon.modifiers
      });
    }

    return _objectSpread({}, icon, {
      element: element
    });
  });
}

createElementsFromValues.contextTypes = {
  showThermostatTemperatureModifier: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
  ignoreModifiers: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
function parseIconsFromServer(icons) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    showThermostatTemperatureModifier: false
  };
  var values = parseValues(icons); // filter in case an icon fails to match a class in iconFromAPIName

  values = values.filter(function (value) {
    return Boolean(value["class"]);
  });
  return createElementsFromValues(values, options);
}




/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LanguageContextWrapper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Locales__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contextHelper__ = __webpack_require__(446);




var LanguageContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext();
/* harmony default export */ __webpack_exports__["b"] = (LanguageContext);
function LanguageContextWrapper(props) {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(Object(__WEBPACK_IMPORTED_MODULE_2__Locales__["b" /* getLanguageSet */])()),
      _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      localeSet = _useState2[0],
      setLocaleSet = _useState2[1];

  var setLocaleContext = function setLocaleContext(value) {
    var newLocalSet = Object(__WEBPACK_IMPORTED_MODULE_2__Locales__["b" /* getLanguageSet */])(value);
    setLocaleSet(newLocalSet);
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LanguageContext.Provider, {
    value: {
      localeSet: localeSet,
      setLocaleContext: setLocaleContext,
      casing: __WEBPACK_IMPORTED_MODULE_3__contextHelper__["a" /* casing */],
      template: __WEBPACK_IMPORTED_MODULE_2__Locales__["e" /* template */]
    }
  }, props.children);
}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResourceMap; });
/* unused harmony export bpfrpt_proptype_Resource */
/* unused harmony export bpfrpt_proptype_FetchOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_framework_link__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_framework_rel__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_backstage__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_url__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_PromiseWithAbort__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var _hrefToResourceMap = {};
var ResourceMap = {
  findByHref: function findByHref(href) {
    return _hrefToResourceMap[href];
  },
  clearAll: function clearAll() {
    _hrefToResourceMap = {};
  }
};
var bpfrpt_proptype_Resource = __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object;
var bpfrpt_proptype_FetchOptions = {};
/* harmony default export */ __webpack_exports__["b"] = ({
  parseLinks: function parseLinks(attrs) {
    var result = {}; // attributes to set() on model

    var linkMap = attrs._links || {};

    for (var _i = 0, _Object$keys = Object.keys(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_framework_rel__["a" /* default */]); _i < _Object$keys.length; _i++) {
      var _key = _Object$keys[_i];
      var handlerName = __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_framework_rel__["a" /* default */][_key];
      var handler = this["parseLinks".concat(handlerName)]; // do we have a handler method for this link rel?

      if (typeof handler == "function") {
        // build an array of Link objects and call the handler with it
        var links = linkMap[_key] || [];

        if (!_.isArray(links)) {
          links = [links];
        }

        links = _.map(links, function (link) {
          return new __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_framework_link__["a" /* default */](link);
        }); // merge the handler's results into our output

        var handlerResult = handler.call(this, links);

        if (handlerResult instanceof __WEBPACK_IMPORTED_MODULE_2_backbone___default.a.Model) {
          handlerResult = null;
        }

        if (handlerResult != null) {
          _.extend(result, handlerResult);
        }
      }
    }

    return result;
  },
  hasUrl: function hasUrl() {
    try {
      return Boolean(this.getUrl());
    } catch (error) {
      return false;
    }
  },
  isNew: function isNew() {
    return !this.hasUrl();
  },
  setUrl: function setUrl(href) {
    return this.id = href;
  },
  getUrlParams: function getUrlParams() {
    return null;
  },
  setUrlParams: function setUrlParams(params) {
    return this._resourceUrlParams = params;
  },
  getUrl: function getUrl() {
    if (this._resourceUrlParams) {
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_url__["a" /* default */].expandTemplate(this.id, this._resourceUrlParams);
    } else if (this.id) {
      return this.id;
    } else {
      return undefined;
    }
  },
  url: function url() {
    return this.getUrl();
  },
  setAsEphemeral: function setAsEphemeral() {
    this._ephemeral = true;
  },
  isEphemeral: function isEphemeral() {
    return Boolean(this._ephemeral || this.constructor.isEphemeral);
  },
  fetchUrlWithResourceClone: function fetchUrlWithResourceClone(url, options) {
    var resourceClone = new this.constructor();
    resourceClone.setUrl(url);
    resourceClone.setAsEphemeral();
    resourceClone.clonedResource = this;
    return resourceClone.fetch(options).then(function () {
      return resourceClone;
    });
  },
  parseLinksSelf: function parseLinksSelf(links) {
    var link = _.first(links);

    if (!link) {
      return {};
    }

    if (!this.isEphemeral()) {
      _hrefToResourceMap[link.href] = this;
    }

    this.id = link.href; // we only need this for collections,
    // because they won't ever have the following attributes
    // set() on them.

    return {
      id: link.href
    };
  },
  maybeParseChildLinkForCollection: function maybeParseChildLinkForCollection(collection, link) {
    // Always parse if there is no collection in the ResourceMap, so that parseLinksSelf
    // puts the collection in the map. If the server (and links only come from the server)
    // has not sent an array of items, don't parse the data because it's only a stub.
    var data = link.getData();
    var resourceHref = link.href || data._links && data._links.self || data.id;

    if (!ResourceMap.findByHref(resourceHref) || data.items instanceof Array) {
      collection.set(data, {
        parse: true
      });
    }
  },
  parseLinksDetails: function parseLinksDetails(links) {
    var link = _.first(links);

    return link ? {
      _detailsLinkHref: link.href
    } : {};
  },
  hasDetailsLink: function hasDetailsLink() {
    return Boolean(this.get("_detailsLinkHref"));
  },
  // Fetch the resource and also its details href, if it has one. This will only
  // fire one change event.
  fetchWithDetails: function fetchWithDetails(options) {
    var _this = this;

    // If we don't have a details href, just perform a normal fetch, and the
    // changes will be applied atomically.
    if (!this.hasDetailsLink()) {
      return this.fetch(options);
    } // Fetch with a dummy model so that we can apply the set with the normal
    // attributes and the set with the details attributes as one atomic change.


    var normalDummy = new __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_base_model__["a" /* default */]();
    normalDummy.setUrl(this.url());
    normalDummy.setAsEphemeral();
    var normalFetch = normalDummy.fetch(options);
    var detailsDummy = new __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_base_model__["a" /* default */]();
    detailsDummy.setUrl(this.get("_detailsLinkHref"));
    detailsDummy.setAsEphemeral();
    var detailsFetch = detailsDummy.fetch(options);
    var combinedFetch = Promise.all([normalFetch, detailsFetch]).then(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          normalResponse = _ref2[0],
          detailsResponse = _ref2[1];

      // Make sure to apply details attributes *after* applying the attributes
      // from a normal fetch, because otherwise, as a result of the model response
      // being parsed and applied after the details response, we might remove some
      // of the properties that were in the details response.
      var combinedResponse = _objectSpread({}, normalResponse, {
        result: _objectSpread({}, normalResponse.result, {}, detailsResponse.result) // Ignore error/success from detailsResponse

      });

      _this.set(_this.parse(combinedResponse));
    });

    var abort = function abort() {
      if (normalFetch.abort != null) {
        normalFetch.abort();
      }

      if (detailsFetch.abort != null) {
        detailsFetch.abort();
      }
    };

    return Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_PromiseWithAbort__["a" /* createPromiseWithAbort */])(combinedFetch, abort);
  },
  fetchDetails: function fetchDetails(options) {
    var _this2 = this;

    if (!this.hasDetailsLink()) {
      throw new Error("Attempted to fetch details for a resource that had no details link");
    }

    var dummyModel = new __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_base_model__["a" /* default */]();
    dummyModel.setUrl(this.get("_detailsLinkHref"));
    dummyModel.setAsEphemeral();
    return dummyModel.fetch(options).done(function () {
      _this2.set(dummyModel.attributes);
    });
  },
  parseLinksPendingRequest: function parseLinksPendingRequest(links) {
    var link = links[0];

    if (link != null) {
      this._pendingRequestLink = link;
    } else {
      this._pendingRequestLink = null;
    }
  },
  hasPendingRequestLink: function hasPendingRequestLink() {
    return Boolean(this._pendingRequestLink);
  },
  fetchPendingRequestData: function fetchPendingRequestData() {
    var _this3 = this;

    if (this._fetchingPendingRequestDataPromise != null) {
      return this._fetchingPendingRequestDataPromise;
    }

    if (this._pendingRequestBackstage != null) {
      this._pendingRequestBackstage.stopPolling();
    }

    var link = this._pendingRequestLink;

    if (link == null) {
      return Promise.resolve({});
    }

    this._fetchingPendingRequestDataPromise = new Promise(function (resolve, reject) {
      _this3._pendingRequestBackstage = new __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_backstage__["a" /* default */](link.polling_path, {
        success: function success(result) {
          resolve(result.options);
        },
        error: function error(errors) {
          reject(new Error("fetchPendingRequestData failed: ".concat(errors.map(function (err) {
            return err.errorMessage;
          }).join(", "))));
        },
        maxRequestsCount: 10
      });

      _this3._pendingRequestBackstage.startPolling();
    }).then(function (result) {
      _this3._fetchingPendingRequestDataPromise = null;
      return result;
    })["catch"](function (err) {
      _this3._fetchingPendingRequestDataPromise = null;
      throw err;
    });
    return this._fetchingPendingRequestDataPromise;
  },
  populatePendingRequestsRecursively: function populatePendingRequestsRecursively() {
    function maybeFetchPendingRequestData(model) {
      if (model == null || typeof model.isEphemeral === "function" && model.isEphemeral()) {
        return Promise.resolve();
      }

      var returnValue = Promise.resolve();

      if (typeof model.hasPendingRequestLink === "function" && model.hasPendingRequestLink()) {
        returnValue = model.fetchPendingRequestData().then(function (data) {
          model.set(data);
        })["catch"](function () {// ignore
        });
      }

      var nestedCollectionKeys = typeof model.nestedCollections === "function" && Object.keys(model.nestedCollections());

      if (!nestedCollectionKeys || nestedCollectionKeys.length === 0) {
        return returnValue;
      } else {
        return returnValue.then(function () {
          return Promise.all(nestedCollectionKeys.map(function (collectionKey) {
            var collection = model.get(collectionKey);

            if (collection == null || collection.length === 0) {
              return null;
            }

            return Promise.all(collection.map(maybeFetchPendingRequestData));
          }));
        }).then(function () {
          /* discard response */
        });
      }
    }

    return maybeFetchPendingRequestData(this);
  }
});




/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(33)) {
  var LIBRARY = __webpack_require__(99);
  var global = __webpack_require__(21);
  var fails = __webpack_require__(25);
  var $export = __webpack_require__(8);
  var $typed = __webpack_require__(189);
  var $buffer = __webpack_require__(255);
  var ctx = __webpack_require__(67);
  var anInstance = __webpack_require__(118);
  var propertyDesc = __webpack_require__(111);
  var hide = __webpack_require__(54);
  var redefineAll = __webpack_require__(120);
  var toInteger = __webpack_require__(69);
  var toLength = __webpack_require__(30);
  var toIndex = __webpack_require__(357);
  var toAbsoluteIndex = __webpack_require__(114);
  var toPrimitive = __webpack_require__(75);
  var has = __webpack_require__(60);
  var classof = __webpack_require__(135);
  var isObject = __webpack_require__(26);
  var toObject = __webpack_require__(39);
  var isArrayIter = __webpack_require__(244);
  var create = __webpack_require__(115);
  var getPrototypeOf = __webpack_require__(64);
  var gOPN = __webpack_require__(116).f;
  var getIterFn = __webpack_require__(246);
  var uid = __webpack_require__(112);
  var wks = __webpack_require__(29);
  var createArrayMethod = __webpack_require__(78);
  var createArrayIncludes = __webpack_require__(179);
  var speciesConstructor = __webpack_require__(157);
  var ArrayIterators = __webpack_require__(249);
  var Iterators = __webpack_require__(137);
  var $iterDetect = __webpack_require__(184);
  var setSpecies = __webpack_require__(117);
  var arrayFill = __webpack_require__(248);
  var arrayCopyWithin = __webpack_require__(346);
  var $DP = __webpack_require__(38);
  var $GOPD = __webpack_require__(63);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(352);
var $export = __webpack_require__(8);
var shared = __webpack_require__(153)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(355))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);
var defaultToWhiteSpace = __webpack_require__(257);
var nativeTrim = String.prototype.trim;

module.exports = function trim(str, characters) {
  str = makeString(str);
  if (!characters && nativeTrim) return nativeTrim.call(str);
  characters = defaultToWhiteSpace(characters);
  return str.replace(new RegExp('^' + characters + '+|' + characters + '+$', 'g'), '');
};


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionPromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_utils_enqueueIn__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_PageTransition__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Routing_SubMemoryRouter__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);















function buildScreenGuard() {
  var screenGuard = document.createElement("div");
  screenGuard.className = "screen-guard";
  Object.assign(screenGuard.style, {
    position: "fixed",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    zIndex: "9001" // over 9000!!

  });
  return screenGuard;
}

var transitionPromise = Promise.resolve();
function getTransitionPromise() {
  return new Promise(function (resolve) {
    // Always delay at least a task first so that if:
    // * A click event or etc causes navigation
    // * and we want to set up .then callbacks within that click event handler
    //   for when transitions are done
    // * then the componentDidUpdate in HistoryPageTransitionController can
    //   update transitionPromise to the new instance which refers to the
    //   current transition,
    // * before those .then callbacks get called.
    // Otherwise, those click event handler .then callbacks would fire
    // immediately, because transitionPromise would be a Promise that got
    // resolved a long time ago.
    //
    // We use enqueueIn here instead of setTimeout because device parsing awaits
    // getTransitionPromise, and we need device parsing to not be throttled.
    Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_utils_enqueueIn__["b" /* default */])(resolve, 0);
  }).then(function () {
    return transitionPromise;
  })["catch"](function (err) {
    // We want to report this, because it shouldn't happen, but in case it
    // does, we want this promise to still resolve so that consumers of
    // getTransitionPromise don't need to guard this promise defensively.
    __WEBPACK_IMPORTED_MODULE_9_raven_js___default.a.captureException(err);
  });
}

var HistoryPageTransitionController =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(HistoryPageTransitionController, _React$Component);

  function HistoryPageTransitionController() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, HistoryPageTransitionController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(HistoryPageTransitionController)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_pageTransitions", new WeakMap());

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_visibleLocations", new Set());

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_getHistoryKey", function () {
      var history = _this.props.history;
      return [history.index, history.entries.map(function (location) {
        return location.key;
      }).join(","), history.action].join("_");
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(HistoryPageTransitionController, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var history = this.props.history;

      this._visibleLocations.add(history.entries[history.index]);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "_forceUpdateIfMounted",
    value: function _forceUpdateIfMounted() {
      if (this._isMounted) {
        this.forceUpdate();
      }
    } // The user should not be able to interact with stuff while the page is
    // transitioning, because if they can, they can eg. tap a tile 10 times
    // which calls history.push("/app/device/details") 10 times in a row.
    // This renders a div on top of the page, which prevents the user and also the
    // BackButtonResponder in BackButton from interacting with anything.

  }, {
    key: "_guardScreenDuringTransition",
    value: function _guardScreenDuringTransition(shouldGuard) {
      var _document = document,
          body = _document.body;

      if (body == null) {
        return;
      }

      if (shouldGuard) {
        if (this._screenGuard == null) {
          this._screenGuard = buildScreenGuard();
        }

        body.appendChild(this._screenGuard);
      } else if (this._screenGuard && body.contains(this._screenGuard)) {
        body.removeChild(this._screenGuard);
      }
    }
  }, {
    key: "_slideNewOntoOld",
    value: function _slideNewOntoOld(newLocation, oldLocation) {
      var _this2 = this;

      this._guardScreenDuringTransition(true);

      this._visibleLocations.add(newLocation);

      if (oldLocation != null) {
        this._visibleLocations.add(oldLocation);
      }

      this.forceUpdate();

      var newPageTransition = this._pageTransitions.get(newLocation);

      var actions = [];

      if (newPageTransition != null) {
        actions.push(newPageTransition.slideIn());
      }

      transitionPromise = transitionPromise.then(function () {
        return Promise.all(actions).then(function () {
          _this2._visibleLocations.add(newLocation);

          _this2._visibleLocations["delete"](oldLocation);

          _this2._forceUpdateIfMounted();

          _this2._guardScreenDuringTransition(false);

          if (newPageTransition != null) {
            newPageTransition.focus();
          }
        });
      });
    }
  }, {
    key: "_slideOldsOffOfNew",
    value: function _slideOldsOffOfNew(oldLocations, newLocation) {
      var _this3 = this;

      this._guardScreenDuringTransition(true);

      var actions = [];

      this._visibleLocations.add(newLocation);

      var newPageTransition = this._pageTransitions.get(newLocation);

      if (newPageTransition != null) {
        actions.push(newPageTransition.teleportIn());
      }

      oldLocations.forEach(function (oldLocation) {
        var oldPageTransition = _this3._pageTransitions.get(oldLocation);

        if (oldPageTransition != null) {
          actions.push(oldPageTransition.slideOut());
        }
      });
      transitionPromise = transitionPromise.then(function () {
        return Promise.all(actions).then(function () {
          _this3._visibleLocations.add(newLocation);

          oldLocations.forEach(function (oldLocation) {
            _this3._visibleLocations["delete"](oldLocation);
          });

          _this3._forceUpdateIfMounted();

          _this3._guardScreenDuringTransition(false);

          if (newPageTransition != null) {
            newPageTransition.focus();
          }
        });
      });
      this.forceUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this4 = this;

      // We need to react to route changes in componentDidUpdate instead of
      // UNSAFE_componentWillReceiveProps because we need our refs to be present before
      // we can call the relevant ref methods.
      var history = this.props.history; // There is a possibility that this update was *not* caused by a route
      // change; if that's the case, don't animate anything.

      var historyKey = this._getHistoryKey();

      if (historyKey === this._previousHistoryKey) {
        return;
      }

      this._previousHistoryKey = historyKey;
      var action = history.computeEffectiveAction();

      if (action === "PUSH") {
        // User is navigating forwards. Slide the page they are navigating
        // onto on top of the page they just came from.
        var newLocation = history.entries[history.index];
        var oldLocation = history.entries[history.index - 1];

        this._slideNewOntoOld(newLocation, oldLocation);
      } else if (action === "POP") {
        // User is navigating back. Slide the page they just came from off the top
        // of the page they are navigating onto.
        var oldLocations = history.entries.slice(history.index + 1);
        var _newLocation = history.entries[history.index];

        this._slideOldsOffOfNew(oldLocations, _newLocation);
      } else if (action === "REPLACE") {
        // The route got replaced. Usually this happens programmatically.
        // Transition it as if it were a PUSH.
        var _newLocation2 = history.entries[history.index];

        var _oldLocation = history.replacedLocation && history.replacedLocation.location;

        if (_oldLocation != null) {
          this._slideNewOntoOld(_newLocation2, _oldLocation);
        }
      } else if (action === "INITIAL_REPLACE") {
        // This is just the /app replace that happens when the app launches.
        // Don't transition the the page in; show it now.
        var _newLocation3 = history.entries[history.index];

        var _oldLocation2 = history.replacedLocation && history.replacedLocation.location;

        if (_oldLocation2 != null) {
          this._visibleLocations["delete"](_oldLocation2);
        }

        this._visibleLocations.add(_newLocation3);

        var newPageTransition = this._pageTransitions.get(_newLocation3);

        if (newPageTransition != null) {
          newPageTransition.teleportIn();
        }

        this.forceUpdate();
      } else if (action === "CLEAR_HISTORY_AND_PUSH") {
        // A clearHistoryAndPush occurred. Stop rendering all the locations that
        // got POPped and slide the new location in on top of the old one.
        var _newLocation4 = history.entries[0];
        var poppedLocations = history.entries.slice(1);

        var _oldLocation3 = history.replacedLocation && history.replacedLocation.location;

        poppedLocations.forEach(function (location) {
          _this4._visibleLocations["delete"](location);
        });

        if (_oldLocation3 != null) {
          this._slideNewOntoOld(_newLocation4, _oldLocation3);
        }
      } else if (action === "VIRTUAL_POP") {
        // A virtual pop occurs from a clearHistoryAndVirtualPopTo, so we need to
        // treat this just like a clearHistoryAndPush, but instead of sliding the
        // new view onto the old view, we slide the old view off of the new view.
        var _newLocation5 = history.entries[0];

        var _poppedLocations = history.entries.slice(1);

        var replacedLocation = history.replacedLocation && history.replacedLocation.location;

        var _oldLocations;

        if (replacedLocation != null) {
          _oldLocations = _poppedLocations.concat(replacedLocation);
        } else {
          _oldLocations = _poppedLocations;
        }

        this._slideOldsOffOfNew(_oldLocations, _newLocation5);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props = this.props,
          children = _this$props.children,
          history = _this$props.history;
      var action = history.computeEffectiveAction();
      var entries = history.entries;
      var entriesWithReplacedLocation = entries;

      if (history.replacedLocation != null && this._visibleLocations.has(history.replacedLocation.location)) {
        var _history$replacedLoca = history.replacedLocation,
            previousIndex = _history$replacedLoca.previousIndex,
            location = _history$replacedLoca.location; // We need to render the replaced location so that it's visible while we
        // slide the new location on top of it. So add it to entries.

        entriesWithReplacedLocation = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(entries);
        entriesWithReplacedLocation.splice(previousIndex - 1, 0, location);
      }

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"], null, entriesWithReplacedLocation.map(function (location, index) {
        var visible = _this5._visibleLocations.has(location);

        var zIndex = index;

        if (action === "CLEAR_HISTORY_AND_PUSH" && history.action === "REPLACE" && location === history.entries[0] // The new location
        ) {
            // The new location needs to be on top of everything else.
            zIndex = entriesWithReplacedLocation.length + 1;
          }

        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_PageTransition__["a" /* default */], {
          id: location.pathname,
          key: location.key,
          ref: function ref(inst) {
            if (inst != null) {
              _this5._pageTransitions.set(location, inst);
            }
          },
          style: {
            zIndex: visible ? zIndex : "",
            display: visible ? "" : "none"
          },
          initialInValue: visible
        }, visible ? __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Routing_SubMemoryRouter__["a" /* default */], {
          entries: entriesWithReplacedLocation,
          index: index
        }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](IgnoreUpdateWhenLeaving, {
          isLeaving: entries[history.index] !== location
        }, children)) : null);
      }));
    }
  }]);

  return HistoryPageTransitionController;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(HistoryPageTransitionController, "propTypes", {
  history: function history() {
    return (typeof NexiaHistory === "function" ? __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.instanceOf(NexiaHistory).isRequired : __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  children: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.node
});

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["g" /* withRouter */])(HistoryPageTransitionController));

// We don't care about updating the render tree for a Page which is leaving
// (and doing so is expensive for no benefit) so short-circuit renders at that
// level with shouldComponentUpdate.
var IgnoreUpdateWhenLeaving =
/*#__PURE__*/
function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(IgnoreUpdateWhenLeaving, _React$Component2);

  function IgnoreUpdateWhenLeaving() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, IgnoreUpdateWhenLeaving);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(IgnoreUpdateWhenLeaving).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(IgnoreUpdateWhenLeaving, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.isLeaving;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return IgnoreUpdateWhenLeaving;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(IgnoreUpdateWhenLeaving, "propTypes", {
  isLeaving: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.node.isRequired
});



/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_schema__ = __webpack_require__(52);

/* harmony default export */ __webpack_exports__["a"] = ({
  parseLinksEdit: function parseLinksEdit(links) {
    var link = _.first(links);

    if (link) {
      var SchemaClass = this.getEditSchemaClass();
      var schema = new SchemaClass(link.getData(), {
        parse: true
      });
      schema.parentModel = this; // so the edit schema can be used to delete its parent resource

      schema.setUrl(link.href);
      schema.setStoredOnServer(link.isPostLink());
      this._editSchema = schema;
    }
  },
  parseLinksTemplate: function parseLinksTemplate(links) {
    return this.parseLinksEdit(links);
  },
  createEditSchema: function createEditSchema() {
    if (this._editSchema) {
      return this._editSchema.prepare();
    } else {
      return Promise.reject(new Error("Attempted to create an edit schema for a model that had no edit link"));
    }
  },
  _createSchemaFromAttrs: function _createSchemaFromAttrs(attrs) {
    var SchemaClass = this.getEditSchemaClass();
    this._editSchema = new SchemaClass(attrs, {
      parse: true
    });
  },
  isEditable: function isEditable() {
    return Boolean(this._editSchema);
  },
  getEditSchemaClass: function getEditSchemaClass() {
    return __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_schema__["a" /* default */];
  }
});

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (prefixedValue, value, keepUnprefixed) {
  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
};

module.exports = exports["default"];

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CommonAppBar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommonAppBarContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_AppBar__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_TopBar_DrawerRevealer__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_TopBar_BackButton__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_TopBar_ModeSelector__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_TopBar_ResourceNameEditor__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_TopBar_ChoicesBannerContainer__ = __webpack_require__(1045);
















var CommonAppBar =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(CommonAppBar, _React$Component);

  function CommonAppBar() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CommonAppBar);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(CommonAppBar).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CommonAppBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          title = _this$props.title,
          isTitleEditable = _this$props.isTitleEditable,
          resourceHref = _this$props.resourceHref,
          onEditorEnd = _this$props.onEditorEnd,
          isLargeAppLayout = _this$props.isLargeAppLayout;
      var titleElement = isTitleEditable ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_TopBar_ResourceNameEditor__["a" /* default */], {
        initialValue: title,
        resourceHref: resourceHref,
        onEditEnd: onEditorEnd
      }) : title;

      var iconLeftForTopLevel = function iconLeftForTopLevel(isTopLevel) {
        if (isTopLevel) {
          return isLargeAppLayout ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_AppBar__["b" /* AppBarEmptyLeftIconPadding */], null) : __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_TopBar_DrawerRevealer__["b" /* default */], null);
        } else {
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_TopBar_BackButton__["b" /* default */], null);
        }
      };

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["c" /* Route */], {
        render: function render(_ref) {
          var history = _ref.history;
          var atTopOfHistory = history.index === 0 || history.index === 1 && history.replacedLocation != null && history.entries[0] === history.replacedLocation.location;
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_AppBar__["d" /* default */], {
            iconLeft: iconLeft === undefined ? iconLeftForTopLevel(atTopOfHistory) : iconLeft,
            title: titleElement,
            iconRight: iconRight
          }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_TopBar_ChoicesBannerContainer__["a" /* default */], null));
        }
      });
    }
  }]);

  return CommonAppBar;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(CommonAppBar, "propTypes", {
  iconLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  iconRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
  isTitleEditable: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  resourceHref: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  isLargeAppLayout: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
  onEditorEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(CommonAppBar, "defaultProps", {
  iconRight: __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_environment__["a" /* default */].isCommercial() ? null : __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_TopBar_ModeSelector__["a" /* default */], null)
});

var CommonAppBarContainer =
/*#__PURE__*/
function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(CommonAppBarContainer, _React$Component2);

  function CommonAppBarContainer() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CommonAppBarContainer);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(CommonAppBarContainer).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CommonAppBarContainer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          iconLeft = _this$props2.iconLeft,
          iconRight = _this$props2.iconRight,
          title = _this$props2.title,
          isTitleEditable = _this$props2.isTitleEditable,
          resourceHref = _this$props2.resourceHref,
          onEditorEnd = _this$props2.onEditorEnd;
      var isLargeAppLayout = this.context.isLargeAppLayout;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](CommonAppBar, {
        iconLeft: iconLeft,
        iconRight: iconRight,
        title: title,
        isTitleEditable: isTitleEditable,
        resourceHref: resourceHref,
        onEditorEnd: onEditorEnd,
        isLargeAppLayout: isLargeAppLayout
      });
    }
  }]);

  return CommonAppBarContainer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(CommonAppBarContainer, "propTypes", {
  iconLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  iconRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
  isTitleEditable: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  resourceHref: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onEditorEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(CommonAppBarContainer, "contextTypes", {
  isLargeAppLayout: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
});



/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_AppContainerBreakpointProvider__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Page__ = __webpack_require__(57);





var AppBarWrapper = function AppBarWrapper(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Page__["a" /* StaticSizedArea */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_nx_components_AppContainerBreakpointProvider__["a" /* default */], null, children));
};

AppBarWrapper.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (AppBarWrapper);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollableArea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_ScrollableDiv__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Scrollable_ScrollShadow__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



 // Page does not make its children scrollable by default because
// the children of Page need to be able to render `position: absolute`
// content (eg. FooterBar), and iOS has some long-standing bugs where absolutely
// positioned content within a scrollable container judders around,
// gets rendered completely wrong, doesn't get rendered... you name it.
//
// No other browser seems to have this issue. If you set
// `-webkit-overflow-scrolling: auto` on iOS, then everything works right,
// but you lose all momentum scrolling.
//
// The workaround is to not put absolutely positioned content within a
// scrollable container. Therefore, Page isn't scrollable by default.
//
// However, because it is very common to want to create Pages with
// scrollable content, this ScrollableArea component is provided; if you do
// the following:
//
// <Page>
//   <ScrollableArea>
//     {/* Your Stuff Goes Here */}
//   </ScrollableArea>
// </Page>
//
// You will probably get the behavior you want.
//
// If you need to make any absolutely positioned content in your Page,
// it *must not* be a child of your ScrollableArea (should be a sibling, etc).

var ScrollableArea =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(ScrollableArea, _React$Component);

  function ScrollableArea() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, ScrollableArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(ScrollableArea)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      div: null
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(ScrollableArea, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          style = _this$props.style,
          _captureRef = _this$props.captureRef,
          ignoreShadowSafeArea = _this$props.ignoreShadowSafeArea,
          otherProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["children", "style", "captureRef", "ignoreShadowSafeArea"]);

      var div = this.state.div;
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Scrollable_ScrollShadow__["a" /* default */], {
        target: div,
        ignoreSafeArea: ignoreShadowSafeArea
      }), __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_ScrollableDiv__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        style: _objectSpread({
          flex: "1 1 auto"
        }, style),
        captureRef: function captureRef(el) {
          _this2.setState({
            div: el
          });

          if (_captureRef != null) {
            _captureRef(el);
          }
        }
      }, otherProps), children));
    }
  }]);

  return ScrollableArea;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(ScrollableArea, "propTypes", {
  ignoreShadowSafeArea: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.node,
  captureRef: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func
});




/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QueryParams__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_Locales__ = __webpack_require__(44);





var UserAgent =
/*#__PURE__*/
function () {
  function UserAgent() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, UserAgent);

    this.value = window.navigator.userAgent.toLowerCase();
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(UserAgent, [{
    key: "hasString",
    value: function hasString(key) {
      return this.value.indexOf(key) !== -1;
    }
  }, {
    key: "isIOS",
    value: function isIOS() {
      return this.isIPhone() || this.isIPod() || this.isIPad();
    }
  }, {
    key: "isIPhone",
    value: function isIPhone() {
      return this.hasString("iphone");
    }
  }, {
    key: "isIPod",
    value: function isIPod() {
      return this.hasString("ipod");
    }
  }, {
    key: "isIPad",
    value: function isIPad() {
      return this.hasString("ipad");
    }
  }, {
    key: "isAndroid",
    value: function isAndroid() {
      return this.hasString("android");
    }
  }, {
    key: "isCrossWalk",
    value: function isCrossWalk() {
      return this.hasString("crosswalk");
    }
  }, {
    key: "getChromeVersion",
    value: function getChromeVersion() {
      var chromeVersionMatches = this.value.match(/chrome\/([\d.]+)/);
      return chromeVersionMatches ? chromeVersionMatches[1] : null;
    }
  }, {
    key: "isAndroidPhone",
    value: function isAndroidPhone() {
      return this.isAndroid() && this.hasString("mobile");
    }
  }, {
    key: "isAndroidTablet",
    value: function isAndroidTablet() {
      return this.isAndroid() && !this.hasString("mobile");
    }
  }, {
    key: "isBlackberry",
    value: function isBlackberry() {
      return this.hasString("blackberry") || this.hasString("bb10") || this.hasString("rim");
    }
  }, {
    key: "isBlackberryPhone",
    value: function isBlackberryPhone() {
      return this.isBlackberry() && !this.hasString("tablet");
    }
  }, {
    key: "isBlackberryTablet",
    value: function isBlackberryTablet() {
      return this.isBlackberry() && this.hasString("tablet");
    }
  }, {
    key: "isWindows",
    value: function isWindows() {
      return this.hasString("windows");
    }
  }, {
    key: "isWindowsPhone",
    value: function isWindowsPhone() {
      return this.isWindows() && this.hasString("phone");
    }
  }, {
    key: "isWindowsPhone81",
    value: function isWindowsPhone81() {
      return this.isWindowsPhone() && this.hasString("8.1");
    }
  }, {
    key: "isWindowsPhone10",
    value: function isWindowsPhone10() {
      return this.isWindowsPhone() && this.hasString("10.0");
    }
  }, {
    key: "isWindows10WebView",
    value: function isWindows10WebView() {
      return this.hasString("webview") && this.isWindows() && this.hasString("10.0");
    }
  }, {
    key: "isWindowsTablet",
    value: function isWindowsTablet() {
      return this.isWindows() && this.hasString("touch");
    }
  }, {
    key: "isInternetExplorer",
    value: function isInternetExplorer() {
      return this.hasString("msie") || this.hasString("trident/");
    }
  }, {
    key: "isEdge",
    value: function isEdge() {
      return this.hasString("edge");
    }
  }, {
    key: "isPhone",
    value: function isPhone() {
      return this.isAndroidPhone() || this.isIPhone() || this.isIPod() || this.isWindowsPhone() || this.isBlackberryPhone();
    }
  }, {
    key: "isTablet",
    value: function isTablet() {
      return this.isIPad() || this.isAndroidTablet() || this.isBlackberryTablet() || this.isWindowsTablet();
    }
  }, {
    key: "webViewDescription",
    value: function webViewDescription() {
      var localeSet = Object(__WEBPACK_IMPORTED_MODULE_3_nx_components_Locales__["b" /* getLanguageSet */])();
      var language = localeSet.nexia_mobile.UserAgent;
      var webViewDescription = "";

      if (this.isAndroid()) {
        webViewDescription = "".concat(language.chromeVersion, ": ");
        webViewDescription += this.getChromeVersion() || language.unknownVersion;

        if (this.isCrossWalk()) {
          var nbsp = String.fromCharCode(160);
          webViewDescription += nbsp;
          webViewDescription += "(Crosswalk)";
        }
      } else if (this.isIOS()) {
        var platformParam = __WEBPACK_IMPORTED_MODULE_2__QueryParams__["a" /* default */].platform();

        if (platformParam === "ios-uiwebview") {
          webViewDescription = "".concat(language.webView, ": UIWebView");
        } else if (platformParam === "ios-wkwebview") {
          webViewDescription = "".concat(language.webView, ": WKWebView");
        }
      }

      return webViewDescription;
    }
  }, {
    key: "hasPassiveEventListeners",
    value: function hasPassiveEventListeners() {
      if (this._passiveSupported != null) {
        return this._passiveSupported;
      } // Test for the "passive" options for event listeners (iOS 10+, etc)
      // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener


      this._passiveSupported = false;

      try {
        // $FlowIgnore: defineProperty is poorly typed in core.
        var options = Object.defineProperty({}, "passive", {
          get: function get() {
            this._passiveSupported = true;
          }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
      } catch (err) {
        this._passiveSupported = false;
      }

      return this._passiveSupported;
    }
  }]);

  return UserAgent;
}();

/* harmony default export */ __webpack_exports__["a"] = (new UserAgent());

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_backstage__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_url__ = __webpack_require__(73);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var getBackstagePollingPath = function getBackstagePollingPath(response) {
  if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(response) !== "object" || response == null) {
    // response is not an object
    return null;
  }

  if (typeof response.polling_path === "string") {
    // response is a BackstageUrl
    return response.polling_path;
  }

  if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(response.result) === "object" && response.result != null && typeof response.result.polling_path === "string") {
    // response is a ServerResponse<BackstageUrl>
    return response.result.polling_path;
  }

  return null;
};

var ajaxWithBackstageSupport = function ajaxWithBackstageSupport(options, link) {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3_backbone___default.a.ajax(options).then(function (response) {
      var pollingPath = getBackstagePollingPath(response);

      if (pollingPath) {
        new __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_backstage__["a" /* default */](pollingPath, {
          success: function success(data) {
            // TODO: Why is this data.options || data? The server should
            // always respond with a BackstageResponse of some
            // sort; are we ever *not* receiving a BackstageResponse here?
            resolve(data.options || data);
          },
          error: function error(errors, xhr) {
            reject(Object.assign(xhr, {
              serverErrors: errors
            }));
          },
          maxRequestsCount: options.maxRequestsCount,
          maxRequestsReached: options.maxRequestsReached
        }).startPolling();
      } else {
        resolve(response);
      }
    }, function (xhr) {
      reject(xhr);
    });
  });
};

function followLink(model, link, passedOptions) {
  var dataForURITemplate;

  if (link.templated) {
    if (passedOptions.data != null && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(passedOptions.data) === "object") {
      dataForURITemplate = passedOptions.data;
    }

    if (dataForURITemplate == null) {
      if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(model) === "object" && model != null) {
        // Flow points out here that a model's attributes might contain
        // properties which aren't in the URI template. That's true, but that's
        // how the app works. Not gonna try to fix it right now
        // $FlowIgnore
        dataForURITemplate = model.attributes;
      } else {
        throw new Error("Attempted to follow a templated link without any data with which " + "to expand the template");
      }
    }
  }

  var passedData = passedOptions.data,
      restOfPassedOptions = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(passedOptions, ["data"]);

  var parsedData = "";

  if (typeof passedData === "string") {
    parsedData = passedData;
  } else if (passedData) {
    parsedData = JSON.stringify(passedData);
  }

  var options = _objectSpread({
    // Ajax Option Defaults
    data: parsedData,
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    method: "POST",
    // default unless overridden by link.method
    // Backbone Option Defaults
    maxRequestsCount: 60,
    // followLink-specific option defaults
    fetchModelWhenDone: false,
    updateModelWithResponse: false,
    silent: false
  }, restOfPassedOptions, {}, link.method && {
    method: link.method
  }, {
    url: link.templated ? __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_url__["a" /* default */].expandTemplate(link.href, dataForURITemplate) : link.href
  });

  var trigger = function trigger() {
    if (!options.silent && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(model) === "object" && model != null) {
      model.trigger.apply(model, arguments);
    }
  };

  return new Promise(function (resolve, reject) {
    trigger("request", model, {}, options);
    Object(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_dispatch__["a" /* default */])("DISABLE_LOCATION_POLLING");

    var finishWithError = function finishWithError(xhr) {
      trigger("error", model, xhr, options);
      Object(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
      reject();
    };

    var finishWithData = function finishWithData(data) {
      var parsedResponseData = (data || {}).result || data;
      trigger("sync", model, parsedResponseData, options);
      Object(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
      resolve(parsedResponseData);
    };

    var finishWithFetch = function finishWithFetch() {
      if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(model) === "object" && model != null) {
        model.fetch().then(finishWithData, finishWithError);
      } else {
        throw new Error("Attempted to fetch model after following link (due to received " + "fetchModelWhenDone option), but fetchLink was not called with a " + "model.");
      }
    };

    ajaxWithBackstageSupport(options, link).then(function (data) {
      if (options.fetchModelWhenDone) {
        finishWithFetch();
      } else {
        if (options.updateModelWithResponse) {
          if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(model) === "object" && model != null) {
            model.set(model.parse(data));
          } else {
            throw new Error("Attempted to update model with response data after following " + "link (due to received updateModelWithResponse option), but " + "fetchLink was not called with a model.");
          }
        }

        finishWithData(data);
      }
    }, function (xhr) {
      finishWithError(xhr);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (followLink);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_raven_js__);











var ErrorHandler =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ErrorHandler, _React$Component);

  function ErrorHandler() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ErrorHandler);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ErrorHandler)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      error: false
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ErrorHandler, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      console.error(error);
      __WEBPACK_IMPORTED_MODULE_9_raven_js___default.a.captureException(error);
      this.setState({
        error: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.error) {
        return this.props.fallback;
      } else {
        return this.props.children;
      }
    }
  }]);

  return ErrorHandler;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ErrorHandler, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.element,
  fallback: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.element
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ErrorHandler, "defaultProps", {
  fallback: null
});



/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(112)('meta');
var isObject = __webpack_require__(26);
var has = __webpack_require__(60);
var setDesc = __webpack_require__(38).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(25)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(29)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(54)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Slider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SliderContainer__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Handle__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var Slider =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Slider, _React$Component);

  function Slider() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Slider);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Slider).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Slider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          sliderContainerProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["style"]);

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "Slider",
        style: _objectSpread({
          paddingRight: __WEBPACK_IMPORTED_MODULE_9__Handle__["a" /* HANDLE_SIZE */] / 2,
          paddingLeft: __WEBPACK_IMPORTED_MODULE_9__Handle__["a" /* HANDLE_SIZE */] / 2
        }, style)
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__SliderContainer__["a" /* default */], sliderContainerProps));
    }
  }]);

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Slider, "propTypes", {
  hasOffState: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,
  formatValue: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  showValueAboveHandle: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,
  step: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number.isRequired,
  max: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  onDragStart: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  onDragEnd: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  tooltipStyle: function tooltipStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  isHeat: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,
  isCool: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  }
});





/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DialogBackground__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__BackButtonResponder__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MountOnBody__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__NoStyleButton__ = __webpack_require__(47);
/* unused harmony reexport DialogBackground */








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var styles = {
  root: Object(__WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["b" /* default */])({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%"
  }),
  closeButtonWrapper: {
    position: "absolute",
    top: "-1.5em",
    right: "-1.5em",
    fontSize: "0.5em",
    padding: "1em",
    // increased click area
    cursor: "pointer"
  },
  closeIcon: {
    fontSize: "0.5em"
  }
};

var Dialog =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Dialog, _React$Component);

  function Dialog() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Dialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Dialog)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleBackButtonPressed", function () {
      var onRequestClose = _this.props.onRequestClose;

      if (onRequestClose != null) {
        onRequestClose();
        return {
          handled: true
        };
      } else {
        return {
          handled: false
        };
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Dialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.noFocusOnOpen && this.props.open) {
        this._focus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!this.props.noFocusOnOpen && this.props.open && !prevProps.open) {
        this._focus();
      }
    }
  }, {
    key: "_focus",
    value: function _focus() {
      var _this2 = this;

      // Buttons that opened Dialogs were becoming the active element instead of
      // the child wrapper. By delaying our focus call, this seems to be fixed.
      setTimeout(function () {
        if (_this2._childWrapper != null) {
          _this2._childWrapper.focus();
        }
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          style = _this$props.style,
          onTapBackground = _this$props.onTapBackground,
          open = _this$props.open,
          docked = _this$props.docked,
          noCloseButton = _this$props.noCloseButton;

      var childWrapperStyle = _objectSpread({
        position: "relative",
        // closeButton is relative to this div
        boxShadow: "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.4)",
        backgroundColor: "white"
      }, docked && {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0
      }, {
        zIndex: __WEBPACK_IMPORTED_MODULE_11__Theme__["a" /* default */].zIndexLayers.MODAL
      }, style);

      return open ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__MountOnBody__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.root,
        "data-component-section": "dialog-root"
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__BackButtonResponder__["b" /* default */], {
        onPressed: this._handleBackButtonPressed
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__DialogBackground__["a" /* default */], {
        open: true,
        onTap: onTapBackground,
        "aria-label": "Close dialog"
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "Dialog",
        style: childWrapperStyle,
        tabIndex: "-1",
        ref: function ref(el) {
          return _this3._childWrapper = el;
        }
      }, children, !noCloseButton && onTapBackground && !docked ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Tappable__["b" /* default */], {
        onTap: onTapBackground
      }, function (_ref) {
        var active = _ref.active,
            tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__NoStyleButton__["a" /* default */], {
          style: styles.closeButtonWrapper,
          innerRef: tapTargetRefHandler,
          "aria-label": "close dialog"
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Button__["a" /* default */], {
          theme: "round",
          forceActiveStyling: active
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Icons__["D" /* IconClose */], {
          style: styles.closeIcon
        })));
      }) : null))) : null;
    }
  }]);

  return Dialog;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Dialog, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  onTapBackground: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  docked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  noCloseButton: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onRequestClose: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  noFocusOnOpen: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});




/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return valuePropType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bpfrpt_proptype_valueType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bpfrpt_proptype_Option; });
/* unused harmony export bpfrpt_proptype_Props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Dialog__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ItemList__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ScrollableDiv__ = __webpack_require__(130);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var bpfrpt_proptype_valueType = __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool]);
var valuePropType = __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool]);
var bpfrpt_proptype_Option = {
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number]),
  value: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool]).isRequired,
  label: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
  // I was unable to get generics working with this. If you *need* your label to be a string, just manipulate the type inline
  isPivot: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onTap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  header: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  info: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};
var bpfrpt_proptype_Props = {
  options: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number]),
    value: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool]).isRequired,
    label: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
    isPivot: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onTap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    header: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    info: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
  }).isRequired).isRequired,
  value: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool]),
  onOptionTapped: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onBackgroundTapped: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onRequestClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
};

var SelectDialog =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(SelectDialog, _React$Component);

  function SelectDialog() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SelectDialog);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SelectDialog).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SelectDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          options = _this$props.options,
          value = _this$props.value,
          onOptionTapped = _this$props.onOptionTapped,
          onBackgroundTapped = _this$props.onBackgroundTapped,
          onRequestClose = _this$props.onRequestClose,
          open = _this$props.open,
          colors = _this$props.colors;
      var styles = {
        dialog: {
          minWidth: "10em",
          maxWidth: "90vw",
          maxHeight: "75vh"
        },
        item: {
          padding: "0 1em"
        }
      };
      var containsHeader = options.find(function (option) {
        return Boolean(option.header);
      });

      var optionStyle = function optionStyle(option) {
        var isHeader = Boolean(option.header);
        var isInfo = Boolean(option.info);
        var isSelectAll = value === "Select All";
        var isSelectedValue = value === option.value;
        return _objectSpread({}, styles.item, {}, isSelectedValue ? {
          color: colors.PRIMARY,
          backgroundColor: "#f3f3f3"
        } : null, {}, containsHeader && isSelectAll ? {
          paddingLeft: ".5em"
        } : null, {}, containsHeader && isHeader ? {
          fontWeight: "bold",
          fontSize: ".8em"
        } : null, {}, isInfo ? {
          fontSize: ".8em"
        } : null, {}, containsHeader && !isHeader && !isInfo ? {
          paddingLeft: "1.5em"
        } : null);
      };

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Dialog__["a" /* default */], {
        open: open,
        onTapBackground: onBackgroundTapped,
        onRequestClose: onRequestClose
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ScrollableDiv__["a" /* default */], {
        style: styles.dialog
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ItemList__["c" /* default */], {
        id: "select-options",
        items: options.map(function (option, index) {
          return {
            id: option.id || "".concat(index),
            label: option.label,
            style: _objectSpread({}, optionStyle(option)),
            onTap: option.header || option.info ? null : option.onTap || function () {
              return onOptionTapped && onOptionTapped(option);
            }
          };
        })
      })));
    }
  }]);

  return SelectDialog;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(SelectDialog, "defaultProps", {
  options: []
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(SelectDialog, "propTypes", {
  options: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number]),
    value: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool]).isRequired,
    label: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
    isPivot: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onTap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    header: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    info: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
  }).isRequired),
  value: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool]),
  onOptionTapped: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onBackgroundTapped: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onRequestClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["c" /* withColorsProvider */])(SelectDialog));






/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export adjustHue */
/* unused harmony export animation */
/* unused harmony export backgroundImages */
/* unused harmony export backgrounds */
/* unused harmony export borderColor */
/* unused harmony export borderRadius */
/* unused harmony export borderStyle */
/* unused harmony export borderWidth */
/* unused harmony export buttons */
/* unused harmony export clearFix */
/* unused harmony export complement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curriedDarken; });
/* unused harmony export desaturate */
/* unused harmony export directionalProperty */
/* unused harmony export ellipsis */
/* unused harmony export em */
/* unused harmony export fontFace */
/* unused harmony export getLuminance */
/* unused harmony export grayscale */
/* unused harmony export invert */
/* unused harmony export hideText */
/* unused harmony export hideVisually */
/* unused harmony export hiDPI */
/* unused harmony export hsl */
/* unused harmony export hsla */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return curriedLighten; });
/* unused harmony export margin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return curriedMix; });
/* unused harmony export modularScale */
/* unused harmony export normalize */
/* unused harmony export opacify */
/* unused harmony export padding */
/* unused harmony export parseToHsl */
/* unused harmony export parseToRgb */
/* unused harmony export placeholder */
/* unused harmony export position */
/* unused harmony export radialGradient */
/* unused harmony export readableColor */
/* unused harmony export rem */
/* unused harmony export retinaImage */
/* unused harmony export rgb */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return rgba; });
/* unused harmony export saturate */
/* unused harmony export selection */
/* unused harmony export setHue */
/* unused harmony export setLightness */
/* unused harmony export setSaturation */
/* unused harmony export shade */
/* unused harmony export size */
/* unused harmony export stripUnit */
/* unused harmony export textInputs */
/* unused harmony export timingFunctions */
/* unused harmony export tint */
/* unused harmony export toColorString */
/* unused harmony export transitions */
/* unused harmony export transparentize */
/* unused harmony export triangle */
/* unused harmony export wordWrap */
//      

// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

//      
var positionMap = ['Top', 'Right', 'Bottom', 'Left'];

function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');
  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return '' + acc + capitalizeString(val);
    });
  }
  var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
  return property === joinedProperty ? '' + property + position : joinedProperty;
}

function generateStyles(property, valuesWithDefaults) {
  var styles = {};
  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
    }
  }
  return styles;
}

/**
 * A helper that enables shorthand for direction based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */

function directionalProperty(property) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  //  prettier-ignore
  var firstValue = values[0],
      _values$ = values[1],
      secondValue = _values$ === undefined ? firstValue : _values$,
      _values$2 = values[2],
      thirdValue = _values$2 === undefined ? firstValue : _values$2,
      _values$3 = values[3],
      fourthValue = _values$3 === undefined ? secondValue : _values$3;

  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

//      

function endsWith (string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

//      

/**
 * Strip the unit from a given CSS value, returning just the number. (or the original value if an invalid string was passed)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */

function stripUnit(value) {
  var unitlessValue = parseFloat(value);
  if (isNaN(unitlessValue)) return value;
  return unitlessValue;
}

//      

/**
 * Factory function that creates pixel-to-x converters
 * @private
 */
var pxtoFactory = function pxtoFactory(to) {
  return function (pxval) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';

    var newPxval = pxval;
    var newBase = base;
    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
      }
      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
      }
      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }

    if (typeof newBase === 'string') {
      throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }

    return '' + newPxval / newBase + to;
  };
};

//      
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */

var em = /*#__PURE__*/pxtoFactory('em');

//      

var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4

  /** */

  /**
   * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables, see below.
   * @example
   * // Styles as object usage
   * const styles = {
   *    // Increment two steps up the default scale
   *   'fontSize': modularScale(2)
   * }
   *
   * // styled-components usage
   * const div = styled.div`
   *    // Increment two steps up the default scale
   *   fontSize: ${modularScale(2)}
   * `
   *
   * // CSS in JS Output
   *
   * element {
   *   'fontSize': '1.77689em'
   * }
   */
};function modularScale(steps) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
  var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';

  if (typeof steps !== 'number') {
    throw new Error('Please provide a number of steps to the modularScale helper.');
  }
  if (typeof ratio === 'string' && !ratioNames[ratio]) {
    throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
  }

  var realBase = typeof base === 'string' ? stripUnit(base) : base;
  var realRatio = typeof ratio === 'string' ? ratioNames[ratio] : ratio;

  if (typeof realBase === 'string') {
    throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
  }

  return realBase * Math.pow(realRatio, steps) + 'em';
}

//      

/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */

var rem = /*#__PURE__*/pxtoFactory('rem');

//      

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */

function clearFix() {
  var _ref;

  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';

  var pseudoSelector = parent + '::after';
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

//      

/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */

function ellipsis() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';

  return {
    display: 'inline-block',
    maxWidth: width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
}

//      

/** */

function generateFileReferences(fontFilePath, fileFormats) {
  var fileFontReferences = fileFormats.map(function (format) {
    return 'url("' + fontFilePath + '.' + format + '")';
  });
  return fileFontReferences.join(', ');
}

function generateLocalReferences(localFonts) {
  var localFontReferences = localFonts.map(function (font) {
    return 'local("' + font + '")';
  });
  return localFontReferences.join(', ');
}

function generateSources(fontFilePath, localFonts, fileFormats) {
  var fontReferences = [];
  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));
  if (fontFilePath) {
    fontReferences.push(generateFileReferences(fontFilePath, fileFormats));
  }
  return fontReferences.join(', ');
}

/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro'
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * injectGlobal`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro'
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */

function fontFace(_ref) {
  var fontFamily = _ref.fontFamily,
      fontFilePath = _ref.fontFilePath,
      fontStretch = _ref.fontStretch,
      fontStyle = _ref.fontStyle,
      fontVariant = _ref.fontVariant,
      fontWeight = _ref.fontWeight,
      _ref$fileFormats = _ref.fileFormats,
      fileFormats = _ref$fileFormats === undefined ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
      localFonts = _ref.localFonts,
      unicodeRange = _ref.unicodeRange;

  // Error Handling
  if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
  if (!fontFilePath && !localFonts) {
    throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
  }
  if (localFonts && !Array.isArray(localFonts)) {
    throw new Error('fontFace expects localFonts to be an array.');
  }
  if (!Array.isArray(fileFormats)) {
    throw new Error('fontFace expects fileFormats to be an array.');
  }

  var fontFaceDeclaration = {
    '@font-face': {
      fontFamily: fontFamily,
      src: generateSources(fontFilePath, localFonts, fileFormats),
      unicodeRange: unicodeRange,
      fontStretch: fontStretch,
      fontStyle: fontStyle,
      fontVariant: fontVariant,
      fontWeight: fontWeight
    }

    // Removes undefined fields for cleaner css object.
  };return JSON.parse(JSON.stringify(fontFaceDeclaration));
}

//      

/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */

function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

//      

/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */

function hideVisually() {
  return {
    border: '0',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };
}

//      

/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */

function hiDPI() {
  var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;

  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



























var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var _opinionatedRules;
var _abbrTitle;
var _unopinionatedRules;

//      
var opinionatedRules = (_opinionatedRules = {
  html: {
    fontFamily: 'sans-serif'
  },

  body: {
    margin: '0'
  }

}, _opinionatedRules['a:active,\n  a:hover'] = {
  outlineWidth: '0'
}, _opinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
  fontFamily: 'sans-serif',
  fontSize: '100%',
  lineHeight: '1.15'
}, _opinionatedRules);

var unopinionatedRules = (_unopinionatedRules = {
  html: {
    lineHeight: '1.15',
    textSizeAdjust: '100%'
  }

}, _unopinionatedRules['article,\n  aside,\n  footer,\n  header,\n  nav,\n  section'] = {
  display: 'block'
}, _unopinionatedRules.h1 = {
  fontSize: '2em',
  margin: '0.67em 0'
}, _unopinionatedRules['figcaption,\n  figure,\n  main'] = {
  display: 'block'
}, _unopinionatedRules.figure = {
  margin: '1em 40px'
}, _unopinionatedRules.hr = {
  boxSizing: 'content-box',
  height: '0',
  overflow: 'visible'
}, _unopinionatedRules.pre = {
  fontFamily: 'monospace, monospace',
  fontSize: '1em'
}, _unopinionatedRules.a = {
  'background-color': 'transparent',
  '-webkit-text-decoration-skip': 'objects'
}, _unopinionatedRules['abbr[title]'] = (_abbrTitle = {
  borderBottom: 'none',
  textDecoration: 'underline'
}, _abbrTitle['textDecoration'] = 'underline dotted', _abbrTitle), _unopinionatedRules['b,\n  strong'] = {
  fontWeight: 'inherit'
}, _unopinionatedRules['code,\n  kbd,\n  samp'] = {
  fontFamily: 'monospace, monospace',
  fontSize: '1em'
}, _unopinionatedRules.dfn = {
  fontStyle: 'italic'
}, _unopinionatedRules.mark = {
  backgroundColor: '#ff0',
  color: '#000'
}, _unopinionatedRules.small = {
  fontSize: '80%'
}, _unopinionatedRules['sub,\n  sup'] = {
  fontSize: '75%',
  lineHeight: '0',
  position: 'relative',
  verticalAlign: 'baseline'
}, _unopinionatedRules.sub = {
  bottom: '-0.25em'
}, _unopinionatedRules.sup = {
  top: '-0.5em'
}, _unopinionatedRules['audio,\n  video'] = {
  display: 'inline-block'
}, _unopinionatedRules['audio:not([controls])'] = {
  display: 'none',
  height: '0'
}, _unopinionatedRules.img = {
  borderStyle: 'none'
}, _unopinionatedRules['svg:not(:root)'] = {
  overflow: 'hidden'
}, _unopinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
  margin: '0'
}, _unopinionatedRules['button,\n  input'] = {
  overflow: 'visible'
}, _unopinionatedRules['button,\n  select'] = {
  textTransform: 'none'
}, _unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
  '-webkit-appearance': 'button'
}, _unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
  borderStyle: 'none',
  padding: '0'
}, _unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
  outline: '1px dotted ButtonText'
}, _unopinionatedRules.fieldset = {
  border: '1px solid #c0c0c0',
  margin: '0 2px',
  padding: '0.35em 0.625em 0.75em'
}, _unopinionatedRules.legend = {
  boxSizing: 'border-box',
  color: 'inherit',
  display: 'table',
  maxWidth: '100%',
  padding: '0',
  whiteSpace: 'normal'
}, _unopinionatedRules.progress = {
  display: 'inline-block',
  verticalAlign: 'baseline'
}, _unopinionatedRules.textarea = {
  overflow: 'auto'
}, _unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
  boxSizing: 'border-box',
  padding: '0'
}, _unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
  height: 'auto'
}, _unopinionatedRules['[type="search"]'] = {
  '-webkit-appearance': 'textfield',
  outlineOffset: '-2px'
}, _unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
  '-webkit-appearance': 'none'
}, _unopinionatedRules['::-webkit-file-upload-button'] = {
  '-webkit-appearance': 'button',
  font: 'inherit'
}, _unopinionatedRules['details,\n  menu'] = {
  display: 'block'
}, _unopinionatedRules.summary = {
  display: 'list-item'
}, _unopinionatedRules.canvas = {
  display: 'inline-block'
}, _unopinionatedRules.template = {
  display: 'none'
}, _unopinionatedRules['[hidden]'] = {
  display: 'none'
}, _unopinionatedRules);

function mergeRules(baseRules, additionalRules) {
  var mergedRules = _extends({}, baseRules);
  Object.keys(additionalRules).forEach(function (key) {
    if (mergedRules[key]) {
      mergedRules[key] = _extends({}, mergedRules[key], additionalRules[key]);
    } else {
      mergedRules[key] = _extends({}, additionalRules[key]);
    }
  });
  return mergedRules;
}

/**
 * CSS to normalize abnormalities across browsers (normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * injectGlobal`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   fontFamily: 'sans-serif',
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize(excludeOpinionated) {
  if (excludeOpinionated) return unopinionatedRules;
  return mergeRules(unopinionatedRules, opinionatedRules);
}

//      

/**
 * CSS to style the placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */

function placeholder(styles) {
  var _ref;

  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';

  return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = _extends({}, styles), _ref[parent + ':-moz-placeholder'] = _extends({}, styles), _ref[parent + '::-moz-placeholder'] = _extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = _extends({}, styles), _ref;
}

var _templateObject = /*#__PURE__*/ taggedTemplateLiteralLoose(['radial-gradient(', '', '', '', ')'], ['radial-gradient(', '', '', '', ')']);

//      

/** */

function parseFallback(colorStops) {
  return colorStops[0].split(' ')[0];
}

function constructGradientValue(literals) {
  var template = '';
  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i];
    // Adds leading coma if properties preceed color-stops
    if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
      template = template.slice(0, -1);
      template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
      // No trailing space if color-stops is the only param provided
    } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) {
      template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
      // Only adds substitution if it is defined
    } else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) {
      template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
    }
  }
  return template.trim();
}

/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */

function radialGradient(_ref) {
  var colorStops = _ref.colorStops,
      extent = _ref.extent,
      fallback = _ref.fallback,
      position = _ref.position,
      shape = _ref.shape;

  if (!colorStops || colorStops.length < 2) {
    throw new Error('radialGradient requries at least 2 color-stops to properly render.');
  }
  return {
    backgroundColor: fallback || parseFallback(colorStops),
    backgroundImage: constructGradientValue(_templateObject, position, shape, extent, colorStops.join(', '))
  };
}

//      

/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */
function retinaImage(filename, backgroundSize) {
  var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';

  var _ref;

  var retinaFilename = arguments[3];
  var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';

  if (!filename) {
    throw new Error('Please supply a filename to retinaImage() as the first argument.');
  }
  // Replace the dot at the beginning of the passed extension if one exists
  var ext = extension.replace(/^\./, '');
  var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;

  return _ref = {
    backgroundImage: 'url(' + filename + '.' + ext + ')'
  }, _ref[hiDPI()] = {
    backgroundImage: 'url(' + rFilename + ')',
    backgroundSize: backgroundSize
  }, _ref;
}

//      

/**
 * CSS to style the selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */

function selection(styles) {
  var _ref;

  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return _ref = {}, _ref[parent + '::-moz-selection'] = _extends({}, styles), _ref[parent + '::selection'] = _extends({}, styles), _ref;
}

//      

/* eslint-disable key-spacing */
var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',

  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',

  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
  /* eslint-enable key-spacing */

  /** */

  /**
   * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
   *
   * @example
   * // Styles as object usage
   * const styles = {
   *   'transitionTimingFunction': timingFunctions('easeInQuad')
   * }
   *
   * // styled-components usage
   *  const div = styled.div`
   *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
   * `
   *
   * // CSS as JS Output
   *
   * 'div': {
   *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
   * }
   */

};function timingFunctions(timingFunction) {
  return functionsMap[timingFunction];
}

//      

/** */

var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
  switch (pointingDirection) {
    case 'top':
      return '0 ' + width / 2 + 'px ' + height + 'px ' + width / 2 + 'px';
    case 'left':
      return height / 2 + 'px ' + width + 'px ' + height / 2 + 'px 0';
    case 'bottom':
      return height + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px';
    case 'right':
      return height / 2 + 'px 0 ' + height / 2 + 'px ' + width + 'px';

    default:
      throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
  }
};

// needed for border-color
var reverseDirection = {
  left: 'Right',
  right: 'Left',
  top: 'Bottom',
  bottom: 'Top'

  /**
   * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
   *
   * @example
   * // Styles as object usage
   *
   * const styles = {
   *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
   * }
   *
   *
   * // styled-components usage
   * const div = styled.div`
   *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
   *
   *
   * // CSS as JS Output
   *
   * div: {
   *  'borderColor': 'transparent',
   *  'borderLeftColor': 'red !important',
   *  'borderStyle': 'solid',
   *  'borderWidth': '50px 0 50px 100px',
   *  'height': '0',
   *  'width': '0',
   * }
   */

};function triangle(_ref) {
  var _ref2;

  var pointingDirection = _ref.pointingDirection,
      height = _ref.height,
      width = _ref.width,
      foregroundColor = _ref.foregroundColor,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;

  var unitlessHeight = parseFloat(height);
  var unitlessWidth = parseFloat(width);
  if (isNaN(unitlessHeight) || isNaN(unitlessWidth)) {
    throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
  }

  return _ref2 = {
    borderColor: backgroundColor,
    width: '0',
    height: '0',
    borderWidth: getBorderWidth(pointingDirection, unitlessHeight, unitlessWidth),
    borderStyle: 'solid'
  }, _ref2['border' + reverseDirection[pointingDirection] + 'Color'] = foregroundColor + ' !important', _ref2;
}

//      

/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */

function wordWrap() {
  var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';

  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
  return {
    overflowWrap: wrap,
    wordWrap: wrap,
    wordBreak: wordBreak
  };
}

//      


function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness) {
  var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : convertToInt;

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  }

  // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
  var huePrime = hue % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));

  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

//      
var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'

  /**
   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
   * @private
   */
};function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? '#' + namedColorMap[normalizedColorName] : color;
}

//      
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;

/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */
function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt('' + rgbMatched[1], 10),
      green: parseInt('' + rgbMatched[2], 10),
      blue: parseInt('' + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor);
  if (rgbaMatched) {
    return {
      red: parseInt('' + rgbaMatched[1], 10),
      green: parseInt('' + rgbaMatched[2], 10),
      blue: parseInt('' + rgbaMatched[3], 10),
      alpha: parseFloat('' + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt('' + hslMatched[1], 10);
    var saturation = parseInt('' + hslMatched[2], 10) / 100;
    var lightness = parseInt('' + hslMatched[3], 10) / 100;
    var rgbColorString = 'rgb(' + hslToRgb(hue, saturation, lightness) + ')';
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + rgbColorString + '.');
    }
    return {
      red: parseInt('' + hslRgbMatched[1], 10),
      green: parseInt('' + hslRgbMatched[2], 10),
      blue: parseInt('' + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor);
  if (hslaMatched) {
    var _hue = parseInt('' + hslaMatched[1], 10);
    var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
    var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
    var _rgbColorString = 'rgb(' + hslToRgb(_hue, _saturation, _lightness) + ')';
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + _rgbColorString + '.');
    }
    return {
      red: parseInt('' + _hslRgbMatched[1], 10),
      green: parseInt('' + _hslRgbMatched[2], 10),
      blue: parseInt('' + _hslRgbMatched[3], 10),
      alpha: parseFloat('' + hslaMatched[4])
    };
  }
  throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}

//      


function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;

  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return { hue: 0, saturation: 0, lightness: lightness };
    }
  }

  var hue = void 0;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue = (blue - red) / delta + 2;
      break;
    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;
  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }
  return { hue: hue, saturation: saturation, lightness: lightness };
}

//      

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

//      

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};

//      
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue('#' + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue('#' + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
  }

  throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}

//      
function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue('#' + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : 'rgba(' + hslToRgb(value, saturation, lightness) + ',' + alpha + ')';
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : 'rgba(' + hslToRgb(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
  }

  throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}

//      
var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};

var errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';

/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */

function toColorString(color) {
  if (typeof color !== 'object') throw new Error(errMsg);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);

  throw new Error(errMsg);
}

//      

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js


// eslint-disable-next-line no-unused-vars


// eslint-disable-next-line no-unused-vars

// eslint-disable-next-line no-redeclare


function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
}

// eslint-disable-next-line no-redeclare
function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

//      

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue(180, 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue(180, 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */
function adjustHue(degree, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + degree) % 360
  }));
}

var curriedAdjustHue = /*#__PURE__*/curry(adjustHue);

//      

/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function complement(color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + 180) % 360
  }));
}

//      

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

//      

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken(0.2, 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken(0.2, 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */
function darken(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - amount)
  }));
}

var curriedDarken = /*#__PURE__*/curry(darken);

//      

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */
function desaturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - amount)
  }));
}

var curriedDesaturate = /*#__PURE__*/curry(desaturate);

//      
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */
function getLuminance(color) {
  var rgbColor = parseToRgb(color);

  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      r = _Object$keys$map[0],
      g = _Object$keys$map[1],
      b = _Object$keys$map[2];

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

//      

/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function grayscale(color) {
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: 0
  }));
}

//      

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */
function invert(color) {
  // parse color string to rgb
  var value = parseToRgb(color);
  return toColorString(_extends({}, value, {
    red: 255 - value.red,
    green: 255 - value.green,
    blue: 255 - value.blue
  }));
}

//      

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */
function lighten(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + amount)
  }));
}

var curriedLighten = /*#__PURE__*/curry(lighten);

//      

/**
 * Mixes two colors together by calculating the average of each of the RGB components.
 *
 * By default the weight is 0.5 meaning that half of the first color and half the second
 * color should be used. Optionally the weight can be modified by providing a number
 * as the first argument. 0.25 means that a quarter of the first color and three quarters
 * of the second color should be used.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */
function mix() {
  var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
  var color = arguments[1];
  var otherColor = arguments[2];

  var parsedColor1 = parseToRgb(color);
  var color1 = _extends({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = parseToRgb(otherColor);
  var color2 = _extends({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1

    // The formular is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
  });var alphaDelta = color1.alpha - color2.alpha;
  var x = weight * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;

  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha + (color2.alpha - color1.alpha) * (weight / 1.0)
  };

  return rgba(mixedColor);
}

var curriedMix = /*#__PURE__*/curry(mix);

//      
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify(0.5, 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify(0.5, 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */
function opacify(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + amount * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

var curriedOpacify = /*#__PURE__*/curry(opacify);

//      
/**
 * Selects black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */

function readableColor(color) {
  return getLuminance(color) > 0.179 ? '#000' : '#fff';
}

var curriedReadableColor = /*#__PURE__*/curry(readableColor);

//      

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */
function saturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + amount)
  }));
}

var curriedSaturate = /*#__PURE__*/curry(saturate);

//      

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue(244, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue(244, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */
function setHue(hue, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    hue: hue
  }));
}

var curriedSetHue = /*#__PURE__*/curry(setHue);

//      

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */
function setLightness(lightness, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    lightness: lightness
  }));
}

var curriedSetLightness = /*#__PURE__*/curry(setLightness);

//      

/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */
function setSaturation(saturation, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: saturation
  }));
}

var curriedSetSaturation = /*#__PURE__*/curry(setSaturation);

//      

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
    throw new Error('Passed an incorrect argument to shade, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
  }
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  return curriedMix(percentage, color, 'rgb(0, 0, 0)');
}

var curriedShade = /*#__PURE__*/curry(shade);

//      

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
    throw new Error('Passed an incorrect argument to tint, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
  }
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  return curriedMix(percentage, color, 'rgb(255, 255, 255)');
}

var curriedTint = /*#__PURE__*/curry(tint);

//      
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize(0.5, 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize(0.5, 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */
function transparentize(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 - amount * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

var curriedTransparentize = /*#__PURE__*/curry(transparentize);

//      

/** */

/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */
function animation() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // Allow single or multiple animations passed
  var multiMode = Array.isArray(args[0]);
  if (!multiMode && args.length > 8) {
    throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
  }
  var code = args.map(function (arg) {
    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
      throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
    }
    if (Array.isArray(arg) && arg.length > 8) {
      throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
    }

    return Array.isArray(arg) ? arg.join(' ') : arg;
  }).join(', ');

  return {
    animation: code
  };
}

//      

/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */

function backgroundImages() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    backgroundImage: properties.join(', ')
  };
}

//      

/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */
function backgrounds() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    background: properties.join(', ')
  };
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */

function borderColor() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderColor'].concat(values));
}

//      
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */

function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);
  if (!radius && radius !== 0) {
    throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
  }
  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;

    return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
  }

  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;

    return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
  }

  throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */

function borderStyle() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderStyle'].concat(values));
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderWidth'].concat(values));
}

//      


function generateSelectors(template, state) {
  var stateSuffix = state ? ':' + state : '';
  return template(stateSuffix);
}

/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */
function statefulSelectors(states, template, stateMap) {
  if (!template) throw new Error('You must provide a template to this method.');
  if (states.length === 0) return generateSelectors(template, null);
  var selectors = [];
  for (var i = 0; i < states.length; i += 1) {
    if (stateMap && stateMap.indexOf(states[i]) < 0) {
      throw new Error('You passed an unsupported selector state to this method.');
    }
    selectors.push(generateSelectors(template, states[i]));
  }
  selectors = selectors.join(',');
  return selectors;
}

//      
var stateMap = [undefined, null, 'active', 'focus', 'hover'];

function template(state) {
  return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
}

/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */

function buttons() {
  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template, stateMap);
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */

function margin() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['margin'].concat(values));
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */

function padding() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['padding'].concat(values));
}

//      
var positionMap$1 = ['absolute', 'fixed', 'relative', 'static', 'sticky'];

/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */

function position(positionKeyword) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (positionMap$1.indexOf(positionKeyword) >= 0) {
    return _extends({
      position: positionKeyword
    }, directionalProperty.apply(undefined, [''].concat(values)));
  } else {
    var firstValue = positionKeyword; // in this case position is actually the first value
    return directionalProperty.apply(undefined, ['', firstValue].concat(values));
  }
}

//      

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */

function size(height) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;

  return {
    height: height,
    width: width
  };
}

//      
var stateMap$1 = [undefined, null, 'active', 'focus', 'hover'];

function template$1(state) {
  return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
}

/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */

function textInputs() {
  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template$1, stateMap$1);
}

//      

/**
 * Shorthand that accepts any number of transition values as parameters for creating a single transition statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 * }
 */

function transitions() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    transition: properties.join(', ')
  };
}

//      
// Helpers
// Mixins
// Color
// Shorthands




/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DarkModeInverter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);










var DarkModeInverter =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DarkModeInverter, _React$Component);

  function DarkModeInverter() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DarkModeInverter);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DarkModeInverter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DarkModeInverter, [{
    key: "render",
    value: function render() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_BackboneListener__["a" /* default */], {
        listenTo: __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_local_settings__["c" /* default */],
        events: ["settings_changed"]
      }, function () {
        var isDarkMode = __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_local_settings__["c" /* default */].getDarkMode();
        return _this.props.children({
          isDarkMode: isDarkMode,
          maybeInvert: {
            filter: isDarkMode ? "invert(100%) hue-rotate(180deg)" : ""
          }
        });
      });
    }
  }]);

  return DarkModeInverter;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DarkModeInverter, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired
});




/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Session; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_account__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_alert_collection__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_location_collection__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_news_collection__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_phone_collection__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_location__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_framework_resource__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_framework_media_type__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_models_geofence__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_models_choice__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_nexia_mobile_event_stream__ = __webpack_require__(278);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















var Session =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Session, _BaseModel);

  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass___default()(Session, [{
    key: "nestedCollections",
    value: function nestedCollections() {
      return {
        locations: {
          collection: __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_location_collection__["a" /* default */]
        },
        alerts: {
          collection: __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_alert_collection__["a" /* default */]
        },
        news: {
          collection: __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_news_collection__["a" /* default */]
        },
        geofences: {
          model: __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_models_geofence__["a" /* default */],
          collection: __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_base_collection__["a" /* default */]
        },
        choices: {
          model: __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_models_choice__["a" /* default */],
          collection: __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_base_collection__["a" /* default */]
        },
        phones: {
          collection: __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_phone_collection__["a" /* default */]
        }
      };
    }
  }, {
    key: "hasNews",
    get: function get() {
      return this.get("hasNews");
    },
    set: function set(value) {
      return this.set("hasNews", value);
    }
  }, {
    key: "hasAlerts",
    get: function get() {
      return this.get("hasAlerts");
    },
    set: function set(value) {
      return this.set("hasAlerts", value);
    }
  }, {
    key: "hasChoices",
    get: function get() {
      return this.get("hasChoices");
    },
    set: function set(value) {
      return this.set("hasChoices", value);
    }
  }]);

  function Session() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Session);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Session)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.listenTo(_this.get("alerts"), "sync", _this._handleUnacknowledgedAlerts);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass___default()(Session, [{
    key: "initialize",
    value: function initialize() {
      __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Session.prototype), "initialize", this).call(this); // We need a valid URL to pull ourselves out of the session cache


      this._updateUrl();
    }
  }, {
    key: "sync",
    value: function sync() {
      var _get2;

      // Update our URL in case the host has changed
      this._updateUrl();

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (_get2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Session.prototype), "sync", this)).call.apply(_get2, [this].concat(args));
    }
  }, {
    key: "populate",
    value: function populate() {
      var _this2 = this;

      this.populateStartedAt = Date.now(); // try to load session and location from cache first

      if (!__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_models_local_settings__["c" /* default */].getShowVognitionOnStartup()) {
        this._loadFromCache();
      }

      return this._fetchFromServer().then(function () {
        __WEBPACK_IMPORTED_MODULE_24_nexia_mobile_event_stream__["a" /* default */].start(_this2.get("eventStream"));
      });
    }
  }, {
    key: "onParse",
    value: function onParse(attrs) {
      // This property gets added when we're placed in the session cache. Reset
      // it before parsing since re-parsing means we've fetched the real session.
      this.set("cached", false);

      var parsedAttrs = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Session.prototype), "onParse", this).call(this, attrs);

      return _objectSpread({}, parsedAttrs, {
        canControlAutomations: parsedAttrs.can_control_automations,
        canManageLocks: parsedAttrs.can_manage_locks,
        canViewVideos: parsedAttrs.can_view_videos,
        canReceiveNotification: parsedAttrs.can_receive_notifications,
        isActivatedByActivationCode: parsedAttrs.is_activated_by_activation_code
      });
    }
  }, {
    key: "parseLinksChild",
    value: function parseLinksChild(links) {
      var _this3 = this;

      var foundLocations = [];
      links.forEach(function (link) {
        var itemType = link.getCollectionItemType();

        if (itemType === __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_framework_media_type__["a" /* default */].ALERT) {
          _this3.hasAlerts = true; // Set showAlertsBadge at the startup based on has_unacknowledged

          Object(__WEBPACK_IMPORTED_MODULE_22_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("showAlertsBadge", link.getData().has_unacknowledged);

          _this3.get("alerts").setUrl(link.href);
        } else if (itemType === __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_framework_media_type__["a" /* default */].NEWS) {
          _this3.get("news").set(link.getData(), {
            parse: true
          });

          _this3.hasNews = _this3.get("news").length > 0;
        } else if (link.hasType(__WEBPACK_IMPORTED_MODULE_18_nexia_mobile_framework_media_type__["a" /* default */].LOCATION)) {
          // Jump through hoops to try to find an existing Location
          // model and just set attributes on it, if one is available.
          var location = __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_framework_resource__["a" /* ResourceMap */].findByHref(link.href);

          if (location) {
            var data = link.getData();
            delete data.id;
            location.set(data, {
              parse: true
            });
          } else {
            location = new __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_location__["a" /* default */](link.getData(), {
              parse: true
            });
          }

          foundLocations.push(location);
        } else if (itemType === __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_framework_media_type__["a" /* default */].GEOFENCE) {
          _this3.get("geofences").set(link.getData(), {
            parse: true
          });
        } else if (itemType === __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_framework_media_type__["a" /* default */].CHOICE) {
          _this3.hasChoices = true;

          _this3.get("choices").set(link.getData(), {
            parse: true
          });
        } else if (itemType === __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_framework_media_type__["a" /* default */].PHONE) {
          _this3.get("phones").set(link.getData(), {
            parse: true
          });
        }
      });
      return this.get("locations").set(foundLocations);
    }
  }, {
    key: "parseLinksSelf",
    value: function parseLinksSelf(links) {
      var result = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Session.prototype), "parseLinksSelf", this).call(this, links);

      var host = __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_models_local_settings__["c" /* default */].getHost();

      if (this.id.indexOf(host) !== 0 && !__WEBPACK_IMPORTED_MODULE_23_nexia_mobile_environment__["a" /* default */].isTestRunner()) {
        console.warn("Host is set to ".concat(host, " in LocalSettings, but the Session retrieved from the server has an href of ").concat(this.id, ". Session caching will not work unless the server returns the same host as is set in LocalSettings."));
      }

      return result;
    }
  }, {
    key: "parseLinksParent",
    value: function parseLinksParent(links) {
      var link = links && links[0];

      if (link && link.hasType(__WEBPACK_IMPORTED_MODULE_18_nexia_mobile_framework_media_type__["a" /* default */].ACCOUNT)) {
        var existingAccount = this.get("account");

        if (existingAccount != null) {
          existingAccount.set(existingAccount.parse(link.getData()));
        } else {
          var newAccount = new __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_account__["a" /* default */](link.getData(), {
            parse: true
          });
          this.set("account", newAccount);
        }
      }
    }
  }, {
    key: "parseLinksStream",
    value: function parseLinksStream(links) {
      var link = links[0];

      if (!link) {
        return;
      }

      this.set("eventStream", link);
    }
  }, {
    key: "hasMultipleLocations",
    value: function hasMultipleLocations() {
      return this.get("locations").length > 1;
    }
  }, {
    key: "hasUnreadNews",
    value: function hasUnreadNews() {
      if (this.get("cached")) {
        return false;
      }

      return this.get("news").any(function (newsItem) {
        return newsItem.get("unread");
      });
    }
  }, {
    key: "_handleUnacknowledgedAlerts",
    value: function _handleUnacknowledgedAlerts(collection) {
      var alerts = collection.filter(function (alert) {
        return !alert.get("acknowledged");
      }); // Set showAlertsBadge if there are unacknowledged alerts

      Object(__WEBPACK_IMPORTED_MODULE_22_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("showAlertsBadge", alerts.length > 0);
    }
  }, {
    key: "_loadFromCache",
    value: function _loadFromCache() {
      var cache = __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_platform__["a" /* default */].getSessionCache();
      var cachedSession = cache[this.url()];

      if (cachedSession) {
        this.set(this.parse(cachedSession));

        if (__WEBPACK_IMPORTED_MODULE_22_nexia_mobile_flux_like_store__["a" /* default */].session === this) {
          var location = this._getDefaultLocation();

          var cachedLocation = cache[location.url()];

          if (cachedLocation) {
            location.preventHomeProfileUpdate();
            location.set(location.parse(cachedLocation));
            location.allowHomeProfileUpdate();
            Object(__WEBPACK_IMPORTED_MODULE_21_nexia_mobile_flux_like_dispatch__["a" /* default */])("LOCATION_CHANGE", location);
          }
        }
      }
    }
  }, {
    key: "_fetchFromServer",
    value: function _fetchFromServer() {
      var _this4 = this;

      return this.fetch({
        type: "POST",
        data: _objectSpread({}, __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_platform__["a" /* default */].getAppInfo(), {
          tracked_settings: __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_models_local_settings__["c" /* default */].getTrackedSettings()
          /* eslint-enable camelcase */

        }),
        postData: true,
        useBackgroundLoadingIndicator: true
      }).then(function (sessionResponse) {
        _this4._addToSessionCache(sessionResponse);

        var location = _this4._getDefaultLocation();

        if (__WEBPACK_IMPORTED_MODULE_22_nexia_mobile_flux_like_store__["a" /* default */].session === _this4) {
          return Promise.all([location.fetch({
            useBackgroundLoadingIndicator: true
          }).done(function (locationResponse) {
            location.populatePendingRequestsRecursively();

            _this4._addToSessionCache(locationResponse);

            Object(__WEBPACK_IMPORTED_MODULE_21_nexia_mobile_flux_like_dispatch__["a" /* default */])("LOCATION_CHANGE", location);
          }), _this4.get("account").fetch()]);
        } else {
          return Promise.resolve();
        }
      });
    }
  }, {
    key: "_addToSessionCache",
    value: function _addToSessionCache(response) {
      __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_platform__["a" /* default */].addToSessionCache(response);
    }
  }, {
    key: "_getDefaultLocation",
    value: function _getDefaultLocation() {
      var id = this._defaultLocationId();

      var location = this.get("locations").get(id);
      return location || this.get("locations").first();
    }
  }, {
    key: "_defaultLocationId",
    value: function _defaultLocationId() {
      return __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_models_local_settings__["c" /* default */].getDefaultLocationId();
    }
  }, {
    key: "_updateUrl",
    value: function _updateUrl() {
      var host = __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_models_local_settings__["c" /* default */].getHost();
      this.setUrl("".concat(host, "/mobile/session"));
    }
  }]);

  return Session;
}(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_base_model__["a" /* default */]);



/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(807);


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalStyleSheet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);






 // Checks for a stylesheet with the provided `id` in document.head when it mounts,
// and if one isn't there, it adds one with the contents specified by `sheet`.
// Example:
//
// <GlobalStyleSheet id="nx-components_red-body" sheet={`
//   body {
//     color: red;
//   }
// `}/>
//
// Use sparingly, and namespace your classes aggressively; you can accomplish
// most of what you want with inline styles instead of this, but this can be
// used for CSS animations, etc.
//
// WARNING: If your stylesheet creates animations that are used on the first
// mount of a component, you need to ensure that those animations are loaded
// before the component is mounted. You can do this with the
// GlobalStyleSheet.preload function:
//
// Instead of:
//
// const id = "my-animation-sheet";
// const stylesheet = `@keyframes my-animation {...}`;
//
// return (
//   <div style={{ animation: "my-animation" }}>
//     <GlobalStyleSheet id={id} sheet={stylesheet} />
//   </div>
// );
//
// Do this:
//
// const id = "my-animation-sheet";
// const stylesheet = `@keyframes my-animation {...}`;
//
// GlobalStyleSheet.preload(id, stylesheet);
//
// return (
//   <div style={{ animation: "my-animation" }} />
// );

var GlobalStyleSheet =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(GlobalStyleSheet, _React$Component);

  function GlobalStyleSheet() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, GlobalStyleSheet);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(GlobalStyleSheet).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(GlobalStyleSheet, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          id = _this$props.id,
          sheet = _this$props.sheet;
      addStyleIfNotPresent(id, sheet);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.id === this.props.id && prevProps.sheet === this.props.sheet) {
        return;
      }

      removeStyleIfPresent(prevProps.id);
      addStyleIfNotPresent(this.props.id, this.props.sheet);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }], [{
    key: "preload",
    value: function preload(id, sheet) {
      addStyleIfNotPresent(id, sheet);
    }
  }]);

  return GlobalStyleSheet;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(GlobalStyleSheet, "propTypes", {
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  sheet: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
});



function getStyleElementById(id) {
  return document.head.querySelector("style#".concat(id));
}

function addStyleIfNotPresent(id, sheet) {
  if (getStyleElementById(id)) {
    return;
  }

  var style = document.createElement("style");
  style.type = "text/css";
  style.id = id;
  style.appendChild(document.createTextNode(sheet));
  document.head.appendChild(style);
}

function removeStyleIfPresent(id) {
  var element = getStyleElementById(id);

  if (element != null) {
    document.head.removeChild(element);
  }
}



/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(331);
var enumBugKeys = __webpack_require__(232);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(69);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(19);
var dPs = __webpack_require__(332);
var enumBugKeys = __webpack_require__(232);
var IE_PROTO = __webpack_require__(231)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(229)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(233).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(331);
var hiddenKeys = __webpack_require__(232).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(21);
var dP = __webpack_require__(38);
var DESCRIPTORS = __webpack_require__(33);
var SPECIES = __webpack_require__(29)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(67);
var call = __webpack_require__(344);
var isArrayIter = __webpack_require__(244);
var anObject = __webpack_require__(19);
var toLength = __webpack_require__(30);
var getIterFn = __webpack_require__(246);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(55);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(831),
    getValue = __webpack_require__(836);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(212);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(162);
util.inherits = __webpack_require__(142);
/*</replacement>*/

var Readable = __webpack_require__(436);
var Writable = __webpack_require__(283);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return warning; });
var warning = function () { };
var invariant = function () { };
if (false) {
    warning = function (check, message) {
        if (!check && typeof console !== 'undefined') {
            console.warn(message);
        }
    };
    invariant = function (check, message) {
        if (!check) {
            throw new Error(message);
        }
    };
}




/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.sheetsManager = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1));

var _extends3 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(2));

var _createClass2 = _interopRequireDefault(__webpack_require__(3));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(5));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(4));

var _inherits2 = _interopRequireDefault(__webpack_require__(6));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(40));

var _warning = _interopRequireDefault(__webpack_require__(49));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(303));

var _utils = __webpack_require__(80);

var _jss = __webpack_require__(424);

var _reactJssContext = _interopRequireDefault(__webpack_require__(937));

var _jssPreset = _interopRequireDefault(__webpack_require__(423));

var _mergeClasses = _interopRequireDefault(__webpack_require__(938));

var _multiKeyStore = _interopRequireDefault(__webpack_require__(939));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(268));

var _themeListener = _interopRequireDefault(__webpack_require__(273));

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(422));

var _getStylesCreator = _interopRequireDefault(__webpack_require__(940));

var _getThemeProps = _interopRequireDefault(__webpack_require__(941));

/* eslint-disable no-underscore-dangle */
// Default JSS instance.
var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = (0, _createGenerateClassName.default)(); // Global index counter to preserve source order.
// We create the style sheet during at the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.

var indexCounter = -10e10; // Exported for test purposes

var sheetsManager = new Map(); // We use the same empty object to ref count the styles that don't need a theme object.

exports.sheetsManager = sheetsManager;
var noopTheme = {}; // In order to have self-supporting components, we rely on default theme when not provided.

var defaultTheme = (0, _createMuiTheme.default)({
  typography: {
    suppressWarning: true
  }
}); // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStylesOld = function withStylesOld(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var _extends2;

    var _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$flip = options.flip,
        flip = _options$flip === void 0 ? null : _options$flip,
        name = options.name,
        styleSheetOptions = (0, _objectWithoutProperties2.default)(options, ["withTheme", "flip", "name"]);
    var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
    var listenToTheme = stylesCreator.themingEnabled || typeof name === 'string' || withTheme;
    indexCounter += 1;
    stylesCreator.options.index = indexCounter;
     false ? (0, _warning.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n')) : void 0;

    var WithStyles =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithStyles, _React$Component);

      function WithStyles(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithStyles);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithStyles).call(this, props, context));
        _this.jss = context[_reactJssContext.default.jss] || jss;
        _this.sheetsManager = sheetsManager;
        _this.unsubscribeId = null;
        var muiThemeProviderOptions = context.muiThemeProviderOptions;

        if (muiThemeProviderOptions) {
          if (muiThemeProviderOptions.sheetsManager) {
            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
          }

          _this.sheetsCache = muiThemeProviderOptions.sheetsCache;
          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
        } // Attach the stylesCreator to the instance of the component as in the context
        // of react-hot-loader the hooks can be executed in a different closure context:
        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107


        _this.stylesCreatorSaved = stylesCreator;
        _this.sheetOptions = (0, _extends3.default)({
          generateClassName: generateClassName
        }, context[_reactJssContext.default.sheetOptions]); // We use || as the function call is lazy evaluated.

        _this.theme = listenToTheme ? _themeListener.default.initial(context) || defaultTheme : noopTheme;

        _this.attach(_this.theme);

        _this.cacheClasses = {
          // Cache for the finalized classes value.
          value: null,
          // Cache for the last used classes prop pointer.
          lastProp: null,
          // Cache for the last used rendered classes pointer.
          lastJSS: {}
        };
        return _this;
      }

      (0, _createClass2.default)(WithStyles, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          if (!listenToTheme) {
            return;
          }

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            var oldTheme = _this2.theme;
            _this2.theme = theme;

            _this2.attach(_this2.theme); // Rerender the component so the underlying component gets the theme update.
            // By theme update we mean receiving and applying the new class names.


            _this2.setState({}, function () {
              _this2.detach(oldTheme);
            });
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          // react-hot-loader specific logic
          if (this.stylesCreatorSaved === stylesCreator || "production" === 'production') {
            return;
          }

          this.detach(this.theme);
          this.stylesCreatorSaved = stylesCreator;
          this.attach(this.theme);
          this.forceUpdate();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.detach(this.theme);

          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "getClasses",
        value: function getClasses() {
          if (this.disableStylesGeneration) {
            return this.props.classes || {};
          } // Tracks if either the rendered classes or classes prop has changed,
          // requiring the generation of a new finalized classes object.


          var generate = false;

          var sheetManager = _multiKeyStore.default.get(this.sheetsManager, this.stylesCreatorSaved, this.theme);

          if (sheetManager.sheet.classes !== this.cacheClasses.lastJSS) {
            this.cacheClasses.lastJSS = sheetManager.sheet.classes;
            generate = true;
          }

          if (this.props.classes !== this.cacheClasses.lastProp) {
            this.cacheClasses.lastProp = this.props.classes;
            generate = true;
          }

          if (generate) {
            this.cacheClasses.value = (0, _mergeClasses.default)({
              baseClasses: this.cacheClasses.lastJSS,
              newClasses: this.props.classes,
              Component: Component
            });
          }

          return this.cacheClasses.value;
        }
      }, {
        key: "attach",
        value: function attach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;

          var sheetManager = _multiKeyStore.default.get(this.sheetsManager, stylesCreatorSaved, theme);

          if (!sheetManager) {
            sheetManager = {
              refs: 0,
              sheet: null
            };

            _multiKeyStore.default.set(this.sheetsManager, stylesCreatorSaved, theme, sheetManager);
          }

          if (sheetManager.refs === 0) {
            var sheet;

            if (this.sheetsCache) {
              sheet = _multiKeyStore.default.get(this.sheetsCache, stylesCreatorSaved, theme);
            }

            if (!sheet) {
              sheet = this.createSheet(theme);
              sheet.attach();

              if (this.sheetsCache) {
                _multiKeyStore.default.set(this.sheetsCache, stylesCreatorSaved, theme, sheet);
              }
            }

            sheetManager.sheet = sheet;
            var sheetsRegistry = this.context[_reactJssContext.default.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.add(sheet);
            }
          }

          sheetManager.refs += 1;
        }
      }, {
        key: "createSheet",
        value: function createSheet(theme) {
          var styles = this.stylesCreatorSaved.create(theme, name);
          var meta = name;

          if (false) {
            // Provide a better DX outside production.
            meta = (0, _utils.getDisplayName)(Component);
            process.env.NODE_ENV !== "production" ? (0, _warning.default)(typeof meta === 'string', ['Material-UI: the component displayName is invalid. It needs to be a string.', "Please fix the following component: ".concat(Component, ".")].join('\n')) : void 0;
          }

          var sheet = this.jss.createStyleSheet(styles, (0, _extends3.default)({
            meta: meta,
            classNamePrefix: meta,
            flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
            link: false
          }, this.sheetOptions, this.stylesCreatorSaved.options, {
            name: name || Component.displayName
          }, styleSheetOptions));
          return sheet;
        }
      }, {
        key: "detach",
        value: function detach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var sheetManager = _multiKeyStore.default.get(this.sheetsManager, this.stylesCreatorSaved, theme);

          sheetManager.refs -= 1;

          if (sheetManager.refs === 0) {
            _multiKeyStore.default.delete(this.sheetsManager, this.stylesCreatorSaved, theme);

            this.jss.removeStyleSheet(sheetManager.sheet);
            var sheetsRegistry = this.context[_reactJssContext.default.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.remove(sheetManager.sheet);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              classes = _this$props.classes,
              innerRef = _this$props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "innerRef"]);
          var more = (0, _getThemeProps.default)({
            theme: this.theme,
            name: name,
            props: other
          }); // Provide the theme to the wrapped component.
          // So we don't have to use the `withTheme()` Higher-order Component.

          if (withTheme && !more.theme) {
            more.theme = this.theme;
          }

          return _react.default.createElement(Component, (0, _extends3.default)({}, more, {
            classes: this.getClasses(),
            ref: innerRef
          }));
        }
      }]);
      return WithStyles;
    }(_react.default.Component);

     false ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: _propTypes.default.object,

      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : void 0;
    WithStyles.contextTypes = (0, _extends3.default)((_extends2 = {
      muiThemeProviderOptions: _propTypes.default.object
    }, (0, _defineProperty2.default)(_extends2, _reactJssContext.default.jss, _propTypes.default.object), (0, _defineProperty2.default)(_extends2, _reactJssContext.default.sheetOptions, _propTypes.default.object), (0, _defineProperty2.default)(_extends2, _reactJssContext.default.sheetsRegistry, _propTypes.default.object), _extends2), listenToTheme ? _themeListener.default.contextTypes : {});

    if (false) {
      WithStyles.displayName = "WithStyles(".concat((0, _utils.getDisplayName)(Component), ")");
    }

    (0, _hoistNonReactStatics.default)(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
    }

    return WithStyles;
  };
};
/* istanbul ignore if */


if (!_utils.ponyfillGlobal.__MUI_STYLES__) {
  _utils.ponyfillGlobal.__MUI_STYLES__ = {};
}

if (!_utils.ponyfillGlobal.__MUI_STYLES__.withStyles) {
  _utils.ponyfillGlobal.__MUI_STYLES__.withStyles = withStylesOld;
}

var _default = function _default(styles, options) {
  return _utils.ponyfillGlobal.__MUI_STYLES__.withStyles(styles, (0, _extends3.default)({
    defaultTheme: defaultTheme
  }, options));
};

exports.default = _default;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(796);

var iterableToArray = __webpack_require__(391);

var nonIterableSpread = __webpack_require__(797);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var RichLabel =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(RichLabel, _React$Component);

  function RichLabel() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, RichLabel);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(RichLabel).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(RichLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          description = _this$props.description,
          icon = _this$props.icon,
          iconStyle = _this$props.iconStyle,
          label = _this$props.label,
          style = _this$props.style,
          textWrapperStyle = _this$props.textWrapperStyle,
          colors = _this$props.colors;
      var styles = {
        richLabel: _objectSpread({}, __WEBPACK_IMPORTED_MODULE_8__Theme__["a" /* default */].Styles.flexLayout, {}, style),
        icon: _objectSpread({
          marginRight: "0.25em",
          lineHeight: 0,
          fontSize: "1.5em"
        }, __WEBPACK_IMPORTED_MODULE_8__Theme__["a" /* default */].Styles.flexFixed, {}, iconStyle),
        label: {
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        description: {
          color: colors.TEXT_SECONDARY,
          fontSize: "0.8em"
        },
        textWrapper: _objectSpread({
          lineHeight: "normal",
          minWidth: 0
        }, __WEBPACK_IMPORTED_MODULE_8__Theme__["a" /* default */].Styles.flexStretch, {}, textWrapperStyle)
      };
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "RichLabel",
        style: styles.richLabel
      }, icon ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.icon,
        "data-component-section": "icon"
      }, icon) : null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.textWrapper
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.label,
        "data-component-section": "label"
      }, label), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.description,
        "data-component-section": "description"
      }, description)));
    }
  }]);

  return RichLabel;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(RichLabel, "propTypes", {
  description: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.node,
  icon: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.node,
  iconStyle: function iconStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  label: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.node,
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  textWrapperStyle: function textWrapperStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["c" /* withColorsProvider */])(RichLabel));




/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_store__ = __webpack_require__(27);










var AppState =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AppState, _BaseModel);

  function AppState() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AppState);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AppState).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AppState, [{
    key: "resetCurrentLocation",
    value: function resetCurrentLocation() {
      this.currentLocation = null;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AppState.prototype), "initialize", this).call(this);

      this._setUpListeners();

      this._backgroundLoadingRequestMap = {};
      this.currentLocation = null;

      this._resetUserAuthenticatedState();
    }
  }, {
    key: "_resetUserAuthenticatedState",
    value: function _resetUserAuthenticatedState() {
      this.userAuthenticated = __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_local_settings__["c" /* default */].canSkipLogin() || this.inDemoMode;
    }
  }, {
    key: "_setUpListeners",
    value: function _setUpListeners() {
      var _this = this;

      this.listenTo(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_local_settings__["c" /* default */], "activation:success", function () {
        if (!__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_local_settings__["c" /* default */].needsAuthentication()) {
          _this.userAuthenticated = true;
        }
      });
      this.listenTo(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__["a" /* default */].Events, "request", function (model, xhr, options) {
        if (!(options.useBackgroundLoadingIndicator && model.id)) {
          return;
        }

        _this._backgroundLoadingRequestMap[model.id] = true;

        _this._updateBackgroundLoading();
      });
      this.listenTo(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__["a" /* default */].Events, "sync error", function (model, response, options) {
        if (!(options.useBackgroundLoadingIndicator && model.id)) {
          return;
        }

        if (_this._backgroundLoadingRequestMap[model.id]) {
          delete _this._backgroundLoadingRequestMap[model.id];
        }

        _this._updateBackgroundLoading();
      });
    }
  }, {
    key: "_updateBackgroundLoading",
    value: function _updateBackgroundLoading() {
      if (Object.keys(this._backgroundLoadingRequestMap).length > 0) {
        Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("backgroundLoading", true);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("backgroundLoading", false);
      }
    }
  }, {
    key: "currentLocation",
    get: function get() {
      return this.get("currentLocation");
    },
    set: function set(value) {
      return this.set("currentLocation", value);
    }
  }, {
    key: "userAuthenticated",
    get: function get() {
      return this.get("userAuthenticated");
    },
    set: function set(value) {
      return this.set("userAuthenticated", value);
    }
  }, {
    key: "inDemoMode",
    get: function get() {
      return this.get("inDemoMode");
    },
    set: function set(value) {
      return this.set("inDemoMode", value);
    }
  }, {
    key: "isFirstVisit",
    get: function get() {
      return this.get("isFirstVisit");
    },
    set: function set(value) {
      return this.set("isFirstVisit", value);
    }
  }, {
    key: "needsAuthentication",
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_local_settings__["c" /* default */].needsAuthentication();
    }
  }]);

  return AppState;
}(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__["a" /* default */]);



/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = killScroll;
/* harmony export (immutable) */ __webpack_exports__["c"] = reviveScroll;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollableDiv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__UserAgent__ = __webpack_require__(95);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var isIOS = __WEBPACK_IMPORTED_MODULE_12__UserAgent__["a" /* default */].isIOS(); // In iOS, elements with style '-webkit-overflow-scrolling: touch' have 2 major
// bugs:
// 1) When the browser switches from portrait to landscape mode: If there was no
// vertical overflow before, but afterwards there is, vertical scrolling
// remains disabled. Toggle this property and the 'overflow-y: auto' so that the
// webview recalculates vertical scrolling. NOTE: This bug seems to have stopped
// mattering since we implemented the orientationchange fix. Perhaps our use of
// flexbox fixed the use cases? Leaving the fix since I don't know why it's not
// needed.
// 2) If an input is focused so that a cursor appears, the cursor will not follow
// the input while the container is scrolling; it will only snap into place after
// the container stops moving. Toggle the property when a child input is focused.
// Also worth noting, iOS doesn't handle absolute positioning within a scrollable
// container well. DO NOT put absolutely positioned content inside a div like this
// In order to prevent scrolling while dragging something (like a slider or
// slide-to-unlock control), we change overflow-y on all ScrollableDivs when we
// receive events on this global scroll killswitch listener.

var scrollKillSwitchListener = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_11_backbone___default.a.Events);

var isScrollDead = false;
scrollKillSwitchListener.on("kill", function () {
  isScrollDead = true;
});
scrollKillSwitchListener.on("revive", function () {
  isScrollDead = false;
});
function killScroll() {
  scrollKillSwitchListener.trigger("kill");
}
function reviveScroll() {
  scrollKillSwitchListener.trigger("revive");
}

var ScrollableDiv =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(ScrollableDiv, _React$Component);

  function ScrollableDiv() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, ScrollableDiv);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(ScrollableDiv)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleOrientationChange", function () {
      clearTimeout(_this._timeout1);
      clearTimeout(_this._timeout2);
      _this._timeout1 = setTimeout(function () {
        _this._justChangedOrientation = true;

        _this._updateContainerStyle();

        _this._timeout2 = setTimeout(function () {
          _this._justChangedOrientation = false;

          _this._updateContainerStyle();
        }, 100);
      }, 100);
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleFocusIn", function (event) {
      var target = event.target;

      if (target && target.nodeName === "INPUT") {
        _this._keyboardShown = true;

        _this._updateContainerStyle();
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleFocusOut", function (event) {
      var target = event.target;

      if (target && target.nodeName === "INPUT") {
        _this._keyboardShown = false;

        _this._updateContainerStyle();
      }
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_updateContainerStyle", function () {
      if (!_this._container) {
        return;
      }

      Object.assign(_this._container.style, _this._computedContainerStyles());
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_captureRef", function (el) {
      _this._container = el;

      if (_this.props.captureRef) {
        _this.props.captureRef(el);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(ScrollableDiv, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      scrollKillSwitchListener.on("kill revive", function () {
        return _this2._updateContainerStyle();
      }, this);

      if (!isIOS) {
        return;
      }

      window.addEventListener("orientationchange", this._handleOrientationChange);

      this._container.addEventListener("focusin", this._handleFocusIn);

      this._container.addEventListener("focusout", this._handleFocusOut);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      scrollKillSwitchListener.off(null, null, this);

      if (!isIOS) {
        return;
      }

      window.removeEventListener("orientationchange", this._handleOrientationChange);

      this._container.removeEventListener("focusin", this._handleFocusIn);

      this._container.removeEventListener("focusout", this._handleFocusOut);
    }
  }, {
    key: "_computedContainerStyles",
    value: function _computedContainerStyles() {
      if (isScrollDead) {
        return {
          WebkitOverflowScrolling: "auto",
          overflowY: "hidden"
        };
      } else if (!this._justChangedOrientation) {
        return {
          WebkitOverflowScrolling: this._keyboardShown ? "auto" : "touch",
          overflowY: "auto"
        };
      } else {
        return {
          WebkitOverflowScrolling: this._keyboardShown ? "touch" : "auto",
          overflowY: "hidden"
        };
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          style = _this$props.style,
          captureRef = _this$props.captureRef,
          elementType = _this$props.elementType,
          attributes = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["children", "style", "captureRef", "elementType"]);

      var ElementType = elementType;
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](ElementType, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        ref: this._captureRef,
        style: _objectSpread({
          overflowX: "hidden"
        }, style, {}, this._computedContainerStyles())
      }, attributes), children);
    }
  }]);

  return ScrollableDiv;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(ScrollableDiv, "propTypes", {
  style: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.node,
  captureRef: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  elementType: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string
});

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(ScrollableDiv, "defaultProps", {
  elementType: "div"
});



/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailsHeaderOffscreenOverscroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_ErrorHandler__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var DetailsHeaderOffscreenOverscroll = Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_ColorsProvider__["c" /* withColorsProvider */])(function (_ref) {
  var colors = _ref.colors;
  return (
    /*
      Add some offscreen grey so that if the user overscrolls downwards
      on the details page, it's still grey "behind" the title bar.
    */
    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
      "data-component-name": "DetailsHeaderOffscreenOverscroll",
      style: {
        marginTop: "-100vh",
        height: "100vh",
        background: colors.DETAILS_HEADER_BACKGROUND,
        // This transform is here to prevent Mobile Safari from applying
        // an optimization where it doesn't render an "offscreen" element.
        transform: "translate3d(0, 0, 0)"
      }
    })
  );
});


var DetailsHeaderWrapper = function DetailsHeaderWrapper(_ref2) {
  var children = _ref2.children,
      style = _ref2.style,
      innerRef = _ref2.innerRef,
      colors = _ref2.colors;
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_ErrorHandler__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    style: _objectSpread({
      color: colors.PRIMARY,
      background: colors.DETAILS_HEADER_BACKGROUND,
      padding: "1em",
      textAlign: "center",
      position: "relative"
    }, style),
    ref: innerRef
  }, children));
};

DetailsHeaderWrapper.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node,
  style: function style() {
    return (typeof StylesObject === "function" ? __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StylesObject) : __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any).apply(this, arguments);
  },
  innerRef: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_ColorsProvider__["c" /* withColorsProvider */])(DetailsHeaderWrapper));


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BackButtonListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BackButtonResponder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);







var BackButtonListener =
/*#__PURE__*/
function () {
  function BackButtonListener() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, BackButtonListener);

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(this, "_handleKeyUp", function (event) {
      if (event.code !== "Escape") {
        return;
      }

      _this._callResponderCallbacks();
    });

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(this, "_callResponderCallbacks", function () {
      // Iterate over the array backwards, so that most-recently-added responders
      // are called first.
      for (var i = _this._responderCallbacks.length - 1; i >= 0; i--) {
        var callback = _this._responderCallbacks[i];

        var _callback = callback(),
            handled = _callback.handled;

        if (handled) {
          break;
        }
      }
    });

    this._responderCallbacks = [];
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(BackButtonListener, [{
    key: "processBackButtonPress",
    value: function processBackButtonPress() {
      this._callResponderCallbacks();
    }
  }, {
    key: "startListening",
    value: function startListening() {
      // This body checks is to make flow happy...
      if (document.body == null) {
        return;
      }

      document.body.addEventListener("keyup", this._handleKeyUp);
    }
  }, {
    key: "stopListening",
    value: function stopListening() {
      // This body checks is to make flow happy...
      if (document.body == null) {
        return;
      }

      document.body.removeEventListener("keyup", this._handleKeyUp);
    }
  }, {
    key: "registerResponderCallback",
    value: function registerResponderCallback(responderCallback) {
      var _this2 = this;

      this._responderCallbacks.push(responderCallback);

      var referenceResponderCallback = responderCallback;

      var getCallbackIndex = function getCallbackIndex() {
        return _this2._responderCallbacks.indexOf(referenceResponderCallback);
      };

      return {
        unregister: function unregister() {
          var index = getCallbackIndex();

          if (index === -1) {
            throw new Error("Attempted to remove a back button responder callback that had already been removed.");
          } else {
            _this2._responderCallbacks.splice(index, 1);
          }
        },
        replace: function replace(newResponderCallback) {
          var index = getCallbackIndex();

          if (index === -1) {
            throw new Error("Attempted to update a back button responder callback that had been removed.");
          } else {
            _this2._responderCallbacks.splice(index, 1, newResponderCallback);

            referenceResponderCallback = newResponderCallback;
          }
        }
      };
    }
  }], [{
    key: "setSingleton",
    value: function setSingleton(instance) {
      this._singleton = instance;
    }
  }, {
    key: "getSingleton",
    value: function getSingleton() {
      return this._singleton;
    }
  }]);

  return BackButtonListener;
}();

var BackButtonResponder =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default()(BackButtonResponder, _React$Component);

  function BackButtonResponder() {
    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, BackButtonResponder);

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_getPrototypeOf___default()(BackButtonResponder).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(BackButtonResponder, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var listener = BackButtonListener.getSingleton();

      if (listener == null) {
        return;
      }

      var onPressed = this.props.onPressed;

      if (onPressed == null) {
        return;
      }

      this._responderCallbackManager = listener.registerResponderCallback(onPressed);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.onPressed === this.props.onPressed) {
        return;
      }

      var listener = BackButtonListener.getSingleton();

      if (listener == null) {
        return;
      }

      var onPressed = this.props.onPressed;

      if (onPressed == null) {
        return;
      }

      if (this._responderCallbackManager != null) {
        this._responderCallbackManager.replace(onPressed);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._responderCallbackManager != null) {
        this._responderCallbackManager.unregister();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return BackButtonResponder;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(BackButtonResponder, "propTypes", {
  onPressed: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
});




/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = function access(obj, accessStr) {
  // auto-curry here
  if (isUndefined(accessStr)) {
    return access.bind(null, obj);
  }

  var funcArgs = Array.prototype.slice.call(arguments, 2);
  return helper(obj, tokenize(accessStr), null, funcArgs);
};

function helper(obj, tokens, ctx, fnArgs) {
  if (tokens.length === 0) {
    return obj;
  }

  var currentToken = tokens[0];

  if (isUndefined(obj) || isNull(obj) ||
    (isTokenFunctionCall(currentToken) && !isFunction(obj))) {
    return undefined;
  }

  if (isTokenFunctionCall(currentToken)) {

    return helper(obj[isArray(fnArgs[0]) ? 'apply' : 'call'](ctx, fnArgs[0]),
      tokens.slice(1),
      // clear context because consecutive fn calls execute in global context
      // e.g. `a.b()()`
      null,
      fnArgs.slice(1));

  } else if (isTokenArrayAccess(currentToken)) {

    return helper(obj[parseInt(currentToken.substr(1), 10)],
      tokens.slice(1),
      // lookahead two tokens for function calls
      isTokenFunctionCall(tokens[1]) ? obj : ctx,
      fnArgs);

  } else {

    return helper(obj[currentToken],
      tokens.slice(1),
      // lookahead two tokens for function calls
      isTokenFunctionCall(tokens[1]) ? obj : ctx,
      fnArgs);

  }
}

function isUndefined(a) {
  return a === void 0;
}

function isNull(a) {
  return a === null;
}

function isArray(a) {
  return Array.isArray(a);
}

function isFunction(a) {
  return typeof a === 'function';
}

function isTokenFunctionCall(token) {
  return token === '()';
}

function isTokenArrayAccess(token) {
  return /^\[\d+\]$/.test(token);
}

function tokenize(str) {
  return str.split(/\.|(\(\))|(\[\d+?])/).filter(function(t) { return t; });
}


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(38).f;
var has = __webpack_require__(60);
var TAG = __webpack_require__(29)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(68);
var TAG = __webpack_require__(29)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var defined = __webpack_require__(76);
var fails = __webpack_require__(25);
var spaces = __webpack_require__(235);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 138 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(139);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(269);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(206);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // It's a getter.
      if (value === undefined) return this.style[name];

      // Don't do anything if the value has not changed.
      if (this.style[name] === value) return this;

      value = this.options.jss.plugins.onChangeValue(value, name, this);

      var isEmpty = value == null || value === false;
      var isDefined = name in this.style;

      // Value is empty and wasn't defined before.
      if (isEmpty && !isDefined) return this;

      // We are going to remove this value.
      var remove = isEmpty && isDefined;

      if (remove) delete this.style[name];else this.style[name] = value;

      // Renderable is defined if StyleSheet option `link` is true.
      if (this.renderable) {
        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
        return this;
      }

      var sheet = this.options.sheet;

      if (sheet && sheet.attached) {
        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
      }
      return this;
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setProperty(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (!this.renderable) return;

      var hasChanged = this.renderer.setSelector(this.renderable, selector);

      // If selector setter is not implemented, rerender the rule.
      if (!hasChanged && this.renderable) {
        var renderable = this.renderer.replaceRule(this.renderable, this);
        if (renderable) this.renderable = renderable;
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 142 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = truncateAndCombineIcons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_Badge__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_CustomPropTypes__ = __webpack_require__(470);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function truncateAndCombineIcons(values, unique) {
  var icons;

  if (unique) {
    // discard repeated values and update count
    icons = uniqueifyWhileCounting(values);
  } else {
    icons = uniqueifyKeys(values);
  } // only support up to 6 icons


  return icons.slice(0, 6);
}

function uniqueifyKeys(values) {
  return values.map(function (value, index) {
    value.count = 1;
    value.key += index;
    return value;
  });
}

function uniqueifyWhileCounting(icons) {
  var values = [];
  var counts = {};
  icons.forEach(function (icon) {
    if (!counts.hasOwnProperty(icon.key)) {
      counts[icon.key] = 0;
      values.push(icon); // can't use _.uniq with objects (===)
    }

    counts[icon.key] += 1;
  });
  return values.map(function (icon) {
    icon.count = counts[icon.key]; // adjust count with new data

    return icon;
  });
}

function IconGroup(_ref) {
  var className = _ref.className,
      values = _ref.values,
      unique = _ref.unique,
      disableBadges = _ref.disableBadges,
      style = _ref.style;

  if (!values || values.length === 0) {
    return null;
  }

  var icons = truncateAndCombineIcons(values, unique);
  var styles = Object(__WEBPACK_IMPORTED_MODULE_5_nx_components_utils_prefixStyles__["b" /* default */])({
    root: _objectSpread({
      display: "flex",
      flexWrap: "wrap",
      position: "relative",
      margin: "0.1em auto",
      justifyContent: "center",
      lineHeight: 0
    }, style),
    iconBadgeWrapper: {
      position: "relative"
    },
    icon: {
      lineHeight: 0,
      margin: icons.length > 1 ? "0.2em" : "0.1em",
      fontSize: "0.5em",
      width: // For non-thermostat icons, only increase the width to match
      // thermostat icon width if there's an even number of icons greater
      // than 2, because the only reason we match the width is so that the
      // icons align vertically, but there's no vertical break when there's
      // only two icons, and alignment doesn't matter when we have an odd
      // number of icons, in fact the extra margin actually looks worse in
      // some cases.
      icons.length > 2 && icons.length % 2 === 0 && icons.some(function (icon) {
        return icon.name === "thermostat";
      }) ? "1.5em" : "1em"
    },
    thermostatIcon: {
      // The width for a thermostat icon is always 1.5em to accomodate the
      // temperature number next to the icon.
      width: "1.5em"
    },
    badge: {
      fontSize: "0.6rem"
    }
  });
  var fontSize = "";

  switch (icons.length) {
    case 2:
      {
        fontSize = "0.7em";
        break;
      }

    case 3:
    case 4:
      {
        fontSize = "0.6em";
        break;
      }

    case 5:
    case 6:
      {
        fontSize = "0.5em";
        break;
      }
  }

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
    className: className,
    style: styles.root,
    "data-component-name": "IconGroup"
  }, values.length > 1 ? {
    // Don't read Icon content when there's more than one icon in the
    // group, because some of those Icons might have temperatures, and
    // those temperature values don't really make sense in the tile
    // context without describing all the other icons. However, when
    // there's only one Icon in the group, we want to read temperatures,
    // because it makes sense at that level.
    "aria-hidden": true
  } : null), icons.map(function (icon) {
    var iconStyle = _objectSpread({}, styles.icon, {}, icon.name === "thermostat" ? styles.thermostatIcon : null, {
      fontSize: fontSize
    });

    if (icon.count > 1 && !disableBadges) {
      return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
        key: icon.key,
        style: styles.iconBadgeWrapper
      }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nx_components_Badge__["a" /* default */], {
        style: styles.badge
      }, icon.count), __WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](icon.element, {
        style: iconStyle
      }));
    } else {
      return __WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](icon.element, {
        style: iconStyle,
        key: icon.key
      });
    }
  }));
}

IconGroup.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  values: __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_CustomPropTypes__["a" /* default */].keyedElementList.isRequired,
  unique: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  disableBadges: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
IconGroup.defaultProps = {
  unique: true
};
/* harmony default export */ __webpack_exports__["a"] = (IconGroup);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = closeDialog;
/* harmony export (immutable) */ __webpack_exports__["a"] = closeAllDestroyableDialogs;
/* harmony export (immutable) */ __webpack_exports__["c"] = renderInDestroyableRoot;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


var dialogDestroyers = {};
var nextId = 0;
function closeDialog(key) {
  if (key in dialogDestroyers) {
    dialogDestroyers[key].destroyRoot();
    delete dialogDestroyers[key];
  } else {
    throw new Error("Attempted to close a dialog with key '".concat(key, "' that does not exist"));
  }
}
function closeAllDestroyableDialogs() {
  Object.keys(dialogDestroyers).forEach(closeDialog);
}
function renderInDestroyableRoot(renderCallback, dialogKey) {
  var key = dialogKey || "".concat(nextId++);
  var _document = document,
      body = _document.body;

  if (key in dialogDestroyers) {
    throw new Error("Attempted to show a dialog with key '".concat(key, "' that already exists"));
  }

  if (body == null) {
    throw new Error("Attempted to call renderInDestroyableRoot without a document.body");
  }

  var el = document.createElement("div");
  body.appendChild(el);

  var destroyRoot = function destroyRoot() {
    if (!el) {
      return;
    }

    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(el);
    body.removeChild(el);
    el = null;
  };

  __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(renderCallback(destroyRoot), el);
  dialogDestroyers[key] = {
    destroyRoot: destroyRoot
  };
}

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_mixins_device_features_access_code__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_mixins_device_features_action_buttons__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_mixins_device_features_activate_lock__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_mixins_device_features_advanced_info__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features_alarm__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_mixins_device_features_barrier__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_mixins_device_features_battery__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_mixins_device_features_button_pad__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_mixins_device_features_camera__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_mixins_device_features_colored__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_mixins_device_features_connection__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mixins_device_features_dimmer__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_mixins_device_features_dragonfly_wifi_configuration__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_mixins_device_features_fan__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_mixins_device_features_group__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_models_mixins_device_features_lock_lock__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_models_mixins_device_features_occupancy__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_models_mixins_device_features_pan_tilt__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_models_mixins_device_features_pivot__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_models_mixins_device_features_pivot_occupancy_mode__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_models_mixins_device_features_room_iq__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_models_mixins_device_features_runtime_history__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_nexia_mobile_models_mixins_device_features_schedule__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_nexia_mobile_models_mixins_device_features_sensor__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_nexia_mobile_models_mixins_device_features_solar_panel__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_nexia_mobile_models_mixins_device_features_speaker__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_nexia_mobile_models_mixins_device_features_sprinkler__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_nexia_mobile_models_mixins_device_features_streamable__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_nexia_mobile_models_mixins_device_features_switch__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_nexia_mobile_models_mixins_device_features_thermostat__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_nexia_mobile_models_mixins_device_features_thermostat_compressor_speed__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_nexia_mobile_models_mixins_device_features_thermostat_fan_mode__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_nexia_mobile_models_mixins_device_features_thermostat_mode__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_nexia_mobile_models_mixins_device_features_thermostat_run_mode__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_nexia_mobile_models_mixins_device_features_unenroll__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_nexia_mobile_models_mixins_device_features_unlock_lock__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_nexia_mobile_models_mixins_device_features_valve__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_nexia_mobile_models_mixins_device_features_window_shade_open_close_stop__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_nexia_mobile_models_mixins_device_features_window_shade_set_percent_open__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_nexia_mobile_models_mixins_device_features_xr724_wifi_configuration__ = __webpack_require__(998);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccessCode", function() { return __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_mixins_device_features_access_code__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ActionButtons", function() { return __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_mixins_device_features_action_buttons__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ActivateLock", function() { return __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_mixins_device_features_activate_lock__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AdvancedInfo", function() { return __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_mixins_device_features_advanced_info__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Alarm", function() { return __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features_alarm__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Barrier", function() { return __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_mixins_device_features_barrier__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Battery", function() { return __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_mixins_device_features_battery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonPad", function() { return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_mixins_device_features_button_pad__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Camera", function() { return __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_mixins_device_features_camera__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Colored", function() { return __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_mixins_device_features_colored__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Connection", function() { return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_mixins_device_features_connection__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dimmer", function() { return __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mixins_device_features_dimmer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DragonflyWifiConfiguration", function() { return __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_mixins_device_features_dragonfly_wifi_configuration__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Fan", function() { return __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_mixins_device_features_fan__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Group", function() { return __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_mixins_device_features_group__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LockLock", function() { return __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_models_mixins_device_features_lock_lock__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Occupancy", function() { return __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_models_mixins_device_features_occupancy__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PanTilt", function() { return __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_models_mixins_device_features_pan_tilt__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pivot", function() { return __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_models_mixins_device_features_pivot__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PivotOccupancyMode", function() { return __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_models_mixins_device_features_pivot_occupancy_mode__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RoomIq", function() { return __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_models_mixins_device_features_room_iq__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RuntimeHistory", function() { return __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_models_mixins_device_features_runtime_history__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Schedule", function() { return __WEBPACK_IMPORTED_MODULE_22_nexia_mobile_models_mixins_device_features_schedule__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sensor", function() { return __WEBPACK_IMPORTED_MODULE_23_nexia_mobile_models_mixins_device_features_sensor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SolarPanel", function() { return __WEBPACK_IMPORTED_MODULE_24_nexia_mobile_models_mixins_device_features_solar_panel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Speaker", function() { return __WEBPACK_IMPORTED_MODULE_25_nexia_mobile_models_mixins_device_features_speaker__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sprinkler", function() { return __WEBPACK_IMPORTED_MODULE_26_nexia_mobile_models_mixins_device_features_sprinkler__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Streamable", function() { return __WEBPACK_IMPORTED_MODULE_27_nexia_mobile_models_mixins_device_features_streamable__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_28_nexia_mobile_models_mixins_device_features_switch__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Thermostat", function() { return __WEBPACK_IMPORTED_MODULE_29_nexia_mobile_models_mixins_device_features_thermostat__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ThermostatCompressorSpeed", function() { return __WEBPACK_IMPORTED_MODULE_30_nexia_mobile_models_mixins_device_features_thermostat_compressor_speed__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ThermostatFanMode", function() { return __WEBPACK_IMPORTED_MODULE_31_nexia_mobile_models_mixins_device_features_thermostat_fan_mode__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ThermostatMode", function() { return __WEBPACK_IMPORTED_MODULE_32_nexia_mobile_models_mixins_device_features_thermostat_mode__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ThermostatRunMode", function() { return __WEBPACK_IMPORTED_MODULE_33_nexia_mobile_models_mixins_device_features_thermostat_run_mode__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Unenroll", function() { return __WEBPACK_IMPORTED_MODULE_34_nexia_mobile_models_mixins_device_features_unenroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UnlockLock", function() { return __WEBPACK_IMPORTED_MODULE_35_nexia_mobile_models_mixins_device_features_unlock_lock__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Valve", function() { return __WEBPACK_IMPORTED_MODULE_36_nexia_mobile_models_mixins_device_features_valve__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WindowShadeOpenCloseStop", function() { return __WEBPACK_IMPORTED_MODULE_37_nexia_mobile_models_mixins_device_features_window_shade_open_close_stop__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WindowShadeSetPercentOpen", function() { return __WEBPACK_IMPORTED_MODULE_38_nexia_mobile_models_mixins_device_features_window_shade_set_percent_open__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "XR724WifiConfiguration", function() { return __WEBPACK_IMPORTED_MODULE_39_nexia_mobile_models_mixins_device_features_xr724_wifi_configuration__["a"]; });
/*
TRANE CONFIDENTIAL

2017 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/










































/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

var _default = ownerDocument;
exports.default = _default;

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AppBarEmptyLeftIconPadding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AppBarIconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppBarButtonWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Tappable__ = __webpack_require__(28);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var APP_BAR_PADDING = 14.25;
var APP_BAR_HEIGHT = 52;
var APP_BAR_TITLE_SIZE = 17.1;
var APP_BAR_TITLE_WEIGHT = 300;
var APP_BAR_HEIGHT_LARGE = 76;
var APP_BAR_TITLE_SIZE_LARGE = 22.8;
var AppBarEmptyLeftIconPadding = function AppBarEmptyLeftIconPadding() {
  return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("span", {
    style: {
      height: APP_BAR_HEIGHT,
      paddingRight: APP_BAR_PADDING
    }
  });
};
var AppBarIconWrapper =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(AppBarIconWrapper, _React$Component);

  function AppBarIconWrapper() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, AppBarIconWrapper);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(AppBarIconWrapper).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(AppBarIconWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          children = _this$props.children,
          onTap = _this$props.onTap,
          _innerRef = _this$props.innerRef,
          holdActiveUntil = _this$props.holdActiveUntil,
          otherProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["name", "children", "onTap", "innerRef", "holdActiveUntil"]);

      var isLargeAppLayout = this.context && this.context.isLargeAppLayout;
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Tappable__["b" /* default */], {
        onTap: onTap,
        holdActiveUntil: holdActiveUntil
      }, function (_ref) {
        var active = _ref.active,
            tapTargetRefHandler = _ref.tapTargetRefHandler;
        var styles = Object(__WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["b" /* default */])({
          button: _objectSpread({
            height: APP_BAR_HEIGHT,
            outline: "none",
            paddingLeft: APP_BAR_PADDING / 2,
            paddingRight: APP_BAR_PADDING / 2,
            position: "relative"
          }, isLargeAppLayout ? {
            fontSize: "1.25em"
          } : null),
          activeDisplay: {
            backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_14__Tappable__["c" /* simpleActiveBackgroundColor */])(active),
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: APP_BAR_PADDING / 2
          },
          iconWrapper: {
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white"
          }
        });
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__NoStyleButton__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          "data-component-prop-name": name,
          style: styles.button,
          innerRef: function innerRef(el) {
            if (typeof _innerRef === "function") {
              _innerRef(el);
            }

            tapTargetRefHandler(el);
          }
        }, otherProps), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
          style: styles.activeDisplay
        }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
          style: styles.iconWrapper
        }, children)));
      });
    }
  }]);

  return AppBarIconWrapper;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AppBarIconWrapper, "contextTypes", {
  isLargeAppLayout: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AppBarIconWrapper, "propTypes", {
  name: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node,
  onTap: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  innerRef: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  holdActiveUntil: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
});

var AppBarButtonWrapper =
/*#__PURE__*/
function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(AppBarButtonWrapper, _React$Component2);

  function AppBarButtonWrapper() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, AppBarButtonWrapper);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(AppBarButtonWrapper).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(AppBarButtonWrapper, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var isLargeAppLayout = this.context && this.context.isLargeAppLayout;
      var style = {
        fontSize: isLargeAppLayout ? "1.0em" : ".7em",
        marginLeft: __WEBPACK_IMPORTED_MODULE_13__Theme__["a" /* default */].Padding.APP_BAR_BUTTON,
        marginRight: __WEBPACK_IMPORTED_MODULE_13__Theme__["a" /* default */].Padding.APP_BAR_BUTTON
      };
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("span", {
        style: style
      }, children);
    }
  }]);

  return AppBarButtonWrapper;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AppBarButtonWrapper, "contextTypes", {
  isLargeAppLayout: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AppBarButtonWrapper, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node
});

var AppBar =
/*#__PURE__*/
function (_React$Component3) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(AppBar, _React$Component3);

  function AppBar() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, AppBar);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(AppBar).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(AppBar, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          title = _this$props2.title,
          iconLeft = _this$props2.iconLeft,
          iconRight = _this$props2.iconRight,
          colors = _this$props2.colors;
      var isLargeAppLayout = this.context && this.context.isLargeAppLayout;
      var leftSafePadding = isLargeAppLayout ? "0px" : __WEBPACK_IMPORTED_MODULE_13__Theme__["a" /* default */].Padding.SAFE_AREA_LEFT;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["b" /* default */])({
        container: {
          backgroundColor: colors.PRIMARY,
          backgroundImage: "linear-gradient(35deg, ".concat(colors.PRIMARY_GRADIENT_DARK, ", ").concat(colors.PRIMARY_GRADIENT_LIGHT, ")"),
          color: colors.PRIMARY_TEXT,
          paddingTop: __WEBPACK_IMPORTED_MODULE_13__Theme__["a" /* default */].Padding.SAFE_AREA_TOP,
          height: "calc(".concat(isLargeAppLayout ? APP_BAR_HEIGHT_LARGE : APP_BAR_HEIGHT, "px + ").concat(__WEBPACK_IMPORTED_MODULE_13__Theme__["a" /* default */].Padding.SAFE_AREA_TOP, ")"),
          marginLeft: "calc(-1 * ".concat(leftSafePadding, ")"),
          paddingLeft: leftSafePadding,
          marginRight: "calc(-1 * ".concat(__WEBPACK_IMPORTED_MODULE_13__Theme__["a" /* default */].Padding.SAFE_AREA_RIGHT, ")"),
          paddingRight: __WEBPACK_IMPORTED_MODULE_13__Theme__["a" /* default */].Padding.SAFE_AREA_RIGHT,
          display: "flex",
          alignItems: "center",
          userSelect: "none"
        },
        title: {
          flex: "1 1 auto",
          fontWeight: APP_BAR_TITLE_WEIGHT,
          fontSize: isLargeAppLayout ? APP_BAR_TITLE_SIZE_LARGE : APP_BAR_TITLE_SIZE,
          paddingLeft: iconLeft ? 0 : APP_BAR_PADDING,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          lineHeight: "normal"
        },
        icon: {
          flex: "0 0 auto",
          fontSize: 19,
          color: colors.SECONDARY
        }
      });
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        "data-component-name": "AppBar",
        style: styles.container
      }, iconLeft ? __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("span", {
        style: styles.icon
      }, iconLeft) : __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](AppBarEmptyLeftIconPadding, null), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("span", {
        style: styles.title
      }, title), iconRight && __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("span", {
        style: styles.icon
      }, iconRight));
    }
  }]);

  return AppBar;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AppBar, "contextTypes", {
  isLargeAppLayout: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AppBar, "propTypes", {
  title: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node,
  iconLeft: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node,
  iconRight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["d"] = (Object(__WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["c" /* withColorsProvider */])(AppBar));



/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sleep;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enqueueIn__ = __webpack_require__(59);

function sleep(ms) {
  return new Promise(function (resolve) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__enqueueIn__["b" /* default */])(resolve, ms);
  });
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_event_collection__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_mixins_editable__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_mixins_has_icon__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);













var Automation =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Automation, _BaseModel);

  function Automation() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Automation);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Automation).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Automation, [{
    key: "nestedCollections",
    value: function nestedCollections() {
      return {
        events: {
          collection: __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_event_collection__["a" /* default */]
        }
      };
    }
  }, {
    key: "initialize",
    value: function initialize() {
      __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Automation.prototype), "initialize", this).call(this);

      this._connectShownOnDashboardAttribute();
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        name: this.get("name"),
        // TODO: shouldnt have to stringify 'enabled', but endpoint is only
        // working with string values for false
        enabled: JSON.stringify(this.get("enabled"))
      };
    }
  }, {
    key: "activate",
    value: function activate() {
      var _this = this;

      return this.postCommand("activate").then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_flux_like_dispatch__["a" /* default */])("DEMO_MODE_EVENT", _this, "Activated automation");
      });
    }
  }, {
    key: "parseLinksFilterEvents",
    value: function parseLinksFilterEvents(links) {
      var link = _.first(links);

      if (link) {
        this.set("filterEventsUrl", link.getHref());
      }
    }
  }, {
    key: "isNameEditable",
    value: function isNameEditable() {
      return true;
    }
  }, {
    key: "_connectShownOnDashboardAttribute",
    value: function _connectShownOnDashboardAttribute() {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_local_settings__["c" /* default */].getAutomationShownOnDashboard(this._numericId())) {
        this.set("shownOnDashboard", true);
      } else {
        this.set("shownOnDashboard", false);
      }

      this.on("change:shownOnDashboard", function () {
        var bool = Boolean(_this2.get("shownOnDashboard"));
        __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_local_settings__["c" /* default */].setAutomationShownOnDashboard(_this2._numericId(), bool);
      });
    }
  }, {
    key: "_numericId",
    value: function _numericId() {
      var url = this.get("id");
      var urlParts = url.split("/");
      var lastPart = urlParts[urlParts.length - 1];
      return Number(lastPart);
    }
  }]);

  return Automation;
}(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__["a" /* default */]);

_.extend(Automation.prototype, __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_mixins_editable__["a" /* default */]);

_.extend(Automation.prototype, __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_mixins_has_icon__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Automation);

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(306),
    getRawTag = __webpack_require__(1033),
    objectToString = __webpack_require__(1034);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 151 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DrawUpdates; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);











// For debugging; flashes an inset box-shadow on the target DOM element when
// Backbone events occur. Enable with the support code "draw_updates"
var DrawUpdates =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(DrawUpdates, _React$Component);

  function DrawUpdates() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DrawUpdates);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DrawUpdates)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_flash", function () {
      if (!__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].getDrawUpdates()) {
        _this._stopListening(_this.props);

        return;
      }

      var el = _this.props.getNodeToStyle();

      if (el == null) {
        return;
      }

      el.style.boxShadow = "inset 0 0 4px red";
      setTimeout(function () {
        el.style.boxShadow = "";
      }, 200);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DrawUpdates, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._startListening(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._stopListening(this.props);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.listenTo === this.props.listenTo) {
        return;
      }

      this._stopListening(this.props);

      this._startListening(nextProps);
    }
  }, {
    key: "_startListening",
    value: function _startListening(props) {
      if (!__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].getDrawUpdates()) {
        return;
      }

      props.listenTo.on(props.events.join(" "), this._flash, this);
    }
  }, {
    key: "_stopListening",
    value: function _stopListening(props) {
      props.listenTo.off(null, null, this);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return DrawUpdates;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(DrawUpdates, "propTypes", {
  listenTo: function listenTo() {
    return (typeof (__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Events == null ? {} : __WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Events) === "function" ? __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Events == null ? {} : __WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Events).isRequired : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  // False positive
  // eslint-disable-next-line react/no-unused-prop-types
  events: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired).isRequired,
  getNodeToStyle: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired
});




/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(61);
var global = __webpack_require__(21);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(99) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(68);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 155 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(19);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(19);
var aFunction = __webpack_require__(50);
var SPECIES = __webpack_require__(29)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Collection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_utils_sleep__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Routing_HistoryPageTransitionController__ = __webpack_require__(89);












var Collection =
/*#__PURE__*/
function (_Backbone$Collection) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Collection, _Backbone$Collection);

  function Collection() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Collection);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Collection).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Collection, [{
    key: "set",
    value: function set(models, options) {
      if (options && options.hasOwnProperty("asyncParseDelay")) {
        return this.setAsync(models, options);
      } else {
        return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Collection.prototype), "set", this).call(this, models, options);
      }
    } // Duplicated from Backbone with sorting stuff removed, edited to support async

  }, {
    key: "setAsync",
    value: function setAsync(passedModels, passedOptions) {
      var models, options, singular, at, set, toAdd, toMerge, toRemove, modelMap, add, merge, remove, model, i, existing, attrs, replace, _this$models, index;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.async(function setAsync$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(Promise.resolve());

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Routing_HistoryPageTransitionController__["a" /* getTransitionPromise */])());

            case 4:
              models = passedModels;
              options = passedOptions;

              if (!(models == null)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", undefined);

            case 8:
              options = _.extend({
                add: true,
                remove: true,
                merge: true
              }, options);

              if (!(options.parse && !this._isModel(models))) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(this._parseModelsAsync(models, options));

            case 12:
              models = _context.sent;

            case 13:
              singular = !_.isArray(models);
              models = singular ? [models] : models.slice();
              at = options.at;

              if (at != null) {
                at = Number(at);
              }

              if (at > this.length) {
                at = this.length;
              }

              if (at < 0) {
                at += this.length + 1;
              }

              set = [];
              toAdd = [];
              toMerge = [];
              toRemove = [];
              modelMap = {};
              add = options.add;
              merge = options.merge;
              remove = options.remove; // Turn bare objects into model references, and prevent invalid models
              // from being added.

              i = 0;

            case 28:
              if (!(i < models.length)) {
                _context.next = 50;
                break;
              }

              _context.next = 31;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Routing_HistoryPageTransitionController__["a" /* getTransitionPromise */])());

            case 31:
              model = models[i]; // If a duplicate is found, prevent it from being added and
              // optionally merge it into the existing model.

              existing = this.get(model);

              if (!existing) {
                _context.next = 46;
                break;
              }

              if (!(merge && model !== existing)) {
                _context.next = 42;
                break;
              }

              attrs = this._isModel(model) ? model.attributes : model;

              if (!options.parse) {
                _context.next = 40;
                break;
              }

              _context.next = 39;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(existing.parse(attrs, options));

            case 39:
              attrs = _context.sent;

            case 40:
              existing.set(attrs, options);
              toMerge.push(existing);

            case 42:
              if (!modelMap[existing.cid]) {
                modelMap[existing.cid] = true;
                set.push(existing);
              }

              models[i] = existing; // If this is a new, valid model, push it to the `toAdd` list.

              _context.next = 47;
              break;

            case 46:
              if (add) {
                models[i] = this._prepareModel(model, options);
                model = models[i];

                if (model) {
                  toAdd.push(model);

                  this._addReference(model, options);

                  modelMap[model.cid] = true;
                  set.push(model);
                }
              }

            case 47:
              i++;
              _context.next = 28;
              break;

            case 50:
              // Remove stale models.
              if (remove) {
                for (i = 0; i < this.length; i++) {
                  model = this.models[i];

                  if (!modelMap[model.cid]) {
                    toRemove.push(model);
                  }
                }

                if (toRemove.length) {
                  this._removeModels(toRemove, options);
                }
              }

              replace = add && remove;

              if (set.length && replace) {
                this.models = set;
                this.length = this.models.length;
              } else if (toAdd.length) {
                index = at == null ? this.length : at;

                (_this$models = this.models).splice.apply(_this$models, [index, 0].concat(toAdd));

                this.length = this.models.length;
              } // Unless silenced, it's time to fire all appropriate add/sort/update events.


              if (!options.silent) {
                for (i = 0; i < toAdd.length; i++) {
                  if (at != null) {
                    options.index = at + i;
                  }

                  model = toAdd[i];
                  model.trigger("add", model, this, options);
                }

                if (toAdd.length || toRemove.length || toMerge.length) {
                  options.changes = {
                    added: toAdd,
                    removed: toRemove,
                    merged: toMerge
                  };
                  this.trigger("update", this, options);
                }
              } // Return the added (or merged) model (or models).


              return _context.abrupt("return", singular ? models[0] : models);

            case 55:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "parse",
    value: function parse(obj) {
      if (!this.model || !(obj instanceof Array)) {
        return obj;
      }

      var ModelClass = this.model;
      return obj.map(function (item) {
        return new ModelClass(item, {
          parse: true
        });
      });
    }
  }, {
    key: "_parseModelsAsync",
    value: function _parseModelsAsync(obj, options) {
      var ModelClass, models, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, model;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.async(function _parseModelsAsync$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this._warnIfSubclassInvalid();

              if (!(!this.model || !(obj instanceof Array))) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", obj);

            case 3:
              ModelClass = this.model;
              models = [];
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context2.prev = 8;
              _iterator = obj[Symbol.iterator]();

            case 10:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context2.next = 19;
                break;
              }

              item = _step.value;
              _context2.next = 14;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(Object(__WEBPACK_IMPORTED_MODULE_9_nx_components_utils_sleep__["a" /* default */])(options.asyncParseDelay));

            case 14:
              model = new ModelClass(item, {
                parse: true
              });
              models.push(model);

            case 16:
              _iteratorNormalCompletion = true;
              _context2.next = 10;
              break;

            case 19:
              _context2.next = 25;
              break;

            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](8);
              _didIteratorError = true;
              _iteratorError = _context2.t0;

            case 25:
              _context2.prev = 25;
              _context2.prev = 26;

              if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
              }

            case 28:
              _context2.prev = 28;

              if (!_didIteratorError) {
                _context2.next = 31;
                break;
              }

              throw _iteratorError;

            case 31:
              return _context2.finish(28);

            case 32:
              return _context2.finish(25);

            case 33:
              return _context2.abrupt("return", models);

            case 34:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this, [[8, 21, 25, 33], [26,, 28, 32]]);
    }
  }, {
    key: "_warnIfSubclassInvalid",
    value: function _warnIfSubclassInvalid() {
      var subclass = Object.getPrototypeOf(this);

      if (subclass.hasOwnProperty("parse") && !subclass.hasOwnProperty("_parseModelsAsync")) {
        console.error("Subclass ".concat(this.constructor.name, " implements parse but not _parseModelsAsync"));
      }

      if (subclass.hasOwnProperty("_parseModelsAsync") && !subclass.hasOwnProperty("parse")) {
        console.error("Subclass ".concat(this.constructor.name, " implements _parseModelsAsync but not parse"));
      }
    }
  }, {
    key: "setSortAttribute",
    value: function setSortAttribute(attr, direction) {
      // TODO: what about server-side sorting for paged collections?
      // perhaps do something entirely different here if this collection came from
      // a media type that supports sorted server queries...
      this.comparator = function (model) {
        return model.get(attr);
      };

      if (_.isString(direction)) {
        this._sortDirection = direction.toUpperCase();
      }
    }
  }, {
    key: "sortBy",
    value: function sortBy(iterator, context) {
      var obj = this.models;
      var direction = this._sortDirection || this.constructor.Sort.ASC;
      return _.pluck(_.map(obj, function (value, index, list) {
        return {
          value: value,
          index: index,
          criteria: iterator.call(context, value, index, list)
        };
      }).sort(function (left, right) {
        // swap a and b for reverse sort
        var criteriaA = direction === "ASC" ? left.criteria : right.criteria;
        var criteriaB = direction === "ASC" ? right.criteria : left.criteria;

        if (criteriaA !== criteriaB) {
          if (criteriaA > criteriaB || criteriaA === undefined) {
            return 1;
          }

          if (criteriaA < criteriaB || criteriaB === undefined) {
            return -1;
          }
        }

        return left.index < right.index ? -1 : 1;
      }), "value");
    }
  }]);

  return Collection;
}(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Collection);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Collection, "Sort", {
  ASC: "ASC",
  DESC: "DESC"
});



/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(817);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(197),
    getRawTag = __webpack_require__(832),
    objectToString = __webpack_require__(833);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(207);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(427);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(140);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(909);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    var _this = this;

    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.update = function (name, data) {
      var _options = _this.options,
          plugins = _options.jss.plugins,
          sheet = _options.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, _this.get(name), sheet);
      } else {
        for (var index = 0; index < _this.index.length; index++) {
          plugins.onUpdate(name, _this.index[index], sheet);
        }
      }
    };

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options2 = this.options,
          parent = _options2.parent,
          sheet = _options2.sheet,
          jss = _options2.jss,
          Renderer = _options2.Renderer,
          generateClassName = _options2.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'link',


    /**
     * Link renderable rules with CSSRuleList.
     */
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(211).Buffer))

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_ErrorHandler__ = __webpack_require__(98);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function TileBody(_ref) {
  var children = _ref.children,
      hasControls = _ref.hasControls,
      header = _ref.header,
      onMouseDown = _ref.onMouseDown,
      onTouchStart = _ref.onTouchStart,
      backgroundStyle = _ref.backgroundStyle,
      innerRef = _ref.innerRef;
  var styles = {
    body: _objectSpread({
      cursor: "pointer",
      width: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      bottom: hasControls ? "3em" : 0
    }, backgroundStyle),
    verticalCenter: {
      width: "100%",
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)"
    }
  };
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_ErrorHandler__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nx_components_NoStyleButton__["a" /* default */], {
    style: styles.body,
    onMouseDown: onMouseDown,
    onTouchStart: onTouchStart,
    innerRef: innerRef
  }, header, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    style: styles.verticalCenter
  }, children)));
}

TileBody.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  hasControls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  header: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  backgroundStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  innerRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (TileBody);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return number; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return scale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alpha; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return degrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return percent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return progressPercentage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return px; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return vw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return vh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return rgba; });
/* unused harmony export rgbUnit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hsla; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return color; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return complex; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var clamp = function (min, max) { return function (v) {
    return Math.max(Math.min(v, max), min);
}; };
var sanitize = function (v) { return (v % 1 ? Number(v.toFixed(5)) : v); };
var floatRegex = /(-)?(\d[\d\.]*)/g;
var colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))$/i;

var number = {
    test: function (v) { return typeof v === 'number'; },
    parse: parseFloat,
    transform: function (v) { return v; }
};
var alpha = __assign(__assign({}, number), { transform: clamp(0, 1) });
var scale = __assign(__assign({}, number), { default: 1 });

var createUnitType = function (unit) { return ({
    test: function (v) {
        return typeof v === 'string' && v.endsWith(unit) && v.split(' ').length === 1;
    },
    parse: parseFloat,
    transform: function (v) { return "" + v + unit; }
}); };
var degrees = createUnitType('deg');
var percent = createUnitType('%');
var px = createUnitType('px');
var vh = createUnitType('vh');
var vw = createUnitType('vw');
var progressPercentage = __assign(__assign({}, percent), { parse: function (v) { return percent.parse(v) / 100; }, transform: function (v) { return percent.transform(v * 100); } });

var getValueFromFunctionString = function (value) {
    return value.substring(value.indexOf('(') + 1, value.lastIndexOf(')'));
};
var clampRgbUnit = clamp(0, 255);
var isRgba = function (v) { return v.red !== undefined; };
var isHsla = function (v) { return v.hue !== undefined; };
var splitColorValues = function (terms) {
    return function (v) {
        if (typeof v !== 'string')
            return v;
        var values = {};
        var valuesArray = getValueFromFunctionString(v).split(/,\s*/);
        for (var i = 0; i < 4; i++) {
            values[terms[i]] =
                valuesArray[i] !== undefined ? parseFloat(valuesArray[i]) : 1;
        }
        return values;
    };
};
var rgbaTemplate = function (_a) {
    var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$$1 = _b === void 0 ? 1 : _b;
    return "rgba(" + red + ", " + green + ", " + blue + ", " + alpha$$1 + ")";
};
var hslaTemplate = function (_a) {
    var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$$1 = _b === void 0 ? 1 : _b;
    return "hsla(" + hue + ", " + saturation + ", " + lightness + ", " + alpha$$1 + ")";
};
var rgbUnit = __assign(__assign({}, number), { transform: function (v) { return Math.round(clampRgbUnit(v)); } });
function isColorString(color, colorType) {
    return color.startsWith(colorType) && singleColorRegex.test(color);
}
var rgba = {
    test: function (v) { return (typeof v === 'string' ? isColorString(v, 'rgb') : isRgba(v)); },
    parse: splitColorValues(['red', 'green', 'blue', 'alpha']),
    transform: function (_a) {
        var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$$1 = _b === void 0 ? 1 : _b;
        return rgbaTemplate({
            red: rgbUnit.transform(red),
            green: rgbUnit.transform(green),
            blue: rgbUnit.transform(blue),
            alpha: sanitize(alpha.transform(alpha$$1))
        });
    }
};
var hsla = {
    test: function (v) { return (typeof v === 'string' ? isColorString(v, 'hsl') : isHsla(v)); },
    parse: splitColorValues(['hue', 'saturation', 'lightness', 'alpha']),
    transform: function (_a) {
        var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$$1 = _b === void 0 ? 1 : _b;
        return hslaTemplate({
            hue: Math.round(hue),
            saturation: percent.transform(sanitize(saturation)),
            lightness: percent.transform(sanitize(lightness)),
            alpha: sanitize(alpha.transform(alpha$$1))
        });
    }
};
var hex = __assign(__assign({}, rgba), { test: function (v) { return typeof v === 'string' && isColorString(v, '#'); }, parse: function (v) {
        var r = '';
        var g = '';
        var b = '';
        if (v.length > 4) {
            r = v.substr(1, 2);
            g = v.substr(3, 2);
            b = v.substr(5, 2);
        }
        else {
            r = v.substr(1, 1);
            g = v.substr(2, 1);
            b = v.substr(3, 1);
            r += r;
            g += g;
            b += b;
        }
        return {
            red: parseInt(r, 16),
            green: parseInt(g, 16),
            blue: parseInt(b, 16),
            alpha: 1
        };
    } });
var color = {
    test: function (v) {
        return (typeof v === 'string' && singleColorRegex.test(v)) ||
            isRgba(v) ||
            isHsla(v);
    },
    parse: function (v) {
        if (rgba.test(v)) {
            return rgba.parse(v);
        }
        else if (hsla.test(v)) {
            return hsla.parse(v);
        }
        else if (hex.test(v)) {
            return hex.parse(v);
        }
        return v;
    },
    transform: function (v) {
        if (isRgba(v)) {
            return rgba.transform(v);
        }
        else if (isHsla(v)) {
            return hsla.transform(v);
        }
        return v;
    }
};

var COLOR_TOKEN = '${c}';
var NUMBER_TOKEN = '${n}';
var convertNumbersToZero = function (v) {
    return typeof v === 'number' ? 0 : v;
};
var complex = {
    test: function (v) {
        if (typeof v !== 'string' || !isNaN(v))
            return false;
        var numValues = 0;
        var foundNumbers = v.match(floatRegex);
        var foundColors = v.match(colorRegex);
        if (foundNumbers)
            numValues += foundNumbers.length;
        if (foundColors)
            numValues += foundColors.length;
        return numValues > 0;
    },
    parse: function (v) {
        var input = v;
        var parsed = [];
        var foundColors = input.match(colorRegex);
        if (foundColors) {
            input = input.replace(colorRegex, COLOR_TOKEN);
            parsed.push.apply(parsed, foundColors.map(color.parse));
        }
        var foundNumbers = input.match(floatRegex);
        if (foundNumbers) {
            parsed.push.apply(parsed, foundNumbers.map(number.parse));
        }
        return parsed;
    },
    createTransformer: function (prop) {
        var template = prop;
        var token = 0;
        var foundColors = prop.match(colorRegex);
        var numColors = foundColors ? foundColors.length : 0;
        if (foundColors) {
            for (var i = 0; i < numColors; i++) {
                template = template.replace(foundColors[i], COLOR_TOKEN);
                token++;
            }
        }
        var foundNumbers = template.match(floatRegex);
        var numNumbers = foundNumbers ? foundNumbers.length : 0;
        if (foundNumbers) {
            for (var i = 0; i < numNumbers; i++) {
                template = template.replace(foundNumbers[i], NUMBER_TOKEN);
                token++;
            }
        }
        return function (v) {
            var output = template;
            for (var i = 0; i < token; i++) {
                output = output.replace(i < numColors ? COLOR_TOKEN : NUMBER_TOKEN, i < numColors ? color.transform(v[i]) : sanitize(v[i]));
            }
            return output;
        };
    },
    getAnimatableNone: function (target) {
        var parsedTarget = complex.parse(target);
        var targetTransformer = complex.createTransformer(target);
        return targetTransformer(parsedTarget.map(convertNumbersToZero));
    }
};




/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reversed */
/* unused harmony export mirrored */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createReversedEasing; });
/* unused harmony export createMirroredEasing */
/* unused harmony export createExpoIn */
/* unused harmony export createBackIn */
/* unused harmony export createAnticipateEasing */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return linear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return easeIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return easeOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return easeInOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return circIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return circOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return circInOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return backIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return backOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return backInOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return anticipate; });
/* unused harmony export bounceOut */
/* unused harmony export bounceIn */
/* unused harmony export bounceInOut */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return cubicBezier; });
var DEFAULT_OVERSHOOT_STRENGTH = 1.525;
var reversed = function (easing) {
    return function (p) {
        return 1 - easing(1 - p);
    };
};
var mirrored = function (easing) {
    return function (p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};
var createReversedEasing = reversed;
var createMirroredEasing = mirrored;
var createExpoIn = function (power) {
    return function (p) {
        return Math.pow(p, power);
    };
};
var createBackIn = function (power) {
    return function (p) {
        return p * p * ((power + 1) * p - power);
    };
};
var createAnticipateEasing = function (power) {
    var backEasing = createBackIn(power);
    return function (p) {
        return (p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
    };
};
var linear = function (p) {
    return p;
};
var easeIn = /*#__PURE__*/createExpoIn(2);
var easeOut = /*#__PURE__*/reversed(easeIn);
var easeInOut = /*#__PURE__*/mirrored(easeIn);
var circIn = function (p) {
    return 1 - Math.sin(Math.acos(p));
};
var circOut = /*#__PURE__*/reversed(circIn);
var circInOut = /*#__PURE__*/mirrored(circOut);
var backIn = /*#__PURE__*/createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
var backOut = /*#__PURE__*/reversed(backIn);
var backInOut = /*#__PURE__*/mirrored(backIn);
var anticipate = /*#__PURE__*/createAnticipateEasing(DEFAULT_OVERSHOOT_STRENGTH);
var BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
var BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
var BOUNCE_THIRD_THRESHOLD = 9.0 / 10.0;
var ca = 4356.0 / 361.0;
var cb = 35442.0 / 1805.0;
var cc = 16061.0 / 1805.0;
var bounceOut = function (p) {
    var p2 = p * p;
    return p < BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < BOUNCE_THIRD_THRESHOLD ? ca * p2 - cb * p + cc : 10.8 * p * p - 20.52 * p + 10.72;
};
var bounceIn = function (p) {
    return 1.0 - bounceOut(1.0 - p);
};
var bounceInOut = function (p) {
    return p < 0.5 ? 0.5 * (1.0 - bounceOut(1.0 - p * 2.0)) : 0.5 * bounceOut(p * 2.0 - 1.0) + 0.5;
};
var NEWTON_ITERATIONS = 8;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;
var K_SPLINE_TABLE_SIZE = 11;
var K_SAMPLE_STEP_SIZE = 1.0 / (K_SPLINE_TABLE_SIZE - 1.0);
var FLOAT_32_SUPPORTED = typeof Float32Array !== 'undefined';
var a = function (a1, a2) {
    return 1.0 - 3.0 * a2 + 3.0 * a1;
};
var b = function (a1, a2) {
    return 3.0 * a2 - 6.0 * a1;
};
var c = function (a1) {
    return 3.0 * a1;
};
var getSlope = function (t, a1, a2) {
    return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1);
};
var calcBezier = function (t, a1, a2) {
    return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
};
function cubicBezier(mX1, mY1, mX2, mY2) {
    var sampleValues = FLOAT_32_SUPPORTED ? new Float32Array(K_SPLINE_TABLE_SIZE) : new Array(K_SPLINE_TABLE_SIZE);
    var binarySubdivide = function (aX, aA, aB) {
        var i = 0;
        var currentX;
        var currentT;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) {
                aB = currentT;
            } else {
                aA = currentT;
            }
        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    };
    var newtonRaphsonIterate = function (aX, aGuessT) {
        var i = 0;
        var currentSlope = 0;
        var currentX;
        for (; i < NEWTON_ITERATIONS; ++i) {
            currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) {
                return aGuessT;
            }
            currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    };
    var calcSampleValues = function () {
        for (var i = 0; i < K_SPLINE_TABLE_SIZE; ++i) {
            sampleValues[i] = calcBezier(i * K_SAMPLE_STEP_SIZE, mX1, mX2);
        }
    };
    var getTForX = function (aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = K_SPLINE_TABLE_SIZE - 1;
        var dist = 0.0;
        var guessForT = 0.0;
        var initialSlope = 0.0;
        for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
            intervalStart += K_SAMPLE_STEP_SIZE;
        }
        --currentSample;
        dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        guessForT = intervalStart + dist * K_SAMPLE_STEP_SIZE;
        initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= NEWTON_MIN_SLOPE) {
            return newtonRaphsonIterate(aX, guessForT);
        } else if (initialSlope === 0.0) {
            return guessForT;
        } else {
            return binarySubdivide(aX, intervalStart, intervalStart + K_SAMPLE_STEP_SIZE);
        }
    };
    calcSampleValues();
    var resolver = function (aX) {
        var returnValue;
        if (mX1 === mY1 && mX2 === mY2) {
            returnValue = aX;
        } else if (aX === 0) {
            returnValue = 0;
        } else if (aX === 1) {
            returnValue = 1;
        } else {
            returnValue = calcBezier(getTForX(aX), mY1, mY2);
        }
        return returnValue;
    };
    return resolver;
}




/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = showConfirmationDialog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_Dialog__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Dialogs_renderInDestroyableRoot__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nx_components_Locales__ = __webpack_require__(44);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var ConfirmationDialog = function ConfirmationDialog(_ref) {
  var cancelButtonText = _ref.cancelButtonText,
      confirmButtonText = _ref.confirmButtonText,
      message = _ref.message,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      onClickBackground = _ref.onClickBackground,
      onRequestClose = _ref.onRequestClose,
      open = _ref.open,
      cancelOnBackgroundClick = _ref.cancelOnBackgroundClick,
      cancelOnRequestClose = _ref.cancelOnRequestClose,
      cancelByDefault = _ref.cancelByDefault;
  var localeSet = Object(__WEBPACK_IMPORTED_MODULE_7_nx_components_Locales__["b" /* getLanguageSet */])();
  var language = localeSet.nexia_mobile.dialogs.ConfirmationDialog;
  cancelButtonText = cancelButtonText || language.defaultCancelText;
  confirmButtonText = confirmButtonText || language.defaultConfirmText;
  var onBackgroundHandler = onClickBackground;

  if (cancelOnBackgroundClick) {
    onBackgroundHandler = function onBackgroundHandler() {
      if (_.isFunction(onClickBackground)) {
        onClickBackground();
      }

      onCancel();
    };
  }

  var onRequestCloseHandler = onRequestClose;

  if (cancelOnRequestClose) {
    onRequestCloseHandler = function onRequestCloseHandler() {
      if (_.isFunction(onRequestClose)) {
        onRequestClose();
      }

      onCancel();
    };
  }

  var styles = {
    container: {
      margin: "1em",
      minWidth: "10em",
      whiteSpace: "pre-line",
      maxWidth: "80vw",
      overflow: "hidden"
    },
    buttonWrapper: {
      textAlign: "center",
      marginTop: "1em",
      marginLeft: "1em",
      marginRight: "1em"
    },
    button: {
      margin: "0.2em 0.1em"
    }
  };
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nx_components_Dialog__["a" /* default */], {
    open: open,
    onTapBackground: onBackgroundHandler,
    onRequestClose: onRequestCloseHandler
  }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    style: styles.container
  }, message, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    style: styles.buttonWrapper
  }, cancelByDefault ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
    onTap: onConfirm,
    theme: "ghost",
    style: styles.button
  }, confirmButtonText), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
    onTap: onCancel,
    style: styles.button
  }, cancelButtonText)) : __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
    onTap: onCancel,
    theme: "ghost",
    style: styles.button
  }, cancelButtonText), __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
    onTap: onConfirm,
    style: styles.button
  }, confirmButtonText)))));
};

ConfirmationDialog.propTypes = {
  cancelButtonText: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  confirmButtonText: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  message: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  onConfirm: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  onClickBackground: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onRequestClose: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  cancelOnBackgroundClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  cancelOnRequestClose: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  cancelByDefault: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
ConfirmationDialog.defaultProps = {
  cancelOnBackgroundClick: true,
  cancelOnRequestClose: true
}; // This method creates a destroyable <div> to mount the ConfirmationDialog in when
// there's no existing React context, like for a Backbone View.
// Usage:
// showConfirmationDialog({
//   message: "Are you sure?",
//   confirmButtonText: "Yes I'm sure",
//   cancelButtonText: "No way",
//   cancelOnBackgroundClick: false, // Background clicks will not close the dialog
//   cancelOnRequestClose: true, // Pressing Esc or Back (On Android, Win10) will not close the dialog
//   onConfirm: () => { doIt(); }
// });

function showConfirmationDialog(options, key) {
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Dialogs_renderInDestroyableRoot__["c" /* default */])(function (destroyRoot) {
    var dialogProps = _objectSpread({}, options);

    dialogProps.onConfirm = function () {
      destroyRoot();

      if (_.isFunction(options.onConfirm)) {
        options.onConfirm();
      }
    };

    dialogProps.onCancel = function () {
      destroyRoot();

      if (_.isFunction(options.onCancel)) {
        options.onCancel();
      }
    };

    return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ConfirmationDialog, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, dialogProps, {
      open: true
    }));
  }, key);
}
/* harmony default export */ __webpack_exports__["a"] = (ConfirmationDialog);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_Spinner__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var SpinnerOverlay = function SpinnerOverlay(props) {
  var message = props.message,
      backgroundAlpha = props.backgroundAlpha,
      colors = props.colors;
  var styles = {
    background: {
      cursor: "default",
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: 99998
    },
    wrapper: {
      position: "absolute",
      width: "128px",
      height: "128px",
      top: "calc(50% - 64px)",
      left: "calc(50% - 64px)"
    },
    message: {
      position: "absolute",
      top: "calc(50% + 2.75em)",
      left: "0",
      right: "0",
      textAlign: "center",
      zIndex: "99999",
      color: colors.PRIMARY,
      padding: "0 1em 1em 1em",
      fontSize: "1.25em"
    }
  };

  var backgroundStyle = _objectSpread({}, styles.background, {
    backgroundColor: "rgba(255, 255, 255, ".concat(backgroundAlpha, ")")
  });

  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    style: backgroundStyle,
    "data-component-name": "SpinnerOverlay"
  }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    style: styles.wrapper
  }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nx_components_Spinner__["a" /* default */], null)), message ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    style: styles.message
  }, message) : null);
};

SpinnerOverlay.propTypes = {
  message: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  backgroundAlpha: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
};
SpinnerOverlay.defaultProps = {
  backgroundAlpha: 0.75
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_ColorsProvider__["c" /* withColorsProvider */])(SpinnerOverlay));


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SSID; });
/* harmony export (immutable) */ __webpack_exports__["e"] = is724ConfigurationPossible;
/* harmony export (immutable) */ __webpack_exports__["b"] = currentlyConfiguring724;
/* unused harmony export parseWifiNetworksCSV */
/* harmony export (immutable) */ __webpack_exports__["d"] = getVisibleWifiNetworks;
/* harmony export (immutable) */ __webpack_exports__["g"] = verifyConnectionKey;
/* harmony export (immutable) */ __webpack_exports__["f"] = setConnectionPinForNexia;
/* harmony export (immutable) */ __webpack_exports__["c"] = disableAdHocAndConnectToNexiaUsingSSIDAndPassword;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_csv_parse__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_csv_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_csv_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_utils_sleep__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_history__ = __webpack_require__(31);




 // Hardcoded connection credentials for 724 thermostat (Join Mode)

var SSID = "NEXIA724";
var HOST = "http://172.31.197.1"; // Change this to true to test 724 wizards in the browser

var stub = false;
function is724ConfigurationPossible() {
  if (stub) {
    return true;
  }

  return __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].canUseNativeHTTP() && __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].canDo724OpenAuthEncryption();
}
function currentlyConfiguring724() {
  return __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_history__["d" /* history */] && __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_history__["d" /* history */].location && __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_history__["d" /* history */].location.pathname && __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_history__["d" /* history */].location.pathname.startsWith("/app/xr724/");
}

function getSecurity(security) {
  if (security.match(/WEP/)) {
    return "WEP";
  } else if (security.match(/WPA/)) {
    return "WPA";
  } else {
    return "OPEN";
  }
}

function parseWifiNetworksCSV(csv) {
  return new Promise(function (resolve, reject) {
    var commaReplacement = "__-%2C-__";
    var quoteReplacement = "__-%22-__";
    var escapedCSV = csv.replace(/\\,/g, commaReplacement).replace(/\\"/g, quoteReplacement);
    __WEBPACK_IMPORTED_MODULE_1_csv_parse___default()(escapedCSV, function (err, records) {
      if (err) {
        reject(err);
        return;
      }

      var data = records.map(function (values) {
        return values.map(function (value) {
          return value.replace(new RegExp(commaReplacement, "g"), ",").replace(new RegExp(quoteReplacement, "g"), '"');
        });
      }).map(function (values) {
        if (values.length !== 5) {
          throw new Error("724 provided unexpected WiFi CSV format");
        }

        return values;
      }).map(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_ref, 5),
            id = _ref2[0],
            rssi = _ref2[1],
            ssid = _ref2[2],
            capabilities = _ref2[3],
            security = _ref2[4];

        return {
          id: "".concat(id, "-").concat(rssi, "-").concat(ssid, "-").concat(capabilities),
          ssid: ssid,
          secure: security.trim().split(" ").filter(function (securityTypes) {
            return securityTypes.length;
          }).length > 0,
          security: getSecurity(security.trim()),
          rssi: rssi
        };
      }).sort(function (_ref3, _ref4) {
        var rssiOne = _ref3.rssi;
        var rssiTwo = _ref4.rssi;

        if (rssiOne > rssiTwo) {
          return 1;
        } else if (rssiOne < rssiTwo) {
          return -1;
        } else {
          return 0;
        }
      }).map(function (_ref5) {
        var id = _ref5.id,
            ssid = _ref5.ssid,
            secure = _ref5.secure,
            security = _ref5.security;
        return {
          id: id,
          ssid: ssid,
          secure: secure,
          security: security // Strip out rssi

        };
      });
      resolve(data);
    });
  });
}
function getVisibleWifiNetworks() {
  if (stub) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_utils_sleep__["a" /* default */])(300).then(function () {
      return [{
        id: "1",
        ssid: "Network 1 (Open)",
        secure: false,
        security: "OPEN"
      }, {
        id: "2",
        ssid: "Network 2 (WEP)",
        secure: true,
        security: "WEP"
      }, {
        id: "3",
        ssid: "Network 3 (WPA/WPA2)",
        secure: true,
        security: "WPA"
      }];
    });
  }

  return Promise.race([__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].nativeHTTPRequest({
    method: "GET",
    url: "".concat(HOST, "/ssid2.txt")
  }).then(function (response) {
    return response.body;
  }).then(parseWifiNetworksCSV), // If we can't talk to the thermostat within 10 seconds, we are probably not connected. Reject
  new Promise(function (resolve, reject) {
    return setTimeout(reject, 10000);
  })]);
}

function createSessionKey(userKey) {
  // TODO: this should change before shipping
  var randPad = "123123";
  return userKey + randPad;
}

function sendEncrypted(userKey, text) {
  if (userKey.length !== 10) {
    return Promise.reject(new Error("User key must be 10 bytes"));
  }

  var sessionKey = createSessionKey(userKey);
  return __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].encryptStringFor724OpenAuth(sessionKey, text).then(function (encrypted) {
    return __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].nativeHTTPRequest({
      method: "GET",
      url: "".concat(HOST, "/output.cgi?text=").concat(encrypted, "&submit=Submit")
    });
  }).then(function () {
    /* discard response */
  });
}

function verifyConnectionKey(userKey) {
  if (stub) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_utils_sleep__["a" /* default */])(400).then(function () {
      return userKey !== "0000000000";
    });
  }

  return sendEncrypted(userKey, "handshake").then(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_utils_sleep__["a" /* default */])(1000);
  }) // Seems like the stat takes a bit to write the handshake_status.txt file
  .then(function () {
    return __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].nativeHTTPRequest({
      method: "GET",
      url: "".concat(HOST, "/handshake_status.txt")
    });
  }).then(function (_ref6) {
    var body = _ref6.body;
    return /^pass:/.test(body);
  });
}
function setConnectionPinForNexia(pin, userKey) {
  if (stub) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_utils_sleep__["a" /* default */])(400);
  }

  return Promise.race([sendEncrypted(userKey, "NEXIA:".concat(pin)), // needs to time out if thermostat is inaccessible. nativeHTTPRequest "GET", doesn't
  // have any way of specifying timeout, so we just reject after 10 seconds
  new Promise(function (resolve, reject) {
    return setTimeout(reject, 10000);
  })]);
} // This will turn off AdHoc mode on the 724, and then the 724 will connect to the provided
// WiFI access point, and then the 724 will try to authenticate with Nexia using the pin it
// was provided by setConnectionPinForNexia. So you should call setConnectionPinForNexia before
// you call this.

function disableAdHocAndConnectToNexiaUsingSSIDAndPassword(ssid) {
  var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var security = arguments.length > 2 ? arguments[2] : undefined;
  var userKey = arguments.length > 3 ? arguments[3] : undefined;

  if (!ssid) {
    return Promise.reject(new Error("You must provide an SSID for the thermostat to connect to"));
  }

  if (security == null) {
    return Promise.reject(new Error("You must provide an auth mode with which to connect to the WiFi network"));
  }

  if (stub) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_utils_sleep__["a" /* default */])(2000);
  }

  return new Promise(function (resolve) {
    sendEncrypted(userKey, "SSID:".concat(ssid)).then(function () {
      return sendEncrypted(userKey, "PWD:".concat(password));
    }).then(function () {
      return sendEncrypted(userKey, "DHCP:On");
    }).then(function () {
      return sendEncrypted(userKey, "SECURITY:".concat(security));
    }).then(function () {
      return sendEncrypted(userKey, "RESTART:now");
    }); // Due to a design flaw in the 724, the above fetch will never get a response.
    // The best we can do is assume it worked...

    setTimeout(resolve, 10000);
  });
}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = currentlyConfiguringDragonfly;
/* harmony export (immutable) */ __webpack_exports__["c"] = getVisibleWifiNetworks;
/* harmony export (immutable) */ __webpack_exports__["e"] = setConnectionPinForNexia;
/* harmony export (immutable) */ __webpack_exports__["f"] = testCanTalkToDevice;
/* harmony export (immutable) */ __webpack_exports__["b"] = disableAdHocAndConnectToNexiaUsingSSIDAndPassword;
/* harmony export (immutable) */ __webpack_exports__["d"] = isDragonflyConfigurationPossible;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toArray__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_utils_sleep__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_history__ = __webpack_require__(31);




function currentlyConfiguringDragonfly() {
  return __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_history__["d" /* history */] && __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_history__["d" /* history */].location && __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_history__["d" /* history */].location.pathname && __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_history__["d" /* history */].location.pathname.startsWith("/app/dragonfly/");
}
var HOST = "http://10.10.10.1:80"; // Change this to true to test dragonfly wizards in the browser

var stub = false;

function doCommand(_ref) {
  var flags = _ref.flags,
      command = _ref.command,
      data = _ref.data;
  return __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_platform__["a" /* default */].nativeHTTPRequest({
    method: "POST",
    url: "".concat(HOST, "/command"),
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      flags: flags || 0,
      command: command,
      data: data
    })
  }).then(function (_ref2) {
    var code = _ref2.code,
        body = _ref2.body;

    if (code >= 400) {
      throw new Error("Dragonfly HTTP error: ".concat(code));
    }

    return JSON.parse(body);
  }).then(function (result) {
    if (result.code !== 0) {
      throw new Error(result.response);
    }

    return result;
  });
}

// Network list looks like eg. this:
// ! 24 networks found
// !  # Ch RSSI MAC (BSSID)        Rate Security   Mode Len Network (SSID)
// #  0  1  -58 4C:55:CC:12:8C:99     0 WPA2-Mixed    -  12 ZentriOS-C99
// #  1  1  -74 04:62:73:52:EA:60     0 WPA2-Mixed    -   5 pluto
// #  2  1  -65 10:0D:7F:73:44:FE     0 Open          -  27 Free Legacy WiFi 2.4GHz_EXT
// #  3  1  -71 0E:8D:9B:1C:74:B1     0 Unknown       -  16 SteelWave - Corp
// #  4  1  -67 0E:8D:9B:1C:74:B2     0 WPA2-Mixed    -  17 SteelWave - Guest
// #  5  1  -72 04:62:73:52:EA:62     0 WPA2-Mixed    -   6 pluto5
// #  6  1  -74 04:62:73:52:EA:61     0 WPA2-Mixed    -   9 altiGuest
// #  7  1  -77 7C:95:F3:74:42:04     0 Unknown       -  11 StnInternal
// #  8  2  -50 38:D5:47:88:FC:20     0 WPA2-AES      -  12 asus-support
// #  9  2  -87 B2:39:56:51:14:F8     0 WPA2-AES      -  15 HemaSourceGuest
// # 10  1  -81 A4:2B:8C:1F:10:28     0 WPA2-Mixed    -  21 SteelWave - Guest_EXT
// # 11  6  -59 80:2A:A8:14:4B:F8     0 WPA2-AES      -   8 nexia_24
// # 12  6  -79 28:CF:DA:B2:65:89     0 WPA2-Mixed    -   6 acus11
// # 13  6  -55 80:2A:A8:14:4B:F7     0 WPA2-AES      -   8 nexia_24
// # 14  6  -50 DC:9B:9C:F1:5A:B2     0 WPA2-AES      -  12 nexia_test_1
// # 15  6  -83 78:F2:9E:7E:39:7B     0 Unknown       -   7 XFINITY
// # 16  6  -84 04:62:73:40:5C:C0     0 WPA2-Mixed    -   5 pluto
// # 17  1  -79 7C:95:F3:74:42:02     0 WPA2-AES      -  17 secure1120-edge-I
// # 18  9  -56 08:60:6E:CD:68:20     0 WPA2-AES      -   4 boom
// # 19 11  -80 10:05:CA:0D:5C:04     0 Unknown       -  11 StnInternal
// # 20 11  -66 10:05:CA:64:26:E4     0 Unknown       -  11 StnInternal
// # 21 11  -81 10:05:CA:0D:5C:06     0 Open          -   8 StnGuest
// # 22 11  -66 10:05:CA:64:26:E2     0 WPA2-AES      -  17 secure1120-edge-I
// # 23  1  -78 7C:95:F3:74:42:06     0 Open          -   8 StnGuest
//
function parseNetworkList(list) {
  var lines = list.split("\n");
  return lines // Trim off first two lines and last line
  .slice(2, lines.length - 1).map(function (line) {
    return line.split(/\s+/) // Split on whitespace
    .slice(1); // Remove first item (empty)
  }).map(
  /* eslint-disable no-unused-vars */
  function (_ref3) {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toArray___default()(_ref3),
        id = _ref4[0],
        channel = _ref4[1],
        rssi = _ref4[2],
        mac = _ref4[3],
        rate = _ref4[4],
        security = _ref4[5],
        mode = _ref4[6],
        length = _ref4[7],
        ssidParts = _ref4.slice(8);

    return {
      id: id,
      ssid: ssidParts.join(" "),
      secure: /WEP|WPA/.test(security)
    };
  });
}

function dedupeNetworkList(list) {
  var networksBySSID = {};
  list.forEach(function (item) {
    // List returned by dragonfly is ordered by signal strength; we want
    // networks that appear more than once (because they have more than one
    // BSSID) to be ordered based on the signal strength of their best BSSID.
    if (networksBySSID[item.ssid] == null) {
      networksBySSID[item.ssid] = item;
    }
  }); // Flow force-cast here is because flow's type for Object.values is hardcoded
  // to return mixed since flow doesn't know about property enumerability.

  return Object.values(networksBySSID);
}

function getVisibleWifiNetworks() {
  if (stub) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_utils_sleep__["a" /* default */])(300).then(function () {
      return [{
        id: "1",
        ssid: "Network 1 (Open)",
        secure: false
      }, {
        id: "2",
        ssid: "Network 2 (Secure)",
        secure: true
      }];
    });
  }

  return doCommand({
    command: "wlan_scan -v"
  }).then(function (_ref5) {
    var response = _ref5.response;
    return dedupeNetworkList(parseNetworkList(response));
  });
}
function setConnectionPinForNexia(pin) {
  if (stub) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_utils_sleep__["a" /* default */])(400);
  }

  var pinFilename = "nexia.pin";
  return doCommand({
    command: "file_create -o ".concat(pinFilename, " ").concat(pin.length)
  }).then(function (_ref6) {
    var response = _ref6.response;
    var fileDescriptor = response.trim();
    return doCommand({
      flags: 4,
      command: "stream_write ".concat(fileDescriptor, " ").concat(pin.length),
      data: btoa(pin)
    });
  });
}
function testCanTalkToDevice() {
  if (stub) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_utils_sleep__["a" /* default */])(400);
  }

  return doCommand({
    command: "get wl s"
  }).then(function () {
    /* discard response */
  });
}
function disableAdHocAndConnectToNexiaUsingSSIDAndPassword(ssid) {
  var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

  if (!ssid) {
    return Promise.reject(new Error("You must provide an SSID for the thermostat to connect to"));
  }

  if (stub) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_utils_sleep__["a" /* default */])(2000);
  }

  return doCommand({
    command: "set wl s ".concat(ssid)
  }).then(function () {
    return doCommand({
      command: "set wl p ".concat(password)
    });
  }).then(function () {
    return doCommand({
      command: "save"
    });
  }).then(function () {
    return doCommand({
      command: "reboot"
    });
  });
}
function isDragonflyConfigurationPossible() {
  if (stub) {
    return true;
  }

  return __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_platform__["a" /* default */].canUseNativeHTTP();
}

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Backstage; });
/* unused harmony export bpfrpt_proptype_BackstageOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_safe_access__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_safe_access___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_safe_access__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_formatServerErrors__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_Locales__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);





var localeSet = Object(__WEBPACK_IMPORTED_MODULE_4_nx_components_Locales__["b" /* getLanguageSet */])();
var language = localeSet.nexia_mobile.utils.backstage;
var TIMEOUT_MESSAGE = language.requestTimeout; // TODO: Should we vendor node_modules/iflow-jquery/index.js.flow so that we can
// export its JQueryXHR type from it?

var bpfrpt_proptype_BackstageOptions = {
  success: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  pollingUpdate: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  error: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  maxRequestsReached: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  maxRequestsCount: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
};

var Backstage =
/*#__PURE__*/
function () {
  function Backstage(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Backstage);

    this._url = url;
    this._onSuccess = options.success;
    this._onUpdate = options.pollingUpdate;
    this._onError = options.error;
    this._maxRequestsCount = options.maxRequestsCount;
    this._onMaxRequestsReached = options.maxRequestsReached;
    this._requestsCount = 0;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Backstage, [{
    key: "startPolling",
    value: function startPolling() {
      var _this = this;

      this._pollingInterval = setInterval(function () {
        // Our jQuery types are wrong; they don't think that ajaxOptions satisfies
        // the necessary options, and they don't think that jqXHRs have a 'done'
        // property on them.
        // $FlowFixMe
        return $.ajax({
          url: _this._url,
          type: "GET",
          dataType: "text"
        }).done(function (jsonData, textStatus, jqXHR) {
          var data;

          try {
            data = JSON.parse(jsonData);
          } catch (error) {
            return;
          }

          if (!data) {
            return;
          }

          if (data.status === "success") {
            _this.stopPolling();

            if (typeof _this._onSuccess === "function") {
              _this._onSuccess(data, jqXHR);
            }
          } else if (data.status === "update") {
            if (typeof _this._onUpdate === "function") {
              _this._onUpdate(data.options, jqXHR);
            }
          } else if (data.status === "error") {
            _this.stopPolling();

            var message = __WEBPACK_IMPORTED_MODULE_2_safe_access___default()(data, "options.errors");

            if (!message) {
              message = __WEBPACK_IMPORTED_MODULE_2_safe_access___default()(data, "options.message");
            }

            if (!message && __WEBPACK_IMPORTED_MODULE_2_safe_access___default()(data, "options.reason") === "timeout") {
              message = TIMEOUT_MESSAGE;
            }

            message = Object(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_formatServerErrors__["a" /* default */])(message, data);
            var options = __WEBPACK_IMPORTED_MODULE_2_safe_access___default()(data, "options");

            if (typeof _this._onError === "function") {
              _this._onError(message, jqXHR, options);
            }
          }
        }).always(function (jsonData, textStatus, jqXHR) {
          if (jqXHR && jqXHR.statusText === "abort") {
            _this.stopPolling();

            return;
          }

          _this._requestsCount++;

          if (_this._maxRequestsCount && _this._requestsCount > _this._maxRequestsCount) {
            if (typeof _this._onMaxRequestsReached === "function") {
              _this._onMaxRequestsReached();
            }

            if (typeof _this._onError === "function") {
              _this._onError([{
                errorMessage: TIMEOUT_MESSAGE
              }], jqXHR);
            }

            _this.stopPolling();
          }
        });
      }, 1000);
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      clearInterval(this._pollingInterval);
    }
  }]);

  return Backstage;
}();





/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_safe_access__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_safe_access___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_safe_access__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */


function Sensor(feature) {
  var _this = this;

  if (this._sensorFeatures == null) {
    this._sensorFeatures = {};
  } // assuming at most one of each sensor type...


  this._sensorFeatures[feature.sensor_type] = feature;

  this.getSensorTypes = function () {
    return _.keys(_this._sensorFeatures);
  };

  this.hasSensorType = function (sensorType) {
    return _this._sensorFeatures[sensorType] != null;
  };

  this.getSensorValue = function (sensorType) {
    var sensor = _this._sensorFeatures[sensorType];
    return __WEBPACK_IMPORTED_MODULE_0_safe_access___default()(sensor, "value");
  };

  this.getSensorDisplayValue = function (sensorType) {
    var sensor = _this._sensorFeatures[sensorType];

    if (sensor == null || sensor.value == null) {
      return null;
    }

    var unit = sensor.unit || "";

    if (/^[A-Za-z]+$/.test(unit)) {
      return "".concat(sensor.value, " ").concat(unit);
    } else {
      return "".concat(sensor.value).concat(unit);
    }
  };

  var attrs = {};

  if (feature.status != null) {
    attrs.status = feature.status;
  }

  return attrs;
} // not meant to be an exhaustive list of sensor types, just of ones that the
// app refers to specifically


Sensor.Type = {
  OUTDOOR_TEMPERATURE: "Outdoor Temperature",
  RELATIVE_HUMIDITY: "Relative Humidity",
  SMOKE: "Smoke",
  TEMPERATURE: "Temperature"
};
/* harmony default export */ __webpack_exports__["a"] = (Sensor);


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);

var QueryParams = {
  platform: function platform() {
    return this._queryParams().platform;
  },
  resetPasswordCode: function resetPasswordCode() {
    return this._queryParams().reset_password_code;
  },
  transferAccountCode: function transferAccountCode() {
    return this._queryParams().transfer_account_code;
  },
  _queryParams: function _queryParams() {
    if (this._cachedParams) {
      return this._cachedParams;
    }

    this._cachedParams = window.location.search.replace(/(^\?)/, "").split("&").reduce(function (obj, pairStr) {
      var _pairStr$split = pairStr.split("="),
          _pairStr$split2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_pairStr$split, 2),
          key = _pairStr$split2[0],
          value = _pairStr$split2[1];

      obj[key] = value;
      return obj;
    }, {});
    return this._cachedParams;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (QueryParams);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_mixins_device_features_group__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_device__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_automation__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_Locales__ = __webpack_require__(44);











var DefaultSorter =
/*#__PURE__*/
function () {
  function DefaultSorter(devices) {
    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, DefaultSorter);

    this.items = devices;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(DefaultSorter, [{
    key: "sort",
    value: function sort() {
      return this.items;
    }
  }, {
    key: "_nameSort",
    value: function _nameSort(items) {
      return _(items).sortBy(function (item) {
        var name = item.get("name");
        return (name || "").toLowerCase();
      });
    }
  }]);

  return DefaultSorter;
}();

var NameSorter =
/*#__PURE__*/
function (_DefaultSorter) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default()(NameSorter, _DefaultSorter);

  function NameSorter() {
    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, NameSorter);

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_getPrototypeOf___default()(NameSorter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(NameSorter, [{
    key: "sort",
    value: function sort() {
      return this._nameSort(this.items);
    }
  }]);

  return NameSorter;
}(DefaultSorter);

var SegmentedSorter =
/*#__PURE__*/
function (_DefaultSorter2) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default()(SegmentedSorter, _DefaultSorter2);

  function SegmentedSorter() {
    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, SegmentedSorter);

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_getPrototypeOf___default()(SegmentedSorter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(SegmentedSorter, [{
    key: "_segmentedSort",
    value: function _segmentedSort(sortCriteriaFunction) {
      var split = _.partition(this.items, function (item) {
        return sortCriteriaFunction(item);
      });

      return _.union(split[0], split[1]);
    }
  }, {
    key: "sort",
    value: function sort() {
      return this._segmentedSort(this.sorter);
    }
  }]);

  return SegmentedSorter;
}(DefaultSorter);

var AutomationsFirstSorter =
/*#__PURE__*/
function (_SegmentedSorter) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default()(AutomationsFirstSorter, _SegmentedSorter);

  function AutomationsFirstSorter() {
    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, AutomationsFirstSorter);

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_getPrototypeOf___default()(AutomationsFirstSorter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(AutomationsFirstSorter, [{
    key: "sorter",
    value: function sorter(item) {
      return item instanceof __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_automation__["a" /* default */];
    }
  }]);

  return AutomationsFirstSorter;
}(SegmentedSorter);

var DevicesFirstSorter =
/*#__PURE__*/
function (_SegmentedSorter2) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default()(DevicesFirstSorter, _SegmentedSorter2);

  function DevicesFirstSorter() {
    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, DevicesFirstSorter);

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_getPrototypeOf___default()(DevicesFirstSorter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(DevicesFirstSorter, [{
    key: "sorter",
    value: function sorter(item) {
      return item instanceof __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_device__["a" /* default */] && !item.hasFeature(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_mixins_device_features_group__["a" /* default */]);
    }
  }]);

  return DevicesFirstSorter;
}(SegmentedSorter);

var GroupsFirstSorter =
/*#__PURE__*/
function (_SegmentedSorter3) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inherits___default()(GroupsFirstSorter, _SegmentedSorter3);

  function GroupsFirstSorter() {
    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, GroupsFirstSorter);

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_getPrototypeOf___default()(GroupsFirstSorter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(GroupsFirstSorter, [{
    key: "sorter",
    value: function sorter(item) {
      return item instanceof __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_device__["a" /* default */] && item.hasFeature(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_mixins_device_features_group__["a" /* default */]);
    }
  }]);

  return GroupsFirstSorter;
}(SegmentedSorter);

var DeviceSorter =
/*#__PURE__*/
function () {
  function DeviceSorter() {
    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this, DeviceSorter);
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(DeviceSorter, [{
    key: "sorters",
    value: function sorters() {
      var language = Object(__WEBPACK_IMPORTED_MODULE_9_nx_components_Locales__["b" /* getLanguageSet */])().nexia_mobile.models.device_sorter;
      return {
        name: {
          sorter: NameSorter,
          description: language.nameSortDescription
        },
        "default": {
          sorter: DevicesFirstSorter,
          description: language.devicesSortDescription
        },
        "groups-first": {
          sorter: GroupsFirstSorter,
          description: language.groupSortDescription
        }
      };
    }
  }, {
    key: "chosenSorter",
    value: function chosenSorter() {
      var sorterClass = this.sorters()[__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_local_settings__["c" /* default */].getDeviceSortOrder()];

      if (!sorterClass || !sorterClass.sorter) {
        return AutomationsFirstSorter;
      }

      return sorterClass.sorter;
    }
  }, {
    key: "descriptions",
    value: function descriptions() {
      return _(this.sorters()).pluck("description");
    }
  }, {
    key: "values",
    value: function values() {
      return _(this.sorters()).keys();
    }
  }, {
    key: "sort",
    value: function sort(devices) {
      return new (this.chosenSorter())(devices).sort();
    }
  }]);

  return DeviceSorter;
}();

if (DeviceSorter.singleton == null) {
  DeviceSorter.singleton = new DeviceSorter();
}

/* harmony default export */ __webpack_exports__["a"] = (DeviceSorter.singleton);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_mixins_editable__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__ = __webpack_require__(24);











var Phone =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Phone, _BaseModel);

  function Phone() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Phone);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Phone).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Phone, [{
    key: "initialize",
    value: function initialize() {
      __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Phone.prototype), "initialize", this).call(this);
    }
  }, {
    key: "activationCode",
    value: function activationCode() {
      var _this = this;

      return this.postCommand("activation_code", {
        method: "PUT",
        data: JSON.stringify({
          /* eslint-disable camelcase */
          is_amstd: __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_environment__["a" /* default */].isAmStdCommercial()
        })
      }).then(function (response) {
        _this.set({
          activationKey: response.activation_key
        });

        return _this.fetch();
      });
    }
  }, {
    key: "setLocale",
    value: function setLocale(locale, setLocaleContext, setUserLocaleContext) {
      var _this2 = this;

      return this.postCommand("locale", {
        method: "POST",
        data: JSON.stringify({
          locale: locale
        })
      }).then(function (response) {
        _this2.set({
          locale: response.locale
        });

        __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].setLocale(response.locale);
        setLocaleContext(response.locale);
        setUserLocaleContext(response.locale);
        return _this2.fetch();
      });
    }
  }]);

  return Phone;
}(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__["a" /* default */]);

_.extend(Phone.prototype, __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_mixins_editable__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Phone);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(169),
    now = __webpack_require__(1032),
    toNumber = __webpack_require__(443);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MountOnBody; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);








 // Just so it's clearer what's happening in React DevTools

var MountedOnBody = function MountedOnBody(_ref) {
  var children = _ref.children;
  return children;
};

MountedOnBody.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element
};

var MountOnBody =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(MountOnBody, _React$Component);

  function MountOnBody() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, MountOnBody);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(MountOnBody).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(MountOnBody, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateRoot();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateRoot();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmountRoot();
    }
  }, {
    key: "ensureEl",
    value: function ensureEl() {
      if (this.el) {
        return;
      }

      this.el = document.createElement("div");
      this.el.classList.add("mounted-on-body");
      document.body.appendChild(this.el);
    }
  }, {
    key: "mountRoot",
    value: function mountRoot() {
      this.ensureEl();
      __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](MountedOnBody, null, this.props.children), this.el);
    }
  }, {
    key: "updateRoot",
    value: function updateRoot() {
      if (this.props.children) {
        this.mountRoot();
      } else {
        this.unmountRoot();
      }
    }
  }, {
    key: "unmountRoot",
    value: function unmountRoot() {
      if (!this.el) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unmountComponentAtNode(this.el);

      if (this.el.parentNode) {
        this.el.parentNode.removeChild(this.el);
      }

      this.el = null;
    }
  }, {
    key: "render",
    value: function render() {
      // We mount a new react root on <body> instead of rendering here.
      return null;
    }
  }]);

  return MountOnBody;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(MountOnBody, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element
});



/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FORM_ERROR_ANIMATION_DELAY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ScreenReaderOnlyLiveRegion__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var FORM_ERROR_ANIMATION_DELAY = 100;

var FormError =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(FormError, _React$Component);

  function FormError() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, FormError);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(FormError).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(FormError, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          error = _this$props.error,
          colors = _this$props.colors;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["b" /* default */])({
        errorWrapper: {
          // transition errors so that iOS cursors don't get off center
          // https://bugs.webkit.org/show_bug.cgi?id=138201
          transition: "max-height ".concat(FORM_ERROR_ANIMATION_DELAY, "ms"),
          overflow: "hidden"
        },
        error: {
          maxHeight: "5em"
        },
        noError: {
          maxHeight: "0em"
        },
        formError: {
          margin: 0,
          padding: "0.625em",
          fontSize: "0.8em",
          color: colors.RED
        }
      });
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, error ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ScreenReaderOnlyLiveRegion__["a" /* default */], null, "Error: ", error) : null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: _objectSpread({}, styles.errorWrapper, {}, error ? styles.error : styles.noError),
        "data-component-section": "error"
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("p", {
        style: styles.formError
      }, error || " ")), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: {
          border: error ? "1px solid ".concat(colors.RED) : "none"
        }
      }, this.props.children));
    }
  }]);

  return FormError;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(FormError, "propTypes", {
  error: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.node.isRequired,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["c" /* withColorsProvider */])(FormError));



/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(62);
var toLength = __webpack_require__(30);
var toAbsoluteIndex = __webpack_require__(114);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 180 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(68);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(69);
var defined = __webpack_require__(76);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(26);
var cof = __webpack_require__(68);
var MATCH = __webpack_require__(29)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(29)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(135);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(348);
var redefine = __webpack_require__(55);
var hide = __webpack_require__(54);
var fails = __webpack_require__(25);
var defined = __webpack_require__(76);
var wks = __webpack_require__(29);
var regexpExec = __webpack_require__(250);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(21);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(55);
var redefineAll = __webpack_require__(120);
var meta = __webpack_require__(100);
var forOf = __webpack_require__(119);
var anInstance = __webpack_require__(118);
var isObject = __webpack_require__(26);
var fails = __webpack_require__(25);
var $iterDetect = __webpack_require__(184);
var setToStringTag = __webpack_require__(134);
var inheritIfRequired = __webpack_require__(236);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var hide = __webpack_require__(54);
var uid = __webpack_require__(112);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(99) || !__webpack_require__(25)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(21)[K];
});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(8);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(8);
var aFunction = __webpack_require__(50);
var ctx = __webpack_require__(67);
var forOf = __webpack_require__(119);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);
var strRepeat = __webpack_require__(385);

module.exports = function pad(str, length, padStr, type) {
  str = makeString(str);
  length = ~~length;

  var padlen = 0;

  if (!padStr)
    padStr = ' ';
  else if (padStr.length > 1)
    padStr = padStr.charAt(0);

  switch (type) {
  case 'right':
    padlen = length - str.length;
    return str + strRepeat(padStr, padlen);
  case 'both':
    padlen = length - str.length;
    return strRepeat(padStr, Math.ceil(padlen / 2)) + str + strRepeat(padStr, Math.floor(padlen / 2));
  default: // 'left'
    padlen = length - str.length;
    return strRepeat(padStr, padlen) + str;
  }
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.4.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code, options ) {
		DOMEval( code, { nonce: options && options.nonce } );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.4
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2019-04-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) &&

				// Support: IE 8 only
				// Exclude object elements
				(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 && rdescend.test( selector ) ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = (elem.ownerDocument || elem).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( typeof elem.contentDocument !== "undefined" ) {
			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								} );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	// Support: IE 9-11 only
	// Also use offsetWidth/offsetHeight for when box sizing is unreliable
	// We use getClientRects() to check for hidden/disconnected.
	// In those cases, the computed value can be trusted to be border-box
	if ( ( !support.boxSizingReliable() && isBorderBox ||
		val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url, options ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_Geofence */
/* unused harmony export bpfrpt_proptype_GeofenceCrossing */
/* unused harmony export bpfrpt_proptype_NativeHTTPRequestOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_safe_access__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_safe_access___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_safe_access__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);







var Event = {
  BACK_BUTTON: "backbutton",
  APP_PAUSE: "pause",
  APP_RESUME: "resume",
  APP_STOP: "stop",
  APP_RESTART: "restart",
  NOTIFICATION_TOKEN: "notification_token",
  VOGNITION_STATE: "vognition",
  BANNER_MESSAGE: "banner_message",
  CONFIRM: "confirm",
  LOCAL_SETTINGS_CHANGED: "local_settings_changed"
};
var bpfrpt_proptype_Geofence = {
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  latitude: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  longitude: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  radius: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  hrefAcknowledge: function hrefAcknowledge() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  hrefEnter: function hrefEnter() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  hrefExit: function hrefExit() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
};
var bpfrpt_proptype_GeofenceCrossing = {
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  date: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
};
var bpfrpt_proptype_NativeHTTPRequestOptions = {
  method: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  url: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  body: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  headers: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired)
};

/* eslint-disable no-empty-function, no-unused-vars */
var Base =
/*#__PURE__*/
function () {
  function Base() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Base);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(this, "_eventuallySaveSessionCache", _.debounce(function (contents) {
      var value = JSON.stringify(contents);

      _this.setStoredValue("session_cache", value);
    }, 1000));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Base, [{
    key: "initScriptInterface",
    // Gets added to the prototype at the bottom of this file
    // Gets added by Backbone.Events mixin at the bottom of this file
    // let the app container do stuff (with access to javascript)
    // and invokes the callback when done.
    value: function initScriptInterface(callback) {
      // In the browser, use the Page Visibility API to trigger app pause and
      // resume. In mobile platforms, we hook into the native code to detect
      // pause/resume instead.
      window.addEventListener("visibilitychange", function () {
        if (document.hidden) {
          Object(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_PAUSE");
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_RESUME");
        }
      });
      this.setDeviceUUID("base"); // /$FlowFixMe

      var currentLocale = function currentLocale() {
        return navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || "en-US";
      };

      this.setCurrentLocale(currentLocale());
      callback();
    }
  }, {
    key: "exitApp",
    value: function exitApp() {}
  }, {
    key: "allowScreenDimming",
    value: function allowScreenDimming() {
      var yesno = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    } // To be called by native host application

  }, {
    key: "bannerMessage",
    value: function bannerMessage(message) {
      var decodedMessage = decodeURIComponent(message);
      this.trigger(this.Event.BANNER_MESSAGE, decodedMessage);
    }
  }, {
    key: "confirm",
    value: function confirm(message, onConfirm) {
      var decodedMessage = decodeURIComponent(message);
      this.trigger(this.Event.CONFIRM, decodedMessage, onConfirm);
    }
  }, {
    key: "getStoredValue",
    value: function getStoredValue(key) {
      return window.localStorage.getItem(key);
    }
  }, {
    key: "setStoredValue",
    value: function setStoredValue(key, value) {
      window.localStorage.setItem(key, value);
    }
  }, {
    key: "clearStoredValue",
    value: function clearStoredValue(key) {
      window.localStorage.removeItem(key);
    }
  }, {
    key: "clearStoredValues",
    value: function clearStoredValues() {
      window.localStorage.clear();
    }
  }, {
    key: "canSendFeedback",
    value: function canSendFeedback() {
      return false;
    }
  }, {
    key: "isMobilePlatform",
    value: function isMobilePlatform() {
      return false;
    }
  }, {
    key: "hasAppInstalled",
    value: function hasAppInstalled(name) {
      return Promise.resolve(false);
    }
  }, {
    key: "obtainPushNotificationToken",
    value: function obtainPushNotificationToken() {}
  }, {
    key: "resetAppBadge",
    value: function resetAppBadge() {}
  }, {
    key: "hideSoftKeyboard",
    value: function hideSoftKeyboard() {}
  }, {
    key: "isImageSaveSupported",
    value: function isImageSaveSupported() {
      return false;
    }
  }, {
    key: "saveImage",
    value: function saveImage(base64Data) {
      return Promise.reject(new Error("Cannot save images on this platform"));
    }
  }, {
    key: "getAppInfo",
    value: function getAppInfo() {
      return {
        /* eslint-disable camelcase */
        app_identifier: this.bundleIdentifier,
        app_version: this.appVersion,
        platform: this.platformName,
        manufacturer: this.manufacturer,
        model: this.model,
        os_version: this.osVersion,
        device_uuid: this.deviceUUID,
        currentLocale: this.currentLocale
        /* eslint-enable camelcase */

      };
    }
  }, {
    key: "getCommandLineArgs",
    value: function getCommandLineArgs() {
      return this.commandLineArgs;
    }
  }, {
    key: "sendGoogleAnalyticsEvent",
    value: function sendGoogleAnalyticsEvent(category, action, label) {}
  }, {
    key: "sendGoogleAnalyticsDuration",
    value: function sendGoogleAnalyticsDuration(category, action, label, value) {} // Geofencing methods

  }, {
    key: "isGeofencingSupported",
    value: function isGeofencingSupported() {
      return false;
    }
  }, {
    key: "isNotificationSoundConfigurable",
    value: function isNotificationSoundConfigurable() {
      return false;
    }
  }, {
    key: "checkLocationPermissions",
    value: function checkLocationPermissions() {
      return Promise.resolve(false);
    }
  }, {
    key: "getLocationServicesWarningMessage",
    value: function getLocationServicesWarningMessage() {
      return Promise.resolve("Nexia needs Location Services to be enabled to use geofencing.");
    }
  }, {
    key: "areLocationServicesEnabled",
    value: function areLocationServicesEnabled() {
      return Promise.resolve(true);
    }
  }, {
    key: "openAppPermissionSettings",
    value: function openAppPermissionSettings() {
      throw new Error("There are no permission settings on the base platform");
    }
  }, {
    key: "openLocationServiceSettings",
    value: function openLocationServiceSettings() {
      throw new Error("Cannot open location service settings on this platform");
    }
  }, {
    key: "openWifiSettings",
    value: function openWifiSettings() {
      throw new Error("Cannot open wifi settings on this platform");
    }
  }, {
    key: "setGeofences",
    value: function setGeofences(geofences) {
      return Promise.resolve();
    }
  }, {
    key: "startGeofenceService",
    value: function startGeofenceService() {
      return Promise.reject(new Error("Geofence service cannot be started on this platform"));
    }
  }, {
    key: "stopGeofenceService",
    value: function stopGeofenceService() {
      return Promise.reject(new Error("Geofence service cannot be stopped on this platform"));
    }
  }, {
    key: "getGeofenceCrossings",
    value: function getGeofenceCrossings() {
      return Promise.resolve([]);
    } // end Geofencing methods
    // methods to be called by native host application

  }, {
    key: "setBundleIdentifier",
    value: function setBundleIdentifier(bundleIdentifier) {
      this.bundleIdentifier = bundleIdentifier;
    }
  }, {
    key: "setAppVersion",
    value: function setAppVersion(appVersion) {
      this.appVersion = appVersion;
    }
  }, {
    key: "setPlatformName",
    value: function setPlatformName(platformName) {
      this.platformName = platformName;
    }
  }, {
    key: "setManufacturer",
    value: function setManufacturer(manufacturer) {
      this.manufacturer = manufacturer;
    }
  }, {
    key: "setModel",
    value: function setModel(model) {
      this.model = model;
    }
  }, {
    key: "setOsVersion",
    value: function setOsVersion(osVersion) {
      this.osVersion = osVersion;
    }
  }, {
    key: "setDeviceName",
    value: function setDeviceName(deviceName) {
      this.deviceName = deviceName;
    }
  }, {
    key: "setUrlEncodedDeviceName",
    value: function setUrlEncodedDeviceName(urlEncodedDeviceName) {
      var deviceName = decodeURIComponent(urlEncodedDeviceName);
      this.deviceName = deviceName;
    }
  }, {
    key: "setCommandLineArgs",
    value: function setCommandLineArgs(value) {
      this.commandLineArgs = value;
    }
  }, {
    key: "setDeviceFamily",
    value: function setDeviceFamily(value) {
      this.deviceFamily = value;
    }
  }, {
    key: "setDeviceUUID",
    value: function setDeviceUUID(value) {
      this.deviceUUID = value;
    }
  }, {
    key: "setCurrentLocale",
    value: function setCurrentLocale(value) {
      this.currentLocale = value;
    }
  }, {
    key: "triggerBackButton",
    value: function triggerBackButton() {
      this.trigger(this.Event.BACK_BUTTON);
    }
  }, {
    key: "triggerAppPause",
    value: function triggerAppPause() {
      this.trigger(this.Event.APP_PAUSE);
    }
  }, {
    key: "triggerAppResume",
    value: function triggerAppResume() {
      this.trigger(this.Event.APP_RESUME);
    }
  }, {
    key: "triggerAppStop",
    value: function triggerAppStop() {
      this.trigger(this.Event.APP_STOP);
    }
  }, {
    key: "triggerAppRestart",
    value: function triggerAppRestart() {
      this.trigger(this.Event.APP_RESTART);
    }
  }, {
    key: "triggerNotificationTokenObtained",
    value: function triggerNotificationTokenObtained(token) {
      this.trigger(this.Event.NOTIFICATION_TOKEN, {
        token: token
      });
    }
  }, {
    key: "triggerLocalSettingsChanged",
    value: function triggerLocalSettingsChanged() {
      this.trigger(this.Event.LOCAL_SETTINGS_CHANGED);
    } // end methods to be called by native host application
    // Vognition methods

  }, {
    key: "checkMicrophonePermissions",
    value: function checkMicrophonePermissions() {
      return Promise.resolve("undetermined");
    }
  }, {
    key: "isVognitionSupported",
    value: function isVognitionSupported() {
      return false;
    }
  }, {
    key: "isVoiceAssistantSupported",
    value: function isVoiceAssistantSupported() {
      return false;
    }
  }, {
    key: "enableVognition",
    value: function enableVognition() {} // To be called by native host application

  }, {
    key: "updateVognitionState",
    value: function updateVognitionState(encodedStateJSON) {
      var state;

      try {
        var stateJSON = decodeURIComponent(encodedStateJSON);
        state = JSON.parse(stateJSON);
      } catch (error) {
        throw new Error("Failed to parse vognition state update");
      }

      Object(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_dispatch__["a" /* default */])("VOGNITION_STATE_UPDATE", state);
    }
  }, {
    key: "runVognitionListener",
    value: function runVognitionListener() {
      throw new Error("Vognition is not supported on this platform");
    }
  }, {
    key: "stopVognitionListener",
    value: function stopVognitionListener() {
      throw new Error("Vognition is not supported on this platform");
    }
  }, {
    key: "speakString",
    value: function speakString(message) {
      throw new Error("Vognition is not supported on this platform");
    }
  }, {
    key: "setVognitionHomeProfile",
    value: function setVognitionHomeProfile(profile) {
      return Promise.reject(new Error("Vognition is not supported on this platform"));
    } // end Vognition methods
    // Does the platform allow programmatic access to Wifi networks?

  }, {
    key: "canGetWifiNetworks",
    value: function canGetWifiNetworks() {
      return false;
    } // Does the platform allow you to programmatically connect to a Wifi network?

  }, {
    key: "canConnectToWifiNetwork",
    value: function canConnectToWifiNetwork() {
      return false;
    } // Start a Wifi network scan. The SSID of each found network will be passed
    // to callback as an array of strings.

  }, {
    key: "wifiScan",
    value: function wifiScan(callback) {} // Connect to a WiFi network.

  }, {
    key: "connectToWifiNetwork",
    value: function connectToWifiNetwork(ssid, password) {
      return Promise.reject(new Error("connectToWifiNetwork not implemented on this platform"));
    }
  }, {
    key: "getBiometricString",
    value: function getBiometricString() {
      return "fingerprint";
    }
  }, {
    key: "isFingerprintAuthAvailable",
    value: function isFingerprintAuthAvailable() {
      return Promise.resolve(false);
    }
  }, {
    key: "authenticateWithFingerprint",
    value: function authenticateWithFingerprint() {
      return Promise.resolve({
        success: false,
        wasIntentionallyCancelled: true
      });
    }
  }, {
    key: "cancelFingerprintAuthentication",
    value: function cancelFingerprintAuthentication() {} // Native HTTP methods, to bypass CORS

  }, {
    key: "canUseNativeHTTP",
    value: function canUseNativeHTTP() {
      return false;
    }
  }, {
    key: "nativeHTTPRequest",
    value: function nativeHTTPRequest(options) {
      return Promise.reject(new Error("Native HTTP is unavailable on this platform"));
    } // end native HTTP methods

  }, {
    key: "canDo724OpenAuthEncryption",
    value: function canDo724OpenAuthEncryption() {
      return false;
    }
  }, {
    key: "encryptStringFor724OpenAuth",
    value: function encryptStringFor724OpenAuth(key, input) {
      return Promise.reject(new Error("724 Open Auth Encryption is unavailable on this platform"));
    }
  }, {
    key: "canEnableRemoteDebugging",
    value: function canEnableRemoteDebugging() {
      return false;
    }
  }, {
    key: "enableRemoteDebugging",
    value: function enableRemoteDebugging() {
      throw new Error("Enabling remote debugging at runtime is not supported on this platform");
    } // Detect if a platform-native screen reader is running so that a better
    // experience can be provided to screen reader users.

  }, {
    key: "canDetectIfScreenReaderIsRunning",
    value: function canDetectIfScreenReaderIsRunning() {
      return false;
    } // To be called by native host application

  }, {
    key: "setIsScreenReaderRunning",
    value: function setIsScreenReaderRunning(value) {
      Object(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_dispatch__["a" /* default */])("SCREEN_READER_RUNNING_CHANGED", value);
    } // End screen reader methods
    // On some platforms, the web view isn't visible until the JS code tells the
    // native code it's ready (a splash screen is shown instead). Call this when
    // it's safe to show the DOM (all views are rendered, etc). It should be safe
    // to call this multiple times without effect if the web view is already
    // visible.

  }, {
    key: "showWebView",
    value: function showWebView() {} // If you call showWebView, you should also call hideWebView on pause so that
    // on a subsequent resume, the splash screen "covers" the app while it decides
    // which view to show

  }, {
    key: "hideWebView",
    value: function hideWebView() {} // Session cache methods

  }, {
    key: "getSessionCache",
    value: function getSessionCache() {
      this._ensureLocalSettingsLoaded();

      return this._sessionCache;
    } // When the app first loads, we might write multiple things to the cache (session, locations... etc).
    // These items all get serialized into the same cache (same LocalSettings key). In order to avoid
    // unnecessarily writing the data twice when the data is just going to change anyway, we use a
    // debounce function that waits up to a second before writing.

  }, {
    key: "addToSessionCache",
    // NOTE: mutates jsonObj argument, adding jsonObj.result.cached = true
    value: function addToSessionCache(jsonObj) {
      this._ensureLocalSettingsLoaded();

      var url = __WEBPACK_IMPORTED_MODULE_4_safe_access___default()(jsonObj, "result.id") || __WEBPACK_IMPORTED_MODULE_4_safe_access___default()(jsonObj, "result._links.self.href");

      if (!url && !__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_environment__["a" /* default */].isTestRunner()) {
        console.warn("Attempted to add an item to the session cache that had no URL:", jsonObj);
      }

      if (jsonObj.result != null) {
        jsonObj.result.cached = true;
      }

      this._sessionCache[url] = jsonObj;

      this._eventuallySaveSessionCache(this._sessionCache);
    }
  }, {
    key: "clearSessionCache",
    value: function clearSessionCache() {
      this._ensureLocalSettingsLoaded();

      this._sessionCache = {};
      this.clearStoredValue("session_cache");
    }
  }, {
    key: "_ensureLocalSettingsLoaded",
    value: function _ensureLocalSettingsLoaded() {
      if (this._sessionCache != null) {
        return;
      }

      try {
        var value = this.getStoredValue("session_cache");

        if (typeof value !== "string") {
          this._sessionCache = {};
          return;
        }

        var json = JSON.parse(value);
        this._sessionCache = json || {};
      } catch (error) {
        this._sessionCache = {};
      }
    }
  }, {
    key: "createTemporaryFile",
    value: function createTemporaryFile(blob, extension) {
      return Promise.resolve(URL.createObjectURL(blob));
    }
  }, {
    key: "removeTemporaryFile",
    value: function removeTemporaryFile(url) {
      URL.revokeObjectURL(url);
      return Promise.resolve();
    } // End session cache methods

  }]);

  return Base;
}();

_.extend(Base.prototype, __WEBPACK_IMPORTED_MODULE_3_backbone___default.a.Events);

_.extend(Base.prototype, {
  Event: Event
});

/* harmony default export */ __webpack_exports__["a"] = (Base);





/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(71);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(160),
    isObjectLike = __webpack_require__(199);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(122);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(848),
    listCacheDelete = __webpack_require__(849),
    listCacheGet = __webpack_require__(850),
    listCacheHas = __webpack_require__(851),
    listCacheSet = __webpack_require__(852);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(407);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(854);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = global || self, global.deepmerge = factory());
}(this, function () { 'use strict';

	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};

	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}

	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);

		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}

	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}

	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}

	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}

	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}

	function getMergeFunction(key, options) {
		if (!options.customMerge) {
			return deepmerge
		}
		var customMerge = options.customMerge(key);
		return typeof customMerge === 'function' ? customMerge : deepmerge
	}

	function getEnumerableOwnPropertySymbols(target) {
		return Object.getOwnPropertySymbols
			? Object.getOwnPropertySymbols(target).filter(function(symbol) {
				return target.propertyIsEnumerable(symbol)
			})
			: []
	}

	function getKeys(target) {
		return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
	}

	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			getKeys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		getKeys(source).forEach(function(key) {
			if (!options.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			} else {
				destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
			}
		});
		return destination
	}

	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;

		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}

	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}

		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};

	var deepmerge_1 = deepmerge;

	return deepmerge_1;

}));


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

var _warning = _interopRequireDefault(__webpack_require__(49));

/* eslint-disable no-restricted-globals */
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

exports.easing = easing;
var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
exports.duration = duration;

var formatMs = function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
};

exports.formatMs = formatMs;

var isString = function isString(value) {
  return typeof value === 'string';
};

exports.isString = isString;

var isNumber = function isNumber(value) {
  return !isNaN(parseFloat(value));
};
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


exports.isNumber = isNumber;
var _default = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
     false ? (0, _warning.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array.') : void 0;
     false ? (0, _warning.default)(isNumber(durationOption) || isString(durationOption), "Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, ".")) : void 0;
     false ? (0, _warning.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string.') : void 0;
     false ? (0, _warning.default)(isNumber(delay) || isString(delay), 'Material-UI: argument "delay" must be a number or a string.') : void 0;
     false ? (0, _warning.default)(Object.keys(other).length === 0, "Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]")) : void 0;
    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};
exports.default = _default;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(139);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(140);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(905);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// returns a style object with a single concated prefixed value string

exports.default = function (property, value) {
  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
    return prefix + value;
  } : arguments[2];
  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
    return replacer(prefix, value);
  }));
};

module.exports = exports['default'];

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Group;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_device_collection__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_mixins_editable__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */


function Group(feature) {
  var _this = this;

  // mix in the methods from the Editable class's prototype
  _.extend(this, __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_mixins_editable__["a" /* default */]);

  if (this._groupMembers == null) {
    this._groupMembers = new __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_device_collection__["a" /* default */]();
  }

  this._groupMembers.set(feature.members, {
    parse: true
  });

  var associateGroupMembers = function associateGroupMembers() {
    _this._groupMembers.each(function (member) {
      member.parentGroup = _this;
    });
  };

  associateGroupMembers();

  this._groupMembers.on("add remove reset sort sync", associateGroupMembers);

  this.getGroupMembers = function () {
    return _this._groupMembers;
  };

  this.isNameEditable = function () {
    return false;
  };
}


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1012)
var ieee754 = __webpack_require__(1013)
var isArray = __webpack_require__(435)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(141)))

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HANDLE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Handle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var HANDLE_SIZE = 22;
var styles = {
  handle: {
    borderRadius: "50%",
    height: HANDLE_SIZE,
    transform: "translate(-50%)",
    width: HANDLE_SIZE
  },
  wrapper: {
    width: 0
  }
};

var Handle =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Handle, _React$Component);

  function Handle() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Handle);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Handle).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Handle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          isMinimum = _this$props.isMinimum,
          tooltip = _this$props.tooltip,
          role = _this$props.role,
          ariaValuenow = _this$props["aria-valuenow"],
          ariaValuemin = _this$props["aria-valuemin"],
          ariaValuemax = _this$props["aria-valuemax"],
          ariaValuetext = _this$props["aria-valuetext"];
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "Handle",
        style: styles.wrapper,
        role: role,
        "aria-valuenow": ariaValuenow,
        "aria-valuemin": ariaValuemin,
        "aria-valuemax": ariaValuemax,
        "aria-valuetext": ariaValuetext
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: _objectSpread({}, styles.handle, {
          backgroundColor: color
        }, isMinimum ? {
          backgroundColor: "white",
          border: "2px solid ".concat(color)
        } : null)
      }, tooltip));
    }
  }]);

  return Handle;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Handle, "propTypes", {
  color: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  isMinimum: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
  tooltip: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  "\"aria-valuenow\"": __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,
  "\"aria-valuemin\"": __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,
  "\"aria-valuemax\"": __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,
  "\"aria-valuetext\"": __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
});




/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(265),
    baseAssignValue = __webpack_require__(403);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["c"] = __rest;
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* harmony export (immutable) */ __webpack_exports__["d"] = __spreadArrays;
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_AppBar__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var AppBarButtons = function AppBarButtons(props) {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.AppBarButtons;
  var customActionTitle = props.customActionTitle,
      onEdit = props.onEdit,
      onDelete = props.onDelete,
      onSave = props.onSave,
      onSaveAs = props.onSaveAs,
      onLoad = props.onLoad,
      onCustomAction = props.onCustomAction,
      colors = props.colors;
  var styles = {
    button: {
      marginRight: __WEBPACK_IMPORTED_MODULE_5_nx_components_Theme__["a" /* default */].Padding.APP_BAR_BUTTON,
      marginLeft: __WEBPACK_IMPORTED_MODULE_5_nx_components_Theme__["a" /* default */].Padding.APP_BAR_BUTTON,
      // currently Button overrides custom styles with a theme if present, so we can't use the
      // "reverse" theme and make the text red at the same time (for the delete button)
      backgroundColor: colors.PRIMARY_TEXT,
      color: colors.PRIMARY
    }
  };
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nx_components_AppBar__["a" /* AppBarButtonWrapper */], null, onCustomAction && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
    onTap: onCustomAction,
    style: styles.button
  }, customActionTitle), onDelete && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
    onTap: onDelete,
    style: _objectSpread({}, styles.button, {
      color: colors.RED
    })
  }, language.deleteButton), onEdit && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
    onTap: onEdit,
    style: styles.button
  }, language.editButton), onSave && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
    onTap: onSave,
    style: styles.button
  }, language.saveButton), onSaveAs && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
    onTap: onSaveAs,
    style: styles.button
  }, language.saveAsButton), onLoad && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
    onTap: onLoad,
    style: styles.button
  }, language.loadButton));
};

AppBarButtons.propTypes = {
  customActionTitle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onEdit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onDelete: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSaveAs: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLoad: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onCustomAction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_ColorsProvider__["c" /* withColorsProvider */])(AppBarButtons));


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(442);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = showAlertDialog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_Dialog__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Dialogs_renderInDestroyableRoot__ = __webpack_require__(144);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var AlertDialog = function AlertDialog(_ref) {
  var buttonText = _ref.buttonText,
      message = _ref.message,
      onDismiss = _ref.onDismiss,
      open = _ref.open,
      ignoreBackgroundClick = _ref.ignoreBackgroundClick,
      ignoreRequestClose = _ref.ignoreRequestClose;
  var onBackgroundHandler;

  if (!ignoreBackgroundClick) {
    onBackgroundHandler = onDismiss;
  }

  var onRequestCloseHandler;

  if (!ignoreRequestClose) {
    onRequestCloseHandler = onDismiss;
  }

  var styles = {
    container: {
      margin: "1em",
      minWidth: "10em",
      maxWidth: "80vw",
      overflow: "hidden"
    },
    buttons: {
      textAlign: "center",
      marginTop: "1em",
      marginLeft: "1em",
      marginRight: "1em"
    }
  };
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nx_components_Dialog__["a" /* default */], {
    open: open,
    onTapBackground: onBackgroundHandler,
    onRequestClose: onRequestCloseHandler
  }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    style: styles.container
  }, message, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    style: styles.buttons
  }, __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
    onTap: onDismiss
  }, buttonText))));
};

AlertDialog.propTypes = {
  buttonText: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  message: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
  onDismiss: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  ignoreBackgroundClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  ignoreRequestClose: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
AlertDialog.defaultProps = {
  buttonText: "OK"
}; // This method creates a destroyable <div> to mount the AlertDialog in when
// there's no existing React context, like for a Backbone View.
// Usage:
// showAlertDialog({
//   message: "The operation completed successfully",
//   buttonText: "Hurray!",
//   ignoreBackgroundClick: true, // Background clicks will not close the dialog
//   ignoreRequestClose: true, // Pressing Esc or Back (On Android, Win10) will not close the dialog
// });

function showAlertDialog(options, key) {
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Dialogs_renderInDestroyableRoot__["c" /* default */])(function (destroyRoot) {
    var dialogProps = _objectSpread({}, options);

    dialogProps.onDismiss = function () {
      destroyRoot();

      if (_.isFunction(options.onDismiss)) {
        options.onDismiss();
      }
    };

    return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](AlertDialog, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, dialogProps, {
      open: true
    }));
  }, key);
}
/* harmony default export */ __webpack_exports__["a"] = (AlertDialog);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GlobalStyleSheet__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var animationsStyleSheet = "\n  @keyframes nx-components_Spinner-rotate {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(270deg);\n    }\n  }\n\n  @keyframes nx-components_Spinner-edge-rotate {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes nx-components_Spinner-dash {\n    0% {\n      stroke-dashoffset: 187;\n    }\n\n    50% {\n      stroke-dashoffset: 46.75;\n      transform: rotate(135deg);\n    }\n\n    100% {\n      stroke-dashoffset: 187;\n      transform: rotate(450deg);\n    }\n  }\n";
var STROKE_WIDTH_RATIO = 3 * 66;
var isEdge = null;

var determineIsEdge = function determineIsEdge() {
  isEdge = /Windows/i.test(navigator.userAgent) && /Edge|Trident/i.test(navigator.userAgent);
  return isEdge;
};

var Spinner =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Spinner, _React$Component);

  function Spinner(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Spinner);

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Spinner).call(this, props));

    if (isEdge === null) {
      determineIsEdge();
    }

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Spinner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          colors = _this$props.colors,
          diameter = _this$props.diameter,
          _this$props$color = _this$props.color,
          color = _this$props$color === void 0 ? colors.PRIMARY : _this$props$color,
          strokeWidth = _this$props.strokeWidth;
      var computedStrokeWidth;

      if (strokeWidth != null) {
        computedStrokeWidth = strokeWidth;
      } else {
        computedStrokeWidth = STROKE_WIDTH_RATIO / diameter;
      }

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "Spinner",
        style: {
          display: "inline-block",
          width: diameter,
          height: diameter
        }
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__GlobalStyleSheet__["a" /* default */], {
        id: "nx-components_Spinner",
        sheet: animationsStyleSheet
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("svg", {
        id: "svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 66 66",
        xmlns: "http://www.w3.org/2000/svg",
        style: isEdge ? {
          animation: "nx-components_Spinner-edge-rotate 1.4s linear infinite"
        } : {
          animation: "nx-components_Spinner-rotate 1.4s linear infinite"
        }
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("circle", {
        id: "circle",
        fill: "none",
        strokeWidth: computedStrokeWidth,
        strokeLinecap: "round",
        cx: "33",
        cy: "33",
        r: "28",
        style: _objectSpread({
          stroke: color,
          strokeDashoffset: "0"
        }, isEdge ? {
          strokeDasharray: "90"
        } : {
          strokeDasharray: "187",
          transformOrigin: "center",
          animation: "nx-components_Spinner-dash 1.4s ease-in-out infinite"
        })
      })));
    }
  }]);

  return Spinner;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Spinner, "defaultProps", {
  diameter: 128
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Spinner, "propTypes", {
  diameter: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  color: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  strokeWidth: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["c" /* withColorsProvider */])(Spinner));



/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Heading__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Theme__ = __webpack_require__(18);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var Section = function Section(_ref) {
  var children = _ref.children,
      style = _ref.style,
      label = _ref.label;
  var styles = {
    content: _objectSpread({
      position: "relative",
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: __WEBPACK_IMPORTED_MODULE_4__Theme__["a" /* default */].Padding.CONTENT,
      paddingRight: __WEBPACK_IMPORTED_MODULE_4__Theme__["a" /* default */].Padding.CONTENT
    }, style),
    section: {
      margin: "0.9em 0" // 0.9em collapses into Header margin when present

    }
  };
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("section", {
    "data-component-name": "Section",
    "data-component-prop-label": label,
    "aria-label": label,
    tabIndex: 0,
    style: styles.section
  }, label && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Heading__["a" /* default */], {
    label: label,
    style: {
      marginLeft: __WEBPACK_IMPORTED_MODULE_4__Theme__["a" /* default */].Padding.CONTENT
    }
  }), __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    style: styles.content,
    "data-component-section": "content"
  }, children));
};

Section.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Theme__ = __webpack_require__(18);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    "data-component-name": "ButtonGroup",
    style: _objectSpread({
      width: "100%"
    }, __WEBPACK_IMPORTED_MODULE_3__Theme__["a" /* default */].Styles.flexLayout)
  }, __WEBPACK_IMPORTED_MODULE_1_react__["Children"].toArray(children).map(function (button, index, all) {
    var style = _objectSpread({}, button.props.style);

    Object.assign(style, __WEBPACK_IMPORTED_MODULE_3__Theme__["a" /* default */].Styles.flexStretchEqual);

    if (all.length !== 1) {
      var borderRadius = style.borderRadius || __WEBPACK_IMPORTED_MODULE_3__Theme__["a" /* default */].Button.RADIUS;
      style.borderRadius = "";
      var borderRule = "1px solid rgba(0, 0, 0, 0.15)";

      if (index === 0) {
        // first button
        Object.assign(style, {
          borderTopLeftRadius: borderRadius,
          borderBottomLeftRadius: borderRadius,
          borderRight: borderRule
        });
      } else if (index + 1 === all.length) {
        // last button
        Object.assign(style, {
          borderTopRightRadius: borderRadius,
          borderBottomRightRadius: borderRadius,
          borderLeft: borderRule
        });
      } else {
        // middle buttons
        Object.assign(style, {
          borderLeft: borderRule,
          borderRight: borderRule
        });
      }
    }

    return __WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](button, {
      style: style
    });
  }));
};

ButtonGroup.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SwitchWith404; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Pages_NotFoundPage__ = __webpack_require__(1047);











var SwitchWith404 =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(SwitchWith404, _React$Component);

  function SwitchWith404() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SwitchWith404);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SwitchWith404).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SwitchWith404, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["e" /* Switch */], null, children, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["c" /* Route */] // fallback
      , {
        component: __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Pages_NotFoundPage__["a" /* default */]
      }));
    }
  }]);

  return SwitchWith404;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(SwitchWith404, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
});



/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_LinearProgress__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_Theme__ = __webpack_require__(18);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var styles = {
  wrapper: function wrapper(context) {
    var leftSafePadding = context.isLargeAppLayout ? "0px" : __WEBPACK_IMPORTED_MODULE_3_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_LEFT;
    return {
      marginBottom: "-4px",
      // LinearProgress is 4px high
      zIndex: "1",
      marginLeft: "calc(-1 * ".concat(leftSafePadding, ")"),
      paddingLeft: leftSafePadding,
      marginRight: "calc(-1 * ".concat(__WEBPACK_IMPORTED_MODULE_3_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_RIGHT, ")"),
      paddingRight: __WEBPACK_IMPORTED_MODULE_3_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_RIGHT
    };
  }
}; // It's like LinearProgress, but it doesn't push stuff after it downwards.
// This is nice to use when the LinearProgress may appear and disappear, because
// when it (dis)appears, it won't change the flow of the page.

var OverlayLinearProgress = function OverlayLinearProgress(props, context) {
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    style: styles.wrapper(context)
  }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_nx_components_LinearProgress__["a" /* default */], props));
};

OverlayLinearProgress.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_2_nx_components_LinearProgress__["a" /* default */].propTypes);
/* harmony default export */ __webpack_exports__["a"] = (OverlayLinearProgress);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackedScrollableArea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Scrollable_ScrollableArea__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);










var rememberedScrollTops = {};

var TrackedScrollableArea =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(TrackedScrollableArea, _React$Component);

  function TrackedScrollableArea() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, TrackedScrollableArea);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(TrackedScrollableArea).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(TrackedScrollableArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this._div) {
        return;
      }

      var trackingKey = this.props.trackingKey;

      if (trackingKey && rememberedScrollTops[trackingKey]) {
        this._div.scrollTop = rememberedScrollTops[trackingKey];
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this._div) {
        return;
      }

      var trackingKey = this.props.trackingKey;

      if (trackingKey) {
        rememberedScrollTops[trackingKey] = this._div.scrollTop;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          children = _this$props.children,
          style = _this$props.style,
          _captureRef = _this$props.captureRef,
          trackingKey = _this$props.trackingKey,
          otherProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["children", "style", "captureRef", "trackingKey"]);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Scrollable_ScrollableArea__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        style: style,
        captureRef: function captureRef(el) {
          _this._div = el;

          if (_captureRef) {
            _captureRef(el);
          }
        }
      }, otherProps), children);
    }
  }], [{
    key: "forgetAll",
    value: function forgetAll() {
      rememberedScrollTops = {};
    }
  }]);

  return TrackedScrollableArea;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(TrackedScrollableArea, "propTypes", {
  trackingKey: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.node,
  style: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object,
  captureRef: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
});




/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = createTileControlsForDevice;
/* harmony export (immutable) */ __webpack_exports__["b"] = createDetailedControlsForDevice;
/* harmony export (immutable) */ __webpack_exports__["c"] = createTileControlForAutomation;
/* harmony export (immutable) */ __webpack_exports__["a"] = createDetailedControlForAutomation;
/* harmony export (immutable) */ __webpack_exports__["d"] = createTileControlsForBuilding;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__ = __webpack_require__(1094);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function createControlsForDevice(device) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controls = [];
  var index = 0;

  var pushControl = function pushControl(componentType) {
    var componentName = componentType.name || componentType.displayName;
    var key = "".concat(componentName, "-").concat(index);
    var element = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](componentType, _objectSpread({
      model: device,
      key: key
    }, props));
    controls.push(element);
    index++;
  };

  if (__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].getMultiVideoEnabled() && device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Group"]) && device.getGroupMembers().length > 0 && device.getGroupMembers().all(function (childDevice) {
    return childDevice.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Camera"]);
  })) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["k" /* MultiCamera */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Alarm"]) && device.canToggleAlarm()) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["d" /* Alarm */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Barrier"])) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["e" /* Barrier */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Camera"])) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["f" /* Camera */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Dimmer"])) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["g" /* Dimmer */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Fan"])) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["h" /* Fan */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["LockLock"]) && device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["UnlockLock"])) {
    // Locks that can be remotely locked and unlocked
    if (!device.get("isLocked") && !device.get("isUnlocked")) {
      // Unknown state; show lock button
      pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["j" /* LockLockButton */]);
    } else {
      pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["i" /* LockAndUnlock */]);
    }
  } else if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["LockLock"]) && device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["ActivateLock"])) {
    // Locks that can be remotely locked or activated, but not unlocked
    if (device.get("isActivatable")) {
      pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["c" /* ActivateLockButton */]);
    } else if (!device.get("isLocked")) {
      pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["j" /* LockLockButton */]);
    }
  } else if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["ActivateLock"])) {
    // Locks that can be remotely activated, but not locked or unlocked
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["c" /* ActivateLockButton */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Occupancy"])) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["m" /* NestStructure */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Streamable"])) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["l" /* NestCamera */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Speaker"])) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["n" /* Speaker */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Switch"])) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["o" /* Switch */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Thermostat"]) && !device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Group"])) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["p" /* Thermostat */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Valve"])) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["q" /* Valve */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["WindowShadeSetPercentOpen"])) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["s" /* WindowShadeSetPercentOpen */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["WindowShadeOpenCloseStop"])) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["r" /* WindowShadeOpenCloseStop */]);
  }

  if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["ActionButtons"])) {
    pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["a" /* ActionButtons */]);
  }

  return controls;
}

function createControlsForBuilding(building) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controls = [];
  var index = 0;
  var devices = building.get("devices");

  var pushControl = function pushControl(componentType, device) {
    var componentName = componentType.name || componentType.displayName;
    var key = "".concat(componentName, "-").concat(index);
    var element = __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](componentType, _objectSpread({
      model: device,
      key: key
    }, props));
    controls.push(element);
    index++;
  };

  devices.each(function (device) {
    if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Alarm"]) && device.canToggleAlarm()) {
      pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["d" /* Alarm */], device);
    }

    if (device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Thermostat"]) && !device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Group"])) {
      pushControl(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["p" /* Thermostat */], device);
    }
  });
  return controls;
}

function createTileControlsForDevice(device) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controls = createControlsForDevice(device, _objectSpread({
    isDetailed: false
  }, props));
  return controls[0] || null;
}
function createDetailedControlsForDevice(device) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controls = createControlsForDevice(device, _objectSpread({
    isDetailed: true
  }, props));

  if (controls.length === 0) {
    return null;
  }

  return controls;
}
function createTileControlForAutomation(automation) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["b" /* ActivateAutomation */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
    isDetailed: false,
    model: automation
  }, props));
}
function createDetailedControlForAutomation(automation) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls__["b" /* ActivateAutomation */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
    isDetailed: true,
    model: automation
  }, props));
}
function createTileControlsForBuilding(building) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controls = createControlsForBuilding(building, _objectSpread({
    isDetailed: true
  }, props));
  return controls[0] || null;
}

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThermostatSetpoints; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ThermostatSetpointControls__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PivotThermostatSetpointControls__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__calculateSetpoint__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ScreenReaderOnlyLiveRegion__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ContextWrappers_UserLanguageContext__ = __webpack_require__(34);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var ThermostatSetpoints =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ThermostatSetpoints, _React$Component);

  function ThermostatSetpoints() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ThermostatSetpoints);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ThermostatSetpoints)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      setpointHeat: _this.props.setpointHeat,
      setpointCool: _this.props.setpointCool,
      changesInProgressCount: 0
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleHeatValue", function (heatSetpoint) {
      _this._mostRecentlyChangedValue = "heat";

      _this.setState(function (prevState) {
        var info = _objectSpread({}, _this.props, {}, prevState);

        return Object(__WEBPACK_IMPORTED_MODULE_11__calculateSetpoint__["b" /* updateHeatSetpoint */])(info, heatSetpoint);
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleCoolValue", function (coolSetpoint) {
      _this._mostRecentlyChangedValue = "cool";

      _this.setState(function (prevState) {
        var info = _objectSpread({}, _this.props, {}, prevState);

        return Object(__WEBPACK_IMPORTED_MODULE_11__calculateSetpoint__["a" /* updateCoolSetpoint */])(info, coolSetpoint);
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChangesStarted", function () {
      if (!_this._isMounted) {
        return;
      }

      _this._initialSetpoints = {
        setpointHeat: _this.state.setpointHeat,
        setpointCool: _this.state.setpointCool
      }; // If there haven't been any changes yet, call onChangesStarted

      if (_this.state.changesInProgressCount === 0 && _this.props.onChangesStarted) {
        _this.props.onChangesStarted(_this._initialSetpoints);
      }

      _this.setState(function (prevState) {
        return {
          changesInProgressCount: prevState.changesInProgressCount + 1
        };
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChangesEnded", function (aborted) {
      if (!_this._isMounted) {
        return;
      }

      var _this$state = _this.state,
          changesInProgressCount = _this$state.changesInProgressCount,
          setpointHeat = _this$state.setpointHeat,
          setpointCool = _this$state.setpointCool;
      var newStateUpdater;
      var finalSetpoints;

      if (aborted) {
        newStateUpdater = function newStateUpdater(prevState) {
          return _objectSpread({
            changesInProgressCount: prevState.changesInProgressCount - 1
          }, _this._initialSetpoints);
        };

        finalSetpoints = _this._initialSetpoints;
      } else {
        newStateUpdater = function newStateUpdater(prevState) {
          return {
            changesInProgressCount: prevState.changesInProgressCount - 1
          };
        };

        finalSetpoints = {
          setpointHeat: setpointHeat,
          setpointCool: setpointCool
        };
      }

      _this.setState(newStateUpdater); // If this is the only change and it's about to end, call onChangesEnded


      if (changesInProgressCount === 1 && _this.props.onChangesEnded) {
        _this.props.onChangesEnded(finalSetpoints);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ThermostatSetpoints, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this._isMounted = true;
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        setpointHeat: nextProps.setpointHeat,
        setpointCool: nextProps.setpointCool
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.changesInProgressCount > 0 && this.props.onChangesCanceled) {
        this.props.onChangesCanceled({
          setpointHeat: this.state.setpointHeat,
          setpointCool: this.state.setpointCool
        });
      }

      this.setState({
        changesInProgressCount: 0
      });
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          setpointIncrement = _this$props.setpointIncrement,
          setpointCoolMin = _this$props.setpointCoolMin,
          setpointCoolMax = _this$props.setpointCoolMax,
          formatter = _this$props.formatter,
          changeBufferMs = _this$props.changeBufferMs,
          setpointHeatMin = _this$props.setpointHeatMin,
          setpointHeatMax = _this$props.setpointHeatMax,
          occuLabel = _this$props.occuLabel,
          occuLabelStyle = _this$props.occuLabelStyle,
          isCommercial = _this$props.isCommercial;
      var _this$state2 = this.state,
          setpointHeat = _this$state2.setpointHeat,
          setpointCool = _this$state2.setpointCool;
      var languageContext = this.context;
      var language = languageContext.localeSet.nx_components.ThermostatSetpoints;
      var valueWidth = 50;

      if (setpointIncrement < 1) {
        if (isCommercial) {
          valueWidth = 75;
        } else {
          valueWidth = 70;
        }
      }

      var styles = {
        value: {
          width: valueWidth
        }
      };
      var valuesRegionId = "nx-components_ThermostatSetpoints_values";
      var valuesRegionContent = null;

      if (this.props.setpointCool != null && this.props.setpointHeat != null) {
        if (this._mostRecentlyChangedValue === "heat") {
          // If heat was recently changed, then announce the heat value first
          // instead of the cool value, since that's more relevant.
          valuesRegionContent = language.heatToCoolTo;
        } else {
          valuesRegionContent = language.coolToHeatTo;
        }
      } else if (this.props.setpointCool != null) {
        valuesRegionContent = language.coolTo;
      } else if (this.props.setpointHeat != null) {
        valuesRegionContent = language.heatTo;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "ThermostatSetpoints"
      }, valuesRegionContent && __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__ScreenReaderOnlyLiveRegion__["a" /* default */], {
        id: valuesRegionId
      }, valuesRegionContent), isCommercial ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__PivotThermostatSetpointControls__["a" /* default */], {
        setpointIncrement: setpointIncrement,
        setpointCoolMin: setpointCoolMin,
        setpointCoolMax: setpointCoolMax,
        setpointCool: setpointCool,
        setpointHeatMin: setpointHeatMin,
        setpointHeatMax: setpointHeatMax,
        setpointHeat: setpointHeat,
        onCoolValue: this.handleCoolValue,
        onHeatValue: this.handleHeatValue,
        onChangesStarted: this.handleChangesStarted,
        onChangesEnd: this.handleChangesEnded,
        changeBufferMs: changeBufferMs,
        valueStyle: styles.value,
        hasAriaControls: Boolean(valuesRegionContent),
        occuLabel: occuLabel,
        occuLabelStyle: occuLabelStyle
      }) : __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ThermostatSetpointControls__["a" /* default */], {
        setpointIncrement: setpointIncrement,
        setpointCoolMin: setpointCoolMin,
        setpointCoolMax: setpointCoolMax,
        setpointCool: setpointCool,
        setpointHeatMin: setpointHeatMin,
        setpointHeatMax: setpointHeatMax,
        setpointHeat: setpointHeat,
        onCoolValue: this.handleCoolValue,
        onHeatValue: this.handleHeatValue,
        onChangesStarted: this.handleChangesStarted,
        onChangesEnd: this.handleChangesEnded,
        formatter: formatter,
        changeBufferMs: changeBufferMs,
        valueStyle: styles.value,
        hasAriaControls: Boolean(valuesRegionContent)
      }));
    }
  }]);

  return ThermostatSetpoints;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ThermostatSetpoints, "propTypes", {
  onChangesStarted: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onChangesEnded: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onChangesCanceled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  changeBufferMs: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  formatter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  setpointHeat: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  setpointHeatMin: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  setpointHeatMax: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  setpointCool: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  setpointCoolMin: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  setpointCoolMax: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  setpointIncrement: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  // the delta is used internally by calculateSetpoint
  setpointDelta: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  // eslint-disable-line react/no-unused-prop-types
  occuLabel: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  occuLabelStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  isCommercial: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ThermostatSetpoints, "defaultProps", {
  changeBufferMs: 2000,
  setpointDelta: 3
});


ThermostatSetpoints.contextType = __WEBPACK_IMPORTED_MODULE_13__ContextWrappers_UserLanguageContext__["b" /* default */];

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_prefixStyles__ = __webpack_require__(9);



var style = Object(__WEBPACK_IMPORTED_MODULE_2__utils_prefixStyles__["b" /* default */])({
  position: "absolute",
  left: "-10000px",
  top: "auto",
  width: "1px",
  height: "1px",
  overflow: "hidden",
  flexShrink: 1
});

var ScreenReaderOnlyLiveRegion = function ScreenReaderOnlyLiveRegion(_ref) {
  var id = _ref.id,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    id: id,
    style: style,
    "aria-live": "assertive",
    "data-component-name": "ScreenReaderOnlyLiveRegion"
  }, children);
};

ScreenReaderOnlyLiveRegion.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (ScreenReaderOnlyLiveRegion);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__GlobalStyleSheet__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ANIMATION_LENGTH = 250;
var STYLE_ID = "nx-components_CheckboxAnimation";
var stylesheet = "\n  @keyframes ".concat(STYLE_ID, "_shrink-bounce {\n    0% {\n      transform: scale(1);\n    }\n    33% {\n      transform: scale(0.85);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n  @keyframes ").concat(STYLE_ID, "_checkbox-check {\n    0%{\n      width: 0;\n      height: 0;\n      border-bottom: 2px solid white;\n      transform: translate(-0.3em, 0) rotate(45deg);\n    }\n    33%{\n      width: .2em;\n      height: 0;\n      border-bottom: 2px solid white;\n      border-right: 2px solid white;\n      transform: translate(-0.3em, -0.1em) rotate(45deg);\n    }\n    100%{\n      width: .2em;\n      height: .5em;\n      border-bottom: 2px solid white;\n      border-right: 2px solid white;\n      transform: translate(-0.3em, -0.6em) rotate(45deg);\n    }\n  }\n  @keyframes ").concat(STYLE_ID, "_indeterminate-check {\n    0%{\n      transform: scale(0);\n    }\n    100%{\n      transform: scale(1);\n    }\n  }\n");
__WEBPACK_IMPORTED_MODULE_12__GlobalStyleSheet__["a" /* default */].preload(STYLE_ID, stylesheet);

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Checkbox, _React$Component);

  function Checkbox() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Checkbox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleChecked", function () {
      var onTap = _this.props.onTap;

      if (onTap) {
        onTap();
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Checkbox, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.checked !== this.props.checked || nextProps.indeterminate !== this.props.indeterminate;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          checked = _this$props.checked,
          style = _this$props.style,
          onTap = _this$props.onTap,
          colors = _this$props.colors,
          disabled = _this$props.disabled,
          indeterminate = _this$props.indeterminate,
          domAttrs = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["checked", "style", "onTap", "colors", "disabled", "indeterminate"]);

      var styles = Object(__WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["b" /* default */])({
        wrapper: {
          position: "relative",
          fontSize: "24px",
          width: "1em",
          height: "1em"
        },
        checkedWrapper: {
          animation: "".concat(STYLE_ID, "_shrink-bounce ").concat(ANIMATION_LENGTH, "ms ease-out")
        },
        borderContainer: {
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          borderWidth: "2px",
          borderStyle: "solid",
          borderColor: disabled ? colors.TEXT_DISABLED : "currentColor",
          borderRadius: "2px",
          transition: "all ".concat(ANIMATION_LENGTH, "ms ease-out")
        },
        checkedBorderContainer: {
          borderWidth: "0.5em",
          borderStyle: "solid",
          borderColor: disabled ? colors.TEXT_DISABLED : colors.PRIMARY
        },
        checkmark: {
          position: "absolute",
          transformOrigin: "bottom left",
          boxSizing: "content-box",
          borderBottom: "0px solid white",
          // border must be present for Safari to animate
          borderRight: "0px solid white",
          animation: "".concat(STYLE_ID, "_checkbox-check ").concat(ANIMATION_LENGTH, "ms 125ms ease-out forwards")
        },
        indeterminateWrapper: {
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        },
        indeterminateCheckMark: {
          width: "0.5em",
          height: "0.25em",
          backgroundColor: "white",
          transform: "scale(0)",
          animation: "".concat(STYLE_ID, "_indeterminate-check ").concat(ANIMATION_LENGTH, "ms 125ms ease-out forwards"),
          borderRadius: "2px"
        }
      });
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Tappable__["b" /* default */], {
        onTap: disabled ? null : this._handleChecked
      }, function (_ref) {
        var tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          "data-component-name": "Checkbox",
          "data-component-prop-checked": String(checked),
          "data-component-prop-indeterminate": String(indeterminate),
          style: _objectSpread({}, styles.wrapper, {}, checked ? styles.checkedWrapper : {}, {}, style),
          ref: tapTargetRefHandler,
          tabIndex: "0"
        }, domAttrs), __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
          style: _objectSpread({}, styles.borderContainer, {}, checked ? styles.checkedBorderContainer : null)
        }, checked && !indeterminate ? __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("span", {
          "data-component-section": "checkmark",
          style: styles.checkmark
        }) : null), checked && indeterminate ? __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
          style: styles.indeterminateWrapper
        }, __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("span", {
          "data-component-section": "indeterminate-mark",
          style: styles.indeterminateCheckMark
        })) : null);
      });
    }
  }]);

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Checkbox, "propTypes", {
  checked: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  onTap: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  },
  indeterminate: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["c" /* withColorsProvider */])(Checkbox));




/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
var document = __webpack_require__(21).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var core = __webpack_require__(61);
var LIBRARY = __webpack_require__(99);
var wksExt = __webpack_require__(330);
var defineProperty = __webpack_require__(38).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(153)('keys');
var uid = __webpack_require__(112);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 232 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(21).document;
module.exports = document && document.documentElement;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(26);
var anObject = __webpack_require__(19);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(67)(Function.call, __webpack_require__(63).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
var setPrototypeOf = __webpack_require__(234).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(69);
var defined = __webpack_require__(76);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 238 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 239 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(99);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(55);
var hide = __webpack_require__(54);
var Iterators = __webpack_require__(137);
var $iterCreate = __webpack_require__(241);
var setToStringTag = __webpack_require__(134);
var getPrototypeOf = __webpack_require__(64);
var ITERATOR = __webpack_require__(29)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(115);
var descriptor = __webpack_require__(111);
var setToStringTag = __webpack_require__(134);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(54)(IteratorPrototype, __webpack_require__(29)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(183);
var defined = __webpack_require__(76);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(29)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(137);
var ITERATOR = __webpack_require__(29)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(38);
var createDesc = __webpack_require__(111);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(135);
var ITERATOR = __webpack_require__(29)('iterator');
var Iterators = __webpack_require__(137);
module.exports = __webpack_require__(61).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(634);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(39);
var toAbsoluteIndex = __webpack_require__(114);
var toLength = __webpack_require__(30);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(101);
var step = __webpack_require__(347);
var Iterators = __webpack_require__(137);
var toIObject = __webpack_require__(62);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(240)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(156);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(182)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(67);
var invoke = __webpack_require__(337);
var html = __webpack_require__(233);
var cel = __webpack_require__(229);
var global = __webpack_require__(21);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(68)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var macrotask = __webpack_require__(252).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(68)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(50);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(21);
var DESCRIPTORS = __webpack_require__(33);
var LIBRARY = __webpack_require__(99);
var $typed = __webpack_require__(189);
var hide = __webpack_require__(54);
var redefineAll = __webpack_require__(120);
var fails = __webpack_require__(25);
var anInstance = __webpack_require__(118);
var toInteger = __webpack_require__(69);
var toLength = __webpack_require__(30);
var toIndex = __webpack_require__(357);
var gOPN = __webpack_require__(116).f;
var dP = __webpack_require__(38).f;
var arrayFill = __webpack_require__(248);
var setToStringTag = __webpack_require__(134);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function capitalize(str, lowercaseRest) {
  str = makeString(str);
  var remainingChars = !lowercaseRest ? str.slice(1) : str.slice(1).toLowerCase();

  return str.charAt(0).toUpperCase() + remainingChars;
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var escapeRegExp = __webpack_require__(377);

module.exports = function defaultToWhiteSpace(characters) {
  if (characters == null)
    return '\\s';
  else if (characters.source)
    return characters.source;
  else
    return '[' + escapeRegExp(characters) + ']';
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function chars(str) {
  return makeString(str).split('');
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);
var defaultToWhiteSpace = __webpack_require__(257);
var nativeTrimRight = String.prototype.trimRight;

module.exports = function rtrim(str, characters) {
  str = makeString(str);
  if (!characters && nativeTrimRight) return nativeTrimRight.call(str);
  characters = defaultToWhiteSpace(characters);
  return str.replace(new RegExp(characters + '+$'), '');
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 261 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__(389);

var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
      ? global
      : typeof self !== 'undefined'
        ? self
        : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch (Object.prototype.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return Object.prototype.toString.call(value) === '[object ErrorEvent]';
}

function isDOMError(value) {
  return Object.prototype.toString.call(value) === '[object DOMError]';
}

function isDOMException(value) {
  return Object.prototype.toString.call(value) === '[object DOMException]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isPlainObject(what) {
  return Object.prototype.toString.call(what) === '[object Object]';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isArray(what) {
  return Object.prototype.toString.call(what) === '[object Array]';
}

function isEmptyObject(what) {
  if (!isPlainObject(what)) return false;

  for (var _ in what) {
    if (what.hasOwnProperty(_)) {
      return false;
    }
  }
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMError() {
  try {
    new DOMError(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMException() {
  try {
    new DOMException(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsFetch() {
  if (!('fetch' in _window)) return false;

  try {
    new Headers(); // eslint-disable-line no-new
    new Request(''); // eslint-disable-line no-new
    new Response(); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
// https://caniuse.com/#feat=referrer-policy
// It doesn't. And it throw exception instead of ignoring this parameter...
// REF: https://github.com/getsentry/raven-js/issues/1233
function supportsReferrerPolicy() {
  if (!supportsFetch()) return false;

  try {
    // eslint-disable-next-line no-new
    new Request('pickleRick', {
      referrerPolicy: 'origin'
    });
    return true;
  } catch (e) {
    return false;
  }
}

function supportsPromiseRejectionEvent() {
  return typeof PromiseRejectionEvent === 'function';
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function(key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  if (typeof max !== 'number') {
    throw new Error('2nd argument to `truncate` function should be a number');
  }
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
    i = 0,
    len = patterns.length,
    pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function(key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  if (typeof url !== 'string') return {};
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = function(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return (
      pad(arr[0]) +
      pad(arr[1]) +
      pad(arr[2]) +
      pad(arr[3]) +
      pad(arr[4]) +
      pad(arr[5]) +
      pad(arr[6]) +
      pad(arr[7])
    );
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
    MAX_OUTPUT_LEN = 80,
    out = [],
    height = 0,
    len = 0,
    separator = ' > ',
    sepLength = separator.length,
    nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (
      nextStr === 'html' ||
      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
    ) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
    className,
    classes,
    key,
    attr,
    i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if both parameters are undefined
 */
function isBothUndefined(a, b) {
  return isUndefined(a) && isUndefined(b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  // in case both stacktraces are undefined, we can't decide so default to false
  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if stacktrace is malformed
  if (frames1 === undefined || frames2 === undefined) return false;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (
      a.filename !== b.filename ||
      a.lineno !== b.lineno ||
      a.colno !== b.colno ||
      a['function'] !== b['function']
    )
      return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  if (obj == null) return;
  var orig = obj[name];
  obj[name] = replacement(orig);
  obj[name].__raven__ = true;
  obj[name].__orig__ = orig;
  if (track) {
    track.push([obj, name, orig]);
  }
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns {string}
 */
function safeJoin(input, delimiter) {
  if (!isArray(input)) return '';

  var output = [];

  for (var i = 0; i < input.length; i++) {
    try {
      output.push(String(input[i]));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

// Default Node.js REPL depth
var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
// 50kB, as 100kB is max payload size, so half sounds reasonable
var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
var MAX_SERIALIZE_KEYS_LENGTH = 40;

function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}

function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

function serializeValue(value) {
  if (typeof value === 'string') {
    var maxLength = 40;
    return truncate(value, maxLength);
  } else if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'undefined'
  ) {
    return value;
  }

  var type = Object.prototype.toString.call(value);

  // Node.js REPL notation
  if (type === '[object Object]') return '[Object]';
  if (type === '[object Array]') return '[Array]';
  if (type === '[object Function]')
    return value.name ? '[Function: ' + value.name + ']' : '[Function]';

  return value;
}

function serializeObject(value, depth) {
  if (depth === 0) return serializeValue(value);

  if (isPlainObject(value)) {
    return Object.keys(value).reduce(function(acc, key) {
      acc[key] = serializeObject(value[key], depth - 1);
      return acc;
    }, {});
  } else if (Array.isArray(value)) {
    return value.map(function(val) {
      return serializeObject(val, depth - 1);
    });
  }

  return serializeValue(value);
}

function serializeException(ex, depth, maxSize) {
  if (!isPlainObject(ex)) return ex;

  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;

  var serialized = serializeObject(ex, depth);

  if (jsonSize(stringify(serialized)) > maxSize) {
    return serializeException(ex, depth - 1);
  }

  return serialized;
}

function serializeKeysForMessage(keys, maxLength) {
  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
  if (!Array.isArray(keys)) return '';

  keys = keys.filter(function(key) {
    return typeof key === 'string';
  });
  if (keys.length === 0) return '[object has no keys]';

  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
  if (keys[0].length >= maxLength) return keys[0];

  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
    var serialized = keys.slice(0, usedKeys).join(', ');
    if (serialized.length > maxLength) continue;
    if (usedKeys === keys.length) return serialized;
    return serialized + '\u2026';
  }

  return '';
}

function sanitize(input, sanitizeKeys) {
  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
    return input;

  var sanitizeRegExp = joinRegExp(sanitizeKeys);
  var sanitizeMask = '********';
  var safeInput;

  try {
    safeInput = JSON.parse(stringify(input));
  } catch (o_O) {
    return input;
  }

  function sanitizeWorker(workerInput) {
    if (isArray(workerInput)) {
      return workerInput.map(function(val) {
        return sanitizeWorker(val);
      });
    }

    if (isPlainObject(workerInput)) {
      return Object.keys(workerInput).reduce(function(acc, k) {
        if (sanitizeRegExp.test(k)) {
          acc[k] = sanitizeMask;
        } else {
          acc[k] = sanitizeWorker(workerInput[k]);
        }
        return acc;
      }, {});
    }

    return workerInput;
  }

  return sanitizeWorker(safeInput);
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isDOMError: isDOMError,
  isDOMException: isDOMException,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isPlainObject: isPlainObject,
  isString: isString,
  isArray: isArray,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  supportsDOMError: supportsDOMError,
  supportsDOMException: supportsDOMException,
  supportsFetch: supportsFetch,
  supportsReferrerPolicy: supportsReferrerPolicy,
  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill,
  safeJoin: safeJoin,
  serializeException: serializeException,
  serializeKeysForMessage: serializeKeysForMessage,
  sanitize: sanitize
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(403),
    eq = __webpack_require__(407);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(122),
    root = __webpack_require__(71);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_url__ = __webpack_require__(73);

/* harmony default export */ __webpack_exports__["a"] = ({
  parseLinksNext: function parseLinksNext(links) {
    var link = _.first(links);

    if (link) {
      this._nextHref = link.href;

      if (this.clonedResource) {
        this.clonedResource._nextHref = link.href;
      }
    } else {
      this._nextHref = null;

      if (this.clonedResource) {
        this.clonedResource._nextHref = null;
      }
    }
  },
  hasNextPage: function hasNextPage() {
    return Boolean(this._nextHref);
  },
  fetchNextPage: function fetchNextPage(options) {
    return this._getPageFromHref(this._nextHref, options);
  },
  parseLinksPrevious: function parseLinksPrevious(links) {
    var link = _.first(links);

    if (link) {
      this._previousHref = link.href;

      if (this.clonedResource) {
        this.clonedResource._previousHref = link.href;
      }
    } else {
      this._previousHref = null;

      if (this.clonedResource) {
        this.clonedResource._previousHref = null;
      }
    }
  },
  hasPreviousPage: function hasPreviousPage() {
    return Boolean(this._previousHref);
  },
  fetchPreviousPage: function fetchPreviousPage(options) {
    return this._getPageFromHref(this._previousHref, options);
  },
  parseLinksPage: function parseLinksPage(links) {
    var link = _.first(links);

    if (link) {
      this._pageTemplateLink = link.href;
      var data = link.getData();
      this._pageCount = data.page_count;
      this._currentPageNumber = data.current_page;

      if (this.clonedResource) {
        this.clonedResource._pageTemplateLink = link.href;
        this.clonedResource._pageCount = data.page_count;
        this.clonedResource._currentPageNumber = data.current_page;
      }
    } else {
      this._pageTemplateLink = null;
      this._pageCount = null;
      this._currentPageNumber = null;

      if (this.clonedResource) {
        this.clonedResource._pageTemplateLink = null;
        this.clonedResource._pageCount = null;
        this.clonedResource._currentPageNumber = null;
      }
    }
  },
  getPages: function getPages() {
    var pages = [];

    for (var pageNumber = 1; pageNumber <= this._pageCount; pageNumber++) {
      pages.push({
        pageNumber: pageNumber
      });
    }

    return pages;
  },
  currentPageNumber: function currentPageNumber() {
    return this._currentPageNumber || 1;
  },
  fetchCurrentPage: function fetchCurrentPage() {
    var href = __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_url__["a" /* default */].expandTemplate(this._pageTemplateLink, {
      page: this.currentPageNumber()
    });
    return this._getPageFromHref(href);
  },
  fetchPage: function fetchPage(pageNumber) {
    if (!this._pageCount) {
      throw new Error("Attempted to fetch a page before a Page link was parsed");
    }

    if (pageNumber > this._pageCount) {
      throw new Error("Attempted to get page with pageNumber ".concat(pageNumber, " which was higher than the pageCount ").concat(this._pageCount));
    }

    var href = __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_url__["a" /* default */].expandTemplate(this._pageTemplateLink, {
      page: pageNumber
    });
    return this._getPageFromHref(href);
  },
  _getPageFromHref: function _getPageFromHref(href, options) {
    var _this = this;

    if (href == null) {
      throw new Error("Attempted to get page from null href");
    }

    return this.fetchUrlWithResourceClone(href, options).then(function (newPage) {
      _this.reset(newPage.models);
    });
  }
});

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1));

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

var _deepmerge = _interopRequireDefault(__webpack_require__(204));

var _isPlainObject = _interopRequireDefault(__webpack_require__(882));

var _warning = _interopRequireDefault(__webpack_require__(49));

var _createBreakpoints = _interopRequireDefault(__webpack_require__(884));

var _createMixins = _interopRequireDefault(__webpack_require__(885));

var _createPalette = _interopRequireDefault(__webpack_require__(886));

var _createTypography = _interopRequireDefault(__webpack_require__(892));

var _shadows = _interopRequireDefault(__webpack_require__(898));

var _shape = _interopRequireDefault(__webpack_require__(899));

var _spacing = _interopRequireDefault(__webpack_require__(900));

var _transitions = _interopRequireDefault(__webpack_require__(205));

var _zIndex = _interopRequireDefault(__webpack_require__(901));

// < 1kb payload overhead when lodash/merge is > 3kb.
function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      shadowsInput = options.shadows,
      _options$spacing = options.spacing,
      spacingInput = _options$spacing === void 0 ? {} : _options$spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "shadows", "spacing", "typography"]);
  var palette = (0, _createPalette.default)(paletteInput);
  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
  var spacing = (0, _extends2.default)({}, _spacing.default, spacingInput);
  var muiTheme = (0, _extends2.default)({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: (0, _createMixins.default)(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Inject custom properties
    shadows: shadowsInput || _shadows.default,
    typography: (0, _createTypography.default)(palette, typographyInput)
  }, (0, _deepmerge.default)({
    shape: _shape.default,
    spacing: spacing,
    transitions: _transitions.default,
    zIndex: _zIndex.default
  }, other, {
    isMergeableObject: _isPlainObject.default
  }));

  if (false) {
    var statesWarning = ['disabled', 'focused', 'selected', 'checked'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (statesWarning.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          process.env.NODE_ENV !== "production" ? (0, _warning.default)(false, ["Material-UI: the `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify((0, _defineProperty2.default)({}, "&$".concat(key), child), null, 2), '', 'https://material-ui.com/customization/overrides#internal-states'].join('\n')) : void 0;
        }
      }
    };

    traverse(other.overrides);
  }

   false ? (0, _warning.default)(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;
  return muiTheme;
}

var _default = createMuiTheme;
exports.default = _default;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(206);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(425);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(208);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CHANNEL = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1));

// Same value used by react-jss
var CHANNEL = '__THEMING__';
exports.CHANNEL = CHANNEL;
var themeListener = {
  contextTypes: (0, _defineProperty2.default)({}, CHANNEL, function () {}),
  initial: function initial(context) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].getState();
  },
  subscribe: function subscribe(context, cb) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].subscribe(cb);
  },
  unsubscribe: function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
};
var _default = themeListener;
exports.default = _default;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(2));

var _createClass2 = _interopRequireDefault(__webpack_require__(3));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(5));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(4));

var _inherits2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(40));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(303));

var _utils = __webpack_require__(80);

var _createMuiTheme = _interopRequireDefault(__webpack_require__(268));

var _themeListener = _interopRequireDefault(__webpack_require__(273));

/* eslint-disable no-underscore-dangle */
var defaultTheme;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme.default)({
    typography: {
      suppressWarning: true
    }
  });
  return defaultTheme;
} // Provide the theme object as a property to the input component.


var withThemeOld = function withThemeOld() {
  return function (Component) {
    var WithTheme =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithTheme, _React$Component);

      function WithTheme(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithTheme);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithTheme).call(this));
        _this.state = {
          // We use || as the function call is lazy evaluated.
          theme: _themeListener.default.initial(context) || getDefaultTheme()
        };
        return _this;
      }

      (0, _createClass2.default)(WithTheme, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            _this2.setState({
              theme: theme
            });
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              innerRef = _this$props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_this$props, ["innerRef"]);
          return _react.default.createElement(Component, (0, _extends2.default)({
            theme: this.state.theme,
            ref: innerRef
          }, other));
        }
      }]);
      return WithTheme;
    }(_react.default.Component);

     false ? WithTheme.propTypes = {
      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : void 0;
    WithTheme.contextTypes = _themeListener.default.contextTypes;

    if (false) {
      WithTheme.displayName = "WithTheme(".concat((0, _utils.getDisplayName)(Component), ")");
    }

    (0, _hoistNonReactStatics.default)(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };
};
/* istanbul ignore if */


if (!_utils.ponyfillGlobal.__MUI_STYLES__) {
  _utils.ponyfillGlobal.__MUI_STYLES__ = {};
}

if (!_utils.ponyfillGlobal.__MUI_STYLES__.withTheme) {
  _utils.ponyfillGlobal.__MUI_STYLES__.withTheme = withThemeOld;
}

var _default = _utils.ponyfillGlobal.__MUI_STYLES__.withTheme;
exports.default = _default;

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bpfrpt_proptype_ColorSetName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bpfrpt_proptype_ColorSet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_ColorSetName = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(["nexia", "pivot"]);
var bpfrpt_proptype_ColorSet = {
  colorSetName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(["nexia", "pivot"]).isRequired,
  PRIMARY: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  PRIMARY_GRADIENT_DARK: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  PRIMARY_GRADIENT_LIGHT: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  PRIMARY_TEXT: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  SECONDARY: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  RED: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  LABEL: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  IMPORTANT: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  WARNING: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  COOL: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  NEW_COOL: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  HEAT: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  COOL_GRADIENT_TOP: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  COOL_GRADIENT_BOTTOM: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  HEAT_GRADIENT_TOP: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  HEAT_GRADIENT_BOTTOM: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  HEADER_BACKGROUND: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  DETAILS_HEADER_BACKGROUND: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  FOOTER_BACKGROUND: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  FOOTER_TEXT: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  SUCCESS: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  ACCEPT: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  REJECT: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  TEXT: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  TITLE: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  TEXT_SECONDARY: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  TEXT_DISABLED: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  DIVIDER: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  OVERLAY_BACKGROUND: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  ANCHOR: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};
var ColorSets = {
  nexia: {
    colorSetName: "nexia",
    PRIMARY: "#1685C4",
    PRIMARY_GRADIENT_DARK: "#106db1",
    PRIMARY_GRADIENT_LIGHT: "#1da2da",
    PRIMARY_TEXT: "#ffffff",
    SECONDARY: "#1f729d",
    RED: "#E2231A",
    LABEL: "#5b5b5b",
    IMPORTANT: "#1685C4",
    WARNING: "#fbcd36",
    COOL: "#188FCB",
    NEW_COOL: "#3e83bf",
    HEAT: "#E2231A",
    COOL_GRADIENT_TOP: "#005eb2",
    COOL_GRADIENT_BOTTOM: "#a6d2d3",
    HEAT_GRADIENT_TOP: "#d00000",
    HEAT_GRADIENT_BOTTOM: "#ffb55c",
    HEADER_BACKGROUND: "#f7f5f3",
    DETAILS_HEADER_BACKGROUND: "",
    FOOTER_BACKGROUND: "#1685C4",
    FOOTER_TEXT: "#ffffff",
    SUCCESS: "#08a818",
    ACCEPT: "#3db14b",
    REJECT: "#E2231A",
    TEXT: "#676767",
    TITLE: "#4c4c4c",
    TEXT_SECONDARY: "#808080",
    TEXT_DISABLED: "#e5e5e5",
    DIVIDER: "#efefef",
    OVERLAY_BACKGROUND: "rgba(0,0,0,0.6)",
    ANCHOR: "blue"
  },
  pivot: {
    colorSetName: "pivot",
    PRIMARY: "#526c7f",
    PRIMARY_GRADIENT_DARK: "#3e515f",
    PRIMARY_GRADIENT_LIGHT: "#758999",
    PRIMARY_TEXT: "#ffffff",
    SECONDARY: "#d7d7da",
    RED: "#E2231A",
    LABEL: "#5b5b5b",
    IMPORTANT: "#526c7f",
    WARNING: "#fbcd36",
    COOL: "#188FCB",
    NEW_COOL: "#3e83bf",
    HEAT: "#E2231A",
    COOL_GRADIENT_TOP: "#005eb2",
    COOL_GRADIENT_BOTTOM: "#a6d2d3",
    HEAT_GRADIENT_TOP: "#d00000",
    HEAT_GRADIENT_BOTTOM: "#ffb55c",
    HEADER_BACKGROUND: "#e2f3ff",
    DETAILS_HEADER_BACKGROUND: "#e2f3ff",
    FOOTER_BACKGROUND: "#e4f2d2",
    FOOTER_TEXT: "#526c7f",
    SUCCESS: "#08a818",
    ACCEPT: "#3db14b",
    REJECT: "#E2231A",
    TEXT: "#919ba3",
    TITLE: "#526c7f",
    TEXT_SECONDARY: "#808080",
    TEXT_DISABLED: "#e5e5e5",
    DIVIDER: "#efefef",
    OVERLAY_BACKGROUND: "rgba(0,0,0,0.6)",
    ANCHOR: "#00326c"
  }
};
/* harmony default export */ __webpack_exports__["c"] = (ColorSets);




/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// helper to capitalize strings

exports.default = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

module.exports = exports["default"];

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  if (Array.isArray(value)) value = value.join(',');

  return value.match(/-webkit-|-moz-|-ms-/) !== null;
};

module.exports = exports['default'];

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_PromiseRetrier__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_framework_resource__ = __webpack_require__(85);







var NUM_RETRIES = 15;
var RETRY_DELAY = 2000;

var EventStream =
/*#__PURE__*/
function () {
  function EventStream() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, EventStream);
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(EventStream, [{
    key: "start",
    value: function start(link) {
      if (this.streamingDisabled) return Promise.resolve();

      this._debug("EventStream.start called");

      this._paused = false;
      this._reconnectUrl = link.data.reconnect_href;
      return this._connectWithRetry(link.href);
    }
  }, {
    key: "pause",
    value: function pause() {
      this._debug("EventStream.pause called");

      this._paused = true;
    }
  }, {
    key: "resume",
    value: function resume() {
      this._debug("EventStream.resume called");

      this._paused = false;
      this.checkForReconnect();
    }
  }, {
    key: "end",
    value: function end() {
      var _this = this;

      this._debug("EventStream.end called");

      if (!this._socket) return Promise.resolve();
      return new Promise(function (resolve) {
        _this._socket.onclose = resolve;

        _this._socket.close();

        _this._socket = null;
      });
    }
  }, {
    key: "checkForReconnect",
    value: function checkForReconnect() {
      if (this.connected) return Promise.resolve();
      if (this.streamingDisabled) return Promise.resolve();
      if (this._paused) return Promise.resolve();
      if (this._connectionInProgress) return this._connectionInProgress;
      return this._reconnect(this._reconnectUrl);
    }
  }, {
    key: "_connectWithRetry",
    value: function _connectWithRetry(wsUrl, reconnectUrl) {
      var _this2 = this;

      if (this._connectionInProgress) return this._connectionInProgress;
      this._connectionInProgress = new __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_PromiseRetrier__["a" /* default */](function () {
        return _this2._initConnection(wsUrl, reconnectUrl);
      }, NUM_RETRIES, RETRY_DELAY).run();

      var nullConnectionInProgress = function nullConnectionInProgress() {
        return _this2._connectionInProgress = null;
      };

      this._connectionInProgress.then(nullConnectionInProgress, nullConnectionInProgress);

      return this._connectionInProgress;
    }
  }, {
    key: "_initConnection",
    value: function _initConnection(wsUrl) {
      var _this3 = this;

      if (this._socket) {
        this._debug("closing open socket before opening new");

        this.end();
      }

      return this._createSocket(wsUrl).then(function (socket) {
        _this3._socket = socket;

        socket.onmessage = function (event) {
          _this3._debug("Message received");

          _this3._onMessage(event);
        };

        socket.onclose = function (event) {
          _this3._debug("WebSocket closed: ".concat(event));

          _this3._socket = null;

          _this3.checkForReconnect();
        };
      });
    }
  }, {
    key: "_createSocket",
    value: function _createSocket(wsUrl) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var socket = new WebSocket(wsUrl);

        _this4._debug("WebSocket created");

        socket.onerror = function (event) {
          var error = new Error("WebSocket Connection Failed");
          error.event = event;

          _this4._debug(error.message);

          reject(error);
        };

        socket.onopen = function () {
          socket.onerror = null;

          _this4._debug("WebSocket opened");

          resolve(socket);
        };
      });
    }
  }, {
    key: "_reconnect",
    value: function _reconnect(reconnectUrl) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        if (!reconnectUrl) {
          reject(new Error("Attempted to start reconnect but had no reconnect URL"));
          return;
        }

        _this5._debug("Calling Nexia to reserve EventStream");

        $.ajax({
          url: reconnectUrl,
          method: "POST",
          dataType: "json",
          error: function error(_jqxhr, textStatus, errorThrown) {
            return reject(new Error("".concat(textStatus, " - ").concat(errorThrown)));
          },
          success: resolve
        });
      }).then(function (data) {
        _this5._debug("Attempting WebSocket reconnect");

        _this5.start(data.result);
      });
    }
  }, {
    key: "_onMessage",
    value: function _onMessage(event) {
      try {
        this._handleMessage(event.data);
      } catch (error) {
        __WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.captureException(new Error("Failed to parse message from Event Stream: ".concat(error.message)), {
          extra: {
            data: event.data
          }
        });
      }
    }
  }, {
    key: "_handleMessage",
    value: function _handleMessage(json) {
      var message = JSON.parse(json);
      if (message.event_type !== "update") return;
      var href = message.serializable._links.self.href;
      var model = __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_framework_resource__["a" /* ResourceMap */].findByHref(href);

      if (model) {
        model.set(model.parse(message.serializable));
      }
    }
  }, {
    key: "_debug",
    value: function _debug(message) {
      if (!__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].getDebugStreaming()) return;
      Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", "ES: ".concat(message));
    }
  }, {
    key: "streamingDisabled",
    get: function get() {
      return !__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].getEventStreamingEnabled();
    }
  }, {
    key: "connected",
    get: function get() {
      return Boolean(this._socket);
    }
  }]);

  return EventStream;
}();

if (EventStream.singleton == null) {
  EventStream.singleton = new EventStream();
}

/* harmony default export */ __webpack_exports__["a"] = (EventStream.singleton);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DOMEventListener; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);







var DOMEventListener =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DOMEventListener, _React$Component);

  function DOMEventListener() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DOMEventListener);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DOMEventListener).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DOMEventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._listen(this.props);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.target === nextProps.target && this.props.eventName === nextProps.eventName && this.props.handler === nextProps.handler) {
        return;
      }

      this._stopListening(this.props);

      this._listen(nextProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._stopListening(this.props);
    }
  }, {
    key: "_listen",
    value: function _listen(_ref) {
      var target = _ref.target,
          eventName = _ref.eventName,
          handler = _ref.handler;

      if (target == null) {
        return;
      } // $FlowIgnore


      target.addEventListener(eventName, handler);
    }
  }, {
    key: "_stopListening",
    value: function _stopListening(_ref2) {
      var target = _ref2.target,
          eventName = _ref2.eventName,
          handler = _ref2.handler;

      if (target == null) {
        return;
      } // $FlowIgnore


      target.removeEventListener(eventName, handler);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return DOMEventListener;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);



/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(436);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(283);
exports.Duplex = __webpack_require__(123);
exports.Transform = __webpack_require__(439);
exports.PassThrough = __webpack_require__(1021);


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(211)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(212);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(162);
util.inherits = __webpack_require__(142);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(260)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(437);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(282).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(438);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(123);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(123);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(141), __webpack_require__(1018).setImmediate, __webpack_require__(32)))

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(1020).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bpfrpt_proptype_Props; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NoStyleButton__ = __webpack_require__(47);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var ITEM_PADDING = __WEBPACK_IMPORTED_MODULE_12__Theme__["a" /* default */].Padding.CONTENT;

var Item =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Item, _React$Component);

  function Item() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Item);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Item).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Item, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // ItemLists can become very large, so we want to control which Items actually render.
      // It is slower do a deep compare of props like "children" than to render, and shallow
      // comparison fails with most Object props. Allow consumers to define criteria on the fly
      // with an "updateKey".
      // Update if no updateKey is provided, or if it is different than the current key.
      return !(nextProps.updateKey && nextProps.updateKey === this.props.updateKey);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          id = _this$props.id,
          labelWrapperStyle = _this$props.labelWrapperStyle,
          childWrapperStyle = _this$props.childWrapperStyle,
          needsTrustedTap = _this$props.needsTrustedTap,
          onTap = _this$props.onTap,
          label = _this$props.label,
          selected = _this$props.selected,
          selectedStyle = _this$props.selectedStyle,
          activeStyle = _this$props.activeStyle,
          style = _this$props.style,
          updateKey = _this$props.updateKey,
          holdActiveUntil = _this$props.holdActiveUntil,
          colors = _this$props.colors,
          otherProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["children", "id", "labelWrapperStyle", "childWrapperStyle", "needsTrustedTap", "onTap", "label", "selected", "selectedStyle", "activeStyle", "style", "updateKey", "holdActiveUntil", "colors"]);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Tappable__["b" /* default */], {
        onTap: onTap,
        needsTrustedTap: needsTrustedTap,
        holdActiveUntil: holdActiveUntil
      }, function (_ref) {
        var active = _ref.active,
            tapTargetRefHandler = _ref.tapTargetRefHandler;
        var styles = Object(__WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["b" /* default */])({
          item: _objectSpread({
            display: "flex",
            alignItems: "center",
            whiteSpace: "normal",
            color: colors.TEXT,
            outline: "none",
            transition: "color 0.1s",
            cursor: onTap ? "pointer" : "default",
            backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_13__Tappable__["c" /* simpleActiveBackgroundColor */])(onTap != null && active)
          }, style, {}, active ? activeStyle : null, {}, selected ? _objectSpread({
            color: colors.PRIMARY
          }, selectedStyle) : null),
          label: _objectSpread({
            paddingTop: ITEM_PADDING,
            paddingRight: ITEM_PADDING,
            paddingBottom: ITEM_PADDING,
            paddingLeft: 0,
            minWidth: 0
          }, __WEBPACK_IMPORTED_MODULE_12__Theme__["a" /* default */].Styles.flexStretch, {}, labelWrapperStyle),
          child: _objectSpread({
            whiteSpace: "normal",
            height: "100%",
            flex: "0 0 auto",
            minWidth: 0
          }, childWrapperStyle)
        });
        var content = __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"], null, label ? __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
          style: styles.label,
          "data-component-section": "label"
        }, label) : null, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
          style: styles.child,
          "data-component-section": "children"
        }, children));

        var wrapperProps = _objectSpread({
          "data-component-name": "Item",
          "data-component-prop-id": id,
          "data-component-prop-selected": selected
        }, otherProps);

        if (onTap == null) {
          return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, wrapperProps, {
            style: styles.item
          }), content);
        } else {
          return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__NoStyleButton__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, wrapperProps, {
            innerRef: tapTargetRefHandler,
            style: {
              display: "block",
              width: "100%",
              textAlign: "left"
            }
          }), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
            style: styles.item
          }, content));
        }
      });
    }
  }]);

  return Item;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Item, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node,
  id: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]).isRequired,
  childWrapperStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  labelWrapperStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  needsTrustedTap: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  onTap: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  label: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node,
  selected: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  selectedStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  activeStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  updateKey: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  holdActiveUntil: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["c" /* withColorsProvider */])(Item)); // Since the exported item is wrapped, from a public perspective, the props for
// Item are the props without colors.

var bpfrpt_proptype_Props = {
  children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node,
  id: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]).isRequired,
  childWrapperStyle: function childWrapperStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  labelWrapperStyle: function labelWrapperStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  needsTrustedTap: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  onTap: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  label: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node,
  selected: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  selectedStyle: function selectedStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  activeStyle: function activeStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  updateKey: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  holdActiveUntil: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
};





/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_ItemList__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_RichLabel__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nx_components_ContextWrappers_LanguageContext__ = __webpack_require__(84);







var styles = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_utils_prefixStyles__["b" /* default */])({
  outerWrapper: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white"
  },
  innerWrapper: {
    margin: "1.5em",
    maxWidth: "25em"
  },
  richLabelWrapper: {
    margin: "1em 0"
  },
  richLabelLabelWrapper: {
    padding: "0.25em 0"
  }
});

var ErrorPage = function ErrorPage() {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6_nx_components_ContextWrappers_LanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.pages.ErrorPage;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: styles.outerWrapper
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: styles.innerWrapper
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: styles.richLabelWrapper
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nx_components_RichLabel__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_nx_components_Icons__["_29" /* IconSad */], null),
    label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      style: styles.richLabelLabelWrapper
    }, language.somethingWentWrong)
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nx_components_ItemList__["a" /* Divider */], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    style: {
      margin: "1em 0"
    }
  }, language.teamNotified), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_nx_components_Button__["a" /* default */], {
    full: true,
    onTap: function onTap() {
      return window.location.reload();
    }
  }, language.restartTheApp)));
};

/* harmony default export */ __webpack_exports__["a"] = (ErrorPage);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeviceDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_device__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_mixins_device_features__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Routing_Loading__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);












var MultiZoneThermostatDetailsPage = Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1288));
});
var GroupDetailsPage = Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1289));
});
var ThermostatDetailsPage = Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1290));
});
var DeviceDetailsPage = Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1291));
});
var PivotDeviceDetailsPage = Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1292));
});

var DeviceDetails =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DeviceDetails, _React$Component);

  function DeviceDetails() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DeviceDetails);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DeviceDetails).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DeviceDetails, [{
    key: "render",
    value: function render() {
      var _this = this;

      var model = this.props.model;
      var isCommercial = __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_environment__["a" /* default */].isCommercial();
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_BackboneListener__["a" /* default */], {
        listenTo: model,
        events: ["change"]
      }, function () {
        if (model.hasFeature(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_mixins_device_features__["Thermostat"]) && model.hasFeature(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_mixins_device_features__["Group"])) {
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](MultiZoneThermostatDetailsPage, _this.props);
        } else if (model.hasFeature(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_mixins_device_features__["Group"])) {
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](GroupDetailsPage, _this.props);
        } else if (isCommercial) {
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](PivotDeviceDetailsPage, _this.props);
        } else if (model.hasFeature(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_mixins_device_features__["Thermostat"])) {
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](ThermostatDetailsPage, _this.props);
        } else {
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](DeviceDetailsPage, _this.props);
        }
      });
    }
  }]);

  return DeviceDetails;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DeviceDetails, "propTypes", {
  appBar: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.node,
  isDashboard: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  model: function model() {
    return (typeof __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_device__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_device__["a" /* default */]).isRequired : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
});




/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = makeLoaderComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_loadable__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Pages_ErrorPage__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_SpinnerOverlay__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Page__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_TopBar_AppBarWrapper__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_TopBar_CommonAppBarContainer__ = __webpack_require__(92);















var Loading =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Loading, _React$Component);

  function Loading() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Loading);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Loading).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Loading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          error = _this$props.error,
          pastDelay = _this$props.pastDelay,
          timedOut = _this$props.timedOut;

      if (error || timedOut) {
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Pages_ErrorPage__["a" /* default */], null);
      }

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Page__["b" /* default */], {
        name: "Loading",
        fullyLoaded: false
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_TopBar_AppBarWrapper__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_TopBar_CommonAppBarContainer__["a" /* default */], {
        title: "",
        iconRight: null,
        iconLeft: null
      })), pastDelay ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_SpinnerOverlay__["a" /* default */], null) : null);
    }
  }]);

  return Loading;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Loading, "propTypes", {
  error: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(Error),
  pastDelay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  timedOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
});


function makeLoaderComponent(promiseFunc) {
  return __WEBPACK_IMPORTED_MODULE_8_react_loadable___default()({
    loader: promiseFunc,
    loading: Loading
  });
}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {
var _slice = Array.prototype.slice;
var Bacon = {
  toString: function () {
    return "Bacon";
  }
};

Bacon.version = '0.7.95';

var Exception = (typeof global !== "undefined" && global !== null ? global : this).Error;
var nop = function () {};
var latter = function (_, x) {
  return x;
};
var former = function (x, _) {
  return x;
};
var cloneArray = function (xs) {
  return xs.slice(0);
};
var assert = function (message, condition) {
  if (!condition) {
    throw new Exception(message);
  }
};
var assertObservableIsProperty = function (x) {
  if ((x != null ? x._isObservable : void 0) && !(x != null ? x._isProperty : void 0)) {
    throw new Exception("Observable is not a Property : " + x);
  }
};
var assertEventStream = function (event) {
  if (!(event != null ? event._isEventStream : void 0)) {
    throw new Exception("not an EventStream : " + event);
  }
};

var assertObservable = function (event) {
  if (!(event != null ? event._isObservable : void 0)) {
    throw new Exception("not an Observable : " + event);
  }
};
var assertFunction = function (f) {
  return assert("not a function : " + f, _.isFunction(f));
};
var isArray = Array.isArray || function (xs) {
  return xs instanceof Array;
};
var isObservable = function (x) {
  return x && x._isObservable;
};
var assertArray = function (xs) {
  if (!isArray(xs)) {
    throw new Exception("not an array : " + xs);
  }
};
var assertNoArguments = function (args) {
  return assert("no arguments supported", args.length === 0);
};
var assertString = function (x) {
  if (typeof x === "string") {
    throw new Exception("not a string : " + x);
  }
};

var extend = function (target) {
  var length = arguments.length;
  for (var i = 1; 1 < length ? i < length : i > length; 1 < length ? i++ : i--) {
    for (var prop in arguments[i]) {
      target[prop] = arguments[i][prop];
    }
  }
  return target;
};

var inherit = function (child, parent) {
  var hasProp = ({}).hasOwnProperty;
  var ctor = function () {};
  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
  for (var key in parent) {
    if (hasProp.call(parent, key)) {
      child[key] = parent[key];
    }
  }
  return child;
};

var symbol = function (key) {
  if (typeof Symbol !== "undefined" && Symbol[key]) {
    return Symbol[key];
  } else if (typeof Symbol !== "undefined" && typeof Symbol["for"] === "function") {
    return Symbol[key] = Symbol["for"](key);
  } else {
    return "@@" + key;
  }
};

var _ = {
  indexOf: (function () {
    if (Array.prototype.indexOf) {
      return function (xs, x) {
        return xs.indexOf(x);
      };
    } else {
      return function (xs, x) {
        for (var i = 0, y; i < xs.length; i++) {
          y = xs[i];
          if (x === y) {
            return i;
          }
        }
        return -1;
      };
    }
  })(),
  indexWhere: function (xs, f) {
    for (var i = 0, y; i < xs.length; i++) {
      y = xs[i];
      if (f(y)) {
        return i;
      }
    }
    return -1;
  },
  head: function (xs) {
    return xs[0];
  },
  always: function (x) {
    return function () {
      return x;
    };
  },
  negate: function (f) {
    return function (x) {
      return !f(x);
    };
  },
  empty: function (xs) {
    return xs.length === 0;
  },
  tail: function (xs) {
    return xs.slice(1, xs.length);
  },
  filter: function (f, xs) {
    var filtered = [];
    for (var i = 0, x; i < xs.length; i++) {
      x = xs[i];
      if (f(x)) {
        filtered.push(x);
      }
    }
    return filtered;
  },
  map: function (f, xs) {
    return (function () {
      var result = [];
      for (var i = 0, x; i < xs.length; i++) {
        x = xs[i];
        result.push(f(x));
      }
      return result;
    })();
  },
  each: function (xs, f) {
    for (var key in xs) {
      if (Object.prototype.hasOwnProperty.call(xs, key)) {
        var value = xs[key];
        f(key, value);
      }
    }
  },
  toArray: function (xs) {
    return isArray(xs) ? xs : [xs];
  },
  contains: function (xs, x) {
    return _.indexOf(xs, x) !== -1;
  },
  id: function (x) {
    return x;
  },
  last: function (xs) {
    return xs[xs.length - 1];
  },
  all: function (xs) {
    var f = arguments.length <= 1 || arguments[1] === undefined ? _.id : arguments[1];

    for (var i = 0, x; i < xs.length; i++) {
      x = xs[i];
      if (!f(x)) {
        return false;
      }
    }
    return true;
  },
  any: function (xs) {
    var f = arguments.length <= 1 || arguments[1] === undefined ? _.id : arguments[1];

    for (var i = 0, x; i < xs.length; i++) {
      x = xs[i];
      if (f(x)) {
        return true;
      }
    }
    return false;
  },
  without: function (x, xs) {
    return _.filter(function (y) {
      return y !== x;
    }, xs);
  },
  remove: function (x, xs) {
    var i = _.indexOf(xs, x);
    if (i >= 0) {
      return xs.splice(i, 1);
    }
  },
  fold: function (xs, seed, f) {
    for (var i = 0, x; i < xs.length; i++) {
      x = xs[i];
      seed = f(seed, x);
    }
    return seed;
  },
  flatMap: function (f, xs) {
    return _.fold(xs, [], function (ys, x) {
      return ys.concat(f(x));
    });
  },
  cached: function (f) {
    var value = None;
    return function () {
      if (typeof value !== "undefined" && value !== null ? value._isNone : undefined) {
        value = f();
        f = undefined;
      }
      return value;
    };
  },
  bind: function (fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  },
  isFunction: function (f) {
    return typeof f === "function";
  },
  toString: function (obj) {
    var internals, key, value;
    var hasProp = ({}).hasOwnProperty;
    try {
      recursionDepth++;
      if (obj == null) {
        return "undefined";
      } else if (_.isFunction(obj)) {
        return "function";
      } else if (isArray(obj)) {
        if (recursionDepth > 5) {
          return "[..]";
        }
        return "[" + _.map(_.toString, obj).toString() + "]";
      } else if ((obj != null ? obj.toString : void 0) != null && obj.toString !== Object.prototype.toString) {
        return obj.toString();
      } else if (typeof obj === "object") {
        if (recursionDepth > 5) {
          return "{..}";
        }
        internals = (function () {
          var results = [];
          for (key in obj) {
            if (!hasProp.call(obj, key)) continue;
            value = (function () {
              var error;
              try {
                return obj[key];
              } catch (error) {
                return error;
              }
            })();
            results.push(_.toString(key) + ":" + _.toString(value));
          }
          return results;
        })();
        return "{" + internals + "}";
      } else {
        return obj;
      }
    } finally {
      recursionDepth--;
    }
  }
};

var recursionDepth = 0;

Bacon._ = _;

var UpdateBarrier = Bacon.UpdateBarrier = (function () {
  var rootEvent;
  var waiterObs = [];
  var waiters = {};
  var aftersStack = [];
  var aftersStackHeight = 0;
  var flushed = {};

  function ensureStackHeight(h) {
    if (h <= aftersStackHeight) return;
    if (!aftersStack[h - 1]) {
      aftersStack[h - 1] = [[], 0];
    }
    aftersStackHeight = h;
  }

  var afterTransaction = function (obs, f) {
    if (rootEvent || aftersStack.length) {
      ensureStackHeight(1);
      var stackIndexForThisObs = 0;
      while (stackIndexForThisObs < aftersStackHeight - 1) {
        if (containsObs(obs, aftersStack[stackIndexForThisObs][0])) {
          break;
        }
        stackIndexForThisObs++;
      }
      var listFromStack = aftersStack[stackIndexForThisObs][0];
      listFromStack.push([obs, f]);
      if (!rootEvent) {
        processAfters();
      }
    } else {
        return f();
      }
  };

  function containsObs(obs, aftersList) {
    for (var i = 0; i < aftersList.length; i++) {
      if (aftersList[i][0].id == obs.id) return true;
    }
    return false;
  }

  function processAfters() {
    var stackSizeAtStart = aftersStackHeight;
    if (!stackSizeAtStart) return;
    while (aftersStackHeight >= stackSizeAtStart) {
      var topOfStack = aftersStack[aftersStackHeight - 1];
      if (!topOfStack) throw new Error("Unexpected stack top: " + topOfStack);
      var topAfters = topOfStack[0];
      var index = topOfStack[1];

      if (index < topAfters.length) {
        var _topAfters$index = topAfters[index];
        var obs = _topAfters$index[0];
        var after = _topAfters$index[1];

        topOfStack[1]++;
        ensureStackHeight(aftersStackHeight + 1);
        var callSuccess = false;
        try {
          after();
          callSuccess = true;
          while (aftersStackHeight > stackSizeAtStart && aftersStack[aftersStackHeight - 1][0].length == 0) {
            aftersStackHeight--;
          }
        } finally {
          if (!callSuccess) {
            aftersStack = [];
            aftersStackHeight = 0;
          }
        }
      } else {
          topOfStack[0] = [];
          topOfStack[1] = 0;
          break;
        }
    }
  }

  var whenDoneWith = function (obs, f) {
    if (rootEvent) {
      var obsWaiters = waiters[obs.id];
      if (!(typeof obsWaiters !== "undefined" && obsWaiters !== null)) {
        obsWaiters = waiters[obs.id] = [f];
        return waiterObs.push(obs);
      } else {
        return obsWaiters.push(f);
      }
    } else {
      return f();
    }
  };

  var flush = function () {
    while (waiterObs.length > 0) {
      flushWaiters(0, true);
    }
    flushed = {};
  };

  var flushWaiters = function (index, deps) {
    var obs = waiterObs[index];
    var obsId = obs.id;
    var obsWaiters = waiters[obsId];
    waiterObs.splice(index, 1);
    delete waiters[obsId];
    if (deps && waiterObs.length > 0) {
      flushDepsOf(obs);
    }
    for (var i = 0, f; i < obsWaiters.length; i++) {
      f = obsWaiters[i];
      f();
    }
  };

  var flushDepsOf = function (obs) {
    if (flushed[obs.id]) return;
    var deps = obs.internalDeps();
    for (var i = 0, dep; i < deps.length; i++) {
      dep = deps[i];
      flushDepsOf(dep);
      if (waiters[dep.id]) {
        var index = _.indexOf(waiterObs, dep);
        flushWaiters(index, false);
      }
    }
    flushed[obs.id] = true;
  };

  var inTransaction = function (event, context, f, args) {
    if (rootEvent) {
      return f.apply(context, args);
    } else {
      rootEvent = event;
      try {
        var result = f.apply(context, args);

        flush();
      } finally {
        rootEvent = undefined;
        processAfters();
      }
      return result;
    }
  };

  var currentEventId = function () {
    return rootEvent ? rootEvent.id : undefined;
  };

  var wrappedSubscribe = function (obs, sink) {
    var unsubd = false;
    var shouldUnsub = false;
    var doUnsub = function () {
      shouldUnsub = true;
      return shouldUnsub;
    };
    var unsub = function () {
      unsubd = true;
      return doUnsub();
    };
    doUnsub = obs.dispatcher.subscribe(function (event) {
      return afterTransaction(obs, function () {
        if (!unsubd) {
          var reply = sink(event);
          if (reply === Bacon.noMore) {
            return unsub();
          }
        }
      });
    });
    if (shouldUnsub) {
      doUnsub();
    }
    return unsub;
  };

  var hasWaiters = function () {
    return waiterObs.length > 0;
  };

  return { whenDoneWith: whenDoneWith, hasWaiters: hasWaiters, inTransaction: inTransaction, currentEventId: currentEventId, wrappedSubscribe: wrappedSubscribe, afterTransaction: afterTransaction };
})();

function Source(obs, sync) {
  var lazy = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

  this.obs = obs;
  this.sync = sync;
  this.lazy = lazy;
  this.queue = [];
}

extend(Source.prototype, {
  _isSource: true,

  subscribe: function (sink) {
    return this.obs.dispatcher.subscribe(sink);
  },
  toString: function () {
    return this.obs.toString();
  },
  markEnded: function () {
    this.ended = true;
    return true;
  },
  consume: function () {
    if (this.lazy) {
      return { value: _.always(this.queue[0]) };
    } else {
      return this.queue[0];
    }
  },
  push: function (x) {
    this.queue = [x];
    return [x];
  },
  mayHave: function () {
    return true;
  },
  hasAtLeast: function () {
    return this.queue.length;
  },
  flatten: true
});

function ConsumingSource() {
  Source.apply(this, arguments);
}

inherit(ConsumingSource, Source);
extend(ConsumingSource.prototype, {
  consume: function () {
    return this.queue.shift();
  },
  push: function (x) {
    return this.queue.push(x);
  },
  mayHave: function (c) {
    return !this.ended || this.queue.length >= c;
  },
  hasAtLeast: function (c) {
    return this.queue.length >= c;
  },
  flatten: false
});

function BufferingSource(obs) {
  Source.call(this, obs, true);
}

inherit(BufferingSource, Source);
extend(BufferingSource.prototype, {
  consume: function () {
    var values = this.queue;
    this.queue = [];
    return {
      value: function () {
        return values;
      }
    };
  },
  push: function (x) {
    return this.queue.push(x.value());
  },
  hasAtLeast: function () {
    return true;
  }
});

Source.isTrigger = function (s) {
  if (s != null ? s._isSource : void 0) {
    return s.sync;
  } else {
    return s != null ? s._isEventStream : void 0;
  }
};

Source.fromObservable = function (s) {
  if (s != null ? s._isSource : void 0) {
    return s;
  } else if (s != null ? s._isProperty : void 0) {
    return new Source(s, false);
  } else {
    return new ConsumingSource(s, true);
  }
};

function Desc(context, method, args) {
  this.context = context;
  this.method = method;
  this.args = args;
}

extend(Desc.prototype, {
  _isDesc: true,
  deps: function () {
    if (!this.cached) {
      this.cached = findDeps([this.context].concat(this.args));
    }
    return this.cached;
  },
  toString: function () {
    return _.toString(this.context) + "." + _.toString(this.method) + "(" + _.map(_.toString, this.args) + ")";
  }
});

var describe = function (context, method) {
  var ref = context || method;
  if (ref && ref._isDesc) {
    return context || method;
  } else {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    return new Desc(context, method, args);
  }
};

var withDesc = function (desc, obs) {
  obs.desc = desc;
  return obs;
};

var findDeps = function (x) {
  if (isArray(x)) {
    return _.flatMap(findDeps, x);
  } else if (isObservable(x)) {
    return [x];
  } else if (typeof x !== "undefined" && x !== null ? x._isSource : undefined) {
    return [x.obs];
  } else {
    return [];
  }
};

Bacon.Desc = Desc;
Bacon.Desc.empty = new Bacon.Desc("", "", []);

var withMethodCallSupport = function (wrapped) {
  return function (f) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    if (typeof f === "object" && args.length) {
      var context = f;
      var methodName = args[0];
      f = function () {
        return context[methodName].apply(context, arguments);
      };
      args = args.slice(1);
    }
    return wrapped.apply(undefined, [f].concat(args));
  };
};

var makeFunctionArgs = function (args) {
  args = Array.prototype.slice.call(args);
  return makeFunction_.apply(undefined, args);
};

var partiallyApplied = function (f, applied) {
  return function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return f.apply(undefined, applied.concat(args));
  };
};

var toSimpleExtractor = function (args) {
  return function (key) {
    return function (value) {
      if (!(typeof value !== "undefined" && value !== null)) {
        return;
      } else {
        var fieldValue = value[key];
        if (_.isFunction(fieldValue)) {
          return fieldValue.apply(value, args);
        } else {
          return fieldValue;
        }
      }
    };
  };
};

var toFieldExtractor = function (f, args) {
  var parts = f.slice(1).split(".");
  var partFuncs = _.map(toSimpleExtractor(args), parts);
  return function (value) {
    for (var i = 0, f; i < partFuncs.length; i++) {
      f = partFuncs[i];
      value = f(value);
    }
    return value;
  };
};

var isFieldKey = function (f) {
  return typeof f === "string" && f.length > 1 && f.charAt(0) === ".";
};

var makeFunction_ = withMethodCallSupport(function (f) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  if (_.isFunction(f)) {
    if (args.length) {
      return partiallyApplied(f, args);
    } else {
      return f;
    }
  } else if (isFieldKey(f)) {
    return toFieldExtractor(f, args);
  } else {
    return _.always(f);
  }
});

var makeFunction = function (f, args) {
  return makeFunction_.apply(undefined, [f].concat(args));
};

var convertArgsToFunction = function (obs, f, args, method) {
  if (typeof f !== "undefined" && f !== null ? f._isProperty : undefined) {
    var sampled = f.sampledBy(obs, function (p, s) {
      return [p, s];
    });
    return method.call(sampled, function (_ref) {
      var p = _ref[0];
      var s = _ref[1];
      return p;
    }).map(function (_ref2) {
      var p = _ref2[0];
      var s = _ref2[1];
      return s;
    });
  } else {
    f = makeFunction(f, args);
    return method.call(obs, f);
  }
};

var toCombinator = function (f) {
  if (_.isFunction(f)) {
    return f;
  } else if (isFieldKey(f)) {
    var key = toFieldKey(f);
    return function (left, right) {
      return left[key](right);
    };
  } else {
    throw new Exception("not a function or a field key: " + f);
  }
};

var toFieldKey = function (f) {
  return f.slice(1);
};

function Some(value) {
  this.value = value;
}

extend(Some.prototype, {
  _isSome: true,
  getOrElse: function () {
    return this.value;
  },
  get: function () {
    return this.value;
  },
  filter: function (f) {
    if (f(this.value)) {
      return new Some(this.value);
    } else {
      return None;
    }
  },
  map: function (f) {
    return new Some(f(this.value));
  },
  forEach: function (f) {
    return f(this.value);
  },
  isDefined: true,
  toArray: function () {
    return [this.value];
  },
  inspect: function () {
    return "Some(" + this.value + ")";
  },
  toString: function () {
    return this.inspect();
  }
});

var None = {
  _isNone: true,
  getOrElse: function (value) {
    return value;
  },
  filter: function () {
    return None;
  },
  map: function () {
    return None;
  },
  forEach: function () {},
  isDefined: false,
  toArray: function () {
    return [];
  },
  inspect: function () {
    return "None";
  },
  toString: function () {
    return this.inspect();
  }
};

var toOption = function (v) {
  if ((typeof v !== "undefined" && v !== null ? v._isSome : undefined) || (typeof v !== "undefined" && v !== null ? v._isNone : undefined)) {
    return v;
  } else {
    return new Some(v);
  }
};

Bacon.noMore = "<no-more>";
Bacon.more = "<more>";

var eventIdCounter = 0;

function Event() {
  this.id = ++eventIdCounter;
}

Event.prototype._isEvent = true;
Event.prototype.isEvent = function () {
  return true;
};
Event.prototype.isEnd = function () {
  return false;
};
Event.prototype.isInitial = function () {
  return false;
};
Event.prototype.isNext = function () {
  return false;
};
Event.prototype.isError = function () {
  return false;
};
Event.prototype.hasValue = function () {
  return false;
};
Event.prototype.filter = function () {
  return true;
};
Event.prototype.inspect = function () {
  return this.toString();
};
Event.prototype.log = function () {
  return this.toString();
};

function Next(valueF, eager) {
  if (!(this instanceof Next)) {
    return new Next(valueF, eager);
  }

  Event.call(this);

  if (!eager && _.isFunction(valueF) || (valueF != null ? valueF._isNext : void 0)) {
    this.valueF = valueF;
    this.valueInternal = void 0;
  } else {
    this.valueF = void 0;
    this.valueInternal = valueF;
  }
}

inherit(Next, Event);

Next.prototype.isNext = function () {
  return true;
};
Next.prototype.hasValue = function () {
  return true;
};
Next.prototype.value = function () {
  var ref;
  if ((ref = this.valueF) != null ? ref._isNext : void 0) {
    this.valueInternal = this.valueF.value();
    this.valueF = void 0;
  } else if (this.valueF) {
    this.valueInternal = this.valueF();
    this.valueF = void 0;
  }
  return this.valueInternal;
};

Next.prototype.fmap = function (f) {
  var event, value;
  if (this.valueInternal) {
    value = this.valueInternal;
    return this.apply(function () {
      return f(value);
    });
  } else {
    event = this;
    return this.apply(function () {
      return f(event.value());
    });
  }
};

Next.prototype.apply = function (value) {
  return new Next(value);
};
Next.prototype.filter = function (f) {
  return f(this.value());
};
Next.prototype.toString = function () {
  return _.toString(this.value());
};
Next.prototype.log = function () {
  return this.value();
};
Next.prototype._isNext = true;

function Initial(valueF, eager) {
  if (!(this instanceof Initial)) {
    return new Initial(valueF, eager);
  }
  Next.call(this, valueF, eager);
}

inherit(Initial, Next);
Initial.prototype._isInitial = true;
Initial.prototype.isInitial = function () {
  return true;
};
Initial.prototype.isNext = function () {
  return false;
};
Initial.prototype.apply = function (value) {
  return new Initial(value);
};
Initial.prototype.toNext = function () {
  return new Next(this);
};

function End() {
  if (!(this instanceof End)) {
    return new End();
  }
  Event.call(this);
}

inherit(End, Event);
End.prototype.isEnd = function () {
  return true;
};
End.prototype.fmap = function () {
  return this;
};
End.prototype.apply = function () {
  return this;
};
End.prototype.toString = function () {
  return "<end>";
};

function Error(error) {
  if (!(this instanceof Error)) {
    return new Error(error);
  }
  this.error = error;
  Event.call(this);
}

inherit(Error, Event);
Error.prototype.isError = function () {
  return true;
};
Error.prototype.fmap = function () {
  return this;
};
Error.prototype.apply = function () {
  return this;
};
Error.prototype.toString = function () {
  return "<error> " + _.toString(this.error);
};

Bacon.Event = Event;
Bacon.Initial = Initial;
Bacon.Next = Next;
Bacon.End = End;
Bacon.Error = Error;

var initialEvent = function (value) {
  return new Initial(value, true);
};
var nextEvent = function (value) {
  return new Next(value, true);
};
var endEvent = function () {
  return new End();
};
var toEvent = function (x) {
  if (x && x._isEvent) {
    return x;
  } else {
    return nextEvent(x);
  }
};

var idCounter = 0;
var registerObs = function () {};

function Observable(desc) {
  this.desc = desc;
  this.id = ++idCounter;
  this.initialDesc = this.desc;
}

extend(Observable.prototype, {
  _isObservable: true,

  subscribe: function (sink) {
    return UpdateBarrier.wrappedSubscribe(this, sink);
  },

  subscribeInternal: function (sink) {
    return this.dispatcher.subscribe(sink);
  },

  onValue: function () {
    var f = makeFunctionArgs(arguments);
    return this.subscribe(function (event) {
      if (event.hasValue()) {
        return f(event.value());
      }
    });
  },

  onValues: function (f) {
    return this.onValue(function (args) {
      return f.apply(undefined, args);
    });
  },

  onError: function () {
    var f = makeFunctionArgs(arguments);
    return this.subscribe(function (event) {
      if (event.isError()) {
        return f(event.error);
      }
    });
  },

  onEnd: function () {
    var f = makeFunctionArgs(arguments);
    return this.subscribe(function (event) {
      if (event.isEnd()) {
        return f();
      }
    });
  },

  name: function (name) {
    this._name = name;
    return this;
  },

  withDescription: function () {
    this.desc = describe.apply(undefined, arguments);
    return this;
  },

  toString: function () {
    if (this._name) {
      return this._name;
    } else {
      return this.desc.toString();
    }
  },

  deps: function () {
    return this.desc.deps();
  },

  internalDeps: function () {
    return this.initialDesc.deps();
  }
});

Observable.prototype.assign = Observable.prototype.onValue;
Observable.prototype.forEach = Observable.prototype.onValue;
Observable.prototype.inspect = Observable.prototype.toString;

Bacon.Observable = Observable;

function CompositeUnsubscribe() {
  var ss = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

  this.unsubscribe = _.bind(this.unsubscribe, this);
  this.unsubscribed = false;
  this.subscriptions = [];
  this.starting = [];
  for (var i = 0, s; i < ss.length; i++) {
    s = ss[i];
    this.add(s);
  }
}

extend(CompositeUnsubscribe.prototype, {
  add: function (subscription) {
    var _this2 = this;

    if (this.unsubscribed) {
      return;
    }
    var ended = false;
    var unsub = nop;
    this.starting.push(subscription);
    var unsubMe = function () {
      if (_this2.unsubscribed) {
        return;
      }
      ended = true;
      _this2.remove(unsub);
      return _.remove(subscription, _this2.starting);
    };
    unsub = subscription(this.unsubscribe, unsubMe);
    if (!(this.unsubscribed || ended)) {
      this.subscriptions.push(unsub);
    } else {
      unsub();
    }
    _.remove(subscription, this.starting);
    return unsub;
  },

  remove: function (unsub) {
    if (this.unsubscribed) {
      return;
    }
    if (_.remove(unsub, this.subscriptions) !== undefined) {
      return unsub();
    }
  },

  unsubscribe: function () {
    if (this.unsubscribed) {
      return;
    }
    this.unsubscribed = true;
    var iterable = this.subscriptions;
    for (var i = 0; i < iterable.length; i++) {
      iterable[i]();
    }
    this.subscriptions = [];
    this.starting = [];
    return [];
  },

  count: function () {
    if (this.unsubscribed) {
      return 0;
    }
    return this.subscriptions.length + this.starting.length;
  },

  empty: function () {
    return this.count() === 0;
  }
});

Bacon.CompositeUnsubscribe = CompositeUnsubscribe;

function Dispatcher(_subscribe, _handleEvent) {
  this._subscribe = _subscribe;
  this._handleEvent = _handleEvent;
  this.subscribe = _.bind(this.subscribe, this);
  this.handleEvent = _.bind(this.handleEvent, this);
  this.pushing = false;
  this.ended = false;
  this.prevError = undefined;
  this.unsubSrc = undefined;
  this.subscriptions = [];
  this.queue = [];
}

Dispatcher.prototype.hasSubscribers = function () {
  return this.subscriptions.length > 0;
};

Dispatcher.prototype.removeSub = function (subscription) {
  this.subscriptions = _.without(subscription, this.subscriptions);
  return this.subscriptions;
};

Dispatcher.prototype.push = function (event) {
  if (event.isEnd()) {
    this.ended = true;
  }
  return UpdateBarrier.inTransaction(event, this, this.pushIt, [event]);
};

Dispatcher.prototype.pushToSubscriptions = function (event) {
  try {
    var tmp = this.subscriptions;
    var len = tmp.length;
    for (var i = 0; i < len; i++) {
      var sub = tmp[i];
      var reply = sub.sink(event);
      if (reply === Bacon.noMore || event.isEnd()) {
        this.removeSub(sub);
      }
    }
    return true;
  } catch (error) {
    this.pushing = false;
    this.queue = [];
    throw error;
  }
};

Dispatcher.prototype.pushIt = function (event) {
  if (!this.pushing) {
    if (event === this.prevError) {
      return;
    }
    if (event.isError()) {
      this.prevError = event;
    }
    this.pushing = true;
    this.pushToSubscriptions(event);
    this.pushing = false;
    while (this.queue.length) {
      event = this.queue.shift();
      this.push(event);
    }
    if (this.hasSubscribers()) {
      return Bacon.more;
    } else {
      this.unsubscribeFromSource();
      return Bacon.noMore;
    }
  } else {
    this.queue.push(event);
    return Bacon.more;
  }
};

Dispatcher.prototype.handleEvent = function (event) {
  if (this._handleEvent) {
    return this._handleEvent(event);
  } else {
    return this.push(event);
  }
};

Dispatcher.prototype.unsubscribeFromSource = function () {
  if (this.unsubSrc) {
    this.unsubSrc();
  }
  this.unsubSrc = undefined;
};

Dispatcher.prototype.subscribe = function (sink) {
  var subscription;
  if (this.ended) {
    sink(endEvent());
    return nop;
  } else {
    assertFunction(sink);
    subscription = {
      sink: sink
    };
    this.subscriptions.push(subscription);
    if (this.subscriptions.length === 1) {
      this.unsubSrc = this._subscribe(this.handleEvent);
      assertFunction(this.unsubSrc);
    }
    return (function (_this) {
      return function () {
        _this.removeSub(subscription);
        if (!_this.hasSubscribers()) {
          return _this.unsubscribeFromSource();
        }
      };
    })(this);
  }
};

Bacon.Dispatcher = Dispatcher;

function EventStream(desc, subscribe, handler) {
  if (!(this instanceof EventStream)) {
    return new EventStream(desc, subscribe, handler);
  }
  if (_.isFunction(desc)) {
    handler = subscribe;
    subscribe = desc;
    desc = Desc.empty;
  }
  Observable.call(this, desc);
  assertFunction(subscribe);
  this.dispatcher = new Dispatcher(subscribe, handler);
  registerObs(this);
}

inherit(EventStream, Observable);
extend(EventStream.prototype, {
  _isEventStream: true,

  toProperty: function (initValue_) {
    var initValue = arguments.length === 0 ? None : toOption(function () {
      return initValue_;
    });
    var disp = this.dispatcher;
    var desc = new Bacon.Desc(this, "toProperty", [initValue_]);
    return new Property(desc, function (sink) {
      var initSent = false;
      var subbed = false;
      var unsub = nop;
      var reply = Bacon.more;
      var sendInit = function () {
        if (!initSent) {
          return initValue.forEach(function (value) {
            initSent = true;
            reply = sink(new Initial(value));
            if (reply === Bacon.noMore) {
              unsub();
              unsub = nop;
              return nop;
            }
          });
        }
      };

      unsub = disp.subscribe(function (event) {
        if (event.hasValue()) {
          if (event.isInitial() && !subbed) {
            initValue = new Some(function () {
              return event.value();
            });
            return Bacon.more;
          } else {
            if (!event.isInitial()) {
              sendInit();
            }
            initSent = true;
            initValue = new Some(event);
            return sink(event);
          }
        } else {
          if (event.isEnd()) {
            reply = sendInit();
          }
          if (reply !== Bacon.noMore) {
            return sink(event);
          }
        }
      });
      subbed = true;
      sendInit();
      return unsub;
    });
  },

  toEventStream: function () {
    return this;
  },

  withHandler: function (handler) {
    return new EventStream(new Bacon.Desc(this, "withHandler", [handler]), this.dispatcher.subscribe, handler);
  }
});

Bacon.EventStream = EventStream;

Bacon.never = function () {
  return new EventStream(describe(Bacon, "never"), function (sink) {
    sink(endEvent());
    return nop;
  });
};

Bacon.when = function () {
  if (arguments.length === 0) {
    return Bacon.never();
  }
  var len = arguments.length;
  var usage = "when: expecting arguments in the form (Observable+,function)+";

  assert(usage, len % 2 === 0);
  var sources = [];
  var pats = [];
  var i = 0;
  var patterns = [];
  while (i < len) {
    patterns[i] = arguments[i];
    patterns[i + 1] = arguments[i + 1];
    var patSources = _.toArray(arguments[i]);
    var f = constantToFunction(arguments[i + 1]);
    var pat = { f: f, ixs: [] };
    var triggerFound = false;
    for (var j = 0, s; j < patSources.length; j++) {
      s = patSources[j];
      var index = _.indexOf(sources, s);
      if (!triggerFound) {
        triggerFound = Source.isTrigger(s);
      }
      if (index < 0) {
        sources.push(s);
        index = sources.length - 1;
      }
      for (var k = 0, ix; k < pat.ixs.length; k++) {
        ix = pat.ixs[k];
        if (ix.index === index) {
          ix.count++;
        }
      }
      pat.ixs.push({ index: index, count: 1 });
    }

    assert("At least one EventStream required", triggerFound || !patSources.length);

    if (patSources.length > 0) {
      pats.push(pat);
    }
    i = i + 2;
  }

  if (!sources.length) {
    return Bacon.never();
  }

  sources = _.map(Source.fromObservable, sources);
  var needsBarrier = _.any(sources, function (s) {
    return s.flatten;
  }) && containsDuplicateDeps(_.map(function (s) {
    return s.obs;
  }, sources));

  var desc = new Bacon.Desc(Bacon, "when", patterns);
  var resultStream = new EventStream(desc, function (sink) {
    var triggers = [];
    var ends = false;
    var match = function (p) {
      for (var i1 = 0, i; i1 < p.ixs.length; i1++) {
        i = p.ixs[i1];
        if (!sources[i.index].hasAtLeast(i.count)) {
          return false;
        }
      }
      return true;
    };
    var cannotSync = function (source) {
      return !source.sync || source.ended;
    };
    var cannotMatch = function (p) {
      for (var i1 = 0, i; i1 < p.ixs.length; i1++) {
        i = p.ixs[i1];
        if (!sources[i.index].mayHave(i.count)) {
          return true;
        }
      }
    };
    var nonFlattened = function (trigger) {
      return !trigger.source.flatten;
    };
    var part = function (source) {
      return function (unsubAll) {
        var flushLater = function () {
          return UpdateBarrier.whenDoneWith(resultStream, flush);
        };
        var flushWhileTriggers = function () {
          if (triggers.length > 0) {
            var reply = Bacon.more;
            var trigger = triggers.pop();
            for (var i1 = 0, p; i1 < pats.length; i1++) {
              p = pats[i1];
              if (match(p)) {
                var events = (function () {
                  var result = [];
                  for (var i2 = 0, i; i2 < p.ixs.length; i2++) {
                    i = p.ixs[i2];
                    result.push(sources[i.index].consume());
                  }
                  return result;
                })();
                reply = sink(trigger.e.apply(function () {
                  var _p;

                  var values = (function () {
                    var result = [];
                    for (var i2 = 0, event; i2 < events.length; i2++) {
                      event = events[i2];
                      result.push(event.value());
                    }
                    return result;
                  })();

                  return (_p = p).f.apply(_p, values);
                }));
                if (triggers.length) {
                  triggers = _.filter(nonFlattened, triggers);
                }
                if (reply === Bacon.noMore) {
                  return reply;
                } else {
                  return flushWhileTriggers();
                }
              }
            }
          } else {
            return Bacon.more;
          }
        };
        var flush = function () {
          var reply = flushWhileTriggers();
          if (ends) {
            if (_.all(sources, cannotSync) || _.all(pats, cannotMatch)) {
              reply = Bacon.noMore;
              sink(endEvent());
            }
          }
          if (reply === Bacon.noMore) {
            unsubAll();
          }

          return reply;
        };
        return source.subscribe(function (e) {
          if (e.isEnd()) {
            ends = true;
            source.markEnded();
            flushLater();
          } else if (e.isError()) {
            var reply = sink(e);
          } else {
            source.push(e);
            if (source.sync) {
              triggers.push({ source: source, e: e });
              if (needsBarrier || UpdateBarrier.hasWaiters()) {
                flushLater();
              } else {
                flush();
              }
            }
          }
          if (reply === Bacon.noMore) {
            unsubAll();
          }
          return reply || Bacon.more;
        });
      };
    };

    return new Bacon.CompositeUnsubscribe((function () {
      var result = [];
      for (var i1 = 0, s; i1 < sources.length; i1++) {
        s = sources[i1];
        result.push(part(s));
      }
      return result;
    })()).unsubscribe;
  });
  return resultStream;
};

var containsDuplicateDeps = function (observables) {
  var state = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

  var checkObservable = function (obs) {
    if (_.contains(state, obs)) {
      return true;
    } else {
      var deps = obs.internalDeps();
      if (deps.length) {
        state.push(obs);
        return _.any(deps, checkObservable);
      } else {
        state.push(obs);
        return false;
      }
    }
  };

  return _.any(observables, checkObservable);
};

var constantToFunction = function (f) {
  if (_.isFunction(f)) {
    return f;
  } else {
    return _.always(f);
  }
};

Bacon.groupSimultaneous = function () {
  for (var _len5 = arguments.length, streams = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    streams[_key5] = arguments[_key5];
  }

  if (streams.length === 1 && isArray(streams[0])) {
    streams = streams[0];
  }
  var sources = (function () {
    var result = [];
    for (var i = 0, s; i < streams.length; i++) {
      s = streams[i];
      result.push(new BufferingSource(s));
    }
    return result;
  })();
  return withDesc(new Bacon.Desc(Bacon, "groupSimultaneous", streams), Bacon.when(sources, function () {
    for (var _len6 = arguments.length, xs = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      xs[_key6] = arguments[_key6];
    }

    return xs;
  }));
};

function PropertyDispatcher(property, subscribe, handleEvent) {
  Dispatcher.call(this, subscribe, handleEvent);
  this.property = property;
  this.subscribe = _.bind(this.subscribe, this);
  this.current = None;
  this.currentValueRootId = undefined;
  this.propertyEnded = false;
}

inherit(PropertyDispatcher, Dispatcher);
extend(PropertyDispatcher.prototype, {
  push: function (event) {
    if (event.isEnd()) {
      this.propertyEnded = true;
    }
    if (event.hasValue()) {
      this.current = new Some(event);
      this.currentValueRootId = UpdateBarrier.currentEventId();
    }
    return Dispatcher.prototype.push.call(this, event);
  },

  maybeSubSource: function (sink, reply) {
    if (reply === Bacon.noMore) {
      return nop;
    } else if (this.propertyEnded) {
      sink(endEvent());
      return nop;
    } else {
      return Dispatcher.prototype.subscribe.call(this, sink);
    }
  },

  subscribe: function (sink) {
    var _this3 = this;

    var initSent = false;

    var reply = Bacon.more;

    if (this.current.isDefined && (this.hasSubscribers() || this.propertyEnded)) {
      var dispatchingId = UpdateBarrier.currentEventId();
      var valId = this.currentValueRootId;
      if (!this.propertyEnded && valId && dispatchingId && dispatchingId !== valId) {
        UpdateBarrier.whenDoneWith(this.property, function () {
          if (_this3.currentValueRootId === valId) {
            return sink(initialEvent(_this3.current.get().value()));
          }
        });

        return this.maybeSubSource(sink, reply);
      } else {
        UpdateBarrier.inTransaction(undefined, this, function () {
          reply = sink(initialEvent(this.current.get().value()));
          return reply;
        }, []);
        return this.maybeSubSource(sink, reply);
      }
    } else {
      return this.maybeSubSource(sink, reply);
    }
  }
});

function Property(desc, subscribe, handler) {
  Observable.call(this, desc);
  assertFunction(subscribe);
  this.dispatcher = new PropertyDispatcher(this, subscribe, handler);
  registerObs(this);
}

inherit(Property, Observable);
extend(Property.prototype, {
  _isProperty: true,

  changes: function () {
    var _this4 = this;

    return new EventStream(new Bacon.Desc(this, "changes", []), function (sink) {
      return _this4.dispatcher.subscribe(function (event) {
        if (!event.isInitial()) {
          return sink(event);
        }
      });
    });
  },

  withHandler: function (handler) {
    return new Property(new Bacon.Desc(this, "withHandler", [handler]), this.dispatcher.subscribe, handler);
  },

  toProperty: function () {
    assertNoArguments(arguments);
    return this;
  },

  toEventStream: function () {
    var _this5 = this;

    return new EventStream(new Bacon.Desc(this, "toEventStream", []), function (sink) {
      return _this5.dispatcher.subscribe(function (event) {
        if (event.isInitial()) {
          event = event.toNext();
        }
        return sink(event);
      });
    });
  }
});

Bacon.Property = Property;

Bacon.constant = function (value) {
  return new Property(new Bacon.Desc(Bacon, "constant", [value]), function (sink) {
    sink(initialEvent(value));
    sink(endEvent());
    return nop;
  });
};

Bacon.fromBinder = function (binder) {
  var eventTransformer = arguments.length <= 1 || arguments[1] === undefined ? _.id : arguments[1];

  var desc = new Bacon.Desc(Bacon, "fromBinder", [binder, eventTransformer]);
  return new EventStream(desc, function (sink) {
    var unbound = false;
    var shouldUnbind = false;
    var unbind = function () {
      if (!unbound) {
        if (typeof unbinder !== "undefined" && unbinder !== null) {
          unbinder();
          return unbound = true;
        } else {
          return shouldUnbind = true;
        }
      }
    };
    var unbinder = binder(function () {
      var ref;

      for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      var value = eventTransformer.apply(this, args);
      if (!(isArray(value) && ((ref = _.last(value)) != null ? ref._isEvent : undefined))) {
        value = [value];
      }
      var reply = Bacon.more;
      for (var i = 0, event; i < value.length; i++) {
        event = value[i];
        reply = sink(event = toEvent(event));
        if (reply === Bacon.noMore || event.isEnd()) {
          unbind();
          return reply;
        }
      }
      return reply;
    });
    if (shouldUnbind) {
      unbind();
    }
    return unbind;
  });
};

Bacon.Observable.prototype.map = function (p) {
  for (var _len8 = arguments.length, args = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
    args[_key8 - 1] = arguments[_key8];
  }

  return convertArgsToFunction(this, p, args, function (f) {
    return withDesc(new Bacon.Desc(this, "map", [f]), this.withHandler(function (event) {
      return this.push(event.fmap(f));
    }));
  });
};

var argumentsToObservables = function (args) {
  if (isArray(args[0])) {
    return args[0];
  } else {
    return Array.prototype.slice.call(args);
  }
};

var argumentsToObservablesAndFunction = function (args) {
  if (_.isFunction(args[0])) {
    return [argumentsToObservables(Array.prototype.slice.call(args, 1)), args[0]];
  } else {
    return [argumentsToObservables(Array.prototype.slice.call(args, 0, args.length - 1)), _.last(args)];
  }
};

Bacon.combineAsArray = function () {
  var streams = argumentsToObservables(arguments);
  if (streams.length) {
    var sources = [];
    for (var i = 0; i < streams.length; i++) {
      var stream = isObservable(streams[i]) ? streams[i] : Bacon.constant(streams[i]);
      sources.push(new Source(stream, true));
    }
    return withDesc(new Bacon.Desc(Bacon, "combineAsArray", streams), Bacon.when(sources, function () {
      for (var _len9 = arguments.length, xs = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        xs[_key9] = arguments[_key9];
      }

      return xs;
    }).toProperty());
  } else {
    return Bacon.constant([]);
  }
};

Bacon.onValues = function () {
  return Bacon.combineAsArray(Array.prototype.slice.call(arguments, 0, arguments.length - 1)).onValues(arguments[arguments.length - 1]);
};

Bacon.combineWith = function () {
  var _argumentsToObservablesAndFunction = argumentsToObservablesAndFunction(arguments);

  var streams = _argumentsToObservablesAndFunction[0];
  var f = _argumentsToObservablesAndFunction[1];

  var desc = new Bacon.Desc(Bacon, "combineWith", [f].concat(streams));
  return withDesc(desc, Bacon.combineAsArray(streams).map(function (values) {
    return f.apply(undefined, values);
  }));
};

Bacon.Observable.prototype.combine = function (other, f) {
  var combinator = toCombinator(f);
  var desc = new Bacon.Desc(this, "combine", [other, f]);
  return withDesc(desc, Bacon.combineAsArray(this, other).map(function (values) {
    return combinator(values[0], values[1]);
  }));
};

Bacon.Observable.prototype.withStateMachine = function (initState, f) {
  var state = initState;
  var desc = new Bacon.Desc(this, "withStateMachine", [initState, f]);
  return withDesc(desc, this.withHandler(function (event) {
    var fromF = f(state, event);
    var newState = fromF[0];
    var outputs = fromF[1];

    state = newState;
    var reply = Bacon.more;
    for (var i = 0, output; i < outputs.length; i++) {
      output = outputs[i];
      reply = this.push(output);
      if (reply === Bacon.noMore) {
        return reply;
      }
    }
    return reply;
  }));
};

var equals = function (a, b) {
  return a === b;
};

var isNone = function (object) {
  return typeof object !== "undefined" && object !== null ? object._isNone : false;
};

Bacon.Observable.prototype.skipDuplicates = function () {
  var isEqual = arguments.length <= 0 || arguments[0] === undefined ? equals : arguments[0];

  var desc = new Bacon.Desc(this, "skipDuplicates", []);
  return withDesc(desc, this.withStateMachine(None, function (prev, event) {
    if (!event.hasValue()) {
      return [prev, [event]];
    } else if (event.isInitial() || isNone(prev) || !isEqual(prev.get(), event.value())) {
      return [new Some(event.value()), [event]];
    } else {
      return [prev, []];
    }
  }));
};

Bacon.Observable.prototype.awaiting = function (other) {
  var desc = new Bacon.Desc(this, "awaiting", [other]);
  return withDesc(desc, Bacon.groupSimultaneous(this, other).map(function (values) {
    return values[1].length === 0;
  }).toProperty(false).skipDuplicates());
};

Bacon.Observable.prototype.not = function () {
  return withDesc(new Bacon.Desc(this, "not", []), this.map(function (x) {
    return !x;
  }));
};

Bacon.Property.prototype.and = function (other) {
  return withDesc(new Bacon.Desc(this, "and", [other]), this.combine(other, function (x, y) {
    return x && y;
  }));
};

Bacon.Property.prototype.or = function (other) {
  return withDesc(new Bacon.Desc(this, "or", [other]), this.combine(other, function (x, y) {
    return x || y;
  }));
};

Bacon.scheduler = {
  setTimeout: function (f, d) {
    return setTimeout(f, d);
  },
  setInterval: function (f, i) {
    return setInterval(f, i);
  },
  clearInterval: function (id) {
    return clearInterval(id);
  },
  clearTimeout: function (id) {
    return clearTimeout(id);
  },
  now: function () {
    return new Date().getTime();
  }
};

Bacon.EventStream.prototype.bufferWithTime = function (delay) {
  return withDesc(new Bacon.Desc(this, "bufferWithTime", [delay]), this.bufferWithTimeOrCount(delay, Number.MAX_VALUE));
};

Bacon.EventStream.prototype.bufferWithCount = function (count) {
  return withDesc(new Bacon.Desc(this, "bufferWithCount", [count]), this.bufferWithTimeOrCount(undefined, count));
};

Bacon.EventStream.prototype.bufferWithTimeOrCount = function (delay, count) {
  var flushOrSchedule = function (buffer) {
    if (buffer.values.length === count) {
      return buffer.flush();
    } else if (delay !== undefined) {
      return buffer.schedule();
    }
  };
  var desc = new Bacon.Desc(this, "bufferWithTimeOrCount", [delay, count]);
  return withDesc(desc, this.buffer(delay, flushOrSchedule, flushOrSchedule));
};

Bacon.EventStream.prototype.buffer = function (delay) {
  var onInput = arguments.length <= 1 || arguments[1] === undefined ? nop : arguments[1];
  var onFlush = arguments.length <= 2 || arguments[2] === undefined ? nop : arguments[2];

  var buffer = {
    scheduled: null,
    end: undefined,
    values: [],
    flush: function () {
      if (this.scheduled) {
        Bacon.scheduler.clearTimeout(this.scheduled);
        this.scheduled = null;
      }
      if (this.values.length > 0) {
        var valuesToPush = this.values;
        this.values = [];
        var reply = this.push(nextEvent(valuesToPush));
        if (this.end != null) {
          return this.push(this.end);
        } else if (reply !== Bacon.noMore) {
          return onFlush(this);
        }
      } else {
        if (this.end != null) {
          return this.push(this.end);
        }
      }
    },
    schedule: function () {
      var _this6 = this;

      if (!this.scheduled) {
        return this.scheduled = delay(function () {
          return _this6.flush();
        });
      }
    }
  };
  var reply = Bacon.more;
  if (!_.isFunction(delay)) {
    var delayMs = delay;
    delay = function (f) {
      return Bacon.scheduler.setTimeout(f, delayMs);
    };
  }
  return withDesc(new Bacon.Desc(this, "buffer", []), this.withHandler(function (event) {
    var _this7 = this;

    buffer.push = function (event) {
      return _this7.push(event);
    };
    if (event.isError()) {
      reply = this.push(event);
    } else if (event.isEnd()) {
      buffer.end = event;
      if (!buffer.scheduled) {
        buffer.flush();
      }
    } else {
      buffer.values.push(event.value());

      onInput(buffer);
    }
    return reply;
  }));
};

Bacon.Observable.prototype.filter = function (f) {
  assertObservableIsProperty(f);

  for (var _len10 = arguments.length, args = Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
    args[_key10 - 1] = arguments[_key10];
  }

  return convertArgsToFunction(this, f, args, function (f) {
    return withDesc(new Bacon.Desc(this, "filter", [f]), this.withHandler(function (event) {
      if (event.filter(f)) {
        return this.push(event);
      } else {
        return Bacon.more;
      }
    }));
  });
};

Bacon.once = function (value) {
  return new EventStream(new Desc(Bacon, "once", [value]), function (sink) {
    sink(toEvent(value));
    sink(endEvent());
    return nop;
  });
};

Bacon.EventStream.prototype.concat = function (right) {
  var left = this;
  return new EventStream(new Bacon.Desc(left, "concat", [right]), function (sink) {
    var unsubRight = nop;
    var unsubLeft = left.dispatcher.subscribe(function (e) {
      if (e.isEnd()) {
        unsubRight = right.toEventStream().dispatcher.subscribe(sink);
        return unsubRight;
      } else {
        return sink(e);
      }
    });
    return function () {
      return unsubLeft(), unsubRight();
    };
  });
};

Bacon.Property.prototype.concat = function (right) {
  return addPropertyInitValueToStream(this, this.changes().concat(right));
};

Bacon.concatAll = function () {
  var streams = argumentsToObservables(arguments);
  if (streams.length) {
    return withDesc(new Bacon.Desc(Bacon, "concatAll", streams), _.fold(_.tail(streams), _.head(streams).toEventStream(), function (a, b) {
      return a.concat(b);
    }));
  } else {
    return Bacon.never();
  }
};

var addPropertyInitValueToStream = function (property, stream) {
  var justInitValue = new EventStream(describe(property, "justInitValue"), function (sink) {
    var value = undefined;
    var unsub = property.dispatcher.subscribe(function (event) {
      if (!event.isEnd()) {
        value = event;
      }
      return Bacon.noMore;
    });
    UpdateBarrier.whenDoneWith(justInitValue, function () {
      if (typeof value !== "undefined" && value !== null) {
        sink(value);
      }
      return sink(endEvent());
    });
    return unsub;
  });
  return justInitValue.concat(stream).toProperty();
};

Bacon.Observable.prototype.flatMap = function () {
  return flatMap_(this, makeSpawner(arguments));
};

Bacon.Observable.prototype.flatMapFirst = function () {
  return flatMap_(this, makeSpawner(arguments), true);
};

var makeSpawner = function (args) {
  if (args.length === 1 && isObservable(args[0])) {
    return _.always(args[0]);
  } else {
    return makeFunctionArgs(args);
  }
};

var makeObservable = function (x) {
  if (isObservable(x)) {
    return x;
  } else {
    return Bacon.once(x);
  }
};

var flatMap_ = function (root, f, firstOnly, limit) {
  var rootDep = [root];
  var childDeps = [];
  var desc = new Bacon.Desc(root, "flatMap" + (firstOnly ? "First" : ""), [f]);
  var result = new EventStream(desc, function (sink) {
    var composite = new CompositeUnsubscribe();
    var queue = [];
    var spawn = function (event) {
      var child = makeObservable(f(event.value()));
      childDeps.push(child);
      return composite.add(function (unsubAll, unsubMe) {
        return child.dispatcher.subscribe(function (event) {
          if (event.isEnd()) {
            _.remove(child, childDeps);
            checkQueue();
            checkEnd(unsubMe);
            return Bacon.noMore;
          } else {
            if (typeof event !== "undefined" && event !== null ? event._isInitial : undefined) {
              event = event.toNext();
            }
            var reply = sink(event);
            if (reply === Bacon.noMore) {
              unsubAll();
            }
            return reply;
          }
        });
      });
    };
    var checkQueue = function () {
      var event = queue.shift();
      if (event) {
        return spawn(event);
      }
    };
    var checkEnd = function (unsub) {
      unsub();
      if (composite.empty()) {
        return sink(endEvent());
      }
    };
    composite.add(function (__, unsubRoot) {
      return root.dispatcher.subscribe(function (event) {
        if (event.isEnd()) {
          return checkEnd(unsubRoot);
        } else if (event.isError()) {
          return sink(event);
        } else if (firstOnly && composite.count() > 1) {
          return Bacon.more;
        } else {
          if (composite.unsubscribed) {
            return Bacon.noMore;
          }
          if (limit && composite.count() > limit) {
            return queue.push(event);
          } else {
            return spawn(event);
          }
        }
      });
    });
    return composite.unsubscribe;
  });
  result.internalDeps = function () {
    if (childDeps.length) {
      return rootDep.concat(childDeps);
    } else {
      return rootDep;
    }
  };
  return result;
};

Bacon.Observable.prototype.flatMapWithConcurrencyLimit = function (limit) {
  for (var _len11 = arguments.length, args = Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
    args[_key11 - 1] = arguments[_key11];
  }

  var desc = new Bacon.Desc(this, "flatMapWithConcurrencyLimit", [limit].concat(args));
  return withDesc(desc, flatMap_(this, makeSpawner(args), false, limit));
};

Bacon.Observable.prototype.flatMapConcat = function () {
  var desc = new Bacon.Desc(this, "flatMapConcat", Array.prototype.slice.call(arguments, 0));
  return withDesc(desc, this.flatMapWithConcurrencyLimit.apply(this, [1].concat(_slice.call(arguments))));
};

Bacon.later = function (delay, value) {
  return withDesc(new Bacon.Desc(Bacon, "later", [delay, value]), Bacon.fromBinder(function (sink) {
    var sender = function () {
      return sink([value, endEvent()]);
    };
    var id = Bacon.scheduler.setTimeout(sender, delay);
    return function () {
      return Bacon.scheduler.clearTimeout(id);
    };
  }));
};

Bacon.Observable.prototype.bufferingThrottle = function (minimumInterval) {
  var desc = new Bacon.Desc(this, "bufferingThrottle", [minimumInterval]);
  return withDesc(desc, this.flatMapConcat(function (x) {
    return Bacon.once(x).concat(Bacon.later(minimumInterval).filter(false));
  }));
};

Bacon.Property.prototype.bufferingThrottle = function () {
  return Bacon.Observable.prototype.bufferingThrottle.apply(this, arguments).toProperty();
};

function Bus() {
  if (!(this instanceof Bus)) {
    return new Bus();
  }

  this.unsubAll = _.bind(this.unsubAll, this);
  this.subscribeAll = _.bind(this.subscribeAll, this);
  this.guardedSink = _.bind(this.guardedSink, this);

  this.sink = undefined;
  this.subscriptions = [];
  this.ended = false;
  EventStream.call(this, new Bacon.Desc(Bacon, "Bus", []), this.subscribeAll);
}

inherit(Bus, EventStream);
extend(Bus.prototype, {
  unsubAll: function () {
    var iterable = this.subscriptions;
    for (var i = 0, sub; i < iterable.length; i++) {
      sub = iterable[i];
      if (typeof sub.unsub === "function") {
        sub.unsub();
      }
    }
  },

  subscribeAll: function (newSink) {
    if (this.ended) {
      newSink(endEvent());
    } else {
      this.sink = newSink;
      var iterable = cloneArray(this.subscriptions);
      for (var i = 0, subscription; i < iterable.length; i++) {
        subscription = iterable[i];
        this.subscribeInput(subscription);
      }
    }
    return this.unsubAll;
  },

  guardedSink: function (input) {
    var _this8 = this;

    return function (event) {
      if (event.isEnd()) {
        _this8.unsubscribeInput(input);
        return Bacon.noMore;
      } else {
        return _this8.sink(event);
      }
    };
  },

  subscribeInput: function (subscription) {
    subscription.unsub = subscription.input.dispatcher.subscribe(this.guardedSink(subscription.input));
    return subscription.unsub;
  },

  unsubscribeInput: function (input) {
    var iterable = this.subscriptions;
    for (var i = 0, sub; i < iterable.length; i++) {
      sub = iterable[i];
      if (sub.input === input) {
        if (typeof sub.unsub === "function") {
          sub.unsub();
        }
        this.subscriptions.splice(i, 1);
        return;
      }
    }
  },

  plug: function (input) {
    var _this9 = this;

    assertObservable(input);
    if (this.ended) {
      return;
    }
    var sub = { input: input };
    this.subscriptions.push(sub);
    if (typeof this.sink !== "undefined") {
      this.subscribeInput(sub);
    }
    return function () {
      return _this9.unsubscribeInput(input);
    };
  },

  end: function () {
    this.ended = true;
    this.unsubAll();
    if (typeof this.sink === "function") {
      return this.sink(endEvent());
    }
  },

  push: function (value) {
    if (!this.ended && typeof this.sink === "function") {
      var rootPush = !this.pushing;
      if (!rootPush) {
        if (!this.pushQueue) this.pushQueue = [];
        this.pushQueue.push(value);

        return;
      }
      this.pushing = true;
      try {
        return this.sink(nextEvent(value));
      } finally {
        if (rootPush && this.pushQueue) {
          var i = 0;
          while (i < this.pushQueue.length) {
            var value = this.pushQueue[i];
            this.sink(nextEvent(value));
            i++;
          }
          this.pushQueue = null;
        }
        this.pushing = false;
      }
    }
  },

  error: function (error) {
    if (typeof this.sink === "function") {
      return this.sink(new Error(error));
    }
  }
});

Bacon.Bus = Bus;

var liftCallback = function (desc, wrapped) {
  return withMethodCallSupport(function (f) {
    var stream = partiallyApplied(wrapped, [function (values, callback) {
      return f.apply(undefined, values.concat([callback]));
    }]);

    for (var _len12 = arguments.length, args = Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
      args[_key12 - 1] = arguments[_key12];
    }

    return withDesc(new Bacon.Desc(Bacon, desc, [f].concat(args)), Bacon.combineAsArray(args).flatMap(stream));
  });
};

Bacon.fromCallback = liftCallback("fromCallback", function (f) {
  for (var _len13 = arguments.length, args = Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
    args[_key13 - 1] = arguments[_key13];
  }

  return Bacon.fromBinder(function (handler) {
    makeFunction(f, args)(handler);
    return nop;
  }, function (value) {
    return [value, endEvent()];
  });
});

Bacon.fromNodeCallback = liftCallback("fromNodeCallback", function (f) {
  for (var _len14 = arguments.length, args = Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
    args[_key14 - 1] = arguments[_key14];
  }

  return Bacon.fromBinder(function (handler) {
    makeFunction(f, args)(handler);
    return nop;
  }, function (error, value) {
    if (error) {
      return [new Error(error), endEvent()];
    }
    return [value, endEvent()];
  });
});

Bacon.combineTemplate = function (template) {
  function current(ctxStack) {
    return ctxStack[ctxStack.length - 1];
  }
  function setValue(ctxStack, key, value) {
    current(ctxStack)[key] = value;
    return value;
  }
  function applyStreamValue(key, index) {
    return function (ctxStack, values) {
      setValue(ctxStack, key, values[index]);
    };
  }
  function constantValue(key, value) {
    return function (ctxStack) {
      setValue(ctxStack, key, value);
    };
  }

  function mkContext(template) {
    return isArray(template) ? [] : {};
  }

  function pushContext(key, value) {
    return function (ctxStack) {
      var newContext = mkContext(value);
      setValue(ctxStack, key, newContext);
      ctxStack.push(newContext);
    };
  }

  function containsObservables(value) {
    if (isObservable(value)) {
      return true;
    } else if (value && (value.constructor == Object || value.constructor == Array)) {
      for (var key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          var child = value[key];
          if (containsObservables(child)) return true;
        }
      }
    }
  }

  function compile(key, value) {
    if (isObservable(value)) {
      streams.push(value);
      funcs.push(applyStreamValue(key, streams.length - 1));
    } else if (containsObservables(value)) {
      var popContext = function (ctxStack) {
        ctxStack.pop();
      };
      funcs.push(pushContext(key, value));
      compileTemplate(value);
      funcs.push(popContext);
    } else {
      funcs.push(constantValue(key, value));
    }
  }

  function combinator(values) {
    var rootContext = mkContext(template);
    var ctxStack = [rootContext];
    for (var i = 0, f; i < funcs.length; i++) {
      f = funcs[i];
      f(ctxStack, values);
    }
    return rootContext;
  }

  function compileTemplate(template) {
    _.each(template, compile);
  }

  var funcs = [];
  var streams = [];

  var resultProperty = containsObservables(template) ? (compileTemplate(template), Bacon.combineAsArray(streams).map(combinator)) : Bacon.constant(template);

  return withDesc(new Bacon.Desc(Bacon, "combineTemplate", [template]), resultProperty);
};

Bacon.Observable.prototype.mapEnd = function () {
  var f = makeFunctionArgs(arguments);
  return withDesc(new Bacon.Desc(this, "mapEnd", [f]), this.withHandler(function (event) {
    if (event.isEnd()) {
      this.push(nextEvent(f(event)));
      this.push(endEvent());
      return Bacon.noMore;
    } else {
      return this.push(event);
    }
  }));
};

Bacon.Observable.prototype.skipErrors = function () {
  return withDesc(new Bacon.Desc(this, "skipErrors", []), this.withHandler(function (event) {
    if (event.isError()) {
      return Bacon.more;
    } else {
      return this.push(event);
    }
  }));
};

Bacon.EventStream.prototype.takeUntil = function (stopper) {
  var endMarker = {};
  return withDesc(new Bacon.Desc(this, "takeUntil", [stopper]), Bacon.groupSimultaneous(this.mapEnd(endMarker), stopper.skipErrors()).withHandler(function (event) {
    if (!event.hasValue()) {
      return this.push(event);
    } else {
      var _event$value = event.value();

      var data = _event$value[0];
      var stopper = _event$value[1];

      if (stopper.length) {
        return this.push(endEvent());
      } else {
        var reply = Bacon.more;
        for (var i = 0, value; i < data.length; i++) {
          value = data[i];
          if (value === endMarker) {
            reply = this.push(endEvent());
          } else {
            reply = this.push(nextEvent(value));
          }
        }
        return reply;
      }
    }
  }));
};

Bacon.Property.prototype.takeUntil = function (stopper) {
  var changes = this.changes().takeUntil(stopper);
  return withDesc(new Bacon.Desc(this, "takeUntil", [stopper]), addPropertyInitValueToStream(this, changes));
};

Bacon.Observable.prototype.flatMapLatest = function () {
  var f = makeSpawner(arguments);
  var stream = this.toEventStream();
  return withDesc(new Bacon.Desc(this, "flatMapLatest", [f]), stream.flatMap(function (value) {
    return makeObservable(f(value)).takeUntil(stream);
  }));
};

Bacon.Property.prototype.delayChanges = function (desc, f) {
  return withDesc(desc, addPropertyInitValueToStream(this, f(this.changes())));
};

Bacon.EventStream.prototype.delayChanges = function (desc, f) {
  return withDesc(desc, f(this));
};

Bacon.Observable.prototype.delay = function (delay) {
  return this.delayChanges(new Bacon.Desc(this, "delay", [delay]), function (changes) {
    return changes.flatMap(function (value) {
      return Bacon.later(delay, value);
    });
  });
};

Bacon.Observable.prototype.debounce = function (delay) {
  return this.delayChanges(new Bacon.Desc(this, "debounce", [delay]), function (changes) {
    return changes.flatMapLatest(function (value) {
      return Bacon.later(delay, value);
    });
  });
};

Bacon.Observable.prototype.debounceImmediate = function (delay) {
  return this.delayChanges(new Bacon.Desc(this, "debounceImmediate", [delay]), function (changes) {
    return changes.flatMapFirst(function (value) {
      return Bacon.once(value).concat(Bacon.later(delay).filter(false));
    });
  });
};

Bacon.Observable.prototype.decode = function (cases) {
  return withDesc(new Bacon.Desc(this, "decode", [cases]), this.combine(Bacon.combineTemplate(cases), function (key, values) {
    return values[key];
  }));
};

Bacon.Observable.prototype.scan = function (seed, f) {
  var _this10 = this;

  var resultProperty;
  f = toCombinator(f);
  var acc = toOption(seed);
  var initHandled = false;
  var subscribe = function (sink) {
    var initSent = false;
    var unsub = nop;
    var reply = Bacon.more;
    var sendInit = function () {
      if (!initSent) {
        return acc.forEach(function (value) {
          initSent = initHandled = true;
          reply = sink(new Initial(function () {
            return value;
          }));
          if (reply === Bacon.noMore) {
            unsub();
            unsub = nop;
            return unsub;
          }
        });
      }
    };
    unsub = _this10.dispatcher.subscribe(function (event) {
      if (event.hasValue()) {
        if (initHandled && event.isInitial()) {
          return Bacon.more;
        } else {
            if (!event.isInitial()) {
              sendInit();
            }
            initSent = initHandled = true;
            var prev = acc.getOrElse(undefined);
            var next = f(prev, event.value());

            acc = new Some(next);
            return sink(event.apply(function () {
              return next;
            }));
          }
      } else {
        if (event.isEnd()) {
          reply = sendInit();
        }
        if (reply !== Bacon.noMore) {
          return sink(event);
        }
      }
    });
    UpdateBarrier.whenDoneWith(resultProperty, sendInit);
    return unsub;
  };
  resultProperty = new Property(new Bacon.Desc(this, "scan", [seed, f]), subscribe);
  return resultProperty;
};

Bacon.Observable.prototype.diff = function (start, f) {
  f = toCombinator(f);
  return withDesc(new Bacon.Desc(this, "diff", [start, f]), this.scan([start], function (prevTuple, next) {
    return [next, f(prevTuple[0], next)];
  }).filter(function (tuple) {
    return tuple.length === 2;
  }).map(function (tuple) {
    return tuple[1];
  }));
};

Bacon.Observable.prototype.doAction = function () {
  var f = makeFunctionArgs(arguments);
  return withDesc(new Bacon.Desc(this, "doAction", [f]), this.withHandler(function (event) {
    if (event.hasValue()) {
      f(event.value());
    }
    return this.push(event);
  }));
};

Bacon.Observable.prototype.doEnd = function () {
  var f = makeFunctionArgs(arguments);
  return withDesc(new Bacon.Desc(this, "doEnd", [f]), this.withHandler(function (event) {
    if (event.isEnd()) {
      f();
    }
    return this.push(event);
  }));
};

Bacon.Observable.prototype.doError = function () {
  var f = makeFunctionArgs(arguments);
  return withDesc(new Bacon.Desc(this, "doError", [f]), this.withHandler(function (event) {
    if (event.isError()) {
      f(event.error);
    }
    return this.push(event);
  }));
};

Bacon.Observable.prototype.doLog = function () {
  for (var _len15 = arguments.length, args = Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
    args[_key15] = arguments[_key15];
  }

  return withDesc(new Bacon.Desc(this, "doLog", args), this.withHandler(function (event) {
    if (typeof console !== "undefined" && console !== null && typeof console.log === "function") {
      console.log.apply(console, args.concat([event.log()]));
    }
    return this.push(event);
  }));
};

Bacon.Observable.prototype.endOnError = function (f) {
  if (!(typeof f !== "undefined" && f !== null)) {
    f = true;
  }

  for (var _len16 = arguments.length, args = Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
    args[_key16 - 1] = arguments[_key16];
  }

  return convertArgsToFunction(this, f, args, function (f) {
    return withDesc(new Bacon.Desc(this, "endOnError", []), this.withHandler(function (event) {
      if (event.isError() && f(event.error)) {
        this.push(event);
        return this.push(endEvent());
      } else {
        return this.push(event);
      }
    }));
  });
};

Observable.prototype.errors = function () {
  return withDesc(new Bacon.Desc(this, "errors", []), this.filter(function () {
    return false;
  }));
};

Bacon.Observable.prototype.take = function (count) {
  if (count <= 0) {
    return Bacon.never();
  }
  return withDesc(new Bacon.Desc(this, "take", [count]), this.withHandler(function (event) {
    if (!event.hasValue()) {
      return this.push(event);
    } else {
      count--;
      if (count > 0) {
        return this.push(event);
      } else {
        if (count === 0) {
          this.push(event);
        }
        this.push(endEvent());
        return Bacon.noMore;
      }
    }
  }));
};

Bacon.Observable.prototype.first = function () {
  return withDesc(new Bacon.Desc(this, "first", []), this.take(1));
};

Bacon.Observable.prototype.mapError = function () {
  var f = makeFunctionArgs(arguments);
  return withDesc(new Bacon.Desc(this, "mapError", [f]), this.withHandler(function (event) {
    if (event.isError()) {
      return this.push(nextEvent(f(event.error)));
    } else {
      return this.push(event);
    }
  }));
};

Bacon.Observable.prototype.flatMapError = function (fn) {
  var desc = new Bacon.Desc(this, "flatMapError", [fn]);
  return withDesc(desc, this.mapError(function (err) {
    return new Error(err);
  }).flatMap(function (x) {
    if (x instanceof Error) {
      return fn(x.error);
    } else {
      return Bacon.once(x);
    }
  }));
};

Bacon.EventStream.prototype.flatScan = function (seed, f) {
  var current = seed;
  return this.flatMapConcat(function (next) {
    return makeObservable(f(current, next)).doAction(function (updated) {
      return current = updated;
    });
  }).toProperty(seed);
};

Bacon.EventStream.prototype.sampledBy = function (sampler, combinator) {
  return withDesc(new Bacon.Desc(this, "sampledBy", [sampler, combinator]), this.toProperty().sampledBy(sampler, combinator));
};

Bacon.Property.prototype.sampledBy = function (sampler, combinator) {
  var lazy = false;
  if (typeof combinator !== "undefined" && combinator !== null) {
    combinator = toCombinator(combinator);
  } else {
    lazy = true;
    combinator = function (f) {
      return f.value();
    };
  }
  var thisSource = new Source(this, false, lazy);
  var samplerSource = new Source(sampler, true, lazy);
  var stream = Bacon.when([thisSource, samplerSource], combinator);
  var result = sampler._isProperty ? stream.toProperty() : stream;
  return withDesc(new Bacon.Desc(this, "sampledBy", [sampler, combinator]), result);
};

Bacon.Property.prototype.sample = function (interval) {
  return withDesc(new Bacon.Desc(this, "sample", [interval]), this.sampledBy(Bacon.interval(interval, {})));
};

Bacon.Observable.prototype.map = function (p) {
  if (p && p._isProperty) {
    return p.sampledBy(this, former);
  } else {
    for (var _len17 = arguments.length, args = Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
      args[_key17 - 1] = arguments[_key17];
    }

    return convertArgsToFunction(this, p, args, function (f) {
      return withDesc(new Bacon.Desc(this, "map", [f]), this.withHandler(function (event) {
        return this.push(event.fmap(f));
      }));
    });
  }
};

Bacon.Observable.prototype.fold = function (seed, f) {
  return withDesc(new Bacon.Desc(this, "fold", [seed, f]), this.scan(seed, f).sampledBy(this.filter(false).mapEnd().toProperty()));
};

Observable.prototype.reduce = Observable.prototype.fold;

var eventMethods = [["addEventListener", "removeEventListener"], ["addListener", "removeListener"], ["on", "off"], ["bind", "unbind"]];

var findHandlerMethods = function (target) {
  var pair;
  for (var i = 0; i < eventMethods.length; i++) {
    pair = eventMethods[i];
    var methodPair = [target[pair[0]], target[pair[1]]];
    if (methodPair[0] && methodPair[1]) {
      return methodPair;
    }
  }
  for (var j = 0; j < eventMethods.length; j++) {
    pair = eventMethods[j];
    var addListener = target[pair[0]];
    if (addListener) {
      return [addListener, function () {}];
    }
  }
  throw new Error("No suitable event methods in " + target);
};

Bacon.fromEventTarget = function (target, eventName, eventTransformer) {
  var _findHandlerMethods = findHandlerMethods(target);

  var sub = _findHandlerMethods[0];
  var unsub = _findHandlerMethods[1];

  var desc = new Bacon.Desc(Bacon, "fromEvent", [target, eventName]);
  return withDesc(desc, Bacon.fromBinder(function (handler) {
    sub.call(target, eventName, handler);
    return function () {
      return unsub.call(target, eventName, handler);
    };
  }, eventTransformer));
};

Bacon.fromEvent = Bacon.fromEventTarget;

Bacon.fromPoll = function (delay, poll) {
  var desc = new Bacon.Desc(Bacon, "fromPoll", [delay, poll]);
  return withDesc(desc, Bacon.fromBinder(function (handler) {
    var id = Bacon.scheduler.setInterval(handler, delay);
    return function () {
      return Bacon.scheduler.clearInterval(id);
    };
  }, poll));
};

function valueAndEnd(value) {
  return [value, endEvent()];
}

Bacon.fromPromise = function (promise, abort) {
  var eventTransformer = arguments.length <= 2 || arguments[2] === undefined ? valueAndEnd : arguments[2];

  return withDesc(new Bacon.Desc(Bacon, "fromPromise", [promise]), Bacon.fromBinder(function (handler) {
    var bound = promise.then(handler, function (e) {
      return handler(new Error(e));
    });
    if (bound && typeof bound.done === "function") {
      bound.done();
    }

    if (abort) {
      return function () {
        if (typeof promise.abort === "function") {
          return promise.abort();
        }
      };
    } else {
      return function () {};
    }
  }, eventTransformer));
};

Bacon.Observable.prototype.groupBy = function (keyF) {
  var limitF = arguments.length <= 1 || arguments[1] === undefined ? Bacon._.id : arguments[1];

  var streams = {};
  var src = this;
  return src.filter(function (x) {
    return !streams[keyF(x)];
  }).map(function (x) {
    var key = keyF(x);
    var similar = src.filter(function (x) {
      return keyF(x) === key;
    });
    var data = Bacon.once(x).concat(similar);
    var limited = limitF(data, x).withHandler(function (event) {
      this.push(event);
      if (event.isEnd()) {
        return delete streams[key];
      }
    });
    streams[key] = limited;
    return limited;
  });
};

Bacon.fromArray = function (values) {
  assertArray(values);
  if (!values.length) {
    return withDesc(new Bacon.Desc(Bacon, "fromArray", values), Bacon.never());
  } else {
    var i = 0;
    var stream = new EventStream(new Bacon.Desc(Bacon, "fromArray", [values]), function (sink) {
      var unsubd = false;
      var reply = Bacon.more;
      var pushing = false;
      var pushNeeded = false;
      function push() {
        pushNeeded = true;
        if (pushing) {
          return;
        }
        pushing = true;
        while (pushNeeded) {
          pushNeeded = false;
          if (reply !== Bacon.noMore && !unsubd) {
            var value = values[i++];
            reply = sink(toEvent(value));
            if (reply !== Bacon.noMore) {
              if (i === values.length) {
                sink(endEvent());
              } else {
                UpdateBarrier.afterTransaction(stream, push);
              }
            }
          }
        }
        pushing = false;
        return pushing;
      };

      push();
      return function () {
        unsubd = true;
        return unsubd;
      };
    });
    return stream;
  }
};

Bacon.EventStream.prototype.holdWhen = function (valve) {
  var onHold = false;
  var bufferedValues = [];
  var src = this;
  var srcIsEnded = false;
  return new EventStream(new Bacon.Desc(this, "holdWhen", [valve]), function (sink) {
    var composite = new CompositeUnsubscribe();
    var subscribed = false;
    var endIfBothEnded = function (unsub) {
      if (typeof unsub === "function") {
        unsub();
      }
      if (composite.empty() && subscribed) {
        return sink(endEvent());
      }
    };
    composite.add(function (unsubAll, unsubMe) {
      return valve.subscribeInternal(function (event) {
        if (event.hasValue()) {
          onHold = event.value();
          if (!onHold) {
            var toSend = bufferedValues;
            bufferedValues = [];
            return (function () {
              var result = [];
              for (var i = 0, value; i < toSend.length; i++) {
                value = toSend[i];
                result.push(sink(nextEvent(value)));
              }
              if (srcIsEnded) {
                result.push(sink(endEvent()));
                unsubMe();
              }
              return result;
            })();
          }
        } else if (event.isEnd()) {
          return endIfBothEnded(unsubMe);
        } else {
          return sink(event);
        }
      });
    });
    composite.add(function (unsubAll, unsubMe) {
      return src.subscribeInternal(function (event) {
        if (onHold && event.hasValue()) {
          return bufferedValues.push(event.value());
        } else if (event.isEnd() && bufferedValues.length) {
          srcIsEnded = true;
          return endIfBothEnded(unsubMe);
        } else {
          return sink(event);
        }
      });
    });
    subscribed = true;
    endIfBothEnded();
    return composite.unsubscribe;
  });
};

Bacon.interval = function (delay) {
  var value = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return withDesc(new Bacon.Desc(Bacon, "interval", [delay, value]), Bacon.fromPoll(delay, function () {
    return nextEvent(value);
  }));
};

Bacon.$ = {};
Bacon.$.asEventStream = function (eventName, selector, eventTransformer) {
  var _this11 = this;

  if (_.isFunction(selector)) {
    eventTransformer = selector;
    selector = undefined;
  }

  return withDesc(new Bacon.Desc(this.selector || this, "asEventStream", [eventName]), Bacon.fromBinder(function (handler) {
    _this11.on(eventName, selector, handler);
    return function () {
      return _this11.off(eventName, selector, handler);
    };
  }, eventTransformer));
};

if (typeof jQuery !== "undefined" && jQuery) {
  jQuery.fn.asEventStream = Bacon.$.asEventStream;
}

if (typeof Zepto !== "undefined" && Zepto) {
  Zepto.fn.asEventStream = Bacon.$.asEventStream;
}

Bacon.Observable.prototype.last = function () {
  var lastEvent;

  return withDesc(new Bacon.Desc(this, "last", []), this.withHandler(function (event) {
    if (event.isEnd()) {
      if (lastEvent) {
        this.push(lastEvent);
      }
      this.push(endEvent());
      return Bacon.noMore;
    } else {
      lastEvent = event;
    }
  }));
};

Bacon.Observable.prototype.log = function () {
  for (var _len18 = arguments.length, args = Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
    args[_key18] = arguments[_key18];
  }

  this.subscribe(function (event) {
    if (typeof console !== "undefined" && typeof console.log === "function") {
      console.log.apply(console, args.concat([event.log()]));
    }
  });
  return this;
};

Bacon.EventStream.prototype.merge = function (right) {
  assertEventStream(right);
  var left = this;
  return withDesc(new Bacon.Desc(left, "merge", [right]), Bacon.mergeAll(this, right));
};

Bacon.mergeAll = function () {
  var streams = argumentsToObservables(arguments);
  if (streams.length) {
    return new EventStream(new Bacon.Desc(Bacon, "mergeAll", streams), function (sink) {
      var ends = 0;
      var smartSink = function (obs) {
        return function (unsubBoth) {
          return obs.dispatcher.subscribe(function (event) {
            if (event.isEnd()) {
              ends++;
              if (ends === streams.length) {
                return sink(endEvent());
              } else {
                return Bacon.more;
              }
            } else {
              var reply = sink(event);
              if (reply === Bacon.noMore) {
                unsubBoth();
              }
              return reply;
            }
          });
        };
      };
      var sinks = _.map(smartSink, streams);
      return new Bacon.CompositeUnsubscribe(sinks).unsubscribe;
    });
  } else {
    return Bacon.never();
  }
};

Bacon.repeatedly = function (delay, values) {
  var index = 0;
  return withDesc(new Bacon.Desc(Bacon, "repeatedly", [delay, values]), Bacon.fromPoll(delay, function () {
    return values[index++ % values.length];
  }));
};

Bacon.repeat = function (generator) {
  var index = 0;
  return Bacon.fromBinder(function (sink) {
    var flag = false;
    var reply = Bacon.more;
    var unsub = function () {};
    function handleEvent(event) {
      if (event.isEnd()) {
        if (!flag) {
          return flag = true;
        } else {
          return subscribeNext();
        }
      } else {
        return reply = sink(event);
      }
    };
    function subscribeNext() {
      var next;
      flag = true;
      while (flag && reply !== Bacon.noMore) {
        next = generator(index++);
        flag = false;
        if (next) {
          unsub = next.subscribeInternal(handleEvent);
        } else {
          sink(endEvent());
        }
      }
      return flag = true;
    };
    subscribeNext();
    return function () {
      return unsub();
    };
  });
};

Bacon.retry = function (options) {
  if (!_.isFunction(options.source)) {
    throw new Exception("'source' option has to be a function");
  }
  var source = options.source;
  var retries = options.retries || 0;
  var retriesDone = 0;
  var delay = options.delay || function () {
    return 0;
  };
  var isRetryable = options.isRetryable || function () {
    return true;
  };
  var finished = false;
  var error = null;

  return withDesc(new Bacon.Desc(Bacon, "retry", [options]), Bacon.repeat(function (count) {
    function valueStream() {
      return source(count).endOnError().withHandler(function (event) {
        if (event.isError()) {
          error = event;
          if (!(isRetryable(error.error) && (retries === 0 || retriesDone < retries))) {
            finished = true;
            return this.push(event);
          }
        } else {
          if (event.hasValue()) {
            error = null;
            finished = true;
          }
          return this.push(event);
        }
      });
    }

    if (finished) {
      return null;
    } else if (error) {
      var context = {
        error: error.error,
        retriesDone: retriesDone
      };
      var pause = Bacon.later(delay(context)).filter(false);
      retriesDone++;
      return pause.concat(Bacon.once().flatMap(valueStream));
    } else {
      return valueStream();
    }
  }));
};

Bacon.sequentially = function (delay, values) {
  var index = 0;
  return withDesc(new Bacon.Desc(Bacon, "sequentially", [delay, values]), Bacon.fromPoll(delay, function () {
    var value = values[index++];
    if (index < values.length) {
      return value;
    } else if (index === values.length) {
      return [value, endEvent()];
    } else {
      return endEvent();
    }
  }));
};

Bacon.Observable.prototype.skip = function (count) {
  return withDesc(new Bacon.Desc(this, "skip", [count]), this.withHandler(function (event) {
    if (!event.hasValue()) {
      return this.push(event);
    } else if (count > 0) {
      count--;
      return Bacon.more;
    } else {
      return this.push(event);
    }
  }));
};

Bacon.EventStream.prototype.skipUntil = function (starter) {
  var started = starter.take(1).map(true).toProperty(false);
  return withDesc(new Bacon.Desc(this, "skipUntil", [starter]), this.filter(started));
};

Bacon.EventStream.prototype.skipWhile = function (f) {
  assertObservableIsProperty(f);
  var ok = false;

  for (var _len19 = arguments.length, args = Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
    args[_key19 - 1] = arguments[_key19];
  }

  return convertArgsToFunction(this, f, args, function (f) {
    return withDesc(new Bacon.Desc(this, "skipWhile", [f]), this.withHandler(function (event) {
      if (ok || !event.hasValue() || !f(event.value())) {
        if (event.hasValue()) {
          ok = true;
        }
        return this.push(event);
      } else {
        return Bacon.more;
      }
    }));
  });
};

Bacon.Observable.prototype.slidingWindow = function (n) {
  var minValues = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];

  return withDesc(new Bacon.Desc(this, "slidingWindow", [n, minValues]), this.scan([], function (window, value) {
    return window.concat([value]).slice(-n);
  }).filter(function (values) {
    return values.length >= minValues;
  }));
};

var spies = [];
var registerObs = function (obs) {
  if (spies.length) {
    if (!registerObs.running) {
      try {
        registerObs.running = true;
        spies.forEach(function (spy) {
          spy(obs);
        });
      } finally {
        delete registerObs.running;
      }
    }
  }
};

Bacon.spy = function (spy) {
  return spies.push(spy);
};

Bacon.Property.prototype.startWith = function (seed) {
  return withDesc(new Bacon.Desc(this, "startWith", [seed]), this.scan(seed, function (prev, next) {
    return next;
  }));
};

Bacon.EventStream.prototype.startWith = function (seed) {
  return withDesc(new Bacon.Desc(this, "startWith", [seed]), Bacon.once(seed).concat(this));
};

Bacon.Observable.prototype.takeWhile = function (f) {
  assertObservableIsProperty(f);

  for (var _len20 = arguments.length, args = Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
    args[_key20 - 1] = arguments[_key20];
  }

  return convertArgsToFunction(this, f, args, function (f) {
    return withDesc(new Bacon.Desc(this, "takeWhile", [f]), this.withHandler(function (event) {
      if (event.filter(f)) {
        return this.push(event);
      } else {
        this.push(endEvent());
        return Bacon.noMore;
      }
    }));
  });
};

Bacon.Observable.prototype.throttle = function (delay) {
  return this.delayChanges(new Bacon.Desc(this, "throttle", [delay]), function (changes) {
    return changes.bufferWithTime(delay).map(function (values) {
      return values[values.length - 1];
    });
  });
};

Observable.prototype.firstToPromise = function (PromiseCtr) {
  var _this12 = this;

  if (typeof PromiseCtr !== "function") {
    if (typeof Promise === "function") {
      PromiseCtr = Promise;
    } else {
      throw new Exception("There isn't default Promise, use shim or parameter");
    }
  }

  return new PromiseCtr(function (resolve, reject) {
    return _this12.subscribe(function (event) {
      if (event.hasValue()) {
        resolve(event.value());
      }
      if (event.isError()) {
        reject(event.error);
      }

      return Bacon.noMore;
    });
  });
};

Observable.prototype.toPromise = function (PromiseCtr) {
  return this.last().firstToPromise(PromiseCtr);
};

Bacon["try"] = function (f) {
  return function (value) {
    try {
      return Bacon.once(f(value));
    } catch (e) {
      return new Bacon.Error(e);
    }
  };
};

Bacon.update = function (initial) {
  function lateBindFirst(f) {
    return function () {
      for (var _len22 = arguments.length, args = Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
        args[_key22] = arguments[_key22];
      }

      return function (i) {
        return f.apply(undefined, [i].concat(args));
      };
    };
  }

  for (var _len21 = arguments.length, patterns = Array(_len21 > 1 ? _len21 - 1 : 0), _key21 = 1; _key21 < _len21; _key21++) {
    patterns[_key21 - 1] = arguments[_key21];
  }

  var i = patterns.length - 1;
  while (i > 0) {
    if (!(patterns[i] instanceof Function)) {
      patterns[i] = _.always(patterns[i]);
    }
    patterns[i] = lateBindFirst(patterns[i]);
    i = i - 2;
  }
  return withDesc(new Bacon.Desc(Bacon, "update", [initial].concat(patterns)), Bacon.when.apply(Bacon, patterns).scan(initial, function (x, f) {
    return f(x);
  }));
};

Bacon.zipAsArray = function () {
  for (var _len23 = arguments.length, args = Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
    args[_key23] = arguments[_key23];
  }

  var streams = argumentsToObservables(args);
  return withDesc(new Bacon.Desc(Bacon, "zipAsArray", streams), Bacon.zipWith(streams, function () {
    for (var _len24 = arguments.length, xs = Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
      xs[_key24] = arguments[_key24];
    }

    return xs;
  }));
};

Bacon.zipWith = function () {
  for (var _len25 = arguments.length, args = Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
    args[_key25] = arguments[_key25];
  }

  var observablesAndFunction = argumentsToObservablesAndFunction(args);
  var streams = observablesAndFunction[0];
  var f = observablesAndFunction[1];

  streams = _.map(function (s) {
    return s.toEventStream();
  }, streams);
  return withDesc(new Bacon.Desc(Bacon, "zipWith", [f].concat(streams)), Bacon.when(streams, f));
};

Bacon.Observable.prototype.zip = function (other, f) {
  return withDesc(new Bacon.Desc(this, "zip", [other]), Bacon.zipWith([this, other], f || Array));
};

function ESObservable(observable) {
  this.observable = observable;
}

ESObservable.prototype.subscribe = function (observerOrOnNext, onError, onComplete) {
  var observer = typeof observerOrOnNext === 'function' ? { next: observerOrOnNext, error: onError, complete: onComplete } : observerOrOnNext;
  var subscription = {
    closed: false,
    unsubscribe: function () {
      subscription.closed = true;
      cancel();
    }
  };

  var cancel = this.observable.subscribe(function (event) {
    if (event.isError()) {
      if (observer.error) observer.error(event.error);
      subscription.unsubscribe();
    } else if (event.isEnd()) {
      subscription.closed = true;
      if (observer.complete) observer.complete();
    } else if (observer.next) {
      observer.next(event.value());
    }
  });
  return subscription;
};

ESObservable.prototype[symbol('observable')] = function () {
  return this;
};

Bacon.Observable.prototype.toESObservable = function () {
  return new ESObservable(this);
};

Bacon.Observable.prototype[symbol('observable')] = Bacon.Observable.prototype.toESObservable;

Bacon.fromESObservable = function (_observable) {
  var observable;
  if (_observable[symbol("observable")]) {
    observable = _observable[symbol("observable")]();
  } else {
    observable = _observable;
  }

  var desc = new Bacon.Desc(Bacon, "fromESObservable", [observable]);
  return new Bacon.EventStream(desc, function (sink) {
    var cancel = observable.subscribe({
      error: function () {
        sink(new Bacon.Error());
        sink(new Bacon.End());
      },
      next: function (value) {
        sink(new Bacon.Next(value, true));
      },
      complete: function () {
        sink(new Bacon.End());
      }
    });

    if (cancel.unsubscribe) {
      return function () {
        cancel.unsubscribe();
      };
    } else {
      return cancel;
    }
  });
};

if ("function" !== "undefined" && __webpack_require__(433) !== null && __webpack_require__(261) != null) {
  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return Bacon;
  }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  if (typeof this !== "undefined" && this !== null) {
    this.Bacon = Bacon;
  }
} else if (typeof module !== "undefined" && module !== null && module.exports != null) {
  module.exports = Bacon;
  Bacon.Bacon = Bacon;
} else {
    this.Bacon = Bacon;
  }
}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(96)(module)))

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconGroupTileWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_CustomPropTypes__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_IconGroup__ = __webpack_require__(143);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var style = Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_utils_prefixStyles__["b" /* default */])({
  margin: "0 auto",
  height: "3.5em",
  display: "flex",
  alignItems: "center"
});

var IconGroupTileWrapper =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(IconGroupTileWrapper, _React$Component);

  function IconGroupTileWrapper() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, IconGroupTileWrapper);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(IconGroupTileWrapper).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(IconGroupTileWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          values = _this$props.values,
          unique = _this$props.unique;
      var icons = Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_IconGroup__["b" /* truncateAndCombineIcons */])(values, unique);
      var hasThermostat = icons.some(function (icon) {
        return icon.name === "thermostat";
      });
      var maxWidth;

      if (icons.length === 4) {
        maxWidth = hasThermostat ? "6.5em" : "5.5em";
      } else {
        maxWidth = hasThermostat ? "7.5em" : "6.5em";
      }

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: _objectSpread({}, style, {
          maxWidth: maxWidth
        })
      }, children);
    }
  }]);

  return IconGroupTileWrapper;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(IconGroupTileWrapper, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  values: __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_CustomPropTypes__["a" /* default */].keyedElementList.isRequired,
  unique: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
});



/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TileSpinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nx_components_Spinner__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nx_components_Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_utils_prefixStyles__ = __webpack_require__(9);









var styles = Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_utils_prefixStyles__["b" /* default */])({
  container: {
    position: "absolute",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: __WEBPACK_IMPORTED_MODULE_7_nx_components_Theme__["a" /* default */].zIndexLayers.MODAL + 1,
    cursor: "default",
    background: "rgba(255, 255, 255, .75)"
  }
});

var TileSpinner =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(TileSpinner, _React$Component);

  function TileSpinner() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, TileSpinner);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(TileSpinner).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(TileSpinner, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", {
        style: styles.container,
        "data-component-name": "TileSpinner"
      }, __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_nx_components_Spinner__["a" /* default */], null));
    }
  }]);

  return TileSpinner;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);



/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(473),
    baseKeys = __webpack_require__(1199),
    isArrayLike = __webpack_require__(477);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 293 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1207),
    stubArray = __webpack_require__(479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(1218);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cancelSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFrameData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hey_listen__ = __webpack_require__(124);


var prevTime = 0;
var onNextFrame = typeof window !== 'undefined' && window.requestAnimationFrame !== undefined
    ? function (callback) { return window.requestAnimationFrame(callback); }
    : function (callback) {
        var timestamp = Date.now();
        var timeToCall = Math.max(0, 16.7 - (timestamp - prevTime));
        prevTime = timestamp + timeToCall;
        setTimeout(function () { return callback(prevTime); }, timeToCall);
    };

var createStep = (function (setRunNextFrame) {
    var processToRun = [];
    var processToRunNextFrame = [];
    var numThisFrame = 0;
    var isProcessing = false;
    var i = 0;
    var cancelled = new WeakSet();
    var toKeepAlive = new WeakSet();
    var renderStep = {
        cancel: function (process) {
            var indexOfCallback = processToRunNextFrame.indexOf(process);
            cancelled.add(process);
            if (indexOfCallback !== -1) {
                processToRunNextFrame.splice(indexOfCallback, 1);
            }
        },
        process: function (frame) {
            var _a;
            isProcessing = true;
            _a = [
                processToRunNextFrame,
                processToRun
            ], processToRun = _a[0], processToRunNextFrame = _a[1];
            processToRunNextFrame.length = 0;
            numThisFrame = processToRun.length;
            if (numThisFrame) {
                var process_1;
                for (i = 0; i < numThisFrame; i++) {
                    process_1 = processToRun[i];
                    process_1(frame);
                    if (toKeepAlive.has(process_1) === true && !cancelled.has(process_1)) {
                        renderStep.schedule(process_1);
                        setRunNextFrame(true);
                    }
                }
            }
            isProcessing = false;
        },
        schedule: function (process, keepAlive, immediate) {
            if (keepAlive === void 0) { keepAlive = false; }
            if (immediate === void 0) { immediate = false; }
            Object(__WEBPACK_IMPORTED_MODULE_0_hey_listen__["a" /* invariant */])(typeof process === 'function', 'Argument must be a function');
            var addToCurrentBuffer = immediate && isProcessing;
            var buffer = addToCurrentBuffer ? processToRun : processToRunNextFrame;
            cancelled.delete(process);
            if (keepAlive)
                toKeepAlive.add(process);
            if (buffer.indexOf(process) === -1) {
                buffer.push(process);
                if (addToCurrentBuffer)
                    numThisFrame = processToRun.length;
            }
        }
    };
    return renderStep;
});

var StepId;
(function (StepId) {
    StepId["Read"] = "read";
    StepId["Update"] = "update";
    StepId["Render"] = "render";
    StepId["PostRender"] = "postRender";
    StepId["FixedUpdate"] = "fixedUpdate";
})(StepId || (StepId = {}));

var maxElapsed = 40;
var defaultElapsed = (1 / 60) * 1000;
var useDefaultElapsed = true;
var willRunNextFrame = false;
var isProcessing = false;
var frame = {
    delta: 0,
    timestamp: 0
};
var stepsOrder = [
    StepId.Read,
    StepId.Update,
    StepId.Render,
    StepId.PostRender
];
var setWillRunNextFrame = function (willRun) { return (willRunNextFrame = willRun); };
var _a = stepsOrder.reduce(function (acc, key) {
    var step = createStep(setWillRunNextFrame);
    acc.sync[key] = function (process, keepAlive, immediate) {
        if (keepAlive === void 0) { keepAlive = false; }
        if (immediate === void 0) { immediate = false; }
        if (!willRunNextFrame)
            startLoop();
        step.schedule(process, keepAlive, immediate);
        return process;
    };
    acc.cancelSync[key] = function (process) { return step.cancel(process); };
    acc.steps[key] = step;
    return acc;
}, {
    steps: {},
    sync: {},
    cancelSync: {}
}), steps = _a.steps, sync = _a.sync, cancelSync = _a.cancelSync;
var processStep = function (stepId) { return steps[stepId].process(frame); };
var processFrame = function (timestamp) {
    willRunNextFrame = false;
    frame.delta = useDefaultElapsed
        ? defaultElapsed
        : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
    if (!useDefaultElapsed)
        defaultElapsed = frame.delta;
    frame.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (willRunNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
var startLoop = function () {
    willRunNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing)
        onNextFrame(processFrame);
};
var getFrameData = function () { return frame; };

/* harmony default export */ __webpack_exports__["b"] = (sync);



/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_Section__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_ErrorHandler__ = __webpack_require__(98);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var DetailsSection = function DetailsSection(_ref) {
  var children = _ref.children,
      style = _ref.style,
      otherProps = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["children", "style"]);

  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    style: {
      marginTop: "2vh"
    }
  }, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nx_components_Section__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
    style: _objectSpread({
      borderTop: otherProps.label ? "1px solid #E3E3E3" : ""
    }, style)
  }, otherProps), __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_ErrorHandler__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    "data-component-name": "DetailsSection",
    "data-component-prop-label": otherProps.label
  }, children))));
};

DetailsSection.propTypes = _objectSpread({
  label: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
}, __WEBPACK_IMPORTED_MODULE_5_nx_components_Section__["a" /* default */].propTypes);
/* harmony default export */ __webpack_exports__["a"] = (DetailsSection);

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.createChainedFunction = createChainedFunction;

var _typeof2 = _interopRequireDefault(__webpack_require__(66));

var _warning = _interopRequireDefault(__webpack_require__(49));

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (false) {
    throw new Error('Material-UI: capitalize(string) expects a string argument.');
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

function contains(obj, pred) {
  return Object.keys(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = (0, _typeof2.default)(pred);

  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }

    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }

    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }

  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */


function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

     false ? (0, _warning.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);



var styles = {
  container: {
    height: "2em",
    backgroundColor: "rgba(0,0,0,0.5)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  text: {
    color: "white"
  }
};

var PivotDemoBanner = function PivotDemoBanner() {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.PivotDemoBanner;
  var inDemoMode = __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState && __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState.inDemoMode;
  return inDemoMode ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: styles.container
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    style: styles.text
  }, language.saveDoesNotOccur)) : null;
};

/* harmony default export */ __webpack_exports__["a"] = (PivotDemoBanner);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = batchReactUpdates;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
 // Wrap this unstable API so that we can rely on the signature as it changes.

function batchReactUpdates(updater) {
  __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.unstable_batchedUpdates(updater);
}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGB = convertHexToRGB;
exports.rgbToHex = rgbToHex;
exports.decomposeColor = decomposeColor;
exports.recomposeColor = recomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = _interopRequireDefault(__webpack_require__(49));

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
   false ? (0, _warning.default)(value >= min && value <= max, "Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "].")) : void 0;

  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function convertHexToRGB(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb(".concat(colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', '), ")") : '';
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Pass hex straight through
  if (color.indexOf('#') === 0) {
    return color;
  }

  function intToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  values = values.map(function (n) {
    return intToHex(n);
  });
  return "#".concat(values.join(''));
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */


function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  if (false) {
    if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
      throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
    }
  }

  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */


function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  }

  if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(color.type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */


function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */


function getLuminance(color) {
  var decomposedColor = decomposeColor(color);

  if (decomposedColor.type.indexOf('rgb') !== -1) {
    var rgb = decomposedColor.values.map(function (val) {
      val /= 255; // normalized

      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits

    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  } // else if (decomposedColor.type.indexOf('hsl') !== -1)


  return decomposedColor.values[2] / 100;
}
/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function fade(color, value) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in fade(".concat(color, ", ").concat(value, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function darken(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in darken(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function lighten(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in lighten(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(159);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ownerDocument = _interopRequireDefault(__webpack_require__(146));

function ownerWindow(node) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var doc = (0, _ownerDocument.default)(node);
  return doc.defaultView || doc.parentView || fallback;
}

var _default = ownerWindow;
exports.default = _default;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(40));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(53));

var _reactLifecyclesCompat = __webpack_require__(494);

var _PropTypes = __webpack_require__(1075);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(217);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_polished__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_Switch__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__UserAgent__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);













var IOSToggle =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(IOSToggle, _React$Component);

  function IOSToggle() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, IOSToggle);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(IOSToggle).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(IOSToggle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          changeOnTap = _this$props.changeOnTap,
          checked = _this$props.checked,
          colors = _this$props.colors,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          ariaLabel = _this$props["aria-label"];
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__internal_Switch__["a" /* default */], {
        changeOnTap: changeOnTap,
        checked: checked,
        onChange: onChange,
        disabled: disabled,
        offColor: "#888",
        onColor: colors.PRIMARY,
        offHandleColor: "#fff",
        onHandleColor: "#fff",
        activeBoxShadow: "0 0 2px 2px ".concat(colors.PRIMARY),
        handleDiameter: 22,
        height: 24,
        width: 40,
        "aria-label": ariaLabel
      });
    }
  }]);

  return IOSToggle;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(IOSToggle, "propTypes", {
  changeOnTap: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  checked: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool.isRequired,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  },
  onChange: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  "\"aria-label\"": __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string
});

var AndroidToggle =
/*#__PURE__*/
function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(AndroidToggle, _React$Component2);

  function AndroidToggle() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AndroidToggle);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AndroidToggle).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AndroidToggle, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          changeOnTap = _this$props2.changeOnTap,
          checked = _this$props2.checked,
          colors = _this$props2.colors,
          onChange = _this$props2.onChange,
          disabled = _this$props2.disabled,
          ariaLabel = _this$props2["aria-label"];
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__internal_Switch__["a" /* default */], {
        changeOnTap: changeOnTap,
        checked: checked,
        onChange: onChange,
        disabled: disabled,
        uncheckedIcon: null,
        checkedIcon: null,
        offColor: "#888",
        onColor: Object(__WEBPACK_IMPORTED_MODULE_7_polished__["b" /* lighten */])(0.275, colors.PRIMARY),
        offHandleColor: "#fff",
        onHandleColor: colors.PRIMARY,
        boxShadow: "0 1px 2px 2px rgba(0, 0, 0, ".concat( // Making the shadow match the darken amount in activeBoxShadow
        // so that the transition looks kinda cool
        __WEBPACK_IMPORTED_MODULE_11__Tappable__["a" /* ACTIVE_DARKEN_AMOUNT */], ")"),
        activeBoxShadow: "0 0 0 5px rgba(0, 0, 0, ".concat(__WEBPACK_IMPORTED_MODULE_11__Tappable__["a" /* ACTIVE_DARKEN_AMOUNT */], ")"),
        handleDiameter: 20,
        height: 14,
        width: 36,
        "aria-label": ariaLabel
      });
    }
  }]);

  return AndroidToggle;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(AndroidToggle, "propTypes", {
  changeOnTap: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  checked: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool.isRequired,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  },
  onChange: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  "\"aria-label\"": __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string
});

var Toggle =
/*#__PURE__*/
function (_React$Component3) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Toggle, _React$Component3);

  function Toggle() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Toggle);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Toggle).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Toggle, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          changeOnTap = _this$props3.changeOnTap,
          checked = _this$props3.checked,
          colors = _this$props3.colors,
          onChange = _this$props3.onChange,
          disabled = _this$props3.disabled,
          ariaLabel = _this$props3["aria-label"],
          forceType = _this$props3.forceType;
      var ToggleComponent = __WEBPACK_IMPORTED_MODULE_10__UserAgent__["a" /* default */].isIOS() ? IOSToggle : AndroidToggle;

      if (forceType === "iOS") {
        ToggleComponent = IOSToggle;
      } else if (forceType === "Android") {
        ToggleComponent = AndroidToggle;
      }

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](ToggleComponent, {
        changeOnTap: changeOnTap,
        checked: checked || false,
        colors: colors,
        onChange: onChange || function () {
          /* no-op */
        },
        disabled: disabled,
        "aria-label": ariaLabel || undefined
      });
    }
  }]);

  return Toggle;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Toggle, "propTypes", {
  changeOnTap: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  checked: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  },
  onChange: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  "\"aria-label\"": __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
  forceType: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.oneOf(["iOS", "Android"])
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["c" /* withColorsProvider */])(Toggle));



/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TileList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Tiles_Tile__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var styles = {
  // Intentionally unprefixed. We use a fallback in Tile if grid is not supported
  list: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
    paddingBottom: __WEBPACK_IMPORTED_MODULE_9_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_BOTTOM,
    overflow: "hidden"
  }
};

var TileList =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(TileList, _React$Component);

  function TileList() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, TileList);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(TileList).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(TileList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          collection = _this$props.collection,
          style = _this$props.style;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        className: "tile-wrap",
        style: _objectSpread({}, styles.list, {}, style),
        "data-component-name": "TileList"
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_BackboneListener__["a" /* default */], {
        listenTo: collection,
        events: ["add", "remove", "reset", "sort", "sync"],
        debounceRender: true
      }, function () {
        return collection.map(function (model) {
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Tiles_Tile__["a" /* default */] // This component is cheap to render, so it's safe to use SizeMe
          , {
            key: model.get("id"),
            model: model
          });
        });
      }));
    }
  }]);

  return TileList;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(TileList, "propTypes", {
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  collection: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Collection)
});



/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var createResizeDetector = _interopDefault(__webpack_require__(460));
var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(__webpack_require__(10));
var ReactDOM = _interopDefault(__webpack_require__(53));
var invariant = _interopDefault(__webpack_require__(463));
var throttleDebounce = __webpack_require__(464);
var isShallowEqual = _interopDefault(__webpack_require__(465));

var instances = {};

// Lazily require to not cause bug
// https://github.com/ctrlplusb/react-sizeme/issues/6
function resizeDetector() {
  var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'scroll';

  if (!instances[strategy]) {
    instances[strategy] = createResizeDetector({
      strategy: strategy
    });
  }

  return instances[strategy];
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/* eslint-disable react/no-multi-comp */

var errMsg = 'react-sizeme: an error occurred whilst stopping to listen to node size changes';

var defaultConfig = {
  monitorWidth: true,
  monitorHeight: false,
  monitorPosition: false,
  refreshRate: 16,
  refreshMode: 'throttle',
  noPlaceholder: false,
  resizeDetectorStrategy: 'scroll'
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/**
 * This is a utility wrapper component that will allow our higher order
 * component to get a ref handle on our wrapped components html.
 * @see https://gist.github.com/jimfb/32b587ee6177665fb4cf
 */

var ReferenceWrapper = function (_Component) {
  inherits(ReferenceWrapper, _Component);

  function ReferenceWrapper() {
    classCallCheck(this, ReferenceWrapper);
    return possibleConstructorReturn(this, (ReferenceWrapper.__proto__ || Object.getPrototypeOf(ReferenceWrapper)).apply(this, arguments));
  }

  createClass(ReferenceWrapper, [{
    key: 'render',
    value: function render() {
      return React.Children.only(this.props.children);
    }
  }]);
  return ReferenceWrapper;
}(React.Component);

ReferenceWrapper.displayName = 'SizeMeReferenceWrapper';

ReferenceWrapper.propTypes = { children: PropTypes.element.isRequired };

function Placeholder(_ref) {
  var className = _ref.className,
      style = _ref.style;

  // Lets create the props for the temp element.
  var phProps = {};

  // We will use any provided className/style or else make the temp
  // container take the full available space.
  if (!className && !style) {
    phProps.style = { width: '100%', height: '100%' };
  } else {
    if (className) {
      phProps.className = className;
    }
    if (style) {
      phProps.style = style;
    }
  }

  return React__default.createElement('div', phProps);
}
Placeholder.displayName = 'SizeMePlaceholder';
Placeholder.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object

  /**
   * As we need to maintain a ref on the root node that is rendered within our
   * SizeMe component we need to wrap our entire render in a sub component.
   * Without this, we lose the DOM ref after the placeholder is removed from
   * the render and the actual component is rendered.
   * It took me forever to figure this out, so tread extra careful on this one!
   */
};var renderWrapper = function renderWrapper(WrappedComponent) {
  function SizeMeRenderer(props) {
    var explicitRef = props.explicitRef,
        className = props.className,
        style = props.style,
        size = props.size,
        disablePlaceholder = props.disablePlaceholder,
        onSize = props.onSize,
        restProps = objectWithoutProperties(props, ['explicitRef', 'className', 'style', 'size', 'disablePlaceholder', 'onSize']);


    var noSizeData = size == null || size.width == null && size.height == null && size.position == null;

    var renderPlaceholder = noSizeData && !disablePlaceholder;

    var renderProps = {
      className: className,
      style: style
    };

    if (size != null) {
      renderProps.size = size;
    }

    var toRender = renderPlaceholder ? React__default.createElement(Placeholder, { className: className, style: style }) : React__default.createElement(WrappedComponent, _extends({}, renderProps, restProps));

    return React__default.createElement(
      ReferenceWrapper,
      { ref: explicitRef },
      toRender
    );
  }

  SizeMeRenderer.displayName = 'SizeMeRenderer(' + getDisplayName(WrappedComponent) + ')';

  SizeMeRenderer.propTypes = {
    explicitRef: PropTypes.func.isRequired,
    className: PropTypes.string,
    style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    size: PropTypes.shape({
      width: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
      height: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
      position: PropTypes.object
    }),
    disablePlaceholder: PropTypes.bool,
    onSize: PropTypes.func
  };

  return SizeMeRenderer;
};

/**
 * :: config -> Component -> WrappedComponent
 *
 * Higher order component that allows the wrapped component to become aware
 * of it's size, by receiving it as an object within it's props.
 *
 * @param  monitorWidth
 *   Default true, whether changes in the element's width should be monitored,
 *   causing a size property to be broadcast.
 * @param  monitorHeight
 *   Default false, whether changes in the element's height should be monitored,
 *   causing a size property to be broadcast.
 *
 * @return The wrapped component.
 */
function withSize() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfig;
  var _config$monitorWidth = config.monitorWidth,
      monitorWidth = _config$monitorWidth === undefined ? defaultConfig.monitorWidth : _config$monitorWidth,
      _config$monitorHeight = config.monitorHeight,
      monitorHeight = _config$monitorHeight === undefined ? defaultConfig.monitorHeight : _config$monitorHeight,
      _config$monitorPositi = config.monitorPosition,
      monitorPosition = _config$monitorPositi === undefined ? defaultConfig.monitorPosition : _config$monitorPositi,
      _config$refreshRate = config.refreshRate,
      refreshRate = _config$refreshRate === undefined ? defaultConfig.refreshRate : _config$refreshRate,
      _config$refreshMode = config.refreshMode,
      refreshMode = _config$refreshMode === undefined ? defaultConfig.refreshMode : _config$refreshMode,
      _config$noPlaceholder = config.noPlaceholder,
      noPlaceholder = _config$noPlaceholder === undefined ? defaultConfig.noPlaceholder : _config$noPlaceholder,
      _config$resizeDetecto = config.resizeDetectorStrategy,
      resizeDetectorStrategy = _config$resizeDetecto === undefined ? defaultConfig.resizeDetectorStrategy : _config$resizeDetecto;


  invariant(monitorWidth || monitorHeight || monitorPosition, 'You have to monitor at least one of the width, height, or position when using "sizeMe"');

  invariant(refreshRate >= 16, "It is highly recommended that you don't put your refreshRate lower than " + '16 as this may cause layout thrashing.');

  invariant(refreshMode === 'throttle' || refreshMode === 'debounce', 'The refreshMode should have a value of "throttle" or "debounce"');

  var refreshDelayStrategy = refreshMode === 'throttle' ? throttleDebounce.throttle : throttleDebounce.debounce;

  return function WrapComponent(WrappedComponent) {
    var SizeMeRenderWrapper = renderWrapper(WrappedComponent);

    var SizeAwareComponent = function (_React$Component) {
      inherits(SizeAwareComponent, _React$Component);

      function SizeAwareComponent() {
        var _ref2;

        var _temp, _this2, _ret;

        classCallCheck(this, SizeAwareComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = possibleConstructorReturn(this, (_ref2 = SizeAwareComponent.__proto__ || Object.getPrototypeOf(SizeAwareComponent)).call.apply(_ref2, [this].concat(args))), _this2), _this2.domEl = null, _this2.state = {
          width: undefined,
          height: undefined,
          position: undefined
        }, _this2.uninstall = function () {
          if (_this2.domEl) {
            try {
              _this2.detector.uninstall(_this2.domEl);
            } catch (err) {
              // eslint-disable-next-line no-console
              console.warn(errMsg);
            }
            _this2.domEl = null;
          }
        }, _this2.determineStrategy = function (props) {
          if (props.onSize) {
            if (!_this2.callbackState) {
              _this2.callbackState = _extends({}, _this2.state);
            }
            _this2.strategy = 'callback';
          } else {
            _this2.strategy = 'render';
          }
        }, _this2.strategisedSetState = function (state) {
          if (_this2.strategy === 'callback') {
            _this2.callbackState = state;
            _this2.props.onSize(state);
          }
          _this2.setState(state);
        }, _this2.strategisedGetState = function () {
          return _this2.strategy === 'callback' ? _this2.callbackState : _this2.state;
        }, _this2.refCallback = function (element) {
          _this2.element = element;
        }, _this2.hasSizeChanged = function (current, next) {
          var c = current;
          var n = next;
          var cp = c.position || {};
          var np = n.position || {};

          return monitorWidth && c.width !== n.width || monitorHeight && c.height !== n.height || monitorPosition && (cp.top !== np.top || cp.left !== np.left || cp.bottom !== np.bottom || cp.right !== np.right);
        }, _this2.checkIfSizeChanged = refreshDelayStrategy(refreshRate, function (el) {
          var _el$getBoundingClient = el.getBoundingClientRect(),
              width = _el$getBoundingClient.width,
              height = _el$getBoundingClient.height,
              right = _el$getBoundingClient.right,
              left = _el$getBoundingClient.left,
              top = _el$getBoundingClient.top,
              bottom = _el$getBoundingClient.bottom;

          var next = {
            width: monitorWidth ? width : null,
            height: monitorHeight ? height : null,
            position: monitorPosition ? { right: right, left: left, top: top, bottom: bottom } : null
          };

          if (_this2.hasSizeChanged(_this2.strategisedGetState(), next)) {
            _this2.strategisedSetState(next);
          }
        }), _temp), possibleConstructorReturn(_this2, _ret);
      }

      createClass(SizeAwareComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.detector = resizeDetector(resizeDetectorStrategy);
          this.determineStrategy(this.props);
          this.handleDOMNode();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          this.determineStrategy(this.props);
          this.handleDOMNode();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          // Change our size checker to a noop just in case we have some
          // late running events.
          this.hasSizeChanged = function () {
            return undefined;
          };
          this.checkIfSizeChanged = function () {
            return undefined;
          };
          this.uninstall();
        }
      }, {
        key: 'handleDOMNode',
        value: function handleDOMNode() {
          var found = this.element && ReactDOM.findDOMNode(this.element);

          if (!found) {
            // If we previously had a dom node then we need to ensure that
            // we remove any existing listeners to avoid memory leaks.
            this.uninstall();
            return;
          }

          if (!this.domEl) {
            this.domEl = found;
            this.detector.listenTo(this.domEl, this.checkIfSizeChanged);
          } else if (this.domEl.isSameNode && !this.domEl.isSameNode(found) || this.domEl !== found) {
            this.uninstall();
            this.domEl = found;
            this.detector.listenTo(this.domEl, this.checkIfSizeChanged);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var disablePlaceholder = withSize.enableSSRBehaviour || withSize.noPlaceholders || noPlaceholder || this.strategy === 'callback';

          var size = _extends({}, this.state);

          return React__default.createElement(SizeMeRenderWrapper, _extends({
            explicitRef: this.refCallback,
            size: this.strategy === 'callback' ? null : size,
            disablePlaceholder: disablePlaceholder
          }, this.props));
        }
      }]);
      return SizeAwareComponent;
    }(React__default.Component);

    SizeAwareComponent.displayName = 'SizeMe(' + getDisplayName(WrappedComponent) + ')';
    SizeAwareComponent.propTypes = {
      onSize: PropTypes.func
    };


    SizeAwareComponent.WrappedComponent = WrappedComponent;

    return SizeAwareComponent;
  };
}

/**
 * Allow SizeMe to run within SSR environments.  This is a "global" behaviour
 * flag that should be set within the initialisation phase of your application.
 *
 * Warning: don't set this flag unless you need to as using it may cause
 * extra render cycles to happen within your components depending on the logic
 * contained within them around the usage of the `size` data.
 *
 * DEPRECATED: Please use the global noPlaceholders
 */
withSize.enableSSRBehaviour = false;

/**
 * Global configuration allowing to disable placeholder rendering for all
 * sizeMe components.
 */
withSize.noPlaceholders = false;

var SizeMe = function (_Component) {
  inherits(SizeMe, _Component);

  function SizeMe(props) {
    classCallCheck(this, SizeMe);

    var _this = possibleConstructorReturn(this, (SizeMe.__proto__ || Object.getPrototypeOf(SizeMe)).call(this, props));

    _initialiseProps.call(_this);

    var children = props.children,
        render = props.render,
        sizeMeConfig = objectWithoutProperties(props, ['children', 'render']);

    _this.createComponent(sizeMeConfig);
    _this.state = {
      size: {
        width: undefined,
        height: undefined
      }
    };
    return _this;
  }

  createClass(SizeMe, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          prevChildren = _props.children,
          prevRender = _props.render,
          currentSizeMeConfig = objectWithoutProperties(_props, ['children', 'render']);
      var nextChildren = prevProps.children,
          nextRender = prevProps.render,
          prevSizeMeConfig = objectWithoutProperties(prevProps, ['children', 'render']);

      if (!isShallowEqual(currentSizeMeConfig, prevSizeMeConfig)) {
        this.createComponent(currentSizeMeConfig);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var SizeAware = this.SizeAware;

      var render = this.props.children || this.props.render;
      return React__default.createElement(
        SizeAware,
        { onSize: this.onSize },
        render({ size: this.state.size })
      );
    }
  }]);
  return SizeMe;
}(React.Component);

SizeMe.propTypes = {
  children: PropTypes.func,
  render: PropTypes.func
};
SizeMe.defaultProps = {
  children: undefined,
  render: undefined
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.createComponent = function (config) {
    _this2.SizeAware = withSize(config)(function (_ref) {
      var children = _ref.children;
      return children;
    });
  };

  this.onSize = function (size) {
    return _this2.setState({ size: size });
  };
};

withSize.SizeMe = SizeMe;
withSize.withSize = withSize;

module.exports = withSize;
//# sourceMappingURL=react-sizeme.js.map


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Thermostat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable camelcase */

/* eslint-disable babel/no-invalid-this */

function Thermostat(feature) {
  var _this = this;

  var setHeatAction = feature.actions.set_heat_setpoint;
  var setCoolAction = feature.actions.set_cool_setpoint;
  var setSetpointsAction = feature.actions.set_setpoints;
  var isCelsius = feature.setpoint_increment === 0.5;

  this.setSetpoints = function (setpoints) {
    if (!setpoints.heat && !setpoints.cool) {
      return Promise.reject(new Error("Attempted to set setpoints, but neither a heat setpoint nor a cool setpoint was provided"));
    }

    var action = setSetpointsAction || setHeatAction || setCoolAction;

    if (action == null) {
      return Promise.reject(new Error("Cannot set setpoints on a thermostat with neither a heat action nor a cool action"));
    }

    var stubResponse = {};

    if (setpoints.heat) {
      stubResponse.setpoint_heat = setpoints.heat;
    }

    if (setpoints.cool) {
      stubResponse.setpoint_cool = setpoints.cool;
    } // Some endpoints (xxls, possibly more) don't actually update right away.
    // Set the setpoints where we expect them to be, then hopefully they'll
    // be updated by the next poll cycle.


    _this.set(stubResponse);

    var heatBefore = _this.get("setpoint_heat");

    var coolBefore = _this.get("setpoint_cool");

    return _this.executeDeviceAction(action, setpoints, {
      updateModelWithResponse: false // some endpoints don't return the right data :-(

    }).then(function () {
      if (stubResponse.setpoint_heat !== heatBefore) {
        Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("DEMO_MODE_EVENT", _this, "Heat setpoint set to ".concat(setpoints.heat, "\xB0").concat(isCelsius ? "C" : "F"));
      }

      if (stubResponse.setpoint_cool !== coolBefore) {
        Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("DEMO_MODE_EVENT", _this, "Cool setpoint set to ".concat(setpoints.cool, "\xB0").concat(isCelsius ? "C" : "F"));
      }
    });
  };

  var result = {
    status: feature.status,
    status_icon: feature.status_icon,
    temperature: feature.temperature,
    temperature_scale: isCelsius ? "c" : "f",
    setpoint_delta: feature.setpoint_delta,
    setpoint_increment: feature.setpoint_increment,
    alert_temperature_low: feature.alert_temperature_low,
    alert_temperature_high: feature.alert_temperature_high,
    setpoint_heat: feature.setpoint_heat,
    setpoint_cool: feature.setpoint_cool,
    setpoint_heat_min: feature.setpoint_heat_min || (isCelsius ? 13 : 55),
    setpoint_heat_max: feature.setpoint_heat_max || (isCelsius ? 32 : 90),
    setpoint_cool_min: feature.setpoint_cool_min || (isCelsius ? 16 : 60),
    setpoint_cool_max: feature.setpoint_cool_max || (isCelsius ? 37 : 99)
  };
  return result;
}


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var Heading =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Heading, _React$Component);

  function Heading() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Heading);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Heading).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Heading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          style = _this$props.style,
          colors = _this$props.colors;

      var headingStyle = _objectSpread({
        // from heading.styl in nx_elements
        fontSize: "1.1em",
        textAlign: "left",
        color: colors.TITLE,
        marginBottom: ".5em",
        marginTop: "1em"
      }, style);

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: headingStyle
      }, label);
    }
  }]);

  return Heading;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Heading, "propTypes", {
  label: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["c" /* withColorsProvider */])(Heading));




/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sentryRelease; });
var _WEBPACK_APP_VERSION_2 = {"fullVersion":"1.8.2-44729d32-2212061201","sentryRelease":"1.8.2-44729d32"},
    fullVersion = _WEBPACK_APP_VERSION_2.fullVersion,
    sentryRelease = _WEBPACK_APP_VERSION_2.sentryRelease;
/* harmony default export */ __webpack_exports__["a"] = (fullVersion);


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_parseIconsFromServer__ = __webpack_require__(83);
/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/



var Icons = {
  getString: function getString(icon) {
    if (icon == null) {
      return "";
    }

    var icons = Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_parseIconsFromServer__["a" /* default */])(icon);

    if (icons.length === 0) {
      return "";
    }

    var _icons$ = icons[0],
        name = _icons$.name,
        modifiers = _icons$.modifiers;

    if (modifiers.length > 0) {
      return "".concat(name, " ").concat(modifiers.join(" "));
    } else {
      return name;
    }
  },
  getIconModifiers: function getIconModifiers(icon) {
    if (icon == null) {
      return [];
    }

    var icons = Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_parseIconsFromServer__["a" /* default */])(icon);

    if (icons.length === 0) {
      return [];
    }

    return icons[0].modifiers;
  },
  getBatteryLevelIcon: function getBatteryLevelIcon(level) {
    if (level > 75) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["b" /* IconBatteryFull */], null);
    }

    if (level > 30) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["d" /* IconBatteryMostlyFull */], null);
    }

    if (level > 1) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["c" /* IconBatteryLow */], {
        modifiers: ["alert"]
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["a" /* IconBatteryEmpty */], null);
  },
  getLightLevelIcon: function getLightLevelIcon(level) {
    if (level === 0) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_1" /* IconLightbulb0 */], null);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_2" /* IconLightbulb100 */], null);
  },
  getWindowCoveringLevelIcon: function getWindowCoveringLevelIcon(percentage) {
    if (percentage >= 97) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["e" /* IconBlindsClosed */], null);
    }

    if (percentage >= 67) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["g" /* IconBlindsMostlyClosed */], null);
    }

    if (percentage >= 34) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["f" /* IconBlindsHalfOpen */], null);
    }

    if (percentage >= 4) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["h" /* IconBlindsMostlyOpen */], null);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["i" /* IconBlindsOpen */], null);
  },
  getVolumeIcon: function getVolumeIcon(volume) {
    if (volume > 75) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_53" /* IconVolumeHigh */], null);
    }

    if (volume > 30) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_55" /* IconVolumeMedium */], null);
    }

    if (volume > 0) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_54" /* IconVolumeLow */], null);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_56" /* IconVolumeMute */], null);
  },
  getEventDescriptionIcon: function getEventDescriptionIcon(initialDescription) {
    if (typeof initialDescription !== "string") {
      return null;
    }

    var description = initialDescription.toLowerCase();

    if (description.match(/battery/)) {
      var matches = description.match(/battery level: (\d+)%/);

      if (matches) {
        return this.getBatteryLevelIcon(parseInt(matches[1]));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["b" /* IconBatteryFull */], null);
    }

    if (description.match(/automation/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_57" /* IconWand */], null);
    }

    if (description.match(/rachio/)) {
      if (description.match(/^water(ed|ing)|started manual schedule/)) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_59" /* IconWaterDrop */], null);
      }

      if (description.match(/^stopped manual schedule/)) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_60" /* IconWaterDropOff */], null);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_22" /* IconRachioLogo */], null);
    }

    if (description.match(/unlocked/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_49" /* IconUnlocked */], null);
    }

    if (description.match(/locked/) || description.match(/activated/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_5" /* IconLocked */], null);
    }

    if (description.match(/new temperature/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_40" /* IconThermostat */], null);
    }

    if (description.match(/cool setpoint/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_37" /* IconSnowflake */], null);
    }

    if (description.match(/heat setpoint/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["Q" /* IconFire */], null);
    }

    if (description.match(/humidity/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["J" /* IconDroplets */], null);
    }

    if (description.match(/turned off/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["Z" /* IconLightSwitchOff */], null);
    }

    if (description.match(/turned on/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_0" /* IconLightSwitchOn */], null);
    }

    if (description.match(/camera disconnected/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["l" /* IconCameraDisconnected */], null);
    }

    if (description.match(/camera connected/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["k" /* IconCamera */], null);
    }

    if (description.match(/signal report/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_61" /* IconWifi */], null);
    }

    if (description.match(/smoke detected/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_35" /* IconSmokeDetectorTriggered */], null);
    }

    if (description.match(/smoke cleared/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_34" /* IconSmokeDetector */], null);
    }

    if (description.match(/no .* detected/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["p" /* IconCheck */], null);
    }

    if (description.match(/tamper|alarm|motion|water/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_58" /* IconWarning */], null);
    }

    if (description.match(/reset/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_23" /* IconRefresh */], null);
    }

    if (description.match(/triggered/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_3" /* IconLightning */], null);
    }

    if (description.match(/changed.*mode/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["M" /* IconEqualizer */], null);
    }

    if (description.match(/set to play/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_18" /* IconPlay */], null);
    }

    if (description.match(/set to pause/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_11" /* IconPause */], null);
    }

    var volumeMatches = description.match(/volume set to (\d+)%/);

    if (volumeMatches) {
      return this.getVolumeIcon(parseInt(volumeMatches[1]));
    }

    var windowCoveringClosedMatches = description.match(/set to (\d+)% closed/);

    if (windowCoveringClosedMatches) {
      return this.getWindowCoveringLevelIcon(parseInt(windowCoveringClosedMatches[1]));
    }

    var windowCoveringOpenMatches = description.match(/set to (\d+)% open/);

    if (windowCoveringOpenMatches) {
      return this.getWindowCoveringLevelIcon(100 - parseInt(windowCoveringOpenMatches[1]));
    }

    var lightMatches = description.match(/set to (\d+)%/);

    if (lightMatches) {
      return this.getLightLevelIcon(parseInt(lightMatches[1]));
    }

    if (description.match(/editcontact/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_12" /* IconPencil */], null);
    }

    if (description.match(/deletecontact/)) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["_24" /* IconRemove */], {
        style: {
          color: "E2231A"
        }
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_nx_components_Icons__["p" /* IconCheck */], null);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Icons);

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.9.1
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if (typeof exports != 'undefined' && !exports.nodeType) {
    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.1';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var has = function(obj, path) {
    return obj != null && hasOwnProperty.call(obj, path);
  }

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return has(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(96)(module)))

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VALIDATION_PATTERNS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_reflection__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__ = __webpack_require__(44);


var VALIDATION_PATTERNS = {
  email: /^(['+\-.\w]+)@((\w[+\-.\w]*)\.[\w]{2,})$/,
  number: /\d+/,
  // US 5+4 and CAN postal validation
  postal: /(^\d{5}$)|(^\d{5}\s{0,}-?\s{0,}\d{4}$)|(^[a-ceghj-npr-tvxy]\d[a-ceghj-npr-tv-z]\s{0,}-?\s{0,}\d[a-ceghj-npr-tv-z]\d$)/i
};
/* harmony default export */ __webpack_exports__["b"] = ({
  _validateAttributes: function _validateAttributes(attrs) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var language = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["b" /* getLanguageSet */])().nexia_mobile.validatable;
    var validationDefs = __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_reflection__["a" /* default */].evaluate(this.validations, this);
    this._validationErrors = {};
    this._validatedAttributes = {}; // we can skip validations based on the attribute name

    var _shouldValidate;

    if (options.validateOnly != null) {
      if (options.validateOnly instanceof RegExp) {
        _shouldValidate = function _shouldValidate(attr) {
          return options.validateOnly.test(attr);
        };
      } else if (_.isArray(options.validateOnly)) {
        _shouldValidate = function _shouldValidate(attr) {
          return _.contains(options.validateOnly, attr);
        };
      } else if (_.isString(options.validateOnly)) {
        _shouldValidate = function _shouldValidate(attr) {
          return options.validateOnly === attr;
        };
      } else if (_.isFunction(options.validateOnly)) {
        _shouldValidate = options.validateOnly;
      }
    }

    _shouldValidate = _shouldValidate || function () {
      return true;
    }; // create of map of fields whose validations depend on other fields


    var validationDependency = {};
    /* eslint-disable guard-for-in */

    for (var attr in validationDefs) {
      var validation = validationDefs[attr];

      if (_.isString(validation.equalTo)) {
        validationDependency[attr] = validation.equalTo;
        validationDependency[validation.equalTo] = attr;
      }
    }
    /* eslint-enable guard-for-in */
    // now run each validation

    /* eslint-disable guard-for-in */


    for (var _attr in validationDefs) {
      var _validation = validationDefs[_attr];

      var hasDependency = validationDependency[_attr] != null && _shouldValidate(validationDependency[_attr]);

      if (!_shouldValidate(_attr) && !hasDependency) {
        continue;
      }

      this._validatedAttributes[_attr] = true; // get the value to be validated

      var value = __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_reflection__["a" /* default */].getNestedAttribute(attrs, _attr); // run a custom validator

      if (_.isFunction(_validation)) {
        _validation = {
          fn: _validation
        };
      }

      if (_.isString(_validation.fn)) {
        _validation.fn = this[_validation.fn];
      }

      if (_.isFunction(_validation.fn)) {
        var message = _validation.fn.call(this, value, _attr);

        if (_.isString(message)) {
          this._addValidationError(_attr, message);
        }

        continue;
      } // determine label to use for error messages


      var label = __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_reflection__["a" /* default */].evaluate(_validation.label, this);
      var errorLabel = __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_reflection__["a" /* default */].evaluate(_validation.errorLabel, this);
      label = errorLabel || label || _attr; // A specifcially-tailored message for required fields

      var requiredMessage = __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_reflection__["a" /* default */].evaluate(_validation.requiredMessage, this); // deal with required attributes

      var required = __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_reflection__["a" /* default */].evaluate(_validation.required, this);
      required = required != null ? required : false;

      if (required) {
        if (value == null || _validation.type && _validation.type === "boolean" && value === false || _.isString(value) && _.str.isBlank(value)) {
          this._addValidationError(_attr, requiredMessage || Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelRequiredTemplate, {
            label: label
          }));

          continue;
        }
      } // equality with another field


      if (_.isString(_validation.equalTo)) {
        if (value !== __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_reflection__["a" /* default */].getNestedAttribute(attrs, _validation.equalTo)) {
          this._addValidationError(_attr, Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelDoesNotMatchTemplate, {
            label: label
          }));
        }
      }

      if (!required && (value == null || value.toString().trim() === "")) {
        // If the field is not required, it is allowed to be empty even if that fails other validations
        continue;
      } // test against regexes


      if (_.isString(_validation.patternType)) {
        _validation.pattern = VALIDATION_PATTERNS[_validation.patternType];
      }

      if (_.isString(_validation.pattern)) {
        _validation.pattern = new RegExp(_validation.pattern);
      }

      var stringValue = (value != null ? value : "").toString();

      if (_validation.pattern instanceof RegExp) {
        if (!stringValue.match(_validation.pattern)) {
          this._addValidationError(_attr, _validation.message || Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelInvalidTemplate, {
            label: label
          }));
        }
      } // string length


      if (_.isNumber(_validation.length)) {
        if (!_.isString(value) || value.length !== _validation.length) {
          this._addValidationError(_attr, Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelExactLengthCharsTemplate, {
            label: label,
            fieldLength: _validation.length
          }));
        }
      }

      if (_.isNumber(_validation.minLength)) {
        if (!_.isString(value) || value.length < _validation.minLength) {
          this._addValidationError(_attr, Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelMinLengthCharsTemplate, {
            label: label,
            fieldMax: _validation.minLength
          }));
        }
      }

      if (_.isNumber(_validation.maxLength)) {
        if (_.isString(value) && value.length > _validation.maxLength) {
          this._addValidationError(_attr, Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelMaxLengthCharsTemplate, {
            label: label,
            fieldMaxLength: _validation.maxLength
          }));
        }
      } // numerical values


      if (_.isNumber(_validation.min)) {
        if (value < _validation.min) {
          this._addValidationError(_attr, Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelMinNumberTemplate, {
            label: label,
            fieldMin: _validation.min
          }));
        }
      }

      if (_.isNumber(_validation.max)) {
        if (value > _validation.max) {
          this._addValidationError(_attr, Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelMaxNumberTemplate, {
            label: label,
            fieldMax: _validation.max
          }));
        }
      }
    }
    /* eslint-enable guard-for-in */


    if (!_.isEmpty(this._validationErrors)) {
      return this._validationErrors;
    } else {
      return null;
    }
  },
  _addValidationError: function _addValidationError(attr, message) {
    this._validationErrors[attr] = this._validationErrors[attr] || [];

    this._validationErrors[attr].push(message);
  },
  wasAttributeValidated: function wasAttributeValidated(attr) {
    if (this._validatedAttributes != null) {
      return this._validatedAttributes[attr] != null;
    } else {
      return false;
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(176),
    isObject = __webpack_require__(169);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/nexia_logo-44729d32-pivot.svg";

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/trane_commercial_logo-44729d32-pivot.svg";

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPendingPromiseForRefreshLocationAndReturnToDashboard;
/* unused harmony export getPendingPromiseForRefreshLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_history__ = __webpack_require__(31);



__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("LOCATION_CHANGE", function (location) {
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("appState.currentLocation", location);
});

var handleReturnToDashboard = function handleReturnToDashboard() {
  Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app/home");
};

var newPromiseRefreshLocation = function newPromiseRefreshLocation(handlerToDashboard) {
  var devices = __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState.currentLocation.get("devices");
  return new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState.currentLocation.fetch({
      success: function success() {
        var finishRefresh = _.once(function () {
          resolve();

          if (handlerToDashboard) {
            handlerToDashboard();
          }
        }); // The response is parsed asynchronously, wait until devices actually update.


        devices.once("update", finishRefresh); // but if they never do, still hide the spinner 10 seconds after the fetch finishes

        setTimeout(finishRefresh, 10000);
      }
    });
  });
};

var returnToDashboardPromise = Promise.resolve();
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("REFRESH_LOCATION_AND_RETURN_TO_DASHBOARD", function () {
  if (!__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState && !__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState.currentLocation) {
    return;
  }

  returnToDashboardPromise = newPromiseRefreshLocation(handleReturnToDashboard);
}); // TODO: Better answer for async actions (probably won't have it until we're using redux)

function getPendingPromiseForRefreshLocationAndReturnToDashboard() {
  return returnToDashboardPromise;
}
var pendingRefreshLocation = Promise.resolve();
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("REFRESH_LOCATION", function () {
  if (!__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState && !__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState.currentLocation) {
    return;
  }

  pendingRefreshLocation = newPromiseRefreshLocation();
}); // TODO: Better answer for async actions (probably won't have it until we're using redux)

function getPendingPromiseForRefreshLocation() {
  return pendingRefreshLocation;
}
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("LOCATION_UNREGISTER_THIRDPARTY", function (href) {
  var location = __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState.currentLocation;
  location.unregisterThirdParty(href).then(function () {
    if (location !== __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState.currentLocation) {
      return;
    }

    location.fetch();
  });
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = safelyOpen;
function safelyOpen(href) {
  // window.open() has an opener, which can't be removed in Safari. Instead,
  // create an anchor tag to add rel="noopenner noreferrer"
  var openTag = document.createElement("a");
  openTag.href = href;
  openTag.target = "_blank";
  openTag.rel = "noopener noreferrer";
  openTag.dispatchEvent(new MouseEvent("click", {
    bubbles: true,
    cancelable: true,
    view: window
  }));
}

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = updateHeatSetpoint;
/* harmony export (immutable) */ __webpack_exports__["a"] = updateCoolSetpoint;
/* unused harmony export bpfrpt_proptype_SetpointProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_SetpointProps = {
  setpointCool: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  setpointCoolMax: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  setpointCoolMin: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  setpointDelta: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  setpointHeat: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  setpointHeatMax: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  setpointHeatMin: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
};
function updateHeatSetpoint(info, targetHeatSetpoint) {
  var nextState = {};
  var clampedHeatSetpoint = clampHeatSetpoint(info, targetHeatSetpoint);
  nextState.setpointHeat = clampedHeatSetpoint;

  if (getMode(info) === "auto") {
    if (info.setpointCool == null) {
      return nextState; // for Flow
    }

    var setpointDifference = info.setpointCool - clampedHeatSetpoint;

    if (setpointDifference < info.setpointDelta) {
      var necessaryAdjustment = info.setpointDelta - setpointDifference;
      var targetCoolsetpoint = info.setpointCool + necessaryAdjustment;
      var clampedCoolSetpoint = clampCoolSetpoint(info, targetCoolsetpoint);
      nextState.setpointCool = clampedCoolSetpoint;
    }
  }

  return nextState;
}
function updateCoolSetpoint(info, targetCoolSetpoint) {
  var nextState = {};
  var clampedCoolSetpoint = clampCoolSetpoint(info, targetCoolSetpoint);
  nextState.setpointCool = clampedCoolSetpoint;

  if (getMode(info) === "auto") {
    if (info.setpointHeat == null) {
      return nextState; // for Flow
    }

    var setpointDifference = clampedCoolSetpoint - info.setpointHeat;

    if (setpointDifference < info.setpointDelta) {
      var necessaryAdjustment = info.setpointDelta - setpointDifference;
      var targetHeatSetpoint = info.setpointHeat - necessaryAdjustment;
      var clampedHeatValue = clampHeatSetpoint(info, targetHeatSetpoint);
      nextState.setpointHeat = clampedHeatValue;
    }
  }

  return nextState;
}

function getMode(info) {
  var setpointHeat = info.setpointHeat,
      setpointCool = info.setpointCool;

  if (setpointHeat && !setpointCool) {
    return "heat";
  } else if (setpointCool && !setpointHeat) {
    return "cool";
  } else if (setpointCool && setpointHeat) {
    return "auto";
  } else {
    return "off";
  }
}

function clampCoolSetpoint(info, value) {
  var min = info.setpointCoolMin || value;
  var max = info.setpointCoolMax || value;
  return Math.max(min, Math.min(max, value));
}

function clampHeatSetpoint(info, value) {
  var min = info.setpointHeatMin || value;
  var max = info.setpointHeatMax || value;
  return Math.max(min, Math.min(max, value));
}




/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_debounce__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ItemList__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FormError__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FormFieldIcons_InfoIcon__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FormFieldIcons_RevealPasswordIcon__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/










var FORM_FIELD_HEIGHT = "48px";

var InputField =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(InputField, _React$Component);

  function InputField() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, InputField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(InputField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      type: _this.props.type || ""
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_captureRef", function (el) {
      _this._input = el;

      if (_this.props.captureRef) {
        _this.props.captureRef(el);
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleKeyUp", function (event) {
      var enterKeycode = 13;

      if (event.keyCode === enterKeycode) {
        if (_this._input) {
          _this._input.blur();
        }

        if (_this.props.onEnterPressed) {
          _this.props.onEnterPressed();
        }
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleFocus", function () {
      _this._debounceFocus();

      if (_this.props.shouldScrollIntoView) {
        // Android resizes the window AFTER the keybaord appears, so sometimes scrolling doesn't work
        // https://stackoverflow.com/questions/23757345/android-does-not-correctly-scroll-on-input-focus-if-not-body-element
        if (_this._scrollToField) {
          window.removeEventListener("resize", _this._scrollToField);
        }

        _this._scrollToField = function () {
          window.setTimeout(function () {
            if (!_this._input || document.activeElement !== _this._input) {
              return;
            } // scrollIntoView is largely supported but the options are not.
            // This will try to center the field or will scroll to the top by default.
            // $FlowIgnore


            _this._input.scrollIntoView({
              block: "center"
            });
          }, 0);
        };

        window.addEventListener("resize", _this._scrollToField);
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_debounceFocus", __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default()(function () {
      _this._debouncedFocused = true; // The 100ms here is racing the amount of time it takes the mobile
      // browser to process an event which changes focus (eg click).
    }, 100));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleBlur", function () {
      _this._debounceBlur();

      window.removeEventListener("resize", _this._scrollToField);
      _this._scrollToField = null;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_debounceBlur", __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default()(function () {
      _this._debouncedFocused = false; // The 100ms here is racing the amount of time it takes the mobile
      // browser to process an event which changes focus (eg click).
    }, 100));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleRevealPassword", function () {
      var type = _this.state.type;

      _this.setState({
        type: type === "password" ? "text" : "password"
      }, function () {
        if (_this._debouncedFocused && _this._input) {
          // In the situation where the input field is focused and you tap on
          // the reveal password icon, the software keyboard hides, because
          // the password icon is the active element now, instead of the input.
          // This is annoying, so re-focus the input so that the software keyboard
          // remains open.
          _this._input.focus();
        }
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(InputField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        if (this._input) {
          this._input.focus();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alignInputLeft = _this$props.alignInputLeft,
          error = _this$props.error,
          hasLeftLabel = _this$props.hasLeftLabel,
          infoIcon = _this$props.infoIcon,
          infoText = _this$props.infoText,
          label = _this$props.label,
          max = _this$props.max,
          maxLength = _this$props.maxLength,
          min = _this$props.min,
          name = _this$props.name,
          onChange = _this$props.onChange,
          pType = _this$props.type,
          value = _this$props.value,
          colors = _this$props.colors;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["b" /* default */])({
        wrapper: {
          marginLeft: "0",
          marginRight: "0",
          position: "relative",
          background: "white",
          color: colors.TEXT
        },
        fieldWrapper: {
          display: "flex",
          flexWrap: "wrap",
          alignItems: "stretch",
          boxSizing: "border-box",
          backgroundColor: "white"
        },
        label: {
          flex: "0 0 auto",
          paddingLeft: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.CONTENT,
          paddingTop: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.CONTENT,
          paddingBottom: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.CONTENT,
          display: "flex",
          alignItems: "center",
          maxWidth: "100%" // Allows long labels to word-wrap

        },
        floatingIcons: {
          // These are floating on top of the input instead of beside it
          // because we want them to appear "inside" the input when Chrome
          // autocomplete colors the input yellow, or when the input field is
          // focused by a screen reader and the bounds rectangle is visible, etc.
          position: "absolute",
          right: "0",
          bottom: "0",
          // Matching height here instead of using top: 0 because when a form error
          // appears, we only want to float the icons over the input, not the error
          // part.
          height: FORM_FIELD_HEIGHT,
          display: "inline-flex",
          alignItems: "center",
          paddingRight: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.CONTENT
        }
      });
      var revealPassword = false;
      var type = this.state.type;

      if (pType === "password") {
        revealPassword = true;
      }

      var hasClickableIcons = infoIcon || revealPassword;
      var hasIcons = hasClickableIcons || hasLeftLabel;
      var numIcons = [infoIcon, revealPassword, hasLeftLabel].filter(Boolean).length;
      var formFieldStyle = {
        WebkitAppearance: "none",
        // the apple system font has ridiculous password dots. Users shouldn't notice the flash of sans-serif isn't technically San Francisco
        fontFamily: type === "password" ? "sans-serif" : "inherit",
        fontWeight: "inherit",
        color: "inherit",
        backgroundColor: "white",
        border: "none",
        borderRadius: "0",
        margin: "0",
        paddingRight: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.CONTENT + numIcons * 25,
        // 25 extra px per icon
        paddingLeft: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.CONTENT,
        fontSize: "1em",
        width: "100%",
        minWidth: "12em",
        minHeight: "calc(2 * ".concat(__WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.CONTENT, "px + 1.2em)"),
        // 1.2em is roughly line-height: normal. This prevents fields with empty values from collapsing
        height: FORM_FIELD_HEIGHT,
        flex: "1 1 10em",
        textOverflow: "ellipsis",
        textAlign: alignInputLeft || !hasLeftLabel ? "" : "right"
      };
      var iconSpacing = __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: {
          paddingRight: "10px"
        }
      });
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.wrapper
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__FormError__["b" /* default */], {
        error: error
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.fieldWrapper
      }, hasLeftLabel ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("label", {
        htmlFor: name,
        style: styles.label
      }, label) : null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("input", {
        ref: this._captureRef,
        type: type,
        name: name,
        style: formFieldStyle,
        placeholder: hasLeftLabel ? null : label,
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        spellCheck: "false",
        maxLength: maxLength,
        min: min,
        max: max,
        pattern: type === "number" ? "[0-9]*" : undefined,
        value: value,
        onChange: onChange,
        onKeyUp: this._handleKeyUp,
        onFocus: this._handleFocus,
        onBlur: this._handleBlur
      })), hasIcons ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: _objectSpread({}, styles.floatingIcons, {
          pointerEvents: hasClickableIcons ? "" : "none"
        })
      }, hasLeftLabel ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Icons__["_12" /* IconPencil */], null) : null, revealPassword || infoIcon ? iconSpacing : null, revealPassword ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__FormFieldIcons_RevealPasswordIcon__["a" /* default */], {
        type: type,
        onClick: this._handleRevealPassword
      }) : null, revealPassword && infoIcon ? iconSpacing : null, infoIcon ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__FormFieldIcons_InfoIcon__["a" /* default */], {
        dialogText: infoText
      }) : null) : null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ItemList__["a" /* Divider */], null)));
    }
  }]);

  return InputField;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(InputField, "defaultProps", {
  value: ""
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(InputField, "propTypes", {
  alignInputLeft: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.bool,
  captureRef: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func,
  error: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.string,
  hasLeftLabel: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.bool,
  infoIcon: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.bool,
  infoText: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.string,
  max: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.number,
  maxLength: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.number,
  name: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.string.isRequired,
  onEnterPressed: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func,
  shouldScrollIntoView: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.bool,
  type: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.oneOf(["date", "email", "number", "password", "text", "time", "tel"]).isRequired,
  value: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.number]),
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["c" /* withColorsProvider */])(InputField));



/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(503),
    isLength = __webpack_require__(327);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 327 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE={id:"1.8.2-44729d32"};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(33) && !__webpack_require__(25)(function () {
  return Object.defineProperty(__webpack_require__(229)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(29);


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(60);
var toIObject = __webpack_require__(62);
var arrayIndexOf = __webpack_require__(179)(false);
var IE_PROTO = __webpack_require__(231)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(38);
var anObject = __webpack_require__(19);
var getKeys = __webpack_require__(113);

module.exports = __webpack_require__(33) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(62);
var gOPN = __webpack_require__(116).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(33);
var getKeys = __webpack_require__(113);
var gOPS = __webpack_require__(180);
var pIE = __webpack_require__(155);
var toObject = __webpack_require__(39);
var IObject = __webpack_require__(154);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(25)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(50);
var isObject = __webpack_require__(26);
var invoke = __webpack_require__(337);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 337 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(21).parseInt;
var $trim = __webpack_require__(136).trim;
var ws = __webpack_require__(235);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(21).parseFloat;
var $trim = __webpack_require__(136).trim;

module.exports = 1 / $parseFloat(__webpack_require__(235) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(68);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(26);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 342 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(238);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(19);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(50);
var toObject = __webpack_require__(39);
var IObject = __webpack_require__(154);
var toLength = __webpack_require__(30);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(39);
var toAbsoluteIndex = __webpack_require__(114);
var toLength = __webpack_require__(30);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(250);
__webpack_require__(8)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(33) && /./g.flags != 'g') __webpack_require__(38).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(156)
});


/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var isObject = __webpack_require__(26);
var newPromiseCapability = __webpack_require__(254);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(353);
var validate = __webpack_require__(121);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(188)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(38).f;
var create = __webpack_require__(115);
var redefineAll = __webpack_require__(120);
var ctx = __webpack_require__(67);
var anInstance = __webpack_require__(118);
var forOf = __webpack_require__(119);
var $iterDefine = __webpack_require__(240);
var step = __webpack_require__(347);
var setSpecies = __webpack_require__(117);
var DESCRIPTORS = __webpack_require__(33);
var fastKey = __webpack_require__(100).fastKey;
var validate = __webpack_require__(121);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(353);
var validate = __webpack_require__(121);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(188)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(21);
var each = __webpack_require__(78)(0);
var redefine = __webpack_require__(55);
var meta = __webpack_require__(100);
var assign = __webpack_require__(334);
var weak = __webpack_require__(356);
var isObject = __webpack_require__(26);
var validate = __webpack_require__(121);
var NATIVE_WEAK_MAP = __webpack_require__(121);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(188)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(120);
var getWeak = __webpack_require__(100).getWeak;
var anObject = __webpack_require__(19);
var isObject = __webpack_require__(26);
var anInstance = __webpack_require__(118);
var forOf = __webpack_require__(119);
var createArrayMethod = __webpack_require__(78);
var $has = __webpack_require__(60);
var validate = __webpack_require__(121);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(69);
var toLength = __webpack_require__(30);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(116);
var gOPS = __webpack_require__(180);
var anObject = __webpack_require__(19);
var Reflect = __webpack_require__(21).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(8);
var $includes = __webpack_require__(179)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(101)('includes');


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(181);
var isObject = __webpack_require__(26);
var toLength = __webpack_require__(30);
var ctx = __webpack_require__(67);
var IS_CONCAT_SPREADABLE = __webpack_require__(29)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(8);
var $pad = __webpack_require__(362);
var userAgent = __webpack_require__(187);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(30);
var repeat = __webpack_require__(237);
var defined = __webpack_require__(76);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(8);
var $pad = __webpack_require__(362);
var userAgent = __webpack_require__(187);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(8);
var ownKeys = __webpack_require__(358);
var toIObject = __webpack_require__(62);
var gOPD = __webpack_require__(63);
var createProperty = __webpack_require__(245);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(8);
var $values = __webpack_require__(366)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(33);
var getKeys = __webpack_require__(113);
var toIObject = __webpack_require__(62);
var isEnum = __webpack_require__(155).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(8);
var $entries = __webpack_require__(366)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(39);
var aFunction = __webpack_require__(50);
var $defineProperty = __webpack_require__(38);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(33) && $export($export.P + __webpack_require__(190), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(39);
var aFunction = __webpack_require__(50);
var $defineProperty = __webpack_require__(38);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(33) && $export($export.P + __webpack_require__(190), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(39);
var toPrimitive = __webpack_require__(75);
var getPrototypeOf = __webpack_require__(64);
var getOwnPropertyDescriptor = __webpack_require__(63).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(33) && $export($export.P + __webpack_require__(190), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(39);
var toPrimitive = __webpack_require__(75);
var getPrototypeOf = __webpack_require__(64);
var getOwnPropertyDescriptor = __webpack_require__(63).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(33) && $export($export.P + __webpack_require__(190), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(135);
var from = __webpack_require__(373);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(119);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 374 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function isBlank(str) {
  return (/^\s*$/).test(makeString(str));
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function decapitalize(str) {
  str = makeString(str);
  return str.charAt(0).toLowerCase() + str.slice(1);
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function escapeRegExp(str) {
  return makeString(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {


var makeString = __webpack_require__(22);

var from  = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșşšŝťțţŭùúüűûñÿýçżźž',
  to    = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssstttuuuuuunyyczzz';

from += from.toUpperCase();
to += to.toUpperCase();

to = to.split('');

// for tokens requireing multitoken output
from += 'ß';
to.push('ss');


module.exports = function cleanDiacritics(str) {
  return makeString(str).replace(/.{1}/g, function(c){
    var index = from.indexOf(c);
    return index === -1 ? c : to[index];
  });
};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var chars = __webpack_require__(258);

module.exports = function splice(str, i, howmany, substr) {
  var arr = chars(str);
  arr.splice(~~i, ~~howmany, substr);
  return arr.join('');
};


/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = function toPositive(number) {
  return number < 0 ? 0 : (+number || 0);
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function adjacent(str, direction) {
  str = makeString(str);
  if (str.length === 0) {
    return '';
  }
  return str.slice(0, -1) + String.fromCharCode(str.charCodeAt(str.length - 1) + direction);
};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(88);
var decap = __webpack_require__(376);

module.exports = function camelize(str, decapitalize) {
  str = trim(str).replace(/[-_\s]+(.)?/g, function(match, c) {
    return c ? c.toUpperCase() : '';
  });

  if (decapitalize === true) {
    return decap(str);
  } else {
    return str;
  }
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(88);

module.exports = function underscored(str) {
  return trim(str).replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(88);

module.exports = function dasherize(str) {
  return trim(str).replace(/([A-Z])/g, '-$1').replace(/[-_\s]+/g, '-').toLowerCase();
};


/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports = function strRepeat(str, qty){
  if (qty < 1) return '';
  var result = '';
  while (qty > 0) {
    if (qty & 1) result += str;
    qty >>= 1, str += str;
  }
  return result;
};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* global window, exports, define */

!function() {
    'use strict'

    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    }

    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments)
    }

    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []))
    }

    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
        for (i = 0; i < tree_length; i++) {
            if (typeof parse_tree[i] === 'string') {
                output += parse_tree[i]
            }
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i] // convenience purposes only
                if (ph.keys) { // keyword argument
                    arg = argv[cursor]
                    for (k = 0; k < ph.keys.length; k++) {
                        if (arg == undefined) {
                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
                        }
                        arg = arg[ph.keys[k]]
                    }
                }
                else if (ph.param_no) { // positional argument (explicit)
                    arg = argv[ph.param_no]
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++]
                }

                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
                    arg = arg()
                }

                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
                }

                if (re.number.test(ph.type)) {
                    is_positive = arg >= 0
                }

                switch (ph.type) {
                    case 'b':
                        arg = parseInt(arg, 10).toString(2)
                        break
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10))
                        break
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10)
                        break
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
                        break
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
                        break
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
                        break
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
                        break
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8)
                        break
                    case 's':
                        arg = String(arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 't':
                        arg = String(!!arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0
                        break
                    case 'v':
                        arg = arg.valueOf()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16)
                        break
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
                        break
                }
                if (re.json.test(ph.type)) {
                    output += arg
                }
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-'
                        arg = arg.toString().replace(re.sign, '')
                    }
                    else {
                        sign = ''
                    }
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
                    pad_length = ph.width - (sign + arg).length
                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
                }
            }
        }
        return output
    }

    var sprintf_cache = Object.create(null)

    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
            return sprintf_cache[fmt]
        }

        var _fmt = fmt, match, parse_tree = [], arg_names = 0
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree.push(match[0])
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree.push('%')
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1
                    var field_list = [], replacement_field = match[2], field_match = []
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1])
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else {
                                throw new SyntaxError('[sprintf] failed to parse named argument key')
                            }
                        }
                    }
                    else {
                        throw new SyntaxError('[sprintf] failed to parse named argument key')
                    }
                    match[2] = field_list
                }
                else {
                    arg_names |= 2
                }
                if (arg_names === 3) {
                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
                }

                parse_tree.push(
                    {
                        placeholder: match[0],
                        param_no:    match[1],
                        keys:        match[2],
                        sign:        match[3],
                        pad_char:    match[4],
                        align:       match[5],
                        width:       match[6],
                        precision:   match[7],
                        type:        match[8]
                    }
                )
            }
            else {
                throw new SyntaxError('[sprintf] unexpected placeholder')
            }
            _fmt = _fmt.substring(match[0].length)
        }
        return sprintf_cache[fmt] = parse_tree
    }

    /**
     * export to either browser or node.js
     */
    /* eslint-disable quote-props */
    if (true) {
        exports['sprintf'] = sprintf
        exports['vsprintf'] = vsprintf
    }
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf
        window['vsprintf'] = vsprintf

        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                return {
                    'sprintf': sprintf,
                    'vsprintf': vsprintf
                }
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
        }
    }
    /* eslint-enable quote-props */
}(); // eslint-disable-line


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var rtrim = __webpack_require__(259);

module.exports = function toSentence(array, separator, lastSeparator, serial) {
  separator = separator || ', ';
  lastSeparator = lastSeparator || ' and ';
  var a = array.slice(),
    lastMember = a.pop();

  if (array.length > 2 && serial) lastSeparator = rtrim(separator) + lastSeparator;

  return a.length ? a.join(separator) + lastSeparator + lastMember : lastMember;
};


/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports = function surround(str, wrapper) {
  return [wrapper, str, wrapper].join('');
};


/***/ }),
/* 389 */
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null
      ? value instanceof Error ? stringifyError(value) : value
      : replacer.call(this, key, value);
  };
}


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_utils_enqueueIn__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_framework_reflection__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_framework_validatable__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_framework_collection__ = __webpack_require__(158);











 // We want to loop over prototype properties on purpose

/* eslint-disable guard-for-in */

var Model =
/*#__PURE__*/
function (_Backbone$Model) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Model, _Backbone$Model);

  function Model() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Model);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Model)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this._initNestedObjects();

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Model, [{
    key: "set",
    value: function set() {
      var key = arguments.length <= 0 ? undefined : arguments[0];
      var val = arguments.length <= 1 ? undefined : arguments[1];
      var options = arguments.length <= 2 ? undefined : arguments[2];

      if (key === null) {
        return this;
      }

      var attrs;

      if (_.isObject(key)) {
        attrs = key;
        options = val;
      } else {
        attrs = {};
        attrs[key] = val;
      }

      if (typeof options === "undefined" || options === null) {
        options = {};
      }

      if (!options.ignoreNestedObjects) {
        for (var name in this._nestedModels) {
          var model = this._nestedModels[name];

          if (_.has(attrs, name)) {
            model.set(model.parse(attrs[name]));
            attrs[name] = model;
          }
        }

        for (var _name in this._nestedCollections) {
          var collection = this._nestedCollections[_name];

          if (_.has(attrs, _name)) {
            var models = collection.parse(attrs[_name]);

            if (models instanceof __WEBPACK_IMPORTED_MODULE_7_backbone___default.a.Collection) {
              var _models = models;
              models = _models.models;
            }

            collection.set(models);
            attrs[_name] = collection;
          }
        }
      }

      return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Model.prototype), "set", this).call(this, attrs, options);
    }
  }, {
    key: "parse",
    value: function parse(attrs, options) {
      var _this2 = this;

      this._initNestedObjects();

      if (options && options.hasOwnProperty("asyncParseDelay")) {
        return new Promise(function (resolve) {
          Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_utils_enqueueIn__["b" /* default */])(function () {
            resolve(_this2.onParse(attrs, options));
          }, options.asyncParseDelay);
        });
      } else {
        return this.onParse(attrs, options);
      }
    }
  }, {
    key: "onParse",
    value: function onParse(attrs) {
      return attrs;
    }
  }, {
    key: "onParseError",
    value: function onParseError(attrs) {
      return attrs;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var attrs = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Model.prototype), "toJSON", this).call(this);

      for (var key in this._nestedModels) {
        var model = this._nestedModels[key];

        if (model instanceof __WEBPACK_IMPORTED_MODULE_7_backbone___default.a.Model) {
          attrs[key] = model.toJSON();
        }
      }

      for (var _key2 in this._nestedCollections) {
        var collection = this._nestedCollections[_key2];

        if (collection instanceof __WEBPACK_IMPORTED_MODULE_7_backbone___default.a.Collection) {
          attrs[_key2] = collection.toJSON();
        }
      }

      return attrs;
    }
  }, {
    key: "sync",
    value: function sync(method, model, options) {
      return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Model.prototype), "sync", this).call(this, method, model, this._defaultAjaxOptions(options));
    }
  }, {
    key: "validate",
    value: function validate(attrs, options) {
      // TODO: what if a nested object attribute has a validation assigned?
      var result = this._validateAttributes(attrs, options); // run nested object validations.
      // this implementation might seem a little weird, but fits the
      // backbone validation scheme. The validate() call is supposed to
      // only validate against the attributes passed in, not everything
      // currently stored in the model.


      for (var key in this._nestedModels) {
        var model = this._nestedModels[key];
        var attrsToValidate = void 0;

        if (attrs[key] instanceof __WEBPACK_IMPORTED_MODULE_7_backbone___default.a.Model) {
          attrsToValidate = attrs[key].attributes;
        } else {
          attrsToValidate = attrs[key];
        }

        var modelResult = model.validate(attrsToValidate, options);

        if (modelResult) {
          if (result == null) {
            result = {};
          }

          result[key] = modelResult;
        }
      }

      for (var _key3 in this._nestedCollections) {
        if (attrs[_key3] instanceof __WEBPACK_IMPORTED_MODULE_7_backbone___default.a.Collection) {
          for (var i = 0; i < attrs[_key3].models.length; i++) {
            var _model = attrs[_key3].models[i];

            if (_.isFunction(_model.validate)) {
              var _modelResult = _model.validate(_model.attributes, options);

              if (_modelResult) {
                if (result == null) {
                  result = {};
                }

                result["".concat(_key3, "[").concat(i, "]")] = _modelResult;
              }
            }
          }
        }
      }

      this._triggerValidationEvents(result, options);

      return result;
    }
  }, {
    key: "_initNestedObjects",
    value: function _initNestedObjects() {
      if (this._nestedModels) {
        return;
      }

      this._nestedModels = {};
      var modelDefs = __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_framework_reflection__["a" /* default */].evaluate(this.nestedModels);

      for (var name in modelDefs) {
        var properties = modelDefs[name];

        this._createNestedModel(name, properties);
      }

      this._nestedCollections = {};
      var collectionDefs = __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_framework_reflection__["a" /* default */].evaluate(this.nestedCollections);

      for (var _name2 in collectionDefs) {
        var _properties = collectionDefs[_name2];

        this._createNestedCollection(_name2, _properties);
      }

      this.set(this._nestedModels, {
        silent: true,
        ignoreNestedObjects: true
      });
      this.set(this._nestedCollections, {
        silent: true,
        ignoreNestedObjects: true
      });
    }
  }, {
    key: "_createNestedModel",
    value: function _createNestedModel() {
      var name = arguments.length <= 0 ? undefined : arguments[0];
      var properties = arguments.length <= 1 ? undefined : arguments[1];

      if (!properties.model) {
        properties = {
          model: properties
        };
      }

      if (!properties.model) {
        throw new Error("Nested model '".concat(name, "' needs a model class"));
      }

      var ModelClass = properties.model;
      var model = new ModelClass();
      this._nestedModels[name] = model;

      this._listenToNestedObjectEvents(model, properties);
    }
  }, {
    key: "_createNestedCollection",
    value: function _createNestedCollection(name, properties) {
      var CollectionClass = properties.collection || __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_framework_collection__["a" /* default */];
      var options = {};

      if (properties.model) {
        options.model = properties.model;
      }

      var collection = new CollectionClass([], options);
      this._nestedCollections[name] = collection;

      this._listenToNestedObjectEvents(collection, properties);
    }
  }, {
    key: "_listenToNestedObjectEvents",
    value: function _listenToNestedObjectEvents(modelOrCollection, properties) {
      var _this3 = this;

      if (!_.isString(properties.bubbleEvents)) {
        return;
      }

      var bubbleAll;
      var eventMap;

      if (properties.bubbleEvents === "all") {
        bubbleAll = true;
      } else {
        eventMap = {};

        _.each(properties.bubbleEvents.split(" "), function (eventName) {
          return eventMap[eventName] = true;
        });

        properties.bubbleEvents = eventMap;
      }

      this.listenTo(modelOrCollection, "all", function (eventName) {
        if (!(bubbleAll || eventMap[eventName])) {
          return;
        }

        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key4 = 1; _key4 < _len2; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        var triggerArgs = [eventName].concat(args); // mark the event as being triggered by this model (not the nested object)

        triggerArgs[1] = _this3; // and re-trigger the event

        _this3.trigger.apply(_this3, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(triggerArgs));
      });
    }
  }, {
    key: "_defaultAjaxOptions",
    value: function _defaultAjaxOptions(options) {
      var defaults = {
        wait: true,
        accepts: this.constructor.mimeType || "application/json",
        dataType: "json"
      };
      return _.extend(defaults, options);
    }
  }, {
    key: "_triggerValidationEvents",
    value: function _triggerValidationEvents(errors, options) {
      var includeBackboneEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.trigger("validated", this, errors, options);

      if (_.isEmpty(errors)) {
        this.trigger("valid", this);
      } else if (includeBackboneEvent) {
        // this includeBackboneEvent conditional is here because normally backbone will
        // trigger the invalid event for us, but not in the case of server-side errors
        // where we are 'mocking' a failed validation
        this.trigger("invalid", this, errors, {});
      }
    }
  }]);

  return Model;
}(__WEBPACK_IMPORTED_MODULE_7_backbone___default.a.Model);

_.extend(Model.prototype, __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_framework_validatable__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Model);

/***/ }),
/* 391 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Reflection = {
  getClassName: function getClassName(obj) {
    var target = obj;

    if (!(target instanceof Function)) {
      target = obj.constructor;
    }

    return target.name;
  },
  evaluate: function evaluate(functionOrValue, context) {
    if (typeof functionOrValue === "function") {
      if (context) {
        return functionOrValue.call(context);
      } else {
        return functionOrValue();
      }
    } else {
      return functionOrValue;
    }
  },
  flatten: function flatten(obj) {
    var ret = {};
    var separator = ".";
    /* eslint-disable guard-for-in */

    for (var key in obj) {
      var val = obj[key];

      if (val && val.constructor === Object && !_.isEmpty(val)) {
        // Recursion for embedded objects
        var obj2 = Reflection.flatten(val);

        for (var key2 in obj2) {
          var val2 = obj2[key2];
          ret[key + separator + key2] = val2;
        }
      } else {
        ret[key] = val;
      }
    }
    /* eslint-enable guard-for-in */


    return ret;
  },
  getNestedAttribute: function getNestedAttribute(obj, path, returnExists) {
    var fields = path.split(".");
    var result = obj || {};
    var i = 0;
    var numFields = fields.length;

    while (i < numFields) {
      if (returnExists && !_.has(result, fields[i])) {
        return false;
      }

      result = result[fields[i]];

      if (!result && i < numFields - 1) {
        result = {};
      }

      if (typeof result === "undefined") {
        if (returnExists) {
          return true;
        }

        return result;
      }

      i++;
    }

    if (returnExists) {
      return true;
    }

    return result;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Reflection);

/***/ }),
/* 393 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 394 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return en_us_values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return en_us; });
/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/

/* eslint-disable camelcase */
var en_us_values = {
  code: "en_us",
  label: "English"
};
var en_us = {
  1: "#{LABEL}# cannot be greater than #{FIELDLENGTH}#",
  3: "#{LABEL}# does not match",
  4: "#{LABEL}# is invalid",
  5: "#{LABEL}# is required",
  6: "#{LABEL}# is too early",
  7: "#{LABEL}# is too late",
  8: "#{LABEL}# must be #{FIELDLENGTH}# characters",
  9: "#{LABEL}# must be #{FIELDMAXLENGTH}# characters or fewer",
  12: "#{LABEL}# must be at least #{FIELDMIN}#",
  13: "#{LABEL}# must be at least #{FIELDMINLENGTH}# characters",
  16: "#{LENGTH}#-digit",
  17: "#{TITLE}# has no thermostats enrolled yet.",
  22: "A day must have at least one time period.",
  24: "Access Restrictions",
  25: "Access Restrictions saved successfully.",
  26: "Access Restrictions can block or limit features and restrict settings on your thermostat.",
  27: "Account Created",
  28: "Account Recovery",
  29: "Activate",
  30: "Activation Code",
  31: "Add Period",
  32: "Advanced",
  33: "Alert sent when temperature is above",
  34: "Alert sent when temperature is below",
  35: "Alerts",
  36: "Alerts saved successfully.",
  37: "All Alphabetically",
  38: "Allow access to all features in MENU and SETTINGS screens allows the user to change everything.",
  39: "Allows users to start a timed override when unoccupied or change temperature setpoints on HOME screen when occupied.",
  40: "An error occurred.",
  41: "Unknown Error",
  43: "App Settings",
  44: "Apply",
  45: "Apply #{LABEL}# to additional thermostats?",
  47: "Apply access restriction to additional thermostats?",
  48: "Apply alert settings to additional thermostats?",
  49: "Apply Changes To",
  50: "Are you sure you want to change your PIN?",
  51: "Are you sure you want to clear all alert notifications?",
  52: "Are you sure you want to delete #{NAME}#?",
  53: "Are you sure you want to delete this Building?",
  54: "Are you sure you want to delete this User?",
  55: "Are you sure you want to delete this?",
  56: "Are you sure you want to log out?",
  57: "Are you sure you want to remove #{NAME}# from Pivot?",
  59: "Authentication Type",
  64: "Building Configuration",
  65: "Building Dashboard",
  66: "Building Details",
  67: "By accessing Pivot App you accept and agree to be bound by the ",
  // Combined with 339
  68: "Call Support #{PHONENUMBER}#",
  69: "Cancel",
  70: "Cannot create a new period. There is a maximum of #{MAXOCCPERIODSPERDAY}# occupied periods per day.",
  71: "Changed #{TITLE}# to #{LABEL}#",
  73: "Changing #{MODELABEL}# to #{OPTIONLABEL}#",
  74: "Changing #{TITLE}# to #{LABEL}#",
  77: "Clear",
  78: "Clear All",
  79: "Compressor",
  80: "Compressor Speed",
  81: "Confirm your PIN",
  83: "Continue",
  87: "Cool To",
  88: "Cool To: {setpoint}°",
  89: "Cool To: {setpoint}. Heat To: {setpoint}°",
  93: "Create Group",
  94: "Daily",
  95: "Dashboard",
  96: "Delete",
  97: "Deleting",
  98: "Demo – save does not occur",
  99: "Device Ordering",
  100: "Devices",
  102: "Devices first (default)",
  103: "Disables access to the MENU screen and SYSTEM and FAN MODE but allows temperature setpoint adjustment and timed overrides.",
  104: "Disables access to the MENU screen but allows SYSTEM and FAN MODE changes and as well as temperature setpoint adjustment and timed overrides.",
  105: "Disassociate From Your Account",
  106: "DISMISS",
  107: "Done",
  109: "Edit Group",
  110: "Email",
  111: "Email Address",
  112: "Email Address is invalid",
  113: "Email Address is required",
  114: "Email Support",
  115: "Enable Service Contractor to see Information about your Thermostats",
  116: "Enroll New Device",
  117: "Enrollment failed.",
  118: "Enter your 12-digit activation code",
  119: "Enter your email address and we will send you an email to recover your username.",
  120: "Enter your PIN",
  122: "Enter your username and we will send you an email to reset your password.",
  123: "Entries don't match, please enter your PIN again.",
  124: "Events",
  125: "Exit Demo",
  126: "Explore Demo",
  127: "Failed to change #{TITLE}# to #{LABEL}#",
  128: "Failed to load thermostat's active schedule. Do you want to choose a saved schedule?",
  131: "For your security we cannot confirm whether the #{PROVIDEDCREDENTIAL}# you entered was correct. If you do not receive your email try again and make sure your #{PROVIDEDCREDENTIAL}# is entered correctly.",
  // Combined with 272, 153
  132: "Forgot your PIN",
  133: "Get Activation Code",
  134: "Get Code",
  135: "Go Back",
  137: "Groups first",
  140: "Heat To",
  141: "Heat To: {setpoint}°",
  142: "Heat To: #{setpoint}#. Cool To: {setpoint}°",
  144: "Help",
  145: "High",
  146: "Space Temperature Alert Enabled",
  147: "History",
  148: "Humidity",
  149: "I forgot my Username or Password",
  150: "I understand the risks",
  151: "If you are ready to add a thermostat to #{TITLE}#, tap Enroll New Device button below.",
  152: "If you continue this user will not be able to control anything in your account until you complete the activation process again. Are you sure you want to generate a new activation code for this user?",
  153: "If you do not receive the email please check your spam folder and make sure that you are not blocking email from #{SUPPORT}#.",
  // Combined with 272, 131
  154: "Invalid PIN. Please try again.",
  156: "Main Menu Passcode requires Access Restrictions set to Low, Medium or High.",
  157: "Last Updated #{TIME}#",
  158: "License Information",
  160: "Load",
  162: "Loading '#{BUILDINGNAME}#'",
  163: "Loading Account Sign Up",
  164: "Loading Alerts",
  165: "Loading building",
  166: "Loading daily runtime history...",
  167: "Loading default schedule",
  168: "Loading devices...",
  169: "Loading monthly runtime history...",
  170: "Loading Reset Password",
  171: "Loading schedule list",
  172: "Loading Setpoints",
  173: "Loading thermostat schedule",
  174: "Loading...",
  175: "Log In",
  176: "Log Out",
  177: "Login",
  178: "Low",
  179: "Manage Users",
  180: "Manufacturer",
  181: "Medium",
  184: "Monthly",
  185: "More",
  186: "My Buildings",
  187: "Name",
  188: "New Activation Code",
  189: "New Building",
  190: "New Period",
  191: "New User",
  192: "No",
  193: "No alerts are active.",
  194: "No Authorization",
  196: "No Recent Activity Found.",
  197: "None",
  198: "Please select a building to enable Group creation and Device enrollment.",
  // Combined with 357
  200: "Occupancy Setpoints",
  201: "Occupied",
  202: "Occupied Time Remaining",
  204: "OK",
  206: "Open Source License Information",
  207: "Operation complete.",
  208: "OS Version",
  209: "Outside",
  210: "Password reset successful.",
  213: "PIN entry disabled for #{MINUTES}# minutes.",
  214: "PIN Length",
  215: "PIN saved successfully.",
  216: "Pivot Mobile App Version",
  217: "Pivot™ Mobile App",
  218: "Platform",
  219: "Please enter a new PIN",
  220: "Please exercise caution when removing user authorization from the app. Due to the risk of unauthorized access, Pivot strongly recommends keeping the app locked unless this mobile device has a lock screen enabled.",
  221: "Please fill out the following information to reset your password.",
  222: "Please re-enter your username and password to manage the users of your Pivot™ account. You will not have to do this again.",
  223: "Pointed to #{HOST}#",
  224: "Postal Code",
  225: "Privacy Policy",
  226: "Recover Username",
  228: "Refresh Devices",
  229: "Remove #{NAME}# from Pivot",
  230: "Remove Period",
  231: "Reset Password",
  232: "Reset PIN",
  233: "Restart the App",
  234: "Prevent unauthorized access to the thermostat using a Passcode.",
  235: "Restrictions: Access Level",
  236: "Restrictions: Passcode",
  237: "Retrieving daily runtime history",
  238: "Retrieving monthly runtime history",
  239: "Retry",
  240: "Runtime History",
  241: "Save",
  242: "Save As",
  243: "Saved Schedules",
  244: "Saving Access Restriction...",
  245: "Saving Alerts...",
  246: "Schedules",
  247: "Scheduling could not be enabled. Please try again later.",
  248: "Scheduling enabled.",
  249: "Scheduling is disabled on this thermostat. Enable scheduling?",
  250: "SELECT PAGE",
  251: "Send Suggestions or Feedback",
  252: "Service Unavailable",
  253: "Set a #{LENGTH}#-digit PIN",
  254: "Set an 8-digit PIN",
  255: "Setpoints",
  256: "Setting cool to #{SETPOINTCOOL}#",
  257: "Setting heat to #{SETPOINTHEAT}#",
  258: "Setting heat to #{SETPOINTHEAT}# and cool to #{SETPOINTCOOL}#",
  259: "Settings",
  260: "Sign In",
  261: "Sign Up",
  262: "Sign Up Now",
  264: "Something went wrong while showing this page.",
  266: "Submit",
  267: "Successfully enrolled #{NAME}#.",
  268: "Support & Feedback",
  270: "Terms and Conditions",
  271: "Terms of Use",
  272: "Thank you. You should receive an email shortly with #{REQUESTEDEMAIL}#. The email may take 5-10 minutes to arrive.",
  // Combined with 153, 131
  274: "The following open source packages are used by the Pivot™ Mobile App.",
  275: "The following period is too close to create a new period.",
  276: "The preceding period is too close to create a new period.",
  277: "Request timed out.",
  280: "Thermostats",
  281: "This action cannot be completed because your account must have a minimum of one building.",
  282: "This group is empty. Edit the group to add devices.",
  283: "This mobile device needs to be reauthenticated.",
  284: "This operation cannot be performed while the device is offline.",
  285: "This thermostat is not compatible with Trane Pivot.",
  286: "To configure alerts for an individual thermostat click the Settings icon -",
  // Combined with 331
  287: "To enroll this thermostat under #{BUILDINGNAME}# click Get Code to generate a 5-digit code for you to enter at the thermostat.",
  288: "To enroll this thermostat under a different building click on Building Dashboard select desired building and then reselect enroll device under menu.",
  289: "To subscribe or modify your subscribed alerts press the Alert Subscriptions button above.",
  291: "Undo",
  292: "Unenrolling #{NAME}#",
  294: "Unlock App",
  295: "Unlock with Biometrics",
  296: "Unlock with PIN",
  297: "Unlock with PIN only",
  298: "Unoccupied",
  299: "Use 12-Digit Code",
  300: "Username",
  301: "Username & Password",
  302: "Username is required",
  303: "Users",
  304: "Version",
  305: "We are unable to communicate with the Pivot servers. Internet access is required for this app to work properly. Please check your data or Wi-Fi settings and try again.",
  306: "Welcome to Pivot",
  307: "Yes",
  309: "You cannot delete the last time period.",
  310: "You haven't saved any schedules yet.",
  311: "Your account has been created!",
  312: "Your network is unavailable. Check your data or Wi-Fi connection.",
  313: "The name of the period cannot be blank.",
  314: "The name of the period cannot contain emojis or special characters.",
  315: "Thermostat Fault Alerts Enabled",
  316: "Saving Setpoints...",
  317: "Setpoints saved successfully.",
  318: "Unexpected Error",
  319: "Apply setpoints to additional thermostats?",
  320: "Would you like to use your PIN to unlock the app when you open it?",
  321: "Would you like to use your #{BIOMETRICSTRING}# to unlock the app when you open it? Your PIN will be used if the #{BIOMETRICSTRING}# fails.",
  322: "Enter your Pivot username and password to reset your PIN",
  323: "Saving PINs...",
  324: "PINs saved successfully.",
  325: "Apply pins to additional thermostats?",
  326: "PIN must be four numeric digits",
  327: "Main Menu Passcode Enabled",
  328: "4 Digit Menu Passcode",
  329: "Technician Passcode Enabled",
  330: "4 Digit Technician Menu Passcode",
  331: "for that thermostat.",
  // Combined with 286
  332: "Our team of developers has been notified about the issue and is working on a fix.",
  333: "The page could not be found.",
  334: "Saving",
  335: "Telling #{NAME}# to #{ACTION}#",
  336: "This action cannot be completed because this building contains enrolled devices.",
  337: "Device Details",
  338: "The thermostat is not currently connected.",
  339: "End User License Agreement Terms and Conditions.",
  // Combined with 67
  340: "Are you sure you want to discard any changes to the schedule?",
  341: "Discard",
  342: "You must give the schedule a name.",
  343: "Saved Schedule",
  344: "Saved current schedule as #{NAME}#",
  345: "Saving schedule",
  346: "[#{NAME}#] already exists.\nDo you want to replace it?",
  347: "Couldn't load that schedule",
  348: "#{NAME}# is invalid and cannot be loaded.",
  349: "#{NAME}# does not match the temperature scale of the thermostat.",
  350: "Deleting '#{NAME}#'",
  351: "Saving thermostat schedule",
  352: "Saving schedules...",
  353: "Schedules saved successfully.",
  354: "Apply schedule to additional thermostats?",
  355: 'Loaded "#{NAME}#"',
  356: "There is nothing here yet.",
  357: "Note",
  // Combined with 198
  358: "Demo mode allows you to navigate throughout the Pivot app and explore how it operates.  As you use the Pivot app in this mode, any changes you make are not saved.",
  359: "Language",
  360: "Set automatically via this device",
  361: "Saving Language…",
  362: "Select Language",
  363: "A value is required.",
  364: "Edit",
  365: "Active Schedule",
  366: "Support Code",
  367: "Chrome Version",
  368: "Web View",
  369: "Unknown",
  370: "Password",
  371: "Mobile User",
  372: "Support Code",
  373: "HEAT",
  374: "COOL",
  375: "OFF",
  376: "Date too early",
  377: "Date too late",
  378: "on",
  379: "at",
  380: "by",
  381: "Device Event",
  382: "Scheduled Event",
  383: "Web Browsers",
  384: "Alert Subscriptions",
  385: "Filter",
  386: "Enroll #{DEVICE}#",
  387: "Enrolling #{DEVICE}#",
  388: "mon",
  389: "tue",
  390: "wed",
  391: "thu",
  392: "fri",
  393: "sat",
  394: "sun",
  395: "Are you sure you want to reset your password?",
  396: "Alert sent when humidity is above",
  397: "Alert sent when humidity is below",
  398: "Space Humidity Alert Enabled",
  399: "The software included in this product contains copyrighted software that is licensed under the GPL, LGPL or other copyleft license. A copy of those licenses is included herewith.  You may obtain the complete corresponding source code from us for a period of three years after our last shipment of this product by sending a request letter to:",
  400: "Trane Commercial HVAC",
  401: "Attn: Open Source Compliance",
  402: "800-E Beaty St.",
  403: "PO Box 940",
  404: "Davidson, NC 28036",
  405: "Please include the name of the product and, if applicable, the version number of the software in the request letter. This offer is valid to anyone in receipt of this information.",
  406: "To transfer your account, please enter your password:",
  407: "Transfer Account",
  409: "Loading Account Transfer",
  410: "Hello!",
  411: "Please fill out the fields below in order to activate the Pivot account that was transferred to you.",
  412: "Thermostat Fault Alerts",
  413: "Enabled",
  414: "Disabled",
  415: "Space Temperature Alert",
  416: "Space Humidity Alert",
  417: "above ",
  418: "below ",
  419: "Send alert notification on:",
  420: "Alert Enabled",
  421: "Alert",
  422: "Username is permanently tied to account. Create a username meaningful to the owner.",
  423: "Alert Subscription Users",
  424: "Thermostats this user can control",
  425: "Add Contact",
  426: "Receives selected alerts at",
  427: "Edit Settings",
  428: "Delete Contact",
  429: "User alert subscriptions",
  430: "Send to",
  431: "At",
  432: "Phone",
  433: "All",
  434: "Custom",
  435: "Receive these alerts",
  436: "High and low limit cannot be same",
  437: "Higher limit must be greater than lower limit",
  438: "My push notification alerts",
  439: "this Mobile Device"
};

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fr_ca_values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fr_ca; });
/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/

/* eslint-disable camelcase */
var fr_ca_values = {
  code: "fr_ca",
  label: "Français"
};
var fr_ca = {
  1: "#{LABEL}# ne peut pas être plus grand",
  3: "#{LABEL}# ne correspond pas",
  4: "#{LABEL}# est invalide",
  5: "#{LABEL}# est requis",
  6: "#{LABEL}# est trop tôt",
  7: "#{LABEL}# est trop tard",
  8: "#{LABEL}# doit être #{FIELDLENGTH}# caractères",
  9: "#{LABEL}# doit être #{FIELDMAXLENGTH}# caractères ou moins",
  12: "#{LABEL}# doit être au moins #{FIELDMIN}#",
  13: "#{LABEL}# doit être au moins #{FIELDMAX}# caractères",
  16: "#{LENGTH}# chiffre",
  17: "#{TITLE}# n'a pas encore de thermostats inscrits.",
  22: "Une journée doit avoir au moins une période.",
  24: "Restrictions d'accès",
  25: "Restrictions d'accès sauvegardées avec succès",
  26: "Les restrictions d'accès peuvent bloquer ou limiter les fonctionnalités et restreindre les paramètres de votre thermostat.",
  27: "Compte créé",
  28: "Récupération du compte",
  29: "Activer",
  30: "Code d'activation",
  31: "Ajouter une période",
  32: "Avancé",
  33: "Alerte envoyée lorsque la température est supérieure",
  34: "Alerte envoyée lorsque la température est inférieure",
  35: "Alertes",
  36: "Les alertes ont été enregistrées avec succès.",
  37: "Tout par ordre alphabétique",
  38: "Autoriser l'accès à toutes les fonctionnalités des écrans MENU et PARAMÈTRES permet à l'utilisateur de tout changer.",
  39: "Permet aux utilisateurs de démarrer une dérogation temporisée lorsqu'ils sont inoccupés ou de modifier les points de consigne de température sur l'écran ACCUEIL lorsqu'ils sont occupés.",
  40: "Une erreur est survenue.",
  41: "Erreur inconnue",
  43: "Paramètres de l'application",
  44: "Appliquer",
  45: "Appliquer #{LABEL}# à des thermostats supplémentaires?",
  47: "Appliquer une restriction d'accès aux thermostats supplémentaires?",
  48: "Appliquer des paramètres d'alerte à des thermostats supplémentaires?",
  49: "Appliquer les modifications à",
  50: "Etes-vous certain de vouloir changer votre NIP?",
  51: "Etes-vous certain de vouloir effacer toutes les notifications d'alerte?",
  52: "Etes-vous certain de vouloir supprimer #{NAME}#?",
  53: "Etes-vous certain de vouloir supprimer ce bâtiment?",
  54: "Etes-vous certain de vouloir supprimer cet utilisateur?",
  55: "Etes-vous certain de vouloir supprimer ceci?",
  56: "Etes-vous certain de vouloir vous déconnecter?",
  57: "Etes-vous certain de vouloir supprimer #{NAME}# de Pivot?",
  59: "Type d'Authentification",
  64: "Configuration du tableau de bord",
  65: "Construction d'un tableau de bord",
  66: "Détails du bâtiment",
  67: "En accédant à l'application Pivot, vous acceptez et consentez d'être lié par les",
  68: "Appeler le Support #{PHONENUMBER}#",
  69: "Annuler",
  70: "Impossible de créer une nouvelle période. Il y a un maximum de #{MAXOCCPERIODSPERDAY}# périodes par jour.",
  71: "Changer #{TITLE}# à #{LABEL}#",
  73: "Changer #{MODELABEL}# à #{OPTIONLABEL}#",
  74: "Changer #{TITLE}# à #{LABEL}#",
  77: "Effacer",
  78: "Tout effacer",
  79: "Compresseur",
  80: "Vitesse du compresseur",
  81: "Confirmer votre NIP",
  83: "Continuer",
  87: "Refroidir à",
  88: "Refroidir à: {setpoint}°",
  89: "Refroidir à | {setpoint}. Chauffer à | {setpoint} °",
  93: "Créer un groupe",
  94: "Chaque jour",
  95: "Tableau de bord",
  96: "Effacer",
  97: "Supprimer",
  98: "Démo - la sauvegarde ne s'effectue pas",
  99: "Commande de périphériques",
  100: "Périphériques",
  102: "Les périphériques d'abord (défault)",
  103: "Accès désactivé à l'écran MENU et au MODE SYSTÈME et MODE VENTILATEUR, mais permet le réglage du point de consigne de la température et les remplacements temporisés.",
  104: "Accès désactivé à l'écran MENU, mais permet les changements de SYSTÈME et de MODE VENTILATEUR ainsi que le réglage du point de consigne de température et les remplacements chronométrés.",
  105: "Dissocier de votre Compte",
  106: "REJETER",
  107: "Terminé",
  109: "Modifier Groupe",
  110: "Courriel",
  111: "Adresse courriel",
  112: "Adresse courriel invalide",
  113: "Adresse courriel requise",
  114: "Assistance par courriel",
  115: "Permettre à l'entrepreneur de service de voir les informations sur vos thermostats",
  116: "Ajout périphérique",
  117: "L'inscription a échoué.",
  118: "Entrez votre code d'activation à 12 chiffres",
  119: "Entrez votre adresse courriel et nous vous enverrons un courriel pour récupérer votre nom d'utilisateur.",
  120: "Entrer votre NIP",
  122: "Saisissez votre nom d'utilisateur et nous vous enverrons un courriel pour réinitialiser votre mot de passe.",
  123: "Les entrées ne correspondent pas, veuillez saisir à nouveau votre code NIP.",
  124: "Evénements",
  125: "Sortir Démo",
  126: "Explorer Démo",
  127: "Échec de la modification de #{TITLE}# en #{LABEL}#",
  128: "Impossible de charger le programme actif du thermostat. Voulez-vous choisir un horaire enregistré?",
  131: "Pour votre sécurité, nous ne pouvons pas confirmer si le #{PROVIDEDCREDENTIAL}# que vous avez entré était correct. Si vous ne recevez pas de courriel, essayez de nouveau et assurez-vous que votre #{PROVIDEDCREDENTIAL}# est entré correctement.",
  132: "Vous avez oublié votre NIP",
  133: "Obtenir un code d'activation",
  134: "Obtenir un code",
  135: "Revenir",
  137: "Groupes d'abord",
  140: "Chauffer à",
  141: "Chauffer à | {setpoint}°",
  142: "Chauffer à | #{setpoint}#. Refroidir à | {setpoint}°",
  144: "Aide",
  145: "Haut",
  146: "fr_Space Temperature Alert Enabled_fr",
  147: "Historique",
  148: "Humidité",
  149: "J'ai oublié mon nom d'utilisateur ou mon mot de passe",
  150: "Je comprends les risques",
  151: "Si vous êtes prêt à ajouter un thermostat à #{TITLE}# appuyez sur le bouton Inscrire un Nouveau Périphérique ci-dessous.",
  152: "Si vous continuez, cet utilisateur ne pourra plus rien contrôler dans votre compte tant que vous n'aurez pas terminé le processus d'activation. Voulez-vous vraiment générer un nouveau code d'activation pour cet utilisateur?",
  153: "Si vous ne recevez pas de courriel, veuillez vérifier votre dossier de courrier indésirable et vous assurer que vous ne bloquez pas les courriels #{SUPPORT}#.",
  154: "NIP invalide. Veuillez réessayer.",
  156: "Le code d'accès du menu principal nécessite des restrictions d'accès définies sur Faible, Moyenne ou Élevée.",
  157: "Dernière mise à jour #{TIME}#",
  158: "Informations de licence",
  160: "Charger",
  162: "Chargement en cours '#{BUILDINGNAME}#'",
  163: "Chargement de l'inscription du compte",
  164: "Chargement des alertes",
  165: "Chargement du bâtiment",
  166: "Chargement de l'historique d'exécution quotidienne...",
  167: "Chargement des horaires par défaut",
  168: "Chargement des périphériques...",
  169: "Chargement de l'historique d'exécution mensuelle...",
  170: "Chargement de la réinitialisation du mot de passe",
  171: "Chargement de la liste des horaires",
  172: "Chargement des points de consigne",
  173: "Chargement du programme du thermostat",
  174: "Chargement en cours...",
  175: "Connexion",
  176: "Déconnexion",
  177: "Ouverture de session",
  178: "Bas",
  179: "Gérer les Utilisateurs",
  180: "Fabricant ",
  181: "Moyen",
  184: "Mensuel",
  185: "Plus",
  186: "Mes Bâtiments",
  187: "Nom",
  188: "Nouveau Code d'Activation",
  189: "Nouveau Bâtiment",
  190: "Nouvelle Période",
  191: "Nouvel Utilisateur",
  192: "Non",
  193: "Aucune alerte n'est activée",
  194: "Aucune autorisation",
  196: "Aucune activité récente trouvée.",
  197: "Aucun",
  198: "Veuillez sélectionner un bâtiment pour permettre la création de groupes et l'inscription des périphériques.",
  200: "Occupation des points de consignes",
  201: "Occupé",
  202: "Temps occupé restant",
  204: "OK",
  206: 'Informations sur la licence "Open Source"',
  207: "Opération complétée",
  208: "Version OS ",
  209: "Dehors",
  210: "Réinitialisation du mot de passe réussie.",
  213: "Saisie du NIP désactivée pendant #{MINUTES}# minutes.",
  214: "Longueur du NIP",
  215: "Le NIP a bien été enregistré.",
  216: "Version de l'application mobile Pivot",
  217: "Application mobile Pivot ™",
  218: "Plateforme",
  219: "Veuillez saisir un nouveau NIP",
  220: "Soyez prudent lorsque vous supprimez l'autorisation d'un utilisateur de l'application. En raison du risque d'accès non autorisé, Pivot recommande fortement de garder l'application verrouillée à moins que cet appareil mobile ne dispose d'un écran de verrouillage",
  221: "Veuillez remplir les informations suivantes pour réinitialiser votre mot de passe.",
  222: "Veuillez ressaisir votre nom d'utilisateur et votre mot de passe pour gérer les utilisateurs de votre compte Pivot ™. Vous n'aurez pas à recommencer.",
  223: "Pointé vers #{HOST}#",
  224: "Code postal",
  225: "Politique de confidentialité",
  226: "Récupérer le nom d'utilisateur",
  228: "Actualiser les périphériques",
  229: "Supprimer #{NAME}# de Pivot",
  230: "Supprimer la période",
  231: "Réinitialiser le NIP",
  232: "Réinitialiser le mot de passe",
  233: "Redémarrez l'application",
  234: "Empêchez l'accès non autorisé au thermostat à l'aide d'un code d'accès.",
  235: "Restrictions|Niveau d'accès",
  236: "Restrictions|Mot de passe",
  237: "Récupération de l'historique d'exécution quotidien",
  238: "Récupération de l'historique d'exécution mensuel",
  239: "Ré-essayer",
  240: "Historique d'exécution",
  241: "Enregistrer",
  242: "Enregistrer sous",
  243: "Horaires sauvegardés",
  244: "Enregistrement de la restriction d'accès...",
  245: "Sauvegarder les alertes",
  246: "Horaires",
  247: "La planification n'a pas pu être activée. Veuillez réessayer plus tard.",
  248: "Planification activée.",
  249: "La programmation est désactivée sur ce thermostat. Activer la planification?",
  250: "CHOISIR UNE PAGE",
  251: "Envoyer des suggestions ou des commentaires",
  252: "Service Non Disponible",
  253: "Définissez un NIP de #{LENGTH}# - chiffres",
  254: "Définir un NIP à 8 chiffres",
  255: "Points de consigne (PdC)",
  256: "Réglage du froid sur #{SETPOINTCOOL}#",
  257: "Réglage de la chaleur sur #{SETPOINTHEAT}#",
  258: "Régler la chaleur à #{SETPOINTHEAT}# et refroidir à #{SETPOINTCOOL}#",
  259: "Paramètres",
  260: "Se connecter",
  261: "S'inscrire",
  262: "S'inscrire maintenant",
  264: "Une erreur s'est produite lors de l'affichage de cette page.",
  266: "Soumettre",
  267: "Enregistré avec succès #{NAME}#.",
  268: "Support & Commentaires",
  270: "Termes and Conditions",
  271: "Termes d'Utilisation",
  272: "Merci. Vous devriez recevoir un courriel sous peu avec #{REQUESTEDEMAIL}#. Le courriel peut prendre de 5 à 10 minutes pour arriver.",
  274: "Les séries de mesure d'Open Source suivants sont utilisés par l'application mobile Pivot ™.",
  275: "La période suivante est trop proche pour créer une nouvelle période.",
  276: "La période précédente est trop proche pour créer une nouvelle période.",
  277: "La demande a expiré.",
  280: "Thermostats",
  281: "Cette action ne peut pas être effectuée car votre compte doit inclure au moins un bâtiment.",
  282: "Ce groupe est vide. Modifiez le groupe pour ajouter des périphériques.",
  283: "Cet appareil mobile doit être authentifié de nouveau.",
  284: "Cette opération ne peut pas être effectuée lorsque le périphérique est hors ligne.",
  285: "Ce thermostat n'est pas compatible avec Pivot",
  286: "Pour configurer des alertes pour un thermostat individuel, cliquez sur l'icône Paramètres -",
  287: "Pour inscrire ce thermostat sous #{BUILDINGNAME}#, cliquez sur Obtenir le code pour générer un Code à 5 chiffres à saisir sur le thermostat.",
  288: 'Pour inscrire ce thermostat sous un autre bâtiment, cliquez sur "Tableau de Bord", sélectionnez le bâtiment souhaité, puis sélectionnez de nouveau Enregistrz un Périphérique dans le menu.',
  289: "fr_To subscribe or modify your subscribed alerts press the Alert Subscriptions button above._fr",
  291: "Annuler",
  292: "Désinscription #{NAME}#",
  294: "Déverrouiller l'Application",
  295: "fr_Unlock with Biometrics_fr",
  296: "Déverrouiller avec le NIP",
  297: "Déverrouiller avec le NIP seulement",
  298: "Inoccupé",
  299: "Utiliser un code à 12 chiffres",
  300: "Nom d'utilisateur",
  301: "Nom d'utilisateur et Mot de passe",
  302: "Nom d’utilisateur requis",
  303: "Utilisateurs",
  304: "Version",
  305: "Nous ne pouvons pas communiquer avec les serveurs de Pivot. Un accès Internet est requis pour que cette application fonctionne correctement. Veuillez vérifier vos données ou vos paramètres Wi-Fi et réessayer.",
  306: "Bienvenue chez Pivot",
  307: "Oui",
  309: "Vous ne pouvez pas supprimer la dernière période.",
  310: "Vous n'avez pas encore d'horaires enregistrés.",
  311: "Votre compte a été créé. Veuillez prendre un moment pour remplir quelques détails supplémentaires.",
  312: "Votre réseau n'est pas disponible. Vérifiez vos données ou votre connexion Wi-Fi.",
  313: "Le nom de la période ne peut pas être vide",
  314: "Le nom de la période ne peut pas contenir d'émojis ou de caractères spéciaux.",
  315: "Alertes du thermostat par défaut activées",
  316: "Enregistrement des points de consigne...",
  317: "Consignes enregistrées avec succès.",
  318: "Erreur inattendue",
  319: "Appliquer des points de consigne à des thermostats supplémentaires?",
  320: "Souhaitez-vous utiliser votre NIP pour déverrouiller l'application lorsque vous l'ouvrez?",
  321: "Souhaitez-vous utiliser votre #{BIOMETRIC STRING}# pour déverrouiller l'application lorsque vous l'ouvrez? Votre code NIP sera utilisé si la #{BIOMETRIC STRING}# échoue.",
  322: "Entrez votre nom d'utilisateur et votre mot de passe Pivot pour réinitialiser votre NIP",
  323: "Sauvegarder NIP",
  324: "NIP sauvegardé avec succès",
  325: "Appliquer des NIP à des thermostats supplémentaires?",
  326: "Le code NIP doit être composé de quatre chiffres",
  327: "Code d'accès au menu principal activé",
  328: "Code d'accès au menu à 4 chiffres",
  329: "Code d'accès du technicien activé",
  330: "Code d'accès du menu technicien à 4 chiffres",
  331: "pour ce thermostat",
  332: "Notre équipe de développeurs a été informée du problème et travaille à corriger la situation.",
  333: "La page ne peut pas être trouvée",
  334: "Sauvegarder",
  335: "Dire #{NAME}# à #{ACTION}#",
  336: "Cette action ne peut pas être effectuée car ce bâtiment contient des périphériques inscrits.",
  337: "Détails du périphérique",
  338: "Le thermostat n'est pas connecté en ce moment",
  339: "Termes et conditions du contrat de licence final de l'utilisateur.",
  340: "Voulez-vous vraiment annuler les modifications apportées au programme?",
  341: "Jeter",
  342: "Vous devez donner un nom au programme.",
  343: "Horaire sauvegardé",
  344: "Calendrier actuel enregistré sous #{NAME}#",
  345: "Enregistrement de l'horaire",
  346: "[#{NAME}#] existe déjà.\nVoulez-vous le remplacer?",
  347: "Impossible de charger cette planification",
  348: "#{NAME}# est invalide et ne peut être chargé",
  349: "#{NAME}# ne correspond pas à l'échelle de température du thermostat.",
  350: "Supprimer '#{NAME}#'",
  351: "Enregistrement du programme du thermostat",
  352: "Enregistrement des horaires...",
  353: "Les horaires ont bien été enregistrés.",
  354: "Appliquer le programme à des thermostats supplémentaires?",
  355: 'Chargé "#{NAME}#"',
  356: "Il n'y a encore rien ici.",
  357: "Note",
  358: "Le mode démo vous permet de naviguer dans l'application Pivot et d'explorer son fonctionnement. Lorsque vous utilisez l'application Pivot dans ce mode, les modifications que vous apportez ne sont pas enregistrées.",
  359: "Langue",
  360: "Définir automatiquement via ce périphérique",
  361: "Enregistrement de la langue...",
  362: "Choisir la langue",
  363: "Une valeur est requise.",
  364: "Éditer",
  365: "Calendrier actif",
  366: "Code de support",
  367: "Version Chrome",
  368: "Affichage Web",
  369: "Inconnue",
  370: "Mot de passe",
  371: "Utilisateur mobile",
  372: "Code de support",
  373: "MODE CHAUD",
  374: "FROID",
  375: "ARRÊT",
  376: "Date trop tôt",
  377: "Date trop tard",
  378: "sur",
  379: "à",
  380: "par",
  381: "Événement de périphérique",
  382: "Événement programmé",
  383: "Navigateurs Web",
  384: "Abonnements aux alertes",
  385: "Filtre",
  386: "Inscrire #{DEVICE}#",
  387: "Inscription #{DEVICE}#",
  388: "lun",
  389: "mar",
  390: "mer",
  391: "jeu",
  392: "ven",
  393: "sam",
  394: "dim",
  395: "FR - Are you sure you want to reset your password? - FR",
  396: "Alerte envoyée lorsque la humidité est supérieure",
  397: "Alerte envoyée lorsque la humidité est inférieure",
  398: "fr_Space Humidity Alert Enabled_fr",
  399: "FR_The software included in this product contains copyrighted software that is licensed under the GPL, LGPL or other copyleft license. A copy of those licenses is included herewith.  You may obtain the complete corresponding source code from us for a period of three years after our last shipment of this product by sending a request letter to:",
  400: "Trane Commercial HVAC",
  401: "Attn: Open Source Compliance",
  402: "800-E Beaty St.",
  403: "PO Box 940",
  404: "Davidson, NC 28036",
  405: "Please include the name of the product and, if applicable, the version number of the software in the request letter. This offer is valid to anyone in receipt of this information._FR",
  406: "fr_To transfer your account, please enter your password:_fr",
  407: "fr_Transfer Account_fr",
  409: "fr_Loading Account Transfer_fr",
  410: "fr_Hello!_fr",
  411: "fr_Please fill out the fields below in order to activate the Pivot account that was transferred to you._fr",
  412: "fr_Thermostat Fault Alerts_fr",
  413: "fr_Enabled_fr",
  414: "fr_Disabled_fr",
  415: "fr_High Low Temperature Alert_fr",
  416: "fr_Humidity Alert_fr",
  417: "fr_above_fr",
  418: "fr_below_fr",
  419: "fr_Send alert notification on:_fr",
  420: "fr_Alert Enabled_fr",
  421: "fr_Alert_fr",
  422: "fr_Username is permanently tied to account.  Create a username meaningful to the owner._fr",
  423: "fr_Alert Subscription Users_fr",
  424: "fr_Thermostats this user can control_fr",
  425: "fr_Add Contact_fr",
  426: "fr_Receives selected alerts at_fr",
  427: "fr_Edit Settings_fr",
  428: "fr_Delete contact_fr",
  429: "fr_User alert subscriptions_fr",
  430: "fr_Send to_fr",
  431: "fr_At_fr",
  432: "fr_Phone Number_fr",
  433: "fr_All_fr",
  434: "fr_Custom_fr",
  435: "fr_Receive these alerts_fr",
  436: "fr_High and low limit cannot be same_fr",
  437: "fr_Higher limit must be greater than lower limit_fr",
  438: "fr_My push notification alerts_fr",
  439: "fr_this Mobile Device_fr"
};

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return es_mx_values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return es_mx; });
/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/

/* eslint-disable camelcase */
var es_mx_values = {
  code: "es_mx",
  label: "Español"
};
var es_mx = {
  1: "#{LABEL}# no puede ser mayor de #{FIELDLENGTH}#",
  3: "#{LABEL}# no concuerda",
  4: "#{LABEL}# no es válido",
  5: "#{LABEL}# es obligatorio",
  6: "#{LABEL}# es muy temprano",
  7: "#{LABEL}# es muy tarde",
  8: "#{LABEL}# debe ser de #{FIELDLENGTH}# caracteres",
  9: "#{LABEL}# debe ser de #{FIELDMAXLENGTH}# caracteres o menos",
  12: "#{LABEL}# debe ser de al menos #{FIELDMIN}#",
  13: "#{LABEL}# debe ser al menos #{FIELDMAX}# caracteres",
  16: "#{LENGTH}#-dígitos",
  17: "#{TITLE}# aún no tiene termostatos inscritos.",
  22: "Un día debe tener al menos un periodo de tiempo.",
  24: "Restricciones de Acceso",
  25: "Restricciones de Acceso guardadas exitosamente.",
  26: "Las Restricciones de Acceso pueden bloquear o limitar funciones y restringir ajustes en su termostato.",
  27: "Cuenta Creada",
  28: "Recuperar Cuenta",
  29: "Activar",
  30: "Código de Activación",
  31: "Añadir Periodo",
  32: "Avanzado",
  33: "Aleta enviada cuando la temperatura está por encima",
  34: "Aleta enviada cuando la temperatura está por debajo",
  35: "Alertas",
  36: "Alertas guardadas exitosamente",
  37: "Todo Alfabéticamente",
  38: "Permitir acceso a todas las funciones en las pantallas de MENU y AJUSTES permite a los usuarios cambiar todo.",
  39: "Permite a los usuarios arrancar un sobremando de tiempo cuando está desocupado o cambiar los puntos de ajuste en su pantalla de INICIO cuando está en ocupado.",
  40: "Se ha producido un error.",
  41: "Error Desconocido",
  43: "Ajustes Aplicación",
  44: "Aplicar",
  45: "¿Aplicar #{LABEL}# a termostatos adicionales?",
  47: "¿Aplicar restricciones de acceso a termostatos adicionales?",
  48: "¿Aplicar ajustes de alerta a termostatos adicionales?",
  49: "Aplicar Cambios A",
  50: "¿Está seguro que desea cambiar su PIN?",
  51: "¿Está seguro que desea borrar todas las notificaciones de alerta?",
  52: "¿Está seguro que desea borrar #{NAME}#?",
  53: "¿Está seguro que desea borrar este Edificio?",
  54: "¿Está seguro que desea borrar este Usuario?",
  55: "¿Está seguro que desea borrar esto?",
  56: "¿Está seguro que desea salir?",
  57: "¿Está seguro que desea remover #{NAME}# del Pivot?",
  59: "Tipo de Autenticación",
  64: "Configuración de Edificio",
  65: "Tablero de Edificio",
  66: "Detalles de Edificio",
  67: "Al acceder a la aplicación Pivot, usted acepta y está de acuerdo a estar obligado por el",
  68: "Llame Soporte al #{PHONENUMBER}#",
  69: "Cancelar",
  70: "No puede crear un nuevo periodo.  Hay un máximo de #{MAXOCCPERIODSPERDAY}# periodos por día.",
  71: "Cambio de #{TITLE}# a #{LABEL}#",
  73: "Cambiando #{MODELABEL}# a #{OPTIONLABEL}#",
  74: "Cambiando #{TITLE}# a #{LABEL}#",
  77: "Remover",
  78: "Remover todo",
  79: "Compresor",
  80: "Velocidad del compresor",
  81: "Confirmar su PIN",
  83: "Continuar",
  87: "Enfriar A",
  88: "Enfriar A: {setpoint}°",
  89: "Enfriar A|{setpoint}. Calentar A|{setpoint}°",
  93: "Crear Grupo",
  94: "Diario",
  95: "Tablero",
  96: "Borrar",
  97: "Borrando",
  98: "Demo - guardar no ocurre",
  99: "Orden Dispositivos",
  100: "Dispositivos",
  102: "Dispositivos primero (por defecto)",
  103: "Deshabilita el acceso a la pantalla de MENU y SISTEMA y MODO DE VENTILADOR pero permite ajustes de temperatura y sobremandos de tiempo.",
  104: "Deshabilita el acceso a la pantalla de MENU pero permite cambios en SISTEMA y MODO DE VENTILADOR así como ajustes de temperatura y sobremandos de tiempo.",
  105: "Desasociar de su Cuenta",
  106: "DESCARTAR",
  107: "Hecho",
  109: "Editar Grupo",
  110: "Correo electrónico",
  111: "Dirección de correo electrónico",
  112: "Dirección de correo no válida",
  113: "Dirección de correo requerida",
  114: "Enviar Correo Soporte",
  115: "Habilitar Contratista de Servicio para ver información acerca de sus Termostatos",
  116: "Inscribir Nuevo Dispositivo",
  117: "Falla al Inscribir.",
  118: "Ingrese su código de activación de 12 dígitos",
  119: "Ingrese su dirección de correo electrónico y le enviaremos un correo para recuperar su nombre de usuario.",
  120: "Ingrese su PIN",
  122: "Ingrese su nombre de usuario y le enviaremos un correo para restablecer su contraseña.",
  123: "Las entradas no concuerdan, por favor ingrese su PIN nuevamente.",
  124: "Eventos",
  125: "Salir Demo",
  126: "Explorar Demo",
  127: "Falla al cambiar #{TITLE}# a #{LABEL}#",
  128: "Falla al cargar el horario activo del termostato.  ¿Usted desea elegir un horario guardado?",
  131: "Por su seguridad no podemos confirmar si su #{PROVIDEDCREDENTIAL}# fue ingresada correctamente. Si no recibe un correo intente nuevamente para asegurarse que su #{PROVIDEDCREDENTIAL}# fue ingresada correctamente. ",
  132: "Olvido su PIN",
  133: "Obtener Código de Activación",
  134: "Obtener Código",
  135: "Volver",
  137: "Grupos primero",
  140: "Calentar A",
  141: "Calentar A |{setpoint}° ",
  142: "Calentar A|#{setpoint}#. Enfriar A|{setpoint}°",
  144: "Ayuda",
  145: "Alto",
  146: "Alerta de Temperatura Ambiente Habilitado",
  147: "Historia",
  148: "Humedad",
  149: "Olvide mi nombre de usuario o contraseña",
  150: "Entiendo los riesgos",
  151: "Si se encuentra listo para añadir un termostato a #{TITLE}# presione el botón de Inscribir Nuevo Dispositivo abajo.",
  152: "Si continuar este usuario no estará habilitado para controlar nada en su cuenta hasta que usted complete el proceso de activación nuevamente.  ¿Está seguro que desea generar un nuevo código de activación para este usuario?",
  153: "Si usted no recibe un correo por favor verifique en su carpeta de correo no deseado y asegúrese que no está bloqueando correos desde #{SUPPORT}#. ",
  154: "PIN no válido.  Por favor intentar nuevamente.",
  156: "El código de acceso del menú principal requiere que las restricciones de acceso se establezcan en Bajo, Medio o Alto.",
  157: "Última Actualización #{TIME}#",
  158: "Información de licencia",
  160: "Cargar",
  162: "Cargando '#{BUILDINGNAME}#'",
  163: "Cargando Registro de Cuenta",
  164: "Cargando Alertas",
  165: "Cargando edificio",
  166: "Cargando historia de tiempo de funcionamiento diario…",
  167: "Cargando horario por defecto",
  168: "Cargando dispositivos…",
  169: "Cargando historia de tiempo de funcionamiento mensual…",
  170: "Cargando Restablecer Contraseña",
  171: "Cargando lista de horarios",
  172: "Cargando Puntos de Ajuste",
  173: "Cargando horario de termostato",
  174: "Cargando…",
  175: "Iniciar sesión",
  176: "Finalizar sesión",
  177: "Iniciar sesión",
  178: "Bajo",
  179: "Administrar usuarios",
  180: "Fabricante",
  181: "Medio",
  184: "Mensual",
  185: "Más",
  186: "Mis Edificios",
  187: "Nombre",
  188: "Nuevo Código de Activación",
  189: "Nuevo Edificio",
  190: "Nuevo Periodo",
  191: "Nuevo Usuario",
  192: "No",
  193: "No hay alertas activas.",
  194: "No hay Autorización",
  196: "No hay Actividad Reciente.",
  197: "Ninguno",
  198: "Por favor selecciones un edificio para habilitar creación de Grupo e inscripción e Dispositivo.",
  200: "Puntos de Ajuste Ocupado",
  201: "Ocupado",
  202: "Tiempo Restante en Ocupado",
  204: "OK",
  206: "Abrir Información Licencia Fuente",
  207: "Operación completa.",
  208: "Versión SO",
  209: "Exterior",
  210: "Contraseña restablecida exitosamente.",
  213: "Entrada de PIN deshabilitada por #{MINUTES}# minutos.",
  214: "Longitud de PIN",
  215: "PIN guardado exitosamente.",
  216: "Versión Aplicación Móvil Pivot",
  217: "Aplicación Móvil Pivot™",
  218: "Plataforma",
  219: "Por favor ingresar un nuevo PIN",
  220: "Favor tenga cuidado cuando remueva la autorización de un usuario de la aplicación.  Debido al riesgo de acceso no autorizado, Pivot recomienda mantener la aplicación bloqueada a no ser que este dispositivo móvil tenga bloqueado de pantalla habilitado.",
  221: "Por favor provea la siguiente información para restablecer su clave.",
  222: "Por favor re-ingrese su usuario y clave para manejar los usuarios de su cuenta de Pivot™.  No tendrá que hacer esto nuevamente.",
  223: "Apuntado a #{HOST}#",
  224: "Código postal",
  225: "Política de Privacidad",
  226: "Recuperar Nombre de Usuario",
  228: "Refrescar Dispositivos",
  229: "Remover #{NAME}# del Pivot",
  230: "Remover Periodo",
  231: "Restablecer contraseña",
  232: "Restablecer PIN",
  233: "Reiniciar la Aplicación",
  234: "Evite el acceso no autorizado al termostato utilizando una contraseña.",
  235: "Restricciones|Nivel de Acceso",
  236: "Restricciones|Código de Acceso",
  237: "Recuperando el historial de tiempo de funcionamiento diario",
  238: "Recuperando el historial de tiempo de funcionamiento mensual",
  239: "Intentar otra vez",
  240: "Historial Tiempo de Funcionamiento",
  241: "Guardar",
  242: "Guardar Como",
  243: "Horarios Guardados",
  244: "Guardando Restricciones de Acceso…",
  245: "Guardando Alertas…",
  246: "Horarios",
  247: "No se pudo habilitar los horarios.  Por favor intente nuevamente más tarde.",
  248: "Horarios habilitados.",
  249: "Los horarios están deshabilitados en este termostato.  ¿Habilitar horarios?",
  250: "SELECCIONAR PÁGINA",
  251: "Enviar sugerencias o realimentación",
  252: "Servicio No Disponible",
  253: "Ajuste un PIN de #{LENGTH}#-dígitos",
  254: "Ajuste un PIN de 8 dígitos",
  255: "Puntos de Ajuste",
  256: "Ajustando enfriamiento a #{SETPOINTCOOL}#",
  257: "Ajustando calefacción a #{SETPOINTHEAT}#",
  258: "Ajustando calefacción a #{SETPOINTHEAT}# y enfriamiento a #{SETPOINTCOOL}#",
  259: "Ajustes",
  260: "Registrarse",
  261: "Regístrese",
  262: "Regístrese Ahora",
  264: "Algo falló mientras se mostraba esta página.",
  266: "Enviar",
  267: "#{NAME}# Inscrito exitosamente",
  268: "Soporte y Realimentación",
  270: "Términos y Condiciones",
  271: "Términos de Uso",
  272: "Gracias.  Debe recibir un correo en breve con #{REQUESTEDEMAIL}#.  El correo puede tardar de 5-10 minutos en llegar.",
  274: "Los siguientes paquetes de fuente abierta son utilizado por la aplicación Móvil de Pivot™.",
  275: "El siguiente periodo está muy cerca del nuevo periodo creado.",
  276: "El periodo anterior está muy cerca al nuevo periodo creado.",
  277: "Tiempo de solicitud agotado.",
  280: "Termostatos",
  281: "La acción no puede ser completada debido a que su cuentea tiene un mínimo de un edificio.",
  282: "Este grupo está vacío.  Edite el grupo para añadir dispositivos.",
  283: "Este dispositivo móvil necesita ser re autenticado.",
  284: "Esta operación no puede ser realizada mientras el dispositivo se encuentra fuera de línea.",
  285: "Este termostato no es compatible con Trane Pivot.",
  286: "Para configurar alertas para un solo termostato haga clic en el ícono de Ajustes -",
  287: "Para inscribir este termostato en #{BUILDINGNAME}# haga clic en Obtener Código para generar un código de 5 dígitos para usted e ingresarlo en el termostato.",
  288: "Para inscribir este termostato bajo un edificio diferente haga clic en Tableros de Edificio seleccione el edificio deseado y luego vuelva a seleccionar el dispositivo en el menú.",
  289: "Para suscribirse o modificar sus alertas suscritas presione el botón Suscripciones de Alertas arriba.",
  291: "Deshacer",
  292: "Des inscribir #{NAME}#",
  294: "Desbloquear Aplicación",
  295: "Desbloquear con biometría",
  296: "Desbloquear con PIN",
  297: "Desbloquear con PIN únicamente",
  298: "Desocupado",
  299: "Utilizar Código de 12 dígitos",
  300: "Nombre de usuario",
  301: "Nombre de usuario y Contraseña",
  302: "Es necesario un nombre de usuario",
  303: "Usuarios",
  304: "Versión",
  305: "No podemos comunicarnos con los servidores de Pivot.  El acceso de internet se requiere para que esta aplicación trabajar apropiadamente.  Por favor verifique sus ajustes de Wi-Fi o datos e intente de nuevo.",
  306: "Bienvenido a Pivot",
  307: "Sí",
  309: "Usted no puede borrar el último periodo de tiempo.",
  310: "Usted no ha guardado aún ningún horario.",
  311: "Su cuenta ha sido creado.  Por favor tome un momento para llenar algunos detalles adicionales.",
  312: "Su red no está disponible.  Verifique sus datos o conexión de Wi-Fi.",
  313: "El nombre del periodo no puede estar vacío.",
  314: "El nombre del periodo no puede contener emojis o caracteres especiales.",
  315: "Alertas de Falla de Termostato Habilitado",
  316: "Guardando Puntos de Ajuste…",
  317: "Puntos de Ajuste guardados exitosamente.",
  318: "Error inesperado",
  319: "¿Aplicar puntos de ajuste a termostatos adicionales?",
  320: "¿Desea utilizar su PIN para desbloquear la aplicación cuando la abra?",
  321: "¿Le gustaría utilizar su #{BIOMETRICSTRING}# para desbloquear su aplicación cuando la abra? Su PIN será utilizado si el #{BIOMETRICSTRING}# falla.",
  322: "Ingrese el nombre de usuario y contraseña de su Pivot para restablecer su PIN",
  323: "Guardando PINs…",
  324: "PINs guardados exitosamente.",
  325: "¿Aplicar PINs a termostatos adicionales?",
  326: "El PIN debe ser de cuatro dígitos numéricos",
  327: "Código de Acceso Menú Principal Habilitado",
  328: "Código de Acceso Menú 4 Dígitos",
  329: "Código de Acceso Técnico Habilitado",
  330: "Código de Acceso Menú Técnicos 4 Dígitos",
  331: "para ese termostato.",
  332: "Nuestro equipo de desarrolladores ha sido notificado acerca del problema y esta trabajando en un arreglo.",
  333: "La página debe ser encontrado.",
  334: "Guardando",
  335: "Diciéndole #{NAME}# a #{ACTION}#",
  336: "Esta acción no puede ser completada porque este edificio contiene dispositivos inscritos.",
  337: "Detalles de Dispositivos",
  338: "El termostato no está actualmente conectado.",
  339: "Términos y condiciones del Acuerdo de licencia de usuario final.",
  340: "¿Esta seguro que desea descartar cualquier cambio al horario?",
  341: "Descartar",
  342: "Debe darle un nombre al horario.",
  343: "Guardar Horarios",
  344: "Guardar horario actual como #{NAME}#",
  345: "Guardar horarios",
  346: "[#{NAME}] ya existe. \n¿Desea remplazarlo?",
  347: "No puede cargar ese horario",
  348: "#{NAME}# no es válido y no puede ser cargado.",
  349: "#{NAME}# no concuerda la escala de temperatura del termostato.",
  350: "Borrando '#{NAME}#'",
  351: "Guardando horario de termostato",
  352: "Guardando horarios…",
  353: "Horario guardado exitosamente.",
  354: "¿Aplicar horarios a termostatos adicionales?",
  355: '"#{NAME}#" Cargado',
  356: "No hay nada allí aún.",
  357: "Nota",
  358: "El modo Demo permite navegar a través de la aplicación del Pivot y explorar como opera.  Cuando utilice la aplicación de Pivot en este modo, cualquier cambio que realice no será guardado.",
  359: "Idioma",
  360: "Ajustar automáticamente a través de este dispositivo",
  361: "Guardando Idioma…",
  362: "Seleccione Idioma",
  363: "Se requiere valor.",
  364: "Editar",
  365: "Horario Activo",
  366: "Código Soporte",
  367: "Versión Chrome",
  368: "Vista Web",
  369: "Desconocido",
  370: "Contraseña",
  371: "Usuario Móvil",
  372: "Código Soporte",
  373: "CALEFACCIÓN",
  374: "ENFRIAMIENTO",
  375: "APAGADO",
  376: "Fecha muy temprana",
  377: "Fecha muy tarde",
  378: "en",
  379: "a las",
  380: "por",
  381: "Evento Dispositivo",
  382: "Evento Horario",
  383: "Navegadores Web",
  384: "Suscripción Alerta",
  385: "Filtro",
  386: "Inscribir #{DEVICE}#",
  387: "Inscribiendo #{DEVICE}#",
  388: "Lun",
  389: "Mar",
  390: "Mie",
  391: "Jue",
  392: "Vie",
  393: "Sáb",
  394: "Ene",
  395: "¿Está seguro de que desea restablecer su contraseña?",
  396: "Aleta enviada cuando la humedad está por encima",
  397: "Aleta enviada cuando la humedad está por debajo",
  398: "Alerta de Humedad Ambiente Habilitado",
  399: "SP_The software included in this product contains copyrighted software that is licensed under the GPL, LGPL or other copyleft license. A copy of those licenses is included herewith.  You may obtain the complete corresponding source code from us for a period of three years after our last shipment of this product by sending a request letter to:",
  400: "Trane Commercial HVAC",
  401: "Attn: Open Source Compliance",
  402: "800-E Beaty St.",
  403: "PO Box 940",
  404: "Davidson, NC 28036",
  405: "Please include the name of the product and, if applicable, the version number of the software in the request letter. This offer is valid to anyone in receipt of this information._SP",
  406: "Para transferir su cuenta, ingrese su contraseña",
  407: "Transferir Cuenta",
  409: "Cargando Transferencia de Cuenta",
  410: "¡Hola!",
  411: "Complete los campos a continuación para activar la cuenta Pivot que se le transfirió",
  412: "Alertas de Falla del Termostato",
  413: "Habilitado",
  414: "Deshabilitado",
  415: "Alerta de Temperatura Ambiente",
  416: "Alerta de Humedad Ambiente",
  417: "encima",
  418: "debajo",
  419: "Enviar notificación de alerta en",
  420: "Alerta habilitada",
  421: "Alerta",
  422: "El nombre de usuario está vinculado permanentemente a la cuenta. Cree un nombre de usuario significativo para el propietario.",
  423: "Suscripción de Alerta Usuarios",
  424: "Termostatos que este usuario puede controlar",
  425: "Agregar contacto",
  426: "Recibe alertas seleccionadas en",
  427: "Editar Ajustes",
  428: "Borrar Contacto",
  429: "Suscripciones a alertas de usuario",
  430: "Enviar a",
  431: "al",
  432: "Número de Teléfono",
  433: "Todos",
  434: "Customizado",
  435: "Recibir estas alertas",
  436: "El límite alto y bajo no pueden ser iguales",
  437: "El límite superior debe ser mayor que el límite inferior",
  438: "Mis alertas de notificaciones automáticas",
  439: "este Dispositivo Móvil"
};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MemoryRouter; });
/* unused harmony export Prompt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Switch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return context; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return matchPath; });
/* unused harmony export useHistory */
/* unused harmony export useLocation */
/* unused harmony export useParams */
/* unused harmony export useRouteMatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return withRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? warning(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : children : component ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
      false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

var useContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext;
function useHistory() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useHistory()") : invariant(false) : void 0;
  }

  return useContext(context).history;
}
function useLocation() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useLocation()") : invariant(false) : void 0;
  }

  return useContext(context).location;
}
function useParams() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useParams()") : invariant(false) : void 0;
  }

  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useRouteMatch()") : invariant(false) : void 0;
  }

  return path ? matchPath(useLocation().pathname, path) : useContext(context).match;
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}


//# sourceMappingURL=react-router.js.map


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(264);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(830);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(160),
    isObject = __webpack_require__(102);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 406 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 407 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(138),
    isKey = __webpack_require__(837),
    stringToPath = __webpack_require__(838),
    toString = __webpack_require__(858);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(841),
    mapCacheDelete = __webpack_require__(853),
    mapCacheGet = __webpack_require__(855),
    mapCacheHas = __webpack_require__(856),
    mapCacheSet = __webpack_require__(857);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 410 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(198);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(861);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatServerErrors;
/* unused harmony export bpfrpt_proptype_ServerError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 // The server responds with different error formats depending on the source, such
// as backstage options, error keys, arrays, etc. We always use them as
// Array<{errorMessage: string}>

var bpfrpt_proptype_ServerError = {
  errorMessage: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

function warnUnparseableError(badError, context) {
  // We don't recognize this as an error message. Tell Sentry and bail.
  __WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.captureMessage("Received unparseable errors from server.", {
    level: "warning",
    extra: {
      providedError: badError,
      context: context
    }
  });
}

function formatServerErrors(errors, context) {
  if (typeof errors === "string") {
    return [{
      errorMessage: errors
    }];
  }

  if (!Array.isArray(errors)) {
    warnUnparseableError(errors, context);
    return [];
  }

  return errors.map(function (error) {
    if (typeof error === "string") {
      return {
        errorMessage: error
      };
    }

    if (typeof error.message === "string") {
      var message = error.message,
          rest = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(error, ["message"]);

      return _objectSpread({
        errorMessage: message
      }, rest);
    }

    if (typeof error.errorMessage === "string") {
      return _objectSpread({}, error);
    }

    warnUnparseableError(error, context);
    return null;
  }).filter(Boolean);
}



/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_location__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_schema__ = __webpack_require__(52);












var LocationCollection =
/*#__PURE__*/
function (_BaseCollection) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(LocationCollection, _BaseCollection);

  function LocationCollection() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, LocationCollection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(LocationCollection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "model", __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_location__["a" /* default */]);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "childSchemaHref", "".concat(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_local_settings__["c" /* default */].getHost(), "/mobile/houses/new"));

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(LocationCollection, [{
    key: "getChildSchema",
    value: function getChildSchema() {
      var schema = new __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_schema__["a" /* default */]();

      if (this.childSchemaHref == null) {
        return Promise.reject(new Error("Cannot get child schema on location collection with no child schema link"));
      }

      schema.setUrl(this.childSchemaHref);
      return schema.fetch().then(function () {
        return schema;
      });
    }
  }]);

  return LocationCollection;
}(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_collection__["a" /* default */]);



/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_mixins_pageable__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_mixins_filterable__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_date_range_filter_schema__ = __webpack_require__(417);









var EventCollection =
/*#__PURE__*/
function (_BaseCollection) {
  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits___default()(EventCollection, _BaseCollection);

  function EventCollection() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, EventCollection);

    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default()(EventCollection).apply(this, arguments));
  }

  return EventCollection;
}(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_base_collection__["a" /* default */]);

_.extend(EventCollection.prototype, __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_mixins_pageable__["a" /* default */]);

_.extend(EventCollection.prototype, __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_mixins_filterable__["a" /* default */], {
  getFilterSchemaClass: function getFilterSchemaClass() {
    return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_date_range_filter_schema__["a" /* default */];
  }
});

/* harmony default export */ __webpack_exports__["a"] = (EventCollection);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_url__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_schema__ = __webpack_require__(52);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/* harmony default export */ __webpack_exports__["a"] = ({
  parseLinksFilter: function parseLinksFilter(links) {
    var link = links[0];

    if (link) {
      var FilterSchema = this.getFilterSchemaClass();
      this._filterSchema = new FilterSchema(link.getData(), {
        parse: true
      });
      this._filterTemplateLink = link.href;

      if (this.clonedResource) {
        this.clonedResource._filterSchema = this._filterSchema;
        this.clonedResource._filterTemplateLink = this._filterTemplateLink;
      }
    } else {
      this._filterSchema = null;
      this._filterTemplateLink = null;

      if (this.clonedResource) {
        this.clonedResource._filterSchema = null;
        this.clonedResource._filterTemplateLink = null;
      }
    }
  },
  getFilterSchemaClass: function getFilterSchemaClass() {
    return __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_schema__["a" /* default */];
  },
  getFilterSchema: function getFilterSchema() {
    return this._filterSchema;
  },
  applyFilterParams: function applyFilterParams() {
    var _this = this;

    var filterLink = __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_url__["a" /* default */].expandTemplate(this._filterTemplateLink, this._filterSchema.attributes);
    return this.fetchUrlWithResourceClone(filterLink).then(function (newCollection) {
      _this.reset(newCollection.models);
    });
  },
  clearFilter: function clearFilter() {
    var defaultValues = this._filterSchema.get("default_values");

    this._filterSchema.set(defaultValues);

    this._filterSchema.schemaFields = this._filterSchema.schemaFields.map(function (field) {
      return _objectSpread({}, field, {
        value: defaultValues[field.name]
      });
    });
    this.trigger("sync"); // Re-render collection if necessary
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateRangeFilterSchema; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_schema__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nx_components_Locales__ = __webpack_require__(44);









var DateRangeFilterSchema =
/*#__PURE__*/
function (_Schema) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(DateRangeFilterSchema, _Schema);

  function DateRangeFilterSchema() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DateRangeFilterSchema);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DateRangeFilterSchema).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DateRangeFilterSchema, [{
    key: "onParse",
    value: function onParse(rawAttrs) {
      var attrs = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DateRangeFilterSchema.prototype), "onParse", this).call(this, rawAttrs); // Add date range validation to the start_date and end_date fields


      if (this.validations.end_date) {
        this.validations.end_date.fn = this._getDateErrorMessage;
      }

      if (this.validations.start_date) {
        this.validations.start_date.fn = this._getDateErrorMessage;
      }

      return attrs;
    }
  }, {
    key: "_getDateErrorMessage",
    value: function _getDateErrorMessage(value, attr) {
      var isBefore = attr === "end_date";
      var localeSet = Object(__WEBPACK_IMPORTED_MODULE_7_nx_components_Locales__["b" /* getLanguageSet */])();
      var language = localeSet.nexia_mobile.pages.EventsPage;
      var endDate = isBefore ? value : this.get("end_date");
      var startDate = isBefore ? this.get("start_date") : value;
      endDate = Date.parse(endDate);
      startDate = Date.parse(startDate);

      if (!isBefore && startDate > Date.now()) {
        // When validating the after date, it should not be later than today
        return language.dateToLate;
      }

      if (isNaN(endDate) || isNaN(startDate)) {
        return null; // A value is unset: no error
      }

      if (endDate < startDate) {
        // When both dates are defined, endDate cannot be before startDate
        return isBefore ? language.dateToEarly : language.dateToLate;
      }

      return null;
    }
  }]);

  return DateRangeFilterSchema;
}(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_schema__["a" /* default */]);



/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  serializedIcon: function serializedIcon() {
    var icon = this.get("icon");

    if (_.isObject(icon)) {
      // Object or Array
      return JSON.stringify(icon);
    } else {
      return icon;
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeviceCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_device__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_device_sorter__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_framework_resource__ = __webpack_require__(85);














var DeviceCollection =
/*#__PURE__*/
function (_BaseCollection) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(DeviceCollection, _BaseCollection);

  function DeviceCollection() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DeviceCollection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(DeviceCollection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "model", __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_device__["a" /* default */]);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(DeviceCollection, [{
    key: "parse",
    value: function parse(attrs) {
      var _get2;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var devices = (_get2 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(DeviceCollection.prototype), "parse", this)).call.apply(_get2, [this, attrs].concat(args));

      return __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_device_sorter__["a" /* default */].sort(this._recycleDevices(attrs, devices));
    }
  }, {
    key: "_parseModelsAsync",
    value: function _parseModelsAsync(attrs) {
      var _get3;

      var _len3,
          args,
          _key3,
          devices,
          _args = arguments;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.async(function _parseModelsAsync$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              for (_len3 = _args.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                args[_key3 - 1] = _args[_key3];
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap((_get3 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(DeviceCollection.prototype), "_parseModelsAsync", this)).call.apply(_get3, [this, attrs].concat(args)));

            case 3:
              devices = _context.sent;
              return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_device_sorter__["a" /* default */].sort(this._recycleDevices(attrs, devices)));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "_recycleDevices",
    value: function _recycleDevices(attrs, devices) {
      var items = attrs.items || attrs.result;

      if (!items) {
        return devices;
      } // Jump through hoops to try to find an existing Device
      // model and just set attributes on it, if one is available.


      return devices.map(function (device, index) {
        var deviceData = items[index];
        var existingDevice = __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_framework_resource__["a" /* ResourceMap */].findByHref(device.id);

        if (existingDevice) {
          delete deviceData.id;
          return existingDevice.set(deviceData, {
            parse: true
          });
        } else {
          return device;
        }
      });
    }
  }]);

  return DeviceCollection;
}(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_base_collection__["a" /* default */]);



/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserCodeSchema; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_backstage__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_schema__ = __webpack_require__(52);








var UserCodeSchema =
/*#__PURE__*/
function (_Schema) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(UserCodeSchema, _Schema);

  function UserCodeSchema() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, UserCodeSchema);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(UserCodeSchema).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(UserCodeSchema, [{
    key: "monitorStatus",
    value: function monitorStatus() {
      var _this = this;

      if (this.get("statusUrl") == null) {
        return;
      }

      new __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_backstage__["a" /* default */](this.get("statusUrl"), {
        pollingUpdate: function pollingUpdate(data) {
          _this.set("message", data.message);

          _this.trigger("userCodeSave:update", _this);

          if (data.progress != null) {
            _this.set("progress", data.progress.completed_steps / data.progress.total_steps);

            _this.trigger("progressUpdate", _this);
          }
        },
        success: function success() {
          _this.trigger("userCodeSave:success", _this);
        },
        error: function error(errors) {
          _this.trigger("userCodeSave:failure", _this, errors);
        }
      }).startPolling();
    }
  }]);

  return UserCodeSchema;
}(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_schema__["a" /* default */]);



/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Battery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_icons__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable camelcase */

function Battery(feature) {
  return {
    battery_label: (feature.label || "").trim().replace(/remaining$/, ""),
    battery_updated_at: feature.updated_at,
    battery_icon: __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_icons__["a" /* default */].getString(feature.icon)
  };
}


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createGenerateClassName;

var _warning = _interopRequireDefault(__webpack_require__(49));

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;

function safePrefix(classNamePrefix) {
  var prefix = String(classNamePrefix);
   false ? (0, _warning.default)(prefix.length < 256, "Material-UI: the class name prefix is too long: ".concat(prefix, ".")) : void 0; // Sanitize the string as will be used to prefix the generated class name.

  return prefix.replace(escapeRegex, '-');
} // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js


function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
      dangerouslyUseGlobalCSS = _options$dangerouslyU === void 0 ? false : _options$dangerouslyU,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var ruleCounter = 0;
  return function (rule, styleSheet) {
    ruleCounter += 1;
     false ? (0, _warning.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0;

    if (dangerouslyUseGlobalCSS && styleSheet && styleSheet.options.name) {
      return "".concat(safePrefix(styleSheet.options.name), "-").concat(rule.key);
    }

    if (true) {
      return "".concat(productionPrefix).concat(seed).concat(ruleCounter);
    } // Help with debuggability.


    if (styleSheet && styleSheet.options.classNamePrefix) {
      return "".concat(safePrefix(styleSheet.options.classNamePrefix), "-").concat(rule.key, "-").concat(seed).concat(ruleCounter);
    }

    return "".concat(rule.key, "-").concat(seed).concat(ruleCounter);
  };
}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jssGlobal = _interopRequireDefault(__webpack_require__(902));

var _jssNested = _interopRequireDefault(__webpack_require__(923));

var _jssCamelCase = _interopRequireDefault(__webpack_require__(925));

var _jssDefaultUnit = _interopRequireDefault(__webpack_require__(926));

var _jssVendorPrefixer = _interopRequireDefault(__webpack_require__(928));

var _jssPropsSort = _interopRequireDefault(__webpack_require__(933));

// Subset of jss-preset-default with only the plugins the Material-UI components are using.
function jssPreset() {
  return {
    plugins: [(0, _jssGlobal.default)(), (0, _jssNested.default)(), (0, _jssCamelCase.default)(), (0, _jssDefaultUnit.default)(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : (0, _jssVendorPrefixer.default)(), (0, _jssPropsSort.default)()]
  };
}

var _default = jssPreset;
exports.default = _default;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(903);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(206);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(425);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(904);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(161);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(270);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(428);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(911);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(906);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(139);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(429);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(910);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var maxRules = 1e10;


var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(427);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(161);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable-next-line no-use-before-define */
var StyleSheet = function () {
  function StyleSheet(styles, options) {
    var _this = this;

    _classCallCheck(this, StyleSheet);

    this.update = function (name, data) {
      if (typeof name === 'string') {
        _this.rules.update(name, data);
      } else {
        _this.rules.update(name);
      }
      return _this;
    };

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var _name in styles) {
      this.rules.add(_name, styles[_name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var _name2 in styles) {
        added.push(this.addRule(_name2, styles[_name2], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'toString',


    /**
     * Convert rules to a CSS string.
     */
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(934);

var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiThemeProviderOld = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(2));

var _createClass2 = _interopRequireDefault(__webpack_require__(3));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(5));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(4));

var _inherits2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(40));

var _warning = _interopRequireDefault(__webpack_require__(49));

var _brcast = _interopRequireDefault(__webpack_require__(935));

var _utils = __webpack_require__(80);

var _themeListener = _interopRequireWildcard(__webpack_require__(273));

/* eslint-disable no-underscore-dangle */

/**
 * This component takes a `theme` property.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
var MuiThemeProviderOld =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MuiThemeProviderOld, _React$Component);

  // We are not using the React state in order to avoid unnecessary rerender.
  function MuiThemeProviderOld(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, MuiThemeProviderOld);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MuiThemeProviderOld).call(this)); // Get the outer theme from the context, can be null

    _this.broadcast = (0, _brcast.default)();
    _this.outerTheme = _themeListener.default.initial(context); // Propagate the theme so it can be accessed by the children

    _this.broadcast.setState(_this.mergeOuterLocalTheme(props.theme));

    return _this;
  }

  (0, _createClass2.default)(MuiThemeProviderOld, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _ref;

      var _this$props = this.props,
          disableStylesGeneration = _this$props.disableStylesGeneration,
          sheetsCache = _this$props.sheetsCache,
          sheetsManager = _this$props.sheetsManager;
      var muiThemeProviderOptions = this.context.muiThemeProviderOptions || {};

      if (disableStylesGeneration !== undefined) {
        muiThemeProviderOptions.disableStylesGeneration = disableStylesGeneration;
      }

      if (sheetsCache !== undefined) {
        muiThemeProviderOptions.sheetsCache = sheetsCache;
      }

      if (sheetsManager !== undefined) {
        muiThemeProviderOptions.sheetsManager = sheetsManager;
      }

      return _ref = {}, (0, _defineProperty2.default)(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty2.default)(_ref, "muiThemeProviderOptions", muiThemeProviderOptions), _ref;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Subscribe on the outer theme, if present
      this.unsubscribeId = _themeListener.default.subscribe(this.context, function (outerTheme) {
        _this2.outerTheme = outerTheme; // Forward the parent theme update to the children

        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Propagate a local theme update
      if (this.props.theme !== prevProps.theme) {
        this.broadcast.setState(this.mergeOuterLocalTheme(this.props.theme));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribeId !== null) {
        _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
      }
    } // Simple merge between the outer theme and the local theme

  }, {
    key: "mergeOuterLocalTheme",
    value: function mergeOuterLocalTheme(localTheme) {
      // To support composition of theme.
      if (typeof localTheme === 'function') {
         false ? (0, _warning.default)(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
        return localTheme(this.outerTheme);
      }

      if (!this.outerTheme) {
        return localTheme;
      }

      return (0, _extends2.default)({}, this.outerTheme, localTheme);
    }
  }, {
    key: "render",
    value: function render() {
      // TODO move the sheetsManager property to a different component.
      // warning(
      //   typeof window !== 'undefined' || this.props.sheetsManager,
      //   [
      //     'Material-UI: you need to provide a sheetsManager to the MuiThemeProvider ' +
      //       'when rendering on the server.',
      //     'If you do not, you might experience a memory leak',
      //   ].join('\n'),
      // );
      return this.props.children;
    }
  }]);
  return MuiThemeProviderOld;
}(_react.default.Component);

exports.MuiThemeProviderOld = MuiThemeProviderOld;
 false ? MuiThemeProviderOld.propTypes = {
  /**
   * You can wrap a node.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side.
   * You can significantly speed up the traversal with this property.
   */
  disableStylesGeneration: _propTypes.default.bool,

  /**
   * @ignore
   *
   * In beta.
   */
  sheetsCache: _propTypes.default.object,

  /**
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: _propTypes.default.object,

  /**
   * A theme object.
   */
  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? MuiThemeProviderOld.propTypes = (0, _utils.exactProp)(MuiThemeProviderOld.propTypes) : void 0;
}

MuiThemeProviderOld.childContextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
MuiThemeProviderOld.contextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
/* istanbul ignore if */

if (!_utils.ponyfillGlobal.__MUI_STYLES__) {
  _utils.ponyfillGlobal.__MUI_STYLES__ = {};
}

if (!_utils.ponyfillGlobal.__MUI_STYLES__.MuiThemeProvider) {
  _utils.ponyfillGlobal.__MUI_STYLES__.MuiThemeProvider = MuiThemeProviderOld;
}

var _default = _utils.ponyfillGlobal.__MUI_STYLES__.MuiThemeProvider;
exports.default = _default;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
module.exports = exports["default"];

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sortPrefixedStyle;

var _isPrefixedProperty = __webpack_require__(944);

var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sortPrefixedStyle(style) {
  return Object.keys(style).sort(function (left, right) {
    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
      return -1;
    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
      return 1;
    }
    return 0;
  }).reduce(function (sortedStyle, prop) {
    sortedStyle[prop] = style[prop];
    return sortedStyle;
  }, {});
}
module.exports = exports['default'];

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nx_components_utils_enqueueIn__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_url__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  openFeed: function openFeed() {
    var path = this.getMediaType() === "image/jpeg" ? "jpeg_url" : "hd_url";
    var feedUrl = __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_url__["a" /* default */].withAdditionalPath(this.url(), path);
    var method = "GET";

    if (this._videoUrlLink) {
      feedUrl = this._videoUrlLink.href;
      method = this._videoUrlLink.method || "POST";
    }

    this._openFeed(feedUrl, method);
  },
  parseLinksVideoURL: function parseLinksVideoURL(links) {
    this._videoUrlLink = links[0];
  },
  closeFeed: function closeFeed() {
    var _this = this;

    if (this._videoFeedUrl == null) {
      return;
    }

    var url;
    var method;

    if (this._stopUrl) {
      url = this._stopUrl;
      method = "POST";
    } else {
      url = this._videoFeedUrl.replace(/jpeg/, "Stop");
      method = "GET";
    }

    $.ajax({
      url: url,
      type: method
    }).then(function () {
      _this.trigger("feed:close");
    }, function (xhr) {
      if (xhr && xhr.statusText === "abort") {
        return;
      }

      _this.trigger("feed:close:error", "There was an error closing the video feed.");
    });
    this._videoFeedUrl = null;
  },
  startRecording: function startRecording() {
    var _this2 = this;

    if (this._videoFeedUrl == null) {
      return;
    }

    if (this.isHD()) {
      $.ajax({
        url: this._recordUrl || __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_url__["a" /* default */].withAdditionalPath(this.url(), "start_recording"),
        type: "POST"
      }).then(function () {
        _this2.trigger("feed:record");
      }, function (xhr) {
        if (xhr && xhr.statusText === "abort") {
          return;
        }

        _this2.trigger("feed:record:error", "An error occurred starting the recording.");
      });
    } else {
      this.trigger("feed:record");
    }
  },
  isHD: function isHD() {
    return this.get("quality") === "hd";
  },
  getMediaType: function getMediaType(isLive) {
    var mediaTypeFromAttributes = this.get("mediaType");

    if (mediaTypeFromAttributes) {
      return mediaTypeFromAttributes;
    } else if (this.isHD()) {
      return isLive ? "application/x-mpegURL" : "video/mp4";
    } else {
      return "image/jpeg";
    }
  },
  enableWaitingForValidFeed: function enableWaitingForValidFeed(yesno) {
    this._waitForValidFeed = yesno;
  },
  canPanTilt: function canPanTilt() {
    return false;
  },
  _openFeed: function _openFeed(url, method) {
    var _this3 = this;

    $.ajax({
      url: url,
      type: method
    }).then(function (data) {
      _this3._processFeedResult(data);
    }, function (xhr) {
      if (xhr && xhr.statusText === "abort") {
        return;
      }

      _this3.trigger("feed:error", "There was an error opening the video feed.");
    });
  },
  _processFeedResult: function _processFeedResult(passedData) {
    var data = passedData;

    if (data.result != null) {
      data = data.result;
    }

    this._videoFeedUrl = data.url;
    this._recordUrl = data.record_url;
    this._stopUrl = data.stop_url;

    if (this._waitForValidFeed) {
      this._pollUntilValid(this._videoFeedUrl);
    } else {
      this._triggerFeedOpenEvent(this._videoFeedUrl);
    }
  },
  _pollUntilValid: function _pollUntilValid(url) {
    var _this4 = this;

    var attempts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (attempts >= 20) {
      this.trigger("feed:error", "There was an error opening the video feed.");
      return;
    }

    $.ajax({
      url: url,
      type: "GET"
    }).done(function () {
      _this4._triggerFeedOpenEvent(url);
    }).fail(function (xhr) {
      if (xhr && xhr.statusText === "abort") {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0_nx_components_utils_enqueueIn__["b" /* default */])(function () {
        return _this4._pollUntilValid(url, attempts + 1);
      }, 500);
    });
  },
  _triggerFeedOpenEvent: function _triggerFeedOpenEvent(url) {
    this.trigger("feed:open", url);
  }
});

/***/ }),
/* 435 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(212);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(435);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(280).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(437);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(282).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(162);
util.inherits = __webpack_require__(142);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(1015);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(1016);
var destroyImpl = __webpack_require__(438);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(123);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(284).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(123);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(284).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(141)))

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(280).EventEmitter;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(212);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(123);

/*<replacement>*/
var util = __webpack_require__(162);
util.inherits = __webpack_require__(142);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(393);

var iterableToArray = __webpack_require__(391);

var nonIterableRest = __webpack_require__(394);

function _toArray(arr) {
  return arrayWithHoles(arr) || iterableToArray(arr) || nonIterableRest();
}

module.exports = _toArray;

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_app_state__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Pages_InternetRequiredPage__ = __webpack_require__(1031);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var InternetRequiredRoute = function InternetRequiredRoute(_ref) {
  var isNetworkConnected = _ref.isNetworkConnected,
      appState = _ref.appState,
      _render = _ref.render,
      component = _ref.component,
      children = _ref.children,
      providedProps = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["isNetworkConnected", "appState", "render", "component", "children"]);

  return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["c" /* Route */] // Now convert all the render behaviors into a function so we can insert
  // an InternetRequiredPage.
  , __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
    render: function render(renderProps) {
      if (!appState.inDemoMode && isNetworkConnected === false) {
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Pages_InternetRequiredPage__["a" /* default */], null);
      } else if (component) {
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](component, renderProps);
      } else if (_render) {
        return _render(renderProps);
      } else if (typeof children === "function") {
        return children(renderProps);
      } else if (children != null) {
        return children;
      }

      throw new Error("Attempted to render ".concat(renderProps.location.pathname, ", but was not provided a render, component, or children prop."));
    }
  }, providedProps));
};

InternetRequiredRoute.propTypes = _objectSpread({
  isNetworkConnected: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  // not required because undefined is allowed
  appState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_app_state__["a" /* default */]).isRequired
}, __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["c" /* Route */].propTypes);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  isNetworkConnected: "isNetworkConnected",
  appState: "appState"
}, InternetRequiredRoute));

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(169),
    isSymbol = __webpack_require__(490);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var Divider =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Divider, _React$Component);

  function Divider() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Divider);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Divider).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Divider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          colors = _this$props.colors,
          style = _this$props.style;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("hr", {
        style: _objectSpread({
          margin: 0,
          height: 1,
          border: "none",
          backgroundColor: colors.DIVIDER
        }, style),
        "aria-hidden": true
      });
    }
  }]);

  return Divider;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Divider, "propTypes", {
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  },
  style: function style() {
    return (typeof StylesObject === "function" ? __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(StylesObject) : __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["c" /* withColorsProvider */])(Divider));



/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppContainerBreakpointProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_throttle__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Theme__ = __webpack_require__(18);











var LARGE_LAYOUT_BREAKPOINT = 800;

function getSafeViewportSize() {
  // iPhone X has a "safe area" which is smaller than the viewport size. It has
  // to be accessed through CSS env() values, so typically we use calc() to
  // inset the content. However, calc() is not supported in media queries, so in
  // order to determine the size of the safe area for laying out the app, we need
  // to use a non-media-query solution.
  var viewport = document.createElement("div");
  Object.assign(viewport.style, {
    position: "absolute",
    pointerEvents: "none",
    top: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.SAFE_AREA_TOP,
    right: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.SAFE_AREA_RIGHT,
    bottom: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.SAFE_AREA_BOTTOM,
    left: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.SAFE_AREA_LEFT
  });
  document.body.appendChild(viewport);
  var size = viewport.clientWidth;
  document.body.removeChild(viewport);
  return size;
}

var AppContainerBreakpointProvider =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AppContainerBreakpointProvider, _React$Component);

  function AppContainerBreakpointProvider() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AppContainerBreakpointProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AppContainerBreakpointProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      isLargeAppLayout: false
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_examineViewport", __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default()(function () {
      var size = getSafeViewportSize();
      var isLargeAppLayout = size > LARGE_LAYOUT_BREAKPOINT;

      if (_this.state.isLargeAppLayout !== isLargeAppLayout) {
        _this.setState({
          isLargeAppLayout: isLargeAppLayout
        });
      }
    }, 16));

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AppContainerBreakpointProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        isLargeAppLayout: this.state.isLargeAppLayout
      };
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      window.addEventListener("resize", this._examineViewport);

      this._examineViewport();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this._examineViewport);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return AppContainerBreakpointProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AppContainerBreakpointProvider, "childContextTypes", {
  isLargeAppLayout: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AppContainerBreakpointProvider, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node.isRequired
});




/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return casing; });
/* unused harmony export template */
var casing = function casing(string, format) {
  // Many single-word strings are duplicates that have difference casings.
  // Multi-word strings are generally expected to be formatted correctly already.
  var base = string.toLowerCase();
  var result;

  switch (format) {
    case "upper":
      result = base.toUpperCase();
      break;

    case "lower":
      break;

    case "capitalizeFirst":
      result = base.charAt(0).toUpperCase() + base.slice(1);
      break;
  }

  return result;
};
var template = function template(string, templates) {
  var newString = string;
  var keys = Object.keys(templates);
  keys.forEach(function (key) {
    var regex = new RegExp("#{".concat(key.toUpperCase(), "}#"), "g");
    newString = newString.replace(regex, templates[key]);
  });
  return newString;
};

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DrawerRevealerProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DrawerRevealer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_AppBar__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_Icons__ = __webpack_require__(23);










var DrawerRevealerProvider =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DrawerRevealerProvider, _React$Component);

  function DrawerRevealerProvider() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DrawerRevealerProvider);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DrawerRevealerProvider).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DrawerRevealerProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this = this;

      return {
        handleDrawerRevealerTap: function handleDrawerRevealerTap() {
          return _this.props.onDrawerRevealerTap();
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return DrawerRevealerProvider;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DrawerRevealerProvider, "propTypes", {
  onDrawerRevealerTap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DrawerRevealerProvider, "childContextTypes", {
  handleDrawerRevealerTap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
});

var DrawerRevealer =
/*#__PURE__*/
function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DrawerRevealer, _React$Component2);

  function DrawerRevealer() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DrawerRevealer);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DrawerRevealer).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DrawerRevealer, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nx_components_AppBar__["c" /* AppBarIconWrapper */], {
        onTap: this.context.handleDrawerRevealerTap,
        "aria-label": "Menu"
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_Icons__["U" /* IconHamburgerMenu */], null));
    }
  }]);

  return DrawerRevealer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DrawerRevealer, "contextTypes", {
  handleDrawerRevealerTap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
});



/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(2));

var _createClass2 = _interopRequireDefault(__webpack_require__(3));

var _style = _interopRequireDefault(__webpack_require__(1060));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(1068));

var _ownerDocument = _interopRequireDefault(__webpack_require__(146));

var _isOverflowing = _interopRequireDefault(__webpack_require__(1069));

var _manageAriaHidden = __webpack_require__(451);

function findIndexOf(data, callback) {
  var idx = -1;
  data.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function getPaddingRight(node) {
  return parseInt((0, _style.default)(node, 'paddingRight') || 0, 10);
}

function setContainerStyle(data) {
  // We are only interested in the actual `style` here because we will override it.
  data.style = {
    overflow: data.container.style.overflow,
    paddingRight: data.container.style.paddingRight
  };
  var style = {
    overflow: 'hidden'
  };

  if (data.overflowing) {
    var scrollbarSize = (0, _scrollbarSize.default)(); // Use computed style, here to get the real padding to add our scrollbar width.

    style.paddingRight = "".concat(getPaddingRight(data.container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

    var fixedNodes = (0, _ownerDocument.default)(data.container).querySelectorAll('.mui-fixed');

    for (var i = 0; i < fixedNodes.length; i += 1) {
      var paddingRight = getPaddingRight(fixedNodes[i]);
      data.prevPaddings.push(paddingRight);
      fixedNodes[i].style.paddingRight = "".concat(paddingRight + scrollbarSize, "px");
    }
  }

  Object.keys(style).forEach(function (key) {
    data.container.style[key] = style[key];
  });
}

function removeContainerStyle(data) {
  // The modal might be closed before it had the chance to be mounted in the DOM.
  if (data.style) {
    Object.keys(data.style).forEach(function (key) {
      data.container.style[key] = data.style[key];
    });
  }

  var fixedNodes = (0, _ownerDocument.default)(data.container).querySelectorAll('.mui-fixed');

  for (var i = 0; i < fixedNodes.length; i += 1) {
    fixedNodes[i].style.paddingRight = "".concat(data.prevPaddings[i], "px");
  }
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager =
/*#__PURE__*/
function () {
  function ModalManager() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, ModalManager);
    var _options$hideSiblingN = options.hideSiblingNodes,
        hideSiblingNodes = _options$hideSiblingN === void 0 ? true : _options$hideSiblingN,
        _options$handleContai = options.handleContainerOverflow,
        handleContainerOverflow = _options$handleContai === void 0 ? true : _options$handleContai;
    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow; // this.modals[modalIdx] = modal

    this.modals = []; // this.data[containerIdx] = {
    //   modals: [],
    //   container,
    //   overflowing,
    //   prevPaddings,
    // }

    this.data = [];
  }

  (0, _createClass2.default)(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx !== -1) {
        return modalIdx;
      }

      modalIdx = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        (0, _manageAriaHidden.ariaHidden)(modal.modalRef, false);
      }

      if (this.hideSiblingNodes) {
        (0, _manageAriaHidden.ariaHiddenSiblings)(container, modal.mountNode, modal.modalRef, true);
      }

      var containerIdx = findIndexOf(this.data, function (item) {
        return item.container === container;
      });

      if (containerIdx !== -1) {
        this.data[containerIdx].modals.push(modal);
        return modalIdx;
      }

      var data = {
        modals: [modal],
        container: container,
        overflowing: (0, _isOverflowing.default)(container),
        prevPaddings: []
      };
      this.data.push(data);
      return modalIdx;
    }
  }, {
    key: "mount",
    value: function mount(modal) {
      var containerIdx = findIndexOf(this.data, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var data = this.data[containerIdx];

      if (!data.style && this.handleContainerOverflow) {
        setContainerStyle(data);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx === -1) {
        return modalIdx;
      }

      var containerIdx = findIndexOf(this.data, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var data = this.data[containerIdx];
      data.modals.splice(data.modals.indexOf(modal), 1);
      this.modals.splice(modalIdx, 1); // If that was the last modal in a container, clean up the container.

      if (data.modals.length === 0) {
        if (this.handleContainerOverflow) {
          removeContainerStyle(data);
        } // In case the modal wasn't in the DOM yet.


        if (modal.modalRef) {
          (0, _manageAriaHidden.ariaHidden)(modal.modalRef, true);
        }

        if (this.hideSiblingNodes) {
          (0, _manageAriaHidden.ariaHiddenSiblings)(data.container, modal.mountNode, modal.modalRef, false);
        }

        this.data.splice(containerIdx, 1);
      } else if (this.hideSiblingNodes) {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = data.modals[data.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          (0, _manageAriaHidden.ariaHidden)(nextTop.modalRef, false);
        }
      }

      return modalIdx;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
  }]);
  return ModalManager;
}();

var _default = ModalManager;
exports.default = _default;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(1061));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.ariaHiddenSiblings = ariaHiddenSiblings;
var BLACKLIST = ['template', 'script', 'style'];

function isHideable(node) {
  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
}

function siblings(container, mount, currentNode, callback) {
  var blacklist = [mount, currentNode];
  [].forEach.call(container.children, function (node) {
    if (blacklist.indexOf(node) === -1 && isHideable(node)) {
      callback(node);
    }
  });
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function ariaHiddenSiblings(container, mountNode, currentNode, show) {
  siblings(container, mountNode, currentNode, function (node) {
    return ariaHidden(node, show);
  });
}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;

var reflow = function reflow(node) {
  return node.scrollTop;
};

exports.reflow = reflow;

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
    delay: style.transitionDelay
  };
}

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var Badge =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Badge, _React$Component);

  function Badge() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Badge);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Badge).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Badge, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          style = _this$props.style,
          colors = _this$props.colors;
      var styles = {
        root: _objectSpread({
          width: "2em",
          lineHeight: "2em",
          color: colors.PRIMARY_TEXT,
          backgroundColor: colors.TEXT_SECONDARY,
          zIndex: 1,
          borderRadius: "50%",
          position: "absolute",
          right: "-5px",
          top: "-5px",
          textAlign: "center"
        }, style)
      };
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.root,
        "aria-hidden": true
      }, children);
    }
  }]);

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Badge, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node,
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["c" /* withColorsProvider */])(Badge));




/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPendingPromiseForRefreshSessionAndReturnToDashboard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_device__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_automation__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_history__ = __webpack_require__(31);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */].on("POPULATE_SESSION", function () {
  Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */])("DISABLE_LOCATION_POLLING");
  __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].session.populate().then(function () {
    Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
    Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */])("SESSION_POPULATED");
  });
});
__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */].on("FAST_POPULATE_SESSION", function () {
  __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].session.populate();
});
__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */].on("SESSION_POPULATED", function () {
  if (__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].appState.inDemoMode) {
    return;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */])("PUBLISH_SETTINGS_TO_SERVER");
  Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */])("OBTAIN_PUSH_NOTIFICATION_TOKEN");
  Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_NEWS_FROM_STARTUP");
  Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_CHOICES");
});
__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */].on("SHOW_CHOICES", function () {
  Object(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("forceChoiceDialogOpen", true);
});

var addDemoModeEventToStore = function addDemoModeEventToStore(event, model) {
  var matches = model.get("id").match(/\d+$/);

  if (matches == null) {
    // The model url doesn't match the expected format (ending with a number);
    // don't try to add an event for it.
    return;
  }

  var id = matches[0];
  var filter = "_NO_FILTER_";

  if (model instanceof __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_device__["a" /* default */]) {
    filter = "device_id=".concat(id);
  } else if (model instanceof __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_automation__["a" /* default */]) {
    filter = "automation_id=".concat(id);
  }

  var newEvents = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].demoModeEvents, {
    _NO_FILTER_: [// All events go into the 'no filter' array
    event].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].demoModeEvents._NO_FILTER_ || []))
  });

  if (filter !== "_NO_FILTER_") {
    newEvents[filter] = [event].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].demoModeEvents[filter] || []));
  }

  Object(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("demoModeEvents", newEvents);
};

__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */].on("PARSED_DEMO_MODE_EVENT", function (event, model) {
  addDemoModeEventToStore(event, model);
});
__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */].on("DEMO_MODE_EVENT", function (model, description) {
  var user = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Demo User";
  var occurredAt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Date().toISOString();

  if (!__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].appState.inDemoMode) {
    return;
  }

  var event = {
    /* eslint-disable camelcase */
    device_name: model.get("name"),
    user_name: user,
    description: description,
    occurred_at: occurredAt
    /* eslint-enable camelcase */

  }; // We have to keep all the events in the Store instead of relying on the ones
  // in the Location's events collection and the Device/Automation's events
  // collection because when you change the filter on the "Events" page, it
  // actually mutates the events in the collection. This works out in the real
  // world where we fetch events every time that page is shown (thereby filling
  // the collection up with the right events again), because the events are in
  // the serverside database. But in demo mode, there's no serverside database,
  // so the Store is our stand-in.

  addDemoModeEventToStore(event, model);
});

var handleReturnToDashboard = function handleReturnToDashboard() {
  if (__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].session.hasMultipleLocations()) {
    __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].appState.resetCurrentLocation();
  }

  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app/home");
};

var newPromiseRefreshSession = function newPromiseRefreshSession(handlerToDashboard) {
  var devices = __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].session.get("locations").first().get("devices");
  return new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].session.populate().then(function () {
      var finishRefresh = _.once(function () {
        resolve();

        if (handlerToDashboard) {
          handlerToDashboard();
        }
      }); // The response is parsed asynchronously, wait until devices actually update.


      devices.once("update", finishRefresh); // but if they never do, still hide the spinner 10 seconds after the fetch finishes

      setTimeout(finishRefresh, 10000);
    });
  });
};

var returnToDashboardPromise = Promise.resolve();
__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */].on("REFRESH_SESSION_AND_RETURN_TO_DASHBOARD", function () {
  if (!__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].appState && !__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].appState.currentLocation) {
    return;
  }

  returnToDashboardPromise = newPromiseRefreshSession(handleReturnToDashboard);
}); // TODO: Better answer for async actions (probably won't have it until we're using redux)

function getPendingPromiseForRefreshSessionAndReturnToDashboard() {
  return returnToDashboardPromise;
}

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Page__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Scrollable_ScrollableArea__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_OverlayLinearProgress__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);








var NoDevicesPageCommercial = function NoDevicesPageCommercial(props) {
  var appBar = props.appBar,
      showDeviceAdd = props.showDeviceAdd,
      backgroundLoading = props.backgroundLoading,
      title = props.title;
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.NoDevicesPageCommercial;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Page__["b" /* default */], {
    name: "NoDevicesPageCommercial",
    fullyLoaded: true
  }, appBar, backgroundLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_OverlayLinearProgress__["a" /* default */], {
    indeterminate: true
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Scrollable_ScrollableArea__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      padding: "0.75em"
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, languageContext.template(language.noStatsEnrolledYetTemplate, {
    title: title
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, languageContext.template(language.tapEnrollCallToActionTemplate, {
    title: title
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      textAlign: "center"
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_nx_components_Button__["a" /* default */], {
    theme: "important",
    onTap: showDeviceAdd
  }, language.enrollNewDevicebutton)))));
};

NoDevicesPageCommercial.propTypes = {
  appBar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
  showDeviceAdd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  backgroundLoading: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  backgroundLoading: "backgroundLoading"
}, NoDevicesPageCommercial));


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_MinimalBatteryIndicator__ = __webpack_require__(457);




function BatteryIndicator(_ref) {
  var icon = _ref.icon,
      inline = _ref.inline,
      label = _ref.label,
      level = _ref.level,
      style = _ref.style;
  var fixedCornerStyle = {
    position: "absolute",
    top: "0.25em",
    // $base-margin
    left: "0.25em",
    // $base-margin
    textAlign: "left",
    fontSize: ".7em"
  };
  var inlineStyle = {
    display: "inline-block",
    textAlign: "left"
  };
  var indicatorStyle = Object.assign({}, inline ? inlineStyle : fixedCornerStyle, style);
  var ariaLevel = label === "?" ? "Unknown" : label;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    "data-component-name": "BatteryIndicator",
    style: indicatorStyle,
    "aria-label": "Battery Level: ".concat(ariaLevel)
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_MinimalBatteryIndicator__["a" /* default */], {
    icon: icon,
    level: level,
    status: status
  }), label);
}

BatteryIndicator.propTypes = {
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  level: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (BatteryIndicator);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toArray__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_Icons__ = __webpack_require__(23);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var MinimalBatteryIndicator = function MinimalBatteryIndicator(_ref) {
  var icon = _ref.icon,
      level = _ref.level,
      style = _ref.style;
  var iconName;
  var modifiers = [];

  if (icon) {
    var _icon$split = icon.split(" ");

    var _icon$split2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toArray___default()(_icon$split);

    iconName = _icon$split2[0];
    modifiers = _icon$split2.slice(1);
  }

  var iconStyle = _objectSpread({
    verticalAlign: "bottom"
  }, style);

  if (iconName === "battery_full" || level > 75) {
    return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nx_components_Icons__["b" /* IconBatteryFull */], {
      style: iconStyle,
      modifiers: modifiers
    });
  } else if (iconName === "battery_mostly_full" || level > 30) {
    return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nx_components_Icons__["d" /* IconBatteryMostlyFull */], {
      style: iconStyle,
      modifiers: modifiers
    });
  } else if (iconName === "battery_mostly_empty" || level > 1) {
    modifiers.push("alert");
    return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nx_components_Icons__["c" /* IconBatteryLow */], {
      style: iconStyle,
      modifiers: modifiers
    });
  }

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nx_components_Icons__["a" /* IconBatteryEmpty */], {
    style: iconStyle,
    modifiers: modifiers
  });
};

MinimalBatteryIndicator.propTypes = {
  icon: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  level: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (MinimalBatteryIndicator);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_ErrorHandler__ = __webpack_require__(98);




var TileControlWrapper = function TileControlWrapper(_ref) {
  var children = _ref.children;
  var styles = {
    wrapper: {
      height: "3em",
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "#F0F0F0"
    },
    controlWrap: {
      margin: "0 0.5em"
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_ErrorHandler__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    style: styles.wrapper,
    "data-component-name": "TileControlWrapper"
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    className: "device-control-wrap",
    style: styles.controlWrap
  }, children)));
};

TileControlWrapper.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element
};
/* harmony default export */ __webpack_exports__["a"] = (TileControlWrapper);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_sizeme__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_sizeme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_sizeme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__internal_Switch__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);












var styles = {
  wrapper: {
    height: "1.6em",
    width: "100%"
  }
};

var SlideToUnlock =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SlideToUnlock, _React$Component);

  function SlideToUnlock() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SlideToUnlock);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SlideToUnlock).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SlideToUnlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          locked = _this$props.locked,
          lockedLabel = _this$props.lockedLabel,
          unlockedLabel = _this$props.unlockedLabel,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange,
          size = _this$props.size,
          colors = _this$props.colors;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.wrapper
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__internal_Switch__["a" /* default */], {
        "aria-label": lockedLabel,
        checked: locked,
        disabled: disabled,
        width: size.width,
        height: size.height,
        changeOnTap: false,
        offColor: colors.RED,
        offBackgroundText: unlockedLabel,
        onColor: colors.PRIMARY,
        onBackgroundText: lockedLabel,
        onChange: onChange
      }));
    }
  }]);

  return SlideToUnlock;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SlideToUnlock, "defaultProps", {
  lockedLabel: "Locked",
  unlockedLabel: "Unlocked"
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SlideToUnlock, "propTypes", {
  locked: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  lockedLabel: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
  unlockedLabel: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  },
  size: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape({
    width: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired,
    height: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired
  }).isRequired
});

var SizedSlideToUnlock = __WEBPACK_IMPORTED_MODULE_8_react_sizeme___default()({
  monitorHeight: true,
  monitorWidth: true,
  refreshRate: __WEBPACK_IMPORTED_MODULE_11__Theme__["a" /* default */].RESPONSIVE_REFRESH_RATE
})(SlideToUnlock);

var SlideToUnlockWrapper =
/*#__PURE__*/
function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SlideToUnlockWrapper, _React$Component2);

  function SlideToUnlockWrapper() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SlideToUnlockWrapper);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SlideToUnlockWrapper).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SlideToUnlockWrapper, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](SizedSlideToUnlock, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        style: styles.wrapper // provide an unused style prop so SizeMe knows how to style the placeholder

      }, this.props));
    }
  }]);

  return SlideToUnlockWrapper;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SlideToUnlockWrapper, "propTypes", {
  locked: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  lockedLabel: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
  unlockedLabel: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["c" /* withColorsProvider */])(SlideToUnlockWrapper));



/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var forEach                 = __webpack_require__(461).forEach;
var elementUtilsMaker       = __webpack_require__(1103);
var listenerHandlerMaker    = __webpack_require__(1104);
var idGeneratorMaker        = __webpack_require__(1105);
var idHandlerMaker          = __webpack_require__(1106);
var reporterMaker           = __webpack_require__(1107);
var browserDetector         = __webpack_require__(462);
var batchProcessorMaker     = __webpack_require__(1108);
var stateHandler            = __webpack_require__(1110);

//Detection strategies.
var objectStrategyMaker     = __webpack_require__(1111);
var scrollStrategyMaker     = __webpack_require__(1112);

function isCollection(obj) {
    return Array.isArray(obj) || obj.length !== undefined;
}

function toArray(collection) {
    if (!Array.isArray(collection)) {
        var array = [];
        forEach(collection, function (obj) {
            array.push(obj);
        });
        return array;
    } else {
        return collection;
    }
}

function isElement(obj) {
    return obj && obj.nodeType === 1;
}

/**
 * @typedef idHandler
 * @type {object}
 * @property {function} get Gets the resize detector id of the element.
 * @property {function} set Generate and sets the resize detector id of the element.
 */

/**
 * @typedef Options
 * @type {object}
 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
                                    If not provided, a default id handler will be used.
 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
                                    If not provided, a default id handler will be used.
                                    If set to false, then nothing will be reported.
 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
 */

/**
 * Creates an element resize detector instance.
 * @public
 * @param {Options?} options Optional global options object that will decide how this instance will work.
 */
module.exports = function(options) {
    options = options || {};

    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var idHandler;

    if (options.idHandler) {
        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
        idHandler = {
            get: function (element) { return options.idHandler.get(element, true); },
            set: options.idHandler.set
        };
    } else {
        var idGenerator = idGeneratorMaker();
        var defaultIdHandler = idHandlerMaker({
            idGenerator: idGenerator,
            stateHandler: stateHandler
        });
        idHandler = defaultIdHandler;
    }

    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var reporter = options.reporter;

    if(!reporter) {
        //If options.reporter is false, then the reporter should be quiet.
        var quiet = reporter === false;
        reporter = reporterMaker(quiet);
    }

    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));

    //Options to be used as default for the listenTo function.
    var globalOptions = {};
    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
    globalOptions.debug         = !!getOption(options, "debug", false);

    var eventListenerHandler    = listenerHandlerMaker(idHandler);
    var elementUtils            = elementUtilsMaker({
        stateHandler: stateHandler
    });

    //The detection strategy to be used.
    var detectionStrategy;
    var desiredStrategy = getOption(options, "strategy", "object");
    var strategyOptions = {
        reporter: reporter,
        batchProcessor: batchProcessor,
        stateHandler: stateHandler,
        idHandler: idHandler
    };

    if(desiredStrategy === "scroll") {
        if (browserDetector.isLegacyOpera()) {
            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
            desiredStrategy = "object";
        } else if (browserDetector.isIE(9)) {
            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
            desiredStrategy = "object";
        }
    }

    if(desiredStrategy === "scroll") {
        detectionStrategy = scrollStrategyMaker(strategyOptions);
    } else if(desiredStrategy === "object") {
        detectionStrategy = objectStrategyMaker(strategyOptions);
    } else {
        throw new Error("Invalid strategy name: " + desiredStrategy);
    }

    //Calls can be made to listenTo with elements that are still being installed.
    //Also, same elements can occur in the elements list in the listenTo function.
    //With this map, the ready callbacks can be synchronized between the calls
    //so that the ready callback can always be called when an element is ready - even if
    //it wasn't installed from the function itself.
    var onReadyCallbacks = {};

    /**
     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
     * @public
     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
     * @param {function} listener The callback to be executed for each resize event for each element.
     */
    function listenTo(options, elements, listener) {
        function onResizeCallback(element) {
            var listeners = eventListenerHandler.get(element);
            forEach(listeners, function callListenerProxy(listener) {
                listener(element);
            });
        }

        function addListener(callOnAdd, element, listener) {
            eventListenerHandler.add(element, listener);

            if(callOnAdd) {
                listener(element);
            }
        }

        //Options object may be omitted.
        if(!listener) {
            listener = elements;
            elements = options;
            options = {};
        }

        if(!elements) {
            throw new Error("At least one element required.");
        }

        if(!listener) {
            throw new Error("Listener required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        var elementsReady = 0;

        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
        var onReadyCallback = getOption(options, "onReady", function noop() {});
        var debug = getOption(options, "debug", globalOptions.debug);

        forEach(elements, function attachListenerToElement(element) {
            if (!stateHandler.getState(element)) {
                stateHandler.initState(element);
                idHandler.set(element);
            }

            var id = idHandler.get(element);

            debug && reporter.log("Attaching listener to element", id, element);

            if(!elementUtils.isDetectable(element)) {
                debug && reporter.log(id, "Not detectable.");
                if(elementUtils.isBusy(element)) {
                    debug && reporter.log(id, "System busy making it detectable");

                    //The element is being prepared to be detectable. Do not make it detectable.
                    //Just add the listener, because the element will soon be detectable.
                    addListener(callOnAdd, element, listener);
                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
                    onReadyCallbacks[id].push(function onReady() {
                        elementsReady++;

                        if(elementsReady === elements.length) {
                            onReadyCallback();
                        }
                    });
                    return;
                }

                debug && reporter.log(id, "Making detectable...");
                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
                elementUtils.markBusy(element, true);
                return detectionStrategy.makeDetectable({ debug: debug }, element, function onElementDetectable(element) {
                    debug && reporter.log(id, "onElementDetectable");

                    if (stateHandler.getState(element)) {
                        elementUtils.markAsDetectable(element);
                        elementUtils.markBusy(element, false);
                        detectionStrategy.addListener(element, onResizeCallback);
                        addListener(callOnAdd, element, listener);

                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
                        // so that a resize event may be emitted.
                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
                        var state = stateHandler.getState(element);
                        if (state && state.startSize) {
                            var width = element.offsetWidth;
                            var height = element.offsetHeight;
                            if (state.startSize.width !== width || state.startSize.height !== height) {
                                onResizeCallback(element);
                            }
                        }

                        if(onReadyCallbacks[id]) {
                            forEach(onReadyCallbacks[id], function(callback) {
                                callback();
                            });
                        }
                    } else {
                        // The element has been unisntalled before being detectable.
                        debug && reporter.log(id, "Element uninstalled before being detectable.");
                    }

                    delete onReadyCallbacks[id];

                    elementsReady++;
                    if(elementsReady === elements.length) {
                        onReadyCallback();
                    }
                });
            }

            debug && reporter.log(id, "Already detecable, adding listener.");

            //The element has been prepared to be detectable and is ready to be listened to.
            addListener(callOnAdd, element, listener);
            elementsReady++;
        });

        if(elementsReady === elements.length) {
            onReadyCallback();
        }
    }

    function uninstall(elements) {
        if(!elements) {
            return reporter.error("At least one element is required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        forEach(elements, function (element) {
            eventListenerHandler.removeAllListeners(element);
            detectionStrategy.uninstall(element);
            stateHandler.cleanState(element);
        });
    }

    return {
        listenTo: listenTo,
        removeListener: eventListenerHandler.removeListener,
        removeAllListeners: eventListenerHandler.removeAllListeners,
        uninstall: uninstall
    };
};

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

/**
 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
 * @public
 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
 */
utils.forEach = function(collection, callback) {
    for(var i = 0; i < collection.length; i++) {
        var result = callback(collection[i]);
        if(result) {
            return result;
        }
    }
};


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var detector = module.exports = {};

detector.isIE = function(version) {
    function isAnyIeVersion() {
        var agent = navigator.userAgent.toLowerCase();
        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
    }

    if(!isAnyIeVersion()) {
        return false;
    }

    if(!version) {
        return true;
    }

    //Shamelessly stolen from https://gist.github.com/padolsey/527683
    var ieVersion = (function(){
        var undef,
            v = 3,
            div = document.createElement("div"),
            all = div.getElementsByTagName("i");

        do {
            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
        }
        while (all[0]);

        return v > 4 ? v : undef;
    }());

    return version === ieVersion;
};

detector.isLegacyOpera = function() {
    return !!window.opera;
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throttle", function() { return throttle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return debounce; });
/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    var self = this;
    var elapsed = Date.now() - lastExec;
    var args = arguments;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, args);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}  [atBegin]     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @return {Function} A new, debounced function.
 */

function debounce (delay, atBegin, callback) {
  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}




/***/ }),
/* 465 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_polished__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ScrollableDiv__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);









/*
This code is derived from react-switch by Markus Englund.
https://github.com/markusenglund/react-switch

MIT License

Copyright (c) 2017 Markus Englund

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/






var MIN_DRAG_THRESHOLD = 2;

var Switch =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Switch, _React$Component);

  function Switch() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Switch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Switch)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isTouchDevice", "ontouchstart" in window);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      currentPosition: _this.props.checked ? _this._getCheckedPos(_this.props) : _this._getUncheckedPos(_this.props),
      startX: null,
      isDragging: false,
      hasOutline: false
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDragStart", function (clientX) {
      _this.setState({
        startX: clientX,
        hasOutline: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDrag", function (clientX) {
      var startX = _this.state.startX;

      if (startX == null) {
        return;
      }

      var checked = _this.props.checked;

      var checkedPos = _this._getCheckedPos(_this.props);

      var uncheckedPos = _this._getUncheckedPos(_this.props);

      var startPos = checked ? checkedPos : uncheckedPos;
      var newPos = startPos + clientX - startX;
      var currentPosition = Math.min(checkedPos, Math.max(uncheckedPos, newPos));
      var isDragging = Math.abs(clientX - startX) > MIN_DRAG_THRESHOLD;

      _this.setState({
        currentPosition: currentPosition,
        isDragging: isDragging
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDragEnd", function () {
      var _this$state = _this.state,
          currentPosition = _this$state.currentPosition,
          isDragging = _this$state.isDragging;
      var _this$props = _this.props,
          checked = _this$props.checked,
          onChange = _this$props.onChange,
          changeOnTap = _this$props.changeOnTap;

      if (!isDragging && changeOnTap) {
        _this.setState({
          startX: null,
          hasOutline: false
        });

        onChange(!checked);
        return;
      }

      var checkedPos = _this._getCheckedPos(_this.props);

      var uncheckedPos = _this._getUncheckedPos(_this.props);

      if (checked) {
        if (currentPosition > (checkedPos + uncheckedPos) / 2) {
          // Dragged less than halfway; revert
          _this.setState({
            currentPosition: checkedPos,
            startX: null,
            isDragging: false,
            hasOutline: false
          });

          return;
        }

        _this.setState({
          startX: null,
          isDragging: false,
          hasOutline: false
        });

        onChange(false);
      } else {
        if (currentPosition <= (checkedPos + uncheckedPos) / 2) {
          // Dragged less than (or equal to) halfway; revert
          _this.setState({
            currentPosition: uncheckedPos,
            startX: null,
            isDragging: false,
            hasOutline: false
          });

          return;
        }

        _this.setState({
          startX: null,
          isDragging: false,
          hasOutline: false
        });

        onChange(true);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleMouseDown", function (event) {
      // Ignore right click and scroll
      if (typeof event.button === "number" && event.button !== 0) {
        return;
      }

      _this._handleDragStart(event.clientX);

      document.addEventListener("mousemove", _this._handleMouseMove);
      document.addEventListener("mouseup", _this._handleMouseUp);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleMouseMove", function (event) {
      event.preventDefault();

      _this._handleDrag(event.clientX);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleMouseUp", function () {
      _this._handleDragEnd();

      document.removeEventListener("mousemove", _this._handleMouseMove);
      document.removeEventListener("mouseup", _this._handleMouseUp);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTouchStart", function (event) {
      _this._handleDragStart(event.touches[0].clientX);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTouchMove", function (event) {
      _this._handleDrag(event.touches[0].clientX);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTouchEnd", function (event) {
      event.preventDefault();

      _this._handleDragEnd();
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTouchCancel", function () {
      _this.setState({
        startX: null,
        hasOutline: false,
        isDragging: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTap", function () {
      _this._handleDragEnd();
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleKeyDown", function (event) {
      var _this$props2 = _this.props,
          checked = _this$props2.checked,
          onChange = _this$props2.onChange;
      var isDragging = _this.state.isDragging;
      var spaceKeyCode = 32;
      var enterKeyCode = 13;

      if ((event.keyCode === spaceKeyCode || event.keyCode === enterKeyCode) && !isDragging) {
        event.preventDefault();
        onChange(!checked);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Switch, [{
    key: "_getHandleDiameter",
    value: function _getHandleDiameter(props) {
      var height = props.height,
          handleDiameter = props.handleDiameter;
      return handleDiameter || height - 2;
    }
  }, {
    key: "_getCheckedPos",
    value: function _getCheckedPos(props) {
      var handleDiameter = this._getHandleDiameter(props);

      var width = props.width,
          height = props.height;
      return Math.max(width - height, width - (height + handleDiameter) / 2);
    }
  }, {
    key: "_getUncheckedPos",
    value: function _getUncheckedPos(props) {
      var handleDiameter = this._getHandleDiameter(props);

      var height = props.height;
      return Math.max(0, (height - handleDiameter) / 2);
    }
  }, {
    key: "_getAmountDraggedRatio",
    value: function _getAmountDraggedRatio(props, state) {
      var uncheckedPos = this._getUncheckedPos(props);

      var checkedPos = this._getCheckedPos(props);

      var currentPosition = state.currentPosition;
      return (currentPosition - uncheckedPos) / (checkedPos - uncheckedPos);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var currentPosition = nextProps.checked ? this._getCheckedPos(nextProps) : this._getUncheckedPos(nextProps);
      this.setState({
        currentPosition: currentPosition
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.isDragging === prevState.isDragging) {
        return;
      }

      if (this.state.isDragging) {
        Object(__WEBPACK_IMPORTED_MODULE_13__ScrollableDiv__["b" /* killScroll */])();
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_13__ScrollableDiv__["c" /* reviveScroll */])();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousemove", this._handleMouseMove);
      document.removeEventListener("mouseup", this._handleMouseUp);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          checked = _this$props3.checked,
          disabled = _this$props3.disabled,
          boxShadow = _this$props3.boxShadow,
          activeBoxShadow = _this$props3.activeBoxShadow,
          height = _this$props3.height,
          width = _this$props3.width,
          id = _this$props3.id,
          ariaLabelledby = _this$props3["aria-labelledby"],
          ariaLabel = _this$props3["aria-label"],
          changeOnTap = _this$props3.changeOnTap,
          offBackgroundText = _this$props3.offBackgroundText,
          onBackgroundText = _this$props3.onBackgroundText,
          colors = _this$props3.colors;
      var _this$state2 = this.state,
          currentPosition = _this$state2.currentPosition,
          isDragging = _this$state2.isDragging,
          hasOutline = _this$state2.hasOutline;

      var handleDiameter = this._getHandleDiameter(this.props);

      var amountDraggedRatio = this._getAmountDraggedRatio(this.props, this.state);

      var offColor = this.props.offColor || "#888";
      var onColor = this.props.onColor || colors.PRIMARY;
      var offHandleColor = this.props.offHandleColor || "#fff";
      var onHandleColor = this.props.onHandleColor || "#fff";
      var styles = Object(__WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["b" /* default */])({
        root: {
          position: "relative",
          display: "inline-block",
          opacity: disabled ? 0.5 : 1,
          borderRadius: height / 2,
          transition: "opacity 0.25s",
          WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
          userSelect: "none"
        },
        background: {
          height: height,
          width: width,
          margin: Math.max(0, (handleDiameter - height) / 2),
          position: "relative",
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_9_polished__["c" /* mix */])(amountDraggedRatio, onColor, offColor),
          borderRadius: height / 2,
          cursor: changeOnTap && !disabled ? "pointer" : "default",
          transition: isDragging ? null : "background 0.25s"
        },
        offBackgroundTextWrapper: {
          position: "absolute",
          width: "100%",
          opacity: 1 - amountDraggedRatio * 2,
          textAlign: "center",
          color: "white",
          fontSize: "0.8em",
          lineHeight: "".concat(height, "px"),
          pointerEvents: "none"
        },
        onBackgroundTextWrapper: {
          position: "absolute",
          width: "100%",
          opacity: amountDraggedRatio * 2 - 1,
          textAlign: "center",
          color: "white",
          fontSize: "0.8em",
          lineHeight: "".concat(height, "px"),
          pointerEvents: "none"
        },
        handle: {
          height: handleDiameter,
          width: handleDiameter,
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_9_polished__["c" /* mix */])(amountDraggedRatio, onHandleColor, offHandleColor),
          cursor: disabled ? "default" : "pointer",
          display: "inline-block",
          borderRadius: "50%",
          position: "absolute",
          transform: "translateX(".concat(currentPosition, "px)"),
          top: Math.max(0, (height - handleDiameter) / 2),
          left: 0,
          // TODO: This makes them look good in mobile, but we shouldn't need it?
          outline: 0,
          boxShadow: hasOutline ? activeBoxShadow : boxShadow,
          border: 0,
          transition: isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
          touchAction: isDragging ? "none" : ""
        }
      });

      var backgroundContent = function backgroundContent(refHandler) {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
          "data-component-section": "background",
          style: styles.background,
          ref: refHandler
        }, offBackgroundText ? __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
          "data-component-section": "off-background-text-wrapper",
          style: styles.offBackgroundTextWrapper
        }, offBackgroundText) : null, onBackgroundText ? __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
          "data-component-section": "on-background-text-wrapper",
          style: styles.onBackgroundTextWrapper
        }, onBackgroundText) : null);
      };

      var dragEventHandlerProps;

      if (disabled) {
        dragEventHandlerProps = {};
      } else if (this._isTouchDevice) {
        dragEventHandlerProps = {
          onTouchStart: disabled ? null : this._handleTouchStart,
          onTouchMove: disabled ? null : this._handleTouchMove,
          onTouchEnd: disabled ? null : this._handleTouchEnd,
          onTouchCancel: disabled ? null : this._handleTouchCancel
        };
      } else {
        dragEventHandlerProps = {
          onMouseDown: disabled ? null : this._handleMouseDown
        };
      }

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        "data-component-name": "Switch",
        style: styles.root
      }, changeOnTap && !disabled ? __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Tappable__["b" /* default */], {
        onTap: this._handleTap
      }, function (_ref) {
        var tapTargetRefHandler = _ref.tapTargetRefHandler;
        return backgroundContent(tapTargetRefHandler);
      }) : backgroundContent(undefined), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        "data-component-section": "handle",
        ref: function ref(el) {
          return _this2._handleDiv = el;
        },
        role: "checkbox",
        style: styles.handle
      }, dragEventHandlerProps, {
        tabIndex: disabled ? null : 0,
        onKeyDown: disabled ? null : this._handleKeyDown,
        onFocus: function onFocus() {
          return _this2.setState({
            hasOutline: true
          });
        },
        onBlur: function onBlur() {
          return _this2.setState({
            hasOutline: false
          });
        },
        id: id,
        "aria-checked": checked,
        "aria-disabled": disabled,
        "aria-labelledby": ariaLabelledby,
        "aria-label": ariaLabel
      })));
    }
  }]);

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Switch, "defaultProps", {
  disabled: false,
  handleDiameter: null,
  boxShadow: null,
  activeBoxShadow: "0px 0px 2px 3px #33bbff",
  height: 28,
  width: 56,
  className: null,
  id: null,
  "aria-labelledby": null,
  "aria-label": null,
  changeOnTap: true,
  offBackgroundText: null,
  onBackgroundText: null
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Switch, "propTypes", {
  // False positive...

  /* eslint-disable react/no-unused-prop-types */
  checked: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  offColor: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  onColor: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  offHandleColor: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  onHandleColor: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  handleDiameter: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number,
  boxShadow: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  activeBoxShadow: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  height: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number,
  id: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  "\"aria-labelledby\"": __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  "\"aria-label\"": __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  changeOnTap: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  offBackgroundText: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.node,
  onBackgroundText: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.node,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["c" /* withColorsProvider */])(Switch));



/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return THROTTLE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SliderController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_throttle__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Handle__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);











var THROTTLE_DELAY = 50;
/* eslint-disable react/no-unused-prop-types */
// Somehow this type is getting inside no-unused-prop-types. Hmmm...

/* eslint-enable react/no-unused-prop-types */
function getPositionFromEvent(ev) {
  if (ev instanceof TouchEvent || ev.nativeEvent instanceof TouchEvent) {
    // MouseEvent is not exact, so Flow can't guarantee it doesn't have a
    // nativeEvent property which is a TouchEvent.
    var touchEvent = ev;
    var position = touchEvent.touches[0];
    return {
      x: position.clientX,
      y: position.clientY
    };
  } else {
    var mouseEvent = ev;
    return {
      x: mouseEvent.clientX,
      y: mouseEvent.clientY
    };
  }
}

var eventFor = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
};
var dragEventFor = eventFor.mouse;

var SliderController =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SliderController, _React$Component);

  function SliderController() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SliderController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SliderController)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isMobilePlatform", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isSliding", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_initialX", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_initialY", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_currentX", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_currentY", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_farthestX", 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_farthestY", 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_offsetX", 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_abort", function () {
      _this._isSliding = false;

      _this._removeListeners();

      __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unstable_batchedUpdates(function () {
        _this.props.onAbort();
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_addListeners", function () {
      window.addEventListener(dragEventFor.move, _this._handleDrag);
      window.addEventListener(dragEventFor.stop, _this._handleDragEnd);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_removeListeners", function () {
      window.removeEventListener(dragEventFor.move, _this._handleDrag);
      window.removeEventListener(dragEventFor.stop, _this._handleDragEnd);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_cleanUpMissingSlider", function () {
      dragEventFor = eventFor.mouse;

      _this._removeListeners();

      dragEventFor = eventFor.touch;

      _this._removeListeners();

      return new Error("Attempted to get the slider ratio for a slider which was not mounted. Presumably a set of listeners was not properly removed. Removing all possible listeners.");
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_getRatio", function (x) {
      if (!_this._slider) {
        // Weird pattern, but flow doesn't know that this always throws unless I do it out here
        throw _this._cleanUpMissingSlider();
      }

      var _this$_slider$getBoun = _this._slider.getBoundingClientRect(),
          left = _this$_slider$getBoun.left,
          width = _this$_slider$getBoun.width;

      var ratio = (x - _this._offsetX - left) / width;
      return Math.max(0, Math.min(1, ratio));
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_getStartingRatio", function (x) {
      if (!_this._slider) {
        // Weird pattern, but flow doesn't know that this always throws unless I do it out here
        throw _this._cleanUpMissingSlider();
      }

      var _this$_slider$getBoun2 = _this._slider.getBoundingClientRect(),
          left = _this$_slider$getBoun2.left,
          width = _this$_slider$getBoun2.width;

      var ratio = _this.props.ratio;
      var positionOfCurrentValue = ratio * width + left;

      if (x >= positionOfCurrentValue - __WEBPACK_IMPORTED_MODULE_10__Handle__["a" /* HANDLE_SIZE */] / 2 && x <= positionOfCurrentValue + __WEBPACK_IMPORTED_MODULE_10__Handle__["a" /* HANDLE_SIZE */] / 2) {
        // User started inside the old handle. Treat it like starting in the center.
        _this._offsetX = x - positionOfCurrentValue;
        return ratio;
      } else {
        _this._offsetX = 0;
        return _this._getRatio(x);
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleMouseDown", function (ev) {
      if (_this._isMobilePlatform) {
        // Ignore mouse events after receiving a touchstart, because mobile devices
        // will have different behavior for how/when they send the mouse versions.
        return;
      }

      if (dragEventFor === eventFor.touch) {
        _this._removeListeners();

        dragEventFor = eventFor.mouse;
      }

      _this._start(ev);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTouchStart", function (ev) {
      if (dragEventFor === eventFor.mouse) {
        _this._removeListeners();

        dragEventFor = eventFor.touch;
      }

      _this._isMobilePlatform = true;

      _this._start(ev);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_start", function (ev) {
      var position = getPositionFromEvent(ev);
      _this._initialX = position.x;
      _this._initialY = position.y;
      _this._farthestX = 0;
      _this._farthestY = 0;

      _this._updateCurrentPosition(position);

      _this._removeListeners();

      _this._addListeners();

      _this._isSliding = true;

      var ratio = _this._getStartingRatio(position.x);

      _this.props.onStart(ratio);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDrag", __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default()(function (ev) {
      var position = getPositionFromEvent(ev);

      _this._updateCurrentPosition(position);

      if (_this._isProbablyScrolling()) {
        _this._abort();

        return;
      }

      if (_this._isSliding) {
        var ratio = _this._getRatio(position.x);

        __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unstable_batchedUpdates(function () {
          _this.props.onDrag(ratio);
        });
      }
    }, THROTTLE_DELAY));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDragEnd", function () {
      _this._isSliding = false;

      _this._removeListeners();

      if (_this._currentX == null) {
        _this._abort();

        return;
      }

      var ratio = _this._getRatio(_this._currentX);

      __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unstable_batchedUpdates(function () {
        _this.props.onEnd(ratio);
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isProbablyScrolling", function () {
      return _this._farthestY > _this._farthestX + 20;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_updateCurrentPosition", function (_ref) {
      var x = _ref.x,
          y = _ref.y;
      _this._currentX = x;
      _this._currentY = y;
      var initialX = _this._initialX;
      var initialY = _this._initialY;

      if (initialX == null || initialY == null) {
        return;
      }

      if (Math.abs(x - initialX) > _this._farthestX) {
        _this._farthestX = Math.abs(x - initialX);
      }

      if (Math.abs(y - initialY) > _this._farthestY) {
        _this._farthestY = Math.abs(y - initialY);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SliderController, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._removeListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      return children({
        onMouseDown: this._handleMouseDown,
        onTouchStartCapture: this._handleTouchStart,
        captureRef: function captureRef(el) {
          _this2._slider = el;
        }
      });
    }
  }]);

  return SliderController;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SliderController, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,
  ratio: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number.isRequired,
  onStart: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,
  onDrag: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,
  onEnd: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,
  onAbort: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired
});




/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OccupanySetpointController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);










var OccupanySetpointController =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(OccupanySetpointController, _React$Component);

  function OccupanySetpointController() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, OccupanySetpointController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(OccupanySetpointController)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      setpointCoolMin: _this.props.model.get("setpoint_cool_min"),
      setpointCoolMax: _this.props.model.get("setpoint_cool_max"),
      setpointHeatMin: _this.props.model.get("setpoint_heat_min"),
      setpointHeatMax: _this.props.model.get("setpoint_heat_max")
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(OccupanySetpointController, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.updateMinMaxSetpoint(nextProps);
    }
  }, {
    key: "updateMinMaxSetpoint",
    value: function updateMinMaxSetpoint(props) {
      var model = props.model;
      var occupancyMode = this.getOccupancyMode(props);
      var setpointCoolMin = model.get("setpoint_cool_min");
      var setpointCoolMax = model.get("setpoint_cool_max");
      var setpointHeatMin = model.get("setpoint_heat_min");
      var setpointHeatMax = model.get("setpoint_heat_max");

      if (occupancyMode && occupancyMode !== "occupied") {
        this.setState({
          setpointCoolMin: model.get("setpoint_cool"),
          setpointCoolMax: model.get("setpoint_cool"),
          setpointHeatMin: model.get("setpoint_heat"),
          setpointHeatMax: model.get("setpoint_heat")
        });
      } else if (this.shouldResetSetpointMinMax()) {
        var occupancy = model.get("occupancy_setpoints");

        if (occupancy) {
          this.setState({
            setpointCoolMin: this.limitedMinSetpoint(occupancy.preset_cool1, setpointCoolMin),
            setpointCoolMax: this.limitedMaxSetpoint(occupancy.preset_cool1, setpointCoolMax),
            setpointHeatMin: this.limitedMinSetpoint(occupancy.preset_heat1, setpointHeatMin),
            setpointHeatMax: this.limitedMaxSetpoint(occupancy.preset_heat1, setpointHeatMax)
          });
        } else {
          this.setState({
            setpointCoolMin: setpointCoolMin,
            setpointCoolMax: setpointCoolMax,
            setpointHeatMin: setpointHeatMin,
            setpointHeatMax: setpointHeatMax
          });
        }
      } else {
        this.setState({
          setpointCoolMin: setpointCoolMin,
          setpointCoolMax: setpointCoolMax,
          setpointHeatMin: setpointHeatMin,
          setpointHeatMax: setpointHeatMax
        });
      }
    }
  }, {
    key: "getOccupancyMode",
    value: function getOccupancyMode(props) {
      var model = props.model;

      if (__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_environment__["a" /* default */].isCommercial()) {
        var occupancyMode = model.get("occupancy_mode");
        return occupancyMode ? occupancyMode.toLowerCase() : null;
      }

      return null;
    }
  }, {
    key: "shouldResetSetpointMinMax",
    value: function shouldResetSetpointMinMax() {
      var model = this.props.model;
      var occupancy = model.get("occupancy_setpoints");

      if (occupancy) {
        var setpointLimitEnabled = occupancy.setpoint_limit_enabled;
        return setpointLimitEnabled && this.getOccupancyMode(this.props) === "occupied";
      }

      return false;
    }
  }, {
    key: "limitedMinSetpoint",
    value: function limitedMinSetpoint(value, minValue) {
      var occupancy = this.props.model.get("occupancy_setpoints");

      if (occupancy) {
        var setpointLimit = occupancy.setpoint_limit;
        var minSetpoint = value - setpointLimit;

        if (minSetpoint < minValue) {
          return minValue;
        } else {
          return minSetpoint;
        }
      }

      return value;
    }
  }, {
    key: "limitedMaxSetpoint",
    value: function limitedMaxSetpoint(value, maxValue) {
      var occupancy = this.props.model.get("occupancy_setpoints");

      if (occupancy) {
        var setpointLimit = occupancy.setpoint_limit;
        var maxSetpoint = value + setpointLimit;

        if (maxSetpoint > maxValue) {
          return maxValue;
        } else {
          return maxSetpoint;
        }
      }

      return value;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var occupancyMode = this.getOccupancyMode(this.props);
      var _this$state = this.state,
          setpointCoolMin = _this$state.setpointCoolMin,
          setpointCoolMax = _this$state.setpointCoolMax,
          setpointHeatMin = _this$state.setpointHeatMin,
          setpointHeatMax = _this$state.setpointHeatMax;
      return children({
        setpointCoolMin: setpointCoolMin,
        setpointCoolMax: setpointCoolMax,
        setpointHeatMin: setpointHeatMin,
        setpointHeatMax: setpointHeatMax,
        occupancyMode: occupancyMode
      });
    }
  }]);

  return OccupanySetpointController;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(OccupanySetpointController, "propTypes", {
  model: function model() {
    return (typeof Device === "function" ? __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.instanceOf(Device).isRequired : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired
});




/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tappable__ = __webpack_require__(28);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var NumericUpDownPicker = function NumericUpDownPicker(_ref) {
  var children = _ref.children,
      onUp = _ref.onUp,
      onDown = _ref.onDown,
      upDisabled = _ref.upDisabled,
      downDisabled = _ref.downDisabled,
      style = _ref.style,
      upButtonStyle = _ref.upButtonStyle,
      downButtonStyle = _ref.downButtonStyle,
      childWrapperStyle = _ref.childWrapperStyle,
      ariaControls = _ref["aria-controls"];
  var iconStyle = {
    cursor: "pointer",
    width: 40,
    height: 40,
    outline: "none"
  };
  var styles = {
    container: Object(__WEBPACK_IMPORTED_MODULE_3__utils_prefixStyles__["b" /* default */])(_objectSpread({
      display: "flex",
      justifyContent: "space-between"
    }, style)),
    button: {
      borderRadius: "50%"
    },
    upButton: _objectSpread({}, iconStyle, {}, upButtonStyle, {}, upDisabled ? {
      opacity: "0.5"
    } : null),
    downButton: _objectSpread({}, iconStyle, {}, downButtonStyle, {}, downDisabled ? {
      opacity: "0.5"
    } : null),
    childWrapper: Object(__WEBPACK_IMPORTED_MODULE_3__utils_prefixStyles__["b" /* default */])(_objectSpread({
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      flexDirection: "column",
      fontSize: 18,
      width: "auto",
      userSelect: "none"
    }, childWrapperStyle))
  };
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    style: styles.container
  }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Tappable__["b" /* default */], {
    onTap: onDown
  }, function (_ref2) {
    var tapTargetRefHandler = _ref2.tapTargetRefHandler,
        active = _ref2.active;
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__NoStyleButton__["a" /* default */], {
      disabled: downDisabled,
      innerRef: tapTargetRefHandler,
      "aria-label": "down",
      "aria-controls": ariaControls,
      style: _objectSpread({}, styles.button, {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__Tappable__["c" /* simpleActiveBackgroundColor */])(active)
      })
    }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons__["y" /* IconCircledArrowDown */], {
      style: styles.downButton
    }));
  }), children ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
    style: styles.childWrapper
  }, children) : null, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Tappable__["b" /* default */], {
    onTap: onUp
  }, function (_ref3) {
    var tapTargetRefHandler = _ref3.tapTargetRefHandler,
        active = _ref3.active;
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__NoStyleButton__["a" /* default */], {
      disabled: upDisabled,
      innerRef: tapTargetRefHandler,
      "aria-label": "up",
      "aria-controls": ariaControls,
      style: _objectSpread({}, styles.button, {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__Tappable__["c" /* simpleActiveBackgroundColor */])(active)
      })
    }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons__["z" /* IconCircledArrowUp */], {
      style: styles.upButton
    }));
  }));
};

NumericUpDownPicker.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  onUp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  upDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  downDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  upButtonStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  downButtonStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  childWrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  "aria-controls": __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (NumericUpDownPicker);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var CustomPropTypes = {
  keyedElementList: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    element: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element.isRequired,
    key: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
  }))
};
/* harmony default export */ __webpack_exports__["a"] = (CustomPropTypes);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);









var UserIcon =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(UserIcon, _React$Component);

  function UserIcon() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, UserIcon);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(UserIcon).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(UserIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          phone = _this$props.phone,
          style = _this$props.style;
      var platform = phone.get("platform");
      var icon;

      if (/^(android|ip(hone|ad|od)|windows)/i.test(platform)) {
        icon = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_nx_components_Icons__["_52" /* IconUserMobile */], {
          style: style
        });
      } else {
        icon = __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_nx_components_Icons__["_51" /* IconUserBrowser */], {
          style: style
        });
      }

      return icon;
    }
  }]);

  return UserIcon;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(UserIcon, "propTypes", {
  phone: function phone() {
    return (typeof Phone === "function" ? __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(Phone).isRequired : __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  style: function style() {
    return (typeof StylesObject === "function" ? __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(StylesObject).isRequired : __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
});




/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Dialog__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Button__ = __webpack_require__(35);












var styles = {
  infoButton: {
    padding: "0",
    borderRadius: "50%",
    backgroundColor: "transparent",
    color: "inherit"
  },
  dialogContainer: {
    margin: "1em",
    minWidth: "10em",
    maxWidth: "80vw",
    overflow: "hidden"
  },
  dialogButton: {
    textAlign: "center",
    marginTop: "1em",
    marginLeft: "1em",
    marginRight: "1em"
  }
};

var InfoIcon =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(InfoIcon, _React$Component);

  function InfoIcon() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, InfoIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(InfoIcon)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      open: false
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_toggleOpen", function () {
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(InfoIcon, [{
    key: "render",
    value: function render() {
      var dialogText = this.props.dialogText;
      var open = this.state.open;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Button__["a" /* default */], {
        "aria-label": "Field info",
        onTap: this._toggleOpen,
        style: styles.infoButton
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Icons__["X" /* IconInfo */], null)), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Dialog__["a" /* default */], {
        open: open,
        onTapBackground: this._toggleOpen,
        onRequestClose: this._toggleOpen
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.dialogContainer
      }, dialogText, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.dialogButton
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Button__["a" /* default */], {
        onTap: this._toggleOpen
      }, "Ok")))));
    }
  }]);

  return InfoIcon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(InfoIcon, "propTypes", {
  dialogText: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
});



/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1191),
    isArguments = __webpack_require__(1192),
    isArray = __webpack_require__(138),
    isBuffer = __webpack_require__(474),
    isIndex = __webpack_require__(410),
    isTypedArray = __webpack_require__(1195);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(71),
    stubFalse = __webpack_require__(1194);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 475 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 476 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(404),
    isLength = __webpack_require__(475);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(473),
    baseKeysIn = __webpack_require__(1202),
    isArrayLike = __webpack_require__(477);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 479 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(481),
    getPrototype = __webpack_require__(482),
    getSymbols = __webpack_require__(294),
    stubArray = __webpack_require__(479);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 481 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(476);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(481),
    isArray = __webpack_require__(138);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 484 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var ValueCallout = function ValueCallout(props) {
  var colors = props.colors,
      icon = props.icon,
      label = props.label,
      value = props.value;
  var styledIcon = "";
  var iconStyles = {};

  if (icon) {
    var iconSize = 80;
    var iconStyle = {
      position: "absolute",
      left: -15
    };

    if (label) {
      iconSize = 50;
      iconStyle.left = 0;
    }

    styledIcon = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icons__["_40" /* IconThermostat */], {
      color: colors.PRIMARY,
      style: iconStyle,
      size: iconSize
    });
    iconStyles = {
      lineHeight: "".concat(iconSize, "px"),
      position: "relative",
      paddingLeft: 50
    };
  }

  var styles = {
    container: {
      display: "inline-block",
      textAlign: "center"
    },
    value: _objectSpread({
      fontSize: !label && !(value.length > 3) ? 68 : 48,
      textAlign: "center",
      verticalAlign: "middle"
    }, iconStyles),
    label: {
      fontSize: 20,
      whiteSpace: "nowrap",
      textAlign: "center"
    }
  };
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
    style: styles.container
  }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
    style: styles.value
  }, styledIcon, value), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    style: styles.label
  }, label));
};

var ValueCalloutSmall = function ValueCalloutSmall(props) {
  var value = props.value,
      label = props.label;
  var style = {
    marginBottom: 6,
    fontSize: 16
  };
  var styledLabel = "";

  if (label) {
    var nbsp = String.fromCharCode(160);
    styledLabel = "".concat(label, ":").concat(nbsp);
  } else {
    style.fontSize = 20;
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    style: style
  }, styledLabel, value);
};

ValueCalloutSmall.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var ThermostatDetailsHeader = function ThermostatDetailsHeader(props) {
  var colors = props.colors,
      temperature = props.temperature,
      temperatureOutside = props.temperatureOutside,
      humidityRelative = props.humidityRelative,
      systemStatus = props.systemStatus,
      compressorSpeed = props.compressorSpeed;
  var styles = {
    container: {
      color: colors.PRIMARY,
      background: colors.DETAILS_HEADER_BACKGROUND,
      padding: __WEBPACK_IMPORTED_MODULE_3__Theme__["a" /* default */].Padding.CONTENT,
      lineHeight: "normal",
      flexBasis: "100%"
    },
    calloutContainer: Object(__WEBPACK_IMPORTED_MODULE_2__utils_prefixStyles__["b" /* default */])({
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center"
    }),
    smallCallouts: {
      display: "inline-block",
      marginLeft: "1.5em",
      textAlign: "left"
    }
  };
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6__ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nx_components.ThermostatDetailsHeader;
  var temperatureValue = "".concat(temperature || "--", "\xB0");
  var outsideCallout = null;

  if (Number.isFinite(temperatureOutside)) {
    var outsideValue = "".concat(temperatureOutside, "\xB0");
    outsideCallout = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ValueCalloutSmall, {
      value: outsideValue,
      label: language.outside
    });
  }

  var humidityCallout = null;

  if (Number.isFinite(humidityRelative)) {
    var humidityValue = "".concat(Math.round(humidityRelative * 100), "%");
    humidityCallout = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ValueCalloutSmall, {
      value: humidityValue,
      label: language.humidity
    });
  }

  var compressorSpeedCallout = null;

  if (Number.isFinite(compressorSpeed)) {
    var compressorSpeedValue = "".concat(Math.round(compressorSpeed * 100), "%");
    compressorSpeedCallout = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ValueCalloutSmall, {
      value: compressorSpeedValue,
      label: language.compressorSpeed
    });
  }

  var systemStatusCallout = null;

  if (systemStatus) {
    systemStatusCallout = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ValueCalloutSmall, {
      value: systemStatus
    });
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    "data-component-name": "ThermostatDetailsHeader",
    style: styles.container
  }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    style: styles.calloutContainer
  }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ValueCallout, {
    icon: true,
    value: temperatureValue,
    colors: colors
  }), (systemStatusCallout || outsideCallout || humidityCallout || compressorSpeedCallout) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    style: styles.smallCallouts
  }, systemStatusCallout, outsideCallout, humidityCallout, compressorSpeedCallout)));
};

ThermostatDetailsHeader.propTypes = {
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_4__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_4__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_4__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_4__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_4__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  },
  temperature: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,
  temperatureOutside: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  humidityRelative: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  systemStatus: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  compressorSpeed: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__ColorsProvider__["c" /* withColorsProvider */])(ThermostatDetailsHeader));



/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_location__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Details_FetchManager__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Page__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_OverlayLinearProgress__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_Scrollable_ScrollableAreaWithPullToRefresh__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_TileList__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_Commercial_PivotDemoMessage__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_components_Commercial_PivotDemoBanner__ = __webpack_require__(300);



















var DashboardTilesPage =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DashboardTilesPage, _React$Component);

  function DashboardTilesPage() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DashboardTilesPage);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DashboardTilesPage).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DashboardTilesPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          location = _this$props.location,
          tileItems = _this$props.tileItems,
          appBar = _this$props.appBar,
          backgroundLoading = _this$props.backgroundLoading;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Details_FetchManager__["a" /* default */], {
        model: location
      }, function (_ref) {
        var progressShown = _ref.progressShown,
            runPromiseWithProgress = _ref.runPromiseWithProgress,
            fetchModelAndMaybeDetails = _ref.fetchModelAndMaybeDetails;
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Page__["b" /* default */], {
          name: "DashboardTilesPage",
          fullyLoaded: true
        }, appBar, (progressShown || backgroundLoading) && __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_OverlayLinearProgress__["a" /* default */], {
          indeterminate: true
        }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_Scrollable_ScrollableAreaWithPullToRefresh__["a" /* default */], {
          onPullToRefresh: function onPullToRefresh() {
            runPromiseWithProgress(fetchModelAndMaybeDetails);
          },
          pullToRefreshDisabled: progressShown,
          trackingKey: "DashboardTilesPage"
        }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_TileList__["a" /* default */], {
          collection: tileItems
        })), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_Commercial_PivotDemoMessage__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_nexia_mobile_components_Commercial_PivotDemoBanner__["a" /* default */], null));
      });
    }
  }]);

  return DashboardTilesPage;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DashboardTilesPage, "propTypes", {
  appBar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_location__["a" /* default */]).isRequired,
  tileItems: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Collection).isRequired,
  backgroundLoading: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  backgroundLoading: "backgroundLoading"
}, DashboardTilesPage));

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Toaster; });
/* harmony export (immutable) */ __webpack_exports__["a"] = addMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Toaster_Toast__ = __webpack_require__(1254);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }




var styles = {
  root: {
    position: "fixed",
    zIndex: __WEBPACK_IMPORTED_MODULE_10_nx_components_Theme__["a" /* default */].zIndexLayers.POPUP,
    left: "1em",
    right: "1em",
    bottom: "1em",
    pointerEvents: "none"
  }
};
// eslint-disable-next-line no-use-before-define
var singleton = null;
var PERSISTENT_REGEX = /(^.{50,}$|device did not respond)/i;

var Toaster =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Toaster, _React$Component);

  function Toaster() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Toaster);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Toaster)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      toasts: {}
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_toastCount", 0);

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDismissToast", function (id) {
      if (!_this._isMounted) {
        return;
      }

      var key = id.toString(); // For Flow's sake

      _this.setState(function (_ref) {
        var toasts = _ref.toasts;

        // eslint-disable-next-line no-unused-vars
        var dismissedToast = toasts[key],
            newToasts = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(toasts, [key].map(_toPropertyKey));

        return {
          toasts: newToasts
        };
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Toaster, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      singleton = this; // eslint-disable-line consistent-this

      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      singleton = null;
      this._isMounted = false;
    } // public ref method

  }, {
    key: "addMessage",
    value: function addMessage(message) {
      if (message === "" || typeof message !== "string") {
        return;
      }

      var id = this._toastCount++;
      this.setState(function (_ref2) {
        var toasts = _ref2.toasts;
        return {
          toasts: _objectSpread({}, toasts, __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()({}, id, {
            id: id,
            message: message,
            persistent: PERSISTENT_REGEX.test(message)
          }))
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var toasts = this.state.toasts;
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
        style: styles.root
      }, __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Toaster_Toast__["a" /* default */], {
        toasts: toasts,
        onDismissToast: this._handleDismissToast
      }));
    }
  }]);

  return Toaster;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(Toaster, "propTypes", {});


function addMessage(message) {
  if (singleton == null) {
    throw new Error("Attempted to show a toast message without a Toaster mounted");
  } else {
    singleton.addMessage(message);
  }
}

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createStylerFactory */
/* unused harmony export buildStyleProperty */
/* unused harmony export buildSVGAttrs */
/* unused harmony export transformProps */
/* unused harmony export isTransformProp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_framesync__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_style_value_types__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hey_listen__ = __webpack_require__(124);





var createStyler = function (_a) {
    var onRead = _a.onRead,
        onRender = _a.onRender,
        _b = _a.uncachedValues,
        uncachedValues = _b === void 0 ? new Set() : _b,
        _c = _a.useCache,
        useCache = _c === void 0 ? true : _c;
    return function (_a) {
        if (_a === void 0) {
            _a = {};
        }
        var props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, []);
        var state = {};
        var changedValues = [];
        var hasChanged = false;
        function setValue(key, value) {
            if (key.startsWith('--')) {
                props.hasCSSVariable = true;
            }
            var currentValue = state[key];
            state[key] = value;
            if (state[key] === currentValue) return;
            if (changedValues.indexOf(key) === -1) {
                changedValues.push(key);
            }
            if (!hasChanged) {
                hasChanged = true;
                __WEBPACK_IMPORTED_MODULE_1_framesync__["b" /* default */].render(styler.render);
            }
        }
        var styler = {
            get: function (key, forceRead) {
                if (forceRead === void 0) {
                    forceRead = false;
                }
                var useCached = !forceRead && useCache && !uncachedValues.has(key) && state[key] !== undefined;
                return useCached ? state[key] : onRead(key, props);
            },
            set: function (values, value) {
                if (typeof values === 'string') {
                    setValue(values, value);
                } else {
                    for (var key in values) {
                        setValue(key, values[key]);
                    }
                }
                return this;
            },
            render: function (forceRender) {
                if (forceRender === void 0) {
                    forceRender = false;
                }
                if (hasChanged || forceRender === true) {
                    onRender(state, props, changedValues);
                    hasChanged = false;
                    changedValues.length = 0;
                }
                return this;
            }
        };
        return styler;
    };
};

var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = '$1-$2';
var camelToDash = function (str) {
    return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};

var camelCache = /*#__PURE__*/new Map();
var dashCache = /*#__PURE__*/new Map();
var prefixes = ['Webkit', 'Moz', 'O', 'ms', ''];
var numPrefixes = prefixes.length;
var isBrowser = typeof document !== 'undefined';
var testElement;
var setDashPrefix = function (key, prefixed) {
    return dashCache.set(key, camelToDash(prefixed));
};
var testPrefix = function (key) {
    testElement = testElement || document.createElement('div');
    for (var i = 0; i < numPrefixes; i++) {
        var prefix = prefixes[i];
        var noPrefix = prefix === '';
        var prefixedPropertyName = noPrefix ? key : prefix + key.charAt(0).toUpperCase() + key.slice(1);
        if (prefixedPropertyName in testElement.style || noPrefix) {
            if (noPrefix && key === 'clipPath' && dashCache.has(key)) {
                return;
            }
            camelCache.set(key, prefixedPropertyName);
            setDashPrefix(key, "" + (noPrefix ? '' : '-') + camelToDash(prefixedPropertyName));
        }
    }
};
var setServerProperty = function (key) {
    return setDashPrefix(key, key);
};
var prefixer = function (key, asDashCase) {
    if (asDashCase === void 0) {
        asDashCase = false;
    }
    var cache = asDashCase ? dashCache : camelCache;
    if (!cache.has(key)) {
        isBrowser ? testPrefix(key) : setServerProperty(key);
    }
    return cache.get(key) || key;
};

var axes = ['', 'X', 'Y', 'Z'];
var order = ['translate', 'scale', 'rotate', 'skew', 'transformPerspective'];
var transformProps = /*#__PURE__*/order.reduce(function (acc, key) {
    return axes.reduce(function (axesAcc, axesKey) {
        axesAcc.push(key + axesKey);
        return axesAcc;
    }, acc);
}, ['x', 'y', 'z']);
var transformPropDictionary = /*#__PURE__*/transformProps.reduce(function (dict, key) {
    dict[key] = true;
    return dict;
}, {});
function isTransformProp(key) {
    return transformPropDictionary[key] === true;
}
function sortTransformProps(a, b) {
    return transformProps.indexOf(a) - transformProps.indexOf(b);
}
var transformOriginProps = /*#__PURE__*/new Set(['originX', 'originY', 'originZ']);
function isTransformOriginProp(key) {
    return transformOriginProps.has(key);
}

var int = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, __WEBPACK_IMPORTED_MODULE_2_style_value_types__["g" /* number */]), { transform: Math.round });
var valueTypes = {
    color: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["b" /* color */],
    backgroundColor: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["b" /* color */],
    outlineColor: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["b" /* color */],
    fill: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["b" /* color */],
    stroke: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["b" /* color */],
    borderColor: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["b" /* color */],
    borderTopColor: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["b" /* color */],
    borderRightColor: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["b" /* color */],
    borderBottomColor: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["b" /* color */],
    borderLeftColor: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["b" /* color */],
    borderWidth: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    borderTopWidth: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    borderRightWidth: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    borderBottomWidth: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    borderLeftWidth: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    borderRadius: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    radius: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    borderTopLeftRadius: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    borderTopRightRadius: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    borderBottomRightRadius: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    borderBottomLeftRadius: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    width: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    maxWidth: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    height: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    maxHeight: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    size: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    top: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    right: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    bottom: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    left: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    padding: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    paddingTop: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    paddingRight: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    paddingBottom: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    paddingLeft: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    margin: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    marginTop: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    marginRight: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    marginBottom: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    marginLeft: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    rotate: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["d" /* degrees */],
    rotateX: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["d" /* degrees */],
    rotateY: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["d" /* degrees */],
    rotateZ: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["d" /* degrees */],
    scale: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["l" /* scale */],
    scaleX: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["l" /* scale */],
    scaleY: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["l" /* scale */],
    scaleZ: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["l" /* scale */],
    skew: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["d" /* degrees */],
    skewX: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["d" /* degrees */],
    skewY: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["d" /* degrees */],
    distance: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    translateX: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    translateY: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    translateZ: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    x: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    y: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    z: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    perspective: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    opacity: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["a" /* alpha */],
    originX: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["i" /* progressPercentage */],
    originY: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["i" /* progressPercentage */],
    originZ: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */],
    zIndex: int,
    fillOpacity: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["a" /* alpha */],
    strokeOpacity: __WEBPACK_IMPORTED_MODULE_2_style_value_types__["a" /* alpha */],
    numOctaves: int
};
var getValueType = function (key) {
    return valueTypes[key];
};
var getValueAsType = function (value, type) {
    return type && typeof value === 'number' ? type.transform(value) : value;
};

var SCROLL_LEFT = 'scrollLeft';
var SCROLL_TOP = 'scrollTop';
var scrollKeys = /*#__PURE__*/new Set([SCROLL_LEFT, SCROLL_TOP]);

var blacklist = /*#__PURE__*/new Set([SCROLL_LEFT, SCROLL_TOP, 'transform']);
var translateAlias = {
    x: 'translateX',
    y: 'translateY',
    z: 'translateZ'
};
function isCustomTemplate(v) {
    return typeof v === 'function';
}
function buildTransform(state, transform, transformKeys, transformIsDefault, enableHardwareAcceleration) {
    var transformString = '';
    var transformHasZ = false;
    transformKeys.sort(sortTransformProps);
    var numTransformKeys = transformKeys.length;
    for (var i = 0; i < numTransformKeys; i++) {
        var key = transformKeys[i];
        transformString += (translateAlias[key] || key) + "(" + transform[key] + ") ";
        transformHasZ = key === 'z' ? true : transformHasZ;
    }
    if (!transformHasZ && enableHardwareAcceleration) {
        transformString += 'translateZ(0)';
    } else {
        transformString = transformString.trim();
    }
    if (isCustomTemplate(state.transform)) {
        transformString = state.transform(transform, transformString);
    } else if (transformIsDefault) {
        transformString = 'none';
    }
    return transformString;
}
function buildStyleProperty(state, enableHardwareAcceleration, styles, transform, transformOrigin, transformKeys, isDashCase) {
    if (enableHardwareAcceleration === void 0) {
        enableHardwareAcceleration = true;
    }
    if (styles === void 0) {
        styles = {};
    }
    if (transform === void 0) {
        transform = {};
    }
    if (transformOrigin === void 0) {
        transformOrigin = {};
    }
    if (transformKeys === void 0) {
        transformKeys = [];
    }
    if (isDashCase === void 0) {
        isDashCase = false;
    }
    var transformIsDefault = true;
    var hasTransform = false;
    var hasTransformOrigin = false;
    for (var key in state) {
        var value = state[key];
        var valueType = getValueType(key);
        var valueAsType = getValueAsType(value, valueType);
        if (isTransformProp(key)) {
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            if (transformIsDefault) {
                if (valueType.default && value !== valueType.default || !valueType.default && value !== 0) {
                    transformIsDefault = false;
                }
            }
        } else if (isTransformOriginProp(key)) {
            transformOrigin[key] = valueAsType;
            hasTransformOrigin = true;
        } else if (!blacklist.has(key) || !isCustomTemplate(valueAsType)) {
            styles[prefixer(key, isDashCase)] = valueAsType;
        }
    }
    if (hasTransform || typeof state.transform === 'function') {
        styles.transform = buildTransform(state, transform, transformKeys, transformIsDefault, enableHardwareAcceleration);
    }
    if (hasTransformOrigin) {
        styles.transformOrigin = (transformOrigin.originX || '50%') + " " + (transformOrigin.originY || '50%') + " " + (transformOrigin.originZ || 0);
    }
    return styles;
}
function createStyleBuilder(enableHardwareAcceleration, isDashCase) {
    if (enableHardwareAcceleration === void 0) {
        enableHardwareAcceleration = true;
    }
    if (isDashCase === void 0) {
        isDashCase = true;
    }
    var styles = {};
    var transform = {};
    var transformOrigin = {};
    var transformKeys = [];
    return function (state) {
        transformKeys.length = 0;
        buildStyleProperty(state, enableHardwareAcceleration, styles, transform, transformOrigin, transformKeys, isDashCase);
        return styles;
    };
}

function onRead(key, options) {
    var element = options.element,
        preparseOutput = options.preparseOutput;
    var defaultValueType = getValueType(key);
    if (isTransformProp(key)) {
        return defaultValueType ? defaultValueType.default || 0 : 0;
    } else if (scrollKeys.has(key)) {
        return element[key];
    } else {
        var domValue = window.getComputedStyle(element, null).getPropertyValue(prefixer(key, true)) || 0;
        return preparseOutput && defaultValueType && defaultValueType.test(domValue) && defaultValueType.parse ? defaultValueType.parse(domValue) : domValue;
    }
}
function onRender(state, _a, changedValues) {
    var element = _a.element,
        buildStyles = _a.buildStyles,
        hasCSSVariable = _a.hasCSSVariable;
    Object.assign(element.style, buildStyles(state));
    if (hasCSSVariable) {
        var numChangedValues = changedValues.length;
        for (var i = 0; i < numChangedValues; i++) {
            var key = changedValues[i];
            if (key.startsWith('--')) {
                element.style.setProperty(key, state[key]);
            }
        }
    }
    if (changedValues.indexOf(SCROLL_LEFT) !== -1) {
        element[SCROLL_LEFT] = state[SCROLL_LEFT];
    }
    if (changedValues.indexOf(SCROLL_TOP) !== -1) {
        element[SCROLL_TOP] = state[SCROLL_TOP];
    }
}
var cssStyler = /*#__PURE__*/createStyler({
    onRead: onRead,
    onRender: onRender,
    uncachedValues: scrollKeys
});
function createCssStyler(element, _a) {
    if (_a === void 0) {
        _a = {};
    }
    var enableHardwareAcceleration = _a.enableHardwareAcceleration,
        props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["enableHardwareAcceleration"]);
    return cssStyler(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ element: element, buildStyles: createStyleBuilder(enableHardwareAcceleration), preparseOutput: true }, props));
}

var camelCaseAttributes = /*#__PURE__*/new Set(['baseFrequency', 'diffuseConstant', 'kernelMatrix', 'kernelUnitLength', 'keySplines', 'keyTimes', 'limitingConeAngle', 'markerHeight', 'markerWidth', 'numOctaves', 'targetX', 'targetY', 'surfaceScale', 'specularConstant', 'specularExponent', 'stdDeviation', 'tableValues']);

var defaultOrigin = 0.5;
var svgAttrsTemplate = function () {
    return {
        style: {}
    };
};
var progressToPixels = function (progress, length) {
    return __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */].transform(progress * length);
};
var unmeasured = { x: 0, y: 0, width: 0, height: 0 };
function calcOrigin(origin, offset, size) {
    return typeof origin === 'string' ? origin : __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */].transform(offset + size * origin);
}
function calculateSVGTransformOrigin(dimensions, originX, originY) {
    return calcOrigin(originX, dimensions.x, dimensions.width) + " " + calcOrigin(originY, dimensions.y, dimensions.height);
}
function buildSVGAttrs(_a, dimensions, totalPathLength, cssBuilder, attrs, isDashCase) {
    if (dimensions === void 0) {
        dimensions = unmeasured;
    }
    if (cssBuilder === void 0) {
        cssBuilder = createStyleBuilder(false, false);
    }
    if (attrs === void 0) {
        attrs = svgAttrsTemplate();
    }
    if (isDashCase === void 0) {
        isDashCase = true;
    }
    var attrX = _a.attrX,
        attrY = _a.attrY,
        originX = _a.originX,
        originY = _a.originY,
        pathLength = _a.pathLength,
        _b = _a.pathSpacing,
        pathSpacing = _b === void 0 ? 1 : _b,
        _c = _a.pathOffset,
        pathOffset = _c === void 0 ? 0 : _c,
        state = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
    var style = cssBuilder(state);
    for (var key in style) {
        if (key === 'transform') {
            attrs.style.transform = style[key];
        } else {
            var attrKey = isDashCase && !camelCaseAttributes.has(key) ? camelToDash(key) : key;
            attrs[attrKey] = style[key];
        }
    }
    if (originX !== undefined || originY !== undefined || style.transform) {
        attrs.style.transformOrigin = calculateSVGTransformOrigin(dimensions, originX !== undefined ? originX : defaultOrigin, originY !== undefined ? originY : defaultOrigin);
    }
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (totalPathLength !== undefined && pathLength !== undefined) {
        attrs[isDashCase ? 'stroke-dashoffset' : 'strokeDashoffset'] = progressToPixels(-pathOffset, totalPathLength);
        attrs[isDashCase ? 'stroke-dasharray' : 'strokeDasharray'] = progressToPixels(pathLength, totalPathLength) + " " + progressToPixels(pathSpacing, totalPathLength);
    }
    return attrs;
}
function createAttrBuilder(dimensions, totalPathLength, isDashCase) {
    if (isDashCase === void 0) {
        isDashCase = true;
    }
    var attrs = svgAttrsTemplate();
    var cssBuilder = createStyleBuilder(false, false);
    return function (state) {
        return buildSVGAttrs(state, dimensions, totalPathLength, cssBuilder, attrs, isDashCase);
    };
}

var getDimensions = function (element) {
    return typeof element.getBBox === 'function' ? element.getBBox() : element.getBoundingClientRect();
};
var getSVGElementDimensions = function (element) {
    try {
        return getDimensions(element);
    } catch (e) {
        return { x: 0, y: 0, width: 0, height: 0 };
    }
};

var isPath = function (element) {
    return element.tagName === 'path';
};
var svgStyler = /*#__PURE__*/createStyler({
    onRead: function (key, _a) {
        var element = _a.element;
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        if (!isTransformProp(key)) {
            return element.getAttribute(key);
        } else {
            var valueType = getValueType(key);
            return valueType ? valueType.default || 0 : 0;
        }
    },
    onRender: function (state, _a) {
        var element = _a.element,
            buildAttrs = _a.buildAttrs;
        var attrs = buildAttrs(state);
        for (var key in attrs) {
            if (key === 'style') {
                Object.assign(element.style, attrs.style);
            } else {
                element.setAttribute(key, attrs[key]);
            }
        }
    }
});
var svg = function (element) {
    var dimensions = getSVGElementDimensions(element);
    var pathLength = isPath(element) && element.getTotalLength ? element.getTotalLength() : undefined;
    return svgStyler({
        element: element,
        buildAttrs: createAttrBuilder(dimensions, pathLength)
    });
};

var viewport = /*#__PURE__*/createStyler({
    useCache: false,
    onRead: function (key) {
        return key === 'scrollTop' ? window.pageYOffset : window.pageXOffset;
    },
    onRender: function (_a) {
        var _b = _a.scrollTop,
            scrollTop = _b === void 0 ? 0 : _b,
            _c = _a.scrollLeft,
            scrollLeft = _c === void 0 ? 0 : _c;
        return window.scrollTo(scrollLeft, scrollTop);
    }
});

var cache = /*#__PURE__*/new WeakMap();
var createDOMStyler = function (node, props) {
    var styler;
    if (node instanceof HTMLElement) {
        styler = createCssStyler(node, props);
    } else if (node instanceof SVGElement) {
        styler = svg(node);
    } else if (node === window) {
        styler = viewport(node);
    }
    Object(__WEBPACK_IMPORTED_MODULE_3_hey_listen__["a" /* invariant */])(styler !== undefined, 'No valid node provided. Node must be HTMLElement, SVGElement or window.');
    cache.set(node, styler);
    return styler;
};
var getStyler = function (node, props) {
    return cache.has(node) ? cache.get(node) : createDOMStyler(node, props);
};
function index(nodeOrSelector, props) {
    var node = typeof nodeOrSelector === 'string' ? document.querySelector(nodeOrSelector) : nodeOrSelector;
    return getStyler(node, props);
}

/* harmony default export */ __webpack_exports__["a"] = (index);



/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Form; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormField__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ItemList__ = __webpack_require__(65);












var style = {
  overflowX: "hidden"
};

var Form =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Form, _React$Component);

  function Form() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Form);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Form)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleSubmit", function (event) {
      event.preventDefault(); // Don't refresh the page

      var onSubmit = _this.props.onSubmit;

      if (onSubmit != null) {
        onSubmit(event);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Form, [{
    key: "_handleChange",
    value: function _handleChange(name, value) {
      if (!this.props.onChange) {
        return;
      }

      this.props.onChange(name, value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          fields = _this$props.fields,
          onBlur = _this$props.onBlur,
          onEnterPressed = _this$props.onEnterPressed,
          autoFocusField = _this$props.autoFocusField,
          shouldScrollIntoView = _this$props.shouldScrollIntoView; // jsx-a11y has a bug which will be fixed in a later version
      // https://github.com/evcohen/eslint-plugin-jsx-a11y/issues/253

      /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("form", {
        style: style,
        onSubmit: this._handleSubmit,
        onBlur: onBlur
      }, fields.map(function (field, index) {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
          key: field.name
        }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__FormField__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, field, {
          shouldScrollIntoView: shouldScrollIntoView,
          onChange: function onChange(value) {
            return _this2._handleChange(field.name, value);
          },
          onEnterPressed: onEnterPressed,
          autoFocus: autoFocusField === field.name
        })), fields[index + 1] && __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ItemList__["a" /* Divider */], null));
      }));
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "propTypes", {
  fields: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_10__FormField__["a" /* default */].propTypes)),
  onChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  // (name: string, value: any) => void
  onSubmit: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  // (event: Event) => void
  onBlur: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  // (event: Event) => void
  onEnterPressed: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  // () => void
  autoFocusField: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  // Field name or undefined
  shouldScrollIntoView: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(Form, "defaultProps", {
  fields: []
});



/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(150),
    isObjectLike = __webpack_require__(151);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = showPivotDevices;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_Pivot_CollapsibleList__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_Pivot_PartialCheckbox__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nx_components_Checkbox__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nx_components_Dialog__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_Dialogs_renderInDestroyableRoot__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_models_device_sorter__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nx_components_Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_nx_components_Locales__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















var PivotDevicesGroupsDialog =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PivotDevicesGroupsDialog, _React$Component);

  function PivotDevicesGroupsDialog() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PivotDevicesGroupsDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(PivotDevicesGroupsDialog)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "language", Object(__WEBPACK_IMPORTED_MODULE_20_nx_components_Locales__["b" /* getLanguageSet */])().nexia_mobile.dialogs.PivotDevicesGroupsDialog);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      buildings: []
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isConnected", function (device) {
      var isSavingSchedule = _this.props.isSavingSchedule;
      return device.get("is_connected") || isSavingSchedule && device.get("scheduling_enabled");
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_buildingTemplate", function () {
      return {
        lonelyStats: [],
        groupStats: [],
        totalDisabledStats: 0,
        disabledGroupStats: []
      };
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_addRemoveThermostat", function (buildingIndex, modelIndex) {
      var childIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var buildings = _this.state.buildings;

      var model = _this._getSortedModel(buildingIndex, modelIndex, childIndex);

      if (!_this._isConnected(model)) {
        return;
      }

      var building = _this._getOrCreateBuilding(buildingIndex);

      var isGroup = model.get("type") === "group";

      if (isGroup || childIndex > -1) {
        // Group logic
        if (isGroup) {
          var members = model.getGroupMembers().models;

          if (!building.groupStats[modelIndex] || !_this._isGroupChecked(buildingIndex, modelIndex, building)) {
            _this._toggleAllGroupStats(buildingIndex, modelIndex, members, "add");
          } else {
            _this._toggleAllGroupStats(buildingIndex, modelIndex, members, "remove");
          }
        } // Group member logic


        if (childIndex > -1) {
          building = _this._toggleGroupMember(modelIndex, childIndex, building);
        } // Shared group and group member logic to toggle the group checkbox


        if (_this._isGroupChecked(buildingIndex, modelIndex, building)) {
          _this._toggleLonelyStat(modelIndex, building, "add");
        } else {
          _this._toggleLonelyStat(modelIndex, building, "remove");
        } // Remove any empty groups


        if (building.groupStats[modelIndex] && building.groupStats[modelIndex].length === 0) {
          delete building.groupStats[modelIndex];
          building.groupStats = building.groupStats.filter(Boolean);
        }
      } else {
        // Non-group logic
        building = _this._toggleLonelyStat(modelIndex, building, type);
      }

      buildings[buildingIndex] = building;

      _this.setState(buildings);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_getSortedModel", function (buildingIndex, modelIndex) {
      var childIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      var building = _this.sortedBuildings[buildingIndex];
      return childIndex > -1 ? building[modelIndex].getGroupMembers().models[childIndex] : building[modelIndex];
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_getOrCreateBuilding", function (buildingIndex) {
      return _this.state.buildings[buildingIndex] ? _this.state.buildings[buildingIndex] : _this._buildingTemplate();
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleCancel", function () {
      if (!_this.props.closeDialog) {
        return;
      }

      if (_this.props.onCancel) {
        // Some components may have additional cancel requirements like state or dialog requirements
        _this.props.onCancel();
      }

      _this.props.closeDialog();
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleApply", function () {
      if (!_this.props.onChoose) {
        return;
      }

      var buildings = _this.state.buildings;
      var ids = [];
      buildings.forEach(function (building, buildingIndex) {
        var lonelyStats = building.lonelyStats;
        var groupStats = building.groupStats;
        lonelyStats.forEach(function (statIndex) {
          var stat = _this.sortedBuildings[buildingIndex][statIndex];

          if (stat.get("type") === "group") {
            return;
          }

          ids.push(stat.get("device_identifier"));
        });
        Object.entries(groupStats).forEach(function (group) {
          var groupIndex = parseInt(group[0]);
          var selectedStats = group[1];

          var groupMembers = _this.sortedBuildings[buildingIndex][groupIndex].getGroupMembers().models;

          selectedStats.forEach(function (groupStatIndex) {
            ids.push(groupMembers[groupStatIndex].get("device_identifier"));
          });
        });
      });

      _this.props.onChoose(ids);

      _this.props.closeDialog();

      Object(__WEBPACK_IMPORTED_MODULE_21_nexia_mobile_flux_like_dispatch__["a" /* default */])("FAST_POPULATE_SESSION");
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleSelectItem", function (buildingIndex, statIndex, childIndex) {
      _this._addRemoveThermostat(buildingIndex, statIndex, childIndex);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_createCheckBox", function (name, buildingIndex, index) {
      var childIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
      var _this$state$buildings = _this.state.buildings[buildingIndex],
          lonelyStats = _this$state$buildings.lonelyStats,
          groupStats = _this$state$buildings.groupStats,
          disabledGroupStats = _this$state$buildings.disabledGroupStats;
      var isChecked = false;
      var partialChecked = false;

      if (childIndex < 0) {
        if (lonelyStats.indexOf(index) >= 0) {
          isChecked = true;
        } else if (groupStats[index] && groupStats[index].length) {
          partialChecked = true;
        }
      } else if (groupStats[index] && groupStats[index].indexOf(childIndex) >= 0) {
        isChecked = true;
      }

      var isDisabled = false;
      var thermostat = childIndex >= 0 ? _this.sortedBuildings[buildingIndex][index].getGroupMembers().models[childIndex] : _this.sortedBuildings[buildingIndex][index];

      if (thermostat.get("type") === "group") {
        if (thermostat.getGroupMembers().length === disabledGroupStats[thermostat.id]) {
          isDisabled = true;
        }
      } else {
        isDisabled = !_this._isConnected(thermostat);
      }

      var key = "".concat(buildingIndex).concat(index);

      if (childIndex >= 0) {
        key = "".concat(key).concat(childIndex);
      }

      var callback = function callback() {
        _this._handleSelectItem(buildingIndex, index, childIndex);
      };

      return _this._checkbox(key, name, isChecked, partialChecked, isDisabled, callback);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_createBuildingCheckbox", function (buildingName, buildingIndex) {
      var building = _this.state.buildings[buildingIndex];
      var currentCount = building.lonelyStats.length;
      var isChecked = currentCount + building.totalDisabledStats === _this.deviceCounts[buildingIndex] && _this.deviceCounts[buildingIndex] > 0;
      var partialChecked = building.lonelyStats.length > 0 || building.groupStats.length > 0;
      var isDisabled = _this.deviceCounts[buildingIndex] === building.totalDisabledStats;

      if (partialChecked || isChecked) {
        _this.hasSelectedItems = true;
      }

      var callback = function callback() {
        _this._handleSelectedBuilding(buildingIndex);
      };

      return _this._checkbox(buildingIndex, buildingName, isChecked, partialChecked, isDisabled, callback);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_checkbox", function (key, name, isChecked, partialChecked, isDisabled, callback) {
      var styles = _this._getStyles();

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: _objectSpread({}, styles.checkbox, {}, isDisabled ? {
          color: "#dbdbdb"
        } : null),
        key: key
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: {
          display: "inline-block",
          position: "relative"
        }
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nx_components_Checkbox__["a" /* default */], {
        style: isDisabled ? {
          backgroundColor: "#cbcbcb"
        } : null,
        checked: isChecked,
        onTap: !isDisabled ? callback : null
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nx_components_Pivot_PartialCheckbox__["a" /* default */], {
        style: styles.partialCheckbox,
        checked: partialChecked
      })), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_nx_components_Tappable__["b" /* default */], {
        onTap: !isDisabled ? callback : null
      }, function (_ref) {
        var tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("span", {
          style: styles.label,
          tabIndex: 0,
          ref: tapTargetRefHandler
        }, name);
      }));
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleSelectedBuilding", function (buildingIndex) {
      var buildings = _this.state.buildings;
      var sortedBuilding = _this.sortedBuildings[buildingIndex];
      var building = _this.state.buildings[buildingIndex];
      var isAdding = building.lonelyStats.length + building.totalDisabledStats !== _this.deviceCounts[buildingIndex];
      var type = isAdding ? "add" : "remove";
      sortedBuilding.forEach(function (device, index) {
        if (device.get("type") !== "group") {
          _this._addRemoveThermostat(buildingIndex, index, -1, type);
        } else {
          var isChecked = _this._isGroupChecked(buildingIndex, index, building);

          if (isAdding && !isChecked || !isAdding && isChecked) {
            _this._addRemoveThermostat(buildingIndex, index);
          }
        }
      });
      buildings[buildingIndex] = building;

      _this.setState(buildings);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PivotDevicesGroupsDialog, [{
    key: "_getStyles",
    value: function _getStyles() {
      var colors = this.props.colors;
      return Object(__WEBPACK_IMPORTED_MODULE_15_nx_components_utils_prefixStyles__["b" /* default */])({
        container: {
          display: "flex",
          flexDirection: "column",
          margin: 12,
          // oddly enough, this fixes the positioning of the scrollbar on
          // Galaxy s6 [bug #141988949]. issue is caused by usage of mui RadioButton.
          transform: "translate3d(0,0,0)",
          maxWidth: "80vw"
        },
        title: {
          color: colors.SECONDARY,
          marginBottom: 12,
          flex: "0 0 auto"
        },
        list: {
          overflowY: "auto",
          overflowX: "hidden",
          flex: "1 1 auto",
          maxHeight: "50vh"
        },
        buttons: {
          flex: "0 0 auto",
          display: "flex",
          justifyContent: "flex-end"
        },
        button: {
          margin: "0.2em 0.1em"
        },
        row: {
          display: "flex",
          alignItems: "center"
        },
        checkbox: {
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          marginBottom: 12
        },
        label: {
          flex: "1 1 auto",
          cursor: "pointer",
          paddingLeft: 8,
          paddingRight: 8,
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        partialCheckbox: {
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: -1
        }
      });
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      var targetId = this.props.targetId;
      var buildings = this.state.buildings;
      var locations = __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_flux_like_store__["a" /* default */].session.get("locations");
      var targetBuildingId = __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_flux_like_store__["a" /* default */].appState.currentLocation.id;
      var buildingIds = [];
      this.sortedBuildings = [];
      this.buildingNames = [];
      this.deviceCounts = [];
      locations.forEach(function (location) {
        buildingIds.push(location.get("id"));

        _this2.sortedBuildings.push(__WEBPACK_IMPORTED_MODULE_17_nexia_mobile_models_device_sorter__["a" /* default */].sort(location.get("devices").map(function (device) {
          return device;
        })));

        _this2.buildingNames.push(location.get("name"));

        _this2.deviceCounts.push(location.get("devices").length);
      });

      var lonelyDisabledCheck = function lonelyDisabledCheck(newBuilding, device) {
        if (_this2._isConnected(device)) {
          return;
        }

        newBuilding.totalDisabledStats++;
      };

      var groupDisabledCheck = function groupDisabledCheck(newBuilding, device, groupStat, thermostatId) {
        if (_this2._isConnected(groupStat)) {
          return;
        }

        if (!newBuilding.disabledGroupStats[thermostatId]) {
          newBuilding.disabledGroupStats[thermostatId] = 0;
        }

        newBuilding.disabledGroupStats[thermostatId]++;

        if (device.getGroupMembers().length === newBuilding.disabledGroupStats[thermostatId]) {
          newBuilding.totalDisabledStats++;
        }
      }; // Find the intial targeted thermostat. Move it to the top of the list and select it by default.


      this.sortedBuildings.forEach(function (sortedBuilding, buildingIndex) {
        var newBuilding = _this2._buildingTemplate();

        var isTargetBuilding = buildingIds[buildingIndex] === targetBuildingId;
        sortedBuilding.forEach(function (device, statIndex) {
          var thermostatId = device.get("id");

          if (device.get("type") === "group") {
            device.getGroupMembers().forEach(function (groupStat, groupIndex) {
              groupDisabledCheck(newBuilding, device, groupStat, thermostatId);

              if (groupStat.get("id") === targetId) {
                sortedBuilding.unshift(sortedBuilding.splice(statIndex, 1)[0]);
                newBuilding.lonelyStats.push(0);
                newBuilding.groupStats[0] = [groupIndex];
              }
            });
          } else {
            lonelyDisabledCheck(newBuilding, device);

            if (isTargetBuilding && device.get("id") === targetId) {
              sortedBuilding.unshift(sortedBuilding.splice(statIndex, 1)[0]);
              newBuilding.lonelyStats.push(0);
            }
          }
        });

        if (isTargetBuilding) {
          buildings.unshift(newBuilding);
          [_this2.sortedBuildings, _this2.buildingNames, _this2.deviceCounts].forEach(function (subject) {
            subject.unshift(subject.splice(buildingIndex, 1)[0]);
          });
        } else {
          buildings.push(newBuilding);
        }
      });
      this.setState(buildings);
    }
  }, {
    key: "_toggleGroupMember",
    value: function _toggleGroupMember(parentIndex, statIndex, building, type) {
      if (building.groupStats[parentIndex]) {
        var index = building.groupStats[parentIndex].indexOf(statIndex);

        if (type !== "add" && index >= 0) {
          building.groupStats[parentIndex].splice(index, 1);
        } else if (index === -1) {
          building.groupStats[parentIndex].push(statIndex);
        }
      } else {
        building.groupStats[parentIndex] = [statIndex];
      }

      return building;
    }
  }, {
    key: "_isGroupChecked",
    value: function _isGroupChecked(buildingIndex, groupIndex, building) {
      var isChecked = false;

      if (building.groupStats[groupIndex]) {
        var group = this._getSortedModel(buildingIndex, groupIndex);

        var membersCount = group.getGroupMembers().length;
        var membersChecked = building.groupStats[groupIndex].length;

        var groupId = this._getSortedModel(buildingIndex, groupIndex).get("id");

        var disabledCount = building.disabledGroupStats[groupId];
        disabledCount = disabledCount || 0;
        isChecked = disabledCount + membersChecked === membersCount;
      }

      return isChecked;
    }
  }, {
    key: "_toggleAllGroupStats",
    value: function _toggleAllGroupStats(buildingIndex, groupIndex, members, type) {
      for (var statIndex = 0; statIndex < members.length; statIndex++) {
        if (this._isConnected(members[statIndex])) {
          this._addRemoveThermostat(buildingIndex, groupIndex, statIndex, type);
        }
      }
    }
  }, {
    key: "_toggleLonelyStat",
    value: function _toggleLonelyStat(statIndex, building) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var index = building.lonelyStats.indexOf(statIndex);
      var addRemove = type;

      if (!addRemove) {
        addRemove = index > -1 ? "remove" : "add";
      }

      if (addRemove === "remove" && index >= 0) {
        building.lonelyStats.splice(index, 1);
      } else if (addRemove !== "remove" && index < 0) {
        building.lonelyStats.push(statIndex);
      }

      return building;
    }
  }, {
    key: "_constructList",
    value: function _constructList() {
      var _this3 = this;

      /* eslint-disable react/no-array-index-key */
      var styles = this._getStyles();

      var results = this.sortedBuildings.map(function (building, buildingIndex) {
        var buildingHeader = _this3._createBuildingCheckbox(_this3.buildingNames[buildingIndex], buildingIndex);

        var checkboxes = building.map(function (model, itemIndex) {
          var isGroup = model.get("type") === "group";
          var items;
          var header;

          if (isGroup) {
            header = _this3._createCheckBox(model.get("name"), buildingIndex, itemIndex);
            items = [];
            model.getGroupMembers().map(function (device, groupIndex) {
              return items.push(_this3._createCheckBox(device.get("name"), buildingIndex, itemIndex, groupIndex));
            });
          } else {
            items = _this3._createCheckBox(model.get("name"), buildingIndex, itemIndex);
          }

          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
            key: itemIndex,
            style: styles.row
          }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_Pivot_CollapsibleList__["a" /* default */], {
            open: true,
            header: header,
            items: items
          }));
        });
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          key: "checkbox_".concat(buildingIndex),
          style: styles.row
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_Pivot_CollapsibleList__["a" /* default */], {
          open: true,
          header: buildingHeader,
          items: checkboxes
        }));
      });
      return results;
      /* eslint-enable react/no-array-index-key */
    }
  }, {
    key: "render",
    value: function render() {
      var open = this.props.open;

      var styles = this._getStyles();

      this.hasSelectedItems = false;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_nx_components_Dialog__["a" /* default */], {
        open: open,
        onTapBackground: this._handleCancel,
        onRequestClose: this._handleCancel
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.container
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.title
      }, this.language.thermostatsTitle), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.list
      }, this._constructList()), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.buttons
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nx_components_Button__["a" /* default */], {
        onTap: this._handleCancel,
        style: styles.button,
        theme: "ghost"
      }, this.language.cancel), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nx_components_Button__["a" /* default */], {
        disabled: !this.hasSelectedItems,
        onTap: this._handleApply,
        style: styles.button
      }, this.language.apply))));
    }
  }]);

  return PivotDevicesGroupsDialog;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(PivotDevicesGroupsDialog, "propTypes", {
  open: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onChoose: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onCancel: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  closeDialog: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  targetId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  isSavingSchedule: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  colors: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object // ColorSet

});

var PivotDevicesGroupDialogWithColors = Object(__WEBPACK_IMPORTED_MODULE_9_nx_components_ColorsProvider__["c" /* withColorsProvider */])(PivotDevicesGroupsDialog);
function showPivotDevices(options) {
  Object(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_Dialogs_renderInDestroyableRoot__["c" /* default */])(function (destroyRoot) {
    var dialogProps = _objectSpread({}, options);

    dialogProps.closeDialog = function () {
      destroyRoot();

      if (_.isFunction(options.closeDialog)) {
        options.closeDialog();
      }
    };

    return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](PivotDevicesGroupDialogWithColors, dialogProps);
  });
}

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SchemaFieldsFormManager; });
/* unused harmony export bpfrpt_proptype_SubmitHandlerArgument */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_SchemaFieldsForm__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_validateFields__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_schema__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/




var bpfrpt_proptype_SubmitHandlerArgument = {
  setServerErrors: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,
  validateBeforeSubmit: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,
  getFieldValues: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired
};

var SchemaFieldsFormManager =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SchemaFieldsFormManager, _React$Component);

  function SchemaFieldsFormManager() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SchemaFieldsFormManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SchemaFieldsFormManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", _this._initialState(_this.props));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_setServerErrors", function (serverErrors) {
      if (!_this._isMounted) {
        return;
      }

      _this.setState({
        serverErrors: serverErrors
      }, function () {
        var names = Object.keys(serverErrors);

        if (_this._isMounted && names.length > 0) {
          if (_this._schemaFieldsForm) {
            _this._schemaFieldsForm.scrollToField(names[0]);
          }
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_validateBeforeSubmit", function () {
      var schema = _this.props.schema;
      var fieldValues = _this.state.fieldValues;
      var fields = schema.getSchemaFields();
      var validationResult = Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_validateFields__["a" /* default */])(fields, fieldValues, {
        validateUnsetFields: true
      });

      if (validationResult.hasErrors && _this._isMounted) {
        // Update state so that these errors are shown in the rendered output
        _this.setState({
          validateUnsetFields: true
        }, function () {
          if (_this._schemaFieldsForm) {
            _this._schemaFieldsForm.scrollToField(validationResult.nameOfFirstFieldWithError);
          }
        });
      }

      return validationResult;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_getFieldValues", function () {
      var schema = _this.props.schema;
      var fieldValues = _this.state.fieldValues;
      var values = {};
      schema.getSchemaFields().forEach(function (field) {
        values[field.name] = Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_validateFields__["b" /* getValueForField */])(field, fieldValues);
      });
      return values;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleSubmit", function () {
      var onSubmitRequested = _this.props.onSubmitRequested;

      if (onSubmitRequested == null) {
        return;
      }

      onSubmitRequested({
        setServerErrors: _this._setServerErrors,
        validateBeforeSubmit: _this._validateBeforeSubmit,
        getFieldValues: _this._getFieldValues
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SchemaFieldsFormManager, [{
    key: "_initialState",
    value: function _initialState(props) {
      return {
        fieldValues: props.initialChanges || {},
        validateUnsetFields: false,
        serverErrors: {}
      };
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.schema !== this.props.schema) {
        this.setState(this._initialState(nextProps));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          schema = _this$props.schema,
          children = _this$props.children,
          title = _this$props.title,
          controllableThermostatsLabel = _this$props.controllableThermostatsLabel;
      var _this$state = this.state,
          fieldValues = _this$state.fieldValues,
          validateUnsetFields = _this$state.validateUnsetFields,
          serverErrors = _this$state.serverErrors;
      var fields = schema.getSchemaFields();

      var _validateFields = Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_validateFields__["a" /* default */])(fields, fieldValues, {
        validateUnsetFields: validateUnsetFields
      }),
          errors = _validateFields.errors;

      var fieldsWithoutOrphans = fields.filter(function (field) {
        return !Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_validateFields__["c" /* isOrphanedField */])(field, fields, fieldValues);
      });
      var schemaFieldsForm = __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_SchemaFieldsForm__["a" /* default */], {
        ref: function ref(inst) {
          return _this2._schemaFieldsForm = inst;
        },
        fields: fieldsWithoutOrphans,
        fieldErrors: _objectSpread({}, errors, {}, serverErrors),
        fieldValues: fieldValues,
        title: title || "",
        schema: schema,
        controllableThermostatsLabel: controllableThermostatsLabel,
        onChange: function onChange(name, newValue) {
          _this2.setState(function (prevState) {
            var nextState = {
              fieldValues: _objectSpread({}, prevState.fieldValues, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({}, name, newValue)),
              serverErrors: _objectSpread({}, prevState.serverErrors)
            };
            fields.forEach(function (field) {
              if (Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_validateFields__["c" /* isOrphanedField */])(field, fields, nextState.fieldValues)) {
                delete nextState.fieldValues[field.name];
              }
            });

            if (prevState.serverErrors[name]) {
              delete nextState.serverErrors[name];
            }

            return nextState;
          });
        },
        onSubmit: this._handleSubmit,
        onEnterPressed: this._handleSubmit
      });
      return children({
        schemaFieldsForm: schemaFieldsForm,
        setServerErrors: this._setServerErrors,
        validateBeforeSubmit: this._validateBeforeSubmit,
        getFieldValues: this._getFieldValues
      });
    }
  }]);

  return SchemaFieldsFormManager;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SchemaFieldsFormManager, "propTypes", {
  schema: function schema() {
    return (typeof __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_schema__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_schema__["a" /* default */]).isRequired : __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  onSubmitRequested: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,
  // This eslint flag is a false positive
  // eslint-disable-next-line react/no-unused-prop-types
  initialChanges: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.objectOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  })
});





/***/ }),
/* 493 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BooleanField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_BooleanItem__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormError__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Theme__ = __webpack_require__(18);













var BooleanField =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(BooleanField, _React$Component);

  function BooleanField() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, BooleanField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(BooleanField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      value: Boolean(_this.props.value)
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleChange", function (isInputChecked) {
      _this.setState({
        value: isInputChecked
      });

      if (!_this.props.onChange) {
        return;
      }

      _this.props.onChange(isInputChecked);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(BooleanField, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value === this.state.value) {
        return;
      }

      var value = nextProps.value === "false" ? false : Boolean(nextProps.value);
      this.setState({
        value: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          label = _this$props.label,
          appearance = _this$props.appearance,
          labelPositionRight = _this$props.labelPositionRight,
          labelHasLink = _this$props.labelHasLink,
          error = _this$props.error,
          labelStyle = _this$props.labelStyle,
          style = _this$props.style;
      var value = this.state.value;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "BooleanField",
        "data-prop-name": name,
        "data-prop-value": value.toString(),
        style: style
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__FormError__["b" /* default */], {
        error: error
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: {
          padding: __WEBPACK_IMPORTED_MODULE_11__Theme__["a" /* default */].Padding.CONTENT
        }
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__internal_BooleanItem__["a" /* default */], {
        value: value,
        label: label,
        labelPositionRight: labelPositionRight,
        labelHasLink: labelHasLink,
        onChange: this._handleChange,
        appearance: appearance,
        labelStyle: labelStyle
      }))));
    }
  }]);

  return BooleanField;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(BooleanField, "propTypes", {
  name: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  labelPositionRight: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  labelHasLink: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  error: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  appearance: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  labelStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object
});



/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/trane_commercial_background-44729d32-pivot.png";

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DumbBackButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BackButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_AppBar__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_BackButtonResponder__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_HistoryPageTransitionController__ = __webpack_require__(89);













var DumbBackButton =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DumbBackButton, _React$Component);

  function DumbBackButton() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DumbBackButton);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DumbBackButton).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DumbBackButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onTap = _this$props.onTap,
          innerRef = _this$props.innerRef;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nx_components_AppBar__["c" /* AppBarIconWrapper */], {
        onTap: onTap,
        innerRef: innerRef,
        "aria-label": "Back",
        holdActiveUntil: __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_HistoryPageTransitionController__["a" /* getTransitionPromise */]
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_Icons__["_43" /* IconThinChevronLeft */], null));
    }
  }]);

  return DumbBackButton;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DumbBackButton, "propTypes", {
  onTap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  // () => void
  innerRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func // (?HTMLElement) => void

});

var BackButton =
/*#__PURE__*/
function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(BackButton, _React$Component2);

  function BackButton() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, BackButton);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(BackButton).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(BackButton, [{
    key: "_isTopmostElement",
    value: function _isTopmostElement() {
      if (!this._el) {
        return false;
      }

      if (!document.body.contains(this._el)) {
        return false;
      }

      var buttonRect = this._el.getBoundingClientRect();

      var buttonCenterX = buttonRect.x + buttonRect.width / 2;
      var buttonCenterY = buttonRect.y + buttonRect.height / 2;
      var topmostElementAtButtonCenter = document.elementFromPoint(buttonCenterX, buttonCenterY);
      return this._el.contains(topmostElementAtButtonCenter);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var onTap = this.props.onTap;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_BackButtonResponder__["b" /* default */], {
        onPressed: function onPressed() {
          if (_this._isTopmostElement()) {
            onTap();
          } else {// Something is covering the BackButton, like a SpinnerOverlay
            // background. Don't actually *do* anything, but still consider
            // the press handled, because we don't want to quit the app.
            // Unless a button is covering the back button, this behaves as
            // if the user tried to tap on the back button.
          }

          return {
            handled: true
          };
        }
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](DumbBackButton, {
        innerRef: function innerRef(el) {
          return _this._el = el;
        },
        onTap: onTap
      }));
    }
  }]);

  return BackButton;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(BackButton, "propTypes", {
  onTap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func // () => void

});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(BackButton, "defaultProps", {
  onTap: function onTap() {
    return __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_history__["d" /* history */].goBack();
  }
});



/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BooleanItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Toggle__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Checkbox__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








 // A string for people

var BooleanItemLabelWithoutColor =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(BooleanItemLabelWithoutColor, _React$Component);

  function BooleanItemLabelWithoutColor() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, BooleanItemLabelWithoutColor);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(BooleanItemLabelWithoutColor).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(BooleanItemLabelWithoutColor, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          labelHasLink = _this$props.labelHasLink,
          label = _this$props.label,
          style = _this$props.style,
          onTap = _this$props.onTap,
          ariaPressed = _this$props["aria-pressed"],
          colors = _this$props.colors;
      var styles = {
        labelWrapper: {
          maxWidth: "66%",
          flexGrow: "1",
          flexShrink: "0"
        },
        label: _objectSpread({
          color: colors.TEXT,
          width: "100%",
          textAlign: "left"
        }, __WEBPACK_IMPORTED_MODULE_14__Theme__["a" /* default */].Styles.flexStretch)
      };
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: _objectSpread({}, styles.labelWrapper, {}, style)
      }, labelHasLink ? __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("span", {
        "data-component-section": "label",
        style: styles.label,
        dangerouslySetInnerHTML: {
          __html: label
        }
      }) : __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Tappable__["b" /* default */], {
        onTap: onTap
      }, function (_ref) {
        var tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__NoStyleButton__["a" /* default */], {
          innerRef: tapTargetRefHandler,
          style: styles.label,
          "aria-pressed": ariaPressed,
          "data-component-section": "label"
        }, label);
      }));
    }
  }]);

  return BooleanItemLabelWithoutColor;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(BooleanItemLabelWithoutColor, "propTypes", {
  labelHasLink: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.string]).isRequired,
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  onTap: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func,
  "\"aria-pressed\"": __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

var BooleanItemLabel = Object(__WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["c" /* withColorsProvider */])(BooleanItemLabelWithoutColor);
var booleanItemStyles = Object(__WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["b" /* default */])({
  checkboxItemContainer: {
    display: "flex",
    alignItems: "start",
    justifyContent: "space-between"
  }
});

var BooleanItem =
/*#__PURE__*/
function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(BooleanItem, _React$Component2);

  function BooleanItem() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, BooleanItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(BooleanItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleChecked", function () {
      var newValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !_this.props.value;
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(newValue);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(BooleanItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          label = _this$props2.label,
          labelPositionRight = _this$props2.labelPositionRight,
          labelHasLink = _this$props2.labelHasLink,
          value = _this$props2.value,
          appearance = _this$props2.appearance,
          labelStyle = _this$props2.labelStyle;
      var labelNoHTML = label;

      if (labelHasLink) {
        // Ensure the aria label for the Toggle doesn't contain raw HTML.
        var div = document.createElement("div");
        div.innerHTML = label;
        labelNoHTML = div.textContent;
      }

      var booleanItemLabelProps = {
        labelHasLink: labelHasLink,
        label: label,
        style: labelStyle,
        onTap: this._handleChecked,
        "aria-pressed": value
      };
      var appearances = {
        toggle: __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Toggle__["a" /* default */], {
          checked: value,
          onChange: this._handleChecked,
          "aria-label": labelNoHTML
        }),
        checkbox: __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Checkbox__["a" /* default */], {
          checked: value,
          onTap: this._handleChecked,
          "aria-label": labelNoHTML
        })
      };
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        "data-component-name": "BooleanItem",
        style: {
          textAlign: "left",
          display: "block",
          width: "100%"
        }
      }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: booleanItemStyles.checkboxItemContainer
      }, !labelPositionRight ? __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](BooleanItemLabel, booleanItemLabelProps) : null, appearances[appearance] || appearances.toggle, labelPositionRight ? __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](BooleanItemLabel, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        style: {
          paddingLeft: "1em",
          maxWidth: "90%",
          fontSize: "0.9em"
        }
      }, booleanItemLabelProps)) : null));
    }
  }]);

  return BooleanItem;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(BooleanItem, "defaultProps", {
  appearance: "toggle"
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(BooleanItem, "propTypes", {
  appearance: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.oneOf(["checkbox", "toggle"]),
  value: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.string]).isRequired,
  labelPositionRight: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool,
  labelHasLink: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func,
  labelStyle: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.object
});






/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Select_SelectWithoutTappable__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Form_fields_FormFieldIcons_InfoIcon__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Select_SelectDialog__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_prop_types__);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var SelectItem =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(SelectItem, _React$Component);

  function SelectItem() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, SelectItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(SelectItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      open: false
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "toggleOpen", function () {
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      });
    });

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleOptionTapped", function (option) {
      if (_this.props.onChange) {
        _this.props.onChange(option.value);
      }

      _this.toggleOpen();
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(SelectItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          label = _this$props.label,
          placeholder = _this$props.placeholder,
          infoIcon = _this$props.infoIcon,
          infoText = _this$props.infoText,
          colors = _this$props.colors,
          props = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["label", "placeholder", "infoIcon", "infoText", "colors"]);

      var open = this.state.open;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["b" /* default */])({
        outerWrapper: {
          display: "flex",
          alignItems: "center"
        },
        wrapper: {
          marginLeft: "0",
          marginRight: "0",
          position: "relative",
          color: colors.TEXT,
          width: "100%",
          textAlign: "left",
          flexGrow: "1",
          flexBasis: "100%"
        },
        container: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer"
        },
        label: {
          color: colors.TEXT,
          display: "flex",
          flexGrow: "1",
          flexShrink: "0",
          flexBasis: "66%",
          paddingRight: "0.75em",
          outline: "none"
        },
        selectWrapper: _objectSpread({
          color: colors.TEXT
        }, __WEBPACK_IMPORTED_MODULE_12__Theme__["a" /* default */].Styles.flexShrink, {
          verticalAlign: "baseline"
        }),
        select: {
          width: "100%",
          fontSize: "0.8em",
          textTransform: "uppercase"
        },
        infoIconWrapper: {
          paddingLeft: "0.25em",
          display: "inline-flex"
        }
      });
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Tappable__["b" /* default */], {
        onTap: this.toggleOpen
      }, function (_ref) {
        var active = _ref.active,
            tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
          style: styles.outerWrapper
        }, __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__NoStyleButton__["a" /* default */], {
          style: _objectSpread({}, styles.wrapper, {
            backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_15__Tappable__["c" /* simpleActiveBackgroundColor */])(active)
          }),
          innerRef: tapTargetRefHandler
        }, __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
          style: styles.container
        }, !placeholder ? __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("span", {
          style: _objectSpread({}, styles.label, {
            flexBasis: _this2.props.isPivot ? "33%" : "66%"
          }),
          "aria-label": "".concat(label, ":")
        }, label) : null, __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
          style: styles.selectWrapper
        }, __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Select_SelectWithoutTappable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          placeholder: placeholder ? label : null,
          open: open,
          style: styles.select,
          onOptionTapped: _this2.handleOptionTapped,
          onBackgroundTapped: _this2.toggleOpen,
          onRequestClose: _this2.toggleOpen
        }, props))))), infoIcon ? __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", {
          style: styles.infoIconWrapper
        }, __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Form_fields_FormFieldIcons_InfoIcon__["a" /* default */], {
          dialogText: infoText
        })) : null);
      });
    }
  }]);

  return SelectItem;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(SelectItem, "propTypes", {
  onChange: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.func.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.string.isRequired,
  placeholder: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.bool,
  infoIcon: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.bool,
  infoText: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.string,
  options: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.arrayOf(function () {
    return (typeof __WEBPACK_IMPORTED_MODULE_17__Select_SelectDialog__["a" /* bpfrpt_proptype_Option */] === "function" ? __WEBPACK_IMPORTED_MODULE_17__Select_SelectDialog__["a" /* bpfrpt_proptype_Option */].isRequired ? __WEBPACK_IMPORTED_MODULE_17__Select_SelectDialog__["a" /* bpfrpt_proptype_Option */].isRequired : __WEBPACK_IMPORTED_MODULE_17__Select_SelectDialog__["a" /* bpfrpt_proptype_Option */] : __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_17__Select_SelectDialog__["a" /* bpfrpt_proptype_Option */]).isRequired).apply(this, arguments);
  }).isRequired,
  value: function value() {
    return (typeof __WEBPACK_IMPORTED_MODULE_17__Select_SelectDialog__["b" /* bpfrpt_proptype_valueType */] === "function" ? __WEBPACK_IMPORTED_MODULE_17__Select_SelectDialog__["b" /* bpfrpt_proptype_valueType */] : __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_17__Select_SelectDialog__["b" /* bpfrpt_proptype_valueType */])).apply(this, arguments);
  },
  onOptionTapped: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.func,
  onBackgroundTapped: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.func,
  onRequestClose: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.func,
  labelStyle: function labelStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  },
  isPivot: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.bool
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__ColorsProvider__["c" /* withColorsProvider */])(SelectItem));






/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var createResizeDetector = _interopDefault(__webpack_require__(460));
var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(__webpack_require__(7));
var ReactDOM = _interopDefault(__webpack_require__(53));
var invariant = _interopDefault(__webpack_require__(463));
var throttleDebounce = __webpack_require__(464);
var isShallowEqual = _interopDefault(__webpack_require__(465));

var instances = {};

// Lazily require to not cause bug
// https://github.com/ctrlplusb/react-sizeme/issues/6
function resizeDetector() {
  var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'scroll';

  if (!instances[strategy]) {
    instances[strategy] = createResizeDetector({
      strategy: strategy
    });
  }

  return instances[strategy];
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/* eslint-disable react/no-multi-comp */

var errMsg = 'react-sizeme: an error occurred whilst stopping to listen to node size changes';

var defaultConfig = {
  monitorWidth: true,
  monitorHeight: false,
  monitorPosition: false,
  refreshRate: 16,
  refreshMode: 'throttle',
  noPlaceholder: false,
  resizeDetectorStrategy: 'scroll'
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/**
 * This is a utility wrapper component that will allow our higher order
 * component to get a ref handle on our wrapped components html.
 * @see https://gist.github.com/jimfb/32b587ee6177665fb4cf
 */

var ReferenceWrapper = function (_Component) {
  inherits(ReferenceWrapper, _Component);

  function ReferenceWrapper() {
    classCallCheck(this, ReferenceWrapper);
    return possibleConstructorReturn(this, (ReferenceWrapper.__proto__ || Object.getPrototypeOf(ReferenceWrapper)).apply(this, arguments));
  }

  createClass(ReferenceWrapper, [{
    key: 'render',
    value: function render() {
      return React.Children.only(this.props.children);
    }
  }]);
  return ReferenceWrapper;
}(React.Component);

ReferenceWrapper.displayName = 'SizeMeReferenceWrapper';

ReferenceWrapper.propTypes = { children: PropTypes.element.isRequired };

function Placeholder(_ref) {
  var className = _ref.className,
      style = _ref.style;

  // Lets create the props for the temp element.
  var phProps = {};

  // We will use any provided className/style or else make the temp
  // container take the full available space.
  if (!className && !style) {
    phProps.style = { width: '100%', height: '100%' };
  } else {
    if (className) {
      phProps.className = className;
    }
    if (style) {
      phProps.style = style;
    }
  }

  return React__default.createElement('div', phProps);
}
Placeholder.displayName = 'SizeMePlaceholder';
Placeholder.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object

  /**
   * As we need to maintain a ref on the root node that is rendered within our
   * SizeMe component we need to wrap our entire render in a sub component.
   * Without this, we lose the DOM ref after the placeholder is removed from
   * the render and the actual component is rendered.
   * It took me forever to figure this out, so tread extra careful on this one!
   */
};var renderWrapper = function renderWrapper(WrappedComponent) {
  function SizeMeRenderer(props) {
    var explicitRef = props.explicitRef,
        className = props.className,
        style = props.style,
        size = props.size,
        disablePlaceholder = props.disablePlaceholder,
        onSize = props.onSize,
        restProps = objectWithoutProperties(props, ['explicitRef', 'className', 'style', 'size', 'disablePlaceholder', 'onSize']);


    var noSizeData = size == null || size.width == null && size.height == null && size.position == null;

    var renderPlaceholder = noSizeData && !disablePlaceholder;

    var renderProps = {
      className: className,
      style: style
    };

    if (size != null) {
      renderProps.size = size;
    }

    var toRender = renderPlaceholder ? React__default.createElement(Placeholder, { className: className, style: style }) : React__default.createElement(WrappedComponent, _extends({}, renderProps, restProps));

    return React__default.createElement(
      ReferenceWrapper,
      { ref: explicitRef },
      toRender
    );
  }

  SizeMeRenderer.displayName = 'SizeMeRenderer(' + getDisplayName(WrappedComponent) + ')';

  SizeMeRenderer.propTypes = {
    explicitRef: PropTypes.func.isRequired,
    className: PropTypes.string,
    style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    size: PropTypes.shape({
      width: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
      height: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
      position: PropTypes.object
    }),
    disablePlaceholder: PropTypes.bool,
    onSize: PropTypes.func
  };

  return SizeMeRenderer;
};

/**
 * :: config -> Component -> WrappedComponent
 *
 * Higher order component that allows the wrapped component to become aware
 * of it's size, by receiving it as an object within it's props.
 *
 * @param  monitorWidth
 *   Default true, whether changes in the element's width should be monitored,
 *   causing a size property to be broadcast.
 * @param  monitorHeight
 *   Default false, whether changes in the element's height should be monitored,
 *   causing a size property to be broadcast.
 *
 * @return The wrapped component.
 */
function withSize() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfig;
  var _config$monitorWidth = config.monitorWidth,
      monitorWidth = _config$monitorWidth === undefined ? defaultConfig.monitorWidth : _config$monitorWidth,
      _config$monitorHeight = config.monitorHeight,
      monitorHeight = _config$monitorHeight === undefined ? defaultConfig.monitorHeight : _config$monitorHeight,
      _config$monitorPositi = config.monitorPosition,
      monitorPosition = _config$monitorPositi === undefined ? defaultConfig.monitorPosition : _config$monitorPositi,
      _config$refreshRate = config.refreshRate,
      refreshRate = _config$refreshRate === undefined ? defaultConfig.refreshRate : _config$refreshRate,
      _config$refreshMode = config.refreshMode,
      refreshMode = _config$refreshMode === undefined ? defaultConfig.refreshMode : _config$refreshMode,
      _config$noPlaceholder = config.noPlaceholder,
      noPlaceholder = _config$noPlaceholder === undefined ? defaultConfig.noPlaceholder : _config$noPlaceholder,
      _config$resizeDetecto = config.resizeDetectorStrategy,
      resizeDetectorStrategy = _config$resizeDetecto === undefined ? defaultConfig.resizeDetectorStrategy : _config$resizeDetecto;


  invariant(monitorWidth || monitorHeight || monitorPosition, 'You have to monitor at least one of the width, height, or position when using "sizeMe"');

  invariant(refreshRate >= 16, "It is highly recommended that you don't put your refreshRate lower than " + '16 as this may cause layout thrashing.');

  invariant(refreshMode === 'throttle' || refreshMode === 'debounce', 'The refreshMode should have a value of "throttle" or "debounce"');

  var refreshDelayStrategy = refreshMode === 'throttle' ? throttleDebounce.throttle : throttleDebounce.debounce;

  return function WrapComponent(WrappedComponent) {
    var SizeMeRenderWrapper = renderWrapper(WrappedComponent);

    var SizeAwareComponent = function (_React$Component) {
      inherits(SizeAwareComponent, _React$Component);

      function SizeAwareComponent() {
        var _ref2;

        var _temp, _this2, _ret;

        classCallCheck(this, SizeAwareComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = possibleConstructorReturn(this, (_ref2 = SizeAwareComponent.__proto__ || Object.getPrototypeOf(SizeAwareComponent)).call.apply(_ref2, [this].concat(args))), _this2), _this2.domEl = null, _this2.state = {
          width: undefined,
          height: undefined,
          position: undefined
        }, _this2.uninstall = function () {
          if (_this2.domEl) {
            try {
              _this2.detector.uninstall(_this2.domEl);
            } catch (err) {
              // eslint-disable-next-line no-console
              console.warn(errMsg);
            }
            _this2.domEl = null;
          }
        }, _this2.determineStrategy = function (props) {
          if (props.onSize) {
            if (!_this2.callbackState) {
              _this2.callbackState = _extends({}, _this2.state);
            }
            _this2.strategy = 'callback';
          } else {
            _this2.strategy = 'render';
          }
        }, _this2.strategisedSetState = function (state) {
          if (_this2.strategy === 'callback') {
            _this2.callbackState = state;
            _this2.props.onSize(state);
          }
          _this2.setState(state);
        }, _this2.strategisedGetState = function () {
          return _this2.strategy === 'callback' ? _this2.callbackState : _this2.state;
        }, _this2.refCallback = function (element) {
          _this2.element = element;
        }, _this2.hasSizeChanged = function (current, next) {
          var c = current;
          var n = next;
          var cp = c.position || {};
          var np = n.position || {};

          return monitorWidth && c.width !== n.width || monitorHeight && c.height !== n.height || monitorPosition && (cp.top !== np.top || cp.left !== np.left || cp.bottom !== np.bottom || cp.right !== np.right);
        }, _this2.checkIfSizeChanged = refreshDelayStrategy(refreshRate, function (el) {
          var _el$getBoundingClient = el.getBoundingClientRect(),
              width = _el$getBoundingClient.width,
              height = _el$getBoundingClient.height,
              right = _el$getBoundingClient.right,
              left = _el$getBoundingClient.left,
              top = _el$getBoundingClient.top,
              bottom = _el$getBoundingClient.bottom;

          var next = {
            width: monitorWidth ? width : null,
            height: monitorHeight ? height : null,
            position: monitorPosition ? { right: right, left: left, top: top, bottom: bottom } : null
          };

          if (_this2.hasSizeChanged(_this2.strategisedGetState(), next)) {
            _this2.strategisedSetState(next);
          }
        }), _temp), possibleConstructorReturn(_this2, _ret);
      }

      createClass(SizeAwareComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.detector = resizeDetector(resizeDetectorStrategy);
          this.determineStrategy(this.props);
          this.handleDOMNode();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          this.determineStrategy(this.props);
          this.handleDOMNode();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          // Change our size checker to a noop just in case we have some
          // late running events.
          this.hasSizeChanged = function () {
            return undefined;
          };
          this.checkIfSizeChanged = function () {
            return undefined;
          };
          this.uninstall();
        }
      }, {
        key: 'handleDOMNode',
        value: function handleDOMNode() {
          var found = this.element && ReactDOM.findDOMNode(this.element);

          if (!found) {
            // If we previously had a dom node then we need to ensure that
            // we remove any existing listeners to avoid memory leaks.
            this.uninstall();
            return;
          }

          if (!this.domEl) {
            this.domEl = found;
            this.detector.listenTo(this.domEl, this.checkIfSizeChanged);
          } else if (this.domEl.isSameNode && !this.domEl.isSameNode(found) || this.domEl !== found) {
            this.uninstall();
            this.domEl = found;
            this.detector.listenTo(this.domEl, this.checkIfSizeChanged);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var disablePlaceholder = withSize.enableSSRBehaviour || withSize.noPlaceholders || noPlaceholder || this.strategy === 'callback';

          var size = _extends({}, this.state);

          return React__default.createElement(SizeMeRenderWrapper, _extends({
            explicitRef: this.refCallback,
            size: this.strategy === 'callback' ? null : size,
            disablePlaceholder: disablePlaceholder
          }, this.props));
        }
      }]);
      return SizeAwareComponent;
    }(React__default.Component);

    SizeAwareComponent.displayName = 'SizeMe(' + getDisplayName(WrappedComponent) + ')';
    SizeAwareComponent.propTypes = {
      onSize: PropTypes.func
    };


    SizeAwareComponent.WrappedComponent = WrappedComponent;

    return SizeAwareComponent;
  };
}

/**
 * Allow SizeMe to run within SSR environments.  This is a "global" behaviour
 * flag that should be set within the initialisation phase of your application.
 *
 * Warning: don't set this flag unless you need to as using it may cause
 * extra render cycles to happen within your components depending on the logic
 * contained within them around the usage of the `size` data.
 *
 * DEPRECATED: Please use the global noPlaceholders
 */
withSize.enableSSRBehaviour = false;

/**
 * Global configuration allowing to disable placeholder rendering for all
 * sizeMe components.
 */
withSize.noPlaceholders = false;

var SizeMe = function (_Component) {
  inherits(SizeMe, _Component);

  function SizeMe(props) {
    classCallCheck(this, SizeMe);

    var _this = possibleConstructorReturn(this, (SizeMe.__proto__ || Object.getPrototypeOf(SizeMe)).call(this, props));

    _initialiseProps.call(_this);

    var children = props.children,
        render = props.render,
        sizeMeConfig = objectWithoutProperties(props, ['children', 'render']);

    _this.createComponent(sizeMeConfig);
    _this.state = {
      size: {
        width: undefined,
        height: undefined
      }
    };
    return _this;
  }

  createClass(SizeMe, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          prevChildren = _props.children,
          prevRender = _props.render,
          currentSizeMeConfig = objectWithoutProperties(_props, ['children', 'render']);
      var nextChildren = prevProps.children,
          nextRender = prevProps.render,
          prevSizeMeConfig = objectWithoutProperties(prevProps, ['children', 'render']);

      if (!isShallowEqual(currentSizeMeConfig, prevSizeMeConfig)) {
        this.createComponent(currentSizeMeConfig);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var SizeAware = this.SizeAware;

      var render = this.props.children || this.props.render;
      return React__default.createElement(
        SizeAware,
        { onSize: this.onSize },
        render({ size: this.state.size })
      );
    }
  }]);
  return SizeMe;
}(React.Component);

SizeMe.propTypes = {
  children: PropTypes.func,
  render: PropTypes.func
};
SizeMe.defaultProps = {
  children: undefined,
  render: undefined
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.createComponent = function (config) {
    _this2.SizeAware = withSize(config)(function (_ref) {
      var children = _ref.children;
      return children;
    });
  };

  this.onSize = function (size) {
    return _this2.setState({ size: size });
  };
};

withSize.SizeMe = SizeMe;
withSize.withSize = withSize;

module.exports = withSize;
//# sourceMappingURL=react-sizeme.js.map


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_UserAgent__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_PullToRefresh__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Scrollable_ScrollableArea__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Scrollable_TrackedScrollableArea__ = __webpack_require__(224);














var isIOS = __WEBPACK_IMPORTED_MODULE_10_nx_components_UserAgent__["a" /* default */].isIOS();
var styles = Object(__WEBPACK_IMPORTED_MODULE_9_nx_components_utils_prefixStyles__["b" /* default */])({
  scrollableArea: {
    position: "relative"
  },
  wrapperDiv: {
    position: "absolute",
    // 101% Ensures that overflow scrolling is always available on iOS
    minHeight: "101%",
    width: "100%",
    // Force iOS to use the GPU to draw all children of this
    // div. Without this, it would occasionally incorrectly
    // render a white screen instead of the div contents.
    transform: "translateZ(0)"
  }
});

var ScrollableAreaWithPullToRefresh =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ScrollableAreaWithPullToRefresh, _React$Component);

  function ScrollableAreaWithPullToRefresh() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ScrollableAreaWithPullToRefresh);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ScrollableAreaWithPullToRefresh)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_targetFound", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_scrollableAreaRefCallback", function (el) {
      _this._target = el;

      if (_this._target && !_this._targetFound) {
        // force update so that the PullToRefresh can get the
        // target (it gets undefined on first render).
        _this._targetFound = true;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ScrollableAreaWithPullToRefresh, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._targetFound = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onPullToRefresh = _this$props.onPullToRefresh,
          pullToRefreshDisabled = _this$props.pullToRefreshDisabled,
          childrenAbove = _this$props.childrenAbove,
          trackingKey = _this$props.trackingKey;
      var innerContent = __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "ScrollableAreaWithPullToRefresh",
        style: styles.wrapperDiv
      }, childrenAbove, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_PullToRefresh__["a" /* default */], {
        target: this._target,
        offstage: isIOS,
        disabled: pullToRefreshDisabled,
        onActivate: onPullToRefresh
      }), children);

      if (trackingKey != null) {
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Scrollable_TrackedScrollableArea__["a" /* default */], {
          captureRef: this._scrollableAreaRefCallback,
          style: styles.scrollableArea,
          trackingKey: trackingKey
        }, innerContent);
      } else {
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Scrollable_ScrollableArea__["a" /* default */], {
          captureRef: this._scrollableAreaRefCallback,
          style: styles.scrollableArea
        }, innerContent);
      }
    }
  }]);

  return ScrollableAreaWithPullToRefresh;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ScrollableAreaWithPullToRefresh, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  childrenAbove: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  onPullToRefresh: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  pullToRefreshDisabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  trackingKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
});

/* harmony default export */ __webpack_exports__["a"] = (ScrollableAreaWithPullToRefresh);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var FetchManager =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(FetchManager, _React$Component);

  function FetchManager() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, FetchManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(FetchManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      spinnerShown: false,
      spinnerMessage: null,
      progressShown: false,
      isFetchingDetails: false,
      isFetchingModelAndMaybeDetails: false
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_pollingDisabledStack", 0);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_runningPromises", {});

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_disablePolling", function () {
      if (_this._pollingDisabledStack === 0) {
        Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__["a" /* default */])("DISABLE_LOCATION_POLLING");
      }

      _this._pollingDisabledStack++;
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_enablePolling", _this._ifMounted(function () {
      _this._pollingDisabledStack--;

      if (_this._pollingDisabledStack <= 0) {
        _this._pollingDisabledStack = 0;
        Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
      }
    }));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_setStateIfMounted", _this._ifMounted(_this.setState.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this))));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_showSpinner", _this._ifMounted(function (spinnerMessage) {
      _this.setState({
        spinnerShown: true,
        spinnerMessage: spinnerMessage
      });
    }));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_hideSpinner", _this._ifMounted(function () {
      _this.setState({
        spinnerShown: false,
        spinnerMessage: null
      });
    }));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_runPromiseWithSpinner", function (callback, message) {
      _this._showSpinner(message);

      callback().then(_this._hideSpinner, _this._hideSpinner);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_showProgress", _this._ifMounted(function () {
      _this.setState({
        progressShown: true
      });
    }));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_hideProgress", _this._ifMounted(function () {
      _this.setState({
        progressShown: false
      });
    }));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_runPromiseWithProgress", function (callback) {
      _this._showProgress();

      callback().then(_this._hideProgress, _this._hideProgress);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_fetchModelAndMaybeDetails", function () {
      var fetchOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this._disablePolling();

      return _this._runPromiseWithAbortAndSaveToPropertyWithStateKey(function () {
        var model = _this.props.model;
        return model.fetchWithDetails(fetchOptions).then(function () {
          model.populatePendingRequestsRecursively();
        });
      }, "_modelAndDetailsPromise", "isFetchingModelAndMaybeDetails").then(_this._enablePolling)["catch"](function (reason) {
        _this._enablePolling();

        throw reason;
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_fetchModelAndMaybeDetailsIfMounted", _this._ifMounted(_this._fetchModelAndMaybeDetails, function () {
      return Promise.resolve();
    }));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_fetchDetails", function () {
      var fetchOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this._disablePolling();

      return _this._runPromiseWithAbortAndSaveToPropertyWithStateKey(function () {
        return _this.props.model.fetchDetails(fetchOptions);
      }, "_detailsPromise", "isFetchingDetails").then(_this._enablePolling)["catch"](function (reason) {
        _this._enablePolling();

        throw reason;
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_fetchDetailsIfMounted", _this._ifMounted(_this._fetchDetails, function () {
      return Promise.resolve();
    }));

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(FetchManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var model = this.props.model;
      this._isMounted = true;

      if (typeof model.hasDetailsLink === "function" && model.hasDetailsLink()) {
        this._runPromiseWithProgress(this._fetchDetails); // HACK: Don't poll the location while showing this device, because
        // polling the location would get the details-less attributes for this
        // device, and setting those onto this model would override the attributes
        // we got from the details fetch (because the server provides null values
        // for those attributes when we aren't fetching details). So the UI would
        // switch back and forth between having details and not having it, which
        // looks broken.


        this._disablePolling(); // That said, we still want to update this device's status every 20
        // seconds, so fetch this device (and its details) when the location poll
        // timer hits.


        __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__["a" /* default */].on("LOCATION_POLL_TIMER", this._fetchModelAndMaybeDetailsIfMounted, this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      Object.values(this._runningPromises).forEach(function (promiseWithAbort) {
        if (promiseWithAbort != null && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(promiseWithAbort) === "object" && typeof promiseWithAbort.abort === "function") {
          promiseWithAbort.abort();
        }
      });

      if (this._pollingDisabledStack !== 0) {
        Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
      }

      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__["a" /* default */].off(null, null, this);
    }
  }, {
    key: "_ifMounted",
    value: function _ifMounted(mountedCallback, unmountedCallback) {
      var _this2 = this;

      var callIfMounted = function callIfMounted() {
        if (_this2._isMounted) {
          return mountedCallback.apply(void 0, arguments);
        } else if (unmountedCallback != null) {
          return unmountedCallback.apply(void 0, arguments);
        } else {
          return undefined;
        }
      };

      return callIfMounted;
    }
  }, {
    key: "_runPromiseWithAbortAndSaveToPropertyWithStateKey",
    value: function _runPromiseWithAbortAndSaveToPropertyWithStateKey(callback, propertyName, stateKey) {
      var _this3 = this;

      if (this._runningPromises[propertyName] != null) {
        return this._runningPromises[propertyName];
      }

      var promiseWithAbort = callback();
      this._runningPromises[propertyName] = promiseWithAbort;

      this._setStateIfMounted(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({}, stateKey, true));

      var removeReference = function removeReference() {
        _this3._runningPromises[propertyName] = null;

        _this3._setStateIfMounted(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({}, stateKey, false));
      };

      return promiseWithAbort.then(removeReference)["catch"](removeReference); // Note: we don't setState on abort because we only abort in willUnmount,
      // and we don't want to schedule an unnecessary state update for a
      // component that is being unmounted.
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(_objectSpread({}, this.state, {
        showSpinner: this._showSpinner,
        hideSpinner: this._hideSpinner,
        showProgress: this._showProgress,
        hideProgress: this._hideProgress,
        runPromiseWithSpinner: this._runPromiseWithSpinner,
        runPromiseWithProgress: this._runPromiseWithProgress,
        fetchDetails: this._fetchDetailsIfMounted,
        fetchModelAndMaybeDetails: this._fetchModelAndMaybeDetailsIfMounted
      }));
    }
  }]);

  return FetchManager;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(FetchManager, "propTypes", {
  model: function model() {
    return (typeof __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_base_model__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_base_model__["a" /* default */]).isRequired : __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  children: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired
});




/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(150),
    isObject = __webpack_require__(169);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 504 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 505 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AndroidPlatform; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_platforms_base__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_utils_enqueueIn__ = __webpack_require__(59);










var AndroidPlatform =
/*#__PURE__*/
function (_Base) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(AndroidPlatform, _Base);

  function AndroidPlatform() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AndroidPlatform);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AndroidPlatform).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AndroidPlatform, [{
    key: "initScriptInterface",
    value: function initScriptInterface(callback) {
      Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_utils_enqueueIn__["c" /* setImplementation */])({
        enqueue: __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].enqueueIn,
        cancel: __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].cancelEnqueued
      });
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].notifyScriptInterfaceReady();
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].setPlatformAttributes();
      callback();
    }
  }, {
    key: "exitApp",
    value: function exitApp() {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].exitApp();
    }
  }, {
    key: "allowScreenDimming",
    value: function allowScreenDimming() {
      var yesno = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (yesno) {
        __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].allowScreenDimming();
      } else {
        __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].keepScreenOn();
      }
    }
  }, {
    key: "getStoredValue",
    value: function getStoredValue(key) {
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].getStoredValue(key);
    }
  }, {
    key: "setStoredValue",
    value: function setStoredValue(key, value) {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].setStoredValue(key, value);
    }
  }, {
    key: "clearStoredValue",
    value: function clearStoredValue(key) {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].clearStoredValue(key);
    }
  }, {
    key: "clearStoredValues",
    value: function clearStoredValues() {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].clearStoredValues();
    }
  }, {
    key: "canSendFeedback",
    value: function canSendFeedback() {
      return true;
    }
  }, {
    key: "obtainPushNotificationToken",
    value: function obtainPushNotificationToken() {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].obtainPushNotificationToken();
    }
  }, {
    key: "resetAppBadge",
    value: function resetAppBadge() {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].clearNotifications();
    }
  }, {
    key: "hideSoftKeyboard",
    value: function hideSoftKeyboard() {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].hideSoftKeyboard();
    }
  }, {
    key: "isImageSaveSupported",
    value: function isImageSaveSupported() {
      return true;
    }
  }, {
    key: "saveImage",
    value: function saveImage(base64Data) {
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].saveImage(base64Data);
    }
  }, {
    key: "isMobilePlatform",
    value: function isMobilePlatform() {
      return true;
    }
  }, {
    key: "hasAppInstalled",
    value: function hasAppInstalled(name) {
      return Promise.resolve(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].hasAppInstalled(name));
    }
  }, {
    key: "sendGoogleAnalyticsEvent",
    value: function sendGoogleAnalyticsEvent(category, action, label) {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].sendGoogleAnalyticsEvent(category, action, label);
    }
  }, {
    key: "sendGoogleAnalyticsDuration",
    value: function sendGoogleAnalyticsDuration(category, action, label, value) {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].sendGoogleAnalyticsTiming(category, action, label, value || 0);
    } // Geofencing methods

  }, {
    key: "isGeofencingSupported",
    value: function isGeofencingSupported() {
      return !__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_environment__["a" /* default */].isCommercial();
    }
  }, {
    key: "isNotificationSoundConfigurable",
    value: function isNotificationSoundConfigurable() {
      // keep this synchronous to improve the experience on the local settings page
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].isNotificationSoundConfigurable();
    }
  }, {
    key: "checkLocationPermissions",
    value: function checkLocationPermissions() {
      var _this = this;

      if (this._inflightPermissionPromise) {
        // We can only have a single permission request at once
        return this._inflightPermissionPromise;
      }

      return this._inflightPermissionPromise = __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].checkLocationPermissions().then(function (result) {
        _this._inflightPermissionPromise = null;
        return result;
      });
    }
  }, {
    key: "getLocationServicesWarningMessage",
    value: function getLocationServicesWarningMessage() {
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].getLocationServicesWarningMessage().then(function (response) {
        if (response.message) {
          return response.message;
        } else {
          throw new Error("Expected getLocationServicesWarningMessage to return a message");
        }
      });
    }
  }, {
    key: "areLocationServicesEnabled",
    value: function areLocationServicesEnabled() {
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].areLocationServicesEnabled();
    }
  }, {
    key: "openAppPermissionSettings",
    value: function openAppPermissionSettings() {
      // Android doesn't allow us to open the permission page, just app settings
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].openAppSettings();
    }
  }, {
    key: "openLocationServiceSettings",
    value: function openLocationServiceSettings() {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].openLocationServiceSettings();
    }
  }, {
    key: "openWifiSettings",
    value: function openWifiSettings() {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].openWifiSettings();
    }
  }, {
    key: "setGeofences",
    value: function setGeofences(geofences) {
      var filteredGeofences = geofences.map(function (_ref) {
        var id = _ref.id,
            name = _ref.name,
            latitude = _ref.latitude,
            longitude = _ref.longitude,
            radius = _ref.radius,
            hrefAcknowledge = _ref.hrefAcknowledge,
            hrefEnter = _ref.hrefEnter,
            hrefExit = _ref.hrefExit;
        return {
          id: id,
          name: name,
          latitude: latitude,
          longitude: longitude,
          radius: parseInt(radius),
          hrefAcknowledge: hrefAcknowledge,
          hrefEnter: hrefEnter,
          hrefExit: hrefExit
        };
      });
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].setGeofences(filteredGeofences);
      return Promise.resolve();
    }
  }, {
    key: "startGeofenceService",
    value: function startGeofenceService() {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].startGeofenceService();
      return Promise.resolve();
    }
  }, {
    key: "stopGeofenceService",
    value: function stopGeofenceService() {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].stopGeofenceService();
      return Promise.resolve();
    }
  }, {
    key: "getGeofenceCrossings",
    value: function getGeofenceCrossings() {
      return Promise.resolve(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].getGeofenceCrossings());
    } // end Geofencing methods

  }, {
    key: "isVoiceAssistantSupported",
    value: function isVoiceAssistantSupported() {
      return true;
    } // Wifi Methods
    // Does the platform allow programmatic access to Wifi networks?

  }, {
    key: "canGetWifiNetworks",
    value: function canGetWifiNetworks() {
      return true;
    } // Does the platform allow you to programmatically connect to a Wifi network?

  }, {
    key: "canConnectToWifiNetwork",
    value: function canConnectToWifiNetwork() {
      return true;
    } // Start a Wifi network scan. The SSID of each found network will be passed
    // to callback as an array of strings.

  }, {
    key: "wifiScan",
    value: function wifiScan(callback) {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].wifiScan().then(callback);
    } // Connect to a Wifi network.

  }, {
    key: "connectToWifiNetwork",
    value: function connectToWifiNetwork(ssid, password) {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].connectToWifiNetwork(ssid, password);
      return Promise.resolve();
    }
  }, {
    key: "isFingerprintAuthAvailable",
    value: function isFingerprintAuthAvailable() {
      return Promise.resolve(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].isFingerprintAuthAvailable());
    }
  }, {
    key: "authenticateWithFingerprint",
    value: function authenticateWithFingerprint() {
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].authenticateWithFingerprint();
    }
  }, {
    key: "cancelFingerprintAuthentication",
    value: function cancelFingerprintAuthentication() {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].cancelFingerprintAuthentication();
    }
  }, {
    key: "canEnableRemoteDebugging",
    value: function canEnableRemoteDebugging() {
      return true;
    }
  }, {
    key: "enableRemoteDebugging",
    value: function enableRemoteDebugging() {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].enableRemoteDebugging();
    }
  }, {
    key: "canUseNativeHTTP",
    value: function canUseNativeHTTP() {
      return true;
    }
  }, {
    key: "nativeHTTPRequest",
    value: function nativeHTTPRequest(options) {
      return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].nativeHTTPRequest(options).then(function (response) {
        if (response.error) {
          throw new Error(response.errorDescription);
        } else {
          var body = response.body,
              code = response.code;
          return {
            body: body,
            code: code
          };
        }
      });
    }
  }, {
    key: "canDo724OpenAuthEncryption",
    value: function canDo724OpenAuthEncryption() {
      return true;
    }
  }, {
    key: "encryptStringFor724OpenAuth",
    value: function encryptStringFor724OpenAuth(key, input) {
      return Promise.resolve(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].encryptStringFor724OpenAuth(key, input));
    }
  }, {
    key: "showWebView",
    value: function showWebView() {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].showWebView();
    }
  }, {
    key: "hideWebView",
    value: function hideWebView() {
      __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["a" /* default */].hideWebView();
    } // Used by the Java code

  }, {
    key: "_invokeCallback",
    value: function _invokeCallback(callbackName, value) {
      Object(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_platforms_android_bridge__["b" /* invokeCallback */])(callbackName, value);
    }
  }]);

  return AndroidPlatform;
}(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_platforms_base__["a" /* default */]);



/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IOSPlatform; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_platforms_base__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__ = __webpack_require__(805);












var ignoreNetworkError = function ignoreNetworkError() {// These promises will only reject for network errors (like CORS, not like 500)
  // Ignore such problems when the function is fire-and-forget.
  // When the promise is actually used, we usually also ignore the error because
  // the issue is usually the power button closing the app. The error should be
  // handled when possible, just in case.
};

var IOSPlatform =
/*#__PURE__*/
function (_Base) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(IOSPlatform, _Base);

  function IOSPlatform() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, IOSPlatform);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(IOSPlatform)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_storedValues", {});

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_biometricString", "fingerprint");

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(IOSPlatform, [{
    key: "initScriptInterface",
    value: function initScriptInterface(scriptInterfaceCallback) {
      var _this2 = this;

      Promise.all([__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].localStorage.getAllStoredValues(), __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].platformAttributes.getPlatformAttributes(), __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].misc.isVoiceOverEnabled()]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_ref, 3),
            storedValues = _ref2[0],
            platformAttributes = _ref2[1],
            isVoiceOverEnabled = _ref2[2];

        _this2._storedValues = storedValues;

        _this2.setBundleIdentifier(platformAttributes.bundleIdentifier);

        _this2.setAppVersion(platformAttributes.appVersion);

        _this2.setPlatformName(platformAttributes.platformName);

        _this2.setManufacturer(platformAttributes.manufacturer);

        _this2.setDeviceName(platformAttributes.deviceName);

        _this2.setModel(platformAttributes.model);

        _this2.setOsVersion(platformAttributes.osVersion);

        _this2.setDeviceUUID(platformAttributes.deviceUUID);

        _this2.setCurrentLocale(platformAttributes.currentLocale);

        _this2.setIsScreenReaderRunning(isVoiceOverEnabled.result);

        scriptInterfaceCallback();
      })["catch"](function (reason) {
        scriptInterfaceCallback();
        throw reason; // we want this to go to Sentry
      });
    }
  }, {
    key: "allowScreenDimming",
    value: function allowScreenDimming() {
      var yesno = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (yesno) {
        __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].misc.allowScreenDimming()["catch"](ignoreNetworkError);
      } else {
        __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].misc.keepScreenOn()["catch"](ignoreNetworkError);
      }
    }
  }, {
    key: "getStoredValue",
    value: function getStoredValue(key) {
      return this._storedValues[key];
    }
  }, {
    key: "setStoredValue",
    value: function setStoredValue(key, value) {
      this._storedValues[key] = value;
      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].localStorage.setStoredValue(key, value)["catch"](ignoreNetworkError);
    }
  }, {
    key: "clearStoredValue",
    value: function clearStoredValue(key) {
      delete this._storedValues[key];
      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].localStorage.clearStoredValue(key)["catch"](ignoreNetworkError);
    }
  }, {
    key: "clearStoredValues",
    value: function clearStoredValues() {
      this._storedValues = {};
      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].localStorage.clearStoredValues()["catch"](ignoreNetworkError);
    }
  }, {
    key: "canSendFeedback",
    value: function canSendFeedback() {
      return true;
    }
  }, {
    key: "obtainPushNotificationToken",
    value: function obtainPushNotificationToken() {
      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].misc.obtainPushNotificationToken()["catch"](ignoreNetworkError);
    }
  }, {
    key: "resetAppBadge",
    value: function resetAppBadge() {
      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].misc.resetAppBadge()["catch"](ignoreNetworkError);
    }
  }, {
    key: "hideSoftKeyboard",
    value: function hideSoftKeyboard() {
      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].misc.hideSoftKeyboard()["catch"](ignoreNetworkError);
    }
  }, {
    key: "isImageSaveSupported",
    value: function isImageSaveSupported() {
      return true;
    }
  }, {
    key: "saveImage",
    value: function saveImage(base64Data) {
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].misc.saveImage(base64Data);
    }
  }, {
    key: "isMobilePlatform",
    value: function isMobilePlatform() {
      return true;
    }
  }, {
    key: "hasAppInstalled",
    value: function hasAppInstalled(name) {
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].misc.hasAppInstalled(name).then(function (response) {
        return response.result;
      });
    }
  }, {
    key: "sendGoogleAnalyticsEvent",
    value: function sendGoogleAnalyticsEvent(category, action, label) {
      this.sendGoogleAnalyticsDuration(category, action, label);
    }
  }, {
    key: "sendGoogleAnalyticsDuration",
    value: function sendGoogleAnalyticsDuration(category, action, label, value) {
      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].misc.sendGoogleAnalyticsEvent(category, action, label, value || 0)["catch"](ignoreNetworkError);
    } // Geofencing methods

  }, {
    key: "isGeofencingSupported",
    value: function isGeofencingSupported() {
      return !__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_environment__["a" /* default */].isCommercial();
    }
  }, {
    key: "checkLocationPermissions",
    value: function checkLocationPermissions() {
      var _this3 = this;

      if (this._inflightPermissionPromise) {
        // We can only have a single permission request at once
        return this._inflightPermissionPromise;
      }

      return this._inflightPermissionPromise = __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].geofence.checkLocationPermissions().then(function (response) {
        _this3._inflightPermissionPromise = null;
        return response.result;
      });
    }
  }, {
    key: "getLocationServicesWarningMessage",
    value: function getLocationServicesWarningMessage() {
      return Promise.resolve("Location Services must be enabled for geofencing to function.\n\nPlease open your Settings app and go to Privacy ➔ Location Services to enable Location Services.");
    }
  }, {
    key: "areLocationServicesEnabled",
    value: function areLocationServicesEnabled() {
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].geofence.areLocationServicesEnabled().then(function (response) {
        return response.result;
      });
    }
  }, {
    key: "openAppPermissionSettings",
    value: function openAppPermissionSettings() {
      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].misc.openAppPermissionSettings()["catch"](ignoreNetworkError);
    }
  }, {
    key: "setGeofences",
    value: function setGeofences(geofences) {
      var filteredGeofences = geofences.map(function (_ref3) {
        var id = _ref3.id,
            name = _ref3.name,
            latitude = _ref3.latitude,
            longitude = _ref3.longitude,
            radius = _ref3.radius,
            hrefAcknowledge = _ref3.hrefAcknowledge,
            hrefEnter = _ref3.hrefEnter,
            hrefExit = _ref3.hrefExit;
        return {
          id: id,
          name: name,
          latitude: latitude,
          longitude: longitude,
          radius: radius,
          hrefAcknowledge: hrefAcknowledge,
          hrefEnter: hrefEnter,
          hrefExit: hrefExit
        };
      });
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].geofence.setGeofences(filteredGeofences).then(function () {
        /* discard response */
      });
    }
  }, {
    key: "startGeofenceService",
    value: function startGeofenceService() {
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].geofence.startGeofenceService().then(function () {
        /* discard response */
      });
    }
  }, {
    key: "stopGeofenceService",
    value: function stopGeofenceService() {
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].geofence.stopGeofenceService().then(function () {
        /* discard response */
      })["catch"](ignoreNetworkError);
    }
  }, {
    key: "getGeofenceCrossings",
    value: function getGeofenceCrossings() {
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].geofence.getGeofenceCrossings().then(function (response) {
        return response.crossings;
      });
    } // end Geofencing methods
    // Vognition methods

  }, {
    key: "checkMicrophonePermissions",
    value: function checkMicrophonePermissions() {
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].vognition.checkMicrophonePermissions().then(function (response) {
        return response.status;
      })["catch"](function () {
        return "undetermined";
      });
    }
  }, {
    key: "isVognitionSupported",
    value: function isVognitionSupported() {
      return true;
    }
  }, {
    key: "runVognitionListener",
    value: function runVognitionListener() {
      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].vognition.runVognitionListener()["catch"](ignoreNetworkError);
    }
  }, {
    key: "stopVognitionListener",
    value: function stopVognitionListener() {
      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].vognition.stopVognitionListener()["catch"](ignoreNetworkError);
    }
  }, {
    key: "speakString",
    value: function speakString(message) {
      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].vognition.speakString(message)["catch"](ignoreNetworkError);
    }
  }, {
    key: "setVognitionHomeProfile",
    value: function setVognitionHomeProfile(profile) {
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].vognition.setCurrentVognitionHomeWithProfile(profile.id, encodeURIComponent(JSON.stringify(profile))).then(function () {
        /* discard response */
      });
    } // end Vognition methods
    // Biometric methods. "Fingerprint" is the most common, but FaceID also exists

  }, {
    key: "getBiometricString",
    value: function getBiometricString() {
      return this._biometricString;
    }
  }, {
    key: "isFingerprintAuthAvailable",
    value: function isFingerprintAuthAvailable() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].touchID.isTouchIDAvailable().then(function (response) {
        _this4._biometricString = response.isActuallyFaceID ? "Face ID" : "fingerprint";
        return response.result;
      });
    }
  }, {
    key: "authenticateWithFingerprint",
    value: function authenticateWithFingerprint() {
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].touchID.authenticateWithTouchID();
    }
  }, {
    key: "cancelFingerprintAuthentication",
    value: function cancelFingerprintAuthentication() {
      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].touchID.cancelTouchIDAuthentication()["catch"](ignoreNetworkError);
    } // end Fingerprint methods
    // Native HTTP methods, to bypass CORS

  }, {
    key: "canUseNativeHTTP",
    value: function canUseNativeHTTP() {
      return true;
    }
  }, {
    key: "nativeHTTPRequest",
    value: function nativeHTTPRequest(options) {
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].http.nativeHTTPRequest(options);
    } // end native HTTP methods

  }, {
    key: "canDo724OpenAuthEncryption",
    value: function canDo724OpenAuthEncryption() {
      return true;
    }
  }, {
    key: "encryptStringFor724OpenAuth",
    value: function encryptStringFor724OpenAuth(key, input) {
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].misc.encryptStringFor724OpenAuth(key, input).then(function (response) {
        return response.result;
      });
    }
  }, {
    key: "canDetectIfScreenReaderIsRunning",
    value: function canDetectIfScreenReaderIsRunning() {
      return true;
    }
  }, {
    key: "createTemporaryFile",
    value: function createTemporaryFile(blob, extension) {
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].temp.createTemporaryFile(blob, extension).then(function (response) {
        return response.url;
      });
    }
  }, {
    key: "removeTemporaryFile",
    value: function removeTemporaryFile(url) {
      return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_platforms_ios_bridge__["a" /* default */].temp.removeTemporaryFile(url).then(function () {
        /* discard response */
      });
    }
  }]);

  return IOSPlatform;
}(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_platforms_base__["a" /* default */]);



/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Win10Platform; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_platforms_base__ = __webpack_require__(195);








var Win10Platform =
/*#__PURE__*/
function (_Base) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Win10Platform, _Base);

  function Win10Platform() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Win10Platform);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Win10Platform)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this._callbacks = {};
    _this._storedValues = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Win10Platform, [{
    key: "initScriptInterface",
    value: function initScriptInterface(callback) {
      var _this2 = this;

      this._callNative("GetAllStoredValues", function (values) {
        try {
          _this2._storedValues = JSON.parse(values);
        } catch (error) {
          __WEBPACK_IMPORTED_MODULE_5_raven_js___default.a.captureException(error, {
            extra: {
              values: values
            }
          });
        }

        _this2._callNative("SetPlatformAttributes", callback);
      });
    }
  }, {
    key: "exitApp",
    value: function exitApp() {
      return this._callNative("Exit");
    }
  }, {
    key: "getStoredValue",
    value: function getStoredValue(key) {
      return this._storedValues[key];
    }
  }, {
    key: "setStoredValue",
    value: function setStoredValue(key, value) {
      this._storedValues[key] = value;
      return this._callNative("SetStoredValue", null, key, value);
    }
  }, {
    key: "clearStoredValue",
    value: function clearStoredValue(key) {
      delete this._storedValues[key];
      return this._callNative("ClearStoredValue", null, key);
    }
  }, {
    key: "clearStoredValues",
    value: function clearStoredValues() {
      this._storedValues = {};
      return this._callNative("ClearStoredValues", null);
    }
  }, {
    key: "isMobilePlatform",
    value: function isMobilePlatform() {
      switch (this.deviceFamily) {
        case "Phone":
        case "Tablet":
          return true;

        default:
          return false;
      }
    }
  }, {
    key: "isImageSaveSupported",
    value: function isImageSaveSupported() {
      return true;
    }
  }, {
    key: "saveImage",
    value: function saveImage(base64Data) {
      return this._callBridge("SaveBase64Image", base64Data).then(function (message) {
        return {
          hasPermission: true,
          message: message
        };
      });
    }
  }, {
    key: "obtainPushNotificationToken",
    value: function obtainPushNotificationToken() {
      return this._callNative("ObtainPushNotificationToken", null);
    }
  }, {
    key: "isGeofencingSupported",
    value: function isGeofencingSupported() {
      return true;
    }
  }, {
    key: "checkLocationPermissions",
    value: function checkLocationPermissions() {
      return this._callBridge("CheckLocationPermissions").then(function (response) {
        return response.result;
      });
    }
  }, {
    key: "openAppPermissionSettings",
    value: function openAppPermissionSettings() {
      // Win10 doesn't have one page that shows permission settings for the whole app.
      // Assuming you want to change the location settings for the app.
      this._callBridge("OpenLocationServiceSettings");
    }
  }, {
    key: "areLocationServicesEnabled",
    value: function areLocationServicesEnabled() {
      // There's no way to tell if location services are disabled on windows 10,
      // but if they are, then checkLocationPermissions will return false. Since
      // we only use areLocationServicesEnabled in conjunction with checkLocationPermissions,
      // return true here and let checkLocationPermissions handle stuff.
      return Promise.resolve(true);
    }
  }, {
    key: "openLocationServiceSettings",
    value: function openLocationServiceSettings() {
      this._callBridge("OpenLocationServiceSettings");
    }
  }, {
    key: "setGeofences",
    value: function setGeofences(geofences) {
      var filteredGeofences = geofences.map(function (geofence) {
        return _.pick(geofence, "id", "name", "latitude", "longitude", "radius", "hrefAcknowledge", "hrefEnter", "hrefExit");
      });
      var geofencesJsonString;

      try {
        geofencesJsonString = JSON.stringify(filteredGeofences);
      } catch (error) {
        throw new Error("Failed to stringify geofences: ".concat(filteredGeofences));
      }

      return this._callBridge("SetGeofences", geofencesJsonString);
    }
  }, {
    key: "startGeofenceService",
    value: function startGeofenceService() {
      return this._callBridge("StartGeofenceService");
    }
  }, {
    key: "stopGeofenceService",
    value: function stopGeofenceService() {
      return this._callBridge("StopGeofenceService");
    }
  }, {
    key: "getGeofenceCrossings",
    value: function getGeofenceCrossings() {
      return this._callBridge("GetGeofenceCrossings");
    }
  }, {
    key: "sendGoogleAnalyticsEvent",
    value: function sendGoogleAnalyticsEvent(category, action, label) {
      return this._callBridge("SendGoogleAnalyticsEvent", category, action, label);
    }
  }, {
    key: "sendGoogleAnalyticsDuration",
    value: function sendGoogleAnalyticsDuration(category, action, label, duration) {
      return this._callBridge("SendGoogleAnalyticsDuration", category, action, label, duration);
    } // Wifi Methods
    // Does the platform allow programmatic access to Wifi networks?

  }, {
    key: "canGetWifiNetworks",
    value: function canGetWifiNetworks() {
      return true;
    } // Does the platform allow you to programmatically connect to a Wifi network?

  }, {
    key: "canConnectToWifiNetwork",
    value: function canConnectToWifiNetwork() {
      return true;
    } // Start a Wifi network scan. The SSID of each found network will be passed
    // to callback as an array of strings.

  }, {
    key: "wifiScan",
    value: function wifiScan(callback) {
      return this._callNative("WifiScan", callback);
    } // Connect to a Wifi network.

  }, {
    key: "connectToWifiNetwork",
    value: function connectToWifiNetwork(ssid, password) {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3._callNative("ConnectToWifiNetwork", null, ssid, password);

        resolve();
      });
    }
  }, {
    key: "_callBridge",
    value: function _callBridge(command) {
      var _this4 = this;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return new Promise(function (resolve, reject) {
        var parseResult = function parseResult(result) {
          if (result == null) {
            resolve();
            return;
          }

          var value;

          try {
            value = JSON.parse(result || "");
          } catch (error) {
            __WEBPACK_IMPORTED_MODULE_5_raven_js___default.a.captureException(error, {
              extra: {
                command: command,
                arguments: args,
                result: result
              }
            });
            reject(error);
            return;
          }

          resolve(value);
        };

        _this4._callNative.apply(_this4, [command, parseResult].concat(args));
      });
    }
  }, {
    key: "_callNative",
    value: function _callNative(command, callback) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      var params = {
        name: command,
        args: _.map(args, function (arg) {
          if (arg === null) {
            return "";
          } else {
            return arg;
          }
        })
      }; // store the callback so the native code can invoke it later

      if (_.isFunction(callback)) {
        var id = _.uniqueId();

        params.callback = "callback_".concat(id);
        this._callbacks[params.callback] = callback;
      }

      var argsString = JSON.stringify(params);
      __WEBPACK_IMPORTED_MODULE_5_raven_js___default.a.captureBreadcrumb({
        category: "Win10 Native",
        level: "info",
        message: command,
        data: {
          args: argsString.length > 1024 ? "[args hidden because size exceeded 1024 bytes]" : argsString
        }
      }); // pass the command up to the native host
      // when finished, it will invoke our callback by its id

      return window.external.notify(argsString);
    }
  }, {
    key: "_invokeCallback",
    value: function _invokeCallback(id, value) {
      if (!this._callbacks[id]) {
        return;
      }

      if (value) {
        var decodedValue = decodeURIComponent(value);

        this._callbacks[id](decodedValue);
      } else {
        this._callbacks[id]();
      }

      delete this._callbacks[id];
    }
  }]);

  return Win10Platform;
}(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_platforms_base__["a" /* default */]);



/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_LinearProgress__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_LinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_LinearProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);









var style = {
  borderRadius: 0
};

var LinearProgress =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(LinearProgress, _React$Component);

  function LinearProgress() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, LinearProgress);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(LinearProgress).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(LinearProgress, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          indeterminate = _this$props.indeterminate,
          min = _this$props.min,
          max = _this$props.max,
          value = _this$props.value,
          colors = _this$props.colors;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "LinearProgress"
      }, indeterminate ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__material_ui_core_LinearProgress___default.a, {
        primary: colors.SECONDARY,
        mode: "indeterminate",
        style: style
      }) : __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__material_ui_core_LinearProgress___default.a, {
        primary: colors.SECONDARY,
        min: min,
        max: max,
        value: value,
        mode: "determinate",
        style: style
      }));
    }
  }]);

  return LinearProgress;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(LinearProgress, "defaultProps", {
  indeterminate: false,
  min: 0,
  max: 100,
  value: 0
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(LinearProgress, "propTypes", {
  indeterminate: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  min: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["c" /* withColorsProvider */])(LinearProgress));



/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(533),
    baseKeys = __webpack_require__(1175),
    isArrayLike = __webpack_require__(326);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(1182);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Details_DetailsHeaders_DefaultDeviceHeader__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Details_DetailsHeaders_ThermostatHeader__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_Details_DetailsHeaders_PivotThermostatHeader__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Details_DetailsHeaders_AutomationHeader__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Details_DetailsHeaders_PhoneHeader__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_phone__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Details_DetailsHeaders_BuildingHeader__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_location__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_automation__ = __webpack_require__(149);














var isCommercial = __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_environment__["a" /* default */].isCommercial();

var DetailsHeaderContainer = function DetailsHeaderContainer(_ref) {
  var model = _ref.model;

  if (model instanceof __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_automation__["a" /* default */]) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Details_DetailsHeaders_AutomationHeader__["a" /* default */], {
      model: model
    });
  }

  if (model instanceof __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_phone__["a" /* default */]) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Details_DetailsHeaders_PhoneHeader__["a" /* default */], {
      model: model
    });
  }

  if (model instanceof __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_location__["a" /* default */]) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Details_DetailsHeaders_BuildingHeader__["a" /* default */], {
      model: model
    });
  }

  if (model.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features__["Thermostat"])) {
    if (isCommercial) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_Details_DetailsHeaders_PivotThermostatHeader__["a" /* default */], {
        model: model
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Details_DetailsHeaders_ThermostatHeader__["a" /* default */], {
        model: model
      });
    }
  }

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Details_DetailsHeaders_DefaultDeviceHeader__["a" /* default */], {
    model: model
  });
};

DetailsHeaderContainer.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_backbone___default.a.Model).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (DetailsHeaderContainer);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = touchHandlersFromClickHandlers;
/*
 * Sometimes, we want to use touchstart, touchmove, and touchend to try to
 * detect something like a click without relying on an actual click event.
 * Most notably, on older iOS devices we use a UIWebView in order to make video
 * streaming work without some of the nice properties that WKWebView didn't add
 * until iOS 10. This requires us to use FastClick to avoid the 300ms delay.
 * This prevents the delay, but also adds some new edge cases to work around. In
 * particular, tapping rapidly will ignore roughly every other tap.
 *
 * This helper is intended to be used when click handlers needs to be processed
 * rapidly based on touch events instead of click events.
 *
 * This function takes a click handler and expands it into touchstart and
 * touchend events instead, which can be spread onto the component props.
 *
 * Usage:
 *   class SomeComponent extends React.Component {
 *     render() {
 *       const handleClick = () => {
 *         // some logic
 *       };
 *       return <SomeChild {...touchHandlersFromClickHandlers(handleClick)} />
 *     }
 *   }
 *
 * NOTE: Be careful not to add onTouchStart, etc handlers as props without
 * carefully combining them with the responses from this helper.
 */
var DRAG_CUTOFF = 20;
var isTouchDevice = "ontouchstart" in window;
function touchHandlersFromClickHandlers(handler, downHandler, upHandler) {
  if (!isTouchDevice) {
    // We won't get any touch events, so rely on normal clicks.
    return {
      onClick: handler,
      onMouseDown: downHandler,
      onMouseUp: upHandler
    };
  } // fire the click handler if
  //   1) the touchstart and touchend are around the same place (no dragging)
  //   2) less than 500ms has passed (otherwise it's a "long press". Probably. Couldn't find standards)


  var time;
  var xcoord;
  var ycoord;
  return {
    onTouchStart: function onTouchStart(event) {
      time = Date.now();
      xcoord = event.changedTouches[0].screenX;
      ycoord = event.changedTouches[0].screenY;

      if (downHandler != null) {
        downHandler.call(this, event);
      }
    },
    onTouchMove: function onTouchMove(event) {
      var newX = event.changedTouches[0].screenX;
      var newY = event.changedTouches[0].screenY;

      if (xcoord < newX - DRAG_CUTOFF || xcoord > newX + DRAG_CUTOFF || ycoord < newY - DRAG_CUTOFF || ycoord > newY + DRAG_CUTOFF) {
        // stop listening if the user moves too much
        time = null;
      }
    },
    onTouchEnd: function onTouchEnd() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (upHandler != null) {
        upHandler.call.apply(upHandler, [this].concat(args));
      }

      if (!time || time + 500 < Date.now()) {
        // touchend was called after too much time or a move
        return;
      }

      time = null;
      handler.call.apply(handler, [this].concat(args));
    }
  };
}

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Digits; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_BrandLogo_LockScreenBrandLogo__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_BrandLogo_PivotLockScreenBrandLogo__ = __webpack_require__(1251);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var styles = Object(__WEBPACK_IMPORTED_MODULE_4_nx_components_utils_prefixStyles__["b" /* default */])({
  digit: {
    flex: "100%",
    textAlign: "center",
    verticalAlign: "middle",
    minHeight: "1em",
    display: "inline-block"
  },
  iconDigit: {
    flexShrink: "0"
  },
  aForgotPin: {
    fontSize: "0.6em",
    margin: "0.75em",
    textTransform: "uppercase"
  },
  digitContainer: {
    display: "flex",
    fontSize: "1.3em",
    marginTop: "0.5em"
  }
});

var ForgotPin = function ForgotPin(props) {
  var onForgotPin = props.onForgotPin;
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nx_components_Button__["a" /* default */], {
    theme: "link",
    style: styles.aForgotPin,
    onTap: onForgotPin
  }, "Forgot pin?");
};

ForgotPin.propTypes = {
  onForgotPin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var Digit = function Digit(props) {
  var entryValue = props.entryValue,
      password = props.password,
      digitValue = props.digitValue,
      small = props.small;
  var width = small ? "0.6em" : "0.7em";

  if (entryValue[digitValue]) {
    if (password) {
      return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nx_components_Icons__["G" /* IconDigit */], {
        style: _objectSpread({}, styles.iconDigit, {
          width: width
        })
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
        style: _objectSpread({}, styles.digit, {
          width: width
        })
      }, entryValue[digitValue]);
    }
  } else {
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nx_components_Icons__["K" /* IconEmptyDigit */], {
      style: _objectSpread({}, styles.iconDigit, {
        width: width
      })
    });
  }
};

Digit.propTypes = {
  entryValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  password: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  digitValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  small: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};
var Digits = function Digits(_ref) {
  var length = _ref.length,
      value = _ref.value,
      password = _ref.password;
  var numbers = [];

  for (var i = 0; i < length; i++) {
    numbers.push(i);
  }

  var digits = numbers.map(function (number) {
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Digit, {
      key: number.toString(),
      digitValue: number,
      entryValue: value,
      password: password,
      small: length > 8
    });
  });
  return digits;
};
Digits.propTypes = {
  length: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  password: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var Prompt = function Prompt(_ref2) {
  var isPortrait = _ref2.isPortrait,
      prompt = _ref2.prompt,
      length = _ref2.length,
      password = _ref2.password,
      disabled = _ref2.disabled,
      value = _ref2.value,
      onForgotPin = _ref2.onForgotPin,
      showForgotPin = _ref2.showForgotPin,
      isTablet = _ref2.isTablet,
      children = _ref2.children;
  var isCommercial = __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_environment__["a" /* default */].isCommercial();
  var promptStyles = Object(__WEBPACK_IMPORTED_MODULE_4_nx_components_utils_prefixStyles__["b" /* default */])({
    promptMessage: {
      color: disabled ? "#f75034" : null,
      textAlign: "center",
      marginTop: isCommercial ? "0.5em" : null
    },
    prompt: {
      flexGrow: "0",
      flexShrink: "1",
      flexBasis: "auto",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      marginBottom: "1em",
      fontSize: isTablet ? "1.5em" : "",
      maxWidth: isPortrait ? null : "50%",
      minWidth: isPortrait ? null : "33%",
      marginTop: isPortrait ? null : "0.5em",
      marginRight: isPortrait ? null : "0.5em",
      marginLeft: isPortrait ? null : "0.5em"
    }
  });
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    style: promptStyles.prompt
  }, isCommercial ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_BrandLogo_PivotLockScreenBrandLogo__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_BrandLogo_LockScreenBrandLogo__["a" /* default */], {
    width: isTablet ? "12em" : undefined,
    height: isTablet ? "6em" : undefined
  }), __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
    id: "prompt-message",
    style: promptStyles.promptMessage
  }, prompt), __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    id: "digits",
    style: styles.digitContainer
  }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Digits, {
    value: value,
    length: length,
    password: password
  })), children, showForgotPin ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ForgotPin, {
    onForgotPin: onForgotPin
  }) : null);
};

Prompt.propTypes = {
  prompt: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  length: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  showForgotPin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  password: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  onForgotPin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  isPortrait: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  isTablet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["b"] = (Prompt);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NumericUpDownPicker__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var DumbPivotNumericUpDownPicker =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DumbPivotNumericUpDownPicker, _React$Component);

  function DumbPivotNumericUpDownPicker() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DumbPivotNumericUpDownPicker);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DumbPivotNumericUpDownPicker).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DumbPivotNumericUpDownPicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step,
          label = _this$props.label,
          onDown = _this$props.onDown,
          onUp = _this$props.onUp,
          style = _this$props.style,
          unit = _this$props.unit,
          valueStyle = _this$props.valueStyle,
          upButtonStyle = _this$props.upButtonStyle,
          downButtonStyle = _this$props.downButtonStyle,
          isHeat = _this$props.isHeat,
          isCool = _this$props.isCool,
          ariaControls = _this$props["aria-controls"],
          colors = _this$props.colors,
          isSidePicker = _this$props.isSidePicker;
      var styles = {
        wrapper: _objectSpread({
          outline: "none",
          margin: "0.3em 0.3em 0.3em 0.3em"
        }, style),
        label: Object(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["b" /* default */])({
          color: colors.LABEL,
          fontSize: 16,
          userSelect: "none"
        }),
        controlsWrapper: Object(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["b" /* default */])({
          display: "flex"
        }),
        value: Object(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["b" /* default */])(_objectSpread({
          fontSize: 35,
          userSelect: "none"
        }, valueStyle))
      };

      var valueDisplay = function valueDisplay() {
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
          style: styles.value
        }, value, unit || null);
      };

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "PivotNumericUpDownPicker",
        tabIndex: "0",
        style: styles.wrapper
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.controlsWrapper
      }, isSidePicker ? valueDisplay() : null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__NumericUpDownPicker__["a" /* default */], {
        onUp: onUp,
        onDown: onDown,
        upDisabled: value + step > max,
        downDisabled: value - step < min,
        upButtonStyle: upButtonStyle,
        downButtonStyle: downButtonStyle,
        label: label,
        isHeat: isHeat,
        isCool: isCool,
        "aria-controls": ariaControls,
        style: style
      }, isSidePicker ? null : valueDisplay())));
    }
  }]);

  return DumbPivotNumericUpDownPicker;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DumbPivotNumericUpDownPicker, "defaultProps", {
  step: 1,
  isSidePicker: false,
  min: 55,
  max: 99,
  value: 70
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DumbPivotNumericUpDownPicker, "propTypes", {
  value: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number,
  step: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number,
  label: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.node,
  onDown: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  onUp: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  unit: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,
  valueStyle: function valueStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  upButtonStyle: function upButtonStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  downButtonStyle: function downButtonStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  isHeat: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,
  isCool: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,
  "\"aria-controls\"": __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  },
  isSidePicker: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["c" /* withColorsProvider */])(DumbPivotNumericUpDownPicker));




/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorPicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Slider__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ItemList__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(1179);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var PREVIEW_SIZE = 7.5;
var SLIDER_MARGIN = 12;
var styles = {
  label: {
    width: "4em"
  },
  slider: {
    margin: "".concat(SLIDER_MARGIN, "px 0")
  }
};

var ColorPicker =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ColorPicker, _React$Component);

  function ColorPicker(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ColorPicker);

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ColorPicker).call(this, props));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_calcPreviewColor", function (colors) {
      if (_this.props.bulb) {
        return Object(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* calcPreviewColorBulb */])(colors);
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* calcPreviewColor */])(colors);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDragEnd", function (color, value, aborted) {
      var newState;

      if (aborted) {
        newState = _this.state;
      } else {
        var newColors;

        switch (color) {
          case "warm":
            {
              newColors = {
                warm: value,
                cool: 0,
                red: 0,
                green: 0,
                blue: 0
              };
              break;
            }

          case "cool":
            {
              newColors = {
                warm: 0,
                cool: value,
                red: 0,
                green: 0,
                blue: 0
              };
              break;
            }

          case "red":
          case "green":
          case "blue":
            {
              newColors = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({
                warm: 0,
                cool: 0
              }, color, value);
              break;
            }

          default:
            {
              throw new Error("Can't handle unknown color: ".concat(color));
            }
        }

        newState = _objectSpread({}, _this.state, {}, newColors);

        _this.setState(_objectSpread({}, newState, {
          previewColor: _this._calcPreviewColor(newState)
        }));
      }

      if (_this.props.onDragEnd) {
        _this.props.onDragEnd(newState);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_getSlidersForColors", function (colors) {
      return colors.map(function (color) {
        var capitalizedColor = color[0].toUpperCase() + color.slice(1);
        var label = __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
          style: styles.label
        }, capitalizedColor);
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ItemList__["b" /* Item */], {
          key: color,
          id: color,
          label: label,
          childWrapperStyle: {
            flex: "1 1 100%"
          }
        }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Slider__["a" /* default */], {
          min: 0,
          max: 255,
          value: _this.state[color],
          sliderStyle: styles.slider,
          onDragStart: _this.props.onDragStart,
          onDragEnd: function onDragEnd(value, aborted) {
            _this._handleDragEnd(color, value, aborted);
          }
        }));
      });
    });

    var _this$props = _this.props,
        warm = _this$props.warm,
        cool = _this$props.cool,
        red = _this$props.red,
        green = _this$props.green,
        blue = _this$props.blue;

    var previewColor = _this._calcPreviewColor({
      warm: warm,
      cool: cool,
      red: red,
      green: green,
      blue: blue
    });

    _this.state = {
      warm: warm,
      cool: cool,
      red: red,
      green: green,
      blue: blue,
      previewColor: previewColor
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ColorPicker, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var warm = nextProps.warm,
          cool = nextProps.cool,
          red = nextProps.red,
          green = nextProps.green,
          blue = nextProps.blue;

      var _map = [warm, cool, red, green, blue].map(Math.round);

      var _map2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_map, 5);

      warm = _map2[0];
      cool = _map2[1];
      red = _map2[2];
      green = _map2[3];
      blue = _map2[4];

      var previewColor = this._calcPreviewColor({
        warm: warm,
        cool: cool,
        red: red,
        green: green,
        blue: blue
      });

      this.setState({
        warm: warm,
        cool: cool,
        red: red,
        green: green,
        blue: blue,
        previewColor: previewColor
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          bulb = _this$props2.bulb,
          isHorizontal = _this$props2.isHorizontal,
          showRGB = _this$props2.showRGB,
          showWarmCool = _this$props2.showWarmCool;
      var previewColor = this.state.previewColor;
      var dynamicStyles = {
        preview: {
          boxSizing: "border-box",
          height: "".concat(PREVIEW_SIZE, "em"),
          width: "".concat(PREVIEW_SIZE, "em"),
          margin: "auto",
          borderRadius: "50%",
          backgroundColor: previewColor,
          boxShadow: bulb ? "inset 0 0 2em #FFE" : "",
          border: "solid lightgray 1px"
        },
        previewDiv: _objectSpread({
          width: "".concat(PREVIEW_SIZE + 1, "em"),
          margin: "0 auto"
        }, isHorizontal && {
          "float": "left",
          position: "absolute",
          top: "50%",
          marginTop: "-".concat(PREVIEW_SIZE / 2, "em")
        }),
        sliderDiv: isHorizontal ? {
          marginLeft: "".concat(PREVIEW_SIZE + 1, "em")
        } : {}
      };
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        "data-component-name": "ColorPicker",
        style: {
          position: "relative"
        }
      }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: dynamicStyles.previewDiv,
        "data-component-section": "Preview"
      }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: dynamicStyles.preview
      })), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: dynamicStyles.sliderDiv,
        "data-component-section": "Sliders"
      }, showWarmCool ? this._getSlidersForColors(["warm", "cool"]) : null, showRGB && showWarmCool ? __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ItemList__["a" /* Divider */], null) : null, showRGB ? this._getSlidersForColors(["red", "green", "blue"]) : null));
    }
  }]);

  return ColorPicker;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ColorPicker, "propTypes", {
  warm: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  cool: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  red: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  green: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  blue: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  bulb: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  showRGB: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  showWarmCool: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  isHorizontal: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  onDragStart: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onDragEnd: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ColorPicker, "defaultProps", {
  warm: 0,
  cool: 0,
  red: 0,
  green: 0,
  blue: 0,
  bulb: false,
  showRGB: false,
  showWarmCool: false,
  isHorizontal: false
});



/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

var Formatter = {
  toClockDisplay: function toClockDisplay(seconds) {
    if (seconds <= 0) {
      return "0:00";
    }

    var minutes = parseInt(seconds / 60);
    return "".concat(minutes, ":").concat("0".concat(seconds % 60).slice(-2));
  },
  getFriendlyTimestamp: function getFriendlyTimestamp(isoDate) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(isoDate).format("dddd, MMMM D, YYYY h:mm A");
  },
  getISODateString: function getISODateString(dateObject) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(dateObject).format("YYYY-MM-DD");
  },
  isISODate: function isISODate(potentialIsoDate) {
    return /^\d{4}-\d{2}-\d{2}$/.test(potentialIsoDate);
  },
  getDateObjectFromISODate: function getDateObjectFromISODate(isoDate) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(isoDate).toDate();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Formatter);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PanTilt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */
function PanTilt(feature) {
  var _this = this;

  var tiltUpAction = feature.actions.up;
  var tiltDownAction = feature.actions.down;
  var panLeftAction = feature.actions.left;
  var panRightAction = feature.actions.right;

  function panTiltError() {
    return new Error("Attempted to use pan/tilt on a device with no associated action in its pan_tilt feature");
  }

  this.tiltUp = function () {
    if (tiltUpAction == null) {
      return $.Deferred.reject(panTiltError());
    } else {
      return _this.executeDeviceAction(tiltUpAction, {}, {
        updateModelWithResponse: false
      });
    }
  };

  this.tiltDown = function () {
    if (tiltDownAction == null) {
      return $.Deferred.reject(panTiltError());
    } else {
      return _this.executeDeviceAction(tiltDownAction, {}, {
        updateModelWithResponse: false
      });
    }
  };

  this.panLeft = function () {
    if (panLeftAction == null) {
      return $.Deferred.reject(panTiltError());
    } else {
      return _this.executeDeviceAction(panLeftAction, {}, {
        updateModelWithResponse: false
      });
    }
  };

  this.panRight = function () {
    if (panRightAction == null) {
      return $.Deferred.reject(panTiltError());
    } else {
      return _this.executeDeviceAction(panRightAction, {}, {
        updateModelWithResponse: false
      });
    }
  };
}


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromiseRetrier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_utils_enqueueIn__ = __webpack_require__(59);





var PromiseRetrier =
/*#__PURE__*/
function () {
  function PromiseRetrier(promiseFactory, maxAttempts, delayBetweenAttempts) // milliseconds
  {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, PromiseRetrier);

    this._promiseFactory = promiseFactory;
    this._maxAttempts = maxAttempts;
    this._delayBetweenAttempts = delayBetweenAttempts;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(PromiseRetrier, [{
    key: "run",
    value: function run() {
      var result;
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.async(function run$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this._attempt = 0;

            case 1:
              if (!this._shouldContinue()) {
                _context.next = 22;
                break;
              }

              this._attempt += 1;
              _context.prev = 3;
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(this._promiseFactory());

            case 6:
              result = _context.sent;
              this._resolved = true;
              _context.next = 20;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);

              if (!this._shouldContinue()) {
                _context.next = 18;
                break;
              }

              _context.next = 15;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(this._delay());

            case 15:
              return _context.abrupt("continue", 1);

            case 18:
              if (this._canceled) {
                _context.next = 20;
                break;
              }

              throw _context.t0;

            case 20:
              _context.next = 1;
              break;

            case 22:
              return _context.abrupt("return", result);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[3, 10]]);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this._canceled = true;
    }
  }, {
    key: "_delay",
    value: function _delay() {
      var _this = this;

      return new Promise(function (resolve) {
        Object(__WEBPACK_IMPORTED_MODULE_3_nx_components_utils_enqueueIn__["b" /* default */])(resolve, _this._delayBetweenAttempts);
      });
    }
  }, {
    key: "_shouldContinue",
    value: function _shouldContinue() {
      return !this._resolved && !this._canceled && this._attempt < this._maxAttempts;
    }
  }]);

  return PromiseRetrier;
}();



/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(217),
    stubFalse = __webpack_require__(1171);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 521 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateTime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);










var DateTime =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DateTime, _React$Component);

  function DateTime() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DateTime);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DateTime).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DateTime, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          relative = _this$props.relative,
          natural = _this$props.natural,
          format = _this$props.format;
      var content;

      if (natural) {
        content = __WEBPACK_IMPORTED_MODULE_8_moment___default()(value).format("[on] dddd, MMMM D, YYYY [at] h:mm A");
      } else if (relative) {
        content = __WEBPACK_IMPORTED_MODULE_8_moment___default()(value).fromNow();
      } else if (format) {
        content = __WEBPACK_IMPORTED_MODULE_8_moment___default()(value).format(format);
      } else {
        content = null;
      }

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
        "data-component-name": "DateTime"
      }, content);
    }
  }]);

  return DateTime;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DateTime, "propTypes", {
  value: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(Date), __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, // ISO-8601 or RFC1123 date string
  __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number // Unix Timestamp
  ]).isRequired,
  relative: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  natural: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  format: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DateTime, "defaultProps", {
  format: "dddd, MMMM D, YYYY h:mm A"
});



/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_utils_enqueueIn__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nx_components_ScrollableDiv__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_PinEntry_Prompt__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_PinEntry_PivotKeyboard__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_PinEntry_PinLengthConfiguration__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nx_components_Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nx_components_ContextWrappers_LanguageContext__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_prop_types__);


















var termsAndConditions = "http://tranecommercial.helpdocsonline.com/terms-conditions";

var EULAContent =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(EULAContent, _React$Component);

  function EULAContent() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, EULAContent);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(EULAContent).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(EULAContent, [{
    key: "render",
    value: function render() {
      var colors = this.props.colors;
      var language = this.context.localeSet.nexia_mobile.PinEntry.PivotPinEntryWrapper;
      var EULAStyles = Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__["b" /* default */])({
        footerStyle: {
          backgroundImage: "linear-gradient(#aabbc2,".concat(colors.PRIMARY_GRADIENT_DARK, ")")
        },
        pinEntrySpan: {
          flex: "1 1 auto",
          display: "flex",
          fontSize: "0.70em",
          color: "white",
          flexDirection: "column",
          margin: "1.5em"
        }
      });
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: EULAStyles.footerStyle
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("span", {
        style: EULAStyles.pinEntrySpan
      }, language.EULApt1, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: termsAndConditions
      }, language.EULApt2Link)), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("span", {
        style: EULAStyles.pinEntrySpan
      }, "\xA92022 Trane | ", language.privacyPolicy, " | ", language.termsOfUse));
    }
  }]);

  return EULAContent;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(EULAContent, "propTypes", {
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
});

var EULADiv = Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_ColorsProvider__["c" /* withColorsProvider */])(EULAContent);
var forgotPinStyles = Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__["b" /* default */])({
  forgotPin: {
    fontSize: "0.6em",
    margin: "0.75em"
  }
});

var ForgotPin =
/*#__PURE__*/
function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ForgotPin, _React$Component2);

  function ForgotPin() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ForgotPin);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ForgotPin).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ForgotPin, [{
    key: "render",
    value: function render() {
      var onForgotPin = this.props.onForgotPin;
      var language = this.context.localeSet.nexia_mobile.PinEntry.PivotPinEntryWrapper;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_Button__["a" /* default */], {
        theme: "link",
        style: forgotPinStyles.forgotPin,
        onTap: onForgotPin
      }, language.forgotPinButton);
    }
  }]);

  return ForgotPin;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ForgotPin, "propTypes", {
  onForgotPin: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.func
});

var PivotPinEntryWrapper =
/*#__PURE__*/
function (_React$Component3) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PivotPinEntryWrapper, _React$Component3);

  function PivotPinEntryWrapper() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, PivotPinEntryWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(PivotPinEntryWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      value: ""
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "reset", function () {
      _this.setState({
        value: ""
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onKeypad", function (key) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onDone = _this$props.onDone,
          onChangeValue = _this$props.onChangeValue;
      var newValue;

      if (disabled) {
        return;
      }

      if (key === "backspace") {
        newValue = _this.state.value.slice(0, -1);
      } else {
        newValue = _this.state.value + key;

        if (newValue.length > _this.props.length) {
          return; // don't update state, don't call back to parent
        }
      }

      _this.setState({
        value: newValue
      });

      if (onChangeValue) {
        onChangeValue(newValue);
      }

      if (newValue.length === _this.props.length && onDone) {
        // Adding a 100 ms delay to make the last pin digit fill in
        Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_utils_enqueueIn__["b" /* default */])(function () {
          onDone(newValue);
        }, 100);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(PivotPinEntryWrapper, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          prompt = _this$props2.prompt,
          length = _this$props2.length,
          showForgotPin = _this$props2.showForgotPin,
          password = _this$props2.password,
          onForgotPin = _this$props2.onForgotPin,
          showEULA = _this$props2.showEULA,
          canChangeLength = _this$props2.canChangeLength,
          lengthChoices = _this$props2.lengthChoices,
          onNewLengthRequested = _this$props2.onNewLengthRequested;
      var value = this.state.value;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__["b" /* default */])({
        pinEntryVerticalContainer: {
          flex: "1 1 auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          overflow: "hidden",
          minHeight: "100%",
          // iPhone X has a "safe area" and it was covering the logo.
          paddingTop: __WEBPACK_IMPORTED_MODULE_16_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_TOP,
          paddingBottom: __WEBPACK_IMPORTED_MODULE_16_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_BOTTOM
        },
        pinEntryWrapper: {
          flex: "1 1 auto",
          display: "flex",
          alignItems: "center",
          width: "100%",
          flexDirection: "column",
          justifyContent: "center",
          marginTop: "0.5em",
          alignSelf: "center"
        },
        forgotPin: {
          fontSize: "0.6em",
          margin: "0.75em",
          textTransform: "uppercase"
        }
      });
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nx_components_ScrollableDiv__["a" /* default */], {
        style: {
          flex: "1 1 100%",
          flexDirection: "column"
        }
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "PivotPinEntryWrapper",
        style: styles.pinEntryVerticalContainer
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.pinEntryWrapper
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_PinEntry_Prompt__["b" /* default */], {
        isPortrait: true,
        value: value,
        prompt: prompt,
        length: length,
        password: password,
        onForgotPin: onForgotPin
      }, canChangeLength && __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_PinEntry_PinLengthConfiguration__["a" /* default */], {
        currentLength: length,
        lengthChoices: lengthChoices,
        onNewLengthRequested: onNewLengthRequested
      })), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_PinEntry_PivotKeyboard__["a" /* default */], {
        onKeypad: this._onKeypad,
        disabled: disabled
      }), showForgotPin ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](ForgotPin, {
        onForgotPin: onForgotPin
      }) : null, showEULA ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](EULADiv, null) : null)));
    }
  }]);

  return PivotPinEntryWrapper;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(PivotPinEntryWrapper, "defaultProps", {
  prompt: "Enter some numbers",
  length: 4,
  password: false,
  disabled: false,
  showForgotPin: false,
  showEULA: false,
  canChangeLength: false,
  lengthChoices: []
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(PivotPinEntryWrapper, "propTypes", {
  prompt: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.string,
  length: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.number,
  password: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.bool,
  showForgotPin: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.bool,
  onChangeValue: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.func,
  onDone: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.func.isRequired,
  onForgotPin: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.func,
  showEULA: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.bool,
  canChangeLength: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.bool,
  lengthChoices: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.number.isRequired),
  onNewLengthRequested: __WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.func
});

/* harmony default export */ __webpack_exports__["a"] = (PivotPinEntryWrapper);
EULAContent.contextType = __WEBPACK_IMPORTED_MODULE_17_nx_components_ContextWrappers_LanguageContext__["b" /* default */];
ForgotPin.contextType = __WEBPACK_IMPORTED_MODULE_17_nx_components_ContextWrappers_LanguageContext__["b" /* default */];


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_Select_SelectDialog__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nx_components_ContextWrappers_LanguageContext__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var styles = {
  button: {
    margin: "0.25em",
    padding: "0.25em",
    borderRadius: "4px"
  }
};

var PinLengthConfiguration = function PinLengthConfiguration(props) {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7_nx_components_ContextWrappers_LanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.PinEntry.PinLengthConfiguration;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),
      _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      dialogOpen = _useState2[0],
      setDialogOpen = _useState2[1];

  var closeDialog = function closeDialog() {
    setDialogOpen(false);
  };

  var handleOptionTapped = function handleOptionTapped(_ref) {
    var value = _ref.value;
    var onNewLengthRequested = props.onNewLengthRequested;

    if (onNewLengthRequested != null) {
      onNewLengthRequested(value);
    }

    closeDialog();
  };

  var currentLength = props.currentLength,
      lengthChoices = props.lengthChoices;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nx_components_Tappable__["b" /* default */], {
    onTap: function onTap() {
      return setDialogOpen(true);
    }
  }, function (_ref2) {
    var active = _ref2.active,
        tapTargetRefHandler = _ref2.tapTargetRefHandler;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nx_components_NoStyleButton__["a" /* default */], {
      style: _objectSpread({}, styles.button, {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_4_nx_components_Tappable__["c" /* simpleActiveBackgroundColor */])(active)
      }),
      innerRef: tapTargetRefHandler
    }, language.pinLengthButton, " ", __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_nx_components_Icons__["I" /* IconDropDownArrow */], null));
  }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_nx_components_Select_SelectDialog__["c" /* default */], {
    open: dialogOpen,
    options: lengthChoices.map(function (length) {
      return {
        value: length,
        label: languageContext.template(language.pinLengthOptionTemplate, {
          length: length
        })
      };
    }),
    value: currentLength,
    onOptionTapped: handleOptionTapped,
    onBackgroundTapped: closeDialog,
    onRequestClose: closeDialog
  }));
};

PinLengthConfiguration.propTypes = {
  currentLength: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,
  lengthChoices: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired).isRequired,
  onNewLengthRequested: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (PinLengthConfiguration);


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Account; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__ = __webpack_require__(36);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/



var Account =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Account, _BaseModel);

  function Account() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, Account);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Account).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Account, [{
    key: "nestedCollections",
    value: function nestedCollections() {
      return {
        operations: {
          collection: __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_collection__["a" /* default */],
          model: __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__["a" /* default */]
        },
        contacts: {
          collection: __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_collection__["a" /* default */],
          model: __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__["a" /* default */]
        }
      };
    }
  }, {
    key: "validations",
    value: function validations() {
      return {
        firstName: {
          required: true
        }
      };
    }
  }, {
    key: "parseLinksOperation",
    value: function parseLinksOperation(links) {
      var result = links.map(function (link) {
        return link == null ? "" : link;
      });

      if (!result.length) {
        return;
      }

      this.get("operations").reset(result);
    }
    /* eslint-disable array-callback-return */

    /* eslint-disable consistent-return */

  }, {
    key: "parseLinksChild",
    value: function parseLinksChild(links) {
      // Currently only expecting contacts so "children" really equals "contacts"
      var result = links.map(function (link) {
        return link == null ? "" : link;
      });

      if (!result.length) {
        return;
      }

      var values = result[0].data;
      var href = result[0].href;
      var massagedResult = values.filter(function (contact) {
        if (contact.email || contact.phoneNumber) {
          return contact;
        }
      }).map(function (contact) {
        return _objectSpread({}, contact, {
          _links: values._links,
          href: href
        });
      });
      this.get("contacts").reset(massagedResult);
    }
  }]);

  return Account;
}(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__["a" /* default */]);



/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_alert__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_mixins_editable__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_platform__ = __webpack_require__(43);













var AlertCollection =
/*#__PURE__*/
function (_BaseCollection) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AlertCollection, _BaseCollection);

  function AlertCollection() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AlertCollection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AlertCollection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "model", __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_alert__["a" /* default */]);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AlertCollection, [{
    key: "parseLinksAcknowledge",
    value: function parseLinksAcknowledge(links) {
      var link = _.first(links);

      this._acknowledgeHref = link ? link.getHref() : this._acknowledgeHref;
    }
  }, {
    key: "acknowledgeAll",
    value: function acknowledgeAll() {
      var model = new __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_base_model__["a" /* default */]();
      model.setAsEphemeral();
      model.setUrl(this._acknowledgeHref);
      return model.save({}, {
        method: "POST",
        success: function success() {
          __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_platform__["a" /* default */].resetAppBadge();
        }
      });
    }
  }, {
    key: "parseLinksClearAll",
    value: function parseLinksClearAll(links) {
      var link = _.first(links);

      this._clearAllHref = link ? link.getHref() : this._clearAllHref;
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      var model = new __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_base_model__["a" /* default */]();
      model.setAsEphemeral();
      model.setUrl(this._clearAllHref);
      return model.save({}, {
        method: "POST"
      });
    }
  }]);

  return AlertCollection;
}(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_base_collection__["a" /* default */]);

_.extend(AlertCollection.prototype, __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_mixins_editable__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AlertCollection);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_recorded_video__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_mixins_pageable__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_mixins_filterable__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_date_range_filter_schema__ = __webpack_require__(417);












var RecordedVideoCollection =
/*#__PURE__*/
function (_BaseCollection) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(RecordedVideoCollection, _BaseCollection);

  function RecordedVideoCollection() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, RecordedVideoCollection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default()(RecordedVideoCollection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this), "model", __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_recorded_video__["a" /* default */]);

    return _this;
  }

  return RecordedVideoCollection;
}(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_collection__["a" /* default */]);

_.extend(RecordedVideoCollection.prototype, __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_mixins_pageable__["a" /* default */]);

_.extend(RecordedVideoCollection.prototype, __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_mixins_filterable__["a" /* default */], {
  getFilterSchemaClass: function getFilterSchemaClass() {
    return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_date_range_filter_schema__["a" /* default */];
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RecordedVideoCollection);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_framework_resource__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_phone__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_schema__ = __webpack_require__(52);












var PhoneCollection =
/*#__PURE__*/
function (_BaseCollection) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PhoneCollection, _BaseCollection);

  function PhoneCollection() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PhoneCollection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(PhoneCollection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "model", __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_phone__["a" /* default */]);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PhoneCollection, [{
    key: "parse",
    // We don't call super here because that always creates new models, which updates
    // the ResourceMap when we don't want it to. Reproduce most of the logic instead.
    value: function parse(attrs) {
      var _this2 = this;

      var items = this._performParseSideEffects(attrs); // Pierce our "links" abstraction to reuse models when possible


      function getId(item) {
        return item && item._links && item._links.self && item._links.self.href;
      }

      return items.filter(getId).map(function (item) {
        var id = getId(item);
        var existingPhone = __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_framework_resource__["a" /* ResourceMap */].findByHref(id);

        if (existingPhone) {
          return existingPhone.set(existingPhone.parse(item));
        } else {
          // eslint-disable-next-line babel/new-cap
          return new _this2.model(item, {
            parse: true
          });
        }
      });
    }
  }, {
    key: "parseLinksChildSchema",
    value: function parseLinksChildSchema(links) {
      this.childSchemaLink = links[0];
    }
  }, {
    key: "getChildSchema",
    value: function getChildSchema() {
      var schema = new __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_schema__["a" /* default */]();

      if (this.childSchemaLink == null) {
        return Promise.reject(new Error("Cannot get child schema on phones collection with no child schema link"));
      }

      schema.setUrl(this.childSchemaLink.href);
      return schema.fetch().then(function () {
        return schema;
      });
    }
  }]);

  return PhoneCollection;
}(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_collection__["a" /* default */]);



/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditableText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__ = __webpack_require__(9);












var styles = Object(__WEBPACK_IMPORTED_MODULE_11__utils_prefixStyles__["b" /* default */])({
  container: {
    display: "flex",
    alignItems: "center"
  },
  input: {
    fontSize: "1em",
    width: "100%",
    maxWidth: "20em"
  },
  icon: {
    position: "absolute",
    right: 0
  }
});

var EditableText =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(EditableText, _React$Component);

  function EditableText() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, EditableText);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(EditableText)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      isEditing: false
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_toggleEditing", function () {
      _this.setState(function (prevState) {
        return {
          isEditing: !prevState.isEditing
        };
      }, function () {
        var callback = _this.state.isEditing ? _this.props.onEditStart : _this.props.onEditEnd;

        if (callback) {
          callback();
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleKeyPress", function (ev) {
      if (ev.charCode === 13) {
        _this._toggleEditing();
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleInput", function (ev) {
      if (ev.target.value.length > _this.props.maxTextLength) {
        ev.target.value = ev.target.value.slice(0, _this.props.maxTextLength);
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleChange", function (ev) {
      if (!_this.props.onChange) {
        return;
      }

      _this.props.onChange(ev.target.value);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(EditableText, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var isEditing = this.state.isEditing;

      if (isEditing && !prevState.isEditing && this._input) {
        this._input.focus();

        this._input.setSelectionRange(0, (this._input.value || "").length);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          value = _this$props.value,
          disabled = _this$props.disabled,
          inputSize = _this$props.inputSize,
          maxWidth = _this$props.maxWidth,
          maxTextLength = _this$props.maxTextLength;
      var isEditing = this.state.isEditing;
      var labelStyle = {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        minWidth: 24,
        maxWidth: maxWidth,
        position: "relative",
        padding: 4,
        paddingRight: "1.2em",
        outline: "none"
      };
      var pencilIcon = !disabled && __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Icons__["_12" /* IconPencil */], {
        style: styles.icon
      });
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("span", {
        style: styles.container,
        "data-component-name": "EditableText"
      }, isEditing && !disabled ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("input", {
        style: styles.input,
        type: "text",
        size: inputSize,
        value: value,
        maxLength: maxTextLength,
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        spellCheck: "false",
        onKeyPress: this._handleKeyPress,
        onChange: this._handleChange,
        onInput: this._handleInput,
        onBlur: this._toggleEditing,
        ref: function ref(el) {
          return _this2._input = el;
        }
      }) : __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Tappable__["b" /* default */], {
        onTap: this._toggleEditing
      }, function (_ref) {
        var tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("span", {
          "data-component-section": "tap-to-edit",
          ref: tapTargetRefHandler,
          style: labelStyle,
          tabIndex: "0"
        }, value, pencilIcon);
      }));
    }
  }]);

  return EditableText;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(EditableText, "propTypes", {
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  inputSize: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  maxWidth: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  maxTextLength: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onEditStart: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onEditEnd: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(EditableText, "defaultProps", {
  inputSize: 16,
  maxWidth: 200,
  maxTextLength: 32
});



/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Tappable__ = __webpack_require__(28);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var baseStyle = Object(__WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["b" /* default */])({
  backgroundColor: "black",
  transition: "opacity 250ms",
  position: "fixed",
  top: 0,
  bottom: 0,
  left: 0,
  // NoStyleButton version needs this in Safari or it slides right to its sibling (https://developers.google.com/web/updates/2016/06/absolute-positioned-children)
  width: "100%",
  // NoStyleButton version needs this instead of "right" in Chrome or it has no width (no one else on the internet has this issue)
  zIndex: __WEBPACK_IMPORTED_MODULE_11__Theme__["a" /* default */].zIndexLayers.MODAL
});

var DialogBackground =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(DialogBackground, _React$Component);

  function DialogBackground() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, DialogBackground);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(DialogBackground)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      opacity: 0
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(DialogBackground, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;

      if (this.props.open) {
        requestAnimationFrame(function () {
          if (_this2._isMounted && _this2.props.open) {
            _this2.setState({
              opacity: 0.5
            });
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.open !== this.props.open) {
        this.setState({
          opacity: nextProps.open ? 0.5 : 0
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          style = _this$props.style,
          onTap = _this$props.onTap,
          rest = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["open", "style", "onTap"]);

      var opacity = this.state.opacity;

      var combinedStyle = _objectSpread({}, baseStyle, {
        opacity: opacity
      }, open ? null : {
        pointerEvents: "none"
      }, {}, style);

      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Tappable__["b" /* default */], {
        onTap: onTap
      }, function (_ref) {
        var tapTargetRefHandler = _ref.tapTargetRefHandler;
        return onTap ? __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__NoStyleButton__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          innerRef: tapTargetRefHandler,
          style: combinedStyle
        }, rest)) // use NoStyleButton for screen readers
        : __WEBPACK_IMPORTED_MODULE_9_react__["createElement"]("div", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          style: combinedStyle
        }, rest));
      });
    }
  }]);

  return DialogBackground;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(DialogBackground, "propTypes", {
  open: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool.isRequired,
  style: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object,
  onTap: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
});

/* harmony default export */ __webpack_exports__["a"] = (DialogBackground);

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/pivot_logo-44729d32-pivot.svg";

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_app_state__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_flux_like_store__ = __webpack_require__(27);













var CurrentLocationCollectionProvider =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(CurrentLocationCollectionProvider, _React$Component);

  function CurrentLocationCollectionProvider() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CurrentLocationCollectionProvider);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(CurrentLocationCollectionProvider).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CurrentLocationCollectionProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appState = _this$props.appState,
          collectionName = _this$props.collectionName,
          children = _this$props.children,
          debounceAmount = _this$props.debounceAmount;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_BackboneListener__["a" /* default */], {
        listenTo: appState,
        events: ["change:currentLocation"]
      }, function () {
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_BackboneListener__["a" /* default */], {
          listenTo: appState.currentLocation,
          events: ["change:".concat(collectionName)]
        }, function () {
          var collection = appState.currentLocation ? appState.currentLocation.get(collectionName) : __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_flux_like_store__["a" /* default */].session.get("locations").first().get(collectionName);
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_BackboneListener__["a" /* default */], {
            listenTo: collection,
            events: ["add", "remove", "reset", "sort", "sync", "change"],
            debounceRender: debounceAmount != null ? debounceAmount : true
          }, function () {
            return children(collection);
          });
        });
      });
    }
  }]);

  return CurrentLocationCollectionProvider;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(CurrentLocationCollectionProvider, "propTypes", {
  appState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_app_state__["a" /* default */]).isRequired,
  collectionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  // (collection: Backbone.Collection) => React.Element<any>
  debounceAmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  appState: "appState"
}, CurrentLocationCollectionProvider));

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1169),
    isArguments = __webpack_require__(534),
    isArray = __webpack_require__(299),
    isBuffer = __webpack_require__(520),
    isIndex = __webpack_require__(505),
    isTypedArray = __webpack_require__(535);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1170),
    isObjectLike = __webpack_require__(151);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1172),
    baseUnary = __webpack_require__(1173),
    nodeUtil = __webpack_require__(1174);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 536 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PhoneContextWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectedPhoneContextWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);




var PhoneContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext();
/* harmony default export */ __webpack_exports__["b"] = (PhoneContext);

var findPhone = function findPhone(phones) {
  var phone;
  var models = phones.models;
  var mobileId = parseInt(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_local_settings__["c" /* default */].getMobileId());

  for (var index = 0; index < models.length; index++) {
    var currentPhone = models[index];
    var phoneId = currentPhone.get("phone_id");

    if (phoneId === mobileId) {
      phone = currentPhone;
      break;
    }
  }

  return phone;
};

var PhoneContextWrapper = function PhoneContextWrapper(props) {
  var getPhoneFromSession = function getPhoneFromSession(session) {
    var currentPhones = session.get("phones");
    return findPhone(currentPhones);
  };

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(getPhoneFromSession(props.session)),
      _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      phone = _useState2[0],
      setPhoneState = _useState2[1];

  var setPhone = function setPhone() {
    setPhoneState(getPhoneFromSession(props.session));
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PhoneContext.Provider, {
    value: {
      phone: phone,
      setPhone: setPhone
    }
  }, props.children);
};
var ConnectedPhoneContextWrapper = Object(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  session: "session"
}, PhoneContextWrapper);

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/amstd_commercial_logo-44729d32-pivot.svg";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(328);
__webpack_require__(328);
__webpack_require__(540);
__webpack_require__(1284);
module.exports = __webpack_require__(1285);


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_polyfills__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_globals__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_raven_config__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fastclick__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_action_handlers_all__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_QueryParams__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_UserAgent__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_patchBackboneSync__ = __webpack_require__(1283);













Object(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_patchBackboneSync__["a" /* default */])();
var platform = __WEBPACK_IMPORTED_MODULE_10_nx_components_QueryParams__["a" /* default */].platform();
var resetPasswordCode = __WEBPACK_IMPORTED_MODULE_10_nx_components_QueryParams__["a" /* default */].resetPasswordCode();
var transferAccountCode = __WEBPACK_IMPORTED_MODULE_10_nx_components_QueryParams__["a" /* default */].transferAccountCode();

if (platform === "ios-uiwebview" || platform === "ios-wkwebview") {
  // This forces iOS to process click events on non-clickable things, which
  // allows users to blur fields by tapping the background, etc.
  document.body.style.cursor = "pointer";
}

if (__WEBPACK_IMPORTED_MODULE_11_nx_components_UserAgent__["a" /* default */].isAndroid()) {
  document.body.style.fontFamily = "Roboto, system-ui, sans-serif";
} else if (__WEBPACK_IMPORTED_MODULE_11_nx_components_UserAgent__["a" /* default */].isIOS()) {
  document.body.style.fontFamily = "-apple-system, BlinkMacSystemFont, system-ui, sans-serif";
} else if (__WEBPACK_IMPORTED_MODULE_11_nx_components_UserAgent__["a" /* default */].isWindows()) {
  document.body.style.fontFamily = '"Segoe UI", system-ui, sans-serif';
} else {
  document.body.style.fontFamily = "-apple-system, BlinkMacSystemFont, Roboto, system-ui, sans-serif";
}

if (platform === "ios-uiwebview") {
  __WEBPACK_IMPORTED_MODULE_4_fastclick___default.a.attach(document.body);
}

__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_platform__["a" /* default */].initScriptInterface(function () {
  __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_local_settings__["c" /* default */].ensureBackwardsCompatibility();
  Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_LAUNCH");

  if (__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_environment__["a" /* default */].isCommercial() && resetPasswordCode) {
    Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_RESET_PASSWORD_CODE", resetPasswordCode);
  } else if (__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_environment__["a" /* default */].isCommercial() && transferAccountCode) {
    Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_TRANSFER_ACCOUNT_CODE", transferAccountCode);
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_stage_4__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_stage_4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_stage_4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_smoothscroll_polyfill__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_smoothscroll_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_smoothscroll_polyfill__);
 // Provides full ES2015 environment (except for Proxies)

 // Everything that has been standardized by ECMA

 // global fetch function (whatwg fetch)


__WEBPACK_IMPORTED_MODULE_3_smoothscroll_polyfill___default.a.polyfill();

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(543);

__webpack_require__(730);

__webpack_require__(731);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(544);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(580);
__webpack_require__(581);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(584);
__webpack_require__(585);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(588);
__webpack_require__(589);
__webpack_require__(590);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(593);
__webpack_require__(594);
__webpack_require__(595);
__webpack_require__(596);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(599);
__webpack_require__(600);
__webpack_require__(601);
__webpack_require__(602);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(607);
__webpack_require__(608);
__webpack_require__(609);
__webpack_require__(610);
__webpack_require__(611);
__webpack_require__(612);
__webpack_require__(613);
__webpack_require__(614);
__webpack_require__(615);
__webpack_require__(616);
__webpack_require__(617);
__webpack_require__(618);
__webpack_require__(619);
__webpack_require__(620);
__webpack_require__(621);
__webpack_require__(622);
__webpack_require__(624);
__webpack_require__(625);
__webpack_require__(627);
__webpack_require__(628);
__webpack_require__(629);
__webpack_require__(630);
__webpack_require__(631);
__webpack_require__(632);
__webpack_require__(633);
__webpack_require__(635);
__webpack_require__(636);
__webpack_require__(637);
__webpack_require__(638);
__webpack_require__(639);
__webpack_require__(640);
__webpack_require__(641);
__webpack_require__(642);
__webpack_require__(643);
__webpack_require__(644);
__webpack_require__(645);
__webpack_require__(646);
__webpack_require__(647);
__webpack_require__(249);
__webpack_require__(648);
__webpack_require__(348);
__webpack_require__(649);
__webpack_require__(349);
__webpack_require__(650);
__webpack_require__(651);
__webpack_require__(652);
__webpack_require__(653);
__webpack_require__(654);
__webpack_require__(352);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(655);
__webpack_require__(656);
__webpack_require__(657);
__webpack_require__(658);
__webpack_require__(659);
__webpack_require__(660);
__webpack_require__(661);
__webpack_require__(662);
__webpack_require__(663);
__webpack_require__(664);
__webpack_require__(665);
__webpack_require__(666);
__webpack_require__(667);
__webpack_require__(668);
__webpack_require__(669);
__webpack_require__(670);
__webpack_require__(671);
__webpack_require__(672);
__webpack_require__(673);
__webpack_require__(674);
__webpack_require__(675);
__webpack_require__(676);
__webpack_require__(677);
__webpack_require__(678);
__webpack_require__(679);
__webpack_require__(680);
__webpack_require__(359);
__webpack_require__(681);
__webpack_require__(682);
__webpack_require__(683);
__webpack_require__(361);
__webpack_require__(363);
__webpack_require__(684);
__webpack_require__(685);
__webpack_require__(686);
__webpack_require__(687);
__webpack_require__(688);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(689);
__webpack_require__(690);
__webpack_require__(691);
__webpack_require__(692);
__webpack_require__(693);
__webpack_require__(694);
__webpack_require__(695);
__webpack_require__(696);
__webpack_require__(697);
__webpack_require__(698);
__webpack_require__(699);
__webpack_require__(700);
__webpack_require__(701);
__webpack_require__(702);
__webpack_require__(703);
__webpack_require__(704);
__webpack_require__(705);
__webpack_require__(706);
__webpack_require__(707);
__webpack_require__(708);
__webpack_require__(709);
__webpack_require__(710);
__webpack_require__(711);
__webpack_require__(712);
__webpack_require__(713);
__webpack_require__(714);
__webpack_require__(715);
__webpack_require__(716);
__webpack_require__(717);
__webpack_require__(718);
__webpack_require__(719);
__webpack_require__(720);
__webpack_require__(721);
__webpack_require__(722);
__webpack_require__(723);
__webpack_require__(724);
__webpack_require__(725);
__webpack_require__(726);
__webpack_require__(727);
__webpack_require__(728);
__webpack_require__(729);
module.exports = __webpack_require__(61);


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(21);
var has = __webpack_require__(60);
var DESCRIPTORS = __webpack_require__(33);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(55);
var META = __webpack_require__(100).KEY;
var $fails = __webpack_require__(25);
var shared = __webpack_require__(153);
var setToStringTag = __webpack_require__(134);
var uid = __webpack_require__(112);
var wks = __webpack_require__(29);
var wksExt = __webpack_require__(330);
var wksDefine = __webpack_require__(230);
var enumKeys = __webpack_require__(546);
var isArray = __webpack_require__(181);
var anObject = __webpack_require__(19);
var isObject = __webpack_require__(26);
var toObject = __webpack_require__(39);
var toIObject = __webpack_require__(62);
var toPrimitive = __webpack_require__(75);
var createDesc = __webpack_require__(111);
var _create = __webpack_require__(115);
var gOPNExt = __webpack_require__(333);
var $GOPD = __webpack_require__(63);
var $GOPS = __webpack_require__(180);
var $DP = __webpack_require__(38);
var $keys = __webpack_require__(113);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(116).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(155).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(99)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(54)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(153)('native-function-to-string', Function.toString);


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(113);
var gOPS = __webpack_require__(180);
var pIE = __webpack_require__(155);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(115) });


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(33), 'Object', { defineProperty: __webpack_require__(38).f });


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(33), 'Object', { defineProperties: __webpack_require__(332) });


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(62);
var $getOwnPropertyDescriptor = __webpack_require__(63).f;

__webpack_require__(77)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(39);
var $getPrototypeOf = __webpack_require__(64);

__webpack_require__(77)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(39);
var $keys = __webpack_require__(113);

__webpack_require__(77)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(77)('getOwnPropertyNames', function () {
  return __webpack_require__(333).f;
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(26);
var meta = __webpack_require__(100).onFreeze;

__webpack_require__(77)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(26);
var meta = __webpack_require__(100).onFreeze;

__webpack_require__(77)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(26);
var meta = __webpack_require__(100).onFreeze;

__webpack_require__(77)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(26);

__webpack_require__(77)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(26);

__webpack_require__(77)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(26);

__webpack_require__(77)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(8);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(334) });


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(8);
$export($export.S, 'Object', { is: __webpack_require__(335) });


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(8);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(234).set });


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(135);
var test = {};
test[__webpack_require__(29)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(55)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(8);

$export($export.P, 'Function', { bind: __webpack_require__(336) });


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(38).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(33) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(26);
var getPrototypeOf = __webpack_require__(64);
var HAS_INSTANCE = __webpack_require__(29)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(38).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $parseInt = __webpack_require__(338);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $parseFloat = __webpack_require__(339);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(21);
var has = __webpack_require__(60);
var cof = __webpack_require__(68);
var inheritIfRequired = __webpack_require__(236);
var toPrimitive = __webpack_require__(75);
var fails = __webpack_require__(25);
var gOPN = __webpack_require__(116).f;
var gOPD = __webpack_require__(63).f;
var dP = __webpack_require__(38).f;
var $trim = __webpack_require__(136).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(115)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(33) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(55)(global, NUMBER, $Number);
}


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toInteger = __webpack_require__(69);
var aNumberValue = __webpack_require__(340);
var repeat = __webpack_require__(237);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(25)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $fails = __webpack_require__(25);
var aNumberValue = __webpack_require__(340);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(8);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(8);
var _isFinite = __webpack_require__(21).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(8);

$export($export.S, 'Number', { isInteger: __webpack_require__(341) });


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(8);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(8);
var isInteger = __webpack_require__(341);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(8);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(8);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $parseFloat = __webpack_require__(339);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $parseInt = __webpack_require__(338);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(8);
var log1p = __webpack_require__(342);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(8);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(8);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(8);
var sign = __webpack_require__(238);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(8);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(8);
var $expm1 = __webpack_require__(239);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', { fround: __webpack_require__(343) });


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(8);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(8);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(25)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', { log1p: __webpack_require__(342) });


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', { sign: __webpack_require__(238) });


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(8);
var expm1 = __webpack_require__(239);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(25)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(8);
var expm1 = __webpack_require__(239);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var toAbsoluteIndex = __webpack_require__(114);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var toIObject = __webpack_require__(62);
var toLength = __webpack_require__(30);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(136)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(182)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(240)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $at = __webpack_require__(182)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(8);
var toLength = __webpack_require__(30);
var context = __webpack_require__(242);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(243)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(8);
var context = __webpack_require__(242);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(243)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(237)
});


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(8);
var toLength = __webpack_require__(30);
var context = __webpack_require__(242);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(243)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(56)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(56)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(56)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(56)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(56)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(56)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(56)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(56)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(56)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(56)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(56)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(56)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(56)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(8);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toObject = __webpack_require__(39);
var toPrimitive = __webpack_require__(75);

$export($export.P + $export.F * __webpack_require__(25)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(8);
var toISOString = __webpack_require__(623);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(25);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(55)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(29)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(54)(proto, TO_PRIMITIVE, __webpack_require__(626));


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(75);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(8);

$export($export.S, 'Array', { isArray: __webpack_require__(181) });


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(67);
var $export = __webpack_require__(8);
var toObject = __webpack_require__(39);
var call = __webpack_require__(344);
var isArrayIter = __webpack_require__(244);
var toLength = __webpack_require__(30);
var createProperty = __webpack_require__(245);
var getIterFn = __webpack_require__(246);

$export($export.S + $export.F * !__webpack_require__(184)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var createProperty = __webpack_require__(245);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(25)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(8);
var toIObject = __webpack_require__(62);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(154) != Object || !__webpack_require__(70)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var html = __webpack_require__(233);
var cof = __webpack_require__(68);
var toAbsoluteIndex = __webpack_require__(114);
var toLength = __webpack_require__(30);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(25)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var aFunction = __webpack_require__(50);
var toObject = __webpack_require__(39);
var fails = __webpack_require__(25);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(70)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $forEach = __webpack_require__(78)(0);
var STRICT = __webpack_require__(70)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
var isArray = __webpack_require__(181);
var SPECIES = __webpack_require__(29)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $map = __webpack_require__(78)(1);

$export($export.P + $export.F * !__webpack_require__(70)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $filter = __webpack_require__(78)(2);

$export($export.P + $export.F * !__webpack_require__(70)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $some = __webpack_require__(78)(3);

$export($export.P + $export.F * !__webpack_require__(70)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $every = __webpack_require__(78)(4);

$export($export.P + $export.F * !__webpack_require__(70)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $reduce = __webpack_require__(345);

$export($export.P + $export.F * !__webpack_require__(70)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $reduce = __webpack_require__(345);

$export($export.P + $export.F * !__webpack_require__(70)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $indexOf = __webpack_require__(179)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(70)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var toIObject = __webpack_require__(62);
var toInteger = __webpack_require__(69);
var toLength = __webpack_require__(30);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(70)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(8);

$export($export.P, 'Array', { copyWithin: __webpack_require__(346) });

__webpack_require__(101)('copyWithin');


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(8);

$export($export.P, 'Array', { fill: __webpack_require__(248) });

__webpack_require__(101)('fill');


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(8);
var $find = __webpack_require__(78)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(101)(KEY);


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(8);
var $find = __webpack_require__(78)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(101)(KEY);


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(117)('Array');


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var inheritIfRequired = __webpack_require__(236);
var dP = __webpack_require__(38).f;
var gOPN = __webpack_require__(116).f;
var isRegExp = __webpack_require__(183);
var $flags = __webpack_require__(156);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(33) && (!CORRECT_NEW || __webpack_require__(25)(function () {
  re2[__webpack_require__(29)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(55)(global, 'RegExp', $RegExp);
}

__webpack_require__(117)('RegExp');


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(349);
var anObject = __webpack_require__(19);
var $flags = __webpack_require__(156);
var DESCRIPTORS = __webpack_require__(33);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(55)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(25)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(19);
var toLength = __webpack_require__(30);
var advanceStringIndex = __webpack_require__(251);
var regExpExec = __webpack_require__(185);

// @@match logic
__webpack_require__(186)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(19);
var toObject = __webpack_require__(39);
var toLength = __webpack_require__(30);
var toInteger = __webpack_require__(69);
var advanceStringIndex = __webpack_require__(251);
var regExpExec = __webpack_require__(185);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(186)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(19);
var sameValue = __webpack_require__(335);
var regExpExec = __webpack_require__(185);

// @@search logic
__webpack_require__(186)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(183);
var anObject = __webpack_require__(19);
var speciesConstructor = __webpack_require__(157);
var advanceStringIndex = __webpack_require__(251);
var toLength = __webpack_require__(30);
var callRegExpExec = __webpack_require__(185);
var regexpExec = __webpack_require__(250);
var fails = __webpack_require__(25);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(186)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(99);
var global = __webpack_require__(21);
var ctx = __webpack_require__(67);
var classof = __webpack_require__(135);
var $export = __webpack_require__(8);
var isObject = __webpack_require__(26);
var aFunction = __webpack_require__(50);
var anInstance = __webpack_require__(118);
var forOf = __webpack_require__(119);
var speciesConstructor = __webpack_require__(157);
var task = __webpack_require__(252).set;
var microtask = __webpack_require__(253)();
var newPromiseCapabilityModule = __webpack_require__(254);
var perform = __webpack_require__(350);
var userAgent = __webpack_require__(187);
var promiseResolve = __webpack_require__(351);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(29)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(120)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(134)($Promise, PROMISE);
__webpack_require__(117)(PROMISE);
Wrapper = __webpack_require__(61)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(184)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(356);
var validate = __webpack_require__(121);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(188)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(8);
var $typed = __webpack_require__(189);
var buffer = __webpack_require__(255);
var anObject = __webpack_require__(19);
var toAbsoluteIndex = __webpack_require__(114);
var toLength = __webpack_require__(30);
var isObject = __webpack_require__(26);
var ArrayBuffer = __webpack_require__(21).ArrayBuffer;
var speciesConstructor = __webpack_require__(157);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(25)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(117)(ARRAY_BUFFER);


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
$export($export.G + $export.W + $export.F * !__webpack_require__(189).ABV, {
  DataView: __webpack_require__(255).DataView
});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(8);
var aFunction = __webpack_require__(50);
var anObject = __webpack_require__(19);
var rApply = (__webpack_require__(21).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(25)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(8);
var create = __webpack_require__(115);
var aFunction = __webpack_require__(50);
var anObject = __webpack_require__(19);
var isObject = __webpack_require__(26);
var fails = __webpack_require__(25);
var bind = __webpack_require__(336);
var rConstruct = (__webpack_require__(21).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(38);
var $export = __webpack_require__(8);
var anObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(75);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(25)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(8);
var gOPD = __webpack_require__(63).f;
var anObject = __webpack_require__(19);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(8);
var anObject = __webpack_require__(19);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(241)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(64);
var has = __webpack_require__(60);
var $export = __webpack_require__(8);
var isObject = __webpack_require__(26);
var anObject = __webpack_require__(19);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(63);
var $export = __webpack_require__(8);
var anObject = __webpack_require__(19);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(8);
var getProto = __webpack_require__(64);
var anObject = __webpack_require__(19);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(8);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(8);
var anObject = __webpack_require__(19);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(8);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(358) });


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(8);
var anObject = __webpack_require__(19);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(38);
var gOPD = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(64);
var has = __webpack_require__(60);
var $export = __webpack_require__(8);
var createDesc = __webpack_require__(111);
var anObject = __webpack_require__(19);
var isObject = __webpack_require__(26);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(8);
var setProto = __webpack_require__(234);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(8);
var flattenIntoArray = __webpack_require__(360);
var toObject = __webpack_require__(39);
var toLength = __webpack_require__(30);
var aFunction = __webpack_require__(50);
var arraySpeciesCreate = __webpack_require__(247);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(101)('flatMap');


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(8);
var flattenIntoArray = __webpack_require__(360);
var toObject = __webpack_require__(39);
var toLength = __webpack_require__(30);
var toInteger = __webpack_require__(69);
var arraySpeciesCreate = __webpack_require__(247);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(101)('flatten');


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(8);
var $at = __webpack_require__(182)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(136)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(136)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(8);
var defined = __webpack_require__(76);
var toLength = __webpack_require__(30);
var isRegExp = __webpack_require__(183);
var getFlags = __webpack_require__(156);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(241)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(230)('asyncIterator');


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(230)('observable');


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(8);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(372)('Map') });


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(8);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(372)('Set') });


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(191)('Map');


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(191)('Set');


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(191)('WeakMap');


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(191)('WeakSet');


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(192)('Map');


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(192)('Set');


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(192)('WeakMap');


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(192)('WeakSet');


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(8);

$export($export.G, { global: __webpack_require__(21) });


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(8);

$export($export.S, 'System', { global: __webpack_require__(21) });


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(8);
var cof = __webpack_require__(68);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);
var scale = __webpack_require__(374);
var fround = __webpack_require__(343);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(8);

$export($export.S, 'Math', { scale: __webpack_require__(374) });


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(8);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(8);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(8);
var core = __webpack_require__(61);
var global = __webpack_require__(21);
var speciesConstructor = __webpack_require__(157);
var promiseResolve = __webpack_require__(351);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(8);
var newPromiseCapability = __webpack_require__(254);
var perform = __webpack_require__(350);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(87);
var anObject = __webpack_require__(19);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(87);
var anObject = __webpack_require__(19);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(87);
var anObject = __webpack_require__(19);
var getPrototypeOf = __webpack_require__(64);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(354);
var from = __webpack_require__(373);
var metadata = __webpack_require__(87);
var anObject = __webpack_require__(19);
var getPrototypeOf = __webpack_require__(64);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(87);
var anObject = __webpack_require__(19);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(87);
var anObject = __webpack_require__(19);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(87);
var anObject = __webpack_require__(19);
var getPrototypeOf = __webpack_require__(64);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(87);
var anObject = __webpack_require__(19);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(87);
var anObject = __webpack_require__(19);
var aFunction = __webpack_require__(50);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(8);
var microtask = __webpack_require__(253)();
var process = __webpack_require__(21).process;
var isNode = __webpack_require__(68)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(8);
var global = __webpack_require__(21);
var core = __webpack_require__(61);
var microtask = __webpack_require__(253)();
var OBSERVABLE = __webpack_require__(29)('observable');
var aFunction = __webpack_require__(50);
var anObject = __webpack_require__(19);
var anInstance = __webpack_require__(118);
var redefineAll = __webpack_require__(120);
var hide = __webpack_require__(54);
var forOf = __webpack_require__(119);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(117)('Observable');


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(21);
var $export = __webpack_require__(8);
var userAgent = __webpack_require__(187);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
var $task = __webpack_require__(252);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(249);
var getKeys = __webpack_require__(113);
var redefine = __webpack_require__(55);
var global = __webpack_require__(21);
var hide = __webpack_require__(54);
var Iterators = __webpack_require__(137);
var wks = __webpack_require__(29);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(732);
module.exports = __webpack_require__(61).RegExp.escape;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(8);
var $re = __webpack_require__(733)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(365);
__webpack_require__(367);
__webpack_require__(364);
__webpack_require__(359);
__webpack_require__(361);
__webpack_require__(363);
module.exports = __webpack_require__(61);


/***/ }),
/* 735 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }

}());


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore_string__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery_mockjax__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery_mockjax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery_mockjax__);



 // Most of the app assumes these are globally available.
// Define them as non-writable properties so that they can't be overwritten.

Object.defineProperty(window, "_", {
  value: __WEBPACK_IMPORTED_MODULE_0_underscore___default.a
});
Object.defineProperty(window._, "str", {
  value: __WEBPACK_IMPORTED_MODULE_1_underscore_string___default.a
});
Object.defineProperty(window, "$", {
  value: __WEBPACK_IMPORTED_MODULE_2_jquery___default.a
});
__WEBPACK_IMPORTED_MODULE_3_jquery_mockjax___default()(window.$, window);

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
* Underscore.string
* (c) 2010 Esa-Matti Suuronen <esa-matti aet suuronen dot org>
* Underscore.string is freely distributable under the terms of the MIT license.
* Documentation: https://github.com/epeli/underscore.string
* Some code is borrowed from MooTools and Alexandru Marasteanu.
* Version '3.3.4'
* @preserve
*/



function s(value) {
  /* jshint validthis: true */
  if (!(this instanceof s)) return new s(value);
  this._wrapped = value;
}

s.VERSION = '3.3.4';

s.isBlank          = __webpack_require__(375);
s.stripTags        = __webpack_require__(739);
s.capitalize       = __webpack_require__(256);
s.decapitalize     = __webpack_require__(376);
s.chop             = __webpack_require__(740);
s.trim             = __webpack_require__(88);
s.clean            = __webpack_require__(741);
s.cleanDiacritics  = __webpack_require__(378);
s.count            = __webpack_require__(742);
s.chars            = __webpack_require__(258);
s.swapCase         = __webpack_require__(743);
s.escapeHTML       = __webpack_require__(744);
s.unescapeHTML     = __webpack_require__(746);
s.splice           = __webpack_require__(379);
s.insert           = __webpack_require__(748);
s.replaceAll       = __webpack_require__(749);
s.include          = __webpack_require__(750);
s.join             = __webpack_require__(751);
s.lines            = __webpack_require__(752);
s.dedent           = __webpack_require__(753);
s.reverse          = __webpack_require__(754);
s.startsWith       = __webpack_require__(755);
s.endsWith         = __webpack_require__(756);
s.pred             = __webpack_require__(757);
s.succ             = __webpack_require__(758);
s.titleize         = __webpack_require__(759);
s.camelize         = __webpack_require__(382);
s.underscored      = __webpack_require__(383);
s.dasherize        = __webpack_require__(384);
s.classify         = __webpack_require__(760);
s.humanize         = __webpack_require__(761);
s.ltrim            = __webpack_require__(762);
s.rtrim            = __webpack_require__(259);
s.truncate         = __webpack_require__(763);
s.prune            = __webpack_require__(764);
s.words            = __webpack_require__(765);
s.pad              = __webpack_require__(193);
s.lpad             = __webpack_require__(766);
s.rpad             = __webpack_require__(767);
s.lrpad            = __webpack_require__(768);
s.sprintf          = __webpack_require__(769);
s.vsprintf         = __webpack_require__(770);
s.toNumber         = __webpack_require__(771);
s.numberFormat     = __webpack_require__(772);
s.strRight         = __webpack_require__(773);
s.strRightBack     = __webpack_require__(774);
s.strLeft          = __webpack_require__(775);
s.strLeftBack      = __webpack_require__(776);
s.toSentence       = __webpack_require__(387);
s.toSentenceSerial = __webpack_require__(777);
s.slugify          = __webpack_require__(778);
s.surround         = __webpack_require__(388);
s.quote            = __webpack_require__(779);
s.unquote          = __webpack_require__(780);
s.repeat           = __webpack_require__(781);
s.naturalCmp       = __webpack_require__(782);
s.levenshtein      = __webpack_require__(783);
s.toBoolean        = __webpack_require__(784);
s.exports          = __webpack_require__(785);
s.escapeRegExp     = __webpack_require__(377);
s.wrap             = __webpack_require__(786);
s.map              = __webpack_require__(787);

// Aliases
s.strip     = s.trim;
s.lstrip    = s.ltrim;
s.rstrip    = s.rtrim;
s.center    = s.lrpad;
s.rjust     = s.lpad;
s.ljust     = s.rpad;
s.contains  = s.include;
s.q         = s.quote;
s.toBool    = s.toBoolean;
s.camelcase = s.camelize;
s.mapChars  = s.map;


// Implement chaining
s.prototype = {
  value: function value() {
    return this._wrapped;
  }
};

function fn2method(key, fn) {
  if (typeof fn !== 'function') return;
  s.prototype[key] = function() {
    var args = [this._wrapped].concat(Array.prototype.slice.call(arguments));
    var res = fn.apply(null, args);
    // if the result is non-string stop the chain and return the value
    return typeof res === 'string' ? new s(res) : res;
  };
}

// Copy functions to instance methods for chaining
for (var key in s) fn2method(key, s[key]);

fn2method('tap', function tap(string, fn) {
  return fn(string);
});

function prototype2method(methodName) {
  fn2method(methodName, function(context) {
    var args = Array.prototype.slice.call(arguments, 1);
    return String.prototype[methodName].apply(context, args);
  });
}

var prototypeMethods = [
  'toUpperCase',
  'toLowerCase',
  'split',
  'replace',
  'slice',
  'substring',
  'substr',
  'concat'
];

for (var method in prototypeMethods) prototype2method(prototypeMethods[method]);


module.exports = s;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function stripTags(str) {
  return makeString(str).replace(/<\/?[^>]+>/g, '');
};


/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = function chop(str, step) {
  if (str == null) return [];
  str = String(str);
  step = ~~step;
  return step > 0 ? str.match(new RegExp('.{1,' + step + '}', 'g')) : [str];
};


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(88);

module.exports = function clean(str) {
  return trim(str).replace(/\s\s+/g, ' ');
};


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function(str, substr) {
  str = makeString(str);
  substr = makeString(substr);

  if (str.length === 0 || substr.length === 0) return 0;
  
  return str.split(substr).length - 1;
};


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function swapCase(str) {
  return makeString(str).replace(/\S/g, function(c) {
    return c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase();
  });
};


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);
var escapeChars = __webpack_require__(745);

var regexString = '[';
for(var key in escapeChars) {
  regexString += key;
}
regexString += ']';

var regex = new RegExp( regexString, 'g');

module.exports = function escapeHTML(str) {

  return makeString(str).replace(regex, function(m) {
    return '&' + escapeChars[m] + ';';
  });
};


/***/ }),
/* 745 */
/***/ (function(module, exports) {

/* We're explicitly defining the list of entities we want to escape.
nbsp is an HTML entity, but we don't want to escape all space characters in a string, hence its omission in this map.

*/
var escapeChars = {
  '¢' : 'cent',
  '£' : 'pound',
  '¥' : 'yen',
  '€': 'euro',
  '©' :'copy',
  '®' : 'reg',
  '<' : 'lt',
  '>' : 'gt',
  '"' : 'quot',
  '&' : 'amp',
  '\'' : '#39'
};

module.exports = escapeChars;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);
var htmlEntities = __webpack_require__(747);

module.exports = function unescapeHTML(str) {
  return makeString(str).replace(/\&([^;]{1,10});/g, function(entity, entityCode) {
    var match;

    if (entityCode in htmlEntities) {
      return htmlEntities[entityCode];
    /*eslint no-cond-assign: 0*/
    } else if (match = entityCode.match(/^#x([\da-fA-F]+)$/)) {
      return String.fromCharCode(parseInt(match[1], 16));
    /*eslint no-cond-assign: 0*/
    } else if (match = entityCode.match(/^#(\d+)$/)) {
      return String.fromCharCode(~~match[1]);
    } else {
      return entity;
    }
  });
};


/***/ }),
/* 747 */
/***/ (function(module, exports) {

/*
We're explicitly defining the list of entities that might see in escape HTML strings
*/
var htmlEntities = {
  nbsp: ' ',
  cent: '¢',
  pound: '£',
  yen: '¥',
  euro: '€',
  copy: '©',
  reg: '®',
  lt: '<',
  gt: '>',
  quot: '"',
  amp: '&',
  apos: '\''
};

module.exports = htmlEntities;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var splice = __webpack_require__(379);

module.exports = function insert(str, i, substr) {
  return splice(str, i, 0, substr);
};


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function replaceAll(str, find, replace, ignorecase) {
  var flags = (ignorecase === true)?'gi':'g';
  var reg = new RegExp(find, flags);

  return makeString(str).replace(reg, replace);
};


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function include(str, needle) {
  if (needle === '') return true;
  return makeString(str).indexOf(needle) !== -1;
};


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);
var slice = [].slice;

module.exports = function join() {
  var args = slice.call(arguments),
    separator = args.shift();

  return args.join(makeString(separator));
};


/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = function lines(str) {
  if (str == null) return [];
  return String(str).split(/\r\n?|\n/);
};


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

function getIndent(str) {
  var matches = str.match(/^[\s\\t]*/gm);
  var indent = matches[0].length;
  
  for (var i = 1; i < matches.length; i++) {
    indent = Math.min(matches[i].length, indent);
  }

  return indent;
}

module.exports = function dedent(str, pattern) {
  str = makeString(str);
  var indent = getIndent(str);
  var reg;

  if (indent === 0) return str;

  if (typeof pattern === 'string') {
    reg = new RegExp('^' + pattern, 'gm');
  } else {
    reg = new RegExp('^[ \\t]{' + indent + '}', 'gm');
  }

  return str.replace(reg, '');
};


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var chars = __webpack_require__(258);

module.exports = function reverse(str) {
  return chars(str).reverse().join('');
};


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);
var toPositive = __webpack_require__(380);

module.exports = function startsWith(str, starts, position) {
  str = makeString(str);
  starts = '' + starts;
  position = position == null ? 0 : Math.min(toPositive(position), str.length);
  return str.lastIndexOf(starts, position) === position;
};


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);
var toPositive = __webpack_require__(380);

module.exports = function endsWith(str, ends, position) {
  str = makeString(str);
  ends = '' + ends;
  if (typeof position == 'undefined') {
    position = str.length - ends.length;
  } else {
    position = Math.min(toPositive(position), str.length) - ends.length;
  }
  return position >= 0 && str.indexOf(ends, position) === position;
};


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var adjacent = __webpack_require__(381);

module.exports = function succ(str) {
  return adjacent(str, -1);
};


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var adjacent = __webpack_require__(381);

module.exports = function succ(str) {
  return adjacent(str, 1);
};


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function titleize(str) {
  return makeString(str).toLowerCase().replace(/(?:^|\s|-)\S/g, function(c) {
    return c.toUpperCase();
  });
};


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var capitalize = __webpack_require__(256);
var camelize = __webpack_require__(382);
var makeString = __webpack_require__(22);

module.exports = function classify(str) {
  str = makeString(str);
  return capitalize(camelize(str.replace(/[\W_]/g, ' ')).replace(/\s/g, ''));
};


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var capitalize = __webpack_require__(256);
var underscored = __webpack_require__(383);
var trim = __webpack_require__(88);

module.exports = function humanize(str) {
  return capitalize(trim(underscored(str).replace(/_id$/, '').replace(/_/g, ' ')));
};


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);
var defaultToWhiteSpace = __webpack_require__(257);
var nativeTrimLeft = String.prototype.trimLeft;

module.exports = function ltrim(str, characters) {
  str = makeString(str);
  if (!characters && nativeTrimLeft) return nativeTrimLeft.call(str);
  characters = defaultToWhiteSpace(characters);
  return str.replace(new RegExp('^' + characters + '+'), '');
};


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function truncate(str, length, truncateStr) {
  str = makeString(str);
  truncateStr = truncateStr || '...';
  length = ~~length;
  return str.length > length ? str.slice(0, length) + truncateStr : str;
};


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * _s.prune: a more elegant version of truncate
 * prune extra chars, never leaving a half-chopped word.
 * @author github.com/rwz
 */
var makeString = __webpack_require__(22);
var rtrim = __webpack_require__(259);

module.exports = function prune(str, length, pruneStr) {
  str = makeString(str);
  length = ~~length;
  pruneStr = pruneStr != null ? String(pruneStr) : '...';

  if (str.length <= length) return str;

  var tmpl = function(c) {
      return c.toUpperCase() !== c.toLowerCase() ? 'A' : ' ';
    },
    template = str.slice(0, length + 1).replace(/.(?=\W*\w*$)/g, tmpl); // 'Hello, world' -> 'HellAA AAAAA'

  if (template.slice(template.length - 2).match(/\w\w/))
    template = template.replace(/\s*\S+$/, '');
  else
    template = rtrim(template.slice(0, template.length - 1));

  return (template + pruneStr).length > str.length ? str : str.slice(0, template.length) + pruneStr;
};


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var isBlank = __webpack_require__(375);
var trim = __webpack_require__(88);

module.exports = function words(str, delimiter) {
  if (isBlank(str)) return [];
  return trim(str, delimiter).split(delimiter || /\s+/);
};


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var pad = __webpack_require__(193);

module.exports = function lpad(str, length, padStr) {
  return pad(str, length, padStr);
};


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var pad = __webpack_require__(193);

module.exports = function rpad(str, length, padStr) {
  return pad(str, length, padStr, 'right');
};


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var pad = __webpack_require__(193);

module.exports = function lrpad(str, length, padStr) {
  return pad(str, length, padStr, 'both');
};


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var deprecate = __webpack_require__(260);

module.exports = deprecate(__webpack_require__(386).sprintf,
  'sprintf() will be removed in the next major release, use the sprintf-js package instead.');


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var deprecate = __webpack_require__(260);

module.exports = deprecate(__webpack_require__(386).vsprintf,
  'vsprintf() will be removed in the next major release, use the sprintf-js package instead.');


/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = function toNumber(num, precision) {
  if (num == null) return 0;
  var factor = Math.pow(10, isFinite(precision) ? precision : 0);
  return Math.round(num * factor) / factor;
};


/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = function numberFormat(number, dec, dsep, tsep) {
  if (isNaN(number) || number == null) return '';

  number = number.toFixed(~~dec);
  tsep = typeof tsep == 'string' ? tsep : ',';

  var parts = number.split('.'),
    fnums = parts[0],
    decimals = parts[1] ? (dsep || '.') + parts[1] : '';

  return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + tsep) + decimals;
};


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function strRight(str, sep) {
  str = makeString(str);
  sep = makeString(sep);
  var pos = !sep ? -1 : str.indexOf(sep);
  return~ pos ? str.slice(pos + sep.length, str.length) : str;
};


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function strRightBack(str, sep) {
  str = makeString(str);
  sep = makeString(sep);
  var pos = !sep ? -1 : str.lastIndexOf(sep);
  return~ pos ? str.slice(pos + sep.length, str.length) : str;
};


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function strLeft(str, sep) {
  str = makeString(str);
  sep = makeString(sep);
  var pos = !sep ? -1 : str.indexOf(sep);
  return~ pos ? str.slice(0, pos) : str;
};


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function strLeftBack(str, sep) {
  str = makeString(str);
  sep = makeString(sep);
  var pos = str.lastIndexOf(sep);
  return~ pos ? str.slice(0, pos) : str;
};


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var toSentence = __webpack_require__(387);

module.exports = function toSentenceSerial(array, sep, lastSep) {
  return toSentence(array, sep, lastSep, true);
};


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(88);
var dasherize = __webpack_require__(384);
var cleanDiacritics = __webpack_require__(378);

module.exports = function slugify(str) {
  return trim(dasherize(cleanDiacritics(str).replace(/[^\w\s-]/g, '-').toLowerCase()), '-');
};


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var surround = __webpack_require__(388);

module.exports = function quote(str, quoteChar) {
  return surround(str, quoteChar || '"');
};


/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = function unquote(str, quoteChar) {
  quoteChar = quoteChar || '"';
  if (str[0] === quoteChar && str[str.length - 1] === quoteChar)
    return str.slice(1, str.length - 1);
  else return str;
};


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);
var strRepeat = __webpack_require__(385);

module.exports = function repeat(str, qty, separator) {
  str = makeString(str);

  qty = ~~qty;

  // using faster implementation if separator is not needed;
  if (separator == null) return strRepeat(str, qty);

  // this one is about 300x slower in Google Chrome
  /*eslint no-empty: 0*/
  for (var repeat = []; qty > 0; repeat[--qty] = str) {}
  return repeat.join(separator);
};


/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = function naturalCmp(str1, str2) {
  if (str1 == str2) return 0;
  if (!str1) return -1;
  if (!str2) return 1;

  var cmpRegex = /(\.\d+|\d+|\D+)/g,
    tokens1 = String(str1).match(cmpRegex),
    tokens2 = String(str2).match(cmpRegex),
    count = Math.min(tokens1.length, tokens2.length);

  for (var i = 0; i < count; i++) {
    var a = tokens1[i],
      b = tokens2[i];

    if (a !== b) {
      var num1 = +a;
      var num2 = +b;
      if (num1 === num1 && num2 === num2) {
        return num1 > num2 ? 1 : -1;
      }
      return a < b ? -1 : 1;
    }
  }

  if (tokens1.length != tokens2.length)
    return tokens1.length - tokens2.length;

  return str1 < str2 ? -1 : 1;
};


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

/**
 * Based on the implementation here: https://github.com/hiddentao/fast-levenshtein
 */
module.exports = function levenshtein(str1, str2) {
  'use strict';
  str1 = makeString(str1);
  str2 = makeString(str2);

  // Short cut cases  
  if (str1 === str2) return 0;
  if (!str1 || !str2) return Math.max(str1.length, str2.length);

  // two rows
  var prevRow = new Array(str2.length + 1);

  // initialise previous row
  for (var i = 0; i < prevRow.length; ++i) {
    prevRow[i] = i;
  }

  // calculate current row distance from previous row
  for (i = 0; i < str1.length; ++i) {
    var nextCol = i + 1;

    for (var j = 0; j < str2.length; ++j) {
      var curCol = nextCol;

      // substution
      nextCol = prevRow[j] + ( (str1.charAt(i) === str2.charAt(j)) ? 0 : 1 );
      // insertion
      var tmp = curCol + 1;
      if (nextCol > tmp) {
        nextCol = tmp;
      }
      // deletion
      tmp = prevRow[j + 1] + 1;
      if (nextCol > tmp) {
        nextCol = tmp;
      }

      // copy current col value into previous (in preparation for next iteration)
      prevRow[j] = curCol;
    }

    // copy last col value into previous (in preparation for next iteration)
    prevRow[j] = nextCol;
  }

  return nextCol;
};


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(88);

function boolMatch(s, matchers) {
  var i, matcher, down = s.toLowerCase();
  matchers = [].concat(matchers);
  for (i = 0; i < matchers.length; i += 1) {
    matcher = matchers[i];
    if (!matcher) continue;
    if (matcher.test && matcher.test(s)) return true;
    if (matcher.toLowerCase() === down) return true;
  }
}

module.exports = function toBoolean(str, trueValues, falseValues) {
  if (typeof str === 'number') str = '' + str;
  if (typeof str !== 'string') return !!str;
  str = trim(str);
  if (boolMatch(str, trueValues || ['true', '1'])) return true;
  if (boolMatch(str, falseValues || ['false', '0'])) return false;
};


/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = function() {
  var result = {};

  for (var prop in this) {
    if (!this.hasOwnProperty(prop) || prop.match(/^(?:include|contains|reverse|join|map|wrap)$/)) continue;
    result[prop] = this[prop];
  }

  return result;
};


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

// Wrap
// wraps a string by a certain width

var makeString = __webpack_require__(22);

module.exports = function wrap(str, options){
  str = makeString(str);
  
  options = options || {};
  
  var width = options.width || 75;
  var seperator = options.seperator || '\n';
  var cut = options.cut || false;
  var preserveSpaces = options.preserveSpaces || false;
  var trailingSpaces = options.trailingSpaces || false;
  
  var result;
  
  if(width <= 0){
    return str;
  }
  
  else if(!cut){
  
    var words = str.split(' ');
    var current_column = 0;
    result = '';
  
    while(words.length > 0){
      
      // if adding a space and the next word would cause this line to be longer than width...
      if(1 + words[0].length + current_column > width){
        //start a new line if this line is not already empty
        if(current_column > 0){
          // add a space at the end of the line is preserveSpaces is true
          if (preserveSpaces){
            result += ' ';
            current_column++;
          }
          // fill the rest of the line with spaces if trailingSpaces option is true
          else if(trailingSpaces){
            while(current_column < width){
              result += ' ';
              current_column++;
            }            
          }
          //start new line
          result += seperator;
          current_column = 0;
        }
      }
  
      // if not at the begining of the line, add a space in front of the word
      if(current_column > 0){
        result += ' ';
        current_column++;
      }
  
      // tack on the next word, update current column, a pop words array
      result += words[0];
      current_column += words[0].length;
      words.shift();
  
    }
  
    // fill the rest of the line with spaces if trailingSpaces option is true
    if(trailingSpaces){
      while(current_column < width){
        result += ' ';
        current_column++;
      }            
    }
  
    return result;
  
  }
  
  else {
  
    var index = 0;
    result = '';
  
    // walk through each character and add seperators where appropriate
    while(index < str.length){
      if(index % width == 0 && index > 0){
        result += seperator;
      }
      result += str.charAt(index);
      index++;
    }
  
    // fill the rest of the line with spaces if trailingSpaces option is true
    if(trailingSpaces){
      while(index % width > 0){
        result += ' ';
        index++;
      }            
    }
    
    return result;
  }
};


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var makeString = __webpack_require__(22);

module.exports = function(str, callback) {
  str = makeString(str);

  if (str.length === 0 || typeof callback !== 'function') return str;

  return str.replace(/./g, callback);
};


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	'use strict';

	// AMDJS module definition
	if ( "function" === 'function' && __webpack_require__(261) && __webpack_require__(261).jQuery ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(194)], __WEBPACK_AMD_DEFINE_RESULT__ = (function($) {
			return factory($, root);
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	// CommonJS module definition
	} else if ( true) {

		// NOTE: To use Mockjax as a Node module you MUST provide the factory with
		// a valid version of jQuery and a window object (the global scope):
		// var mockjax = require('jquery.mockjax')(jQuery, window);

		module.exports = factory;

	// Global jQuery in web browsers
	} else {
		return factory(root.jQuery || root.$, root);
	}
}(this, function($, window) {
	'use strict';

	var _ajax = $.ajax,
		mockHandlers = [],
		mockedAjaxCalls = [],
		unmockedAjaxCalls = [],
		CALLBACK_REGEX = /=\?(&|$)/,
		jsc = (new Date()).getTime(),
		DEFAULT_RESPONSE_TIME = 500;

	// Parse the given XML string.
	function parseXML(xml) {
		if ( window.DOMParser === undefined && window.ActiveXObject ) {
			window.DOMParser = function() { };
			DOMParser.prototype.parseFromString = function( xmlString ) {
				var doc = new ActiveXObject('Microsoft.XMLDOM');
				doc.async = 'false';
				doc.loadXML( xmlString );
				return doc;
			};
		}

		try {
			var xmlDoc = ( new DOMParser() ).parseFromString( xml, 'text/xml' );
			if ( $.isXMLDoc( xmlDoc ) ) {
				var err = $('parsererror', xmlDoc);
				if ( err.length === 1 ) {
					throw new Error('Error: ' + $(xmlDoc).text() );
				}
			} else {
				throw new Error('Unable to parse XML');
			}
			return xmlDoc;
		} catch( e ) {
			var msg = ( e.name === undefined ? e : e.name + ': ' + e.message );
			$(document).trigger('xmlParseError', [ msg ]);
			return undefined;
		}
	}

	// Check if the data field on the mock handler and the request match. This
	// can be used to restrict a mock handler to being used only when a certain
	// set of data is passed to it.
	function isMockDataEqual( mock, live ) {
		logger.debug( mock, ['Checking mock data against request data', mock, live] );
		var identical = true;

		if ( $.isFunction(mock) ) {
			return !!mock(live);
		}

		// Test for situations where the data is a querystring (not an object)
		if (typeof live === 'string') {
			// Querystring may be a regex
			if ($.isFunction( mock.test )) {
				return mock.test(live);
			} else if (typeof mock === 'object') {
				live = getQueryParams(live);
			} else {
				return mock === live;
			}
		}

		$.each(mock, function(k) {
			if ( live[k] === undefined ) {
				identical = false;
				return identical;
			} else {
				if ( typeof live[k] === 'object' && live[k] !== null ) {
					if ( identical && $.isArray( live[k] ) ) {
						identical = $.isArray( mock[k] ) && live[k].length === mock[k].length;
					}
					identical = identical && isMockDataEqual(mock[k], live[k]);
				} else {
					if ( mock[k] && $.isFunction( mock[k].test ) ) {
						identical = identical && mock[k].test(live[k]);
					} else {
						identical = identical && ( mock[k] === live[k] );
					}
				}
			}
		});

		return identical;
	}

	function getQueryParams(queryString) {
		var i, l, param, tmp,
			paramsObj = {},
			params = String(queryString).split(/&/);

		for (i=0, l=params.length; i<l; ++i) {
			param = params[i];
			try {
				param = decodeURIComponent(param.replace(/\+/g, ' '));
				param = param.split(/=/);
			} catch(e) {
				// Can't parse this one, so let it go?
				continue;
			}

			if (paramsObj[param[0]]) {
				// this is an array query param (more than one entry in query)
				if (!paramsObj[param[0]].splice) {
					// if not already an array, make it one
					tmp = paramsObj[param[0]];
					paramsObj[param[0]] = [];
					paramsObj[param[0]].push(tmp);
				}
				paramsObj[param[0]].push(param[1]);
			} else {
				paramsObj[param[0]] = param[1];
			}
		}

		logger.debug( null, ['Getting query params from string', queryString, paramsObj] );

		return paramsObj;
	}

	// See if a mock handler property matches the default settings
	function isDefaultSetting(handler, property) {
		return handler[property] === $.mockjaxSettings[property];
	}

	// Check the given handler should mock the given request
	function getMockForRequest( handler, requestSettings ) {
		// If the mock was registered with a function, let the function decide if we
		// want to mock this request
		if ( $.isFunction(handler) ) {
			return handler( requestSettings );
		}

		// Inspect the URL of the request and check if the mock handler's url
		// matches the url for this ajax request
		if ( $.isFunction(handler.url.test) ) {
			// The user provided a regex for the url, test it
			if ( !handler.url.test( requestSettings.url ) ) {
				return null;
			}
		} else {

			var effecitveUrl = handler.url;

			// Apply namespace prefix to the mock handler's url.
			var namespace = handler.namespace || (typeof(handler.namespace) === 'undefined' && $.mockjaxSettings.namespace);

			if (!!namespace) {
				var namespacedUrl = [
					namespace.replace(/(\/+)$/, ''),
					handler.url.replace(/^(\/+)/, '')
				].join('/');
				effecitveUrl = namespacedUrl;
			}

			// Look for a simple wildcard '*' or a direct URL match
			var star = effecitveUrl.indexOf('*');
			if (effecitveUrl !== requestSettings.url && star === -1 ||
					!new RegExp(effecitveUrl.replace(/[-[\]{}()+?.,\\^$|#\s]/g, '\\$&').replace(/\*/g, '.+')).test(requestSettings.url)) {
				return null;
			}
		}

		// Inspect the request headers submitted
		if ( handler.requestHeaders ) {
			//No expectation for headers, do not mock this request
			if (requestSettings.headers === undefined) {
				return null;
			} else {
				var headersMismatch = false;
				$.each(handler.requestHeaders, function(key, value) {
					var v = requestSettings.headers[key];
					if(v !== value) {
						headersMismatch = true;
						return false;
					}
				});
				//Headers do not match, do not mock this request
				if (headersMismatch) {
					return null;
				}
			}
		}

		// Inspect the data submitted in the request (either POST body or GET query string)
		if ( handler.data ) {
			if ( !requestSettings.data || !isMockDataEqual(handler.data, requestSettings.data) ) {
				// They're not identical, do not mock this request
				return null;
			}
		}
		// Inspect the request type
		if ( handler && handler.type &&
				handler.type.toLowerCase() !== requestSettings.type.toLowerCase() ) {
			// The request type doesn't match (GET vs. POST)
			return null;
		}

		return handler;
	}

	function isPosNum(value) {
		return typeof value === 'number' && value >= 0;
	}

	function parseResponseTimeOpt(responseTime) {
		if ($.isArray(responseTime) && responseTime.length === 2) {
			var min = responseTime[0];
			var max = responseTime[1];
			if(isPosNum(min) && isPosNum(max)) {
				return Math.floor(Math.random() * (max - min)) + min;
			}
		} else if(isPosNum(responseTime)) {
			return responseTime;
		}
		return DEFAULT_RESPONSE_TIME;
	}

	// Process the xhr objects send operation
	function _xhrSend(mockHandler, requestSettings, origSettings) {
		logger.debug( mockHandler, ['Sending fake XHR request', mockHandler, requestSettings, origSettings] );

		// This is a substitute for < 1.4 which lacks $.proxy
		var process = (function(that) {
			return function() {
				return (function() {
					// The request has returned
					this.status = mockHandler.status;
					this.statusText = mockHandler.statusText;
					this.readyState	= 1;

					var finishRequest = function () {
						this.readyState	= 4;

						var onReady;
						// Copy over our mock to our xhr object before passing control back to
						// jQuery's onreadystatechange callback
						if ( requestSettings.dataType === 'json' && ( typeof mockHandler.responseText === 'object' ) ) {
							this.responseText = JSON.stringify(mockHandler.responseText);
						} else if ( requestSettings.dataType === 'xml' ) {
							if ( typeof mockHandler.responseXML === 'string' ) {
								this.responseXML = parseXML(mockHandler.responseXML);
								//in jQuery 1.9.1+, responseXML is processed differently and relies on responseText
								this.responseText = mockHandler.responseXML;
							} else {
								this.responseXML = mockHandler.responseXML;
							}
						} else if (typeof mockHandler.responseText === 'object' && mockHandler.responseText !== null) {
							// since jQuery 1.9 responseText type has to match contentType
							mockHandler.contentType = 'application/json';
							this.responseText = JSON.stringify(mockHandler.responseText);
						} else {
							this.responseText = mockHandler.responseText;
						}

						if ($.isArray(mockHandler.status)) {
							var idxStatus = Math.floor(Math.random() * mockHandler.status.length);
							this.status = mockHandler.status[idxStatus];
						} else if (typeof mockHandler.status === 'number' || typeof mockHandler.status === 'string') {
							this.status = mockHandler.status;
						}

						if( typeof mockHandler.statusText === 'string') {
							this.statusText = mockHandler.statusText;
						}
						// jQuery 2.0 renamed onreadystatechange to onload
						onReady = this.onload || this.onreadystatechange;

						// jQuery < 1.4 doesn't have onreadystate change for xhr
						if ( $.isFunction( onReady ) ) {
							if( mockHandler.isTimeout) {
								this.status = -1;
							}
							onReady.call( this, mockHandler.isTimeout ? 'timeout' : undefined );
						} else if ( mockHandler.isTimeout ) {
							// Fix for 1.3.2 timeout to keep success from firing.
							this.status = -1;
						}
					};

					// We have an executable function, call it to give
					// the mock handler a chance to update it's data
					if ( $.isFunction(mockHandler.response) ) {
						// Wait for it to finish
						if ( mockHandler.response.length === 2 ) {
							mockHandler.response(origSettings, function () {
								finishRequest.call(that);
							});
							return;
						} else {
							mockHandler.response(origSettings);
						}
					}

					finishRequest.call(that);
				}).apply(that);
			};
		})(this);

		if ( mockHandler.proxy ) {
			logger.info( mockHandler, ['Retrieving proxy file: ' + mockHandler.proxy, mockHandler] );
			// We're proxying this request and loading in an external file instead
			_ajax({
				global: false,
				url: mockHandler.proxy,
				type: mockHandler.proxyType,
				data: mockHandler.data,
				async: requestSettings.async,
				dataType: requestSettings.dataType === 'script' ? 'text/plain' : requestSettings.dataType,
				complete: function(xhr) {
					// Fix for bug #105
					// jQuery will convert the text to XML for us, and if we use the actual responseXML here
					// then some other things don't happen, resulting in no data given to the 'success' cb
					mockHandler.responseXML = mockHandler.responseText = xhr.responseText;

					// Don't override the handler status/statusText if it's specified by the config
					if (isDefaultSetting(mockHandler, 'status')) {
						mockHandler.status = xhr.status;
					}
					if (isDefaultSetting(mockHandler, 'statusText')) {
						mockHandler.statusText = xhr.statusText;
					}

					if ( requestSettings.async === false ) {
						// TODO: Blocking delay
						process();
					} else {
						this.responseTimer = setTimeout(process, parseResponseTimeOpt(mockHandler.responseTime));
					}
				}
			});
		} else {
			// type === 'POST' || 'GET' || 'DELETE'
			if ( requestSettings.async === false ) {
				// TODO: Blocking delay
				process();
			} else {
				this.responseTimer = setTimeout(process, parseResponseTimeOpt(mockHandler.responseTime));
			}
		}

	}

	// Construct a mocked XHR Object
	function xhr(mockHandler, requestSettings, origSettings, origHandler) {
		logger.debug( mockHandler, ['Creating new mock XHR object', mockHandler, requestSettings, origSettings, origHandler] );

		// Extend with our default mockjax settings
		mockHandler = $.extend(true, {}, $.mockjaxSettings, mockHandler);

		if (typeof mockHandler.headers === 'undefined') {
			mockHandler.headers = {};
		}
		if (typeof requestSettings.headers === 'undefined') {
			requestSettings.headers = {};
		}
		if ( mockHandler.contentType ) {
			mockHandler.headers['content-type'] = mockHandler.contentType;
		}

		return {
			status: mockHandler.status,
			statusText: mockHandler.statusText,
			readyState: 1,
			open: function() { },
			send: function() {
				origHandler.fired = true;
				_xhrSend.call(this, mockHandler, requestSettings, origSettings);
			},
			abort: function() {
				clearTimeout(this.responseTimer);
			},
			setRequestHeader: function(header, value) {
				requestSettings.headers[header] = value;
			},
			getResponseHeader: function(header) {
				// 'Last-modified', 'Etag', 'content-type' are all checked by jQuery
				if ( mockHandler.headers && mockHandler.headers[header] ) {
					// Return arbitrary headers
					return mockHandler.headers[header];
				} else if ( header.toLowerCase() === 'last-modified' ) {
					return mockHandler.lastModified || (new Date()).toString();
				} else if ( header.toLowerCase() === 'etag' ) {
					return mockHandler.etag || '';
				} else if ( header.toLowerCase() === 'content-type' ) {
					return mockHandler.contentType || 'text/plain';
				}
			},
			getAllResponseHeaders: function() {
				var headers = '';
				// since jQuery 1.9 responseText type has to match contentType
				if (mockHandler.contentType) {
					mockHandler.headers['Content-Type'] = mockHandler.contentType;
				}
				$.each(mockHandler.headers, function(k, v) {
					headers += k + ': ' + v + '\n';
				});
				return headers;
			}
		};
	}

	// Process a JSONP mock request.
	function processJsonpMock( requestSettings, mockHandler, origSettings ) {
		// Handle JSONP Parameter Callbacks, we need to replicate some of the jQuery core here
		// because there isn't an easy hook for the cross domain script tag of jsonp

		processJsonpUrl( requestSettings );

		requestSettings.dataType = 'json';
		if(requestSettings.data && CALLBACK_REGEX.test(requestSettings.data) || CALLBACK_REGEX.test(requestSettings.url)) {
			createJsonpCallback(requestSettings, mockHandler, origSettings);

			// We need to make sure
			// that a JSONP style response is executed properly

			var rurl = /^(\w+:)?\/\/([^\/?#]+)/,
				parts = rurl.exec( requestSettings.url ),
				remote = parts && (parts[1] && parts[1] !== location.protocol || parts[2] !== location.host);

			requestSettings.dataType = 'script';
			if(requestSettings.type.toUpperCase() === 'GET' && remote ) {
				var newMockReturn = processJsonpRequest( requestSettings, mockHandler, origSettings );

				// Check if we are supposed to return a Deferred back to the mock call, or just
				// signal success
				if(newMockReturn) {
					return newMockReturn;
				} else {
					return true;
				}
			}
		}
		return null;
	}

	// Append the required callback parameter to the end of the request URL, for a JSONP request
	function processJsonpUrl( requestSettings ) {
		if ( requestSettings.type.toUpperCase() === 'GET' ) {
			if ( !CALLBACK_REGEX.test( requestSettings.url ) ) {
				requestSettings.url += (/\?/.test( requestSettings.url ) ? '&' : '?') +
					(requestSettings.jsonp || 'callback') + '=?';
			}
		} else if ( !requestSettings.data || !CALLBACK_REGEX.test(requestSettings.data) ) {
			requestSettings.data = (requestSettings.data ? requestSettings.data + '&' : '') + (requestSettings.jsonp || 'callback') + '=?';
		}
	}

	// Process a JSONP request by evaluating the mocked response text
	function processJsonpRequest( requestSettings, mockHandler, origSettings ) {
		logger.debug( mockHandler, ['Performing JSONP request', mockHandler, requestSettings, origSettings] );

		// Synthesize the mock request for adding a script tag
		var callbackContext = origSettings && origSettings.context || requestSettings,
			// If we are running under jQuery 1.5+, return a deferred object
			newMock = ($.Deferred) ? (new $.Deferred()) : null;

		// If the response handler on the moock is a function, call it
		if ( mockHandler.response && $.isFunction(mockHandler.response) ) {

			mockHandler.response(origSettings);


		} else if ( typeof mockHandler.responseText === 'object' ) {
			// Evaluate the responseText javascript in a global context
			$.globalEval( '(' + JSON.stringify( mockHandler.responseText ) + ')');

		} else if (mockHandler.proxy) {
			logger.info( mockHandler, ['Performing JSONP proxy request: ' + mockHandler.proxy, mockHandler] );

			// This handles the unique case where we have a remote URL, but want to proxy the JSONP
			// response to another file (not the same URL as the mock matching)
			_ajax({
				global: false,
				url: mockHandler.proxy,
				type: mockHandler.proxyType,
				data: mockHandler.data,
				dataType: requestSettings.dataType === 'script' ? 'text/plain' : requestSettings.dataType,
				complete: function(xhr) {
					$.globalEval( '(' + xhr.responseText + ')');
					completeJsonpCall( requestSettings, mockHandler, callbackContext, newMock );
				}
			});

			return newMock;

		} else {
			$.globalEval( '(' +
				((typeof mockHandler.responseText === 'string') ?
					('"' + mockHandler.responseText + '"') : mockHandler.responseText) +
			')');
		}

		completeJsonpCall( requestSettings, mockHandler, callbackContext, newMock );

		return newMock;
	}

	function completeJsonpCall( requestSettings, mockHandler, callbackContext, newMock ) {
		var json;

		// Successful response
		setTimeout(function() {
			jsonpSuccess( requestSettings, callbackContext, mockHandler );
			jsonpComplete( requestSettings, callbackContext );

			if ( newMock ) {
				try {
					json = $.parseJSON( mockHandler.responseText );
				} catch (err) { /* just checking... */ }

				newMock.resolveWith( callbackContext, [json || mockHandler.responseText] );
				logger.log( mockHandler, ['JSONP mock call complete', mockHandler, newMock] );
			}
		}, parseResponseTimeOpt( mockHandler.responseTime ));
	}


	// Create the required JSONP callback function for the request
	function createJsonpCallback( requestSettings, mockHandler, origSettings ) {
		var callbackContext = origSettings && origSettings.context || requestSettings;
		var jsonp = (typeof requestSettings.jsonpCallback === 'string' && requestSettings.jsonpCallback) || ('jsonp' + jsc++);

		// Replace the =? sequence both in the query string and the data
		if ( requestSettings.data ) {
			requestSettings.data = (requestSettings.data + '').replace(CALLBACK_REGEX, '=' + jsonp + '$1');
		}

		requestSettings.url = requestSettings.url.replace(CALLBACK_REGEX, '=' + jsonp + '$1');


		// Handle JSONP-style loading
		window[ jsonp ] = window[ jsonp ] || function() {
			jsonpSuccess( requestSettings, callbackContext, mockHandler );
			jsonpComplete( requestSettings, callbackContext );
			// Garbage collect
			window[ jsonp ] = undefined;

			try {
				delete window[ jsonp ];
			} catch(e) {}
		};
		requestSettings.jsonpCallback = jsonp;
	}

	// The JSONP request was successful
	function jsonpSuccess(requestSettings, callbackContext, mockHandler) {
		// If a local callback was specified, fire it and pass it the data
		if ( requestSettings.success ) {
			requestSettings.success.call( callbackContext, mockHandler.responseText || '', 'success', {} );
		}

		// Fire the global callback
		if ( requestSettings.global ) {
			(requestSettings.context ? $(requestSettings.context) : $.event).trigger('ajaxSuccess', [{}, requestSettings]);
		}
	}

	// The JSONP request was completed
	function jsonpComplete(requestSettings, callbackContext) {
		if ( requestSettings.complete ) {
			requestSettings.complete.call( callbackContext, {
				statusText: 'success',
				status: 200
			} , 'success' );
		}

		// The request was completed
		if ( requestSettings.global ) {
			(requestSettings.context ? $(requestSettings.context) : $.event).trigger('ajaxComplete', [{}, requestSettings]);
		}

		// Handle the global AJAX counter
		if ( requestSettings.global && ! --$.active ) {
			$.event.trigger( 'ajaxStop' );
		}
	}


	// The core $.ajax replacement.
	function handleAjax( url, origSettings ) {
		var mockRequest, requestSettings, mockHandler, overrideCallback;

		logger.debug( null, ['Ajax call intercepted', url, origSettings] );

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === 'object' ) {
			origSettings = url;
			url = undefined;
		} else {
			// work around to support 1.5 signature
			origSettings = origSettings || {};
			origSettings.url = url || origSettings.url;
		}

		// Extend the original settings for the request
		requestSettings = $.ajaxSetup({}, origSettings);
		requestSettings.type = requestSettings.method = requestSettings.method || requestSettings.type;

		// Generic function to override callback methods for use with
		// callback options (onAfterSuccess, onAfterError, onAfterComplete)
		overrideCallback = function(action, mockHandler) {
			var origHandler = origSettings[action.toLowerCase()];
			return function() {
				if ( $.isFunction(origHandler) ) {
					origHandler.apply(this, [].slice.call(arguments));
				}
				mockHandler['onAfter' + action]();
			};
		};

		// Iterate over our mock handlers (in order depending on the matchInRegistrationOrder setting)
		// until we find one that is willing to intercept the request
		for(var k = 0; k < mockHandlers.length; k++) {
			var handlerIndex = $.mockjaxSettings.matchInRegistrationOrder ? k : mockHandlers.length - 1 - k;
			var origHandler = mockHandlers[handlerIndex];
			if ( !origHandler ) {
				continue;
			}

			mockHandler = getMockForRequest( origHandler, requestSettings );
			if(!mockHandler) {
				logger.debug( origHandler, ['Mock does not match request', url, requestSettings] );
				// No valid mock found for this request
				continue;
			}

			if ($.mockjaxSettings.retainAjaxCalls) {
				mockedAjaxCalls.push(requestSettings);
			}

			// If logging is enabled, log the mock to the console
			logger.info( mockHandler, [
				'MOCK ' + requestSettings.type.toUpperCase() + ': ' + requestSettings.url,
				$.ajaxSetup({}, requestSettings)
			] );

			if ((mockHandler.status === 301 || mockHandler.status === 302) &&
				(requestSettings.type.toUpperCase() === 'GET' || requestSettings.type.toUpperCase() === 'HEAD') &&
				mockHandler.headers.Location) {
				logger.debug('Doing mock redirect to', mockHandler.headers.Location, requestSettings.type);

				var redirectSettings = {};
				var origKeys = Object.keys(origSettings);
				// We can't alter origSettings, so we need a shallow copy of it...
				for (var oi=0; oi<origKeys.length; oi++) {
					redirectSettings[origKeys[oi]] = origSettings[origKeys[oi]];
				}
				redirectSettings.url = mockHandler.headers.Location;
				redirectSettings.headers = {
					Referer: origSettings.url
				};

				return handleAjax(redirectSettings);
			}

			if ( requestSettings.dataType && requestSettings.dataType.toUpperCase() === 'JSONP' ) {
				if ((mockRequest = processJsonpMock( requestSettings, mockHandler, origSettings ))) {
					// This mock will handle the JSONP request
					return mockRequest;
				}
			}

			// We are mocking, so there will be no cross domain request, however, jQuery
			// aggressively pursues this if the domains don't match, so we need to
			// explicitly disallow it. (See #136)
			origSettings.crossDomain = false;

			// Removed to fix #54 - keep the mocking data object intact
			//mockHandler.data = requestSettings.data;

			mockHandler.cache = requestSettings.cache;
			mockHandler.timeout = requestSettings.timeout;
			mockHandler.global = requestSettings.global;

			// In the case of a timeout, we just need to ensure
			// an actual jQuery timeout (That is, our reponse won't)
			// return faster than the timeout setting.
			if ( mockHandler.isTimeout ) {
				if ( mockHandler.responseTime > 1 ) {
					origSettings.timeout = mockHandler.responseTime - 1;
				} else {
					mockHandler.responseTime = 2;
					origSettings.timeout = 1;
				}
			}

			// Set up onAfter[X] callback functions
			if ( $.isFunction( mockHandler.onAfterSuccess ) ) {
				origSettings.success = overrideCallback('Success', mockHandler);
			}
			if ( $.isFunction( mockHandler.onAfterError ) ) {
				origSettings.error = overrideCallback('Error', mockHandler);
			}
			if ( $.isFunction( mockHandler.onAfterComplete ) ) {
				origSettings.complete = overrideCallback('Complete', mockHandler);
			}

			copyUrlParameters(mockHandler, origSettings);

			/* jshint loopfunc:true */
			(function(mockHandler, requestSettings, origSettings, origHandler) {

				mockRequest = _ajax.call($, $.extend(true, {}, origSettings, {
					// Mock the XHR object
					xhr: function() { return xhr( mockHandler, requestSettings, origSettings, origHandler ); }
				}));
			})(mockHandler, requestSettings, origSettings, origHandler);
			/* jshint loopfunc:false */

			return mockRequest;
		}

		// We don't have a mock request
		logger.log( null, ['No mock matched to request', url, origSettings] );
		if ($.mockjaxSettings.retainAjaxCalls) {
			unmockedAjaxCalls.push(origSettings);
		}
		if($.mockjaxSettings.throwUnmocked === true) {
			throw new Error('AJAX not mocked: ' + origSettings.url);
		}
		else { // trigger a normal request
			logger.log('Real ajax call to', origSettings.url);
			return _ajax.apply($, [origSettings]);
		}
	}

	/**
	* Copies URL parameter values if they were captured by a regular expression
	* @param {Object} mockHandler
	* @param {Object} origSettings
	*/
	function copyUrlParameters(mockHandler, origSettings) {
		//parameters aren't captured if the URL isn't a RegExp
		if (!(mockHandler.url instanceof RegExp)) {
			return;
		}
		//if no URL params were defined on the handler, don't attempt a capture
		if (!mockHandler.hasOwnProperty('urlParams')) {
			return;
		}
		var captures = mockHandler.url.exec(origSettings.url);
		//the whole RegExp match is always the first value in the capture results
		if (captures.length === 1) {
			return;
		}
		captures.shift();
		//use handler params as keys and capture resuts as values
		var i = 0,
		capturesLength = captures.length,
		paramsLength = mockHandler.urlParams.length,
		//in case the number of params specified is less than actual captures
		maxIterations = Math.min(capturesLength, paramsLength),
		paramValues = {};
		for (i; i < maxIterations; i++) {
			var key = mockHandler.urlParams[i];
			paramValues[key] = captures[i];
		}
		origSettings.urlParams = paramValues;
	}

	/**
	 * Clears handlers that mock given url
	 * @param url
	 * @returns {Array}
	 */
	function clearByUrl(url) {
		var i, len,
			handler,
			results = [],
			match=url instanceof RegExp ?
				function(testUrl) { return url.test(testUrl); } :
				function(testUrl) { return url === testUrl; };
		for (i=0, len=mockHandlers.length; i<len; i++) {
			handler = mockHandlers[i];
			if (!match(handler.url)) {
				results.push(handler);
			} else {
				logger.log( handler, [
					'Clearing mock: ' + (handler && handler.url),
					handler
				] );
			}
		}
		return results;
	}


	// Public

	$.extend({
		ajax: handleAjax
	});

	var logger = {
		_log: function logger( mockHandler, args, level ) {
			var loggerLevel = $.mockjaxSettings.logging;
			if (mockHandler && typeof mockHandler.logging !== 'undefined') {
				loggerLevel = mockHandler.logging;
			}
			level = ( level === 0 ) ? level : ( level || logLevels.LOG );
			args = (args.splice) ? args : [ args ];

			// Is logging turned off for this mock or mockjax as a whole?
			// Or is this log message above the desired log level?
			if ( loggerLevel === false || loggerLevel < level ) {
				return;
			}

			if ( $.mockjaxSettings.log ) {
				return $.mockjaxSettings.log( mockHandler, args[1] || args[0] );
			} else if ( $.mockjaxSettings.logger && $.mockjaxSettings.logger[$.mockjaxSettings.logLevelMethods[level]] ) {
				return $.mockjaxSettings.logger[$.mockjaxSettings.logLevelMethods[level]].apply( $.mockjaxSettings.logger, args );
			}
		},
		/**
		 * Convenience method for logging a DEBUG level message
		 * @param  {Object} m  The mock handler in question
		 * @param  {Array|String|Object} a  The items to log
		 * @return {?}  Will return whatever the $.mockjaxSettings.logger method for this level would return (generally 'undefined')
		 */
		debug: function(m,a) { return logger._log(m,a,logLevels.DEBUG); },
		/**
		 * @see logger.debug
		 */
		log: function(m,a) { return logger._log(m,a,logLevels.LOG); },
		/**
		 * @see logger.debug
		 */
		info: function(m,a) { return logger._log(m,a,logLevels.INFO); },
		/**
		 * @see logger.debug
		 */
		warn: function(m,a) { return logger._log(m,a,logLevels.WARN); },
		/**
		 * @see logger.debug
		 */
		error: function(m,a) { return logger._log(m,a,logLevels.ERROR); }
	};

	var logLevels = {
		DEBUG: 4,
		LOG: 3,
		INFO: 2,
		WARN: 1,
		ERROR: 0
	};

	/**
	 * Default settings for mockjax. Some of these are used for defaults of
	 * individual mock handlers, and some are for the library as a whole.
	 * For individual mock handler settings, please see the README on the repo:
	 * https://github.com/jakerella/jquery-mockjax#api-methods.
	 * For Global settings see:
	 * https://github.com/jakerella/jquery-mockjax#globally-defining-mockjax-settings
	 *
	 * @type {Object}
	 */
	$.mockjaxSettings = {
		log:				null, // this is only here for historical purposes... use $.mockjaxSettings.logger
		logger:				window.console,
		logging:			2,
		logLevelMethods:	['error', 'warn', 'info', 'log', 'debug'],
		matchInRegistrationOrder: true,
		namespace:			null,
		status:				200,
		statusText:			'OK',
		responseTime:		DEFAULT_RESPONSE_TIME,
		isTimeout:			false,
		throwUnmocked:		false,
		retainAjaxCalls:	true,
		contentType:		'text/plain',
		response:			'',
		responseText:		'',
		responseXML:		'',
		proxy:				'',
		proxyType:			'GET',

		lastModified:		null,
		etag:				'',
		headers:			{
								etag: 'IJF@H#@923uf8023hFO@I#H#',
								'content-type' : 'text/plain'
							}
	};

	/**
	 * Create a new mock Ajax handler. When a mock handler is matched during a
	 * $.ajax() call this library will intercept that request and fake a response
	 * using the data and methods in the mock. You can see all settings in the
	 * README of the main repository:
	 * https://github.com/jakerella/jquery-mockjax#api-methods
	 *
	 * @param  {Object} settings The mock handelr settings: https://github.com/jakerella/jquery-mockjax#api-methods
	 * @return {Number}		  The id (index) of the mock handler suitable for clearing (see $.mockjax.clear())
	 */
	$.mockjax = function(settings) {
		// Multiple mocks.
		if ( $.isArray(settings) ) {
			return $.map(settings, function(s) {
				return $.mockjax(s);
			});
		}

		var i = mockHandlers.length;
		mockHandlers[i] = settings;
		logger.log( settings, ['Created new mock handler', settings] );
		return i;
	};

	$.mockjax._logger = logger;

	/**
	 * Remove an Ajax mock from those held in memory. This will prevent any
	 * future Ajax request mocking for matched requests.
	 * NOTE: Clearing a mock will not prevent the resolution of in progress requests
	 *
	 * @param  {Number|String|RegExp} i  OPTIONAL The mock to clear. If not provided, all mocks are cleared,
	 *                                   if a number it is the index in the in-memory cache. If a string or
	 *                                   RegExp, find a mock that matches that URL and clear it.
	 * @return {void}
	 */
	$.mockjax.clear = function(i) {
		if ( typeof i === 'string' || i instanceof RegExp) {
			mockHandlers = clearByUrl(i);
		} else if ( i || i === 0 ) {
			logger.log( mockHandlers[i], [
				'Clearing mock: ' + (mockHandlers[i] && mockHandlers[i].url),
				mockHandlers[i]
			] );
			mockHandlers[i] = null;
		} else {
			logger.log( null, 'Clearing all mocks' );
			mockHandlers = [];
		}
		mockedAjaxCalls = [];
		unmockedAjaxCalls = [];
	};

	/**
	 * By default all Ajax requests performed after loading Mockjax are recorded
	 * so that we can see which requests were mocked and which were not. This
	 * method allows the developer to clear those retained requests.
	 *
	 * @return {void}
	 */
	$.mockjax.clearRetainedAjaxCalls = function() {
		mockedAjaxCalls = [];
		unmockedAjaxCalls = [];
		logger.debug( null, 'Cleared retained ajax calls' );
	};

	/**
	 * Retrive the mock handler with the given id (index).
	 *
	 * @param  {Number} i  The id (index) to retrieve
	 * @return {Object}	The mock handler settings
	 */
	$.mockjax.handler = function(i) {
		if ( arguments.length === 1 ) {
			return mockHandlers[i];
		}
	};

	/**
	 * Retrieve the current array of mock handlers.
	 * NOTE: Altering these handlers, or the array itself is probably not a good
	 * idea! This could easily lead to malfunction of the library. If you need
	 * to alter a handler, clear(index) it (using the array index) and then
	 * create a new handler with $.mockjax({ ... })
	 *
	 * **WARNING**: Additionally, note that the handlers array WILL NOT CHANGE
	 * when a mock is cleared. This is because we have to maintain the handler
	 * indeces for clearing of other mock handlers. (This is not ideal, and
	 * will probably change in the future.) Cleared mocks are set to null!
	 *
 	 * @return {Array} The current collection of handlers
	 */
	$.mockjax.handlers = function() {
		return mockHandlers;
	};

	/**
	 * Retrieve all Ajax calls that have been mocked by this library during the
	 * current session (in other words, only since you last loaded this file).
	 *
	 * @return {Array}  The mocked Ajax calls (request settings)
	 */
	$.mockjax.mockedAjaxCalls = function() {
		return mockedAjaxCalls;
	};

	/**
	 * Return all mock handlers that have NOT been matched against Ajax requests
	 *
	 * @return {Array}  The mock handlers
	 */
	$.mockjax.unfiredHandlers = function() {
		var results = [];
		for (var i=0, len=mockHandlers.length; i<len; i++) {
			var handler = mockHandlers[i];
			if (handler !== null && !handler.fired) {
				results.push(handler);
			}
		}
		return results;
	};

	/**
	 * Retrieve all Ajax calls that have NOT been mocked by this library during
	 * the current session (in other words, only since you last loaded this file).
	 *
	 * @return {Array}  The mocked Ajax calls (request settings)
	 */
	$.mockjax.unmockedAjaxCalls = function() {
		return unmockedAjaxCalls;
	};

	return $.mockjax;

}));


/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_version__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__ = __webpack_require__(24);




var endpoint = "https://172be0dae8484dfe8a681f5f229e58d4@sentry.io/56039";
var config = {
  release: __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_version__["b" /* sentryRelease */],
  shouldSendCallback: function shouldSendCallback() {
    return __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_environment__["a" /* default */].isProductionDeployTarget() && __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].isPointedToProductionHost();
  }
};
__WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.config(endpoint, config).install();
window.addEventListener("unhandledrejection", function (event) {
  __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.captureException(event.reason);
});
/* unused harmony default export */ var _unused_webpack_default_export = (config);

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */

var TraceKit = __webpack_require__(791);
var stringify = __webpack_require__(389);
var md5 = __webpack_require__(792);
var RavenConfigError = __webpack_require__(793);

var utils = __webpack_require__(262);
var isErrorEvent = utils.isErrorEvent;
var isDOMError = utils.isDOMError;
var isDOMException = utils.isDOMException;
var isError = utils.isError;
var isObject = utils.isObject;
var isPlainObject = utils.isPlainObject;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isArray = utils.isArray;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;
var supportsFetch = utils.supportsFetch;
var supportsReferrerPolicy = utils.supportsReferrerPolicy;
var serializeKeysForMessage = utils.serializeKeysForMessage;
var serializeException = utils.serializeException;
var sanitize = utils.sanitize;

var wrapConsoleMethod = __webpack_require__(794).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback)
    ? function(data) {
        return callback(data, original);
      }
    : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    headers: null,
    collectWindowErrors: true,
    captureUnhandledRejections: true,
    maxMessageLength: 0,
    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1,
    sanitizeKeys: []
  };
  this._fetchDefaults = {
    method: 'POST',
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.27.2',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function(key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
      ? joinRegExp(globalOptions.ignoreUrls)
      : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
      ? joinRegExp(globalOptions.whitelistUrls)
      : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(
      0,
      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
    ); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true,
      sentry: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function() {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });

      if (self._globalOptions.captureUnhandledRejections) {
        self._attachPromiseRejectionHandler();
      }

      self._patchFunctionToString();

      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function(dsn) {
    var self = this,
      uri = self._parseDSN(dsn),
      lastSlash = uri.path.lastIndexOf('/'),
      path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint =
      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = {};
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} _before A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
        i = arguments.length,
        deep = !options || (options && options.deep !== false);

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

      try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    wrapped.__raven__ = true;
    wrapped.__orig__ = func;

    return wrapped;
  },

  /**
   * Uninstalls the global error handler.
   *
   * @return {Raven}
   */
  uninstall: function() {
    TraceKit.report.uninstall();

    this._detachPromiseRejectionHandler();
    this._unpatchFunctionToString();
    this._restoreBuiltIns();
    this._restoreConsole();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /**
   * Callback used for `unhandledrejection` event
   *
   * @param {PromiseRejectionEvent} event An object containing
   *   promise: the Promise that was rejected
   *   reason: the value with which the Promise was rejected
   * @return void
   */
  _promiseRejectionHandler: function(event) {
    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
    this.captureException(event.reason, {
      mechanism: {
        type: 'onunhandledrejection',
        handled: false
      }
    });
  },

  /**
   * Installs the global promise rejection handler.
   *
   * @return {raven}
   */
  _attachPromiseRejectionHandler: function() {
    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
    _window.addEventListener &&
      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Uninstalls the global promise rejection handler.
   *
   * @return {raven}
   */
  _detachPromiseRejectionHandler: function() {
    _window.removeEventListener &&
      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Manually capture an exception and send it over to Sentry
   *
   * @param {error} ex An exception to be logged
   * @param {object} options A specific set of options for this error [optional]
   * @return {Raven}
   */
  captureException: function(ex, options) {
    options = objectMerge({trimHeadFrames: 0}, options ? options : {});

    if (isErrorEvent(ex) && ex.error) {
      // If it is an ErrorEvent with `error` property, extract it to get actual Error
      ex = ex.error;
    } else if (isDOMError(ex) || isDOMException(ex)) {
      // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
      // then we just extract the name and message, as they don't provide anything else
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
      var name = ex.name || (isDOMError(ex) ? 'DOMError' : 'DOMException');
      var message = ex.message ? name + ': ' + ex.message : name;

      return this.captureMessage(
        message,
        objectMerge(options, {
          // neither DOMError or DOMException provide stack trace and we most likely wont get it this way as well
          // but it's barely any overhead so we may at least try
          stacktrace: true,
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    } else if (isError(ex)) {
      // we have a real Error object
      ex = ex;
    } else if (isPlainObject(ex)) {
      // If it is plain Object, serialize it manually and extract options
      // This will allow us to group events based on top-level keys
      // which is much better than creating new group when any key/value change
      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
      ex = new Error(options.message);
    } else {
      // If none of previous checks were valid, then it means that
      // it's not a DOMError/DOMException
      // it's not a plain Object
      // it's not a valid ErrorEvent (one with an error property)
      // it's not an Error
      // So bail out and capture it as a simple message:
      return this.captureMessage(
        ex,
        objectMerge(options, {
          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    }

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
    var exKeys = Object.keys(ex).sort();
    var options = objectMerge(currentOptions, {
      message:
        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
      fingerprint: [md5(exKeys)],
      extra: currentOptions.extra || {}
    });
    options.extra.__serialized__ = serializeException(ex);

    return options;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (
      !!this._globalOptions.ignoreErrors.test &&
      this._globalOptions.ignoreErrors.test(msg)
    ) {
      return;
    }

    options = options || {};
    msg = msg + ''; // Make sure it's actually a string

    var data = objectMerge(
      {
        message: msg
      },
      options
    );

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = isArray(stack.stack) && stack.stack[1];

    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
    // initialCall => captureException(string) => captureMessage(string)
    if (initialCall && initialCall.func === 'Raven.captureException') {
      initialCall = stack.stack[2];
    }

    var fileurl = (initialCall && initialCall.url) || '';

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    // Always attempt to get stacktrace if message is empty.
    // It's the only way to provide any helpful information to the user.
    if (this._globalOptions.stacktrace || options.stacktrace || data.message === '') {
      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;

      options = objectMerge(
        {
          trimHeadFrames: 0
        },
        options
      );
      // Since we know this is a synthetic trace, the top frame (this function call)
      // MUST be from Raven.js, so mark it for trimming
      // We add to the trim counter so that callers can choose to trim extra frames, such
      // as utility functions.
      options.trimHeadFrames += 1;

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Make sure that fingerprint is always wrapped in an array
    if (data.fingerprint) {
      data.fingerprint = isArray(data.fingerprint)
        ? data.fingerprint
        : [data.fingerprint];
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function(obj) {
    var crumb = objectMerge(
      {
        timestamp: now() / 1000
      },
      obj
    );

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
   * Override the default HTTP transport mechanism that transmits data
   * to the Sentry server.
   *
   * @param {function} transport Function invoked instead of the default
   *                             `makeRequest` handler.
   *
   * @return {Raven}
   */
  setTransport: function(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function(options) {
    if (
      !_document // doesn't work without a document (React native)
    )
      return;

    options = objectMerge(
      {
        eventId: this.lastEventId(),
        dsn: this._dsn,
        user: this._globalContext.user || {}
      },
      options
    );

    if (!options.eventId) {
      throw new RavenConfigError('Missing eventId');
    }

    if (!options.dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var encodedOptions = [];

    for (var key in options) {
      if (key === 'user') {
        var user = options.user;
        if (user.name) encodedOptions.push('name=' + encode(user.name));
        if (user.email) encodedOptions.push('email=' + encode(user.email));
      } else {
        encodedOptions.push(encode(key) + '=' + encode(options[key]));
      }
    }
    var globalServer = this._getGlobalServer(this._parseDSN(options.dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/?' + encodedOptions.join('&');
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function() {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options)
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }

    if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
   * Wraps addEventListener to capture UI breadcrumbs
   * @param evtName the event name (e.g. "click")
   * @returns {Function}
   * @private
   */
  _breadcrumbEventHandler: function(evtName) {
    var self = this;
    return function(evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
   * Wraps addEventListener to capture keypress UI events
   * @returns {Function}
   * @private
   */
  _keypressEventHandler: function() {
    var self = this,
      debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (
        !tagName ||
        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
      )
        return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function() {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
   * Captures a breadcrumb of type "navigation", normalizing input URLs
   * @param to the originating URL
   * @param from the target URL
   * @private
   */
  _captureUrlChange: function(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
      to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
      from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  _patchFunctionToString: function() {
    var self = this;
    self._originalFunctionToString = Function.prototype.toString;
    // eslint-disable-next-line no-extend-native
    Function.prototype.toString = function() {
      if (typeof this === 'function' && this.__raven__) {
        return self._originalFunctionToString.apply(this.__orig__, arguments);
      }
      return self._originalFunctionToString.apply(this, arguments);
    };
  },

  _unpatchFunctionToString: function() {
    if (this._originalFunctionToString) {
      // eslint-disable-next-line no-extend-native
      Function.prototype.toString = this._originalFunctionToString;
    }
  },

  /**
   * Wrap timer functions and event targets to catch errors and provide
   * better metadata.
   */
  _instrumentTryCatch: function() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function(fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: orig.name || '<anonymous>'}
              }
            },
            originalCallback
          );
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(
          proto,
          'addEventListener',
          function(orig) {
            return function(evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          target: global,
                          function: 'handleEvent',
                          handler: (fn && fn.name) || '<anonymous>'
                        }
                      }
                    },
                    fn.handleEvent
                  );
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before, clickHandler, keypressHandler;

              if (
                autoBreadcrumbs &&
                autoBreadcrumbs.dom &&
                (global === 'EventTarget' || global === 'Node')
              ) {
                // NOTE: generating multiple handlers per addEventListener invocation, should
                //       revisit and verify we can just use one (almost certainly)
                clickHandler = self._breadcrumbEventHandler('click');
                keypressHandler = self._keypressEventHandler();
                before = function(evt) {
                  // need to intercept every DOM event in `before` argument, in case that
                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                  // see #724
                  if (!evt) return;

                  var eventType;
                  try {
                    eventType = evt.type;
                  } catch (e) {
                    // just accessing event properties can throw an exception in some rare circumstances
                    // see: https://github.com/getsentry/raven-js/issues/838
                    return;
                  }
                  if (eventType === 'click') return clickHandler(evt);
                  else if (eventType === 'keypress') return keypressHandler(evt);
                };
              }
              return orig.call(
                this,
                evtName,
                self.wrap(
                  {
                    mechanism: {
                      type: 'instrument',
                      data: {
                        target: global,
                        function: 'addEventListener',
                        handler: (fn && fn.name) || '<anonymous>'
                      }
                    }
                  },
                  fn,
                  before
                ),
                capture,
                secure
              );
            };
          },
          wrappedBuiltIns
        );
        fill(
          proto,
          'removeEventListener',
          function(orig) {
            return function(evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          wrappedBuiltIns
        );
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(
        _window,
        'requestAnimationFrame',
        function(orig) {
          return function(cb) {
            return orig(
              self.wrap(
                {
                  mechanism: {
                    type: 'instrument',
                    data: {
                      function: 'requestAnimationFrame',
                      handler: (orig && orig.name) || '<anonymous>'
                    }
                  }
                },
                cb
              )
            );
          };
        },
        wrappedBuiltIns
      );
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = [
      'EventTarget',
      'Window',
      'Node',
      'ApplicationCache',
      'AudioTrackList',
      'ChannelMergerNode',
      'CryptoOperation',
      'EventSource',
      'FileReader',
      'HTMLUnknownElement',
      'IDBDatabase',
      'IDBRequest',
      'IDBTransaction',
      'KeyOperation',
      'MediaController',
      'MessagePort',
      'ModalWindow',
      'Notification',
      'SVGElementInstance',
      'Screen',
      'TextTrack',
      'TextTrackCue',
      'TextTrackList',
      'WebSocket',
      'WebSocketWorker',
      'Worker',
      'XMLHttpRequest',
      'XMLHttpRequestEventTarget',
      'XMLHttpRequestUpload'
    ];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - XMLHttpRequests
   *  - DOM interactions (click/typing)
   *  - window.location changes
   *  - console
   *
   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
   */
  _instrumentBreadcrumbs: function() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function(orig) {
          return self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: prop, handler: (orig && orig.name) || '<anonymous>'}
              }
            },
            orig
          );
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
      fill(
        xhrproto,
        'open',
        function(origOpen) {
          return function(method, url) {
            // preserve arity

            // if Sentry key appears in URL, don't capture
            if (isString(url) && url.indexOf(self._globalKey) === -1) {
              this.__raven_xhr = {
                method: method,
                url: url,
                status_code: null
              };
            }

            return origOpen.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );

      fill(
        xhrproto,
        'send',
        function(origSend) {
          return function() {
            // preserve arity
            var xhr = this;

            function onreadystatechangeHandler() {
              if (xhr.__raven_xhr && xhr.readyState === 4) {
                try {
                  // touching statusCode in some platforms throws
                  // an exception
                  xhr.__raven_xhr.status_code = xhr.status;
                } catch (e) {
                  /* do nothing */
                }

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'xhr',
                  data: xhr.__raven_xhr
                });
              }
            }

            var props = ['onload', 'onerror', 'onprogress'];
            for (var j = 0; j < props.length; j++) {
              wrapProp(props[j], xhr);
            }

            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
              fill(
                xhr,
                'onreadystatechange',
                function(orig) {
                  return self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          function: 'onreadystatechange',
                          handler: (orig && orig.name) || '<anonymous>'
                        }
                      }
                    },
                    orig,
                    onreadystatechangeHandler
                  );
                } /* intentionally don't track this instrumentation */
              );
            } else {
              // if onreadystatechange wasn't actually set by the page on this xhr, we
              // are free to set our own and capture the breadcrumb
              xhr.onreadystatechange = onreadystatechangeHandler;
            }

            return origSend.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );
    }

    if (autoBreadcrumbs.xhr && supportsFetch()) {
      fill(
        _window,
        'fetch',
        function(origFetch) {
          return function() {
            // preserve arity
            // Make a copy of the arguments to prevent deoptimization
            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; ++i) {
              args[i] = arguments[i];
            }

            var fetchInput = args[0];
            var method = 'GET';
            var url;

            if (typeof fetchInput === 'string') {
              url = fetchInput;
            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
              url = fetchInput.url;
              if (fetchInput.method) {
                method = fetchInput.method;
              }
            } else {
              url = '' + fetchInput;
            }

            // if Sentry key appears in URL, don't capture, as it's our own request
            if (url.indexOf(self._globalKey) !== -1) {
              return origFetch.apply(this, args);
            }

            if (args[1] && args[1].method) {
              method = args[1].method;
            }

            var fetchData = {
              method: method,
              url: url,
              status_code: null
            };

            return origFetch
              .apply(this, args)
              .then(function(response) {
                fetchData.status_code = response.status;

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData
                });

                return response;
              })
              ['catch'](function(err) {
                // if there is an error performing the request
                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData,
                  level: 'error'
                });

                throw err;
              });
          };
        },
        wrappedBuiltIns
      );
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else if (_document.attachEvent) {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState =
      !isChromePackagedApp &&
      _window.history &&
      _window.history.pushState &&
      _window.history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function() {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function(/* state, title, url */) {
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(_window.history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(_window.history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
        name = builtin[1],
        orig = builtin[2];

      obj[name] = orig;
    }
  },

  _restoreConsole: function() {
    // eslint-disable-next-line guard-for-in
    for (var method in this._originalConsoleMethods) {
      this._originalConsole[method] = this._originalConsoleMethods[method];
    }
  },

  _drainPlugins: function() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function(_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function(str) {
    var m = dsnPattern.exec(str),
      dsn = {},
      i = 7;

    try {
      while (i--) dsn[dsnKeys[i]] = m[i] || '';
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError(
        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
      );
    }

    return dsn;
  },

  _getGlobalServer: function(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function(stackInfo, options) {
    options = options || {};
    options.mechanism = options.mechanism || {
      type: 'onerror',
      handled: false
    };

    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo(stackInfo, options);
    }
  },

  _handleStackInfo: function(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(
      stackInfo.name,
      stackInfo.message,
      stackInfo.url,
      stackInfo.lineno,
      frames,
      options
    );
  },

  _prepareFrames: function(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function(i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !// determine if an exception came from outside of our app
    // first we check the global includePaths list.
    (
      (!!this._globalOptions.includePaths.test &&
        !this._globalOptions.includePaths.test(normalized.filename)) ||
      // Now we check for fun, if the function name is Raven or TraceKit
      /(Raven|TraceKit)\./.test(normalized['function']) ||
      // finally, we do a last ditch effort and check for raven.min.js
      /raven\.(min\.)?js$/.test(normalized.filename)
    );

    return normalized;
  },

  _processException: function(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (
      !!this._globalOptions.ignoreErrors.test &&
      (this._globalOptions.ignoreErrors.test(message) ||
        this._globalOptions.ignoreErrors.test(prefixedMessage))
    ) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = {frames: frames};
    } else if (fileurl) {
      stacktrace = {
        frames: [
          {
            filename: fileurl,
            lineno: lineno,
            in_app: true
          }
        ]
      };
    }

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    var data = objectMerge(
      {
        // sentry.interfaces.Exception
        exception: {
          values: [
            {
              type: type,
              value: message,
              stacktrace: stacktrace
            }
          ]
        },
        transaction: fileurl
      },
      options
    );

    var ex = data.exception.values[0];
    if (ex.type == null && ex.value === '') {
      ex.value = 'Unrecoverable error caught';
    }

    // Move mechanism from options to exception interface
    // We do this, as requiring user to pass `{exception:{mechanism:{ ... }}}` would be
    // too much
    if (!data.exception.mechanism && data.mechanism) {
      data.exception.mechanism = data.mechanism;
      delete data.mechanism;
    }

    data.exception.mechanism = objectMerge(
      {
        type: 'generic',
        handled: true
      },
      data.exception.mechanism || {}
    );

    // Fire away!
    this._send(data);
  },

  _trimPacket: function(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values)
      this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
   * Truncate breadcrumb values (right now just URLs)
   */
  _trimBreadcrumbs: function(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
      urlProp,
      crumb,
      data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (
        !crumb.hasOwnProperty('data') ||
        !isObject(crumb.data) ||
        objectFrozen(crumb.data)
      )
        continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': _navigator.userAgent
      };
    }

    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
    if (_window.location && _window.location.href) {
      httpData.url = _window.location.href;
    }

    if (this._hasDocument && _document.referrer) {
      if (!httpData.headers) httpData.headers = {};
      httpData.headers.Referer = _document.referrer;
    }

    return httpData;
  },

  _resetBackoff: function() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
   * Returns true if the in-process data payload matches the signature
   * of the previously-sent data
   *
   * NOTE: This has to be done at this level because TraceKit can generate
   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
   *       other old browsers). This can take the form of an "exception"
   *       data object with a single frame (derived from the onerror args).
   */
  _isRepeatData: function(current) {
    var last = this._lastData;

    if (
      !last ||
      current.message !== last.message || // defined for captureMessage
      current.transaction !== last.transaction // defined for captureException/onerror
    )
      return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    } else if (current.fingerprint || last.fingerprint) {
      return Boolean(current.fingerprint && last.fingerprint) &&
        JSON.stringify(current.fingerprint) === JSON.stringify(last.fingerprint)
    }

    return true;
  },

  _setBackoffState: function(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      if (supportsFetch()) {
        retry = request.headers.get('Retry-After');
      } else {
        retry = request.getResponseHeader('Retry-After');
      }

      // Retry-After is returned in seconds
      retry = parseInt(retry, 10) * 1000;
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry
      ? // If Sentry server returned a Retry-After value, use it
        retry
      : // Otherwise, double the last backoff duration (starts at 1 sec)
        this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
        project: this._globalProject,
        logger: globalOptions.logger,
        platform: 'javascript'
      },
      httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    data = this._sanitizeData(data);

    // Cleanup empty properties before sending them to the server
    Object.keys(data).forEach(function(key) {
      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
        delete data[key];
      }
    });

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (
      isFunction(globalOptions.shouldSendCallback) &&
      !globalOptions.shouldSendCallback(data)
    ) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _sanitizeData: function(data) {
    return sanitize(data, this._globalOptions.sanitizeKeys);
  },

  _getUuid: function() {
    return uuid4();
  },

  _sendProcessedPayload: function(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];

    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
    if (
      this._globalOptions.autoBreadcrumbs &&
      this._globalOptions.autoBreadcrumbs.sentry
    ) {
      this.captureBreadcrumb({
        category: 'sentry',
        message: exception
          ? (exception.type ? exception.type + ': ' : '') + exception.value
          : data.message,
        event_id: data.event_id,
        level: data.level || 'error' // presume error unless specified
      });
    }

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function(opts) {
    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
    var url = opts.url + '?' + urlencode(opts.auth);

    var evaluatedHeaders = null;
    var evaluatedFetchParameters = {};

    if (opts.options.headers) {
      evaluatedHeaders = this._evaluateHash(opts.options.headers);
    }

    if (opts.options.fetchParameters) {
      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
    }

    if (supportsFetch()) {
      evaluatedFetchParameters.body = stringify(opts.data);

      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);

      if (evaluatedHeaders) {
        fetchOptions.headers = evaluatedHeaders;
      }

      return _window
        .fetch(url, fetchOptions)
        .then(function(response) {
          if (response.ok) {
            opts.onSuccess && opts.onSuccess();
          } else {
            var error = new Error('Sentry error code: ' + response.status);
            // It's called request only to keep compatibility with XHR interface
            // and not add more redundant checks in setBackoffState method
            error.request = response;
            opts.onError && opts.onError(error);
          }
        })
        ['catch'](function() {
          opts.onError &&
            opts.onError(new Error('Sentry error code: network unavailable'));
        });
    }

    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    if ('withCredentials' in request) {
      request.onreadystatechange = function() {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function() {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    request.open('POST', url);

    if (evaluatedHeaders) {
      each(evaluatedHeaders, function(key, value) {
        request.setRequestHeader(key, value);
      });
    }

    request.send(stringify(opts.data));
  },

  _evaluateHash: function(hash) {
    var evaluated = {};

    for (var key in hash) {
      if (hash.hasOwnProperty(key)) {
        var value = hash[key];
        evaluated[key] = typeof value === 'function' ? value() : value;
      }
    }

    return evaluated;
  },

  _logDebug: function(level) {
    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
    if (
      this._originalConsoleMethods[level] &&
      (this.debug || this._globalOptions.debug)
    ) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(
        this._originalConsoleMethods[level],
        this._originalConsole,
        [].slice.call(arguments, 1)
      );
    }
  },

  _mergeContext: function(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(262);

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
    ? global
    : typeof self !== 'undefined'
    ? self
    : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';
  return document.location.href;
}

function getLocationOrigin() {
  if (typeof document === 'undefined' || document.location == null) return '';

  // Oh dear IE10...
  if (!document.location.origin) {
    return (
      document.location.protocol +
      '//' +
      document.location.hostname +
      (document.location.port ? ':' + document.location.port : '')
    );
  }

  return document.location.origin;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
   * Add a crash handler.
   * @param {Function} handler
   */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
   * Remove a crash handler.
   * @param {Function} handler
   */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
   * Remove all crash handlers.
   */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} msg Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */
  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
    var stack = null;
    // If 'ex' is ErrorEvent, get real Error from inside
    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
    // If 'msg' is ErrorEvent, get real message from inside
    var message = utils.isErrorEvent(msg) ? msg.message : msg;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
        lastExceptionStack,
        url,
        lineNo,
        message
      );
      processLastException();
    } else if (exception && utils.isError(exception)) {
      // non-string `exception` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(exception);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          message = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: message,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(
      function() {
        if (lastException === ex) {
          processLastException();
        }
      },
      stack.incomplete ? 2000 : 0
    );

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
})();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
    // Used to additionally parse URL/line/column from eval frames
    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    var lines = ex.stack.split('\n');
    var stack = [];
    var submatch;
    var parts;
    var element;
    var reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if ((parts = chrome.exec(lines[i]))) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = winjs.exec(lines[i]))) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = gecko.exec(lines[i]))) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      if (element.url && element.url.substr(0, 5) === 'blob:') {
        // Special case for handling JavaScript loaded into a blob.
        // We use a synchronous AJAX request here as a blob is already in
        // memory - it's not making a network request.  This will generate a warning
        // in the browser console, but there has already been an error so that's not
        // that much of an issue.
        var xhr = new XMLHttpRequest();
        xhr.open('GET', element.url, false);
        xhr.send(null);

        // If we failed to download the source, skip this patch
        if (xhr.status === 200) {
          var source = xhr.responseText || '';

          // We trim the source down to the last 300 characters as sourceMappingURL is always at the end of the file.
          // Why 300? To be in line with: https://github.com/getsentry/sentry/blob/4af29e8f2350e20c28a6933354e4f42437b4ba42/src/sentry/lang/javascript/processor.py#L164-L175
          source = source.slice(-300);

          // Now we dig out the source map URL
          var sourceMaps = source.match(/\/\/# sourceMappingURL=(.*)$/);

          // If we don't find a source map comment or we find more than one, continue on to the next element.
          if (sourceMaps) {
            var sourceMapAddress = sourceMaps[1];

            // Now we check to see if it's a relative URL.
            // If it is, convert it to an absolute one.
            if (sourceMapAddress.charAt(0) === '~') {
              sourceMapAddress = getLocationOrigin() + sourceMapAddress.slice(1);
            }

            // Now we strip the '.map' off of the end of the URL and update the
            // element so that Sentry can match the map to the blob.
            element.url = sourceMapAddress.slice(0, -4);
          }
        }
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (
            !stackInfo.stack[0].line &&
            stackInfo.stack[0].func === initial.func
          ) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;

    for (
      var curr = computeStackTraceByWalkingCallerChain.caller;
      curr && !recursion;
      curr = curr.caller
    ) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if ((parts = functionName.exec(curr.toString()))) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(
      result,
      ex.sourceURL || ex.fileName,
      ex.line || ex.lineNumber,
      ex.message || ex.description
    );
    return result;
  }

  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
})();

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 792 */
/***/ (function(module, exports) {

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
* Add integers, wrapping at 2^32. This uses 16-bit operations internally
* to work around bugs in some JS interpreters.
*/
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xffff);
}

/*
* Bitwise rotate a 32-bit number to the left.
*/
function bitRotateLeft(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
}

/*
* These functions implement the four basic operations the algorithm uses.
*/
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
* Calculate the MD5 of an array of little-endian words, and a bit length.
*/
function binlMD5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << (len % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;

    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}

/*
* Convert an array of little-endian words to a string
*/
function binl2rstr(input) {
  var i;
  var output = '';
  var length32 = input.length * 32;
  for (i = 0; i < length32; i += 8) {
    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
  }
  return output;
}

/*
* Convert a raw string to an array of little-endian words
* Characters >255 have their high-byte silently ignored.
*/
function rstr2binl(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;
  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }
  var length8 = input.length * 8;
  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
  }
  return output;
}

/*
* Calculate the MD5 of a raw string
*/
function rstrMD5(s) {
  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}

/*
* Calculate the HMAC-MD5, of a key and some data (raw strings)
*/
function rstrHMACMD5(key, data) {
  var i;
  var bkey = rstr2binl(key);
  var ipad = [];
  var opad = [];
  var hash;
  ipad[15] = opad[15] = undefined;
  if (bkey.length > 16) {
    bkey = binlMD5(bkey, key.length * 8);
  }
  for (i = 0; i < 16; i += 1) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5c5c5c5c;
  }
  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}

/*
* Convert a raw string to a hex string
*/
function rstr2hex(input) {
  var hexTab = '0123456789abcdef';
  var output = '';
  var x;
  var i;
  for (i = 0; i < input.length; i += 1) {
    x = input.charCodeAt(i);
    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
  }
  return output;
}

/*
* Encode a string as utf-8
*/
function str2rstrUTF8(input) {
  return unescape(encodeURIComponent(input));
}

/*
* Take string arguments and return either raw or hex encoded strings
*/
function rawMD5(s) {
  return rstrMD5(str2rstrUTF8(s));
}
function hexMD5(s) {
  return rstr2hex(rawMD5(s));
}
function rawHMACMD5(k, d) {
  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
function hexHMACMD5(k, d) {
  return rstr2hex(rawHMACMD5(k, d));
}

function md5(string, key, raw) {
  if (!key) {
    if (!raw) {
      return hexMD5(string);
    }
    return rawMD5(string);
  }
  if (!raw) {
    return hexHMACMD5(key, string);
  }
  return rawHMACMD5(key, string);
}

module.exports = md5;


/***/ }),
/* 793 */
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(262);

var wrapMethod = function(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function() {
    var args = [].slice.call(arguments);

    var msg = utils.safeJoin(args, ' ');
    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg =
          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};


/***/ }),
/* 795 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 796 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 797 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(4);

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

module.exports = _superPropBase;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(308);
var invariant = __webpack_require__(309);
var ReactPropTypesSecret = __webpack_require__(800);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 801 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(308);
var invariant = __webpack_require__(309);
var ReactPropTypesSecret = __webpack_require__(803);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = invokeCallback;
/* unused harmony export bpfrpt_proptype_AndroidGeofence */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);

var bpfrpt_proptype_AndroidGeofence = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  latitude: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  longitude: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  radius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  // int
  hrefAcknowledge: function hrefAcknowledge() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  hrefEnter: function hrefEnter() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  hrefExit: function hrefExit() {
    return (typeof Url === "function" ? __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Url).isRequired : __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
};

function callBridge(method) {
  var _window$AndroidAppInt;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var argsString = JSON.stringify(args);
  __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.captureBreadcrumb({
    category: "AndroidAppInterface",
    level: "info",
    message: method,
    data: {
      args: argsString.length > 1024 ? "[args hidden because size exceeded 1024 bytes]" : argsString
    }
  });
  return (_window$AndroidAppInt = window.AndroidAppInterface)[method].apply(_window$AndroidAppInt, args);
} // callBridgeAsync start


var callbacks = {};

function registerCallback(callback) {
  var callbackName = "callback_".concat(_.uniqueId());
  callbacks[callbackName] = callback;
  return callbackName;
}

function invokeCallback(callbackName, value) {
  if (!callbacks[callbackName]) {
    return;
  }

  callbacks[callbackName](value);
  delete callbacks[callbackName];
}

function deleteCallback(callbackName) {
  delete callbacks[callbackName];
}

function callBridgeAsync(method) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return new Promise(function (resolve) {
    var callbackName = registerCallback(resolve);
    callBridge.apply(void 0, [method, callbackName].concat(args));
  });
} // callBridgeAsync end
// JSON helpers


function tryParse(jsonString) {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    throw new Error("Unable to parse JSON string from Android Platform bridge: ".concat(jsonString));
  }
}

function tryStringify(jsonValue) {
  try {
    return JSON.stringify(jsonValue);
  } catch (error) {
    throw new Error("Unable to stringify JSON value from Android Platform Bridge");
  }
} // JSON helpers end
// These all pass through to either callBridge or callBridgeAsync, but they have
// types that match the Java code, so that that type info is available to the
// rest of the world. They also handle JSON (de)serialization so that you don't
// have to think about JSON outside of this file and the Java code.


/* harmony default export */ __webpack_exports__["a"] = ({
  enableRemoteDebugging: function enableRemoteDebugging() {
    return callBridge("enableRemoteDebugging");
  },
  notifyScriptInterfaceReady: function notifyScriptInterfaceReady() {
    return callBridge("notifyScriptInterfaceReady");
  },
  setPlatformAttributes: function setPlatformAttributes() {
    return callBridge("setPlatformAttributes");
  },
  exitApp: function exitApp() {
    return callBridge("exitApp");
  },
  getStoredValue: function getStoredValue(key) {
    return callBridge("getStoredValue", key);
  },
  setStoredValue: function setStoredValue(key, value) {
    return callBridge("setStoredValue", key, value);
  },
  clearStoredValue: function clearStoredValue(key) {
    return callBridge("clearStoredValue", key);
  },
  clearStoredValues: function clearStoredValues() {
    return callBridge("clearStoredValues");
  },
  saveImage: function saveImage(base64Data) {
    return callBridgeAsync("saveImage", base64Data).then(tryParse);
  },
  keepScreenOn: function keepScreenOn() {
    return callBridge("keepScreenOn");
  },
  allowScreenDimming: function allowScreenDimming() {
    return callBridge("allowScreenDimming");
  },
  obtainPushNotificationToken: function obtainPushNotificationToken() {
    return callBridge("obtainPushNotificationToken");
  },
  clearNotifications: function clearNotifications() {
    return callBridge("clearNotifications");
  },
  isNotificationSoundConfigurable: function isNotificationSoundConfigurable() {
    return callBridge("isNotificationSoundConfigurable");
  },
  hideSoftKeyboard: function hideSoftKeyboard() {
    return callBridge("hideSoftKeyboard");
  },
  sendGoogleAnalyticsEvent: function sendGoogleAnalyticsEvent(category, action, label) {
    return callBridge("sendGoogleAnalyticsEvent", category, action, label);
  },
  sendGoogleAnalyticsTiming: function sendGoogleAnalyticsTiming(category, action, label, duration) {
    return callBridge("sendGoogleAnalyticsEvent", category, action, label, duration);
  },
  checkLocationPermissions: function checkLocationPermissions() {
    return callBridgeAsync("checkLocationPermissions");
  },
  areLocationServicesEnabled: function areLocationServicesEnabled() {
    return callBridgeAsync("areLocationServicesEnabled");
  },
  getLocationServicesWarningMessage: function getLocationServicesWarningMessage() {
    return callBridgeAsync("getLocationServicesWarningMessage").then(tryParse);
  },
  openAppSettings: function openAppSettings() {
    return callBridge("openAppSettings");
  },
  openLocationServiceSettings: function openLocationServiceSettings() {
    return callBridge("openLocationServiceSettings");
  },
  openWifiSettings: function openWifiSettings() {
    return callBridge("openWifiSettings");
  },
  setGeofences: function setGeofences(geofences) {
    return callBridge("setGeofences", tryStringify(geofences));
  },
  startGeofenceService: function startGeofenceService() {
    return callBridge("startGeofenceService");
  },
  stopGeofenceService: function stopGeofenceService() {
    return callBridge("stopGeofenceService");
  },
  getGeofenceCrossings: function getGeofenceCrossings() {
    return tryParse(callBridge("getGeofenceCrossings"));
  },
  hasAppInstalled: function hasAppInstalled(name) {
    return callBridge("hasAppInstalled", name);
  },
  wifiScan: function wifiScan() {
    return callBridgeAsync("wifiScan").then(tryParse);
  },
  connectToWifiNetwork: function connectToWifiNetwork(ssid, password) {
    return callBridge("connectToWifiNetwork", ssid, password);
  },
  isFingerprintAuthAvailable: function isFingerprintAuthAvailable() {
    return callBridge("isFingerprintAuthAvailable");
  },
  authenticateWithFingerprint: function authenticateWithFingerprint() {
    return callBridgeAsync("authenticateWithFingerprint").then(tryParse);
  },
  cancelFingerprintAuthentication: function cancelFingerprintAuthentication() {
    return callBridge("cancelFingerprintAuthentication");
  },
  nativeHTTPRequest: function nativeHTTPRequest(_ref) {
    var method = _ref.method,
        url = _ref.url,
        headers = _ref.headers,
        body = _ref.body;
    return callBridgeAsync("nativeHTTPRequest", method, url, tryStringify(headers || {}), body).then(decodeURIComponent).then(tryParse);
  },
  encryptStringFor724OpenAuth: function encryptStringFor724OpenAuth(key, input) {
    return callBridge("encryptStringFor724OpenAuth", key, input);
  },
  showWebView: function showWebView() {
    return callBridge("showWebView");
  },
  hideWebView: function hideWebView() {
    return callBridge("hideWebView");
  },
  enqueueIn: function enqueueIn(callback) {
    var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var callbackName = registerCallback(callback);
    callBridge("enqueueIn", callbackName, ms);
    return callbackName;
  },
  cancelEnqueued: function cancelEnqueued(callbackName) {
    deleteCallback(callbackName);
  }
});



/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);


function callBridge(prefix, command) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var search = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var argsString;

  if (body instanceof Blob) {
    argsString = "Blob(".concat(body.size, ")");
  } else {
    argsString = JSON.stringify(body);
  }

  __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.captureBreadcrumb({
    category: "iOS Bridge",
    level: "info",
    message: "".concat(prefix, "/").concat(command),
    data: {
      args: argsString.length > 1024 ? "[args hidden because size exceeded 1024 bytes]" : argsString,
      search: search
    }
  });
  return fetch("http://localhost:4400/".concat(prefix, "/").concat(command).concat(search), {
    method: "POST",
    headers: {
      "Content-Type": body instanceof Blob ? "application/octet-stream" : "application/json"
    },
    body: body instanceof Blob ? body : argsString
  }).then(function (response) {
    return response.json();
  }).then(function (jsonResponse) {
    if (jsonResponse.error) {
      throw new Error(jsonResponse.errorDescription);
    } else {
      return jsonResponse.data;
    }
  });
} // These all pass through to callBridge, but they have type info; callBridge
// returns Promise<any>, so these refine that into eg.
// Promise<{ result: boolean }> so that the types written in the Objective-C
// code are available to the rest of the world.


/* harmony default export */ __webpack_exports__["a"] = ({
  misc: {
    keepScreenOn: function keepScreenOn() {
      return callBridge("misc", "keepScreenOn");
    },
    allowScreenDimming: function allowScreenDimming() {
      return callBridge("misc", "allowScreenDimming");
    },
    obtainPushNotificationToken: function obtainPushNotificationToken() {
      return callBridge("misc", "obtainPushNotificationToken");
    },
    resetAppBadge: function resetAppBadge() {
      return callBridge("misc", "resetAppBadge");
    },
    saveImage: function saveImage(image) {
      return callBridge("misc", "saveImage", {
        image: image
      });
    },
    sendGoogleAnalyticsEvent: function sendGoogleAnalyticsEvent(category, label, action, value) {
      return callBridge("misc", "sendGoogleAnalyticsEvent", {
        category: category,
        label: label,
        action: action,
        value: value
      });
    },
    hasAppInstalled: function hasAppInstalled(name) {
      return callBridge("misc", "hasAppInstalled", {
        name: name
      });
    },
    hideSoftKeyboard: function hideSoftKeyboard() {
      return callBridge("misc", "hideSoftKeyboard");
    },
    openAppPermissionSettings: function openAppPermissionSettings() {
      return callBridge("misc", "openAppPermissionSettings");
    },
    isVoiceOverEnabled: function isVoiceOverEnabled() {
      return callBridge("misc", "isVoiceOverEnabled");
    },
    encryptStringFor724OpenAuth: function encryptStringFor724OpenAuth(key, input) {
      return callBridge("misc", "encryptStringFor724OpenAuth", {
        key: key,
        input: input
      });
    }
  },
  localStorage: {
    getAllStoredValues: function getAllStoredValues() {
      return callBridge("localStorage", "getAllStoredValues");
    },
    setStoredValue: function setStoredValue(key, value) {
      return callBridge("localStorage", "setStoredValue", {
        key: key,
        value: value
      });
    },
    clearStoredValue: function clearStoredValue(key) {
      return callBridge("localStorage", "clearStoredValue", {
        key: key
      });
    },
    clearStoredValues: function clearStoredValues() {
      return callBridge("localStorage", "clearStoredValues");
    }
  },
  vognition: {
    checkMicrophonePermissions: function checkMicrophonePermissions() {
      return callBridge("vognition", "checkMicrophonePermissions");
    },
    runVognitionListener: function runVognitionListener() {
      return callBridge("vognition", "runVognitionListener");
    },
    stopVognitionListener: function stopVognitionListener() {
      return callBridge("vognition", "stopVognitionListener");
    },
    speakString: function speakString(message) {
      return callBridge("vognition", "speakString", {
        message: message
      });
    },
    setCurrentVognitionHomeWithProfile: function setCurrentVognitionHomeWithProfile(houseId, encodedProfile) {
      return callBridge("vognition", "setCurrentVognitionHomeWithProfile", {
        houseId: houseId,
        encodedProfile: encodedProfile
      });
    }
  },
  geofence: {
    checkLocationPermissions: function checkLocationPermissions() {
      return callBridge("geofence", "checkLocationPermissions");
    },
    areLocationServicesEnabled: function areLocationServicesEnabled() {
      return callBridge("geofence", "areLocationServicesEnabled");
    },
    setGeofences: function setGeofences(geofences) {
      return callBridge("geofence", "setGeofences", {
        geofences: geofences
      });
    },
    startGeofenceService: function startGeofenceService() {
      return callBridge("geofence", "startGeofenceService");
    },
    stopGeofenceService: function stopGeofenceService() {
      return callBridge("geofence", "stopGeofenceService");
    },
    getGeofenceCrossings: function getGeofenceCrossings() {
      return callBridge("geofence", "getGeofenceCrossings");
    }
  },
  touchID: {
    isTouchIDAvailable: function isTouchIDAvailable() {
      return callBridge("touchID", "isTouchIDAvailable");
    },
    authenticateWithTouchID: function authenticateWithTouchID() {
      return callBridge("touchID", "authenticateWithTouchID");
    },
    cancelTouchIDAuthentication: function cancelTouchIDAuthentication() {
      return callBridge("touchID", "cancelTouchIDAuthentication");
    }
  },
  platformAttributes: {
    getPlatformAttributes: function getPlatformAttributes() {
      return callBridge("platformAttributes", "getPlatformAttributes");
    }
  },
  http: {
    nativeHTTPRequest: function nativeHTTPRequest(options) {
      return callBridge("http", "nativeHTTPRequest", options);
    }
  },
  temp: {
    createTemporaryFile: function createTemporaryFile(blob, extension) {
      return callBridge("temp", "createTemporaryFile", blob, "?extension=".concat(extension));
    },
    removeTemporaryFile: function removeTemporaryFile(url) {
      return callBridge("temp", "removeTemporaryFile", {
        url: url
      });
    }
  }
});

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en_us_core__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fr_ca_core__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es_mx_core__ = __webpack_require__(397);
/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/

/* eslint-disable camelcase */




var stringsProvider = function stringsProvider(locale) {
  var core;

  switch (locale) {
    case "en_us":
      core = __WEBPACK_IMPORTED_MODULE_0__en_us_core__["a" /* en_us */];
      break;

    case "fr_ca":
      core = __WEBPACK_IMPORTED_MODULE_1__fr_ca_core__["a" /* fr_ca */];
      break;

    case "es_mx":
      core = __WEBPACK_IMPORTED_MODULE_2__es_mx_core__["a" /* es_mx */];
      break;

    default:
      core = __WEBPACK_IMPORTED_MODULE_0__en_us_core__["a" /* en_us */];
  }

  return {
    nx_components: {
      schedules: {
        EditPeriod: {
          cannotBeBlank: core[313],
          noSpecialCharacters: core[314],
          applyChanges: core[49]
        },
        Footer: {
          addPeriod: core[31],
          removePeriod: core[230],
          done: core[107],
          undo: core[291],
          cancelButton: core[69],
          applyButton: core[44]
        },
        ScrollableWithIndicators: {
          more: core[185]
        },
        ThermostatSchedule: {
          cannotCreateTemplate: core[70],
          newPeriod: core[190],
          precedingPeriod: core[276],
          followingPeriod: core[275],
          unoccupied: core[298],
          occupied: core[201],
          mustHaveOnePeriod: core[22],
          cannotDelete: core[309]
        },
        utils: {
          precedingPeriod: core[276],
          followingPeriod: core[275]
        },
        Schedule: {
          mon: core[388],
          tue: core[389],
          wed: core[390],
          thu: core[391],
          fri: core[392],
          sat: core[393],
          sun: core[394]
        }
      },
      PivotThermostatSetpointControls: {
        heatTo: core[140],
        coolTo: core[87]
      },
      ThermostatDetailsHeader: {
        outside: core[209],
        humidity: core[148],
        compressorSpeed: core[80]
      },
      ThermostatHighLowAlertControls: {
        alertHigh: core[33],
        alertLow: core[34]
      },
      ThermostatSetpointControls: {
        heatTo: core[140],
        coolTo: core[87]
      },
      ThermostatSetpoints: {
        coolToHeatTo: core[89],
        heatToCoolTo: core[142],
        heatTo: core[141],
        coolTo: core[88]
      },
      ThermostatStatusPane: {
        outside: core[209],
        humidity: core[148],
        compressor: core[79]
      },
      TileControl: {
        Heat: core[373],
        Cool: core[374],
        Off: core[375]
      },
      ThermostatHumidityAlertControls: {
        alertHigh: core[396],
        alertLow: core[397]
      }
    },
    nexia_mobile: {
      pages: {
        ForgotCredentialsPage: {
          index: {
            usernameRequiredError: core[302],
            emailRequiredError: core[113],
            emailInvalidError: core[112],
            title: core[28],
            usernameCallToAction: core[122],
            usernameLabel: core[300],
            resetPasswordButton: core[231],
            passwordCallToAction: core[119],
            emailLabel: core[111],
            recoverUsernameButton: core[226]
          },
          ForgotCredentialsButton: {
            iForgotCredentials: core[149]
          },
          CredentialsRequestedDialog: {
            successPt1Template: core[272],
            successPt2Template: core[153],
            successPt3Template: core[131]
          }
        },
        LocalSettingsPage: {
          index: {
            title: core[43]
          },
          DealerOptInItem: {
            enableServiceContractor: core[115]
          },
          DeviceOrderingItem: {
            deviceOrderingLabel: core[99]
          },
          LogOutItem: {
            areYouSure: core[56],
            disassociateLabel: core[105],
            logoutLabel: core[176],
            yes: core[307],
            no: core[192]
          },
          RefreshDevicesItem: {
            networkUnavailable: core[312],
            refreshDevicesLabel: core[228]
          },
          ResetPinItem: {
            confirmChangePin: core[50],
            resetPinLabel: core[232]
          },
          UnlockAppItem: {
            caution: core[220],
            confirmRisk: core[150],
            pinUnlockMessage: core[320],
            biometricUnlockMessageTemplate: core[321],
            biometricUnlockLabel: core[295],
            pinUnlockOnlyLabel: core[297],
            pinUnlockLabel: core[296],
            noAuthorizationLabel: core[194],
            unlockAppLabel: core[294]
          },
          LanguageItem: {
            languageLabel: core[359]
          }
        },
        AccessRestrictionPage: {
          none: core[197],
          saving: core[244],
          saveSuccessful: core[25],
          applyToAdditional: core[47],
          yes: core[307],
          no: core[192],
          arNoneLabel: core[197],
          arLowLabel: core[178],
          arMediumLabel: core[181],
          arHighLabel: core[145],
          arNoneText: core[38],
          arLowText: core[104],
          arMediumText: core[103],
          arHighText: core[39],
          title: core[24],
          description: core[26],
          cancel: core[69],
          apply: core[44]
        },
        PinAccessPage: {
          title: core[236],
          descriptionPt1: core[234],
          descriptionPt2: core[156],
          cancel: core[69],
          apply: core[44],
          savingPinsMessage: core[323],
          pinSaveSuccessToast: core[324],
          applyPinsToAdditionalThermostats: core[325],
          yes: core[307],
          no: core[192],
          pinLengthError: core[326],
          mainPinCheckboxLabel: core[327],
          mainPinCheckboxHeader: core[328],
          techPinCheckboxLabel: core[329],
          techPinCheckboxHeader: core[330]
        },
        CreatePinEntryPage: {
          pinSaveSuccessfully: core[215],
          entriesDontMatch: core[123],
          setAPin: core[253],
          setAn8DigitPin: core[254],
          confirmPin: core[81]
        },
        ValidatePinEntryPage: {
          reauthPromptMessageTemplate: core[322],
          reauthSubmitButton: core[232],
          reauthTitle: core[232],
          reauthNewPinToast: core[219],
          pinDisabledTemplate: core[213],
          enterPin: core[120]
        },
        ThermostatAlertsPage: {
          savingAlerts: core[245],
          saveSuccessful: core[36],
          saveError: core[318],
          applyAlertsToAdditionalStats: core[48],
          yes: core[307],
          no: core[192],
          cancel: core[69],
          apply: core[44],
          title: core[35],
          faultsEnabled: core[315],
          highLowEnabled: core[146],
          humidityEnabled: core[398],
          faultAlert: core[412],
          enabled: core[413],
          disabled: core[414],
          highLowAlertTitle: core[415],
          humidityAlertTitle: core[416],
          above: core[417],
          below: core[418],
          AlertStatusText: core[419],
          AlertEnabled: core[420],
          Alert: core[421],
          highLowAlertError1: core[436],
          highLowAlertError2: core[437]
        },
        DeviceAdvancedInfoPage: {
          lastUpdated: core[157],
          title: core[32]
        },
        DeviceSettingsPage: {
          settings: core[259]
        },
        OccupancySetpointsPage: {
          occupiedLabel: core[201],
          unoccupiedLabel: core[298],
          savingSetpoints: core[316],
          saveSuccessful: core[317],
          saveError: core[318],
          applyToAdditionalStats: core[319],
          title: core[200],
          cancel: core[69],
          apply: core[44],
          yes: core[307],
          no: core[192]
        },
        WelcomePage: {
          logIn: core[175],
          exploreDemo: core[126],
          signUpNow: core[262]
        },
        SignInPage: {
          title: core[260],
          submit: core[266],
          pin: core[299],
          pointedToTemplate: core[223],
          usernameLabel: core[300],
          passwordLabel: core[370]
        },
        SignUpSchemaPage: {
          signUp: core[261],
          transferAccount: core[407],
          greeting: core[410],
          description: core[411],
          usernameInformation: core[422]
        },
        SignUpInfoPage: {
          "continue": core[83],
          loading: core[163]
        },
        SignUpChallengePage: {
          "continue": core[83]
        },
        SignUpComplete: {
          title: core[27],
          createdMessage: core[311],
          "continue": core[83]
        },
        TransferAccountInfoPage: {
          "continue": core[83],
          loading: core[409]
        },
        ResetPasswordPage: {
          errorToast: core[40],
          success: core[210],
          title: core[231],
          instructions: core[221],
          resetPassword: core[231],
          loading: core[170]
        },
        ActivatePhonePage: {
          title: core[29],
          enter12DigitCode: core[118]
        },
        AlertListPage: {
          loadingAlerts: core[164],
          clear: core[77],
          noAlertsActive: core[193],
          subscribeCallToAction: core[289],
          confirmCallToActionPt1: core[286],
          confirmCallToActionPt2: core[331],
          title: core[35],
          settingsButtonLabel: core[384],
          settingsButtonLabelForUsers: core[429],
          clearAll: core[78],
          clearAllConfirm: core[51],
          yes: core[307],
          no: core[192]
        },
        AlerterListEditPage: {
          title: core[429],
          save: core[241],
          name: core[187],
          sendTo: core[430],
          at: core[431],
          phoneNumber: core[432],
          emailAddress: core[110],
          all: core[433],
          none: core[197],
          custom: core[434],
          alertsLabel: core[435]
        },
        AlerterListUserPage: {
          title: core[423],
          addContact: core[425],
          description: core[426],
          editButtonLabel: core[427],
          deleteButtonLabel: core[428],
          pushNotificationTitle: core[438],
          description1: core[439]
        },
        CreateGroupPage: {
          loadingDevices: core[168]
        },
        ErrorPage: {
          somethingWentWrong: core[264],
          teamNotified: core[332],
          restartTheApp: core[233]
        },
        EventsPage: {
          title: core[124],
          noRecentActivity: core[196],
          dateToEarly: core[376],
          dateToLate: core[377],
          on: core[378],
          at: core[379],
          by: core[380],
          "Device Event": core[381],
          "Scheduled Event": core[382],
          "Web Browsers": core[383]
        },
        SupportPage: {
          deviceOfflineToast: core[284],
          operationCompleteToast: core[207],
          callSupportTemplate: core[68],
          emailSupport: core[114],
          sendSuggestionsOrFeedback: core[251],
          licenseInformation: core[158],
          termsAndConditionsLabel: core[270],
          helpDocumentationLabel: core[144],
          title: core[268],
          pivotMobleApp: core[217],
          loading: core[174],
          loginLabel: core[177],
          emailLabel: core[110],
          versionLabel: core[304],
          PasswordChangeMessage: core[395],
          passwordRequired: core[406]
        },
        NotFoundPage: {
          pageNotFound: core[333],
          goBack: core[135]
        },
        OpenSourceLicensePage: {
          title: core[206],
          description: core[274],
          acknowledgementText1: core[399],
          acknowledgementAddressLine1: core[400],
          acknowledgementAddressLine2: core[401],
          acknowledgementAddressLine3: core[402],
          acknowledgementAddressLine4: core[403],
          acknowledgementAddressLine5: core[404],
          acknowledgementText2: core[405]
        },
        PhonesPage: {
          title: core[303],
          newUserButton: core[191]
        },
        RuntimeHistoryPage: {
          dailyButtonLabel: core[94],
          montlyButtonLabel: core[184],
          loadingDaily: core[166],
          loadingMonthly: core[169],
          title: core[240]
        },
        SchemaEditPage: {
          savingMessage: core[334],
          deletingMessage: core[97],
          deleteConfirmationMessage: core[55],
          deleteConfirmationButton: core[96]
        },
        GroupDetailsPage: {
          loadingDevices: core[168],
          emptyGroupMessage: core[282],
          editGroupButton: core[109]
        },
        HomePage: {
          loadingBuilding: core[165]
        },
        InternetRequiredPage: {
          title: core[252],
          serviceUnavailableLabel: core[252],
          serviceUnavailableDescription: core[305],
          retryButton: core[239]
        },
        BuildingDashboardPage: {
          title: core[186],
          noDevicesTitle: core[186]
        },
        BuildingEditPage: {
          save: core[241]
        },
        BuildingsPage: {
          title: core[64],
          newBuilding: core[189]
        },
        ThermostatScheduleEditPage: {
          index: {
            activeScheduleTitle: core[365],
            discardConfirmation: core[340],
            discardButton: core[341],
            savedSchedulesTitle: core[243],
            emptySavedSchedulesMessage: core[310],
            loadButton: core[160],
            saveAsTitle: core[242],
            mustHaveANameWarning: core[342],
            SaveButton: core[241],
            initialSaveText: core[343]
          },
          actions: {
            savedAsNameTemplate: core[344],
            savingScheduleMessage: core[345],
            scheduleAlreadyExistsTemplate: core[346],
            yes: core[307],
            no: core[192],
            couldntLoadSchedule: core[347],
            scheduleInvalidTemplate: core[348],
            scheduleDoesNotMatchTempScaleTemplate: core[349],
            deletingScheduleTemplate: core[350],
            savingSchedule: core[351],
            savingSchedules: core[352],
            scheduleSaveSuccess: core[353],
            applyScheduleToAdditionalStats: core[354],
            loadedScheduleTemplate: core[355]
          }
        },
        PhoneEditPage: {
          saveButton: core[241],
          controllableThermostatsLabel: core[424]
        }
      },
      utils: {
        ajax_hooks: {
          reauthenticationToast: core[283]
        },
        backstage: {
          requestTimeout: core[277]
        },
        validateFields: {
          labelRequiredTemplate: core[5],
          labelDoesNotMatchTemplate: core[3],
          labelInvalidTemplate: core[4],
          labelExactLengthCharsTemplate: core[8],
          labelMinLengthCharsTemplate: core[13],
          labelMaxLengthCharsTemplate: core[9],
          labelMinNumberTemplate: core[12],
          labelMaxNumberTemplate: core[1],
          labelEarlyTemplate: core[6],
          labelLateTemplate: core[7]
        },
        flux_like: {
          network: {
            requestTimedOut: core[277]
          },
          pin: {
            invalidPinToast: core[154]
          }
        },
        ToastMsg: {
          dismiss: core[106]
        }
      },
      controls: {
        ActionButtons: {
          tellingActionTemplate: core[335]
        },
        ActivateUser: {
          newActivationConfirmation: core[152]
        },
        ThermostatDetailControls: {
          heatAndCoolToTemplate: core[258],
          heatToTemplate: core[257],
          coolToTemplate: core[256]
        },
        ThermostatModesControl: {
          modeChangeTemplate: core[73],
          applyToAdditionalStatsTemplate: core[45],
          yes: core[307],
          no: core[192]
        }
      },
      details: {
        BuildingDetails: {
          minOneBuilding: core[281],
          deleteConfirmation: core[53],
          "delete": core[96],
          hasDevicesCannotDelete: core[336],
          nameLabel: core[187],
          postalCodeLabel: core[224],
          buildingDetailsLabel: core[66],
          devices: core[100],
          none: core[197]
        },
        BuildingHeader: {
          buildingConfiguration: core[64]
        },
        PhoneDetails: {
          deleteUserConfirmation: core[54],
          "delete": core[96],
          platformLabel: core[218],
          manufacturerLabel: core[180],
          osVersionLabel: core[208],
          nameLabel: core[187],
          pivotAppVersionLabel: core[216],
          authTypeLabel: core[59],
          activationCodeType: core[30],
          usernamePasswordType: core[301],
          newActivationCode: core[188],
          getActivationCode: core[133],
          activationCode: core[30],
          deviceDetailsLabel: core[337]
        }
      },
      DeviceAdvancedSettingItemList: {
        accessRestrictionPageItem: {
          accessLevelLabel: core[235]
        },
        advancedInfoPageItem: {
          advancedLabel: core[32]
        },
        pinAccessPageItem: {
          passcodeLabel: core[236]
        },
        thermostatAlertsPageItem: {
          alertsLabel: core[35]
        },
        unenrollItem: {
          removeDeviceLabelTemplate: core[229],
          removeConfirmationTemplate: core[57],
          unenrollingTemplate: core[292]
        }
      },
      Toolbar: {
        DeviceDetailsToolbar: {
          loadingSchedule: core[173],
          scheduleLoadFailure: core[128],
          loadingScheduleList: core[171],
          loadingDefaultSchedule: core[167],
          thermostatNotconnected: core[338],
          scheduleDisabledEnableCallToAction: core[249],
          schedulesLabel: core[246],
          setpointsLabel: core[255],
          loadingSetpoints: core[172],
          eventsLabel: core[124],
          historyLabel: core[147],
          settingsLabel: core[259]
        },
        FilterItem: {
          clearButton: core[77],
          applyButton: core[44],
          filterLabel: core[385]
        },
        PivotScheduleChooser: {
          savedSchedulesTitle: core[243],
          emptyMessage: core[310],
          load: core[160]
        }
      },
      PinEntry: {
        PinLengthConfiguration: {
          pinLengthButton: core[214],
          pinLengthOptionTemplate: core[16]
        },
        PivotPinEntryWrapper: {
          forgotPinButton: core[132],
          EULApt1: core[67],
          EULApt2Link: core[339],
          privacyPolicy: core[225],
          termsOfUse: core[271]
        }
      },
      models: {
        base_model: {
          unkownError: core[41]
        },
        device_sorter: {
          nameSortDescription: core[37],
          devicesSortDescription: core[102],
          groupSortDescription: core[137]
        },
        setting: {
          descriptionPastTemplate: core[71],
          // template: title, label
          descriptionPresentTemplate: core[74],
          // template: title, label
          descriptionFailureTemplate: core[127] // template: title, label

        }
      },
      device_features: {
        runtime_history: {
          retrievingMonthlyHistory: core[238],
          retrievingDailyHistory: core[237]
        },
        schedule: {
          scheduleEnableSuccess: core[248],
          scheduleEnableFailure: core[247]
        }
      },
      dialogs: {
        ChooseOrDeleteDialog: {
          deleteConfirmationTemplate: core[52],
          deleteButton: core[96],
          emptyMessage: core[356],
          cancelButton: core[69],
          confirmButton: core[204]
        },
        InternetRequiredDialog: {
          internetRequiredMessage: core[305]
        },
        PaginationDialog: {
          selectPageHeader: core[250]
        },
        PivotDevicesGroupsDialog: {
          thermostatsTitle: core[280],
          cancel: core[69],
          apply: core[44]
        },
        PivotChooseDialog: {
          emptyMessage: core[356],
          cancelButton: core[69],
          confirmButton: core[204]
        },
        LanguageDialog: {
          savingLanguages: core[361],
          setViaDevice: core[360],
          selectLanguage: core[362]
        },
        PromptDialog: {
          defaultCancelText: core[69],
          defaultConfirmText: core[204],
          defaultRequiredWarningText: core[363]
        },
        ConfirmationDialog: {
          defaultCancelText: core[69],
          defaultConfirmText: core[204]
        },
        LoginConfirmationDialog: {
          defaultCancelText: core[69],
          defaultConfirmText: core[204],
          passwordLabel: core[370]
        }
      },
      PivotWelcomePageBrandLogo: {
        welcomeToPivot: core[306]
      },
      PivotOccupancyModeExtra: {
        occupied: core[201],
        unoccupied: core[298],
        occupiedTimeRemaining: core[202]
      },
      MainMenuWithoutColor: {
        note: core[357],
        selectBuldingToEnable: core[198],
        createGroupButton: core[93],
        dashboardLabel: core[95],
        alertsLabel: core[35],
        eventsLabel: core[124],
        usersLabel: core[303],
        usernamePasswordPrompt: core[222],
        manageUsersTitle: core[179],
        buildingConfigurationLabel: core[64],
        exitDemoLabel: core[125],
        appSettingsLabel: core[43],
        supportAndFeedbackLabel: core[268],
        enrollNewDeviceButton: core[116]
      },
      SettingListView: {
        applyToAdditionalStatsTemplate: core[45],
        yes: core[307],
        no: core[192]
      },
      validatable: {
        labelRequiredTemplate: core[5],
        labelDoesNotMatchTemplate: core[3],
        labelInvalidTemplate: core[4],
        labelExactLengthCharsTemplate: core[8],
        labelMinLengthCharsTemplate: core[13],
        labelMaxLengthCharsTemplate: core[9],
        labelMinNumberTemplate: core[12],
        labelMaxNumberTemplate: core[1]
      },
      NoDevicesPageCommercial: {
        noStatsEnrolledYetTemplate: core[17],
        tapEnrollCallToActionTemplate: core[151],
        enrollNewDevicebutton: core[116]
      },
      PivotDemoBanner: {
        saveDoesNotOccur: core[98]
      },
      PivotDemoMessage: {
        demoMessage: core[358],
        okButton: core[204]
      },
      EnrollmentWizard: {
        ChooseADevice: {
          notCompatibleMessage: core[285]
        },
        EnrollDevice: {
          getCodeDescriptionTemplate: core[287],
          otherBuildingDescription: core[288],
          getCodeButton: core[134],
          buildingDashboardButton: core[65]
        },
        EnrollingDevice: {
          enrollmentSuccessfulTemplate: core[267],
          enrollmentFailed: core[117]
        },
        EnrollmentWizardAppBar: {
          enroll: core[386],
          enrolling: core[387]
        },
        WizardFooter: {
          cancel: core[69]
        }
      },
      BuildingInfoTile: {
        loadingBuildingTemplate: core[162]
      },
      AppBarButtons: {
        deleteButton: core[96],
        editButton: core[364],
        saveButton: core[241],
        saveAsButton: core[242],
        loadButton: core[160]
      },
      PhoneHeader: {
        mobileUserLabel: core[371]
      },
      SupportCode: {
        supportCodeLabel: core[372]
      },
      UserAgent: {
        chromeVersion: core[367],
        unknownVersion: core[369],
        webView: core[368]
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (stringsProvider);

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(398),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(810);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(196);






var MAX_SIGNED_31_BIT_INT = 1073741823;

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + __WEBPACK_IMPORTED_MODULE_3_gud___default()() + '__';

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer =
  /*#__PURE__*/
  function (_Component2) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_inheritsLoose___default()(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(816)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(159);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_UserAgent__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_QueryParams__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_utils_sleep__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var oldWebView = __WEBPACK_IMPORTED_MODULE_9_nx_components_UserAgent__["a" /* default */].isCrossWalk() || __WEBPACK_IMPORTED_MODULE_10_nx_components_QueryParams__["a" /* default */].platform() === "ios-uiwebview";
var ANIMATION_DURATION = 200; // boxShadow makes the pages look like they're on top of each other, but on some
// retina displays it replaces the bottom pixel. Shift it up 10px; the illusion
// of depth will still be there but the bottom pixel is now visible.

var boxShadow = "0 -10px 4px rgba(0, 0, 0, 0.25)";

// This renders a div with some ref methods on it that change the styles so that
// it transitions in and out. The styles on the div are not updated using
// setState as a performance optimization because re-rendering the entire child
// Page you put inside this as you move it around is unnecessary.
var PageTransition =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(PageTransition, _React$Component);

  function PageTransition() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, PageTransition);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(PageTransition)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isIn", _this.props.initialInValue != null ? _this.props.initialInValue : true);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_shouldTransition", true);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_slide", function _callee(isIn) {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_utils_sleep__["a" /* default */])(0));

            case 2:
              _this._shouldTransition = false;
              _this._isIn = !isIn;

              _this._updateDivStyle();

              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_utils_sleep__["a" /* default */])(0));

            case 7:
              _this._shouldTransition = true;

              _this._updateDivStyle();

              _context.next = 11;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_utils_sleep__["a" /* default */])(0));

            case 11:
              _this._isIn = isIn;

              _this._updateDivStyle();

              _context.next = 15;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(_this._transitionEndPromise());

            case 15:
            case "end":
              return _context.stop();
          }
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "slideIn", function () {
      return _this._slide(true);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "slideOut", function () {
      return _this._slide(false);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "teleportIn", function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.async(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_utils_sleep__["a" /* default */])(0));

            case 2:
              _this._shouldTransition = false;
              _this._isIn = true;

              _this._updateDivStyle();

              _context2.next = 7;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap(Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_utils_sleep__["a" /* default */])(0));

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "focus", function () {
      if (_this._div == null) {
        return;
      }

      _this._div.focus();
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(PageTransition, [{
    key: "_transitionEndPromise",
    value: function _transitionEndPromise() {
      var _this2 = this;

      if (oldWebView) {
        return Promise.resolve();
      }

      var _done;

      return new Promise(function (resolve) {
        if (_this2._div == null) {
          resolve();
          return;
        }

        _done = function done() {
          if (_this2._div == null) {
            resolve();
            return;
          }

          _this2._div.removeEventListener("transitionend", _done);

          resolve();
        };

        _this2._div.addEventListener("transitionend", _done); // In case the browser doesn't support transitionend, or in case we miss
        // the transitionend (due to the main thread being blocked for the
        // duration of the transition). If this never resolves, the whole app
        // could get frozen (since we await the page transition promise a lot), so
        // we want to have a safe fallback here.


        Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_utils_sleep__["a" /* default */])(ANIMATION_DURATION).then(_done);
      });
    }
    /* public ref interface */

  }, {
    key: "_calculateDivStylesForTransition",

    /* public ref interface end */
    value: function _calculateDivStylesForTransition() {
      return {
        transition: this._shouldTransition && !oldWebView ? "transform ".concat(ANIMATION_DURATION, "ms ease-in-out") : "",
        // Add 2% is to get the shadow off the screen AND work around #157490429
        transform: "translateX(".concat(this._isIn ? "0%" : "102%")
      };
    }
  }, {
    key: "_updateDivStyle",
    value: function _updateDivStyle() {
      if (this._div == null) {
        return;
      }

      Object.assign(this._div.style, this._calculateDivStylesForTransition());
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          id = _this$props.id;
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        id: id,
        ref: function ref(el) {
          return _this3._div = el;
        },
        style: _objectSpread({
          position: "absolute",
          width: "100%",
          height: "100%",
          boxShadow: boxShadow,
          backgroundColor: "white"
        }, this._calculateDivStylesForTransition(), {}, this.props.style),
        tabIndex: "-1"
      }, children);
    }
  }]);

  return PageTransition;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(PageTransition, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.node,
  style: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object,
  initialInValue: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string
});




/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubMemoryRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(81);









 // This is used to render a portion of a MemoryRouter, for the sake of showing
// old state in transitions. If you call any methods on its history, it actually
// calls the method on outer history (provided to this component via a Router).

var SubMemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SubMemoryRouter, _React$Component);

  function SubMemoryRouter() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SubMemoryRouter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SubMemoryRouter)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_history", {});

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SubMemoryRouter, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["c" /* Route */], {
        render: function render(_ref) {
          var outerHistory = _ref.history;
          var _this2$props = _this2.props,
              index = _this2$props.index,
              entries = _this2$props.entries;
          Object.assign(_this2._history, outerHistory, {
            index: index,
            entries: entries,
            length: entries.length,
            location: entries[index]
          });
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["d" /* Router */], {
            history: _this2._history
          }, _this2.props.children);
        }
      });
    }
  }]);

  return SubMemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SubMemoryRouter, "propTypes", {
  entries: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object).isRequired,
  index: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
});



/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function parseURI (str, opts) {
  opts = opts || {}

  var o = {
    key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
    q: {
      name: 'queryKey',
      parser: /(?:^|&)([^&=]*)=?([^&]*)/g
    },
    parser: {
      strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
      loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
    }
  }

  var m = o.parser[opts.strictMode ? 'strict' : 'loose'].exec(str)
  var uri = {}
  var i = 14

  while (i--) uri[o.key[i]] = m[i] || ''

  uri[o.q.name] = {}
  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
    if ($1) uri[o.q.name][$1] = $2
  })

  return uri
}


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

		// Don't send a synthetic click to disabled inputs (issue #62)
		case 'button':
		case 'select':
		case 'textarea':
			if (target.disabled) {
				return true;
			}

			break;
		case 'input':

			// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
			if ((deviceIsIOS && target.type === 'file') || target.disabled) {
				return true;
			}

			break;
		case 'label':
		case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
		case 'video':
			return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
		case 'textarea':
			return true;
		case 'select':
			return !deviceIsAndroid;
		case 'input':
			switch (target.type) {
			case 'button':
			case 'checkbox':
			case 'file':
			case 'image':
			case 'radio':
			case 'submit':
				return false;
			}

			// No point in attempting to focus disabled inputs
			return !target.disabled && !target.readOnly;
		default:
			return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

			// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (true) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return FastClick;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());


/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__connection__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enrollment__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fingerprint__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__location__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__network__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__news__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pin__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__platform__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__polling__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__resource__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__session__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__spinner__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__toaster__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__video__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__vognition__ = __webpack_require__(1281);
// Load all the action handlers in the app

















/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_BackButtonResponder__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_utils_enqueueIn__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Dialogs_renderInDestroyableRoot__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_app_state__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_framework_resource__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_ajax_hooks__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_session__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_demo_session__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_commercial_demo_session__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_version__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_api_xr724__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_api_dragonfly__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_components_App__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_event_stream__ = __webpack_require__(278);























var showWebView = function showWebView() {
  Object(__WEBPACK_IMPORTED_MODULE_3_nx_components_utils_enqueueIn__["b" /* default */])(function () {
    // Wait a tick to make sure all layout issues are resolved. We use enqueueIn
    // to work around edge cases where an invisible webview never fires setTimeout
    __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_platform__["a" /* default */].showWebView();
  }, 0);
};

var setInitialUserAuthenticated = function setInitialUserAuthenticated() {
  var needsAuth = !__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].isActivated() && __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].getCurrentAuth() !== __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["b" /* AUTH_TYPES */].NONE && __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].needsPin();
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("appState.userAuthenticated", !needsAuth);
};

__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_LAUNCH", function () {
  Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("INIT_CONNECTION_TRACKING");
  __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_ajax_hooks__["a" /* default */].init();
  var listener = new __WEBPACK_IMPORTED_MODULE_2_nx_components_BackButtonResponder__["a" /* BackButtonListener */]();
  __WEBPACK_IMPORTED_MODULE_2_nx_components_BackButtonResponder__["a" /* BackButtonListener */].setSingleton(listener);
  listener.startListening();
  __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].listenTo(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_platform__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_platform__["a" /* default */].Event.APP_PAUSE, function () {
    return Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_PAUSE");
  });
  __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].listenTo(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_platform__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_platform__["a" /* default */].Event.APP_RESUME, function () {
    return Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_RESUME");
  });
  Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("START_LISTENING_TO_PLATFORM_EVENTS");
  Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("START_LISTENING_TO_PLATFORM_BACK_BUTTON");

  if (!__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_platform__["a" /* default */].appVersion) {
    // On Mobile platforms, the native sets the app version.
    // We want to always have a version, even in the browser,
    // because the server cares about it.
    var numericVersion = __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_version__["a" /* default */].split("-")[0];
    __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_platform__["a" /* default */].setAppVersion(numericVersion);
  }

  if (__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["a" /* default */].appState) {
    __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["a" /* default */].appState.stopListening();
  }

  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("appState", new __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_app_state__["a" /* default */]());
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("session", new __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_session__["a" /* default */]());
  setInitialUserAuthenticated();

  if (__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].isActivated()) {
    Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("SETUP_LOCATION_POLLING");
  }

  $("body").find(".spinner-background").remove();
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("isAuthAttemptLockedOut", __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].isAuthAttemptLockedOut());
  Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_MOUNT_REACT");
  showWebView();
});
__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_MOUNT_REACT", function () {
  document.body.innerHTML = '<div id="root"></div>';
  __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_components_App__["a" /* default */], null), document.querySelector("#root"));
});
__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_RESET_PASSWORD_CODE", function (resetPasswordCode) {
  Object(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/reset-password");
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("resetPasswordCode", resetPasswordCode);
});
__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_TRANSFER_ACCOUNT_CODE", function (transferAccountCode) {
  Object(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/transfer-account/user-info");
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("transferAccountCode", transferAccountCode);
});
__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_TRANSFER_ACCOUNT_SUCCESS", function (message) {
  Object(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/welcome");
  Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", message);
});
__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_PAUSE", function () {
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("isAppPaused", true);
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("appLastPausedAt", Date.now());
  Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("STOP_VOGNITION_LISTENER");
  __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_event_stream__["a" /* default */].pause();
});

function pausedLongEnoughAgoThatAuthorizationIsRequired() {
  var oneHour = 60 * 60 * 1000;
  var oneMinute = 1 * 60 * 1000;
  var longEnoughAgo = Object(__WEBPACK_IMPORTED_MODULE_17_nexia_mobile_api_xr724__["b" /* currentlyConfiguring724 */])() || Object(__WEBPACK_IMPORTED_MODULE_18_nexia_mobile_api_dragonfly__["a" /* currentlyConfiguringDragonfly */])() ? // Increase the amount of time the app must be paused for before pin entry
  // is shown, because if we show pin entry while they are configuring a 724,
  // when they finish pin entry, it will go to the dashboard, instead of to
  // the in-progress enrollment. Plus, the user has to switch back and forth
  // between the app and the phone's WiFi settings as part of the
  // configuration process, and it'd be annoying to have to put their pin in
  // while doing that.
  oneHour : oneMinute;
  return __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["a" /* default */].appLastPausedAt && Date.now() - longEnoughAgo > __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["a" /* default */].appLastPausedAt;
}

__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_RESUME", function () {
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("isAppPaused", false);
  Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("CHECK_NETWORK_STATUS");

  if (__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].isActivated() && pausedLongEnoughAgoThatAuthorizationIsRequired()) {
    Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_SOFT_RESTART");
  } else {
    __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_event_stream__["a" /* default */].resume();
  }

  showWebView();
}); // The app was paused for long enough that we want to treat the pause/resume
// that just occurred more like a restart. So things that happen "at launch"
// should happen now.

__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_SOFT_RESTART", function () {
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("userCancelledFingerprint", false);
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("vognition.listenOnStartupPending", true);
  var shouldReauthorize = !__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].canSkipLogin() && !__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["a" /* default */].appState.inDemoMode;

  if (shouldReauthorize) {
    Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_REAUTHORIZE_FROM_RESUME");
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("POPULATE_SESSION");
    Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("START_VOGNITION_LISTENER_FROM_STARTUP");
  }
});
__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_LOG_IN", function (mobileId, apiKey, setupStep, locale) {
  if (setupStep === "signup_survey") {
    __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_history__["d" /* history */].push("/signup/survey", {
      mobileId: mobileId,
      apiKey: apiKey
    });
  } else if (setupStep === "promo_code") {
    __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_history__["d" /* history */].push("/signup/promo-code", {
      mobileId: mobileId,
      apiKey: apiKey
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].setMobileIdAndApiKey(mobileId, apiKey);
    __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].setLocale(locale);
    setInitialUserAuthenticated();
    Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("session", new __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_session__["a" /* default */]());
    Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("SETUP_LOCATION_POLLING");
    Object(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/");
  }
});
__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_LOG_OUT", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(function () {
    __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_event_stream__["a" /* default */].end();

    if (options.failedAuthentication) {
      Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("CANCEL_FINGERPRINT");
    } else {
      __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["a" /* default */].session.destroy({
        silent: true
      });
    }

    __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["a" /* default */].appState.stopListening();
    __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_ajax_hooks__["a" /* default */].abortAllActiveRequests();
    __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_framework_resource__["a" /* ResourceMap */].clearAll();
    Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("TEARDOWN_LOCATION_POLLING");
    __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_platform__["a" /* default */].clearSessionCache();
    __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_platform__["a" /* default */].resetAppBadge();
    var locale = __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].getLocale();
    __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].clear();
    __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_local_settings__["c" /* default */].setLocale(locale);
    Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["c" /* resetStore */])();
    Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("appState", new __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_app_state__["a" /* default */]());
    Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("session", new __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_session__["a" /* default */]());
    Object(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/");
  });
});
__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_ENTER_DEMO_MODE", function () {
  __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_platform__["a" /* default */].sendGoogleAnalyticsEvent("Dispatch", "APP_ENTER_DEMO_MODE");
  __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["a" /* default */].appState.stopListening();
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("appState", new __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_app_state__["a" /* default */]({
    inDemoMode: true,
    isFirstVisit: true
  }));
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("session", __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_environment__["a" /* default */].isCommercial() ? new __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_commercial_demo_session__["a" /* default */]() : new __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_demo_session__["a" /* default */]());
  Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("POPULATE_SESSION");
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("demoModeEvents", {});
  Object(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/");
});
__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_FIRST_DEMO_VISIT", function () {
  __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["a" /* default */].appState.isFirstVisit = false;
});
__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_REAUTHORIZE_FROM_RESUME", function () {
  // Close any dialogs that are not automatically unmounted so they don't cover auth.
  Object(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Dialogs_renderInDestroyableRoot__["a" /* closeAllDestroyableDialogs */])();
  Object(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/");
});
__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */].on("SCREEN_READER_RUNNING_CHANGED", function (newValue) {
  Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("isScreenReaderRunning", newValue);
});

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(398),q=__webpack_require__(826);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),cc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},dd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ed={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=ed[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?dd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},wd=0;for(;wd<td.length;wd++){var yd=td[wd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===cc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<cc.length;h++)F(cc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<cc.length;d++)F(cc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode&&!k.alternate){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;
e.lastEffect=b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=
V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){do Sj();while(null!==Ej);if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=
null;me={focusedElem:g,selectionRange:h};Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,
Y);break;case 4:aj(Y.alternate,Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),
l=p.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});
"function"===typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var dc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var fd=t.stateNode;if(t.effectTag&4)if(null===dc)fd.componentDidMount();else{var hk=t.elementType===t.type?dc.memoizedProps:mg(t.type,dc.memoizedProps);fd.componentDidUpdate(hk,dc.memoizedState,
fd.__reactInternalSnapshotBeforeUpdate)}var Eh=t.updateQueue;null!==Eh&&Kg(t,Eh,fd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===dc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=
Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var xd=Y.ref;if(null!==xd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof xd?xd(t):xd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&
(jj=null);1073741823===b?a===Ij?Hj++:(Hj=0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}vk.prototype.render=function(a,b){rk(a,this._internalRoot,null,void 0===b?null:b)};vk.prototype.unmount=function(a){var b=this._internalRoot,c=void 0===a?null:a,d=b.containerInfo;rk(null,b,null,function(){d[we]=null;null!==c&&c()})};
function wk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function yk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new vk(a,0,b?{hydrate:!0}:void 0)}
function zk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=yk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Ak(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};eb=bk;
fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!wk(b))throw Error(u(200));return Ak(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!0,c)},render:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!wk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return zk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!wk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){zk(null,null,a,!1,function(){a._reactRootContainer=null;a[we]=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.12.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(827);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(829);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(265),
    castPath = __webpack_require__(408),
    isIndex = __webpack_require__(410),
    isObject = __webpack_require__(102),
    toKey = __webpack_require__(411);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(122);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(404),
    isMasked = __webpack_require__(834),
    isObject = __webpack_require__(102),
    toSource = __webpack_require__(406);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(197);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 833 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(835);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(71);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 836 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(138),
    isSymbol = __webpack_require__(198);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(839);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(840);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(409);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(842),
    ListCache = __webpack_require__(201),
    Map = __webpack_require__(266);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(843),
    hashDelete = __webpack_require__(844),
    hashGet = __webpack_require__(845),
    hashHas = __webpack_require__(846),
    hashSet = __webpack_require__(847);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(200);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 844 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(200);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(200);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(200);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 848 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(202);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(202);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(202);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(202);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(203);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 854 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(203);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(203);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(203);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(859);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(197),
    arrayMap = __webpack_require__(860),
    isArray = __webpack_require__(138),
    isSymbol = __webpack_require__(198);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 860 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(408),
    toKey = __webpack_require__(411);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState = {
  appState: null,
  session: null,
  showAlertsBadge: false,
  isAuthAttemptLockedOut: false,
  isNetworkConnected: undefined,
  isAppPaused: false,
  appLastPausedAt: null,
  xr724Enrollment: {
    detailsHaveBeenFetched: false,
    pin: null,
    statusUrl: null,
    childSchemaLink: null,
    cancelLink: null,
    wizardExpiresAt: null,
    userKey: null,
    networks: null,
    chosenNetwork: null,
    errorMessage: null,
    isErrorRecoverable: true
  },
  xr724WifiConfiguration: {
    userKey: null,
    networks: null,
    chosenNetwork: null
  },
  dragonflyEnrollment: {
    detailsHaveBeenFetched: false,
    pin: null,
    statusUrl: null,
    cancelLink: null,
    wizardExpiresAt: null,
    networks: null,
    chosenNetwork: null,
    errorMessage: null,
    isErrorRecoverable: true
  },
  dragonflyWifiConfiguration: {
    networks: null,
    chosenNetwork: null
  },
  locationPolling: {
    disableStack: 0
  },
  vognition: {
    listenOnStartupPending: true,
    isMicrophoneButtonActive: false,
    isMicrophoneButtonLoading: false
  },
  newsDialogOpen: false,
  forceChoiceDialogOpen: false,
  isScreenReaderRunning: false,
  userCancelledFingerprint: false,
  backgroundLoading: false,
  isPlayingVideo: false,
  demoModeEvents: {},
  currentlyPollingEnrollmentStatus: false,
  spinnerShown: false,
  spinnerMessage: undefined,
  resetPasswordCode: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (initialState);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_framework_media_type__ = __webpack_require__(72);




var Link =
/*#__PURE__*/
function () {
  function Link(attrs, options) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Link);

    _.extend(this, attrs);

    this.options = options || {};

    if (!this.method) {
      this.method = "";
    }

    if (!this.data) {
      this.data = {};
    }

    if (!this.data._links) {
      this.data._links = {};
    }

    if (!this.data._links.self) {
      this.data._links.self = {
        href: this.href
      };
    }
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Link, [{
    key: "getHref",
    value: function getHref() {
      return this.href;
    }
  }, {
    key: "isTemplated",
    value: function isTemplated() {
      return Boolean(this.templated);
    }
  }, {
    key: "isPostLink",
    value: function isPostLink() {
      return this.method === "POST";
    }
  }, {
    key: "isPutLink",
    value: function isPutLink() {
      return this.method === "PUT";
    }
  }, {
    key: "hasData",
    value: function hasData() {
      return Boolean(this.data);
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "hasType",
    value: function hasType(mediaType) {
      if (_.isString(mediaType)) {
        return this.type === mediaType;
      } else {
        return Boolean(this.type);
      }
    }
  }, {
    key: "getCollectionItemType",
    value: function getCollectionItemType() {
      if (this.type !== __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_framework_media_type__["a" /* default */].COLLECTION) {
        return null;
      }

      if (this.data) {
        return this.data.item_type;
      }

      return null;
    }
  }]);

  return Link;
}();



/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_LinkRelationName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* eslint-disable camelcase */
// maps link relations to handler function names
// for example:
//    "next" : "DiscGolf"
//
//    will result in links with the relation "next"
//    getting parsed by a method called parseLinksDiscGolf
var Rel = {
  acknowledge: "Acknowledge",
  commit: "Commit",
  // save a schema to the server
  child: "Child",
  "child-schema": "ChildSchema",
  // schema for an item in a collection
  clear: "Clear",
  // clear a single alert
  clear_all: "ClearAll",
  // clear all alerts
  edit: "Edit",
  // edit an existing resource
  filter: "Filter",
  // filter a collection
  filter_events: "FilterEvents",
  filter_videos: "FilterVideos",
  image: "Image",
  // an image url
  "nexia:history": "History",
  next: "Next",
  // next in a series of items
  previous: "Previous",
  page: "Page",
  // a templated link to a page on a collection
  self: "Self",
  template: "Template",
  // TODO: remove, seems to duplicate child-schema
  parent: "Parent",
  operation: "Operation",
  // an arbitrary action with a human-readable title
  automate: "Automate",
  // a resource that can help automate the linking resource
  details: "Details",
  // further information for a resource
  video_url: "VideoURL",
  // video stream URL
  stream: "Stream",
  // event stream
  pending_request: "PendingRequest" // some additional data associated with the model that is incoming

};

var bpfrpt_proptype_LinkRelationName = function bpfrpt_proptype_LinkRelationName() {
  return (typeof $Keys === "function" ? __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf($Keys) : __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any).apply(this, arguments);
};

/* harmony default export */ __webpack_exports__["a"] = (Rel);



/***/ }),
/* 865 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPromiseWithAbort;
/* unused harmony export bpfrpt_proptype_PromiseWithAbort */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_PromiseWithAbort = {
  then: function then() {
    return (typeof $PropertyType === "function" ? __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf($PropertyType).isRequired : __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  "catch": function _catch() {
    return (typeof $PropertyType === "function" ? __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf($PropertyType).isRequired : __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  abort: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
};
// eslint-disable-next-line import/prefer-default-export
function createPromiseWithAbort(promise, abort) {
  // $FlowFixMe: Flow's internal Promise type doesn't know about then.bind and catch.bind
  return {
    then: promise.then.bind(promise),
    "catch": promise["catch"].bind(promise),
    abort: abort
  };
}



/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_Locales__ = __webpack_require__(44);





function addHeadersToRequest(xhr) {
  var appVersion = __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_platform__["a" /* default */].getAppInfo().app_version;

  if (appVersion) {
    xhr.setRequestHeader("X-AppVersion", appVersion);
  }

  var mobileId = __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_local_settings__["c" /* default */].getMobileId();

  if (mobileId) {
    xhr.setRequestHeader("X-MobileId", mobileId);
  }

  var apiKey = __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_local_settings__["c" /* default */].getApiKey();

  if (apiKey) {
    xhr.setRequestHeader("X-ApiKey", apiKey);
  }
}

function urlMatchesMobileAPIHost(url) {
  return url.indexOf(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_local_settings__["c" /* default */].getHost()) !== -1;
}

var activeRequests = new Set();
/* harmony default export */ __webpack_exports__["a"] = ({
  init: _.once(function () {
    $(document).ajaxSend(function (event, xhr, options) {
      if (!activeRequests.has(xhr)) {
        activeRequests.add(xhr);
      }

      xhr.setRequestHeader("Accept", "application/json");
      options.dataType = "json";
      options.timeout = 30000;

      if (urlMatchesMobileAPIHost(options.url)) {
        addHeadersToRequest(xhr);
      }
    });
    $(document).ajaxComplete(function (event, xhr) {
      activeRequests["delete"](xhr);
    });
    $(document).ajaxError(function (event, xhr) {
      var localeSet = Object(__WEBPACK_IMPORTED_MODULE_3_nx_components_Locales__["b" /* getLanguageSet */])();
      var language = localeSet.nexia_mobile.utils.ajax_hooks;
      activeRequests["delete"](xhr);

      if (xhr.statusText === "timeout") {
        Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */])("NETWORK_REQUEST_TIMEOUT");
      }

      try {
        var data = JSON.parse(xhr.responseText);
        var error = data.error.message;

        if (error.match(/mobile.*device.*not.*valid/i) && __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_local_settings__["c" /* default */].isActivated()) {
          Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", language.reauthenticationToast);
          Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_LOG_OUT", {
            failedAuthentication: true
          });
        }
      } catch (error) {// ignored
      }
    });
  }),
  abortAllActiveRequests: function abortAllActiveRequests() {
    activeRequests.forEach(function (xhr) {
      return xhr.abort();
    });
  }
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Alert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_base_model__ = __webpack_require__(36);







var Alert =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Alert, _BaseModel);

  function Alert() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Alert);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Alert).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Alert, [{
    key: "parseLinksClear",
    value: function parseLinksClear(links) {
      var link = _.first(links);

      this._clearHref = link ? link.getHref() : this._clearHref;
    }
  }, {
    key: "clear",
    value: function clear() {
      var model = new __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_base_model__["a" /* default */]();
      model.setAsEphemeral();
      model.setUrl(this._clearHref);
      return model.save({}, {
        method: "POST"
      });
    }
  }]);

  return Alert;
}(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_base_model__["a" /* default */]);



/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutomationCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_automation__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_framework_resource__ = __webpack_require__(85);













var AutomationCollection =
/*#__PURE__*/
function (_BaseCollection) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(AutomationCollection, _BaseCollection);

  function AutomationCollection() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AutomationCollection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(AutomationCollection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "model", __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_automation__["a" /* default */]);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AutomationCollection, [{
    key: "parse",
    value: function parse(attrs) {
      var _get2;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var automations = (_get2 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(AutomationCollection.prototype), "parse", this)).call.apply(_get2, [this, attrs].concat(args));

      return this._recycleAutomations(attrs, automations);
    }
  }, {
    key: "_parseModelsAsync",
    value: function _parseModelsAsync(attrs) {
      var _get3;

      var _len3,
          args,
          _key3,
          automations,
          _args = arguments;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.async(function _parseModelsAsync$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              for (_len3 = _args.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                args[_key3 - 1] = _args[_key3];
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap((_get3 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(AutomationCollection.prototype), "_parseModelsAsync", this)).call.apply(_get3, [this, attrs].concat(args)));

            case 3:
              automations = _context.sent;
              return _context.abrupt("return", this._recycleAutomations(attrs, automations));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "_recycleAutomations",
    value: function _recycleAutomations(attrs, automations) {
      var items = attrs.items || attrs.result;

      if (!items) {
        return automations;
      }

      if (!_.isArray(items) && items.items) {
        var _items = items;
        items = _items.items;
      } // Jump through hoops to try to find an existing Automation
      // model and just set attributes on it, if one is available.


      return automations.map(function (automation, index) {
        var automationData = items[index];
        var existingAutomation = __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_framework_resource__["a" /* ResourceMap */].findByHref(automation.id);

        if (existingAutomation) {
          delete automationData.id;
          return existingAutomation.set(automationData, {
            parse: true
          });
        } else {
          return automation;
        }
      });
    }
  }]);

  return AutomationCollection;
}(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_base_collection__["a" /* default */]);



/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Setting; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_followLink__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_Locales__ = __webpack_require__(44);












var Setting =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Setting, _BaseModel);

  function Setting() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Setting);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Setting).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Setting, [{
    key: "parse",
    value: function parse(passedAttrs) {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var attrs = (_get2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Setting.prototype), "parse", this)).call.apply(_get2, [this].concat([passedAttrs].concat(args)));

      if (attrs.current_value != null) {
        attrs.value = attrs.current_value;
        delete attrs.current_value;
      }

      return attrs;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.get("title");
    }
  }, {
    key: "getValueName",
    value: function getValueName() {
      var forValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var values = this.get("values");

      var valueIndex = _(values || []).indexOf(forValue == null ? this.get("value") : forValue);

      return this.get("labels")[valueIndex];
    }
  }, {
    key: "isBoolean",
    value: function isBoolean() {
      return this.get("values")[0] === true && this.get("values")[1] === false;
    }
  }, {
    key: "getDescriptionsForChange",
    value: function getDescriptionsForChange(newValue) {
      var language = Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_Locales__["b" /* getLanguageSet */])().nexia_mobile.models.setting;
      var label = this.getValueName(newValue); // should really select setting values using an index to avoid this nonsense...

      if (label == null) {
        label = this.getValueName(parseFloat(newValue));
      }

      var title = this.get("title");
      return {
        past: Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_Locales__["e" /* template */])(language.descriptionPastTemplate, {
          title: title,
          label: label
        }),
        presentParticiple: Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_Locales__["e" /* template */])(language.descriptionPresentTemplate, {
          title: title,
          label: label
        }),
        failure: Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_Locales__["e" /* template */])(language.descriptionFailureTemplate, {
          title: title,
          label: label
        })
      };
    }
  }, {
    key: "saveValue",
    value: function saveValue(newValue, parentDevice) {
      var _this = this;

      var ids = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_dispatch__["a" /* default */])("DISABLE_LOCATION_POLLING");
      var link = {
        href: this.url(),
        method: "POST"
      };
      var oldValue = this.get("value");
      this.set("value", newValue); // Set value optimistically so the UI shows the requested value during the fetch

      if (ids) {
        this.set("hasGroupSaveChanges", true);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_followLink__["a" /* default */])(this, link, {
        // This used to send form-encoded data (because of jQuery) so the controllers expect strings from all settings
        // TODO: change the relevant controllers in some backwards compatible way to be more flexible
        data: {
          value: newValue.toString(),
          ids: ids
        },
        maxRequestsCount: 30
      }).then(function () {
        return parentDevice.fetch();
      }, function () {
        _this.set("value", oldValue);
      }).then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
        Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_dispatch__["a" /* default */])("DEMO_MODE_EVENT", parentDevice, _this.getDescriptionsForChange(newValue).past);
      })["catch"](function () {
        return Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
      }).then(function () {
        if (_this.get("value") !== newValue) {
          throw new Error(_this.getDescriptionsForChange(newValue).failure);
        }
      });
    }
  }]);

  return Setting;
}(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Setting, "isEphemeral", true);



/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_schema__ = __webpack_require__(52);

/* harmony default export */ __webpack_exports__["a"] = ({
  parseLinksAutomate: function parseLinksAutomate(links) {
    var link = _.first(links);

    var schema;

    if (link == null) {
      schema = null;
    } else {
      schema = new __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_schema__["a" /* default */](link.getData(), {
        parse: true
      });
      schema.setStoredOnServer(link.isPostLink());
      schema.setUrl(link.href);
    }

    return {
      automateSchema: schema
    };
  },
  canBeAutomated: function canBeAutomated() {
    return this.get("automateSchema") != null;
  },
  createAutomateSchema: function createAutomateSchema() {
    return this.get("automateSchema").prepare();
  }
});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AccessCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_user_code_collection__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */

function AccessCode(feature) {
  var _this = this;

  var setTemporaryAction = feature.actions.set_temporary;
  var removeTemporaryAction = feature.actions.remove_temporary;

  if (feature.resource && !this._accessCodes) {
    this._accessCodes = new __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_user_code_collection__["a" /* default */]();

    this._accessCodes.setUrl(feature.resource.href);
  }

  this.getAccessCodes = function () {
    return _this._accessCodes;
  };

  this.getAccessCodeLength = function () {
    return feature.code_length;
  };

  this.hasTemporaryAccessCode = function () {
    return feature.has_temporary;
  };

  this.setTemporaryAccessCode = function (value) {
    var name = _this.get("name");

    return _this.executeDeviceAction(setTemporaryAction, {
      code: value
    }, {
      message: "Setting temporary code for ".concat(name)
    });
  };

  this.removeTemporaryAccessCode = function () {
    var name = _this.get("name");

    return _this.executeDeviceAction(removeTemporaryAction, {}, {
      message: "Removing temporary code from ".concat(name)
    });
  };
}


/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserCodeCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_user_code__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_user_code_schema__ = __webpack_require__(420);













var UserCodeCollection =
/*#__PURE__*/
function (_BaseCollection) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(UserCodeCollection, _BaseCollection);

  function UserCodeCollection() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, UserCodeCollection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(UserCodeCollection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "model", __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_user_code__["a" /* default */]);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(UserCodeCollection, [{
    key: "createNewCode",
    value: function createNewCode() {
      var code = new __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_user_code__["a" /* default */]({
        href: this.url()
      }, {
        parse: true
      });
      this.add(code);
      return code;
    }
  }, {
    key: "getEditSchemaClass",
    value: function getEditSchemaClass() {
      return __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_user_code_schema__["a" /* default */];
    }
  }, {
    key: "parse",
    value: function parse() {
      var _get2,
          _this2 = this;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var codes = (_get2 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(UserCodeCollection.prototype), "parse", this)).call.apply(_get2, [this].concat(args));

      if (!_.isArray(codes)) {
        return [];
      }

      return codes.map(function (code) {
        code.href = _this2.url().replace(/\/user_codes/, "/user_codes/".concat(code.id));
        return code;
      });
    }
  }, {
    key: "_parseModelsAsync",
    value: function _parseModelsAsync() {
      var _get3,
          _this3 = this;

      var _len3,
          args,
          _key3,
          codes,
          _args = arguments;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.async(function _parseModelsAsync$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              for (_len3 = _args.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = _args[_key3];
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.awrap((_get3 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(UserCodeCollection.prototype), "_parseModelsAsync", this)).call.apply(_get3, [this].concat(args)));

            case 3:
              codes = _context.sent;

              if (_.isArray(codes)) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", []);

            case 6:
              return _context.abrupt("return", codes.map(function (code) {
                code.href = _this3.url().replace(/\/user_codes/, "/user_codes/".concat(code.id));
                return code;
              }));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }]);

  return UserCodeCollection;
}(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_base_collection__["a" /* default */]);



/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_user_code_schema__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_mixins_editable__ = __webpack_require__(90);








var UserCode =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits___default()(UserCode, _BaseModel);

  function UserCode() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, UserCode);

    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default()(UserCode).apply(this, arguments));
  }

  return UserCode;
}(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_base_model__["a" /* default */]);

_.extend(UserCode.prototype, __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_mixins_editable__["a" /* default */], {
  getEditSchemaClass: function getEditSchemaClass() {
    return __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_user_code_schema__["a" /* default */];
  }
});

/* harmony default export */ __webpack_exports__["a"] = (UserCode);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ActionButtons;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */
function ActionButtons(feature) {
  var _this = this;

  this.performAction = function (action) {
    return _this.executeDeviceAction(action, {}, {
      fetchModelWhenDone: true
    });
  };

  return {
    actions: feature.actions
  };
}


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ActivateLock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */

function ActivateLock(feature) {
  var _this = this;

  var activateAction = feature.actions.activate;

  this.activate = function () {
    var promiseWithAbort = _this.executeDeviceAction(activateAction, {});

    promiseWithAbort.then(function () {
      Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("DEMO_MODE_EVENT", _this, "Activated");
    });
    return promiseWithAbort;
  };

  return {
    isActivatable: feature.is_activatable
  };
}


/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AdvancedInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_backstage__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(17);


/* eslint-disable babel/no-invalid-this */

function AdvancedInfo(feature) {
  var _this = this;

  this.getAdvancedInfoItems = function () {
    return feature.items;
  };

  this.getAdvancedInfoDisplayed = function () {
    return _this.get("advancedInfoDisplayed");
  };

  this.setAdvancedInfoDisplayed = function () {
    return _this.set("advancedInfoDisplayed", true);
  };

  this.unsetAdvancedInfoDisplayed = function () {
    return _this.unset("advancedInfoDisplayed");
  };

  this.setAdvancedInfoLoading = function (key) {
    return _this.set("advancedInfoLoading", key);
  };

  this.unsetAdvancedInfoLoading = function () {
    return _this.unset("advancedInfoLoading");
  };

  this.setAdvancedInfoLoadedValue = function (key, value) {
    return _this.set("advancedInfoLoadedValues", Object.assign({}, _this.get("advancedInfoLoadedValues"), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, key, {
      value: value,
      time: Date.now()
    })));
  };

  this.unsetAdvancedInfoLoadedValue = function (key) {
    var newLoadedValues = Object.assign({}, _this.get("advancedInfoLoadedValues"));
    delete newLoadedValues[key];

    _this.set("advancedInfoLoadedValues", newLoadedValues);
  };

  this.getAdvancedInfoLoadedValue = function (key) {
    return (_this.get("advancedInfoLoadedValues") || {})[key] || {};
  };

  this.makeAdvancedInfoRequest = function (_ref) {
    var key = _ref.label,
        loadLink = _ref.load_link,
        timeoutMessage = _ref.timeout_message;
    if (!loadLink) return Promise.reject(Error("An error occurred."));

    _this.setAdvancedInfoLoading(key);

    return new Promise(function (resolve, reject) {
      $.ajax({
        url: loadLink.href,
        method: loadLink.method || "POST",
        dataType: "json",
        error: function error(_jqxhr, textStatus, errorThrown) {
          return reject(Error("".concat(textStatus, " - ").concat(errorThrown)));
        },
        success: resolve
      });
    }).then(function (response) {
      return new Promise(function (resolve, reject) {
        new __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_backstage__["a" /* default */](response.result.polling_path, {
          success: function success(result) {
            return resolve(result && result.options && result.options.message);
          },
          error: function error(_serverErrors, _xhr, options) {
            return reject(Error(options && options.message || "An error occurred."));
          },
          maxRequestsReached: function maxRequestsReached() {
            return reject(Error(timeoutMessage));
          },
          maxRequestsCount: 60
        }).startPolling();
      });
    })["catch"](function (err) {
      _this.unsetAdvancedInfoLoading();

      throw err;
    }).then(function (result) {
      _this.unsetAdvancedInfoLoading();

      return result;
    });
  };
}



/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Alarm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */
function Alarm(feature) {
  var _this = this;

  var toggleAction = feature.actions && feature.actions.toggle;

  this.canToggleAlarm = function () {
    return toggleAction != null;
  };

  this.toggleAlarm = function () {
    if (_this.canToggleAlarm) {
      return _this.executeDeviceAction(toggleAction);
    } else {
      return Promise.reject(new Error("Can't toggle an alarm with no toggle action"));
    }
  };

  this.isOn = function () {
    return feature.status === "on";
  };

  return {
    status: feature.status
  };
}


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Barrier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_safe_access__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_safe_access___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_safe_access__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */

function Barrier(feature) {
  var _this = this;

  var operateAction = feature.actions.operate;

  this.isBarrierClosed = function () {
    return _this.get("status") === "closed";
  };

  this.isBarrierOperable = function () {
    return operateAction != null;
  };

  this.getCurrentBarrierOperation = function () {
    return __WEBPACK_IMPORTED_MODULE_0_safe_access___default()(operateAction, "title");
  };

  this.operateBarrier = function () {
    if (!_this.isBarrierOperable()) {
      return Promise.reject(new Error("Can't operate a barrier that isn't operable"));
    }

    return _this.executeDeviceActionThenFetch(operateAction, {});
  };

  return {
    status: feature.status
  };
}


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var IconBase =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(IconBase, _React$Component);

  function IconBase() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, IconBase);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(IconBase).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(IconBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          modifiers = _this$props.modifiers,
          color = _this$props.color,
          size = _this$props.size,
          style = _this$props.style,
          innerRef = _this$props.innerRef,
          colors = _this$props.colors,
          domAttrs = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["modifiers", "color", "size", "style", "innerRef", "colors"]);

      var baseStyle = {
        verticalAlign: "middle"
      };

      var alertStyle = _objectSpread({}, baseStyle, {
        color: colors.RED
      });

      var warningStyle = _objectSpread({}, baseStyle, {
        color: colors.WARNING
      });

      var emergencyStyle = _objectSpread({}, baseStyle, {
        color: colors.RED
      });

      var computedSize = size || "1em";
      var computedStyle = baseStyle;
      modifiers.forEach(function (modifier) {
        if (modifier === "alert" || modifier === "insecure" || modifier === "disconnected") {
          computedStyle = alertStyle;
        } else if (modifier === "warning") {
          computedStyle = warningStyle;
        } else if (modifier === "emergency") {
          computedStyle = emergencyStyle;
        }
      }); // Try to re-use the same style object if we can. But if they passed a `color`
      // or `style` prop, we have to make a new one.

      var svgStyle;

      if (style || color) {
        svgStyle = _objectSpread({}, computedStyle, {}, color ? {
          color: color
        } : null, {}, style);
      } else {
        svgStyle = computedStyle;
      }

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("svg", __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        fill: "currentColor",
        preserveAspectRatio: "xMidYMid meet",
        height: svgStyle.height || computedSize,
        width: svgStyle.width || computedSize
      }, domAttrs, {
        ref: innerRef,
        style: svgStyle
      }));
    }
  }]);

  return IconBase;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(IconBase, "defaultProps", {
  modifiers: []
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(IconBase, "propTypes", {
  modifiers: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string.isRequired),
  color: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number]),
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  innerRef: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__ColorsProvider__["c" /* withColorsProvider */])(IconBase));




/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createGenerateClassName", {
  enumerable: true,
  get: function get() {
    return _createGenerateClassName.default;
  }
});
Object.defineProperty(exports, "createMuiTheme", {
  enumerable: true,
  get: function get() {
    return _createMuiTheme.default;
  }
});
Object.defineProperty(exports, "jssPreset", {
  enumerable: true,
  get: function get() {
    return _jssPreset.default;
  }
});
Object.defineProperty(exports, "MuiThemeProvider", {
  enumerable: true,
  get: function get() {
    return _MuiThemeProvider.default;
  }
});
Object.defineProperty(exports, "createStyles", {
  enumerable: true,
  get: function get() {
    return _createStyles.default;
  }
});
Object.defineProperty(exports, "withStyles", {
  enumerable: true,
  get: function get() {
    return _withStyles.default;
  }
});
Object.defineProperty(exports, "withTheme", {
  enumerable: true,
  get: function get() {
    return _withTheme.default;
  }
});

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(422));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(268));

var _jssPreset = _interopRequireDefault(__webpack_require__(423));

var _MuiThemeProvider = _interopRequireDefault(__webpack_require__(430));

var _createStyles = _interopRequireDefault(__webpack_require__(936));

var _withStyles = _interopRequireDefault(__webpack_require__(126));

var _withTheme = _interopRequireDefault(__webpack_require__(274));

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(883);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBreakpoints;
exports.keys = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

exports.keys = keys;

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return "@media (min-width:".concat(values[start]).concat(unit, ") and ") + "(max-width:".concat(values[keys[endIndex]] - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return (0, _extends2.default)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMixins;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1));

var _extends3 = _interopRequireDefault(__webpack_require__(14));

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0, _extends3.default)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _extends3.default)({
        paddingLeft: spacing.unit * 2,
        paddingRight: spacing.unit * 2
      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _extends3.default)({
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPalette;
exports.dark = exports.light = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

var _warning = _interopRequireDefault(__webpack_require__(49));

var _deepmerge = _interopRequireDefault(__webpack_require__(204));

var _indigo = _interopRequireDefault(__webpack_require__(887));

var _pink = _interopRequireDefault(__webpack_require__(888));

var _grey = _interopRequireDefault(__webpack_require__(889));

var _red = _interopRequireDefault(__webpack_require__(890));

var _common = _interopRequireDefault(__webpack_require__(891));

var _colorManipulator = __webpack_require__(302);

// < 1kb payload overhead when lodash/merge is > 3kb.
var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _common.default.white,
    default: _grey.default[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.08)',
    hoverOpacity: 0.08,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.14)',
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};
exports.light = light;
var dark = {
  text: {
    primary: _common.default.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: _grey.default[800],
    default: '#303030'
  },
  action: {
    active: _common.default.white,
    hover: 'rgba(255, 255, 255, 0.1)',
    hoverOpacity: 0.1,
    selected: 'rgba(255, 255, 255, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)'
  }
};
exports.dark = dark;

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: _indigo.default[300],
    main: _indigo.default[500],
    dark: _indigo.default[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: _pink.default.A200,
    main: _pink.default.A400,
    dark: _pink.default.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: _red.default[300],
    main: _red.default[500],
    dark: _red.default[700]
  } : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "type", "contrastThreshold", "tonalOffset"]);

  function getContrastText(background) {
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
      process.env.NODE_ENV !== "production" ? (0, _warning.default)(contrast >= 3, ["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
    }

    return contrastText;
  }

  function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (false) {
      throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  }

  augmentColor(primary);
  augmentColor(secondary, 'A400', 'A200', 'A700');
  augmentColor(error);
  var types = {
    dark: dark,
    light: light
  };
   false ? (0, _warning.default)(types[type], "Material-UI: the palette type `".concat(type, "` is not supported.")) : void 0;
  var paletteOutput = (0, _deepmerge.default)((0, _extends2.default)({
    // A collection of common colors.
    common: _common.default,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: primary,
    // The colors used to represent secondary interface elements for a user.
    secondary: secondary,
    // The colors used to represent interface elements that the user should be made aware of.
    error: error,
    // The grey colors.
    grey: _grey.default,
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: contrastThreshold,
    // Take a background color and return the color of the text to maximize the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other, {
    clone: false // No need to clone deep

  });
  return paletteOutput;
}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var _default = indigo;
exports.default = _default;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var _default = pink;
exports.default = _default;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var _default = grey;
exports.default = _default;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var _default = red;
exports.default = _default;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var common = {
  black: '#000',
  white: '#fff'
};
var _default = common;
exports.default = _default;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTypography;

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

var _deepmerge = _interopRequireDefault(__webpack_require__(204));

var _warning = _interopRequireDefault(__webpack_require__(49));

var _utils = __webpack_require__(80);

// < 1kb payload overhead when lodash/merge is > 3kb.
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      _ref$useNextVariants = _ref.useNextVariants,
      useNextVariants = _ref$useNextVariants === void 0 ? Boolean(_utils.ponyfillGlobal.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__) : _ref$useNextVariants,
      _ref$suppressWarning = _ref.suppressWarning,
      suppressWarning = _ref$suppressWarning === void 0 ? false : _ref$suppressWarning,
      allVariants = _ref.allVariants,
      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "htmlFontSize", "useNextVariants", "suppressWarning", "allVariants"]);

   false ? (0, _warning.default)(useNextVariants || suppressWarning, 'Material-UI: you are using the deprecated typography variants ' + 'that will be removed in the next major release.' + '\nPlease read the migration guide under https://material-ui.com/style/typography#migration-to-typography-v2') : void 0;
  var coef = fontSize / 14;

  var pxToRem = function pxToRem(size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return (0, _extends2.default)({
      color: palette.text.primary,
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following http://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var nextVariants = {
    h1: buildVariant(fontWeightLight, 96, 1, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.04, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.17, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.33, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1Next: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2Next: buildVariant(fontWeightRegular, 14, 1.5, 0.15),
    buttonNext: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    captionNext: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  }; // To remove in v4

  var oldVariants = {
    display4: (0, _extends2.default)({
      fontSize: pxToRem(112),
      fontWeight: fontWeightLight,
      fontFamily: fontFamily,
      letterSpacing: '-.04em',
      lineHeight: "".concat(round(128 / 112), "em"),
      marginLeft: '-.04em',
      color: palette.text.secondary
    }, allVariants),
    display3: (0, _extends2.default)({
      fontSize: pxToRem(56),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      letterSpacing: '-.02em',
      lineHeight: "".concat(round(73 / 56), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display2: (0, _extends2.default)({
      fontSize: pxToRem(45),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(51 / 45), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display1: (0, _extends2.default)({
      fontSize: pxToRem(34),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(41 / 34), "em"),
      color: palette.text.secondary
    }, allVariants),
    headline: (0, _extends2.default)({
      fontSize: pxToRem(24),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(32.5 / 24), "em"),
      color: palette.text.primary
    }, allVariants),
    title: (0, _extends2.default)({
      fontSize: pxToRem(21),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24.5 / 21), "em"),
      color: palette.text.primary
    }, allVariants),
    subheading: (0, _extends2.default)({
      fontSize: pxToRem(16),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 16), "em"),
      color: palette.text.primary
    }, allVariants),
    body2: (0, _extends2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    body1: (0, _extends2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(20.5 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    caption: (0, _extends2.default)({
      fontSize: pxToRem(12),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(16.5 / 12), "em"),
      color: palette.text.secondary
    }, allVariants),
    button: (0, _extends2.default)({
      fontSize: pxToRem(14),
      textTransform: 'uppercase',
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      color: palette.text.primary
    }, allVariants)
  };
  return (0, _deepmerge.default)((0, _extends2.default)({
    pxToRem: pxToRem,
    round: round,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium
  }, oldVariants, nextVariants, useNextVariants ? {
    body1: nextVariants.body1Next,
    body2: nextVariants.body2Next,
    button: nextVariants.buttonNext,
    caption: nextVariants.captionNext
  } : {}, {
    useNextVariants: useNextVariants
  }), other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(66));

var _reactIs = __webpack_require__(159);

/**
 * A factory that returns a propTypes validator that only accepts values that
 * are also accepted by React.createElement
 * e.g. "div", functional, class components, forwardRef etc.
 *
 * @param {boolean} isRequired If `true` returns a validator
 *                             that will throw if nullish values are passed
 */
function createComponentProp(isRequired) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  return function componentPropType(props, key, componentName, location, propFullName) {
    var prop = props[key];
    var propName = propFullName || key;
    var message;

    if (prop == null) {
      if (isRequired) {
        message = "The ".concat(location, " `").concat(propName, "` is marked as required in `").concat(componentName, "`, ") + "but its value is `".concat((0, _typeof2.default)(prop), "`.");
      }
    } else if (!(0, _reactIs.isValidElementType)(prop)) {
      var preciseType = (0, _typeof2.default)(prop);
      message = "Invalid ".concat(location, " `").concat(propName, "` of type `").concat(preciseType, "` ") + "supplied to `".concat(componentName, "`, expected a component.");
    }

    if (message != null) {
      // change error message slightly on every check to prevent caching when testing
      // which would not trigger console errors on subsequent fails
      return new Error("".concat(message).concat( false ? Date.now() : ''));
    }

    return null;
  };
}

var componentPropType = createComponentProp(false);
componentPropType.isRequired = createComponentProp(true);
var _default = componentPropType;
exports.default = _default;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function chainPropTypes(propType1, propType2) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

var _default = chainPropTypes;
exports.default = _default;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.specialProperty = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1));

var _extends3 = _interopRequireDefault(__webpack_require__(14));

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
exports.specialProperty = specialProperty;

function exactProp(propTypes) {
  /* istanbul ignore if */
  if (true) {
    return propTypes;
  }

  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following properties are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

var _default = exactProp;
exports.default = _default;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFunctionName = getFunctionName;
exports.default = void 0;
// Fork of recompose/getDisplayName with added IE 11 support
// Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;

function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}

function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || getFunctionName(Component) || 'Component';
}

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

exports.default = _default;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
}

var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var _default = shadows;
exports.default = _default;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shape = {
  borderRadius: 4
};
var _default = shape;
exports.default = _default;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var spacing = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/design/layout/understanding-layout.html#pixel-density
  unit: 8
};
var _default = spacing;
exports.default = _default;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var _default = zIndex;
exports.default = _default;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(424);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = getDynamicStyles;
/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(139);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(426);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(908);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32), __webpack_require__(907)(module)))

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isInBrowser = __webpack_require__(208);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(429);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(912);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(913);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(919);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(920);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(270);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(140);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(428);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(207);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(921);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(922);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.8.7";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(139);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(914);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(915);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(916);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(917);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(918);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
var plugins = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var RuleClass = classes[key];
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new RuleClass(name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

exports['default'] = plugins;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(161);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(161);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(269);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(269);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(140);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(207);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(426);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(161);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(140);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(207);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// A symbol replacement.
var now = Date.now();

var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[prop] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(139);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(270);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(140);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(206);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value = void 0;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
function getPropertyValue(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Remove a style property.
 */
function removeProperty(cssRule, prop) {
  try {
    cssRule.style.removeProperty(prop);
  } catch (err) {
    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
  }
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

/**
 * Read jss nonce setting from the page if the user has set it.
 */
var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setProperty',
    value: function setProperty() {
      return true;
    }
  }, {
    key: 'getPropertyValue',
    value: function getPropertyValue() {
      return '';
    }
  }, {
    key: 'removeProperty',
    value: function removeProperty() {}
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(924);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelCase;

var _hyphenateStyleName = __webpack_require__(271);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);

    // There was no camel case in place
    if (prop === hyphenatedProp) return value;

    rule.prop(hyphenatedProp, value);

    // Core will ignore that property value we set the proper one above.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(927);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(929);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(272);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(930);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(932);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(208);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(272);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(931);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(208);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(272);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(66);

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createBroadcast (initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState () {
    return _state
  }

  function setState (state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) { listeners[keys[i]](state); }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe (listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.')
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId
  }

  // remove subscription by removing the listener function
  function unsubscribe (id) {
    listeners[id] = undefined;
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
}

/* harmony default export */ __webpack_exports__["default"] = (createBroadcast);


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;

function createStyles(styles) {
  return styles;
}

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Share the same values than in
// https://github.com/cssinjs/jss/blob/master/packages/react-jss/src/ns.js
var ns = {
  jss: '64a55d578f856d258dc345b094a2a2b3',
  sheetsRegistry: 'd4bd0baacbc52bbd48bbb9eb24344ecd',
  sheetOptions: '6fc570d6bd61383819d0f9e7407c452d'
};
var _default = ns;
exports.default = _default;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _warning = _interopRequireDefault(__webpack_require__(49));

var _utils = __webpack_require__(80);

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = (0, _extends2.default)({}, baseClasses);

  if (false) {
    process.env.NODE_ENV !== "production" ? (0, _warning.default)(false, ["Material-UI: the value `".concat(newClasses, "` ") + "provided to the classes property of ".concat((0, _utils.getDisplayName)(Component), " is incorrect."), 'You might want to use the className property instead.'].join('\n')) : void 0;
    return baseClasses;
  }

  Object.keys(newClasses).forEach(function (key) {
     false ? (0, _warning.default)(baseClasses[key] || !newClasses[key], ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not implemented in ".concat((0, _utils.getDisplayName)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n')) : void 0;
     false ? (0, _warning.default)(!newClasses[key] || typeof newClasses[key] === 'string', ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not valid for ".concat((0, _utils.getDisplayName)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n')) : void 0;

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

var _default = mergeClasses;
exports.default = _default;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
var _default = multiKeyStore;
exports.default = _default;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _typeof2 = _interopRequireDefault(__webpack_require__(66));

var _warning = _interopRequireDefault(__webpack_require__(49));

var _deepmerge = _interopRequireDefault(__webpack_require__(204));

// < 1kb payload overhead when lodash/merge is > 3kb.
// Support for the jss-expand plugin.
function arrayMerge(destination, source) {
  return source;
}

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';
   false ? (0, _warning.default)((0, _typeof2.default)(stylesOrCreator) === 'object' || themingEnabled, ['Material-UI: the first argument provided to withStyles() is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n')) : void 0;

  function create(theme, name) {
    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;

    if (!name || !theme.overrides || !theme.overrides[name]) {
      return styles;
    }

    var overrides = theme.overrides[name];
    var stylesWithOverrides = (0, _extends2.default)({}, styles);
    Object.keys(overrides).forEach(function (key) {
       false ? (0, _warning.default)(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n')) : void 0;
      stylesWithOverrides[key] = (0, _deepmerge.default)(stylesWithOverrides[key], overrides[key], {
        arrayMerge: arrayMerge
      });
    });
    return stylesWithOverrides;
  }

  return {
    create: create,
    options: {},
    themingEnabled: themingEnabled
  };
}

var _default = getStylesCreator;
exports.default = _default;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme.props || !name || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var _default = getThemeProps;
exports.default = _default;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
// special flexbox specifications


var _prefixAll2 = __webpack_require__(943);

var _prefixAll3 = _interopRequireDefault(_prefixAll2);

var _getBrowserInformation = __webpack_require__(954);

var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);

var _getPrefixedKeyframes = __webpack_require__(956);

var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);

var _capitalizeString = __webpack_require__(276);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _sortPrefixedStyle = __webpack_require__(432);

var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);

var _prefixProps = __webpack_require__(957);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

var _position = __webpack_require__(958);

var _position2 = _interopRequireDefault(_position);

var _calc = __webpack_require__(959);

var _calc2 = _interopRequireDefault(_calc);

var _zoomCursor = __webpack_require__(960);

var _zoomCursor2 = _interopRequireDefault(_zoomCursor);

var _grabCursor = __webpack_require__(961);

var _grabCursor2 = _interopRequireDefault(_grabCursor);

var _flex = __webpack_require__(962);

var _flex2 = _interopRequireDefault(_flex);

var _sizing = __webpack_require__(963);

var _sizing2 = _interopRequireDefault(_sizing);

var _gradient = __webpack_require__(964);

var _gradient2 = _interopRequireDefault(_gradient);

var _transition = __webpack_require__(965);

var _transition2 = _interopRequireDefault(_transition);

var _flexboxIE = __webpack_require__(967);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(968);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var plugins = [_position2.default, _calc2.default, _zoomCursor2.default, _grabCursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default,
// this must be run AFTER the flexbox specs
_flex2.default];

var Prefixer = function () {
  /**
   * Instantiante a new prefixer
   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
   * @param {string} keepUnprefixed - keeps unprefixed properties and values
   */

  function Prefixer() {
    var _this = this;

    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    _classCallCheck(this, Prefixer);

    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;

    this._userAgent = options.userAgent || defaultUserAgent;
    this._keepUnprefixed = options.keepUnprefixed || false;

    this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);

    // Checks if the userAgent was resolved correctly
    if (this._browserInfo && this._browserInfo.prefix) {
      // set additional prefix information
      this.cssPrefix = this._browserInfo.prefix.css;
      this.jsPrefix = this._browserInfo.prefix.inline;
      this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo);
    } else {
      this._usePrefixAllFallback = true;
      return false;
    }

    var data = this._browserInfo.browser && _prefixProps2.default[this._browserInfo.browser];
    if (data) {
      this._requiresPrefix = Object.keys(data).filter(function (key) {
        return data[key] >= _this._browserInfo.version;
      }).reduce(function (result, name) {
        result[name] = true;
        return result;
      }, {});
      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
    } else {
      this._usePrefixAllFallback = true;
    }
  }

  /**
   * Returns a prefixed version of the style object
   * @param {Object} styles - Style object that gets prefixed properties added
   * @returns {Object} - Style object with prefixed properties and values
   */


  _createClass(Prefixer, [{
    key: 'prefix',
    value: function prefix(styles) {
      var _this2 = this;

      // use prefixAll as fallback if userAgent can not be resolved
      if (this._usePrefixAllFallback) {
        return (0, _prefixAll3.default)(styles);
      }

      // only add prefixes if needed
      if (!this._hasPropsRequiringPrefix) {
        return styles;
      }

      Object.keys(styles).forEach(function (property) {
        var value = styles[property];
        if (value instanceof Object && !Array.isArray(value)) {
          // recurse through nested style objects
          styles[property] = _this2.prefix(value);
        } else {
          // add prefixes if needed
          if (_this2._requiresPrefix[property]) {
            styles[_this2.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
            if (!_this2._keepUnprefixed) {
              delete styles[property];
            }
          }
        }
      });

      Object.keys(styles).forEach(function (property) {
        [].concat(styles[property]).forEach(function (value) {
          // resolve plugins
          plugins.forEach(function (plugin) {
            // generates a new plugin interface with current data
            assignStyles(styles, plugin({
              property: property,
              value: value,
              styles: styles,
              browserInfo: _this2._browserInfo,
              prefix: {
                js: _this2.jsPrefix,
                css: _this2.cssPrefix,
                keyframes: _this2.prefixedKeyframes
              },
              keepUnprefixed: _this2._keepUnprefixed,
              requiresPrefix: _this2._requiresPrefix
            }), value, _this2._keepUnprefixed);
          });
        });
      });

      return (0, _sortPrefixedStyle2.default)(styles);
    }

    /**
     * Returns a prefixed version of the style object using all vendor prefixes
     * @param {Object} styles - Style object that gets prefixed properties added
     * @returns {Object} - Style object with prefixed properties and values
     */

  }], [{
    key: 'prefixAll',
    value: function prefixAll(styles) {
      return (0, _prefixAll3.default)(styles);
    }
  }]);

  return Prefixer;
}();

exports.default = Prefixer;


function assignStyles(base) {
  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var value = arguments[2];
  var keepUnprefixed = arguments[3];

  Object.keys(extend).forEach(function (property) {
    var baseValue = base[property];
    if (Array.isArray(baseValue)) {
      [].concat(extend[property]).forEach(function (val) {
        if (base[property].indexOf(val) === -1) {
          base[property].splice(baseValue.indexOf(value), keepUnprefixed ? 0 : 1, val);
        }
      });
    } else {
      base[property] = extend[property];
    }
  });
}
module.exports = exports['default'];

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixAll;

var _prefixProps = __webpack_require__(431);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

var _capitalizeString = __webpack_require__(276);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _sortPrefixedStyle = __webpack_require__(432);

var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);

var _position = __webpack_require__(945);

var _position2 = _interopRequireDefault(_position);

var _calc = __webpack_require__(946);

var _calc2 = _interopRequireDefault(_calc);

var _cursor = __webpack_require__(947);

var _cursor2 = _interopRequireDefault(_cursor);

var _flex = __webpack_require__(948);

var _flex2 = _interopRequireDefault(_flex);

var _sizing = __webpack_require__(949);

var _sizing2 = _interopRequireDefault(_sizing);

var _gradient = __webpack_require__(950);

var _gradient2 = _interopRequireDefault(_gradient);

var _transition = __webpack_require__(951);

var _transition2 = _interopRequireDefault(_transition);

var _flexboxIE = __webpack_require__(952);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(953);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// special flexbox specifications


var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];

/**
 * Returns a prefixed version of the style object using all vendor prefixes
 * @param {Object} styles - Style object that gets prefixed properties added
 * @returns {Object} - Style object with prefixed properties and values
 */
function prefixAll(styles) {
  Object.keys(styles).forEach(function (property) {
    var value = styles[property];
    if (value instanceof Object && !Array.isArray(value)) {
      // recurse through nested style objects
      styles[property] = prefixAll(value);
    } else {
      Object.keys(_prefixProps2.default).forEach(function (prefix) {
        var properties = _prefixProps2.default[prefix];
        // add prefixes if needed
        if (properties[property]) {
          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
        }
      });
    }
  });

  Object.keys(styles).forEach(function (property) {
    [].concat(styles[property]).forEach(function (value, index) {
      // resolve every special plugins
      plugins.forEach(function (plugin) {
        return assignStyles(styles, plugin(property, value));
      });
    });
  });

  return (0, _sortPrefixedStyle2.default)(styles);
}

function assignStyles(base) {
  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  Object.keys(extend).forEach(function (property) {
    var baseValue = base[property];
    if (Array.isArray(baseValue)) {
      [].concat(extend[property]).forEach(function (value) {
        var valueIndex = baseValue.indexOf(value);
        if (valueIndex > -1) {
          base[property].splice(valueIndex, 1);
        }
        base[property].push(value);
      });
    } else {
      base[property] = extend[property];
    }
  });
}
module.exports = exports['default'];

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (property) {
  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
};

module.exports = exports["default"];

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return { position: ['-webkit-sticky', 'sticky'] };
  }
}
module.exports = exports['default'];

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _joinPrefixedValue = __webpack_require__(209);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

var _isPrefixedValue = __webpack_require__(277);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;

var _joinPrefixedValue = __webpack_require__(209);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values[value]) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = { flex: true, 'inline-flex': true };

function flex(property, value) {
  if (property === 'display' && values[value]) {
    return {
      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _joinPrefixedValue = __webpack_require__(209);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties[property] && values[value]) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _joinPrefixedValue = __webpack_require__(209);

var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);

var _isPrefixedValue = __webpack_require__(277);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
    return (0, _joinPrefixedValue2.default)(property, value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateStyleName = __webpack_require__(271);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _capitalizeString = __webpack_require__(276);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _isPrefixedValue = __webpack_require__(277);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _prefixProps = __webpack_require__(431);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true
};

function transition(property, value) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties[property]) {
    var _ref2;

    var outputValue = prefixValue(value);
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
      return value.match(/-moz-|-ms-/) === null;
    }).join(',');

    // if the property is already prefixed
    if (property.indexOf('Webkit') > -1) {
      return _defineProperty({}, property, webkitOutput);
    }

    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
  }
}

function prefixValue(value) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  // iterate each single value and check for transitioned properties
  // that need to be prefixed as well
  multipleValues.forEach(function (val, index) {
    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';

      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);

        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
          // join all prefixes and create a new value
          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
        }
      });
      return out;
    }, val);
  });

  return multipleValues.join(',');
}
module.exports = exports['default'];

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msPreferredSize'
};

function flexboxIE(property, value) {
  if (alternativeProps[property]) {
    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value) {
  if (property === 'flexDirection' && typeof value === 'string') {
    return {
      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
    };
  }
  if (alternativeProps[property]) {
    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
  }
}
module.exports = exports['default'];

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bowser = __webpack_require__(955);

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendorPrefixes = {
  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen', 'chromium', 'vivaldi'],
  Moz: ['firefox', 'seamonkey', 'sailfish'],
  ms: ['msie', 'msedge']
};
var browsers = {
  chrome: [['chrome'], ['chromium']],
  safari: [['safari']],
  firefox: [['firefox']],
  edge: [['msedge']],
  opera: [['opera'], ['vivaldi']],
  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
  ie: [['msie']],
  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
  and_uc: [['android', 'mobile'], ['android', 'tablet']],
  android: [['android', 'mobile'], ['android', 'tablet']]
};

var browserByInfo = function browserByInfo(info) {
  if (info.firefox) {
    return 'firefox';
  }
  var name = '';

  Object.keys(browsers).forEach(function (browser) {
    browsers[browser].forEach(function (condition) {
      var match = 0;
      condition.forEach(function (single) {
        if (info[single]) {
          match += 1;
        }
      });
      if (condition.length === match) {
        name = browser;
      }
    });
  });

  return name;
};

/**
 * Uses bowser to get default browser information such as version and name
 * Evaluates bowser info and adds vendorPrefix information
 * @param {string} userAgent - userAgent that gets evaluated
 */

exports.default = function (userAgent) {
  if (!userAgent) {
    return false;
  }
  var info = _bowser2.default._detect(userAgent);

  Object.keys(vendorPrefixes).forEach(function (prefix) {
    vendorPrefixes[prefix].forEach(function (browser) {
      if (info[browser]) {
        info.prefix = {
          inline: prefix,
          css: '-' + prefix.toLowerCase() + '-'
        };
      }
    });
  });

  info.browser = browserByInfo(info);

  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
  info.osversion = parseFloat(info.osversion);

  // iOS forces all browsers to use Safari under the hood
  // as the Safari version seems to match the iOS version
  // we just explicitely use the osversion instead
  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
  if (info.browser === 'ios_saf' && info.version > info.osversion) {
    info.version = info.osversion;
    info.safari = true;
  }

  // seperate native android chrome
  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
  if (info.browser === 'android' && info.chrome && info.version > 37) {
    info.browser = 'and_chr';
  }

  // For android < 4.4 we want to check the osversion
  // not the chrome version, see issue #26
  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
  if (info.browser === 'android' && info.osversion < 5) {
    info.version = info.osversion;
  }

  return info;
};

module.exports = exports['default'];

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(433)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)(o|0)s/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/Whale/i.test(ua)) {
      result = {
        name: 'NAVER Whale browser'
        , whale: t
        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/MZBrowser/i.test(ua)) {
      result = {
        name: 'MZ Browser'
        , mzbrowser: t
        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/focus/i.test(ua)) {
      result = {
        name: 'Focus'
        , focus: t
        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var browser = _ref.browser;
  var version = _ref.version;
  var prefix = _ref.prefix;

  var prefixedKeyframes = 'keyframes';

  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
    prefixedKeyframes = prefix.css + prefixedKeyframes;
  }
  return prefixedKeyframes;
};

module.exports = exports['default'];

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 55, "userSelect": 55, "fontKerning": 32, "textEmphasisPosition": 55, "textEmphasis": 55, "textEmphasisStyle": 55, "textEmphasisColor": 55, "boxDecorationBreak": 55, "clipPath": 55, "maskImage": 55, "maskMode": 55, "maskRepeat": 55, "maskPosition": 55, "maskClip": 55, "maskOrigin": 55, "maskSize": 55, "maskComposite": 55, "mask": 55, "maskBorderSource": 55, "maskBorderMode": 55, "maskBorderSlice": 55, "maskBorderWidth": 55, "maskBorderOutset": 55, "maskBorderRepeat": 55, "maskBorder": 55, "maskType": 55, "textDecorationStyle": 55, "textDecorationSkip": 55, "textDecorationLine": 55, "textDecorationColor": 55, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 51, "userSelect": 51, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 51, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 41, "userSelect": 41, "fontKerning": 19, "textEmphasisPosition": 41, "textEmphasis": 41, "textEmphasisStyle": 41, "textEmphasisColor": 41, "boxDecorationBreak": 41, "clipPath": 41, "maskImage": 41, "maskMode": 41, "maskRepeat": 41, "maskPosition": 41, "maskClip": 41, "maskOrigin": 41, "maskSize": 41, "maskComposite": 41, "mask": 41, "maskBorderSource": 41, "maskBorderMode": 41, "maskBorderSlice": 41, "maskBorderWidth": 41, "maskBorderOutset": 41, "maskBorderRepeat": 41, "maskBorder": 41, "maskType": 41, "textDecorationStyle": 41, "textDecorationSkip": 41, "textDecorationLine": 41, "textDecorationColor": 41, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 51, "userSelect": 51, "fontKerning": 4.4, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "filter": 51, "fontFeatureSettings": 4.4, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "and_chr": { "appearance": 51, "userSelect": 51, "textEmphasisPosition": 51, "textEmphasis": 51, "textEmphasisStyle": 51, "textEmphasisColor": 51, "boxDecorationBreak": 51, "clipPath": 51, "maskImage": 51, "maskMode": 51, "maskRepeat": 51, "maskPosition": 51, "maskClip": 51, "maskOrigin": 51, "maskSize": 51, "maskComposite": 51, "mask": 51, "maskBorderSource": 51, "maskBorderMode": 51, "maskBorderSlice": 51, "maskBorderWidth": 51, "maskBorderOutset": 51, "maskBorderRepeat": 51, "maskBorder": 51, "maskType": 51, "textDecorationStyle": 51, "textDecorationSkip": 51, "textDecorationLine": 51, "textDecorationColor": 51, "filter": 51 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": {} };
module.exports = exports["default"];

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;

var _getPrefixedValue = __webpack_require__(91);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function position(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var browser = _ref.browserInfo.browser;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'position' && value === 'sticky' && (browser === 'safari' || browser === 'ios_saf')) {
    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
  }
}
module.exports = exports['default'];

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _getPrefixedValue = __webpack_require__(91);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function calc(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, css + 'calc('), value, keepUnprefixed));
  }
}
module.exports = exports['default'];

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = zoomCursor;

var _getPrefixedValue = __webpack_require__(91);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = { 'zoom-in': true, 'zoom-out': true };

function zoomCursor(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
    return {
      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = grabCursor;

var _getPrefixedValue = __webpack_require__(91);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = { grab: true, grabbing: true };

function grabCursor(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var browser = _ref.browserInfo.browser;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  // adds prefixes for firefox, chrome, safari, and opera regardless of version until a reliable brwoser support info can be found (see: https://github.com/rofrischmann/inline-style-prefixer/issues/79)
  if (property === 'cursor' && values[value] && (browser === 'firefox' || browser === 'chrome' || browser === 'safari' || browser === 'opera')) {
    return {
      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;

var _getPrefixedValue = __webpack_require__(91);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = { flex: true, 'inline-flex': true };

function flex(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
    return {
      display: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _getPrefixedValue = __webpack_require__(91);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  // This might change in the future
  // Keep an eye on it
  if (properties[property] && values[value]) {
    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
  }
}
module.exports = exports['default'];

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _getPrefixedValue = __webpack_require__(91);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
  }
}
module.exports = exports['default'];

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = transition;

var _hyphenateStyleName = __webpack_require__(271);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _unprefixProperty = __webpack_require__(966);

var _unprefixProperty2 = _interopRequireDefault(_unprefixProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var properties = { transition: true, transitionProperty: true };

function transition(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var css = _ref.prefix.css;
  var requiresPrefix = _ref.requiresPrefix;
  var keepUnprefixed = _ref.keepUnprefixed;

  // also check for already prefixed transitions
  var unprefixedProperty = (0, _unprefixProperty2.default)(property);

  if (typeof value === 'string' && properties[unprefixedProperty]) {
    var _ret = function () {
      // TODO: memoize this array
      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
        return (0, _hyphenateStyleName2.default)(prop);
      });

      // only split multi values, not cubic beziers
      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

      requiresPrefixDashCased.forEach(function (prop) {
        multipleValues.forEach(function (val, index) {
          if (val.indexOf(prop) > -1 && prop !== 'order') {
            multipleValues[index] = val.replace(prop, css + prop) + (keepUnprefixed ? ',' + val : '');
          }
        });
      });

      return {
        v: _defineProperty({}, property, multipleValues.join(','))
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }
}
module.exports = exports['default'];

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (property) {
  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
};

module.exports = exports['default'];

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

var _getPrefixedValue = __webpack_require__(91);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  flex: 'flexbox',
  'inline-flex': 'inline-flexbox'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msPreferredSize'
};

function flexboxIE(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var styles = _ref.styles;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if ((alternativeProps[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
    if (!keepUnprefixed && !Array.isArray(styles[property])) {
      delete styles[property];
    }
    if (property === 'display' && alternativeValues[value]) {
      return {
        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
      };
    }
    if (alternativeProps[property]) {
      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

var _getPrefixedValue = __webpack_require__(91);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple',
  flex: 'box',
  'inline-flex': 'inline-box'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
var properties = Object.keys(alternativeProps).concat(otherProps);

function flexboxOld(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var styles = _ref.styles;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
    if (!keepUnprefixed && !Array.isArray(styles[property])) {
      delete styles[property];
    }
    if (property === 'flexDirection' && typeof value === 'string') {
      return {
        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
      };
    }
    if (property === 'display' && alternativeValues[value]) {
      return {
        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
      };
    }
    if (alternativeProps[property]) {
      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_Icons__ = __webpack_require__(23);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function getTemperature(value) {
  var temp = "--";
  value.modifiers.forEach(function (modifier) {
    if (modifier.startsWith("temperature-")) {
      temp = modifier.substring(modifier.indexOf('-') + 1) || temp;
    }
  });
  return "".concat(temp, "\xB0");
}

function DeviceThermostatIcon(_ref) {
  var value = _ref.value,
      style = _ref.style,
      includeTemperature = _ref.includeTemperature;

  if (!includeTemperature) {
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nx_components_Icons__["_40" /* IconThermostat */], {
      style: style
    });
  }

  var styles = Object(__WEBPACK_IMPORTED_MODULE_3_nx_components_utils_prefixStyles__["b" /* default */])({
    root: _objectSpread({
      lineHeight: "0",
      margin: "0.2em 0.1em",
      fontSize: "0.5em",
      width: "1.5em",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between"
    }, style),
    icon: {
      margin: "0 -0.25em"
    },
    temperature: {
      fontSize: "0.65em",
      marginLeft: "0.1em"
    }
  });
  var temp = getTemperature(value);

  if (temp.length > 3) {
    // Celsius and very high Fahreinheit temeratures can be long
    styles.temperature.fontSize = "0.35em";
  }

  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
    style: styles.root
  }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nx_components_Icons__["_40" /* IconThermostat */], {
    style: styles.icon
  }), __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
    style: styles.temperature
  }, temp));
}

DeviceThermostatIcon.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    modifiers: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string).isRequired
  }),
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  includeTemperature: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (DeviceThermostatIcon);

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ButtonPad;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_schema__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */


function ButtonPad(feature) {
  var _this = this;

  var assignAction = feature.actions.assign;

  if (this._buttonSchema == null) {
    this._buttonSchema = new __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_schema__["a" /* default */](assignAction.data, {
      parse: true
    });
  }

  if (assignAction && assignAction.type === __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__["a" /* default */].SCHEMA) {
    this._buttonSchema.setUrl(assignAction.href);
  }

  this.getButtonSchema = function () {
    return _this._buttonSchema;
  };
}


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Camera;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_mixins_video_feed__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */

function Camera(feature) {
  var _this = this;

  // mix in the methods from VideoFeed
  _.extend(this, __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_mixins_video_feed__["a" /* default */]);

  this.isConnected = function () {
    return _this.get("connected");
  };

  return {
    connected: feature.connected,
    status: feature.connected ? "Connected" : "Disconnected",
    quality: feature.quality,
    aspectRatio: feature.aspect_ratio
  };
}


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Colored;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */
function Colored(feature) {
  var _this = this;

  var setColorAction = feature.actions.set_color;
  this.set("color", feature.colors);
  return this.syncColor = function () {
    return _this.executeDeviceAction(setColorAction, _this.get("color"), {
      updateModelWithResponse: false
    });
  };
}


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Connection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* eslint-disable camelcase */
function Connection(feature) {
  return {
    connection_protocol: feature.protocol,
    connection_strength: feature.signal_strength,
    is_connected: feature.is_connected
  };
}


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Dimmer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* eslint-disable camelcase */

/* eslint-disable babel/no-invalid-this */
function Dimmer(feature) {
  var _this = this;

  var setLevelAction = feature.actions.set_level;

  this.setDimmerLevel = function (level) {
    if (setLevelAction == null) {
      return Promise.reject(new Error("Attempted to set level on a dimmer with no set level action"));
    }

    return _this.executeDeviceAction(setLevelAction, {
      value: level
    });
  };

  return {
    status: "Level: ".concat(feature.level, "%"),
    dimmer_level: feature.level
  };
}


/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DragonflyWifiConfiguration;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_followLink__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */

function DragonflyWifiConfiguration(feature) {
  var _this = this;

  this.fetchLastUpdateTime = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_followLink__["a" /* default */])(_this, feature.get_last_update_time, {
      silent: true
    }).then(function (data) {
      return data.last_update_time && new Date(data.last_update_time);
    });
  };

  return {};
}


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Fan;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* eslint-disable camelcase */

/* eslint-disable babel/no-invalid-this */
function Fan(feature) {
  var _this = this;

  var fanSpeedAction = feature.actions.set_speed;

  this.getFanSpeedLabel = function () {
    var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : feature.speed;
    var roundedSpeed = Math.round(speed);

    switch (false) {
      case roundedSpeed !== 0:
        return "Off";

      case roundedSpeed > 33:
        return "Low";

      case roundedSpeed > 67:
        return "Medium";

      default:
        return "High";
    }
  };

  this.setFanSpeed = function (speed) {
    return _this.executeDeviceAction(fanSpeedAction, {
      level: _this.getFanSpeedLabel(speed)
    }, {
      updateModelWithResponse: false
    });
  };

  return {
    fan_speed: feature.speed,
    fan_speed_increment: feature.speed_increment,
    status: feature.status
  };
}


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LockLock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */

function LockLock(feature) {
  var _this = this;

  var lockAction = feature.actions.lock;

  this.lock = function () {
    var promiseWithAbort = _this.executeDeviceAction(lockAction, {});

    promiseWithAbort.then(function () {
      Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("DEMO_MODE_EVENT", _this, "Locked");
    });
    return promiseWithAbort;
  };

  return {
    isLocked: feature.is_locked
  };
}


/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Occupancy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */
function Occupancy(feature) {
  var _this = this;

  var toggleAction = feature.actions.set_value;

  this.toggleOccupancy = function () {
    var newValue = _this.isHome() ? "away" : "home";

    if (toggleAction == null) {
      return $.Deferred.reject(new Error("Attempted to toggle occupancy on a device with no toggle action in its occupancy feature"));
    } else {
      return _this.executeDeviceAction(toggleAction, {
        value: newValue
      });
    }
  };

  this.isAway = function () {
    return feature.value === "away";
  };

  this.isAutoAway = function () {
    return feature.value === "auto-away";
  };

  this.isUnknown = function () {
    return feature.value === "unknown";
  };

  return this.isHome = function () {
    return feature.value === "home";
  };
}


/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Pivot;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(17);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable camelcase */

/* eslint-disable babel/no-invalid-this */


function Pivot(feature) {
  var _this = this;

  var setOccupancySetpointsAction = feature.actions.set_occupancy_setpoints;
  var setGroupOccupancySetpointsAction = feature.actions.set_group_occupancy_setpoints;
  var setOccupancyModeAction = feature.actions.set_occupancy_mode;
  var setGroupSchedule = feature.actions.set_group_schedule;
  var getSchedulesWithDefault = feature.actions.get_schedules_with_default;
  var maxSchedulePeriodsPerDay = feature.max_periods_per_day;
  var maxPeriodNameLength = feature.max_period_name_length;
  var setHighLowTempAlertAction = feature.actions.set_high_low_temp_alert;
  var setGroupHighLowTempAlertAction = feature.actions.set_group_high_low_temp_alert;
  var setHumidityAlertAction = feature.actions.set_humidity_alert;
  var setGroupHumidityAlertAction = feature.actions.set_group_humidity_alert;
  var setSensorFaultAction = feature.actions.set_sensor_fault_enabled;
  var setGroupSensorFaultAction = feature.actions.set_group_sensor_fault_enabled;
  var setSensorAction = feature.actions.set_generic_sensor_alert;
  var setPinAccessAction = feature.actions.set_pin_access;
  var setGroupPinAccessAction = feature.actions.set_group_pin_access;
  var setAccessLevelAction = feature.actions.set_access_level;
  var setGroupAccessLevelAction = feature.actions.set_group_access_level;

  this.setOccupancySetpoints = function (setpoints) {
    if (setOccupancySetpointsAction) {
      var options = {
        data: {
          setpoints: setpoints
        },
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setOccupancySetpointsAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set occupancy setpoints on a device with no set occupancy setpoints action"));
    }
  };

  this.setGroupOccupancySetpoints = function (device_ids, setpoints) {
    if (setGroupOccupancySetpointsAction) {
      var options = {
        data: {
          device_ids: device_ids,
          setpoints: setpoints
        },
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setGroupOccupancySetpointsAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set group occupancy setpoints on a device with no set group occupancy setpoints action"));
    }
  };

  this.setOccupancyMode = function (value) {
    if (setOccupancyModeAction) {
      var options = {
        data: {
          value: value
        },
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setOccupancyModeAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set occupancy mode on a device with no set occupancy mode action"));
    }
  };

  this.setGroupSchedule = function (device_ids, schedule) {
    if (setGroupSchedule) {
      var options = {
        data: {
          device_ids: device_ids,
          schedule: schedule
        },
        // make sure the schedule verifier on the server has more than enough time to finish its attempts
        maxRequestsCount: 120
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setGroupSchedule, options);
    } else {
      return Promise.reject(new Error("Attempted to set group schedule on a device with no set group schedule action"));
    }
  };

  var createScheduleModelFromData = function createScheduleModelFromData(data) {
    var result = new __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_base_model__["a" /* default */](data, {
      parse: true
    });
    result.set({
      can_add_remove_periods: true,
      max_period_name_length: maxPeriodNameLength,
      max_periods_per_day: maxSchedulePeriodsPerDay
    });
    return result;
  };

  this.getSchedulesWithDefault = function () {
    if (getSchedulesWithDefault) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, getSchedulesWithDefault, {}).then(function (results) {
        return results.items.map(function (schedule) {
          return createScheduleModelFromData(schedule);
        });
      });
    } else {
      return Promise.reject(new Error("Attempted to get schedules with default on a device with no get schedules with default action"));
    }
  };

  this.setHighLowTempAlert = function (alertSettings) {
    if (setHighLowTempAlertAction) {
      var options = {
        data: {
          temperature_high_limit: alertSettings.alertHigh,
          temperature_low_limit: alertSettings.alertLow,
          notified_for_temperature: alertSettings.highLowAlertEnabled
        },
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setHighLowTempAlertAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set temperature alerts on a device with no temperature alerts action"));
    }
  };

  this.setGroupHighLowTempAlert = function (device_ids, alertSettings) {
    if (setGroupHighLowTempAlertAction) {
      var options = {
        data: {
          device_ids: device_ids,
          temperature_high_limit: alertSettings.alertHigh,
          temperature_low_limit: alertSettings.alertLow,
          notified_for_temperature: alertSettings.highLowAlertEnabled
        },
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setGroupHighLowTempAlertAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set group temperature alerts on a device with no group temperature alerts action"));
    }
  };

  this.setHumidityAlert = function (alertSettings) {
    if (setHumidityAlertAction) {
      var options = {
        data: {
          humidity_high_limit: alertSettings.humidityHigh,
          humidity_low_limit: alertSettings.humidityLow,
          notified_for_humidity: alertSettings.humidityAlertEnabled
        },
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setHumidityAlertAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set humidity alerts on a device with no humidity alerts action"));
    }
  };

  this.setGroupHumidityAlert = function (device_ids, alertSettings) {
    if (setGroupHumidityAlertAction) {
      var options = {
        data: {
          id: device_ids[1],
          device_ids: device_ids,
          humidity_high_limit: alertSettings.humidityHigh,
          humidity_low_limit: alertSettings.humidityLow,
          notified_for_humidity: alertSettings.humidityAlertEnabled
        },
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setGroupHumidityAlertAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set group humidity alerts on a device with no group humidity alerts action"));
    }
  };

  this.setSensorFaultAlert = function (value) {
    if (setSensorFaultAction) {
      var options = {
        data: {
          value: value
        },
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setSensorFaultAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set sensor fault alerts on a device with no sensor fault alerts action"));
    }
  };

  this.setSensorAlert = function (alertSettings, notificationType, sensorID) {
    if (setSensorAction) {
      var options = {
        data: {
          notified_for_alert: alertSettings.alertEnabled,
          sensor_high_limit: alertSettings.alertHigh,
          sensor_low_limit: alertSettings.alertLow,
          notification_type: notificationType,
          sensor_id: sensorID
        },
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setSensorAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set sensor alerts on a device with no sensor alerts action"));
    }
  };

  this.setPinAccess = function (pins) {
    if (setPinAccessAction) {
      var options = {
        data: _objectSpread({}, pins),
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setPinAccessAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set pin access on a device with no pin access action"));
    }
  };

  this.setGroupSensorFaultAlert = function (device_ids, value) {
    if (setGroupSensorFaultAction) {
      var options = {
        data: {
          device_ids: device_ids,
          value: value
        },
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setGroupSensorFaultAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set group sensor fault alerts on a device with no group sensor fault alerts action"));
    }
  };

  this.setGroupPinAccess = function (device_ids, pins) {
    if (setGroupPinAccessAction) {
      var options = {
        data: _objectSpread({
          device_ids: device_ids
        }, pins),
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setGroupPinAccessAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set group pin access on a device with no group pin access action"));
    }
  };

  this.setAccessLevel = function (access_level_type) {
    if (setAccessLevelAction) {
      var options = {
        data: {
          access_level_type: access_level_type
        },
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setAccessLevelAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set access level on a device with no access level action"));
    }
  };

  this.setGroupAccessLevel = function (device_ids, access_level_type) {
    if (setGroupAccessLevelAction) {
      var options = {
        data: {
          device_ids: device_ids,
          access_level_type: access_level_type
        },
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_followLink__["a" /* default */])(_this, setGroupAccessLevelAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set set group access level on a device with no set group access level action"));
    }
  };

  return {
    device_identifier: feature.device_identifier,
    occupancy_setpoints: feature.occupancy_setpoints,
    occupancy_mode: feature.occupancy_mode,
    high_low_temp_alert: feature.high_low_temp_alert,
    humidity_alert: feature.humidity_alert,
    sensor_fault_enabled: feature.sensor_fault_enabled,
    pin_access: feature.pin_access,
    access_level: feature.access_level
  };
}


/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PivotOccupancyMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_followLink__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);

function PivotOccupancyMode(feature) {
  var _this = this;

  var setOccupancyOverrideAction = feature.actions.set_occupancy_override;

  this.setOccupancyOverride = function (value) {
    if (setOccupancyOverrideAction) {
      var options = {
        data: {
          value: value
        },
        fetchModelWhenDone: true
      };
      return Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_followLink__["a" /* default */])(_this, setOccupancyOverrideAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set occupancy override on a device with no set occupancy override action"));
    }
  };
  /* eslint-disable camelcase */


  return {
    pivotOccupancyMode: {
      name: feature.name,
      label: feature.label,
      options: feature.options,
      value: feature.value,
      displayValue: feature.display_value
    },
    override_mode: feature.setpoints_override.occupancy_override_mode,
    override_enabled: feature.occupancy_override.occupancy_override_enabled,
    occupancy_override_start_time: feature.occupancy_override.occupancy_override_start_time,
    occupancy_override_time: feature.occupancy_override.occupancy_override_time,
    current_time: feature.occupancy_override.current_time
  };
  /* eslint-enable camelcase */
}


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RoomIq;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_schema__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(17);


function RoomIq(feature) {
  this.createRoomIqSchema = function () {
    return fetch(feature.href, {
      headers: {
        "Content-Type": "application/json",
        "X-MobileId": __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_local_settings__["c" /* default */].getMobileId(),
        "X-ApiKey": __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_local_settings__["c" /* default */].getApiKey()
      }
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (!data.success) {
        throw new Error("Server error.");
      }

      return new __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_schema__["a" /* default */](data.result, {
        parse: true
      });
    });
  };
}


/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RuntimeHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nx_components_Locales__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */

function RuntimeHistory(feature) {
  var _this = this;

  var language = Object(__WEBPACK_IMPORTED_MODULE_0_nx_components_Locales__["b" /* getLanguageSet */])().nexia_mobile.device_features.runtime_history;
  var getRuntimeHistoryAction = feature.actions.get_runtime_history;
  var getMonthlyRuntimeHistoryAction = feature.actions.get_monthly_runtime_history;

  this.getMonthlyRuntimeHistory = function () {
    return _this.executeDeviceAction(getMonthlyRuntimeHistoryAction, {}, {
      updateModelWithResponse: false,
      message: language.retrievingMonthlyHistory
    });
  };

  this.getDailyRuntimeHistory = function () {
    return _this.executeDeviceAction(getRuntimeHistoryAction, {}, {
      updateModelWithResponse: false,
      message: language.retrievingDailyHistory
    });
  };
}


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Schedule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_followLink__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_Locales__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(17);
/* eslint-disable camelcase */

/* eslint-disable babel/no-invalid-this */




function Schedule(feature) {
  var _this = this;

  var getActiveScheduleAction = feature.actions.get_active_schedule;
  var getDefaultScheduleAction = feature.actions.get_default_schedule;
  var setActiveScheduleAction = feature.actions.set_active_schedule;
  var enableSchedulingAction = feature.actions.enable_scheduling;

  var createScheduleModelFromData = function createScheduleModelFromData(data) {
    var result = new __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_base_model__["a" /* default */](data, {
      parse: true
    });
    result.set({
      can_add_remove_periods: feature.can_add_remove_periods,
      max_schedule_periods_per_day: feature.max_periods_per_day,
      max_period_name_length: feature.max_period_name_length
    });
    return result;
  };

  this.enableScheduling = function () {
    var language = Object(__WEBPACK_IMPORTED_MODULE_3_nx_components_Locales__["b" /* getLanguageSet */])().nexia_mobile.device_features.schedule;

    if (enableSchedulingAction) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_followLink__["a" /* default */])(_this, enableSchedulingAction, {
        data: enableSchedulingAction.data || "",
        fetchModelWhenDone: true
      }).then(function () {
        if (_this.parentGroup) {
          // If the device has a parentGroup and a scheduling feature, it's an
          // xxl zone. Refresh the parent thermostat as well.
          return _this.parentGroup.fetch();
        }

        return Promise.resolve();
      }).then(function () {
        return _this.get("scheduling_enabled") ? {
          message: language.scheduleEnableSuccess,
          success: true
        } : {
          message: language.scheduleEnableFailure,
          success: false
        };
      }, // A rejection from followLink has already shown a toast
      function () {
        return null;
      });
    } else {
      return Promise.reject(new Error("Attempted to enable scheduling on a device with no enable scheduling action"));
    }
  };

  this.getActiveSchedule = function () {
    if (getActiveScheduleAction) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_followLink__["a" /* default */])(_this, getActiveScheduleAction, {}).then(function (data) {
        return createScheduleModelFromData(data);
      });
    } else {
      return Promise.reject(new Error("Attempted to get schedule on a device with no get schedule action"));
    }
  };

  this.hasDefaultSchedule = function () {
    return Boolean(getDefaultScheduleAction);
  };

  this.getDefaultSchedule = function () {
    if (getDefaultScheduleAction) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_followLink__["a" /* default */])(_this, getDefaultScheduleAction, {}).then(function (data) {
        return createScheduleModelFromData(data);
      });
    } else {
      return Promise.reject(new Error("Attempted to load default schedule on a device with no default schedule action"));
    }
  };

  this.setActiveSchedule = function (schedule) {
    if (setActiveScheduleAction) {
      var options = {
        data: schedule.attributes,
        // make sure the schedule verifier on the server has more than enough time to finish its attempts
        maxRequestsCount: 120
      };
      return Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_followLink__["a" /* default */])(_this, setActiveScheduleAction, options);
    } else {
      return Promise.reject(new Error("Attempted to set schedule on a device with no set schedule action"));
    }
  };

  if (!this._scheduleCollection) {
    this._scheduleCollection = new __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_base_collection__["a" /* default */]();
  }

  this._scheduleCollection.setUrl(feature.collection_url);

  this.getScheduleCollection = function () {
    return _this._scheduleCollection;
  };

  return {
    scheduling_enabled: feature.enabled
  };
}


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SolarPanel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable camelcase */

/* eslint-disable babel/no-invalid-this */
function SolarPanel(feature) {
  this.isNameEditable = function () {
    return false;
  };

  return _objectSpread({
    name: "Energy",
    icon: "icon_sunny",
    is_setup: feature.is_setup
  }, feature.is_setup ? {
    history_chart: feature.history_chart,
    energy_production_current: feature.energy_production_current,
    energy_production_today: feature.energy_production_today,
    energy_production_month: feature.energy_production_month,
    energy_production_lifetime: feature.energy_production_lifetime,
    dollars_saved_today: feature.dollars_saved_today,
    dollars_saved_month: feature.dollars_saved_month,
    dollars_saved_lifetime: feature.dollars_saved_lifetime
  } : null);
}


/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Speaker;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* eslint-disable camelcase */

/* eslint-disable babel/no-invalid-this */
function Speaker(feature) {
  var _this = this;

  var playAction = feature.actions.play;
  var pauseAction = feature.actions.pause;
  var setVolumeAction = feature.actions.set_volume;
  var playFavoriteAction = feature.actions.play_favorite;
  var seekPreviousAction = feature.actions.seek_previous;
  var seekNextAction = feature.actions.seek_next;
  /* eslint-disable no-unused-vars */

  var playUrlAction = feature.actions.play_url;
  /* eslint-enable no-unused-vars */

  this.play = function () {
    if (feature.is_playing) {
      return $.Deferred.resolve();
    } else {
      return _this.executeDeviceAction(playAction, {}, {
        message: "Playing"
      });
    }
  };

  this.playFavorite = function (title) {
    return _this.executeDeviceAction(playFavoriteAction, {
      title: title
    }, {
      message: "Playing favorite \"".concat(title, "\"")
    });
  };

  this.pause = function () {
    if (feature.is_playing) {
      return _this.executeDeviceAction(pauseAction, {}, {
        message: "Pausing"
      });
    } else {
      return $.Deferred.resolve();
    }
  };

  this.setVolume = function (speakerVolume) {
    return _this.executeDeviceAction(setVolumeAction, {
      volume: speakerVolume
    }, {
      message: "Setting volume to ".concat(speakerVolume, "%")
    });
  };

  this.canSeekNext = function () {
    return seekNextAction != null;
  };

  this.seekNext = function () {
    return _this.executeDeviceAction(seekNextAction, {}, {
      message: "Seeking next track"
    });
  };

  this.canSeekPrevious = function () {
    return seekPreviousAction != null;
  };

  this.seekPrevious = function () {
    return _this.executeDeviceAction(seekPreviousAction, {}, {
      message: "Seeking previous track"
    });
  }; // let Sonos app/speaker configuration decide name


  this.isNameEditable = function () {
    return false;
  };

  return {
    status: feature.status,
    is_playing: feature.is_playing,
    volume: feature.volume,
    favorites: feature.favorites
  };
}


/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Sprinkler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_schema__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */

function Sprinkler(feature) {
  var _this = this;

  var standbyAction = feature.actions.standby_mode;
  var waterZonesAction = feature.actions.water_zones;
  var stopWaterAction = feature.actions.stop_water; // let rachio decide name

  this.isNameEditable = function () {
    return false;
  };

  this.inStandbyMode = function () {
    return _this.get("standby_mode");
  };

  this.enableStandbyMode = function (yesno) {
    return _this.executeDeviceAction(standbyAction, {
      value: yesno
    }, {
      updateModelWithResponse: false
    }).then(function () {
      return _this.fetchDetails();
    });
  };

  this.fetchWaterZonesSchema = function () {
    return _this.executeDeviceAction(waterZonesAction, {}, {
      updateModelWithResponse: false
    }).then(function (data) {
      return new __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_schema__["a" /* default */](data, {
        parse: true
      });
    });
  };

  this.stopWater = function () {
    return _this.executeDeviceAction(stopWaterAction, {}, {
      updateModelWithResponse: false
    }).then(function () {
      return _this.fetchDetails();
    });
  };

  return {};
}


/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Streamable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */
function Streamable(feature) {
  var _this = this;

  var toggleAction = feature.actions.set_value;

  this.toggleStreaming = function () {
    var newValue = !_this.isStreaming();

    if (toggleAction == null) {
      return $.Deferred.reject(new Error("Attempted to toggle streaming on a device whose streamable feature had no set_value action"));
    } else {
      return _this.executeDeviceAction(toggleAction, {
        value: newValue
      });
    }
  };

  this.isStreaming = function () {
    return feature.value;
  };

  this.isConnected = function () {
    return feature.connected;
  };

  return {
    status: feature.connected ? "Connected" : "Disconnected",
    streamWebUrl: feature.stream_web_url,
    streamAppUrl: feature.stream_app_url
  };
}


/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Switch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */


var executeWithCheck = function executeWithCheck(device, action, errorVerb) {
  if (action == null) {
    return Promise.reject(new Error("Attempted to ".concat(errorVerb, " a device whose switch feature had no ").concat(errorVerb, " action")));
  } else {
    return device.executeDeviceAction(action, {});
  }
};

function Switch(feature) {
  var _this = this;

  var toggleAction = feature.actions.toggle;
  var onAction = feature.actions.on;
  var offAction = feature.actions.off;

  this.canSetOnAndOffSeparately = function () {
    return Boolean(onAction && offAction);
  };

  this.turnOn = function () {
    return executeWithCheck(_this, onAction, "turn on").then(function () {
      Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("DEMO_MODE_EVENT", _this, "Turned on");
    });
  };

  this.turnOff = function () {
    return executeWithCheck(_this, offAction, "turn off").then(function () {
      Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("DEMO_MODE_EVENT", _this, "Turned off");
    });
  };

  this.isOn = function () {
    return _this.get("status") === "on";
  };

  this.toggle = function () {
    var demoEventDescription = _this.isOn() ? "Turned off" : "Turned on";
    return executeWithCheck(_this, toggleAction, "toggle").then(function () {
      Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("DEMO_MODE_EVENT", _this, demoEventDescription);
    });
  };

  return {
    status: feature.status
  };
}


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ThermostatCompressorSpeed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
function ThermostatCompressorSpeed(feature) {
  return {
    /* eslint-disable camelcase */
    compressor_speed: feature.compressor_speed
    /* eslint-enable camelcase */

  };
}


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ThermostatFanMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
function ThermostatFanMode(feature) {
  var _this = this;

  var updateFanModeAction = feature.actions.update_thermostat_fan_mode;

  this.setThermostatFanMode = function (value) {
    var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _this.executeDeviceAction(updateFanModeAction, {
      value: value,
      ids: ids
    }, {
      fetchModelWhenDone: true
    });
  };

  return {
    thermostatFanMode: {
      name: feature.name,
      label: feature.label,
      statusIcon: feature.status_icon,
      options: feature.options,
      value: feature.value,
      displayValue: feature.display_value
    }
  };
}


/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ThermostatMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
function ThermostatMode(feature) {
  var _this = this;

  var updateModeAction = feature.actions.update_thermostat_mode;

  this.setThermostatMode = function (value) {
    var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _this.executeDeviceAction(updateModeAction, {
      value: value,
      ids: ids
    }, {
      fetchModelWhenDone: true
    });
  };

  return {
    thermostatMode: {
      name: feature.name,
      label: feature.label,
      options: feature.options,
      value: feature.value,
      displayValue: feature.display_value
    }
  };
}


/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ThermostatRunMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
function ThermostatRunMode(feature) {
  var _this = this;

  var updateRunModeAction = feature.actions.update_thermostat_run_mode;

  this.setThermostatRunMode = function (value) {
    return _this.executeDeviceAction(updateRunModeAction, {
      value: value
    }, {
      fetchModelWhenDone: true
    });
  };

  return {
    thermostatRunMode: {
      name: feature.name,
      label: feature.label,
      options: feature.options,
      value: feature.value,
      displayValue: feature.display_value
    }
  };
}


/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Unenroll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */

function Unenroll(feature) {
  var _this = this;

  var unenrollAction = feature.actions.unenroll;

  this.hasGuidedUnenrollment = function () {
    return unenrollAction.type === __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__["a" /* default */].SCHEMA;
  };

  this.unenroll = function () {
    if (unenrollAction == null) {
      return $.Deferred.reject(new Error("Attempted to unenroll device whose unenroll feature has no unenroll action"));
    }

    return _this.executeDeviceAction(unenrollAction, {}, {
      updateModelWithResponse: false
    });
  };
}


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UnlockLock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */

function UnlockLock(feature) {
  var _this = this;

  var unlockAction = feature.actions.unlock;

  this.unlock = function () {
    var promiseWithAbort = _this.executeDeviceAction(unlockAction, {});

    promiseWithAbort.then(function () {
      Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("DEMO_MODE_EVENT", _this, "Unlocked");
    });
    return promiseWithAbort;
  };

  return {
    isUnlocked: feature.is_unlocked
  };
}


/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Valve;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_safe_access__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_safe_access___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_safe_access__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */

function Valve(feature) {
  var _this = this;

  var operateAction = feature.actions.operate;

  this.isValveClosed = function () {
    return _this.get("status") === "closed";
  };

  this.isValveOperable = function () {
    return operateAction != null;
  };

  this.getCurrentValveOperation = function () {
    return __WEBPACK_IMPORTED_MODULE_0_safe_access___default()(operateAction, "title");
  };

  this.operateValve = function () {
    if (!_this.isValveOperable()) {
      return $.Deferred.reject(new Error("Attempted to operate an inoperable valve"));
    }

    return _this.executeDeviceActionThenFetch(operateAction, {});
  };

  return {
    status: feature.status
  };
}


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WindowShadeOpenCloseStop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* eslint-disable camelcase */

/* eslint-disable babel/no-invalid-this */
function WindowShadeOpenCloseStop(feature) {
  var _this = this;

  var openAction = feature.actions.open;
  var stopAction = feature.actions.stop;
  var closeAction = feature.actions.close;

  this.open = function () {
    return _this.executeDeviceAction(openAction, {});
  };

  this.close = function () {
    return _this.executeDeviceAction(closeAction, {});
  };

  this.stop = function () {
    return _this.executeDeviceAction(stopAction, {});
  };

  return {
    percent_open: feature.percent_open
  };
}


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WindowShadeSetPercentOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(17);
/* eslint-disable camelcase */

/* eslint-disable babel/no-invalid-this */
function WindowShadeSetPercentOpen(feature) {
  var _this = this;

  var setPercentOpenAction = feature.actions.set_percent_open;

  this.setPercentOpen = function (newValue) {
    return _this.executeDeviceAction(setPercentOpenAction, {
      percent_open: newValue
    });
  };

  return {
    percent_open: feature.percent_open
  };
}


/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = XR724WifiConfiguration;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_followLink__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(17);
/* eslint-disable babel/no-invalid-this */

function XR724WifiConfiguration(feature) {
  var _this = this;

  this.fetchLastUpdateTime = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_followLink__["a" /* default */])(_this, feature.get_last_update_time, {
      silent: true
    }).then(function (data) {
      return data.last_update_time && new Date(data.last_update_time);
    });
  };

  return {};
}


/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_schema__ = __webpack_require__(52);

/* harmony default export */ __webpack_exports__["a"] = ({
  parseLinksDetails: function parseLinksDetails(links) {
    var link = _.first(links);

    if (link) {
      var SchemaClass = this.getDetailsSchemaClass();
      var schema = new SchemaClass(link.getData(), {
        parse: true
      });
      schema.parentModel = this; // so the details schema can be used to delete its parent resource

      schema.setUrl(link.href);
      schema.setStoredOnServer(link.isPostLink());
      this._detailsSchema = schema;
    }
  },
  createDetailsSchema: function createDetailsSchema() {
    if (this._detailsSchema) {
      return this._detailsSchema.prepare();
    } else {
      return Promise.reject(new Error("Attempted to create a details schema for a model that had no details link"));
    }
  },
  getDetailsSchemaClass: function getDetailsSchemaClass() {
    return __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_models_schema__["a" /* default */];
  }
});

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModeCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_mode__ = __webpack_require__(1001);










var ModeCollection =
/*#__PURE__*/
function (_BaseCollection) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ModeCollection, _BaseCollection);

  function ModeCollection() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ModeCollection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ModeCollection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "model", __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_mode__["a" /* default */]);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ModeCollection, [{
    key: "getActiveMode",
    value: function getActiveMode() {
      return this.findWhere({
        enabled: true
      });
    }
  }, {
    key: "setActiveMode",
    value: function setActiveMode(mode) {
      var _this2 = this;

      return mode.postCommand("activate").then(function () {
        return _this2.fetch();
      }, function () {
        return _this2.fetch();
      }).then(function () {
        // when the current mode changes, the 'enable' state of each automation
        // can change, so just reload the automations
        _this2.trigger("reload_automations");
      });
    }
  }]);

  return ModeCollection;
}(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_collection__["a" /* default */]);



/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_url__ = __webpack_require__(73);









var Mode =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Mode, _BaseModel);

  function Mode() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Mode);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Mode).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Mode, [{
    key: "onParse",
    value: function onParse(rawAttrs) {
      var attrs = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Mode.prototype), "onParse", this).call(this, rawAttrs);

      if (attrs.hasOwnProperty("current_mode")) {
        attrs.enabled = attrs.current_mode;
        delete attrs.current_mode;
      }

      if (attrs.icon) {
        var filename = __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_url__["a" /* default */].getFilename(attrs.icon);
        attrs.icon = filename.substr(0, filename.lastIndexOf(".")) || filename;
      }

      return attrs;
    }
  }]);

  return Mode;
}(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__["a" /* default */]);



/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_mixins_video_feed__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_mixins_editable__ = __webpack_require__(90);











var RecordedVideo =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(RecordedVideo, _BaseModel);

  function RecordedVideo() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, RecordedVideo);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(RecordedVideo).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(RecordedVideo, [{
    key: "getResolution",
    value: function getResolution() {
      return this.get("resolution");
    }
  }, {
    key: "onParse",
    value: function onParse(rawAttrs) {
      var attrs = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(RecordedVideo.prototype), "onParse", this).call(this, rawAttrs);

      return {
        id: attrs.id,
        name: attrs.name,
        size: attrs.size,
        "protected": attrs.write_protected == null ? attrs["protected"] : attrs.write_protected,
        thumbnail: attrs.thumbnail,
        mediaType: attrs.media_type == null ? attrs.mediaType : attrs.media_type,
        recordedAt: attrs.created_at == null ? attrs.recordedAt : attrs.created_at,
        trigger: attrs.trigger,
        quality: attrs.quality,
        resolution: attrs.resolution,
        aspectRatio: attrs.aspect_ratio == null ? attrs.aspectRatio : attrs.aspect_ratio
      };
    }
  }]);

  return RecordedVideo;
}(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_base_model__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(RecordedVideo, "isEphemeral", true);

_.extend(RecordedVideo.prototype, __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_mixins_video_feed__["a" /* default */]);

_.extend(RecordedVideo.prototype, __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_mixins_editable__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (RecordedVideo);

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_base_collection__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_mixins_pageable__ = __webpack_require__(267);







var NewsCollection =
/*#__PURE__*/
function (_BaseCollection) {
  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits___default()(NewsCollection, _BaseCollection);

  function NewsCollection() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, NewsCollection);

    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default()(NewsCollection).apply(this, arguments));
  }

  return NewsCollection;
}(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_base_collection__["a" /* default */]);

_.extend(NewsCollection.prototype, __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_mixins_pageable__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (NewsCollection);

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Geofence; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__ = __webpack_require__(36);








var Geofence =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Geofence, _BaseModel);

  function Geofence() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Geofence);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Geofence).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Geofence, [{
    key: "defaults",
    value: function defaults() {
      return {
        name: "New Geofence",
        latitude: 0,
        longitude: 0,
        radius: 10000
      };
    }
  }, {
    key: "onParse",
    value: function onParse(attrs) {
      this.set("hrefAcknowledge", null);
      return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Geofence.prototype), "onParse", this).call(this, attrs);
    }
  }, {
    key: "parseLinksAcknowledge",
    value: function parseLinksAcknowledge(links) {
      var link = _.first(links);

      if (link == null) {
        return;
      }

      this.set("hrefAcknowledge", link.href);
    }
  }, {
    key: "parseLinksOperation",
    value: function parseLinksOperation(links) {
      var _this = this;

      _.each(links, function (link) {
        if (link.title.match(/enter/i)) {
          _this.set("hrefEnter", link.href);
        } else if (link.title.match(/exit/i)) {
          _this.set("hrefExit", link.href);
        }
      });
    }
  }]);

  return Geofence;
}(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__["a" /* default */]);



/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Choice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_base_model__ = __webpack_require__(36);







var Choice =
/*#__PURE__*/
function (_BaseModel) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Choice, _BaseModel);

  function Choice() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Choice);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Choice).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Choice, [{
    key: "nestedCollections",
    value: function nestedCollections() {
      return {
        buttons: {}
      };
    }
  }]);

  return Choice;
}(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_base_model__["a" /* default */]);



/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DemoSession; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_session__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_framework_media_type__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_fixtures_location__ = __webpack_require__(1007);






/* eslint-disable camelcase */




$.mockjaxSettings.responseTime = 500;
$.mockjaxSettings.contentType = "application/json";
$.mockjaxSettings.logging = false;
$.mockjaxSettings.retainAjaxCalls = false;

var DemoSession =
/*#__PURE__*/
function (_Session) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DemoSession, _Session);

  function DemoSession() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DemoSession);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DemoSession).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DemoSession, [{
    key: "initialize",
    value: function initialize() {
      this.setUrl("mobile/session");

      this._stubAllEndpoints();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._unstubAllEndpoints();
    }
  }, {
    key: "_unstubAllEndpoints",
    value: function _unstubAllEndpoints() {
      this._handlerIds.forEach(function (id) {
        return $.mockjax.clear(id);
      });

      this._handlerIds = [];
    }
  }, {
    key: "_stubAllEndpoints",
    value: function _stubAllEndpoints() {
      var _this = this;

      this._handlerIds = [];

      var stub = function stub(obj) {
        _this._handlerIds.push($.mockjax(obj));
      };

      function apiResponse(data) {
        return JSON.stringify({
          success: true,
          error: null,
          result: data
        });
      }

      var location = _.extend({}, __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_fixtures_location__["a" /* default */]);

      location._links.self = {
        href: "mobile/houses/1"
      };
      var session = {
        can_control_automations: true,
        can_manage_locks: true,
        can_view_videos: true,
        can_receive_notifications: true,
        _links: {
          child: [{
            href: "mobile/houses/1",
            type: __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_framework_media_type__["a" /* default */].LOCATION,
            data: {
              id: location.id,
              name: location.name
            }
          }]
        }
      };
      stub({
        url: /session/,
        responseText: apiResponse(session)
      });
      stub({
        url: /houses\/1/,
        responseText: apiResponse(location)
      });
      stub({
        url: /mode.*activate/,
        type: "POST",
        responseText: apiResponse({})
      });
      stub({
        url: /automations/,
        responseText: apiResponse(location._urlMap.automations)
      });
      stub({
        url: /events/,
        response: function response(request) {
          var filter = "_NO_FILTER_";
          var matches = request.url.match(/events\??([\w=]+)$/);

          if (matches && matches[1]) {
            filter = matches[1];
          }

          var events = __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_store__["a" /* default */].demoModeEvents[filter];
          this.responseText = apiResponse({
            item_type: __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_framework_media_type__["a" /* default */].EVENT,
            items: events,
            _links: {
              self: {
                href: request.url
              },
              page: {
                data: {
                  current_page: 1,
                  page_count: 1
                }
              }
            }
          });
        }
      });
      stub({
        url: /videos/,
        responseText: apiResponse(location._urlMap.videos)
      });
      Object.keys(location._urlMap).forEach(function (url) {
        stub({
          url: url,
          type: "GET",
          response: function response(request) {
            var resource = location._urlMap[request.url];
            this.responseText = apiResponse(resource);
          }
        });
      });
      stub({
        type: "DELETE",
        url: /automation/,
        responseText: apiResponse({})
      });
      stub({
        url: /.*/,
        type: "PUT",
        response: function response(request) {
          var resource = location._urlMap[request.url];

          if (typeof request.data !== "string") {
            request.data = JSON.stringify(request.data);
          }

          var data = _.extend(resource, JSON.parse(request.data || "{}"));

          this.responseText = apiResponse(data);
        }
      });
      stub({
        url: /thermostat.*\/(mode)/,
        urlParams: ["setting"],
        type: "POST",
        response: function response(request) {
          var setting = request.urlParams.setting;

          var resource = location._urlMap[request.url.replace(new RegExp("/".concat(setting, "/?$")), "")];

          var value = request.data.value;
          resource.settings[0].current_value = request.data.value;

          switch (value) {
            case 0:
              {
                resource.features[0].setpoint_heat = undefined;
                resource.features[0].setpoint_cool = undefined;
                break;
              }

            case 1:
              {
                resource.features[0].setpoint_heat = resource.setpoints.heat;
                resource.features[0].setpoint_cool = undefined;
                break;
              }

            case 2:
              {
                resource.features[0].setpoint_heat = undefined;
                resource.features[0].setpoint_cool = resource.setpoints.cool;
                break;
              }

            case 3:
              {
                resource.features[0].setpoint_heat = resource.setpoints.heat;
                resource.features[0].setpoint_cool = resource.setpoints.cool;
              }
          }

          this.responseText = apiResponse(resource);
        }
      });
      stub({
        url: /thermostat.*\/(setpoints)/,
        urlParams: ["action"],
        type: "POST",
        response: function response(request) {
          var action = request.urlParams.action;

          var resource = location._urlMap[request.url.replace(new RegExp("/".concat(action, "$")), "")];

          if (action === "setpoints") {
            resource.setpoints = JSON.parse(request.data);
          }

          this.responseText = apiResponse(resource);
        }
      });
      stub({
        url: /lock.*\/(lock|unlock|activate)$/,
        urlParams: ["action"],
        type: "POST",
        response: function response(request) {
          var action = request.urlParams.action;

          var resource = location._urlMap[request.url.replace(new RegExp("/".concat(action, "$")), "")];

          if (action === "lock") {
            resource.current_state = "locked";
            resource.current_action = "unlock";
            resource.icon = {
              name: "lock_locked",
              modifiers: []
            };
          } else if (action === "unlock") {
            resource.current_state = "unlocked";
            resource.current_action = "lock";
            resource.icon = {
              name: "lock_unlocked",
              modifiers: ["insecure"]
            };
          }

          this.responseText = apiResponse(resource);
        }
      });
      stub({
        url: /switch.*\/(on|off)$/,
        urlParams: ["action"],
        type: "POST",
        response: function response(request) {
          var action = request.urlParams.action;

          var resource = location._urlMap[request.url.replace("/".concat(action), "")];

          if (action === "off") {
            resource.value = 0;
            resource.icon = {
              name: "switch_off"
            };
          } else {
            resource.value = 255;
            resource.icon = {
              name: "switch_on"
            };
          }

          this.responseText = apiResponse(resource);
        }
      });
      stub({
        url: /.*/,
        type: "POST",
        response: function response(request) {
          if (typeof request.data !== "string") {
            request.data = JSON.stringify(request.data);
          }

          this.responseText = apiResponse(JSON.parse(request.data || "{}"));
        }
      });
    }
  }, {
    key: "_loadFromCache",
    value: function _loadFromCache() {// no-op parent behavior
    }
  }, {
    key: "_addToSessionCache",
    value: function _addToSessionCache() {// no-op parent behavior
    }
  }, {
    key: "_defaultLocationId",
    value: function _defaultLocationId() {
      return 1;
    }
  }]);

  return DemoSession;
}(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_session__["a" /* default */]);



/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__ = __webpack_require__(72);
/* eslint-disable camelcase */

var oneDayAgo = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
var thermostat = {
  type: "thermostat",
  id: 11,
  name: "Thermostat",
  current_fan_mode: 0,
  current_mode: 3,
  current_run_mode: 0,
  delta: 3,
  features: [{
    name: "thermostat",
    temperature: 77,
    status: "System Idle",
    actions: {
      set_heat_setpoint: {
        method: "POST",
        href: "thermostat/11/setpoints"
      },
      set_cool_setpoint: {
        method: "POST",
        href: "thermostat/11/setpoints"
      }
    },
    setpoint_delta: 3,
    setpoint_increment: 1,
    setpoint_heat_min: 55,
    setpoint_heat_max: 95,
    setpoint_cool_min: 60,
    setpoint_cool_max: 100,
    setpoint_heat: 70,
    setpoint_cool: 80
  }],
  icon: {
    name: "thermostat",
    modifiers: ["temperature-77"]
  },
  operating_state: "System Idle",
  scale: "F",
  setpoints: {
    heat: 70,
    cool: 80
  },
  settings: [{
    current_value: 3,
    labels: ["Off", "Heat", "Cool", "Auto"],
    title: "Mode",
    type: "mode",
    values: [0, 1, 2, 3]
  }],
  supported_fan_modes: {
    0: "Auto",
    1: "On"
  },
  supported_modes: {
    0: "Off",
    1: "Heat",
    2: "Cool",
    3: "Auto"
  },
  supported_run_modes: {
    0: "Hold Temp",
    2: "Energy Save"
  },
  temperature: 77,
  value: 255
};
var livingRoomLights = {
  name: "Living Room Lights",
  id: 12,
  type: "switch",
  value: 45,
  icon: {
    name: "switch_on"
  },
  settings: []
};
var frontDoorLock = {
  name: "Front Door Lock",
  id: 13,
  battery_level: 66,
  current_action: "unlock",
  current_state: "locked",
  has_temporary_code: false,
  icon: {
    name: "lock_locked",
    modifiers: []
  },
  supports_user_codes: false,
  type: "lock",
  user_code_length: 4,
  value: 255,
  status: "Locked",
  features: [{
    name: "lock_lock",
    is_locked: true,
    actions: {
      lock: {
        method: "POST",
        href: "locks/13/lock"
      }
    }
  }, {
    name: "unlock_lock",
    is_unlocked: false,
    actions: {
      lock: {
        method: "POST",
        href: "locks/13/unlock"
      }
    }
  }]
};
var motionSensor = {
  name: "Hallway Motion Sensor",
  id: 14,
  current_state_text: "no motion detected",
  icon: {
    name: "sensor_motion_idle",
    modifiers: []
  },
  sensor_type: "motion",
  settings: [],
  type: "sensor",
  value: 0,
  features: [{
    name: "battery",
    label: "75% remaining",
    updated_at: oneDayAgo,
    icon: "battery_mostly_full"
  }]
};
var masterBedroomLights = {
  name: "Master Bedroom Lights",
  id: 16,
  type: "switch",
  value: 45,
  icon: {
    name: "switch_on"
  },
  settings: []
};
var masterBedroomLock = {
  name: "Master Bedroom Lock",
  id: 17,
  battery_level: 99,
  current_action: "unlock",
  current_state: "locked",
  has_temporary_code: false,
  icon: {
    name: "lock_locked",
    modifiers: []
  },
  supports_user_codes: false,
  type: "lock",
  user_code_length: 4,
  value: 255
};
var upstairsGroup = {
  name: "Upstairs",
  id: 15,
  type: "group",
  icon: [{
    name: "switch_on"
  }, {
    name: "lock_locked"
  }],
  _links: {
    child: [{
      data: masterBedroomLights
    }, {
      data: masterBedroomLock
    }]
  }
};

var addHistoryLink = function addHistoryLink(model, filterType) {
  if (!model._links) {
    model._links = {};
  }

  model._links["nexia:history"] = {
    href: "/events?".concat(filterType, "_id=").concat(model.id)
  };
};

var addEvents = function addEvents(device, events) {
  device._links["nexia:history"].data = {
    item_type: __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__["a" /* default */].EVENT,
    items: events
  };
};

addHistoryLink(thermostat, "device");
addHistoryLink(livingRoomLights, "device");
addHistoryLink(frontDoorLock, "device");
addHistoryLink(motionSensor, "device");
addEvents(motionSensor, [{
  device_name: motionSensor.name,
  user_name: "",
  description: "Motion detected",
  occurred_at: oneDayAgo
}, {
  device_name: motionSensor.name,
  user_name: "",
  description: "Battery Level: 75% remaining",
  occurred_at: oneDayAgo
}]);
addHistoryLink(masterBedroomLights, "device");
addHistoryLink(masterBedroomLock, "device");
var devices = {
  item_type: __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__["a" /* default */].DEVICE,
  items: [thermostat, livingRoomLights, frontDoorLock, motionSensor, upstairsGroup]
};
var modes = {
  item_type: __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__["a" /* default */].MODE,
  items: [{
    id: 21,
    name: "Home",
    current_mode: false,
    icon: "home.png",
    settings: []
  }, {
    id: 22,
    name: "Away",
    current_mode: false,
    icon: "away.png",
    settings: []
  }, {
    id: 23,
    name: "Vacation",
    current_mode: true,
    icon: "picture.png",
    settings: []
  }]
};
var events = {
  item_type: __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__["a" /* default */].EVENT,
  _links: {
    page: {
      data: {
        current_page: 1,
        page_count: 1
      }
    }
  }
};
var videos = {
  item_type: __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__["a" /* default */].VIDEO,
  items: [{
    id: 1,
    name: "test",
    size: "size",
    write_protected: false,
    thumbnail: "attrs.thumbnail",
    created_at: "created_at"
  }]
};
var automations = {
  item_type: __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__["a" /* default */].AUTOMATION,
  items: [{
    id: 31,
    name: "Movie Night",
    settings: [],
    triggers: [],
    description: "On Saturdays at sunset Living Room Lights will be set to 50% AND Send an alert",
    enabled: true,
    icon: [{
      name: "calendar_empty",
      modifiers: []
    }, {
      name: "dimmer_30",
      modifiers: []
    }, {
      name: "message",
      modifiers: []
    }]
  }],
  _links: {
    self: {
      href: "automations"
    }
  }
};
addHistoryLink(automations.items[0], "automation");
var location = {
  id: 1,
  name: "Demo House",
  _urlMap: {},
  _links: {}
};
location._links.child = [{
  data: modes,
  type: __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__["a" /* default */].COLLECTION
}, {
  data: devices,
  type: __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__["a" /* default */].COLLECTION
}, {
  data: automations,
  type: __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__["a" /* default */].COLLECTION
}, {
  data: events,
  type: __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__["a" /* default */].COLLECTION
}, {
  data: videos,
  type: __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_media_type__["a" /* default */].COLLECTION
}];

function addSelfLink(resource, objectType) {
  var url = objectType || resource.type || "resource";

  if (resource.id != null) {
    url += "/".concat(resource.id);
  }

  location._urlMap[url] = resource;

  if (resource._links == null) {
    resource._links = {};
  }

  resource._links.self = {
    href: url
  };
}

addSelfLink(automations, "automations");
addSelfLink(videos, "videos");
addSelfLink(events, "events");

_.each(automations.items, function (mode) {
  return addSelfLink(mode, "automation");
});

_.each(modes.items, function (mode) {
  return addSelfLink(mode, "mode");
});

_.each(devices.items, function (device) {
  addSelfLink(device);

  _.each(device.settings, function (setting) {
    return addSelfLink(setting, "".concat(device._links.self.href, "/").concat(setting.type));
  });

  _.each(device._links.child, function (link) {
    if (link.data != null) {
      addSelfLink(link.data);
    }
  });
});

/* harmony default export */ __webpack_exports__["a"] = (location);

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommercialDemoSession; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_session__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_framework_media_type__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_fixtures_commercial_location__ = __webpack_require__(1009);






/* eslint-disable camelcase */



$.mockjaxSettings.responseTime = 500;
$.mockjaxSettings.contentType = "application/json";
$.mockjaxSettings.logging = false;
$.mockjaxSettings.retainAjaxCalls = false;

var CommercialDemoSession =
/*#__PURE__*/
function (_Session) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(CommercialDemoSession, _Session);

  function CommercialDemoSession() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CommercialDemoSession);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(CommercialDemoSession).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CommercialDemoSession, [{
    key: "initialize",
    value: function initialize() {
      this.setUrl("mobile/session");

      this._stubAllEndpoints();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._unstubAllEndpoints();
    }
  }, {
    key: "_unstubAllEndpoints",
    value: function _unstubAllEndpoints() {
      this._handlerIds.forEach(function (id) {
        return $.mockjax.clear(id);
      });

      this._handlerIds = [];
    }
  }, {
    key: "_stubAllEndpoints",
    value: function _stubAllEndpoints() {
      var _this = this;

      this._handlerIds = [];

      var stub = function stub(obj) {
        _this._handlerIds.push($.mockjax(obj));
      };

      function apiResponse(data) {
        return JSON.stringify({
          success: true,
          error: null,
          result: data
        });
      }

      var location = _.extend({}, __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_fixtures_commercial_location__["a" /* default */]);

      location._links.self = {
        href: "mobile/houses/1"
      };
      var session = {
        _links: {
          child: [{
            href: "mobile/houses/1",
            type: __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_framework_media_type__["a" /* default */].LOCATION,
            data: {
              id: location.id,
              name: location.name
            }
          }]
        }
      };
      stub({
        url: /session/,
        responseText: apiResponse(session)
      });
      stub({
        url: /houses\/1/,
        responseText: apiResponse(location)
      });
      stub({
        url: /mode.*activate/,
        type: "POST",
        responseText: apiResponse({})
      });
      stub({
        url: /automations/,
        responseText: apiResponse(location._urlMap.automations)
      });
      stub({
        url: /events/,
        response: function response(request) {
          var date = new Date();
          var today = "".concat(date.getFullYear(), "-").concat(date.getMonth().toString().padStart(2, "0"), "-").concat(date.getDate().toString().padStart(2, "0"));
          var yesterday = "".concat(date.getFullYear(), "-").concat(date.getMonth().toString().padStart(2, "0"), "-").concat((date.getDate() - 1).toString().padStart(2, "0"));
          this.responseText = apiResponse({
            item_type: __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_framework_media_type__["a" /* default */].EVENT,
            items: [{
              device_name: "Clearwater",
              description: "New temperature 72",
              occurred_at: "".concat(today, "T11:40:01-05:00"),
              user_name: "Device Event"
            }, {
              device_name: "Clearwater",
              description: "Set to System Idle",
              occurred_at: "".concat(today, "T11:40:01-05:00"),
              user_name: "Device Event"
            }, {
              device_name: "Clearwater",
              description: "Set to Fan Running",
              occurred_at: "".concat(today, "T11:32:01-05:00"),
              user_name: "Device Event"
            }, {
              device_name: "Clearwater",
              description: "Set to Cooling",
              occurred_at: "".concat(today, "T11:30:01-05:00"),
              user_name: "Device Event"
            }, {
              device_name: "Springfield",
              description: "Schedule mode status set to Following Schedule - Occupied",
              occurred_at: "".concat(today, "T09:45:01-05:00"),
              user_name: "Device Event"
            }, {
              device_name: "Springfield",
              description: "Heat setpoint set to 65",
              occurred_at: "".concat(today, "T09:41:01-05:00"),
              user_name: "Device Event"
            }, {
              device_name: "Springfield",
              description: "Cool setpoint set to 72",
              occurred_at: "".concat(today, "T09:34:01-05:00"),
              user_name: "Device Event"
            }, {
              device_name: "Springfield",
              description: "Set to Cooling",
              occurred_at: "".concat(today, "T09:19:01-05:00"),
              user_name: "Device Event"
            }, {
              device_name: "Offices",
              description: "Set to Cooling",
              occurred_at: "".concat(today, "T07:36:01-05:00"),
              user_name: "Device Event"
            }, {
              device_name: "Offices",
              description: "Set to System Idle",
              occurred_at: "".concat(today, "T07:29:01-05:00"),
              user_name: "Device Event"
            }, {
              device_name: "Offices",
              description: "Set to Cooling",
              occurred_at: "".concat(today, "T07:14:01-05:00"),
              user_name: "Device Event"
            }, {
              device_name: "Show_Room",
              description: "Set to Cooling",
              occurred_at: "".concat(yesterday, "T08:01:01-05:00"),
              user_name: "Device Event"
            }, {
              device_name: "Show_Room",
              description: "Set to System Idle",
              occurred_at: "".concat(yesterday, "T07:50:01-05:00"),
              user_name: "Device Event"
            }, {
              device_name: "Show_Room",
              description: "Set to Fan Running",
              occurred_at: "".concat(yesterday, "T07:50:01-05:00"),
              user_name: "Device Event"
            }],
            _links: {
              self: {
                href: request.url
              },
              page: {
                data: {
                  current_page: 1,
                  page_count: 1
                }
              }
            }
          });
        }
      });
      Object.keys(location._urlMap).forEach(function (url) {
        stub({
          url: url,
          type: "GET",
          response: function response(request) {
            var resource = location._urlMap[request.url];
            this.responseText = apiResponse(resource);
          }
        });
      });
      stub({
        url: /mobile\/runtime_history/,
        response: function response() {
          this.responseText = apiResponse({
            type: "runtime_history",
            chart: {
              chart: {
                type: "column"
              },
              title: {
                text: ""
              },
              subtitle: {
                text: "Daily History"
              },
              colors: ["#9f2d26", "#184c8e"],
              series: [{
                name: "Heat",
                data: [null, null, null, null, null, null, null, null],
                stack: "heat",
                state: "heat"
              }, {
                name: "Cool",
                data: [9, 9, 7, 8, 11, 11, 14, 2],
                stack: "cool",
                state: "cool"
              }],
              xAxis: {
                categories: ["Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday", "Monday", "Tuesday"],
                labels: {
                  rotation: -45
                }
              },
              yAxis: {
                allowDecimals: false,
                min: 0,
                max: 24,
                tickInternval: 4,
                title: {
                  text: "Runtime (Hours)"
                }
              },
              legend: {
                layout: "vertical",
                align: "center",
                floating: false,
                shadow: false,
                itemStyle: {
                  fontSize: "1em"
                }
              },
              tooltip: {
                shared: true,
                borderColor: "#000000"
              },
              credits: {
                enabled: false
              },
              plotOptions: {
                column: {
                  stacking: "normal"
                },
                series: {
                  shadow: false
                }
              }
            },
            table: {
              headings: ["Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Mon", "Tue"],
              series: [{
                name: "Aux Heat",
                data: ["-", "-", "-", "-", "-", "-", "-", "-"],
                stack: "heat",
                state: "heat_aux"
              }, {
                name: "Outdoor High Temp.",
                data: [91, 89, 92, 88, 90, 94, 95, 68],
                stack: null,
                state: "outdoor_high_temperature"
              }, {
                name: "Outdoor Low Temp.",
                data: [61, 65, 61, 63, 62, 69, 70, 62],
                stack: null,
                state: "outdoor_low_temperature"
              }, {
                name: "Avg Indoor Temp.",
                data: [71.2, 70.8, 72.4, 72.4, 72.9, 72.7, 72.1, 72],
                stack: null,
                state: "average_indoor_temperature"
              }, {
                name: "Avg Indoor Humidity",
                data: [50, 47, 46, 45, 48, 45, 44, 40],
                stack: null,
                state: "average_indoor_humidity"
              }, {
                name: "Fan Only Runtime",
                data: [7.8, 5.9, 0.4, 0.3, 0.2, 0.5, 0.4, 0.3],
                stack: null,
                state: "fan_only"
              }, {
                name: "Vent",
                data: [],
                stack: null,
                state: "vent"
              }]
            },
            show_monthly_runtime_history: false
          });
        }
      });
      stub({
        url: /thermostat_schedules.*\/(get_active_schedule)/,
        type: "POST",
        response: function response() {
          var schedule = {
            temperature_scale: "f",
            days: [{
              name: "Mon",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Tue",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Wed",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Thu",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Fri",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Sat",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 12.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Sun",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 12.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }]
          };
          this.responseText = apiResponse(schedule);
        }
      });
      stub({
        url: /schedules.*/,
        type: "GET",
        response: function response() {
          var schedules = [{
            name: "7 Day Store Hours",
            temperature_scale: "f",
            days: [{
              name: "Mon",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Tue",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Wed",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Thu",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Fri",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Sat",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 12.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Sun",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 12.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }],
            _links: {
              self: {
                href: "mobile/schedules/1?house_id=1"
              }
            }
          }, {
            name: "Weekday Only",
            temperature_scale: "f",
            days: [{
              name: "Mon",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Tue",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Wed",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Thu",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Fri",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Sat",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Sun",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }],
            _links: {
              self: {
                href: "mobile/schedules/2?house_id=1"
              }
            }
          }, {
            name: "Monday Closed",
            temperature_scale: "f",
            days: [{
              name: "Mon",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Tue",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Wed",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Thu",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Fri",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }, {
                name: "Occupied",
                time: 7.5 * 60,
                value: {
                  cool: 78,
                  heat: 70
                }
              }, {
                name: "Unoccupied",
                time: 16.5 * 60,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Sat",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }, {
              name: "Sun",
              periods: [{
                name: "Unoccupied",
                time: 0,
                value: {
                  cool: 82,
                  heat: 62
                }
              }]
            }],
            _links: {
              self: {
                href: "mobile/schedules/3?house_id=1"
              }
            }
          }];
          this.responseText = apiResponse(schedules);
        }
      });
      stub({
        url: /.*/,
        type: "PUT",
        response: function response(request) {
          var resource = location._urlMap[request.url];

          if (typeof request.data !== "string") {
            request.data = JSON.stringify(request.data);
          }

          var data = _.extend(resource, JSON.parse(request.data || "{}"));

          this.responseText = apiResponse(data);
        }
      });
      stub({
        url: /.*/,
        type: "POST",
        response: function response(request) {
          if (typeof request.data !== "string") {
            request.data = JSON.stringify(request.data);
          }

          this.responseText = apiResponse(JSON.parse(request.data || "{}"));
        }
      });
    }
  }, {
    key: "_loadFromCache",
    value: function _loadFromCache() {// no-op parent behavior
    }
  }, {
    key: "_addToSessionCache",
    value: function _addToSessionCache() {// no-op parent behavior
    }
  }, {
    key: "_defaultLocationId",
    value: function _defaultLocationId() {
      return 1;
    }
  }]);

  return CommercialDemoSession;
}(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_session__["a" /* default */]);



/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_framework_media_type__ = __webpack_require__(72);


/* eslint-disable camelcase */


var getFeatures = function getFeatures(currentTemp, status, isOccupied, occupancy_setpoints, isConnected, mode) {
  var setpointHeat = isOccupied ? occupancy_setpoints.preset_heat1 : occupancy_setpoints.preset_heat2;
  var setpointCool = isOccupied ? occupancy_setpoints.preset_cool1 : occupancy_setpoints.preset_cool2;
  return [{
    name: "unenroll",
    actions: {
      unenroll: {
        method: "POST",
        href: "xxl_thermostats/demo/unenroll"
      }
    }
  }, {
    name: "runtime_history",
    actions: {
      get_runtime_history: {
        method: "GET",
        href: "mobile/runtime_history/737395?report_type=daily"
      },
      get_monthly_runtime_history: {
        method: "GET",
        href: "mobile/runtime_history/737395?report_type=monthly"
      }
    }
  }, {
    name: "thermostat",
    temperature: currentTemp,
    status: status,
    actions: {},
    setpoint_delta: 3,
    setpoint_increment: 1,
    setpoint_heat: mode.value === "AUTO" || mode.value === "HEAT" ? setpointHeat : null,
    setpoint_cool: mode.value === "AUTO" || mode.value === "COOL" ? setpointCool : null,
    setpoint_heat_min: 55,
    setpoint_heat_max: 90,
    setpoint_cool_min: 60,
    setpoint_cool_max: 99,
    system_status: status,
    status_icon: {
      modifiers: [],
      name: status
    }
  }, {
    name: "connection",
    signal_strength: "unknown",
    is_connected: isConnected
  }, {
    name: "thermostat_mode",
    label: "System Mode",
    value: mode.value,
    display_value: mode.label,
    options: [{
      id: "thermostat_mode",
      label: "System Mode",
      value: "thermostat_mode",
      header: true
    }, {
      value: "AUTO",
      label: "Auto"
    }, {
      value: "COOL",
      label: "Cooling"
    }, {
      value: "HEAT",
      label: "Heating"
    }, {
      value: "OFF",
      label: "Off"
    }],
    actions: {
      update_thermostat_mode: {
        method: "POST",
        href: "xxl_zones/120996/zone_mode"
      }
    }
  }, {
    name: "thermostat_fan_mode",
    label: "Fan Mode",
    options: [{
      id: "thermostat_fan_mode",
      label: "Fan Mode",
      value: "thermostat_fan_mode",
      header: true
    }, {
      value: "auto",
      label: "Auto"
    }, {
      value: "on",
      label: "On"
    }],
    value: "auto",
    display_value: "Auto",
    actions: {
      update_thermostat_fan_mode: {
        method: "POST",
        href: "xxl_thermostats/demo/fan_mode"
      }
    }
  }, {
    name: "schedule",
    enabled: true,
    max_period_name_length: 10,
    collection_url: "schedules?device_identifier=TraneXl824c-demo&house_id=57265",
    actions: {
      get_active_schedule: {
        href: "thermostat_schedules/get_active_schedule?device_identifier=TraneXl824c-demo",
        method: "POST"
      },
      set_active_schedule: {
        href: "thermostat_schedules/set_active_schedule?device_identifier=TraneXl824c-demo",
        method: "POST"
      },
      get_default_schedule: {
        href: "thermostat_schedules/get_default_schedule?device_identifier=TraneXl824c-demo",
        method: "GET"
      }
    },
    can_add_remove_periods: true,
    max_periods_per_day: 6
  }, {
    name: "pivot",
    device_identifier: "TraneXl824c-demo",
    occupancy_mode: isOccupied ? "occupied" : "unoccupied",
    occupancy_setpoints: occupancy_setpoints,
    max_period_name_length: 10,
    max_periods_per_day: 6,
    high_low_temp_alert: {
      high_low_enabled: null,
      high_limit: 100,
      low_limit: 45
    },
    sensor_fault_enabled: false,
    pin_access: {
      pin_enabled: true,
      pin_passcode: "1234",
      technican_pin_enabled: false,
      technican_passcode: "5678"
    },
    access_level: {
      access_level_type: "NONE"
    },
    actions: {
      set_occupancy_mode: {
        href: "xxl_zones/120996/commercial_preset_selected",
        method: "POST"
      },
      set_occupancy_setpoints: {
        href: "xxl_zones/120996/occupancy_setpoints",
        method: "POST"
      },
      set_group_occupancy_setpoints: {
        href: "xxl_zones/group_occupancy_setpoints",
        method: "POST"
      },
      set_group_schedule: {
        href: "thermostat_schedules/set_commercial_group_schedule",
        method: "POST"
      },
      get_schedules_with_default: {
        href: "thermostat_schedules/get_schedules_with_default?device_identifier=TraneXl824c-demo&house_id=57265",
        method: "GET"
      },
      set_high_low_temp_alert: {
        href: "mobile/xxl_thermostats/740802/temperature_alert",
        method: "POST"
      },
      set_group_high_low_temp_alert: {
        href: "mobile/xxl_thermostats/set_group_temperature_alerts",
        method: "POST"
      },
      set_sensor_fault_enabled: {
        href: "mobile/xxl_thermostats/740802/sensor_fault_enabled",
        method: "POST"
      },
      set_group_sensor_fault_enabled: {
        href: "mobile/xxl_thermostats/group_sensor_fault_enabled",
        method: "POST"
      },
      set_pin_access: {
        href: "mobile/xxl_thermostats/740802/set_pin_access",
        method: "POST"
      },
      set_group_pin_access: {
        href: "mobile/xxl_thermostats/set_group_pin_access",
        method: "POST"
      },
      set_access_level: {
        href: "mobile/xxl_thermostats/740802/set_access_level",
        method: "POST"
      },
      set_group_access_level: {
        href: "mobile/xxl_thermostats/set_group_access_level",
        method: "POST"
      }
    }
  }, {
    name: "pivot_occupancy_mode",
    label: "Occupancy Mode Override",
    value: isOccupied ? "occupied" : "unoccupied",
    display_value: "Occupied",
    setpoints_override: {
      occupancy_override_mode: 0,
      setpoint_expiration_time: 2,
      setpoint_degree_limit_enabled: true,
      setpoint_degree_limit: 5
    },
    occupancy_override: {
      occupancy_override_enabled: 0,
      occupancy_override_time: 2,
      occupancy_override_start_date: "0",
      occupancy_override_start_time: "0"
    },
    actions: {
      set_occupancy_override: {
        href: "mobile/xxl_zones/6/pivot_timed_override",
        method: "POST"
      }
    }
  }];
};

var getBaseSettings = function getBaseSettings(mode) {
  return [{
    type: "system_mode",
    title: "System Mode",
    options: [{
      value: "AUTO",
      label: "Auto"
    }, {
      value: "COOL",
      label: "Cooling"
    }, {
      value: "HEAT",
      label: "Heating"
    }, {
      value: "OFF",
      label: "Off"
    }],
    labels: ["Auto", "Cooling", "Heating", "Off"],
    values: ["AUTO", "COOL", "HEAT", "OFF"],
    _links: {
      self: {
        href: "http://localhost:3000/mobile/xxl_zones/6/zone_mode"
      }
    },
    id: "http://localhost:3000/mobile/xxl_zones/6/zone_mode",
    value: mode.value
  }, {
    type: "scheduling_enabled",
    title: "Scheduling",
    options: [{
      value: true,
      label: "ON"
    }, {
      value: false,
      label: "OFF"
    }],
    labels: ["ON", "OFF"],
    values: [true, false],
    _links: {
      self: {
        href: "http://localhost:3000/mobile/xxl_zones/6/scheduling_enabled"
      }
    },
    id: "http://localhost:3000/mobile/xxl_zones/6/scheduling_enabled",
    value: true
  }, {
    type: "fan_mode",
    title: "Fan Mode",
    options: [{
      value: "auto",
      label: "Auto"
    }, {
      value: "on",
      label: "On"
    }],
    labels: ["Auto", "On"],
    values: ["auto", "on"],
    _links: {
      self: {
        href: "http://localhost:3000/mobile/xxl_thermostats/6/fan_mode"
      }
    },
    id: "http://localhost:3000/mobile/xxl_thermostats/6/fan_mode",
    value: "auto"
  }, {
    type: "dehumidify",
    title: "Cooling Dehumidify Set Point",
    options: [{
      value: 0.35,
      label: "35%"
    }, {
      value: 0.4,
      label: "40%"
    }, {
      value: 0.45,
      label: "45%"
    }, {
      value: 0.5,
      label: "50%"
    }, {
      value: 0.55,
      label: "55%"
    }, {
      value: 0.6,
      label: "60%"
    }, {
      value: 0.65,
      label: "65%"
    }],
    labels: ["35%", "40%", "45%", "50%", "55%", "60%", "65%"],
    values: [0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65],
    _links: {
      self: {
        href: "http://localhost:3000/mobile/xxl_thermostats/6/dehumidify"
      }
    },
    id: "http://localhost:3000/mobile/xxl_thermostats/6/dehumidify",
    value: 0.5
  }, {
    type: "scale",
    title: "Temperature Scale",
    options: [{
      value: "f",
      label: "F"
    }, {
      value: "c",
      label: "C"
    }],
    labels: ["F", "C"],
    values: ["f", "c"],
    _links: {
      self: {
        href: "http://localhost:3000/mobile/xxl_thermostats/6/scale"
      }
    },
    id: "http://localhost:3000/mobile/xxl_thermostats/6/scale",
    value: "f"
  }];
};

var getSettings = function getSettings(isOccupied, mode) {
  if (isOccupied) {
    return [{
      type: "pivot_timed_override",
      title: "Occupancy",
      options: [{
        value: "pivot_default_no_schedule_unoccupied",
        label: "Occupied"
      }],
      labels: ["Occupied"],
      values: ["pivot_default_no_schedule_unoccupied"],
      _links: {
        self: {
          href: "http://localhost:3000/mobile/xxl_zones/6/pivot_timed_override"
        }
      },
      id: "http://localhost:3000/mobile/xxl_zones/6/pivot_timed_override",
      value: "pivot_default_no_schedule_unoccupied"
    }].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(getBaseSettings(mode)));
  } else {
    return [{
      type: "pivot_timed_override",
      title: "Occupancy",
      options: [{
        value: "pivot_default_schedule",
        label: "Unoccupied"
      }, {
        value: "event",
        label: "Occupied"
      }, {
        value: "time",
        label: "Occupied"
      }],
      labels: ["Unoccupied", "Occupied", "Occupied"],
      values: ["pivot_default_schedule", "event", "time"],
      _links: {
        self: {
          href: "http://localhost:3000/mobile/xxl_zones/6/pivot_timed_override"
        }
      },
      id: "http://localhost:3000/mobile/xxl_zones/6/pivot_timed_override",
      value: "pivot_default_schedule"
    }].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(getBaseSettings(mode)));
  }
};

var getStat = function getStat(settings) {
  return {
    id: settings.id,
    name: settings.name,
    type: "xxl_thermostat",
    icon: {
      name: "thermostat",
      modifiers: ["temperature-".concat(settings.currentTemp)]
    },
    current_fan_mode: 0,
    current_mode: 3,
    current_run_mode: 0,
    delta: 3,
    features: getFeatures(settings.currentTemp, settings.status, settings.isOccupied, settings.occupancy_setpoints, settings.isConnected, settings.mode),
    operating_state: "System Idle",
    scale: "F",
    setpoints: {
      heat: settings.isOccupied ? settings.occupancy_setpoints.preset_heat1 : settings.occupancy_setpoints.preset_heat2,
      cool: settings.isOccupied ? settings.occupancy_setpoints.preset_cool1 : settings.occupancy_setpoints.preset_cool2
    },
    supported_fan_modes: {
      0: "Auto",
      1: "On"
    },
    supported_modes: {
      0: "Off",
      1: "Heat",
      2: "Cool",
      3: "Auto"
    },
    supported_run_modes: {
      0: "Hold Temp",
      2: "Energy Save"
    },
    temperature: settings.currentTemp,
    value: 255,
    settings: getSettings(settings.isOccupied, settings.mode)
  };
};

var dashboardStat = getStat({
  id: 11,
  name: "Springfield",
  currentTemp: 75,
  isOccupied: true,
  status: "Cooling",
  mode: {
    value: "AUTO",
    label: "Auto"
  },
  occupancy_setpoints: {
    preset_heat1: 70,
    preset_cool1: 75,
    preset_heat2: 60,
    preset_cool2: 85
  },
  isConnected: true
});
var dashboardStat2 = getStat({
  id: 12,
  name: "Clearwater",
  currentTemp: 76,
  isOccupied: false,
  status: "Cooling",
  mode: {
    value: "COOL",
    label: "Cool"
  },
  occupancy_setpoints: {
    preset_heat1: 70,
    preset_cool1: 75,
    preset_heat2: 60,
    preset_cool2: 75
  },
  isConnected: true
});
var groupStatOne = getStat({
  id: 13,
  name: "Show Room",
  currentTemp: 68,
  isOccupied: true,
  status: "Heating",
  mode: {
    value: "AUTO",
    label: "Auto"
  },
  occupancy_setpoints: {
    preset_heat1: 68,
    preset_cool1: 72,
    preset_heat2: 60,
    preset_cool2: 85
  },
  isConnected: true
});
var groupStatTwo = getStat({
  id: 14,
  name: "Offices",
  currentTemp: 69,
  isOccupied: true,
  status: "Heating",
  mode: {
    value: "HEAT",
    label: "Heat"
  },
  occupancy_setpoints: {
    preset_heat1: 68,
    preset_cool1: 72,
    preset_heat2: 60,
    preset_cool2: 85
  },
  isConnected: true
});
var groupOne = {
  name: "Parker Grove",
  id: 15,
  type: "group",
  icon: [{
    name: "thermostat",
    modifiers: ["temperature-68"]
  }, {
    name: "thermostat",
    modifiers: ["temperature-69"]
  }],
  _links: {
    child: [{
      data: groupStatOne
    }, {
      data: groupStatTwo
    }]
  }
};

var addHistoryLink = function addHistoryLink(model, filterType) {
  if (!model._links) {
    model._links = {};
  }

  model._links["nexia:history"] = {
    href: "/events?".concat(filterType, "_id=").concat(model.id)
  };
};

addHistoryLink(dashboardStat, "device");
addHistoryLink(dashboardStat2, "device");
addHistoryLink(groupStatOne, "device");
addHistoryLink(groupStatTwo, "device");
var devices = {
  item_type: __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_framework_media_type__["a" /* default */].DEVICE,
  items: [dashboardStat, dashboardStat2, groupOne]
};
var modes = {
  item_type: __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_framework_media_type__["a" /* default */].MODE,
  items: [{
    id: 21,
    name: "Home",
    current_mode: false,
    icon: "home.png",
    settings: []
  }, {
    id: 22,
    name: "Away",
    current_mode: false,
    icon: "away.png",
    settings: []
  }, {
    id: 23,
    name: "Vacation",
    current_mode: true,
    icon: "picture.png",
    settings: []
  }]
};
var events = {
  item_type: __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_framework_media_type__["a" /* default */].EVENT,
  _links: {
    page: {
      data: {
        current_page: 1,
        page_count: 1
      }
    }
  }
};
var location = {
  id: 1,
  name: "Demo",
  _urlMap: {},
  _links: {}
};
location._links.child = [{
  data: modes,
  type: __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_framework_media_type__["a" /* default */].COLLECTION
}, {
  data: devices,
  type: __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_framework_media_type__["a" /* default */].COLLECTION
}, {
  data: events,
  type: __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_framework_media_type__["a" /* default */].COLLECTION
}];

function addSelfLink(resource, objectType) {
  var url = objectType || resource.type || "resource";

  if (resource.id != null) {
    url += "/".concat(resource.id);
  }

  location._urlMap[url] = resource;

  if (resource._links == null) {
    resource._links = {};
  }

  resource._links.self = {
    href: url
  };
}

addSelfLink(events, "events");

_.each(modes.items, function (mode) {
  return addSelfLink(mode, "mode");
});

_.each(devices.items, function (device) {
  addSelfLink(device);

  _.each(device.settings, function (setting) {
    return addSelfLink(setting, "".concat(device._links.self.href, "/").concat(setting.type));
  });

  _.each(device._links.child, function (link) {
    if (link.data != null) {
      addSelfLink(link.data);
    }
  });
});

/* harmony default export */ __webpack_exports__["a"] = (location);

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppBarShadow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_DOMEventListener__ = __webpack_require__(279);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var baseStyles = {
  wrapper: {
    flex: "none",
    transition: "opacity 100ms ease-in-out",
    position: "relative",
    height: "0",
    zIndex: __WEBPACK_IMPORTED_MODULE_10_nx_components_Theme__["a" /* default */].zIndexLayers.CONTENTS + 1
  }
};
var styles = Object(__WEBPACK_IMPORTED_MODULE_9_nx_components_utils_prefixStyles__["b" /* default */])({
  wrapperVisible: _objectSpread({}, baseStyles.wrapper, {
    opacity: "1.0"
  }),
  wrapperInvisible: _objectSpread({}, baseStyles.wrapper, {
    opacity: "0.0"
  }),
  inner: {
    backgroundColor: "transparent",
    backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.20), transparent)",
    position: "absolute",
    top: "0",
    height: "5px",
    width: "100%"
  }
});

var AppBarShadow =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AppBarShadow, _React$Component);

  function AppBarShadow() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AppBarShadow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AppBarShadow)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      isVisible: false
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_calculateVisibility", function () {
      var target = _this.props.target;

      if (target == null) {
        _this.setState({
          isVisible: false
        });

        return;
      }

      var isVisible = target.scrollTop > 0;

      if (isVisible !== _this.state.isVisible) {
        _this.setState({
          isVisible: isVisible
        });
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AppBarShadow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          target = _this$props.target,
          ignoreSafeArea = _this$props.ignoreSafeArea;
      var isVisible = this.state.isVisible;
      var leftSafePadding = this.context.isLargeAppLayout ? "0px" : __WEBPACK_IMPORTED_MODULE_10_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_LEFT;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "ScrollShadow",
        style: isVisible ? styles.wrapperVisible : styles.wrapperInvisible
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: _objectSpread({}, styles.inner, {}, ignoreSafeArea ? null : {
          width: "calc(100% + ".concat(leftSafePadding, " + ").concat(__WEBPACK_IMPORTED_MODULE_10_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_RIGHT, ")"),
          marginLeft: "calc(-1 * ".concat(leftSafePadding, ")")
        })
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_DOMEventListener__["a" /* default */], {
        target: target,
        eventName: "scroll",
        handler: this._calculateVisibility
      })));
    }
  }]);

  return AppBarShadow;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AppBarShadow, "contextTypes", {
  isLargeAppLayout: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AppBarShadow, "propTypes", {
  target: function target() {
    return (typeof HTMLElement === "function" ? __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(HTMLElement) : __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any).apply(this, arguments);
  },
  ignoreSafeArea: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});




/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, process) {// Generated by CoffeeScript 1.12.7
var Parser, StringDecoder, isObjLiteral, stream, util;

stream = __webpack_require__(1014);

util = __webpack_require__(1026);

StringDecoder = __webpack_require__(284).StringDecoder;

module.exports = function() {
  var callback, called, chunks, data, err, options, parser;
  if (arguments.length === 3) {
    data = arguments[0];
    options = arguments[1];
    callback = arguments[2];
    if (typeof callback !== 'function') {
      throw Error("Invalid callback argument: " + (JSON.stringify(callback)));
    }
    if (!(typeof data === 'string' || Buffer.isBuffer(arguments[0]))) {
      return callback(Error("Invalid data argument: " + (JSON.stringify(data))));
    }
  } else if (arguments.length === 2) {
    if (typeof arguments[0] === 'string' || Buffer.isBuffer(arguments[0])) {
      data = arguments[0];
    } else if (isObjLiteral(arguments[0])) {
      options = arguments[0];
    } else {
      err = "Invalid first argument: " + (JSON.stringify(arguments[0]));
    }
    if (typeof arguments[1] === 'function') {
      callback = arguments[1];
    } else if (isObjLiteral(arguments[1])) {
      if (options) {
        err = 'Invalid arguments: got options twice as first and second arguments';
      } else {
        options = arguments[1];
      }
    } else {
      err = "Invalid first argument: " + (JSON.stringify(arguments[1]));
    }
    if (err) {
      if (!callback) {
        throw Error(err);
      } else {
        return callback(Error(err));
      }
    }
  } else if (arguments.length === 1) {
    if (typeof arguments[0] === 'function') {
      callback = arguments[0];
    } else {
      options = arguments[0];
    }
  }
  if (options == null) {
    options = {};
  }
  parser = new Parser(options);
  if (data != null) {
    process.nextTick(function() {
      parser.write(data);
      return parser.end();
    });
  }
  if (callback) {
    called = false;
    chunks = options.objname ? {} : [];
    parser.on('readable', function() {
      var chunk, results;
      results = [];
      while (chunk = parser.read()) {
        if (options.objname) {
          results.push(chunks[chunk[0]] = chunk[1]);
        } else {
          results.push(chunks.push(chunk));
        }
      }
      return results;
    });
    parser.on('error', function(err) {
      called = true;
      return callback(err);
    });
    parser.on('end', function() {
      if (!called) {
        return callback(null, chunks);
      }
    });
  }
  return parser;
};

Parser = function(options) {
  var base, base1, base10, base11, base12, base13, base14, base15, base16, base2, base3, base4, base5, base6, base7, base8, base9, k, v;
  if (options == null) {
    options = {};
  }
  this.options = {};
  for (k in options) {
    v = options[k];
    this.options[k] = v;
  }
  this.options.objectMode = true;
  stream.Transform.call(this, this.options);
  if ((base = this.options).rowDelimiter == null) {
    base.rowDelimiter = null;
  }
  if (typeof this.options.rowDelimiter === 'string') {
    this.options.rowDelimiter = [this.options.rowDelimiter];
  }
  if ((base1 = this.options).delimiter == null) {
    base1.delimiter = ',';
  }
  if (this.options.quote !== void 0 && !this.options.quote) {
    this.options.quote = '';
  }
  if ((base2 = this.options).quote == null) {
    base2.quote = '"';
  }
  if ((base3 = this.options).escape == null) {
    base3.escape = '"';
  }
  if ((base4 = this.options).columns == null) {
    base4.columns = null;
  }
  if ((base5 = this.options).comment == null) {
    base5.comment = '';
  }
  if ((base6 = this.options).objname == null) {
    base6.objname = false;
  }
  if ((base7 = this.options).trim == null) {
    base7.trim = false;
  }
  if ((base8 = this.options).ltrim == null) {
    base8.ltrim = false;
  }
  if ((base9 = this.options).rtrim == null) {
    base9.rtrim = false;
  }
  if ((base10 = this.options).auto_parse == null) {
    base10.auto_parse = false;
  }
  if ((base11 = this.options).auto_parse_date == null) {
    base11.auto_parse_date = false;
  }
  if (this.options.auto_parse_date === true) {
    this.options.auto_parse_date = function(value) {
      var m;
      m = Date.parse(value);
      if (!isNaN(m)) {
        value = new Date(m);
      }
      return value;
    };
  }
  if ((base12 = this.options).relax == null) {
    base12.relax = false;
  }
  if ((base13 = this.options).relax_column_count == null) {
    base13.relax_column_count = false;
  }
  if ((base14 = this.options).skip_empty_lines == null) {
    base14.skip_empty_lines = false;
  }
  if ((base15 = this.options).max_limit_on_data_read == null) {
    base15.max_limit_on_data_read = 128000;
  }
  if ((base16 = this.options).skip_lines_with_empty_values == null) {
    base16.skip_lines_with_empty_values = false;
  }
  this.lines = 0;
  this.count = 0;
  this.skipped_line_count = 0;
  this.empty_line_count = 0;
  this.is_int = /^(\-|\+)?([1-9]+[0-9]*)$/;
  this.is_float = function(value) {
    return (value - parseFloat(value) + 1) >= 0;
  };
  this._ = {
    decoder: new StringDecoder(),
    quoting: false,
    commenting: false,
    field: null,
    nextChar: null,
    closingQuote: 0,
    line: [],
    chunks: [],
    rawBuf: '',
    buf: '',
    rowDelimiterLength: this.options.rowDelimiter ? Math.max.apply(Math, this.options.rowDelimiter.map(function(v) {
      return v.length;
    })) : void 0
  };
  return this;
};

util.inherits(Parser, stream.Transform);

module.exports.Parser = Parser;

Parser.prototype._transform = function(chunk, encoding, callback) {
  var err;
  if (chunk instanceof Buffer) {
    chunk = this._.decoder.write(chunk);
  }
  err = this.__write(chunk, false);
  if (err) {
    return this.emit('error', err);
  }
  return callback();
};

Parser.prototype._flush = function(callback) {
  var err;
  err = this.__write(this._.decoder.end(), true);
  if (err) {
    return this.emit('error', err);
  }
  if (this._.quoting) {
    this.emit('error', new Error("Quoted field not terminated at line " + (this.lines + 1)));
    return;
  }
  if (this._.line.length > 0) {
    err = this.__push(this._.line);
    if (err) {
      return callback(err);
    }
  }
  return callback();
};

Parser.prototype.__push = function(line) {
  var call_column_udf, columns, err, field, i, j, len, lineAsColumns, rawBuf, ref, row;
  if (this.options.skip_lines_with_empty_values && line.join('').trim() === '') {
    return;
  }
  row = null;
  if (this.options.columns === true) {
    this.options.columns = line;
    rawBuf = '';
    return;
  } else if (typeof this.options.columns === 'function') {
    call_column_udf = function(fn, line) {
      var columns, err;
      try {
        columns = fn.call(null, line);
        return [null, columns];
      } catch (error) {
        err = error;
        return [err];
      }
    };
    ref = call_column_udf(this.options.columns, line), err = ref[0], columns = ref[1];
    if (err) {
      return err;
    }
    this.options.columns = columns;
    rawBuf = '';
    return;
  }
  if (!this._.line_length && line.length > 0) {
    this._.line_length = this.options.columns ? this.options.columns.length : line.length;
  }
  if (line.length === 1 && line[0] === '') {
    this.empty_line_count++;
  } else if (line.length !== this._.line_length) {
    if (this.options.relax_column_count) {
      this.count++;
      this.skipped_line_count++;
    } else if (this.options.columns != null) {
      return Error("Number of columns on line " + this.lines + " does not match header");
    } else {
      return Error("Number of columns is inconsistent on line " + this.lines);
    }
  } else {
    this.count++;
  }
  if (this.options.columns != null) {
    lineAsColumns = {};
    for (i = j = 0, len = line.length; j < len; i = ++j) {
      field = line[i];
      if (this.options.columns[i] === false) {
        continue;
      }
      lineAsColumns[this.options.columns[i]] = field;
    }
    if (this.options.objname) {
      row = [lineAsColumns[this.options.objname], lineAsColumns];
    } else {
      row = lineAsColumns;
    }
  } else {
    row = line;
  }
  if (this.count < this.options.from) {
    return;
  }
  if (this.count > this.options.to) {
    return;
  }
  if (this.options.raw) {
    this.push({
      raw: this._.rawBuf,
      row: row
    });
    this._.rawBuf = '';
  } else {
    this.push(row);
  }
  return null;
};

Parser.prototype.__write = function(chars, end) {
  var areNextCharsDelimiter, areNextCharsRowDelimiters, auto_parse, char, err, escapeIsQuote, i, isDelimiter, isEscape, isNextCharAComment, isQuote, isRowDelimiter, isRowDelimiterLength, is_float, is_int, l, ltrim, nextCharPos, ref, ref1, ref2, ref3, ref4, ref5, remainingBuffer, rowDelimiter, rtrim, wasCommenting;
  is_int = (function(_this) {
    return function(value) {
      if (typeof _this.is_int === 'function') {
        return _this.is_int(value);
      } else {
        return _this.is_int.test(value);
      }
    };
  })(this);
  is_float = (function(_this) {
    return function(value) {
      if (typeof _this.is_float === 'function') {
        return _this.is_float(value);
      } else {
        return _this.is_float.test(value);
      }
    };
  })(this);
  auto_parse = (function(_this) {
    return function(value) {
      if (!_this.options.auto_parse) {
        return value;
      }
      if (typeof _this.options.auto_parse === 'function') {
        return _this.options.auto_parse(value);
      }
      if (is_int(value)) {
        value = parseInt(value);
      } else if (is_float(value)) {
        value = parseFloat(value);
      } else if (_this.options.auto_parse_date) {
        value = _this.options.auto_parse_date(value);
      }
      return value;
    };
  })(this);
  ltrim = this.options.trim || this.options.ltrim;
  rtrim = this.options.trim || this.options.rtrim;
  chars = this._.buf + chars;
  l = chars.length;
  i = 0;
  if (this.lines === 0 && 0xFEFF === chars.charCodeAt(0)) {
    i++;
  }
  while (i < l) {
    if (!end) {
      remainingBuffer = chars.substr(i, l - i);
      if ((!this.options.rowDelimiter && i + 3 > l) || (!this._.commenting && l - i < this.options.comment.length && this.options.comment.substr(0, l - i) === remainingBuffer) || (this.options.rowDelimiter && l - i < this._.rowDelimiterLength && this.options.rowDelimiter.some(function(rd) {
        return rd.substr(0, l - i) === remainingBuffer;
      })) || (this.options.rowDelimiter && this._.quoting && l - i < (this.options.quote.length + this._.rowDelimiterLength) && this.options.rowDelimiter.some((function(_this) {
        return function(rd) {
          return (_this.options.quote + rd).substr(0, l - i) === remainingBuffer;
        };
      })(this))) || (l - i <= this.options.delimiter.length && this.options.delimiter.substr(0, l - i) === remainingBuffer) || (l - i <= this.options.escape.length && this.options.escape.substr(0, l - i) === remainingBuffer)) {
        break;
      }
    }
    char = this._.nextChar ? this._.nextChar : chars.charAt(i);
    this._.nextChar = l > i + 1 ? chars.charAt(i + 1) : '';
    if (this.options.raw) {
      this._.rawBuf += char;
    }
    if (this.options.rowDelimiter == null) {
      nextCharPos = i;
      rowDelimiter = null;
      if (!this._.quoting && (char === '\n' || char === '\r')) {
        rowDelimiter = char;
        nextCharPos += 1;
      } else if (this._.quoting && char === this.options.quote && ((ref = this._.nextChar) === '\n' || ref === '\r')) {
        rowDelimiter = this._.nextChar;
        nextCharPos += 2;
        if (this.raw) {
          rawBuf += this._.nextChar;
        }
      }
      if (rowDelimiter) {
        if (rowDelimiter === '\r' && chars.charAt(nextCharPos) === '\n') {
          rowDelimiter += '\n';
        }
        this.options.rowDelimiter = [rowDelimiter];
        this._.rowDelimiterLength = rowDelimiter.length;
      }
    }
    if (!this._.commenting && char === this.options.escape) {
      escapeIsQuote = this.options.escape === this.options.quote;
      isEscape = this._.nextChar === this.options.escape;
      isQuote = this._.nextChar === this.options.quote;
      if (!(escapeIsQuote && (this._.field == null) && !this._.quoting) && (isEscape || isQuote)) {
        i++;
        char = this._.nextChar;
        this._.nextChar = chars.charAt(i + 1);
        if (this._.field == null) {
          this._.field = '';
        }
        this._.field += char;
        if (this.options.raw) {
          this._.rawBuf += char;
        }
        i++;
        continue;
      }
    }
    if (!this._.commenting && char === this.options.quote) {
      if (this._.quoting) {
        areNextCharsRowDelimiters = this.options.rowDelimiter && this.options.rowDelimiter.some(function(rd) {
          return chars.substr(i + 1, rd.length) === rd;
        });
        areNextCharsDelimiter = chars.substr(i + 1, this.options.delimiter.length) === this.options.delimiter;
        isNextCharAComment = this._.nextChar === this.options.comment;
        if (this._.nextChar && !areNextCharsRowDelimiters && !areNextCharsDelimiter && !isNextCharAComment) {
          if (this.options.relax) {
            this._.quoting = false;
            if (this._.field) {
              this._.field = "" + this.options.quote + this._.field;
            }
          } else {
            return Error("Invalid closing quote at line " + (this.lines + 1) + "; found " + (JSON.stringify(this._.nextChar)) + " instead of delimiter " + (JSON.stringify(this.options.delimiter)));
          }
        } else {
          this._.quoting = false;
          this._.closingQuote = this.options.quote.length;
          i++;
          if (end && i === l) {
            this._.line.push(auto_parse(this._.field || ''));
            this._.field = null;
          }
          continue;
        }
      } else if (!this._.field) {
        this._.quoting = true;
        i++;
        continue;
      } else if ((this._.field != null) && !this.options.relax) {
        return Error("Invalid opening quote at line " + (this.lines + 1));
      }
    }
    isRowDelimiter = this.options.rowDelimiter && this.options.rowDelimiter.some(function(rd) {
      return chars.substr(i, rd.length) === rd;
    });
    if (isRowDelimiter || (end && i === l - 1)) {
      this.lines++;
    }
    wasCommenting = false;
    if (!this._.commenting && !this._.quoting && this.options.comment && chars.substr(i, this.options.comment.length) === this.options.comment) {
      this._.commenting = true;
    } else if (this._.commenting && isRowDelimiter) {
      wasCommenting = true;
      this._.commenting = false;
    }
    isDelimiter = chars.substr(i, this.options.delimiter.length) === this.options.delimiter;
    if (!this._.commenting && !this._.quoting && (isDelimiter || isRowDelimiter)) {
      if (isRowDelimiter) {
        isRowDelimiterLength = this.options.rowDelimiter.filter(function(rd) {
          return chars.substr(i, rd.length) === rd;
        })[0].length;
      }
      if (isRowDelimiter && this._.line.length === 0 && (this._.field == null)) {
        if (wasCommenting || this.options.skip_empty_lines) {
          i += isRowDelimiterLength;
          this._.nextChar = chars.charAt(i);
          continue;
        }
      }
      if (rtrim) {
        if (!this._.closingQuote) {
          this._.field = (ref1 = this._.field) != null ? ref1.trimRight() : void 0;
        }
      }
      this._.line.push(auto_parse(this._.field || ''));
      this._.closingQuote = 0;
      this._.field = null;
      if (isDelimiter) {
        i += this.options.delimiter.length;
        this._.nextChar = chars.charAt(i);
        if (end && !this._.nextChar) {
          isRowDelimiter = true;
          this._.line.push('');
        }
      }
      if (isRowDelimiter) {
        err = this.__push(this._.line);
        if (err) {
          return err;
        }
        this._.line = [];
        i += isRowDelimiterLength;
        this._.nextChar = chars.charAt(i);
        continue;
      }
    } else if (!this._.commenting && !this._.quoting && (char === ' ' || char === '\t')) {
      if (this._.field == null) {
        this._.field = '';
      }
      if (!(ltrim && !this._.field)) {
        this._.field += char;
      }
      i++;
    } else if (!this._.commenting) {
      if (this._.field == null) {
        this._.field = '';
      }
      this._.field += char;
      i++;
    } else {
      i++;
    }
    if (!this._.commenting && ((ref2 = this._.field) != null ? ref2.length : void 0) > this.options.max_limit_on_data_read) {
      return Error("Field exceeds max_limit_on_data_read setting (" + this.options.max_limit_on_data_read + ") " + (JSON.stringify(this.options.delimiter)));
    }
    if (!this._.commenting && ((ref3 = this._.line) != null ? ref3.length : void 0) > this.options.max_limit_on_data_read) {
      return Error("Row delimiter not found in the file " + (JSON.stringify(this.options.rowDelimiter)));
    }
  }
  if (end) {
    if (this._.field != null) {
      if (rtrim) {
        if (!this._.closingQuote) {
          this._.field = (ref4 = this._.field) != null ? ref4.trimRight() : void 0;
        }
      }
      this._.line.push(auto_parse(this._.field || ''));
      this._.field = null;
    }
    if (((ref5 = this._.field) != null ? ref5.length : void 0) > this.options.max_limit_on_data_read) {
      return Error("Delimiter not found in the file " + (JSON.stringify(this.options.delimiter)));
    }
    if (l === 0) {
      this.lines++;
    }
    if (this._.line.length > this.options.max_limit_on_data_read) {
      return Error("Row delimiter not found in the file " + (JSON.stringify(this.options.rowDelimiter)));
    }
  }
  this._.buf = chars.substr(i);
  return null;
};

isObjLiteral = function(_obj) {
  var _test;
  _test = _obj;
  if (typeof _obj !== 'object' || _obj === null || Array.isArray(_obj)) {
    return false;
  } else {
    return (function() {
      while (!false) {
        if (Object.getPrototypeOf(_test = Object.getPrototypeOf(_test)) === null) {
          break;
        }
      }
      return Object.getPrototypeOf(_obj === _test);
    })();
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(211).Buffer, __webpack_require__(141)))

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 1013 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(280).EventEmitter;
var inherits = __webpack_require__(142);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(281);
Stream.Writable = __webpack_require__(1022);
Stream.Duplex = __webpack_require__(1023);
Stream.Transform = __webpack_require__(1024);
Stream.PassThrough = __webpack_require__(1025);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(282).Buffer;
var util = __webpack_require__(1017);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1019);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32), __webpack_require__(141)))

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(211)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(439);

/*<replacement>*/
var util = __webpack_require__(162);
util.inherits = __webpack_require__(142);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(283);


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(123);


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(281).Transform


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(281).PassThrough


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","APP_BRAND":"commercial","APP_BRAND_TYPE":undefined}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(1027);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(1028);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(141)))

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Routing_RootRoutes__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Pages_ErrorPage__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_ErrorHandler__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Toaster__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_GlobalBlockingSpinner__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_DarkModeInverter__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nx_components_ContextWrappers_LanguageContext__ = __webpack_require__(84);



















var App =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(App, _React$Component);

  function App() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, App);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(App).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(App, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          initialEntries = _this$props.initialEntries,
          initialIndex = _this$props.initialIndex;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_nx_components_ContextWrappers_LanguageContext__["a" /* LanguageContextWrapper */], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_ErrorHandler__["a" /* default */], {
        fallback: __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Pages_ErrorPage__["a" /* default */], null)
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["a" /* MemoryRouter */], {
        initialEntries: initialEntries,
        initialIndex: initialIndex
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["c" /* Route */] // No path; always render
      , null, function (_ref) {
        var history = _ref.history,
            location = _ref.location;
        Object(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_history__["e" /* setHistory */])(history);
        __WEBPACK_IMPORTED_MODULE_9_raven_js___default.a.captureBreadcrumb({
          category: "Route changed",
          level: "info",
          message: location.pathname
        });
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
          style: {
            display: "none"
          },
          id: "current-route",
          "data-pathname": location.pathname
        }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_DarkModeInverter__["a" /* default */], null, function (_ref2) {
          var maybeInvert = _ref2.maybeInvert;
          Object.assign(document.body.style, maybeInvert);
          return null;
        }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Routing_RootRoutes__["a" /* default */], null));
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Toaster__["b" /* default */], null), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_GlobalBlockingSpinner__["a" /* default */], null)))));
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(App, "propTypes", {
  // These are only used by storybook stories for generating app store images.
  initialEntries: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object // Location object
  ])),
  initialIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
});



/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RootRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Routing_InternetRequiredRoute__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_SwitchWith404__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Routing_AppRoutes__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_Pages_ValidatePinEntryPage__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Routing_Loading__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nx_components_ContextWrappers_PhoneContext__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);


















var ActivatePhonePage = Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1324));
});
var ForgotCredentialsPage = Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1325));
});
var SignUpPage = Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1326));
});
var CreatePinEntryPage = Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1327));
});
var ReauthenticateUserPage = Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1328));
});
var SignInPage = Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1329));
});
var WelcomePage = Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  SignInPage.preload();
  SignUpPage.preload();
  CreatePinEntryPage.preload();
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1330));
});
var ResetPasswordPage = Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 1331));
});
var TransferAccountPage = Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1332));
});

var RootRoutes =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(RootRoutes, _React$Component);

  function RootRoutes() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, RootRoutes);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(RootRoutes).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(RootRoutes, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_SwitchWith404__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */], {
        path: "/",
        exact: true,
        render: function render() {
          if (__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_flux_like_store__["a" /* default */].appState.inDemoMode) {
            return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Redirect */], {
              to: "/app"
            });
          }

          if (!__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_local_settings__["c" /* default */].isActivated()) {
            return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Redirect */], {
              to: "/welcome"
            });
          }

          Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__["a" /* default */])("POPULATE_SESSION");

          if (__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_local_settings__["c" /* default */].needsPin()) {
            return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Redirect */], {
              to: "/pin-entry/create"
            });
          }

          switch (__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_local_settings__["c" /* default */].getCurrentAuth()) {
            case __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_local_settings__["b" /* AUTH_TYPES */].FINGERPRINT:
            case __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_local_settings__["b" /* AUTH_TYPES */].PIN:
              {
                return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Redirect */], {
                  to: "/pin-entry/validate"
                });
              }

            case __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_local_settings__["b" /* AUTH_TYPES */].NONE:
              {
                return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Redirect */], {
                  to: "/app"
                });
              }

            case __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_local_settings__["b" /* AUTH_TYPES */].UNINITIALIZED:
              {
                return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Redirect */], {
                  to: "/pin-entry/create"
                });
              }

            default:
              {
                // Should never get here
                return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Redirect */], {
                  to: "/welcome"
                });
              }
          }
        }
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */], {
        path: "/welcome",
        exact: true,
        component: WelcomePage
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */], {
        path: "/pin-entry/create",
        exact: true,
        render: function render(_ref) {
          var state = _ref.location.state;
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](CreatePinEntryPage, {
            isPinReset: state && state.isPinReset
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */], {
        path: "/pin-entry/validate",
        exact: true,
        component: __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_Pages_ValidatePinEntryPage__["a" /* default */]
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/reauth",
        exact: true,
        render: function render(_ref2) {
          var _ref2$location$state = _ref2.location.state,
              authenticationParams = _ref2$location$state.authenticationParams,
              prompt = _ref2$location$state.prompt,
              submitButtonText = _ref2$location$state.submitButtonText,
              title = _ref2$location$state.title,
              onUserAuthenticated = _ref2$location$state.onUserAuthenticated;
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](ReauthenticateUserPage, {
            authenticationParams: authenticationParams,
            prompt: prompt,
            submitButtonText: submitButtonText,
            title: title,
            onUserAuthenticated: onUserAuthenticated
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */], {
        path: "/signin",
        exact: true,
        component: SignInPage
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */], {
        path: "/signin/activate-phone",
        exact: true,
        component: ActivatePhonePage
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/signin/forgot-credentials",
        exact: true,
        component: ForgotCredentialsPage
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/signup" // Not exact because SignUpPage has nested routes
        ,
        component: SignUpPage
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */], {
        path: "/reset-password",
        exact: true,
        component: ResetPasswordPage
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/transfer-account/user-info",
        exact: true,
        component: TransferAccountPage
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/transfer-account/challenge-terms",
        exact: true,
        component: TransferAccountPage
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */], {
        path: "/app" // Not exact because AppRoutes has nested routes
        ,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_nx_components_ContextWrappers_PhoneContext__["a" /* ConnectedPhoneContextWrapper */], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_nx_components_ContextWrappers_UserLanguageContext__["a" /* UserLanguageContextWrapper */], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Routing_AppRoutes__["a" /* default */], null)));
        }
      }));
    }
  }]);

  return RootRoutes;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(RootRoutes, "propTypes", {});



/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_ItemList__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_RichLabel__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_TopBar_AppBarWrapper__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_TopBar_CommonAppBarContainer__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Scrollable_ScrollableArea__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Page__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_ContextWrappers_LanguageContext__ = __webpack_require__(84);












var styles = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_utils_prefixStyles__["b" /* default */])({
  outerWrapper: {
    margin: "auto",
    maxWidth: "25em"
  },
  innerWrapper: {
    margin: "0 1.5em",
    display: "flex",
    flexDirection: "column"
  },
  richLabelWrapper: {
    margin: "0.5em 0",
    fontSize: "1.95em",
    alignSelf: "center"
  },
  richLabelLabelWrapper: {
    padding: "0.25em 0"
  }
});

var InternetRequiredPage = function InternetRequiredPage() {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_11_nx_components_ContextWrappers_LanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.pages.InternetRequiredPage;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Page__["b" /* default */], {
    name: "InternetRequiredPage",
    fullyLoaded: true
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_TopBar_AppBarWrapper__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_TopBar_CommonAppBarContainer__["a" /* default */], {
    title: language.title,
    iconRight: null
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Scrollable_ScrollableArea__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: styles.outerWrapper
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: styles.innerWrapper
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: styles.richLabelWrapper
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nx_components_RichLabel__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_nx_components_Icons__["E" /* IconCloudOff */], null),
    iconStyle: {
      marginLeft: "6px"
    },
    label: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      style: styles.richLabelLabelWrapper
    }, language.serviceUnavailableLabel)
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nx_components_ItemList__["a" /* Divider */], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    style: {
      margin: "1em 0"
    }
  }, language.serviceUnavailableDescription), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_nx_components_Button__["a" /* default */], {
    full: true,
    onTap: function onTap() {
      Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__["a" /* default */])("CHECK_NETWORK_STATUS");
    }
  }, language.retryButton)))));
};

/* harmony default export */ __webpack_exports__["a"] = (InternetRequiredPage);

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(217);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(306);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1034 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Heading__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Item__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Divider__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);













var ItemList =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ItemList, _React$Component);

  function ItemList() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, ItemList);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(ItemList).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(ItemList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showDividers = _this$props.showDividers,
          itemsFromProps = _this$props.items,
          style = _this$props.style,
          title = _this$props.title,
          id = _this$props.id,
          itemsWrapperProps = _this$props.itemsWrapperProps;
      var items = [];
      itemsFromProps.forEach(function (item, index) {
        var children = item.children,
            itemId = item.id,
            itemProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(item, ["children", "id"]);

        var showBottomLine = showDividers && index !== itemsFromProps.length - 1;
        items.push(__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Item__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          key: itemId,
          id: itemId
        }, itemProps), children));

        if (showBottomLine) {
          items.push(__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Divider__["a" /* default */], {
            key: "".concat(itemId, "-hr")
          }));
        }
      });
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        "data-component-name": "ItemList",
        "data-component-prop-title": title,
        "data-component-prop-id": id,
        style: style
      }, title ? __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Heading__["a" /* default */], {
        label: title
      }) : null, itemsWrapperProps == null ? items : __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", itemsWrapperProps, items));
    }
  }]);

  return ItemList;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ItemList, "propTypes", {
  showDividers: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.bool,
  items: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.arrayOf(function () {
    return (typeof __WEBPACK_IMPORTED_MODULE_10__Item__["a" /* bpfrpt_proptype_Props */] === "function" ? __WEBPACK_IMPORTED_MODULE_10__Item__["a" /* bpfrpt_proptype_Props */].isRequired ? __WEBPACK_IMPORTED_MODULE_10__Item__["a" /* bpfrpt_proptype_Props */].isRequired : __WEBPACK_IMPORTED_MODULE_10__Item__["a" /* bpfrpt_proptype_Props */] : __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_10__Item__["a" /* bpfrpt_proptype_Props */]).isRequired).apply(this, arguments);
  }).isRequired,
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  title: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.string.isRequired,
  // for end-to-end testing
  itemsWrapperProps: function itemsWrapperProps() {
    return (typeof (__WEBPACK_IMPORTED_MODULE_8_react__["ElementConfig"] == null ? {} : __WEBPACK_IMPORTED_MODULE_8_react__["ElementConfig"]) === "function" ? __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_react__["ElementConfig"] == null ? {} : __WEBPACK_IMPORTED_MODULE_8_react__["ElementConfig"]) : __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.any).apply(this, arguments);
  }
});






/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_AppBar__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_Popover__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_app_state__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ModeList__ = __webpack_require__(1042);

















var styles = {
  listWrapper: Object(__WEBPACK_IMPORTED_MODULE_9_nx_components_utils_prefixStyles__["b" /* default */])({
    display: "flex",
    position: "relative",
    right: "0.25em",
    // don't align the box all the way on the right edge of the screen
    width: "14em",
    maxWidth: "75vw",
    maxHeight: "70vh",
    backgroundColor: "white",
    borderRadius: 4,
    overflow: "hidden",
    // so that content gets cut by the border radius
    boxShadow: "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.4)"
  })
};

var ModeSelector =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ModeSelector, _React$Component);

  function ModeSelector() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ModeSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ModeSelector)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      popoverOpen: false
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_closePopover", function () {
      if (_this._isMounted) {
        _this.setState({
          popoverOpen: false
        });
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ModeSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var appState = this.props.appState;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_BackboneListener__["a" /* default */], {
        listenTo: appState,
        events: ["change:currentLocation"]
      }, function () {
        if (appState == null) {
          return null;
        }

        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_BackboneListener__["a" /* default */], {
          listenTo: appState.currentLocation,
          events: ["change:modes"]
        }, function () {
          if (appState.currentLocation == null) {
            return null;
          }

          var modesCollection = appState.currentLocation.get("modes");

          if (modesCollection == null) {
            return null;
          }

          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_BackboneListener__["a" /* default */], {
            listenTo: modesCollection,
            events: ["add", "remove", "reset", "sort", "sync", "change"],
            debounceRender: true
          }, function () {
            var popoverOpen = _this2.state.popoverOpen;
            var modeIcon;
            var currentMode = modesCollection.getActiveMode();

            if (currentMode != null) {
              modeIcon = currentMode.get("icon");
            }

            var ModeIconClass = modeIcon && Object(__WEBPACK_IMPORTED_MODULE_12_nx_components_Icons__["_62" /* iconFromAPIName */])(modeIcon) || __WEBPACK_IMPORTED_MODULE_12_nx_components_Icons__["W" /* IconHomeMode */];
            return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_AppBar__["c" /* AppBarIconWrapper */], {
              name: "ModeSelector",
              onTap: function onTap() {
                return _this2.setState({
                  popoverOpen: true
                });
              },
              innerRef: function innerRef(el) {
                return _this2._target = el;
              },
              "aria-label": "House Mode"
            }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](ModeIconClass, {
              style: {
                verticalAlign: ""
              }
            }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nx_components_Popover__["a" /* default */], {
              open: popoverOpen,
              arrowPosition: "topRight",
              onRequestClose: function onRequestClose() {
                return _this2.setState({
                  popoverOpen: false
                });
              },
              getTargetRect: function getTargetRect() {
                if (_this2._target) {
                  return _this2._target.getBoundingClientRect();
                } else {
                  return null;
                }
              }
            }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
              style: styles.listWrapper
            }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__ModeList__["a" /* default */], {
              modesCollection: modesCollection,
              onFinished: _this2._closePopover
            }))));
          });
        });
      });
    }
  }]);

  return ModeSelector;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ModeSelector, "propTypes", {
  appState: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_app_state__["a" /* default */])
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  appState: "appState"
}, ModeSelector));

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Popover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_debounce__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BackButtonResponder__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MountOnBody__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FocusController__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var ARROW_SIZE = 6;
var baseStyles = {
  root: {
    display: "flex",
    position: "fixed",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    zIndex: __WEBPACK_IMPORTED_MODULE_12__Theme__["a" /* default */].zIndexLayers.POPUP
  },
  childWrapperPrefixed: Object(__WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["b" /* default */])({
    flexShrink: "0",
    flexGrow: "0"
  }),
  childWrapper: function childWrapper(_ref) {
    var open = _ref.open;
    return _objectSpread({}, baseStyles.childWrapperPrefixed, {
      position: "relative",
      transition: open ? "transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)" : "transform 0.2s cubic-bezier(0.165, 0.84, 0.44, 1)",
      transform: open ? "scale(1.0)" : "scale(0.0)"
    });
  },
  arrow: {
    position: "absolute",
    width: 0,
    height: 0,
    border: "solid ".concat(ARROW_SIZE, "px transparent"),
    zIndex: "1" // render above potential box shadow of childWrapper children

  }
};
var styles = {
  // $FlowFixMe spread operator is buggy https://github.com/facebook/flow/issues/3061
  root: Object(__WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["b" /* default */])({
    topLeft: _objectSpread({}, baseStyles.root, {
      justifyContent: "flex-start",
      alignItems: "flex-start"
    }),
    topRight: _objectSpread({}, baseStyles.root, {
      justifyContent: "flex-end",
      alignItems: "flex-start"
    }),
    bottomLeft: _objectSpread({}, baseStyles.root, {
      justifyContent: "flex-start",
      alignItems: "flex-end"
    }),
    bottomRight: _objectSpread({}, baseStyles.root, {
      justifyContent: "flex-end",
      alignItems: "flex-end"
    })
  }),
  childWrapper: {
    topLeft: function topLeft(_ref2) {
      var targetRect = _ref2.targetRect,
          open = _ref2.open;
      return _objectSpread({}, baseStyles.childWrapper({
        open: open
      }), {
        transformOrigin: "".concat(targetRect.width / 2, "px ").concat(-ARROW_SIZE, "px"),
        marginTop: targetRect.bottom + ARROW_SIZE,
        marginLeft: targetRect.left
      });
    },
    topRight: function topRight(_ref3) {
      var targetRect = _ref3.targetRect,
          open = _ref3.open;
      return _objectSpread({}, baseStyles.childWrapper({
        open: open
      }), {
        transformOrigin: "calc(100% - ".concat(targetRect.width / 2, "px) ").concat(-ARROW_SIZE, "px"),
        marginTop: targetRect.bottom + ARROW_SIZE,
        marginRight: window.innerWidth - targetRect.right
      });
    },
    bottomLeft: function bottomLeft(_ref4) {
      var targetRect = _ref4.targetRect,
          open = _ref4.open;
      return _objectSpread({}, baseStyles.childWrapper({
        open: open
      }), {
        transformOrigin: "".concat(targetRect.width / 2, "px calc(100% + ").concat(ARROW_SIZE, "px)"),
        marginBottom: targetRect.top + targetRect.height + ARROW_SIZE,
        marginLeft: targetRect.left
      });
    },
    bottomRight: function bottomRight(_ref5) {
      var targetRect = _ref5.targetRect,
          open = _ref5.open;
      return _objectSpread({}, baseStyles.childWrapper({
        open: open
      }), {
        transformOrigin: "calc(100% - ".concat(targetRect.width / 2, "px) calc(100% + ").concat(ARROW_SIZE, "px)"),
        marginBottom: targetRect.bottom + ARROW_SIZE,
        marginRight: targetRect.left
      });
    }
  },
  arrow: {
    topLeft: function topLeft(_ref6) {
      var arrowBackgroundColor = _ref6.arrowBackgroundColor,
          targetRect = _ref6.targetRect;
      return _objectSpread({}, baseStyles.arrow, {
        borderBottomColor: arrowBackgroundColor,
        transform: "translateY(-100%)",
        top: 0,
        left: targetRect.width / 2 - ARROW_SIZE
      });
    },
    topRight: function topRight(_ref7) {
      var arrowBackgroundColor = _ref7.arrowBackgroundColor,
          targetRect = _ref7.targetRect;
      return _objectSpread({}, baseStyles.arrow, {
        borderBottomColor: arrowBackgroundColor,
        transform: "translateY(-100%)",
        top: 0,
        right: targetRect.width / 2 - ARROW_SIZE
      });
    },
    bottomLeft: function bottomLeft(_ref8) {
      var arrowBackgroundColor = _ref8.arrowBackgroundColor,
          targetRect = _ref8.targetRect;
      return _objectSpread({}, baseStyles.arrow, {
        borderTopColor: arrowBackgroundColor,
        transform: "translateY(100%)",
        bottom: 0,
        left: targetRect.width / 2 - ARROW_SIZE
      });
    },
    bottomRight: function bottomRight(_ref9) {
      var arrowBackgroundColor = _ref9.arrowBackgroundColor,
          targetRect = _ref9.targetRect;
      return _objectSpread({}, baseStyles.arrow, {
        borderTopColor: arrowBackgroundColor,
        transform: "translateY(100%)",
        bottom: 0,
        right: targetRect.width / 2 - ARROW_SIZE
      });
    }
  }
};

var Popover =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Popover, _React$Component);

  function Popover() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Popover)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      targetRect: null,
      closing: false
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isMounted", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_updateTargetRect", function () {
      if (!_this._isMounted) {
        return;
      }

      var getTargetRect = _this.props.getTargetRect;

      _this.setState({
        targetRect: getTargetRect()
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_debouncedUpdateTargetRect", __WEBPACK_IMPORTED_MODULE_8_lodash_debounce___default()(_this._updateTargetRect, __WEBPACK_IMPORTED_MODULE_12__Theme__["a" /* default */].RESPONSIVE_REFRESH_RATE));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleRootClicked", function (event) {
      if (!_this._wrapper) {
        return;
      }

      if (!(event.target instanceof Node) || !_this._wrapper.contains(event.target)) {
        _this.props.onRequestClose();
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleBackButtonPressed", function () {
      _this.props.onRequestClose();

      return {
        handled: true
      };
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;

      this._updateTargetRect();

      window.addEventListener("resize", this._debouncedUpdateTargetRect);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      window.removeEventListener("resize", this._debouncedUpdateTargetRect);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      this._updateTargetRect();

      if (this.props.open && !nextProps.open) {
        this.setState({
          closing: true
        }, function () {
          setTimeout(function () {
            if (!_this2._isMounted) {
              return;
            }

            _this2.setState({
              closing: false
            });
          }, 200);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          open = _this$props.open,
          children = _this$props.children,
          arrowPosition = _this$props.arrowPosition,
          arrowBackgroundColor = _this$props.arrowBackgroundColor;
      var _this$state = this.state,
          targetRect = _this$state.targetRect,
          closing = _this$state.closing;

      if (targetRect == null) {
        // Usually, the parent is not able to provide a target rect from a DOM
        // node in until componentDidMount (once it has the ref), so the first
        // time we render, we don't have a target rect.
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__MountOnBody__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__FocusController__["a" /* default */], {
        focused: open,
        onFocusExited: this.props.onRequestClose
      }, function (_ref10) {
        var captureTargetRef = _ref10.captureTargetRef;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          style: _objectSpread({}, styles.root[arrowPosition], {}, open ? null : {
            pointerEvents: "none"
          }) // eslint-disable-next-line nexia/prefer-tappable
          ,
          onClick: _this3._handleRootClicked
        }, open ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__BackButtonResponder__["b" /* default */], {
          onPressed: _this3._handleBackButtonPressed
        }) : null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          ref: function ref(el) {
            return _this3._wrapper = el;
          },
          style: styles.childWrapper[arrowPosition]({
            targetRect: targetRect,
            open: open
          }),
          "data-component-name": "Popover",
          "data-component-prop-open": String(Boolean(open))
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          style: styles.arrow[arrowPosition]({
            arrowBackgroundColor: arrowBackgroundColor,
            targetRect: targetRect
          })
        }), open || closing ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          ref: captureTargetRef,
          tabIndex: -1
        }, children) : null));
      }));
    }
  }]);

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Popover, "defaultProps", {
  arrowBackgroundColor: "white"
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Popover, "propTypes", {
  open: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool.isRequired,
  onRequestClose: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.node.isRequired,
  arrowPosition: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.oneOf(["topLeft", "topRight", "bottomLeft", "bottomRight"]).isRequired,
  getTargetRect: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func.isRequired,
  arrowBackgroundColor: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string
});




/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FocusController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);









var FocusController =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(FocusController, _React$Component);

  function FocusController() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, FocusController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(FocusController)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_target", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_previousActiveElement", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTargetRef", function (el) {
      if (el === _this._target) {
        return;
      }

      _this._target = el;

      _this._updateFocus({
        target: el,
        focused: _this.props.focused
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onFocusIn", function (event) {
      if (!_this._target) {
        return;
      }

      if (_this._target.contains(event.target)) {
        return;
      }

      _this.props.onFocusExited();
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(FocusController, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.focused === nextProps.focused) {
        return;
      }

      this._updateFocus({
        target: this._target,
        focused: nextProps.focused
      });
    }
  }, {
    key: "_updateFocus",
    value: function _updateFocus(next) {
      var target = next.target,
          focused = next.focused;

      if (target && focused) {
        this._focusTarget(target);
      } else {
        this._returnFocus();
      }
    }
  }, {
    key: "_focusTarget",
    value: function _focusTarget(target) {
      this._previousActiveElement = document.activeElement;
      target.focus();
      window.addEventListener("focusin", this._onFocusIn);
    }
  }, {
    key: "_returnFocus",
    value: function _returnFocus() {
      var prev = this._previousActiveElement;

      if (prev == null) {
        return;
      }

      prev.focus();
      this._previousActiveElement = null;
      window.removeEventListener("focusin", this._onFocusIn);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        captureTargetRef: this._handleTargetRef
      });
    }
  }]);

  return FocusController;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(FocusController, "propTypes", {
  focused: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,
  onFocusExited: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired
});




/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(102),
    now = __webpack_require__(1040),
    toNumber = __webpack_require__(1041);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(71);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(102),
    isSymbol = __webpack_require__(198);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModeList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_framework_collection__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_parseIconsFromServer__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DumbModeList__ = __webpack_require__(1043);














var ModeList =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ModeList, _React$Component);

  function ModeList() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ModeList);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ModeList).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ModeList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          modesCollection = _this$props.modesCollection,
          onFinished = _this$props.onFinished;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_BackboneListener__["a" /* default */], {
        listenTo: modesCollection,
        events: ["add", "remove", "reset", "sort", "sync", "change"],
        debounceRender: true
      }, function () {
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__DumbModeList__["a" /* default */], {
          modes: modesCollection.map(function (mode) {
            var icons = Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_parseIconsFromServer__["a" /* default */])(mode.get("icon"));
            var icon = null;

            if (icons.length > 0) {
              icon = icons[0].element;
            }

            return {
              id: mode.get("id"),
              name: mode.get("name"),
              icon: icon,
              isSelected: mode.get("enabled")
            };
          }),
          onModeSelected: function onModeSelected(id) {
            var mode = modesCollection.findWhere({
              id: id
            });
            Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_dispatch__["a" /* default */])("RUN_PROMISE_WITH_SPINNER", function () {
              return modesCollection.setActiveMode(mode).then(onFinished, onFinished);
            }, "Setting mode to '".concat(mode.get("name"), "'"));
          }
        });
      });
    }
  }]);

  return ModeList;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(ModeList, "propTypes", {
  modesCollection: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_framework_collection__["a" /* default */]).isRequired,
  onFinished: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
});



/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DumbModeList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_ItemList__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_RichLabel__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__ = __webpack_require__(9);











var styles = {
  wrapper: Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__["b" /* default */])({
    width: "100%",
    display: "flex",
    flexDirection: "column"
  }),
  title: {
    fontWeight: "bold",
    color: "black",
    padding: "1em 1em 0 1em"
  },
  modes: {
    overflowX: "hidden",
    overflowY: "auto"
  },
  mode: {
    padding: "1em",
    width: "100%"
  }
};

var DumbModeList =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DumbModeList, _React$Component);

  function DumbModeList() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DumbModeList);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DumbModeList).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DumbModeList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          modes = _this$props.modes,
          onModeSelected = _this$props.onModeSelected;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.wrapper
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.title
      }, "Choose a Mode"), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.modes
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nx_components_ItemList__["c" /* default */], {
        id: "modes",
        showDividers: true,
        items: modes.map(function (_ref) {
          var id = _ref.id,
              name = _ref.name,
              icon = _ref.icon,
              isSelected = _ref.isSelected;
          return {
            id: id,
            selected: isSelected,
            children: __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_RichLabel__["a" /* default */], {
              icon: icon,
              label: name
            }),
            childWrapperStyle: styles.mode,
            onTap: function onTap() {
              if (onModeSelected != null) {
                onModeSelected(id);
              }
            }
          };
        })
      })));
    }
  }]);

  return DumbModeList;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DumbModeList, "propTypes", {
  modes: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number]).isRequired,
    name: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
    icon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
    isSelected: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
  })),
  onModeSelected: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func // (modeId: string) => void

});



/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResourceNameEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_EditableText__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);












var ResourceNameEditor =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ResourceNameEditor, _React$Component);

  function ResourceNameEditor() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ResourceNameEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ResourceNameEditor)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      value: _this.props.initialValue
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleChange", function (value) {
      _this.setState({
        value: value
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleEditEnd", function () {
      var value = _this.state.value;
      var _this$props = _this.props,
          initialValue = _this$props.initialValue,
          resourceHref = _this$props.resourceHref,
          onEditEnd = _this$props.onEditEnd;

      if (value === "") {
        _this.setState({
          value: initialValue
        });

        return;
      }

      if (onEditEnd) {
        onEditEnd(value);
      }

      if (!resourceHref) {
        Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", "Change could not be saved.");

        _this.setState({
          value: initialValue
        });

        return;
      }

      if (initialValue !== value) {
        Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__["a" /* default */])("RESOURCE_CHANGE_NAME_REQUEST", resourceHref, value);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ResourceNameEditor, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.initialValue !== this.props.initialValue) {
        this.setState({
          value: nextProps.initialValue
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_EditableText__["a" /* default */], {
        value: value,
        inputSize: 16,
        maxTextLength: 32,
        maxWidth: 275,
        onChange: this._handleChange,
        onEditEnd: this._handleEditEnd
      });
    }
  }]);

  return ResourceNameEditor;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ResourceNameEditor, "propTypes", {
  initialValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  resourceHref: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  onEditEnd: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
});



/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_polished__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nx_components_NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nx_components_Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nx_components_Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_models_session__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_components_Dialogs_ChoiceDialog__ = __webpack_require__(1046);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var ChoiceItemWithoutColor =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ChoiceItemWithoutColor, _React$Component);

  function ChoiceItemWithoutColor() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, ChoiceItemWithoutColor);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(ChoiceItemWithoutColor).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(ChoiceItemWithoutColor, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          title = _this$props.title,
          text = _this$props.text,
          buttons = _this$props.buttons,
          persistenceText = _this$props.persistenceText,
          openDialog = _this$props.openDialog,
          closeDialog = _this$props.closeDialog,
          colors = _this$props.colors;
      var leftSafePadding = this.context.isLargeAppLayout ? "0px" : __WEBPACK_IMPORTED_MODULE_14_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_LEFT;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_15_nx_components_utils_prefixStyles__["b" /* default */])({
        choice: {
          color: colors.PRIMARY_TEXT,
          fontSize: "14px",
          padding: "0.5em",
          textAlign: "left"
        },
        flex: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        },
        icon: {
          fontSize: "16px",
          flex: "0 0 auto"
        }
      });
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nx_components_Tappable__["b" /* default */], {
        onTap: openDialog
      }, function (_ref) {
        var active = _ref.active,
            tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nx_components_NoStyleButton__["a" /* default */], {
          style: _objectSpread({}, styles.choice, {
            width: "calc(100% + ".concat(leftSafePadding, " + ").concat(__WEBPACK_IMPORTED_MODULE_14_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_RIGHT, ")"),
            marginLeft: "calc(-1 * ".concat(leftSafePadding, ")"),
            backgroundColor: active ? Object(__WEBPACK_IMPORTED_MODULE_10_polished__["a" /* darken */])(__WEBPACK_IMPORTED_MODULE_13_nx_components_Tappable__["a" /* ACTIVE_DARKEN_AMOUNT */], colors.TEXT) : colors.TEXT
          }),
          innerRef: tapTargetRefHandler
        }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
          style: styles.flex
        }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("span", null, persistenceText), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_nx_components_Icons__["H" /* IconDisclosureArrowRight */], {
          style: styles.icon
        })));
      }), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_nexia_mobile_components_Dialogs_ChoiceDialog__["a" /* default */], {
        open: open,
        title: title,
        text: text,
        buttons: buttons,
        onDismiss: closeDialog
      }));
    }
  }]);

  return ChoiceItemWithoutColor;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ChoiceItemWithoutColor, "contextTypes", {
  isLargeAppLayout: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ChoiceItemWithoutColor, "propTypes", {
  open: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool.isRequired,
  title: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  // html
  buttons: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape({
    action: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(["href", "dismiss"]).isRequired,
    text: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
    type: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string
  }).isRequired),
  persistenceText: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  openDialog: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,
  closeDialog: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
});

var ChoiceItem = Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_ColorsProvider__["c" /* withColorsProvider */])(ChoiceItemWithoutColor);

var ChoicesBanner =
/*#__PURE__*/
function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ChoicesBanner, _React$Component2);

  function ChoicesBanner() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, ChoicesBanner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(ChoicesBanner)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      openId: null
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleCloseDialog", function () {
      _this.setState({
        openId: null
      });

      _this.props.onDismiss();
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(ChoicesBanner, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var choices = this.props.choices;

      if (this.props.forceChoiceDialogOpen && choices.length > 0) {
        this.setState({
          openId: choices[0].id
        });
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // Determine which, if any, dialog should be open
      var choices = this.props.choices;
      var openId = this.state.openId;

      if (!choices.find(function (choice) {
        return choice.id === openId;
      })) {
        openId = null;
      }

      if (nextProps.forceChoiceDialogOpen && choices.length > 0 && openId == null) {
        openId = choices[0].id;
      }

      this.setState({
        openId: openId
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var choices = this.props.choices;
      var openId = this.state.openId;
      return choices.map(function (choice) {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](ChoiceItem, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
          key: choice.id
        }, choice, {
          open: choice.id === openId,
          openDialog: function openDialog() {
            return _this2.setState({
              openId: choice.id
            });
          },
          closeDialog: _this2._handleCloseDialog
        }));
      });
    }
  }]);

  return ChoicesBanner;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ChoicesBanner, "propTypes", {
  choices: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
    text: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
    // html
    buttons: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape({
      action: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(["href", "dismiss"]).isRequired,
      text: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
      type: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
      href: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string
    }).isRequired),
    persistenceText: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired
  }).isRequired).isRequired,
  forceChoiceDialogOpen: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool.isRequired,
  onDismiss: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired
});

var ChoicesBannerContainer =
/*#__PURE__*/
function (_React$Component3) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ChoicesBannerContainer, _React$Component3);

  function ChoicesBannerContainer() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, ChoicesBannerContainer);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(ChoicesBannerContainer).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(ChoicesBannerContainer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          session = _this$props2.session,
          forceChoiceDialogOpen = _this$props2.forceChoiceDialogOpen;

      if (!session) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_nexia_mobile_components_BackboneListener__["a" /* default */], {
        listenTo: session,
        events: ["change:choices"]
      }, function () {
        var choices = session.get("choices");

        if (!choices) {
          return null;
        }

        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_nexia_mobile_components_BackboneListener__["a" /* default */], {
          listenTo: choices,
          events: ["add", "remove", "reset", "sort", "sync", "change"],
          debounceRender: true
        }, function () {
          return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](ChoicesBanner, {
            choices: choices.map(function (choice) {
              return {
                id: choice.get("id"),
                title: choice.get("title"),
                text: choice.get("text"),
                buttons: choice.get("buttons").map(function (button) {
                  return button.attributes;
                }),
                persistenceText: choice.get("persistence_text")
              };
            }),
            forceChoiceDialogOpen: forceChoiceDialogOpen,
            onDismiss: function onDismiss() {
              setTimeout(function () {
                // I dont' know why this timeout is needed, but without it
                // the dialog doesn't close for about a second (maybe when
                // the fetch completes?)
                Object(__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("forceChoiceDialogOpen", false);
              });
              choices.fetch();
            }
          });
        });
      });
    }
  }]);

  return ChoicesBannerContainer;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ChoicesBannerContainer, "propTypes", {
  session: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_17_nexia_mobile_models_session__["a" /* default */]).isRequired,
  forceChoiceDialogOpen: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  session: "session",
  forceChoiceDialogOpen: "forceChoiceDialogOpen"
}, ChoicesBannerContainer));


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChoiceDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_Dialog__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_GlobalStyleSheet__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nx_components_ScrollableDiv__ = __webpack_require__(130);













 // Allow server-sent HTML to provide some default styling despite our reset

var CHOICE_CSS_ID = "nexia-js_ChoiceDialog";
var sheet = "\n  .".concat(CHOICE_CSS_ID, "_unreset i {\n    font-style: italic;\n  }\n  .").concat(CHOICE_CSS_ID, "_unreset b {\n    font-weight: bold;\n  }\n");
var styles = {
  wrapper: {
    width: "80vw",
    maxWidth: "20em",
    maxHeight: "80vh",
    padding: "1em"
  },
  title: {
    fontSize: "1.15em",
    fontWeight: "bold",
    marginBottom: "0.5em"
  },
  buttons: {
    marginTop: "1em",
    textAlign: "center"
  }
};

var ChoiceDialog =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ChoiceDialog, _React$Component);

  function ChoiceDialog() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ChoiceDialog);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ChoiceDialog).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ChoiceDialog, [{
    key: "_handleButtonClick",
    value: function _handleButtonClick(button) {
      var _this$props = this.props,
          title = _this$props.title,
          onDismiss = _this$props.onDismiss;

      if (button.action === "href" && button.href) {
        fetch(button.href, {
          method: button.method || "POST",
          headers: {
            "Content-Type": "application/json",
            "X-MobileId": __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_local_settings__["c" /* default */].getMobileId(),
            "X-ApiKey": __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_models_local_settings__["c" /* default */].getApiKey()
          }
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (!data.success) {
            // TODO: extract this into a nice `handleServerError` method which is
            // exported from the same file as the request API, so that you can tweak
            // behavior going in instead of overloading `handleServerError` so hard.
            Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", data.error && data.error.message || "An error occurred.");
          }

          onDismiss();
        }, onDismiss);
      } else if (button.action === "dismiss") {
        onDismiss();
      } else {
        onDismiss();
        throw new Error("Attempted to perform unknown Choice button action \"".concat(button.action, "\" for choice with title ").concat(title));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          open = _this$props2.open,
          title = _this$props2.title,
          text = _this$props2.text,
          buttons = _this$props2.buttons,
          onDismiss = _this$props2.onDismiss;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_Dialog__["a" /* default */], {
        open: open,
        onTapBackground: onDismiss,
        onRequestClose: onDismiss
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nx_components_ScrollableDiv__["a" /* default */], {
        style: styles.wrapper
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_GlobalStyleSheet__["a" /* default */], {
        id: CHOICE_CSS_ID,
        sheet: sheet
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("h1", {
        style: styles.title
      }, title), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        className: "".concat(CHOICE_CSS_ID, "_unreset"),
        dangerouslySetInnerHTML: {
          __html: text
        }
      }), buttons && buttons.length > 0 ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.buttons
      }, buttons.map(function (button) {
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nx_components_Button__["a" /* default */], {
          key: button.text,
          onTap: function onTap() {
            return _this._handleButtonClick(button);
          },
          theme: button.type,
          full: true
        }, button.text);
      })) : null));
    }
  }]);

  return ChoiceDialog;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(ChoiceDialog, "propTypes", {
  open: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  // html
  buttons: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    action: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(["href", "dismiss"]).isRequired,
    text: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
    type: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  })),
  onDismiss: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
});



/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_ContextWrappers_LanguageContext__ = __webpack_require__(84);





var styles = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_utils_prefixStyles__["b" /* default */])({
  outerWrapper: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    overflowY: "auto"
  },
  innerWrapper: {
    margin: "1.5em",
    maxWidth: "25em",
    maxHeight: "100%"
  },
  fourOhFourWrapper: {
    margin: "1rem 0",
    fontSize: "3em",
    textAlign: "center"
  },
  textWrapper: {
    margin: "1rem 0",
    textAlign: "center"
  },
  pre: {
    margin: "1rem 0",
    padding: "0.5rem",
    fontFamily: "monospace",
    backgroundColor: "#f6f8fa",
    color: "#24292e",
    fontSize: "0.75em",
    overflowX: "auto"
  },
  codeComment: {
    color: "#6a737d"
  }
});

var NotFoundPage = function NotFoundPage() {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4_nx_components_ContextWrappers_LanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.pages.NotFoundPage;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: styles.outerWrapper
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: styles.innerWrapper
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: styles.fourOhFourWrapper
  }, "404"), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: styles.textWrapper
  }, language.pageNotFound),  true ? null : // eslint-enable no-process-env
  React.createElement("pre", {
    style: styles.pre
  }, React.createElement("code", null, React.createElement("span", {
    style: styles.codeComment
  }, "// history.location:\n\n"), JSON.stringify(history.location, null, 2), React.createElement("span", {
    style: styles.codeComment
  }, "\n\n// (this box is not shown in prod)"))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_nx_components_Button__["a" /* default */], {
    full: true,
    onTap: function onTap() {
      if (__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_history__["d" /* history */].entries.length > 1) {
        __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_history__["d" /* history */].goBack();
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/");
      }
    }
  }, language.goBack)));
};

/* harmony default export */ __webpack_exports__["a"] = (NotFoundPage);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_AppContainer__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Routing_SwitchWith404__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_MainMenu__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_TopBar_DrawerRevealer__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_CurrentLocationCollectionProvider__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_flux_like_action_handlers_location__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_flux_like_action_handlers_session__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_nexia_mobile_components_Pages_HomePage__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_nexia_mobile_components_Routing_BuildingRoutes__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_nexia_mobile_components_Details_DeviceDetails__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_nexia_mobile_components_Pages_OccupancySetpointsPage__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__ = __webpack_require__(288);








/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/




















var DeviceEnrollmentPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1293));
});
var Alerts = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1294));
});
var AutomationRoutes = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1295));
});
var EventsPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1296));
});
var RecordedVideoPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1297));
});
var PhoneRoutes = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1298));
});
var HomeSettings = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1299));
});
var OpenSourceLicensePage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1300));
});
var CreateGroupPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1301));
});
var EditGroupPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1302));
});
var VideoFeedPlayerPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1303));
});
var MultiVideoFeedPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1304));
});
var SchemaEditPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1286));
});
var LocalSettingsPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1305));
});
var SupportPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1306));
});
var XR724EnrollmentWizard = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1307));
});
var XR724WifiConfigurationWizard = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1308));
});
var DragonflyEnrollmentWizard = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1309));
});
var DragonflyWifiConfigurationWizard = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1310));
});
var DeviceSettingsPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1311));
});
var ThermostatAlertsPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1312));
});
var ThermostatFaultAlertsPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1313));
});
var ThermostatHighLowAlertsPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1314));
});
var ThermostatHumidityAlertsPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1315));
});
var OtherTemperatureAlertsPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1316));
});
var BinaryInputAlertPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1317));
});
var PinAccessPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1318));
});
var AccessRestrictionPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1319));
});
var DeviceAdvancedInfoPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1320));
});
var UserCodes = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1321));
});
var TemporaryCodeEdit = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1322));
});
var ThermostatScheduleEditPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1287));
});
var RuntimeHistoryPage = Object(__WEBPACK_IMPORTED_MODULE_26_nexia_mobile_components_Routing_Loading__["a" /* makeLoaderComponent */])(function () {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1323));
});

var AppRoutes =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AppRoutes, _React$Component);

  function AppRoutes() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AppRoutes);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AppRoutes)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      isDrawerRequested: false
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AppRoutes, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var isPlayingVideo = this.props.isPlayingVideo;
      var isDrawerRequested = this.state.isDrawerRequested;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_TopBar_DrawerRevealer__["a" /* DrawerRevealerProvider */], {
        onDrawerRevealerTap: function onDrawerRevealerTap() {
          _this2.setState(function (prevState) {
            return {
              isDrawerRequested: !prevState.isDrawerRequested
            };
          });
        }
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_AppContainer__["a" /* default */], {
        drawerChildren: __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_MainMenu__["a" /* default */], {
          itemIsSelected: function itemIsSelected(id) {
            var location = __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_history__["d" /* history */].location;
            var computedMatch = Object(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["f" /* matchPath */])(location.pathname, {
              path: "/app/".concat(id)
            });
            return Boolean(computedMatch);
          },
          onItemSelected: function onItemSelected() {
            _this2.setState({
              isDrawerRequested: false
            });
          }
        }),
        isDrawerRequested: isDrawerRequested,
        fullscreen: isPlayingVideo,
        onDrawerClose: function onDrawerClose() {
          return _this2.setState({
            isDrawerRequested: false
          });
        },
        onDrawerOpen: function onDrawerOpen() {
          return _this2.setState({
            isDrawerRequested: true
          });
        }
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Routing_SwitchWith404__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["c" /* Route */], {
        path: "/app",
        exact: true,
        render: function render() {
          if (__WEBPACK_IMPORTED_MODULE_18_nexia_mobile_flux_like_store__["a" /* default */].vognition.listenOnStartupPending) {
            Object(__WEBPACK_IMPORTED_MODULE_17_nexia_mobile_flux_like_dispatch__["a" /* default */])("START_VOGNITION_LISTENER_FROM_STARTUP");
          }

          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["b" /* Redirect */], {
            to: "/app/home"
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/home",
        exact: true,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_nexia_mobile_components_Pages_HomePage__["a" /* default */], {
            showDeviceAdd: function showDeviceAdd() {
              Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app/devices/add");
            }
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/buildings",
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_nexia_mobile_components_Routing_BuildingRoutes__["a" /* default */], null);
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/details",
        exact: true,
        render: function render(_ref) {
          var location = _ref.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_nexia_mobile_components_Details_DeviceDetails__["a" /* default */], {
            model: device
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/schedule",
        exact: true,
        render: function render(_ref2) {
          var location = _ref2.location;
          var _location$state = location.state,
              device = _location$state.device,
              schedule = _location$state.schedule;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](ThermostatScheduleEditPage, {
            device: device,
            schedule: schedule
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/runtime-history",
        exact: true,
        render: function render(_ref3) {
          var location = _ref3.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](RuntimeHistoryPage, {
            model: device
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/settings",
        exact: true,
        render: function render(_ref4) {
          var location = _ref4.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](DeviceSettingsPage, {
            device: device
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/user-codes" // Not exact because UserCodes has nested routes
        ,
        render: function render(_ref5) {
          var location = _ref5.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](UserCodes, {
            model: device
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/temporary-code-edit",
        exact: true,
        render: function render(_ref6) {
          var location = _ref6.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](TemporaryCodeEdit, {
            model: device
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/add" // Not exact because DeviceEnrollmentPage has nested routes
        ,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](DeviceEnrollmentPage, {
            onWizardFinish: function onWizardFinish() {
              Object(__WEBPACK_IMPORTED_MODULE_17_nexia_mobile_flux_like_dispatch__["a" /* default */])("REFRESH_LOCATION_AND_RETURN_TO_DASHBOARD");
              return Object(__WEBPACK_IMPORTED_MODULE_20_nexia_mobile_flux_like_action_handlers_location__["a" /* getPendingPromiseForRefreshLocationAndReturnToDashboard */])();
            }
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/occupancy-setpoints",
        exact: true,
        render: function render(_ref7) {
          var location = _ref7.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25_nexia_mobile_components_Pages_OccupancySetpointsPage__["a" /* default */], {
            model: device
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/thermostat-alerts",
        exact: true,
        render: function render(_ref8) {
          var location = _ref8.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](ThermostatAlertsPage, {
            model: device
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/thermostat-alerts/fault",
        exact: true,
        render: function render(_ref9) {
          var location = _ref9.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](ThermostatFaultAlertsPage, {
            model: device
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/thermostat-alerts/highlowfault",
        exact: true,
        render: function render(_ref10) {
          var location = _ref10.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](ThermostatHighLowAlertsPage, {
            model: device
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/thermostat-alerts/humidityfault",
        exact: true,
        render: function render(_ref11) {
          var location = _ref11.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](ThermostatHumidityAlertsPage, {
            model: device
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/thermostat-alerts/othertemperature",
        exact: true,
        render: function render(_ref12) {
          var location = _ref12.location;
          var _location$state2 = location.state,
              device = _location$state2.device,
              giValue = _location$state2.giValue;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](OtherTemperatureAlertsPage, {
            model: device,
            giValue: giValue
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/thermostat-alerts/binaryinputalert",
        exact: true,
        render: function render(_ref13) {
          var location = _ref13.location;
          var _location$state3 = location.state,
              device = _location$state3.device,
              giValue = _location$state3.giValue;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](BinaryInputAlertPage, {
            model: device,
            giValue: giValue
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/pin-access",
        exact: true,
        render: function render(_ref14) {
          var location = _ref14.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](PinAccessPage, {
            model: device
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/access-restriction",
        exact: true,
        render: function render(_ref15) {
          var location = _ref15.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](AccessRestrictionPage, {
            model: device
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/devices/advanced",
        exact: true,
        render: function render(_ref16) {
          var location = _ref16.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](DeviceAdvancedInfoPage, {
            device: device
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/alerts" // Not exact because Alerts has nested routes
        ,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](Alerts, null);
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/automations" // Not exact because AutomationRoutes has nested routes
        ,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](AutomationRoutes, null);
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/events",
        exact: true,
        render: function render(_ref17) {
          var location = _ref17.location;
          var filterHref = location && location.state ? location.state.filterHref : null;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_CurrentLocationCollectionProvider__["a" /* default */], {
            collectionName: "events"
          }, function (collection) {
            return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](EventsPage, {
              collection: collection,
              filterHref: filterHref
            });
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/videos",
        exact: true,
        render: function render(_ref18) {
          var location = _ref18.location;
          var filterHref = location && location.state ? location.state.filterHref : null;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_CurrentLocationCollectionProvider__["a" /* default */], {
            collectionName: "recordedVideos"
          }, function (collection) {
            return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](RecordedVideoPage, {
              collection: collection,
              filterHref: filterHref,
              loadOnMount: __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_history__["d" /* history */].action !== "POP"
            });
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/videos/edit",
        exact: true,
        render: function render(_ref19) {
          var location = _ref19.location;
          var _location$state4 = location.state,
              editSchema = _location$state4.editSchema,
              onCommitted = _location$state4.onCommitted,
              onDeleted = _location$state4.onDeleted;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](SchemaEditPage, {
            schema: editSchema,
            onCommitted: onCommitted,
            onDeleted: onDeleted
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/phones" // Not exact because PhoneRoutes has nested routes
        ,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](PhoneRoutes, null);
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["c" /* Route */], {
        path: "/app/settings",
        exact: true,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](LocalSettingsPage, {
            refreshLocation: function refreshLocation() {
              Object(__WEBPACK_IMPORTED_MODULE_17_nexia_mobile_flux_like_dispatch__["a" /* default */])("REFRESH_SESSION_AND_RETURN_TO_DASHBOARD");
              return Object(__WEBPACK_IMPORTED_MODULE_21_nexia_mobile_flux_like_action_handlers_session__["a" /* getPendingPromiseForRefreshSessionAndReturnToDashboard */])();
            }
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/settings/home-settings",
        exact: true,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](HomeSettings, null);
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["c" /* Route */], {
        path: "/app/support",
        exact: true,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](SupportPage, null);
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["c" /* Route */], {
        path: "/app/open-source-license-info",
        exact: true,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](OpenSourceLicensePage, null);
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/groups/add",
        exact: true,
        render: function render() {
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](CreateGroupPage, {
            onCommitted: function onCommitted() {
              Object(__WEBPACK_IMPORTED_MODULE_17_nexia_mobile_flux_like_dispatch__["a" /* default */])("REFRESH_LOCATION_AND_RETURN_TO_DASHBOARD");
              return Object(__WEBPACK_IMPORTED_MODULE_20_nexia_mobile_flux_like_action_handlers_location__["a" /* getPendingPromiseForRefreshLocationAndReturnToDashboard */])();
            }
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/groups/edit",
        exact: true,
        render: function render(_ref20) {
          var location = _ref20.location;
          var editSchema = location.state.editSchema;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](EditGroupPage, {
            editSchema: editSchema,
            onCommitted: function onCommitted() {
              Object(__WEBPACK_IMPORTED_MODULE_17_nexia_mobile_flux_like_dispatch__["a" /* default */])("REFRESH_LOCATION_AND_RETURN_TO_DASHBOARD");
              return Object(__WEBPACK_IMPORTED_MODULE_20_nexia_mobile_flux_like_action_handlers_location__["a" /* getPendingPromiseForRefreshLocationAndReturnToDashboard */])();
            },
            onDeleted: function onDeleted() {
              Object(__WEBPACK_IMPORTED_MODULE_17_nexia_mobile_flux_like_dispatch__["a" /* default */])("REFRESH_LOCATION_AND_RETURN_TO_DASHBOARD");
              return Object(__WEBPACK_IMPORTED_MODULE_20_nexia_mobile_flux_like_action_handlers_location__["a" /* getPendingPromiseForRefreshLocationAndReturnToDashboard */])();
            }
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/video-feed",
        exact: true,
        render: function render(_ref21) {
          var location = _ref21.location;
          var model = location.state.model;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](VideoFeedPlayerPage, {
            model: model,
            onRequestClose: function onRequestClose() {
              __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_history__["d" /* history */].goBack();
            }
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_InternetRequiredRoute__["a" /* default */], {
        path: "/app/multi-video-feed",
        exact: true,
        render: function render(_ref22) {
          var location = _ref22.location;
          var group = location.state.group;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](MultiVideoFeedPage, {
            group: group
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["c" /* Route */], {
        path: "/app/xr724/enrollment-wizard" // Not exact because XR724EnrollmentWizard has nested routes
        ,
        render: function render(_ref23) {
          var location = _ref23.location;
          var _location$state5 = location.state,
              wizardVideos = _location$state5.wizardVideos,
              fetchEnrollmentDetails = _location$state5.fetchEnrollmentDetails,
              onWizardFinish = _location$state5.onWizardFinish,
              onWizardLeave = _location$state5.onWizardLeave;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](XR724EnrollmentWizard, {
            wizardVideos: wizardVideos,
            fetchEnrollmentDetails: fetchEnrollmentDetails,
            onWizardFinish: onWizardFinish,
            onWizardLeave: onWizardLeave,
            exitWizard: onWizardFinish,
            defaultWizardState: {
              detailsHaveBeenFetched: false,
              pin: null,
              statusUrl: null,
              cancelLink: null,
              wizardExpiresAt: null,
              userKey: null,
              networks: null,
              chosenNetwork: null,
              errorMessage: null,
              isErrorRecoverable: true
            }
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["c" /* Route */], {
        path: "/app/xr724/wifi-configuration-wizard" // Not exact because XR724WifiConfigurationWizard has nested routes
        ,
        render: function render(_ref24) {
          var location = _ref24.location;
          var _location$state6 = location.state,
              fetchDeviceLastUpdateTime = _location$state6.fetchDeviceLastUpdateTime,
              wizardVideos = _location$state6.wizardVideos,
              onWizardFinish = _location$state6.onWizardFinish,
              onWizardLeave = _location$state6.onWizardLeave,
              defaultWizardState = _location$state6.defaultWizardState;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](XR724WifiConfigurationWizard, {
            wizardVideos: wizardVideos,
            fetchDeviceLastUpdateTime: fetchDeviceLastUpdateTime,
            onWizardFinish: onWizardFinish,
            onWizardLeave: onWizardLeave,
            defaultWizardState: defaultWizardState
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["c" /* Route */], {
        path: "/app/dragonfly/enrollment-wizard" // Not exact because DragonflyEnrollmentWizard has nested routes
        ,
        render: function render(_ref25) {
          var location = _ref25.location;
          var _location$state7 = location.state,
              fetchEnrollmentDetails = _location$state7.fetchEnrollmentDetails,
              onWizardFinish = _location$state7.onWizardFinish;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](DragonflyEnrollmentWizard, {
            fetchEnrollmentDetails: fetchEnrollmentDetails,
            onWizardFinish: onWizardFinish,
            exitWizard: onWizardFinish,
            defaultWizardState: {
              detailsHaveBeenFetched: false,
              pin: null,
              statusUrl: null,
              cancelLink: null,
              wizardExpiresAt: null,
              networks: null,
              chosenNetwork: null,
              errorMessage: null,
              isErrorRecoverable: true
            }
          });
        }
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["c" /* Route */], {
        path: "/app/dragonfly/wifi-configuration-wizard" // Not exact because DragonflyWifiConfigurationWizard has nested routes
        ,
        render: function render(_ref26) {
          var location = _ref26.location;
          var device = location.state.device;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](DragonflyWifiConfigurationWizard, {
            fetchDeviceLastUpdateTime: function fetchDeviceLastUpdateTime() {
              return device.fetchLastUpdateTime();
            },
            onWizardFinish: function onWizardFinish() {
              Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_history__["c" /* goBackTo */])("/app/devices/settings");
            },
            defaultWizardState: {
              networks: null,
              chosenNetwork: null
            }
          });
        }
      }))));
    }
  }]);

  return AppRoutes;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AppRoutes, "propTypes", {
  isPlayingVideo: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  isPlayingVideo: "isPlayingVideo"
}, AppRoutes));

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppContainerContents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AppContainerBreakpointProvider__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AppDrawer__ = __webpack_require__(1050);











var AppContainerContents = function AppContainerContents(_ref, context) {
  var children = _ref.children,
      drawerChildren = _ref.drawerChildren,
      isDrawerRequested = _ref.isDrawerRequested,
      fullscreen = _ref.fullscreen,
      onDrawerClose = _ref.onDrawerClose;
  var isLargeAppLayout = context.isLargeAppLayout;

  var handleDrawerRequestChange = function handleDrawerRequestChange() {
    // Currently we do not have or need a way to open the drawer from here
    if (onDrawerClose) {
      onDrawerClose();
    }
  };

  var style = {
    container: {
      position: "absolute",
      top: 0,
      left: isLargeAppLayout && !fullscreen ? __WEBPACK_IMPORTED_MODULE_10__AppDrawer__["a" /* default */].WIDTH : 0,
      right: 0,
      bottom: 0
    }
  };
  var drawerOpen = fullscreen ? false : isLargeAppLayout || isDrawerRequested;
  return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
    "data-component-name": "AppContainerContents",
    "data-app-is-large": isLargeAppLayout
  }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__AppDrawer__["a" /* default */], {
    docked: isLargeAppLayout,
    onRequestChange: handleDrawerRequestChange,
    open: drawerOpen
  }, drawerChildren), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
    "data-component-section": "app-container-main-contents",
    style: style.container
  }, children));
};
AppContainerContents.contextTypes = {
  isLargeAppLayout: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
AppContainerContents.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  drawerChildren: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  isDrawerRequested: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onDrawerClose: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  fullscreen: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

var AppContainer =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AppContainer, _React$Component);

  function AppContainer() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, AppContainer);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(AppContainer).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(AppContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          rest = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_this$props, ["children"]);

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__AppContainerBreakpointProvider__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](AppContainerContents, rest, children));
    }
  }]);

  return AppContainer;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AppContainer, "propTypes", AppContainerContents.propTypes);



/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppDrawer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Drawer__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BackButtonResponder__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ColorsProvider__ = __webpack_require__(12);













function getWidth() {
  // Hack to get a safe width for iPhones with a notch when in landscape.
  var span = document.createElement("span");
  Object.assign(span.style, {
    position: "absolute",
    pointerEvents: "none",
    paddingTop: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.SAFE_AREA_TOP,
    paddingRight: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.SAFE_AREA_RIGHT,
    paddingBottom: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.SAFE_AREA_BOTTOM,
    paddingLeft: __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Padding.SAFE_AREA_LEFT
  });
  document.body.appendChild(span);
  var styles = window.getComputedStyle(span);
  var hasSafeArea = styles.padding !== "0px";
  document.body.removeChild(span);
  return 275 + (hasSafeArea ? 22 : 0);
}

var AppDrawer =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(AppDrawer, _React$Component);

  function AppDrawer() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AppDrawer);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AppDrawer).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AppDrawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      AppDrawer.WIDTH = getWidth(); // This doesn't seem to be correct during the
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          children = _this$props.children,
          open = _this$props.open,
          docked = _this$props.docked,
          onRequestChange = _this$props.onRequestChange;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, open && __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__BackButtonResponder__["b" /* default */], {
        onPressed: function onPressed() {
          onRequestChange(false);
          return {
            handled: true
          };
        }
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ColorsProvider__["b" /* default */], null, function () {
        return (// we don't use colors directly, but ColorsProvider also wraps its
          // children in a MuiThemeProvider whose MUI theme is based on the
          // current colorSet, so we are relying on that.
          __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
            "aria-hidden": !open
          }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Drawer___default.a, {
            open: open,
            variant: docked ? "permanent" : "temporary",
            onClose: onRequestChange,
            ref: function ref(drawer) {
              return _this._muiDrawer = drawer;
            },
            PaperProps: {
              // The more appropriate way for styling the Paper sub-component is using MUI's withStyles
              // but that breaks Drawer's animations. For now pass styling directly to Paper
              // so as long as we have that prop to do so.
              style: {
                width: AppDrawer.WIDTH,
                border: "none",
                boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px" // Note: was not originally added by Nexia or Pivot, was it from mui 0.15.0?

              }
            }
          }, children))
        );
      }));
    }
  }]);

  return AppDrawer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(AppDrawer, "WIDTH", getWidth());

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(AppDrawer, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  open: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  docked: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onRequestChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(AppDrawer, "defaultProps", {
  docked: false
});



/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Drawer.default;
  }
});

var _Drawer = _interopRequireDefault(__webpack_require__(1052));

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHorizontal = isHorizontal;
exports.getAnchor = getAnchor;
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(2));

var _createClass2 = _interopRequireDefault(__webpack_require__(3));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(5));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(4));

var _inherits2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(40));

var _classnames = _interopRequireDefault(__webpack_require__(125));

var _Modal = _interopRequireDefault(__webpack_require__(1053));

var _withStyles = _interopRequireDefault(__webpack_require__(126));

var _Slide = _interopRequireDefault(__webpack_require__(1076));

var _Paper = _interopRequireDefault(__webpack_require__(1080));

var _helpers = __webpack_require__(298);

var _transitions = __webpack_require__(205);

var oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};

function isHorizontal(props) {
  return ['left', 'right'].indexOf(props.anchor) !== -1;
}

function getAnchor(props) {
  return props.theme.direction === 'rtl' && isHorizontal(props) ? oppositeDirection[props.anchor] : props.anchor;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `variant="permanent or persistent"`. */
    docked: {
      flex: '0 0 auto'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 'none'
    },

    /* Styles applied to the `Paper` component if `anchor="left"`. */
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },

    /* Styles applied to the `Paper` component if `anchor="right"`. */
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },

    /* Styles applied to the `Paper` component if `anchor="top"`. */
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="left"` & `variant` is not "temporary". */
    paperAnchorDockedLeft: {
      borderRight: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="top"` & `variant` is not "temporary". */
    paperAnchorDockedTop: {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="right"` & `variant` is not "temporary". */
    paperAnchorDockedRight: {
      borderLeft: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"` & `variant` is not "temporary". */
    paperAnchorDockedBottom: {
      borderTop: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Modal` component. */
    modal: {}
  };
};
/**
 * The properties of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */


exports.styles = styles;

var Drawer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Drawer, _React$Component);

  function Drawer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Drawer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Drawer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.mounted = false;
    return _this;
  }

  (0, _createClass2.default)(Drawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          anchorProp = _this$props.anchor,
          BackdropProps = _this$props.BackdropProps,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          elevation = _this$props.elevation,
          _this$props$ModalProp = _this$props.ModalProps;
      _this$props$ModalProp = _this$props$ModalProp === void 0 ? {} : _this$props$ModalProp;
      var BackdropPropsProp = _this$props$ModalProp.BackdropProps,
          ModalProps = (0, _objectWithoutProperties2.default)(_this$props$ModalProp, ["BackdropProps"]),
          onClose = _this$props.onClose,
          open = _this$props.open,
          PaperProps = _this$props.PaperProps,
          SlideProps = _this$props.SlideProps,
          theme = _this$props.theme,
          transitionDuration = _this$props.transitionDuration,
          variant = _this$props.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "theme", "transitionDuration", "variant"]);
      var anchor = getAnchor(this.props);

      var drawer = _react.default.createElement(_Paper.default, (0, _extends2.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true,
        className: (0, _classnames.default)(classes.paper, classes["paperAnchor".concat((0, _helpers.capitalize)(anchor))], (0, _defineProperty2.default)({}, classes["paperAnchorDocked".concat((0, _helpers.capitalize)(anchor))], variant !== 'temporary'))
      }, PaperProps), children);

      if (variant === 'permanent') {
        return _react.default.createElement("div", (0, _extends2.default)({
          className: (0, _classnames.default)(classes.root, classes.docked, className)
        }, other), drawer);
      }

      var slidingDrawer = _react.default.createElement(_Slide.default, (0, _extends2.default)({
        in: open,
        direction: oppositeDirection[anchor],
        timeout: transitionDuration,
        appear: this.mounted
      }, SlideProps), drawer);

      if (variant === 'persistent') {
        return _react.default.createElement("div", (0, _extends2.default)({
          className: (0, _classnames.default)(classes.root, classes.docked, className)
        }, other), slidingDrawer);
      } // variant === temporary


      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        BackdropProps: (0, _extends2.default)({}, BackdropProps, BackdropPropsProp, {
          transitionDuration: transitionDuration
        }),
        className: (0, _classnames.default)(classes.root, classes.modal, className),
        open: open,
        onClose: onClose
      }, other, ModalProps), slidingDrawer);
    }
  }]);
  return Drawer;
}(_react.default.Component);

 false ? Drawer.propTypes = {
  /**
   * Side from which the drawer will appear.
   */
  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * @ignore
   */
  BackdropProps: _propTypes.default.object,

  /**
   * The contents of the drawer.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The elevation of the drawer.
   */
  elevation: _propTypes.default.number,

  /**
   * Properties applied to the [`Modal`](/api/modal/) element.
   */
  ModalProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes.default.bool,

  /**
   * Properties applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * Properties applied to the [`Slide`](/api/slide/) element.
   */
  SlideProps: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
Drawer.defaultProps = {
  anchor: 'left',
  elevation: 16,
  open: false,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  },
  variant: 'temporary' // Mobile first.

};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDrawer',
  flip: false,
  withTheme: true
})(Drawer);

exports.default = _default;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "ModalManager", {
  enumerable: true,
  get: function get() {
    return _ModalManager.default;
  }
});

var _Modal = _interopRequireDefault(__webpack_require__(1054));

var _ModalManager = _interopRequireDefault(__webpack_require__(448));

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(2));

var _createClass2 = _interopRequireDefault(__webpack_require__(3));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(5));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(4));

var _inherits2 = _interopRequireDefault(__webpack_require__(6));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(53));

var _propTypes = _interopRequireDefault(__webpack_require__(40));

var _classnames = _interopRequireDefault(__webpack_require__(125));

var _warning = _interopRequireDefault(__webpack_require__(49));

var _utils = __webpack_require__(80);

var _ownerDocument = _interopRequireDefault(__webpack_require__(146));

var _RootRef = _interopRequireDefault(__webpack_require__(1055));

var _Portal = _interopRequireDefault(__webpack_require__(1058));

var _helpers = __webpack_require__(298);

var _withStyles = _interopRequireDefault(__webpack_require__(126));

var _ModalManager = _interopRequireDefault(__webpack_require__(448));

var _Backdrop = _interopRequireDefault(__webpack_require__(1071));

var _manageAriaHidden = __webpack_require__(451);

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/* istanbul ignore if */


exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Modal, _React$Component);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Modal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Modal).call(this));
    _this.mounted = false;

    _this.handleOpen = function () {
      var doc = (0, _ownerDocument.default)(_this.mountNode);
      var container = getContainer(_this.props.container, doc.body);

      _this.props.manager.add((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), container);

      doc.addEventListener('focus', _this.enforceFocus, true);

      if (_this.dialogRef) {
        _this.handleOpened();
      }
    };

    _this.handleRendered = function () {
      if (_this.props.onRendered) {
        _this.props.onRendered();
      }

      if (_this.props.open) {
        _this.handleOpened();
      } else {
        (0, _manageAriaHidden.ariaHidden)(_this.modalRef, true);
      }
    };

    _this.handleOpened = function () {
      _this.autoFocus();

      _this.props.manager.mount((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this))); // Fix a bug on Chrome where the scroll isn't initially 0.


      _this.modalRef.scrollTop = 0;
    };

    _this.handleClose = function (reason) {
      var hasTransition = getHasTransition(_this.props);
      /* If the component does not have a transition or is unmounting remove the Modal
      otherwise let the transition handle removing the style, this prevents elements
      moving around when the Modal is closed. */

      if (!(hasTransition && _this.props.closeAfterTransition) || reason === 'unmount') {
        _this.props.manager.remove((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
      }

      var doc = (0, _ownerDocument.default)(_this.mountNode);
      doc.removeEventListener('focus', _this.enforceFocus, true);

      _this.restoreLastFocus();
    };

    _this.handleExited = function () {
      if (_this.props.closeAfterTransition) {
        _this.props.manager.remove((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
      }

      _this.setState({
        exited: true
      });
    };

    _this.handleBackdropClick = function (event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    _this.handleKeyDown = function (event) {
      // event.defaultPrevented:
      //
      // Ignore events that have been `event.preventDefault()` marked.
      // preventDefault() is meant to stop default behaviours like
      // clicking a checkbox to check it, hitting a button to submit a form,
      // and hitting left arrow to move the cursor in a text input etc.
      // Only special HTML elements have these default bahaviours.
      //
      // To remove in v4.
      if (event.key !== 'Escape' || !_this.isTopModal() || event.defaultPrevented) {
        return;
      } // Swallow the event, in case someone is listening for the escape key on the body.


      event.stopPropagation();

      if (_this.props.onEscapeKeyDown) {
        _this.props.onEscapeKeyDown(event);
      }

      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
        _this.props.onClose(event, 'escapeKeyDown');
      }
    };

    _this.enforceFocus = function () {
      // The Modal might not already be mounted.
      if (!_this.isTopModal() || _this.props.disableEnforceFocus || !_this.mounted || !_this.dialogRef) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(_this.mountNode).activeElement;

      if (!_this.dialogRef.contains(currentActiveElement)) {
        _this.dialogRef.focus();
      }
    };

    _this.handlePortalRef = function (ref) {
      _this.mountNode = ref ? ref.getMountNode() : ref;
    };

    _this.handleModalRef = function (ref) {
      _this.modalRef = ref;
    };

    _this.onRootRef = function (ref) {
      _this.dialogRef = ref;
    };

    _this.state = {
      exited: !props.open
    };
    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;

      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open && !this.props.open) {
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.lastFocus = (0, _ownerDocument.default)(this.mountNode).activeElement;
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
        this.handleClose('unmount');
      }
    }
  }, {
    key: "autoFocus",
    value: function autoFocus() {
      // We might render an empty child.
      if (this.props.disableAutoFocus || !this.dialogRef) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(this.mountNode).activeElement;

      if (!this.dialogRef.contains(currentActiveElement)) {
        if (!this.dialogRef.hasAttribute('tabIndex')) {
           false ? (0, _warning.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
          this.dialogRef.setAttribute('tabIndex', -1);
        }

        this.lastFocus = currentActiveElement;
        this.dialogRef.focus();
      }
    }
  }, {
    key: "restoreLastFocus",
    value: function restoreLastFocus() {
      if (this.props.disableRestoreFocus || !this.lastFocus) {
        return;
      } // Not all elements in IE 11 have a focus method.
      // Because IE 11 market share is low, we accept the restore focus being broken
      // and we silent the issue.


      if (this.lastFocus.focus) {
        this.lastFocus.focus();
      }

      this.lastFocus = null;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal() {
      return this.props.manager.isTopModal(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          BackdropComponent = _this$props.BackdropComponent,
          BackdropProps = _this$props.BackdropProps,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          closeAfterTransition = _this$props.closeAfterTransition,
          container = _this$props.container,
          disableAutoFocus = _this$props.disableAutoFocus,
          disableBackdropClick = _this$props.disableBackdropClick,
          disableEnforceFocus = _this$props.disableEnforceFocus,
          disableEscapeKeyDown = _this$props.disableEscapeKeyDown,
          disablePortal = _this$props.disablePortal,
          disableRestoreFocus = _this$props.disableRestoreFocus,
          hideBackdrop = _this$props.hideBackdrop,
          keepMounted = _this$props.keepMounted,
          manager = _this$props.manager,
          onBackdropClick = _this$props.onBackdropClick,
          onClose = _this$props.onClose,
          onEscapeKeyDown = _this$props.onEscapeKeyDown,
          onRendered = _this$props.onRendered,
          open = _this$props.open,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["BackdropComponent", "BackdropProps", "children", "classes", "className", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
      var exited = this.state.exited;
      var hasTransition = getHasTransition(this.props);

      if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
      }

      var childProps = {}; // It's a Transition like component

      if (hasTransition) {
        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
      }

      if (children.props.role === undefined) {
        childProps.role = children.props.role || 'document';
      }

      if (children.props.tabIndex === undefined) {
        childProps.tabIndex = children.props.tabIndex || '-1';
      }

      return _react.default.createElement(_Portal.default, {
        ref: this.handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        onRendered: this.handleRendered
      }, _react.default.createElement("div", (0, _extends2.default)({
        ref: this.handleModalRef,
        onKeyDown: this.handleKeyDown,
        role: "presentation",
        className: (0, _classnames.default)(classes.root, className, (0, _defineProperty2.default)({}, classes.hidden, exited))
      }, other), hideBackdrop ? null : _react.default.createElement(BackdropComponent, (0, _extends2.default)({
        open: open,
        onClick: this.handleBackdropClick
      }, BackdropProps)), _react.default.createElement(_RootRef.default, {
        rootRef: this.onRootRef
      }, _react.default.cloneElement(children, childProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      }

      if (!getHasTransition(nextProps)) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);
  return Modal;
}(_react.default.Component);

 false ? Modal.propTypes = {
  /**
   * A backdrop component. This property enables custom backdrop rendering.
   */
  BackdropComponent: _utils.componentPropType,

  /**
   * Properties applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: _propTypes.default.object,

  /**
   * A single child content element.
   */
  children: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   */
  closeAfterTransition: _propTypes.default.bool,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _propTypes.default.bool,

  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: _propTypes.default.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _propTypes.default.bool,

  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: _propTypes.default.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: _propTypes.default.bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: _propTypes.default.bool,

  /**
   * @ignore
   *
   * A modal manager used to track and manage the state of open
   * Modals. This enables customizing how modals interact within a container.
   */
  manager: _propTypes.default.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` property took effect.
   */
  onRendered: _propTypes.default.func,

  /**
   * If `true`, the modal is open.
   */
  open: _propTypes.default.bool.isRequired
} : void 0;
Modal.defaultProps = {
  BackdropComponent: _Backdrop.default,
  closeAfterTransition: false,
  disableAutoFocus: false,
  disableBackdropClick: false,
  disableEnforceFocus: false,
  disableEscapeKeyDown: false,
  disablePortal: false,
  disableRestoreFocus: false,
  hideBackdrop: false,
  keepMounted: false,
  // Modals don't open on the server so this won't conflict with concurrent requests.
  manager: new _ModalManager.default()
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiModal'
})(Modal);

exports.default = _default;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RootRef.default;
  }
});

var _RootRef = _interopRequireDefault(__webpack_require__(1056));

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(2));

var _createClass2 = _interopRequireDefault(__webpack_require__(3));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(5));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(4));

var _inherits2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(53));

var _propTypes = _interopRequireDefault(__webpack_require__(40));

var _utils = __webpack_require__(80);

var _reactHelpers = __webpack_require__(1057);

/**
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 *
 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * For example:
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * class MyComponent extends React.Component {
 *   constructor() {
 *     super();
 *     this.domRef = React.createRef();
 *   }
 *
 *   componentDidMount() {
 *     console.log(this.domRef.current); // DOM node
 *   }
 *
 *   render() {
 *     return (
 *       <RootRef rootRef={this.domRef}>
 *         <SomeChildComponent />
 *       </RootRef>
 *     );
 *   }
 * }
 * ```
 */
var RootRef =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RootRef, _React$Component);

  function RootRef() {
    (0, _classCallCheck2.default)(this, RootRef);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RootRef).apply(this, arguments));
  }

  (0, _createClass2.default)(RootRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ref = _reactDom.default.findDOMNode(this);
      (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var ref = _reactDom.default.findDOMNode(this);

      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
        if (prevProps.rootRef !== this.props.rootRef) {
          (0, _reactHelpers.setRef)(prevProps.rootRef, null);
        }

        this.ref = ref;
        (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.ref = null;
      (0, _reactHelpers.setRef)(this.props.rootRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return RootRef;
}(_react.default.Component);

 false ? RootRef.propTypes = {
  /**
   * The wrapped element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Provide a way to access the DOM node of the wrapped element.
   * You can provide a callback ref or a `React.createRef()` ref.
   */
  rootRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]).isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? RootRef.propTypes = (0, _utils.exactProp)(RootRef.propTypes) : void 0;
}

var _default = RootRef;
exports.default = _default;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElementWithClassName = cloneElementWithClassName;
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.setRef = setRef;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(125));

function cloneElementWithClassName(child, className) {
  return _react.default.cloneElement(child, {
    className: (0, _classnames.default)(child.props.className, className)
  });
}

function cloneChildrenWithClassName(children, className) {
  return _react.default.Children.map(children, function (child) {
    return _react.default.isValidElement(child) && cloneElementWithClassName(child, className);
  });
}

function isMuiElement(element, muiNames) {
  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Portal.default;
  }
});

var _Portal = _interopRequireDefault(__webpack_require__(1059));

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(2));

var _createClass2 = _interopRequireDefault(__webpack_require__(3));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(5));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(4));

var _inherits2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(53));

var _propTypes = _interopRequireDefault(__webpack_require__(40));

var _ownerDocument = _interopRequireDefault(__webpack_require__(146));

var _utils = __webpack_require__(80);

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument.default)(_reactDom.default.findDOMNode(element));
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */


var Portal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Portal, _React$Component);

  function Portal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getMountNode = function () {
      return _this.mountNode;
    };

    return _this;
  }

  (0, _createClass2.default)(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMountNode(this.props.container); // Only rerender if needed

      if (!this.props.disablePortal) {
        this.forceUpdate(this.props.onRendered);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.container !== this.props.container || prevProps.disablePortal !== this.props.disablePortal) {
        this.setMountNode(this.props.container); // Only rerender if needed

        if (!this.props.disablePortal) {
          this.forceUpdate(function () {
            if (_this2.props.onRendered) {
              // This might be triggered earlier than the componentDidUpdate of a parent element.
              // We need to account for it.
              clearTimeout(_this2.renderedTimer);
              _this2.renderedTimer = setTimeout(_this2.props.onRendered);
            }
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mountNode = null;
      clearTimeout(this.renderedTimer);
    }
  }, {
    key: "setMountNode",
    value: function setMountNode(container) {
      if (this.props.disablePortal) {
        this.mountNode = _reactDom.default.findDOMNode(this).parentElement;
        return;
      }

      this.mountNode = getContainer(container, getOwnerDocument(this).body);
    }
    /**
     * @public
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disablePortal = _this$props.disablePortal;

      if (disablePortal) {
        return children;
      }

      return this.mountNode ? _reactDom.default.createPortal(children, this.mountNode) : null;
    }
  }]);
  return Portal;
}(_react.default.Component);

 false ? Portal.propTypes = {
  /**
   * The children to render into the `container`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   */
  onRendered: _propTypes.default.func
} : void 0;
Portal.defaultProps = {
  disablePortal: false
};

if (false) {
  process.env.NODE_ENV !== "production" ? Portal.propTypes = (0, _utils.exactProp)(Portal.propTypes) : void 0;
}

var _default = Portal;
exports.default = _default;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(449));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1062));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1064));

var _removeStyle = _interopRequireDefault(__webpack_require__(1065));

var _properties = __webpack_require__(1066);

var _isTransform = _interopRequireDefault(__webpack_require__(1067));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(1063));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(449));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(450));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(450));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBody = isBody;
exports.default = isOverflowing;

var _isWindow = _interopRequireDefault(__webpack_require__(1070));

var _ownerDocument = _interopRequireDefault(__webpack_require__(146));

var _ownerWindow = _interopRequireDefault(__webpack_require__(304));

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
} // Do we have a vertical scroll bar?


function isOverflowing(container) {
  var doc = (0, _ownerDocument.default)(container);
  var win = (0, _ownerWindow.default)(doc);
  /* istanbul ignore next */

  if (!(0, _isWindow.default)(doc) && !isBody(container)) {
    return container.scrollHeight > container.clientHeight;
  } // Takes in account potential non zero margin on the body.


  var style = win.getComputedStyle(doc.body);
  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
}

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Backdrop.default;
  }
});

var _Backdrop = _interopRequireDefault(__webpack_require__(1072));

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(40));

var _classnames = _interopRequireDefault(__webpack_require__(125));

var _withStyles = _interopRequireDefault(__webpack_require__(126));

var _Fade = _interopRequireDefault(__webpack_require__(1073));

var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    // Disable scroll capabilities.
    touchAction: 'none'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
exports.styles = styles;

function Backdrop(props) {
  var classes = props.classes,
      className = props.className,
      invisible = props.invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "invisible", "open", "transitionDuration"]);
  return _react.default.createElement(_Fade.default, (0, _extends2.default)({
    in: open,
    timeout: transitionDuration
  }, other), _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.invisible, invisible), className),
    "aria-hidden": "true"
  }));
}

 false ? Backdrop.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : void 0;
Backdrop.defaultProps = {
  invisible: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBackdrop'
})(Backdrop);

exports.default = _default;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fade.default;
  }
});

var _Fade = _interopRequireDefault(__webpack_require__(1074));

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(2));

var _createClass2 = _interopRequireDefault(__webpack_require__(3));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(5));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(4));

var _inherits2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(40));

var _Transition = _interopRequireDefault(__webpack_require__(305));

var _transitions = __webpack_require__(205);

var _withTheme = _interopRequireDefault(__webpack_require__(274));

var _utils = __webpack_require__(452);

// @inheritedComponent Transition
var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
/**
 * The Fade transition is used by the [Modal](/utils/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Fade, _React$Component);

  function Fade() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Fade);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Fade)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleEnter = function (node) {
      var theme = _this.props.theme;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Fade, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onEnter = _this$props.onEnter,
          onExit = _this$props.onExit,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onExit", "style", "theme"]);
      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            opacity: 0
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Fade;
}(_react.default.Component);

 false ? Fade.propTypes = {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : void 0;
Fade.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Fade);

exports.default = _default;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(40));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Slide.default;
  }
});

var _Slide = _interopRequireDefault(__webpack_require__(1077));

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTranslateValue = setTranslateValue;
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(2));

var _createClass2 = _interopRequireDefault(__webpack_require__(3));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(5));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(4));

var _inherits2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(40));

var _reactDom = _interopRequireDefault(__webpack_require__(53));

var _reactEventListener = _interopRequireDefault(__webpack_require__(1078));

var _debounce = _interopRequireDefault(__webpack_require__(1079));

var _Transition = _interopRequireDefault(__webpack_require__(305));

var _ownerWindow = _interopRequireDefault(__webpack_require__(304));

var _withTheme = _interopRequireDefault(__webpack_require__(274));

var _transitions = __webpack_require__(205);

var _utils = __webpack_require__(452);

// @inheritedComponent Transition
// < 1kb payload overhead when lodash/debounce is > 3kb.
var GUTTER = 24; // Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `translate3d(0, 0, 0)`.`

function getTranslateValue(props, node) {
  var direction = props.direction;
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = (0, _ownerWindow.default)(node).getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(100vw) translateX(-".concat(rect.left - offsetX, "px)");
  }

  if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width + GUTTER - offsetX, "px)");
  }

  if (direction === 'up') {
    return "translateY(100vh) translateY(-".concat(rect.top - offsetY, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height + GUTTER - offsetY, "px)");
}

function setTranslateValue(props, node) {
  var transform = getTranslateValue(props, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
/**
 * The Slide transition is used by the [Snackbar](/demos/snackbars/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */


var Slide =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Slide, _React$Component);

  function Slide() {
    var _this;

    (0, _classCallCheck2.default)(this, Slide);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Slide).call(this));
    _this.mounted = false;

    _this.handleEnter = function (node) {
      setTranslateValue(_this.props, node);
      (0, _utils.reflow)(node);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleEntering = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.webkitTransform = 'translate(0, 0)';
      node.style.transform = 'translate(0, 0)';

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      setTranslateValue(_this.props, node);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.handleExited = function (node) {
      // No need for transitions when the component is hidden
      node.style.webkitTransition = '';
      node.style.transition = '';

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    if (typeof window !== 'undefined') {
      _this.handleResize = (0, _debounce.default)(function () {
        // Skip configuration where the position is screen size invariant.
        if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
          return;
        }

        if (_this.transitionRef) {
          setTranslateValue(_this.props, _this.transitionRef);
        }
      }, 166); // Corresponds to 10 frames at 60 Hz.
    }

    return _this;
  }

  (0, _createClass2.default)(Slide, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true; // state.mounted handle SSR, once the component is mounted, we need
      // to properly hide it.

      if (!this.props.in) {
        // We need to set initial translate values of transition element
        // otherwise component will be shown when in=false.
        this.updatePosition();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.direction !== this.props.direction && !this.props.in) {
        // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        this.updatePosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (this.transitionRef) {
        this.transitionRef.style.visibility = 'inherit';
        setTranslateValue(this.props, this.transitionRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          direction = _this$props.direction,
          onEnter = _this$props.onEnter,
          onEntering = _this$props.onEntering,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "direction", "onEnter", "onEntering", "onExit", "onExited", "style", "theme"]);
      var style = {}; // We use this state to handle the server-side rendering.
      // We don't know the width of the children ahead of time.
      // We need to render it.

      if (!this.props.in && !this.mounted) {
        style.visibility = 'hidden';
      }

      style = (0, _extends2.default)({}, style, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }, _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onExit: this.handleExit,
        onExited: this.handleExited,
        appear: true,
        style: style,
        ref: function ref(_ref) {
          _this2.transitionRef = _reactDom.default.findDOMNode(_ref);
        }
      }, other), children));
    }
  }]);
  return Slide;
}(_react.default.Component);

 false ? Slide.propTypes = {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * Direction the child node will enter from.
   */
  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntering: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  onExited: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : void 0;
Slide.defaultProps = {
  direction: 'down',
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Slide);

exports.default = _default;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(__webpack_require__(2));
var _createClass = _interopDefault(__webpack_require__(3));
var _possibleConstructorReturn = _interopDefault(__webpack_require__(5));
var _getPrototypeOf = _interopDefault(__webpack_require__(4));
var _inherits = _interopDefault(__webpack_require__(6));
var _typeof = _interopDefault(__webpack_require__(66));
var _objectWithoutProperties = _interopDefault(__webpack_require__(20));
var _extends = _interopDefault(__webpack_require__(14));
var React = _interopDefault(__webpack_require__(0));
var PropTypes = _interopDefault(__webpack_require__(40));
var warning = _interopDefault(__webpack_require__(49));

function defineProperty(object, property, attr) {
  return Object.defineProperty(object, property, attr);
} // Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js


var passiveOption = function () {
  var cache = null;
  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {//
    }

    cache = supportsPassiveOption;
    return supportsPassiveOption;
  }();
}();

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return _extends({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = _objectWithoutProperties(props, ["children", "target"]);

  Object.keys(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];

    var type = _typeof(prop);

    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({
        capture: capture
      }));
    }
  });
}

function withOptions(handler, options) {
   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EventListener, _React$PureComponent);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyListeners(on);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.applyListeners(off, prevProps);
      this.applyListeners(on);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.applyListeners(off);
    }
  }, {
    key: "applyListeners",
    value: function applyListeners(onOrOff) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var target = props.target;

      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(React.PureComponent);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: PropTypes.node,

  /**
   * The DOM target to listen to.
   */
  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
} : {};

exports.withOptions = withOptions;
exports.default = EventListener;


/***/ }),
/* 1079 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__(1081));

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(40));

var _classnames = _interopRequireDefault(__webpack_require__(125));

var _warning = _interopRequireDefault(__webpack_require__(49));

var _utils = __webpack_require__(80);

var _withStyles = _interopRequireDefault(__webpack_require__(126));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

 false ? Paper.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : void 0;
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MainMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_Badge__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_ItemList__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nx_components_RichLabel__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nx_components_Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_app_state__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_BrandLogo_MainMenuBrandLogo__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_BrandLogo_PivotMainMenuBrandLogo__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nx_components_ScrollableDiv__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_models_session__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_components_Routing_HistoryPageTransitionController__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_prop_types__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }























var MainMenuWithoutColor = function MainMenuWithoutColor(props) {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_21_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.MainMenuWithoutColor;
  var onItemSelected = props.onItemSelected,
      itemIsSelected = props.itemIsSelected,
      showAlertsBadge = props.showAlertsBadge,
      session = props.session,
      appState = props.appState,
      colors = props.colors;
  var styles = {
    item: {
      padding: "0 1em",
      cursor: "pointer"
    },
    disabledItem: {
      opacity: "0.25"
    },
    buttonGroup: {
      padding: "1em"
    },
    button: {
      marginBottom: "0.5em"
    },
    iconStyle: {
      fontSize: "1em"
    },
    badgeStyle: {
      width: "12px",
      height: "12px",
      backgroundColor: colors.RED
    },
    badgeWrapper: {
      position: "relative"
    },
    uaText: {
      fontSize: "0.7em",
      paddingTop: "1em",
      paddingLeft: "2em",
      paddingRight: "2em"
    },
    uaTextBold: {
      fontWeight: "bold"
    }
  };
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_BackboneListener__["a" /* default */], {
    listenTo: session,
    events: ["change"]
  }, function () {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_BackboneListener__["a" /* default */], {
      listenTo: appState,
      events: ["change:inDemoMode", "change:currentLocation"]
    }, function () {
      var hasAlerts = session.hasAlerts;
      var isActivatedByActivationCode = session.get("isActivatedByActivationCode");
      var inDemoMode = appState.inDemoMode;
      var isCommercial = __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_environment__["a" /* default */].isCommercial();
      var authPinUser = __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_local_settings__["c" /* default */].isEnabledByAuthPin();
      var isAtBuildingDashboard = appState.currentLocation === null;
      var hasMultipleLocations = session.hasMultipleLocations();

      var isEventItemSelected = function isEventItemSelected() {
        return isAtBuildingDashboard ? false : itemIsSelected("events");
      };

      var isEventItemDisabled = function isEventItemDisabled() {
        return isAtBuildingDashboard;
      };

      var alertIcon;

      if (showAlertsBadge) {
        alertIcon = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
          style: styles.badgeWrapper
        }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_nx_components_Icons__["_58" /* IconWarning */], null), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nx_components_Badge__["a" /* default */], {
          style: styles.badgeStyle
        }));
      } else {
        alertIcon = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_nx_components_Icons__["_58" /* IconWarning */], null);
      }

      var items = [{
        id: "home",
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_nx_components_Icons__["S" /* IconGrid */], null),
        label: language.dashboardLabel,
        selected: itemIsSelected("home"),
        onTap: function onTap() {
          if (hasMultipleLocations) {
            appState.resetCurrentLocation();
          }

          if (!itemIsSelected("home")) {
            Object(__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app/home");
          }

          onItemSelected();
        }
      }];
      items.push({
        id: "alerts",
        icon: alertIcon,
        label: language.alertsLabel,
        selected: itemIsSelected("alerts"),
        onTap: function onTap() {
          if (!itemIsSelected("alerts")) {
            Object(__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app/alerts");
          }

          onItemSelected();
        }
      });
      items.push({
        id: "events",
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_nx_components_Icons__["_4" /* IconListUl */], null),
        label: language.eventsLabel,
        selected: isEventItemSelected(),
        style: isAtBuildingDashboard ? styles.disabledItem : null,
        onTap: function onTap() {
          if (isAtBuildingDashboard) {
            return;
          }

          if (!itemIsSelected("events")) {
            Object(__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app/events");
          }

          onItemSelected();
        },
        noActiveStyle: isEventItemDisabled()
      });

      if (!authPinUser && !inDemoMode) {
        items.push({
          id: "users",
          icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_nx_components_Icons__["_50" /* IconUser */], null),
          label: language.usersLabel,
          selected: itemIsSelected("users"),
          onTap: function onTap() {
            onItemSelected();

            if (itemIsSelected("users")) {
              return;
            }

            if (isActivatedByActivationCode != null) {
              Object(__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app/phones");
            } else {
              // A commercial account with isActivatedByActivationCode as either null or 1
              __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_history__["d" /* history */].push("/reauth", {
                authenticationParams: {
                  authenticationFor: "users"
                },
                prompt: language.usernamePasswordPrompt,
                title: language.manageUsersTitle,
                onUserAuthenticated: function onUserAuthenticated() {
                  // rather than fetch the session, manually set the expected result to avoid side effects
                  session.set("isActivatedByActivationCode", 0);
                  Object(__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app/phones");
                }
              });
            }
          }
        });
        items.push({
          id: "managebuilding",
          icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_nx_components_Icons__["j" /* IconBuilding */], null),
          label: language.buildingConfigurationLabel,
          selected: itemIsSelected("managebuilding"),
          onTap: function onTap() {
            onItemSelected();

            if (itemIsSelected("managebuilding")) {
              return;
            }

            Object(__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app/buildings");
          }
        });
      }

      if (inDemoMode) {
        items.push({
          id: "exit-demo",
          icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_nx_components_Icons__["N" /* IconExit */], null),
          label: language.exitDemoLabel,
          selected: itemIsSelected("exit-demo"),
          onTap: function onTap() {
            Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_LOG_OUT");
            onItemSelected();
          }
        });
      }

      if (!inDemoMode) {
        items.push({
          id: "settings",
          icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_nx_components_Icons__["_31" /* IconSettings */], null),
          label: language.appSettingsLabel,
          selected: itemIsSelected("settings"),
          onTap: function onTap() {
            if (!itemIsSelected("settings")) {
              Object(__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app/settings");
            }

            onItemSelected();
          }
        }, {
          id: "support",
          icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_nx_components_Icons__["_39" /* IconSupport */], null),
          label: language.supportAndFeedbackLabel,
          selected: itemIsSelected("support"),
          onTap: function onTap() {
            if (!itemIsSelected("support")) {
              Object(__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app/support");
            }

            onItemSelected();
          }
        });
      }

      items = items.map(function (item) {
        return {
          id: item.id,
          label: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_nx_components_RichLabel__["a" /* default */], {
            label: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, item.label),
            icon: item.icon,
            iconStyle: styles.iconStyle
          }),
          selected: item.selected,
          style: _objectSpread({}, styles.item, {}, item.style ? item.style : null),
          onTap: item.onTap,
          activeStyle: item.noActiveStyle ? undefined : {
            color: colors.PRIMARY
          },
          holdActiveUntil: __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_components_Routing_HistoryPageTransitionController__["a" /* getTransitionPromise */]
        };
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_nx_components_ScrollableDiv__["a" /* default */], {
        elementType: "nav",
        "data-component-name": "MainMenu" // This gets focused by DrawerRevealer
        ,
        tabIndex: "-1",
        style: {
          paddingTop: __WEBPACK_IMPORTED_MODULE_7_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_TOP,
          paddingLeft: __WEBPACK_IMPORTED_MODULE_7_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_LEFT,
          paddingBottom: __WEBPACK_IMPORTED_MODULE_7_nx_components_Theme__["a" /* default */].Padding.SAFE_AREA_BOTTOM
        }
      }, isCommercial ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_BrandLogo_PivotMainMenuBrandLogo__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_BrandLogo_MainMenuBrandLogo__["a" /* default */], null), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_nx_components_ItemList__["c" /* default */], {
        id: "menu-items",
        items: items
      }), inDemoMode ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, isAtBuildingDashboard ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        style: styles.uaText
      }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
        style: styles.uaTextBold
      }, "".concat(language.note, ": ")), language.selectBuldingToEnable)) : null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        style: styles.buttonGroup
      }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
        theme: "outline",
        disabled: isAtBuildingDashboard,
        style: styles.button,
        full: true,
        onTap: function onTap() {
          Object(__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app/groups/add");
          onItemSelected();
        }
      }, language.createGroupButton), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
        theme: "outline",
        disabled: isAtBuildingDashboard,
        style: styles.button,
        full: true,
        onTap: function onTap() {
          Object(__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app/devices/add");
          onItemSelected();
        }
      }, language.enrollNewDeviceButton))));
    });
  });
};

MainMenuWithoutColor.propTypes = {
  onItemSelected: __WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func.isRequired,
  itemIsSelected: __WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func.isRequired,
  showAlertsBadge: __WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.bool,
  session: function session() {
    return (typeof __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_models_session__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_18_nexia_mobile_models_session__["a" /* default */]).isRequired : __WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  appState: function appState() {
    return (typeof __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_app_state__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_app_state__["a" /* default */]).isRequired : __WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
};
var MainMenu = Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_ColorsProvider__["c" /* withColorsProvider */])(MainMenuWithoutColor);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  showAlertsBadge: "showAlertsBadge",
  session: "session",
  appState: "appState"
}, MainMenu));


/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_DarkModeInverter__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_styl_images_nexia_logo_svg__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_styl_images_nexia_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_styl_images_nexia_logo_svg__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var styles = {
  offcanvasLogo: {
    textAlign: "center",
    paddingTop: ".5em"
  },
  backgroundStyle: {
    display: "inline-block",
    backgroundSize: "100%",
    backgroundRepeat: "no-repeat",
    backgroundImage: "url(".concat(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_styl_images_nexia_logo_svg___default.a, ")"),
    width: "8em",
    height: "3.5em"
  }
};

var MainMenuBrandLogo = function MainMenuBrandLogo() {
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_DarkModeInverter__["a" /* default */], null, function (_ref) {
    var maybeInvert = _ref.maybeInvert;
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
      style: styles.offcanvasLogo
    }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
      "data-component-name": "MainMenuBrandLogo",
      style: _objectSpread({}, styles.backgroundStyle, {}, maybeInvert)
    }));
  });
};

/* harmony default export */ __webpack_exports__["a"] = (MainMenuBrandLogo);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_DarkModeInverter__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_styl_images_trane_commercial_logo_svg__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_styl_images_trane_commercial_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_styl_images_trane_commercial_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_styl_images_amstd_commercial_zoom_logo_svg__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_styl_images_amstd_commercial_zoom_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_styl_images_amstd_commercial_zoom_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_styl_images_pivot_logo_svg__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_styl_images_pivot_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_styl_images_pivot_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nx_components_Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_utils_prefixStyles__ = __webpack_require__(9);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var isTrane = __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_environment__["a" /* default */].isTraneCommercial();
var styles = Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_utils_prefixStyles__["b" /* default */])({
  backgroundStyle: {
    display: "inline-block",
    backgroundSize: "100%",
    backgroundRepeat: "no-repeat"
  },
  commercialDiv: {
    flex: "1 1 auto",
    display: "flex",
    alignItems: "center",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center"
  },
  commercialSpanHorizontal: {
    marginRight: "0.5em"
  }
});

var PivotMainMenuBrandLogo = function PivotMainMenuBrandLogo() {
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_DarkModeInverter__["a" /* default */], null, function (_ref) {
    var maybeInvert = _ref.maybeInvert;
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
      "data-component-name": "PivotMainMenuBrandLogo",
      style: _objectSpread({}, maybeInvert, {}, styles.commercialDiv)
    }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
      style: {
        display: "flex",
        backgroundColor: "#60ae33",
        width: "100%",
        height: "3.2em",
        alignItems: "center",
        justifyContent: "center"
      }
    }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
      style: _objectSpread({}, styles.backgroundStyle, {
        backgroundImage: "url(".concat(isTrane ? __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_styl_images_trane_commercial_logo_svg___default.a : __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_styl_images_amstd_commercial_zoom_logo_svg___default.a, ")"),
        width: isTrane ? "6em" : "12em",
        height: "100%",
        backgroundPositionY: "center"
      })
    })), __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
      style: _objectSpread({}, __WEBPACK_IMPORTED_MODULE_7_nx_components_Theme__["a" /* default */].Styles.flexLayout, {
        backgroundColor: "#34505f",
        width: "100%",
        height: "3em",
        justifyContent: "center"
      })
    }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
      style: _objectSpread({}, styles.commercialSpanHorizontal, {
        color: "white"
      })
    }, "PIVOT"), __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
      style: _objectSpread({}, styles.backgroundStyle, {
        backgroundImage: "url(".concat(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_styl_images_pivot_logo_svg___default.a, ")"),
        width: "2em",
        height: "2em"
      })
    })));
  });
};

/* harmony default export */ __webpack_exports__["a"] = (PivotMainMenuBrandLogo);

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/amstd_commercial_zoom_logo-44729d32-pivot.svg";

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nx_components_MountOnBody__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_SpinnerOverlay__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Pages_BuildingDashboardPage__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Pages_DashboardPage__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_app_state__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_session__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);











var HomePage = function HomePage(props) {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.pages.HomePage;
  var appState = props.appState,
      session = props.session,
      showDeviceAdd = props.showDeviceAdd;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_BackboneListener__["a" /* default */], {
    listenTo: session,
    events: ["change:locations"]
  }, function () {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_BackboneListener__["a" /* default */], {
      listenTo: appState,
      events: ["change:currentLocation"]
    }, function () {
      if (!appState.currentLocation && session.get("locations") && session.get("locations").length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Pages_BuildingDashboardPage__["a" /* default */], {
          session: session,
          showDeviceAdd: showDeviceAdd
        });
      } else if (appState.currentLocation && session.get("locations") && session.get("locations").length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Pages_DashboardPage__["a" /* default */], {
          locations: session.get("locations"),
          currentLocation: appState.currentLocation,
          showDeviceAdd: showDeviceAdd
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_nx_components_MountOnBody__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_SpinnerOverlay__["a" /* default */], {
          message: language.loadingBuilding
        }));
      }
    });
  });
};

HomePage.propTypes = {
  appState: function appState() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_app_state__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_app_state__["a" /* default */]).isRequired : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  session: function session() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_session__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_session__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.any).apply(this, arguments);
  },
  showDeviceAdd: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  appState: "appState",
  session: "session"
}, HomePage));


/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_framework_collection__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_TopBar_AppBarWrapper__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_TopBar_CommonAppBarContainer__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Commercial_NoDevicesPageCommercial__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Details_DeviceDetails__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_Pages_DashboardTilesPage__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_device_sorter__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_session__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);












var BuildingDashboardPage = function BuildingDashboardPage(props) {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_10_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.pages.BuildingDashboardPage;
  var tileItemsRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();

  var loadBuildingTileItems = function loadBuildingTileItems(locations) {
    var models = [];
    locations.each(function (location) {
      location.allowDeviceListingView();
      return models.push(location);
    });
    var sortedModels = __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_device_sorter__["a" /* default */].sort(models);

    if (tileItemsRef.current) {
      tileItemsRef.current.set(sortedModels);
    } else {
      tileItemsRef.current = new __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_framework_collection__["a" /* default */](sortedModels);
    }

    return tileItemsRef.current;
  };

  var loadDeviceTileItems = function loadDeviceTileItems(location) {
    var devices = location.get("devices");
    var models = [];
    devices.each(function (device) {
      return models.push(device);
    });
    var sortedModels = __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_models_device_sorter__["a" /* default */].sort(models);

    if (tileItemsRef.current) {
      tileItemsRef.current.set(sortedModels);
    } else {
      tileItemsRef.current = new __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_framework_collection__["a" /* default */](sortedModels);
    }

    return tileItemsRef.current;
  };

  var session = props.session,
      showDeviceAdd = props.showDeviceAdd;
  var locationAppBar = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_TopBar_AppBarWrapper__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_TopBar_CommonAppBarContainer__["a" /* default */], {
    title: language.title
  }));
  var locations = session.get("locations");
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_BackboneListener__["a" /* default */], {
    listenTo: session,
    events: ["change:locations"]
  }, function () {
    var firstLocation = locations.first(); // If location is not present it is covered in Home Page
    // A SpinnerOverlay will be shown

    if (locations.length === 1) {
      var tileItems = loadDeviceTileItems(firstLocation);

      if (tileItems.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Commercial_NoDevicesPageCommercial__["a" /* default */], {
          appBar: locationAppBar,
          showDeviceAdd: showDeviceAdd,
          title: language.noDevicesTitle
        });
      } else if (tileItems.length === 1) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Details_DeviceDetails__["a" /* default */], {
          model: tileItems.first(),
          appBar: locationAppBar,
          isDashboard: true
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_Pages_DashboardTilesPage__["a" /* default */], {
          appBar: locationAppBar,
          location: firstLocation,
          tileItems: tileItems
        });
      }
    } else {
      var _tileItems = loadBuildingTileItems(locations);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_Pages_DashboardTilesPage__["a" /* default */], {
        appBar: locationAppBar,
        location: firstLocation,
        tileItems: _tileItems
      });
    }
  });
};

BuildingDashboardPage.propTypes = {
  session: function session() {
    return (typeof __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_session__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_models_session__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.any).apply(this, arguments);
  },
  showDeviceAdd: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (BuildingDashboardPage);


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _LinearProgress.default;
  }
});

var _LinearProgress = _interopRequireDefault(__webpack_require__(1089));

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(16);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(14));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(1));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(20));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(40));

var _classnames = _interopRequireDefault(__webpack_require__(125));

var _warning = _interopRequireDefault(__webpack_require__(49));

var _withStyles = _interopRequireDefault(__webpack_require__(126));

var _colorManipulator = __webpack_require__(302);

var TRANSITION_DURATION = 4; // seconds

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 4
    },

    /* Styles applied to the root & bar2 element if `color="primary"`; bar2 if `variant-"buffer"`. */
    colorPrimary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
    },
    // eslint-disable-next-line max-len

    /* Styles applied to the root & bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
    colorSecondary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {},

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {},

    /* Styles applied to the root element if `variant="buffer"`. */
    buffer: {
      backgroundColor: 'transparent'
    },

    /* Styles applied to the root element if `variant="query"`. */
    query: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the additional bar element if `variant="buffer"`. */
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: 'buffer 3s infinite linear',
      // Backward compatible logic between JSS v9 and v10.
      // To remove with the release of Material-UI v4
      animationName: '$buffer'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` & `color="primary"`. */
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` & `color="secondary"`. */
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6), " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },

    /* Styles applied to the layered bar1 & bar2 elements. */
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },

    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },

    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
    bar1Indeterminate: {
      width: 'auto',
      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite',
      // Backward compatible logic between JSS v9 and v10.
      // To remove with the release of Material-UI v4
      animationName: '$mui-indeterminate1'
    },

    /* Styles applied to the bar1 element if `variant="determinate"`. */
    bar1Determinate: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar1 element if `variant="buffer"`. */
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
    bar2Indeterminate: {
      width: 'auto',
      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
      // Backward compatible logic between JSS v9 and v10.
      // To remove with the release of Material-UI v4
      animationName: '$mui-indeterminate2',
      animationDelay: '1.15s'
    },

    /* Styles applied to the bar2 element if `variant="buffer"`. */
    bar2Buffer: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes mui-indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes mui-indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0px -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0px -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */


exports.styles = styles;

function LinearProgress(props) {
  var _classNames, _classNames2, _classNames3, _classNames4;

  var classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.colorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.colorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames, classes.indeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames, classes.buffer, variant === 'buffer'), (0, _defineProperty2.default)(_classNames, classes.query, variant === 'query'), _classNames), classNameProp);
  var dashedClass = (0, _classnames.default)(classes.dashed, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.dashedColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames2, classes.dashedColorSecondary, color === 'secondary'), _classNames2));
  var bar1ClassName = (0, _classnames.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.barColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames3, classes.barColorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames3, classes.bar1Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames3, classes.bar1Determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames3, classes.bar1Buffer, variant === 'buffer'), _classNames3));
  var bar2ClassName = (0, _classnames.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty2.default)(_classNames4, classes.barColorPrimary, color === 'primary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorPrimary, color === 'primary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.barColorSecondary, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorSecondary, color === 'secondary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.bar2Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames4, classes.bar2Buffer, variant === 'buffer'), _classNames4));
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      inlineStyles.bar1.transform = "scaleX(".concat(value / 100, ")");
    } else {
       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
    }
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      inlineStyles.bar2.transform = "scaleX(".concat((valueBuffer || 0) / 100, ")");
    } else {
       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
    }
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: className,
    role: "progressbar"
  }, rootProps, other), variant === 'buffer' ? _react.default.createElement("div", {
    className: dashedClass
  }) : null, _react.default.createElement("div", {
    className: bar1ClassName,
    style: inlineStyles.bar1
  }), variant === 'determinate' ? null : _react.default.createElement("div", {
    className: bar2ClassName,
    style: inlineStyles.bar2
  }));
}

 false ? LinearProgress.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),

  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: _propTypes.default.number,

  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: _propTypes.default.number,

  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   */
  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
} : void 0;
LinearProgress.defaultProps = {
  color: 'primary',
  variant: 'indeterminate'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiLinearProgress'
})(LinearProgress);

exports.default = _default;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(40);

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];

function isWebpackReady(getModuleIds) {
  if (( false ? "undefined" : _typeof(__webpack_require__.m)) !== "object") {
    return false;
  }

  return getModuleIds().every(function (moduleId) {
    return typeof moduleId !== "undefined" && typeof __webpack_require__.m[moduleId] !== "undefined";
  });
}

function load(loader) {
  var promise = loader();

  var state = {
    loading: true,
    loaded: null,
    error: null
  };

  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });

  return state;
}

function loadMap(obj) {
  var state = {
    loading: false,
    loaded: {},
    error: null
  };

  var promises = [];

  try {
    Object.keys(obj).forEach(function (key) {
      var result = load(obj[key]);

      if (!result.loading) {
        state.loaded[key] = result.loaded;
        state.error = result.error;
      } else {
        state.loading = true;
      }

      promises.push(result.promise);

      result.promise.then(function (res) {
        state.loaded[key] = res;
      }).catch(function (err) {
        state.error = err;
      });
    });
  } catch (err) {
    state.error = err;
  }

  state.promise = Promise.all(promises).then(function (res) {
    state.loading = false;
    return res;
  }).catch(function (err) {
    state.loading = false;
    throw err;
  });

  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function render(loaded, props) {
  return React.createElement(resolve(loaded), props);
}

function createLoadableComponent(loadFn, options) {
  var _class, _temp;

  if (!options.loading) {
    throw new Error("react-loadable requires a `loading` component");
  }

  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    render: render,
    webpack: null,
    modules: null
  }, options);

  var res = null;

  function init() {
    if (!res) {
      res = loadFn(opts.loader);
    }
    return res.promise;
  }

  ALL_INITIALIZERS.push(init);

  if (typeof opts.webpack === "function") {
    READY_INITIALIZERS.push(function () {
      if (isWebpackReady(opts.webpack)) {
        return init();
      }
    });
  }

  return _temp = _class = function (_React$Component) {
    _inherits(LoadableComponent, _React$Component);

    function LoadableComponent(props) {
      _classCallCheck(this, LoadableComponent);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      _this.retry = function () {
        _this.setState({ error: null, loading: true, timedOut: false });
        res = loadFn(opts.loader);
        _this._loadModule();
      };

      init();

      _this.state = {
        error: res.error,
        pastDelay: false,
        timedOut: false,
        loading: res.loading,
        loaded: res.loaded
      };
      return _this;
    }

    LoadableComponent.preload = function preload() {
      return init();
    };

    LoadableComponent.prototype.componentWillMount = function componentWillMount() {
      this._mounted = true;
      this._loadModule();
    };

    LoadableComponent.prototype._loadModule = function _loadModule() {
      var _this2 = this;

      if (this.context.loadable && Array.isArray(opts.modules)) {
        opts.modules.forEach(function (moduleName) {
          _this2.context.loadable.report(moduleName);
        });
      }

      if (!res.loading) {
        return;
      }

      if (typeof opts.delay === "number") {
        if (opts.delay === 0) {
          this.setState({ pastDelay: true });
        } else {
          this._delay = setTimeout(function () {
            _this2.setState({ pastDelay: true });
          }, opts.delay);
        }
      }

      if (typeof opts.timeout === "number") {
        this._timeout = setTimeout(function () {
          _this2.setState({ timedOut: true });
        }, opts.timeout);
      }

      var update = function update() {
        if (!_this2._mounted) {
          return;
        }

        _this2.setState({
          error: res.error,
          loaded: res.loaded,
          loading: res.loading
        });

        _this2._clearTimeouts();
      };

      res.promise.then(function () {
        update();
      }).catch(function (err) {
        update();
      });
    };

    LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this._mounted = false;
      this._clearTimeouts();
    };

    LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    };

    LoadableComponent.prototype.render = function render() {
      if (this.state.loading || this.state.error) {
        return React.createElement(opts.loading, {
          isLoading: this.state.loading,
          pastDelay: this.state.pastDelay,
          timedOut: this.state.timedOut,
          error: this.state.error,
          retry: this.retry
        });
      } else if (this.state.loaded) {
        return opts.render(this.state.loaded, this.props);
      } else {
        return null;
      }
    };

    return LoadableComponent;
  }(React.Component), _class.contextTypes = {
    loadable: PropTypes.shape({
      report: PropTypes.func.isRequired
    })
  }, _temp;
}

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function LoadableMap(opts) {
  if (typeof opts.render !== "function") {
    throw new Error("LoadableMap requires a `render(loaded, props)` function");
  }

  return createLoadableComponent(loadMap, opts);
}

Loadable.Map = LoadableMap;

var Capture = function (_React$Component2) {
  _inherits(Capture, _React$Component2);

  function Capture() {
    _classCallCheck(this, Capture);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Capture.prototype.getChildContext = function getChildContext() {
    return {
      loadable: {
        report: this.props.report
      }
    };
  };

  Capture.prototype.render = function render() {
    return React.Children.only(this.props.children);
  };

  return Capture;
}(React.Component);

Capture.propTypes = {
  report: PropTypes.func.isRequired
};
Capture.childContextTypes = {
  loadable: PropTypes.shape({
    report: PropTypes.func.isRequired
  }).isRequired
};


Loadable.Capture = Capture;

function flushInitializers(initializers) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init());
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolve, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolve, reject);
  });
};

Loadable.preloadReady = function () {
  return new Promise(function (resolve, reject) {
    // We always will resolve, errors should be handled within loading UIs.
    flushInitializers(READY_INITIALIZERS).then(resolve, resolve);
  });
};

module.exports = Loadable;

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_GlobalStyleSheet__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Tiles_tileLegacyStyles__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Tiles_DeviceTile__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_Tiles_AutomationTile__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Tiles_PhoneTile__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_Tiles_BuildingTile__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_components_Tiles_BuildingInfoTile__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_ErrorHandler__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_models_automation__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_models_device__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_models_phone__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_nexia_mobile_models_location__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_nexia_mobile_components_DrawUpdates__ = __webpack_require__(152);
























var tileStyles = {
  contents: Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__["b" /* default */])({
    position: "absolute",
    top: "0.125em",
    left: "0.125em",
    bottom: "0.125em",
    right: "0.125em",
    textAlign: "center",
    background: "#fff",
    color: "#808080",
    overflow: "hidden",
    border: "1px solid #d0d0d0",
    borderRadius: "2px",
    transformStyle: "preserve-3d"
  }),
  icon: {
    fontSize: "2.5em"
  },
  title: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    padding: "0.5em",
    fontSize: "0.85em"
  },
  status: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#808080",
    fontSize: "0.65em",
    textTransform: "uppercase",
    padding: "0 0.1em"
  }
};

if (typeof CSS === "undefined" || typeof CSS.supports !== "function" || !CSS.supports("display", "grid")) {
  __WEBPACK_IMPORTED_MODULE_9_nx_components_GlobalStyleSheet__["a" /* default */].preload("nexia_mobile_tile_legacy", __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Tiles_tileLegacyStyles__["a" /* default */]);
}

var Tile =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Tile, _React$Component);

  function Tile() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Tile);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Tile).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Tile, [{
    key: "render",
    value: function render() {
      var _this = this;

      var model = this.props.model;
      var TileClass;
      var tileType = "";

      if (model instanceof __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_models_device__["a" /* default */]) {
        TileClass = __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Tiles_DeviceTile__["a" /* default */];
        tileType = model.getDeviceTypeString();
      } else if (model instanceof __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_models_automation__["a" /* default */]) {
        TileClass = __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_Tiles_AutomationTile__["a" /* default */];
        tileType = "Automation";
      } else if (model instanceof __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_models_phone__["a" /* default */]) {
        TileClass = __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Tiles_PhoneTile__["a" /* default */];
        tileType = "Phone";
      } else if (model instanceof __WEBPACK_IMPORTED_MODULE_22_nexia_mobile_models_location__["a" /* default */]) {
        if (model.getDeviceListingView()) {
          TileClass = __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_components_Tiles_BuildingInfoTile__["a" /* default */];
          tileType = "group";
        } else {
          TileClass = __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_Tiles_BuildingTile__["a" /* default */];
          tileType = "Location";
        }
      }

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_ErrorHandler__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_nexia_mobile_components_DrawUpdates__["a" /* default */], {
        listenTo: model,
        events: ["change"],
        getNodeToStyle: function getNodeToStyle() {
          return _this._el;
        }
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        className: "tile-aspect-ratio"
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        className: "tile",
        "data-tile-type": tileType,
        "data-model-cid": model.cid,
        style: {
          width: "100%",
          paddingBottom: "120%",
          position: "relative"
        },
        ref: function ref(el) {
          return _this._el = el;
        }
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_BackboneListener__["a" /* default */], {
        listenTo: model,
        events: ["change"]
      }, function () {
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](TileClass, {
          model: model,
          tileStyles: tileStyles
        });
      })))));
    }
  }]);

  return Tile;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Tile, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Model).isRequired
});



/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("\n.tile-aspect-ratio {\n    width: 50%;\n    float: left;\n}\n\n@media (min-width: 440px) {\n  .tile-aspect-ratio {\n    width: calc(100% / 3);\n  }\n}\n\n@media (min-width: 600px) {\n  .tile-aspect-ratio {\n    width: calc(100% / 4);\n  }\n}\n\n// breaks to large-format layout here\n\n@media (min-width: 800px) {\n  .tile-aspect-ratio {\n    width: calc(100% / 3);\n  }\n}\n\n@media (min-width: 1000px) {\n  .tile-aspect-ratio {\n    width: calc(100% / 4);\n  }\n}\n\n@media (min-width: 1200px) {\n  .tile-aspect-ratio {\n    width: calc(100% / 5);\n  }\n}\n\n@media (min-width: 1400px) {\n  .tile-aspect-ratio {\n    width: calc(100% / 6);\n  }\n}\n\n@media (min-width: 1600px) {\n  .tile-aspect-ratio {\n    width: calc(100% / 7);\n  }\n}\n\n@media (min-width: 1800px) {\n  .tile-aspect-ratio {\n    width: calc(100% / 8);\n  }\n}\n");

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_device__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_BatteryIndicator__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_MinimalBatteryIndicator__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_mixins_device_features_battery__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Controls_createControlsForModel__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_icons__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_components_IconGroup__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_DarkModeInverter__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_parseIconsFromServer__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_components_Tiles_IconGroupTileWrapper__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_components_Tiles_TileBody__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_nexia_mobile_components_Tiles_TileSpinner__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_nexia_mobile_components_Routing_HistoryPageTransitionController__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










 // some icon helper methods










function getColorWithOpacity(color, opacity) {
  if (!color || !(color[0] === "#")) {
    return color;
  }

  var _r = Number.parseInt(color.slice(1, 3), 16);

  var _g = Number.parseInt(color.slice(3, 5), 16);

  var _b = Number.parseInt(color.slice(5, 7), 16);

  return "rgba(".concat(_r, ",").concat(_g, ",").concat(_b, ",").concat(opacity, ")");
}

var DeviceTile =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(DeviceTile, _React$Component);

  function DeviceTile() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DeviceTile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DeviceTile)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      spinnerShown: false
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_showSpinner", function () {
      if (_this._isMounted) {
        _this.setState({
          spinnerShown: true
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_hideSpinner", function () {
      if (_this._isMounted) {
        _this.setState({
          spinnerShown: false
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTap", function () {
      var model = _this.props.model;
      __WEBPACK_IMPORTED_MODULE_23_nexia_mobile_history__["d" /* history */].push("/app/devices/details", {
        device: model
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DeviceTile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "_deviceStateColor",
    value: function _deviceStateColor(modifiers) {
      var colors = this.props.colors;
      var modifiersObj = modifiers.reduce(function (obj, modifier) {
        obj[modifier] = true;
        return obj;
      }, {});

      if (modifiersObj.emergency) {
        return colors.RED;
      }

      if (modifiersObj.alert || modifiersObj.insecure || modifiersObj.disconnected) {
        return colors.RED;
      }

      if (modifiersObj.warning) {
        return colors.WARNING;
      }

      if (modifiersObj.heat) {
        return colors.HEAT;
      }

      if (modifiersObj.cool) {
        return colors.COOL;
      }

      return colors.TEXT_SECONDARY;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          model = _this$props.model,
          tileStyles = _this$props.tileStyles,
          colors = _this$props.colors;
      var spinnerShown = this.state.spinnerShown;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__["b" /* default */])({
        deviceImageHeader: {
          color: colors.HEADER_BACKGROUND,
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          position: "absolute",
          top: "0"
        },
        title: {
          padding: "0.5em",
          fontSize: "0.85em"
        },
        iconGroup: {
          fontSize: "2.5em"
        },
        verticalCenter: {
          width: "100%",
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)"
        },
        ellipsis: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }
      });
      var deviceName = model.get("name");
      var deviceIcon = model.get("icon");

      var currentStatus = _.str.capitalize(model.get("status"));

      var statusModifiers = __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_icons__["a" /* default */].getIconModifiers(model.get("icon"));
      var hasBattery = model.hasFeature(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_mixins_device_features_battery__["a" /* default */]) && model.get("battery_label") != null;
      var batteryIcon = model.get("battery_icon");
      var batteryLabel = model.get("battery_label") === "Unknown" ? "?" : model.get("battery_label");
      var batteryLevel = model.get("battery_level");
      var deviceImageSrc = model.get("imageSrc");
      var controls = Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Controls_createControlsForModel__["e" /* createTileControlsForDevice */])(model, {
        showSpinner: this._showSpinner,
        hideSpinner: this._hideSpinner
      });
      var icons = Object(__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_parseIconsFromServer__["a" /* default */])(deviceIcon, {
        showThermostatTemperatureModifier: true
      });
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_Tappable__["b" /* default */], {
        onTap: this._handleTap,
        holdActiveUntil: __WEBPACK_IMPORTED_MODULE_24_nexia_mobile_components_Routing_HistoryPageTransitionController__["a" /* getTransitionPromise */]
      }, function (_ref) {
        var active = _ref.active,
            tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          "data-component-name": "DeviceTile",
          className: "tile-contents",
          "data-status": currentStatus,
          style: _objectSpread({}, tileStyles.contents, {
            backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_9_nx_components_Tappable__["c" /* simpleActiveBackgroundColor */])(active)
          })
        }, deviceImageSrc ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_DarkModeInverter__["a" /* default */], null, function (_ref2) {
          var maybeInvert = _ref2.maybeInvert;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_nexia_mobile_components_Tiles_TileBody__["a" /* default */], {
            backgroundStyle: _objectSpread({
              backgroundImage: "url(\"".concat(deviceImageSrc, "\")"),
              backgroundColor: "black",
              backgroundSize: "cover",
              opacity: active ? "0.5" : ""
            }, maybeInvert),
            innerRef: tapTargetRefHandler,
            hasControls: Boolean(controls),
            header: __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
              className: "tile-title",
              style: _objectSpread({}, tileStyles.title, {}, styles.deviceImageHeader, {
                background: getColorWithOpacity(_this2._deviceStateColor(statusModifiers), 0.5)
              }, maybeInvert)
            }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
              style: styles.ellipsis
            }, deviceName), hasBattery ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_MinimalBatteryIndicator__["a" /* default */], {
              icon: batteryIcon,
              style: {
                fontSize: "0.85em"
              }
            }) : null)
          });
        }) : __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_nexia_mobile_components_Tiles_TileBody__["a" /* default */], {
          innerRef: tapTargetRefHandler,
          hasControls: Boolean(controls),
          header: hasBattery ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_BatteryIndicator__["a" /* default */], {
            icon: batteryIcon,
            label: batteryLabel,
            level: batteryLevel
          }) : null
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_nexia_mobile_components_Tiles_IconGroupTileWrapper__["a" /* default */], {
          values: icons,
          unique: true
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17_nexia_mobile_components_IconGroup__["a" /* default */], {
          style: styles.iconGroup,
          values: icons,
          unique: true
        })), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          className: "tile-title",
          style: tileStyles.title
        }, deviceName), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          className: "tile-status ".concat(statusModifiers.join(" ")),
          style: tileStyles.status
        }, currentStatus)), controls, spinnerShown ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_nexia_mobile_components_Tiles_TileSpinner__["a" /* default */], null) : null);
      });
    }
  }]);

  return DeviceTile;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(DeviceTile, "propTypes", {
  model: function model() {
    return (typeof __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_device__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_device__["a" /* default */]).isRequired : __WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  tileStyles: __WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.shape({
    contents: __WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object.isRequired,
    icon: __WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object.isRequired,
    status: __WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object.isRequired
  }).isRequired,
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_ColorsProvider__["c" /* withColorsProvider */])(DeviceTile));


/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_components_Controls_ActionButtons__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_components_Controls_ActivateAutomation__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Controls_ActivateLockButton__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_Alarm__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_Barrier__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls_Camera__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Controls_Dimmer__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_Controls_Fan__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Controls_LockAndUnlock__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Controls_LockLockButton__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Controls_MultiCamera__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Controls_NestCamera__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Controls_NestStructure__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Controls_Speaker__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_Controls_Switch__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Controls_Thermostat__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_Controls_Valve__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_components_Controls_WindowShadeOpenCloseStop__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_Controls_WindowShadeSetPercentOpen__ = __webpack_require__(1144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_components_Controls_ActionButtons__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_components_Controls_ActivateAutomation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Controls_ActivateLockButton__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_Alarm__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_Barrier__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls_Camera__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Controls_Dimmer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_Controls_Fan__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Controls_LockAndUnlock__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Controls_LockLockButton__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Controls_MultiCamera__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Controls_NestCamera__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Controls_NestStructure__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Controls_Speaker__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_Controls_Switch__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Controls_Thermostat__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_Controls_Valve__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_components_Controls_WindowShadeOpenCloseStop__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_Controls_WindowShadeSetPercentOpen__["a"]; });





















/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Controls_DeviceControlButtonGroup__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_IconFromServer__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);










var ActionButtons = function ActionButtons(_ref) {
  var model = _ref.model,
      isDetailed = _ref.isDetailed,
      showSpinner = _ref.showSpinner,
      hideSpinner = _ref.hideSpinner;
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.controls.ActionButtons;
  var actions = model.get("actions");
  var buttons = Object.entries(actions).map(function (_ref2) {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
        key = _ref3[0],
        action = _ref3[1];

    var actionString = languageContext.template(language.tellingActionTemplate, {
      name: model.get("name"),
      action: action.button_text
    });
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nx_components_Button__["a" /* default */], {
      key: key,
      onTap: function onTap() {
        showSpinner(actionString);
        model.performAction(action).then(hideSpinner, hideSpinner);
      },
      disabled: action.disabled
    }, action.icon ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_IconFromServer__["a" /* default */], {
      value: action.icon
    }) : null, action.icon && action.button_text ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
      style: {
        marginRight: "0.25em"
      }
    }) : null, action.button_text);
  });
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
    isDetailed: isDetailed
  }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Controls_DeviceControlButtonGroup__["a" /* default */], null, buttons));
};

ActionButtons.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // () => void

};
/* harmony default export */ __webpack_exports__["a"] = (ActionButtons);

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Details_DetailsSection__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_ErrorHandler__ = __webpack_require__(98);





var DetailsControlWrapper = function DetailsControlWrapper(_ref) {
  var children = _ref.children;
  var controlStyle = {
    fontSize: "1.5em",
    maxWidth: "20em",
    margin: "0 auto"
  };
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_ErrorHandler__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    "data-component-name": "DetailsControlsWrapper",
    style: {
      textAlign: "center"
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Details_DetailsSection__["a" /* default */], {
    style: controlStyle
  }, children)));
};

DetailsControlWrapper.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (DetailsControlWrapper);

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_ButtonGroup__ = __webpack_require__(221);



var wrapperStyle = {
  fontSize: "0.8em",
  width: "100%"
};

var DeviceControlButtonGroup = function DeviceControlButtonGroup(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    style: wrapperStyle
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_nx_components_ButtonGroup__["a" /* default */], null, children));
};

DeviceControlButtonGroup.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (DeviceControlButtonGroup);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_parseIconsFromServer__ = __webpack_require__(83);




var IconFromServer = function IconFromServer(_ref) {
  var value = _ref.value;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", null, Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_parseIconsFromServer__["a" /* default */])(value).map(function (icon) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](icon.element, {
      key: icon.key
    });
  }));
};

IconFromServer.propTypes = {
  // The number of Icon formats the server can return is unholy.
  // They all get handled by parseIconsFromServer, though,
  // so don't worry about it here in the prop types.

  /* eslint-disable react/forbid-prop-types */
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (IconFromServer);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_DeviceControlButton__ = __webpack_require__(74);






var ActivateAutomation = function ActivateAutomation(_ref) {
  var model = _ref.model,
      isDetailed = _ref.isDetailed,
      showSpinner = _ref.showSpinner,
      hideSpinner = _ref.hideSpinner;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
    isDetailed: isDetailed
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_DeviceControlButton__["a" /* default */], {
    buttonLabel: "Run Now",
    onTap: function onTap() {
      showSpinner("Running '".concat(model.get("name"), "'"));
      model.activate().then(hideSpinner, hideSpinner);
    }
  }));
};

ActivateAutomation.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired // () => void

};
/* harmony default export */ __webpack_exports__["a"] = (ActivateAutomation);

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivateLockButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Controls_DeviceControlButton__ = __webpack_require__(74);












var ActivateLockButton =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ActivateLockButton, _React$Component);

  function ActivateLockButton() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ActivateLockButton);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ActivateLockButton).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ActivateLockButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          model = _this$props.model,
          isDetailed = _this$props.isDetailed,
          showSpinner = _this$props.showSpinner,
          hideSpinner = _this$props.hideSpinner;
      var isActivatable = model.get("isActivatable");
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
        isDetailed: isDetailed
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Controls_DeviceControlButton__["a" /* default */], {
        buttonLabel: "Activate",
        disabled: !isActivatable,
        onTap: function onTap() {
          showSpinner("Activating '".concat(model.get("name"), "'"));
          model.activate().then(hideSpinner, hideSpinner);
        }
      }));
    }
  }]);

  return ActivateLockButton;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(ActivateLockButton, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired // () => void

});



/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_DeviceControlButton__ = __webpack_require__(74);






var Alarm = function Alarm(_ref) {
  var model = _ref.model,
      isDetailed = _ref.isDetailed,
      showSpinner = _ref.showSpinner,
      hideSpinner = _ref.hideSpinner;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
    isDetailed: isDetailed
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_DeviceControlButton__["a" /* default */], {
    buttonLabel: model.isOn() ? "Turn Off" : "Turn On",
    onTap: function onTap() {
      showSpinner("Turning ".concat(model.isOn() ? "off" : "on", " '").concat(model.get("name"), "'"));
      model.toggleAlarm().then(hideSpinner, hideSpinner);
    }
  }));
};

Alarm.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired // () => void

};
/* harmony default export */ __webpack_exports__["a"] = (Alarm);

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Barrier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_SlideToUnlock__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);













var Barrier =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Barrier, _React$Component);

  function Barrier() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Barrier);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Barrier)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      pendingClosedValue: null
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Barrier, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "_setPendingClosedValue",
    value: function _setPendingClosedValue(pendingClosedValue) {
      if (!this._isMounted) {
        return;
      }

      this.setState({
        pendingClosedValue: pendingClosedValue
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          model = _this$props.model,
          isDetailed = _this$props.isDetailed,
          showSpinner = _this$props.showSpinner,
          hideSpinner = _this$props.hideSpinner;
      var pendingClosedValue = this.state.pendingClosedValue;
      var closed = pendingClosedValue == null ? model.isBarrierClosed() : pendingClosedValue;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
        isDetailed: isDetailed
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_SlideToUnlock__["a" /* default */], {
        locked: closed,
        lockedLabel: "Closed",
        unlockedLabel: "Open",
        disabled: !model.isBarrierOperable(),
        onChange: function onChange(newClosedValue) {
          showSpinner("".concat(newClosedValue ? "Closing" : "Opening", " ").concat(model.get("name")));

          _this2._setPendingClosedValue(newClosedValue);

          var onDone = function onDone() {
            hideSpinner();

            _this2._setPendingClosedValue(null);
          };

          model.operateBarrier().then(onDone, onDone);
        }
      }));
    }
  }]);

  return Barrier;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Barrier, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired // () => void

});



/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var getState = options.stateHandler.getState;

    /**
     * Tells if the element has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is detectable or not.
     */
    function isDetectable(element) {
        var state = getState(element);
        return state && !!state.isDetectable;
    }

    /**
     * Marks the element that it has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to mark.
     */
    function markAsDetectable(element) {
        getState(element).isDetectable = true;
    }

    /**
     * Tells if the element is busy or not.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is busy or not.
     */
    function isBusy(element) {
        return !!getState(element).busy;
    }

    /**
     * Marks the object is busy and should not be made detectable.
     * @public
     * @param {element} element The element to mark.
     * @param {boolean} busy If the element is busy or not.
     */
    function markBusy(element, busy) {
        getState(element).busy = !!busy;
    }

    return {
        isDetectable: isDetectable,
        markAsDetectable: markAsDetectable,
        isBusy: isBusy,
        markBusy: markBusy
    };
};


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(idHandler) {
    var eventListeners = {};

    /**
     * Gets all listeners for the given element.
     * @public
     * @param {element} element The element to get all listeners for.
     * @returns All listeners for the given element.
     */
    function getListeners(element) {
        var id = idHandler.get(element);

        if (id === undefined) {
            return [];
        }

        return eventListeners[id] || [];
    }

    /**
     * Stores the given listener for the given element. Will not actually add the listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The callback that the element has added.
     */
    function addListener(element, listener) {
        var id = idHandler.get(element);

        if(!eventListeners[id]) {
            eventListeners[id] = [];
        }

        eventListeners[id].push(listener);
    }

    function removeListener(element, listener) {
        var listeners = getListeners(element);
        for (var i = 0, len = listeners.length; i < len; ++i) {
            if (listeners[i] === listener) {
              listeners.splice(i, 1);
              break;
            }
        }
    }

    function removeAllListeners(element) {
      var listeners = getListeners(element);
      if (!listeners) { return; }
      listeners.length = 0;
    }

    return {
        get: getListeners,
        add: addListener,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners
    };
};


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function() {
    var idCount = 1;

    /**
     * Generates a new unique id in the context.
     * @public
     * @returns {number} A unique id in the context.
     */
    function generate() {
        return idCount++;
    }

    return {
        generate: generate
    };
};


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var idGenerator     = options.idGenerator;
    var getState        = options.stateHandler.getState;

    /**
     * Gets the resize detector id of the element.
     * @public
     * @param {element} element The target element to get the id of.
     * @returns {string|number|null} The id of the element. Null if it has no id.
     */
    function getId(element) {
        var state = getState(element);

        if (state && state.id !== undefined) {
            return state.id;
        }

        return null;
    }

    /**
     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
     * @public
     * @param {element} element The target element to set the id of.
     * @returns {string|number|null} The id of the element.
     */
    function setId(element) {
        var state = getState(element);

        if (!state) {
            throw new Error("setId required the element to have a resize detection state.");
        }

        var id = idGenerator.generate();

        state.id = id;

        return id;
    }

    return {
        get: getId,
        set: setId
    };
};


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global console: false */

/**
 * Reporter that handles the reporting of logs, warnings and errors.
 * @public
 * @param {boolean} quiet Tells if the reporter should be quiet or not.
 */
module.exports = function(quiet) {
    function noop() {
        //Does nothing.
    }

    var reporter = {
        log: noop,
        warn: noop,
        error: noop
    };

    if(!quiet && window.console) {
        var attachFunction = function(reporter, name) {
            //The proxy is needed to be able to call the method with the console context,
            //since we cannot use bind.
            reporter[name] = function reporterProxy() {
                var f = console[name];
                if (f.apply) { //IE9 does not support console.log.apply :)
                    f.apply(console, arguments);
                } else {
                    for (var i = 0; i < arguments.length; i++) {
                        f(arguments[i]);
                    }
                }
            };
        };

        attachFunction(reporter, "log");
        attachFunction(reporter, "warn");
        attachFunction(reporter, "error");
    }

    return reporter;
};

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1109);

module.exports = function batchProcessorMaker(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var asyncProcess    = utils.getOption(options, "async", true);
    var autoProcess     = utils.getOption(options, "auto", true);

    if(autoProcess && !asyncProcess) {
        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
        asyncProcess = true;
    }

    var batch = Batch();
    var asyncFrameHandler;
    var isProcessing = false;

    function addFunction(level, fn) {
        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
            // This needs to be done before, since we're checking the size of the batch to be 0.
            processBatchAsync();
        }

        batch.add(level, fn);
    }

    function processBatch() {
        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
        isProcessing = true;
        while (batch.size()) {
            var processingBatch = batch;
            batch = Batch();
            processingBatch.process();
        }
        isProcessing = false;
    }

    function forceProcessBatch(localAsyncProcess) {
        if (isProcessing) {
            return;
        }

        if(localAsyncProcess === undefined) {
            localAsyncProcess = asyncProcess;
        }

        if(asyncFrameHandler) {
            cancelFrame(asyncFrameHandler);
            asyncFrameHandler = null;
        }

        if(localAsyncProcess) {
            processBatchAsync();
        } else {
            processBatch();
        }
    }

    function processBatchAsync() {
        asyncFrameHandler = requestFrame(processBatch);
    }

    function clearBatch() {
        batch           = {};
        batchSize       = 0;
        topLevel        = 0;
        bottomLevel     = 0;
    }

    function cancelFrame(listener) {
        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
        var cancel = clearTimeout;
        return cancel(listener);
    }

    function requestFrame(callback) {
        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
        var raf = function(fn) { return setTimeout(fn, 0); };
        return raf(callback);
    }

    return {
        add: addFunction,
        force: forceProcessBatch
    };
};

function Batch() {
    var batch       = {};
    var size        = 0;
    var topLevel    = 0;
    var bottomLevel = 0;

    function add(level, fn) {
        if(!fn) {
            fn = level;
            level = 0;
        }

        if(level > topLevel) {
            topLevel = level;
        } else if(level < bottomLevel) {
            bottomLevel = level;
        }

        if(!batch[level]) {
            batch[level] = [];
        }

        batch[level].push(fn);
        size++;
    }

    function process() {
        for(var level = bottomLevel; level <= topLevel; level++) {
            var fns = batch[level];

            for(var i = 0; i < fns.length; i++) {
                var fn = fns[i];
                fn();
            }
        }
    }

    function getSize() {
        return size;
    }

    return {
        add: add,
        process: process,
        size: getSize
    };
}


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

utils.getOption = getOption;

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var prop = "_erd";

function initState(element) {
    element[prop] = {};
    return getState(element);
}

function getState(element) {
    return element[prop];
}

function cleanState(element) {
    delete element[prop];
}

module.exports = {
    initState: initState,
    getState: getState,
    cleanState: cleanState
};


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects objects to elements in order to detect resize events.
 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
 */



var browserDetector = __webpack_require__(462);

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;

    if(!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        if(!getObject(element)) {
            throw new Error("Element is not detectable by this strategy.");
        }

        function listenerProxy() {
            listener(element);
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support object, but supports the resize event directly on elements.
            getState(element).object = {
                proxy: listenerProxy
            };
            element.attachEvent("onresize", listenerProxy);
        } else {
            var object = getObject(element);
            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
        }
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};
        var debug = options.debug;

        function injectObject(element, callback) {
            var OBJECT_STYLE = "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; padding: 0; margin: 0; opacity: 0; z-index: -1000; pointer-events: none;";

            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.

            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
            var positionCheckPerformed = false;

            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
            var style = window.getComputedStyle(element);
            var width = element.offsetWidth;
            var height = element.offsetHeight;

            getState(element).startSize = {
                width: width,
                height: height
            };

            function mutateDom() {
                function alterPositionStyles() {
                    if(style.position === "static") {
                        element.style.position = "relative";

                        var removeRelativeStyles = function(reporter, element, style, property) {
                            function getNumericalValue(value) {
                                return value.replace(/[^-\d\.]/g, "");
                            }

                            var value = style[property];

                            if(value !== "auto" && getNumericalValue(value) !== "0") {
                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                                element.style[property] = 0;
                            }
                        };

                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                        removeRelativeStyles(reporter, element, style, "top");
                        removeRelativeStyles(reporter, element, style, "right");
                        removeRelativeStyles(reporter, element, style, "bottom");
                        removeRelativeStyles(reporter, element, style, "left");
                    }
                }

                function onObjectLoad() {
                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
                    if (!positionCheckPerformed) {
                        alterPositionStyles();
                    }

                    /*jshint validthis: true */

                    function getDocument(element, callback) {
                        //Opera 12 seem to call the object.onload before the actual document has been created.
                        //So if it is not present, poll it with an timeout until it is present.
                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
                        if(!element.contentDocument) {
                            setTimeout(function checkForObjectDocument() {
                                getDocument(element, callback);
                            }, 100);

                            return;
                        }

                        callback(element.contentDocument);
                    }

                    //Mutating the object element here seems to fire another load event.
                    //Mutating the inner document of the object element is fine though.
                    var objectElement = this;

                    //Create the style element to be added to the object.
                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
                        //Notify that the element is ready to be listened to.
                        callback(element);
                    });
                }

                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
                if (style.position !== "") {
                    alterPositionStyles(style);
                    positionCheckPerformed = true;
                }

                //Add an object element as a child to the target element that will be listened to for resize events.
                var object = document.createElement("object");
                object.style.cssText = OBJECT_STYLE;
                object.tabIndex = -1;
                object.type = "text/html";
                object.setAttribute("aria-hidden", "true");
                object.onload = onObjectLoad;

                //Safari: This must occur before adding the object to the DOM.
                //IE: Does not like that this happens before, even if it is also added after.
                if(!browserDetector.isIE()) {
                    object.data = "about:blank";
                }

                element.appendChild(object);
                getState(element).object = object;

                //IE: This must occur after adding the object to the DOM.
                if(browserDetector.isIE()) {
                    object.data = "about:blank";
                }
            }

            if(batchProcessor) {
                batchProcessor.add(mutateDom);
            } else {
                mutateDom();
            }
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support objects properly. Luckily they do support the resize event.
            //So do not inject the object and notify that the element is already ready to be listened to.
            //The event handler for the resize event is attached in the utils.addListener instead.
            callback(element);
        } else {
            injectObject(element, callback);
        }
    }

    /**
     * Returns the child object of the target element.
     * @private
     * @param {element} element The target element.
     * @returns The object element of the target.
     */
    function getObject(element) {
        return getState(element).object;
    }

    function uninstall(element) {
        if(browserDetector.isIE(8)) {
            element.detachEvent("onresize", getState(element).object.proxy);
        } else {
            element.removeChild(getObject(element));
        }
        delete getState(element).object;
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
 */



var forEach = __webpack_require__(461).forEach;

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;
    var hasState        = options.stateHandler.hasState;
    var idHandler       = options.idHandler;

    if (!batchProcessor) {
        throw new Error("Missing required dependency: batchProcessor");
    }

    if (!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    //TODO: Could this perhaps be done at installation time?
    var scrollbarSizes = getScrollbarSizes();

    // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
    // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
    var styleId = "erd_scroll_detection_scrollbar_style";
    var detectionContainerClass = "erd_scroll_detection_container";
    injectScrollStyle(styleId, detectionContainerClass);

    function getScrollbarSizes() {
        var width = 500;
        var height = 500;

        var child = document.createElement("div");
        child.style.cssText = "position: absolute; width: " + width*2 + "px; height: " + height*2 + "px; visibility: hidden; margin: 0; padding: 0;";

        var container = document.createElement("div");
        container.style.cssText = "position: absolute; width: " + width + "px; height: " + height + "px; overflow: scroll; visibility: none; top: " + -width*3 + "px; left: " + -height*3 + "px; visibility: hidden; margin: 0; padding: 0;";

        container.appendChild(child);

        document.body.insertBefore(container, document.body.firstChild);

        var widthSize = width - container.clientWidth;
        var heightSize = height - container.clientHeight;

        document.body.removeChild(container);

        return {
            width: widthSize,
            height: heightSize
        };
    }

    function injectScrollStyle(styleId, containerClass) {
        function injectStyle(style, method) {
            method = method || function (element) {
                document.head.appendChild(element);
            };

            var styleElement = document.createElement("style");
            styleElement.innerHTML = style;
            styleElement.id = styleId;
            method(styleElement);
            return styleElement;
        }

        if (!document.getElementById(styleId)) {
            var containerAnimationClass = containerClass + "_animation";
            var containerAnimationActiveClass = containerClass + "_animation_active";
            var style = "/* Created by the element-resize-detector library. */\n";
            style += "." + containerClass + " > div::-webkit-scrollbar { display: none; }\n\n";
            style += "." + containerAnimationActiveClass + " { -webkit-animation-duration: 0.1s; animation-duration: 0.1s; -webkit-animation-name: " + containerAnimationClass + "; animation-name: " + containerAnimationClass + "; }\n";
            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
            injectStyle(style);
        }
    }

    function addAnimationClass(element) {
        element.className += " " + detectionContainerClass + "_animation_active";
    }

    function addEvent(el, name, cb) {
        if (el.addEventListener) {
            el.addEventListener(name, cb);
        } else if(el.attachEvent) {
            el.attachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to add event listeners.");
        }
    }

    function removeEvent(el, name, cb) {
        if (el.removeEventListener) {
            el.removeEventListener(name, cb);
        } else if(el.detachEvent) {
            el.detachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to remove event listeners.");
        }
    }

    function getExpandElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
    }

    function getShrinkElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        var listeners = getState(element).listeners;

        if (!listeners.push) {
            throw new Error("Cannot add listener to an element that is not detectable.");
        }

        getState(element).listeners.push(listener);
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};

        function debug() {
            if (options.debug) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift(idHandler.get(element), "Scroll: ");
                if (reporter.log.apply) {
                    reporter.log.apply(null, args);
                } else {
                    for (var i = 0; i < args.length; i++) {
                        reporter.log(args[i]);
                    }
                }
            }
        }

        function isDetached(element) {
            function isInDocument(element) {
                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element);
            }

            if (!isInDocument(element)) {
                return true;
            }

            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
            if (window.getComputedStyle(element) === null) {
                return true;
            }

            return false;
        }

        function isUnrendered(element) {
            // Check the absolute positioned container since the top level container is display: inline.
            var container = getState(element).container.childNodes[0];
            var style = window.getComputedStyle(container);
            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
        }

        function getStyle() {
            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
            var elementStyle            = window.getComputedStyle(element);
            var style                   = {};
            style.position              = elementStyle.position;
            style.width                 = element.offsetWidth;
            style.height                = element.offsetHeight;
            style.top                   = elementStyle.top;
            style.right                 = elementStyle.right;
            style.bottom                = elementStyle.bottom;
            style.left                  = elementStyle.left;
            style.widthCSS              = elementStyle.width;
            style.heightCSS             = elementStyle.height;
            return style;
        }

        function storeStartSize() {
            var style = getStyle();
            getState(element).startSize = {
                width: style.width,
                height: style.height
            };
            debug("Element start size", getState(element).startSize);
        }

        function initListeners() {
            getState(element).listeners = [];
        }

        function storeStyle() {
            debug("storeStyle invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getStyle();
            getState(element).style = style;
        }

        function storeCurrentSize(element, width, height) {
            getState(element).lastWidth = width;
            getState(element).lastHeight  = height;
        }

        function getExpandChildElement(element) {
            return getExpandElement(element).childNodes[0];
        }

        function getWidthOffset() {
            return 2 * scrollbarSizes.width + 1;
        }

        function getHeightOffset() {
            return 2 * scrollbarSizes.height + 1;
        }

        function getExpandWidth(width) {
            return width + 10 + getWidthOffset();
        }

        function getExpandHeight(height) {
            return height + 10 + getHeightOffset();
        }

        function getShrinkWidth(width) {
            return width * 2 + getWidthOffset();
        }

        function getShrinkHeight(height) {
            return height * 2 + getHeightOffset();
        }

        function positionScrollbars(element, width, height) {
            var expand          = getExpandElement(element);
            var shrink          = getShrinkElement(element);
            var expandWidth     = getExpandWidth(width);
            var expandHeight    = getExpandHeight(height);
            var shrinkWidth     = getShrinkWidth(width);
            var shrinkHeight    = getShrinkHeight(height);
            expand.scrollLeft   = expandWidth;
            expand.scrollTop    = expandHeight;
            shrink.scrollLeft   = shrinkWidth;
            shrink.scrollTop    = shrinkHeight;
        }

        function injectContainerElement() {
            var container = getState(element).container;

            if (!container) {
                container                   = document.createElement("div");
                container.className         = detectionContainerClass;
                container.style.cssText     = "visibility: hidden; display: inline; width: 0px; height: 0px; z-index: -1; overflow: hidden; margin: 0; padding: 0;";
                getState(element).container = container;
                addAnimationClass(container);
                element.appendChild(container);

                var onAnimationStart = function () {
                    getState(element).onRendered && getState(element).onRendered();
                };

                addEvent(container, "animationstart", onAnimationStart);

                // Store the event handler here so that they may be removed when uninstall is called.
                // See uninstall function for an explanation why it is needed.
                getState(element).onAnimationStart = onAnimationStart;
            }

            return container;
        }

        function injectScrollElements() {
            function alterPositionStyles() {
                var style = getState(element).style;

                if(style.position === "static") {
                    element.style.position = "relative";

                    var removeRelativeStyles = function(reporter, element, style, property) {
                        function getNumericalValue(value) {
                            return value.replace(/[^-\d\.]/g, "");
                        }

                        var value = style[property];

                        if(value !== "auto" && getNumericalValue(value) !== "0") {
                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                            element.style[property] = 0;
                        }
                    };

                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                    removeRelativeStyles(reporter, element, style, "top");
                    removeRelativeStyles(reporter, element, style, "right");
                    removeRelativeStyles(reporter, element, style, "bottom");
                    removeRelativeStyles(reporter, element, style, "left");
                }
            }

            function getLeftTopBottomRightCssText(left, top, bottom, right) {
                left = (!left ? "0" : (left + "px"));
                top = (!top ? "0" : (top + "px"));
                bottom = (!bottom ? "0" : (bottom + "px"));
                right = (!right ? "0" : (right + "px"));

                return "left: " + left + "; top: " + top + "; right: " + right + "; bottom: " + bottom + ";";
            }

            debug("Injecting elements");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            alterPositionStyles();

            var rootContainer = getState(element).container;

            if (!rootContainer) {
                rootContainer = injectContainerElement();
            }

            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
            // the targeted element.
            // When the bug is resolved, "containerContainer" may be removed.

            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.

            var scrollbarWidth          = scrollbarSizes.width;
            var scrollbarHeight         = scrollbarSizes.height;
            var containerContainerStyle = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; width: 100%; height: 100%; left: 0px; top: 0px;";
            var containerStyle          = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; " + getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth);
            var expandStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
            var shrinkStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
            var expandChildStyle        = "position: absolute; left: 0; top: 0;";
            var shrinkChildStyle        = "position: absolute; width: 200%; height: 200%;";

            var containerContainer      = document.createElement("div");
            var container               = document.createElement("div");
            var expand                  = document.createElement("div");
            var expandChild             = document.createElement("div");
            var shrink                  = document.createElement("div");
            var shrinkChild             = document.createElement("div");

            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
            containerContainer.dir              = "ltr";

            containerContainer.style.cssText    = containerContainerStyle;
            containerContainer.className        = detectionContainerClass;
            container.className                 = detectionContainerClass;
            container.style.cssText             = containerStyle;
            expand.style.cssText                = expandStyle;
            expandChild.style.cssText           = expandChildStyle;
            shrink.style.cssText                = shrinkStyle;
            shrinkChild.style.cssText           = shrinkChildStyle;

            expand.appendChild(expandChild);
            shrink.appendChild(shrinkChild);
            container.appendChild(expand);
            container.appendChild(shrink);
            containerContainer.appendChild(container);
            rootContainer.appendChild(containerContainer);

            function onExpandScroll() {
                getState(element).onExpand && getState(element).onExpand();
            }

            function onShrinkScroll() {
                getState(element).onShrink && getState(element).onShrink();
            }

            addEvent(expand, "scroll", onExpandScroll);
            addEvent(shrink, "scroll", onShrinkScroll);

            // Store the event handlers here so that they may be removed when uninstall is called.
            // See uninstall function for an explanation why it is needed.
            getState(element).onExpandScroll = onExpandScroll;
            getState(element).onShrinkScroll = onShrinkScroll;
        }

        function registerListenersAndPositionElements() {
            function updateChildSizes(element, width, height) {
                var expandChild             = getExpandChildElement(element);
                var expandWidth             = getExpandWidth(width);
                var expandHeight            = getExpandHeight(height);
                expandChild.style.width     = expandWidth + "px";
                expandChild.style.height    = expandHeight + "px";
            }

            function updateDetectorElements(done) {
                var width           = element.offsetWidth;
                var height          = element.offsetHeight;

                debug("Storing current size", width, height);

                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
                // Otherwise the if-check in handleScroll is useless.
                storeCurrentSize(element, width, height);

                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.

                batchProcessor.add(0, function performUpdateChildSizes() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    if (options.debug) {
                        var w = element.offsetWidth;
                        var h = element.offsetHeight;

                        if (w !== width || h !== height) {
                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
                        }
                    }

                    updateChildSizes(element, width, height);
                });

                batchProcessor.add(1, function updateScrollbars() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    positionScrollbars(element, width, height);
                });

                if (done) {
                    batchProcessor.add(2, function () {
                        if (!getState(element)) {
                            debug("Aborting because element has been uninstalled");
                            return;
                        }

                        if (!areElementsInjected()) {
                          debug("Aborting because element container has not been initialized");
                          return;
                        }

                        done();
                    });
                }
            }

            function areElementsInjected() {
                return !!getState(element).container;
            }

            function notifyListenersIfNeeded() {
                function isFirstNotify() {
                    return getState(element).lastNotifiedWidth === undefined;
                }

                debug("notifyListenersIfNeeded invoked");

                var state = getState(element);

                // Don't notify the if the current size is the start size, and this is the first notification.
                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
                }

                // Don't notify if the size already has been notified.
                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
                    return debug("Not notifying: Size already notified");
                }


                debug("Current size not notified, notifying...");
                state.lastNotifiedWidth = state.lastWidth;
                state.lastNotifiedHeight = state.lastHeight;
                forEach(getState(element).listeners, function (listener) {
                    listener(element);
                });
            }

            function handleRender() {
                debug("startanimation triggered.");

                if (isUnrendered(element)) {
                    debug("Ignoring since element is still unrendered...");
                    return;
                }

                debug("Element rendered.");
                var expand = getExpandElement(element);
                var shrink = getShrinkElement(element);
                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
                    debug("Scrollbars out of sync. Updating detector elements...");
                    updateDetectorElements(notifyListenersIfNeeded);
                }
            }

            function handleScroll() {
                debug("Scroll detected.");

                if (isUnrendered(element)) {
                    // Element is still unrendered. Skip this scroll event.
                    debug("Scroll event fired while unrendered. Ignoring...");
                    return;
                }

                var width = element.offsetWidth;
                var height = element.offsetHeight;

                if (width !== getState(element).lastWidth || height !== getState(element).lastHeight) {
                    debug("Element size changed.");
                    updateDetectorElements(notifyListenersIfNeeded);
                } else {
                    debug("Element size has not changed (" + width + "x" + height + ").");
                }
            }

            debug("registerListenersAndPositionElements invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            getState(element).onRendered = handleRender;
            getState(element).onExpand = handleScroll;
            getState(element).onShrink = handleScroll;

            var style = getState(element).style;
            updateChildSizes(element, style.width, style.height);
        }

        function finalizeDomMutation() {
            debug("finalizeDomMutation invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getState(element).style;
            storeCurrentSize(element, style.width, style.height);
            positionScrollbars(element, style.width, style.height);
        }

        function ready() {
            callback(element);
        }

        function install() {
            debug("Installing...");
            initListeners();
            storeStartSize();

            batchProcessor.add(0, storeStyle);
            batchProcessor.add(1, injectScrollElements);
            batchProcessor.add(2, registerListenersAndPositionElements);
            batchProcessor.add(3, finalizeDomMutation);
            batchProcessor.add(4, ready);
        }

        debug("Making detectable...");

        if (isDetached(element)) {
            debug("Element is detached");

            injectContainerElement();

            debug("Waiting until element is attached...");

            getState(element).onRendered = function () {
                debug("Element is now attached");
                install();
            };
        } else {
            install();
        }
    }

    function uninstall(element) {
        var state = getState(element);

        if (!state) {
            // Uninstall has been called on a non-erd element.
            return;
        }

        // Uninstall may have been called in the following scenarios:
        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
        // So to be on the safe side, let's check for each thing before removing.

        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);

        state.container && element.removeChild(state.container);
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_DeviceControlButton__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_history__ = __webpack_require__(31);







var Camera = function Camera(_ref) {
  var model = _ref.model,
      isDetailed = _ref.isDetailed;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
    isDetailed: isDetailed
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_DeviceControlButton__["a" /* default */], {
    buttonLabel: "Show Video",
    onTap: function onTap() {
      __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_history__["d" /* history */].push("/app/video-feed", {
        model: model
      });
    },
    disabled: !model.isConnected()
  }));
};

Camera.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Camera);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dimmer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_Slider__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);















var formatValue = function formatValue(value) {
  return "".concat(value, "%");
};

var style = Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_utils_prefixStyles__["b" /* default */])({
  flex: "1 0 auto",
  margin: "1em 0.5em"
});

var Dimmer =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Dimmer, _React$Component);

  function Dimmer() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Dimmer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Dimmer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      pendingValue: null
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isEditing", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDragStart", function () {
      _this._isEditing = true;
      Object(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_flux_like_dispatch__["a" /* default */])("DISABLE_LOCATION_POLLING");
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDragEnd", function (value) {
      _this._isEditing = false;
      var _this$props = _this.props,
          model = _this$props.model,
          showSpinner = _this$props.showSpinner,
          hideSpinner = _this$props.hideSpinner;

      if (value !== model.get("dimmer_level")) {
        // don't set dimmer level if it hasn't changed
        _this.setState({
          pendingValue: value
        });

        showSpinner("Setting level for '".concat(model.get("name"), "'"));

        var onDone = function onDone() {
          _this.setState({
            pendingValue: null
          });

          hideSpinner();
        };

        model.setDimmerLevel(value).then(onDone, onDone);
      }

      Object(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Dimmer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      // If the user is editing the dimmer value, stay out of
      // their way. We'll miss an update, but that's okay,
      // because they're about to set a new value.
      return !this._isEditing;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          model = _this$props2.model,
          isDetailed = _this$props2.isDetailed;
      var pendingValue = this.state.pendingValue;
      var displayValue = model.get("dimmer_level") || 0;

      if (pendingValue != null) {
        displayValue = pendingValue;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
        isDetailed: isDetailed
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_Slider__["a" /* default */], {
        min: 0,
        max: 99,
        value: displayValue,
        formatValue: formatValue,
        onDragStart: this._handleDragStart,
        onDragEnd: this._handleDragEnd,
        style: style
      }));
    }
  }]);

  return Dimmer;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Dimmer, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired // () => void

});



/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_sizeme__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_sizeme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_sizeme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SliderController__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SliderPresenter__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);













function getPrecision(number) {
  // number of digits after the decimal place
  return (number.toString().split(".")[1] || "").length;
} // float-safe modulo operator (https://stackoverflow.com/a/31711034)


function isStepValid(min, max, step) {
  var range = max - min;

  if (range % step === 0) {
    return true;
  }

  var precision = Math.max(getPrecision(step), getPrecision(range));
  var rangeInt = parseInt(range.toFixed(precision).replace(".", ""));
  var stepInt = parseInt(step.toFixed(precision).replace(".", ""));
  return rangeInt % stepInt === 0;
}

var SliderContainer =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SliderContainer, _React$Component);

  function SliderContainer() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SliderContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SliderContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      isBeingDragged: false,
      value: _this.props.value
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_initialValue", _this.props.value);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_getNewValue", function (ratio) {
      var _this$props = _this.props,
          max = _this$props.max,
          min = _this$props.min,
          step = _this$props.step;
      var numberOfSteps = (max - min) / step;
      var positionInSteps = Math.round(ratio * numberOfSteps);
      var newValue = min + positionInSteps * step; // Trim floating-point cruft

      newValue = parseFloat(newValue.toFixed(getPrecision(step))); // Clamp value to range

      return Math.max(min, Math.min(max, newValue));
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleStart", function (ratio) {
      _this._initialValue = _this.state.value;

      var newValue = _this._getNewValue(ratio);

      _this.setState({
        isBeingDragged: true,
        value: newValue
      });

      if (_this.props.onDragStart) {
        _this.props.onDragStart(newValue);
      }

      if (_this.props.onChange) {
        _this.props.onChange(newValue);
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDrag", function (ratio) {
      var newValue = _this._getNewValue(ratio);

      if (newValue === _this.state.value) {
        return;
      }

      _this.setState({
        value: newValue
      });

      if (_this.props.onChange) {
        _this.props.onChange(newValue);
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleEnd", function (ratio) {
      var newValue = _this._getNewValue(ratio);

      _this.setState({
        isBeingDragged: false,
        value: newValue
      });

      if (_this.props.onDragEnd) {
        _this.props.onDragEnd(newValue);
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleAbort", function () {
      _this.setState({
        value: _this._initialValue,
        isBeingDragged: false
      });

      if (_this.props.onDragEnd) {
        _this.props.onDragEnd(_this._initialValue, true);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SliderContainer, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.state.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          hasOffState = _this$props2.hasOffState,
          max = _this$props2.max,
          min = _this$props2.min,
          step = _this$props2.step,
          formatValue = _this$props2.formatValue,
          showValueAboveHandle = _this$props2.showValueAboveHandle,
          size = _this$props2.size,
          tooltipStyle = _this$props2.tooltipStyle,
          isHeat = _this$props2.isHeat,
          isCool = _this$props2.isCool;
      var _this$state = this.state,
          value = _this$state.value,
          isBeingDragged = _this$state.isBeingDragged;

      if (!isStepValid(min, max, step)) {
        console.error("A Slider was rendered with an invalid step ".concat(step, " which doesn't evenly divide the range from ").concat(min, " to ").concat(max));
        return null;
      }

      if (max === min) {
        console.error("A Slider was rendered with the same 'min' and 'max' props. The value provided for both was ".concat(max));
        return null;
      }

      var ratio = (value - min) / (max - min);
      ratio = Math.max(0, Math.min(1, ratio));
      ratio = parseFloat(ratio.toFixed(5));
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__SliderController__["b" /* default */], {
        ratio: ratio,
        onStart: this._handleStart,
        onDrag: this._handleDrag,
        onEnd: this._handleEnd,
        onAbort: this._handleAbort
      }, function (_ref) {
        var onMouseDown = _ref.onMouseDown,
            onTouchStartCapture = _ref.onTouchStartCapture,
            captureRef = _ref.captureRef;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__SliderPresenter__["a" /* default */], {
          captureRef: captureRef,
          ariaValues: {
            min: min,
            max: max,
            value: value
          },
          isHeat: isHeat,
          isCool: isCool,
          isBeingDragged: isBeingDragged,
          hasOffState: hasOffState,
          ratio: ratio,
          showValueAboveHandle: showValueAboveHandle,
          fullSliderWidth: size.width,
          tooltipLabel: formatValue(value),
          tooltipStyle: tooltipStyle,
          onMouseDown: onMouseDown,
          onTouchStartCapture: onTouchStartCapture
        });
      });
    }
  }]);

  return SliderContainer;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SliderContainer, "defaultProps", {
  hasOffState: true,
  formatValue: function formatValue(value) {
    return String(value);
  },
  showValueAboveHandle: false,
  step: 1
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SliderContainer, "propTypes", {
  hasOffState: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.bool,
  formatValue: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func,
  showValueAboveHandle: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.bool,
  step: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.number.isRequired,
  max: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.number.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.number.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func,
  onDragStart: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func,
  onDragEnd: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func,
  tooltipStyle: function tooltipStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_12__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  isHeat: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.bool,
  isCool: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.shape({
    width: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.number
  }).isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_8_react_sizeme___default()({
  monitorWidth: true,
  noPlaceholder: true,
  refreshRate: __WEBPACK_IMPORTED_MODULE_9__Theme__["a" /* default */].RESPONSIVE_REFRESH_RATE
})(SliderContainer));



/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SliderTooltip__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Bar__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Handle__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var SliderPresenter =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(SliderPresenter, _React$Component);

  function SliderPresenter() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SliderPresenter);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SliderPresenter).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SliderPresenter, [{
    key: "_getColor",
    value: function _getColor() {
      var _this$props = this.props,
          isHeat = _this$props.isHeat,
          isCool = _this$props.isCool,
          colors = _this$props.colors;
      var color = colors.PRIMARY;

      if (isHeat) {
        color = colors.HEAT;
      } else if (isCool) {
        color = colors.COOL;
      }

      return color;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          captureRef = _this$props2.captureRef,
          ariaValues = _this$props2.ariaValues,
          isBeingDragged = _this$props2.isBeingDragged,
          hasOffState = _this$props2.hasOffState,
          ratio = _this$props2.ratio,
          showValueAboveHandle = _this$props2.showValueAboveHandle,
          fullSliderWidth = _this$props2.fullSliderWidth,
          tooltipLabel = _this$props2.tooltipLabel,
          tooltipStyle = _this$props2.tooltipStyle,
          onMouseDown = _this$props2.onMouseDown,
          onTouchStartCapture = _this$props2.onTouchStartCapture,
          colors = _this$props2.colors;

      var color = this._getColor();

      var styles = {
        wrapper: Object(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["b" /* default */])({
          display: "flex",
          alignItems: "center"
        }),
        popUpTooltip: {
          fontSize: 16,
          lineHeight: "normal",
          color: colors.HEADER_BACKGROUND,
          padding: ".5em",
          textAlign: "center"
        },
        valueTooltip: {
          lineHeight: 1.2,
          fontSize: 10,
          color: colors.LABEL
        }
      };

      var wrapperStyle = _objectSpread({}, styles.wrapper, {
        paddingTop: showValueAboveHandle ? 15 : 0
      });

      var popUpTooltipStyle = _objectSpread({}, styles.popUpTooltip, {
        backgroundColor: color
      }, tooltipStyle);

      var tooltips = [__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__SliderTooltip__["a" /* default */], {
        key: "pop-up",
        isVisible: isBeingDragged,
        sliderWidth: fullSliderWidth,
        label: tooltipLabel,
        ratio: ratio,
        style: popUpTooltipStyle
      })];

      if (showValueAboveHandle) {
        tooltips.push(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__SliderTooltip__["a" /* default */], {
          key: "value",
          isVisible: !isBeingDragged,
          sliderWidth: fullSliderWidth,
          isPersistentValue: true,
          label: tooltipLabel,
          ratio: ratio,
          style: styles.valueTooltip
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "SliderPresenter",
        style: wrapperStyle,
        onMouseDown: onMouseDown,
        onTouchStartCapture: onTouchStartCapture,
        ref: captureRef
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Bar__["a" /* default */], {
        color: color,
        size: ratio
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Handle__["b" /* default */], {
        color: color,
        tooltip: tooltips,
        isMinimum: hasOffState && ratio === 0,
        role: "slider",
        "aria-valuenow": ariaValues.value,
        "aria-valuetext": tooltipLabel,
        "aria-valuemin": ariaValues.min,
        "aria-valuemax": ariaValues.max
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Bar__["a" /* default */], {
        size: 1 - ratio
      }));
    }
  }]);

  return SliderPresenter;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(SliderPresenter, "propTypes", {
  captureRef: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  ariaValues: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape({
    min: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired,
    max: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired
  }).isRequired,
  isHeat: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  isCool: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  isBeingDragged: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool.isRequired,
  hasOffState: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool.isRequired,
  ratio: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired,
  showValueAboveHandle: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool.isRequired,
  fullSliderWidth: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number,
  tooltipLabel: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string.isRequired,
  tooltipStyle: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  onTouchStartCapture: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["c" /* withColorsProvider */])(SliderPresenter));



/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clampTooltipOffset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SliderTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Handle__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function clampTooltipOffset(_ref) {
  var tooltipWidth = _ref.tooltipWidth,
      maybeWidth = _ref.sliderWidth,
      ratio = _ref.ratio;
  var sliderWidth = maybeWidth || 0;
  var tooltipCenter = sliderWidth * ratio + __WEBPACK_IMPORTED_MODULE_9__Handle__["a" /* HANDLE_SIZE */] / 2;
  var totalWidth = sliderWidth + __WEBPACK_IMPORTED_MODULE_9__Handle__["a" /* HANDLE_SIZE */];
  var halfTooltipWidth = tooltipWidth / 2;
  var offset = 0;

  if (tooltipCenter + -halfTooltipWidth < 0) {
    // tooltip is too close to the left end, offset further to the right
    offset = halfTooltipWidth - tooltipCenter;
  }

  if (tooltipCenter + halfTooltipWidth > totalWidth) {
    // tooltip is too close to the right end, offset further to the left
    offset = totalWidth - (tooltipCenter + halfTooltipWidth);
  }

  return offset;
}

var SliderTooltip =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SliderTooltip, _React$Component);

  function SliderTooltip() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SliderTooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SliderTooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      tooltipWidth: 30
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SliderTooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._syncOffset();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._syncOffset();
    }
  }, {
    key: "_syncOffset",
    value: function _syncOffset() {
      if (!this._tooltipEl) {
        return;
      } // If the width changes the clampingOffset can become out of sync with the real offsetWidth.
      // This will frequently double-render, but the renders are isolated to this component


      if (this.state.tooltipWidth === this._tooltipEl.offsetWidth) {
        return;
      }

      this.setState({
        tooltipWidth: this._tooltipEl.offsetWidth
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isPersistentValue = _this$props.isPersistentValue,
          isVisible = _this$props.isVisible,
          label = _this$props.label,
          ratio = _this$props.ratio,
          sliderWidth = _this$props.sliderWidth,
          style = _this$props.style;
      var tooltipWidth = this.state.tooltipWidth;
      var TOOLTIP_SPACING = isPersistentValue ? __WEBPACK_IMPORTED_MODULE_9__Handle__["a" /* HANDLE_SIZE */] / 2 : __WEBPACK_IMPORTED_MODULE_9__Handle__["a" /* HANDLE_SIZE */] / 2 + 8;
      var TAIL_HEIGHT = 6;
      var clampingOffset = clampTooltipOffset({
        tooltipWidth: tooltipWidth,
        sliderWidth: sliderWidth,
        ratio: ratio
      });
      var styles = {
        offsetPositioning: {
          position: "relative",
          left: "50%",
          top: "50%",
          opacity: isVisible ? 1 : 0,
          transform: "scale(".concat(isVisible ? 1 : 0, ")"),
          transition: "all 200ms ".concat(isVisible ? "ease-out" : "ease-in"),
          width: 0
        },
        tooltip: _objectSpread({
          position: "absolute",
          display: "inline",
          zIndex: __WEBPACK_IMPORTED_MODULE_8__Theme__["a" /* default */].zIndexLayers.POPUP,
          whiteSpace: "pre",
          transform: "translate(calc(-50% + ".concat(clampingOffset, "px), calc(-98% + ").concat(-TOOLTIP_SPACING, "px))")
        }, style),
        tail: _objectSpread({
          position: "absolute",
          transformOrigin: "0 0",
          border: "solid ".concat(TAIL_HEIGHT, "px transparent"),
          zIndex: __WEBPACK_IMPORTED_MODULE_8__Theme__["a" /* default */].zIndexLayers.POPUP
        }, style && {
          borderTopColor: style.backgroundColor
        }, {
          transform: "translate(-50%, ".concat(-TOOLTIP_SPACING, "px)")
        })
      };
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "SliderTooltip",
        style: styles.offsetPositioning
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        ref: function ref(el) {
          _this2._tooltipEl = el;
        },
        style: styles.tooltip
      }, label), !isPersistentValue ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.tail
      }) : null);
    }
  }]);

  return SliderTooltip;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SliderTooltip, "defaultProps", {
  isPersistentValue: false
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SliderTooltip, "propTypes", {
  isPersistentValue: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,
  isVisible: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string.isRequired,
  ratio: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number.isRequired,
  sliderWidth: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object
});




/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SliderController__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);










var Bar =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Bar, _React$Component);

  function Bar() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Bar);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Bar).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Bar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          size = _this$props.size;
      var style = Object(__WEBPACK_IMPORTED_MODULE_7__utils_prefixStyles__["b" /* default */])({
        backgroundColor: color,
        flexGrow: size,
        transition: "flex-grow ".concat(__WEBPACK_IMPORTED_MODULE_8__SliderController__["a" /* THROTTLE_DELAY */], "ms ease-in-out"),
        height: 2
      });
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "Bar",
        style: style
      });
    }
  }]);

  return Bar;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Bar, "defaultProps", {
  color: "#BDBDBD"
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(Bar, "propTypes", {
  color: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number.isRequired
});




/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Fan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_Slider__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);














var sliderStyle = Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_utils_prefixStyles__["b" /* default */])({
  flex: "1 0 auto",
  margin: "1em 0.5em"
});

var Fan =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Fan, _React$Component);

  function Fan() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Fan);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Fan)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      pendingValue: null
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isEditing", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDragStart", function () {
      _this._isEditing = true;
      Object(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_flux_like_dispatch__["a" /* default */])("DISABLE_LOCATION_POLLING");
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDragEnd", function (value) {
      _this._isEditing = false;
      Object(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
      var _this$props = _this.props,
          model = _this$props.model,
          showSpinner = _this$props.showSpinner,
          hideSpinner = _this$props.hideSpinner;

      if (value === model.get("fan_speed")) {
        return; // don't set fan speed if it hasn't changed
      }

      _this.setState({
        pendingValue: value
      });

      showSpinner("Setting speed for '".concat(model.get("name"), "'"));

      var onDone = function onDone() {
        hideSpinner();

        _this.setState({
          pendingValue: null
        });
      };

      model.setFanSpeed(value).then(function () {
        model.fetch().then(onDone, onDone);
      }, onDone);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_formatValue", function (value) {
      return _this.props.model.getFanSpeedLabel(value);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Fan, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      // If the user is editing the fan value, stay out of
      // their way. We'll miss an update, but that's okay,
      // because they're about to set a new value.
      return !this._isEditing;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          model = _this$props2.model,
          isDetailed = _this$props2.isDetailed;
      var pendingValue = this.state.pendingValue;
      var displayValue = model.get("fan_speed");

      if (pendingValue != null) {
        displayValue = pendingValue;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
        isDetailed: isDetailed
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_Slider__["a" /* default */], {
        min: 0,
        max: 99,
        step: model.get("fan_speed_increment"),
        value: displayValue,
        formatValue: this._formatValue,
        onDragStart: this._handleDragStart,
        onDragEnd: this._handleDragEnd,
        style: sliderStyle
      }));
    }
  }]);

  return Fan;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Fan, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired // () => void

});



/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LockAndUnlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_SlideToUnlock__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);













var LockAndUnlock =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(LockAndUnlock, _React$Component);

  function LockAndUnlock() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, LockAndUnlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(LockAndUnlock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      pendingLockedValue: null
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(LockAndUnlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "_setPendingLockedValue",
    value: function _setPendingLockedValue(pendingLockedValue) {
      if (!this._isMounted) {
        return;
      }

      this.setState({
        pendingLockedValue: pendingLockedValue
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          model = _this$props.model,
          isDetailed = _this$props.isDetailed,
          showSpinner = _this$props.showSpinner,
          hideSpinner = _this$props.hideSpinner;
      var pendingLockedValue = this.state.pendingLockedValue;
      var isLocked = model.get("isLocked");
      var isUnlocked = model.get("isUnlocked");
      var action;
      var message;

      if (!isLocked) {
        action = function action() {
          _this2._setPendingLockedValue(true);

          var resetPending = function resetPending() {
            _this2._setPendingLockedValue(null);
          };

          return model.lock().then(resetPending, resetPending);
        };

        message = "Locking '".concat(model.get("name"), "'");
      } else {
        action = function action() {
          _this2._setPendingLockedValue(false);

          var resetPending = function resetPending() {
            _this2._setPendingLockedValue(null);
          };

          return model.unlock().then(resetPending, resetPending);
        };

        message = "Unlocking '".concat(model.get("name"), "'");
      }

      var locked = pendingLockedValue == null ? isLocked : pendingLockedValue;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
        isDetailed: isDetailed
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_SlideToUnlock__["a" /* default */], {
        disabled: !isLocked && !isUnlocked,
        locked: locked,
        onChange: function onChange() {
          showSpinner(message);
          action().then(hideSpinner, hideSpinner);
        }
      }));
    }
  }]);

  return LockAndUnlock;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(LockAndUnlock, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired // () => void

});



/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LockLockButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Controls_DeviceControlButton__ = __webpack_require__(74);












var LockLockButton =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(LockLockButton, _React$Component);

  function LockLockButton() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, LockLockButton);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(LockLockButton).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(LockLockButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          model = _this$props.model,
          isDetailed = _this$props.isDetailed,
          showSpinner = _this$props.showSpinner,
          hideSpinner = _this$props.hideSpinner;
      var isLocked = model.get("isLocked");
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
        isDetailed: isDetailed
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Controls_DeviceControlButton__["a" /* default */], {
        alert: true,
        buttonLabel: "Lock",
        disabled: isLocked,
        onTap: function onTap() {
          showSpinner("Locking '".concat(model.get("name"), "'"));
          model.lock().then(hideSpinner, hideSpinner);
        }
      }));
    }
  }]);

  return LockLockButton;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(LockLockButton, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired // () => void

});



/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_DeviceControlButton__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_history__ = __webpack_require__(31);







var MultiCamera = function MultiCamera(_ref) {
  var model = _ref.model,
      isDetailed = _ref.isDetailed;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
    isDetailed: isDetailed
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_DeviceControlButton__["a" /* default */], {
    buttonLabel: "Show Videos",
    onTap: function onTap() {
      __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_history__["d" /* history */].push("/app/multi-video-feed", {
        group: model
      });
    },
    disabled: !model.getGroupMembers().any(function (child) {
      return child.isConnected();
    })
  }));
};

MultiCamera.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (MultiCamera);

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Controls_DeviceControlButton__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_safelyOpen__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nx_components_UserAgent__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_Dialogs_AlertDialog__ = __webpack_require__(218);
















var NestCamera =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(NestCamera, _React$Component);

  function NestCamera() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, NestCamera);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(NestCamera).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(NestCamera, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.determineVideoLaunchStrategy();
    }
  }, {
    key: "determineVideoLaunchStrategy",
    value: function determineVideoLaunchStrategy() {
      var _this = this;

      // We need to decide this ahead of time because WKWebView will only
      // care about safelyOpen calls that happened as the result of user
      // interaction, and going async with the _isNestInstalled Promise
      // will lose that context.
      if (__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_platform__["a" /* default */].isMobilePlatform()) {
        this._isNestInstalled().then(function (isInstalled) {
          if (isInstalled) {
            _this._launchVideo = _this._launchNestInApp;
          } else {
            _this._launchVideo = _this._showDialog;
          }
        })["catch"](function () {
          // if a platform bridge error occured we can't verify if Nest exists, so assume not
          _this._launchVideo = _this._showDialog;
        });
      } else {
        this._launchVideo = this._launchNestInBrowser;
      }
    }
  }, {
    key: "_launchNestInApp",
    value: function _launchNestInApp() {
      return Object(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_safelyOpen__["a" /* default */])(this.props.model.get("streamAppUrl"));
    }
  }, {
    key: "_launchNestInBrowser",
    value: function _launchNestInBrowser() {
      return Object(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_safelyOpen__["a" /* default */])(this.props.model.get("streamWebUrl"));
    }
  }, {
    key: "_isNestInstalled",
    value: function _isNestInstalled() {
      if (!this._mobilePlatformSupportsNest()) {
        return Promise.resolve(false);
      }

      return __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_platform__["a" /* default */].hasAppInstalled("nest");
    }
  }, {
    key: "_mobilePlatformSupportsNest",
    value: function _mobilePlatformSupportsNest() {
      return !__WEBPACK_IMPORTED_MODULE_13_nx_components_UserAgent__["a" /* default */].isWindows();
    }
  }, {
    key: "_showDialog",
    value: function _showDialog() {
      var notAvailable = "The Nest application is not available for your platform.";
      var pleaseInstall = "Please install the Nest application for your platform.";
      var message = this._mobilePlatformSupportsNest() ? pleaseInstall : notAvailable;
      Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_Dialogs_AlertDialog__["b" /* showAlertDialog */])({
        message: message
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          model = _this$props.model,
          isDetailed = _this$props.isDetailed;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
        isDetailed: isDetailed
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Controls_DeviceControlButton__["a" /* default */], {
        buttonLabel: "Show Video",
        disabled: !model.isConnected(),
        needsTrustedTap: true,
        onTap: function onTap() {
          return _this2._launchVideo();
        }
      }));
    }
  }]);

  return NestCamera;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(NestCamera, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (NestCamera);

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_DeviceControlButton__ = __webpack_require__(74);






var NestStructure = function NestStructure(_ref) {
  var model = _ref.model,
      isDetailed = _ref.isDetailed,
      showSpinner = _ref.showSpinner,
      hideSpinner = _ref.hideSpinner;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
    isDetailed: isDetailed
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_DeviceControlButton__["a" /* default */], {
    buttonLabel: model.isHome() ? "Set Away" : "Set Home",
    onTap: function onTap() {
      showSpinner("Setting '".concat(model.get("name"), "' to ").concat(model.isHome() ? "Away" : "Home"));
      model.toggleOccupancy().then(hideSpinner, hideSpinner);
    }
  }));
};

NestStructure.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired // () => void

};
/* harmony default export */ __webpack_exports__["a"] = (NestStructure);

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpeakerDetailControls__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpeakerTileControls__ = __webpack_require__(1127);







var Speaker = function Speaker(_ref) {
  var isDetailed = _ref.isDetailed,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["isDetailed"]);

  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
    isDetailed: isDetailed
  }, isDetailed ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__SpeakerDetailControls__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__SpeakerTileControls__["a" /* default */], props));
};

Speaker.propTypes = {
  isDetailed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Speaker);

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpeakerDetailControls; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nx_components_Slider__ = __webpack_require__(103);














var styles = Object(__WEBPACK_IMPORTED_MODULE_12_nx_components_utils_prefixStyles__["b" /* default */])({
  detailsSpeakerControl: {
    padding: "5em",
    position: "relative",
    flex: "1 1 auto"
  }
});

var SpeakerDetailControls =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(SpeakerDetailControls, _React$Component);

  function SpeakerDetailControls() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SpeakerDetailControls);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SpeakerDetailControls).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SpeakerDetailControls, [{
    key: "onVolumeChanged",
    value: function onVolumeChanged(value) {
      if (value !== this.props.model.get("volume")) {
        this.props.model.setVolume(value);
      }
    }
  }, {
    key: "onPlay",
    value: function onPlay() {
      if (this.props.model.get("is_playing")) {
        this.props.model.pause();
      } else {
        this.props.model.play();
      }
    }
  }, {
    key: "onPrevious",
    value: function onPrevious() {
      this.props.model.seekPrevious();
    }
  }, {
    key: "onNext",
    value: function onNext() {
      this.props.model.seekNext();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var PlayIcon = this.props.model.get("is_playing") ? __WEBPACK_IMPORTED_MODULE_11_nx_components_Icons__["_11" /* IconPause */] : __WEBPACK_IMPORTED_MODULE_11_nx_components_Icons__["_18" /* IconPlay */];
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.detailsSpeakerControl
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_Button__["a" /* default */], {
        disabled: !this.props.model.canSeekPrevious(),
        onTap: function onTap() {
          return _this.onPrevious();
        }
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nx_components_Icons__["_26" /* IconRewind */], null)), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_Button__["a" /* default */], {
        onTap: function onTap() {
          return _this.onPlay();
        }
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](PlayIcon, null)), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_Button__["a" /* default */], {
        disabled: !this.props.model.canSeekNext(),
        onTap: function onTap() {
          return _this.onNext();
        }
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nx_components_Icons__["O" /* IconFastForward */], null))), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nx_components_Slider__["a" /* default */], {
        min: "0",
        max: "100",
        value: this.props.model.get("volume"),
        formatValue: function formatValue(value) {
          return "Volume ".concat(value, "%");
        },
        onChange: function onChange(value) {
          return _this.onVolumeChanged(value);
        },
        onDragStart: function onDragStart() {
          return Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__["a" /* default */])("DISABLE_LOCATION_POLLING");
        },
        onDragEnd: function onDragEnd() {
          return Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
        }
      }));
    }
  }]);

  return SpeakerDetailControls;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(SpeakerDetailControls, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Model).isRequired
});



/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpeakerTileControls; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nx_components_Slider__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);















var sliderStyle = Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__["b" /* default */])({
  flex: "1 0 auto",
  margin: "1em 0.5em"
});

var SpeakerTileControls =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SpeakerTileControls, _React$Component);

  function SpeakerTileControls() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SpeakerTileControls);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SpeakerTileControls)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      showVolumeSlider: false
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "hideVolumeSliderEventually", _.debounce(function () {
      if (!_this._isMounted) {
        return;
      } // if no volume changes have been made for 5 seconds, hide the volume slider.


      _this.setState({
        showVolumeSlider: false
      });
    }, 5000));

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SpeakerTileControls, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "getVolumeIcon",
    value: function getVolumeIcon(volume) {
      if (volume > 75) {
        return __WEBPACK_IMPORTED_MODULE_13_nx_components_Icons__["_53" /* IconVolumeHigh */];
      }

      if (volume > 30) {
        return __WEBPACK_IMPORTED_MODULE_13_nx_components_Icons__["_55" /* IconVolumeMedium */];
      }

      if (volume > 0) {
        return __WEBPACK_IMPORTED_MODULE_13_nx_components_Icons__["_54" /* IconVolumeLow */];
      }

      return __WEBPACK_IMPORTED_MODULE_13_nx_components_Icons__["_56" /* IconVolumeMute */];
    }
  }, {
    key: "momentarilyShowVolumeSlider",
    value: function momentarilyShowVolumeSlider() {
      this.setState({
        showVolumeSlider: true
      });
      this.hideVolumeSliderEventually();
    }
  }, {
    key: "onVolumeChanged",
    value: function onVolumeChanged(value) {
      this.momentarilyShowVolumeSlider(); // wait 5 seconds after every change.

      if (value !== this.props.model.get("volume")) {
        this.props.model.setVolume(value);
      }
    }
  }, {
    key: "onPlay",
    value: function onPlay() {
      if (this.props.model.get("is_playing")) {
        this.props.model.pause();
      } else {
        this.props.model.play();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isPlaying = this.props.model.get("is_playing");
      var volume = this.props.model.get("volume");
      var VolumeIcon = this.getVolumeIcon(volume);
      var volumeControl;

      if (this.state.showVolumeSlider) {
        volumeControl = __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nx_components_Slider__["a" /* default */], {
          min: "0",
          max: "100",
          value: volume,
          onChange: function onChange(value) {
            return _this2.onVolumeChanged(value);
          },
          onDragStart: function onDragStart() {
            return Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_dispatch__["a" /* default */])("DISABLE_LOCATION_POLLING");
          },
          onDragEnd: function onDragEnd() {
            return Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
          },
          formatValue: function formatValue(value) {
            return "Volume ".concat(value, "%");
          },
          style: sliderStyle
        });
      } else {
        volumeControl = __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nx_components_Tappable__["b" /* default */], {
          onTap: function onTap() {
            return _this2.momentarilyShowVolumeSlider();
          }
        }, function (_ref) {
          var tapTargetRefHandler = _ref.tapTargetRefHandler;
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
            className: "device-control-disclosure",
            ref: tapTargetRefHandler,
            tabIndex: "0"
          }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](VolumeIcon, {
            className: "device-control-disclosure-action"
          }));
        });
      }

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nx_components_Tappable__["b" /* default */], {
        onTap: function onTap() {
          return _this2.onPlay();
        }
      }, function (_ref2) {
        var tapTargetRefHandler = _ref2.tapTargetRefHandler,
            active = _ref2.active;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          className: "device-control-disclosure",
          ref: tapTargetRefHandler,
          tabIndex: "0",
          style: {
            backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_Tappable__["c" /* simpleActiveBackgroundColor */])(active)
          }
        }, isPlaying ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nx_components_Icons__["_11" /* IconPause */], {
          className: "device-control-disclosure-action"
        }) : __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nx_components_Icons__["_18" /* IconPlay */], {
          className: "device-control-disclosure-action"
        }));
      }), volumeControl);
    }
  }]);

  return SpeakerTileControls;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SpeakerTileControls, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_backbone___default.a.Model).isRequired
});



/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Controls_DeviceControlButton__ = __webpack_require__(74);







var styles = Object(__WEBPACK_IMPORTED_MODULE_4_nx_components_utils_prefixStyles__["b" /* default */])({
  wrapper: {
    fontSize: "0.8em",
    display: "flex"
  },
  detailButtonOn: {
    marginRight: "0.25em",
    flexGrow: "1",
    flexBasis: "100%"
  },
  detailButtonOff: {
    marginLeft: "0.25em",
    flexGrow: "1",
    flexBasis: "100%"
  }
});

var Switch = function Switch(_ref) {
  var model = _ref.model,
      isDetailed = _ref.isDetailed,
      showSpinner = _ref.showSpinner,
      hideSpinner = _ref.hideSpinner;

  if (isDetailed && model.canSetOnAndOffSeparately()) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
      isDetailed: isDetailed
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
      style: styles.wrapper
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nx_components_Button__["a" /* default */], {
      style: styles.detailButtonOn,
      onTap: function onTap() {
        showSpinner("Turning on '".concat(model.get("name"), "'"));
        model.turnOn().then(hideSpinner, hideSpinner);
      }
    }, "Turn On"), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nx_components_Button__["a" /* default */], {
      style: styles.detailButtonOff,
      onTap: function onTap() {
        showSpinner("Turning off '".concat(model.get("name"), "'"));
        model.turnOff().then(hideSpinner, hideSpinner);
      }
    }, "Turn Off")));
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
      isDetailed: isDetailed
    }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Controls_DeviceControlButton__["a" /* default */], {
      buttonLabel: model.isOn() ? "Turn Off" : "Turn On",
      onTap: function onTap() {
        showSpinner("Turning ".concat(model.isOn() ? "off" : "on", " '").concat(model.get("name"), "'"));
        model.toggle().then(hideSpinner, hideSpinner);
      }
    }));
  }
};

Switch.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired // () => void

};
/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_TileControlWrapper__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThermostatDetailControls__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThermostatTileControlsWrapper__ = __webpack_require__(1137);







var Thermostat = function Thermostat(_ref) {
  var isDetailed = _ref.isDetailed,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["isDetailed"]);

  return isDetailed ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ThermostatDetailControls__["a" /* default */], props) : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_TileControlWrapper__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ThermostatTileControlsWrapper__["a" /* default */], props));
};

Thermostat.propTypes = {
  isDetailed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Thermostat);

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OccupanySetpointController__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_Thermostat_ThermostatSetpoints__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Details_DetailsSection__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);


















var ThermostatDetailControls =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ThermostatDetailControls, _React$Component);

  function ThermostatDetailControls() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ThermostatDetailControls);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ThermostatDetailControls)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "languageContext", _this.context);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "language", _this.languageContext.localeSet.nexia_mobile.controls.ThermostatDetailControls);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      pendingHeatValue: null,
      pendingCoolValue: null
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isEditing", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChangesStarted", function () {
      _this._isEditing = true;
      Object(__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_flux_like_dispatch__["a" /* default */])("DISABLE_LOCATION_POLLING");
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChangesEnded", function (_ref) {
      var setpointHeat = _ref.setpointHeat,
          setpointCool = _ref.setpointCool;
      _this._isEditing = false;
      Object(__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
      var _this$props = _this.props,
          model = _this$props.model,
          showSpinner = _this$props.showSpinner,
          hideSpinner = _this$props.hideSpinner;

      if (setpointHeat === model.get("setpoint_heat") && setpointCool === model.get("setpoint_cool")) {
        // They didn't change anything
        return;
      }

      var message;

      if (setpointHeat && setpointCool) {
        message = _this.languageContext.template(_this.language.heatAndCoolToTemplate, {
          setpointHeat: setpointHeat,
          setpointCool: setpointCool
        });
      } else if (setpointHeat) {
        message = _this.languageContext.template(_this.language.heatToTemplate, {
          setpointHeat: setpointHeat
        });
      } else if (setpointCool) {
        message = _this.languageContext.template(_this.language.coolToTemplate, {
          setpointCool: setpointCool
        });
      }

      _this.setState({
        pendingHeatValue: setpointHeat,
        pendingCoolValue: setpointCool
      });

      showSpinner(message);

      var onDone = function onDone() {
        _this.setState({
          pendingHeatValue: null,
          pendingCoolValue: null
        });

        hideSpinner();
      };

      model.setSetpoints({
        heat: setpointHeat,
        cool: setpointCool
      }).then(onDone, onDone);
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChangesCanceled", function () {
      _this._isEditing = false;
      Object(__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ThermostatDetailControls, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      // If the user is currently changing their setpoint, don't
      // override the setpoint with a new value, because it's
      // annoying to change stuff while the user is changing it.
      // We miss an update, but since they're about to
      // set a new value, that's fine.
      return !this._isEditing;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          model = _this$props2.model,
          isScreenReaderRunning = _this$props2.isScreenReaderRunning;
      var _this$state = this.state,
          pendingHeatValue = _this$state.pendingHeatValue,
          pendingCoolValue = _this$state.pendingCoolValue;

      if (model.get("is_connected") === false) {
        return null;
      }

      var changeBufferMs;

      if (__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_platform__["a" /* default */].canDetectIfScreenReaderIsRunning() && isScreenReaderRunning) {
        changeBufferMs = 6000;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__OccupanySetpointController__["a" /* default */], {
        model: model
      }, function (_ref2) {
        var setpointCoolMin = _ref2.setpointCoolMin,
            setpointCoolMax = _ref2.setpointCoolMax,
            setpointHeatMin = _ref2.setpointHeatMin,
            setpointHeatMax = _ref2.setpointHeatMax;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Details_DetailsSection__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nx_components_Thermostat_ThermostatSetpoints__["a" /* default */], {
          setpointCool: pendingCoolValue || model.get("setpoint_cool"),
          setpointCoolMin: setpointCoolMin,
          setpointCoolMax: setpointCoolMax,
          setpointDelta: model.get("setpoint_delta"),
          setpointHeat: pendingHeatValue || model.get("setpoint_heat"),
          setpointHeatMin: setpointHeatMin,
          setpointHeatMax: setpointHeatMax,
          setpointIncrement: model.get("setpoint_increment"),
          onChangesStarted: _this2.handleChangesStarted,
          onChangesEnded: _this2.handleChangesEnded,
          onChangesCanceled: _this2.handleChangesCanceled,
          changeBufferMs: changeBufferMs
        }));
      });
    }
  }]);

  return ThermostatDetailControls;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ThermostatDetailControls, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_backbone___default.a.Model).isRequired,
  isScreenReaderRunning: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  showSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired // () => void

});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  isScreenReaderRunning: "isScreenReaderRunning"
}, ThermostatDetailControls));
ThermostatDetailControls.contextType = __WEBPACK_IMPORTED_MODULE_16_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */];

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrecisionSlider__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);





var ThermostatSetpointControls = function ThermostatSetpointControls(props) {
  var colors = props.colors,
      setpointIncrement = props.setpointIncrement,
      setpointCoolMin = props.setpointCoolMin,
      setpointCoolMax = props.setpointCoolMax,
      setpointCool = props.setpointCool,
      setpointHeatMin = props.setpointHeatMin,
      setpointHeatMax = props.setpointHeatMax,
      setpointHeat = props.setpointHeat,
      onCoolValue = props.onCoolValue,
      onHeatValue = props.onHeatValue,
      onChangesStarted = props.onChangesStarted,
      onChangesEnd = props.onChangesEnd,
      formatter = props.formatter,
      changeBufferMs = props.changeBufferMs,
      valueStyle = props.valueStyle,
      hasAriaControls = props.hasAriaControls;
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3__ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nx_components.ThermostatSetpointControls;
  var valuesRegionId = "nx-components_ThermostatSetpoints_values";
  var ariaControls = hasAriaControls ? valuesRegionId : undefined;
  var styles = {
    cool: {
      color: colors.COOL
    },
    heat: {
      marginTop: "0.5em",
      color: colors.HEAT
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, setpointCool ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PrecisionSlider__["a" /* default */], {
    hasOffState: false,
    label: "".concat(language.coolTo, ":"),
    unit: "\xB0",
    step: setpointIncrement,
    min: setpointCoolMin,
    max: setpointCoolMax,
    value: setpointCool,
    onValue: onCoolValue,
    onChangesStarted: onChangesStarted,
    onChangesEnded: onChangesEnd,
    formatter: formatter,
    changeBufferMs: changeBufferMs,
    valueStyle: valueStyle,
    style: styles.cool,
    isCool: true,
    "aria-controls": ariaControls
  }) : null, setpointHeat ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PrecisionSlider__["a" /* default */], {
    hasOffState: false,
    label: "".concat(language.heatTo, ":"),
    unit: "\xB0",
    step: setpointIncrement,
    min: setpointHeatMin,
    max: setpointHeatMax,
    value: setpointHeat,
    onValue: onHeatValue,
    onChangesStarted: onChangesStarted,
    onChangesEnded: onChangesEnd,
    formatter: formatter,
    changeBufferMs: changeBufferMs,
    valueStyle: valueStyle,
    style: styles.heat,
    isHeat: true,
    "aria-controls": ariaControls
  }) : null);
};

ThermostatSetpointControls.propTypes = {
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_1__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_1__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_1__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_1__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_1__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  },
  setpointIncrement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
  setpointCoolMin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  setpointCoolMax: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  setpointCool: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  setpointHeatMin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  setpointHeatMax: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  setpointHeat: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  onCoolValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  onHeatValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  onChangesStarted: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  onChangesEnd: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
  formatter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  changeBufferMs: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
  valueStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  hasAriaControls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__ColorsProvider__["c" /* withColorsProvider */])(ThermostatSetpointControls));



/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrecisionSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_baconjs__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_baconjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_baconjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DumbPrecisionSlider__ = __webpack_require__(1133);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





/* eslint-disable no-unused-vars */

var _ref = // PropTypes are added as a babel compilation step
__WEBPACK_IMPORTED_MODULE_12__DumbPrecisionSlider__["a" /* default */].propTypes || {},
    onDown = _ref.onDown,
    onUp = _ref.onUp,
    onSliderChange = _ref.onSliderChange,
    onDragStart = _ref.onDragStart,
    onDragEnd = _ref.onDragEnd,
    propTypesFromDumbPrecisionSlider = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["onDown", "onUp", "onSliderChange", "onDragStart", "onDragEnd"]);
/* eslint-enable no-unused-vars */


var PrecisionSlider =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(PrecisionSlider, _React$Component);

  function PrecisionSlider() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, PrecisionSlider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(PrecisionSlider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      value: _this.props.value
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChange", function (value) {
      _this._valuesStream.push(value);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleUp", function () {
      _this._valuesStream.push(_this.state.value + _this.props.step);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDown", function () {
      _this._valuesStream.push(_this.state.value - _this.props.step);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDragStart", function () {
      _this._aborted = false;

      _this._isNotPressedStream.push(false);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDragEnd", function (value, aborted) {
      if (aborted) {
        _this._aborted = true; // streams are hard, I'm in a hurry

        _this._valuesStream.push(value);
      }

      _this._isNotPressedStream.push(true);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(PrecisionSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._setUpBacon();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.changeBufferMs === this.props.changeBufferMs) {
        return;
      }

      this._tearDownBacon();

      this._setUpBacon();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._tearDownBacon();
    }
  }, {
    key: "_setUpBacon",
    value: function _setUpBacon() {
      var _this2 = this;

      this._valuesStream = new __WEBPACK_IMPORTED_MODULE_11_baconjs___default.a.Bus(); // contains values (numeric)

      this._isNotPressedStream = new __WEBPACK_IMPORTED_MODULE_11_baconjs___default.a.Bus();

      this._valuesStream.onValue(function (targetValue) {
        var clampedValue = Math.max(_this2.props.min, Math.min(_this2.props.max, targetValue));

        if (_this2.state.value !== clampedValue) {
          _this2.setState({
            value: clampedValue
          });
        }

        if (_this2.props.onValue) {
          _this2.props.onValue(clampedValue);
        }
      });

      var isNotPressed = this._isNotPressedStream.toProperty(true);

      var startEvents = this._valuesStream.merge(this._isNotPressedStream).debounceImmediate(this.props.changeBufferMs).map(function () {
        return "start";
      });

      var endEvents = this._valuesStream.merge(this._isNotPressedStream).debounce(this.props.changeBufferMs).filter(isNotPressed).map(function () {
        return "end";
      });

      startEvents.merge(endEvents).skipDuplicates().onValue(function (event) {
        if (event === "start" && _this2.props.onChangesStarted) {
          _this2.props.onChangesStarted();
        } else if (event === "end" && _this2.props.onChangesEnded) {
          _this2.props.onChangesEnded(_this2._aborted);
        }
      });
    }
  }, {
    key: "_tearDownBacon",
    value: function _tearDownBacon() {
      this._valuesStream.end();

      this._isNotPressedStream.end();
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__DumbPrecisionSlider__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        value: this.state.value,
        onSliderChange: this.handleChange,
        onUp: this.handleUp,
        onDown: this.handleDown,
        onDragStart: this.handleDragStart,
        onDragEnd: this.handleDragEnd
      }));
    }
  }]);

  return PrecisionSlider;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(PrecisionSlider, "propTypes", _objectSpread({}, propTypesFromDumbPrecisionSlider, {
  // Called when the user starts interacting with the controls
  onChangesStarted: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  // Called after the user has interacted with the controls
  // and then hasn't touched them for `changeBufferMs` ms
  onChangesEnded: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  // Called whenever some user interaction updates the value.
  // Useful if you need to aggregate and debounce changes from
  // multiple sliders.
  onValue: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  changeBufferMs: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number
}));

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(PrecisionSlider, "defaultProps", {
  min: 0,
  max: 100,
  value: 0,
  step: 1,
  unit: "",
  changeBufferMs: 2000
});



/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Slider__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NumericUpDownPicker__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var DumbPrecisionSlider =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DumbPrecisionSlider, _React$Component);

  function DumbPrecisionSlider() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DumbPrecisionSlider);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DumbPrecisionSlider).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DumbPrecisionSlider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          hasOffState = _this$props.hasOffState,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step,
          unit = _this$props.unit,
          label = _this$props.label,
          onDown = _this$props.onDown,
          onUp = _this$props.onUp,
          onSliderChange = _this$props.onSliderChange,
          onDragStart = _this$props.onDragStart,
          onDragEnd = _this$props.onDragEnd,
          formatter = _this$props.formatter,
          style = _this$props.style,
          valueStyle = _this$props.valueStyle,
          upButtonStyle = _this$props.upButtonStyle,
          downButtonStyle = _this$props.downButtonStyle,
          isHeat = _this$props.isHeat,
          isCool = _this$props.isCool,
          sliderStyle = _this$props.sliderStyle,
          ariaControls = _this$props["aria-controls"],
          colors = _this$props.colors;
      var styles = {
        wrapper: _objectSpread({
          outline: "none"
        }, style),
        label: Object(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["b" /* default */])({
          color: colors.LABEL,
          fontSize: 16,
          userSelect: "none"
        }),
        controlsWrapper: Object(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["b" /* default */])({
          display: "flex"
        }),
        value: Object(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["b" /* default */])(_objectSpread({
          fontSize: 35,
          userSelect: "none"
        }, valueStyle)),
        slider: _objectSpread({
          marginTop: 10,
          marginLeft: 15,
          marginRight: 15
        }, __WEBPACK_IMPORTED_MODULE_10__Theme__["a" /* default */].Styles.flexStretch, {}, sliderStyle),
        upButton: _objectSpread({}, upButtonStyle),
        downButton: _objectSpread({
          marginRight: "0.4em"
        }, downButtonStyle)
      };
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "PrecisionSlider",
        tabIndex: "0",
        style: styles.wrapper
      }, label && __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.label
      }, label), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.controlsWrapper
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
        style: styles.value
      }, formatter ? formatter(value) : "".concat(value).concat(unit || "")), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Slider__["a" /* default */], {
        hasOffState: hasOffState,
        style: styles.slider,
        min: min,
        max: max,
        step: step,
        value: value,
        onChange: onSliderChange,
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        isHeat: isHeat,
        isCool: isCool
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__NumericUpDownPicker__["a" /* default */], {
        onUp: onUp,
        onDown: onDown,
        upDisabled: value + step > max,
        downDisabled: value - step < min,
        upButtonStyle: styles.upButton,
        downButtonStyle: styles.downButton,
        "aria-controls": ariaControls
      })));
    }
  }]);

  return DumbPrecisionSlider;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DumbPrecisionSlider, "defaultProps", {
  step: 1
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DumbPrecisionSlider, "propTypes", {
  value: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired,
  hasOffState: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool.isRequired,
  min: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired,
  max: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired,
  step: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number,
  unit: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.node,
  onDown: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
  onUp: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
  onSliderChange: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
  onDragStart: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
  onDragEnd: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
  formatter: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  valueStyle: function valueStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  upButtonStyle: function upButtonStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  downButtonStyle: function downButtonStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  sliderStyle: function sliderStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  isHeat: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  isCool: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  "\"aria-controls\"": __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["c" /* withColorsProvider */])(DumbPrecisionSlider));




/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PivotNumericUpDownPicker__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextWrappers_UserLanguageContext__ = __webpack_require__(34);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center"
  },
  contents: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
  }
};

var PivotThermostatSetpointControls = function PivotThermostatSetpointControls(_ref) {
  var setpointIncrement = _ref.setpointIncrement,
      setpointCoolMin = _ref.setpointCoolMin,
      setpointCoolMax = _ref.setpointCoolMax,
      setpointCool = _ref.setpointCool,
      setpointHeatMin = _ref.setpointHeatMin,
      setpointHeatMax = _ref.setpointHeatMax,
      setpointHeat = _ref.setpointHeat,
      onCoolValue = _ref.onCoolValue,
      onHeatValue = _ref.onHeatValue,
      onChangesStarted = _ref.onChangesStarted,
      onChangesEnd = _ref.onChangesEnd,
      changeBufferMs = _ref.changeBufferMs,
      valueStyle = _ref.valueStyle,
      hasAriaControls = _ref.hasAriaControls,
      occuLabelStyle = _ref.occuLabelStyle,
      occuLabel = _ref.occuLabel;
  var valuesRegionId = "nx-components_ThermostatSetpoints_values";
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nx_components.PivotThermostatSetpointControls;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    style: styles.container
  }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
    style: _objectSpread({}, styles.contents, {}, occuLabelStyle)
  }, occuLabel), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    style: styles.contents
  }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PivotNumericUpDownPicker__["a" /* default */], {
    label: "".concat(language.heatTo, ":"),
    unit: "\xB0",
    step: setpointIncrement,
    min: setpointHeatMin,
    max: setpointHeatMax,
    value: setpointHeat,
    onValue: onHeatValue,
    onChangesStarted: onChangesStarted,
    onChangesEnded: onChangesEnd,
    changeBufferMs: changeBufferMs,
    valueStyle: valueStyle,
    isHeat: true,
    "aria-controls": hasAriaControls ? valuesRegionId : undefined
  }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PivotNumericUpDownPicker__["a" /* default */], {
    label: "".concat(language.coolTo, ":"),
    unit: "\xB0",
    step: setpointIncrement,
    min: setpointCoolMin,
    max: setpointCoolMax,
    value: setpointCool,
    onValue: onCoolValue,
    onChangesStarted: onChangesStarted,
    onChangesEnded: onChangesEnd,
    changeBufferMs: changeBufferMs,
    valueStyle: valueStyle,
    isCool: true,
    "aria-controls": hasAriaControls ? valuesRegionId : undefined
  })));
};

PivotThermostatSetpointControls.propTypes = {
  setpointIncrement: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  setpointCoolMin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  setpointCoolMax: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  setpointCool: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  setpointHeatMin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  setpointHeatMax: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  setpointHeat: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  onCoolValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onHeatValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onChangesStarted: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onChangesEnd: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  changeBufferMs: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  valueStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  hasAriaControls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  occuLabelStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  occuLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (PivotThermostatSetpointControls);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PivotNumericUpDownPicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_baconjs__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_baconjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_baconjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DumbPivotNumericUpDownPicker__ = __webpack_require__(515);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





/* eslint-disable no-unused-vars */

var _ref = __WEBPACK_IMPORTED_MODULE_12__DumbPivotNumericUpDownPicker__["a" /* default */].propTypes || {},
    onDown = _ref.onDown,
    onUp = _ref.onUp,
    propTypesFromDumbPivotNumericUpDownPicker = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["onDown", "onUp"]);
/* eslint-enable no-unused-vars */


var PivotNumericUpDownPicker =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(PivotNumericUpDownPicker, _React$Component);

  function PivotNumericUpDownPicker() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, PivotNumericUpDownPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(PivotNumericUpDownPicker)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      value: _this.props.value
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleUp", function () {
      _this._valuesStream.push(_this.state.value + _this.props.step);
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDown", function () {
      _this._valuesStream.push(_this.state.value - _this.props.step);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(PivotNumericUpDownPicker, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._setUpBacon();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.changeBufferMs === this.props.changeBufferMs) {
        return;
      }

      this._tearDownBacon();

      this._setUpBacon();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._tearDownBacon();
    }
  }, {
    key: "_setUpBacon",
    value: function _setUpBacon() {
      var _this2 = this;

      this._valuesStream = new __WEBPACK_IMPORTED_MODULE_11_baconjs___default.a.Bus(); // contains values (numeric)

      this._isNotPressedStream = new __WEBPACK_IMPORTED_MODULE_11_baconjs___default.a.Bus();

      this._valuesStream.onValue(function (targetValue) {
        var clampedValue = Math.max(_this2.props.min, Math.min(_this2.props.max, targetValue));

        if (_this2.state.value !== clampedValue) {
          _this2.setState({
            value: clampedValue
          });
        }

        if (_this2.props.onValue) {
          _this2.props.onValue(clampedValue);
        }
      });

      var isNotPressed = this._isNotPressedStream.toProperty(true);

      var startEvents = this._valuesStream.merge(this._isNotPressedStream).debounceImmediate(this.props.changeBufferMs).map(function () {
        return "start";
      });

      var endEvents = this._valuesStream.merge(this._isNotPressedStream).debounce(this.props.changeBufferMs).filter(isNotPressed).map(function () {
        return "end";
      });

      startEvents.merge(endEvents).skipDuplicates().onValue(function (event) {
        if (event === "start" && _this2.props.onChangesStarted) {
          _this2.props.onChangesStarted();
        } else if (event === "end" && _this2.props.onChangesEnded) {
          _this2.props.onChangesEnded();
        }
      });
    }
  }, {
    key: "_tearDownBacon",
    value: function _tearDownBacon() {
      this._valuesStream.end();

      this._isNotPressedStream.end();
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__DumbPivotNumericUpDownPicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        value: this.state.value,
        onUp: this.handleUp,
        onDown: this.handleDown
      }));
    }
  }]);

  return PivotNumericUpDownPicker;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(PivotNumericUpDownPicker, "propTypes", _objectSpread({}, propTypesFromDumbPivotNumericUpDownPicker, {
  // Called when the user starts interacting with the controls
  onChangesStarted: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  // Called after the user has interacted with the controls
  // and then hasn't touched them for `changeBufferMs` ms
  onChangesEnded: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  // Called whenever some user interaction updates the value.
  onValue: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  changeBufferMs: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number
}));

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(PivotNumericUpDownPicker, "defaultProps", {
  min: 55,
  max: 95,
  value: 70,
  step: 1,
  unit: "°",
  changeBufferMs: 2000
});



/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var NumericUpDownPicker =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(NumericUpDownPicker, _React$Component);

  function NumericUpDownPicker() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, NumericUpDownPicker);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(NumericUpDownPicker).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(NumericUpDownPicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onUp = _this$props.onUp,
          onDown = _this$props.onDown,
          upDisabled = _this$props.upDisabled,
          downDisabled = _this$props.downDisabled,
          style = _this$props.style,
          upButtonStyle = _this$props.upButtonStyle,
          downButtonStyle = _this$props.downButtonStyle,
          childWrapperStyle = _this$props.childWrapperStyle,
          label = _this$props.label,
          isHeat = _this$props.isHeat,
          isCool = _this$props.isCool,
          ariaControls = _this$props["aria-controls"],
          colors = _this$props.colors;
      var colorTheme = "black";

      if (isHeat) {
        colorTheme = colors.HEAT;
      } else if (isCool) {
        colorTheme = colors.COOL;
      }

      var iconStyle = {
        cursor: "pointer",
        width: 40,
        height: 40,
        outline: "none"
      };
      var styles = {
        container: Object(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["b" /* default */])(_objectSpread({
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }, style)),
        button: {
          borderRadius: "50%",
          width: "40px",
          margin: "0 auto"
        },
        upButton: _objectSpread({
          color: colorTheme
        }, iconStyle, {}, upButtonStyle, {}, upDisabled ? {
          opacity: "0.5"
        } : null),
        downButton: _objectSpread({
          color: colorTheme
        }, iconStyle, {}, downButtonStyle, {}, downDisabled ? {
          opacity: "0.5"
        } : null),
        labelWrapper: Object(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["b" /* default */])({
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          flexDirection: "row",
          fontSize: 16,
          width: "auto",
          userSelect: "none"
        }),
        childWrapper: Object(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["b" /* default */])(_objectSpread({
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          flexDirection: "row",
          fontSize: 35,
          width: "auto",
          userSelect: "none",
          color: colorTheme
        }, childWrapperStyle))
      };
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.container
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Tappable__["b" /* default */], {
        onTap: onUp
      }, function (_ref) {
        var active = _ref.active,
            tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__NoStyleButton__["a" /* default */], {
          disabled: upDisabled,
          innerRef: tapTargetRefHandler,
          "aria-label": "up",
          "aria-controls": ariaControls,
          style: _objectSpread({}, styles.button, {
            backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_10__Tappable__["c" /* simpleActiveBackgroundColor */])(active)
          })
        }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Icons__["z" /* IconCircledArrowUp */], {
          style: styles.upButton
        }));
      }), label ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
        style: styles.labelWrapper
      }, label) : null, children ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
        style: styles.childWrapper
      }, children) : null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Tappable__["b" /* default */], {
        onTap: onDown
      }, function (_ref2) {
        var active = _ref2.active,
            tapTargetRefHandler = _ref2.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__NoStyleButton__["a" /* default */], {
          disabled: downDisabled,
          innerRef: tapTargetRefHandler,
          "aria-label": "down",
          "aria-controls": ariaControls,
          style: _objectSpread({}, styles.button, {
            backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_10__Tappable__["c" /* simpleActiveBackgroundColor */])(active)
          })
        }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Icons__["y" /* IconCircledArrowDown */], {
          style: styles.downButton
        }));
      }));
    }
  }]);

  return NumericUpDownPicker;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(NumericUpDownPicker, "propTypes", {
  children: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.node,
  onUp: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
  onDown: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
  upDisabled: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  downDisabled: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  upButtonStyle: function upButtonStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  downButtonStyle: function downButtonStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  childWrapperStyle: function childWrapperStyle() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  label: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.node,
  isHeat: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  isCool: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  "\"aria-controls\"": __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["c" /* withColorsProvider */])(NumericUpDownPicker));




/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OccupanySetpointController__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_Thermostat_TileControls__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);








var _class, _temp;









/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  isScreenReaderRunning: "isScreenReaderRunning"
}, (_temp = _class =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ThermostatTileControlsWrapper, _React$Component);

  function ThermostatTileControlsWrapper() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ThermostatTileControlsWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ThermostatTileControlsWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      pendingHeatValue: null,
      pendingCoolValue: null
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_isEditing", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChangesStarted", function () {
      Object(__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_flux_like_dispatch__["a" /* default */])("DISABLE_LOCATION_POLLING");
      _this._isEditing = true;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChangesEnded", function (_ref) {
      var setpointHeat = _ref.setpointHeat,
          setpointCool = _ref.setpointCool;
      Object(__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
      _this._isEditing = false;
      var _this$props = _this.props,
          model = _this$props.model,
          showSpinner = _this$props.showSpinner,
          hideSpinner = _this$props.hideSpinner;

      if (setpointHeat === model.get("setpoint_heat") && setpointCool === model.get("setpoint_cool")) {
        // They didn't change anything
        return;
      }

      _this.setState({
        pendingHeatValue: setpointHeat,
        pendingCoolValue: setpointCool
      });

      showSpinner();

      var onDone = function onDone() {
        _this.setState({
          pendingHeatValue: null,
          pendingCoolValue: null
        });

        hideSpinner();
      };

      model.setSetpoints({
        heat: setpointHeat,
        cool: setpointCool
      }).then(onDone, onDone);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ThermostatTileControlsWrapper, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      // If the user is currently changing their setpoint, don't
      // override the setpoint with a new value, because it's
      // annoying to change stuff while the user is changing it.
      // We miss an update, but since they're about to
      // set a new value, that's fine.
      return !this._isEditing;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          model = _this$props2.model,
          isScreenReaderRunning = _this$props2.isScreenReaderRunning;
      var _this$state = this.state,
          pendingHeatValue = _this$state.pendingHeatValue,
          pendingCoolValue = _this$state.pendingCoolValue;
      var changeBufferMs;

      if (__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_platform__["a" /* default */].canDetectIfScreenReaderIsRunning() && isScreenReaderRunning) {
        changeBufferMs = 6000;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__OccupanySetpointController__["a" /* default */], {
        model: model
      }, function (_ref2) {
        var setpointCoolMin = _ref2.setpointCoolMin,
            setpointCoolMax = _ref2.setpointCoolMax,
            setpointHeatMin = _ref2.setpointHeatMin,
            setpointHeatMax = _ref2.setpointHeatMax,
            occupancyMode = _ref2.occupancyMode;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nx_components_Thermostat_TileControls__["a" /* default */], {
          isConnected: model.get("is_connected"),
          setpointHeat: pendingHeatValue || model.get("setpoint_heat"),
          setpointHeatMin: setpointHeatMin,
          setpointHeatMax: setpointHeatMax,
          setpointCool: pendingCoolValue || model.get("setpoint_cool"),
          setpointCoolMin: setpointCoolMin,
          setpointCoolMax: setpointCoolMax,
          setpointDelta: model.get("setpoint_delta"),
          setpointIncrement: model.get("setpoint_increment"),
          setpointLimitEnabled: model.get("setpoint_limit_enabled"),
          setpointLimit: model.get("setpoint_limit"),
          occupancyMode: occupancyMode,
          onChangesStarted: _this2.handleChangesStarted,
          onChangesEnded: _this2.handleChangesEnded,
          changeBufferMs: changeBufferMs
        });
      });
    }
  }]);

  return ThermostatTileControlsWrapper;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]), __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_class, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_backbone___default.a.Model).isRequired,
  isScreenReaderRunning: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  showSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  // () => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired // () => void

}), _temp)));

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_baconjs__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_baconjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_baconjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__calculateSetpoint__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TileControl__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var ThermostatTileControls =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ThermostatTileControls, _React$Component);

  function ThermostatTileControls() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ThermostatTileControls);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ThermostatTileControls)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      selectedSetpoint: null,
      // "heat", "cool"
      setpointHeat: _this.props.setpointHeat,
      // number
      setpointCool: _this.props.setpointCool // number

    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleHeatUp", function () {
      if (_this._heatChanged) {
        _this._heatChanged.push(_this.props.setpointIncrement);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleHeatDown", function () {
      if (_this._heatChanged) {
        _this._heatChanged.push(-_this.props.setpointIncrement);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleCoolUp", function () {
      if (_this._coolChanged) {
        _this._coolChanged.push(_this.props.setpointIncrement);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleCoolDown", function () {
      if (_this._coolChanged) {
        _this._coolChanged.push(-_this.props.setpointIncrement);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleSetpointChosen", function (kind) {
      if (_this._setpointChosen) {
        _this._setpointChosen.push(kind);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleShowHeat", function () {
      _this.handleSetpointChosen("heat");
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleShowCool", function () {
      _this.handleSetpointChosen("cool");
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ThermostatTileControls, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;

      this._setUpBacon();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        setpointHeat: nextProps.setpointHeat,
        setpointCool: nextProps.setpointCool
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.selectedSetpoint !== this.state.selectedSetpoint && this._focusable != null) {
        this._focusable.focus();
      }

      if (prevProps.changeBufferMs !== this.props.changeBufferMs) {
        this._tearDownBacon();

        this._setUpBacon();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._tearDownBacon();

      this._isMounted = false;
    }
  }, {
    key: "_computeIsConnected",
    value: function _computeIsConnected() {
      var _this$props = this.props,
          setpointHeat = _this$props.setpointHeat,
          setpointCool = _this$props.setpointCool,
          isConnected = _this$props.isConnected;

      if (isConnected != null) {
        return isConnected;
      } else if (setpointHeat || setpointCool) {
        return true;
      }

      return false;
    }
  }, {
    key: "_setUpBacon",
    value: function _setUpBacon() {
      var _this2 = this;

      this._heatChanged = new __WEBPACK_IMPORTED_MODULE_9_baconjs___default.a.Bus();
      this._coolChanged = new __WEBPACK_IMPORTED_MODULE_9_baconjs___default.a.Bus();
      this._setpointChosen = new __WEBPACK_IMPORTED_MODULE_9_baconjs___default.a.Bus(); // This is to make flow happy

      var _heatChanged = this._heatChanged;
      var _coolChanged = this._coolChanged;
      var _setpointChosen = this._setpointChosen;

      _setpointChosen.onValue(function (value) {
        _this2.setState({
          selectedSetpoint: value
        });
      });

      _heatChanged.onValue(function (value) {
        _this2.setState(function (prevState) {
          var targetHeatSetpoint = prevState.setpointHeat + value;

          var info = _objectSpread({}, _this2.props, {}, prevState);

          return Object(__WEBPACK_IMPORTED_MODULE_11__calculateSetpoint__["b" /* updateHeatSetpoint */])(info, targetHeatSetpoint);
        });
      });

      _coolChanged.onValue(function (value) {
        _this2.setState(function (prevState) {
          var targetCoolSetpoint = prevState.setpointCool + value;

          var info = _objectSpread({}, _this2.props, {}, prevState);

          return Object(__WEBPACK_IMPORTED_MODULE_11__calculateSetpoint__["a" /* updateCoolSetpoint */])(info, targetCoolSetpoint);
        });
      });

      var userInteraction = _heatChanged.merge(this._coolChanged).merge(this._setpointChosen);

      var startEvents = userInteraction.debounceImmediate(this.props.changeBufferMs).map(function () {
        return "start";
      });
      var endEvents = userInteraction.debounce(this.props.changeBufferMs).map(function () {
        return "end";
      });
      startEvents.merge(endEvents).skipDuplicates().onValue(function (event) {
        var _this2$state = _this2.state,
            setpointHeat = _this2$state.setpointHeat,
            setpointCool = _this2$state.setpointCool;

        if (event === "start") {
          if (_this2.props.onChangesStarted) {
            _this2.props.onChangesStarted({
              setpointHeat: setpointHeat,
              setpointCool: setpointCool
            });
          }
        } else if (event === "end") {
          if (_this2.props.onChangesEnded) {
            _this2.props.onChangesEnded({
              setpointHeat: setpointHeat,
              setpointCool: setpointCool
            });
          }

          if (_this2._isMounted) {
            _this2.setState({
              selectedSetpoint: null
            });
          }
        }
      });
    }
  }, {
    key: "_tearDownBacon",
    value: function _tearDownBacon() {
      if (this._heatChanged) {
        this._heatChanged.end();
      }

      if (this._coolChanged) {
        this._coolChanged.end();
      }

      if (this._setpointChosen) {
        this._setpointChosen.end();
      }
    }
  }, {
    key: "getMode",
    value: function getMode() {
      var _this$state = this.state,
          setpointHeat = _this$state.setpointHeat,
          setpointCool = _this$state.setpointCool;
      var mode = "off";

      if (this._computeIsConnected()) {
        if (setpointHeat && !setpointCool) {
          mode = "heat";
        } else if (setpointCool && !setpointHeat) {
          mode = "cool";
        } else if (setpointCool && setpointHeat) {
          mode = "auto";
        }
      }

      return mode;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          colors = _this$props2.colors,
          setpointHeatMin = _this$props2.setpointHeatMin,
          setpointHeatMax = _this$props2.setpointHeatMax,
          setpointCoolMin = _this$props2.setpointCoolMin,
          setpointCoolMax = _this$props2.setpointCoolMax,
          setpointIncrement = _this$props2.setpointIncrement,
          occupancyMode = _this$props2.occupancyMode;
      var languageContext = this.context;
      var language = languageContext.localeSet.nx_components.TileControl;
      var _this$state2 = this.state,
          selectedSetpoint = _this$state2.selectedSetpoint,
          setpointHeat = _this$state2.setpointHeat,
          setpointCool = _this$state2.setpointCool;
      var styles = {
        wrapper: {
          color: colors.LABEL,
          textAlign: "center",
          width: "100%"
        },
        content: Object(__WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__["b" /* default */])({
          display: "flex",
          justifyContent: "space-around"
        }),
        occupancyContent: Object(__WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__["b" /* default */])({
          display: "flex",
          justifyContent: "space-around",
          alignItems: "space-around"
        })
      }; // Default values for Flow

      var pickerProps = {
        pickerValue: 70,
        setpointMin: 60,
        setpointMax: 80
      };

      if (selectedSetpoint === "heat") {
        pickerProps = {
          pickerValue: setpointHeat,
          setpointMin: setpointHeatMin,
          setpointMax: setpointHeatMax
        };
      } else if (selectedSetpoint === "cool") {
        pickerProps = {
          pickerValue: setpointCool,
          setpointMin: setpointCoolMin,
          setpointMax: setpointCoolMax
        };
      }

      var mode = this.getMode();
      var content = mode === "off" ? language.Off : __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__TileControl__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
        selectedSetpoint: selectedSetpoint,
        mode: mode,
        occupancyMode: occupancyMode,
        setpointHeat: setpointHeat,
        setpointCool: setpointCool,
        handleShowHeat: this.handleShowHeat,
        handleShowCool: this.handleShowCool,
        handleHeatUp: this.handleHeatUp,
        handleHeatDown: this.handleHeatDown,
        handleCoolUp: this.handleCoolUp,
        handleCoolDown: this.handleCoolDown,
        setpointIncrement: setpointIncrement
      }, pickerProps));
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        "data-component-name": "ThermostatTileControls",
        style: styles.wrapper,
        "aria-live": "polite"
      }, content);
    }
  }]);

  return ThermostatTileControls;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ThermostatTileControls, "defaultProps", {
  changeBufferMs: 2000,
  setpointDelta: 3,
  setpointIncrement: 1
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(ThermostatTileControls, "propTypes", {
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_12__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_12__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_12__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_12__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_12__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  },
  onChangesStarted: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.func,
  onChangesEnded: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.func,
  changeBufferMs: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.number,
  setpointHeat: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.number,
  setpointHeatMin: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.number,
  setpointHeatMax: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.number,
  setpointCool: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.number,
  setpointCoolMin: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.number,
  setpointCoolMax: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.number,
  setpointIncrement: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.number,
  isConnected: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.bool,
  // the delta is used internally by calculateSetpoint
  setpointDelta: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.number,
  // eslint-disable-line react/no-unused-prop-types
  occupancyMode: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.string,
  onOccupancyChange: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.func
});

ThermostatTileControls.contextType = __WEBPACK_IMPORTED_MODULE_14__ContextWrappers_UserLanguageContext__["b" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__ColorsProvider__["c" /* withColorsProvider */])(ThermostatTileControls));



/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TileControl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SetpointPicker__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ValueCallout__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);













var OccupancyIcon =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(OccupancyIcon, _React$Component);

  function OccupancyIcon() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, OccupancyIcon);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(OccupancyIcon).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(OccupancyIcon, [{
    key: "render",
    value: function render() {
      var styles = {
        icon: {
          fontSize: "2.5em"
        }
      };
      var occupancyMode = this.props.occupancyMode;

      if (occupancyMode) {
        if (occupancyMode.toLowerCase() === "occupied") {
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Icons__["_14" /* IconPivotOccupied */], {
            style: styles.icon
          });
        } else {
          return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Icons__["_17" /* IconPivotUnoccupied */], {
            style: styles.icon
          });
        }
      }

      return null;
    }
  }]);

  return OccupancyIcon;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(OccupancyIcon, "propTypes", {
  occupancyMode: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string
});

var TileControl =
/*#__PURE__*/
function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(TileControl, _React$Component2);

  function TileControl() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, TileControl);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(TileControl).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(TileControl, [{
    key: "constructCallouts",
    value: function constructCallouts() {
      var styles = {
        content: Object(__WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__["b" /* default */])({
          display: "flex",
          justifyContent: "space-around",
          alignItems: "space-around"
        })
      };
      var _this$props = this.props,
          mode = _this$props.mode,
          occupancyMode = _this$props.occupancyMode;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.content
      }, mode ? this.getCallout(mode) : null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](OccupancyIcon, {
        occupancyMode: occupancyMode
      }), mode === "auto" ? this.getCallout("cool") : null);
    }
  }, {
    key: "getCallout",
    value: function getCallout(mode) {
      var _this$props2 = this.props,
          setpointHeat = _this$props2.setpointHeat,
          setpointCool = _this$props2.setpointCool,
          handleShowHeat = _this$props2.handleShowHeat,
          handleShowCool = _this$props2.handleShowCool;
      var languageContext = this.context;
      var language = languageContext.localeSet.nx_components.TileControl;
      var isHeatOrAuto = mode === "heat" || mode === "auto";
      var kind = isHeatOrAuto ? "heat" : "cool";
      var label = isHeatOrAuto ? language.Heat : language.Cool;
      var callback = isHeatOrAuto ? handleShowHeat : handleShowCool;
      var setpoint = isHeatOrAuto ? setpointHeat : setpointCool;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ValueCallout__["a" /* default */], {
        key: kind,
        label: label,
        kind: kind,
        value: setpoint,
        onTap: callback
      });
    }
  }, {
    key: "constructPicker",
    value: function constructPicker() {
      var _this$props3 = this.props,
          selectedSetpoint = _this$props3.selectedSetpoint,
          pickerValue = _this$props3.pickerValue,
          handleHeatUp = _this$props3.handleHeatUp,
          handleHeatDown = _this$props3.handleHeatDown,
          handleCoolUp = _this$props3.handleCoolUp,
          handleCoolDown = _this$props3.handleCoolDown,
          setpointIncrement = _this$props3.setpointIncrement,
          setpointMax = _this$props3.setpointMax,
          setpointMin = _this$props3.setpointMin;
      var isHeating = selectedSetpoint === "heat";
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__SetpointPicker__["a" /* default */], {
        value: pickerValue,
        kind: selectedSetpoint || "heat" // Default value keeps Flow happy
        ,
        onUp: isHeating ? handleHeatUp : handleCoolUp,
        onDown: isHeating ? handleHeatDown : handleCoolDown,
        upDisabled: pickerValue + setpointIncrement > setpointMax,
        downDisabled: pickerValue - setpointIncrement < setpointMin
      });
    }
  }, {
    key: "render",
    value: function render() {
      var selectedSetpoint = this.props.selectedSetpoint;
      return selectedSetpoint ? this.constructPicker() : this.constructCallouts();
    }
  }]);

  return TileControl;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(TileControl, "propTypes", {
  selectedSetpoint: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.oneOf(["heat", "cool"]),
  mode: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
  occupancyMode: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.string,
  handleShowHeat: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  handleShowCool: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  handleHeatUp: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  handleHeatDown: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  handleCoolUp: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  handleCoolDown: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func.isRequired,
  setpointHeat: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number,
  setpointCool: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number,
  setpointIncrement: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired,
  pickerValue: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired,
  setpointMin: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired,
  setpointMax: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired
});


TileControl.contextType = __WEBPACK_IMPORTED_MODULE_11__ContextWrappers_UserLanguageContext__["b" /* default */];


/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NumericUpDownPicker__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);










var SetpointPicker =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(SetpointPicker, _React$Component);

  function SetpointPicker() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SetpointPicker);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SetpointPicker).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SetpointPicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          colors = _this$props.colors,
          onUp = _this$props.onUp,
          onDown = _this$props.onDown,
          upDisabled = _this$props.upDisabled,
          downDisabled = _this$props.downDisabled,
          kind = _this$props.kind,
          value = _this$props.value;
      var kindStyles = {
        heat: {
          color: colors.HEAT
        },
        cool: {
          color: colors.COOL
        }
      };
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__NumericUpDownPicker__["a" /* default */], {
        onUp: onUp,
        onDown: onDown,
        upDisabled: upDisabled,
        downDisabled: downDisabled,
        style: kindStyles[kind]
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", null, value, "°"));
    }
  }]);

  return SetpointPicker;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(SetpointPicker, "propTypes", {
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  },
  onUp: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,
  onDown: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,
  upDisabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  downDisabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  kind: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(["heat", "cool"]).isRequired,
  value: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number.isRequired
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["c" /* withColorsProvider */])(SetpointPicker));



/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ValueCallout =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ValueCallout, _React$Component);

  function ValueCallout() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ValueCallout);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ValueCallout).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ValueCallout, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          colors = _this$props.colors,
          kind = _this$props.kind,
          label = _this$props.label,
          onTap = _this$props.onTap,
          value = _this$props.value;
      var kindStyles = {
        heat: {
          color: colors.HEAT
        },
        cool: {
          color: colors.COOL
        }
      };
      var styles = {
        container: _objectSpread({
          display: "inline-block",
          textAlign: "center",
          cursor: "pointer",
          outline: "none",
          borderRadius: "4px"
        }, kindStyles[kind]),
        value: {
          fontSize: 24,
          textAlign: "center",
          verticalAlign: "middle"
        },
        label: {
          fontSize: 14,
          whiteSpace: "nowrap",
          textAlign: "center",
          textTransform: "uppercase"
        }
      };
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Tappable__["b" /* default */], {
        onTap: onTap
      }, function (_ref) {
        var active = _ref.active,
            tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__NoStyleButton__["a" /* default */], {
          style: _objectSpread({}, styles.container, {
            backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_8__Tappable__["c" /* simpleActiveBackgroundColor */])(active)
          }),
          innerRef: tapTargetRefHandler
        }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
          style: styles.value
        }, value, "°"), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
          style: styles.label
        }, label));
      });
    }
  }]);

  return ValueCallout;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(ValueCallout, "propTypes", {
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  },
  kind: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOf(["heat", "cool"]).isRequired,
  label: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,
  onTap: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["c" /* withColorsProvider */])(ValueCallout));



/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_DeviceControlButton__ = __webpack_require__(74);






var Valve = function Valve(_ref) {
  var model = _ref.model,
      isDetailed = _ref.isDetailed,
      showSpinner = _ref.showSpinner,
      hideSpinner = _ref.hideSpinner;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
    isDetailed: isDetailed
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Controls_DeviceControlButton__["a" /* default */], {
    alert: model.isValveClosed(),
    buttonLabel: model.isValveClosed() ? "Open" : "Close",
    disabled: !model.isValveOperable(),
    onTap: function onTap() {
      showSpinner("".concat(model.isValveClosed() ? "Opening" : "Closing", " '").concat(model.get("name"), "'"));
      model.operateValve().then(hideSpinner, hideSpinner);
    }
  }));
};

Valve.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired // () => void

};
/* harmony default export */ __webpack_exports__["a"] = (Valve);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_ButtonGroup__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);








var WindowShadeOpenCloseStop = function WindowShadeOpenCloseStop(_ref) {
  var model = _ref.model,
      isDetailed = _ref.isDetailed,
      showSpinner = _ref.showSpinner,
      hideSpinner = _ref.hideSpinner;
  var styles = {
    wrapper: {
      fontSize: "0.8em",
      width: "100%"
    },
    button: {
      lineHeight: 0 // ignore icon height

    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
    isDetailed: isDetailed
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    style: styles.wrapper
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nx_components_ButtonGroup__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nx_components_Button__["a" /* default */], {
    style: styles.button,
    onTap: function onTap() {
      showSpinner("Closing '".concat(model.get("name"), "'"));
      model.close().then(hideSpinner, hideSpinner);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nx_components_Icons__["s" /* IconChevronDown */], null)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nx_components_Button__["a" /* default */], {
    style: styles.button,
    onTap: function onTap() {
      showSpinner("Stopping '".concat(model.get("name"), "'"));
      model.stop().then(hideSpinner, hideSpinner);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nx_components_Icons__["w" /* IconCircle */], null)), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nx_components_Button__["a" /* default */], {
    style: styles.button,
    onTap: function onTap() {
      showSpinner("Opening '".concat(model.get("name"), "'"));
      model.open().then(hideSpinner, hideSpinner);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nx_components_Icons__["v" /* IconChevronUp */], null)))));
};

WindowShadeOpenCloseStop.propTypes = {
  model: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired // () => void

};
/* harmony default export */ __webpack_exports__["a"] = (WindowShadeOpenCloseStop);

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WindowShadeSetPercentOpen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_Slider__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__ = __webpack_require__(42);














var sliderStyle = Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_utils_prefixStyles__["b" /* default */])({
  flex: "1 0 auto",
  margin: "1em 0.5em"
});

var WindowShadeSetPercentOpen =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(WindowShadeSetPercentOpen, _React$Component);

  function WindowShadeSetPercentOpen() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, WindowShadeSetPercentOpen);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(WindowShadeSetPercentOpen)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      pendingValue: null
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDragStart", function () {
      return Object(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_flux_like_dispatch__["a" /* default */])("DISABLE_LOCATION_POLLING");
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDragEnd", function (value) {
      var _this$props = _this.props,
          model = _this$props.model,
          showSpinner = _this$props.showSpinner,
          hideSpinner = _this$props.hideSpinner;

      if (value !== model.get("percent_open")) {
        // don't set percent open if it hasn't changed
        _this.setState({
          pendingValue: value
        });

        showSpinner("Setting '".concat(model.get("name"), "' to ").concat(value));

        var onDone = function onDone() {
          _this.setState({
            pendingValue: null
          });

          hideSpinner();
        };

        model.setPercentOpen(value).then(onDone, onDone);
      }

      Object(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(WindowShadeSetPercentOpen, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          model = _this$props2.model,
          isDetailed = _this$props2.isDetailed;
      var pendingValue = this.state.pendingValue;
      var displayValue = model.get("percent_open") || 0;

      if (pendingValue != null) {
        displayValue = pendingValue;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Controls_wrappers_CommonControlWrapper__["a" /* default */], {
        isDetailed: isDetailed
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_Slider__["a" /* default */], {
        min: 0,
        max: 100,
        value: displayValue,
        formatValue: function formatValue(value) {
          return "".concat(value, "%");
        },
        onDragStart: this._handleDragStart,
        onDragEnd: this._handleDragEnd,
        style: sliderStyle
      }));
    }
  }]);

  return WindowShadeSetPercentOpen;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(WindowShadeSetPercentOpen, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_backbone___default.a.Model).isRequired,
  isDetailed: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,
  showSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  // (?string) => void
  hideSpinner: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired // () => void

});



/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutomationTile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Tiles_TileBody__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Tiles_TileSpinner__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Tiles_IconGroupTileWrapper__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_IconGroup__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_parseIconsFromServer__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_Controls_createControlsForModel__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_Routing_HistoryPageTransitionController__ = __webpack_require__(89);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var AutomationTile =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AutomationTile, _React$Component);

  function AutomationTile() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AutomationTile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AutomationTile)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      spinnerShown: false
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_showSpinner", function () {
      if (_this._isMounted) {
        _this.setState({
          spinnerShown: true
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_hideSpinner", function () {
      if (_this._isMounted) {
        _this.setState({
          spinnerShown: false
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTap", function () {
      var model = _this.props.model;
      __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_history__["d" /* history */].push("/app/automations/details", {
        automation: model
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AutomationTile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          model = _this$props.model,
          tileStyles = _this$props.tileStyles;
      var spinnerShown = this.state.spinnerShown;
      var icons = model.get("icon");
      var automationName = model.get("name");
      var iconValues = Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_parseIconsFromServer__["a" /* default */])(icons, {
        ignoreModifiers: true
      });
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_Tappable__["b" /* default */], {
        onTap: this._handleTap,
        holdActiveUntil: __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_Routing_HistoryPageTransitionController__["a" /* getTransitionPromise */]
      }, function (_ref) {
        var active = _ref.active,
            tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          "data-component-name": "AutomationTile",
          className: "tile-contents",
          style: _objectSpread({}, tileStyles.contents, {
            backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_Tappable__["c" /* simpleActiveBackgroundColor */])(active)
          })
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Tiles_TileBody__["a" /* default */], {
          innerRef: tapTargetRefHandler,
          hasControls: true
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Tiles_IconGroupTileWrapper__["a" /* default */], {
          values: iconValues,
          unique: true
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_IconGroup__["a" /* default */], {
          className: "tile-icon",
          style: tileStyles.icon,
          values: iconValues,
          showJoinIcon: true,
          unique: true
        })), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          className: "tile-title",
          style: tileStyles.title
        }, automationName)), Object(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_Controls_createControlsForModel__["c" /* createTileControlForAutomation */])(model, {
          showSpinner: _this2._showSpinner,
          hideSpinner: _this2._hideSpinner
        }), spinnerShown ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Tiles_TileSpinner__["a" /* default */], null) : null);
      });
    }
  }]);

  return AutomationTile;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(AutomationTile, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_backbone___default.a.Model).isRequired,
  tileStyles: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    contents: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,
    icon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,
    status: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired
  }).isRequired
});



/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneTile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Tiles_TileBody__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_HistoryPageTransitionController__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_UserIcon__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_phone__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var styles = Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__["b" /* default */])({
  iconStyle: {
    fontSize: "3em"
  }
});

var PhoneTile =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PhoneTile, _React$Component);

  function PhoneTile() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PhoneTile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(PhoneTile)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTap", function () {
      var model = _this.props.model;
      __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_history__["d" /* history */].push("/app/phones/details", {
        phone: model
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PhoneTile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          model = _this$props.model,
          tileStyles = _this$props.tileStyles;
      var phoneName = model.get("name");
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nx_components_Tappable__["b" /* default */], {
        onTap: this._handleTap,
        holdActiveUntil: __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_HistoryPageTransitionController__["a" /* getTransitionPromise */]
      }, function (_ref) {
        var active = _ref.active,
            tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          "data-component-name": "PhoneTile",
          className: "tile-contents",
          style: _objectSpread({}, tileStyles.contents, {
            backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_Tappable__["c" /* simpleActiveBackgroundColor */])(active)
          })
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Tiles_TileBody__["a" /* default */], {
          innerRef: tapTargetRefHandler
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_UserIcon__["a" /* default */], {
          phone: model,
          style: styles.iconStyle
        }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          className: "tile-title",
          style: tileStyles.title
        }, phoneName)));
      });
    }
  }]);

  return PhoneTile;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(PhoneTile, "propTypes", {
  model: function model() {
    return (typeof __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_phone__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_phone__["a" /* default */]).isRequired : __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  tileStyles: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.shape({
    contents: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object.isRequired,
    icon: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object.isRequired,
    status: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object.isRequired
  }).isRequired
});




/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BuildingTile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Tiles_TileBody__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_HistoryPageTransitionController__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_location__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var styles = Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_utils_prefixStyles__["b" /* default */])({
  iconStyle: {
    fontSize: "6em"
  }
});

var BuildingTile =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(BuildingTile, _React$Component);

  function BuildingTile() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, BuildingTile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(BuildingTile)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTap", function () {
      var model = _this.props.model;
      __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_history__["d" /* history */].push("/app/buildings/details", {
        building: model
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(BuildingTile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          model = _this$props.model,
          tileStyles = _this$props.tileStyles;
      var buildingName = model.get("name");
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nx_components_Tappable__["b" /* default */], {
        onTap: this._handleTap,
        holdActiveUntil: __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Routing_HistoryPageTransitionController__["a" /* getTransitionPromise */]
      }, function (_ref) {
        var active = _ref.active,
            tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          "data-component-name": "BuildingTile",
          className: "tile-contents",
          style: _objectSpread({}, tileStyles.contents, {
            backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_Tappable__["c" /* simpleActiveBackgroundColor */])(active)
          })
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_Tiles_TileBody__["a" /* default */], {
          innerRef: tapTargetRefHandler
        }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nx_components_Icons__["j" /* IconBuilding */], {
          style: styles.iconStyle
        }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
          className: "tile-title",
          style: tileStyles.title
        }, buildingName)));
      });
    }
  }]);

  return BuildingTile;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(BuildingTile, "propTypes", {
  model: function model() {
    return (typeof __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_location__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_location__["a" /* default */]).isRequired : __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  tileStyles: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.shape({
    contents: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object.isRequired
  }).isRequired
});




/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_location__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Controls_createControlsForModel__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_IconGroup__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_parseIconsFromServer__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Tiles_IconGroupTileWrapper__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Tiles_TileBody__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Tiles_TileSpinner__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Routing_HistoryPageTransitionController__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















var BuildingInfoTile = function BuildingInfoTile(props) {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_16_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.BuildingInfoTile;
  var model = props.model,
      tileStyles = props.tileStyles;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),
      _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      spinnerShown = _useState2[0],
      setSpinnerShown = _useState2[1];

  var isMounted = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(false);
  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var showSpinner = function showSpinner() {
    if (isMounted.current) {
      setSpinnerShown(true);
    }
  };

  var hideSpinner = function hideSpinner() {
    if (isMounted.current) {
      setSpinnerShown(false);
    }
  };

  var handleTap = function handleTap() {
    var id = model.attributes.id;
    Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_dispatch__["a" /* default */])("RUN_PROMISE_WITH_SPINNER", function () {
      return model.fetch().then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_flux_like_dispatch__["a" /* default */])("LOCATION_CHANGE", model);
        __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_models_local_settings__["c" /* default */].setDefaultLocationId(id);
      });
    }, languageContext.template(language.loadingBuildingTemplate, {
      buildingName: model.get("name")
    }));
  };

  var styles = Object(__WEBPACK_IMPORTED_MODULE_4_nx_components_utils_prefixStyles__["b" /* default */])({
    iconStyle: {
      fontSize: "2.5em"
    }
  });
  var buildingName = model.get("name");
  var devices = model.get("devices");
  var deviceIcon = devices.map(function (device) {
    return device.get("icon");
  });
  var controls = Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Controls_createControlsForModel__["d" /* createTileControlsForBuilding */])(model, {
    showSpinner: showSpinner,
    hideSpinner: hideSpinner
  });
  var icons = Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_parseIconsFromServer__["a" /* default */])(deviceIcon, {
    showThermostatTemperatureModifier: true
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nx_components_Tappable__["b" /* default */], {
    onTap: handleTap,
    holdActiveUntil: __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Routing_HistoryPageTransitionController__["a" /* getTransitionPromise */]
  }, function (_ref) {
    var active = _ref.active,
        tapTargetRefHandler = _ref.tapTargetRefHandler;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      "data-component-name": "BuildingInfoTile",
      className: "tile-contents",
      style: _objectSpread({}, tileStyles.contents, {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_3_nx_components_Tappable__["c" /* simpleActiveBackgroundColor */])(active)
      })
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Tiles_TileBody__["a" /* default */], {
      innerRef: tapTargetRefHandler
    }, controls ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Tiles_IconGroupTileWrapper__["a" /* default */], {
      values: icons,
      unique: true
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_IconGroup__["a" /* default */], {
      style: styles.iconStyle,
      values: icons,
      unique: true
    })) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_nx_components_Icons__["j" /* IconBuilding */], {
      style: styles.iconStyle
    }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      className: "tile-title",
      style: tileStyles.title
    }, buildingName)), spinnerShown ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Tiles_TileSpinner__["a" /* default */], null) : null);
  });
};

BuildingInfoTile.propTypes = {
  model: function model() {
    return (typeof __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_location__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_location__["a" /* default */]).isRequired : __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  tileStyles: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.shape({
    contents: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object.isRequired,
    icon: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object.isRequired,
    title: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object.isRequired,
    status: __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object.isRequired
  }).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (BuildingInfoTile);


/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PullToRefresh; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PullToRefreshLabelBar__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PullToRefreshOffstageIndicator__ = __webpack_require__(1151);











var PullToRefresh =
/*#__PURE__*/
function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(PullToRefresh, _React$PureComponent);

  function PullToRefresh() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PullToRefresh);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(PullToRefresh).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PullToRefresh, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          target = _this$props.target,
          disabled = _this$props.disabled,
          offstage = _this$props.offstage,
          dragThreshold = _this$props.dragThreshold,
          activationThreshold = _this$props.activationThreshold,
          onActivate = _this$props.onActivate;
      return offstage ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__PullToRefreshOffstageIndicator__["a" /* default */], {
        target: target,
        disabled: disabled,
        activationThreshold: activationThreshold,
        onActivate: onActivate
      }) : __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__PullToRefreshLabelBar__["a" /* default */], {
        target: target,
        disabled: disabled,
        dragThreshold: dragThreshold,
        activationThreshold: activationThreshold,
        onActivate: onActivate
      });
    }
  }]);

  return PullToRefresh;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(PullToRefresh, "propTypes", {
  // The target element that we should track touch and scroll events on.
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  // HTMLElement
  // When disabled, we don't do anything if you pull to refresh again. This
  // should be set to true once the pull-to-refresh has been "handled" and a
  // network request is inflight, so that you don't queue up a ton of network
  // requests for the same resource.
  //
  // Additionally, for non-offstage (floating label bar), we hide the bar when
  // disabled is true.
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  // Whether to use an offstage arrow or a floating bar. We use an offstage
  // arrow on iOS because we can leverage iOS's overscroll there. On Android
  // we use the floating bar at the top (dark blue, says 'PULL TO REFRESH')
  offstage: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  // How many pixels you have to drag for the bar to show up on the top.
  // Doesn't affect the offstage arrow.
  dragThreshold: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  // How many pixels you have to drag for the pull-to-refresh event to occur.
  // Doesn't affect the offstage arrow.
  activationThreshold: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  // This gets called once they've pulled enough that we should refresh. It
  // won't get called if our disabled prop is true (to be consistent with
  // Polymer behavior.)
  onActivate: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
});

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(PullToRefresh, "defaultProps", {
  disabled: false,
  dragThreshold: 20,
  activationThreshold: 50,
  offstage: false
});



/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_DOMEventListener__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PullToRefreshLabelBar =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PullToRefreshLabelBar, _React$Component);

  function PullToRefreshLabelBar() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PullToRefreshLabelBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(PullToRefreshLabelBar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      amountPulled: 0
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_dragging", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_shouldActivate", false);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_startY", null);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onDown", function () {
      if (_this.props.disabled) {
        return;
      }

      _this._dragging = true;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onDrag", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          disabled = _this$props.disabled,
          activationThreshold = _this$props.activationThreshold,
          dragThreshold = _this$props.dragThreshold;

      if (disabled || !_this._dragging || target == null || target.scrollTop > 0) {
        return;
      }

      var touch = event.touches[0];

      if (_this._startY === null) {
        _this._startY = touch.pageY;
      }

      var delta = touch.pageY - _this._startY;

      if (delta < 0) {
        return;
      }

      var amountPulled;

      if (delta >= activationThreshold + dragThreshold) {
        _this._shouldActivate = true;
        amountPulled = 1;
      } else if (delta >= dragThreshold) {
        _this._shouldActivate = false;
        amountPulled = (delta - dragThreshold) / activationThreshold;
      } else {
        _this._shouldActivate = false;
        amountPulled = 0;
      }

      _this.setState({
        amountPulled: amountPulled
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onUp", function () {
      var _this$props2 = _this.props,
          target = _this$props2.target,
          disabled = _this$props2.disabled,
          onActivate = _this$props2.onActivate;

      if (disabled || target == null) {
        return;
      }

      _this._startY = null;
      _this._dragging = false;

      _this.setState({
        amountPulled: 0
      });

      if (_this._shouldActivate) {
        _this._shouldActivate = false;

        if ( // Don't activate if the user pulled down enough to activate but
        // then scrolled down the page, because they might have intended to
        // cancel the pull-to-refresh by going back up.
        target.scrollTop <= 0 && onActivate) {
          onActivate();
        }
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PullToRefreshLabelBar, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          target = _this$props3.target,
          colors = _this$props3.colors;
      var amountPulled = this.state.amountPulled;
      var styles = {
        // TODO: These styles don't extend past the safe area on iPhone X. They are
        // never rendered on that device, but future Android notched devices will have
        // this. Replace this component with a better-looking alternative before then.
        bar: {
          pointerEvents: "none",
          position: "absolute",
          width: "100%",
          background: colors.IMPORTANT,
          color: colors.PRIMARY_TEXT,
          textAlign: "center",
          textTransform: "uppercase",
          fontSize: "0.8em",
          padding: "0.5em",
          zIndex: "1"
        }
      };
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "PullToRefreshLabelBar",
        style: _objectSpread({}, styles.bar, {
          opacity: amountPulled
        })
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_DOMEventListener__["a" /* default */], {
        target: target,
        eventName: "touchstart",
        handler: this._onDown
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_DOMEventListener__["a" /* default */], {
        target: target,
        eventName: "touchmove",
        handler: this._onDrag
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_DOMEventListener__["a" /* default */], {
        target: target,
        eventName: "touchend",
        handler: this._onUp
      }), amountPulled === 1 ? "Release to refresh" : "Pull to refresh");
    }
  }]);

  return PullToRefreshLabelBar;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(PullToRefreshLabelBar, "propTypes", {
  target: function target() {
    return (typeof HTMLElement === "function" ? __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.instanceOf(HTMLElement) : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.any).apply(this, arguments);
  },
  disabled: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,
  dragThreshold: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number.isRequired,
  activationThreshold: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number.isRequired,
  onActivate: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_ColorsProvider__["c" /* withColorsProvider */])(PullToRefreshLabelBar));


/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_DOMEventListener__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var PullToRefreshOffstageIndicator =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PullToRefreshOffstageIndicator, _React$Component);

  function PullToRefreshOffstageIndicator() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PullToRefreshOffstageIndicator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(PullToRefreshOffstageIndicator)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      flipped: false
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onTouchEnd", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onActivate = _this$props.onActivate;

      if (disabled) {
        return;
      }

      if (onActivate != null && _this._beyondThreshold()) {
        onActivate();
      }

      _this.setState({
        flipped: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_onScroll", function () {
      if (_this.props.disabled) {
        return;
      }

      _this.setState({
        flipped: _this._beyondThreshold()
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PullToRefreshOffstageIndicator, [{
    key: "_beyondThreshold",
    value: function _beyondThreshold() {
      var _this$props2 = this.props,
          target = _this$props2.target,
          activationThreshold = _this$props2.activationThreshold;

      if (target == null) {
        return false;
      }

      return target.scrollTop < 0 - activationThreshold;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          target = _this$props3.target,
          disabled = _this$props3.disabled,
          colors = _this$props3.colors;
      var flipped = this.state.flipped;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_9_nx_components_utils_prefixStyles__["b" /* default */])({
        wrapper: {
          marginTop: "-2em",
          lineHeight: "2em",
          fontSize: "1.5em",
          color: colors.TITLE,
          textAlign: "center",
          // Prevents iOS Safari from not drawing this element (as an optimization
          // since it's off-screen).
          transform: "translate3d(0, 0, 0)"
        },
        indicator: {
          transition: "transform 0.3s, opacity 0.1s"
        }
      });
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "PullToRefreshOffstageIndicator",
        style: styles.wrapper
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_DOMEventListener__["a" /* default */], {
        target: target,
        eventName: "touchend",
        handler: this._onTouchEnd
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_DOMEventListener__["a" /* default */], {
        target: target,
        eventName: "scroll",
        handler: this._onScroll
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_Icons__["_42" /* IconThinArrowDown */], {
        style: _objectSpread({}, styles.indicator, {
          transform: "rotate3d(0, 0, 1, ".concat( // We use 180.1 here instead of 180 because with 180, it's
          // indeterminate whether the browser will decide to transition it
          // clockwise or counter-clickwise towards 180 degrees (and in
          // practice, it flips back and forth). With 180.1, it will
          // (almost) always go the same way.
          flipped ? "180.1deg" : "0deg", ")"),
          opacity: disabled ? "0.0" : "1.0"
        })
      }));
    }
  }]);

  return PullToRefreshOffstageIndicator;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(PullToRefreshOffstageIndicator, "propTypes", {
  target: function target() {
    return (typeof HTMLElement === "function" ? __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.instanceOf(HTMLElement) : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.any).apply(this, arguments);
  },
  disabled: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.bool,
  activationThreshold: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.number.isRequired,
  onActivate: __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func,
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_ColorsProvider__["c" /* withColorsProvider */])(PullToRefreshOffstageIndicator));


/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fields_GenericField__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fields_DateTimeField__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fields_BooleanField__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fields_SelectField__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fields_MultiSelectField__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fields_SliderField__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fields_ColorPickerField__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fields_ThermostatSetpointField__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fields_LabelField__ = __webpack_require__(1181);







/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/












var FormField =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(FormField, _React$Component);

  function FormField() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, FormField);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(FormField).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(FormField, [{
    key: "render",
    value: function render() {
      var _this = this;

      var FieldComponent = function () {
        switch (_this.props.type) {
          case "date":
          case "time":
            return __WEBPACK_IMPORTED_MODULE_9__fields_DateTimeField__["a" /* default */];

          case "boolean":
            return __WEBPACK_IMPORTED_MODULE_10__fields_BooleanField__["a" /* default */];

          case "select":
            return __WEBPACK_IMPORTED_MODULE_11__fields_SelectField__["a" /* default */];

          case "multi":
            return __WEBPACK_IMPORTED_MODULE_12__fields_MultiSelectField__["a" /* default */];

          case "range":
            return __WEBPACK_IMPORTED_MODULE_13__fields_SliderField__["a" /* default */];

          case "color":
            return __WEBPACK_IMPORTED_MODULE_14__fields_ColorPickerField__["a" /* default */];

          case "setpoints":
            return __WEBPACK_IMPORTED_MODULE_15__fields_ThermostatSetpointField__["a" /* default */];

          case "label":
            return __WEBPACK_IMPORTED_MODULE_16__fields_LabelField__["a" /* default */];

          default:
            return __WEBPACK_IMPORTED_MODULE_8__fields_GenericField__["a" /* default */];
        }
      }();

      if (FieldComponent) {
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
          id: this.props.name,
          "data-field-name": this.props.name
        }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](FieldComponent, this.props));
      } else {
        return null;
      }
    }
  }]);

  return FormField;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(FormField, "propTypes", {
  name: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
});



/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenericField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InputField__ = __webpack_require__(325);












var GenericField =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(GenericField, _React$Component);

  function GenericField() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, GenericField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(GenericField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      value: _this._extractStateValue(_this.props),
      hasLeftLabel: false
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleChange", function (event) {
      var value = event.currentTarget.value;

      _this.setState({
        value: value
      });

      if (_this.props.onChange) {
        _this.props.onChange(value);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(GenericField, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.state.value !== nextProps.value) {
        this.setState({
          value: this._extractStateValue(nextProps)
        });
      }
    }
  }, {
    key: "_extractStateValue",
    value: function _extractStateValue(props) {
      return props.value || "";
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__InputField__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        value: value,
        onChange: this._handleChange
      }));
    }
  }]);

  return GenericField;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(GenericField, "propTypes", {
  name: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(["text", "password", "email", "number", "tel"]).isRequired,
  label: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]),
  maxLength: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  error: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string
});



/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RevealPasswordIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__ = __webpack_require__(9);











var buttonStyle = Object(__WEBPACK_IMPORTED_MODULE_10__utils_prefixStyles__["b" /* default */])({
  display: "inline-flex"
});

var RevealPasswordIcon =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(RevealPasswordIcon, _React$Component);

  function RevealPasswordIcon() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, RevealPasswordIcon);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(RevealPasswordIcon).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(RevealPasswordIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          onClick = _this$props.onClick;
      var isPassword = type === "password";
      var icon = isPassword ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Icons__["_9" /* IconPasswordNotVisible */], {
        height: "1.1em",
        width: "1.1em"
      }) : __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Icons__["_10" /* IconPasswordVisible */], {
        height: "1.1em",
        width: "1.1em"
      });
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__NoStyleButton__["a" /* default */], {
        "aria-label": isPassword ? "Show password" : "Hide password" // Intentionally using an onClick handler here instead of a Tappable due
        // to conflicts with special focus management with password reveal in
        // fields; see InputField#_handleRevealPassword for context.
        // eslint-disable-next-line nexia/prefer-tappable
        ,
        onClick: onClick,
        "aria-pressed": isPassword,
        style: buttonStyle
      }, icon);
    }
  }]);

  return RevealPasswordIcon;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(RevealPasswordIcon, "propTypes", {
  type: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(["password", "text"]),
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
});



/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateTimeField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InputField__ = __webpack_require__(325);












var DateTimeField =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(DateTimeField, _React$Component);

  function DateTimeField() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, DateTimeField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(DateTimeField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      value: _this._extractStateValue(_this.props)
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "componentDidMount", function () {
      _this._resetDefaultValue(); // Because a default value may be set as part of object initialization,
      // we need to explicitly call onChange to update any listeners with the
      // new value.


      if (_this.props.onChange && _this.props.value !== _this.state.value) {
        _this.props.onChange(_this.props.value);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "componentDidUpdate", function () {
      _this._resetDefaultValue();
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleChange", function (event) {
      var value = event.currentTarget.value;

      _this.setState({
        value: value
      });

      if (_this.props.onChange) {
        _this.props.onChange(value);
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_resetDefaultValue", function () {
      // The "value" attribute of HTML5 date and time inputs technically controls the defaultValue
      // property of the element and only incidentally changes the UI. On iOS, the "clear"
      // button calls onChange with the defaultValue instead of an empty string like other
      // platforms. After the element is rendered, clear the defaultValue of date and time inputs
      // so that the "clear" button will work on iOS.
      if (_this.input) {
        _this.input.defaultValue = "";
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_captureRef", function (el) {
      _this.input = el;
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(DateTimeField, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.state.value !== nextProps.value) {
        this.setState({
          value: this._extractStateValue(nextProps)
        });
      }
    }
  }, {
    key: "_extractStateValue",
    value: function _extractStateValue(props) {
      var value = props.value || "";

      if (props.type === "time") {
        if (props.value == null) {
          // HH:MM
          var hoursAndMinutes = new Date().toTimeString().slice(0, 5);
          value = hoursAndMinutes;
        } else if (props.value === "no value") {
          // times explicitly set to "no value" should not default to now
          value = "";
        }
      }

      if (props.type === "date") {
        if (props.value == null) {
          // YYYY-MM-DD
          var dateString = new Date().toISOString().slice(0, 10);
          value = dateString;
        } else if (props.value === "no value") {
          // dates explicitly set to "no value" should not default to today
          value = "";
        }
      }

      if (this.props.onChange) {
        this.props.onChange(value);
      }

      return value;
    }
  }, {
    key: "render",
    value: function render() {
      var label = this.props.label;
      var value = this.state.value; // add a label on the left for date and time inputs

      var hasLeftLabel = Boolean(label);
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__InputField__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this.props, {
        captureRef: this._captureRef,
        value: value,
        onChange: this._handleChange,
        hasLeftLabel: hasLeftLabel
      }));
    }
  }]);

  return DateTimeField;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(DateTimeField, "propTypes", {
  name: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(["time", "date"]).isRequired,
  label: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]),
  maxLength: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  error: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string
});



/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_SelectItem__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Select_SelectDialog__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormError__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Theme__ = __webpack_require__(18);














var SelectField =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SelectField, _React$Component);

  function SelectField() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SelectField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SelectField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      value: _this.props.value
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChange", function (newValue) {
      _this.setState({
        value: newValue
      });

      if (_this.props.onChange) {
        _this.props.onChange(newValue);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SelectField, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.state.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          label = _this$props.label,
          options = _this$props.options,
          error = _this$props.error,
          placeholder = _this$props.placeholder,
          infoIcon = _this$props.infoIcon,
          infoText = _this$props.infoText;
      var value = this.state.value;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "SelectField",
        "data-prop-name": name,
        "data-prop-value": value == null ? "" : value.toString()
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__FormError__["b" /* default */], {
        error: error
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: {
          padding: __WEBPACK_IMPORTED_MODULE_12__Theme__["a" /* default */].Padding.CONTENT
        }
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__internal_SelectItem__["a" /* default */], {
        label: label,
        options: options,
        value: value,
        onChange: this.handleChange,
        placeholder: placeholder,
        infoIcon: infoIcon,
        infoText: infoText
      }))));
    }
  }]);

  return SelectField;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SelectField, "propTypes", {
  name: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_10__Select_SelectDialog__["d" /* valuePropType */],
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  error: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  options: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
    label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_10__Select_SelectDialog__["d" /* valuePropType */].isRequired,
    icon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
  })),
  infoIcon: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  infoText: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SelectField, "defaultProps", {
  options: []
});



/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectWithoutTappable; });
/* unused harmony export bpfrpt_proptype_Props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SelectDialog__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icons__ = __webpack_require__(23);
/* unused harmony reexport SelectDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var bpfrpt_proptype_Props = {
  placeholder: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,
  options: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.arrayOf(function () {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__SelectDialog__["a" /* bpfrpt_proptype_Option */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__SelectDialog__["a" /* bpfrpt_proptype_Option */].isRequired ? __WEBPACK_IMPORTED_MODULE_8__SelectDialog__["a" /* bpfrpt_proptype_Option */].isRequired : __WEBPACK_IMPORTED_MODULE_8__SelectDialog__["a" /* bpfrpt_proptype_Option */] : __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__SelectDialog__["a" /* bpfrpt_proptype_Option */]).isRequired).apply(this, arguments);
  }).isRequired,
  value: function value() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__SelectDialog__["b" /* bpfrpt_proptype_valueType */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__SelectDialog__["b" /* bpfrpt_proptype_valueType */] : __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__SelectDialog__["b" /* bpfrpt_proptype_valueType */])).apply(this, arguments);
  },
  onOptionTapped: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  onBackgroundTapped: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  onRequestClose: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  labelStyle: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.any,
  style: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.any,
  open: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool.isRequired
};

var SelectWithoutTappable =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SelectWithoutTappable, _React$Component);

  function SelectWithoutTappable() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, SelectWithoutTappable);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SelectWithoutTappable).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SelectWithoutTappable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          options = _this$props.options,
          value = _this$props.value,
          onOptionTapped = _this$props.onOptionTapped,
          onBackgroundTapped = _this$props.onBackgroundTapped,
          onRequestClose = _this$props.onRequestClose,
          labelStyle = _this$props.labelStyle,
          style = _this$props.style,
          open = _this$props.open;
      var valueLabel = "";
      var selectedOption = options.find(function (option) {
        return option.value === value;
      });
      var hasPivotSubtitle = selectedOption && selectedOption.label && selectedOption.isPivot;

      if (selectedOption) {
        valueLabel = selectedOption.label;
      } else {
        valueLabel = placeholder || "Select A Value";
      }

      var styles = {
        wrapper: _objectSpread({
          display: "inline-block"
        }, style),
        labelWrapper: _objectSpread({}, __WEBPACK_IMPORTED_MODULE_9__Theme__["a" /* default */].Styles.flexLayout, {
          lineHeight: "1em",
          minWidth: "3em",
          outline: "none",
          textTransform: style && style.textTransform
        }),
        label: _objectSpread({
          whiteSpace: placeholder ? "initial" : "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "inline-block",
          verticalAlign: "bottom",
          lineHeight: hasPivotSubtitle ? "1.2em" : "2em",
          textAlign: hasPivotSubtitle ? "right" : ""
        }, __WEBPACK_IMPORTED_MODULE_9__Theme__["a" /* default */].Styles.flexStretch, {}, labelStyle),
        icon: _objectSpread({}, __WEBPACK_IMPORTED_MODULE_9__Theme__["a" /* default */].Styles.flexFixed, {
          fontSize: "1.35em",
          paddingLeft: "0.25em"
        })
      }; // Placeholders (labels) are placed at the top as a default and are not selectable

      var newOptions = placeholder ? [{
        id: "_default",
        value: "_default",
        label: placeholder,
        onClick: function onClick() {
          return onBackgroundTapped && onBackgroundTapped();
        }
      }].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(options)) : options;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "Select",
        style: styles.wrapper
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.labelWrapper
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("span", {
        className: "value",
        style: styles.label
      }, valueLabel), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Icons__["I" /* IconDropDownArrow */], {
        style: styles.icon
      })), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__SelectDialog__["c" /* default */], {
        options: newOptions,
        value: value,
        onOptionTapped: onOptionTapped,
        onBackgroundTapped: onBackgroundTapped,
        onRequestClose: onRequestClose,
        open: open
      }));
    }
  }]);

  return SelectWithoutTappable;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SelectWithoutTappable, "defaultProps", {
  options: []
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SelectWithoutTappable, "propTypes", {
  placeholder: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,
  options: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.arrayOf(function () {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__SelectDialog__["a" /* bpfrpt_proptype_Option */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__SelectDialog__["a" /* bpfrpt_proptype_Option */].isRequired ? __WEBPACK_IMPORTED_MODULE_8__SelectDialog__["a" /* bpfrpt_proptype_Option */].isRequired : __WEBPACK_IMPORTED_MODULE_8__SelectDialog__["a" /* bpfrpt_proptype_Option */] : __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__SelectDialog__["a" /* bpfrpt_proptype_Option */]).isRequired).apply(this, arguments);
  }),
  value: function value() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__SelectDialog__["b" /* bpfrpt_proptype_valueType */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__SelectDialog__["b" /* bpfrpt_proptype_valueType */] : __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__SelectDialog__["b" /* bpfrpt_proptype_valueType */])).apply(this, arguments);
  },
  onOptionTapped: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  onBackgroundTapped: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  onRequestClose: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  labelStyle: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.any,
  style: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.any,
  open: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool.isRequired
});








/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultiSelectField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Checkbox__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RichLabel__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ItemList__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_prefixStyles__ = __webpack_require__(9);

















var MultiSelectField =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(MultiSelectField, _React$Component);

  function MultiSelectField() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, MultiSelectField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(MultiSelectField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      currentValue: _this.props.value
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleChange", function (toggledValue, checked) {
      var currentValue = _this.state.currentValue;
      var newValue;

      if (checked) {
        newValue = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(currentValue), [toggledValue]);
      } else {
        newValue = currentValue.filter(function (value) {
          return value !== toggledValue;
        });
      }

      _this.setState({
        currentValue: newValue
      }, function () {
        _this.props.onChange(newValue);
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(MultiSelectField, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        currentValue: nextProps.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          label = _this$props.label,
          options = _this$props.options,
          name = _this$props.name,
          disabled = _this$props.disabled;
      var currentValue = this.state.currentValue;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_15__utils_prefixStyles__["b" /* default */])({
        wrapper: {
          marginTop: "0.9em",
          marginBottom: "0.9em"
        },
        heading: {
          paddingLeft: __WEBPACK_IMPORTED_MODULE_14__Theme__["a" /* default */].Padding.CONTENT,
          paddingRight: __WEBPACK_IMPORTED_MODULE_14__Theme__["a" /* default */].Padding.CONTENT,
          display: "flex",
          justifyContent: "space-between"
        }
      });
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        "data-component-name": "MultiSelectField",
        style: styles.wrapper
      }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        "data-component-section": "heading",
        style: styles.heading
      }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("span", {
        "data-component-section": "label"
      }, label), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Checkbox__["a" /* default */], {
        "data-component-section": "group-checkbox",
        indeterminate: currentValue.length > 0 && currentValue.length < options.length,
        checked: currentValue.length > 0,
        disabled: disabled,
        onTap: disabled ? null : function () {
          var newValue;

          if (currentValue.length === 0) {
            newValue = options.map(function (option) {
              return option.value;
            });
          } else {
            newValue = [];
          }

          _this2.setState({
            currentValue: newValue
          }, function () {
            _this2.props.onChange(newValue);
          });
        }
      })), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__ItemList__["c" /* default */], {
        id: name,
        showDividers: true,
        dividerProps: {
          overflow: false
        },
        items: options.map(function (option) {
          var id = option.id || "".concat(name, "-").concat(option.value);
          var checked = __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default()(currentValue, option.value);
          return {
            id: id,
            onTap: disabled ? null : function () {
              _this2._handleChange(option.value, !checked);
            },
            label: __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__RichLabel__["a" /* default */], {
              icon: option.icon,
              label: option.label,
              style: {
                marginLeft: __WEBPACK_IMPORTED_MODULE_14__Theme__["a" /* default */].Padding.CONTENT
              }
            }),
            children: __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Checkbox__["a" /* default */], {
              checked: checked,
              disabled: disabled,
              style: {
                marginRight: __WEBPACK_IMPORTED_MODULE_14__Theme__["a" /* default */].Padding.CONTENT
              }
            }),
            updateKey: "".concat(id, ",checked=").concat(checked),
            "aria-pressed": String(Boolean(checked))
          };
        })
      }));
    }
  }]);

  return MultiSelectField;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(MultiSelectField, "propTypes", {
  name: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string),
  options: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]),
    label: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]).isRequired,
    icon: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node
  })),
  onChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(MultiSelectField, "defaultProps", {
  options: [],
  value: []
});



/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1160),
    isArrayLike = __webpack_require__(326),
    isString = __webpack_require__(1164),
    toInteger = __webpack_require__(1165),
    values = __webpack_require__(1167);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1161),
    baseIsNaN = __webpack_require__(1162),
    strictIndexOf = __webpack_require__(1163);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1161 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 1162 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1163 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(150),
    isArray = __webpack_require__(299),
    isObjectLike = __webpack_require__(151);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1166);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(443);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(1168),
    keys = __webpack_require__(510);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(504);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 1169 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(150),
    isObjectLike = __webpack_require__(151);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1171 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(150),
    isLength = __webpack_require__(327),
    isObjectLike = __webpack_require__(151);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1173 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(442);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(521),
    nativeKeys = __webpack_require__(1176);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(536);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RichLabel__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Slider__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var styles = Object(__WEBPACK_IMPORTED_MODULE_13__utils_prefixStyles__["b" /* default */])({
  wrapper: {
    display: "flex",
    width: "100%"
  },
  button: {
    fontSize: "0.75em",
    alignSelf: "center",
    flex: "0 0 auto"
  },
  slider: {
    flex: "1 1 33%",
    alignSelf: "center",
    paddingTop: 0
  }
});

var SliderField =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SliderField, _React$Component);

  function SliderField() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SliderField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SliderField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      // A factory reset thermostat doesn't always provide a value, so use the min.
      value: _this.props.value != null ? _this.props.value : _this.props.min
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_formatSliderValue", function (value) {
      var _this$props = _this.props,
          stepValues = _this$props.stepValues,
          display = _this$props.display;
      var displayValue = String(value);

      if (stepValues && stepValues[value] != null) {
        displayValue = stepValues[value];
      }

      if (display) {
        displayValue = "".concat(displayValue).concat(display.postfix);
      }

      return displayValue;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleChange", function (value) {
      if (value === _this.state.value) {
        return;
      }

      _this.setState({
        value: value
      });

      if (_this.props.onChange) {
        _this.props.onChange(value);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SliderField, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.state.value) {
        this.setState({
          value: nextProps.value != null ? nextProps.value : nextProps.min
        });
      }
    }
  }, {
    key: "createButton",
    value: function createButton(subField, clickValue, style) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */], {
        onTap: function onTap() {
          _this2.setState({
            value: clickValue
          });

          if (_this2.props.onChange) {
            _this2.props.onChange(clickValue);
          }
        },
        style: _objectSpread({}, styles.button, {}, style)
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__RichLabel__["a" /* default */], {
        icon: subField.icon,
        label: subField.label
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          hasOffState = _this$props2.hasOffState,
          label = _this$props2.label,
          min = _this$props2.min,
          max = _this$props2.max,
          step = _this$props2.step,
          minButton = _this$props2.minButton,
          maxButton = _this$props2.maxButton,
          colors = _this$props2.colors;
      var value = this.state.value;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "SliderField",
        style: {
          color: colors.TEXT,
          boxSizing: "border-box",
          padding: __WEBPACK_IMPORTED_MODULE_12__Theme__["a" /* default */].Padding.CONTENT
        }
      }, label ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("span", {
        "data-component-section": "label"
      }, label) : null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: _objectSpread({}, styles.wrapper, {
          marginTop: label ? 12 : 30 // spacing between label or extra for tooltip w/o label

        })
      }, minButton ? this.createButton(minButton, min) : null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Slider__["a" /* default */], {
        hasOffState: hasOffState,
        style: _objectSpread({}, styles.slider, {
          marginLeft: minButton ? __WEBPACK_IMPORTED_MODULE_12__Theme__["a" /* default */].Padding.CONTENT : ""
        }),
        min: min,
        max: max,
        step: step,
        value: value,
        showValueAboveHandle: true,
        formatValue: this._formatSliderValue,
        onChange: this.handleChange
      }), maxButton ? this.createButton(maxButton, max, {
        marginLeft: __WEBPACK_IMPORTED_MODULE_12__Theme__["a" /* default */].Padding.CONTENT
      }) : null));
    }
  }]);

  return SliderField;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SliderField, "defaultProps", {
  hasOffState: true,
  step: 1
});

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SliderField, "propTypes", {
  display: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.shape({
    postfix: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string.isRequired
  }),
  hasOffState: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,
  label: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number.isRequired,
  max: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number.isRequired,
  step: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number,
  stepValues: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string.isRequired),
  minButton: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string.isRequired,
    icon: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.node
  }),
  maxButton: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.shape({
    label: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string.isRequired,
    icon: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.node
  }),
  onChange: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__ColorsProvider__["c" /* withColorsProvider */])(SliderField));



/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorPickerField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ColorPicker__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Section__ = __webpack_require__(220);












var ColorPickerField =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ColorPickerField, _React$Component);

  function ColorPickerField() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ColorPickerField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ColorPickerField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "handleDragEnd", function (colors) {
      if (_this.props.onChange) {
        _this.props.onChange(colors);
      }
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ColorPickerField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          warm = _this$props.warm,
          cool = _this$props.cool,
          red = _this$props.red,
          green = _this$props.green,
          blue = _this$props.blue,
          bulb = _this$props.bulb,
          ranges = _this$props.ranges;
      var rangesMap = ranges.reduce(function (obj, item) {
        obj[item] = true;
        return obj;
      }, {});
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Section__["a" /* default */], {
        label: label
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ColorPicker__["a" /* default */], {
        warm: warm,
        cool: cool,
        red: red,
        green: green,
        blue: blue,
        bulb: bulb,
        showRGB: rangesMap.red || rangesMap.green || rangesMap.blue,
        showWarmCool: rangesMap.warm || rangesMap.cool,
        onDragEnd: this.handleDragEnd
      }));
    }
  }]);

  return ColorPickerField;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ColorPickerField, "propTypes", {
  label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  ranges: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(["warm", "cool", "red", "green", "blue"])).isRequired,
  bulb: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  warm: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  cool: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  red: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  green: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  blue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
});



/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calcPreviewColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calcPreviewColorBulb; });
var rgbString = function rgbString(red, green, blue) {
  var r2 = red.toFixed(0);
  var g2 = green.toFixed(0);
  var b2 = blue.toFixed(0);
  return "rgb(".concat(r2, ", ").concat(g2, ", ").concat(b2, ")");
};

var hslString = function hslString(hue, saturation, lightness) {
  var h2 = hue.toFixed(0);
  var s2 = saturation.toFixed(0);
  var l2 = lightness.toFixed(0);
  return "hsl(".concat(h2, ", ").concat(s2, "%, ").concat(l2, "%)");
};

var RGBtoHSL = function RGBtoHSL(red, green, blue) {
  // This algorithm comes from Wikipedia. There are two algorithms; the official
  // CSS HSL -> RGB algorithm doesn't use tangents, so I used the RGB -> HSL that didn't either.
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var _h = 0;
  var l1 = (max + min) / 255 / 2;
  var s1 = (max - min) / 255 / (1 - Math.abs(2 * l1 - 1));

  if (max === min) {
    s1 = 0; // this compensates for the rare NaN scenarios and shortcircuits hue calculation
  } else if (max === red) {
    _h = (green - blue) / (max - min);
  } else if (max === green) {
    _h = (blue - red) / (max - min) + 2;
  } else if (max === blue) {
    _h = (red - green) / (max - min) + 4;
  }

  var h1 = _h % 6 * 60;
  return {
    hue: h1,
    saturation: s1 * 100,
    lightness: l1 * 100
  };
};

var calcPreviewColor = function calcPreviewColor(_ref) {
  var warm = _ref.warm,
      cool = _ref.cool,
      red = _ref.red,
      green = _ref.green,
      blue = _ref.blue;

  if (red + green + blue > 0) {
    // default to RGB if not zero
    return rgbString(red, green, blue);
  } else if (warm > 0) {
    return hslString(34, warm / 255 * 100, 90);
  } else if (cool > 0) {
    return hslString(203, cool / 255 * 100, 95);
  }

  return rgbString(0, 0, 0);
};

var SATURATION_MAX = 90;
var RED_DIMMING_RATIO = 0.9;
var GREEN_DIMMING_RATIO = 0.95;

var calcPreviewColorBulb = function calcPreviewColorBulb(_ref2) {
  var warm = _ref2.warm,
      cool = _ref2.cool,
      red = _ref2.red,
      green = _ref2.green,
      blue = _ref2.blue;
  var hueValue;
  var saturationRatio;
  var lightnessRatio;

  if (warm + cool + red + blue + green === 0) {
    // All off
    hueValue = 0;
    saturationRatio = 0;
    lightnessRatio = 0.5;
  } else if (warm > 0) {
    // Only warm set
    saturationRatio = warm / 255;
    hueValue = 34;
    lightnessRatio = 0.8;
  } else if (cool > 0) {
    // Only cool set
    saturationRatio = cool / 255;
    hueValue = 203;
    lightnessRatio = 0.9;
  } else {
    // red and green on the bulb are not as bright, so suppress them in the preview
    var dimRed = RED_DIMMING_RATIO * red;
    var dimGreen = GREEN_DIMMING_RATIO * green;
    var hslObj = RGBtoHSL(dimRed, dimGreen, blue);
    hueValue = hslObj.hue;
    saturationRatio = hslObj.saturation / 100;
    lightnessRatio = hslObj.lightness / 100; // we want saturation and lightness over a smaller range

    saturationRatio = saturationRatio < 0.1 ? 5 * saturationRatio : 0.5 + (1 - 0.5) * saturationRatio;
    lightnessRatio = 0.5 + (0.95 - 0.5) * lightnessRatio;
  }

  var saturation = saturationRatio * SATURATION_MAX;
  var hue = hueValue;
  var lightness = lightnessRatio * 100;
  return hslString(hue, saturation, lightness);
};



/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThermostatSetpointField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Thermostat_ThermostatSetpoints__ = __webpack_require__(226);











var styles = {
  field: {
    padding: __WEBPACK_IMPORTED_MODULE_9__Theme__["a" /* default */].Padding.CONTENT
  }
};

var ThermostatSetpointField =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ThermostatSetpointField, _React$Component);

  function ThermostatSetpointField() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ThermostatSetpointField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ThermostatSetpointField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_getStateValue", function (value) {
      // A factory-reset thermostat doesn't always provide a value, so use the min.
      return {
        heat: value.heat || _this.props.min_heat_setpoint,
        cool: value.cool || _this.props.min_cool_setpoint
      };
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      value: _this.props.value
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleChange", function (setpoints) {
      var newSetpoints = {
        heat: setpoints.setpointHeat,
        cool: setpoints.setpointCool
      };

      _this.props.onChange(newSetpoints);

      _this.setState({
        value: newSetpoints
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ThermostatSetpointField, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange;

      var stateValue = this._getStateValue(value);

      this.setState({
        value: stateValue
      });

      if (onChange && (value.heat == null || value.cool == null)) {
        onChange(stateValue); // we're changing the value, we're just doing it very early.
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var newValue = this._getStateValue(nextProps.value);

      if (newValue.heat !== this.state.value.heat || newValue.cool !== this.state.value.cool) {
        this.setState({
          value: newValue
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          minHeatSetpoint = _this$props2.min_heat_setpoint,
          maxHeatSetpoint = _this$props2.max_heat_setpoint,
          minCoolSetpoint = _this$props2.min_cool_setpoint,
          maxCoolSetpoint = _this$props2.max_cool_setpoint,
          delta = _this$props2.delta,
          step = _this$props2.step;
      var value = this.state.value;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "ThermostatSetpointField",
        style: styles.field
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Thermostat_ThermostatSetpoints__["a" /* default */], {
        onChangesEnded: this._handleChange,
        changeBufferMs: 0,
        setpointHeat: value.heat,
        setpointCool: value.cool,
        setpointHeatMin: minHeatSetpoint,
        setpointHeatMax: maxHeatSetpoint,
        setpointCoolMin: minCoolSetpoint,
        setpointCoolMax: maxCoolSetpoint,
        setpointDelta: delta,
        setpointIncrement: step
      }));
    }
  }]);

  return ThermostatSetpointField;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ThermostatSetpointField, "propTypes", {
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    heat: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
    cool: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number
  }).isRequired,

  /* eslint-disable camelcase */
  min_heat_setpoint: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,
  max_heat_setpoint: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,
  min_cool_setpoint: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,
  max_cool_setpoint: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,

  /* eslint-enable camelcase */
  delta: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,
  step: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
});



/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelField; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__ = __webpack_require__(9);







/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/





var LabelField =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(LabelField, _React$Component);

  function LabelField() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, LabelField);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(LabelField).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(LabelField, [{
    key: "render",
    value: function render() {
      var styles = Object(__WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["b" /* default */])({
        label: {
          flex: "0 0 auto",
          display: "flex",
          alignItems: "center",
          maxWidth: "100%",
          fontWeight: "bold",
          justifyContent: "center"
        }
      });
      var _this$props = this.props,
          label = _this$props.label,
          style = _this$props.style;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "LabelField",
        style: style
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: {
          padding: __WEBPACK_IMPORTED_MODULE_8__Theme__["a" /* default */].Padding.CONTENT
        }
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.label
      }, label)));
    }
  }]);

  return LabelField;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(LabelField, "propTypes", {
  label: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  labelStyle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
});



/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(1183),
    arrayEach = __webpack_require__(1189),
    assignValue = __webpack_require__(265),
    baseAssign = __webpack_require__(1190),
    baseAssignIn = __webpack_require__(1201),
    cloneBuffer = __webpack_require__(1204),
    copyArray = __webpack_require__(1205),
    copySymbols = __webpack_require__(1206),
    copySymbolsIn = __webpack_require__(1208),
    getAllKeys = __webpack_require__(1209),
    getAllKeysIn = __webpack_require__(1210),
    getTag = __webpack_require__(1211),
    initCloneArray = __webpack_require__(1216),
    initCloneByTag = __webpack_require__(1217),
    initCloneObject = __webpack_require__(1229),
    isArray = __webpack_require__(138),
    isBuffer = __webpack_require__(474),
    isObject = __webpack_require__(102),
    keys = __webpack_require__(292);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(201),
    stackClear = __webpack_require__(1184),
    stackDelete = __webpack_require__(1185),
    stackGet = __webpack_require__(1186),
    stackHas = __webpack_require__(1187),
    stackSet = __webpack_require__(1188);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(201);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1185 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1186 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1187 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(201),
    Map = __webpack_require__(266),
    MapCache = __webpack_require__(409);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1189 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(214),
    keys = __webpack_require__(292);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 1191 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1193),
    isObjectLike = __webpack_require__(199);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(160),
    isObjectLike = __webpack_require__(199);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1194 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1196),
    baseUnary = __webpack_require__(1197),
    nodeUtil = __webpack_require__(1198);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(160),
    isLength = __webpack_require__(475),
    isObjectLike = __webpack_require__(199);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1197 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(405);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(293),
    nativeKeys = __webpack_require__(1200);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(476);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(214),
    keysIn = __webpack_require__(478);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(102),
    isPrototype = __webpack_require__(293),
    nativeKeysIn = __webpack_require__(1203);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1203 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(71);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)(module)))

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(214),
    getSymbols = __webpack_require__(294);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1207 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(214),
    getSymbolsIn = __webpack_require__(480);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(483),
    getSymbols = __webpack_require__(294),
    keys = __webpack_require__(292);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(483),
    getSymbolsIn = __webpack_require__(480),
    keysIn = __webpack_require__(478);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1212),
    Map = __webpack_require__(266),
    Promise = __webpack_require__(1213),
    Set = __webpack_require__(1214),
    WeakMap = __webpack_require__(1215),
    baseGetTag = __webpack_require__(160),
    toSource = __webpack_require__(406);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(122),
    root = __webpack_require__(71);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(122),
    root = __webpack_require__(71);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(122),
    root = __webpack_require__(71);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(122),
    root = __webpack_require__(71);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1216 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(295),
    cloneDataView = __webpack_require__(1219),
    cloneMap = __webpack_require__(1220),
    cloneRegExp = __webpack_require__(1223),
    cloneSet = __webpack_require__(1224),
    cloneSymbol = __webpack_require__(1227),
    cloneTypedArray = __webpack_require__(1228);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(71);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(295);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(1221),
    arrayReduce = __webpack_require__(484),
    mapToArray = __webpack_require__(1222);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 1221 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 1222 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1223 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(1225),
    arrayReduce = __webpack_require__(484),
    setToArray = __webpack_require__(1226);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 1225 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 1226 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(197);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(295);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1230),
    getPrototype = __webpack_require__(482),
    isPrototype = __webpack_require__(293);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(102);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapsableList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Tappable__ = __webpack_require__(28);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var styles = Object(__WEBPACK_IMPORTED_MODULE_9__utils_prefixStyles__["b" /* default */])({
  labelContainer: {
    display: "flex"
  },
  label: {
    flex: "1 1 auto"
  },
  iconContainer: {
    flex: "0 0 auto",
    width: "1.5em"
  },
  icon: {
    transition: "all 100ms ease-in-out"
  },
  iconOpen: {
    transform: "rotate(90deg)"
  },
  children: {
    paddingLeft: "2.5em",
    overflow: "hidden",
    height: 0
  },
  childrenOpen: {
    height: "inherit"
  }
});

var CollapsableList =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(CollapsableList, _React$Component);

  function CollapsableList() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CollapsableList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(CollapsableList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      open: _this.props.open
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleTap", function () {
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CollapsableList, [{
    key: "render",
    value: function render() {
      var open = this.state.open;
      var _this$props = this.props,
          header = _this$props.header,
          items = _this$props.items;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "CollapsibleList"
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        style: styles.labelContainer
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Tappable__["b" /* default */], {
        onTap: this._handleTap
      }, function (_ref) {
        var tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("span", {
          style: styles.iconContainer,
          ref: tapTargetRefHandler
        }, header ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Icons__["u" /* IconChevronRight */], {
          style: _objectSpread({}, styles.icon, {}, open ? styles.iconOpen : null)
        }) : null);
      }), __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-name": "header",
        style: styles.label
      }, header || items)), header && items ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-name": "items",
        style: _objectSpread({}, styles.children, {}, open ? styles.childrenOpen : null)
      }, items) : null);
    }
  }]);

  return CollapsableList;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(CollapsableList, "propTypes", {
  open: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  header: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  items: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node
});



/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GlobalStyleSheet__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ANIMATION_LENGTH = 250;
var STYLE_ID = "nx-components_PartialCheckboxAnimation";
var stylesheet = "\n  @keyframes ".concat(STYLE_ID, "_shrink-bounce {\n    0% {\n      transform: scale(1);\n    }\n    33% {\n      transform: scale(0.85);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n  @keyframes ").concat(STYLE_ID, "_checkbox-check {\n    0%{\n      width: 0;\n      height: 0;\n      border-bottom: 3px solid white;\n      transform: translate(0, 0);\n    }\n    100%{\n      width: .5em;\n      height: .5em;\n      border-bottom: 3px solid white;\n      transform: translate(-0.25em, -0.6em);\n    }\n  }\n");
__WEBPACK_IMPORTED_MODULE_9__GlobalStyleSheet__["a" /* default */].preload(STYLE_ID, stylesheet);

var PartialCheckbox =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(PartialCheckbox, _React$Component);

  function PartialCheckbox() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PartialCheckbox);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(PartialCheckbox).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PartialCheckbox, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.checked !== this.props.checked;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          checked = _this$props.checked,
          style = _this$props.style,
          colors = _this$props.colors;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["b" /* default */])({
        wrapper: {
          position: "relative",
          fontSize: "24px",
          width: "1em",
          height: "1em",
          border: "2px solid currentColor",
          borderRadius: "2px",
          transition: "all ".concat(ANIMATION_LENGTH, "ms ease-out")
        },
        checkedWrapper: {
          border: "0.5em solid ".concat(colors.PRIMARY),
          animation: "".concat(STYLE_ID, "_shrink-bounce ").concat(ANIMATION_LENGTH, "ms ease-out")
        },
        checkmark: {
          position: "absolute",
          transformOrigin: "bottom left",
          boxSizing: "content-box",
          borderBottom: "0px solid white",
          // border must be present for Safari to animate
          borderRight: "0px solid white",
          animation: "".concat(STYLE_ID, "_checkbox-check ").concat(ANIMATION_LENGTH, "ms 100ms ease-out forwards")
        }
      });
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "PartialCheckbox",
        "data-component-prop-checked": String(checked),
        style: _objectSpread({}, styles.wrapper, {}, checked ? styles.checkedWrapper : {}, {}, style)
      }, checked ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
        style: styles.checkmark
      }) : null);
    }
  }]);

  return PartialCheckbox;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(PartialCheckbox, "propTypes", {
  checked: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,
  style: function style() {
    return (typeof __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] === "function" ? __WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */] : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_8__utils_prefixStyles__["a" /* bpfrpt_proptype_StylesObject */])).apply(this, arguments);
  },
  colors: function colors() {
    return (typeof __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] === "function" ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired ? __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */].isRequired : __WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */] : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["a" /* bpfrpt_proptype_ColorSet */]).isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__ColorsProvider__["c" /* withColorsProvider */])(PartialCheckbox));




/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultDeviceHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_BatteryIndicator__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_DateTime__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Details_DetailsImage__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_IconGroup__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_parseIconsFromServer__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_models_mixins_device_features__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nx_components_Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_DrawUpdates__ = __webpack_require__(152);




















var DefaultDeviceHeader =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DefaultDeviceHeader, _React$Component);

  function DefaultDeviceHeader() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DefaultDeviceHeader);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DefaultDeviceHeader).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DefaultDeviceHeader, [{
    key: "render",
    value: function render() {
      var _this = this;

      var model = this.props.model;
      var icons = Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_parseIconsFromServer__["a" /* default */])(model.get("icon"), {
        showThermostatTemperatureModifier: true
      });

      var statusTextPrimary = _.str.capitalize(model.get("status"));

      var statusTextSecondary = model.get("status_secondary");
      var statusTextTertiary = model.get("status_tertiary");
      var hasBattery = Boolean(model.hasFeature(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_models_mixins_device_features__["Battery"]) && model.get("battery_label"));
      var batteryIcon = model.get("battery_icon");
      var batteryLabel = model.get("battery_label");
      var batteryUpdated = model.get("battery_updated_at");
      var deviceImageSrc = model.get("imageSrc");
      var strength = model.get("connection_strength");
      var hasConnection = model.hasFeature(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_models_mixins_device_features__["Connection"]) && strength !== "unknown";
      var signalStrength;

      if (hasConnection) {
        if (_.isNumber(strength)) {
          if (strength < 50) {
            signalStrength = "Low";
          } else {
            signalStrength = "".concat(strength, "%");
          }
        }
      }

      var styles = {
        calloutContainer: Object(__WEBPACK_IMPORTED_MODULE_15_nx_components_utils_prefixStyles__["b" /* default */])({
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }),
        statusIcon: {
          fontSize: "4em",
          margin: "0",
          // remove default margin
          verticalAlign: "middle"
        },
        statusText: {
          display: "inline-block",
          fontSize: ".8em",
          marginLeft: ".25em",
          textAlign: "left",
          verticalAlign: "middle"
        },
        primary: {
          fontSize: "1.1em",
          fontWeight: __WEBPACK_IMPORTED_MODULE_17_nx_components_Theme__["a" /* default */].Font.WEIGHT_BOLD,
          whiteSpace: "normal"
        },
        secondary: {
          whiteSpace: "normal",
          fontSize: ".8em"
        },
        tertiary: {
          fontSize: ".8em",
          marginTop: ".25em",
          whiteSpace: "normal"
        },
        furtherDetails: {
          marginTop: ".8em auto 0",
          maxWidth: "12em"
        },
        batteryDetails: {
          display: "inline-block",
          fontSize: ".9em",
          marginTop: ".4em",
          textAlign: "left"
        },
        batteryIcon: {
          marginLeft: "-.2em"
        },
        statusTimestamp: {
          fontSize: ".8em"
        },
        statusLabel: {
          fontWeight: __WEBPACK_IMPORTED_MODULE_17_nx_components_Theme__["a" /* default */].Font.WEIGHT_BOLD
        }
      };
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_DrawUpdates__["a" /* default */], {
        listenTo: model,
        events: ["change"],
        getNodeToStyle: function getNodeToStyle() {
          return _this._wrapper;
        }
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__["b" /* default */], {
        style: styles.calloutContainer,
        innerRef: function innerRef(el) {
          return _this._wrapper = el;
        }
      }, deviceImageSrc ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Details_DetailsImage__["a" /* default */], {
        imageSrc: deviceImageSrc,
        imageAlt: model.get("name")
      }) : __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_IconGroup__["a" /* default */], {
        values: icons,
        style: styles.statusIcon
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
        "data-component-section": "status-text",
        style: styles.statusText
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-status": "primary",
        style: styles.primary
      }, statusTextPrimary), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-status": "secondary",
        style: styles.secondary
      }, statusTextSecondary), statusTextTertiary ? __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-status": "tertiary",
        style: styles.tertiary
      }, statusTextTertiary) : null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.furtherDetails
      }, hasBattery && __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-section": "battery",
        style: styles.batteryDetails
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_components_BatteryIndicator__["a" /* default */], {
        icon: batteryIcon,
        label: "Battery: ".concat(batteryLabel),
        inline: true,
        style: styles.batteryIcon
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("br", null), batteryUpdated && __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
        style: styles.statusTimestamp
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("span", {
        style: styles.statusLabel
      }, "Last Updated: "), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_DateTime__["a" /* default */], {
        relative: true,
        value: batteryUpdated
      }))), hasConnection && __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", null, "Signal strength: ", signalStrength)))));
    }
  }]);

  return DefaultDeviceHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DefaultDeviceHeader, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Model).isRequired
});



/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_DarkModeInverter__ = __webpack_require__(107);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var DetailsImage = function DetailsImage(_ref) {
  var imageSrc = _ref.imageSrc,
      imageAlt = _ref.imageAlt;
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_DarkModeInverter__["a" /* default */], null, function (_ref2) {
    var maybeInvert = _ref2.maybeInvert;

    var imageStyle = _objectSpread({
      width: "100%",
      display: "block"
    }, maybeInvert);

    var bodyStyle = {
      display: "inline-block",
      margin: "0.25em 1em",
      verticalAlign: "middle",
      maxWidth: "12em",
      backgroundColor: "black"
    };
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
      style: bodyStyle
    }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("img", {
      style: imageStyle,
      src: imageSrc,
      alt: imageAlt
    }));
  });
};

DetailsImage.propTypes = {
  imageSrc: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  imageAlt: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (DetailsImage);

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThermostatHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_Thermostat_ThermostatDetailsHeader__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mixins_device_features_sensor__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_DrawUpdates__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nx_components_utils_prefixStyles__ = __webpack_require__(9);














var style = Object(__WEBPACK_IMPORTED_MODULE_13_nx_components_utils_prefixStyles__["b" /* default */])({
  padding: "",
  background: "none",
  minHeight: "20vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});

var ThermostatHeader =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ThermostatHeader, _React$Component);

  function ThermostatHeader() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ThermostatHeader);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ThermostatHeader).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ThermostatHeader, [{
    key: "render",
    value: function render() {
      var _this = this;

      var model = this.props.model;
      var temperatureOutside = null;
      var humidityRelative = null;

      if (model.hasFeature(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mixins_device_features_sensor__["a" /* default */])) {
        temperatureOutside = parseFloat(model.getSensorValue(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mixins_device_features_sensor__["a" /* default */].Type.OUTDOOR_TEMPERATURE));
        var humidity = model.getSensorValue(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mixins_device_features_sensor__["a" /* default */].Type.RELATIVE_HUMIDITY);
        humidityRelative = parseFloat(humidity) / 100;
      }

      var compressorSpeed = model.get("compressor_speed") == null ? null : model.get("compressor_speed");
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_DrawUpdates__["a" /* default */], {
        listenTo: model,
        events: ["change"],
        getNodeToStyle: function getNodeToStyle() {
          return _this._wrapper;
        }
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__["b" /* default */], {
        style: style,
        innerRef: function innerRef(el) {
          return _this._wrapper = el;
        }
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_Thermostat_ThermostatDetailsHeader__["a" /* default */], {
        humidityRelative: humidityRelative,
        systemStatus: model.get("status"),
        temperature: model.get("temperature"),
        temperatureOutside: temperatureOutside,
        compressorSpeed: compressorSpeed
      })));
    }
  }]);

  return ThermostatHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(ThermostatHeader, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Model).isRequired
});



/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PivotThermostatHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_Thermostat_ThermostatDetailsHeader__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mixins_device_features_sensor__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_DrawUpdates__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nx_components_utils_prefixStyles__ = __webpack_require__(9);














var style = Object(__WEBPACK_IMPORTED_MODULE_13_nx_components_utils_prefixStyles__["b" /* default */])({
  padding: "",
  background: "none"
});

var PivotThermostatHeader =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(PivotThermostatHeader, _React$Component);

  function PivotThermostatHeader() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PivotThermostatHeader);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(PivotThermostatHeader).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PivotThermostatHeader, [{
    key: "render",
    value: function render() {
      var _this = this;

      var model = this.props.model;
      var temperatureOutside = null;
      var humidityRelative = null;

      if (model.hasFeature(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mixins_device_features_sensor__["a" /* default */])) {
        temperatureOutside = parseFloat(model.getSensorValue(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mixins_device_features_sensor__["a" /* default */].Type.OUTDOOR_TEMPERATURE));
        var humidity = model.getSensorValue(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_mixins_device_features_sensor__["a" /* default */].Type.RELATIVE_HUMIDITY);
        humidityRelative = parseFloat(humidity) / 100;
      }

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_DrawUpdates__["a" /* default */], {
        listenTo: model,
        events: ["change"],
        getNodeToStyle: function getNodeToStyle() {
          return _this._wrapper;
        }
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__["b" /* default */], {
        style: style,
        innerRef: function innerRef(el) {
          return _this._wrapper = el;
        }
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_Thermostat_ThermostatDetailsHeader__["a" /* default */], {
        humidityRelative: humidityRelative,
        systemStatus: model.get("status"),
        temperature: model.get("temperature"),
        temperatureOutside: temperatureOutside
      })));
    }
  }]);

  return PivotThermostatHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(PivotThermostatHeader, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Model).isRequired
});



/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutomationHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_parseIconsFromServer__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_IconGroup__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_DrawUpdates__ = __webpack_require__(152);














var AutomationHeader =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(AutomationHeader, _React$Component);

  function AutomationHeader() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AutomationHeader);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AutomationHeader).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AutomationHeader, [{
    key: "render",
    value: function render() {
      var _this = this;

      var model = this.props.model;
      var icons = Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_parseIconsFromServer__["a" /* default */])(model.get("icon"));
      var styles = {
        statusIcon: {
          fontSize: "4em",
          margin: "0",
          // override default margin
          verticalAlign: "middle"
        },
        statusDescription: {
          display: "block",
          padding: ".5em",
          paddingTop: "1em",
          whiteSpace: "normal"
        }
      };
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_DrawUpdates__["a" /* default */], {
        listenTo: model,
        events: ["change"],
        getNodeToStyle: function getNodeToStyle() {
          return _this._wrapper;
        }
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "AutomationHeader"
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__["a" /* DetailsHeaderOffscreenOverscroll */], null), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__["b" /* default */], {
        innerRef: function innerRef(el) {
          return _this._wrapper = el;
        }
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_IconGroup__["a" /* default */], {
        values: icons,
        disableBadges: true,
        style: styles.statusIcon
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-section": "description",
        style: styles.statusDescription
      }, model.get("description")))));
    }
  }]);

  return AutomationHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(AutomationHeader, "propTypes", {
  model: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Model).isRequired
});



/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_UserIcon__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);





var styles = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_utils_prefixStyles__["b" /* default */])({
  iconStyle: {
    fontSize: "5em"
  }
});

var PhoneHeader = function PhoneHeader(props) {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.PhoneHeader;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    "data-component-name": "PhoneHeader"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__["a" /* DetailsHeaderOffscreenOverscroll */], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__["b" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_UserIcon__["a" /* default */], {
    phone: props.model,
    style: styles.iconStyle
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "details-status-description"
  }, language.mobileUserLabel)));
};

PhoneHeader.propTypes = {
  model: function model() {
    return (typeof Phone === "function" ? __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(Phone).isRequired : __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (PhoneHeader);


/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_location__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);





var BuildingHeader = function BuildingHeader(props) {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_3_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.details.BuildingHeader;
  var name = props.model.get("name");
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    "data-component-name": "BuildingHeader"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__["a" /* DetailsHeaderOffscreenOverscroll */], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderWrapper__["b" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "details-status-description"
  }, "".concat(language.buildingConfiguration, " > "), name)));
};

BuildingHeader.propTypes = {
  model: function model() {
    return (typeof __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_location__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_location__["a" /* default */]).isRequired : __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (BuildingHeader);


/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Dialogs_AlertDialog__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_ContextWrappers_LanguageContext__ = __webpack_require__(84);







var PivotDemoMessage = function PivotDemoMessage() {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5_nx_components_ContextWrappers_LanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.PivotDemoMessage;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store__["a" /* default */].appState && __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store__["a" /* default */].appState.inDemoMode && __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store__["a" /* default */].appState.isFirstVisit),
      _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      isDemoMessageOpen = _useState2[0],
      setIsDemoMessageOpen = _useState2[1];

  var dismissDemoMessage = function dismissDemoMessage() {
    setIsDemoMessageOpen(false);
    Object(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_FIRST_DEMO_VISIT");
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Dialogs_AlertDialog__["a" /* default */], {
    message: language.demoMessage,
    buttonText: language.okButton,
    onDismiss: dismissDemoMessage,
    open: isDemoMessageOpen
  });
};

/* harmony default export */ __webpack_exports__["a"] = (PivotDemoMessage);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DashboardPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_MountOnBody__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_location__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_framework_collection__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_TopBar_AppBarWrapper__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_TopBar_CommonAppBarContainer__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_models_device__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_models_mixins_device_features_group__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_models_mixins_device_features_thermostat__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_components_Commercial_NoDevicesPageCommercial__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_nexia_mobile_components_Pages_NoDevicesPage__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_nexia_mobile_components_Details_DeviceDetails__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_nexia_mobile_components_Pages_DashboardTilesPage__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_nexia_mobile_components_Page__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_nexia_mobile_components_SpinnerOverlay__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_nexia_mobile_models_device_sorter__ = __webpack_require__(174);



























function shouldViewItemDetails(item) {
  // Don't go to the GroupDetailsPage. Groups which are thermostats are multi-zoned
  // so that page is allowed.
  return item instanceof __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_models_device__["a" /* default */] && (!item.hasFeature(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_models_mixins_device_features_group__["a" /* default */]) || item.hasFeature(__WEBPACK_IMPORTED_MODULE_17_nexia_mobile_models_mixins_device_features_thermostat__["a" /* default */]));
}

var DashboardPage =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(DashboardPage, _React$Component);

  function DashboardPage() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DashboardPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DashboardPage)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_loadTileItems", function () {
      var currentLocation = _this.props.currentLocation;
      var devices = currentLocation.get("devices");
      var models = [];
      devices.each(function (device) {
        return models.push(device);
      });
      var sortedModels = __WEBPACK_IMPORTED_MODULE_25_nexia_mobile_models_device_sorter__["a" /* default */].sort(models);

      if (_this._tileItems) {
        _this._tileItems.set(sortedModels);
      } else {
        _this._tileItems = new __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_framework_collection__["a" /* default */](sortedModels);
      }

      return _this._tileItems;
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DashboardPage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          currentLocation = _this$props.currentLocation,
          showDeviceAdd = _this$props.showDeviceAdd;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_BackboneListener__["a" /* default */], {
        listenTo: currentLocation,
        events: ["change:hasParsedChildCollections", "change:hasGroupSaveUpdates"]
      }, function () {
        var automations = currentLocation.get("automations");
        var devices = currentLocation.get("devices");
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_BackboneListener__["a" /* default */], {
          listenTo: automations,
          events: ["add", "remove", "reset", "sort", "change:shownOnDashboard"],
          debounceRender: true
        }, function () {
          return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_BackboneListener__["a" /* default */], {
            listenTo: devices,
            events: ["reset", "sort", "update"]
          }, function () {
            var isCommercial = __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_environment__["a" /* default */].isCommercial();
            var locationAppBar = __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_TopBar_AppBarWrapper__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_components_TopBar_CommonAppBarContainer__["a" /* default */], {
              title: currentLocation.get("name")
            }));

            if (!currentLocation.get("hasParsedChildCollections")) {
              return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23_nexia_mobile_components_Page__["b" /* default */], {
                name: "UnparsedSpinner",
                fullyLoaded: false
              }, locationAppBar, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_MountOnBody__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24_nexia_mobile_components_SpinnerOverlay__["a" /* default */], null)));
            }

            var tileItems = _this2._loadTileItems();

            if (tileItems.length === 0) {
              return isCommercial ? __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19_nexia_mobile_components_Commercial_NoDevicesPageCommercial__["a" /* default */], {
                appBar: locationAppBar,
                title: currentLocation.get("name"),
                showDeviceAdd: showDeviceAdd
              }) : __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20_nexia_mobile_components_Pages_NoDevicesPage__["a" /* default */], {
                appBar: locationAppBar,
                showDeviceAdd: showDeviceAdd
              });
            } else if (tileItems.length === 1 && shouldViewItemDetails(tileItems.first())) {
              return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21_nexia_mobile_components_Details_DeviceDetails__["a" /* default */], {
                model: tileItems.first(),
                appBar: locationAppBar,
                isDashboard: true
              });
            }

            return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22_nexia_mobile_components_Pages_DashboardTilesPage__["a" /* default */], {
              appBar: locationAppBar,
              location: currentLocation,
              tileItems: tileItems
            });
          });
        });
      });
    }
  }]);

  return DashboardPage;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(DashboardPage, "propTypes", {
  currentLocation: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_models_location__["a" /* default */]).isRequired,
  showDeviceAdd: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired // () => void

});



/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Page__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Scrollable_ScrollableArea__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_OverlayLinearProgress__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_safelyOpen__ = __webpack_require__(323);









var NoDevicesPage = function NoDevicesPage(_ref) {
  var appBar = _ref.appBar,
      showDeviceAdd = _ref.showDeviceAdd,
      backgroundLoading = _ref.backgroundLoading;
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Page__["b" /* default */], {
    name: "NoDevicesPage",
    fullyLoaded: true
  }, appBar, backgroundLoading && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_OverlayLinearProgress__["a" /* default */], {
    indeterminate: true
  }), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Scrollable_ScrollableArea__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    style: {
      padding: "0 0.75em",
      maxWidth: "25em",
      margin: "0.75em auto"
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "With Nexia, you have the flexibility to monitor and control your home's smart devices."), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "If you already have your devices, select the 'Connect New Device' button below to begin connecting your devices to Nexia."), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    style: {
      textAlign: "center"
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_nx_components_Button__["a" /* default */], {
    theme: "ghost",
    onTap: showDeviceAdd
  }, "Connect New Device")), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p", null, "For more information about devices that work with Nexia, go to our 'Compatible Products' page."), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    style: {
      textAlign: "center"
    }
  }, __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_nx_components_Button__["a" /* default */], {
    theme: "ghost",
    needsTrustedTap: true,
    onTap: function onTap() {
      Object(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_safelyOpen__["a" /* default */])("http://www.nexiahome.com/compatible-products/");
    }
  }, "Compatible Products")))));
};

NoDevicesPage.propTypes = {
  appBar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,
  showDeviceAdd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  backgroundLoading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  backgroundLoading: "backgroundLoading"
}, NoDevicesPage));

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_Routing_SwitchWith404__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Pages_BuildingsPage__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Pages_BuildingEditPage__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Details_BuildingDetails__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_flux_like_store__ = __webpack_require__(27);

















var BuildingRoutes =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(BuildingRoutes, _React$Component);

  function BuildingRoutes() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, BuildingRoutes);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(BuildingRoutes).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(BuildingRoutes, [{
    key: "render",
    value: function render() {
      var session = this.props.session;
      return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_BackboneListener__["a" /* default */], {
        listenTo: session,
        events: ["change:locations"]
      }, function () {
        var locations = session.get("locations");
        locations.each(function (location) {
          return location.preventDeviceListingView();
        });
        return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_BackboneListener__["a" /* default */], {
          listenTo: locations,
          events: ["add", "remove", "reset", "sort", "sync"],
          debounceRender: true
        }, function () {
          return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_Routing_SwitchWith404__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* Route */], {
            path: "/app/buildings",
            exact: true,
            render: function render() {
              return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Pages_BuildingsPage__["a" /* default */], {
                collection: locations,
                onNew: function onNew() {
                  Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_dispatch__["a" /* default */])("RUN_PROMISE_WITH_SPINNER", function () {
                    return locations.getChildSchema().then(function (editSchema) {
                      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_history__["d" /* history */].push("/app/buildings/edit", {
                        editSchema: editSchema
                      });
                    });
                  });
                }
              });
            }
          }), __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* Route */], {
            path: "/app/buildings/details",
            exact: true,
            render: function render(_ref) {
              var location = _ref.location;
              var building = location.state.building;
              return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_BackboneListener__["a" /* default */], {
                listenTo: building,
                events: ["change"]
              }, function () {
                return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_components_Details_BuildingDetails__["a" /* default */], {
                  model: building,
                  openBuildingEdit: function openBuildingEdit(editSchema) {
                    __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_history__["d" /* history */].push("/app/buildings/edit", {
                      editSchema: editSchema
                    });
                  },
                  onDelete: function onDelete() {
                    Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_dispatch__["a" /* default */])("RUN_PROMISE_WITH_SPINNER", function () {
                      return new Promise(function (resolve) {
                        Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_dispatch__["a" /* default */])("POPULATE_SESSION");
                        __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_flux_like_store__["a" /* default */].session.get("locations").once("remove", resolve);
                      }).then(function () {
                        return __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_history__["d" /* history */].goBack();
                      });
                    });
                  }
                });
              });
            }
          }), __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* Route */], {
            path: "/app/buildings/edit",
            exact: true,
            render: function render(_ref2) {
              var location = _ref2.location;
              var editSchema = location.state.editSchema;
              return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_Pages_BuildingEditPage__["a" /* default */], {
                model: editSchema,
                onCommit: function onCommit() {
                  Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_dispatch__["a" /* default */])("RUN_PROMISE_WITH_SPINNER", function () {
                    return Promise.resolve(Object(__WEBPACK_IMPORTED_MODULE_14_nexia_mobile_flux_like_dispatch__["a" /* default */])("POPULATE_SESSION")).then(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_history__["d" /* history */].goBack());
                  });
                }
              });
            }
          }));
        });
      });
    }
  }]);

  return BuildingRoutes;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  session: "session"
}, BuildingRoutes));

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_location_collection__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Page__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Scrollable_TrackedScrollableArea__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_TileList__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_TopBar_AppBarButtons__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_TopBar_AppBarWrapper__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_TopBar_CommonAppBarContainer__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);










var BuildingsPage = function BuildingsPage(props) {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_8_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.pages.BuildingsPage;
  var collection = props.collection,
      onNew = props.onNew;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Page__["b" /* default */], {
    name: "BuildingsPage",
    fullyLoaded: true
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_TopBar_AppBarWrapper__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_TopBar_CommonAppBarContainer__["a" /* default */], {
    title: language.title,
    iconRight: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_TopBar_AppBarButtons__["a" /* default */], {
      customActionTitle: language.newBuilding,
      onCustomAction: onNew
    })
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Scrollable_TrackedScrollableArea__["a" /* default */], {
    trackingKey: "BuildingsPage"
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_TileList__["a" /* default */], {
    collection: collection
  })));
};

BuildingsPage.propTypes = {
  collection: function collection() {
    return (typeof __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_location_collection__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_models_location_collection__["a" /* default */]).isRequired : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  onNew: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (BuildingsPage);


/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Page__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Scrollable_ScrollableArea__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_SchemaFieldsFormManager__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_TopBar_AppBarWrapper__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_TopBar_AppBarButtons__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_TopBar_CommonAppBarContainer__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);











var BuildingEditPage = function BuildingEditPage(props) {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.pages.BuildingEditPage;

  var handleSave = function handleSave(_ref) {
    var setServerErrors = _ref.setServerErrors,
        getFieldValues = _ref.getFieldValues,
        validateBeforeSubmit = _ref.validateBeforeSubmit;
    var model = props.model,
        onCommit = props.onCommit;
    model.set(getFieldValues());
    var validationResult = validateBeforeSubmit();

    if (validationResult.hasErrors) {
      return;
    }

    Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */])("RUN_PROMISE_WITH_SPINNER", function () {
      return model.commit().then(function (result) {
        if (result && result.serverErrors) {
          setServerErrors(result.serverErrors);
          return Promise.resolve();
        } else {
          return onCommit();
        }
      });
    });
  };

  var model = props.model;
  var buildingComponents = model.getChildren();
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_BackboneListener__["a" /* default */], {
    listenTo: buildingComponents,
    debounceRender: true,
    events: ["add", "remove", "reset", "sort", "sync", "change"]
  }, function () {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Page__["b" /* default */], {
      name: "BuildingEditPage",
      fullyLoaded: true
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_SchemaFieldsFormManager__["a" /* default */], {
      schema: model
    }, function (_ref2) {
      var schemaFieldsForm = _ref2.schemaFieldsForm,
          setServerErrors = _ref2.setServerErrors,
          getFieldValues = _ref2.getFieldValues,
          validateBeforeSubmit = _ref2.validateBeforeSubmit;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_TopBar_AppBarWrapper__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_TopBar_CommonAppBarContainer__["a" /* default */], {
        title: model.get("title"),
        iconRight: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_TopBar_AppBarButtons__["a" /* default */], {
          onCustomAction: function onCustomAction() {
            handleSave({
              setServerErrors: setServerErrors,
              getFieldValues: getFieldValues,
              validateBeforeSubmit: validateBeforeSubmit
            });
          },
          customActionTitle: language.save
        })
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Scrollable_ScrollableArea__["a" /* default */], null, schemaFieldsForm));
    }));
  });
};

BuildingEditPage.propTypes = {
  model: function model() {
    return (typeof Schema === "function" ? __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.instanceOf(Schema).isRequired : __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  onCommit: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (BuildingEditPage);


/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SchemaFieldsForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raven_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_Form__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_FormError__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_parseIconsFromServer__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nx_components_UserAgent__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/







var isAndroid = __WEBPACK_IMPORTED_MODULE_12_nx_components_UserAgent__["a" /* default */].isAndroid();

var SchemaFieldsForm =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SchemaFieldsForm, _React$Component);

  function SchemaFieldsForm() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, SchemaFieldsForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SchemaFieldsForm)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_massageFieldShape", function (field, errorsForField, changedValue) {
      // $FlowFixMe cloning unions of object types via spread doesn't really work
      var newField = _objectSpread({}, field); // Create icons from icon strings


      if (newField.type === "multi") {
        _this._massageMultiField(newField);
      } else if (newField.type === "range") {
        _this._massageSliderField(newField);
      }

      if (errorsForField && errorsForField.length > 0) {
        newField.error = errorsForField[0];
      }

      if (changedValue != null) {
        if (newField.type === "color") {
          newField.warm = changedValue.warm;
          newField.cool = changedValue.cool;
          newField.red = changedValue.red;
          newField.green = changedValue.green;
          newField.blue = changedValue.blue;
        } else {
          newField.value = changedValue;
        }
      }

      return newField;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_massageMultiField", function (newField) {
      if (newField.options && Array.isArray(newField.options)) {
        var dedupedOptions = [];
        var hasDupes = false;
        var prevValue = null;
        newField.options.forEach(function (option) {
          if (prevValue != null && prevValue === option.value) {
            hasDupes = true;
            return; // don't display this duplicate option
          }

          prevValue = option.value;
          var icon = Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_parseIconsFromServer__["a" /* default */])(option.icon)[0];
          dedupedOptions.push(_objectSpread({}, option, {
            id: option.value,
            icon: icon && icon.element
          }));
        });

        if (hasDupes) {
          __WEBPACK_IMPORTED_MODULE_8_raven_js___default.a.captureMessage("MultiSelectField created with duplicate options", {
            level: "warning",
            extra: {
              options: newField.options
            }
          });
        }

        newField.options = dedupedOptions;
      }

      return newField;
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_massageSliderField", function (newField) {
      newField.stepValues = newField.step_values;
      newField.hasOffState = newField.has_off_state;

      if (newField.minButton != null && newField.minButton.icon != null && !__WEBPACK_IMPORTED_MODULE_7_react__["isValidElement"](newField.minButton.icon)) {
        newField.minButton.icon = Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_parseIconsFromServer__["a" /* default */])(newField.minButton.icon)[0].element;
      }

      if (newField.maxButton != null && newField.maxButton.icon != null && !__WEBPACK_IMPORTED_MODULE_7_react__["isValidElement"](newField.maxButton.icon)) {
        newField.maxButton.icon = Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_parseIconsFromServer__["a" /* default */])(newField.maxButton.icon)[0].element;
      }

      return newField;
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SchemaFieldsForm, [{
    key: "scrollToField",

    /* public ref interface */
    value: function scrollToField(fieldName) {
      var _this2 = this;

      setTimeout(function () {
        return _this2._scrollToField(fieldName);
      }, __WEBPACK_IMPORTED_MODULE_10_nx_components_FormError__["a" /* FORM_ERROR_ANIMATION_DELAY */]);
    }
    /* public ref interface end */

  }, {
    key: "_scrollToField",
    value: function _scrollToField(fieldName) {
      if (!this._wrapper) {
        return;
      }

      var fieldElement = this._wrapper.querySelector("[data-field-name=\"".concat(fieldName, "\"]"));

      if (fieldElement != null) {
        // $FlowIgnore scrollIntoViewIfNeeded is supported on all of our browsers
        if (typeof fieldElement.scrollIntoViewIfNeeded == "function") {
          fieldElement.scrollIntoViewIfNeeded();
        } else {
          fieldElement.scrollIntoView();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          fields = _this$props.fields,
          fieldErrors = _this$props.fieldErrors,
          fieldValues = _this$props.fieldValues,
          onChange = _this$props.onChange,
          onSubmit = _this$props.onSubmit,
          onBlur = _this$props.onBlur,
          onEnterPressed = _this$props.onEnterPressed,
          autoFocusField = _this$props.autoFocusField,
          title = _this$props.title,
          controllableThermostatsLabel = _this$props.controllableThermostatsLabel,
          schema = _this$props.schema;
      var copy = __WEBPACK_IMPORTED_MODULE_13_lodash_cloneDeep___default()(fields);
      var massagedFields;

      if (title) {
        var newFieldObj = {
          label: controllableThermostatsLabel,
          type: "label"
        };

        if (schema.get("phone_carrier_id")) {
          copy.splice(3, 0, newFieldObj);
        } else {
          copy.splice(4, 0, newFieldObj);
        }

        massagedFields = copy.map(function (field) {
          return _this3._massageFieldShape(field, fieldErrors[field.name], fieldValues[field.name]);
        });
      } else {
        massagedFields = fields.map(function (field) {
          return _this3._massageFieldShape(field, fieldErrors[field.name], fieldValues[field.name]);
        });
      }

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "SchemaFieldsForm",
        ref: function ref(el) {
          return _this3._wrapper = el;
        }
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_Form__["a" /* default */], {
        fields: massagedFields,
        onChange: onChange,
        onSubmit: onSubmit,
        onBlur: onBlur,
        onEnterPressed: onEnterPressed,
        autoFocusField: autoFocusField,
        shouldScrollIntoView: isAndroid
      }));
    }
  }]);

  return SchemaFieldsForm;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(SchemaFieldsForm, "propTypes", {
  fields: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.arrayOf(function () {
    return (typeof FormField === "function" ? __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.instanceOf(FormField).isRequired : __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.any.isRequired).apply(this, arguments);
  }).isRequired,
  fieldErrors: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string.isRequired).isRequired).isRequired,
  fieldValues: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.objectOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `".concat(propName, "` has type 'any' or 'mixed', but was not provided to `").concat(componentName, "`. Pass undefined or any other value."));
    }
  }).isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  onSubmit: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  onEnterPressed: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,
  autoFocusField: __WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string
});




/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getValueForField;
/* harmony export (immutable) */ __webpack_exports__["c"] = isOrphanedField;
/* harmony export (immutable) */ __webpack_exports__["a"] = validateFields;
/* unused harmony export bpfrpt_proptype_FieldValidationResult */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_validatable__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);


var bpfrpt_proptype_FieldValidationResult = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
  hasErrors: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([false]).isRequired,
  nameOfFirstFieldWithError: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([true]).isRequired,
  errors: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    __exact__: function __exact__(values, prop, displayName) {
      var props = {};
      var extra = [];

      for (var k in values) {
        if (values.hasOwnProperty(k) && !props.hasOwnProperty(k)) {
          extra.push(k);
        }
      }

      if (extra.length > 0) {
        return new Error('Invalid additional prop(s) ' + JSON.stringify(extra));
      }
    }
  }).isRequired
}), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
  hasErrors: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf([true]).isRequired,
  nameOfFirstFieldWithError: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  errors: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired).isRequired).isRequired
})]);
function getValueForField(field, fieldValuesObject) {
  var value;

  if ({}.hasOwnProperty.call(fieldValuesObject, field.name)) {
    value = fieldValuesObject[field.name];
  } else {
    // If the value is not specified in the fieldValuesObject, check the
    // field definition itself. A value will be present there when editing
    // an existing resource, for example.
    // eslint-disable-next-line no-lonely-if
    if (field.type === "color") {
      value = {
        warm: field.warm || 0,
        cool: field.cool || 0,
        red: field.red || 0,
        green: field.green || 0,
        blue: field.blue || 0
      };
    } else if (typeof field.value !== "undefined") {
      value = field.value;
    }
  }

  if (field.type === "boolean" && value == null) {
    value = false;
  }

  return value;
}
function isOrphanedField(field, fields, fieldValuesObject) {
  if (field.dependency == null && field.hideIf == null) {
    return false;
  }

  if (field.dependency) {
    return fields.findIndex(function (otherField) {
      return getValueForField(otherField, fieldValuesObject) === field.dependency;
    }) === -1;
  }

  if (field.hideIf) {
    var hideIf = field.hideIf;

    switch (hideIf.operator) {
      case "one_of":
        {
          var parentField = fields.find(function (otherField) {
            return otherField.name === hideIf.fieldName;
          });

          if (parentField == null) {
            return false;
          }

          return hideIf.argument.includes(getValueForField(parentField, fieldValuesObject));
        }
    }
  }

  return false;
}
function validateFields(fields, fieldValuesObject, options) {
  var localeSet = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["b" /* getLanguageSet */])();
  var language = localeSet.nexia_mobile.utils.validateFields;
  var hasErrors = false;
  var nameOfFirstFieldWithError = null;
  var errors = {};
  fields.forEach(function (field) {
    if (options.validateUnsetFields === false && fieldValuesObject[field.name] == null) {
      return;
    }

    var addError = function addError(message) {
      hasErrors = true;

      if (nameOfFirstFieldWithError == null) {
        nameOfFirstFieldWithError = field.name;
      }

      if (errors[field.name] == null) {
        errors[field.name] = [];
      }

      errors[field.name].push(message);
    };

    var value = getValueForField(field, fieldValuesObject);
    var label = field.label || field.name; // For string templates only.

    var fieldLength = field.length || 0;
    var fieldMinLength = field.minLength || 0;
    var fieldMaxLength = field.maxLength || 0;
    var fieldMin = field.min || 0;
    var fieldMax = field.max || 0;
    var LABEL_REQUIRED = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelRequiredTemplate, {
      label: label
    });
    var LABEL_DOES_NOT_MATCH = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelDoesNotMatchTemplate, {
      label: label
    });
    var LABEL_INVALID = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelInvalidTemplate, {
      label: label
    });
    var LABEL_EXACT_LENGTH_CHARS = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelExactLengthCharsTemplate, {
      label: label,
      fieldLength: fieldLength
    });
    var LABEL_MIN_LENGTH_CHARS = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelMinLengthCharsTemplate, {
      label: label,
      fieldMinLength: fieldMinLength
    });
    var LABEL_MAX_LENGTH_CHARS = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelMaxLengthCharsTemplate, {
      label: label,
      fieldMaxLength: fieldMaxLength
    });
    var LABEL_MIN_NUMBER = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelMinNumberTemplate, {
      label: label,
      fieldMin: fieldMin
    });
    var LABEL_MAX_NUMBER = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelMaxNumberTemplate, {
      label: label,
      fieldMax: fieldMax
    });
    var LABEL_EARLY = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelEarlyTemplate, {
      label: label
    });
    var LABEL_LATE = Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_Locales__["e" /* template */])(language.labelLateTemplate, {
      label: label
    }); // Handle required fields

    if (field.required && (value == null || // null or undefined
    value.toString().trim() === "" || // empty string or whitespace only
    field.type === "select" && value === "_default" || // a select item placeholder
    field.type === "boolean" && value !== true) // for boolean fields, required means "must be true"
    ) {
        if (isOrphanedField(field, fields, fieldValuesObject)) {// It's okay for this field to be omitted even though it is listed
          // as required, because its parent field's value is not set.
        } else {
          addError(field.requiredMessage || field.message || LABEL_REQUIRED);
        }
      } // Equality with another field


    if (field.equalTo != null) {
      var equalToField = fields.find(function (otherField) {
        return otherField.name === field.equalTo;
      });

      if (equalToField != null && value !== getValueForField(equalToField, fieldValuesObject)) {
        addError(LABEL_DOES_NOT_MATCH);
      }
    }

    var stringValue = value != null ? value.toString() : "";

    if (stringValue === "" && !field.required) {
      // If the field is not required, it is allowed to be empty even if that fails other validations
      return;
    } // Handle validation patterns


    var pattern = field.pattern && new RegExp(field.pattern);

    if (field.patternType) {
      pattern = __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_framework_validatable__["a" /* VALIDATION_PATTERNS */][field.patternType];
    }

    if (pattern && !stringValue.match(pattern)) {
      addError(field.message || LABEL_INVALID);
    } // Handle string length


    if (field.type === "text" || field.type === "password" || field.type === "email") {
      if (typeof field.length === "number") {
        if (typeof value !== "string" || value.length !== field.length) {
          addError(LABEL_EXACT_LENGTH_CHARS);
        }
      }

      if (typeof field.minLength === "number") {
        if (typeof value !== "string" || value.length < field.minLength) {
          addError(LABEL_MIN_LENGTH_CHARS);
        }
      }

      if (typeof field.maxLength === "number") {
        if (typeof value === "string" && value.length > field.maxLength) {
          addError(LABEL_MAX_LENGTH_CHARS);
        }
      }
    } // Handle number min/max


    if (typeof value === "number" && (field.type === "number" || field.type === "range")) {
      if (typeof field.min === "number" && typeof value === "number") {
        if (value < field.min) {
          addError(LABEL_MIN_NUMBER);
        }
      }

      if (typeof field.max === "number") {
        if (value > field.max) {
          addError(LABEL_MAX_NUMBER);
        }
      }
    } // Handle date min/max


    if (field.type === "date") {
      if (field.min != null) {
        // $FlowFixMe: field.min is not refined from `string | void` to `string` here for some reason
        if (Date.parse(value) < Date.parse(field.min)) {
          addError(LABEL_EARLY);
        }
      }

      if (field.max != null) {
        // $FlowFixMe: field.max is not refined from `string | void` to `string` here for some reason
        if (Date.parse(value) > Date.parse(field.max)) {
          addError(LABEL_LATE);
        }
      }
    }
  }); // $FlowIgnore: flow can't tell that errors is guaranteed to be empty when hasErrors is false

  return {
    hasErrors: hasErrors,
    errors: errors,
    nameOfFirstFieldWithError: nameOfFirstFieldWithError
  };
}



/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Page__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderContainer__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Scrollable_ScrollableArea__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_TopBar_AppBarButtons__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_TopBar_AppBarWrapper__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_TopBar_CommonAppBarContainer__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Dialogs_ConfirmationDialog__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Dialogs_AlertDialog__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_location__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nexia_mobile_models_device__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_models_schema__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nx_components_Section__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nx_components_ItemList__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nx_components_Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);





















var ITEM_PADDING = __WEBPACK_IMPORTED_MODULE_18_nx_components_Theme__["a" /* default */].Padding.CONTENT;

var BuildingDetails = function BuildingDetails(props) {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_20_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.details.BuildingDetails;
  var styles = Object(__WEBPACK_IMPORTED_MODULE_3_nx_components_utils_prefixStyles__["b" /* default */])({
    section: {
      borderTop: "1px solid #E3E3E3"
    },
    detail: {
      fontSize: ".9em",
      flexDirection: "row"
    },
    itemDeviceContainer: {
      display: "flex",
      alignItems: "top",
      whiteSpace: "normal",
      color: props.colors.TEXT,
      outline: "none",
      transition: "color 0.1s",
      cursor: "default",
      backgroundColor: "transparent",
      fontSize: "0.85em"
    },
    itemDeviceLabel: {
      paddingTop: ITEM_PADDING,
      paddingRight: ITEM_PADDING,
      paddingBottom: ITEM_PADDING,
      paddingLeft: 0,
      minWidth: 0,
      // fixes a bizarre bug with text-overflow
      flex: "1 1 auto"
    },
    itemDeviceChildren: {
      paddingTop: ITEM_PADDING,
      whiteSpace: "normal",
      height: "100%",
      flex: "0 0 auto",
      minWidth: 0 // fixes a bizarre bug with text-overflow

    }
  });

  var handleDelete = function handleDelete() {
    var locations = __WEBPACK_IMPORTED_MODULE_19_nexia_mobile_flux_like_store__["a" /* default */].session.get("locations");

    if (locations.length === 1) {
      var message = language.minOneBuilding;
      Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Dialogs_AlertDialog__["b" /* showAlertDialog */])({
        message: message
      });
      return;
    }

    var model = props.model,
        onDelete = props.onDelete;
    var deviceCollection = model.get("devices").models;

    if (deviceCollection.length === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Dialogs_ConfirmationDialog__["b" /* showConfirmationDialog */])({
        message: language.deleteConfirmation,
        cancelOnBackgroundClick: false,
        cancelOnRequestClose: false,
        confirmButtonText: language["delete"],
        onConfirm: function onConfirm() {
          Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */])("RUN_PROMISE_WITH_SPINNER", function () {
            return model.destroy({
              wait: true
            }).then(onDelete);
          });
        }
      });
    } else {
      var _message = language.hasDevicesCannotDelete;
      Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Dialogs_AlertDialog__["b" /* showAlertDialog */])({
        message: _message
      });
    }
  };

  var handleEdit = function handleEdit() {
    var model = props.model,
        openBuildingEdit = props.openBuildingEdit;
    Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */])("RUN_PROMISE_WITH_SPINNER", function () {
      return model.fetch().then(function () {
        model.createEditSchema().then(openBuildingEdit);
      });
    });
  };

  var buildingDevicesList = function buildingDevicesList(devices) {
    return devices.map(function (device) {
      var key = device.get("id");
      var name = device.get("name");
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: key,
        style: styles.detail
      }, name);
    });
  };

  var model = props.model;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_BackboneListener__["a" /* default */], {
    listenTo: model,
    events: ["change", "sync"]
  }, function () {
    var name = model.get("name");
    var postalCode = model.get("postal_code");
    var deviceCollection = model.get("devices").models;
    var detailsItems = [{
      id: "name",
      label: language.nameLabel,
      children: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        style: styles.detail
      }, name)
    }, {
      id: "postalCode",
      label: language.postalCodeLabel,
      children: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        style: styles.detail
      }, postalCode)
    }];
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Page__["b" /* default */], {
      name: "BuildingDetails",
      fullyLoaded: true
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_TopBar_AppBarWrapper__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_TopBar_CommonAppBarContainer__["a" /* default */], {
      title: model.get("name"),
      iconRight: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_TopBar_AppBarButtons__["a" /* default */], {
        onDelete: handleDelete,
        onEdit: handleEdit
      })
    })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Scrollable_ScrollableArea__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_components_Details_DetailsHeaders_DetailsHeaderContainer__["a" /* default */], {
      model: model
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_nx_components_Section__["a" /* default */], {
      style: styles.section,
      label: language.buildingDetailsLabel
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_nx_components_ItemList__["c" /* default */], {
      id: "detail-items",
      items: detailsItems,
      style: {
        fontSize: "0.85em"
      }
    }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      style: styles.itemDeviceContainer
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      style: styles.itemDeviceLabel
    }, language.devices), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      style: styles.itemDeviceChildren
    }, deviceCollection.length !== 0 ? buildingDevicesList(deviceCollection) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      style: styles.detail
    }, language.none))))));
  });
};

BuildingDetails.propTypes = {
  model: function model() {
    return (typeof __WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_location__["a" /* default */] === "function" ? __WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_13_nexia_mobile_models_location__["a" /* default */]).isRequired : __WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  openBuildingEdit: __WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.func.isRequired,
  onDelete: __WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.func.isRequired,
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_nx_components_ColorsProvider__["c" /* withColorsProvider */])(BuildingDetails));


/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_sizeme__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_sizeme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_sizeme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nx_components_Theme__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nx_components_Thermostat_ThermostatSetpoints__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Scrollable_ScrollableArea__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Page__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_TopBar_AppBarWrapper__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_TopBar_CommonAppBarContainer__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nx_components_Button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nx_components_ButtonGroup__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Dialogs_ConfirmationDialog__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_Dialogs_Pivot_PivotDevicesGroupsDialog__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_Commercial_PivotDemoBanner__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_nx_components_ContextWrappers_UserLanguageContext__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_prop_types__);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















var OccupancySetpointsPage = function OccupancySetpointsPage(props) {
  /* eslint-disable camelcase */
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])({
    preset_heat1: null,
    preset_cool1: null,
    preset_heat2: null,
    preset_cool2: null
  }),
      _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];
  /* eslint-enable camelcase */


  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_19_nx_components_ContextWrappers_UserLanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.pages.OccupancySetpointsPage;
  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
    Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_flux_like_dispatch__["a" /* default */])("DISABLE_LOCATION_POLLING");
    return function () {
      Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_flux_like_dispatch__["a" /* default */])("ENABLE_LOCATION_POLLING");
    };
  }, []);

  var showSpinner = function showSpinner(message) {
    Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_SPINNER", message);
  };

  var hideSpinner = function hideSpinner() {
    Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_flux_like_dispatch__["a" /* default */])("HIDE_SPINNER");
  };

  var handleChangesStarted = function handleChangesStarted() {// Is required but do nothing. Needs to be refactored out of ThermostatSetpoints.
  };

  var handleApplyChanges = function handleApplyChanges() {
    var model = props.model;
    var message = language.savingSetpoints;

    var onDone = function onDone() {
      Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", language.saveSuccessful);
      hideSpinner();
      __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_history__["d" /* history */].goBack();
    };

    var onError = function onError() {
      Object(__WEBPACK_IMPORTED_MODULE_9_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", language.saveError);
      hideSpinner();
    };

    var onChoose = function onChoose(ids) {
      showSpinner(message);
      model.setGroupOccupancySetpoints(ids, state).then(onDone, onError);
    };

    Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_Dialogs_ConfirmationDialog__["b" /* showConfirmationDialog */])({
      message: language.applyToAdditionalStats,
      cancelButtonText: language.no,
      confirmButtonText: language.yes,
      onConfirm: function onConfirm() {
        Object(__WEBPACK_IMPORTED_MODULE_16_nexia_mobile_components_Dialogs_Pivot_PivotDevicesGroupsDialog__["a" /* showPivotDevices */])({
          open: true,
          targetId: model.get("id"),
          onChoose: onChoose
        });
      },
      onCancel: function onCancel() {
        showSpinner(message);
        model.setOccupancySetpoints(state).then(onDone, onError);
      }
    });
  };

  var handleChangesEnded = function handleChangesEnded(_ref) {
    var setpointHeat = _ref.setpointHeat,
        setpointCool = _ref.setpointCool,
        label = _ref.label;
    var newSetpoints;
    /* eslint-disable camelcase */

    if (label === "Occupied") {
      newSetpoints = {
        preset_heat1: setpointHeat,
        preset_cool1: setpointCool
      };
    } else {
      newSetpoints = {
        preset_heat2: setpointHeat,
        preset_cool2: setpointCool
      };
    }
    /* eslint-enable camelcase */


    setState(_objectSpread({}, state, {}, newSetpoints));
  };

  var handleOccupiedChangesEnded = function handleOccupiedChangesEnded(_ref2) {
    var setpointHeat = _ref2.setpointHeat,
        setpointCool = _ref2.setpointCool;
    handleChangesEnded({
      setpointHeat: setpointHeat,
      setpointCool: setpointCool,
      label: "Occupied"
    });
  };

  var handleUnoccupiedChangesEnded = function handleUnoccupiedChangesEnded(_ref3) {
    var setpointHeat = _ref3.setpointHeat,
        setpointCool = _ref3.setpointCool;
    handleChangesEnded({
      setpointHeat: setpointHeat,
      setpointCool: setpointCool,
      label: "Unoccupied"
    });
  };

  var handleChangesCanceled = function handleChangesCanceled() {// Is required but do nothing. Needs to be refactored out of ThermostatSetpoints.
  };

  var model = props.model,
      size = props.size;
  /* eslint-disable camelcase */

  var preset_heat1 = state.preset_heat1,
      preset_cool1 = state.preset_cool1,
      preset_heat2 = state.preset_heat2,
      preset_cool2 = state.preset_cool2;
  /* eslint-enable camelcase */

  var occupancy = model.get("occupancy_setpoints");
  var isPortrait = size.width < size.height;
  var styles = Object(__WEBPACK_IMPORTED_MODULE_5_nx_components_utils_prefixStyles__["b" /* default */])({
    contents: {
      flex: "1 1 auto",
      display: "flex",
      justifyContent: "center",
      flexDirection: isPortrait ? "column" : "row",
      alignItems: "center",
      backgroundColor: "white",
      alignSelf: "center",
      width: "14em",
      maxWidth: "80vw",
      margin: "auto"
    },
    setpoints: {
      margin: "1em"
    }
  });
  /* eslint-disable camelcase */

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Page__["b" /* default */], {
    name: "OccupancySetpoints",
    fullyLoaded: true
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_TopBar_AppBarWrapper__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_nexia_mobile_components_TopBar_CommonAppBarContainer__["a" /* default */], {
    title: language.title,
    iconRight: null
  })), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_components_Scrollable_ScrollableArea__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    style: styles.contents
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    style: styles.setpoints
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_nx_components_Thermostat_ThermostatSetpoints__["a" /* default */], {
    occuLabel: language.occupiedLabel,
    setpointHeat: preset_heat1 || occupancy.preset_heat1,
    setpointHeatMin: model.get("setpoint_heat_min"),
    setpointHeatMax: model.get("setpoint_heat_max"),
    setpointCool: preset_cool1 || occupancy.preset_cool1,
    setpointCoolMin: model.get("setpoint_cool_min"),
    setpointCoolMax: model.get("setpoint_cool_max"),
    onChangesStarted: handleChangesStarted,
    onChangesEnded: handleOccupiedChangesEnded,
    onChangesCanceled: handleChangesCanceled,
    setpointIncrement: model.get("setpoint_increment"),
    setpointDelta: model.get("setpoint_delta"),
    changeBufferMs: 0,
    isCommercial: true
  })), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    style: styles.setpoints
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_nx_components_Thermostat_ThermostatSetpoints__["a" /* default */], {
    occuLabel: language.unoccupiedLabel,
    setpointHeat: preset_heat2 || occupancy.preset_heat2,
    setpointHeatMin: model.get("setpoint_heat_min"),
    setpointHeatMax: model.get("setpoint_heat_max"),
    setpointCool: preset_cool2 || occupancy.preset_cool2,
    setpointCoolMin: model.get("setpoint_cool_min"),
    setpointCoolMax: model.get("setpoint_cool_max"),
    onChangesStarted: handleChangesStarted,
    onChangesEnded: handleUnoccupiedChangesEnded,
    onChangesCanceled: handleChangesCanceled,
    setpointIncrement: model.get("setpoint_increment"),
    setpointDelta: model.get("setpoint_delta"),
    changeBufferMs: 0,
    isCommercial: true
  }))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    style: styles.contents
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_nx_components_ButtonGroup__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_nx_components_Button__["a" /* default */], {
    onTap: function onTap() {
      return __WEBPACK_IMPORTED_MODULE_17_nexia_mobile_history__["d" /* history */].goBack();
    },
    theme: "ghost"
  }, language.cancel), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_nx_components_Button__["a" /* default */] //                disabled={_isEditing}
  , {
    onTap: handleApplyChanges
  }, language.apply)))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_nexia_mobile_components_Commercial_PivotDemoBanner__["a" /* default */], null));
  /* eslint-enable camelcase */
};

OccupancySetpointsPage.propTypes = {
  model: function model() {
    return (typeof (__WEBPACK_IMPORTED_MODULE_3_backbone___default.a.Model == null ? {} : __WEBPACK_IMPORTED_MODULE_3_backbone___default.a.Model) === "function" ? __WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_backbone___default.a.Model == null ? {} : __WEBPACK_IMPORTED_MODULE_3_backbone___default.a.Model).isRequired : __WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  size: __WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.shape({
    width: __WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.number.isRequired,
    height: __WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.number.isRequired
  }).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_react_sizeme___default()({
  monitorHeight: true,
  monitorWidth: true,
  refreshRate: __WEBPACK_IMPORTED_MODULE_6_nx_components_Theme__["a" /* default */].RESPONSIVE_REFRESH_RATE
})(OccupancySetpointsPage));


/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_DarkModeInverter__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_styl_images_nexia_logo_svg__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_styl_images_nexia_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_styl_images_nexia_logo_svg__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var styles = {
  backgroundStyle: {
    display: "inline-block",
    backgroundSize: "100%",
    backgroundRepeat: "no-repeat"
  }
};

var LockScreenBrandLogo = function LockScreenBrandLogo(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_DarkModeInverter__["a" /* default */], null, function (_ref2) {
    var maybeInvert = _ref2.maybeInvert;
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
      "data-component-name": "LockScreenBrandLogo",
      style: _objectSpread({}, styles.backgroundStyle, {
        backgroundImage: "url(".concat(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_styl_images_nexia_logo_svg___default.a, ")"),
        width: width,
        height: height
      }, maybeInvert)
    });
  });
};

LockScreenBrandLogo.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
LockScreenBrandLogo.defaultProps = {
  width: "8em",
  height: "3.5em"
};
/* harmony default export */ __webpack_exports__["a"] = (LockScreenBrandLogo);

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_DarkModeInverter__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_styl_images_trane_commercial_logo_svg__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_styl_images_trane_commercial_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_styl_images_trane_commercial_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_styl_images_amstd_commercial_logo_svg__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_styl_images_amstd_commercial_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_styl_images_amstd_commercial_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nx_components_utils_prefixStyles__ = __webpack_require__(9);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var isTrane = __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_environment__["a" /* default */].isTraneCommercial();
var styles = Object(__WEBPACK_IMPORTED_MODULE_6_nx_components_utils_prefixStyles__["b" /* default */])({
  maskStyle: {
    backgroundColor: "#60ae33",
    WebkitMaskSize: "cover",
    maskSize: "cover"
  },
  commercialDiv: {
    flex: "1 1 auto",
    display: "flex",
    alignItems: "center",
    width: "100%",
    flexDirection: "column",
    justifyContent: "center"
  }
});

var PivotLockScreenBrandLogo = function PivotLockScreenBrandLogo() {
  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_DarkModeInverter__["a" /* default */], null, function (_ref) {
    var maybeInvert = _ref.maybeInvert;
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", {
      "data-component-name": "PivotLockScreenBrandLogo",
      style: _objectSpread({}, maybeInvert, {}, styles.commercialDiv)
    }, __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
      style: _objectSpread({}, styles.maskStyle, {
        maskImage: "url(".concat(isTrane ? __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_styl_images_trane_commercial_logo_svg___default.a : __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_styl_images_amstd_commercial_logo_svg___default.a, ")"),
        WebkitMaskImage: "url(".concat(isTrane ? __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_styl_images_trane_commercial_logo_svg___default.a : __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_styl_images_amstd_commercial_logo_svg___default.a, ")"),
        width: isTrane ? "13em" : "14em",
        height: isTrane ? "4.5em" : "3.5em"
      })
    }));
  });
};

/* harmony default export */ __webpack_exports__["a"] = (PivotLockScreenBrandLogo);

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_PinEntry_PivotPinEntryWrapper__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Page__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_styl_images_trane_commercial_background_png__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_styl_images_trane_commercial_background_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_styl_images_trane_commercial_background_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_ContextWrappers_LanguageContext__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);










var styles = {
  backgroundImageStyles: {
    backgroundImage: "url(".concat(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_styl_images_trane_commercial_background_png___default.a, ")"),
    backgroundSize: "cover",
    backgroundPosition: "center"
  }
};

var ValidatePinEntryPage = function ValidatePinEntryPage(props) {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9_nx_components_ContextWrappers_LanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.pages.ValidatePinEntryPage;
  var pinEntryWrapper = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();

  if (!props.isAuthAttemptLockedOut && __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_local_settings__["c" /* default */].getCurrentAuth() === __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_local_settings__["b" /* AUTH_TYPES */].FINGERPRINT && __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_flux_like_store__["a" /* default */].userCancelledFingerprint === false) {
    Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("VALIDATE_FINGERPRINT");
  }

  var onDone = function onDone(value) {
    pinEntryWrapper.current.reset();
    Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("VALIDATE_PIN", value);
  };

  var onForgotPin = function onForgotPin() {
    var prompt = "".concat(languageContext.template(language.reauthPromptMessageTemplate, {
      brand: "Pivot"
    }), ":");
    __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_history__["d" /* history */].push("/reauth", {
      prompt: prompt,
      submitButtonText: language.reauthSubmitButton,
      title: language.reauthTitle,
      onUserAuthenticated: function onUserAuthenticated() {
        Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", language.reauthNewPinToast);
        Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_flux_like_dispatch__["a" /* default */])("PIN_RESET");
      }
    });
  };

  var isAuthAttemptLockedOut = props.isAuthAttemptLockedOut;
  var prompt = isAuthAttemptLockedOut ? languageContext.template(language.pinDisabledTemplate, {
    minutes: __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_local_settings__["a" /* AUTH_LOCKOUT_MINUTES */]
  }) : language.enterPin;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Page__["b" /* default */], {
    name: "ValidatePinEntryPage",
    backgroundImageStyles: styles.backgroundImageStyles,
    fullyLoaded: true
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_PinEntry_PivotPinEntryWrapper__["a" /* default */], {
    ref: function ref(inst) {
      return pinEntryWrapper.current = inst;
    },
    prompt: prompt,
    password: true,
    length: __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_local_settings__["c" /* default */].pinLength(),
    showForgotPin: true,
    disabled: isAuthAttemptLockedOut,
    onDone: onDone,
    onForgotPin: onForgotPin,
    showEULA: true
  }));
};

ValidatePinEntryPage.propTypes = {
  isAuthAttemptLockedOut: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  isAuthAttemptLockedOut: "isAuthAttemptLockedOut"
}, ValidatePinEntryPage));


/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_polished__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nx_components_Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_utils_touchHandlersFromClickHandlers__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
















var DISABLED_LIGHTEN_AMOUNT = 0.3;

var KeyWithoutColors =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(KeyWithoutColors, _React$Component);

  function KeyWithoutColors() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, KeyWithoutColors);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(KeyWithoutColors)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      isActive: false
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleClick", function () {
      var onClick = _this.props.onClick;

      if (onClick != null) {
        onClick();
      }
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleDown", function () {
      _this.setState({
        isActive: true
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleUp", function () {
      _this.setState({
        isActive: false
      });
    });

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handlers", Object(__WEBPACK_IMPORTED_MODULE_15_nexia_mobile_components_utils_touchHandlersFromClickHandlers__["a" /* default */])(_this._handleClick, _this._handleDown, _this._handleUp));

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(KeyWithoutColors, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disabled = _this$props.disabled,
          colors = _this$props.colors;
      var isActive = this.state.isActive && !disabled;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_13_nx_components_utils_prefixStyles__["b" /* default */])({
        button: {
          borderRadius: "50%",
          height: "2.3em",
          maxWidth: "2.3em",
          flex: "1 1 100%",
          fontSize: "1.5em",
          padding: "0.5em",
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_12_nx_components_Tappable__["c" /* simpleActiveBackgroundColor */])(isActive),
          color: disabled ? Object(__WEBPACK_IMPORTED_MODULE_9_polished__["b" /* lighten */])(DISABLED_LIGHTEN_AMOUNT, colors.TEXT) : colors.TEXT
        }
      });
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nx_components_NoStyleButton__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, this._handlers, {
        style: styles.button
      }), children);
    }
  }]);

  return KeyWithoutColors;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(KeyWithoutColors, "propTypes", {
  onClick: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.node,
  disabled: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool,
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
});

var Key = Object(__WEBPACK_IMPORTED_MODULE_10_nx_components_ColorsProvider__["c" /* withColorsProvider */])(KeyWithoutColors);

var PivotKeyboard =
/*#__PURE__*/
function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(PivotKeyboard, _React$Component2);

  function PivotKeyboard() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, PivotKeyboard);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(PivotKeyboard).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(PivotKeyboard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isTablet = _this$props2.isTablet,
          disabled = _this$props2.disabled,
          onKeypad = _this$props2.onKeypad;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_13_nx_components_utils_prefixStyles__["b" /* default */])({
        keypadRow: {
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "space-around",
          lineHeight: "1.5em",
          maxHeight: "3.5em",
          padding: "0.5em",
          fontSize: isTablet ? "1.25em" : "",
          border: "1px  solid #929ba2"
        },
        keypadBorder: {
          border: "1px  solid #929ba2",
          backgroundColor: "rgba(255, 255, 255, 0.5)"
        },
        keypadDivider: {
          height: "2.3em",
          flex: "1 1 100%",
          fontSize: "1.5em",
          maxWidth: "2px",
          borderLeft: "2px  solid #929ba2"
        },
        keypad: {
          flex: "1 1 auto",
          padding: "1em",
          width: "100%",
          maxWidth: "25em",
          display: "flex",
          alignItems: "stretch",
          justifyContent: "space-around",
          flexDirection: "column"
        },
        deletePinpadIcon: {
          fontSize: "1.2em"
        }
      });
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypad
      }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypadBorder
      }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypadRow
      }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](Key, {
        disabled: disabled,
        onClick: function onClick() {
          return onKeypad("1");
        }
      }, "1"), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypadDivider
      }), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](Key, {
        disabled: disabled,
        onClick: function onClick() {
          return onKeypad("2");
        }
      }, "2"), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypadDivider
      }), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](Key, {
        disabled: disabled,
        onClick: function onClick() {
          return onKeypad("3");
        }
      }, "3")), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypadRow
      }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](Key, {
        disabled: disabled,
        onClick: function onClick() {
          return onKeypad("4");
        }
      }, "4"), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypadDivider
      }), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](Key, {
        disabled: disabled,
        onClick: function onClick() {
          return onKeypad("5");
        }
      }, "5"), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypadDivider
      }), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](Key, {
        disabled: disabled,
        onClick: function onClick() {
          return onKeypad("6");
        }
      }, "6")), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypadRow
      }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](Key, {
        disabled: disabled,
        onClick: function onClick() {
          return onKeypad("7");
        }
      }, "7"), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypadDivider
      }), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](Key, {
        disabled: disabled,
        onClick: function onClick() {
          return onKeypad("8");
        }
      }, "8"), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypadDivider
      }), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](Key, {
        disabled: disabled,
        onClick: function onClick() {
          return onKeypad("9");
        }
      }, "9")), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypadRow
      }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](Key, {
        disabled: true
      }), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypadDivider
      }), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](Key, {
        disabled: disabled,
        onClick: function onClick() {
          return onKeypad("0");
        }
      }, "0"), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]("div", {
        style: styles.keypadDivider
      }), __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](Key, {
        disabled: disabled,
        onClick: function onClick() {
          return onKeypad("backspace");
        }
      }, __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_nx_components_Icons__["F" /* IconDeletePinpad */], {
        style: styles.deletePinpadIcon
      })))));
    }
  }]);

  return PivotKeyboard;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(PivotKeyboard, "propTypes", {
  onKeypad: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func.isRequired,
  isTablet: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool
});

/* harmony default export */ __webpack_exports__["a"] = (PivotKeyboard);


/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toast; });
/* unused harmony export bpfrpt_proptype_toast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_pose__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Toaster_ToastMsg__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);











var style = Object(__WEBPACK_IMPORTED_MODULE_9_nx_components_utils_prefixStyles__["b" /* default */])({
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
});
var DRAG_LIMIT = 80;
var PosedToastMsg = Object(__WEBPACK_IMPORTED_MODULE_8_react_pose__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_Toaster_ToastMsg__["a" /* default */])({
  // The ToastMsg div styl must match this because it will be treated as an "initial" state
  preEnter: {
    opacity: 0,
    height: 0,
    x: "-100vw"
  },
  enter: {
    opacity: 1,
    height: "auto",
    // 🎉
    x: 0
  },
  exit: {
    opacity: 0,
    height: 0 // no "x" so that the dragEnd transition for "x" isn't overridden

  },

  /* Modified heavily from https://codepen.io/stolinski/pen/WJEQzw */
  draggable: "x",
  dragEnd: {
    transition: {
      x: function x(props) {
        if (Math.abs(props.from) > DRAG_LIMIT) {
          // Toast is being dismissed, just continue at the current velocity
          return {
            type: "physics"
          };
        } else {
          return {
            type: "spring"
          };
        }
      }
    }
  }
  /* End of borrowed code */

});
var bpfrpt_proptype_toast = {
  id: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number.isRequired,
  message: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string.isRequired,
  persistent: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool.isRequired
};

var Toast =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Toast, _React$Component);

  function Toast() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Toast);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Toast)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_toastPositions", new Map());

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_mapToasts", function (mapper) {
      var toasts = _this.props.toasts;
      return Object.values(toasts).map(mapper);
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Toast, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var onDismissToast = this.props.onDismissToast;

      var toastMessages = this._mapToasts(function (_ref) {
        var id = _ref.id,
            message = _ref.message,
            persistent = _ref.persistent;
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](PosedToastMsg, {
          key: id,
          id: id,
          persistent: persistent,
          text: message,
          onDismiss: function onDismiss() {
            return onDismissToast(id);
          },
          onValueChange: {
            x: function x(_x) {
              return _this2._toastPositions.set(id, _x);
            }
          },
          onDragEnd: function onDragEnd() {
            var currentX = _this2._toastPositions.get(id);

            if (currentX && Math.abs(currentX) > DRAG_LIMIT) {
              _this2._toastPositions["delete"](id);

              onDismissToast(id);
            }
          }
        });
      });

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "Toast",
        style: style
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_react_pose__["a" /* PoseGroup */], {
        preEnterPose: "preEnter"
      }, toastMessages));
    }
  }]);

  return Toast;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(Toast, "propTypes", {
  toasts: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape({
    id: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number.isRequired,
    message: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string.isRequired,
    persistent: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool.isRequired
  }).isRequired).isRequired,
  onDismissToast: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired
});





/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Transition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PoseGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_popmotion_pose__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_is_prop_valid__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hey_listen__ = __webpack_require__(124);







var hasChanged = function (prev, next) {
    if (prev === next)
        return false;
    var prevIsArray = Array.isArray(prev);
    var nextIsArray = Array.isArray(next);
    if (prevIsArray !== nextIsArray || (!prevIsArray && !nextIsArray)) {
        return true;
    }
    else if (prevIsArray && nextIsArray) {
        var numPrev = prev.length;
        var numNext = next.length;
        if (numPrev !== numNext)
            return true;
        for (var i = 0; i < numPrev; i++) {
            if (prev[i] !== next[i])
                return true;
        }
    }
    return false;
};

var pickAssign = function (shouldPick, sources) {
    return sources.reduce(function (picked, source) {
        for (var key in source) {
            if (shouldPick(key)) {
                picked[key] = source[key];
            }
        }
        return picked;
    }, {});
};

var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])({}), PoseParentConsumer = _a.Consumer, PoseParentProvider = _a.Provider;
var calcPopFromFlowStyle = function (el) {
    var offsetTop = el.offsetTop, offsetLeft = el.offsetLeft, offsetWidth = el.offsetWidth, offsetHeight = el.offsetHeight;
    return {
        position: 'absolute',
        top: offsetTop,
        left: offsetLeft,
        width: offsetWidth,
        height: offsetHeight
    };
};
var hasPose = function (pose, key) {
    return Array.isArray(pose) ? pose.indexOf(key) !== -1 : pose === key;
};
var objectToMap = function (obj) {
    return Object.keys(obj).reduce(function (map, key) {
        map.set(key, { raw: obj[key] });
        return map;
    }, new Map());
};
var testAlwaysTrue = function () { return true; };
var filterProps = function (_a) {
    var elementType = _a.elementType, poseConfig = _a.poseConfig, onValueChange = _a.onValueChange, innerRef = _a.innerRef, _pose = _a._pose, pose = _a.pose, initialPose = _a.initialPose, poseKey = _a.poseKey, onPoseComplete = _a.onPoseComplete, getParentPoseConfig = _a.getParentPoseConfig, registerChild = _a.registerChild, onUnmount = _a.onUnmount, getInitialPoseFromParent = _a.getInitialPoseFromParent, popFromFlow = _a.popFromFlow, values = _a.values, parentValues = _a.parentValues, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, onPressStart = _a.onPressStart, onPressEnd = _a.onPressEnd, props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["elementType", "poseConfig", "onValueChange", "innerRef", "_pose", "pose", "initialPose", "poseKey", "onPoseComplete", "getParentPoseConfig", "registerChild", "onUnmount", "getInitialPoseFromParent", "popFromFlow", "values", "parentValues", "onDragStart", "onDragEnd", "onPressStart", "onPressEnd"]);
    return props;
};
var PoseElement = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PoseElement, _super);
    function PoseElement(props) {
        var _this = _super.call(this, props) || this;
        _this.children = new Set();
        _this.childrenHandlers = {
            registerChild: function (props) {
                _this.children.add(props);
                if (_this.poser)
                    _this.flushChildren();
            },
            onUnmount: function (child) { return _this.poser.removeChild(child); },
            getParentPoseConfig: function () { return _this.poseConfig; },
            getInitialPoseFromParent: function () { return _this.getInitialPose(); }
        };
        _this.getRefs = function () {
            var refs = {};
            var elementType = _this.props.elementType;
            if (typeof elementType === 'string' ||
                Object(__WEBPACK_IMPORTED_MODULE_2_react_is__["isForwardRef"])(elementType)) {
                refs.ref = _this.setRef;
            }
            else {
                refs.innerRef = _this.setRef;
                refs.hostRef = _this.setRef;
            }
            return refs;
        };
        _this.setRef = function (ref) {
            if (ref instanceof Element || (_this.ref && ref === null)) {
                var innerRef = _this.props.innerRef;
                if (innerRef) {
                    if (typeof innerRef === 'function') {
                        innerRef(ref);
                    }
                    else {
                        innerRef.current = ref;
                    }
                }
                _this.ref = ref;
            }
        };
        _this.shouldForwardProp =
            typeof _this.props.elementType === 'string' ? __WEBPACK_IMPORTED_MODULE_4__emotion_is_prop_valid__["a" /* default */] : testAlwaysTrue;
        var poseConfig = _this.props.poseConfig;
        _this.poseConfig = typeof poseConfig === 'function'
            ? poseConfig(filterProps(props))
            : poseConfig;
        return _this;
    }
    PoseElement.prototype.getInitialPose = function () {
        var _a = this.props, getInitialPoseFromParent = _a.getInitialPoseFromParent, pose = _a.pose, _pose = _a._pose, initialPose = _a.initialPose;
        if (initialPose) {
            return initialPose;
        }
        else {
            var parentPose = getInitialPoseFromParent && getInitialPoseFromParent();
            var initialPoses = (Array.isArray(parentPose) ? parentPose : [parentPose])
                .concat(pose, _pose)
                .filter(Boolean);
            return initialPoses.length > 0 ? initialPoses : undefined;
        }
    };
    PoseElement.prototype.getFirstPose = function () {
        var _a = this.props, initialPose = _a.initialPose, pose = _a.pose, _pose = _a._pose;
        if (!initialPose)
            return;
        var firstPose = (Array.isArray(pose) ? pose : [pose])
            .concat(_pose)
            .filter(Boolean);
        return firstPose.length === 1 ? firstPose[0] : firstPose;
    };
    PoseElement.prototype.getSetProps = function () {
        var props = filterProps(this.props);
        if (this.props.popFromFlow && this.ref && this.ref instanceof HTMLElement) {
            if (!this.popStyle) {
                props.style = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.style, calcPopFromFlowStyle(this.ref));
                this.popStyle = props.style;
            }
            else {
                props.style = this.popStyle;
            }
        }
        else {
            this.popStyle = null;
        }
        return props;
    };
    PoseElement.prototype.componentDidMount = function () {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_5_hey_listen__["a" /* invariant */])(typeof this.ref !== 'undefined', "No DOM ref found. If you're converting an existing component via posed(Component), you must ensure you're passing the hostRef prop to your underlying DOM element.");
        var _a = this.props, onValueChange = _a.onValueChange, registerChild = _a.registerChild, values = _a.values, parentValues = _a.parentValues, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, onPressStart = _a.onPressStart, onPressEnd = _a.onPressEnd;
        var config = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.poseConfig, { initialPose: this.getInitialPose(), values: values || this.poseConfig.values, parentValues: parentValues ? objectToMap(parentValues) : undefined, props: this.getSetProps(), onDragStart: onDragStart,
            onDragEnd: onDragEnd,
            onPressStart: onPressStart,
            onPressEnd: onPressEnd, onChange: onValueChange });
        if (!registerChild) {
            this.initPoser(Object(__WEBPACK_IMPORTED_MODULE_3_popmotion_pose__["a" /* default */])(this.ref, config));
        }
        else {
            registerChild({
                element: this.ref,
                poseConfig: config,
                onRegistered: function (poser) { return _this.initPoser(poser); }
            });
        }
    };
    PoseElement.prototype.getSnapshotBeforeUpdate = function (_a) {
        var pose = _a.pose, _pose = _a._pose;
        if (hasPose(pose, 'flip') || hasPose(_pose, 'flip'))
            this.poser.measure();
        return null;
    };
    PoseElement.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, pose = _a.pose, _pose = _a._pose, poseKey = _a.poseKey;
        this.poser.setProps(this.getSetProps());
        if (poseKey !== prevProps.poseKey ||
            hasChanged(prevProps.pose, pose) ||
            pose === 'flip') {
            this.setPose(pose);
        }
        if (_pose !== prevProps._pose || _pose === 'flip')
            this.setPose(_pose);
    };
    PoseElement.prototype.componentWillUnmount = function () {
        if (!this.poser)
            return;
        var onUnmount = this.props.onUnmount;
        if (onUnmount)
            onUnmount(this.poser);
        this.poser.destroy();
    };
    PoseElement.prototype.initPoser = function (poser) {
        this.poser = poser;
        this.flushChildren();
        var firstPose = this.getFirstPose();
        if (firstPose)
            this.setPose(firstPose);
    };
    PoseElement.prototype.setPose = function (pose) {
        var _this = this;
        var onPoseComplete = this.props.onPoseComplete;
        var poseList = Array.isArray(pose) ? pose : [pose];
        Promise.all(poseList.map(function (key) { return key && _this.poser.set(key); })).then(function () { return onPoseComplete && onPoseComplete(pose); });
    };
    PoseElement.prototype.flushChildren = function () {
        var _this = this;
        this.children.forEach(function (_a) {
            var element = _a.element, poseConfig = _a.poseConfig, onRegistered = _a.onRegistered;
            return onRegistered(_this.poser.addChild(element, poseConfig));
        });
        this.children.clear();
    };
    PoseElement.prototype.render = function () {
        var elementType = this.props.elementType;
        return (Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(PoseParentProvider, { value: this.childrenHandlers }, Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(elementType, pickAssign(this.shouldForwardProp, [
            this.getSetProps(),
            this.getRefs()
        ]))));
    };
    return PoseElement;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

var supportedElements = [
    'a',
    'article',
    'aside',
    'audio',
    'b',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dialog',
    'div',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'i',
    'iframe',
    'img',
    'input',
    'label',
    'legend',
    'li',
    'nav',
    'object',
    'ol',
    'option',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'section',
    'select',
    'span',
    'strong',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'ul',
    'video',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];

var componentCache = new Map();
var createComponentFactory = function (key) {
    var componentFactory = function (poseConfig) {
        if (poseConfig === void 0) { poseConfig = {}; }
        return function (_a) {
            var _b = _a.withParent, withParent = _b === void 0 ? true : _b, props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["withParent"]);
            return !withParent || props.parentValues ? (Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(PoseElement, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ poseConfig: poseConfig, elementType: key }, props))) : (Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(PoseParentConsumer, null, function (parentCtx) { return (Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(PoseElement, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ poseConfig: poseConfig, elementType: key }, props, parentCtx))); }));
        };
    };
    componentCache.set(key, componentFactory);
    return componentFactory;
};
var getComponentFactory = function (key) {
    return componentCache.has(key)
        ? componentCache.get(key)
        : createComponentFactory(key);
};
var posed = (function (component) {
    return getComponentFactory(component);
});
supportedElements.reduce(function (acc, key) {
    acc[key] = createComponentFactory(key);
    return acc;
}, posed);

var getKey = function (child) {
    Object(__WEBPACK_IMPORTED_MODULE_5_hey_listen__["a" /* invariant */])(child && child.key !== null, 'Every child of Transition must be given a unique key');
    var childKey = typeof child.key === 'number' ? child.key.toString() : child.key;
    return childKey.replace('.$', '');
};
var prependProps = function (element, props) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(element.type, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ key: element.key, ref: element.ref }, props, element.props));
};
var handleTransition = function (_a, _b) {
    var displayedChildren = _b.displayedChildren, finishedLeaving = _b.finishedLeaving, hasInitialized = _b.hasInitialized, indexedChildren = _b.indexedChildren, scheduleChildRemoval = _b.scheduleChildRemoval;
    var incomingChildren = _a.children, preEnterPose = _a.preEnterPose, enterPose = _a.enterPose, exitPose = _a.exitPose, animateOnMount = _a.animateOnMount, enterAfterExit = _a.enterAfterExit, flipMove = _a.flipMove, onRest = _a.onRest, propsForChildren = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["children", "preEnterPose", "enterPose", "exitPose", "animateOnMount", "enterAfterExit", "flipMove", "onRest"]);
    var targetChildren = makeChildList(incomingChildren);
    var nextState = {
        displayedChildren: []
    };
    if (false) {
        warning(!propsForChildren.onPoseComplete, "<Transition/> (or <PoseGroup/>) doesn't accept onPoseComplete prop.");
    }
    var prevKeys = displayedChildren.map(getKey);
    var nextKeys = targetChildren.map(getKey);
    var hasPropsForChildren = Object.keys(propsForChildren).length !== 0;
    var entering = new Set(nextKeys.filter(function (key) { return finishedLeaving.hasOwnProperty(key) || prevKeys.indexOf(key) === -1; }));
    entering.forEach(function (key) { return delete finishedLeaving[key]; });
    var leaving = [];
    var newlyLeaving = {};
    prevKeys.forEach(function (key) {
        if (entering.has(key)) {
            return;
        }
        var isLeaving = finishedLeaving.hasOwnProperty(key);
        if (!isLeaving && nextKeys.indexOf(key) !== -1) {
            return;
        }
        leaving.push(key);
        if (!isLeaving) {
            finishedLeaving[key] = false;
            newlyLeaving[key] = true;
        }
    });
    var moving = new Set(prevKeys.filter(function (key, i) {
        if (entering.has(key)) {
            return false;
        }
        var nextIndex = nextKeys.indexOf(key);
        return nextIndex !== -1 && i !== nextIndex;
    }));
    targetChildren.forEach(function (child) {
        var newChildProps = {};
        if (entering.has(child.key)) {
            if (hasInitialized || animateOnMount) {
                newChildProps.initialPose = preEnterPose;
            }
            newChildProps._pose = enterPose;
        }
        else if (moving.has(child.key) && flipMove) {
            newChildProps._pose = [enterPose, 'flip'];
        }
        else {
            newChildProps._pose = enterPose;
        }
        var newChild = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, newChildProps);
        indexedChildren[child.key] = newChild;
        nextState.displayedChildren.push(hasPropsForChildren ? prependProps(newChild, propsForChildren) : newChild);
    });
    leaving.forEach(function (key) {
        var child = indexedChildren[key];
        var newChild = newlyLeaving[key]
            ? Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, {
                _pose: exitPose,
                onPoseComplete: function (pose) {
                    scheduleChildRemoval(key);
                    var onPoseComplete = child.props.onPoseComplete;
                    onPoseComplete && onPoseComplete(pose);
                },
                popFromFlow: flipMove
            })
            : child;
        var insertionIndex = prevKeys.indexOf(key);
        indexedChildren[child.key] = newChild;
        nextState.displayedChildren.splice(insertionIndex, 0, hasPropsForChildren ? prependProps(newChild, propsForChildren) : newChild);
    });
    return nextState;
};
var handleChildrenTransitions = (function (props, state) {
    var newState = handleTransition(props, state);
    newState.hasInitialized = true;
    return newState;
});
var makeChildList = function (children) {
    var list = [];
    __WEBPACK_IMPORTED_MODULE_1_react__["Children"].forEach(children, function (child) { return child && list.push(child); });
    return list;
};

var Transition = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Transition, _super);
    function Transition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            displayedChildren: [],
            finishedLeaving: {},
            hasInitialized: false,
            indexedChildren: {},
            scheduleChildRemoval: function (key) { return _this.removeChild(key); }
        };
        return _this;
    }
    Transition.prototype.removeChild = function (key) {
        var _a = this.state, displayedChildren = _a.displayedChildren, finishedLeaving = _a.finishedLeaving;
        var _b = this.props, enterAfterExit = _b.enterAfterExit, onRest = _b.onRest;
        if (!finishedLeaving.hasOwnProperty(key))
            return;
        finishedLeaving[key] = true;
        if (!Object.keys(finishedLeaving).every(function (leavingKey) { return finishedLeaving[leavingKey]; })) {
            return;
        }
        var targetChildren = displayedChildren.filter(function (child) { return !finishedLeaving.hasOwnProperty(child.key); });
        var newState = enterAfterExit
            ? Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ finishedLeaving: {} }, handleChildrenTransitions(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.props, { enterAfterExit: false }), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.state, { displayedChildren: targetChildren }))) : {
            finishedLeaving: {},
            displayedChildren: targetChildren
        };
        this.setState(newState, onRest);
    };
    Transition.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return this.state !== nextState;
    };
    Transition.prototype.render = function () {
        return this.state.displayedChildren;
    };
    Transition.defaultProps = {
        flipMove: false,
        enterAfterExit: false,
        preEnterPose: 'exit',
        enterPose: 'enter',
        exitPose: 'exit'
    };
    Transition.getDerivedStateFromProps = handleChildrenTransitions;
    return Transition;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var PoseGroup = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PoseGroup, _super);
    function PoseGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PoseGroup.prototype.render = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Transition, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.props));
    };
    PoseGroup.defaultProps = {
        flipMove: true
    };
    return PoseGroup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

/* harmony default export */ __webpack_exports__["b"] = (posed);



/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popmotion__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_style_value_types__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pose_core__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hey_listen__ = __webpack_require__(124);






/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}

var BoundingBoxDimension;
(function (BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));

var measureWithoutTransform = function (element) {
    var transform$$1 = element.style.transform;
    element.style.transform = '';
    var bbox = element.getBoundingClientRect();
    element.style.transform = transform$$1;
    return bbox;
};
var resolveProp = function (target, props) {
    return typeof target === 'function' ? target(props) : target;
};

var interpolate = __WEBPACK_IMPORTED_MODULE_0_popmotion__["k" /* transform */].interpolate;
var singleAxisPointer = function (axis) {
    return function (from) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["h" /* pointer */])((_a = {}, _a[axis] = typeof from === 'string' ? parseFloat(from) : from, _a)).pipe(function (v) {
            return v[axis];
        });
    };
};
var pointerX = /*#__PURE__*/singleAxisPointer('x');
var pointerY = /*#__PURE__*/singleAxisPointer('y');
var createPointer = function (axisPointerCreator, min, max, measurement) {
    return function (transitionProps) {
        var from = transitionProps.from,
            type = transitionProps.type,
            dimensions = transitionProps.dimensions,
            dragBounds = transitionProps.dragBounds;
        var axisPointer = axisPointerCreator(dimensions.measurementAsPixels(measurement, from, type));
        var transformQueue = [];
        if (dragBounds) {
            var resolvedDragBounds_1 = resolveProp(dragBounds, transitionProps);
            if (resolvedDragBounds_1[min] !== undefined) {
                transformQueue.push(function (v) {
                    return Math.max(v, dimensions.measurementAsPixels(measurement, resolvedDragBounds_1[min], type));
                });
            }
            if (resolvedDragBounds_1[max] !== undefined) {
                transformQueue.push(function (v) {
                    return Math.min(v, dimensions.measurementAsPixels(measurement, resolvedDragBounds_1[max], type));
                });
            }
        }
        if (type === __WEBPACK_IMPORTED_MODULE_2_style_value_types__["h" /* percent */]) {
            transformQueue.push(interpolate([0, dimensions.get(measurement)], [0, 100], { clamp: false }), function (v) {
                return v + '%';
            });
        }
        return transformQueue.length ? axisPointer.pipe.apply(axisPointer, transformQueue) : axisPointer;
    };
};
var just = function (from) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["a" /* action */])(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        update(from);
        complete();
    });
};
var underDampedSpring = function (_a) {
    var from = _a.from,
        velocity = _a.velocity,
        to = _a.to;
    return Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["i" /* spring */])({
        from: from,
        to: to,
        velocity: velocity,
        stiffness: 500,
        damping: 25,
        restDelta: 0.5,
        restSpeed: 10
    });
};
var overDampedSpring = function (_a) {
    var from = _a.from,
        velocity = _a.velocity,
        to = _a.to;
    return Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["i" /* spring */])({ from: from, to: to, velocity: velocity, stiffness: 700, damping: to === 0 ? 100 : 35 });
};
var linearTween = function (_a) {
    var from = _a.from,
        to = _a.to;
    return Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["l" /* tween */])({ from: from, to: to, ease: __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["m" /* linear */] });
};
var intelligentTransition = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: overDampedSpring,
    scaleY: overDampedSpring,
    scale: overDampedSpring,
    opacity: linearTween,
    default: __WEBPACK_IMPORTED_MODULE_0_popmotion__["l" /* tween */]
};
var dragAction = /*#__PURE__*/__assign( /*#__PURE__*/__assign({}, intelligentTransition), { x: /*#__PURE__*/createPointer(pointerX, 'left', 'right', BoundingBoxDimension.width), y: /*#__PURE__*/createPointer(pointerY, 'top', 'bottom', BoundingBoxDimension.height) });
var justAxis = function (_a) {
    var from = _a.from;
    return just(from);
};
var intelligentDragEnd = /*#__PURE__*/__assign( /*#__PURE__*/__assign({}, intelligentTransition), { x: justAxis, y: justAxis });
var defaultTransitions = /*#__PURE__*/new Map([['default', intelligentTransition], ['drag', dragAction], ['dragEnd', intelligentDragEnd]]);

var animationLookup = {
    tween: __WEBPACK_IMPORTED_MODULE_0_popmotion__["l" /* tween */],
    spring: __WEBPACK_IMPORTED_MODULE_0_popmotion__["i" /* spring */],
    decay: __WEBPACK_IMPORTED_MODULE_0_popmotion__["c" /* decay */],
    keyframes: __WEBPACK_IMPORTED_MODULE_0_popmotion__["e" /* keyframes */],
    physics: __WEBPACK_IMPORTED_MODULE_0_popmotion__["g" /* physics */]
};
var easingLookup = {
    linear: __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["m" /* linear */],
    easeIn: __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["j" /* easeIn */],
    easeOut: __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["l" /* easeOut */],
    easeInOut: __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["k" /* easeInOut */],
    circIn: __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["e" /* circIn */],
    circOut: __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["g" /* circOut */],
    circInOut: __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["f" /* circInOut */],
    backIn: __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["b" /* backIn */],
    backOut: __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["d" /* backOut */],
    backInOut: __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["c" /* backInOut */],
    anticipate: __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["a" /* anticipate */]
};

var auto = {
    test: function (v) {
        return v === 'auto';
    },
    parse: function (v) {
        return v;
    }
};
var valueTypeTests = [__WEBPACK_IMPORTED_MODULE_2_style_value_types__["g" /* number */], __WEBPACK_IMPORTED_MODULE_2_style_value_types__["d" /* degrees */], __WEBPACK_IMPORTED_MODULE_2_style_value_types__["h" /* percent */], __WEBPACK_IMPORTED_MODULE_2_style_value_types__["j" /* px */], __WEBPACK_IMPORTED_MODULE_2_style_value_types__["n" /* vw */], __WEBPACK_IMPORTED_MODULE_2_style_value_types__["m" /* vh */], auto];
var testValueType = function (v) {
    return function (type) {
        return type.test(v);
    };
};
var getValueType = function (v) {
    return valueTypeTests.find(testValueType(v));
};

var createPassiveValue = function (init, parent, transform$$1) {
    var raw = Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["m" /* value */])(transform$$1(init));
    parent.raw.subscribe(function (v) {
        return raw.update(transform$$1(v));
    });
    return { raw: raw };
};
var createValue = function (init) {
    var type = getValueType(init);
    var raw = Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["m" /* value */])(init);
    return { raw: raw, type: type };
};
var addActionDelay = function (delay$$1, transition) {
    if (delay$$1 === void 0) {
        delay$$1 = 0;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["b" /* chain */])(Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["d" /* delay */])(delay$$1), transition);
};
var isCubicBezierArgs = function (args) {
    return typeof args[0] === 'number';
};
var getAction = function (v, _a, _b) {
    var from = _b.from,
        to = _b.to,
        velocity = _b.velocity;
    var _c = _a.type,
        type = _c === void 0 ? 'tween' : _c,
        definedEase = _a.ease,
        def = __rest(_a, ["type", "ease"]);
    Object(__WEBPACK_IMPORTED_MODULE_4_hey_listen__["a" /* invariant */])(animationLookup[type] !== undefined, "Invalid transition type '" + type + "'. Valid transition types are: tween, spring, decay, physics and keyframes.");
    var ease;
    if (type === 'tween') {
        if (typeof definedEase !== 'function') {
            if (typeof definedEase === 'string') {
                Object(__WEBPACK_IMPORTED_MODULE_4_hey_listen__["a" /* invariant */])(easingLookup[definedEase] !== undefined, "Invalid easing type '" + definedEase + "'. popmotion.io/pose/api/config");
                ease = easingLookup[definedEase];
            } else if (Array.isArray(definedEase) && isCubicBezierArgs(definedEase)) {
                Object(__WEBPACK_IMPORTED_MODULE_4_hey_listen__["a" /* invariant */])(definedEase.length === 4, "Cubic bezier arrays must contain four numerical values.");
                var x1 = definedEase[0],
                    y1 = definedEase[1],
                    x2 = definedEase[2],
                    y2 = definedEase[3];
                ease = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["i" /* cubicBezier */])(x1, y1, x2, y2);
            }
        }
    }
    ease = ease || definedEase;
    var baseProps = type !== 'keyframes' ? {
        from: from,
        to: to,
        velocity: velocity,
        ease: ease
    } : { ease: ease };
    return animationLookup[type](__assign(__assign({}, baseProps), def));
};
var isAction = function (action$$1) {
    return typeof action$$1.start !== 'undefined';
};
var pose = function (_a) {
    var transformPose = _a.transformPose,
        addListenerToValue = _a.addListenerToValue,
        extendAPI = _a.extendAPI,
        readValueFromSource = _a.readValueFromSource,
        posePriority = _a.posePriority,
        setValueNative = _a.setValueNative;
    return Object(__WEBPACK_IMPORTED_MODULE_3_pose_core__["a" /* default */])({
        bindOnChange: function (values, onChange) {
            return function (key) {
                if (!values.has(key)) return;
                var raw = values.get(key).raw;
                raw.subscribe(onChange[key]);
            };
        },
        readValue: function (_a) {
            var raw = _a.raw;
            return raw.get();
        },
        setValue: function (_a, to) {
            var raw = _a.raw;
            return raw.update(to);
        },
        createValue: function (init, key, _a, _b) {
            var elementStyler = _a.elementStyler;
            var _c = _b === void 0 ? {} : _b,
                passiveParent = _c.passiveParent,
                passiveProps = _c.passiveProps;
            var val = passiveParent ? createPassiveValue(init, passiveParent, passiveProps) : createValue(init);
            val.raw.subscribe(addListenerToValue(key, elementStyler));
            return val;
        },
        convertValue: function (raw, key, _a) {
            var elementStyler = _a.elementStyler;
            raw.subscribe(addListenerToValue(key, elementStyler));
            return {
                raw: raw,
                type: getValueType(raw.get())
            };
        },
        getTransitionProps: function (_a, to) {
            var raw = _a.raw,
                type = _a.type;
            return {
                from: raw.get(),
                velocity: raw.getVelocity(),
                to: to,
                type: type
            };
        },
        resolveTarget: function (_, to) {
            return to;
        },
        selectValueToRead: function (_a) {
            var raw = _a.raw;
            return raw;
        },
        startAction: function (_a, action$$1, complete) {
            var raw = _a.raw;
            var reaction = {
                update: function (v) {
                    return raw.update(v);
                },
                complete: complete
            };
            return action$$1.start(reaction);
        },
        stopAction: function (action$$1) {
            return action$$1.stop();
        },
        getInstantTransition: function (_, _a) {
            var to = _a.to;
            return just(to);
        },
        convertTransitionDefinition: function (val, def, props) {
            if (isAction(def)) return def;
            var delay$$1 = def.delay,
                min = def.min,
                max = def.max,
                round = def.round,
                remainingDef = __rest(def, ["delay", "min", "max", "round"]);
            var action$$1 = getAction(val, remainingDef, props);
            var outputPipe = [];
            if (delay$$1) action$$1 = addActionDelay(delay$$1, action$$1);
            if (min !== undefined) outputPipe.push(function (v) {
                return Math.max(v, min);
            });
            if (max !== undefined) outputPipe.push(function (v) {
                return Math.min(v, max);
            });
            if (round) outputPipe.push(Math.round);
            return outputPipe.length ? action$$1.pipe.apply(action$$1, outputPipe) : action$$1;
        },
        setValueNative: setValueNative,
        addActionDelay: addActionDelay,
        defaultTransitions: defaultTransitions,
        transformPose: transformPose,
        readValueFromSource: readValueFromSource,
        posePriority: posePriority,
        extendAPI: extendAPI
    });
};

var createDimensions = function (element) {
    var hasMeasured = false;
    var current = {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    };
    return {
        get: function (measurement) {
            return measurement ? current[measurement] : current;
        },
        measure: function () {
            current = element.getBoundingClientRect();
            hasMeasured = true;
            return current;
        },
        measurementAsPixels: function (measurement, value$$1, type) {
            return type === __WEBPACK_IMPORTED_MODULE_2_style_value_types__["h" /* percent */] ? (typeof value$$1 === 'string' ? parseFloat(value$$1) : value$$1) / 100 * current[measurement] : value$$1;
        },
        has: function () {
            return hasMeasured;
        }
    };
};

var makeUIEventApplicator = function (_a) {
    var startEvents = _a.startEvents,
        endEvents = _a.endEvents,
        startPose = _a.startPose,
        endPose = _a.endPose,
        startCallback = _a.startCallback,
        endCallback = _a.endCallback,
        useDocumentToEnd = _a.useDocumentToEnd,
        preventScroll = _a.preventScroll;
    return function (element, activeActions, poser, config) {
        var startListener = startPose + 'Start';
        var endListener = startPose + 'End';
        var moveListener = startPose + 'Move';
        if (preventScroll) {
            var touchMoveListener = Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["f" /* listen */])(element, 'touchmove', {
                passive: false
            }).start(function (e) {
                e.preventDefault();
            });
            activeActions.set(moveListener, touchMoveListener);
        }
        var eventStartListener = Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["f" /* listen */])(element, startEvents).start(function (startEvent) {
            poser.unset(endPose);
            poser.set(startPose);
            if (startCallback && config[startCallback]) config[startCallback](startEvent);
            var eventEndListener = Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["f" /* listen */])(useDocumentToEnd ? document.documentElement : element, endEvents + (useDocumentToEnd ? ' mouseenter' : '')).start(function (endEvent) {
                if (useDocumentToEnd && endEvent.type === 'mouseenter' && endEvent.buttons === 1) {
                    return;
                }
                activeActions.get(endListener).stop();
                poser.unset(startPose);
                poser.set(endPose);
                if (endCallback && config[endCallback]) config[endCallback](endEvent);
            });
            activeActions.set(endListener, eventEndListener);
        });
        activeActions.set(startListener, eventStartListener);
    };
};
var events = {
    draggable: /*#__PURE__*/makeUIEventApplicator({
        startEvents: 'mousedown touchstart',
        endEvents: 'mouseup touchend',
        startPose: 'drag',
        endPose: 'dragEnd',
        startCallback: 'onDragStart',
        endCallback: 'onDragEnd',
        useDocumentToEnd: true,
        preventScroll: true
    }),
    hoverable: /*#__PURE__*/makeUIEventApplicator({
        startEvents: 'mouseenter',
        endEvents: 'mouseleave',
        startPose: 'hover',
        endPose: 'hoverEnd'
    }),
    focusable: /*#__PURE__*/makeUIEventApplicator({
        startEvents: 'focus',
        endEvents: 'blur',
        startPose: 'focus',
        endPose: 'blur'
    }),
    pressable: /*#__PURE__*/makeUIEventApplicator({
        startEvents: 'mousedown touchstart',
        endEvents: 'mouseup touchend',
        startPose: 'press',
        endPose: 'pressEnd',
        startCallback: 'onPressStart',
        endCallback: 'onPressEnd',
        useDocumentToEnd: true
    })
};
var eventKeys = /*#__PURE__*/Object.keys(events);
var appendEventListeners = function (element, activeActions, poser, _a) {
    var props = _a.props;
    return eventKeys.forEach(function (key) {
        if (props[key]) events[key](element, activeActions, poser, props);
    });
};

var ORIGIN_START = 0;
var ORIGIN_CENTER = '50%';
var ORIGIN_END = '100%';
var findCenter = function (_a) {
    var top = _a.top,
        right = _a.right,
        bottom = _a.bottom,
        left = _a.left;
    return {
        x: (left + right) / 2,
        y: (top + bottom) / 2
    };
};
var positionalProps = ['width', 'height', 'top', 'left', 'bottom', 'right'];
var positionalPropsDict = /*#__PURE__*/new Set(positionalProps);
var checkPositionalProp = function (key) {
    return positionalPropsDict.has(key);
};
var hasPositionalProps = function (pose) {
    return Object.keys(pose).some(checkPositionalProp);
};
var isFlipPose = function (flip, key, state) {
    return state.props.element instanceof HTMLElement && (flip === true || key === 'flip');
};
var setValue = function (_a, key, to) {
    var values = _a.values,
        props = _a.props;
    if (values.has(key)) {
        var raw = values.get(key).raw;
        raw.update(to);
        raw.update(to);
    } else {
        values.set(key, {
            raw: Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["m" /* value */])(to, function (v) {
                return props.elementStyler.set(key, v);
            })
        });
    }
};
var explicitlyFlipPose = function (state, nextPose) {
    var _a = state.props,
        dimensions = _a.dimensions,
        elementStyler = _a.elementStyler;
    dimensions.measure();
    var width = nextPose.width,
        height = nextPose.height,
        top = nextPose.top,
        left = nextPose.left,
        bottom = nextPose.bottom,
        right = nextPose.right,
        position = nextPose.position,
        remainingPose = __rest(nextPose, ["width", "height", "top", "left", "bottom", "right", "position"]);
    var propsToSet = positionalProps.concat('position').reduce(function (acc, key) {
        if (nextPose[key] !== undefined) {
            acc[key] = resolveProp(nextPose[key], state.props);
        }
        return acc;
    }, {});
    elementStyler.set(propsToSet).render();
    return implicitlyFlipPose(state, remainingPose);
};
var implicitlyFlipPose = function (state, nextPose) {
    var _a = state.props,
        dimensions = _a.dimensions,
        element = _a.element,
        elementStyler = _a.elementStyler;
    if (!dimensions.has()) return {};
    var prev = dimensions.get();
    var next = measureWithoutTransform(element);
    var originX = prev.left === next.left ? ORIGIN_START : prev.right === next.right ? ORIGIN_END : ORIGIN_CENTER;
    var originY = prev.top === next.top ? ORIGIN_START : prev.bottom === next.bottom ? ORIGIN_END : ORIGIN_CENTER;
    elementStyler.set({ originX: originX, originY: originY });
    if (prev.width !== next.width) {
        setValue(state, 'scaleX', prev.width / next.width);
        nextPose.scaleX = 1;
    }
    if (prev.height !== next.height) {
        setValue(state, 'scaleY', prev.height / next.height);
        nextPose.scaleY = 1;
    }
    var prevCenter = findCenter(prev);
    var nextCenter = findCenter(next);
    if (originX === ORIGIN_CENTER) {
        setValue(state, 'x', prevCenter.x - nextCenter.x);
        nextPose.x = 0;
    }
    if (originY === ORIGIN_CENTER) {
        setValue(state, 'y', prevCenter.y - nextCenter.y);
        nextPose.y = 0;
    }
    elementStyler.render();
    return nextPose;
};
var flipPose = function (props, nextPose) {
    return hasPositionalProps(nextPose) ? explicitlyFlipPose(props, nextPose) : implicitlyFlipPose(props, nextPose);
};

var getPosFromMatrix = function (matrix, pos) {
    return parseFloat(matrix.split(', ')[pos]);
};
var getTranslateFromMatrix = function (pos2, pos3) {
    return function (element, bbox, _a) {
        var transform$$1 = _a.transform;
        if (!transform$$1 || transform$$1 === 'none') return 0;
        var matrix3d = transform$$1.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return getPosFromMatrix(matrix3d[1], pos3);
        return getPosFromMatrix(transform$$1.match(/^matrix\((.+)\)$/)[1], pos2);
    };
};
var positionalValues = {
    width: function (element, _a) {
        var width = _a.width;
        return width;
    },
    height: function (element, _a) {
        var height = _a.height;
        return height;
    },
    top: function (element, bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function (element, bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function (element, _a, _b) {
        var height = _a.height;
        var top = _b.top;
        return parseFloat(top) + height;
    },
    right: function (element, _a, _b) {
        var width = _a.width;
        var left = _b.left;
        return parseFloat(left) + width;
    },
    x: /*#__PURE__*/getTranslateFromMatrix(4, 13),
    y: /*#__PURE__*/getTranslateFromMatrix(5, 14)
};
var isPositionalKey = function (v) {
    return positionalValues[v] !== undefined;
};
var isPositional = function (pose) {
    return Object.keys(pose).some(isPositionalKey);
};
var convertPositionalUnits = function (state, nextPose) {
    var values = state.values,
        props = state.props;
    var element = props.element,
        elementStyler = props.elementStyler;
    var positionalPoseKeys = Object.keys(nextPose).filter(isPositionalKey);
    var changedPositionalKeys = [];
    var elementComputedStyle = getComputedStyle(element);
    var applyAtEndHasBeenCopied = false;
    positionalPoseKeys.forEach(function (key) {
        var value$$1 = values.get(key);
        var fromValueType = getValueType(value$$1.raw.get());
        var to = resolveProp(nextPose[key], props);
        var toValueType = getValueType(to);
        if (fromValueType !== toValueType) {
            changedPositionalKeys.push(key);
            if (!applyAtEndHasBeenCopied) {
                applyAtEndHasBeenCopied = true;
                nextPose.applyAtEnd = nextPose.applyAtEnd ? __assign({}, nextPose.applyAtEnd) : {};
            }
            nextPose.applyAtEnd[key] = nextPose.applyAtEnd[key] || nextPose[key];
            setValue(state, key, to);
        }
    });
    if (!changedPositionalKeys.length) return nextPose;
    var originBbox = element.getBoundingClientRect();
    var top = elementComputedStyle.top,
        left = elementComputedStyle.left,
        bottom = elementComputedStyle.bottom,
        right = elementComputedStyle.right,
        transform$$1 = elementComputedStyle.transform;
    var originComputedStyle = { top: top, left: left, bottom: bottom, right: right, transform: transform$$1 };
    elementStyler.render();
    var targetBbox = element.getBoundingClientRect();
    changedPositionalKeys.forEach(function (key) {
        setValue(state, key, positionalValues[key](element, originBbox, originComputedStyle));
        nextPose[key] = positionalValues[key](element, targetBbox, elementComputedStyle);
    });
    elementStyler.render();
    return nextPose;
};

var getCurrent = function (prop) {
    return function (_a) {
        var elementStyler = _a.elementStyler;
        return elementStyler.get(prop);
    };
};
var dragPoses = function (draggable) {
    var drag = {
        preTransition: function (_a) {
            var dimensions = _a.dimensions;
            return dimensions.measure();
        }
    };
    var dragEnd = {};
    if (draggable === true || draggable === 'x') {
        drag.x = dragEnd.x = getCurrent('x');
    }
    if (draggable === true || draggable === 'y') {
        drag.y = dragEnd.y = getCurrent('y');
    }
    return { drag: drag, dragEnd: dragEnd };
};
var createPoseConfig = function (element, _a) {
    var onDragStart = _a.onDragStart,
        onDragEnd = _a.onDragEnd,
        onPressStart = _a.onPressStart,
        onPressEnd = _a.onPressEnd,
        draggable = _a.draggable,
        hoverable = _a.hoverable,
        focusable = _a.focusable,
        pressable = _a.pressable,
        dragBounds = _a.dragBounds,
        config = __rest(_a, ["onDragStart", "onDragEnd", "onPressStart", "onPressEnd", "draggable", "hoverable", "focusable", "pressable", "dragBounds"]);
    var poseConfig = __assign(__assign({ flip: {} }, config), { props: __assign(__assign({}, config.props), { onDragStart: onDragStart,
            onDragEnd: onDragEnd,
            onPressStart: onPressStart,
            onPressEnd: onPressEnd,
            dragBounds: dragBounds,
            draggable: draggable,
            hoverable: hoverable,
            focusable: focusable,
            pressable: pressable,
            element: element, elementStyler: Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["j" /* styler */])(element, { preparseOutput: false }), dimensions: createDimensions(element) }) });
    if (draggable) {
        var _b = dragPoses(draggable),
            drag = _b.drag,
            dragEnd = _b.dragEnd;
        poseConfig.drag = __assign(__assign({}, drag), poseConfig.drag);
        poseConfig.dragEnd = __assign(__assign({}, dragEnd), poseConfig.dragEnd);
    }
    return poseConfig;
};
var domPose = /*#__PURE__*/pose({
    posePriority: ['drag', 'press', 'focus', 'hover'],
    transformPose: function (_a, name, state) {
        var flip = _a.flip,
            pose$$1 = __rest(_a, ["flip"]);
        if (isFlipPose(flip, name, state)) {
            return flipPose(state, pose$$1);
        } else if (isPositional(pose$$1)) {
            return convertPositionalUnits(state, pose$$1);
        }
        return pose$$1;
    },
    forceRender: function (_a) {
        var elementStyler = _a.elementStyler;
        elementStyler.render();
    },
    addListenerToValue: function (key, elementStyler) {
        return function (v) {
            return elementStyler.set(key, v);
        };
    },
    readValueFromSource: function (key, _a) {
        var elementStyler = _a.elementStyler,
            dragBounds = _a.dragBounds;
        var value$$1 = elementStyler.get(key);
        if (dragBounds && (key === 'x' || key === 'y')) {
            var bound = key === 'x' ? dragBounds.left || dragBounds.right : dragBounds.top || dragBounds.bottom;
            if (bound) {
                var boundType = getValueType(bound);
                value$$1 = boundType.transform(value$$1);
            }
        }
        return isNaN(value$$1) ? value$$1 : parseFloat(value$$1);
    },
    setValueNative: function (key, to, _a) {
        var elementStyler = _a.elementStyler;
        return elementStyler.set(key, to);
    },
    extendAPI: function (api, _a, config) {
        var props = _a.props,
            activeActions = _a.activeActions;
        var measure = props.dimensions.measure;
        var poserApi = __assign(__assign({}, api), { addChild: function (element, childConfig) {
                return api._addChild(createPoseConfig(element, childConfig), domPose);
            }, measure: measure, flip: function (op) {
                if (op) {
                    measure();
                    op();
                }
                return api.set('flip');
            } });
        props.elementStyler.render();
        appendEventListeners(props.element, activeActions, poserApi, config);
        return poserApi;
    }
});
var domPose$1 = function (element, config) {
    return domPose(createPoseConfig(element, config));
};

/* harmony default export */ __webpack_exports__["a"] = (domPose$1);


/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return action; });
/* unused harmony export multicast */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return vectorDecay; });
/* unused harmony export inertia */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return keyframes; });
/* unused harmony export everyFrame */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return vectorPhysics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return vectorSpring; });
/* unused harmony export timeline */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return tween; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return listen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return index$1; });
/* unused harmony export mouse */
/* unused harmony export multitouch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return chain; });
/* unused harmony export composite */
/* unused harmony export crossfade */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return delay; });
/* unused harmony export merge */
/* unused harmony export parallel */
/* unused harmony export schedule */
/* unused harmony export stagger */
/* unused harmony export calc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return transformers; });
/* unused harmony export css */
/* unused harmony export svg */
/* unused harmony export Action */
/* unused harmony export ValueReaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_framesync__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_style_value_types__ = __webpack_require__(164);
/* unused harmony reexport valueTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popmotion_easing__ = __webpack_require__(165);
/* unused harmony reexport easing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_stylefire__ = __webpack_require__(488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5_stylefire__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hey_listen__ = __webpack_require__(124);













var Chainable = /*#__PURE__*/function () {
    function Chainable(props) {
        if (props === void 0) {
            props = {};
        }
        this.props = props;
    }
    Chainable.prototype.applyMiddleware = function (middleware) {
        return this.create(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.props, { middleware: this.props.middleware ? [middleware].concat(this.props.middleware) : [middleware] }));
    };
    Chainable.prototype.pipe = function () {
        var funcs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            funcs[_i] = arguments[_i];
        }
        var pipedUpdate = funcs.length === 1 ? funcs[0] : __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["n" /* pipe */].apply(void 0, funcs);
        return this.applyMiddleware(function (update) {
            return function (v) {
                return update(pipedUpdate(v));
            };
        });
    };
    Chainable.prototype.while = function (predicate) {
        return this.applyMiddleware(function (update, complete) {
            return function (v) {
                return predicate(v) ? update(v) : complete();
            };
        });
    };
    Chainable.prototype.filter = function (predicate) {
        return this.applyMiddleware(function (update) {
            return function (v) {
                return predicate(v) && update(v);
            };
        });
    };
    return Chainable;
}();

var Observer = /*#__PURE__*/function () {
    function Observer(_a, observer) {
        var middleware = _a.middleware,
            onComplete = _a.onComplete;
        var _this = this;
        this.isActive = true;
        this.update = function (v) {
            if (_this.observer.update) _this.updateObserver(v);
        };
        this.complete = function () {
            if (_this.observer.complete && _this.isActive) _this.observer.complete();
            if (_this.onComplete) _this.onComplete();
            _this.isActive = false;
        };
        this.error = function (err) {
            if (_this.observer.error && _this.isActive) _this.observer.error(err);
            _this.isActive = false;
        };
        this.observer = observer;
        this.updateObserver = function (v) {
            return observer.update(v);
        };
        this.onComplete = onComplete;
        if (observer.update && middleware && middleware.length) {
            middleware.forEach(function (m) {
                return _this.updateObserver = m(_this.updateObserver, _this.complete);
            });
        }
    }
    return Observer;
}();
var createObserver = function (observerCandidate, _a, onComplete) {
    var middleware = _a.middleware;
    if (typeof observerCandidate === 'function') {
        return new Observer({ middleware: middleware, onComplete: onComplete }, { update: observerCandidate });
    } else {
        return new Observer({ middleware: middleware, onComplete: onComplete }, observerCandidate);
    }
};

var Action = /*#__PURE__*/function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Action, _super);
    function Action() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Action.prototype.create = function (props) {
        return new Action(props);
    };
    Action.prototype.start = function (observerCandidate) {
        if (observerCandidate === void 0) {
            observerCandidate = {};
        }
        var isComplete = false;
        var subscription = {
            stop: function () {
                return undefined;
            }
        };
        var _a = this.props,
            init = _a.init,
            observerProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["init"]);
        var observer = createObserver(observerCandidate, observerProps, function () {
            isComplete = true;
            subscription.stop();
        });
        var api = init(observer);
        subscription = api ? Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, subscription, api) : subscription;
        if (observerCandidate.registerParent) {
            observerCandidate.registerParent(subscription);
        }
        if (isComplete) subscription.stop();
        return subscription;
    };
    return Action;
}(Chainable);
var action = function (init) {
    return new Action({ init: init });
};

var BaseMulticast = /*#__PURE__*/function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BaseMulticast, _super);
    function BaseMulticast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.subscribers = [];
        return _this;
    }
    BaseMulticast.prototype.complete = function () {
        this.subscribers.forEach(function (subscriber) {
            return subscriber.complete();
        });
    };
    BaseMulticast.prototype.error = function (err) {
        this.subscribers.forEach(function (subscriber) {
            return subscriber.error(err);
        });
    };
    BaseMulticast.prototype.update = function (v) {
        for (var i = 0; i < this.subscribers.length; i++) {
            this.subscribers[i].update(v);
        }
    };
    BaseMulticast.prototype.subscribe = function (observerCandidate) {
        var _this = this;
        var observer = createObserver(observerCandidate, this.props);
        this.subscribers.push(observer);
        var subscription = {
            unsubscribe: function () {
                var index = _this.subscribers.indexOf(observer);
                if (index !== -1) _this.subscribers.splice(index, 1);
            }
        };
        return subscription;
    };
    BaseMulticast.prototype.stop = function () {
        if (this.parent) this.parent.stop();
    };
    BaseMulticast.prototype.registerParent = function (subscription) {
        this.stop();
        this.parent = subscription;
    };
    return BaseMulticast;
}(Chainable);

var Multicast = /*#__PURE__*/function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Multicast, _super);
    function Multicast() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Multicast.prototype.create = function (props) {
        return new Multicast(props);
    };
    return Multicast;
}(BaseMulticast);
var multicast = function () {
    return new Multicast();
};

var stepProgress = function (steps, progress$$1) {
    var segment = 1 / (steps - 1);
    var subsegment = 1 / (2 * (steps - 1));
    var percentProgressOfTarget = Math.min(progress$$1, 1);
    var subsegmentProgressOfTarget = percentProgressOfTarget / subsegment;
    var segmentProgressOfTarget = Math.floor((subsegmentProgressOfTarget + 1) / 2);
    return segmentProgressOfTarget * segment;
};

var calc = /*#__PURE__*/Object.freeze({
    angle: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["a" /* angle */],
    degreesToRadians: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["e" /* degreesToRadians */],
    distance: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["f" /* distance */],
    isPoint3D: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["i" /* isPoint3D */],
    isPoint: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["h" /* isPoint */],
    dilate: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["j" /* mix */],
    getValueFromProgress: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["j" /* mix */],
    pointFromAngleAndDistance: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["o" /* pointFromVector */],
    getProgressFromValue: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["p" /* progress */],
    radiansToDegrees: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["q" /* radiansToDegrees */],
    smooth: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["s" /* smoothFrame */],
    speedPerFrame: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["x" /* velocityPerFrame */],
    speedPerSecond: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["y" /* velocityPerSecond */],
    stepProgress: stepProgress
});

var isValueList = function (v) {
    return Array.isArray(v);
};
var isSingleValue = function (v) {
    var typeOfV = typeof v;
    return typeOfV === 'string' || typeOfV === 'number';
};
var ValueReaction = /*#__PURE__*/function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ValueReaction, _super);
    function ValueReaction(props) {
        var _this = _super.call(this, props) || this;
        _this.scheduleVelocityCheck = function () {
            return __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].postRender(_this.velocityCheck);
        };
        _this.velocityCheck = function (_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
            }
        };
        _this.prev = _this.current = props.value || 0;
        if (isSingleValue(_this.current)) {
            _this.updateCurrent = function (v) {
                return _this.current = v;
            };
            _this.getVelocityOfCurrent = function () {
                return _this.getSingleVelocity(_this.current, _this.prev);
            };
        } else if (isValueList(_this.current)) {
            _this.updateCurrent = function (v) {
                return _this.current = v.slice();
            };
            _this.getVelocityOfCurrent = function () {
                return _this.getListVelocity();
            };
        } else {
            _this.updateCurrent = function (v) {
                _this.current = {};
                for (var key in v) {
                    if (v.hasOwnProperty(key)) {
                        _this.current[key] = v[key];
                    }
                }
            };
            _this.getVelocityOfCurrent = function () {
                return _this.getMapVelocity();
            };
        }
        if (props.initialSubscription) _this.subscribe(props.initialSubscription);
        return _this;
    }
    ValueReaction.prototype.create = function (props) {
        return new ValueReaction(props);
    };
    ValueReaction.prototype.get = function () {
        return this.current;
    };
    ValueReaction.prototype.getVelocity = function () {
        return this.getVelocityOfCurrent();
    };
    ValueReaction.prototype.update = function (v) {
        _super.prototype.update.call(this, v);
        this.prev = this.current;
        this.updateCurrent(v);
        var _a = Object(__WEBPACK_IMPORTED_MODULE_2_framesync__["c" /* getFrameData */])(),
            delta = _a.delta,
            timestamp = _a.timestamp;
        this.timeDelta = delta;
        this.lastUpdated = timestamp;
        __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].postRender(this.scheduleVelocityCheck);
    };
    ValueReaction.prototype.subscribe = function (observerCandidate) {
        var sub = _super.prototype.subscribe.call(this, observerCandidate);
        this.subscribers[this.subscribers.length - 1].update(this.current);
        return sub;
    };
    ValueReaction.prototype.getSingleVelocity = function (current, prev) {
        return typeof current === 'number' && typeof prev === 'number' ? Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["y" /* velocityPerSecond */])(current - prev, this.timeDelta) : Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["y" /* velocityPerSecond */])(parseFloat(current) - parseFloat(prev), this.timeDelta) || 0;
    };
    ValueReaction.prototype.getListVelocity = function () {
        var _this = this;
        return this.current.map(function (c, i) {
            return _this.getSingleVelocity(c, _this.prev[i]);
        });
    };
    ValueReaction.prototype.getMapVelocity = function () {
        var velocity = {};
        for (var key in this.current) {
            if (this.current.hasOwnProperty(key)) {
                velocity[key] = this.getSingleVelocity(this.current[key], this.prev[key]);
            }
        }
        return velocity;
    };
    return ValueReaction;
}(BaseMulticast);
var value = function (value, initialSubscription) {
    return new ValueReaction({ value: value, initialSubscription: initialSubscription });
};

var multi = function (_a) {
    var getCount = _a.getCount,
        getFirst = _a.getFirst,
        getOutput = _a.getOutput,
        mapApi = _a.mapApi,
        setProp = _a.setProp,
        startActions = _a.startActions;
    return function (actions) {
        return action(function (_a) {
            var update = _a.update,
                complete = _a.complete,
                error = _a.error;
            var numActions = getCount(actions);
            var output = getOutput();
            var updateOutput = function () {
                return update(output);
            };
            var numCompletedActions = 0;
            var subs = startActions(actions, function (a, name) {
                var hasCompleted = false;
                return a.start({
                    complete: function () {
                        if (!hasCompleted) {
                            hasCompleted = true;
                            numCompletedActions++;
                            if (numCompletedActions === numActions) __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(complete);
                        }
                    },
                    error: error,
                    update: function (v) {
                        setProp(output, name, v);
                        __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(updateOutput, false, true);
                    }
                });
            });
            return Object.keys(getFirst(subs)).reduce(function (api, methodName) {
                api[methodName] = mapApi(subs, methodName);
                return api;
            }, {});
        });
    };
};

var composite = /*#__PURE__*/multi({
    getOutput: function () {
        return {};
    },
    getCount: function (subs) {
        return Object.keys(subs).length;
    },
    getFirst: function (subs) {
        return subs[Object.keys(subs)[0]];
    },
    mapApi: function (subs, methodName) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return Object.keys(subs).reduce(function (output, propKey) {
                var _a;
                if (subs[propKey][methodName]) {
                    args[0] && args[0][propKey] !== undefined ? output[propKey] = subs[propKey][methodName](args[0][propKey]) : output[propKey] = (_a = subs[propKey])[methodName].apply(_a, args);
                }
                return output;
            }, {});
        };
    },
    setProp: function (output, name, v) {
        return output[name] = v;
    },
    startActions: function (actions, starter) {
        return Object.keys(actions).reduce(function (subs, key) {
            subs[key] = starter(actions[key], key);
            return subs;
        }, {});
    }
});

var parallel = /*#__PURE__*/multi({
    getOutput: function () {
        return [];
    },
    getCount: function (subs) {
        return subs.length;
    },
    getFirst: function (subs) {
        return subs[0];
    },
    mapApi: function (subs, methodName) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return subs.map(function (sub, i) {
                if (sub[methodName]) {
                    return Array.isArray(args[0]) ? sub[methodName](args[0][i]) : sub[methodName].apply(sub, args);
                }
            });
        };
    },
    setProp: function (output, name, v) {
        return output[name] = v;
    },
    startActions: function (actions, starter) {
        return actions.map(function (action, i) {
            return starter(action, i);
        });
    }
});
var parallel$1 = function () {
    var actions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        actions[_i] = arguments[_i];
    }
    return parallel(actions);
};

var createVectorTests = function (typeTests) {
    var testNames = Object.keys(typeTests);
    var isVectorProp = function (prop, key) {
        return prop !== undefined && !typeTests[key](prop);
    };
    var getVectorKeys = function (props) {
        return testNames.reduce(function (vectorKeys, key) {
            if (isVectorProp(props[key], key)) vectorKeys.push(key);
            return vectorKeys;
        }, []);
    };
    var testVectorProps = function (props) {
        return props && testNames.some(function (key) {
            return isVectorProp(props[key], key);
        });
    };
    return { getVectorKeys: getVectorKeys, testVectorProps: testVectorProps };
};
var unitTypes = [__WEBPACK_IMPORTED_MODULE_3_style_value_types__["j" /* px */], __WEBPACK_IMPORTED_MODULE_3_style_value_types__["h" /* percent */], __WEBPACK_IMPORTED_MODULE_3_style_value_types__["d" /* degrees */], __WEBPACK_IMPORTED_MODULE_3_style_value_types__["m" /* vh */], __WEBPACK_IMPORTED_MODULE_3_style_value_types__["n" /* vw */]];
var findUnitType = function (prop) {
    return unitTypes.find(function (type) {
        return type.test(prop);
    });
};
var isUnitProp = function (prop) {
    return Boolean(findUnitType(prop));
};
var createAction = function (action, props) {
    return action(props);
};
var reduceArrayValue = function (i) {
    return function (props, key) {
        props[key] = props[key][i];
        return props;
    };
};
var createArrayAction = function (action, props, vectorKeys) {
    var firstVectorKey = vectorKeys[0];
    var actionList = props[firstVectorKey].map(function (v, i) {
        var childActionProps = vectorKeys.reduce(reduceArrayValue(i), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props));
        return getActionCreator(v)(action, childActionProps);
    });
    return parallel$1.apply(void 0, actionList);
};
var reduceObjectValue = function (key) {
    return function (props, propKey) {
        props[propKey] = props[propKey][key];
        return props;
    };
};
var createObjectAction = function (action, props, vectorKeys) {
    var firstVectorKey = vectorKeys[0];
    var actionMap = Object.keys(props[firstVectorKey]).reduce(function (map, key) {
        var childActionProps = vectorKeys.reduce(reduceObjectValue(key), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props));
        map[key] = getActionCreator(props[firstVectorKey][key])(action, childActionProps);
        return map;
    }, {});
    return composite(actionMap);
};
var createUnitAction = function (action, _a) {
    var from = _a.from,
        to = _a.to,
        props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["from", "to"]);
    var unitType = findUnitType(from) || findUnitType(to);
    var transform = unitType.transform,
        parse = unitType.parse;
    return action(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, { from: typeof from === 'string' ? parse(from) : from, to: typeof to === 'string' ? parse(to) : to })).pipe(transform);
};
var createMixerAction = function (mixer) {
    return function (action, _a) {
        var from = _a.from,
            to = _a.to,
            props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["from", "to"]);
        return action(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, { from: 0, to: 1 })).pipe(mixer(from, to));
    };
};
var createColorAction = /*#__PURE__*/createMixerAction(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["l" /* mixColor */]);
var createComplexAction = /*#__PURE__*/createMixerAction(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["m" /* mixComplex */]);
var createVectorAction = function (action, typeTests) {
    var _a = createVectorTests(typeTests),
        testVectorProps = _a.testVectorProps,
        getVectorKeys = _a.getVectorKeys;
    var vectorAction = function (props) {
        var isVector = testVectorProps(props);
        if (!isVector) return action(props);
        var vectorKeys = getVectorKeys(props);
        var testKey = vectorKeys[0];
        var testProp = props[testKey];
        return getActionCreator(testProp)(action, props, vectorKeys);
    };
    return vectorAction;
};
var getActionCreator = function (prop) {
    if (typeof prop === 'number') {
        return createAction;
    } else if (Array.isArray(prop)) {
        return createArrayAction;
    } else if (isUnitProp(prop)) {
        return createUnitAction;
    } else if (__WEBPACK_IMPORTED_MODULE_3_style_value_types__["b" /* color */].test(prop)) {
        return createColorAction;
    } else if (__WEBPACK_IMPORTED_MODULE_3_style_value_types__["c" /* complex */].test(prop)) {
        return createComplexAction;
    } else if (typeof prop === 'object') {
        return createObjectAction;
    } else {
        return createAction;
    }
};

var decay = function (props) {
    if (props === void 0) {
        props = {};
    }
    return action(function (_a) {
        var complete = _a.complete,
            update = _a.update;
        var _b = props.velocity,
            velocity = _b === void 0 ? 0 : _b,
            _c = props.from,
            from = _c === void 0 ? 0 : _c,
            _d = props.power,
            power = _d === void 0 ? 0.8 : _d,
            _e = props.timeConstant,
            timeConstant = _e === void 0 ? 350 : _e,
            _f = props.restDelta,
            restDelta = _f === void 0 ? 0.5 : _f,
            modifyTarget = props.modifyTarget;
        var elapsed = 0;
        var amplitude = power * velocity;
        var idealTarget = Math.round(from + amplitude);
        var target = typeof modifyTarget === 'undefined' ? idealTarget : modifyTarget(idealTarget);
        var process = __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(function (_a) {
            var frameDelta = _a.delta;
            elapsed += frameDelta;
            var delta = -amplitude * Math.exp(-elapsed / timeConstant);
            var isMoving = delta > restDelta || delta < -restDelta;
            var current = isMoving ? target + delta : target;
            update(current);
            if (!isMoving) {
                __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
                complete();
            }
        }, true);
        return {
            stop: function () {
                return __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
            }
        };
    });
};
var vectorDecay = /*#__PURE__*/createVectorAction(decay, {
    from: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    modifyTarget: function (func) {
        return typeof func === 'function';
    },
    velocity: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test
});

var spring = function (props) {
    if (props === void 0) {
        props = {};
    }
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        var _b = props.velocity,
            velocity = _b === void 0 ? 0.0 : _b;
        var _c = props.from,
            from = _c === void 0 ? 0.0 : _c,
            _d = props.to,
            to = _d === void 0 ? 0.0 : _d,
            _e = props.stiffness,
            stiffness = _e === void 0 ? 100 : _e,
            _f = props.damping,
            damping = _f === void 0 ? 10 : _f,
            _g = props.mass,
            mass = _g === void 0 ? 1.0 : _g,
            _h = props.restSpeed,
            restSpeed = _h === void 0 ? 0.01 : _h,
            _j = props.restDelta,
            restDelta = _j === void 0 ? 0.01 : _j;
        var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        var t = 0;
        var delta = to - from;
        var position = from;
        var prevPosition = position;
        var process = __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(function (_a) {
            var timeDelta = _a.delta;
            t += timeDelta;
            var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
            var angularFreq = Math.sqrt(stiffness / mass) / 1000;
            prevPosition = position;
            if (dampingRatio < 1) {
                var envelope = Math.exp(-dampingRatio * angularFreq * t);
                var expoDecay = angularFreq * Math.sqrt(1.0 - dampingRatio * dampingRatio);
                position = to - envelope * ((initialVelocity + dampingRatio * angularFreq * delta) / expoDecay * Math.sin(expoDecay * t) + delta * Math.cos(expoDecay * t));
            } else {
                var envelope = Math.exp(-angularFreq * t);
                position = to - envelope * (delta + (initialVelocity + angularFreq * delta) * t);
            }
            velocity = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["y" /* velocityPerSecond */])(position - prevPosition, timeDelta);
            var isBelowVelocityThreshold = Math.abs(velocity) <= restSpeed;
            var isBelowDisplacementThreshold = Math.abs(to - position) <= restDelta;
            if (isBelowVelocityThreshold && isBelowDisplacementThreshold) {
                position = to;
                update(position);
                __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
                complete();
            } else {
                update(position);
            }
        }, true);
        return {
            stop: function () {
                return __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
            }
        };
    });
};
var vectorSpring = /*#__PURE__*/createVectorAction(spring, {
    from: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    to: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    stiffness: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    damping: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    mass: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    velocity: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test
});

var inertia = function (_a) {
    var _b = _a.from,
        from = _b === void 0 ? 0 : _b,
        _c = _a.velocity,
        velocity = _c === void 0 ? 0 : _c,
        min = _a.min,
        max = _a.max,
        _d = _a.power,
        power = _d === void 0 ? 0.8 : _d,
        _e = _a.timeConstant,
        timeConstant = _e === void 0 ? 700 : _e,
        _f = _a.bounceStiffness,
        bounceStiffness = _f === void 0 ? 500 : _f,
        _g = _a.bounceDamping,
        bounceDamping = _g === void 0 ? 10 : _g,
        _h = _a.restDelta,
        restDelta = _h === void 0 ? 1 : _h,
        modifyTarget = _a.modifyTarget;
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        var current = value(from);
        var activeAnimation;
        var isSpring = false;
        var isLessThanMin = function (v) {
            return min !== undefined && v <= min;
        };
        var isMoreThanMax = function (v) {
            return max !== undefined && v >= max;
        };
        var isOutOfBounds = function (v) {
            return isLessThanMin(v) || isMoreThanMax(v);
        };
        var isTravellingAwayFromBounds = function (v, currentVelocity) {
            return isLessThanMin(v) && currentVelocity < 0 || isMoreThanMax(v) && currentVelocity > 0;
        };
        var startAnimation = function (animation, next) {
            activeAnimation && activeAnimation.stop();
            activeAnimation = animation.start({
                update: function (v) {
                    return current.update(v);
                },
                complete: function () {
                    if (next) {
                        next();
                        return;
                    }
                    complete();
                }
            });
        };
        var startSpring = function (props) {
            isSpring = true;
            startAnimation(vectorSpring(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, { to: isLessThanMin(props.from) ? min : max, stiffness: bounceStiffness, damping: bounceDamping, restDelta: restDelta })));
        };
        current.subscribe(function (v) {
            update(v);
            var currentVelocity = current.getVelocity();
            if (activeAnimation && !isSpring && isTravellingAwayFromBounds(v, currentVelocity)) {
                startSpring({ from: v, velocity: currentVelocity });
            }
        });
        if (isOutOfBounds(from)) {
            startSpring({ from: from, velocity: velocity });
        } else if (velocity !== 0) {
            var animation = vectorDecay({
                from: from,
                velocity: velocity,
                timeConstant: timeConstant,
                power: power,
                restDelta: isOutOfBounds(from) ? 20 : restDelta,
                modifyTarget: modifyTarget
            });
            startAnimation(animation, function () {
                var v = current.get();
                if (isOutOfBounds(v)) {
                    startSpring({ from: v, velocity: current.getVelocity() });
                } else {
                    complete();
                }
            });
        } else {
            complete();
        }
        return {
            stop: function () {
                return activeAnimation && activeAnimation.stop();
            }
        };
    });
};
var index = /*#__PURE__*/createVectorAction(inertia, {
    from: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    velocity: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    min: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    max: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    damping: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    stiffness: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    modifyTarget: function (func) {
        return typeof func === 'function';
    }
});

var frame = function () {
    return action(function (_a) {
        var update = _a.update;
        var initialTime = 0;
        var process = __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(function (_a) {
            var timestamp = _a.timestamp;
            if (!initialTime) initialTime = timestamp;
            update(timestamp - initialTime);
        }, true, true);
        return {
            stop: function () {
                return __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
            }
        };
    });
};

var scrubber = function (_a) {
    var _b = _a.from,
        from = _b === void 0 ? 0 : _b,
        _c = _a.to,
        to = _c === void 0 ? 1 : _c,
        _d = _a.ease,
        ease = _d === void 0 ? __WEBPACK_IMPORTED_MODULE_4__popmotion_easing__["m" /* linear */] : _d,
        _e = _a.reverseEase,
        reverseEase = _e === void 0 ? false : _e;
    if (reverseEase) {
        ease = Object(__WEBPACK_IMPORTED_MODULE_4__popmotion_easing__["h" /* createReversedEasing */])(ease);
    }
    return action(function (_a) {
        var update = _a.update;
        return {
            seek: function (progress$$1) {
                return update(progress$$1);
            }
        };
    }).pipe(ease, function (v) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["j" /* mix */])(from, to, v);
    });
};
var vectorScrubber = /*#__PURE__*/createVectorAction(scrubber, {
    ease: function (func) {
        return typeof func === 'function';
    },
    from: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    to: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test
});

var clampProgress = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["c" /* clamp */])(0, 1);
var tween = function (props) {
    if (props === void 0) {
        props = {};
    }
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        var _b = props.duration,
            duration = _b === void 0 ? 300 : _b,
            _c = props.ease,
            ease = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_4__popmotion_easing__["l" /* easeOut */] : _c,
            _d = props.flip,
            flip = _d === void 0 ? 0 : _d,
            _e = props.loop,
            loop = _e === void 0 ? 0 : _e,
            _f = props.yoyo,
            yoyo = _f === void 0 ? 0 : _f,
            _g = props.repeatDelay,
            repeatDelay = _g === void 0 ? 0 : _g;
        var _h = props.from,
            from = _h === void 0 ? 0 : _h,
            _j = props.to,
            to = _j === void 0 ? 1 : _j,
            _k = props.elapsed,
            elapsed = _k === void 0 ? 0 : _k,
            _l = props.flipCount,
            flipCount = _l === void 0 ? 0 : _l,
            _m = props.yoyoCount,
            yoyoCount = _m === void 0 ? 0 : _m,
            _o = props.loopCount,
            loopCount = _o === void 0 ? 0 : _o;
        var playhead = vectorScrubber({ from: from, to: to, ease: ease }).start(update);
        var currentProgress = 0;
        var process;
        var isActive = false;
        var reverseAnimation = function (reverseEase) {
            if (reverseEase === void 0) {
                reverseEase = false;
            }
            var _a;
            _a = [to, from], from = _a[0], to = _a[1];
            playhead = vectorScrubber({ from: from, to: to, ease: ease, reverseEase: reverseEase }).start(update);
        };
        var isTweenComplete = function () {
            var isComplete = isActive && elapsed > duration + repeatDelay;
            if (!isComplete) return false;
            if (isComplete && !loop && !flip && !yoyo) return true;
            elapsed = duration - (elapsed - repeatDelay);
            if (loop && loopCount < loop) {
                loopCount++;
                return false;
            } else if (flip && flipCount < flip) {
                flipCount++;
                reverseAnimation();
                return false;
            } else if (yoyo && yoyoCount < yoyo) {
                yoyoCount++;
                reverseAnimation(yoyoCount % 2 !== 0);
                return false;
            }
            return true;
        };
        var updateTween = function () {
            currentProgress = clampProgress(Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["p" /* progress */])(0, duration, elapsed));
            playhead.seek(currentProgress);
        };
        var startTimer = function () {
            isActive = true;
            process = __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(function (_a) {
                var delta = _a.delta;
                elapsed += delta;
                updateTween();
                if (isTweenComplete()) {
                    __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
                    complete && __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(complete, false, true);
                }
            }, true);
        };
        var stopTimer = function () {
            isActive = false;
            if (process) __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
        };
        startTimer();
        return {
            isActive: function () {
                return isActive;
            },
            getElapsed: function () {
                return Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["c" /* clamp */])(0, duration, elapsed);
            },
            getProgress: function () {
                return currentProgress;
            },
            stop: function () {
                stopTimer();
            },
            pause: function () {
                stopTimer();
                return this;
            },
            resume: function () {
                if (!isActive) startTimer();
                return this;
            },
            seek: function (newProgress) {
                elapsed = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["j" /* mix */])(0, duration, newProgress);
                __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(updateTween, false, true);
                return this;
            },
            reverse: function () {
                reverseAnimation();
                return this;
            }
        };
    });
};

var clampProgress$1 = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["c" /* clamp */])(0, 1);
var defaultEasings = function (values, easing$$1) {
    return values.map(function () {
        return easing$$1 || __WEBPACK_IMPORTED_MODULE_4__popmotion_easing__["l" /* easeOut */];
    }).splice(0, values.length - 1);
};
var defaultTimings = function (values) {
    var numValues = values.length;
    return values.map(function (value, i) {
        return i !== 0 ? i / (numValues - 1) : 0;
    });
};
var interpolateScrubbers = function (input, scrubbers, update) {
    var rangeLength = input.length;
    var finalInputIndex = rangeLength - 1;
    var finalScrubberIndex = finalInputIndex - 1;
    var subs = scrubbers.map(function (scrub) {
        return scrub.start(update);
    });
    return function (v) {
        if (v <= input[0]) {
            subs[0].seek(0);
        }
        if (v >= input[finalInputIndex]) {
            subs[finalScrubberIndex].seek(1);
        }
        var i = 1;
        for (; i < rangeLength; i++) {
            if (input[i] > v || i === finalInputIndex) break;
        }
        var progressInRange = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["p" /* progress */])(input[i - 1], input[i], v);
        subs[i - 1].seek(clampProgress$1(progressInRange));
    };
};
var keyframes = function (_a) {
    var easings = _a.easings,
        _b = _a.ease,
        ease = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_4__popmotion_easing__["m" /* linear */] : _b,
        times = _a.times,
        values = _a.values,
        tweenProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["easings", "ease", "times", "values"]);
    easings = Array.isArray(easings) ? easings : defaultEasings(values, easings);
    times = times || defaultTimings(values);
    var scrubbers = easings.map(function (easing$$1, i) {
        return vectorScrubber({
            from: values[i],
            to: values[i + 1],
            ease: easing$$1
        });
    });
    return tween(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, tweenProps, { ease: ease })).applyMiddleware(function (update) {
        return interpolateScrubbers(times, scrubbers, update);
    });
};

var physics = function (props) {
    if (props === void 0) {
        props = {};
    }
    return action(function (_a) {
        var complete = _a.complete,
            update = _a.update;
        var _b = props.acceleration,
            acceleration = _b === void 0 ? 0 : _b,
            _c = props.friction,
            friction = _c === void 0 ? 0 : _c,
            _d = props.velocity,
            velocity = _d === void 0 ? 0 : _d,
            springStrength = props.springStrength,
            to = props.to;
        var _e = props.restSpeed,
            restSpeed = _e === void 0 ? 0.001 : _e,
            _f = props.from,
            from = _f === void 0 ? 0 : _f;
        var current = from;
        var process = __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(function (_a) {
            var delta = _a.delta;
            var elapsed = Math.max(delta, 16);
            if (acceleration) velocity += Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["x" /* velocityPerFrame */])(acceleration, elapsed);
            if (friction) velocity *= Math.pow(1 - friction, elapsed / 100);
            if (springStrength !== undefined && to !== undefined) {
                var distanceToTarget = to - current;
                velocity += distanceToTarget * Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["x" /* velocityPerFrame */])(springStrength, elapsed);
            }
            current += Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["x" /* velocityPerFrame */])(velocity, elapsed);
            update(current);
            var isComplete = restSpeed !== false && (!velocity || Math.abs(velocity) <= restSpeed);
            if (isComplete) {
                __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
                complete();
            }
        }, true);
        return {
            set: function (v) {
                current = v;
                return this;
            },
            setAcceleration: function (v) {
                acceleration = v;
                return this;
            },
            setFriction: function (v) {
                friction = v;
                return this;
            },
            setSpringStrength: function (v) {
                springStrength = v;
                return this;
            },
            setSpringTarget: function (v) {
                to = v;
                return this;
            },
            setVelocity: function (v) {
                velocity = v;
                return this;
            },
            stop: function () {
                return __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
            }
        };
    });
};
var vectorPhysics = /*#__PURE__*/createVectorAction(physics, {
    acceleration: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    friction: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    velocity: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    from: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    to: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    springStrength: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test
});

var DEFAULT_DURATION = 300;
var flattenTimings = function (instructions) {
    var flatInstructions = [];
    var lastArg = instructions[instructions.length - 1];
    var isStaggered = typeof lastArg === 'number';
    var staggerDelay = isStaggered ? lastArg : 0;
    var segments = isStaggered ? instructions.slice(0, -1) : instructions;
    var numSegments = segments.length;
    var offset = 0;
    segments.forEach(function (item, i) {
        flatInstructions.push(item);
        if (i !== numSegments - 1) {
            var duration = item.duration || DEFAULT_DURATION;
            offset += staggerDelay;
            flatInstructions.push("-" + (duration - offset));
        }
    });
    return flatInstructions;
};
var flattenArrayInstructions = function (instructions, instruction) {
    Array.isArray(instruction) ? instructions.push.apply(instructions, flattenTimings(instruction)) : instructions.push(instruction);
    return instructions;
};
var convertDefToProps = function (props, def, i) {
    var duration = props.duration,
        easings = props.easings,
        times = props.times,
        values = props.values;
    var numValues = values.length;
    var prevTimeTo = times[numValues - 1];
    var timeFrom = def.at === 0 ? 0 : def.at / duration;
    var timeTo = (def.at + def.duration) / duration;
    if (i === 0) {
        values.push(def.from);
        times.push(timeFrom);
    } else {
        if (prevTimeTo !== timeFrom) {
            if (def.from !== undefined) {
                values.push(values[numValues - 1]);
                times.push(timeFrom);
                easings.push(__WEBPACK_IMPORTED_MODULE_4__popmotion_easing__["m" /* linear */]);
            }
            var from = def.from !== undefined ? def.from : values[numValues - 1];
            values.push(from);
            times.push(timeFrom);
            easings.push(__WEBPACK_IMPORTED_MODULE_4__popmotion_easing__["m" /* linear */]);
        } else if (def.from !== undefined) {
            values.push(def.from);
            times.push(timeFrom);
            easings.push(__WEBPACK_IMPORTED_MODULE_4__popmotion_easing__["m" /* linear */]);
        }
    }
    values.push(def.to);
    times.push(timeTo);
    easings.push(def.ease || __WEBPACK_IMPORTED_MODULE_4__popmotion_easing__["k" /* easeInOut */]);
    return props;
};
var timeline = function (instructions, _a) {
    var _b = _a === void 0 ? {} : _a,
        duration = _b.duration,
        elapsed = _b.elapsed,
        ease = _b.ease,
        loop = _b.loop,
        flip = _b.flip,
        yoyo = _b.yoyo;
    var playhead = 0;
    var calculatedDuration = 0;
    var flatInstructions = instructions.reduce(flattenArrayInstructions, []);
    var animationDefs = [];
    flatInstructions.forEach(function (instruction) {
        if (typeof instruction === 'string') {
            playhead += parseFloat(instruction);
        } else if (typeof instruction === 'number') {
            playhead = instruction;
        } else {
            var def = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, instruction, { at: playhead });
            def.duration = def.duration === undefined ? DEFAULT_DURATION : def.duration;
            animationDefs.push(def);
            playhead += def.duration;
            calculatedDuration = Math.max(calculatedDuration, def.at + def.duration);
        }
    });
    var tracks = {};
    var numDefs = animationDefs.length;
    for (var i = 0; i < numDefs; i++) {
        var def = animationDefs[i];
        var track = def.track;
        if (track === undefined) {
            throw new Error('No track defined');
        }
        if (!tracks.hasOwnProperty(track)) tracks[track] = [];
        tracks[track].push(def);
    }
    var trackKeyframes = {};
    for (var key in tracks) {
        if (tracks.hasOwnProperty(key)) {
            var keyframeProps = tracks[key].reduce(convertDefToProps, {
                duration: calculatedDuration,
                easings: [],
                times: [],
                values: []
            });
            trackKeyframes[key] = keyframes(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, keyframeProps, { duration: duration || calculatedDuration, ease: ease,
                elapsed: elapsed,
                loop: loop,
                yoyo: yoyo,
                flip: flip }));
        }
    }
    return composite(trackKeyframes);
};

var listen = function (element, events, options) {
    return action(function (_a) {
        var update = _a.update;
        var eventNames = events.split(' ').map(function (eventName) {
            element.addEventListener(eventName, update, options);
            return eventName;
        });
        return {
            stop: function () {
                return eventNames.forEach(function (eventName) {
                    return element.removeEventListener(eventName, update, options);
                });
            }
        };
    });
};

var defaultPointerPos = function () {
    return {
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        x: 0,
        y: 0
    };
};
var eventToPoint = function (e, point) {
    if (point === void 0) {
        point = defaultPointerPos();
    }
    point.clientX = point.x = e.clientX;
    point.clientY = point.y = e.clientY;
    point.pageX = e.pageX;
    point.pageY = e.pageY;
    return point;
};

var points = [/*#__PURE__*/defaultPointerPos()];
var isTouchDevice = false;
if (typeof document !== 'undefined') {
    var updatePointsLocation = function (_a) {
        var touches = _a.touches;
        isTouchDevice = true;
        var numTouches = touches.length;
        points.length = 0;
        for (var i = 0; i < numTouches; i++) {
            var thisTouch = touches[i];
            points.push(eventToPoint(thisTouch));
        }
    };
    listen(document, 'touchstart touchmove', {
        passive: true,
        capture: true
    }).start(updatePointsLocation);
}
var multitouch = function (_a) {
    var _b = _a === void 0 ? {} : _a,
        _c = _b.preventDefault,
        preventDefault = _c === void 0 ? true : _c,
        _d = _b.scale,
        scale = _d === void 0 ? 1.0 : _d,
        _e = _b.rotate,
        rotate = _e === void 0 ? 0.0 : _e;
    return action(function (_a) {
        var update = _a.update;
        var output = {
            touches: points,
            scale: scale,
            rotate: rotate
        };
        var initialDistance = 0.0;
        var initialRotation = 0.0;
        var isGesture = points.length > 1;
        if (isGesture) {
            var firstTouch = points[0],
                secondTouch = points[1];
            initialDistance = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["f" /* distance */])(firstTouch, secondTouch);
            initialRotation = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["a" /* angle */])(firstTouch, secondTouch);
        }
        var updatePoint = function () {
            if (isGesture) {
                var firstTouch = points[0],
                    secondTouch = points[1];
                var newDistance = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["f" /* distance */])(firstTouch, secondTouch);
                var newRotation = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["a" /* angle */])(firstTouch, secondTouch);
                output.scale = scale * (newDistance / initialDistance);
                output.rotate = rotate + (newRotation - initialRotation);
            }
            update(output);
        };
        var onMove = function (e) {
            if (preventDefault || e.touches.length > 1) e.preventDefault();
            __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(updatePoint);
        };
        var updateOnMove = listen(document, 'touchmove', {
            passive: !preventDefault
        }).start(onMove);
        if (isTouchDevice) __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(updatePoint);
        return {
            stop: function () {
                __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(updatePoint);
                updateOnMove.stop();
            }
        };
    });
};
var getIsTouchDevice = function () {
    return isTouchDevice;
};

var point = /*#__PURE__*/defaultPointerPos();
var isMouseDevice = false;
if (typeof document !== 'undefined') {
    var updatePointLocation = function (e) {
        isMouseDevice = true;
        eventToPoint(e, point);
    };
    listen(document, 'mousedown mousemove', true).start(updatePointLocation);
}
var mouse = function (_a) {
    var _b = (_a === void 0 ? {} : _a).preventDefault,
        preventDefault = _b === void 0 ? true : _b;
    return action(function (_a) {
        var update = _a.update;
        var updatePoint = function () {
            return update(point);
        };
        var onMove = function (e) {
            if (preventDefault) e.preventDefault();
            __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(updatePoint);
        };
        var updateOnMove = listen(document, 'mousemove').start(onMove);
        if (isMouseDevice) __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(updatePoint);
        return {
            stop: function () {
                __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(updatePoint);
                updateOnMove.stop();
            }
        };
    });
};

var getFirstTouch = function (_a) {
    var firstTouch = _a[0];
    return firstTouch;
};
var pointer = function (props) {
    if (props === void 0) {
        props = {};
    }
    return getIsTouchDevice() ? multitouch(props).pipe(function (_a) {
        var touches = _a.touches;
        return touches;
    }, getFirstTouch) : mouse(props);
};
var index$1 = function (_a) {
    if (_a === void 0) {
        _a = {};
    }
    var x = _a.x,
        y = _a.y,
        props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["x", "y"]);
    if (x !== undefined || y !== undefined) {
        var applyXOffset_1 = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["b" /* applyOffset */])(x || 0);
        var applyYOffset_1 = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["b" /* applyOffset */])(y || 0);
        var delta_1 = { x: 0, y: 0 };
        return pointer(props).pipe(function (point) {
            delta_1.x = applyXOffset_1(point.x);
            delta_1.y = applyYOffset_1(point.y);
            return delta_1;
        });
    } else {
        return pointer(props);
    }
};

var chain = function () {
    var actions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        actions[_i] = arguments[_i];
    }
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        var i = 0;
        var current;
        var playCurrent = function () {
            current = actions[i].start({
                complete: function () {
                    i++;
                    i >= actions.length ? complete() : playCurrent();
                },
                update: update
            });
        };
        playCurrent();
        return {
            stop: function () {
                return current && current.stop();
            }
        };
    });
};

var crossfade = function (a, b) {
    return action(function (observer) {
        var balance = 0;
        var fadable = parallel$1(a, b).start(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, observer, { update: function (_a) {
                var va = _a[0],
                    vb = _a[1];
                observer.update(Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["j" /* mix */])(va, vb, balance));
            } }));
        return {
            setBalance: function (v) {
                return balance = v;
            },
            stop: function () {
                return fadable.stop();
            }
        };
    });
};

var delay = function (timeToDelay) {
    return action(function (_a) {
        var complete = _a.complete;
        var timeout = setTimeout(complete, timeToDelay);
        return {
            stop: function () {
                return clearTimeout(timeout);
            }
        };
    });
};

var merge = function () {
    var actions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        actions[_i] = arguments[_i];
    }
    return action(function (observer) {
        var subs = actions.map(function (thisAction) {
            return thisAction.start(observer);
        });
        return {
            stop: function () {
                return subs.forEach(function (sub) {
                    return sub.stop();
                });
            }
        };
    });
};

var schedule = function (scheduler, schedulee) {
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        var latest;
        var schedulerSub = scheduler.start({
            update: function () {
                return latest !== undefined && update(latest);
            },
            complete: complete
        });
        var scheduleeSub = schedulee.start({
            update: function (v) {
                return latest = v;
            },
            complete: complete
        });
        return {
            stop: function () {
                schedulerSub.stop();
                scheduleeSub.stop();
            }
        };
    });
};

var stagger = function (actions, interval) {
    var intervalIsNumber = typeof interval === 'number';
    var actionsWithDelay = actions.map(function (a, i) {
        var timeToDelay = intervalIsNumber ? interval * i : interval(i);
        return chain(delay(timeToDelay), a);
    });
    return parallel$1.apply(void 0, actionsWithDelay);
};

var appendUnit = function (unit) {
    return function (v) {
        return "" + v + unit;
    };
};
var steps = function (st, min, max) {
    if (min === void 0) {
        min = 0;
    }
    if (max === void 0) {
        max = 1;
    }
    return function (v) {
        var current = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["p" /* progress */])(min, max, v);
        return Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["j" /* mix */])(min, max, stepProgress(st, current));
    };
};
var transformMap = function (childTransformers) {
    return function (v) {
        var output = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, v);
        for (var key in childTransformers) {
            if (childTransformers.hasOwnProperty(key)) {
                var childTransformer = childTransformers[key];
                output[key] = childTransformer(v[key]);
            }
        }
        return output;
    };
};

var transformers = /*#__PURE__*/Object.freeze({
    applyOffset: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["b" /* applyOffset */],
    clamp: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["c" /* clamp */],
    conditional: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["d" /* conditional */],
    interpolate: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["g" /* interpolate */],
    blendArray: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["k" /* mixArray */],
    blendColor: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["l" /* mixColor */],
    pipe: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["n" /* pipe */],
    smooth: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["r" /* smooth */],
    snap: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["t" /* snap */],
    generateStaticSpring: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["u" /* springForce */],
    nonlinearSpring: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["v" /* springForceExpo */],
    linearSpring: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["w" /* springForceLinear */],
    wrap: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["z" /* wrap */],
    appendUnit: appendUnit,
    steps: steps,
    transformMap: transformMap
});

var css = function (element, props) {
    Object(__WEBPACK_IMPORTED_MODULE_6_hey_listen__["b" /* warning */])(false, 'css() is deprecated, use styler instead');
    return Object(__WEBPACK_IMPORTED_MODULE_5_stylefire__["a" /* default */])(element, props);
};
var svg = function (element, props) {
    Object(__WEBPACK_IMPORTED_MODULE_6_hey_listen__["b" /* warning */])(false, 'svg() is deprecated, use styler instead');
    return Object(__WEBPACK_IMPORTED_MODULE_5_stylefire__["a" /* default */])(element, props);
};




/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return angle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return applyOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clamp$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return conditional; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return degreesToRadians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return distance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return interpolate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isPoint3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return mix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return mixArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return mixColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return mixComplex; });
/* unused harmony export mixObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return pipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return pointFromVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return progress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return radiansToDegrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return smooth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return smoothFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return snap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return springForce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return springForceExpo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return springForceLinear; });
/* unused harmony export steps */
/* unused harmony export toDecimal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return velocityPerFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return velocityPerSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return wrap$1; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_style_value_types__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hey_listen__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_framesync__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popmotion_easing__ = __webpack_require__(165);
/* unused harmony reexport createAnticipateEasing */
/* unused harmony reexport createBackIn */
/* unused harmony reexport createExpoIn */
/* unused harmony reexport cubicBezier */
/* unused harmony reexport linear */
/* unused harmony reexport easeIn */
/* unused harmony reexport easeOut */
/* unused harmony reexport easeInOut */
/* unused harmony reexport circIn */
/* unused harmony reexport circOut */
/* unused harmony reexport circInOut */
/* unused harmony reexport backIn */
/* unused harmony reexport backOut */
/* unused harmony reexport backInOut */
/* unused harmony reexport anticipate */
/* unused harmony reexport reversed */
/* unused harmony reexport mirrored */






var zeroPoint = {
    x: 0,
    y: 0,
    z: 0
};
var isNum = function (v) { return typeof v === 'number'; };

var radiansToDegrees = (function (radians) { return (radians * 180) / Math.PI; });

var angle = (function (a, b) {
    if (b === void 0) { b = zeroPoint; }
    return radiansToDegrees(Math.atan2(b.y - a.y, b.x - a.x));
});

var applyOffset = (function (from, to) {
    var hasReceivedFrom = true;
    if (to === undefined) {
        to = from;
        hasReceivedFrom = false;
    }
    return function (v) {
        if (hasReceivedFrom) {
            return v - from + to;
        }
        else {
            from = v;
            hasReceivedFrom = true;
            return to;
        }
    };
});

var curryRange = (function (func) { return function (min, max, v) { return (v !== undefined ? func(min, max, v) : function (cv) { return func(min, max, cv); }); }; });

var clamp = function (min, max, v) {
    return Math.min(Math.max(v, min), max);
};
var clamp$1 = curryRange(clamp);

var conditional = (function (check, apply) { return function (v) {
    return check(v) ? apply(v) : v;
}; });

var degreesToRadians = (function (degrees) { return (degrees * Math.PI) / 180; });

var isPoint = (function (point) {
    return point.hasOwnProperty('x') && point.hasOwnProperty('y');
});

var isPoint3D = (function (point) {
    return isPoint(point) && point.hasOwnProperty('z');
});

var distance1D = function (a, b) { return Math.abs(a - b); };
var distance = (function (a, b) {
    if (b === void 0) { b = zeroPoint; }
    if (isNum(a) && isNum(b)) {
        return distance1D(a, b);
    }
    else if (isPoint(a) && isPoint(b)) {
        var xDelta = distance1D(a.x, b.x);
        var yDelta = distance1D(a.y, b.y);
        var zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
    return 0;
});

var progress = (function (from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
});

var mix = (function (from, to, progress) {
    return -progress * from + progress * to + from;
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var mixLinearColor = function (from, to, v) {
    var fromExpo = from * from;
    var toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
var colorTypes = [__WEBPACK_IMPORTED_MODULE_0_style_value_types__["e" /* hex */], __WEBPACK_IMPORTED_MODULE_0_style_value_types__["k" /* rgba */], __WEBPACK_IMPORTED_MODULE_0_style_value_types__["f" /* hsla */]];
var getColorType = function (v) {
    return colorTypes.find(function (type) { return type.test(v); });
};
var notAnimatable = function (color$$1) {
    return "'" + color$$1 + "' is not an animatable color. Use the equivalent color code instead.";
};
var mixColor = (function (from, to) {
    var fromColorType = getColorType(from);
    var toColorType = getColorType(to);
    Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(!!fromColorType, notAnimatable(from));
    Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(!!toColorType, notAnimatable(to));
    Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(fromColorType.transform === toColorType.transform, 'Both colors must be hex/RGBA, OR both must be HSLA.');
    var fromColor = fromColorType.parse(from);
    var toColor = toColorType.parse(to);
    var blended = __assign({}, fromColor);
    var mixFunc = fromColorType === __WEBPACK_IMPORTED_MODULE_0_style_value_types__["f" /* hsla */] ? mix : mixLinearColor;
    return function (v) {
        for (var key in blended) {
            if (key !== 'alpha') {
                blended[key] = mixFunc(fromColor[key], toColor[key], v);
            }
        }
        blended.alpha = mix(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
});

var combineFunctions = function (a, b) { return function (v) { return b(a(v)); }; };
var pipe = (function () {
    var transformers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        transformers[_i] = arguments[_i];
    }
    return transformers.reduce(combineFunctions);
});

function getMixer(origin, target) {
    if (isNum(origin)) {
        return function (v) { return mix(origin, target, v); };
    }
    else if (__WEBPACK_IMPORTED_MODULE_0_style_value_types__["b" /* color */].test(origin)) {
        return mixColor(origin, target);
    }
    else {
        return mixComplex(origin, target);
    }
}
var mixArray = function (from, to) {
    var output = from.slice();
    var numValues = output.length;
    var blendValue = from.map(function (fromThis, i) { return getMixer(fromThis, to[i]); });
    return function (v) {
        for (var i = 0; i < numValues; i++) {
            output[i] = blendValue[i](v);
        }
        return output;
    };
};
var mixObject = function (origin, target) {
    var output = __assign({}, origin, target);
    var blendValue = {};
    for (var key in output) {
        if (origin[key] !== undefined && target[key] !== undefined) {
            blendValue[key] = getMixer(origin[key], target[key]);
        }
    }
    return function (v) {
        for (var key in blendValue) {
            output[key] = blendValue[key](v);
        }
        return output;
    };
};
function analyse(value) {
    var parsed = __WEBPACK_IMPORTED_MODULE_0_style_value_types__["c" /* complex */].parse(value);
    var numValues = parsed.length;
    var numNumbers = 0;
    var numRGB = 0;
    var numHSL = 0;
    for (var i = 0; i < numValues; i++) {
        if (numNumbers || typeof parsed[i] === 'number') {
            numNumbers++;
        }
        else {
            if (parsed[i].hue !== undefined) {
                numHSL++;
            }
            else {
                numRGB++;
            }
        }
    }
    return { parsed: parsed, numNumbers: numNumbers, numRGB: numRGB, numHSL: numHSL };
}
var mixComplex = function (origin, target) {
    var template = __WEBPACK_IMPORTED_MODULE_0_style_value_types__["c" /* complex */].createTransformer(target);
    var originStats = analyse(origin);
    var targetStats = analyse(target);
    Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(originStats.numHSL === targetStats.numHSL &&
        originStats.numRGB === targetStats.numRGB &&
        originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
    return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
};

var mixNumber = function (from, to) { return function (p) { return mix(from, to, p); }; };
function detectMixerFactory(v) {
    if (typeof v === 'number') {
        return mixNumber;
    }
    else if (typeof v === 'string') {
        if (__WEBPACK_IMPORTED_MODULE_0_style_value_types__["b" /* color */].test(v)) {
            return mixColor;
        }
        else {
            return mixComplex;
        }
    }
    else if (Array.isArray(v)) {
        return mixArray;
    }
    else if (typeof v === 'object') {
        return mixObject;
    }
}
function createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || detectMixerFactory(output[0]);
    var numMixers = output.length - 1;
    for (var i = 0; i < numMixers; i++) {
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = pipe(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function fastInterpolate(_a, _b) {
    var from = _a[0], to = _a[1];
    var mixer = _b[0];
    return function (v) { return mixer(progress(from, to, v)); };
}
function slowInterpolate(input, mixers) {
    var inputLength = input.length;
    var lastInputIndex = inputLength - 1;
    return function (v) {
        var mixerIndex = 0;
        var foundMixerIndex = false;
        if (v <= input[0]) {
            foundMixerIndex = true;
        }
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            var i = 1;
            for (; i < inputLength; i++) {
                if (input[i] > v || i === lastInputIndex) {
                    break;
                }
            }
            mixerIndex = i - 1;
        }
        var progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function interpolate(input, output, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.clamp, clamp = _c === void 0 ? true : _c, ease = _b.ease, mixer = _b.mixer;
    var inputLength = input.length;
    Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(inputLength === output.length, 'Both input and output ranges must be the same length');
    Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, 'Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.');
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    var mixers = createMixers(output, ease, mixer);
    var interpolator = inputLength === 2
        ? fastInterpolate(input, mixers)
        : slowInterpolate(input, mixers);
    return clamp
        ? pipe(clamp$1(input[0], input[inputLength - 1]), interpolator)
        : interpolator;
}

var pointFromVector = (function (origin, angle, distance) {
    angle = degreesToRadians(angle);
    return {
        x: distance * Math.cos(angle) + origin.x,
        y: distance * Math.sin(angle) + origin.y
    };
});

var toDecimal = (function (num, precision) {
    if (precision === void 0) { precision = 2; }
    precision = Math.pow(10, precision);
    return Math.round(num * precision) / precision;
});

var smoothFrame = (function (prevValue, nextValue, duration, smoothing) {
    if (smoothing === void 0) { smoothing = 0; }
    return toDecimal(prevValue +
        (duration * (nextValue - prevValue)) / Math.max(smoothing, duration));
});

var smooth = (function (strength) {
    if (strength === void 0) { strength = 50; }
    var previousValue = 0;
    var lastUpdated = 0;
    return function (v) {
        var currentFramestamp = Object(__WEBPACK_IMPORTED_MODULE_2_framesync__["c" /* getFrameData */])().timestamp;
        var timeDelta = currentFramestamp !== lastUpdated ? currentFramestamp - lastUpdated : 0;
        var newValue = timeDelta
            ? smoothFrame(previousValue, v, timeDelta, strength)
            : previousValue;
        lastUpdated = currentFramestamp;
        previousValue = newValue;
        return newValue;
    };
});

var snap = (function (points) {
    if (typeof points === 'number') {
        return function (v) { return Math.round(v / points) * points; };
    }
    else {
        var i_1 = 0;
        var numPoints_1 = points.length;
        return function (v) {
            var lastDistance = Math.abs(points[0] - v);
            for (i_1 = 1; i_1 < numPoints_1; i_1++) {
                var point = points[i_1];
                var distance = Math.abs(point - v);
                if (distance === 0)
                    return point;
                if (distance > lastDistance)
                    return points[i_1 - 1];
                if (i_1 === numPoints_1 - 1)
                    return point;
                lastDistance = distance;
            }
        };
    }
});

var identity = function (v) { return v; };
var springForce = function (alterDisplacement) {
    if (alterDisplacement === void 0) { alterDisplacement = identity; }
    return curryRange(function (constant, origin, v) {
        var displacement = origin - v;
        var springModifiedDisplacement = -(0 - constant + 1) * (0 - alterDisplacement(Math.abs(displacement)));
        return displacement <= 0
            ? origin + springModifiedDisplacement
            : origin - springModifiedDisplacement;
    });
};
var springForceLinear = springForce();
var springForceExpo = springForce(Math.sqrt);

var velocityPerFrame = (function (xps, frameDuration) {
    return isNum(xps) ? xps / (1000 / frameDuration) : 0;
});

var velocityPerSecond = (function (velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
});

var wrap = function (min, max, v) {
    var rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};
var wrap$1 = curryRange(wrap);

var clampProgress = clamp$1(0, 1);
var steps = (function (steps, direction) {
    if (direction === void 0) { direction = 'end'; }
    return function (progress) {
        progress =
            direction === 'end' ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        var expanded = progress * steps;
        var rounded = direction === 'end' ? Math.floor(expanded) : Math.ceil(expanded);
        return clampProgress(rounded / steps);
    };
});




/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hey_listen__ = __webpack_require__(124);



var getPoseValues = function (_a) {
    var transition = _a.transition,
        flip = _a.flip,
        delay = _a.delay,
        delayChildren = _a.delayChildren,
        staggerChildren = _a.staggerChildren,
        staggerDirection = _a.staggerDirection,
        afterChildren = _a.afterChildren,
        beforeChildren = _a.beforeChildren,
        preTransition = _a.preTransition,
        applyAtStart = _a.applyAtStart,
        applyAtEnd = _a.applyAtEnd,
        props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["transition", "flip", "delay", "delayChildren", "staggerChildren", "staggerDirection", "afterChildren", "beforeChildren", "preTransition", "applyAtStart", "applyAtEnd"]);
    return props;
};
var selectPoses = function (_a) {
    var label = _a.label,
        props = _a.props,
        values = _a.values,
        parentValues = _a.parentValues,
        ancestorValues = _a.ancestorValues,
        onChange = _a.onChange,
        passive = _a.passive,
        initialPose = _a.initialPose,
        poses = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["label", "props", "values", "parentValues", "ancestorValues", "onChange", "passive", "initialPose"]);
    return poses;
};
var selectAllValues = function (values, selectValue) {
    var allValues = {};
    values.forEach(function (value, key) {
        return allValues[key] = selectValue(value);
    });
    return allValues;
};

var resolveProp = function (target, props) {
    return typeof target === 'function' ? target(props) : target;
};
var poseDefault = function (pose, prop, defaultValue, resolveProps) {
    return pose && pose[prop] !== undefined ? resolveProp(pose[prop], resolveProps) : defaultValue;
};
var startChildAnimations = function (children, next, pose, props) {
    var animations = [];
    var delay = poseDefault(pose, 'delayChildren', 0, props);
    var stagger = poseDefault(pose, 'staggerChildren', 0, props);
    var staggerDirection = poseDefault(pose, 'staggerDirection', 1, props);
    var maxStaggerDuration = (children.size - 1) * stagger;
    var generateStaggerDuration = staggerDirection === 1 ? function (i) {
        return i * stagger;
    } : function (i) {
        return maxStaggerDuration - i * stagger;
    };
    Array.from(children).forEach(function (child, i) {
        animations.push(child.set(next, {
            delay: delay + generateStaggerDuration(i)
        }));
    });
    return animations;
};
var resolveTransition = function (transition, key, value, props, convertTransitionDefinition, getInstantTransition) {
    var resolvedTransition;
    if (typeof transition === 'function') {
        var resolvedTransitionMap = transition(props);
        resolvedTransition = resolveTransition(resolvedTransitionMap, key, value, props, convertTransitionDefinition, getInstantTransition);
    } else if (transition[key] || transition.default) {
        var keyTransition = transition[key] || transition.default;
        if (typeof keyTransition === 'function') {
            resolvedTransition = keyTransition(props);
        } else {
            resolvedTransition = keyTransition;
        }
    } else {
        resolvedTransition = transition;
    }
    return resolvedTransition === false ? getInstantTransition(value, props) : convertTransitionDefinition(value, resolvedTransition, props);
};
var findInsertionIndex = function (poseList, priorityList, priorityIndex) {
    var insertionIndex = 0;
    for (var i = priorityIndex - 1; i >= 0; i--) {
        var nextHighestPriorityIndex = poseList.indexOf(priorityList[i]);
        if (nextHighestPriorityIndex !== -1) {
            insertionIndex = nextHighestPriorityIndex + 1;
            break;
        }
    }
    return insertionIndex;
};
var applyValues = function (toApply, values, props, setValue, setValueNative) {
    Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(typeof toApply === 'object', 'applyAtStart and applyAtEnd must be of type object');
    return Object.keys(toApply).forEach(function (key) {
        var valueToSet = resolveProp(toApply[key], props);
        values.has(key) ? setValue(values.get(key), valueToSet) : setValueNative(key, valueToSet, props);
    });
};
var createPoseSetter = function (setterProps) {
    var state = setterProps.state,
        poses = setterProps.poses,
        startAction = setterProps.startAction,
        stopAction = setterProps.stopAction,
        getInstantTransition = setterProps.getInstantTransition,
        addActionDelay = setterProps.addActionDelay,
        getTransitionProps = setterProps.getTransitionProps,
        resolveTarget = setterProps.resolveTarget,
        transformPose = setterProps.transformPose,
        posePriority = setterProps.posePriority,
        convertTransitionDefinition = setterProps.convertTransitionDefinition,
        setValue = setterProps.setValue,
        setValueNative = setterProps.setValueNative,
        forceRender = setterProps.forceRender;
    return function (next, nextProps, propagate) {
        if (nextProps === void 0) {
            nextProps = {};
        }
        if (propagate === void 0) {
            propagate = true;
        }
        var children = state.children,
            values = state.values,
            props = state.props,
            activeActions = state.activeActions,
            activePoses = state.activePoses;
        var _a = nextProps.delay,
            delay = _a === void 0 ? 0 : _a;
        var hasChildren = children.size;
        var baseTransitionProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props), nextProps);
        var nextPose = poses[next];
        var getChildAnimations = function () {
            return hasChildren && propagate ? startChildAnimations(children, next, nextPose, baseTransitionProps) : [];
        };
        var getParentAnimations = function () {
            if (!nextPose) return [];
            var applyAtStart = nextPose.applyAtStart;
            if (applyAtStart) {
                applyValues(applyAtStart, values, baseTransitionProps, setValue, setValueNative);
                if (forceRender) forceRender(baseTransitionProps);
            }
            if (transformPose) nextPose = transformPose(nextPose, next, state);
            var preTransition = nextPose.preTransition,
                getTransition = nextPose.transition,
                applyAtEnd = nextPose.applyAtEnd;
            if (preTransition) preTransition(baseTransitionProps);
            var animations = Object.keys(getPoseValues(nextPose)).map(function (key) {
                var valuePoses = activePoses.has(key) ? activePoses.get(key) : (activePoses.set(key, []), activePoses.get(key));
                var existingIndex = valuePoses.indexOf(next);
                if (existingIndex !== -1) valuePoses.splice(existingIndex, 1);
                var priority = posePriority ? posePriority.indexOf(next) : 0;
                var insertionIndex = priority <= 0 ? 0 : findInsertionIndex(valuePoses, posePriority, priority);
                valuePoses.splice(insertionIndex, 0, next);
                return insertionIndex === 0 ? new Promise(function (complete) {
                    var value = values.get(key);
                    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, baseTransitionProps), { key: key,
                        value: value });
                    var target = resolveTarget(value, resolveProp(nextPose[key], transitionProps));
                    if (activeActions.has(key)) stopAction(activeActions.get(key));
                    var resolveTransitionProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ to: target }, transitionProps), getTransitionProps(value, target, transitionProps));
                    var transition = resolveTransition(getTransition, key, value, resolveTransitionProps, convertTransitionDefinition, getInstantTransition);
                    var poseDelay = delay || resolveProp(nextPose.delay, transitionProps);
                    if (poseDelay) {
                        transition = addActionDelay(poseDelay, transition);
                    }
                    activeActions.set(key, startAction(value, transition, complete));
                }) : Promise.resolve();
            });
            return applyAtEnd ? [Promise.all(animations).then(function () {
                applyValues(applyAtEnd, values, baseTransitionProps, setValue, setValueNative);
            })] : animations;
        };
        if (nextPose && hasChildren) {
            if (resolveProp(nextPose.beforeChildren, baseTransitionProps)) {
                return Promise.all(getParentAnimations()).then(function () {
                    return Promise.all(getChildAnimations());
                });
            } else if (resolveProp(nextPose.afterChildren, baseTransitionProps)) {
                return Promise.all(getChildAnimations()).then(function () {
                    return Promise.all(getParentAnimations());
                });
            }
        }
        return Promise.all(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArrays */])(getParentAnimations(), getChildAnimations()));
    };
};

var DEFAULT_INITIAL_POSE = 'init';
var isScale = function (key) {
    return key.includes('scale');
};
var defaultReadValueFromSource = function (key) {
    return isScale(key) ? 1 : 0;
};
var readValueFromPose = function (pose, key, props) {
    var valueToResolve = pose.applyAtEnd && pose.applyAtEnd[key] !== undefined ? pose.applyAtEnd[key] : pose[key] !== undefined ? pose[key] : pose.applyAtStart && pose.applyAtStart[key] !== undefined ? pose.applyAtStart[key] : 0;
    return resolveProp(valueToResolve, props);
};
var getPosesToSearch = function (pose) {
    var posesToSearch = Array.isArray(pose) ? pose : [pose];
    posesToSearch.push(DEFAULT_INITIAL_POSE);
    return posesToSearch;
};
var getInitialValue = function (poses, key, initialPose, props, readValueFromSource, activePoses) {
    if (readValueFromSource === void 0) {
        readValueFromSource = defaultReadValueFromSource;
    }
    var posesToSearch = getPosesToSearch(initialPose);
    var pose = posesToSearch.filter(Boolean).find(function (name) {
        var thisPose = poses[name];
        return thisPose && (thisPose[key] !== undefined || thisPose.applyAtStart && thisPose.applyAtStart[key] !== undefined || thisPose.applyAtEnd && thisPose.applyAtEnd[key] !== undefined);
    });
    activePoses.set(key, [pose || DEFAULT_INITIAL_POSE]);
    return pose ? readValueFromPose(poses[pose], key, props) : readValueFromSource(key, props);
};
var createValues = function (values, _a) {
    var userSetValues = _a.userSetValues,
        createValue = _a.createValue,
        convertValue = _a.convertValue,
        readValueFromSource = _a.readValueFromSource,
        initialPose = _a.initialPose,
        poses = _a.poses,
        activePoses = _a.activePoses,
        props = _a.props;
    return function (key) {
        if (values.has(key)) return;
        var value;
        if (userSetValues && userSetValues[key] !== undefined) {
            value = convertValue(userSetValues[key], key, props);
        } else {
            var initValue = getInitialValue(poses, key, initialPose, props, readValueFromSource, activePoses);
            value = createValue(initValue, key, props);
        }
        values.set(key, value);
    };
};
var scrapeValuesFromPose = function (values, props) {
    return function (key) {
        var pose = props.poses[key];
        Object.keys(getPoseValues(pose)).forEach(createValues(values, props));
    };
};
var getAncestorValue = function (key, fromParent, ancestors) {
    if (fromParent === true) {
        return ancestors[0] && ancestors[0].values.get(key);
    } else {
        var foundAncestor = ancestors.find(function (_a) {
            var label = _a.label;
            return label === fromParent;
        });
        return foundAncestor && foundAncestor.values.get(key);
    }
};
var bindPassiveValues = function (values, _a) {
    var passive = _a.passive,
        ancestorValues = _a.ancestorValues,
        createValue = _a.createValue,
        readValue = _a.readValue,
        props = _a.props;
    return function (key) {
        var _a = passive[key],
            valueKey = _a[0],
            passiveProps = _a[1],
            fromParent = _a[2];
        var valueToBind = fromParent && ancestorValues.length ? getAncestorValue(valueKey, fromParent, ancestorValues) : values.has(valueKey) ? values.get(valueKey) : false;
        if (!valueToBind) return;
        var newValue = createValue(readValue(valueToBind), key, props, {
            passiveParentKey: valueKey,
            passiveParent: valueToBind,
            passiveProps: passiveProps
        });
        values.set(key, newValue);
    };
};
var setNativeValues = function (_a) {
    var setValueNative = _a.setValueNative,
        initialPose = _a.initialPose,
        props = _a.props,
        poses = _a.poses;
    var valuesHaveSet = new Set();
    var setValues = function (pose, propKey) {
        if (pose[propKey]) {
            for (var key in pose[propKey]) {
                if (!valuesHaveSet.has(key)) {
                    valuesHaveSet.add(key);
                    setValueNative(key, resolveProp(pose[propKey][key], props), props);
                }
            }
        }
    };
    getPosesToSearch(initialPose).forEach(function (poseKey) {
        var pose = poses[poseKey];
        if (pose) {
            setValues(pose, 'applyAtEnd');
            setValues(pose, 'applyAtStart');
        }
    });
};
var createValueMap = function (props) {
    var poses = props.poses,
        passive = props.passive;
    var values = new Map();
    Object.keys(poses).forEach(scrapeValuesFromPose(values, props));
    setNativeValues(props);
    if (passive) Object.keys(passive).forEach(bindPassiveValues(values, props));
    return values;
};

var applyDefaultTransition = function (pose, key, defaultTransitions) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, pose), { transition: defaultTransitions.has(key) ? defaultTransitions.get(key) : defaultTransitions.get('default') });
};
var generateTransitions = function (poses, defaultTransitions) {
    Object.keys(poses).forEach(function (key) {
        var pose = poses[key];
        Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(typeof pose === 'object', "Pose '" + key + "' is of invalid type. All poses should be objects.");
        poses[key] = pose.transition !== undefined ? pose : applyDefaultTransition(pose, key, defaultTransitions);
    });
    return poses;
};

var sortByReversePriority = function (priorityOrder) {
    return function (a, b) {
        var aP = priorityOrder.indexOf(a);
        var bP = priorityOrder.indexOf(b);
        if (aP === -1 && bP !== -1) return -1;
        if (aP !== -1 && bP === -1) return 1;
        return aP - bP;
    };
};

var poseFactory = function (_a) {
    var getDefaultProps = _a.getDefaultProps,
        defaultTransitions = _a.defaultTransitions,
        bindOnChange = _a.bindOnChange,
        startAction = _a.startAction,
        stopAction = _a.stopAction,
        readValue = _a.readValue,
        readValueFromSource = _a.readValueFromSource,
        resolveTarget = _a.resolveTarget,
        setValue = _a.setValue,
        setValueNative = _a.setValueNative,
        createValue = _a.createValue,
        convertValue = _a.convertValue,
        getInstantTransition = _a.getInstantTransition,
        getTransitionProps = _a.getTransitionProps,
        addActionDelay = _a.addActionDelay,
        selectValueToRead = _a.selectValueToRead,
        convertTransitionDefinition = _a.convertTransitionDefinition,
        transformPose = _a.transformPose,
        posePriority = _a.posePriority,
        forceRender = _a.forceRender,
        extendAPI = _a.extendAPI;
    return function (config) {
        var parentValues = config.parentValues,
            _a = config.ancestorValues,
            ancestorValues = _a === void 0 ? [] : _a;
        if (parentValues) ancestorValues.unshift({ values: parentValues });
        var activeActions = new Map();
        var activePoses = new Map();
        var children = new Set();
        var poses = generateTransitions(selectPoses(config), defaultTransitions);
        var _b = config.props,
            props = _b === void 0 ? {} : _b;
        if (getDefaultProps) props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, getDefaultProps(config)), props);
        var passive = config.passive,
            userSetValues = config.values,
            _c = config.initialPose,
            initialPose = _c === void 0 ? DEFAULT_INITIAL_POSE : _c;
        var values = createValueMap({
            poses: poses,
            passive: passive,
            ancestorValues: ancestorValues,
            readValue: readValue,
            setValueNative: setValueNative,
            createValue: createValue,
            convertValue: convertValue,
            readValueFromSource: readValueFromSource,
            userSetValues: userSetValues,
            initialPose: initialPose,
            activePoses: activePoses,
            props: props
        });
        var state = {
            activeActions: activeActions,
            activePoses: activePoses,
            children: children,
            props: props,
            values: values
        };
        var onChange = config.onChange;
        if (onChange) Object.keys(onChange).forEach(bindOnChange(values, onChange));
        var set = createPoseSetter({
            state: state,
            poses: poses,
            getInstantTransition: getInstantTransition,
            getTransitionProps: getTransitionProps,
            convertTransitionDefinition: convertTransitionDefinition,
            setValue: setValue,
            setValueNative: setValueNative,
            startAction: startAction,
            stopAction: stopAction,
            resolveTarget: resolveTarget,
            addActionDelay: addActionDelay,
            transformPose: transformPose,
            posePriority: posePriority,
            forceRender: forceRender
        });
        var has = function (poseName) {
            return !!poses[poseName];
        };
        var api = {
            set: set,
            unset: function (poseName, poseProps) {
                var posesToSet = [];
                activePoses.forEach(function (valuePoses) {
                    var poseIndex = valuePoses.indexOf(poseName);
                    if (poseIndex === -1) return;
                    var currentPose = valuePoses[0];
                    valuePoses.splice(poseIndex, 1);
                    var nextPose = valuePoses[0];
                    if (nextPose === currentPose) return;
                    if (posesToSet.indexOf(nextPose) === -1) {
                        posesToSet.push(nextPose);
                    }
                });
                var animationsToResolve = posesToSet.sort(sortByReversePriority(posePriority)).map(function (poseToSet) {
                    return set(poseToSet, poseProps, false);
                });
                children.forEach(function (child) {
                    return animationsToResolve.push(child.unset(poseName));
                });
                return Promise.all(animationsToResolve);
            },
            get: function (valueName) {
                return valueName ? selectValueToRead(values.get(valueName)) : selectAllValues(values, selectValueToRead);
            },
            has: has,
            setProps: function (newProps) {
                return state.props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, state.props), newProps);
            },
            _addChild: function (childConfig, factory) {
                var child = factory(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ initialPose: initialPose }, childConfig), { ancestorValues: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArrays */])([{ label: config.label, values: values }], ancestorValues) }));
                children.add(child);
                return child;
            },
            removeChild: function (child) {
                return children.delete(child);
            },
            clearChildren: function () {
                children.forEach(function (child) {
                    return child.destroy();
                });
                children.clear();
            },
            destroy: function () {
                activeActions.forEach(stopAction);
                children.forEach(function (child) {
                    return child.destroy();
                });
            }
        };
        return extendAPI(api, state, config);
    };
};

/* harmony default export */ __webpack_exports__["a"] = (poseFactory);


/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(1261);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class)|(on[A-Z].*)|((data|aria|x)-.*))$/i;
var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(reactPropsRegex.test.bind(reactPropsRegex));

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nx_components_ScreenReaderOnlyLiveRegion__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_NoStyleButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nx_components_ContextWrappers_LanguageContext__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);






 // The server has a tremendous volume of error messages to provide, and not all
// of them have proper sentence punctuation. Report bad messages to Sentry.
// For now we will also check that the toast is capitalized, but it may not be
// possible in the future (a toast which starts with a device name, for example)

var INVALID_FIRST_CHARS = /^[a-z]/;
var VALID_LAST_CHARS = /[.!?"']$/;

function toSentence(text) {
  var badFirstChar = text.match(INVALID_FIRST_CHARS);
  var badPunctuation = !text.match(VALID_LAST_CHARS);

  if (!badFirstChar && !badPunctuation) {
    return text;
  }

  var newText = text;

  if (badFirstChar) {
    newText = newText[0].toUpperCase() + newText.slice(1);
  }

  if (badPunctuation) {
    newText += ".";
  }

  __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.captureMessage("A toast was shown to the user with bad punctuation.", {
    level: "warning",
    extra: {
      providedText: text,
      displayedText: newText
    }
  });
  return newText;
}

var ToastMsg = function ToastMsg(props) {
  var languageContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_6_nx_components_ContextWrappers_LanguageContext__["b" /* default */]);
  var language = languageContext.localeSet.nexia_mobile.utils.ToastMsg;
  var id = props.id,
      colors = props.colors,
      hostRef = props.hostRef,
      persistent = props.persistent,
      text = props.text,
      onDismiss = props.onDismiss;
  var styles = Object(__WEBPACK_IMPORTED_MODULE_2_nx_components_utils_prefixStyles__["b" /* default */])({
    wrapper: {
      // This must match the style of the PosedToastMsg pose that the PosedToastMsg starts in
      opacity: 0,
      height: 0,
      overflow: "hidden",
      transform: "translateX(-100vw)"
    },
    toast: {
      display: "flex",
      alignItems: "center",
      background: "#323232",
      borderRadius: "2px",
      boxShadow: "0 2px 5px 0 rgba(0, 0, 0, 0.26)",
      fontSize: "0.8em",
      margin: "0.5em auto 0",
      maxWidth: "30em",
      overflow: "hidden",
      padding: "0.75em",
      pointerEvents: "auto"
    },
    message: {
      color: "#f1f1f1"
    },
    button: {
      color: colors.PRIMARY_GRADIENT_LIGHT,
      flex: "0 0 auto",
      fontSize: "1.2em",
      paddingLeft: "0.75em"
    }
  });

  if (!persistent) {
    setTimeout(onDismiss, 3200);
  }

  var sentence = toSentence(text);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    "data-component-name": "ToastMsg",
    style: styles.wrapper,
    ref: hostRef
  }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    style: styles.toast
  }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    style: styles.message
  }, sentence), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_nx_components_ScreenReaderOnlyLiveRegion__["a" /* default */], {
    id: "toast-".concat(id)
  }, sentence), persistent ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_nx_components_NoStyleButton__["a" /* default */], {
    style: styles.button,
    onTap: onDismiss
  }, language.dismiss) : null));
};

ToastMsg.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  hostRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  persistent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  onDismiss: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_nx_components_ColorsProvider__["c" /* withColorsProvider */])(ToastMsg));


/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_SpinnerOverlay__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_store_connect__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);










var GlobalBlockingSpinner =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(GlobalBlockingSpinner, _React$Component);

  function GlobalBlockingSpinner() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, GlobalBlockingSpinner);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(GlobalBlockingSpinner).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(GlobalBlockingSpinner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          spinnerShown = _this$props.spinnerShown,
          spinnerMessage = _this$props.spinnerMessage;

      if (!spinnerShown) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_components_SpinnerOverlay__["a" /* default */], {
        message: spinnerMessage
      });
    }
  }]);

  return GlobalBlockingSpinner;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(GlobalBlockingSpinner, "propTypes", {
  spinnerShown: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool.isRequired,
  spinnerMessage: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_nexia_mobile_flux_like_store_connect__["a" /* default */])({
  spinnerShown: "spinnerShown",
  spinnerMessage: "spinnerMessage"
}, GlobalBlockingSpinner));


/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_api_xr724__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_api_dragonfly__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_local_settings__ = __webpack_require__(24);







function pingUrl() {
  return "".concat(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_local_settings__["c" /* default */].getHost(), "/rack_pinger?").concat(Date.now());
}

function shouldCheck() {
  return !__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].isAppPaused && !__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].isPlayingVideo && !Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_api_xr724__["b" /* currentlyConfiguring724 */])() && !Object(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_api_dragonfly__["a" /* currentlyConfiguringDragonfly */])() && !__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].currentlyPollingEnrollmentStatus && !__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_environment__["a" /* default */].isTestRunner() && !(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState && __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState.inDemoMode);
}

var timeout;

function enqueueNextCheck() {
  var interval = __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].isNetworkConnected ? 10000 : 2000;
  clearTimeout(timeout); // Don't allow more than one at once, in case this is called more than once per check cycle.

  timeout = setTimeout(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("CHECK_NETWORK_STATUS");
  }, interval);
}

__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("INIT_CONNECTION_TRACKING", function () {
  Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("CHECK_NETWORK_STATUS");
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("CHECK_NETWORK_STATUS", function () {
  if (!shouldCheck()) {
    enqueueNextCheck();
    return;
  }

  $.ajax(pingUrl(), {
    success: function success() {
      if (!shouldCheck()) {
        enqueueNextCheck();
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("NETWORK_CONNECTION_UP");
      enqueueNextCheck();
    },
    error: function error(xhr) {
      if (!shouldCheck()) {
        enqueueNextCheck();
        return;
      }

      if (xhr && xhr.statusText === "abort") {
        enqueueNextCheck();
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("NETWORK_CONNECTION_DOWN");
      enqueueNextCheck();
    },
    timeout: __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].isNetworkConnected ? 9000 : 1950
  });
});

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__ = __webpack_require__(27);


__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_IS_CURRENTLY_POLLING_ENROLLMENT_STATUS", function () {
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("currentlyPollingEnrollmentStatus", true);
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("APP_IS_NO_LONGER_POLLING_ENROLLMENT_STATUS", function () {
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("currentlyPollingEnrollmentStatus", false);
});

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_batchReactUpdates__ = __webpack_require__(301);






var isAuthenticating = false;
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("VALIDATE_FINGERPRINT", function () {
  if (isAuthenticating) {
    // only bring up the dialog once
    return;
  }

  __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platform__["a" /* default */].isFingerprintAuthAvailable().then(function (available) {
    if (!available) {
      return;
    }

    isAuthenticating = true;
    __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platform__["a" /* default */].authenticateWithFingerprint().then(function (result) {
      isAuthenticating = false;

      if (result.success) {
        __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].clearFailedAuthAttempts();
        __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platform__["a" /* default */].sendGoogleAnalyticsEvent("login", "fingerprint_auth", "success");
        Object(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_batchReactUpdates__["a" /* default */])(function () {
          Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("appState.userAuthenticated", true);
          Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app");
        });
      } else {
        if (result.wasIntentionallyCancelled) {
          Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("userCancelledFingerprint", true);
          return;
        } // Don't count a failure when "Cancel" is pressed


        __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].recordFailedAuthAttempt();
        __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platform__["a" /* default */].sendGoogleAnalyticsEvent("login", "fingerprint_auth", "error");
        Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("isAuthAttemptLockedOut", __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].isAuthAttemptLockedOut());

        if (__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].isAuthAttemptLockedOut) {
          setTimeout(function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("AUTH_LOCKOUT_ENDED");
          }, __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["a" /* AUTH_LOCKOUT_MINUTES */] * 60 * 1000);
        } // Rather than explicitly going to the validate-pin view here, just assume
        // the view is underneath the fingerprint dialog. If not, we probably
        // want to be at whatever other page (like the dashboard) anyway.

      }
    })["catch"](function () {
      // Treat a network error as the user closing the dialog.
      isAuthenticating = false;
      Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("userCancelledFingerprint", true);
    });
  })["catch"](function () {// ignore platform bridge error
  });
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("CANCEL_FINGERPRINT", function () {
  if (isAuthenticating) {
    __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platform__["a" /* default */].cancelFingerprintAuthentication();
  }
});

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_api_xr724__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_api_dragonfly__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_event_stream__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nx_components_Locales__ = __webpack_require__(44);







__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("NETWORK_CONNECTION_DOWN", function () {
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("isNetworkConnected", false);
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("NETWORK_CONNECTION_UP", function () {
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("isNetworkConnected", true);
  __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_event_stream__["a" /* default */].checkForReconnect();
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("NETWORK_REQUEST_TIMEOUT", function () {
  var localeSet = Object(__WEBPACK_IMPORTED_MODULE_6_nx_components_Locales__["b" /* getLanguageSet */])();
  var language = localeSet.nexia_mobile.utils.flux_like.network;

  if (Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_api_xr724__["b" /* currentlyConfiguring724 */])() || Object(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_api_dragonfly__["a" /* currentlyConfiguringDragonfly */])()) {
    // Don't show toasts for request timeouts during 724 enrollment,
    // because we disconnect from the WiFi network while polling a Backstage Url
    // during part of the enrollment process.
    return;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", language.requestTimedOut);
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("PUBLISH_SETTINGS_TO_SERVER", function () {
  return __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_local_settings__["c" /* default */].publish();
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("SERVERSIDE_ERROR_OCCURRED", function (errors) {
  if (!_.isArray(errors)) {
    return;
  }

  if (__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].isNetworkConnected === false) {
    return;
  }

  errors.forEach(function (error) {
    Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", error.errorMessage);
  });
});

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Dialogs_NewsDialog__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_environment__ = __webpack_require__(37);





Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["b" /* listenToPath */])("newsDialogOpen", function (newValue, oldValue) {
  if (newValue && !oldValue) {
    Object(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_components_Dialogs_NewsDialog__["a" /* showNewsDialog */])({
      collection: __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].session.get("news"),
      onCloseDialog: function onCloseDialog() {
        return Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("newsDialogOpen", false);
      }
    });
  }
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("SHOW_NEWS", function () {
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("newsDialogOpen", !__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_environment__["a" /* default */].isCommercial());
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("SHOW_NEWS_FROM_STARTUP", function () {
  if (!__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].session) {
    return;
  }

  if (__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState == null) {
    return;
  }

  if (!__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].session.hasUnreadNews()) {
    return;
  }

  if (!__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_models_local_settings__["c" /* default */].getShowNews()) {
    return;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_NEWS");
});

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = showNewsDialog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_Dialog__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_News__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Dialogs_renderInDestroyableRoot__ = __webpack_require__(144);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var NewsDialog =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(NewsDialog, _React$Component);

  function NewsDialog() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, NewsDialog);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(NewsDialog).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(NewsDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          collection = _this$props.collection,
          onCloseDialog = _this$props.onCloseDialog;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_Dialog__["a" /* default */], {
        open: true,
        onTapBackground: onCloseDialog,
        onRequestClose: onCloseDialog
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_components_News__["a" /* default */], {
        collection: collection
      }));
    }
  }]);

  return NewsDialog;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(NewsDialog, "propTypes", {
  collection: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8_backbone___default.a.Collection).isRequired,
  onCloseDialog: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
});


function showNewsDialog(options) {
  Object(__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_Dialogs_renderInDestroyableRoot__["c" /* default */])(function (destroyRoot) {
    var dialogProps = _objectSpread({}, options);

    dialogProps.onCloseDialog = function () {
      if (options.onCloseDialog) {
        options.onCloseDialog();
      }

      destroyRoot();
    };

    return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](NewsDialog, dialogProps);
  });
}

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return News; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_BackboneListener__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DumbNews__ = __webpack_require__(1271);














var News =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(News, _React$Component);

  function News() {
    var _getPrototypeOf2;

    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, News);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, (_getPrototypeOf2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(News)).call.apply(_getPrototypeOf2, [this].concat(args)));

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      isLoading: false
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_handleShowNewsClicked", function () {
      __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_local_settings__["c" /* default */].setShowNews(!__WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_local_settings__["c" /* default */].getShowNews());

      _this.forceUpdate();
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_showPreviousPage", function () {
      _this._runPromiseWithLoadingState(function () {
        var collection = _this.props.collection;
        return collection.fetchPreviousPage();
      });
    });

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this), "_showNextPage", function () {
      _this._runPromiseWithLoadingState(function () {
        var collection = _this.props.collection;
        return collection.fetchNextPage();
      });
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(News, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "_setStateIfMounted",
    value: function _setStateIfMounted() {
      if (this._isMounted) {
        this.setState.apply(this, arguments);
      }
    }
  }, {
    key: "_runPromiseWithLoadingState",
    value: function _runPromiseWithLoadingState(promiseFn) {
      var _this2 = this;

      this.setState({
        isLoading: true
      });

      var doneLoading = function doneLoading() {
        _this2._setStateIfMounted({
          isLoading: false
        });
      };

      promiseFn().then(doneLoading, doneLoading);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var collection = this.props.collection;
      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]("div", {
        "data-component-name": "News"
      }, __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nexia_mobile_components_BackboneListener__["a" /* default */], {
        listenTo: collection,
        events: ["add", "remove", "reset", "sort", "sync"]
      }, function () {
        var isLoading = _this3.state.isLoading;
        var newsItem = collection.at(0);
        return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__DumbNews__["a" /* default */], {
          hasPreviousPage: collection.hasPreviousPage(),
          showPreviousPage: _this3._showPreviousPage,
          hasNextPage: collection.hasNextPage(),
          showNextPage: _this3._showNextPage,
          isShowNewsChecked: __WEBPACK_IMPORTED_MODULE_10_nexia_mobile_models_local_settings__["c" /* default */].getShowNews(),
          onShowNewsClicked: _this3._handleShowNewsClicked,
          isLoading: isLoading,
          headline: newsItem.get("headline"),
          publishedDate: new Date(newsItem.get("published")),
          content: newsItem.get("content")
        });
      }));
    }
  }]);

  return News;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(News, "propTypes", {
  collection: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9_backbone___default.a.Collection).isRequired
});



/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DumbNews; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_ItemList__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_Spinner__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NewsPage__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NewsControls__ = __webpack_require__(1273);













var styles = Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_utils_prefixStyles__["b" /* default */])({
  wrapper: {
    width: "14em",
    maxWidth: "80vw",
    maxHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    position: "relative" // for spinnerWrapper

  },
  pageWrapper: {
    padding: "0.5em",
    overflow: "auto"
  },
  spinnerWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.5)"
  },
  dividerWrapper: {
    flexShrink: "0"
  }
});

var DumbNews =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(DumbNews, _React$Component);

  function DumbNews() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, DumbNews);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(DumbNews).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(DumbNews, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hasPreviousPage = _this$props.hasPreviousPage,
          showPreviousPage = _this$props.showPreviousPage,
          hasNextPage = _this$props.hasNextPage,
          showNextPage = _this$props.showNextPage,
          isShowNewsChecked = _this$props.isShowNewsChecked,
          onShowNewsClicked = _this$props.onShowNewsClicked,
          isLoading = _this$props.isLoading,
          headline = _this$props.headline,
          publishedDate = _this$props.publishedDate,
          content = _this$props.content;
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "DumbNews",
        style: styles.wrapper
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.pageWrapper
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__NewsPage__["a" /* default */], {
        headline: headline,
        publishedDate: publishedDate,
        content: content
      })), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.dividerWrapper
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_nx_components_ItemList__["a" /* Divider */], null)), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__NewsControls__["a" /* default */], {
        isShowNewsChecked: isShowNewsChecked,
        onShowNewsClicked: onShowNewsClicked,
        onBackArrowClicked: hasPreviousPage ? showPreviousPage : undefined,
        onForwardArrowClicked: hasNextPage ? showNextPage : undefined
      }), isLoading && __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.spinnerWrapper
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_Spinner__["a" /* default */], {
        diameter: 96
      })));
    }
  }]);

  return DumbNews;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(DumbNews, "propTypes", {
  hasPreviousPage: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
  showPreviousPage: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  hasNextPage: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
  showNextPage: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  isShowNewsChecked: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
  onShowNewsClicked: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  isLoading: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
  headline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
  publishedDate: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(Date).isRequired,
  content: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
});



/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_polished__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);










var NewsPage =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(NewsPage, _React$Component);

  function NewsPage() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, NewsPage);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(NewsPage).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(NewsPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          headline = _this$props.headline,
          publishedDate = _this$props.publishedDate,
          content = _this$props.content,
          colors = _this$props.colors;
      var styles = {
        headline: {
          fontSize: "1.2em"
        },
        content: {
          color: colors.TEXT_SECONDARY,
          margin: "0.5em 0",
          fontSize: "0.8em"
        },
        date: {
          color: Object(__WEBPACK_IMPORTED_MODULE_7_polished__["b" /* lighten */])(0.2, colors.TEXT_SECONDARY),
          fontSize: "0.75em"
        }
      };
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "NewsPage"
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-section": "headline",
        style: styles.headline
      }, headline), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.content,
        "data-component-section": "content",
        dangerouslySetInnerHTML: {
          __html: content
        }
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-section": "date",
        style: styles.date
      }, publishedDate.toDateString()));
    }
  }]);

  return NewsPage;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(NewsPage, "propTypes", {
  headline: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  publishedDate: function publishedDate() {
    return (typeof Date === "function" ? __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.instanceOf(Date).isRequired : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any.isRequired).apply(this, arguments);
  },
  content: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_ColorsProvider__["c" /* withColorsProvider */])(NewsPage));


/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_polished__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_nx_components_ColorsProvider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_nx_components_utils_prefixStyles__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_nx_components_Toggle__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_nx_components_Tappable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_nx_components_Icons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var NewsControls =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(NewsControls, _React$Component);

  function NewsControls() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, NewsControls);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(NewsControls).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(NewsControls, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isShowNewsChecked = _this$props.isShowNewsChecked,
          onShowNewsClicked = _this$props.onShowNewsClicked,
          onBackArrowClicked = _this$props.onBackArrowClicked,
          onForwardArrowClicked = _this$props.onForwardArrowClicked,
          colors = _this$props.colors;
      var styles = Object(__WEBPACK_IMPORTED_MODULE_9_nx_components_utils_prefixStyles__["b" /* default */])({
        wrapper: {
          padding: "0.5em",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          flexShrink: "0"
        },
        showAtStartupWrapper: {
          marginRight: "auto",
          display: "flex",
          position: "relative",
          alignItems: "center",
          cursor: "pointer",
          flexBasis: "5.5em"
        },
        showAtStartupLabel: {
          fontSize: "0.8em"
        },
        checkboxWrapper: {
          marginRight: "0.25em",
          flexShrink: 0 // iOS <10 doesn't properly prevent shrinking when overflow is visible: https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size

        },
        arrow: {
          flexShrink: "0"
        },
        clickableArrow: {
          color: colors.PRIMARY,
          cursor: "pointer"
        },
        disabledArrow: {
          color: Object(__WEBPACK_IMPORTED_MODULE_7_polished__["b" /* lighten */])(0.4, colors.TEXT)
        },
        backArrowWrapper: {
          marginLeft: "0.5em",
          padding: "0 0.5em"
        },
        forwardArrowWrapper: {
          marginLeft: "1em",
          padding: "0 0.5em"
        }
      });
      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-name": "NewsControls",
        style: styles.wrapper
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        "data-component-section": "show-at-startup",
        style: styles.showAtStartupWrapper
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
        style: styles.checkboxWrapper
      }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10_nx_components_Toggle__["a" /* default */], {
        checked: isShowNewsChecked,
        onChange: onShowNewsClicked
      })), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nx_components_Tappable__["b" /* default */], {
        onTap: onShowNewsClicked
      }, function (_ref) {
        var tapTargetRefHandler = _ref.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
          ref: tapTargetRefHandler,
          tabIndex: "0",
          style: styles.showAtStartupLabel,
          "data-component-section": "label"
        }, "Show news at startup?");
      })), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nx_components_Tappable__["b" /* default */], {
        onTap: onBackArrowClicked
      }, function (_ref2) {
        var active = _ref2.active,
            tapTargetRefHandler = _ref2.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
          style: _objectSpread({}, styles.backArrowWrapper, {}, onBackArrowClicked ? styles.clickableArrow : styles.disabledArrow, {
            backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_Tappable__["c" /* simpleActiveBackgroundColor */])(active)
          }),
          ref: tapTargetRefHandler,
          tabIndex: "0"
        }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nx_components_Icons__["_43" /* IconThinChevronLeft */], {
          style: styles.arrow
        }));
      }), __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_nx_components_Tappable__["b" /* default */], {
        onTap: onForwardArrowClicked
      }, function (_ref3) {
        var active = _ref3.active,
            tapTargetRefHandler = _ref3.tapTargetRefHandler;
        return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]("div", {
          style: _objectSpread({}, styles.forwardArrowWrapper, {}, onForwardArrowClicked ? styles.clickableArrow : styles.disabledArrow, {
            backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_11_nx_components_Tappable__["c" /* simpleActiveBackgroundColor */])(active)
          }),
          ref: tapTargetRefHandler,
          tabIndex: "0"
        }, __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_nx_components_Icons__["_44" /* IconThinChevronRight */], {
          style: styles.arrow
        }));
      }));
    }
  }]);

  return NewsControls;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(NewsControls, "propTypes", {
  isShowNewsChecked: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.bool.isRequired,
  onShowNewsClicked: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func.isRequired,
  onBackArrowClicked: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func,
  onForwardArrowClicked: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func,
  colors: function colors() {
    return (typeof ColorSet === "function" ? __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.instanceOf(ColorSet).isRequired : __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.any.isRequired).apply(this, arguments);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_nx_components_ColorsProvider__["c" /* withColorsProvider */])(NewsControls));


/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nx_components_Locales__ = __webpack_require__(44);






__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("SAVE_NEW_PIN", function (pinCode) {
  __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].saveNewPin(pinCode);
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("appState.userAuthenticated", true); // Default new logins to PIN, or fingerprint if available

  if (__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].getCurrentAuth() === __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["b" /* AUTH_TYPES */].UNINITIALIZED) {
    __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].setAuthToPin();
    __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platform__["a" /* default */].isFingerprintAuthAvailable().then(function (hasFingerprint) {
      if (hasFingerprint) {
        __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].setAuthToFingerprint();
      }
    })["catch"](function () {// ignore platform bridge error
    });
  }

  Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app");
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("VALIDATE_PIN", function (pinCode) {
  var localeSet = Object(__WEBPACK_IMPORTED_MODULE_5_nx_components_Locales__["b" /* getLanguageSet */])();
  var language = localeSet.nexia_mobile.utils.flux_like.pin;

  if (__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].isPinValid(pinCode)) {
    __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].clearFailedAuthAttempts();
    __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platform__["a" /* default */].sendGoogleAnalyticsEvent("login", "pin_entry", "success");
    Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("appState.userAuthenticated", true);
    Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/app");
  } else {
    __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].recordFailedAuthAttempt();
    Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("isAuthAttemptLockedOut", __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].isAuthAttemptLockedOut());

    if (__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].isAuthAttemptLockedOut) {
      setTimeout(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("AUTH_LOCKOUT_ENDED");
      }, __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["a" /* AUTH_LOCKOUT_MINUTES */] * 60 * 1000);
    }

    __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_platform__["a" /* default */].sendGoogleAnalyticsEvent("login", "pin_entry", "error");
    Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", language.invalidPinToast);
  }
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("AUTH_LOCKOUT_ENDED", function () {
  __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].clearFailedAuthAttempts();
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("isAuthAttemptLockedOut", __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].isAuthAttemptLockedOut());
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("PIN_RESET", function () {
  __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_local_settings__["c" /* default */].clearPin();
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("appState.userAuthenticated", false);
  Object(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_history__["a" /* clearHistoryAndPush */])("/pin-entry/create", {
    isPinReset: true
  });
});

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nx_components_BackButtonResponder__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nx_components_utils_enqueueIn__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Dialogs_ConfirmationDialog__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_history__ = __webpack_require__(31);








__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */].on("OBTAIN_PUSH_NOTIFICATION_TOKEN", function () {
  __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_local_settings__["c" /* default */].obtainPushNotificationToken();
});
var backButtonEnabled = true;
__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */].on("START_LISTENING_TO_PLATFORM_BACK_BUTTON", function () {
  var listener = __WEBPACK_IMPORTED_MODULE_0_nx_components_BackButtonResponder__["a" /* BackButtonListener */].getSingleton();
  backButtonEnabled = true;
  __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */].listenTo(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_platform__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_platform__["a" /* default */].Event.BACK_BUTTON, function () {
    if (!backButtonEnabled) {
      return;
    }

    backButtonEnabled = false;
    Object(__WEBPACK_IMPORTED_MODULE_1_nx_components_utils_enqueueIn__["b" /* default */])(function () {
      return backButtonEnabled = true;
    }, 500);
    listener.processBackButtonPress();
  });
  listener.registerResponderCallback(function () {
    var exitLocations = new Set(["/welcome", "/pin-entry/create", "/pin-entry/validate", "/reauth", "/app/home"]); // If nothing else has handled this back button press, then if we are in an
    // exit location, we should exit the app. Otherwise, we should go to
    // the dashboard (if we are logged in).

    if (exitLocations.has(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_history__["d" /* history */].location.pathname)) {
      if (__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].appState.inDemoMode) {
        Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */])("APP_LOG_OUT");
      } else {
        __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_platform__["a" /* default */].exitApp();
      }

      return {
        handled: true
      };
    } else if (__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_flux_like_store__["a" /* default */].appState.userAuthenticated) {
      Object(__WEBPACK_IMPORTED_MODULE_7_nexia_mobile_history__["b" /* clearHistoryAndVirtualPopTo */])("/app/home");
      return {
        handled: true
      };
    } else {
      return {
        handled: false
      };
    }
  });
});
__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */].on("START_LISTENING_TO_PLATFORM_EVENTS", function () {
  __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */].listenTo(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_platform__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_platform__["a" /* default */].Event.BANNER_MESSAGE, function (message) {
    Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", message);
  });
  __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_dispatch__["a" /* default */].listenTo(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_platform__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_platform__["a" /* default */].Event.CONFIRM, function (message, onConfirm) {
    Object(__WEBPACK_IMPORTED_MODULE_6_nexia_mobile_components_Dialogs_ConfirmationDialog__["b" /* showConfirmationDialog */])({
      message: message,
      onConfirm: onConfirm
    });
  });
});

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_api_xr724__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_api_dragonfly__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_history__ = __webpack_require__(31);









function isPollingDisabled() {
  return __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].isAppPaused || __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].isPlayingVideo || __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState.inDemoMode || Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_api_xr724__["b" /* currentlyConfiguring724 */])() || Object(__WEBPACK_IMPORTED_MODULE_3_nexia_mobile_api_dragonfly__["a" /* currentlyConfiguringDragonfly */])() || __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].locationPolling.disableStack !== 0;
}

var timeoutReference;
var inFlightLocationPoll;

function enqueueNextPoll() {
  var pollingInterval = __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_local_settings__["c" /* default */].getEventStreamingEnabled() ? 60000 : 20000;
  var delay = __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_local_settings__["c" /* default */].getFastPolling() ? 4000 : pollingInterval;
  clearTimeout(timeoutReference); // in case enqueueNextPoll is called multiple times

  timeoutReference = setTimeout(function () {
    Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("LOCATION_POLL_TIMER");
    enqueueNextPoll();
  }, delay);
}

function showPollMessage(message) {
  if (__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_local_settings__["c" /* default */].getShowPolling()) {
    Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", message);
  }
}

__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("SETUP_LOCATION_POLLING", function () {
  return enqueueNextPoll();
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("TEARDOWN_LOCATION_POLLING", function () {
  clearTimeout(timeoutReference);
}); // We use a stack to keep track of polling disabled state so that if multiple things
// disable it at once, then it doesn't get enabled again until they all call enable.
// If the stack is 0, polling is enabled.

__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("DISABLE_LOCATION_POLLING", function () {
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("locationPolling.disableStack", __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].locationPolling.disableStack + 1); // Abort in-flight requests so that whatever important change is happening now
  // is reflected in future polls

  if (inFlightLocationPoll) {
    inFlightLocationPoll.abort();
  }
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("ENABLE_LOCATION_POLLING", function () {
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("locationPolling.disableStack", Math.max(0, __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].locationPolling.disableStack - 1));
});

function currentlyViewingPhones() {
  return __WEBPACK_IMPORTED_MODULE_7_nexia_mobile_history__["d" /* history */].location.pathname.startsWith("/app/phones");
}

__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("LOCATION_POLL_TIMER", function () {
  var location = __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].appState.currentLocation;

  if (isPollingDisabled() || !location) {
    return;
  }

  if (currentlyViewingPhones()) {
    var phones = __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["a" /* default */].session.get("phones");
    /* eslint-disable no-empty-function */

    if (phones) phones.fetch()["catch"](function () {});
    /* eslint-enable no-empty-function */
  } // Use a dummy model to do the polling fetch, so we're able to cancel
  // the model.set after the request finishes in case polling was disabled
  // during the request


  var dummyModel = new __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_models_base_model__["a" /* default */]();
  dummyModel.setUrl(location.url());
  dummyModel.setAsEphemeral();
  var startTime = Date.now();
  showPollMessage("Poll start.");
  inFlightLocationPoll = dummyModel.fetch();
  inFlightLocationPoll.then(function (response) {
    inFlightLocationPoll = null;

    if (isPollingDisabled()) {
      return;
    }

    var pollTime = Date.now() - startTime;
    showPollMessage("Poll finish. Took ".concat(pollTime, " ms."));
    __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_platform__["a" /* default */].addToSessionCache(response);
    location.set(location.parse(response));

    if (!location.get("hasParsedChildCollections")) {
      location.on("change:hasParsedChildCollections", function () {
        if (!location.get("hasParsedChildCollections")) {
          return;
        }

        location.off("change:hasParsedChildCollections");
        location.populatePendingRequestsRecursively().then(function () {
          Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("LOCATION_POLL_FINISHED");
        })["catch"](function () {
          Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("LOCATION_POLL_FINISHED");
        });
      });
    }
  })["catch"](function () {
    inFlightLocationPoll = null; // ignore aborted requests
  });
});

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_framework_resource__ = __webpack_require__(85);


__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("RESOURCE_CHANGE_NAME_REQUEST", function (resourceHref, newName) {
  var resource = __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_framework_resource__["a" /* ResourceMap */].findByHref(resourceHref);

  if (!resource) {
    throw new Error("RESOURCE_CHANGE_NAME_REQUEST handler couldn't find resource with href ".concat(resourceHref));
  }

  var currentName = resource.get("name");
  var xhr = resource.save({
    name: newName
  });

  if (xhr) {
    // backbone.save returns false if resource is invalid
    Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_SPINNER");
    xhr["catch"](function () {
      resource.set({
        name: currentName
      });
    }).then(function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("HIDE_SPINNER");
    });
  }
});

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__ = __webpack_require__(27);


__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("SHOW_SPINNER", function () {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("spinnerMessage", message);
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("spinnerShown", true);
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("HIDE_SPINNER", function () {
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("spinnerShown", false);
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("RUN_PROMISE_WITH_SPINNER", function (promiseFunc, message) {
  Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_SPINNER", message);

  var hideSpinner = function hideSpinner() {
    Object(__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */])("HIDE_SPINNER");
  };

  promiseFunc().then(hideSpinner, hideSpinner);
});

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_components_Toaster__ = __webpack_require__(487);


__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("SHOW_TOAST", function (message) {
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_components_Toaster__["a" /* addMessage */])(message);
});

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__ = __webpack_require__(27);


__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("VIDEO_PLAYER_VISIBLE", function () {
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("isPlayingVideo", true);
});
__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_flux_like_dispatch__["a" /* default */].on("VIDEO_PLAYER_NOT_VISIBLE", function () {
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("isPlayingVideo", false);
});

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nexia_mobile_environment__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_local_settings__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Dialogs_ConfirmationDialog__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_vognition_home_profile__ = __webpack_require__(1282);







var isVognitionSupported = __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].isVognitionSupported() && !__WEBPACK_IMPORTED_MODULE_0_nexia_mobile_environment__["a" /* default */].isCommercial();
var profileUpdated = false;
var shouldStartOnProfileUpdated = false;
var previousProfile;
__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */].on("UPDATE_VOGNITION_HOME_PROFILE", function (location) {
  if (!isVognitionSupported) {
    return;
  }

  if (!__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store__["a" /* default */].appState) {
    return;
  }

  if (__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store__["a" /* default */].appState.inDemoMode || !__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_local_settings__["c" /* default */].getShowVognition()) {
    return;
  }

  var profile = new __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_vognition_home_profile__["a" /* default */](location);

  if (profile.noDevices() || profile.isEqual(previousProfile)) {
    previousProfile = profile;
    return;
  }

  previousProfile = profile;
  __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].setVognitionHomeProfile(profile).then(function () {
    profileUpdated = true;

    if (shouldStartOnProfileUpdated) {
      Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */])("START_VOGNITION_LISTENER");
      shouldStartOnProfileUpdated = false;
    }
  })["catch"](function () {
    /* ??? */
  });
});
var vognitionListenerTimeout;

function startListenerWithTimeout() {
  clearTimeout(vognitionListenerTimeout);
  __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].runVognitionListener();
  vognitionListenerTimeout = setTimeout(function () {
    return __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].stopVognitionListener();
  }, 10000);
}

function showVoicePermissionInstructionDialog() {
  Object(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_components_Dialogs_ConfirmationDialog__["b" /* showConfirmationDialog */])({
    message: "You must grant Nexia permission to use your microphone in order to use voice control.",
    confirmButtonText: "Open Settings",
    onConfirm: function onConfirm() {
      __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].openAppPermissionSettings();
    }
  });
}

__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */].on("START_VOGNITION_LISTENER_FROM_STARTUP", function () {
  Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("vognition.listenOnStartupPending", false);

  if (isVognitionSupported && __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_local_settings__["c" /* default */].getShowVognition() && __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_local_settings__["c" /* default */].getShowVognitionOnStartup()) {
    Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */])("START_VOGNITION_LISTENER");
  }
});
__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */].on("START_VOGNITION_LISTENER", function () {
  if (!isVognitionSupported) {
    return;
  }

  if (!profileUpdated) {
    shouldStartOnProfileUpdated = true;
    return;
  }

  __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].checkMicrophonePermissions().then(function (status) {
    if (status === "granted") {
      startListenerWithTimeout();
    } else if (status === "undetermined") {
      // Since it's undetermined, we've never requested permission before, so
      // starting the listener will request permission.
      startListenerWithTimeout();
    } else if (status === "denied") {
      showVoicePermissionInstructionDialog();
    }
  });
});
__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */].on("STOP_VOGNITION_LISTENER", function () {
  if (!isVognitionSupported) {
    return;
  }

  clearTimeout(vognitionListenerTimeout);
  __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].stopVognitionListener();
});

var handleVognitionDetail = _.debounce(function (detail) {
  __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].speakString(detail);
  Object(__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */])("SHOW_TOAST", detail);
}, 1000);

var fakeLoadingTimer;

var eventuallyStopListener = function eventuallyStopListener(loading) {
  // On iOS there are certain commands which never properly close themselves.
  // Namely, commands which respond "Please make your command more specific".
  // Normal, happy-path behavior is to detail the action Vognition will perform
  // and then "Success" or "Failure" a couple seconds later, which comes with
  // "loading: false" and properly stops the process. Cancel the process if
  // we never (racey!) receive the response.
  if (loading === false) {
    // We properly finished a command, so we don't need to clean up later
    clearTimeout(fakeLoadingTimer);
  } else if (loading === true) {
    // We received an update with text, but it still wants to show the loading
    // spinner. Either we'll soon get a new update that doesn't, or we should
    // cancel the command in a few seconds.
    clearTimeout(fakeLoadingTimer);
    fakeLoadingTimer = setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_platform__["a" /* default */].stopVognitionListener();
    }, 10000);
  }
};

__WEBPACK_IMPORTED_MODULE_1_nexia_mobile_flux_like_dispatch__["a" /* default */].on("VOGNITION_STATE_UPDATE", function (_ref) {
  var recording = _ref.recording,
      loading = _ref.loading,
      detail = _ref.detail;

  if (__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store__["a" /* default */].vognition.isMicrophoneButtonActive === true && recording === false) {
    // We are transitioning from recording to not recording. We should not
    // call stopVognitionListener in ~10 seconds.
    clearTimeout(vognitionListenerTimeout);
  }

  Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("vognition.isMicrophoneButtonActive", Boolean(recording));
  Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_flux_like_store__["d" /* setValueAtPath */])("vognition.isMicrophoneButtonLoading", Boolean(loading));

  if (typeof detail === "string" && detail.trim().length > 0) {
    handleVognitionDetail(detail);
    eventuallyStopListener(loading);
  }
});

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VognitionHomeProfile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_safe_access__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_safe_access___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_safe_access__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_device__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features_group__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_mixins_device_features_sensor__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_url__ = __webpack_require__(73);



/* eslint-disable camelcase */






var VognitionHomeProfile =
/*#__PURE__*/
function () {
  function VognitionHomeProfile(location) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, VognitionHomeProfile);

    this.id = this._getIdFromUrl(location.get("id"));
    this.name = location.get("name");
    this.devices = [];
    location.get("devices").forEach(function (device) {
      var deviceAttrs = _this._getAttrsForModel(device);

      var addGroupMembers = device.hasFeature(__WEBPACK_IMPORTED_MODULE_4_nexia_mobile_models_mixins_device_features_group__["a" /* default */]);

      if (device.get("type") === "xxl_thermostat") {
        deviceAttrs.zones = [];

        if (addGroupMembers) {
          // add members to zones attribute
          device.getGroupMembers().forEach(function (zone) {
            deviceAttrs.zones.push(_this._getAttrsForModel(zone));
          });
          addGroupMembers = false;
        } else {
          // add single zone to zones attribute
          var zone = device.get("zones")[0];

          if (!zone) {
            // We are getting a rare error where we receive an empty zone (#152763626)
            zone = {};
          }

          zone = {
            name: device.get("name"),
            type: "xxl_zone",
            url: __WEBPACK_IMPORTED_MODULE_2_safe_access___default()(zone, "_links.self.href"),
            id: zone.id
          };
          deviceAttrs.zones.push(zone);
        }
      }

      if (!_.contains(["group"], device.get("type"))) {
        _this.devices.push(deviceAttrs);
      }

      if (addGroupMembers) {
        device.getGroupMembers().forEach(function (subDevice) {
          _this.devices.push(_this._getAttrsForModel(subDevice));
        });
      }
    });
    location.get("automations").forEach(function (automation) {
      _this.devices.push(_this._getAttrsForModel(automation, "automation"));
    });
    location.get("modes").forEach(function (mode) {
      _this.devices.push(_this._getAttrsForModel(mode, "mode"));
    }); // remove duplicates

    this.devices = _.uniq(this.devices, function (device_info) {
      return "".concat(device_info.type, "-").concat(device_info.id);
    }); // remove anything that doesn't have an id

    this.devices = _.filter(this.devices, function (item) {
      return _.isFinite(item.id);
    });
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(VognitionHomeProfile, [{
    key: "noDevices",
    value: function noDevices() {
      return !this.devices || this.devices.length < 1;
    }
  }, {
    key: "isEqual",
    value: function isEqual(profile) {
      return profile && JSON.stringify(profile) === JSON.stringify(this);
    }
  }, {
    key: "_getAttrsForModel",
    value: function _getAttrsForModel(model) {
      var _this2 = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var attrs = {
        name: model.get("name"),
        url: model.id,
        type: type || model.get("type")
      };

      var id = this._getIdFromUrl(model.id);

      if (_.isNumber(id)) {
        attrs.id = id;
      }

      if (model instanceof __WEBPACK_IMPORTED_MODULE_3_nexia_mobile_models_device__["a" /* default */]) {
        if (model.hasFeature(__WEBPACK_IMPORTED_MODULE_5_nexia_mobile_models_mixins_device_features_sensor__["a" /* default */])) {
          var sensors = [{
            type: this._normalizeSensorType(model.get("sensor_type"))
          }];

          _.each(model.getSensorTypes(), function (sensorType) {
            return sensors.push({
              type: _this2._normalizeSensorType(sensorType)
            });
          });

          sensors = _.filter(sensors, function (sensor) {
            return Boolean(sensor.type);
          });
          sensors = _.uniq(sensors, function (sensor) {
            return sensor.type;
          });
          attrs.sensors = sensors;
        }
      }

      return attrs;
    }
  }, {
    key: "_getIdFromUrl",
    value: function _getIdFromUrl(url) {
      var urlWithoutParams = __WEBPACK_IMPORTED_MODULE_6_nexia_mobile_url__["a" /* default */].withoutParams(url) || "";
      return parseInt(__WEBPACK_IMPORTED_MODULE_2_safe_access___default()(urlWithoutParams.match(/\d+$/), "[0]"));
    }
  }, {
    key: "_normalizeSensorType",
    value: function _normalizeSensorType(type) {
      return _.str.underscored(type);
    }
  }]);

  return VognitionHomeProfile;
}();



/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = patchBackboneSync;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backbone__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_backbone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_backbone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Routing_HistoryPageTransitionController__ = __webpack_require__(89);


 // We patch Backbone.sync here so that it doesn't resolve/reject until page
// transitions are done. We do this because we do a bunch of parsing logic as
// the result of a Backbone.sync and we don't want to block the main thread
// during a page transition because that will make the transition freeze up on
// mobile devices.

function patchBackboneSync() {
  var originalSync = __WEBPACK_IMPORTED_MODULE_1_backbone___default.a.sync;

  __WEBPACK_IMPORTED_MODULE_1_backbone___default.a.sync = function sync() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var jqXHR = originalSync.apply(this, args);
    var deferred = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Deferred();
    jqXHR.then(function () {
      for (var _len2 = arguments.length, responseArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        responseArgs[_key2] = arguments[_key2];
      }

      Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Routing_HistoryPageTransitionController__["a" /* getTransitionPromise */])().then(function () {
        deferred.resolve.apply(deferred, responseArgs);
      });
    });
    jqXHR["catch"](function () {
      for (var _len3 = arguments.length, errorArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        errorArgs[_key3] = arguments[_key3];
      }

      Object(__WEBPACK_IMPORTED_MODULE_2_nexia_mobile_components_Routing_HistoryPageTransitionController__["a" /* getTransitionPromise */])().then(function () {
        deferred.reject.apply(deferred, errorArgs);
      });
    });
    deferred.abort = jqXHR.abort;
    return deferred;
  };
}

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon.ico";

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[539]);


// WEBPACK FOOTER //
// assets/main-44729d32-pivot.js